//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), s = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, c = (n, r, a) => (a = n == null ? {} : e(i(n)), s(r || !n || !n.__esModule ? t(a, "default", {
	value: n,
	enumerable: !0
}) : a, n));
//#endregion
//#region src/general/domain/access.ts
function l({ features: e, hasParity: t = !1, hasParityAnalyticsStaff: n = !1, hasRanking: r = !1, hasRates: i = !1 }) {
	let a = new Set(e);
	return {
		hasFeature: (e) => a.has(e),
		hasParity: t,
		hasParityAnalyticsStaff: n,
		hasRanking: r,
		hasRates: i
	};
}
//#endregion
//#region src/general/domain/feature-toggle.ts
var u = {
	BI_NET_REVENUE: "bi-net-revenue",
	BI_SNAPSHOTS: "business-intelligence-snapshots",
	SMART_INSIGHTS_MODULATION_SETTINGS: "smart-insights-modulation-settings",
	UNIFIED_HOTEL_VIEW: "unified-hotel-view"
};
function d(e) {
	let t = new Set(e);
	return { hasToggle: (e) => t.has(e) };
}
//#endregion
//#region ../../node_modules/.pnpm/react@19.2.4/node_modules/react/cjs/react.production.js
var f = /* @__PURE__ */ o(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.activity"), p = Symbol.iterator;
	function m(e) {
		return typeof e != "object" || !e ? null : (e = p && e[p] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var h = {
		isMounted: function() {
			return !1;
		},
		enqueueForceUpdate: function() {},
		enqueueReplaceState: function() {},
		enqueueSetState: function() {}
	}, g = Object.assign, _ = {};
	function v(e, t, n) {
		this.props = e, this.context = t, this.refs = _, this.updater = n || h;
	}
	v.prototype.isReactComponent = {}, v.prototype.setState = function(e, t) {
		if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
		this.updater.enqueueSetState(this, e, t, "setState");
	}, v.prototype.forceUpdate = function(e) {
		this.updater.enqueueForceUpdate(this, e, "forceUpdate");
	};
	function y() {}
	y.prototype = v.prototype;
	function b(e, t, n) {
		this.props = e, this.context = t, this.refs = _, this.updater = n || h;
	}
	var x = b.prototype = new y();
	x.constructor = b, g(x, v.prototype), x.isPureReactComponent = !0;
	var S = Array.isArray;
	function C() {}
	var w = {
		H: null,
		A: null,
		T: null,
		S: null
	}, T = Object.prototype.hasOwnProperty;
	function E(e, n, r) {
		var i = r.ref;
		return {
			$$typeof: t,
			type: e,
			key: n,
			ref: i === void 0 ? null : i,
			props: r
		};
	}
	function D(e, t) {
		return E(e.type, t, e.props);
	}
	function O(e) {
		return typeof e == "object" && !!e && e.$$typeof === t;
	}
	function k(e) {
		var t = {
			"=": "=0",
			":": "=2"
		};
		return "$" + e.replace(/[=:]/g, function(e) {
			return t[e];
		});
	}
	var A = /\/+/g;
	function j(e, t) {
		return typeof e == "object" && e && e.key != null ? k("" + e.key) : t.toString(36);
	}
	function M(e) {
		switch (e.status) {
			case "fulfilled": return e.value;
			case "rejected": throw e.reason;
			default: switch (typeof e.status == "string" ? e.then(C, C) : (e.status = "pending", e.then(function(t) {
				e.status === "pending" && (e.status = "fulfilled", e.value = t);
			}, function(t) {
				e.status === "pending" && (e.status = "rejected", e.reason = t);
			})), e.status) {
				case "fulfilled": return e.value;
				case "rejected": throw e.reason;
			}
		}
		throw e;
	}
	function N(e, r, i, a, o) {
		var s = typeof e;
		(s === "undefined" || s === "boolean") && (e = null);
		var c = !1;
		if (e === null) c = !0;
		else switch (s) {
			case "bigint":
			case "string":
			case "number":
				c = !0;
				break;
			case "object": switch (e.$$typeof) {
				case t:
				case n:
					c = !0;
					break;
				case d: return c = e._init, N(c(e._payload), r, i, a, o);
			}
		}
		if (c) return o = o(e), c = a === "" ? "." + j(e, 0) : a, S(o) ? (i = "", c != null && (i = c.replace(A, "$&/") + "/"), N(o, r, i, "", function(e) {
			return e;
		})) : o != null && (O(o) && (o = D(o, i + (o.key == null || e && e.key === o.key ? "" : ("" + o.key).replace(A, "$&/") + "/") + c)), r.push(o)), 1;
		c = 0;
		var l = a === "" ? "." : a + ":";
		if (S(e)) for (var u = 0; u < e.length; u++) a = e[u], s = l + j(a, u), c += N(a, r, i, s, o);
		else if (u = m(e), typeof u == "function") for (e = u.call(e), u = 0; !(a = e.next()).done;) a = a.value, s = l + j(a, u++), c += N(a, r, i, s, o);
		else if (s === "object") {
			if (typeof e.then == "function") return N(M(e), r, i, a, o);
			throw r = String(e), Error("Objects are not valid as a React child (found: " + (r === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
		}
		return c;
	}
	function P(e, t, n) {
		if (e == null) return e;
		var r = [], i = 0;
		return N(e, r, "", "", function(e) {
			return t.call(n, e, i++);
		}), r;
	}
	function F(e) {
		if (e._status === -1) {
			var t = e._result;
			t = t(), t.then(function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
			}, function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
			}), e._status === -1 && (e._status = 0, e._result = t);
		}
		if (e._status === 1) return e._result.default;
		throw e._result;
	}
	var I = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, L = {
		map: P,
		forEach: function(e, t, n) {
			P(e, function() {
				t.apply(this, arguments);
			}, n);
		},
		count: function(e) {
			var t = 0;
			return P(e, function() {
				t++;
			}), t;
		},
		toArray: function(e) {
			return P(e, function(e) {
				return e;
			}) || [];
		},
		only: function(e) {
			if (!O(e)) throw Error("React.Children.only expected to receive a single React element child.");
			return e;
		}
	};
	e.Activity = f, e.Children = L, e.Component = v, e.Fragment = r, e.Profiler = a, e.PureComponent = b, e.StrictMode = i, e.Suspense = l, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = w, e.__COMPILER_RUNTIME = {
		__proto__: null,
		c: function(e) {
			return w.H.useMemoCache(e);
		}
	}, e.cache = function(e) {
		return function() {
			return e.apply(null, arguments);
		};
	}, e.cacheSignal = function() {
		return null;
	}, e.cloneElement = function(e, t, n) {
		if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
		var r = g({}, e.props), i = e.key;
		if (t != null) for (a in t.key !== void 0 && (i = "" + t.key), t) !T.call(t, a) || a === "key" || a === "__self" || a === "__source" || a === "ref" && t.ref === void 0 || (r[a] = t[a]);
		var a = arguments.length - 2;
		if (a === 1) r.children = n;
		else if (1 < a) {
			for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
			r.children = o;
		}
		return E(e.type, i, r);
	}, e.createContext = function(e) {
		return e = {
			$$typeof: s,
			_currentValue: e,
			_currentValue2: e,
			_threadCount: 0,
			Provider: null,
			Consumer: null
		}, e.Provider = e, e.Consumer = {
			$$typeof: o,
			_context: e
		}, e;
	}, e.createElement = function(e, t, n) {
		var r, i = {}, a = null;
		if (t != null) for (r in t.key !== void 0 && (a = "" + t.key), t) T.call(t, r) && r !== "key" && r !== "__self" && r !== "__source" && (i[r] = t[r]);
		var o = arguments.length - 2;
		if (o === 1) i.children = n;
		else if (1 < o) {
			for (var s = Array(o), c = 0; c < o; c++) s[c] = arguments[c + 2];
			i.children = s;
		}
		if (e && e.defaultProps) for (r in o = e.defaultProps, o) i[r] === void 0 && (i[r] = o[r]);
		return E(e, a, i);
	}, e.createRef = function() {
		return { current: null };
	}, e.forwardRef = function(e) {
		return {
			$$typeof: c,
			render: e
		};
	}, e.isValidElement = O, e.lazy = function(e) {
		return {
			$$typeof: d,
			_payload: {
				_status: -1,
				_result: e
			},
			_init: F
		};
	}, e.memo = function(e, t) {
		return {
			$$typeof: u,
			type: e,
			compare: t === void 0 ? null : t
		};
	}, e.startTransition = function(e) {
		var t = w.T, n = {};
		w.T = n;
		try {
			var r = e(), i = w.S;
			i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && r.then(C, I);
		} catch (e) {
			I(e);
		} finally {
			t !== null && n.types !== null && (t.types = n.types), w.T = t;
		}
	}, e.unstable_useCacheRefresh = function() {
		return w.H.useCacheRefresh();
	}, e.use = function(e) {
		return w.H.use(e);
	}, e.useActionState = function(e, t, n) {
		return w.H.useActionState(e, t, n);
	}, e.useCallback = function(e, t) {
		return w.H.useCallback(e, t);
	}, e.useContext = function(e) {
		return w.H.useContext(e);
	}, e.useDebugValue = function() {}, e.useDeferredValue = function(e, t) {
		return w.H.useDeferredValue(e, t);
	}, e.useEffect = function(e, t) {
		return w.H.useEffect(e, t);
	}, e.useEffectEvent = function(e) {
		return w.H.useEffectEvent(e);
	}, e.useId = function() {
		return w.H.useId();
	}, e.useImperativeHandle = function(e, t, n) {
		return w.H.useImperativeHandle(e, t, n);
	}, e.useInsertionEffect = function(e, t) {
		return w.H.useInsertionEffect(e, t);
	}, e.useLayoutEffect = function(e, t) {
		return w.H.useLayoutEffect(e, t);
	}, e.useMemo = function(e, t) {
		return w.H.useMemo(e, t);
	}, e.useOptimistic = function(e, t) {
		return w.H.useOptimistic(e, t);
	}, e.useReducer = function(e, t, n) {
		return w.H.useReducer(e, t, n);
	}, e.useRef = function(e) {
		return w.H.useRef(e);
	}, e.useState = function(e) {
		return w.H.useState(e);
	}, e.useSyncExternalStore = function(e, t, n) {
		return w.H.useSyncExternalStore(e, t, n);
	}, e.useTransition = function() {
		return w.H.useTransition();
	}, e.version = "19.2.4";
})), p = /* @__PURE__ */ o(((e, t) => {
	process.env.NODE_ENV !== "production" && (function() {
		function n(e, t) {
			Object.defineProperty(a.prototype, e, { get: function() {
				console.warn("%s(...) is deprecated in plain JavaScript React classes. %s", t[0], t[1]);
			} });
		}
		function r(e) {
			return typeof e != "object" || !e ? null : (e = oe && e[oe] || e["@@iterator"], typeof e == "function" ? e : null);
		}
		function i(e, t) {
			e = (e = e.constructor) && (e.displayName || e.name) || "ReactClass";
			var n = e + "." + t;
			H[n] || (console.error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", t, e), H[n] = !0);
		}
		function a(e, t, n) {
			this.props = e, this.context = t, this.refs = le, this.updater = n || se;
		}
		function o() {}
		function s(e, t, n) {
			this.props = e, this.context = t, this.refs = le, this.updater = n || se;
		}
		function c() {}
		function l(e) {
			return "" + e;
		}
		function u(e) {
			try {
				l(e);
				var t = !1;
			} catch {
				t = !0;
			}
			if (t) {
				t = console;
				var n = t.error, r = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
				return n.call(t, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", r), l(e);
			}
		}
		function d(e) {
			if (e == null) return null;
			if (typeof e == "function") return e.$$typeof === fe ? null : e.displayName || e.name || null;
			if (typeof e == "string") return e;
			switch (e) {
				case L: return "Fragment";
				case R: return "Profiler";
				case ee: return "StrictMode";
				case V: return "Suspense";
				case ne: return "SuspenseList";
				case ae: return "Activity";
			}
			if (typeof e == "object") switch (typeof e.tag == "number" && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), e.$$typeof) {
				case I: return "Portal";
				case te: return e.displayName || "Context";
				case z: return (e._context.displayName || "Context") + ".Consumer";
				case B:
					var t = e.render;
					return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
				case re: return t = e.displayName || null, t === null ? d(e.type) || "Memo" : t;
				case ie:
					t = e._payload, e = e._init;
					try {
						return d(e(t));
					} catch {}
			}
			return null;
		}
		function f(e) {
			if (e === L) return "<>";
			if (typeof e == "object" && e && e.$$typeof === ie) return "<...>";
			try {
				var t = d(e);
				return t ? "<" + t + ">" : "<...>";
			} catch {
				return "<...>";
			}
		}
		function p() {
			var e = pe.A;
			return e === null ? null : e.getOwner();
		}
		function m() {
			return Error("react-stack-top-frame");
		}
		function h(e) {
			if (me.call(e, "key")) {
				var t = Object.getOwnPropertyDescriptor(e, "key").get;
				if (t && t.isReactWarning) return !1;
			}
			return e.key !== void 0;
		}
		function g(e, t) {
			function n() {
				ge || (ge = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", t));
			}
			n.isReactWarning = !0, Object.defineProperty(e, "key", {
				get: n,
				configurable: !0
			});
		}
		function _() {
			var e = d(this.type);
			return ve[e] || (ve[e] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.")), e = this.props.ref, e === void 0 ? null : e;
		}
		function v(e, t, n, r, i, a) {
			var o = n.ref;
			return e = {
				$$typeof: F,
				type: e,
				key: t,
				props: n,
				_owner: r
			}, (o === void 0 ? null : o) === null ? Object.defineProperty(e, "ref", {
				enumerable: !1,
				value: null
			}) : Object.defineProperty(e, "ref", {
				enumerable: !1,
				get: _
			}), e._store = {}, Object.defineProperty(e._store, "validated", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: 0
			}), Object.defineProperty(e, "_debugInfo", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: null
			}), Object.defineProperty(e, "_debugStack", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: i
			}), Object.defineProperty(e, "_debugTask", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: a
			}), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
		}
		function y(e, t) {
			return t = v(e.type, t, e.props, e._owner, e._debugStack, e._debugTask), e._store && (t._store.validated = e._store.validated), t;
		}
		function b(e) {
			x(e) ? e._store && (e._store.validated = 1) : typeof e == "object" && e && e.$$typeof === ie && (e._payload.status === "fulfilled" ? x(e._payload.value) && e._payload.value._store && (e._payload.value._store.validated = 1) : e._store && (e._store.validated = 1));
		}
		function x(e) {
			return typeof e == "object" && !!e && e.$$typeof === F;
		}
		function S(e) {
			var t = {
				"=": "=0",
				":": "=2"
			};
			return "$" + e.replace(/[=:]/g, function(e) {
				return t[e];
			});
		}
		function C(e, t) {
			return typeof e == "object" && e && e.key != null ? (u(e.key), S("" + e.key)) : t.toString(36);
		}
		function w(e) {
			switch (e.status) {
				case "fulfilled": return e.value;
				case "rejected": throw e.reason;
				default: switch (typeof e.status == "string" ? e.then(c, c) : (e.status = "pending", e.then(function(t) {
					e.status === "pending" && (e.status = "fulfilled", e.value = t);
				}, function(t) {
					e.status === "pending" && (e.status = "rejected", e.reason = t);
				})), e.status) {
					case "fulfilled": return e.value;
					case "rejected": throw e.reason;
				}
			}
			throw e;
		}
		function T(e, t, n, i, a) {
			var o = typeof e;
			(o === "undefined" || o === "boolean") && (e = null);
			var s = !1;
			if (e === null) s = !0;
			else switch (o) {
				case "bigint":
				case "string":
				case "number":
					s = !0;
					break;
				case "object": switch (e.$$typeof) {
					case F:
					case I:
						s = !0;
						break;
					case ie: return s = e._init, T(s(e._payload), t, n, i, a);
				}
			}
			if (s) {
				s = e, a = a(s);
				var c = i === "" ? "." + C(s, 0) : i;
				return de(a) ? (n = "", c != null && (n = c.replace(Se, "$&/") + "/"), T(a, t, n, "", function(e) {
					return e;
				})) : a != null && (x(a) && (a.key != null && (s && s.key === a.key || u(a.key)), n = y(a, n + (a.key == null || s && s.key === a.key ? "" : ("" + a.key).replace(Se, "$&/") + "/") + c), i !== "" && s != null && x(s) && s.key == null && s._store && !s._store.validated && (n._store.validated = 2), a = n), t.push(a)), 1;
			}
			if (s = 0, c = i === "" ? "." : i + ":", de(e)) for (var l = 0; l < e.length; l++) i = e[l], o = c + C(i, l), s += T(i, t, n, o, a);
			else if (l = r(e), typeof l == "function") for (l === e.entries && (xe || console.warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), xe = !0), e = l.call(e), l = 0; !(i = e.next()).done;) i = i.value, o = c + C(i, l++), s += T(i, t, n, o, a);
			else if (o === "object") {
				if (typeof e.then == "function") return T(w(e), t, n, i, a);
				throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
			}
			return s;
		}
		function E(e, t, n) {
			if (e == null) return e;
			var r = [], i = 0;
			return T(e, r, "", "", function(e) {
				return t.call(n, e, i++);
			}), r;
		}
		function D(e) {
			if (e._status === -1) {
				var t = e._ioInfo;
				t != null && (t.start = t.end = performance.now()), t = e._result;
				var n = t();
				if (n.then(function(t) {
					if (e._status === 0 || e._status === -1) {
						e._status = 1, e._result = t;
						var r = e._ioInfo;
						r != null && (r.end = performance.now()), n.status === void 0 && (n.status = "fulfilled", n.value = t);
					}
				}, function(t) {
					if (e._status === 0 || e._status === -1) {
						e._status = 2, e._result = t;
						var r = e._ioInfo;
						r != null && (r.end = performance.now()), n.status === void 0 && (n.status = "rejected", n.reason = t);
					}
				}), t = e._ioInfo, t != null) {
					t.value = n;
					var r = n.displayName;
					typeof r == "string" && (t.name = r);
				}
				e._status === -1 && (e._status = 0, e._result = n);
			}
			if (e._status === 1) return t = e._result, t === void 0 && console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", t), "default" in t || console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", t), t.default;
			throw e._result;
		}
		function O() {
			var e = pe.H;
			return e === null && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem."), e;
		}
		function k() {
			pe.asyncTransitions--;
		}
		function A(e) {
			if (Te === null) try {
				var n = ("require" + Math.random()).slice(0, 7);
				Te = (t && t[n]).call(t, "timers").setImmediate;
			} catch {
				Te = function(e) {
					!1 === we && (we = !0, typeof MessageChannel > "u" && console.error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
					var t = new MessageChannel();
					t.port1.onmessage = e, t.port2.postMessage(void 0);
				};
			}
			return Te(e);
		}
		function j(e) {
			return 1 < e.length && typeof AggregateError == "function" ? AggregateError(e) : e[0];
		}
		function M(e, t) {
			t !== Ee - 1 && console.error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Ee = t;
		}
		function N(e, t, n) {
			var r = pe.actQueue;
			if (r !== null) if (r.length !== 0) try {
				P(r), A(function() {
					return N(e, t, n);
				});
				return;
			} catch (e) {
				pe.thrownErrors.push(e);
			}
			else pe.actQueue = null;
			0 < pe.thrownErrors.length ? (r = j(pe.thrownErrors), pe.thrownErrors.length = 0, n(r)) : t(e);
		}
		function P(e) {
			if (!U) {
				U = !0;
				var t = 0;
				try {
					for (; t < e.length; t++) {
						var n = e[t];
						do {
							pe.didUsePromise = !1;
							var r = n(!1);
							if (r !== null) {
								if (pe.didUsePromise) {
									e[t] = n, e.splice(0, t);
									return;
								}
								n = r;
							} else break;
						} while (1);
					}
					e.length = 0;
				} catch (n) {
					e.splice(0, t + 1), pe.thrownErrors.push(n);
				} finally {
					U = !1;
				}
			}
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var F = Symbol.for("react.transitional.element"), I = Symbol.for("react.portal"), L = Symbol.for("react.fragment"), ee = Symbol.for("react.strict_mode"), R = Symbol.for("react.profiler"), z = Symbol.for("react.consumer"), te = Symbol.for("react.context"), B = Symbol.for("react.forward_ref"), V = Symbol.for("react.suspense"), ne = Symbol.for("react.suspense_list"), re = Symbol.for("react.memo"), ie = Symbol.for("react.lazy"), ae = Symbol.for("react.activity"), oe = Symbol.iterator, H = {}, se = {
			isMounted: function() {
				return !1;
			},
			enqueueForceUpdate: function(e) {
				i(e, "forceUpdate");
			},
			enqueueReplaceState: function(e) {
				i(e, "replaceState");
			},
			enqueueSetState: function(e) {
				i(e, "setState");
			}
		}, ce = Object.assign, le = {};
		Object.freeze(le), a.prototype.isReactComponent = {}, a.prototype.setState = function(e, t) {
			if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
			this.updater.enqueueSetState(this, e, t, "setState");
		}, a.prototype.forceUpdate = function(e) {
			this.updater.enqueueForceUpdate(this, e, "forceUpdate");
		};
		var ue = {
			isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
			replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
		};
		for (ke in ue) ue.hasOwnProperty(ke) && n(ke, ue[ke]);
		o.prototype = a.prototype, ue = s.prototype = new o(), ue.constructor = s, ce(ue, a.prototype), ue.isPureReactComponent = !0;
		var de = Array.isArray, fe = Symbol.for("react.client.reference"), pe = {
			H: null,
			A: null,
			T: null,
			S: null,
			actQueue: null,
			asyncTransitions: 0,
			isBatchingLegacy: !1,
			didScheduleLegacyUpdate: !1,
			didUsePromise: !1,
			thrownErrors: [],
			getCurrentStack: null,
			recentlyCreatedOwnerStacks: 0
		}, me = Object.prototype.hasOwnProperty, he = console.createTask ? console.createTask : function() {
			return null;
		};
		ue = { react_stack_bottom_frame: function(e) {
			return e();
		} };
		var ge, _e, ve = {}, ye = ue.react_stack_bottom_frame.bind(ue, m)(), be = he(f(m)), xe = !1, Se = /\/+/g, Ce = typeof reportError == "function" ? reportError : function(e) {
			if (typeof window == "object" && typeof window.ErrorEvent == "function") {
				var t = new window.ErrorEvent("error", {
					bubbles: !0,
					cancelable: !0,
					message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
					error: e
				});
				if (!window.dispatchEvent(t)) return;
			} else if (typeof process == "object" && typeof process.emit == "function") {
				process.emit("uncaughtException", e);
				return;
			}
			console.error(e);
		}, we = !1, Te = null, Ee = 0, De = !1, U = !1, Oe = typeof queueMicrotask == "function" ? function(e) {
			queueMicrotask(function() {
				return queueMicrotask(e);
			});
		} : A;
		ue = Object.freeze({
			__proto__: null,
			c: function(e) {
				return O().useMemoCache(e);
			}
		});
		var ke = {
			map: E,
			forEach: function(e, t, n) {
				E(e, function() {
					t.apply(this, arguments);
				}, n);
			},
			count: function(e) {
				var t = 0;
				return E(e, function() {
					t++;
				}), t;
			},
			toArray: function(e) {
				return E(e, function(e) {
					return e;
				}) || [];
			},
			only: function(e) {
				if (!x(e)) throw Error("React.Children.only expected to receive a single React element child.");
				return e;
			}
		};
		e.Activity = ae, e.Children = ke, e.Component = a, e.Fragment = L, e.Profiler = R, e.PureComponent = s, e.StrictMode = ee, e.Suspense = V, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = pe, e.__COMPILER_RUNTIME = ue, e.act = function(e) {
			var t = pe.actQueue, n = Ee;
			Ee++;
			var r = pe.actQueue = t === null ? [] : t, i = !1;
			try {
				var a = e();
			} catch (e) {
				pe.thrownErrors.push(e);
			}
			if (0 < pe.thrownErrors.length) throw M(t, n), e = j(pe.thrownErrors), pe.thrownErrors.length = 0, e;
			if (typeof a == "object" && a && typeof a.then == "function") {
				var o = a;
				return Oe(function() {
					i || De || (De = !0, console.error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
				}), { then: function(e, a) {
					i = !0, o.then(function(i) {
						if (M(t, n), n === 0) {
							try {
								P(r), A(function() {
									return N(i, e, a);
								});
							} catch (e) {
								pe.thrownErrors.push(e);
							}
							if (0 < pe.thrownErrors.length) {
								var o = j(pe.thrownErrors);
								pe.thrownErrors.length = 0, a(o);
							}
						} else e(i);
					}, function(e) {
						M(t, n), 0 < pe.thrownErrors.length ? (e = j(pe.thrownErrors), pe.thrownErrors.length = 0, a(e)) : a(e);
					});
				} };
			}
			var s = a;
			if (M(t, n), n === 0 && (P(r), r.length !== 0 && Oe(function() {
				i || De || (De = !0, console.error("A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"));
			}), pe.actQueue = null), 0 < pe.thrownErrors.length) throw e = j(pe.thrownErrors), pe.thrownErrors.length = 0, e;
			return { then: function(e, t) {
				i = !0, n === 0 ? (pe.actQueue = r, A(function() {
					return N(s, e, t);
				})) : e(s);
			} };
		}, e.cache = function(e) {
			return function() {
				return e.apply(null, arguments);
			};
		}, e.cacheSignal = function() {
			return null;
		}, e.captureOwnerStack = function() {
			var e = pe.getCurrentStack;
			return e === null ? null : e();
		}, e.cloneElement = function(e, t, n) {
			if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
			var r = ce({}, e.props), i = e.key, a = e._owner;
			if (t != null) {
				var o;
				a: {
					if (me.call(t, "ref") && (o = Object.getOwnPropertyDescriptor(t, "ref").get) && o.isReactWarning) {
						o = !1;
						break a;
					}
					o = t.ref !== void 0;
				}
				for (s in o && (a = p()), h(t) && (u(t.key), i = "" + t.key), t) !me.call(t, s) || s === "key" || s === "__self" || s === "__source" || s === "ref" && t.ref === void 0 || (r[s] = t[s]);
			}
			var s = arguments.length - 2;
			if (s === 1) r.children = n;
			else if (1 < s) {
				o = Array(s);
				for (var c = 0; c < s; c++) o[c] = arguments[c + 2];
				r.children = o;
			}
			for (r = v(e.type, i, r, a, e._debugStack, e._debugTask), i = 2; i < arguments.length; i++) b(arguments[i]);
			return r;
		}, e.createContext = function(e) {
			return e = {
				$$typeof: te,
				_currentValue: e,
				_currentValue2: e,
				_threadCount: 0,
				Provider: null,
				Consumer: null
			}, e.Provider = e, e.Consumer = {
				$$typeof: z,
				_context: e
			}, e._currentRenderer = null, e._currentRenderer2 = null, e;
		}, e.createElement = function(e, t, n) {
			for (var r = 2; r < arguments.length; r++) b(arguments[r]);
			r = {};
			var i = null;
			if (t != null) for (c in _e || !("__self" in t) || "key" in t || (_e = !0, console.warn("Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform")), h(t) && (u(t.key), i = "" + t.key), t) me.call(t, c) && c !== "key" && c !== "__self" && c !== "__source" && (r[c] = t[c]);
			var a = arguments.length - 2;
			if (a === 1) r.children = n;
			else if (1 < a) {
				for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
				Object.freeze && Object.freeze(o), r.children = o;
			}
			if (e && e.defaultProps) for (c in a = e.defaultProps, a) r[c] === void 0 && (r[c] = a[c]);
			i && g(r, typeof e == "function" ? e.displayName || e.name || "Unknown" : e);
			var c = 1e4 > pe.recentlyCreatedOwnerStacks++;
			return v(e, i, r, p(), c ? Error("react-stack-top-frame") : ye, c ? he(f(e)) : be);
		}, e.createRef = function() {
			var e = { current: null };
			return Object.seal(e), e;
		}, e.forwardRef = function(e) {
			e != null && e.$$typeof === re ? console.error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof e == "function" ? e.length !== 0 && e.length !== 2 && console.error("forwardRef render functions accept exactly two parameters: props and ref. %s", e.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.") : console.error("forwardRef requires a render function but was given %s.", e === null ? "null" : typeof e), e != null && e.defaultProps != null && console.error("forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?");
			var t = {
				$$typeof: B,
				render: e
			}, n;
			return Object.defineProperty(t, "displayName", {
				enumerable: !1,
				configurable: !0,
				get: function() {
					return n;
				},
				set: function(t) {
					n = t, e.name || e.displayName || (Object.defineProperty(e, "name", { value: t }), e.displayName = t);
				}
			}), t;
		}, e.isValidElement = x, e.lazy = function(e) {
			e = {
				_status: -1,
				_result: e
			};
			var t = {
				$$typeof: ie,
				_payload: e,
				_init: D
			}, n = {
				name: "lazy",
				start: -1,
				end: -1,
				value: null,
				owner: null,
				debugStack: Error("react-stack-top-frame"),
				debugTask: console.createTask ? console.createTask("lazy()") : null
			};
			return e._ioInfo = n, t._debugInfo = [{ awaited: n }], t;
		}, e.memo = function(e, t) {
			e ?? console.error("memo: The first argument must be a component. Instead received: %s", e === null ? "null" : typeof e), t = {
				$$typeof: re,
				type: e,
				compare: t === void 0 ? null : t
			};
			var n;
			return Object.defineProperty(t, "displayName", {
				enumerable: !1,
				configurable: !0,
				get: function() {
					return n;
				},
				set: function(t) {
					n = t, e.name || e.displayName || (Object.defineProperty(e, "name", { value: t }), e.displayName = t);
				}
			}), t;
		}, e.startTransition = function(e) {
			var t = pe.T, n = {};
			n._updatedFibers = /* @__PURE__ */ new Set(), pe.T = n;
			try {
				var r = e(), i = pe.S;
				i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && (pe.asyncTransitions++, r.then(k, k), r.then(c, Ce));
			} catch (e) {
				Ce(e);
			} finally {
				t === null && n._updatedFibers && (e = n._updatedFibers.size, n._updatedFibers.clear(), 10 < e && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.")), t !== null && n.types !== null && (t.types !== null && t.types !== n.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), t.types = n.types), pe.T = t;
			}
		}, e.unstable_useCacheRefresh = function() {
			return O().useCacheRefresh();
		}, e.use = function(e) {
			return O().use(e);
		}, e.useActionState = function(e, t, n) {
			return O().useActionState(e, t, n);
		}, e.useCallback = function(e, t) {
			return O().useCallback(e, t);
		}, e.useContext = function(e) {
			var t = O();
			return e.$$typeof === z && console.error("Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?"), t.useContext(e);
		}, e.useDebugValue = function(e, t) {
			return O().useDebugValue(e, t);
		}, e.useDeferredValue = function(e, t) {
			return O().useDeferredValue(e, t);
		}, e.useEffect = function(e, t) {
			return e ?? console.warn("React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?"), O().useEffect(e, t);
		}, e.useEffectEvent = function(e) {
			return O().useEffectEvent(e);
		}, e.useId = function() {
			return O().useId();
		}, e.useImperativeHandle = function(e, t, n) {
			return O().useImperativeHandle(e, t, n);
		}, e.useInsertionEffect = function(e, t) {
			return e ?? console.warn("React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?"), O().useInsertionEffect(e, t);
		}, e.useLayoutEffect = function(e, t) {
			return e ?? console.warn("React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?"), O().useLayoutEffect(e, t);
		}, e.useMemo = function(e, t) {
			return O().useMemo(e, t);
		}, e.useOptimistic = function(e, t) {
			return O().useOptimistic(e, t);
		}, e.useReducer = function(e, t, n) {
			return O().useReducer(e, t, n);
		}, e.useRef = function(e) {
			return O().useRef(e);
		}, e.useState = function(e) {
			return O().useState(e);
		}, e.useSyncExternalStore = function(e, t, n) {
			return O().useSyncExternalStore(e, t, n);
		}, e.useTransition = function() {
			return O().useTransition();
		}, e.version = "19.2.4", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
})), m = /* @__PURE__ */ o(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = f() : t.exports = p();
})), h = /* @__PURE__ */ o(((e) => {
	var t = m().__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
	e.c = function(e) {
		return t.H.useMemoCache(e);
	};
})), g = /* @__PURE__ */ o(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		var t = m().__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
		e.c = function(e) {
			var n = t.H;
			return n === null && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem."), n.useMemoCache(e);
		};
	})();
})), _ = /* @__PURE__ */ o(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = h() : t.exports = g();
})), v = /* @__PURE__ */ o(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
	function r(e, n, r) {
		var i = null;
		if (r !== void 0 && (i = "" + r), n.key !== void 0 && (i = "" + n.key), "key" in n) for (var a in r = {}, n) a !== "key" && (r[a] = n[a]);
		else r = n;
		return n = r.ref, {
			$$typeof: t,
			type: e,
			key: i,
			ref: n === void 0 ? null : n,
			props: r
		};
	}
	e.Fragment = n, e.jsx = r, e.jsxs = r;
})), y = /* @__PURE__ */ o(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e) {
			if (e == null) return null;
			if (typeof e == "function") return e.$$typeof === k ? null : e.displayName || e.name || null;
			if (typeof e == "string") return e;
			switch (e) {
				case v: return "Fragment";
				case b: return "Profiler";
				case y: return "StrictMode";
				case w: return "Suspense";
				case T: return "SuspenseList";
				case O: return "Activity";
			}
			if (typeof e == "object") switch (typeof e.tag == "number" && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), e.$$typeof) {
				case _: return "Portal";
				case S: return e.displayName || "Context";
				case x: return (e._context.displayName || "Context") + ".Consumer";
				case C:
					var n = e.render;
					return e = e.displayName, e ||= (e = n.displayName || n.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
				case E: return n = e.displayName || null, n === null ? t(e.type) || "Memo" : n;
				case D:
					n = e._payload, e = e._init;
					try {
						return t(e(n));
					} catch {}
			}
			return null;
		}
		function n(e) {
			return "" + e;
		}
		function r(e) {
			try {
				n(e);
				var t = !1;
			} catch {
				t = !0;
			}
			if (t) {
				t = console;
				var r = t.error, i = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
				return r.call(t, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", i), n(e);
			}
		}
		function i(e) {
			if (e === v) return "<>";
			if (typeof e == "object" && e && e.$$typeof === D) return "<...>";
			try {
				var n = t(e);
				return n ? "<" + n + ">" : "<...>";
			} catch {
				return "<...>";
			}
		}
		function a() {
			var e = A.A;
			return e === null ? null : e.getOwner();
		}
		function o() {
			return Error("react-stack-top-frame");
		}
		function s(e) {
			if (j.call(e, "key")) {
				var t = Object.getOwnPropertyDescriptor(e, "key").get;
				if (t && t.isReactWarning) return !1;
			}
			return e.key !== void 0;
		}
		function c(e, t) {
			function n() {
				P || (P = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", t));
			}
			n.isReactWarning = !0, Object.defineProperty(e, "key", {
				get: n,
				configurable: !0
			});
		}
		function l() {
			var e = t(this.type);
			return F[e] || (F[e] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.")), e = this.props.ref, e === void 0 ? null : e;
		}
		function u(e, t, n, r, i, a) {
			var o = n.ref;
			return e = {
				$$typeof: g,
				type: e,
				key: t,
				props: n,
				_owner: r
			}, (o === void 0 ? null : o) === null ? Object.defineProperty(e, "ref", {
				enumerable: !1,
				value: null
			}) : Object.defineProperty(e, "ref", {
				enumerable: !1,
				get: l
			}), e._store = {}, Object.defineProperty(e._store, "validated", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: 0
			}), Object.defineProperty(e, "_debugInfo", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: null
			}), Object.defineProperty(e, "_debugStack", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: i
			}), Object.defineProperty(e, "_debugTask", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: a
			}), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
		}
		function d(e, n, i, o, l, d) {
			var p = n.children;
			if (p !== void 0) if (o) if (M(p)) {
				for (o = 0; o < p.length; o++) f(p[o]);
				Object.freeze && Object.freeze(p);
			} else console.error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
			else f(p);
			if (j.call(n, "key")) {
				p = t(e);
				var m = Object.keys(n).filter(function(e) {
					return e !== "key";
				});
				o = 0 < m.length ? "{key: someKey, " + m.join(": ..., ") + ": ...}" : "{key: someKey}", ee[p + o] || (m = 0 < m.length ? "{" + m.join(": ..., ") + ": ...}" : "{}", console.error("A props object containing a \"key\" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />", o, p, m, p), ee[p + o] = !0);
			}
			if (p = null, i !== void 0 && (r(i), p = "" + i), s(n) && (r(n.key), p = "" + n.key), "key" in n) for (var h in i = {}, n) h !== "key" && (i[h] = n[h]);
			else i = n;
			return p && c(i, typeof e == "function" ? e.displayName || e.name || "Unknown" : e), u(e, p, i, a(), l, d);
		}
		function f(e) {
			p(e) ? e._store && (e._store.validated = 1) : typeof e == "object" && e && e.$$typeof === D && (e._payload.status === "fulfilled" ? p(e._payload.value) && e._payload.value._store && (e._payload.value._store.validated = 1) : e._store && (e._store.validated = 1));
		}
		function p(e) {
			return typeof e == "object" && !!e && e.$$typeof === g;
		}
		var h = m(), g = Symbol.for("react.transitional.element"), _ = Symbol.for("react.portal"), v = Symbol.for("react.fragment"), y = Symbol.for("react.strict_mode"), b = Symbol.for("react.profiler"), x = Symbol.for("react.consumer"), S = Symbol.for("react.context"), C = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), T = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), D = Symbol.for("react.lazy"), O = Symbol.for("react.activity"), k = Symbol.for("react.client.reference"), A = h.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, j = Object.prototype.hasOwnProperty, M = Array.isArray, N = console.createTask ? console.createTask : function() {
			return null;
		};
		h = { react_stack_bottom_frame: function(e) {
			return e();
		} };
		var P, F = {}, I = h.react_stack_bottom_frame.bind(h, o)(), L = N(i(o)), ee = {};
		e.Fragment = v, e.jsx = function(e, t, n) {
			var r = 1e4 > A.recentlyCreatedOwnerStacks++;
			return d(e, t, n, !1, r ? Error("react-stack-top-frame") : I, r ? N(i(e)) : L);
		}, e.jsxs = function(e, t, n) {
			var r = 1e4 > A.recentlyCreatedOwnerStacks++;
			return d(e, t, n, !0, r ? Error("react-stack-top-frame") : I, r ? N(i(e)) : L);
		};
	})();
})), b = /* @__PURE__ */ o(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = v() : t.exports = y();
})), x = _(), S = /* @__PURE__ */ c(m(), 1), C = b(), w = (0, S.createContext)(null);
function T() {
	let e = (0, S.useContext)(w);
	if (!e) throw Error("`useAccess` must be used inside <AccessProvider>");
	return e;
}
function E(e) {
	let t = (0, x.c)(3), { access: n, children: r } = e, i;
	return t[0] !== n || t[1] !== r ? (i = /* @__PURE__ */ (0, C.jsx)(w, {
		value: n,
		children: r
	}), t[0] = n, t[1] = r, t[2] = i) : i = t[2], i;
}
var D = {
	header: "_header_j51uz_1",
	content: "_content_j51uz_19"
}, O = {
	"prism-icon": "_prism-icon_1qls3_1",
	"prism-icon--extra-small": "_prism-icon--extra-small_1qls3_12",
	"prism-icon--small": "_prism-icon--small_1qls3_19",
	"prism-icon--medium": "_prism-icon--medium_1qls3_26",
	"prism-icon--large": "_prism-icon--large_1qls3_33",
	"prism-icon--inherit": "_prism-icon--inherit_1qls3_40",
	"prism-icon--default": "_prism-icon--default_1qls3_44",
	"prism-icon--default-inverse": "_prism-icon--default-inverse_1qls3_48",
	"prism-icon--emphasis": "_prism-icon--emphasis_1qls3_52",
	"prism-icon--subdued": "_prism-icon--subdued_1qls3_56",
	"prism-icon--info": "_prism-icon--info_1qls3_60",
	"prism-icon--success": "_prism-icon--success_1qls3_64",
	"prism-icon--warning": "_prism-icon--warning_1qls3_68",
	"prism-icon--critical": "_prism-icon--critical_1qls3_72",
	"prism-icon--brand": "_prism-icon--brand_1qls3_76",
	"prism-icon--intelligence": "_prism-icon--intelligence_1qls3_80",
	"prism-icon--on-info": "_prism-icon--on-info_1qls3_84",
	"prism-icon--on-success": "_prism-icon--on-success_1qls3_88",
	"prism-icon--on-warning": "_prism-icon--on-warning_1qls3_92",
	"prism-icon--on-critical": "_prism-icon--on-critical_1qls3_96",
	"prism-icon--on-brand": "_prism-icon--on-brand_1qls3_100",
	"prism-icon--on-intelligence": "_prism-icon--on-intelligence_1qls3_104",
	"prism-icon--disabled": "_prism-icon--disabled_1qls3_108"
}, k = {
	"amenities-shower": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for amenities-shower\"><path d=\"M8 18C8.55228 18 9 17.5523 9 17C9 16.4477 8.55228 16 8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18Z\"/><path d=\"M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z\"/><path d=\"M16 18C16.5523 18 17 17.5523 17 17C17 16.4477 16.5523 16 16 16C15.4477 16 15 16.4477 15 17C15 17.5523 15.4477 18 16 18Z\"/><path d=\"M13 5.08V4C13 3.45 12.55 3 12 3C11.45 3 11 3.45 11 4V5.08C7.61 5.57 5 8.47 5 12V13C5 13.55 5.45 14 6 14H18C18.55 14 19 13.55 19 13V12C19 8.47 16.39 5.57 13 5.08Z\"/><path d=\"M8 21C8.55228 21 9 20.5523 9 20C9 19.4477 8.55228 19 8 19C7.44772 19 7 19.4477 7 20C7 20.5523 7.44772 21 8 21Z\"/><path d=\"M12 21C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21Z\"/><path d=\"M16 21C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21Z\"/></svg>",
	archive: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for archive\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.1025 3.00488C21.6067 3.05621 22 3.48232 22 4V9H21V20L20.9951 20.1025C20.9472 20.573 20.573 20.9472 20.1025 20.9951L20 21H4C3.48232 21 3.05621 20.6067 3.00488 20.1025L3 20V9H2V4C2 3.44772 2.44772 3 3 3H21L21.1025 3.00488ZM5 19H19V9H5V19ZM4 7H20V5H4V7Z\"/><path d=\"M8 12C8 11.4477 8.44772 11 9 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H9C8.44772 13 8 12.5523 8 12Z\"/></svg>",
	"arrow-down": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for arrow-down\"><path d=\"M11.9999 4C11.4477 4 10.9999 4.44771 10.9999 5L10.9999 16.17L7.70538 12.8837C7.31563 12.4949 6.68464 12.4953 6.29538 12.8846C5.90577 13.2742 5.90577 13.9058 6.29538 14.2954L11.2928 19.2929C11.6834 19.6834 12.3165 19.6834 12.707 19.2929L17.7045 14.2954C18.0941 13.9058 18.0941 13.2742 17.7045 12.8846C17.3152 12.4953 16.6842 12.4949 16.2945 12.8837L12.9999 16.17L12.9999 5C12.9999 4.44771 12.5522 4 11.9999 4Z\"/></svg>",
	"arrow-left": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for arrow-left\"><path d=\"M19.9999 11.9999C19.9999 11.4476 19.5522 10.9999 18.9999 10.9999L7.82991 10.9999L11.1162 7.70536C11.505 7.31561 11.5046 6.68462 11.1154 6.29536C10.7257 5.90576 10.0941 5.90576 9.70447 6.29536L4.70702 11.2928C4.31649 11.6833 4.31649 12.3165 4.70702 12.707L9.70447 17.7045C10.0941 18.0941 10.7257 18.0941 11.1153 17.7045C11.5046 17.3152 11.505 16.6842 11.1162 16.2945L7.82991 12.9999L18.9999 12.9999C19.5522 12.9999 19.9999 12.5522 19.9999 11.9999Z\"/></svg>",
	"arrow-right": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for arrow-right\"><path d=\"M3.99997 12.0001C3.99997 12.5524 4.44768 13.0001 4.99997 13.0001L16.17 13.0001L12.8836 16.2946C12.4949 16.6844 12.4953 17.3154 12.8845 17.7046C13.2741 18.0942 13.9058 18.0942 14.2954 17.7046L19.2929 12.7072C19.6834 12.3167 19.6834 11.6835 19.2929 11.293L14.2954 6.29552C13.9058 5.90592 13.2741 5.90592 12.8845 6.29552C12.4953 6.68478 12.4949 7.31577 12.8836 7.70552L16.17 11.0001L4.99997 11.0001C4.44768 11.0001 3.99997 11.4478 3.99997 12.0001Z\"/></svg>",
	"arrow-up": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for arrow-up\"><path d=\"M12 20C12.5523 20 13 19.5523 13 19L13 7.83L16.2946 11.1163C16.6843 11.5051 17.3153 11.5047 17.7046 11.1154C18.0942 10.7258 18.0942 10.0942 17.7046 9.70456L12.7071 4.70711C12.3166 4.31658 11.6834 4.31658 11.2929 4.70711L6.29544 9.70456C5.90584 10.0942 5.90584 10.7258 6.29544 11.1154C6.6847 11.5047 7.3157 11.5051 7.70544 11.1163L11 7.83L11 19C11 19.5523 11.4477 20 12 20Z\"/></svg>",
	"artificial-intelligence": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" alt=\"Icon for artificial-intelligence\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.087 8.745a1.221 1.221 0 0 1 2.326 0l1.155 3.273 3.122 1.211c1.08.419 1.08 2.02 0 2.439l-3.122 1.21-1.155 3.273a1.221 1.221 0 0 1-2.326 0l-1.155-3.273-3.122-1.21c-1.08-.42-1.08-2.02 0-2.439l3.122-1.211 1.155-3.273Z\"/><path d=\"M16.83 2.352a.506.506 0 0 1 .965 0l.963 2.728a.527.527 0 0 0 .303.319l2.603 1.01c.448.173.448.837 0 1.01l-2.603 1.01a.527.527 0 0 0-.303.318l-.963 2.729a.506.506 0 0 1-.965 0l-.963-2.729a.527.527 0 0 0-.304-.318l-2.602-1.01c-.448-.173-.448-.837 0-1.01l2.602-1.01a.527.527 0 0 0 .304-.319l.963-2.728Z\"/></svg>",
	"attach-file": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for attach-file\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 6.5C6 4.01472 8.01472 2 10.5 2C12.9853 2 15 4.01472 15 6.5V15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15V7C9 6.44772 9.44772 6 10 6C10.5523 6 11 6.44772 11 7V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V6.5C13 5.11929 11.8807 4 10.5 4C9.11929 4 8 5.11929 8 6.5V16C8 18.2091 9.79086 20 12 20C14.2091 20 16 18.2091 16 16V7C16 6.44772 16.4477 6 17 6C17.5523 6 18 6.44772 18 7V16C18 19.3137 15.3137 22 12 22C8.68629 22 6 19.3137 6 16V6.5Z\"/></svg>",
	"automation-off": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for automation-off\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.80553 4.03854C3.4125 3.70038 2.81907 3.7176 2.44645 4.09022C2.05577 4.4809 2.05577 5.11432 2.44645 5.50499L7.1547 10.2132L4.68247 13.1799C4.41109 13.5056 4.64266 14 5.06658 14H10.1223C10.4149 14 10.6449 14.25 10.6206 14.5415L10.1306 20.4217C10.09 20.9086 10.7002 21.1587 11.013 20.7833L14.0638 17.1223L18.0022 21.0608C18.3929 21.4515 19.0263 21.4515 19.417 21.0608C19.7896 20.6882 19.8069 20.0947 19.4687 19.7017L3.80553 4.03854ZM16.6343 14.0377L19.3157 10.8201C19.587 10.4944 19.3555 10 18.9315 10H13.8758C13.5833 10 13.3532 9.74999 13.3775 9.45848L13.8675 3.57831C13.9081 3.09137 13.298 2.84132 12.9852 3.2167L9.72519 7.12865L16.6343 14.0377Z\"/></svg>",
	automation: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for automation\"><path d=\"M5.06748 14C4.64357 14 4.41199 13.5056 4.68337 13.1799L12.9861 3.2167C13.2989 2.84132 13.909 3.09137 13.8684 3.57831L13.3784 9.45848C13.3541 9.74999 13.5842 10 13.8767 10H18.9324C19.3564 10 19.5879 10.4944 19.3166 10.8201L11.0139 20.7833C10.7011 21.1587 10.0909 20.9086 10.1315 20.4217L10.6215 14.5415C10.6458 14.25 10.4158 14 10.1232 14H5.06748Z\"/></svg>",
	"badge-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for badge-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 14.899C5.76281 13.6364 5 11.9073 5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10C19 11.9073 18.2372 13.6364 17 14.899V19.7192C17 21.0204 15.7772 21.9751 14.5149 21.6595L12 21.0308L9.48507 21.6595C8.22278 21.9751 7 21.0204 7 19.7192V14.899ZM15 14.0004C14.1643 14.6281 13.1256 15 12 15C10.8744 15 9.83566 14.6281 9 14.0004C7.78583 13.0881 7 11.6356 7 10C7 7.23858 9.23858 5 12 5C14.7614 5 17 7.23858 17 10C17 11.6356 16.2142 13.0881 15 14.0004ZM15 16.3264C14.0907 16.7583 13.0736 17 12 17C10.9264 17 9.90926 16.7583 9 16.3264V19.7192L12 18.9692L15 19.7192V16.3264Z\"/></svg>",
	badge: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for badge\"><path d=\"M17 14.899C18.2372 13.6364 19 11.9073 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10C5 11.9073 5.76281 13.6364 7 14.899V19.7802C7 20.4112 7.57733 20.8845 8.19612 20.7608L12 20L15.8039 20.7608C16.4227 20.8845 17 20.4112 17 19.7802V14.899Z\"/></svg>",
	bank: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for bank\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.5143 2.12584C11.8164 1.95805 12.1836 1.95805 12.4856 2.12584L21.4856 7.12584C21.8839 7.34714 22.0823 7.80974 21.968 8.25084C21.8537 8.69195 21.4557 9 21 9H2.99997C2.5443 9 2.14624 8.69195 2.03194 8.25084C1.91764 7.80974 2.116 7.34714 2.51433 7.12584L11.5143 2.12584Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 20.5C2 19.6716 2.67157 19 3.5 19H20.5C21.3284 19 22 19.6716 22 20.5C22 21.3284 21.3284 22 20.5 22H3.5C2.67157 22 2 21.3284 2 20.5Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.5 17V11H19.5V17H16.5Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.5 17V11H7.5V17H4.5Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5 17V11H13.5V17H10.5Z\"/></svg>",
	banknotes: "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for banknotes\"><path d=\"M13.3333 6.00008C13.3333 5.63189 13.6317 5.33341 13.9999 5.33341C14.3681 5.33341 14.6666 5.63189 14.6666 6.00008V12.0001C14.6666 12.7365 14.0696 13.3334 13.3333 13.3334H4.66658C4.2984 13.3334 3.99992 13.0349 3.99992 12.6667C3.99992 12.2986 4.2984 12.0001 4.66659 12.0001H13.3333V6.00008ZM2.66659 2.66675H10.6666C11.403 2.66675 11.9999 3.2637 11.9999 4.00008V9.33341C11.9999 10.0698 11.403 10.6667 10.6666 10.6667H2.66659C1.93021 10.6667 1.33325 10.0698 1.33325 9.33341V4.00008C1.33325 3.2637 1.93021 2.66675 2.66659 2.66675ZM2.66659 4.00008V9.33341H10.6666V4.00008H2.66659ZM6.66659 8.33341C5.74611 8.33341 4.99992 7.58722 4.99992 6.66675C4.99992 5.74627 5.74611 5.00008 6.66659 5.00008C7.58706 5.00008 8.33325 5.74627 8.33325 6.66675C8.33325 7.58722 7.58706 8.33341 6.66659 8.33341Z\"/></svg>",
	bin: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for bin\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 2L15 2C16.103 2 17 2.897 17 4L17 5L20 5C20.5523 5 21 5.44771 21 6C21 6.55228 20.5523 7 20 7L18.5 7L5.5 7L4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5L7 5L7 4C7 2.897 7.897 2 9 2ZM5.5 8L5.5 20C5.5 21.103 6.397 22 7.5 22L16.5 22C17.603 22 18.5 21.103 18.5 20L18.5 8L5.5 8ZM15 4L9 4L9 5L15 5L15 4Z\"/></svg>",
	book: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for book\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 10C5 9.44776 5.44772 9.00004 6 9.00004H8C8.55228 9.00004 9 9.44776 9 10C9 10.5523 8.55228 11 8 11H6C5.44772 11 5 10.5523 5 10Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 13C5 12.4478 5.44772 12 6 12H9C9.55228 12 10 12.4478 10 13C10 13.5523 9.55228 14 9 14H6C5.44772 14 5 13.5523 5 13Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.40409 18.723C6.83894 19.3028 8.59718 20.1269 11.486 21.8578C11.8135 22.0541 12.2082 22.0411 12.5144 21.8578C14.8512 20.516 17.4788 19.2271 19.5959 18.723C20.952 18.4 22 17.2061 22 15.741V6.12482C22 4.43958 20.5507 2.93387 18.7247 3.23506C16.4274 3.61399 14.5746 4.46249 12 6.34225C9.42535 4.46249 7.57257 3.61399 5.27526 3.23506C3.44925 2.93387 2 4.43958 2 6.12482V15.741C2 17.2061 3.04797 18.4 4.40409 18.723ZM4.94977 5.2084C4.50228 5.13459 4 5.50584 4 6.12482V15.741C4 16.2099 4.34211 16.6523 4.86739 16.7774C7.09404 17.3076 8.81114 18.0325 11 19.2609V8.08931C8.48403 6.22887 6.88943 5.52834 4.94977 5.2084ZM19.0502 5.2084C19.4977 5.13459 20 5.50584 20 6.12482V15.741C20 16.2099 19.6579 16.6523 19.1326 16.7774C16.906 17.3076 15.1889 18.0325 13 19.2609V8.08931C15.516 6.22887 17.1106 5.52834 19.0502 5.2084Z\"/></svg>",
	"bookmark-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for bookmark-filled\"><path d=\"M7 3C5.89543 3 5 3.89543 5 5V20.2768C5 21.0446 5.82948 21.526 6.49614 21.1451L11.5039 18.2835C11.8113 18.1078 12.1887 18.1078 12.4961 18.2835L17.5039 21.1451C18.1705 21.526 19 21.0446 19 20.2768V5C19 3.89543 18.1046 3 17 3H7Z\"/></svg>",
	"bookmark-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for bookmark-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 18.5536L10.5116 16.547C11.4339 16.02 12.5661 16.02 13.4884 16.547L17 18.5536V5L7 5V18.5536ZM5 5V20.2768C5 21.0446 5.82948 21.526 6.49614 21.1451L11.5039 18.2835C11.8113 18.1078 12.1887 18.1078 12.4961 18.2835L17.5039 21.1451C18.1705 21.526 19 21.0446 19 20.2768V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5Z\"/></svg>",
	bullet: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for bullet\"><circle cx=\"12\" cy=\"12\" r=\"5\"/></svg>",
	"business-type-hotel": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for business-type-hotel\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.5144 2.12584C11.8164 1.95805 12.1837 1.95805 12.4857 2.12584L21.4857 7.12584C21.9685 7.39406 22.1424 8.00286 21.8742 8.48564C21.606 8.96843 20.9972 9.14237 20.5144 8.87416L16.2572 6.50906L12.0001 4.14396L3.4857 8.87416C3.00292 9.14237 2.39412 8.96843 2.1259 8.48564C1.85769 8.00286 2.03163 7.39406 2.51442 7.12584L11.5144 2.12584Z\"/><path d=\"M11 14C11 15.1046 10.1046 16 9 16C7.89543 16 7 15.1046 7 14C7 12.8954 7.89543 12 9 12C10.1046 12 11 12.8954 11 14Z\"/><path d=\"M6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12V17V19V20C4 20.5523 4.44772 21 5 21C5.55228 21 6 20.5523 6 20V19H18V20C18 20.5523 18.4477 21 19 21C19.5523 21 20 20.5523 20 20V18V17V16C20 13.7909 18.2091 12 16 12H14C12.8954 12 12 12.8954 12 14V17H6V12Z\"/></svg>",
	"business-type-market": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for business-type-market\"><path d=\"M17 11V5C17 3.9 16.1 3 15 3H9C7.9 3 7 3.9 7 5V7H5C3.9 7 3 7.9 3 9V19C3 20.1 3.9 21 5 21H10C10.55 21 11 20.55 11 20V17H13V20C13 20.55 13.45 21 14 21H19C20.1 21 21 20.1 21 19V13C21 11.9 20.1 11 19 11H17ZM7 19H5V17H7V19ZM7 15H5V13H7V15ZM7 11H5V9H7V11ZM11 15H9V13H11V15ZM11 11H9V9H11V11ZM11 7H9V5H11V7ZM15 15H13V13H15V15ZM15 11H13V9H15V11ZM15 7H13V5H15V7ZM19 19H17V17H19V19ZM19 15H17V13H19V15Z\"/></svg>",
	"calendar-accepted": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for calendar-accepted\"><path d=\"M10.2929 17.7069C10.6834 18.0975 11.3166 18.0975 11.7071 17.7069L16 13.414C16.3905 13.0236 16.3905 12.3905 16 12C15.6095 11.6096 14.9765 11.6096 14.586 12L11 15.586L9.414 14C9.02354 13.6096 8.39047 13.6096 8 14C7.60953 14.3905 7.60953 15.0236 8 15.414L10.2929 17.7069Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 4H17V3C17 2.44772 16.5523 2 16 2C15.4477 2 15 2.44772 15 3V4H9V3C9 2.44772 8.55229 2 8 2C7.44772 2 7 2.44772 7 3V4H5C3.897 4 3 4.897 3 6V20C3 21.103 3.897 22 5 22H19C20.103 22 21 21.103 21 20V6C21 4.897 20.103 4 19 4ZM19.002 20H5V10H19L19.002 20Z\"/></svg>",
	"calendar-add": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for calendar-add\"><path d=\"M8.5 15C8.5 15.5523 8.94772 16 9.5 16H11V17.5C11 18.0523 11.4477 18.5 12 18.5C12.5523 18.5 13 18.0523 13 17.5V16H14.5C15.0523 16 15.5 15.5523 15.5 15C15.5 14.4477 15.0523 14 14.5 14H13V12.5C13 11.9477 12.5523 11.5 12 11.5C11.4477 11.5 11 11.9477 11 12.5V14H9.5C8.94772 14 8.5 14.4477 8.5 15Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 4H17V3C17 2.44772 16.5523 2 16 2C15.4477 2 15 2.44772 15 3V4H9V3C9 2.44772 8.55229 2 8 2C7.44772 2 7 2.44772 7 3V4H5C3.897 4 3 4.897 3 6V20C3 21.103 3.897 22 5 22H19C20.103 22 21 21.103 21 20V6C21 4.897 20.103 4 19 4ZM5 20H19.002L19 10H5V20Z\"/></svg>",
	"calendar-clock": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" alt=\"Icon for calendar-clock\"><path d=\"M1.83333 13.4637C1.46667 13.4637 1.15278 13.3331 0.891667 13.072C0.630556 12.8109 0.5 12.497 0.5 12.1304V2.79704C0.5 2.43037 0.630556 2.11648 0.891667 1.85537C1.15278 1.59426 1.46667 1.4637 1.83333 1.4637H2.5V0.130371H3.83333V1.4637H9.16667V0.130371H10.5V1.4637H11.1667C11.5333 1.4637 11.8472 1.59426 12.1083 1.85537C12.3694 2.11648 12.5 2.43037 12.5 2.79704V6.58037C12.2889 6.48037 12.0722 6.39704 11.85 6.33037C11.6278 6.2637 11.4 6.2137 11.1667 6.18037V5.4637H1.83333V12.1304H6.03333C6.11111 12.3748 6.20278 12.6081 6.30833 12.8304C6.41389 13.0526 6.53889 13.2637 6.68333 13.4637H1.83333ZM10.5 14.1304C9.57778 14.1304 8.79167 13.8054 8.14167 13.1554C7.49167 12.5054 7.16667 11.7193 7.16667 10.797C7.16667 9.87482 7.49167 9.08871 8.14167 8.4387C8.79167 7.7887 9.57778 7.4637 10.5 7.4637C11.4222 7.4637 12.2083 7.7887 12.8583 8.4387C13.5083 9.08871 13.8333 9.87482 13.8333 10.797C13.8333 11.7193 13.5083 12.5054 12.8583 13.1554C12.2083 13.8054 11.4222 14.1304 10.5 14.1304ZM11.6167 12.3804L12.0833 11.9137L10.8333 10.6637V8.79704H10.1667V10.9304L11.6167 12.3804Z\"/></svg>",
	"calendar-default": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for calendar-default\"><path d=\"M13 13C13 12.4477 12.5523 12 12 12H8C7.44772 12 7 12.4477 7 13V17C7 17.5523 7.44772 18 8 18H12C12.5523 18 13 17.5523 13 17V13Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 4H19C20.103 4 21 4.897 21 6V20C21 21.103 20.103 22 19 22H5C3.897 22 3 21.103 3 20V6C3 4.897 3.897 4 5 4H7V3C7 2.44772 7.44772 2 8 2C8.55229 2 9 2.44772 9 3V4H15V3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3V4ZM5 20H19.001L19.0003 10H5V20Z\"/></svg>",
	"calendar-message": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for calendar-message\"><path d=\"M7 12H17V14H7V12Z\"/><path d=\"M7 16H14V18H7V16Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 22H5C3.897 22 3 21.103 3 20V6C3 4.897 3.897 4 5 4H7V3C7 2.44772 7.44772 2 8 2C8.55229 2 9 2.44772 9 3V4H15V3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3V4H19C20.103 4 21 4.897 21 6V20C21 21.103 20.103 22 19 22ZM19.0001 8L19 6H5V8H19.0001ZM19.0003 10L19.001 20H5V10H19.0003Z\"/><path d=\"M19 6L19.0001 8H5V6H19Z\"/></svg>",
	checkmark: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for checkmark\"><path d=\"M6.69667 12C6.30615 11.6095 5.67298 11.6095 5.28246 12C4.89193 12.3905 4.89193 13.0237 5.28246 13.4142L8.81799 16.9498C9.20851 17.3403 9.84168 17.3403 10.2322 16.9498L18.7175 8.46446C19.108 8.07394 19.108 7.44077 18.7175 7.05025C18.327 6.65972 17.6938 6.65972 17.3033 7.05025L9.52509 14.8284L6.69667 12Z\"/></svg>",
	"chevron-down-double": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for chevron-down-double\"><path d=\"M6.6967 6.6967C6.30618 7.08723 6.30618 7.72039 6.6967 8.11092L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071L17.3033 8.11092C17.6938 7.72039 17.6938 7.08723 17.3033 6.6967C16.9128 6.30618 16.2796 6.30618 15.8891 6.6967L12 10.5858L8.11092 6.6967C7.72039 6.30618 7.08723 6.30618 6.6967 6.6967Z\"/><path d=\"M6.6967 11.6967C6.30618 12.0872 6.30618 12.7204 6.6967 13.1109L11.2929 17.7071C11.6834 18.0976 12.3166 18.0976 12.7071 17.7071L17.3033 13.1109C17.6938 12.7204 17.6938 12.0872 17.3033 11.6967C16.9128 11.3062 16.2796 11.3062 15.8891 11.6967L12 15.5858L8.11092 11.6967C7.72039 11.3062 7.08723 11.3062 6.6967 11.6967Z\"/></svg>",
	"chevron-down": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for chevron-down\"><path d=\"M6.6967 8.9948C6.30618 9.38532 6.30618 10.0185 6.6967 10.409L11.2929 15.0052C11.6834 15.3957 12.3166 15.3957 12.7071 15.0052L17.3033 10.409C17.6938 10.0185 17.6938 9.38532 17.3033 8.9948C16.9128 8.60427 16.2796 8.60427 15.8891 8.9948L12 12.8839L8.11092 8.9948C7.72039 8.60427 7.08723 8.60427 6.6967 8.9948Z\"/></svg>",
	"chevron-left": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for chevron-left\"><path d=\"M15.0052 6.6967C14.6147 6.30618 13.9815 6.30618 13.591 6.6967L8.9948 11.2929C8.60427 11.6834 8.60427 12.3166 8.9948 12.7071L13.591 17.3033C13.9815 17.6938 14.6147 17.6938 15.0052 17.3033C15.3957 16.9128 15.3957 16.2796 15.0052 15.8891L11.1161 12L15.0052 8.11092C15.3957 7.72039 15.3957 7.08723 15.0052 6.6967Z\"/></svg>",
	"chevron-right": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for chevron-right\"><path d=\"M8.9948 17.3033C9.38532 17.6938 10.0185 17.6938 10.409 17.3033L15.0052 12.7071C15.3957 12.3166 15.3957 11.6834 15.0052 11.2929L10.409 6.6967C10.0185 6.30618 9.38532 6.30618 8.9948 6.6967C8.60428 7.08723 8.60428 7.72039 8.9948 8.11092L12.8839 12L8.9948 15.8891C8.60427 16.2796 8.60427 16.9128 8.9948 17.3033Z\"/></svg>",
	"chevron-up-double": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for chevron-up-double\"><path d=\"M17.3033 17.3033C17.6938 16.9128 17.6938 16.2796 17.3033 15.8891L12.7071 11.2929C12.3166 10.9024 11.6834 10.9024 11.2929 11.2929L6.6967 15.8891C6.30618 16.2796 6.30618 16.9128 6.6967 17.3033C7.08723 17.6938 7.72039 17.6938 8.11092 17.3033L12 13.4142L15.8891 17.3033C16.2796 17.6938 16.9128 17.6938 17.3033 17.3033Z\"/><path d=\"M17.3033 12.3033C17.6938 11.9128 17.6938 11.2796 17.3033 10.8891L12.7071 6.29289C12.3166 5.90237 11.6834 5.90237 11.2929 6.29289L6.6967 10.8891C6.30618 11.2796 6.30618 11.9128 6.6967 12.3033C7.08723 12.6938 7.72039 12.6938 8.11092 12.3033L12 8.41421L15.8891 12.3033C16.2796 12.6938 16.9128 12.6938 17.3033 12.3033Z\"/></svg>",
	"chevron-up": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for chevron-up\"><path d=\"M17.3033 15.0052C17.6938 14.6147 17.6938 13.9815 17.3033 13.591L12.7071 8.99477C12.3166 8.60424 11.6834 8.60424 11.2929 8.99477L6.6967 13.591C6.30618 13.9815 6.30618 14.6146 6.6967 15.0052C7.08723 15.3957 7.72039 15.3957 8.11092 15.0052L12 11.1161L15.8891 15.0052C16.2796 15.3957 16.9128 15.3957 17.3033 15.0052Z\"/></svg>",
	"circle-arrow-bottom": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-arrow-bottom\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 12C22 6.47 17.53 2 12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12ZM15.7071 12.2929C16.0976 12.6834 16.0976 13.3166 15.7071 13.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L8.29289 13.7071C7.90237 13.3166 7.90237 12.6834 8.29289 12.2929C8.68342 11.9024 9.31658 11.9024 9.70711 12.2929L11.003 13.5888V7.99702C11.003 7.44638 11.4494 7 12.0001 7C12.5507 7 12.9971 7.44638 12.9971 7.99702V13.5887L14.2929 12.2929C14.6834 11.9024 15.3166 11.9024 15.7071 12.2929Z\"/></svg>",
	"circle-arrow-left": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-arrow-left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22ZM11.7071 15.7071C11.3166 16.0976 10.6834 16.0976 10.2929 15.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L10.2929 8.29289C10.6834 7.90237 11.3166 7.90237 11.7071 8.29289C12.0976 8.68342 12.0976 9.31658 11.7071 9.70711L10.4112 11.003H16.003C16.5536 11.003 17 11.4494 17 12.0001C17 12.5507 16.5536 12.9971 16.003 12.9971H10.4113L11.7071 14.2929C12.0976 14.6834 12.0976 15.3166 11.7071 15.7071Z\"/></svg>",
	"circle-arrow-right": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-arrow-right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12.2929 8.29289C12.6834 7.90237 13.3166 7.90237 13.7071 8.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L13.7071 15.7071C13.3166 16.0976 12.6834 16.0976 12.2929 15.7071C11.9024 15.3166 11.9024 14.6834 12.2929 14.2929L13.5888 12.997H7.99702C7.44638 12.997 7 12.5506 7 11.9999C7 11.4493 7.44638 11.0029 7.99702 11.0029H13.5887L12.2929 9.70711C11.9024 9.31658 11.9024 8.68342 12.2929 8.29289Z\"/></svg>",
	"circle-arrow-up": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-arrow-up\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2C6.47 2 2 6.47 2 12ZM8.29289 11.7071C7.90237 11.3166 7.90237 10.6834 8.29289 10.2929L11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L15.7071 10.2929C16.0976 10.6834 16.0976 11.3166 15.7071 11.7071C15.3166 12.0976 14.6834 12.0976 14.2929 11.7071L12.997 10.4112L12.997 16.003C12.997 16.5536 12.5506 17 11.9999 17C11.4493 17 11.0029 16.5536 11.0029 16.003L11.0029 10.4113L9.70711 11.7071C9.31658 12.0976 8.68342 12.0976 8.29289 11.7071Z\"/></svg>",
	"circle-checkmark": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-checkmark\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM17.2071 8.70711C17.5976 9.09763 17.5976 9.7308 17.2071 10.1213L11.2071 16.1213C10.8166 16.5118 10.1834 16.5118 9.79289 16.1213L7.29289 13.6213C6.90237 13.2308 6.90237 12.5976 7.29289 12.2071C7.68342 11.8166 8.31658 11.8166 8.70711 12.2071L10.5 14L15.7929 8.70711C16.1834 8.31658 16.8166 8.31658 17.2071 8.70711Z\"/></svg>",
	"circle-cross": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-cross\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 12C2 6.47 6.47 2 12 2C17.53 2 22 6.47 22 12C22 17.53 17.53 22 12 22C6.47 22 2 17.53 2 12ZM12 10.59L13.885 8.705C14.2744 8.31564 14.9056 8.31564 15.295 8.705C15.6844 9.09436 15.6844 9.72564 15.295 10.115L13.41 12L15.295 13.885C15.6844 14.2744 15.6844 14.9056 15.295 15.295C14.9056 15.6844 14.2744 15.6844 13.885 15.295L12 13.41L10.115 15.295C9.72564 15.6844 9.09436 15.6844 8.705 15.295C8.31564 14.9056 8.31564 14.2744 8.705 13.885L10.59 12L8.705 10.115C8.31564 9.72564 8.31564 9.09436 8.705 8.705C9.09436 8.31564 9.72564 8.31564 10.115 8.705L12 10.59Z\"/></svg>",
	"circle-error-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-error-filled\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9999 2.00002C6.47703 2.00001 1.99988 6.47717 1.99988 12C1.99988 17.5229 6.47703 22 11.9999 22C17.5227 22 21.9999 17.5229 21.9999 12C21.9999 6.47717 17.5227 2.00002 11.9999 2.00002ZM11.9999 15C11.4476 15 10.9999 15.4477 10.9999 16C10.9999 16.5523 11.4476 17 11.9999 17C12.5522 17 12.9999 16.5523 12.9999 16C12.9999 15.4477 12.5522 15 11.9999 15ZM10.9999 12C10.9999 12.5523 11.4476 13 11.9999 13C12.5522 13 12.9999 12.5523 12.9999 12V8.00002C12.9999 7.44773 12.5522 7.00002 11.9999 7.00002C11.4476 7.00002 10.9999 7.44773 10.9999 8.00002V12Z\"/></svg>",
	"circle-error-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-error-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9999 4.00002C7.5816 4.00001 3.99988 7.58174 3.99988 12C3.99988 16.4183 7.5816 20 11.9999 20C16.4182 20 19.9999 16.4183 19.9999 12C19.9999 7.58174 16.4182 4.00002 11.9999 4.00002ZM11.9999 2.00002C6.47703 2.00001 1.99988 6.47717 1.99988 12C1.99988 17.5229 6.47703 22 11.9999 22C17.5227 22 21.9999 17.5229 21.9999 12C21.9999 6.47717 17.5227 2.00002 11.9999 2.00002Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9999 13C11.4476 13 10.9999 12.5523 10.9999 12V8.00002C10.9999 7.44773 11.4476 7.00002 11.9999 7.00002C12.5522 7.00002 12.9999 7.44773 12.9999 8.00002V12C12.9999 12.5523 12.5522 13 11.9999 13Z\"/><path d=\"M10.9999 16C10.9999 15.4477 11.4476 15 11.9999 15C12.5522 15 12.9999 15.4477 12.9999 16C12.9999 16.5523 12.5522 17 11.9999 17C11.4476 17 10.9999 16.5523 10.9999 16Z\"/></svg>",
	"circle-heart-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-heart-filled\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.3355 16.8742C12.1422 17.0415 11.8573 17.042 11.6636 16.8752C11.4298 16.674 11.1803 16.4664 10.9227 16.2523C9.15087 14.7787 7 12.9899 7 10.7489C7 9.20951 8.21 8 9.75 8C10.62 8 11.455 8.37929 12 9.01903C12.545 8.37929 13.38 8 14.25 8C15.79 8 17 9.20951 17 10.7489C17 12.9797 14.8729 14.752 13.1086 16.2221C12.8395 16.4463 12.5789 16.6635 12.3355 16.8742Z\"/></svg>",
	"circle-information-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-information-filled\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9ZM13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V12Z\"/></svg>",
	"circle-information-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-information-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z\"/><path d=\"M13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8Z\"/></svg>",
	"circle-minus": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-minus\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.0711 4.9289C15.1608 1.01859 8.83924 1.01859 4.92894 4.9289C1.01864 8.8392 1.01864 15.1607 4.92894 19.071C8.83924 22.9813 15.1608 22.9813 19.0711 19.071C22.9814 15.1607 22.9814 8.8392 19.0711 4.9289ZM15.6628 11.0029C16.2135 11.0029 16.6598 11.4493 16.6598 12C16.6598 12.5506 16.2135 12.997 15.6628 12.997H8.3372C7.78656 12.997 7.34018 12.5506 7.34018 12C7.34018 11.4493 7.78656 11.0029 8.3372 11.0029H15.6628Z\"/></svg>",
	"circle-plus": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-plus\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.92894 4.92897C8.83924 1.01867 15.1608 1.01867 19.0711 4.92897C22.9814 8.83927 22.9814 15.1608 19.0711 19.0711C15.1608 22.9814 8.83924 22.9814 4.92894 19.0711C1.01864 15.1608 1.01864 8.83927 4.92894 4.92897ZM12.997 11.003H15.6628C16.2135 11.003 16.6598 11.4494 16.6598 12C16.6598 12.5507 16.2135 12.9971 15.6628 12.9971H12.997V15.6629C12.997 16.2135 12.5507 16.6599 12 16.6599C11.4494 16.6599 11.003 16.2135 11.003 15.6629V12.9971H8.3372C7.78656 12.9971 7.34018 12.5507 7.34018 12C7.34018 11.4494 7.78656 11.003 8.3372 11.003H11.003V8.33723C11.003 7.78659 11.4494 7.34021 12 7.34021C12.5507 7.34021 12.997 7.78659 12.997 8.33723V11.003Z\"/></svg>",
	"circle-question-mark": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-question-mark\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17ZM14.17 12.17L15.07 11.25C15.64 10.68 16 9.88 16 9C16 6.79 14.21 5 12 5C10.1353 5 8.56966 6.2743 8.12589 8C7.99104 8.53557 8.44772 9 9 9C9.55228 9 9.97992 8.52553 10.2462 8.04165C10.2539 8.02767 10.2617 8.01378 10.2697 8C10.6169 7.40334 11.2636 7 12 7C13.1 7 14 7.9 14 9C14 9.55 13.78 10.05 13.41 10.41L12.17 11.67C11.5608 12.2877 11.1449 13.0987 11.0313 14C10.9623 14.548 11.4477 15 12 15C12.5523 15 12.9786 14.5467 13.086 14.005C13.2489 13.1833 13.6349 12.7125 14.17 12.17Z\"/></svg>",
	"circle-spanner": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-spanner\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11.39 13.49L14.1052 16.2052C14.6795 16.7795 15.6105 16.7795 16.1848 16.2052C16.7553 15.6347 16.7596 14.7111 16.1945 14.1353L13.49 11.38C13.92 10.16 13.66 8.74 12.68 7.76C11.57 6.65 9.9 6.46 8.58 7.17L10.7031 9.28563C11.0933 9.67444 11.0939 10.3061 10.7044 10.6956C10.3154 11.0846 9.68464 11.0846 9.29562 10.6956L7.18 8.58C6.47 9.89 6.66 11.57 7.77 12.68C8.75 13.66 10.17 13.92 11.39 13.49Z\"/></svg>",
	"circle-user": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for circle-user\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 12C22 15.3047 20.397 18.235 17.9261 20.0557C17.4613 20.3982 16.9657 20.7015 16.4443 20.9606C16.4177 20.9738 16.3909 20.987 16.3641 21C15.0454 21.6407 13.5646 22 12 22C10.4354 22 8.95464 21.6407 7.63587 21C7.1363 20.7573 6.65997 20.4742 6.21112 20.1551C6.16509 20.1223 6.11934 20.0892 6.07388 20.0557C3.60301 18.235 2 15.3047 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 15C9.75654 15 7.80066 16.2313 6.77128 18.055C7.27723 18.4923 7.83855 18.8672 8.44332 19.1679C9.51467 19.7005 10.7224 20 12 20C13.2776 20 14.4853 19.7005 15.5567 19.1679C16.1614 18.8672 16.7228 18.4923 17.2287 18.055C16.1993 16.2313 14.2435 15 12 15ZM12 13.5C13.933 13.5 15.5 11.933 15.5 10C15.5 8.067 13.933 6.5 12 6.5C10.067 6.5 8.5 8.067 8.5 10C8.5 11.933 10.067 13.5 12 13.5Z\"/></svg>",
	clock: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for clock\"><path d=\"M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z\"/><path d=\"M12.5 8.5C12.5 7.94772 12.0523 7.5 11.5 7.5C10.9477 7.5 10.5 7.94772 10.5 8.5V12.5C10.5 13.0523 10.9477 13.5 11.5 13.5H15.5C16.0523 13.5 16.5 13.0523 16.5 12.5C16.5 11.9477 16.0523 11.5 15.5 11.5H12.5V8.5Z\"/></svg>",
	"collapse-all": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for collapse-all\"><path d=\"M11.3691 14.2244C11.7618 13.904 12.3408 13.9266 12.707 14.2927L17.707 19.2927C18.0975 19.6833 18.0975 20.3163 17.707 20.7068C17.3164 21.0973 16.6834 21.0973 16.2929 20.7068L11.9999 16.4138L7.70696 20.7068C7.31643 21.0973 6.68342 21.0973 6.29289 20.7068C5.90237 20.3163 5.90237 19.6833 6.29289 19.2927L11.2929 14.2927L11.3691 14.2244Z\"/><path d=\"M16.2929 3.29289C16.6834 2.90237 17.3164 2.90237 17.707 3.29289C18.0975 3.68342 18.0975 4.31643 17.707 4.70696L12.707 9.70696C12.3164 10.0975 11.6834 10.0975 11.2929 9.70696L6.29289 4.70696C5.90237 4.31643 5.90237 3.68342 6.29289 3.29289C6.68342 2.90237 7.31643 2.90237 7.70696 3.29289L11.9999 7.58586L16.2929 3.29289Z\"/></svg>",
	collapse: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for collapse\"><path d=\"M10 20C9.44772 20 9 19.5523 9 19V16.4142L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L7.58579 15L5 15C4.44772 15 4 14.5523 4 14C4 13.4477 4.44772 13 5 13L10 13C10.5523 13 11 13.4477 11 14L11 19C11 19.5523 10.5523 20 10 20Z\"/><path d=\"M14 4C14.5523 4 15 4.44772 15 5V7.58579L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L16.4142 9L19 9C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11L14 11C13.4477 11 13 10.5523 13 10L13 5C13 4.44772 13.4477 4 14 4Z\"/></svg>",
	"comment-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for comment-filled\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.05841 16.2381C3.36139 14.9343 2.99778 13.4784 3.00001 12C3.00001 7.0293 7.02931 3 12 3C16.9707 3 21 7.0293 21 12C21 16.9707 16.9707 21 12 21C10.5216 21.0022 9.06566 20.6386 7.76191 19.9416L3.76708 20.8295C3.40981 20.9089 3.09109 20.5902 3.1705 20.2329L4.05841 16.2381ZM7 10C7 9.44772 7.44772 9 8 9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H8C7.44772 11 7 10.5523 7 10ZM7 14C7 13.4477 7.44772 13 8 13H12C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15H8C7.44772 15 7 14.5523 7 14Z\"/></svg>",
	"comment-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for comment-outline\"><path d=\"M8.05135 17.8285L8.70486 18.1778C9.71761 18.7193 10.8486 19.0017 11.997 19C15.8631 19 19 15.8661 19 12C19 8.13387 15.8661 5 12 5C8.13388 5 5.00001 8.13688 5.00001 12.003C4.99828 13.1514 5.28073 14.2824 5.82217 15.2951L6.17155 15.9486L5.63433 18.3657L8.05135 17.8285ZM3.76708 20.8295C3.40981 20.9089 3.09109 20.5902 3.1705 20.2329L4.05841 16.2381C3.36139 14.9343 2.99778 13.4784 3.00001 12C3.00001 7.0293 7.02931 3 12 3C16.9707 3 21 7.0293 21 12C21 16.9707 16.9707 21 12 21C10.5216 21.0022 9.06566 20.6386 7.76191 19.9416L3.76708 20.8295Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 10C7 9.44772 7.44772 9 8 9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H8C7.44772 11 7 10.5523 7 10Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 14C7 13.4477 7.44772 13 8 13H12C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15H8C7.44772 15 7 14.5523 7 14Z\"/></svg>",
	compare: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for compare\"><path d=\"M8.29289 12.2929C8.68342 11.9024 9.31658 11.9024 9.70711 12.2929L12.7071 15.2929C12.8946 15.4804 13 15.7348 13 16C13 16.2652 12.8946 16.5196 12.7071 16.7071L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071C7.90237 19.3166 7.90237 18.6834 8.29289 18.2929L9.58579 17H3C2.44772 17 2 16.5523 2 16C2 15.4477 2.44772 15 3 15H9.58579L8.29289 13.7071C7.90237 13.3166 7.90237 12.6834 8.29289 12.2929Z\"/><path d=\"M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L14.4142 7H21C21.5523 7 22 7.44772 22 8C22 8.55228 21.5523 9 21 9H14.4142L15.7071 10.2929C16.0976 10.6834 16.0976 11.3166 15.7071 11.7071C15.3166 12.0976 14.6834 12.0976 14.2929 11.7071L11.2929 8.70711C10.9024 8.31658 10.9024 7.68342 11.2929 7.29289L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289Z\"/></svg>",
	connection: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for connection\"><path d=\"M3.29289 20.7071C3.68342 21.0976 4.31658 21.0976 4.70711 20.7071L6.95711 18.4571L7.37868 18.8787C8.55025 20.0503 10.4497 20.0503 11.6213 18.8787L12.7929 17.7071C13.1834 17.3166 13.1834 16.6834 12.7929 16.2929L12.2071 15.7071L13.2071 14.7071C13.5976 14.3166 13.5976 13.6834 13.2071 13.2929C12.8166 12.9024 12.1834 12.9024 11.7929 13.2929L10.7929 14.2929L9.70711 13.2071L10.7071 12.2071C11.0976 11.8166 11.0976 11.1834 10.7071 10.7929C10.3166 10.4024 9.68342 10.4024 9.29289 10.7929L8.29289 11.7929L7.70711 11.2071C7.31658 10.8166 6.68342 10.8166 6.29289 11.2071L5.12132 12.3787C3.94975 13.5503 3.94975 15.4497 5.12132 16.6213L5.54289 17.0429L3.29289 19.2929C2.90237 19.6834 2.90237 20.3166 3.29289 20.7071Z\"/><path d=\"M20.7071 4.70711C21.0976 4.31658 21.0976 3.68342 20.7071 3.29289C20.3166 2.90237 19.6834 2.90237 19.2929 3.29289L17.0429 5.54289L16.6213 5.12132C15.4498 3.94975 13.5503 3.94975 12.3787 5.12132L11.2071 6.29289C10.8166 6.68342 10.8166 7.31658 11.2071 7.70711L16.2929 12.7929C16.6834 13.1834 17.3166 13.1834 17.7071 12.7929L18.8787 11.6213C20.0503 10.4497 20.0503 8.55025 18.8787 7.37868L18.4571 6.95711L20.7071 4.70711Z\"/></svg>",
	contacts: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for contacts\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 4C4 2.89543 4.89543 2 6 2H18C19.1046 2 20 2.89543 20 4V6H21C21.5523 6 22 6.44772 22 7C22 7.55228 21.5523 8 21 8H20V11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H20V16H21C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18H20V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4ZM18 12V7V4L6 4V20H18V17V12ZM12 7C10.696 7 9.63887 8.08069 9.63887 9.41379C9.63887 10.7469 10.696 11.8276 12 11.8276C13.3033 11.8259 14.3595 10.7462 14.3611 9.41379C14.3611 8.08069 13.304 7 12 7ZM15.373 17C15.7456 17 16.0535 16.6889 15.9922 16.3132C15.6722 14.3548 14.0066 12.8621 12 12.8621C9.9934 12.8621 8.32784 14.3548 8.00784 16.3132C7.94645 16.6889 8.25438 17 8.62695 17H15.373Z\"/></svg>",
	copy: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for copy\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 4C6 2.89543 6.89543 2 8 2H18C19.1046 2 20 2.89543 20 4V17C20 18.1046 19.1046 19 18 19H8C6.89543 19 6 18.1046 6 17V4ZM18 4H8V17H18V4Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 20V6H3V20.0046C3 21.1122 3.89606 22 4.99765 22H16V20H5Z\"/></svg>",
	"credit-card": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for credit-card\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 15C6 14.4477 6.44772 14 7 14H11C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H7C6.44772 16 6 15.5523 6 15Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4ZM4 6L20 6V8H4V6ZM4 12V18L20 18V12H4ZM7 14C6.44772 14 6 14.4477 6 15C6 15.5523 6.44772 16 7 16H11C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14H7Z\"/></svg>",
	cross: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for cross\"><path d=\"M18.295 7.11502C18.6843 6.72565 18.6843 6.09438 18.295 5.70501C17.9056 5.31565 17.2743 5.31565 16.885 5.70502L12 10.59L7.11498 5.70501C6.72562 5.31565 6.09435 5.31565 5.70498 5.70501C5.31562 6.09438 5.31562 6.72565 5.70498 7.11502L10.59 12L5.70498 16.885C5.31562 17.2744 5.31562 17.9057 5.70498 18.295C6.09435 18.6844 6.72562 18.6844 7.11498 18.295L12 13.41L16.885 18.295C17.2743 18.6844 17.9056 18.6844 18.295 18.295C18.6843 17.9057 18.6843 17.2744 18.295 16.885L13.41 12L18.295 7.11502Z\"/></svg>",
	currency: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for currency\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 7C12.2386 7 10 9.23858 10 12C10 14.7614 12.2386 17 15 17C17.7614 17 20 14.7614 20 12C20 9.23858 17.7614 7 15 7ZM8 12C8 8.13401 11.134 5 15 5C18.866 5 22 8.13401 22 12C22 15.866 18.866 19 15 19C11.134 19 8 15.866 8 12Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.41279 5.9448C8.55539 6.47835 8.23846 7.02649 7.70491 7.1691C6.84614 7.39862 6.07699 7.85194 5.46447 8.46446C4.55855 9.37038 4 10.619 4 12C4 13.381 4.55855 14.6296 5.46447 15.5355C6.07699 16.1481 6.84614 16.6014 7.70491 16.8309C8.23846 16.9735 8.55539 17.5216 8.41279 18.0552C8.27018 18.5888 7.72205 18.9057 7.18849 18.7631C5.98194 18.4406 4.90525 17.8047 4.05025 16.9497C2.7846 15.6841 2 13.9327 2 12C2 10.0673 2.7846 8.31591 4.05025 7.05025C4.90525 6.19526 5.98194 5.5594 7.18849 5.23692C7.72205 5.09431 8.27018 5.41124 8.41279 5.9448Z\"/></svg>",
	"devices-app": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for devices-app\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 5H9V9H5V5ZM3 5C3 3.89543 3.89543 3 5 3H9C10.1046 3 11 3.89543 11 5V9C11 10.1046 10.1046 11 9 11H5C3.89543 11 3 10.1046 3 9V5ZM5 15H9V19H5V15ZM3 15C3 13.8954 3.89543 13 5 13H9C10.1046 13 11 13.8954 11 15V19C11 20.1046 10.1046 21 9 21H5C3.89543 21 3 20.1046 3 19V15ZM15 19V15H19V19H15ZM13 15C13 13.8954 13.8954 13 15 13H19C20.1046 13 21 13.8954 21 15V19C21 20.1046 20.1046 21 19 21H15C13.8954 21 13 20.1046 13 19V15Z\"/><path d=\"M13 5C13 3.89543 13.8954 3 15 3H19C20.1046 3 21 3.89543 21 5V9C21 10.1046 20.1046 11 19 11H15C13.8954 11 13 10.1046 13 9V5Z\"/></svg>",
	"devices-desktop": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for devices-desktop\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.5 18V19H8C7.44772 19 7 19.4477 7 20C7 20.5523 7.44772 21 8 21H16C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19H14.5V18H20C21.1046 18 22 17.1046 22 16V6C22 4.89543 21.1046 4 20 4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H9.5ZM20 16H4V6H20V16Z\"/></svg>",
	"devices-phone": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for devices-phone\"><path d=\"M17 2H7C5.897 2 5 2.897 5 4V20C5 21.103 5.897 22 7 22H17C18.103 22 19 21.103 19 20V4C19 2.897 18.103 2 17 2ZM7 20V4H17L17.002 20H7Z\"/><path d=\"M12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z\"/></svg>",
	"discount-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for discount-filled\"><path d=\"M11.998 1.23145C12.4096 1.23155 12.8047 1.39459 13.0957 1.68555L14.8721 3.45898C15.1628 3.75028 15.5582 3.91354 15.9697 3.91406H18.7627C19.1744 3.91406 19.5702 4.07797 19.8613 4.36914C20.1523 4.66025 20.3154 5.05517 20.3154 5.4668V8.26074C20.3155 8.6721 20.4788 9.06737 20.7695 9.3584L22.5459 11.1318C22.8368 11.4229 22.9999 11.818 23 12.2295C23 12.641 22.8367 13.036 22.5459 13.3271L20.7715 15.1035C20.4792 15.3942 20.3154 15.7885 20.3154 16.2002V18.9941C20.3154 19.4057 20.1522 19.8007 19.8613 20.0918C19.5702 20.383 19.1744 20.5469 18.7627 20.5469H15.9697C15.5584 20.547 15.1631 20.7103 14.8721 21.001L13.0986 22.7773C12.8076 23.0683 12.4125 23.2314 12.001 23.2314C11.5895 23.2314 11.1944 23.0682 10.9033 22.7773L9.12793 21.0029C8.83723 20.7106 8.44197 20.5469 8.03027 20.5469H5.2373C4.37934 20.5469 3.68457 19.8522 3.68457 18.9941V16.2002C3.6846 15.9965 3.64432 15.7946 3.56641 15.6064C3.48853 15.4184 3.37434 15.2475 3.23047 15.1035L1.4541 13.3291C1.16321 13.038 1 12.643 1 12.2314C1 11.8199 1.16321 11.4249 1.4541 11.1338L3.22656 9.35645C3.51778 9.06573 3.68203 8.67126 3.68262 8.25977V5.46582C3.68262 5.05404 3.84654 4.65836 4.1377 4.36719C4.42882 4.0762 4.82374 3.91309 5.23535 3.91309H8.0293C8.4408 3.91253 8.83526 3.74829 9.12598 3.45703L10.9004 1.68555C11.1915 1.39474 11.5866 1.23145 11.998 1.23145ZM7.0498 15.7666L8.46484 17.1816L16.9502 8.69629L15.5352 7.28223L7.0498 15.7666ZM14 16.2314H16V14.2314H14V16.2314ZM8 10.2314H10V8.23145H8V10.2314Z\"/></svg>",
	discount: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for discount\"><path d=\"M3.44043 18.1484V15.6074L3.43262 15.5273C3.42742 15.5013 3.41937 15.4758 3.40918 15.4512C3.38858 15.4014 3.35838 15.3555 3.32031 15.3174L1.70605 13.7051C1.25402 13.2529 1 12.6394 1 12C1 11.3606 1.25402 10.7471 1.70605 10.2949L3.31641 8.68066L3.31836 8.67871L3.36914 8.61621C3.41373 8.5496 3.43803 8.47097 3.43848 8.38965V5.84863C3.43859 5.20925 3.6934 4.5957 4.14551 4.14355C4.59769 3.69155 5.21121 3.4375 5.85059 3.4375H8.38867C8.4977 3.43736 8.60264 3.3936 8.67969 3.31641L10.2939 1.70508C10.746 1.2536 11.3591 1 11.998 1C12.637 1.00005 13.2501 1.25352 13.7021 1.70508L15.3174 3.31641L15.3193 3.31836L15.3818 3.37012C15.4487 3.41471 15.5278 3.43929 15.6094 3.43945H18.1484C18.788 3.43948 19.4013 3.69328 19.8535 4.14551C20.3057 4.59774 20.5596 5.21109 20.5596 5.85059V8.39062L20.5674 8.4707C20.5831 8.54965 20.6221 8.62282 20.6797 8.68066L22.2939 10.293L22.4541 10.4707C22.8055 10.8998 23 11.4396 23 11.999C22.9999 12.5583 22.8054 13.0974 22.4541 13.5264L22.2939 13.7031L20.6797 15.3193C20.6032 15.3954 20.5596 15.4995 20.5596 15.6084V18.1484C20.5595 18.7878 20.3056 19.4014 19.8535 19.8535C19.4013 20.3057 18.7879 20.5595 18.1484 20.5596H15.6084C15.4996 20.5597 15.3954 20.6029 15.3184 20.6797L15.3174 20.6787L13.7061 22.2939C13.2539 22.7458 12.6402 22.9999 12.001 23C11.4415 23 10.9017 22.8056 10.4727 22.4541L10.2959 22.2939L8.68164 20.6816L8.67969 20.6787C8.60366 20.6023 8.50039 20.5596 8.3916 20.5596H5.85156C4.5194 20.5595 3.44063 19.4805 3.44043 18.1484ZM5.43848 8.39062C5.43762 9.02917 5.18298 9.64035 4.73145 10.0918L4.73242 10.0928L3.12109 11.708L3.12012 11.709C3.04307 11.7861 3 11.8909 3 12C3 12.1086 3.04271 12.213 3.11914 12.29L4.73438 13.9033L4.89355 14.0791C5.04355 14.2619 5.16602 14.4663 5.25684 14.6855C5.37791 14.978 5.44048 15.2919 5.44043 15.6084V18.1484C5.44063 18.376 5.62411 18.5595 5.85156 18.5596H8.3916C9.03031 18.5596 9.64341 18.8129 10.0957 19.2666L11.71 20.8789L11.7725 20.9307C11.8396 20.9755 11.9191 21 12.001 21C12.1097 20.9999 12.214 20.9567 12.291 20.8799L13.9043 19.2656L14.0811 19.1055C14.5099 18.7542 15.0492 18.5597 15.6084 18.5596H18.1484C18.2575 18.5595 18.3623 18.5165 18.4395 18.4395C18.5165 18.3624 18.5595 18.2575 18.5596 18.1484V15.6084C18.5596 15.0488 18.7542 14.5085 19.1074 14.0791L19.2686 13.9014L20.8799 12.2891L20.9307 12.2266C20.9753 12.1596 20.9999 12.0807 21 11.999C21 11.9172 20.9754 11.8376 20.9307 11.7705L20.8799 11.708L19.2656 10.0947C18.8706 9.6992 18.6261 9.18035 18.5713 8.62891L18.5596 8.39062V5.85059C18.5596 5.74151 18.5165 5.63672 18.4395 5.55957C18.3623 5.48243 18.2575 5.43948 18.1484 5.43945H15.6074C14.9682 5.43865 14.3549 5.18387 13.9033 4.73145L12.2891 3.12109C12.212 3.04401 12.107 3.00005 11.998 3C11.8891 3 11.7842 3.04309 11.707 3.12012L10.0938 4.73145L10.0928 4.73047C9.64137 5.18193 9.03008 5.43664 8.3916 5.4375H5.85059C5.74166 5.4375 5.63669 5.48067 5.55957 5.55762C5.48252 5.63468 5.43859 5.73964 5.43848 5.84863V8.39062Z\"/><path d=\"M8 8H10V10H8V8Z\"/><path d=\"M14 14H16V16H14V14Z\"/><path d=\"M7.05025 15.5355L15.5355 7.05025L16.9497 8.46447L8.46447 16.9497L7.05025 15.5355Z\"/></svg>",
	"double-horizontal-line": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for double-horizontal-line\"><path d=\"M19 14C19 14.5523 18.5523 15 18 15H6C5.44772 15 5 14.5523 5 14C5 13.4477 5.44772 13 6 13H18C18.5523 13 19 13.4477 19 14Z\"/><path d=\"M19 10C19 10.5523 18.5523 11 18 11H6C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9H18C18.5523 9 19 9.44772 19 10Z\"/></svg>",
	download: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for download\"><path d=\"M12 2C11.4477 2 11 2.44771 11 3L11 14.17L7.70544 10.8837C7.31569 10.4949 6.6847 10.4953 6.29544 10.8845C5.90584 11.2742 5.90584 11.9058 6.29544 12.2954L11.2929 17.2929C11.6834 17.6834 12.3166 17.6834 12.7071 17.2929L17.7046 12.2955C18.0942 11.9058 18.0942 11.2742 17.7046 10.8846C17.3153 10.4953 16.6843 10.4949 16.2946 10.8837L13 14.17L13 3C13 2.44771 12.5523 2 12 2Z\"/><path d=\"M6 21C6 20.4477 6.44772 20 7 20H17C17.5523 20 18 20.4477 18 21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21Z\"/></svg>",
	drag: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for drag\"><path d=\"M11 6C11 7.10457 10.1046 8 9 8C7.89543 8 7 7.10457 7 6C7 4.89543 7.89543 4 9 4C10.1046 4 11 4.89543 11 6Z\"/><path d=\"M11 12C11 13.1046 10.1046 14 9 14C7.89543 14 7 13.1046 7 12C7 10.8954 7.89543 10 9 10C10.1046 10 11 10.8954 11 12Z\"/><path d=\"M11 18C11 19.1046 10.1046 20 9 20C7.89543 20 7 19.1046 7 18C7 16.8954 7.89543 16 9 16C10.1046 16 11 16.8954 11 18Z\"/><path d=\"M17 6C17 7.10457 16.1046 8 15 8C13.8954 8 13 7.10457 13 6C13 4.89543 13.8954 4 15 4C16.1046 4 17 4.89543 17 6Z\"/><path d=\"M17 12C17 13.1046 16.1046 14 15 14C13.8954 14 13 13.1046 13 12C13 10.8954 13.8954 10 15 10C16.1046 10 17 10.8954 17 12Z\"/><path d=\"M17 18C17 19.1046 16.1046 20 15 20C13.8954 20 13 19.1046 13 18C13 16.8954 13.8954 16 15 16C16.1046 16 17 16.8954 17 18Z\"/></svg>",
	"edit-pencil": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for edit-pencil\"><path d=\"M14.9833 5.48122L3.92558 16.5389C3.76016 16.7043 3.65797 16.9225 3.63679 17.1555L3.42466 19.4889C3.36812 20.1109 3.88915 20.6319 4.51109 20.5754L6.84454 20.3632C7.07752 20.342 7.29569 20.2399 7.46111 20.0744L18.5188 9.01675L14.9833 5.48122Z\"/><path d=\"M19.2259 8.30964L21.3472 6.18831C21.7378 5.79778 21.7378 5.16462 21.3472 4.77409L19.2259 2.65277C18.8354 2.26225 18.2022 2.26225 17.8117 2.65277L15.6904 4.77411L19.2259 8.30964Z\"/></svg>",
	"events-conference": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for events-conference\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 16C22 17.1046 21.1046 18 20 18H17.618L18.8944 20.5528C19.1414 21.0468 18.9412 21.6474 18.4472 21.8944C17.9532 22.1414 17.3526 21.9412 17.1056 21.4472L15.382 18H13V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V18H8.61803L6.89443 21.4472C6.64744 21.9412 6.04676 22.1414 5.55279 21.8944C5.05881 21.6474 4.85858 21.0468 5.10557 20.5528L6.38197 18H4C2.89543 18 2 17.1046 2 16V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V16ZM20 16H4V6H20V16Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.7702 13.0984C13.15 13.4702 13.7638 13.4702 14.1436 13.0984L17.7969 9.53101C18.1826 9.15435 18.183 8.53411 17.7977 8.15698C17.4246 7.79175 16.8281 7.79131 16.4545 8.15599L13.4569 11.0818L11.2298 8.90159C10.85 8.52983 10.2362 8.52983 9.85638 8.90159L6.2605 12.4118C5.87467 12.7885 5.87423 13.4088 6.25954 13.786C6.63259 14.1512 7.22899 14.1517 7.60265 13.7871L10.5431 10.9182L12.7702 13.0984Z\"/></svg>",
	"events-global": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for events-global\"><path d=\"M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19.93C7.05 19.44 4 16.08 4 12C4 11.38 4.08 10.79 4.21 10.21L9 15V16C9 17.1 9.9 18 11 18V19.93ZM17.9 17.39C17.64 16.58 16.9 16 16 16H15V13C15 12.45 14.55 12 14 12H8V10H10C10.55 10 11 9.55 11 9V7H13C14.1 7 15 6.1 15 5V4.59C17.93 5.78 20 8.65 20 12C20 14.08 19.2 15.97 17.9 17.39Z\"/></svg>",
	"events-holiday": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for events-holiday\"><path d=\"M13.57 15L15 13.57L20.29 18.86C20.68 19.25 20.68 19.89 20.29 20.29C19.9 20.68 19.26 20.68 18.86 20.29L13.57 15Z\"/><path d=\"M17.42 8.83001L18.69 7.56001C19.58 6.67001 19.46 5.13001 18.38 4.48001C14.49 2.10001 9.33 2.61001 5.96 5.97001C2.6 9.34001 2.1 14.49 4.47 18.38C5.13 19.46 6.66 19.59 7.55 18.69L8.82 17.42C6.48594 15.0785 5.31594 12.0318 5.41888 9.00001C5.44687 8.50979 6.03176 8.5002 6.15291 8.97125C6.15532 8.98064 6.15756 8.99023 6.1596 9.00001C6.70493 11.3308 8.10957 13.8327 10.26 15.99L15.99 10.26C13.8413 8.11131 11.3345 6.71192 9 6.16859C8.99031 6.16658 8.98081 6.16438 8.97149 6.162C8.50019 6.04144 8.50969 5.45512 9 5.42717C12.0318 5.32434 15.0806 6.49063 17.42 8.83001Z\"/></svg>",
	"events-music": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for events-music\"><path d=\"M12 5V13.55C11.06 13.01 9.89997 12.8 8.66997 13.23C7.32997 13.71 6.29997 14.9 6.05997 16.3C5.59997 19.04 7.91997 21.38 10.65 20.95C12.61 20.64 14 18.84 14 16.85V7H16C17.1 7 18 6.1 18 5C18 3.9 17.1 3 16 3H14C12.9 3 12 3.9 12 5Z\"/></svg>",
	"events-performing-arts": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for events-performing-arts\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.5 4C11.5 2.89543 12.3954 2 13.5 2H20C21.1046 2 22 2.89543 22 4V8C22 11.5 19 13 16.5 13C15.6318 13 14.7635 12.8191 14 12.4363C13.9835 12.428 13.9671 12.4197 13.9507 12.4112C13.7411 11.1737 12.8819 10.1572 11.7361 9.72455C11.7174 9.66197 11.6998 9.59843 11.6832 9.53392C11.5645 9.07284 11.5 8.56222 11.5 8L11.5 4ZM13.75 5.5C13.75 4.95 14.2 4.5 14.75 4.5C15.3 4.5 15.75 4.95 15.75 5.5C15.75 6.05 15.3 6.5 14.75 6.5C14.2 6.5 13.75 6.05 13.75 5.5ZM18.75 6.5C18.2 6.5 17.75 6.05 17.75 5.5C17.75 4.95 18.2 4.5 18.75 4.5C19.3 4.5 19.75 4.95 19.75 5.5C19.75 6.05 19.3 6.5 18.75 6.5ZM14.45 9.75C14.75 9.21316 15.45 8.5 16.75 8.5C18.05 8.5 18.75 9.21316 19.05 9.75C19.24 10.09 18.99 10.5 18.61 10.5L14.89 10.5C14.51 10.5 14.26 10.09 14.45 9.75Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.5 13C12.5 11.8954 11.6046 11 10.5 11H4C2.89543 11 2 11.8954 2 13L2.00001 17C2.00001 20.5 4.50001 22 7.00001 22C9.50001 22 12.5 20.5 12.5 17V13ZM5.25001 13.5C4.70001 13.5 4.25001 13.95 4.25001 14.5C4.25001 15.05 4.70001 15.5 5.25001 15.5C5.80001 15.5 6.25001 15.05 6.25001 14.5C6.25001 13.95 5.80001 13.5 5.25001 13.5ZM9.25001 15.5C8.70001 15.5 8.25001 15.05 8.25001 14.5C8.25001 13.95 8.70001 13.5 9.25001 13.5C9.80001 13.5 10.25 13.95 10.25 14.5C10.25 15.05 9.80001 15.5 9.25001 15.5ZM7.25001 19.5C8.55001 19.5 9.25001 18.7868 9.55001 18.25C9.74001 17.91 9.49001 17.5 9.11001 17.5H5.39001C5.01001 17.5 4.76001 17.91 4.95001 18.25C5.25001 18.7868 5.95001 19.5 7.25001 19.5Z\"/></svg>",
	"events-sports": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for events-sports\"><path d=\"M11.4122 8.42705C11.7627 8.1724 12.2373 8.17241 12.5878 8.42705L15.2164 10.3369C15.5669 10.5915 15.7136 11.0429 15.5797 11.4549L14.5757 14.5451C14.4418 14.9571 14.0578 15.2361 13.6246 15.2361H10.3754C9.94217 15.2361 9.55822 14.9571 9.42434 14.5451L8.42028 11.4549C8.28641 11.0429 8.43307 10.5915 8.78356 10.3369L11.4122 8.42705Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.5615 19.8477C13.0565 19.9476 12.5344 20 12 20C11.4533 20 10.9194 19.9452 10.4036 19.8407L9.35238 16.7878C9.21134 16.3782 8.82257 16.106 8.38941 16.1136L5.17126 16.1697C4.51001 15.0891 4.09806 13.8394 4.01541 12.5006L6.68294 10.7013C7.0421 10.459 7.20442 10.0131 7.08501 9.59662L6.19554 6.49468C6.92195 5.72905 7.79823 5.10702 8.7774 4.67559L11.396 6.57807C11.7464 6.83272 12.221 6.83272 12.5715 6.57807L15.2023 4.66669C16.3948 5.18817 17.4357 5.99202 18.2403 6.9937L17.0737 10.0327C16.9185 10.4372 17.0413 10.8956 17.378 11.1683L19.908 13.217C19.7449 14.2857 19.3704 15.2848 18.8284 16.1703L15.5781 16.1136C15.1449 16.106 14.7561 16.3782 14.6151 16.7878L13.5615 19.8477ZM11.4122 8.42705C11.7627 8.1724 12.2373 8.17241 12.5878 8.42705L15.2164 10.3369C15.5669 10.5915 15.7136 11.0429 15.5797 11.4549L14.5757 14.5451C14.4418 14.9571 14.0578 15.2361 13.6246 15.2361H10.3754C9.94217 15.2361 9.55822 14.9571 9.42434 14.5451L8.42028 11.4549C8.28641 11.0429 8.43307 10.5915 8.78356 10.3369L11.4122 8.42705Z\"/></svg>",
	"excel-export": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for excel-export\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.8356 21.8059C13.4451 21.9075 14 21.4375 14 20.8195V20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H14V3.19061C14 2.57304 13.4458 2.1031 12.8365 2.20407L2 4V20L12.8356 21.8059ZM14 18H20V6H14V9H18V11H14V13H18V15H14V18ZM6.95474 8.96789C6.86408 8.73459 6.77342 8.5013 6.68491 8.26732C6.28191 8.28937 5.87933 8.31312 5.4765 8.33689L5.16119 8.35546C5.37822 8.83778 5.60089 9.31743 5.82356 9.79707C6.15051 10.5014 6.47746 11.2056 6.78654 11.9183C6.38635 12.6789 6.00286 13.4465 5.6195 14.2138C5.41683 14.6194 5.21414 15.0251 5.00909 15.4296C5.51453 15.4506 6.01997 15.4716 6.52608 15.4784C6.6684 15.1126 6.82449 14.7522 6.98061 14.3918C7.21945 13.8404 7.45835 13.2888 7.64801 12.7176C7.84414 13.4243 8.13611 14.094 8.42792 14.7634C8.55467 15.0541 8.6814 15.3448 8.80022 15.6384C9.35681 15.6777 9.91071 15.713 10.4666 15.7455C10.1725 15.1445 9.87591 14.5454 9.5794 13.9465C9.23347 13.2478 8.88756 12.5491 8.54582 11.8478C9.17375 10.5806 9.79226 9.30804 10.4087 8.03613C9.88446 8.06189 9.36085 8.09444 8.83926 8.13173C8.72166 8.41973 8.59819 8.70546 8.47473 8.99117C8.1884 9.6538 7.90209 10.3164 7.68906 11.0071C7.47814 10.3148 7.21637 9.64114 6.95474 8.96789Z\"/></svg>",
	"exclamation-mark": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for exclamation-mark\"><path d=\"M10.5 20.5C10.5 19.6716 11.1716 19 12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5Z\"/><path d=\"M13.5 15.5C13.5 16.3284 12.8284 17 12 17C11.1716 17 10.5 16.3284 10.5 15.5V3.5C10.5 2.67157 11.1716 2 12 2C12.8284 2 13.5 2.67157 13.5 3.5V15.5Z\"/></svg>",
	"expand-all": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for expand-all\"><path d=\"M16.2929 14.2929C16.6834 13.9024 17.3164 13.9024 17.707 14.2929C18.0975 14.6834 18.0975 15.3164 17.707 15.707L12.707 20.707C12.3164 21.0975 11.6834 21.0975 11.2929 20.707L6.29289 15.707C5.90237 15.3164 5.90237 14.6834 6.29289 14.2929C6.68342 13.9024 7.31643 13.9024 7.70696 14.2929L11.9999 18.5859L16.2929 14.2929Z\"/><path d=\"M11.3691 3.22438C11.7618 2.90402 12.3408 2.92662 12.707 3.29273L17.707 8.29273C18.0975 8.68326 18.0975 9.31627 17.707 9.7068C17.3164 10.0973 16.6834 10.0973 16.2929 9.7068L11.9999 5.41383L7.70696 9.7068C7.31643 10.0973 6.68342 10.0973 6.29289 9.7068C5.90237 9.31627 5.90237 8.68326 6.29289 8.29273L11.2929 3.29273L11.3691 3.22438Z\"/></svg>",
	expand: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for expand\"><path d=\"M5 13C5.55228 13 6 13.4477 6 14V16.5858L9.29289 13.2929C9.68342 12.9024 10.3166 12.9024 10.7071 13.2929C11.0976 13.6834 11.0976 14.3166 10.7071 14.7071L7.41421 18L10 18C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20H5C4.44772 20 4 19.5523 4 19V14C4 13.4477 4.44772 13 5 13Z\"/><path d=\"M13 5C13 4.44772 13.4477 4 14 4H19C19.5523 4 20 4.44772 20 5V10C20 10.5523 19.5523 11 19 11C18.4477 11 18 10.5523 18 10V7.41421L14.7071 10.7071C14.3166 11.0976 13.6834 11.0976 13.2929 10.7071C12.9024 10.3166 12.9024 9.68342 13.2929 9.29289L16.5858 6H14C13.4477 6 13 5.55228 13 5Z\"/></svg>",
	export: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for export\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 12H7.625C8.17729 12 8.625 11.5523 8.625 11C8.625 10.4477 8.17729 10 7.625 10H5.875C4.80379 10 4 10.8911 4 11.9091V20.0909C4 21.1089 4.80379 22 5.875 22H18.125C19.1962 22 20 21.1089 20 20.0909V11.9091C20 10.8911 19.1962 10 18.125 10H16.375C15.8227 10 15.375 10.4477 15.375 11C15.375 11.5523 15.8227 12 16.375 12H18V20H6V12Z\"/><path d=\"M12.7071 2.29289C12.3166 1.90237 11.6834 1.90237 11.2929 2.29289L7.29289 6.29289C6.90237 6.68342 6.90237 7.31658 7.29289 7.70711C7.68342 8.09763 8.31658 8.09763 8.70711 7.70711L11 5.41421V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V5.41421L15.2929 7.70711C15.6834 8.09763 16.3166 8.09763 16.7071 7.70711C17.0976 7.31658 17.0976 6.68342 16.7071 6.29289L12.7071 2.29289Z\"/></svg>",
	"feedback-negative-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for feedback-negative-filled\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10 10C10.8284 10 11.5 9.32843 11.5 8.5C11.5 7.67157 10.8284 7 10 7C9.17157 7 8.5 7.67157 8.5 8.5C8.5 9.32843 9.17157 10 10 10ZM15.5 8.5C15.5 9.32843 14.8284 10 14 10C13.1716 10 12.5 9.32843 12.5 8.5C12.5 7.67157 13.1716 7 14 7C14.8284 7 15.5 7.67157 15.5 8.5ZM15.9914 12.9569C16.5197 12.7962 16.8177 12.2375 16.6569 11.7091C16.4961 11.1808 15.9374 10.8828 15.4091 11.0436L8.50893 13.1434C7.98057 13.3042 7.6826 13.8629 7.84339 14.3913C8.00418 14.9196 8.56285 15.2176 9.09121 15.0568L15.9914 12.9569Z\"/></svg>",
	"feedback-negative-outline": "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for feedback-negative-outline\"><path d=\"M8.00024 14.6666C11.682 14.6665 14.6663 11.6814 14.6663 7.99963C14.6661 4.31799 11.6819 1.33379 8.00024 1.33362C4.31845 1.33362 1.33343 4.31788 1.33325 7.99963C1.33325 11.6815 4.31835 14.6666 8.00024 14.6666ZM8.00024 13.3336C5.05473 13.3336 2.66626 10.9452 2.66626 7.99963C2.66644 5.05426 5.05483 2.66663 8.00024 2.66663C10.9455 2.6668 13.3331 5.05437 13.3333 7.99963C13.3333 10.945 10.9456 13.3334 8.00024 13.3336ZM6.66626 6.66663C7.21854 6.66663 7.66626 6.21891 7.66626 5.66663C7.66626 5.11434 7.21854 4.66663 6.66626 4.66663C6.11412 4.6668 5.66626 5.11445 5.66626 5.66663C5.66626 6.2188 6.11412 6.66645 6.66626 6.66663ZM9.33325 6.66663C9.88554 6.66663 10.3333 6.21891 10.3333 5.66663C10.3333 5.11434 9.88554 4.66663 9.33325 4.66663C8.78097 4.66663 8.33325 5.11434 8.33325 5.66663C8.33325 6.21891 8.78097 6.66663 9.33325 6.66663ZM6.06079 10.0377L10.6604 8.63831C11.0126 8.53114 11.2117 8.15843 11.1047 7.80627C10.9976 7.45409 10.6249 7.25486 10.2727 7.36194L5.67212 8.76233C5.32013 8.86969 5.12161 9.24226 5.22876 9.59436C5.33603 9.94648 5.70861 10.1449 6.06079 10.0377Z\"/></svg>",
	"feedback-positive-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for feedback-positive-filled\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10 10C10.8284 10 11.5 9.32843 11.5 8.5C11.5 7.67157 10.8284 7 10 7C9.17157 7 8.5 7.67157 8.5 8.5C8.5 9.32843 9.17157 10 10 10ZM15.5 8.5C15.5 9.32843 14.8284 10 14 10C13.1716 10 12.5 9.32843 12.5 8.5C12.5 7.67157 13.1716 7 14 7C14.8284 7 15.5 7.67157 15.5 8.5ZM9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z\"/></svg>",
	"feedback-positive-outline": "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for feedback-positive-outline\"><path d=\"M7.99976 14.6666C4.31801 14.6664 1.33374 11.6814 1.33374 7.99963C1.33392 4.31799 4.31812 1.33379 7.99976 1.33362C11.6815 1.33362 14.6666 4.31788 14.6667 7.99963C14.6667 11.6815 11.6817 14.6666 7.99976 14.6666ZM7.99976 13.3336C10.9453 13.3336 13.3337 10.9452 13.3337 7.99963C13.3336 5.05426 10.9452 2.66663 7.99976 2.66663C5.0545 2.6668 2.66692 5.05437 2.66675 7.99963C2.66675 10.945 5.05439 13.3334 7.99976 13.3336ZM9.33374 6.66663C8.78146 6.66663 8.33374 6.21891 8.33374 5.66663C8.33374 5.11434 8.78146 4.66663 9.33374 4.66663C9.88588 4.6668 10.3337 5.11445 10.3337 5.66663C10.3337 6.2188 9.88588 6.66645 9.33374 6.66663ZM6.66675 6.66663C6.11446 6.66663 5.66675 6.21891 5.66675 5.66663C5.66675 5.11434 6.11446 4.66663 6.66675 4.66663C7.21903 4.66663 7.66675 5.11434 7.66675 5.66663C7.66675 6.21891 7.21903 6.66663 6.66675 6.66663ZM7.99976 11.3336C6.15896 11.3334 4.66675 9.84047 4.66675 7.99963C4.66692 7.63159 4.96566 7.33362 5.33374 7.33362C5.70167 7.33379 5.99958 7.6317 5.99976 7.99963C5.99976 9.10409 6.89534 9.99946 7.99976 9.99963C9.10433 9.99963 9.99976 9.1042 9.99976 7.99963C9.99993 7.63159 10.2987 7.33362 10.6667 7.33362C11.0348 7.33362 11.3336 7.63159 11.3337 7.99963C11.3337 9.84058 9.84071 11.3336 7.99976 11.3336Z\"/></svg>",
	"feedback-super-positive-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for feedback-super-positive-filled\"><path d=\"M8.4782 12.9091C8.88187 14.4775 10.3056 15.6364 12 15.6364C13.6944 15.6364 15.1181 14.4775 15.5218 12.9091H8.4782Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8.81818 8.81818C8.81818 8.56714 9.02169 8.36364 9.27273 8.36364C9.52377 8.36364 9.72727 8.56714 9.72727 8.81818C9.72727 9.32026 10.1343 9.72727 10.6364 9.72727C11.1384 9.72727 11.5455 9.32026 11.5455 8.81818C11.5455 7.56299 10.5279 6.54545 9.27273 6.54545C8.01753 6.54545 7 7.56299 7 8.81818C7 9.32026 7.40701 9.72727 7.90909 9.72727C8.41117 9.72727 8.81818 9.32026 8.81818 8.81818ZM14.2727 8.81818C14.2727 8.56714 14.4762 8.36364 14.7273 8.36364C14.9783 8.36364 15.1818 8.56714 15.1818 8.81818C15.1818 9.32026 15.5888 9.72727 16.0909 9.72727C16.593 9.72727 17 9.32026 17 8.81818C17 7.56299 15.9825 6.54545 14.7273 6.54545C13.4721 6.54545 12.4545 7.56299 12.4545 8.81818C12.4545 9.32026 12.8616 9.72727 13.3636 9.72727C13.8657 9.72727 14.2727 9.32026 14.2727 8.81818ZM6.54545 12C6.54545 11.4979 6.95247 11.0909 7.45455 11.0909H16.5455C17.0475 11.0909 17.4545 11.4979 17.4545 12C17.4545 15.0125 15.0125 17.4545 12 17.4545C8.98754 17.4545 6.54545 15.0125 6.54545 12Z\"/></svg>",
	"feedback-super-positive-outline": "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for feedback-super-positive-outline\"><path d=\"M8.00024 1.33337C11.682 1.33355 14.6663 4.31858 14.6663 8.00037C14.6661 11.682 11.6819 14.6662 8.00024 14.6664C4.31845 14.6664 1.33343 11.6821 1.33325 8.00037C1.33325 4.31847 4.31835 1.33337 8.00024 1.33337ZM8.00024 2.66638C5.05473 2.66638 2.66626 5.05485 2.66626 8.00037C2.66644 10.9457 5.05483 13.3334 8.00024 13.3334C10.9455 13.3332 13.3331 10.9456 13.3333 8.00037C13.3333 5.05496 10.9456 2.66656 8.00024 2.66638ZM11.3333 7.33337C11.7014 7.33337 12.0002 7.63218 12.0002 8.00037C12.0001 10.2092 10.2091 12.0002 8.00024 12.0004C5.79121 12.0004 4.00042 10.2094 4.00024 8.00037C4.00024 7.63228 4.29822 7.33355 4.66626 7.33337L11.3333 7.33337ZM5.41724 8.66638C5.71326 9.81653 6.75768 10.6664 8.00024 10.6664C9.24266 10.6662 10.2863 9.81643 10.5823 8.66638H5.41724ZM6.00024 4.00037C6.92046 4.00054 7.66608 4.74617 7.66626 5.66638C7.66626 6.03446 7.36828 6.3332 7.00024 6.33337C6.63205 6.33337 6.33325 6.03457 6.33325 5.66638C6.33308 5.48255 6.18408 5.33355 6.00024 5.33337C5.81626 5.33337 5.66644 5.48244 5.66626 5.66638C5.66626 6.03446 5.36828 6.3332 5.00024 6.33337C4.63205 6.33337 4.33325 6.03457 4.33325 5.66638C4.33343 4.74606 5.07988 4.00037 6.00024 4.00037ZM10.0002 4.00037C10.9205 4.00054 11.6661 4.74617 11.6663 5.66638C11.6663 6.03446 11.3683 6.3332 11.0002 6.33337C10.6321 6.33337 10.3333 6.03457 10.3333 5.66638C10.3331 5.48255 10.1841 5.33355 10.0002 5.33337C9.81626 5.33337 9.66644 5.48244 9.66626 5.66638C9.66626 6.03446 9.36828 6.3332 9.00024 6.33337C8.63205 6.33337 8.33325 6.03457 8.33325 5.66638C8.33343 4.74606 9.07988 4.00037 10.0002 4.00037Z\"/></svg>",
	"file-chart": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for file-chart\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 4C4 2.89543 4.89543 2 6 2H12.5858C12.6674 2 12.7484 2.00498 12.8286 2.01478C13.1447 1.95975 13.4739 2.05967 13.7071 2.29292L13.9935 2.57935C13.9957 2.58149 13.9978 2.58364 14 2.58579L19.4142 8C19.4164 8.00216 19.4185 8.00432 19.4207 8.00648L19.7071 8.29292C19.9404 8.52619 20.0403 8.85534 19.9852 9.17154C19.995 9.25165 20 9.33267 20 9.41421V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4ZM12 4V9.00003C12 9.55231 12.4477 10 13 10H18V20H6V4L12 4ZM11 19L11 11H13V19H11ZM14 19V13H16V19H14ZM8 14L8 19H10V14H8ZM14 8.00003V5.41424L16.5858 8.00003H14Z\"/></svg>",
	file: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for file\"><path d=\"M9 18H15C15.2833 18 15.5208 17.9042 15.7125 17.7125C15.9042 17.5208 16 17.2833 16 17C16 16.7167 15.9042 16.4792 15.7125 16.2875C15.5208 16.0958 15.2833 16 15 16H9C8.71667 16 8.47917 16.0958 8.2875 16.2875C8.09583 16.4792 8 16.7167 8 17C8 17.2833 8.09583 17.5208 8.2875 17.7125C8.47917 17.9042 8.71667 18 9 18ZM9 14H15C15.2833 14 15.5208 13.9042 15.7125 13.7125C15.9042 13.5208 16 13.2833 16 13C16 12.7167 15.9042 12.4792 15.7125 12.2875C15.5208 12.0958 15.2833 12 15 12H9C8.71667 12 8.47917 12.0958 8.2875 12.2875C8.09583 12.4792 8 12.7167 8 13C8 13.2833 8.09583 13.5208 8.2875 13.7125C8.47917 13.9042 8.71667 14 9 14ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H13.175C13.4417 2 13.6958 2.05 13.9375 2.15C14.1792 2.25 14.3917 2.39167 14.575 2.575L19.425 7.425C19.6083 7.60833 19.75 7.82083 19.85 8.0625C19.95 8.30417 20 8.55833 20 8.825V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 8V4H6V20H18V9H14C13.7167 9 13.4792 8.90417 13.2875 8.7125C13.0958 8.52083 13 8.28333 13 8Z\"/></svg>",
	filter: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for filter\"><path d=\"M11 18H13C13.55 18 14 17.55 14 17C14 16.45 13.55 16 13 16H11C10.45 16 10 16.45 10 17C10 17.55 10.45 18 11 18ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7ZM7 13H17C17.55 13 18 12.55 18 12C18 11.45 17.55 11 17 11H7C6.45 11 6 11.45 6 12C6 12.55 6.45 13 7 13Z\"/></svg>",
	flag: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for flag\"><path d=\"M14.4 6L14.16 4.8C14.07 4.34 13.66 4 13.18 4H6C5.45 4 5 4.45 5 5V20C5 20.55 5.45 21 6 21C6.55 21 7 20.55 7 20V14H12.6L12.84 15.2C12.93 15.67 13.34 16 13.82 16H19C19.55 16 20 15.55 20 15V7C20 6.45 19.55 6 19 6H14.4Z\"/></svg>",
	flask: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for flask\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.49996 3C7.49996 2.44772 7.94768 2 8.49996 2H15.5C16.0522 2 16.5 2.44772 16.5 3C16.5 3.55228 16.0522 4 15.5 4H15L15 4.00222L15 10.723L19.4944 18.2138C20.4942 19.8801 19.2939 22 17.3507 22L6.64925 22C4.70601 22 3.50573 19.8801 4.50551 18.2138L8.99996 10.723L9.00051 4C9.00015 4.01106 9.00051 3.98885 9.00051 4H8.49996C7.94768 4 7.49996 3.55228 7.49996 3ZM10.9994 4L11 11.277L8.76615 15L15.2338 15L13 11.277L13 4H10.9994Z\"/></svg>",
	"folder-outline": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" alt=\"Icon for folder-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.519 6H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.068a2 2 0 0 1 1.632.844L11.52 6ZM4 6v12h16v-8h-6.548a3 3 0 0 1-2.448-1.266L9.068 6H4Z\"/></svg>",
	folder: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" alt=\"Icon for folder\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.417 6H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.068a2 2 0 0 1 1.632.844L11.417 6Zm2.544 4H20V8h-7.839l1.8 2Z\"/></svg>",
	"heart-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for heart-filled\"><path d=\"M11.3272 20.419C11.7146 20.7464 12.2844 20.7453 12.671 20.4169C16.3492 17.292 22 13.4412 22 8.3951C22 5.37384 19.58 3 16.5 3C14.76 3 13.09 3.74441 12 5C10.91 3.74441 9.24 3 7.5 3C4.42 3 2 5.37384 2 8.3951C2 13.4327 7.64311 17.306 11.3272 20.419Z\"/></svg>",
	"heart-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for heart-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 8.05084L13.5103 6.31111C14.2025 5.51373 15.3116 5 16.5 5C18.5119 5 20 6.51455 20 8.3951C20 10.147 19.0159 11.8935 17.2603 13.7537C15.979 15.1114 14.5068 16.3152 13.0432 17.512C12.6928 17.7985 12.343 18.0846 11.9964 18.3723C11.6746 18.1062 11.3498 17.8411 11.0243 17.5754C9.5378 16.362 8.03662 15.1366 6.73808 13.7576C4.98347 11.8944 4 10.144 4 8.3951C4 6.51455 5.48808 5 7.5 5C8.68843 5 9.79748 5.51373 10.4897 6.31111L12 8.05084ZM13.1722 3.9824C14.1373 3.35284 15.3021 3 16.5 3C19.58 3 22 5.37384 22 8.3951C22 12.7735 17.7458 16.2519 14.2172 19.1371C13.679 19.5771 13.1577 20.0033 12.671 20.4169C12.2844 20.7453 11.7146 20.7464 11.3272 20.419C10.8596 20.0239 10.3606 19.6166 9.84549 19.1963C6.30173 16.3041 2 12.7934 2 8.3951C2 5.37384 4.42 3 7.5 3C8.69792 3 9.86267 3.35284 10.8278 3.9824C11.2646 4.26729 11.6604 4.60884 12 5C12.3396 4.60884 12.7354 4.26729 13.1722 3.9824Z\"/></svg>",
	history: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for history\"><path d=\"M12.5 8.5C12.5 7.94772 12.0523 7.5 11.5 7.5C10.9477 7.5 10.5 7.94772 10.5 8.5V12.5C10.5 13.0523 10.9477 13.5 11.5 13.5H15.5C16.0523 13.5 16.5 13.0523 16.5 12.5C16.5 11.9477 16.0523 11.5 15.5 11.5H12.5V8.5Z\"/><path d=\"M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.97203 4 8.12348 4.75573 6.71289 6H8C8.55229 6 9 6.44771 9 7C9 7.55229 8.55228 8 8 8H4C3.44772 8 3 7.55228 3 7V3C3 2.44772 3.44771 2 4 2C4.55229 2 5 2.44772 5 3V4.8623C6.8029 3.09412 9.2739 2 12 2Z\"/></svg>",
	"image-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for image-filled\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21ZM5 5V19H19V5H5Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 5V19H19V5H5ZM8.17683 10.2638C7.27557 10.2638 6.54495 9.53315 6.54495 8.63188C6.54495 7.73062 7.27557 7 8.17683 7C9.0781 7 9.80872 7.73062 9.80872 8.63188C9.80872 9.53315 9.0781 10.2638 8.17683 10.2638ZM6.54495 16.7913H17.4551C17.8975 16.7913 18.1549 16.2912 17.8977 15.9312L13.5044 9.78055C13.2906 9.48116 12.8474 9.47601 12.6266 9.77035L9.80872 13.5275L9.16429 12.8831C8.93022 12.649 8.5431 12.6765 8.34448 12.9414L6.10978 15.921C5.84083 16.2796 6.0967 16.7913 6.54495 16.7913Z\"/></svg>",
	"image-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for image-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5ZM2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.17683 10.2638C7.27557 10.2638 6.54495 9.53315 6.54495 8.63188C6.54495 7.73062 7.27557 7 8.17683 7C9.0781 7 9.80872 7.73062 9.80872 8.63188C9.80872 9.53315 9.0781 10.2638 8.17683 10.2638ZM6.54495 16.7913H17.4551C17.8975 16.7913 18.1549 16.2912 17.8977 15.9312L13.5044 9.78055C13.2906 9.48116 12.8474 9.47601 12.6266 9.77035L9.80872 13.5275L9.16429 12.8831C8.93021 12.649 8.54309 12.6765 8.34448 12.9414L6.10978 15.921C5.84083 16.2796 6.0967 16.7913 6.54495 16.7913Z\"/></svg>",
	"image-stack": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for image-stack\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.55 3.7C7.08056 3.7 6.7 4.08056 6.7 4.55V16.45C6.7 16.9194 7.08056 17.3 7.55 17.3H19.45C19.9194 17.3 20.3 16.9194 20.3 16.45V4.55C20.3 4.08056 19.9194 3.7 19.45 3.7H7.55ZM5 4.55C5 3.14167 6.14167 2 7.55 2H19.45C20.8583 2 22 3.14167 22 4.55V16.45C22 17.8583 20.8583 19 19.45 19H7.55C6.14167 19 5 17.8583 5 16.45V4.55Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.2503 9.0242C9.48423 9.0242 8.86321 8.40318 8.86321 7.6371C8.86321 6.87103 9.48423 6.25 10.2503 6.25C11.0164 6.25 11.6374 6.87103 11.6374 7.6371C11.6374 8.40318 11.0164 9.0242 10.2503 9.0242ZM8.86321 14.5726H18.1368C18.5129 14.5726 18.7317 14.1475 18.5131 13.8415L14.7788 8.61347C14.597 8.35898 14.2203 8.35461 14.0326 8.60479L11.6374 11.7984L11.0896 11.2506C10.8907 11.0517 10.5616 11.0751 10.3928 11.3002L8.49331 13.8328C8.26471 14.1376 8.4822 14.5726 8.86321 14.5726Z\"/><path d=\"M3.7 8V19.45C3.7 19.9194 4.08056 20.3 4.55 20.3H16V22H4.55C3.14167 22 2 20.8583 2 19.45V8H3.7Z\"/></svg>",
	kebab: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for kebab\"><path d=\"M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6Z\"/><path d=\"M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z\"/><path d=\"M14 18C14 19.1046 13.1046 20 12 20C10.8954 20 10 19.1046 10 18C10 16.8954 10.8954 16 12 16C13.1046 16 14 16.8954 14 18Z\"/></svg>",
	layers: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for layers\"><path d=\"M12.6139 20.6575C12.2528 20.9384 11.7472 20.9384 11.386 20.6575L3.50742 14.5297C3.25005 14.3295 3.25005 13.9405 3.50742 13.7403L4.61998 12.875L11.99 18.605L19.37 12.865L20.4933 13.7402C20.7504 13.9405 20.7502 14.3293 20.493 14.5293L12.6139 20.6575ZM12 16.865L3.50742 10.2597C3.25005 10.0595 3.25005 9.67051 3.50742 9.47033L11.386 3.34251C11.7472 3.06165 12.2528 3.06165 12.6139 3.34251L20.4925 9.47033C20.7499 9.67051 20.7499 10.0595 20.4925 10.2597L12 16.865Z\"/></svg>",
	"link-out": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for link-out\"><path d=\"M10.9986 13C11.3891 13.3905 12.0223 13.3905 12.4128 13L17.9986 7.41421V10C17.9986 10.5523 18.4463 11 18.9986 11C19.5509 11 19.9986 10.5523 19.9986 10V5C19.9986 4.44772 19.5509 4 18.9986 4H13.9986C13.4463 4 12.9986 4.44772 12.9986 5C12.9986 5.55228 13.4463 6 13.9986 6H16.5844L10.9986 11.5858C10.608 11.9763 10.608 12.6095 10.9986 13Z\"/><path d=\"M19.0015 18V15C19.0015 14.4477 18.5538 14 18.0015 14C17.4492 14 17.0015 14.4477 17.0015 15V18H6.00147V7H9.00147C9.55375 7 10.0015 6.55228 10.0015 6C10.0015 5.44772 9.55375 5 9.00147 5H6.00147C4.8969 5 4.00146 5.89543 4.00146 7V18C4.00146 19.1046 4.8969 20 6.00147 20H17.0015C18.106 20 19.0015 19.1046 19.0015 18Z\"/></svg>",
	link: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for link\"><path d=\"M9 15C9.55228 15 10 15.4477 10 16C10 16.5523 9.55228 17 9 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H9C9.55228 7 10 7.44772 10 8C10 8.55228 9.55228 9 9 9H7C5.34315 9 4 10.3431 4 12C4 13.6569 5.34315 15 7 15H9Z\"/><path d=\"M15 9C14.4477 9 14 8.55228 14 8C14 7.44772 14.4477 7 15 7H17C19.7614 7 22 9.23858 22 12C22 14.7614 19.7614 17 17 17H15C14.4477 17 14 16.5523 14 16C14 15.4477 14.4477 15 15 15H17C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9H15Z\"/><path d=\"M17 12C17 11.4477 16.5523 11 16 11H8C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H16C16.5523 13 17 12.5523 17 12Z\"/></svg>",
	"location-pin-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for location-pin-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 10C4 5.57771 7.57772 2 12 2C16.4223 2 20 5.57771 20 10C20 12.473 18.6719 14.9184 17.256 16.85C15.8177 18.8124 14.167 20.4066 13.288 21.2025C12.5531 21.8679 11.4469 21.8679 10.712 21.2025C9.83296 20.4066 8.18235 18.8124 6.74397 16.85C5.32811 14.9184 4 12.473 4 10ZM12 4C8.68229 4 6 6.68229 6 10C6 11.8168 7.0087 13.8281 8.35705 15.6677C9.65447 17.4378 11.1579 18.904 12 19.6706C12.8421 18.904 14.3455 17.4378 15.6429 15.6677C16.9913 13.8281 18 11.8168 18 10C18 6.68229 15.3177 4 12 4Z\"/><path d=\"M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z\"/></svg>",
	"location-pin": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for location-pin\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 3C8.13 3 5 6.13 5 10C5 14.2898 9.67363 18.9134 11.3832 20.4612C11.7371 20.7816 12.2629 20.7816 12.6168 20.4612C14.3264 18.9134 19 14.2898 19 10C19 6.13 15.87 3 12 3ZM12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z\"/></svg>",
	lock: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for lock\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 12V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V12C20 10.8954 19.1046 10 18 10H17.5V7.5C17.5 4.46243 15.0376 2 12 2C8.96243 2 6.5 4.46243 6.5 7.5V10H6C4.89543 10 4 10.8954 4 12ZM12 4C10.067 4 8.5 5.567 8.5 7.5V10H15.5V7.5C15.5 5.567 13.933 4 12 4Z\"/></svg>",
	login: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for login\"><path d=\"M9.58579 3L18.5858 3C19.6904 3 20.5858 3.89543 20.5858 5L20.5858 19C20.5858 20.1046 19.6904 21 18.5858 21H9.58579C9.0335 21 8.58579 20.5523 8.58579 20C8.58579 19.4477 9.0335 19 9.58579 19H18.5858L18.5858 5L9.58579 5C9.03351 5 8.58579 4.55228 8.58579 4C8.58579 3.44772 9.03351 3 9.58579 3Z\"/><path d=\"M3 12.09C3 12.6423 3.44771 13.09 4 13.09L13.17 13.09L11.3829 14.8843C10.9945 15.2743 10.9951 15.9051 11.3843 16.2943C11.774 16.6841 12.406 16.6841 12.7957 16.2943L16.2929 12.7971C16.6834 12.4066 16.6834 11.7734 16.2929 11.3829L12.6157 7.70569C12.2259 7.31596 11.5941 7.31596 11.2043 7.70569C10.8151 8.0949 10.8145 8.72575 11.203 9.11568L13.17 11.09L4 11.09C3.44771 11.09 3 11.5377 3 12.09Z\"/></svg>",
	logout: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for logout\"><path d=\"M14 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H14C14.5523 3 15 3.44772 15 4C15 4.55228 14.5523 5 14 5H5V19H14C14.5523 19 15 19.4477 15 20C15 20.5523 14.5523 21 14 21Z\"/><path d=\"M7 12.09C7 12.6423 7.44772 13.09 8 13.09L17.17 13.09L15.3829 14.8843C14.9945 15.2743 14.9951 15.9051 15.3843 16.2943C15.774 16.684 16.406 16.684 16.7957 16.2943L20.2929 12.7971C20.6834 12.4066 20.6834 11.7734 20.2929 11.3829L16.6157 7.70565C16.2259 7.31593 15.5941 7.31593 15.2043 7.70565C14.8151 8.09486 14.8145 8.72571 15.203 9.11565L17.17 11.09L8 11.09C7.44771 11.09 7 11.5377 7 12.09Z\"/></svg>",
	"mail-sent": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for mail-sent\"><path d=\"M18.05 21.29C17.66 21.68 17.03 21.68 16.64 21.29L14.52 19.17C14.13 18.78 14.13 18.15 14.52 17.76C14.91 17.37 15.54 17.37 15.93 17.76L17.34 19.17L20.88 15.63C21.27 15.24 21.9 15.24 22.29 15.63C22.68 16.02 22.68 16.65 22.29 17.04L18.05 21.29ZM12.08 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H20C21.1 4 22 4.9 22 6V12.68C21.09 12.25 20.08 12 19 12C15.13 12 12 15.13 12 19C12 19.34 12.03 19.67 12.08 20ZM11.47 12.67C11.79 12.87 12.21 12.87 12.53 12.67L19.6 8.25C19.85 8.09 20 7.82 20 7.53C20 6.86 19.27 6.46 18.7 6.81L12 11L5.3 6.81C4.73 6.46 4 6.86 4 7.53C4 7.82 4.15 8.09 4.4 8.25L11.47 12.67Z\"/></svg>",
	mail: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for mail\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 20H4C2.89543 20 2 19.1046 2 18V5.913C2.04661 4.84255 2.92853 3.99899 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20ZM4.17596 6.62097C4.48885 6.16587 5.11142 6.05057 5.56653 6.36346L12 10.7865L18.4335 6.36346C18.8886 6.05057 19.5112 6.16587 19.824 6.62097C20.1369 7.07608 20.0216 7.69866 19.5665 8.01154L12.5665 12.824C12.2253 13.0587 11.7747 13.0587 11.4335 12.824L4.43347 8.01154C3.97837 7.69866 3.86307 7.07608 4.17596 6.62097Z\"/></svg>",
	"major-otas": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for major-otas\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.5265 4.60771 15.4439 8 15.9291V12C8 11.6701 8.05325 11.3526 8.15163 11.0557C8.10126 10.7281 8.06086 10.3762 8.03447 10H8.76389C9.09621 9.62871 9.51963 9.34068 9.99902 9.17105C10.3121 9.06028 10.649 9 11 9H16ZM6.6625 4.5789C5.36175 5.26805 4.40157 6.51444 4.10002 8H6.03018C6.11589 6.59889 6.37339 5.45792 6.6625 4.5789ZM4.10002 10C4.40157 11.4856 5.36175 12.7319 6.6625 13.4211C6.37339 12.5421 6.11589 11.4011 6.03018 10H4.10002ZM8.03447 8C8.13075 6.62763 8.41342 5.57888 8.68633 4.85112C8.79634 4.55775 8.90509 4.31571 9 4.12498C9.09491 4.31571 9.20366 4.55775 9.31367 4.85112C9.58658 5.57888 9.86925 6.62763 9.96553 8H8.03447ZM13.9 8C13.5984 6.51444 12.6382 5.26805 11.3375 4.5789C11.6266 5.45792 11.8841 6.59889 11.9698 8H13.9Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 12C9 10.8954 9.89543 10 11 10H19C20.1046 10 21 10.8954 21 12V17C21 18.1046 20.1046 19 19 19H16V20H17C17.5523 20 18 20.4477 18 21C18 21.5523 17.5523 22 17 22H13C12.4477 22 12 21.5523 12 21C12 20.4477 12.4477 20 13 20H14V19H11C9.89543 19 9 18.1046 9 17V12ZM19 12H11V17H19V12Z\"/></svg>",
	"mark-as-read": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for mark-as-read\"><path d=\"M3.28239 12C3.67292 11.6095 4.30608 11.6095 4.69661 12L7.52503 14.8285L15.3032 7.05028C15.6937 6.65975 16.3269 6.65975 16.7174 7.05028C17.1079 7.4408 17.1079 8.07397 16.7174 8.46449L8.23214 16.9498C7.84162 17.3403 7.20845 17.3403 6.81793 16.9498L3.2824 13.4143C2.89187 13.0237 2.89187 12.3906 3.28239 12Z\"/><path d=\"M14.2321 16.9498C13.8416 17.3403 13.2085 17.3403 12.8179 16.9498L11.0856 15.4142L12.4998 14L13.525 14.8285L20.3032 8.05028C20.6937 7.65975 21.3269 7.65975 21.7174 8.05028C22.1079 8.4408 22.1079 9.07397 21.7174 9.46449L14.2321 16.9498Z\"/></svg>",
	"meals-all-inclusive": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for meals-all-inclusive\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.11341 3C3.81914 3 3.13242 4.52919 3.99229 5.49655L11 13.3802L11 19H7.99998C7.4477 19 6.99998 19.4477 6.99998 20C6.99998 20.5523 7.4477 21 7.99998 21H16C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19H13V13.3802L20.0077 5.49655C20.8675 4.52919 20.1808 3 18.8866 3H5.11341ZM17.7731 5H6.22683L8.00461 7H15.9954L17.7731 5Z\"/></svg>",
	"meals-bed-and-breakfast": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for meals-bed-and-breakfast\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 19C3 18.4477 3.44772 18 4 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 4C5.89543 4 5 4.89543 5 6V11C5 13.7614 7.23858 16 10 16H12C14.419 16 16.4367 14.2822 16.9 12H17C19.2091 12 21 10.2091 21 8C21 5.79086 19.2091 4 17 4H7ZM15 6L7 6V8H15V6ZM17 10C18.1046 10 19 9.10457 19 8C19 6.89543 18.1046 6 17 6V10Z\"/></svg>",
	"meals-full-meal": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for meals-full-meal\"><path d=\"M20.15 10.15C18.56 11.74 16.41 12.24 14.88 11.53L13.4084 12.9983L18.59 18.18C18.98 18.57 18.98 19.2 18.59 19.59C18.2 19.98 17.57 19.98 17.18 19.59L11.9968 14.4068L6.81 19.58C6.42 19.97 5.79 19.97 5.4 19.58C5.01 19.19 5.01 18.56 5.4 18.17L10.58 12.99L9.12 11.53L8.41139 12.2386C8.02115 12.6288 7.38854 12.6291 6.9979 12.2393L2.99268 8.24264C1.8211 7.07107 1.8211 5.17157 2.99268 4C3.3832 3.60948 4.01637 3.60948 4.40689 4L11.99 11.58L13.46 10.11C12.75 8.57996 13.25 6.42996 14.84 4.83996C16.76 2.92996 19.5 2.56996 20.96 4.02996C22.43 5.49996 22.06 8.23996 20.15 10.15Z\"/></svg>",
	"meals-half-meal": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for meals-half-meal\"><path d=\"M18 4L18 20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20L16 13H15C14.4477 13 14 12.5523 14 12V6C14 4.34315 15.3431 3 17 3C17.5523 3 18 3.44772 18 4Z\"/><path d=\"M6 4C6 3.44772 5.55228 3 5 3C4.44772 3 4 3.44772 4 4V9C4 10.6569 5.34315 12 7 12V20C7 20.5523 7.44772 21 8 21C8.55229 21 9 20.5523 9 20V12C10.6569 12 12 10.6569 12 9V4C12 3.44772 11.5523 3 11 3C10.4477 3 10 3.44772 10 4V8H9V4C9 3.44772 8.55229 3 8 3C7.44772 3 7 3.44772 7 4V8H6V4Z\"/></svg>",
	"meals-room-only": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for meals-room-only\"><path d=\"M10 10.5C10 11.8807 8.88071 13 7.5 13C6.11929 13 5 11.8807 5 10.5C5 9.11929 6.11929 8 7.5 8C8.88071 8 10 9.11929 10 10.5Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 7C4 6.44772 3.55228 6 3 6C2.44772 6 2 6.44772 2 7V18C2 18.5523 2.44772 19 3 19C3.55228 19 4 18.5523 4 18V17H20V18C20 18.5523 20.4477 19 21 19C21.5523 19 22 18.5523 22 18V16V15V13C22 10.2386 19.7614 8 17 8H13C11.8954 8 11 8.89543 11 10V14H4V7Z\"/></svg>",
	meatballs: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for meatballs\"><path d=\"M8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12Z\"/><path d=\"M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z\"/><path d=\"M20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12C16 10.8954 16.8954 10 18 10C19.1046 10 20 10.8954 20 12Z\"/></svg>",
	megaphone: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for megaphone\"><path d=\"M2 11V13C2 14.1046 2.89543 15 4 15H6V18C6 18.5523 6.44772 19 7 19C7.55228 19 8 18.5523 8 18V8.99999H4C2.89543 8.99999 2 9.89542 2 11Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.134 7.49998C16.8578 7.02169 17.0217 6.4101 17.5 6.13396L19.232 5.13396C19.7103 4.85782 20.3219 5.02169 20.5981 5.49998C20.8742 5.97828 20.7103 6.58987 20.232 6.86601L18.5 7.86601C18.0217 8.14215 17.4101 7.97828 17.134 7.49998Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 12C18 11.4477 18.4477 11 19 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H19C18.4477 13 18 12.5523 18 12Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.134 16.5C17.4101 16.0217 18.0217 15.8578 18.5 16.134L20.232 17.134C20.7103 17.4101 20.8742 18.0217 20.5981 18.5C20.3219 18.9783 19.7103 19.1422 19.232 18.866L17.5 17.866C17.0217 17.5899 16.8578 16.9783 17.134 16.5Z\"/><path d=\"M9 8.99999V15L12.4855 17.0913C13.152 17.4912 14 17.0111 14 16.2338V7.76618C14 6.98888 13.152 6.50877 12.4855 6.90868L9 8.99999Z\"/></svg>",
	minus: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for minus\"><path d=\"M19 12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12Z\"/></svg>",
	"moon-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for moon-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.3816 14.8809C17.9326 14.9592 17.471 15 17 15C12.5817 15 9 11.4183 9 7C9 6.52904 9.04083 6.06737 9.11912 5.61841C6.69013 6.71667 5 9.16096 5 12C5 15.866 8.13401 19 12 19C14.839 19 17.2833 17.3099 18.3816 14.8809ZM18.9684 12.6697C18.3518 12.8837 17.6895 13 17 13C13.6863 13 11 10.3137 11 7C11 6.31053 11.1163 5.64822 11.3303 5.03162C11.4971 4.55113 11.7233 4.09841 12 3.68221C12.1561 3.44749 12.3282 3.22439 12.5149 3.01448C12.3445 3.00487 12.1728 3 12 3C11.2908 3 10.6008 3.08202 9.93894 3.2371C5.96167 4.16894 3 7.7386 3 12C3 16.9706 7.02944 21 12 21C16.2614 21 19.8311 18.0383 20.7629 14.0611C20.918 13.3992 21 12.7092 21 12C21 11.8272 20.9951 11.6555 20.9855 11.4851C20.7756 11.6718 20.5525 11.8439 20.3178 12C19.9016 12.2767 19.4489 12.5029 18.9684 12.6697Z\"/></svg>",
	moon: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for moon\"><path d=\"M20.9855 11.4851C19.9258 12.4275 18.5297 13 17 13C13.6863 13 11 10.3137 11 7C11 5.47027 11.5725 4.07425 12.5149 3.01448C12.3445 3.00487 12.1728 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.8272 20.9951 11.6555 20.9855 11.4851Z\"/></svg>",
	"newspaper-1": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for newspaper-1\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 4C5 2.89543 5.89543 2 7 2H20C21.1046 2 22 2.89543 22 4V17C22 19.2091 20.2091 21 18 21H6C3.79086 21 2 19.2091 2 17V8C2 6.89543 2.89543 6 4 6H5V4ZM5 8H4V17C4 18.1046 4.89543 19 6 19H18C19.1046 19 20 18.1046 20 17V4H7V17C7 17.5523 6.55228 18 6 18C5.44772 18 5 17.5523 5 17V8Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 7C9 6.44772 9.44772 6 10 6H17C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H10C9.44772 8 9 7.55228 9 7Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 16C9 15.4477 9.44772 15 10 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H10C9.44772 17 9 16.5523 9 16Z\"/><path d=\"M9 10C9 9.44772 9.44772 9 10 9H12C12.5523 9 13 9.44772 13 10V13C13 13.5523 12.5523 14 12 14H10C9.44772 14 9 13.5523 9 13V10Z\"/><path d=\"M14 10C14 9.44772 14.4477 9 15 9H17C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11H15C14.4477 11 14 10.5523 14 10Z\"/><path d=\"M14 13C14 12.4477 14.4477 12 15 12H17C17.5523 12 18 12.4477 18 13C18 13.5523 17.5523 14 17 14H15C14.4477 14 14 13.5523 14 13Z\"/><path d=\"M14 16C14 15.4477 14.4477 15 15 15H17C17.5523 15 18 15.4477 18 16C18 16.5523 17.5523 17 17 17H15C14.4477 17 14 16.5523 14 16Z\"/></svg>",
	newspaper: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for newspaper\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 3C6.89543 3 6 3.89543 6 5V16.5C6 16.7761 5.77614 17 5.5 17C5.22386 17 5 16.7761 5 16.5V7C3.89543 7 3 7.89543 3 9V17C3 18.6569 4.34315 20 6 20H18C19.6569 20 21 18.6569 21 17V5C21 3.89543 20.1046 3 19 3H8ZM9 7C9 6.44772 9.44772 6 10 6H17C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H10C9.44772 8 9 7.55228 9 7ZM9 16C9 15.4477 9.44772 15 10 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H10C9.44772 17 9 16.5523 9 16ZM12 9H10C9.44772 9 9 9.44772 9 10V13C9 13.5523 9.44772 14 10 14H12C12.5523 14 13 13.5523 13 13V10C13 9.44772 12.5523 9 12 9ZM17 9H15C14.4477 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9ZM17 12H15C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14H17C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12ZM17 15H15C14.4477 15 14 15.4477 14 16C14 16.5523 14.4477 17 15 17H17C17.5523 17 18 16.5523 18 16C18 15.4477 17.5523 15 17 15Z\"/></svg>",
	"note-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for note-filled\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 20H12V16C12 14.8954 12.8954 14 14 14H18L18 4L6 4L6 20ZM8 7C8 7.55229 8.44772 8 9 8L15 8C15.5523 8 16 7.55229 16 7C16 6.44772 15.5523 6 15 6L9 6C8.44772 6 8 6.44772 8 7ZM8 11C8 10.4477 8.44772 10 9 10H12C12.5523 10 13 10.4477 13 11C13 11.5523 12.5523 12 12 12H9C8.44772 12 8 11.5523 8 11Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 14L20 4C20 2.89543 19.1046 2 18 2L6 2C4.89543 2 4 2.89543 4 4L4 20C4 21.1046 4.89543 22 6 22H12L12 20H6L6 4L18 4L18 14H20Z\"/><path d=\"M14 19.5281L17.2668 16H14V19.5281Z\"/><path d=\"M15.0306 21.3588L19.4675 16.5669C19.6232 16.3988 19.7474 16.2068 19.8366 16L17.2668 16L14 19.5281V21.9517C14.3924 21.8639 14.7528 21.6588 15.0306 21.3588Z\"/></svg>",
	"note-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for note-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 7C8 7.55229 8.44772 8 9 8L15 8C15.5523 8 16 7.55229 16 7C16 6.44772 15.5523 6 15 6L9 6C8.44772 6 8 6.44772 8 7Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 11C8 10.4477 8.44772 10 9 10H12C12.5523 10 13 10.4477 13 11C13 11.5523 12.5523 12 12 12H9C8.44772 12 8 11.5523 8 11Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.5631 22C14.1202 22 14.6521 21.7676 15.0306 21.3588L19.4675 16.5669C19.8098 16.1972 20 15.712 20 15.2081L20 4C20 2.89543 19.1046 2 18 2L6 2C4.89543 2 4 2.89543 4 4L4 20C4 21.1046 4.89543 22 6 22H13.5631ZM12 20H6L6 4L18 4L18 14H14C12.8954 14 12 14.8954 12 16V20ZM17.2668 16L14 19.5281V16H17.2668Z\"/><path d=\"M14 19.5281L17.2668 16H14V19.5281Z\"/></svg>",
	notification: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for notification\"><path d=\"M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.89 22 12 22ZM18.125 16.125C18.045 16.045 18 15.9364 18 15.8232V11C18 7.93001 16.36 5.36001 13.5 4.68001V3.50226C13.5 2.67226 12.83 2.10004 12 2.10004C11.17 2.10004 10.5 2.67226 10.5 3.50226V4.68001C7.63 5.36001 6 7.92001 6 11V15.8204C6 15.9354 5.95432 16.0457 5.87302 16.127L4.20711 17.7929C4.0745 17.9255 4 18.1054 4 18.2929C4 18.6834 4.31658 19 4.70711 19H19.2929C19.6834 19 20 18.6834 20 18.2929C20 18.1054 19.9255 17.9255 19.7929 17.7929L18.125 16.125Z\"/></svg>",
	pin: "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for pin\"><path d=\"M10.8647 0.676086C11.3224 0.721571 11.7525 0.92431 12.0806 1.25226C12.4556 1.62725 12.6664 2.13601 12.6665 2.66632C12.6665 3.19675 12.4556 3.70531 12.0806 4.08038C11.7524 4.40851 11.3225 4.61104 10.8647 4.65656L10.6665 4.66632V7.17316L10.6733 7.26495C10.6861 7.3565 10.718 7.44461 10.7671 7.52374C10.8161 7.60272 10.8804 7.67083 10.9565 7.72296L11.0366 7.76984L11.0405 7.77179L12.228 8.3714H12.2271C12.5587 8.53702 12.8383 8.79166 13.0337 9.10675C13.2296 9.42287 13.3333 9.78756 13.3335 10.1595V10.6663C13.3335 11.0199 13.1929 11.3596 12.9429 11.6097C12.6929 11.8596 12.3539 12.0002 12.0005 12.0003H8.66748V14.6663C8.66748 15.0344 8.36853 15.3331 8.00049 15.3333C7.6323 15.3333 7.3335 15.0345 7.3335 14.6663V12.0003H4.00049C3.64687 12.0003 3.30718 11.8597 3.05713 11.6097C2.80708 11.3596 2.6665 11.0199 2.6665 10.6663V10.1595L2.67139 10.0208C2.69406 9.69732 2.79565 9.38353 2.96729 9.10675C3.16338 8.79054 3.44365 8.53502 3.77686 8.36945L4.95947 7.77179L4.96338 7.76984L5.04346 7.72296C5.11967 7.67081 5.18486 7.6028 5.23389 7.52374C5.28283 7.4447 5.31387 7.35637 5.32666 7.26495L5.3335 7.17316V4.66632C4.80306 4.66632 4.29451 4.45546 3.91943 4.08038C3.5914 3.75227 3.38876 3.32225 3.34326 2.86456L3.3335 2.66632C3.33358 2.13601 3.54444 1.62725 3.91943 1.25226C4.29449 0.877287 4.80314 0.666321 5.3335 0.666321H10.6665L10.8647 0.676086ZM5.3335 2.00031C5.15669 2.00031 4.98684 2.07059 4.86182 2.19562C4.73707 2.32053 4.66659 2.48978 4.6665 2.66632L4.68018 2.79718C4.70577 2.92527 4.76813 3.04425 4.86182 3.138C4.98684 3.26302 5.15669 3.33331 5.3335 3.33331L5.46533 3.34015C5.77046 3.37046 6.05713 3.50526 6.27588 3.72394C6.52585 3.97391 6.66642 4.31282 6.6665 4.66632V7.17413C6.66622 7.54606 6.56271 7.91078 6.3667 8.22687C6.17139 8.54179 5.8915 8.79466 5.56006 8.96027L5.56104 8.96124L4.37451 9.56183L4.37061 9.56378C4.25962 9.61893 4.16545 9.70361 4.1001 9.8089C4.03473 9.91431 4.00055 10.0364 4.00049 10.1605V10.6663H12.0005V10.1605C12.0004 10.0364 11.9653 9.91431 11.8999 9.8089C11.8346 9.70374 11.7412 9.61891 11.6304 9.56378L11.6265 9.56183L10.439 8.96124V8.96027C10.1079 8.79463 9.82841 8.54151 9.6333 8.22687C9.43731 7.91079 9.33378 7.54604 9.3335 7.17413V4.66632C9.33358 4.31282 9.47415 3.97391 9.72412 3.72394C9.97409 3.47397 10.313 3.3334 10.6665 3.33331L10.7974 3.32062C10.9256 3.29502 11.0444 3.23181 11.1382 3.138C11.2632 3.01298 11.3335 2.84313 11.3335 2.66632C11.3334 2.4897 11.263 2.32055 11.1382 2.19562C11.0444 2.10182 10.9255 2.0386 10.7974 2.013L10.6665 2.00031H5.3335Z\"/></svg>",
	plane: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for plane\"><path d=\"M3.75787 5.53492L3.82135 5.47143C4.06973 5.22305 4.43022 5.1232 4.771 5.2084L13.8384 7.47524L17.3032 4.01042C17.889 3.42463 18.8387 3.42463 19.4245 4.01042C20.0103 4.5962 20.0103 5.54595 19.4245 6.13174L15.9597 9.59656L18.2265 18.6639C18.3117 19.0047 18.2119 19.3652 17.9635 19.6136L17.9 19.6771C17.4263 20.1507 16.63 20.0338 16.3124 19.444L12.7423 12.8139L9.43662 16.1196L9.80785 18.7182C9.85237 19.0298 9.74758 19.3442 9.52501 19.5668L9.37 19.7218C8.90997 20.1818 8.14011 20.087 7.8054 19.5292L6.34303 17.0919L3.90575 15.6295C3.34789 15.2948 3.25312 14.5249 3.71314 14.0649L3.86816 13.9099C4.09072 13.6873 4.40509 13.5826 4.71668 13.6271L7.3153 13.9983L10.621 10.6926L3.99088 7.12249C3.40108 6.80491 3.2842 6.00858 3.75787 5.53492Z\"/></svg>",
	plus: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for plus\"><path d=\"M19 12C19 12.5523 18.5523 13 18 13H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H11V6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V11H18C18.5523 11 19 11.4477 19 12Z\"/></svg>",
	"question-mark": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for question-mark\"><path d=\"M9.99994 20.5C9.99994 19.6716 10.6715 19 11.4999 19C12.3284 19 12.9999 19.6716 12.9999 20.5C12.9999 21.3284 12.3284 22 11.4999 22C10.6715 22 9.99994 21.3284 9.99994 20.5ZM11.9999 2C17.3499 2.22 19.6799 7.62 16.4999 11.67C15.6699 12.67 14.3299 13.33 13.6699 14.17C13.3388 14.5802 13.1714 15.0319 13.0866 15.5046C12.9405 16.32 12.3284 17 11.4999 17C10.6715 17 9.98395 16.3278 10.0211 15.5002C10.0668 14.4802 10.2116 13.6042 10.6699 12.92C11.3299 11.92 12.6699 11.33 13.4999 10.67C15.9199 8.43 15.3199 5.26 11.9999 5C11.2043 5 10.4412 5.31607 9.87862 5.87868C9.67464 6.08267 9.50306 6.31301 9.3672 6.5617C8.97005 7.28872 8.32837 8 7.49994 8C6.67152 8 5.98148 7.3182 6.18646 6.51553C6.45078 5.48051 6.98915 4.52552 7.7573 3.75736C8.88252 2.63214 10.4086 2 11.9999 2Z\"/></svg>",
	"rates-best-flex": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for rates-best-flex\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.06604 5.07057C3.06604 3.96695 3.95999 3.07191 5.06361 3.07057L11.7172 3.06418C12.5137 3.06341 13.2778 3.37944 13.8411 3.94259L16.5556 6.6564L6.65552 16.5565L3.94472 13.8457C3.38211 13.2831 3.06604 12.52 3.06604 11.7244V5.07057ZM8.00004 10C9.10461 10 10 9.10458 10 8.00001C10 6.89544 9.10461 6 8.00004 6C6.89547 6 6.00004 6.89544 6.00004 8.00001C6.00004 9.10458 6.89547 10 8.00004 10Z\"/><path d=\"M21.383 14.311L14.3108 21.3833C13.5297 22.1643 12.2634 22.1643 11.4823 21.3833L9.47956 19.3805L7.50959 21.3505C7.11783 21.7152 6.50443 21.7067 6.12303 21.325C5.73322 20.9349 5.70763 20.3284 6.09757 19.9385L8.06754 17.9685L17.9678 8.06824L19.9121 6.12399L19.9131 6.12299C20.3027 5.73446 20.9333 5.73434 21.3231 6.12299C21.7139 6.51274 21.7142 7.14586 21.3239 7.53617L19.38 9.48009L21.3828 11.4824C22.164 12.2634 22.1641 13.5299 21.383 14.311Z\"/></svg>",
	"rates-lowest": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for rates-lowest\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.06604 5.07057C3.06604 3.96695 3.95999 3.07191 5.06361 3.07057L11.7172 3.06418C12.5137 3.06341 13.2778 3.37944 13.8411 3.94259L21.3828 11.4824C22.164 12.2634 22.1641 13.5299 21.383 14.311L14.3108 21.3833C13.5297 22.1643 12.2634 22.1643 11.4823 21.3833L3.94472 13.8457C3.38211 13.2831 3.06604 12.52 3.06604 11.7244V5.07057ZM8.00004 10C9.10461 10 10 9.10458 10 8.00001C10 6.89544 9.10461 6 8.00004 6C6.89547 6 6.00004 6.89544 6.00004 8.00001C6.00004 9.10458 6.89547 10 8.00004 10Z\"/></svg>",
	"rates-semi-flex": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for rates-semi-flex\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.9688 12.8968L21.3828 11.4824C22.1639 12.2634 22.1641 13.53 21.383 14.311L19.9688 12.8968ZM12.8965 19.9691L11.4823 21.3833C12.2634 22.1643 13.5297 22.1643 14.3108 21.3833L12.8965 19.9691ZM11.4821 18.5546L10.0679 19.9689L8.65369 18.5546L10.0679 17.1404L11.4821 18.5546Z\"/><path d=\"M14.3108 18.5549L15.725 19.9691L17.1392 18.5549L15.725 17.1406L14.3108 18.5549Z\"/><path d=\"M17.1392 15.7264L18.5534 17.1406L19.9676 15.7264L18.5534 14.3122L17.1392 15.7264Z\"/><path d=\"M18.5542 11.4826L19.9684 10.0684L18.554 8.65431L17.1398 10.0685L18.5542 11.4826Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.8411 3.9426C13.2778 3.37944 12.5137 3.06342 11.7172 3.06418L5.06361 3.07057C3.95999 3.07191 3.06604 3.96695 3.06604 5.07057V11.7244C3.06604 12.52 3.38211 13.2831 3.94472 13.8457L5.82526 15.7262L7.23947 17.1404L8.65368 15.7262L8.06973 15.1423L15.1414 8.07061L15.7254 8.65449L17.1396 7.24028L15.7252 5.82624L13.8411 3.9426ZM8.00005 10C9.10462 10 10 9.10457 10 8C10 6.89543 9.10462 6 8.00005 6C6.89548 6 6.00005 6.89543 6.00005 8C6.00005 9.10457 6.89548 10 8.00005 10Z\"/></svg>",
	"rates-third-party": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for rates-third-party\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5 4C9.67157 4 9 4.67157 9 5.5V8.17157C9 8.96722 9.31607 9.73028 9.87868 10.2929L15.9393 16.3536C16.5251 16.9393 17.4749 16.9393 18.0607 16.3536L21.3536 13.0607C21.9393 12.4749 21.9393 11.5251 21.3536 10.9393L15.2929 4.87868C14.7303 4.31607 13.9672 4 13.1716 4H10.5ZM12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.5 6C7.05228 6 7.5 6.44772 7.5 7V10.1716C7.5 10.4368 7.60536 10.6911 7.79289 10.8787L14.2071 17.2929C14.5976 17.6834 14.5976 18.3166 14.2071 18.7071C13.8166 19.0976 13.1834 19.0976 12.7929 18.7071L6.37868 12.2929C5.81607 11.7303 5.5 10.9672 5.5 10.1716V7C5.5 6.44772 5.94772 6 6.5 6Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 8C3.55228 8 4 8.44772 4 9V12.1716C4 12.4368 4.10536 12.6911 4.29289 12.8787L10.7071 19.2929C11.0976 19.6834 11.0976 20.3166 10.7071 20.7071C10.3166 21.0976 9.68342 21.0976 9.29289 20.7071L2.87868 14.2929C2.31607 13.7303 2 12.9672 2 12.1716V9C2 8.44772 2.44772 8 3 8Z\"/></svg>",
	recommendation: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for recommendation\"><path d=\"M10.3242 4.166C10.89954 2.61118 13.10042 2.61116 13.67576 4.166L15.33788 8.6621L19.83398 10.3242C21.3888 10.89954 21.3888 13.10042 19.83398 13.67576L15.33788 15.33788L13.67576 19.83398C13.10042 21.3888 10.89954 21.3888 10.3242 19.83398L8.6621 15.33788L4.166 13.67576C2.61118 13.10042 2.61116 10.89954 4.166 10.3242L8.6621 8.6621L10.3242 4.166Z\"/></svg>",
	redo: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for redo\"><path d=\"M11.75 5C9.81728 5 8.06591 5.7846 6.80025 7.05025C5.5346 8.31591 4.75 10.0673 4.75 12C4.75 13.9327 5.5346 15.6841 6.80025 16.9497C8.06591 18.2154 9.81728 19 11.75 19C13.6827 19 15.4341 18.2154 16.6997 16.9497C17.0903 16.5592 17.0903 15.9261 16.6997 15.5355C16.3092 15.145 15.6761 15.145 15.2855 15.5355C14.3796 16.4415 13.131 17 11.75 17C10.369 17 9.12038 16.4415 8.21447 15.5355C7.30855 14.6296 6.75 13.381 6.75 12C6.75 10.619 7.30855 9.37038 8.21447 8.46447C9.12038 7.55855 10.369 7 11.75 7C12.8763 7 13.9145 7.37152 14.7506 8H13C12.4477 8 12 8.44772 12 9C12 9.55228 12.4477 10 13 10H17C17.5523 10 18 9.55228 18 9V5C18 4.44772 17.5523 4 17 4C16.4477 4 16 4.44772 16 5V6.4375C14.822 5.53635 13.348 5 11.75 5Z\"/></svg>",
	"refer-friend": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for refer-friend\"><path d=\"M15 10.7994C15 12.1314 16.9179 13.6996 18.1647 14.7233C18.3576 14.8817 18.6376 14.8755 18.8231 14.7087C19.9612 13.6857 21.674 12.1315 21.674 10.8004C21.6741 10.3169 21.4797 9.85369 21.1345 9.5151C20.7893 9.17651 20.3225 8.99102 19.839 9.00042C19.2669 8.99901 18.7212 9.24163 18.339 9.66742C17.9569 9.24153 17.4112 8.99888 16.839 9.00042C16.3551 8.98994 15.8873 9.1748 15.5413 9.51329C15.1953 9.85178 15.0002 10.3154 15 10.7994Z\"/><path d=\"M13.9178 18.0042C14.0088 18.5489 13.5523 19 13 19H3.00004C2.44775 19 1.9913 18.5489 2.0823 18.0042C2.55665 15.1644 5.02558 13 8.00004 13C10.9745 13 13.4434 15.1644 13.9178 18.0042Z\"/><path d=\"M4.50004 8C4.50004 6.067 6.06704 4.5 8.00004 4.5C9.93303 4.5 11.5 6.067 11.5 8C11.4976 9.932 9.93204 11.4976 8.00004 11.5C6.06704 11.5 4.50004 9.933 4.50004 8Z\"/></svg>",
	"reset-currency": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for reset-currency\"><path d=\"M6 9H10C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7H7V4C7 3.44772 6.55228 3 6 3C5.44772 3 5 3.44772 5 4V8C5 8.55228 5.44772 9 6 9Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.6569 5.30951C10.7236 5.30951 8.97495 6.09192 7.70711 7.35977C7.31658 7.75029 6.68342 7.75029 6.29289 7.35977C5.90237 6.96924 5.90237 6.33608 6.29289 5.94555C7.92048 4.31797 10.1718 3.30951 12.6569 3.30951C17.6274 3.30951 21.6569 7.33895 21.6569 12.3095C21.6569 13.5012 21.4247 14.6411 21.0023 15.6847C20.7951 16.1967 20.2121 16.4437 19.7001 16.2365C19.1882 16.0292 18.9412 15.4462 19.1484 14.9343C19.476 14.1251 19.6569 13.2396 19.6569 12.3095C19.6569 8.44352 16.5228 5.30951 12.6569 5.30951Z\"/><path d=\"M12 16C12 17.1046 11.1046 18 10 18C8.89543 18 8 17.1046 8 16C8 14.8954 8.89543 14 10 14C11.1046 14 12 14.8954 12 16Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 13V19H15V13H5ZM4 11C3.44772 11 3 11.4477 3 12V20C3 20.5523 3.44772 21 4 21H16C16.5523 21 17 20.5523 17 20V12C17 11.4477 16.5523 11 16 11H4Z\"/></svg>",
	rocket: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for rocket\"><path d=\"M9.36901 5.96035C7.27822 8.30737 5.84337 11.6793 5.71013 11.997L2 10.4084L6.15084 6.25757C6.63254 5.77587 7.32947 5.56064 8.0059 5.69388L9.36901 5.96035ZM11.3983 16.8755C11.3983 16.8755 15.2314 15.2869 17.435 13.0834C22.9694 7.54894 22.047 3.22388 21.7498 2.25022C20.7761 1.94275 16.4511 1.0306 10.9166 6.56504C8.71308 8.76857 7.12449 12.6017 7.12449 12.6017L11.3983 16.8755ZM18.0396 14.631C15.6926 16.7218 12.3207 18.1566 12.003 18.2899L13.5916 22L17.7424 17.8492C18.2241 17.3675 18.4394 16.6705 18.3061 15.9941L18.0396 14.631ZM9.17428 17.9004C9.17428 18.7511 8.82582 19.5197 8.27237 20.0732C7.06299 21.2826 2 22 2 22C2 22 2.71743 16.937 3.92681 15.7276C4.48025 15.1742 5.24893 14.8257 6.09959 14.8257C7.80092 14.8257 9.17428 16.1991 9.17428 17.9004ZM13.2739 8.67633C13.2739 7.54894 14.1963 6.62654 15.3237 6.62654C16.4511 6.62654 17.3735 7.54894 17.3735 8.67633C17.3735 9.80372 16.4511 10.7261 15.3237 10.7261C14.1963 10.7261 13.2739 9.80372 13.2739 8.67633Z\"/></svg>",
	"room-type-change": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for room-type-change\"><path d=\"M11 16.5C11 17.3284 10.3284 18 9.5 18C8.67157 18 8 17.3284 8 16.5C8 15.6716 8.67157 15 9.5 15C10.3284 15 11 15.6716 11 16.5Z\"/><path d=\"M15.5356 3.87868C14.6318 2.97495 13.3805 2.41421 12 2.41421C11.1115 2.41421 10.2764 2.64653 9.55311 3.0531L8.86568 2.36568C8.36171 1.86171 7.5 2.21864 7.5 2.93137V5.41421C7.5 5.96649 7.94772 6.41421 8.5 6.41421H10.9828C11.6956 6.41421 12.0525 5.55249 11.5485 5.04852L11.0632 4.56315C11.3578 4.46643 11.6727 4.41421 12 4.41421C12.8287 4.41421 13.5774 4.7489 14.1213 5.29289C14.3066 5.47813 14.4676 5.68725 14.5993 5.91494C14.8758 6.393 15.4876 6.55636 15.9656 6.27982C16.4437 6.00327 16.607 5.39155 16.3305 4.91348C16.1109 4.53392 15.8431 4.18623 15.5356 3.87868Z\"/><path d=\"M9.40076 8.91348C9.12422 8.43542 8.51249 8.27206 8.03443 8.5486C7.55637 8.82515 7.39301 9.43687 7.66955 9.91494C7.88912 10.2945 8.15694 10.6422 8.46449 10.9497C9.36822 11.8535 10.6196 12.4142 12 12.4142C12.866 12.4142 13.6812 12.1935 14.3917 11.8059L15.0485 12.4627C15.5525 12.9667 16.4142 12.6098 16.4142 11.8971V9.41421C16.4142 8.86193 15.9665 8.41421 15.4142 8.41421L12.9313 8.41421C12.2186 8.41421 11.8617 9.27593 12.3657 9.7799L12.8716 10.2859C12.5959 10.3694 12.3033 10.4142 12 10.4142C11.1713 10.4142 10.4227 10.0795 9.87871 9.53553C9.69346 9.35029 9.53247 9.14117 9.40076 8.91348Z\"/><path d=\"M6 14C6.55228 14 7 14.4477 7 15V19H12V17C12 15.8954 12.8954 15 14 15H16C17.6569 15 19 16.3431 19 18V21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21H7C7 21.5523 6.55228 22 6 22C5.44772 22 5 21.5523 5 21V19V15C5 14.4477 5.44772 14 6 14Z\"/></svg>",
	search: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for search\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.3764 12.4769C16.0463 10.1337 15.8302 6.85958 13.7279 4.75736C11.3848 2.41421 7.5858 2.41421 5.24265 4.75736C2.8995 7.1005 2.8995 10.8995 5.24265 13.2426C7.34488 15.3449 10.619 15.561 12.9622 13.8911L17.9706 18.8995C18.3611 19.29 18.9943 19.29 19.3848 18.8995C19.7753 18.509 19.7753 17.8758 19.3848 17.4853L14.3764 12.4769ZM12.3137 6.17157C13.8758 7.73367 13.8758 10.2663 12.3137 11.8284C10.7516 13.3905 8.21896 13.3905 6.65686 11.8284C5.09477 10.2663 5.09477 7.73367 6.65686 6.17157C8.21896 4.60948 10.7516 4.60948 12.3137 6.17157Z\"/></svg>",
	seat: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for seat\"><path d=\"M5 21C4.71667 21 4.47917 20.9042 4.2875 20.7125C4.09583 20.5208 4 20.2833 4 20V19C3.16667 19 2.45833 18.7083 1.875 18.125C1.29167 17.5417 1 16.8333 1 16V11C1 10.1667 1.29167 9.45833 1.875 8.875C2.45833 8.29167 3.16667 8 4 8V6C4 5.16667 4.29167 4.45833 4.875 3.875C5.45833 3.29167 6.16667 3 7 3H17C17.8333 3 18.5417 3.29167 19.125 3.875C19.7083 4.45833 20 5.16667 20 6V8C20.8333 8 21.5417 8.29167 22.125 8.875C22.7083 9.45833 23 10.1667 23 11V16C23 16.8333 22.7083 17.5417 22.125 18.125C21.5417 18.7083 20.8333 19 20 19V20C20 20.2833 19.9042 20.5208 19.7125 20.7125C19.5208 20.9042 19.2833 21 19 21C18.7167 21 18.4792 20.9042 18.2875 20.7125C18.0958 20.5208 18 20.2833 18 20V19H6V20C6 20.2833 5.90417 20.5208 5.7125 20.7125C5.52083 20.9042 5.28333 21 5 21ZM4 17H20C20.2833 17 20.5208 16.9042 20.7125 16.7125C20.9042 16.5208 21 16.2833 21 16V11C21 10.7167 20.9042 10.4792 20.7125 10.2875C20.5208 10.0958 20.2833 10 20 10C19.7167 10 19.4792 10.0958 19.2875 10.2875C19.0958 10.4792 19 10.7167 19 11V15H5V11C5 10.7167 4.90417 10.4792 4.7125 10.2875C4.52083 10.0958 4.28333 10 4 10C3.71667 10 3.47917 10.0958 3.2875 10.2875C3.09583 10.4792 3 10.7167 3 11V16C3 16.2833 3.09583 16.5208 3.2875 16.7125C3.47917 16.9042 3.71667 17 4 17ZM7 13H17V11C17 10.55 17.0917 10.1417 17.275 9.775C17.4583 9.40833 17.7 9.08333 18 8.8V6C18 5.71667 17.9042 5.47917 17.7125 5.2875C17.5208 5.09583 17.2833 5 17 5H7C6.71667 5 6.47917 5.09583 6.2875 5.2875C6.09583 5.47917 6 5.71667 6 6V8.8C6.3 9.08333 6.54167 9.40833 6.725 9.775C6.90833 10.1417 7 10.55 7 11V13Z\"/></svg>",
	"send-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for send-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.0168 3.45266C18.7355 3.21311 19.5278 3.40015 20.0635 3.93582C20.5991 4.47148 20.7862 5.26381 20.5466 5.98249L15.5969 20.8317C15.3461 21.5842 14.6743 22.1173 13.8846 22.1907C13.1026 22.2634 12.3512 21.8717 11.9626 21.1908L8.49882 15.5005L2.8085 12.0367C2.12763 11.6481 1.73592 10.8967 1.8086 10.1147C1.88199 9.32496 2.41513 8.65322 3.16756 8.40241L18.0168 3.45266ZM10.4894 14.9241L13.6795 20.165C13.6864 20.1763 13.6931 20.1877 13.6995 20.1993L18.6493 5.35003L3.80001 10.2998C3.81158 10.3062 3.82302 10.3129 3.83433 10.3197L9.07517 13.5099L12.9924 9.59271C13.3829 9.20218 14.0161 9.20218 14.4066 9.59271C14.7971 9.98323 14.7971 10.6164 14.4066 11.0069L10.4894 14.9241Z\"/></svg>",
	send: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for send\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.49141 9.34423C3.11519 9.46964 2.84862 9.80551 2.81193 10.2004C2.77523 10.5952 2.97533 10.9745 3.32199 11.1671L8.52705 14.0588L9.99786 12.588L13 9.58581C13.3905 9.19528 14.0237 9.19528 14.4142 9.58581C14.8048 9.97633 14.8048 10.6095 14.4142 11L11.4121 14.0022L9.94127 15.473L12.833 20.6781C13.0256 21.0247 13.4048 21.2248 13.7997 21.1881C14.1945 21.1514 14.5304 20.8849 14.6558 20.5086L19.6056 5.65939C19.7253 5.30006 19.6318 4.90389 19.364 4.63606C19.0961 4.36823 18.7 4.27471 18.3406 4.39448L3.49141 9.34423Z\"/></svg>",
	"settings-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for settings-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.33904 3.36754C8.61127 2.55086 9.37555 2 10.2364 2H13.3004C14.1612 2 14.9255 2.55086 15.1977 3.36754L15.6711 4.78768C15.8258 4.87141 15.9775 4.95995 16.1259 5.05309L17.62 4.74734C18.4634 4.57476 19.3226 4.96121 19.753 5.70674L21.285 8.36021C21.7154 9.10573 21.6205 10.043 21.0494 10.6871L19.9764 11.8971C19.9769 11.935 19.9772 11.973 19.9772 12.0109C19.9772 12.0888 19.9761 12.1664 19.9739 12.2438L21.0655 13.4748C21.6367 14.1189 21.7316 15.0562 21.3012 15.8017L19.7692 18.4552C19.3388 19.2007 18.4796 19.5872 17.6362 19.4146L15.9582 19.0712C15.8991 19.1064 15.8395 19.1408 15.7794 19.1745L15.2301 20.8224C14.9579 21.6391 14.1936 22.1899 13.3327 22.1899H10.2688C9.4079 22.1899 8.64363 21.6391 8.3714 20.8224L7.83675 19.2185C7.76596 19.1798 7.69581 19.1401 7.62631 19.0994L5.94914 19.4426C5.10576 19.6152 4.24656 19.2287 3.81613 18.4832L2.28415 15.8297C1.85372 15.0842 1.94864 14.1469 2.51979 13.5028L3.56548 12.3236C3.56159 12.2198 3.55963 12.1156 3.55963 12.0109C3.55963 11.9762 3.55984 11.9415 3.56028 11.9068L2.50362 10.7152C1.93246 10.0711 1.83754 9.13376 2.26797 8.38823L3.79996 5.73476C4.23039 4.98924 5.08958 4.60278 5.93297 4.77537L7.38129 5.07175C7.53915 4.97176 7.70069 4.87699 7.86566 4.78769L8.33904 3.36754ZM13.9506 18.3363C13.9988 18.0199 14.1978 17.7366 14.4989 17.5889C14.7456 17.4679 14.9831 17.3309 15.2103 17.1793C15.4323 17.0311 15.7044 16.9778 15.9659 17.0313L18.0371 17.4552L19.5691 14.8017L18.2052 13.2636C18.0245 13.0598 17.9347 12.7911 17.9567 12.5195C17.9702 12.352 17.9772 12.1824 17.9772 12.0109C17.9772 11.8725 17.9727 11.7353 17.9638 11.5994C17.9464 11.3329 18.0363 11.0706 18.2135 10.8708L19.553 9.36021L18.021 6.70674L16.1194 7.09587C15.8491 7.15118 15.5679 7.09236 15.3425 6.93333C15.0533 6.72935 14.7461 6.54957 14.4239 6.39684C14.1776 6.28012 13.9897 6.06796 13.9035 5.80943L13.3004 4L10.2364 4L9.63326 5.80944C9.54709 6.06796 9.35914 6.28012 9.11288 6.39684C8.78197 6.55369 8.46694 6.73905 8.17099 6.94985C7.94497 7.11085 7.66222 7.17068 7.39035 7.11505L5.53201 6.73476L4.00002 9.38823L5.32275 10.8799C5.49963 11.0794 5.58954 11.3412 5.57251 11.6073C5.56397 11.7406 5.55963 11.8752 5.55963 12.0109C5.55963 12.2046 5.56846 12.3959 5.58571 12.5845C5.61084 12.8595 5.52121 13.1325 5.33806 13.3391L4.0162 14.8297L5.54818 17.4832L7.61467 17.0603C7.87374 17.0073 8.14325 17.0591 8.36426 17.2043C8.59555 17.3562 8.83749 17.4931 9.08867 17.6135C9.33305 17.7306 9.51943 17.9419 9.60513 18.199L10.2688 20.1899L13.3327 20.1899L13.9506 18.3363ZM11.7684 9.40663C10.33 9.40663 9.16401 10.5726 9.16401 12.011C9.16401 13.4494 10.33 14.6154 11.7684 14.6154C13.2068 14.6154 14.3728 13.4494 14.3728 12.011C14.3728 10.5726 13.2068 9.40663 11.7684 9.40663ZM7.16401 12.011C7.16401 9.46808 9.22546 7.40663 11.7684 7.40663C14.3113 7.40663 16.3728 9.46808 16.3728 12.011C16.3728 14.5539 14.3113 16.6154 11.7684 16.6154C9.22546 16.6154 7.16401 14.5539 7.16401 12.011Z\"/></svg>",
	settings: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for settings\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.2721 2.68377C9.40821 2.27543 9.79035 2 10.2208 2H13.7793C14.2097 2 14.5918 2.27543 14.7279 2.68377L15.4223 4.76689C15.8175 4.95422 16.195 5.17298 16.5514 5.41996L18.7042 4.97943C19.1258 4.89314 19.5554 5.08637 19.7707 5.45913L21.5499 8.54087C21.7651 8.91363 21.7177 9.38229 21.4321 9.70434L19.9739 11.3487C19.9894 11.5519 20 11.7929 20 12C20 12.2193 19.9912 12.4364 19.9739 12.6512L21.4321 14.2957C21.7177 14.6177 21.7651 15.0864 21.5499 15.4591L19.7707 18.5409C19.5554 18.9136 19.1258 19.1069 18.7042 19.0206L16.5514 18.58C16.195 18.827 15.8176 19.0458 15.4223 19.2331L14.7279 21.3162C14.5918 21.7246 14.2097 22 13.7793 22H10.2208C9.79035 22 9.40821 21.7246 9.2721 21.3162L8.57773 19.2331C8.1825 19.0458 7.80508 18.827 7.44869 18.58L5.2959 19.0206C4.8742 19.1069 4.4446 18.9136 4.22939 18.5409L2.45015 15.4591C2.23493 15.0864 2.28239 14.6177 2.56797 14.2957L4.02615 12.6513C4.00884 12.4365 4.00002 12.2193 4.00002 12C4.00002 11.7807 4.00884 11.5635 4.02615 11.3487L2.56797 9.70434C2.28239 9.38229 2.23493 8.91363 2.45015 8.54087L4.22939 5.45913C4.44461 5.08637 4.87421 4.89314 5.2959 4.97943L7.44868 5.41997C7.80507 5.17299 8.1825 4.95422 8.57773 4.76689L9.2721 2.68377ZM12 16C14.2092 16 16 14.2091 16 12C16 9.79086 14.2092 8 12 8C9.79088 8 8.00002 9.79086 8.00002 12C8.00002 14.2091 9.79088 16 12 16Z\"/></svg>",
	"shopping-cart": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for shopping-cart\"><path d=\"M8.00922 22C7.45922 22 6.98838 21.8042 6.59672 21.4125C6.20505 21.0208 6.00922 20.55 6.00922 20C6.00922 19.45 6.20505 18.9792 6.59672 18.5875C6.98838 18.1958 7.45922 18 8.00922 18C8.55922 18 9.03005 18.1958 9.42172 18.5875C9.81338 18.9792 10.0092 19.45 10.0092 20C10.0092 20.55 9.81338 21.0208 9.42172 21.4125C9.03005 21.8042 8.55922 22 8.00922 22ZM18.0092 22C17.4592 22 16.9884 21.8042 16.5967 21.4125C16.205 21.0208 16.0092 20.55 16.0092 20C16.0092 19.45 16.205 18.9792 16.5967 18.5875C16.9884 18.1958 17.4592 18 18.0092 18C18.5592 18 19.0301 18.1958 19.4217 18.5875C19.8134 18.9792 20.0092 19.45 20.0092 20C20.0092 20.55 19.8134 21.0208 19.4217 21.4125C19.0301 21.8042 18.5592 22 18.0092 22ZM6.20922 4H20.9592C21.3426 4 21.6342 4.17083 21.8342 4.5125C22.0342 4.85417 22.0425 5.2 21.8592 5.55L18.3092 11.95C18.1259 12.2833 17.88 12.5417 17.5717 12.725C17.2634 12.9083 16.9259 13 16.5592 13H9.10922L8.00922 15H19.0092C19.2925 15 19.5301 15.0958 19.7217 15.2875C19.9134 15.4792 20.0092 15.7167 20.0092 16C20.0092 16.2833 19.9134 16.5208 19.7217 16.7125C19.5301 16.9042 19.2925 17 19.0092 17H8.00922C7.25922 17 6.69255 16.6708 6.30922 16.0125C5.92588 15.3542 5.90922 14.7 6.25922 14.05L7.60922 11.6L4.00922 4H3.00922C2.72588 4 2.48838 3.90417 2.29672 3.7125C2.10505 3.52083 2.00922 3.28333 2.00922 3C2.00922 2.71667 2.10505 2.47917 2.29672 2.2875C2.48838 2.09583 2.72588 2 3.00922 2H4.63422C4.81755 2 4.99255 2.05 5.15922 2.15C5.32588 2.25 5.45088 2.39167 5.53422 2.575L6.20922 4Z\"/></svg>",
	"short-term-rental ": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for short-term-rental \"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.3861 2.21065C11.7472 1.92978 12.2528 1.92978 12.6139 2.21065L22.8996 10.2106C23.3356 10.5497 23.4141 11.178 23.0751 11.6139C22.736 12.0499 22.1077 12.1284 21.6718 11.7894L21 11.2669V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V11.2669L2.32822 11.7894C1.89227 12.1284 1.264 12.0499 0.924928 11.6139C0.585857 11.178 0.664392 10.5497 1.10034 10.2106L3 8.73313V5C3 4.44772 3.44772 4 4 4C4.55229 4 5 4.44772 5 5V7.17758L11.3861 2.21065ZM15 15C15 13.8954 14.1046 13 13 13H11C9.89542 13 8.99999 13.8954 8.99999 15V20H5V9.7113L12 4.26686L19 9.71131V20H15V15Z\"/></svg>",
	"short-term-rental": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for short-term-rental\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.3861 2.21065C11.7472 1.92978 12.2528 1.92978 12.6139 2.21065L22.8996 10.2106C23.3356 10.5497 23.4141 11.178 23.0751 11.6139C22.736 12.0499 22.1077 12.1284 21.6718 11.7894L21 11.2669V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V11.2669L2.32822 11.7894C1.89227 12.1284 1.264 12.0499 0.924928 11.6139C0.585857 11.178 0.664392 10.5497 1.10034 10.2106L3 8.73313V5C3 4.44772 3.44772 4 4 4C4.55229 4 5 4.44772 5 5V7.17758L11.3861 2.21065ZM15 15C15 13.8954 14.1046 13 13 13H11C9.89542 13 8.99999 13.8954 8.99999 15V20H5V9.7113L12 4.26686L19 9.71131V20H15V15Z\"/></svg>",
	"sidebar-arrow-left": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for sidebar-arrow-left\"><path d=\"M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21ZM10 5V19H19V5H10ZM5 5V19H8V5H5Z\"/><path d=\"M15.1383 8.33031L12.3185 11.2159C11.8938 11.6504 11.8938 12.3523 12.3185 12.7868L15.1383 15.6724C15.8242 16.3743 17 15.873 17 14.8814L17 9.11021C17 8.11863 15.8242 7.62841 15.1383 8.33031Z\"/></svg>",
	"sidebar-arrow-right": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for sidebar-arrow-right\"><path d=\"M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21ZM10 5V19H19V5H10ZM5 5V19H8V5H5Z\"/><path d=\"M13.8617 15.6697L16.6815 12.7841C17.1062 12.3496 17.1062 11.6477 16.6815 11.2132L13.8617 8.32757C13.1758 7.62567 12 8.12702 12 9.1186L12 14.8898C12 15.8814 13.1758 16.3716 13.8617 15.6697Z\"/></svg>",
	sliders: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for sliders\"><path d=\"M13 5L21 5C21.5523 5 22 5.44772 22 6C22 6.55229 21.5523 7 21 7L13 7L13 5ZM2 6C2 6.55228 2.44771 7 3 7L9 7L9 8C9 8.55229 9.44772 9 10 9C10.5523 9 11 8.55229 11 8L11 4C11 3.44772 10.5523 3 10 3C9.44772 3 9 3.44772 9 4L9 5L3 5C2.44771 5 2 5.44772 2 6ZM9 17L21 17C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19L9 19L9 17ZM19 11L21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13L19 13L19 11ZM16 15C16.5523 15 17 14.5523 17 14L17 10.012C17 9.45972 16.5523 9.012 16 9.012C15.4477 9.012 15 9.45972 15 10.012L15 11L3 11C2.44771 11 2 11.4477 2 12C2 12.5523 2.44771 13 3 13L15 13L15 14C15 14.5523 15.4477 15 16 15ZM6 21C6.55228 21 7 20.5523 7 20L7 16C7 15.4477 6.55228 15 6 15C5.44771 15 5 15.4477 5 16L5 17L3 17C2.44771 17 2 17.4477 2 18C2 18.5523 2.44771 19 3 19L5 19L5 20C5 20.5523 5.44771 21 6 21Z\"/></svg>",
	"smart-insights": "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for smart-insights\"><g id=\"{{UNIQUE_ID}}__Icon\"><g id=\"{{UNIQUE_ID}}__Colour\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.2556 2.51828C13.5113 1.82724 14.4887 1.82724 14.7444 2.51828L15.4837 4.51627L17.4817 5.2556C18.1728 5.5113 18.1728 6.4887 17.4817 6.7444L15.4837 7.48373L14.7444 9.48172C14.4887 10.1728 13.5113 10.1728 13.2556 9.48172L12.5163 7.48373L10.5183 6.7444C9.82724 6.4887 9.82724 5.51131 10.5183 5.2556L12.5163 4.51627L13.2556 2.51828Z\"/><path d=\"M2.5 3C2.5 2.72386 2.72386 2.5 3 2.5H5C5.27614 2.5 5.5 2.72386 5.5 3V17C5.5 17.2761 5.27614 17.5 5 17.5H3C2.72386 17.5 2.5 17.2761 2.5 17V3Z\"/><path d=\"M7.5 9.5C7.5 9.22386 7.72386 9 8 9H10C10.2761 9 10.5 9.22386 10.5 9.5V17C10.5 17.2761 10.2761 17.5 10 17.5H8C7.72386 17.5 7.5 17.2761 7.5 17V9.5Z\"/><path d=\"M12.5 12C12.5 11.7239 12.7239 11.5 13 11.5H15C15.2761 11.5 15.5 11.7239 15.5 12V17C15.5 17.2761 15.2761 17.5 15 17.5H13C12.7239 17.5 12.5 17.2761 12.5 17V12Z\"/></g></g></svg>",
	"smart-summary": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for smart-summary\"><path d=\"M18 5.40003C18.6627 5.40003 19.2 5.93728 19.2 6.60003C19.2 7.26277 18.6627 7.80003 18 7.80003L3.6 7.80003C2.93726 7.80003 2.4 7.26277 2.4 6.60002C2.4 5.93728 2.93726 5.40002 3.6 5.40002L18 5.40003Z\"/><path d=\"M10.2 10.8C10.8627 10.8 11.4 11.3373 11.4 12C11.4 12.6628 10.8627 13.2 10.2 13.2L3.6 13.2C2.93726 13.2 2.4 12.6628 2.4 12C2.4 11.3373 2.93726 10.8 3.6 10.8H10.2Z\"/><path d=\"M11.4 16.2C12.0627 16.2 12.6 16.7373 12.6 17.4C12.6 18.0628 12.0627 18.6 11.4 18.6H3.6C2.93726 18.6 2.4 18.0628 2.4 17.4C2.4 16.7373 2.93726 16.2 3.6 16.2L11.4 16.2Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.1067 10.222C17.4136 9.39272 18.5864 9.39271 18.8933 10.222L19.7805 12.6196L22.1781 13.5067C23.0073 13.8136 23.0073 14.9865 22.1781 15.2933L19.7805 16.1805L18.8933 18.5781C18.5864 19.4073 17.4136 19.4073 17.1067 18.5781L16.2195 16.1805L13.8219 15.2933C12.9927 14.9865 12.9927 13.8136 13.8219 13.5067L16.2195 12.6196L17.1067 10.222Z\"/></svg>",
	snooze: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for snooze\"><path d=\"M15.5 12.75V15.8232C15.5 15.9364 15.545 16.0449 15.625 16.125L17.2929 17.7929C17.4255 17.9255 17.5 18.1053 17.5 18.2929C17.5 18.6834 17.1834 19 16.7929 19H2.20711C1.81658 19 1.5 18.6834 1.5 18.2929C1.5 18.1053 1.5745 17.9255 1.70711 17.7929L3.37302 16.127C3.45432 16.0457 3.5 15.9354 3.5 15.8204V11C3.5 7.91998 5.13 5.35998 8 4.67998V3.50223C8 2.67223 8.67 2.10001 9.5 2.10001C10.33 2.10001 11 2.67223 11 3.50223V4.67998C11.9466 4.90504 12.7595 5.33713 13.4236 5.92587L12.2132 7.13622C11.2728 8.07671 10.9914 9.49114 11.5004 10.7199C12.0094 11.9488 13.2085 12.75 14.5385 12.75H15.5Z\"/><path d=\"M11.5 20C11.5 21.1 10.6 22 9.5 22C8.39 22 7.5 21.1 7.5 20H11.5Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.3145 2.53852C14.3145 1.965 14.7794 1.50006 15.3529 1.50006H21.4614C21.8814 1.50006 22.2601 1.75307 22.4208 2.14112C22.5816 2.52917 22.4927 2.97583 22.1957 3.27283L17.0455 8.42314H21.0542C21.6277 8.42314 22.0926 8.88807 22.0926 9.4616C22.0926 10.0351 21.6277 10.5001 21.0542 10.5001H14.5385C14.1185 10.5001 13.7398 10.247 13.5791 9.859C13.4183 9.47095 13.5072 9.02429 13.8042 8.7273L18.9544 3.57698H15.3529C14.7794 3.57698 14.3145 3.11205 14.3145 2.53852Z\"/></svg>",
	"social-linkedin": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for social-linkedin\"><path d=\"M3 19.7131C3.00553 20.0559 3.14533 20.3829 3.38932 20.6235C3.6333 20.8642 3.96193 20.9993 4.30446 20.9998H19.66C20.008 21.0065 20.3445 20.8749 20.5957 20.6337C20.8469 20.3925 20.9923 20.0614 21 19.7131V4.2869C20.9945 3.94405 20.8548 3.61706 20.6108 3.3764C20.3668 3.13573 20.0381 3.00064 19.6955 3.00025H4.34C3.99199 2.99347 3.65548 3.12511 3.40429 3.36631C3.1531 3.6075 3.00772 3.93856 3 4.2869V19.7131ZM7.00081 8.54722C6.69379 8.54903 6.39317 8.45943 6.13714 8.28981C5.8811 8.12019 5.6812 7.8782 5.56287 7.5946C5.44454 7.31099 5.41312 6.99858 5.47258 6.69705C5.53203 6.39552 5.67969 6.11849 5.89679 5.90116C6.11389 5.68384 6.39064 5.53603 6.69186 5.47651C6.99307 5.41699 7.30515 5.44846 7.58846 5.56691C7.87177 5.68536 8.11349 5.88546 8.28294 6.14176C8.45238 6.39806 8.5419 6.699 8.54009 7.00634C8.53726 7.41392 8.37433 7.804 8.0865 8.09228C7.79867 8.38056 7.40907 8.54388 7.00193 8.54694L7.00081 8.54722ZM9.98945 18.3537V9.72523H12.5429V10.9396H12.5789C12.8917 10.5025 13.3053 10.1474 13.7845 9.90449C14.2636 9.66154 14.7943 9.53791 15.3314 9.54408C17.3411 9.54408 18.3189 10.9216 18.3189 12.7161V18.3537H15.675V13.6044C15.675 12.7342 15.3672 11.9004 14.2445 11.9004C13.1038 11.9004 12.6331 12.7161 12.6331 13.713V18.3528L9.98945 18.3537ZM8.32417 18.3537H5.68053V9.72523H8.32417V18.3537Z\"/></svg>",
	"social-twitter": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for social-twitter\"><path d=\"M8.28251 20C15.8295 20 19.9592 14.2274 19.9592 9.22982C19.9592 9.06742 19.9592 8.90502 19.9512 8.74262C20.7515 8.21112 21.4478 7.53937 22 6.77904C21.2637 7.08169 20.4714 7.281 19.6391 7.37697C20.4874 6.91191 21.1357 6.16634 21.4478 5.28051C20.6555 5.71604 19.7751 6.02608 18.8387 6.19587C18.0864 5.45768 17.022 5 15.8455 5C13.5806 5 11.7399 6.69783 11.7399 8.78691C11.7399 9.08218 11.7799 9.37008 11.8439 9.65059C8.43457 9.49557 5.40936 7.98228 3.38455 5.6939C3.03241 6.25492 2.83233 6.90453 2.83233 7.59842C2.83233 8.9124 3.56062 10.0714 4.65706 10.7505C3.98479 10.7283 3.35254 10.5586 2.80032 10.278C2.80032 10.2928 2.80032 10.3076 2.80032 10.3297C2.80032 12.1604 4.21689 13.6959 6.08964 14.0428C5.7455 14.1314 5.38535 14.1757 5.0092 14.1757C4.7451 14.1757 4.489 14.1535 4.2409 14.1093C4.7611 15.6152 6.28171 16.7077 8.07443 16.7372C6.66587 17.7559 4.89716 18.3612 2.97639 18.3612C2.64826 18.3612 2.32013 18.3465 2 18.3095C3.80872 19.3725 5.96959 20 8.28251 20Z\"/></svg>",
	"social-youtube": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for social-youtube\"><path d=\"M9.79996 15.4285V8.57139L15.5155 12L9.79996 15.4285ZM22.5402 6.4984C22.2872 5.51504 21.5418 4.74047 20.5953 4.47765C18.8795 4 11.9999 4 11.9999 4C11.9999 4 5.12041 4 3.40471 4.47765C2.45822 4.74047 1.7127 5.51504 1.45973 6.4984C1 8.28095 1 11.9999 1 11.9999C1 11.9999 1 15.7191 1.45973 17.5015C1.7127 18.4848 2.45822 19.2595 3.40471 19.5222C5.12041 20 11.9999 20 11.9999 20C11.9999 20 18.8795 20 20.5953 19.5222C21.5418 19.2595 22.2872 18.4848 22.5402 17.5015C23 15.7191 23 11.9999 23 11.9999C23 11.9999 23 8.28095 22.5402 6.4984Z\"/></svg>",
	"sort-asc": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for sort-asc\"><path d=\"M7.00024 10.9998L12 5.97479L16.9998 10.9998H7.00024Z\"/></svg>",
	"sort-desc": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for sort-desc\"><path d=\"M12 18L7.00024 13.0248H16.9998L12 18Z\"/></svg>",
	sort: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for sort\"><path d=\"M12 18L7.00024 13.0248H16.9998L12 18Z\"/><path d=\"M7.00024 10.9998L12 5.97479L16.9998 10.9998H7.00024Z\"/></svg>",
	spinner: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for spinner\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 4.50004C11.0151 4.50004 10.0398 4.69403 9.12988 5.07094C8.21993 5.44785 7.39314 6.0003 6.6967 6.69674C6.00026 7.39318 5.44782 8.21997 5.07091 9.12991C4.694 10.0399 4.5 11.0151 4.5 12C4.5 12.985 4.694 13.9602 5.07091 14.8702C5.44782 15.7801 6.00026 16.6069 6.6967 17.3033C7.39314 17.9998 8.21993 18.5522 9.12988 18.9291C10.0398 19.306 11.0151 19.5 12 19.5C12.9849 19.5 13.9602 19.306 14.8701 18.9291C15.7801 18.5522 16.6069 17.9998 17.3033 17.3033C17.9997 16.6069 18.5522 15.7801 18.9291 14.8702C19.306 13.9602 19.5 12.985 19.5 12C19.5 11.0151 19.306 10.0399 18.9291 9.12992C18.5522 8.21997 17.9997 7.39318 17.3033 6.69674C16.6069 6.0003 15.7801 5.44785 14.8701 5.07094C13.9602 4.69403 12.9849 4.50004 12 4.50004ZM8.49207 3.53114C9.60422 3.07048 10.7962 2.83337 12 2.83337C13.2038 2.83337 14.3958 3.07048 15.5079 3.53115C16.6201 3.99181 17.6306 4.66703 18.4818 5.51823C19.333 6.36943 20.0082 7.37996 20.4689 8.49211C20.9296 9.60426 21.1667 10.7963 21.1667 12C21.1667 13.2038 20.9296 14.3958 20.4689 15.508C20.0082 16.6201 19.333 17.6306 18.4818 18.4819C17.6306 19.3331 16.6201 20.0083 15.5079 20.4689C14.3958 20.9296 13.2038 21.1667 12 21.1667C10.7962 21.1667 9.60422 20.9296 8.49207 20.4689C7.37992 20.0083 6.36939 19.3331 5.51819 18.4819C4.66699 17.6306 3.99177 16.6201 3.53111 15.508C3.07044 14.3958 2.83334 13.2038 2.83334 12C2.83334 10.7963 3.07044 9.60426 3.53111 8.49211C3.99178 7.37996 4.66699 6.36943 5.51819 5.51823C6.36939 4.66702 7.37992 3.99181 8.49207 3.53114Z\"/></svg>",
	split: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" alt=\"Icon for split\"><path d=\"M19 4a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V7.414l-3.293 3.293a1.004 1.004 0 0 1-.415.25l-.062.015-.034.008-.031.004c-.02.004-.041.009-.063.011L14 11H5a1 1 0 1 1 0-2h8.586l3-3H14a1 1 0 1 1 0-2h5Zm-.99 12.603V14.03a.995.995 0 0 1 1.99 0v4.974c0 .55-.446.995-.995.995H14.03a.995.995 0 0 1 0-1.99h2.574L11.594 13h2.813l3.603 3.603Z\"/></svg>",
	sso: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for sso\"><path d=\"M2.6125 18.425C3.6875 19.475 4.98333 20 6.5 20H13.7558C12.8751 19.4916 12.1073 18.8093 11.4995 18H6.5C5.53333 18 4.70833 17.6583 4.025 16.975C3.34167 16.2917 3 15.4667 3 14.5C3 13.5333 3.34167 12.7083 4.025 12.025C4.70833 11.3417 5.53333 11 6.5 11H7C7 9.61667 7.4875 8.4375 8.4625 7.4625C9.4375 6.4875 10.6167 6 12 6C12.9127 6 13.7365 6.21221 14.4714 6.63662C15.2373 6.29819 16.0704 6.08418 16.9452 6.02021C15.5901 4.6734 13.9417 4 12 4C10.4167 4 9 4.475 7.75 5.425C6.5 6.375 5.66667 7.61667 5.25 9.15C3.98333 9.43333 2.95833 10.0833 2.175 11.1C1.39167 12.1167 1 13.275 1 14.575C1 16.0917 1.5375 17.375 2.6125 18.425Z\"/><path d=\"M18 21L16.5 19.5V14.85C15.7667 14.6333 15.1667 14.2208 14.7 13.6125C14.2333 13.0042 14 12.3 14 11.5C14 10.5333 14.3417 9.70833 15.025 9.025C15.7083 8.34167 16.5333 8 17.5 8C18.4667 8 19.2917 8.34167 19.975 9.025C20.6583 9.70833 21 10.5333 21 11.5C21 12.25 20.7875 12.9167 20.3625 13.5C19.9375 14.0833 19.4 14.5 18.75 14.75L20 16L18.5 17.5L20 19L18 21ZM17.5 12C17.7833 12 18.0208 11.9042 18.2125 11.7125C18.4042 11.5208 18.5 11.2833 18.5 11C18.5 10.7167 18.4042 10.4792 18.2125 10.2875C18.0208 10.0958 17.7833 10 17.5 10C17.2167 10 16.9792 10.0958 16.7875 10.2875C16.5958 10.4792 16.5 10.7167 16.5 11C16.5 11.2833 16.5958 11.5208 16.7875 11.7125C16.9792 11.9042 17.2167 12 17.5 12Z\"/></svg>",
	"star-filled": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for star-filled\"><path d=\"M12 17.27L16.15 19.78C16.91 20.24 17.8399 19.56 17.6399 18.7L16.54 13.98L20.2099 10.8C20.8799 10.22 20.5199 9.12001 19.6399 9.05001L14.81 8.64001L12.92 4.18001C12.58 3.37001 11.42 3.37001 11.08 4.18001L9.18995 8.63001L4.35995 9.04001C3.47995 9.11001 3.11995 10.21 3.78995 10.79L7.45995 13.97L6.35995 18.69C6.15995 19.55 7.08995 20.23 7.84995 19.77L12 17.27Z\"/></svg>",
	"star-outline": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for star-outline\"><path d=\"M19.6501 9.04L14.8101 8.62L12.9201 4.17C12.5801 3.36 11.4201 3.36 11.0801 4.17L9.19007 8.63L4.36007 9.04C3.48007 9.11 3.12007 10.21 3.79007 10.79L7.46007 13.97L6.36007 18.69C6.16007 19.55 7.09007 20.23 7.85007 19.77L12.0001 17.27L16.1501 19.78C16.9101 20.24 17.8401 19.56 17.6401 18.7L16.5401 13.97L20.2101 10.79C20.8801 10.21 20.5301 9.11 19.6501 9.04ZM12.0001 15.4L8.24007 17.67L9.24007 13.39L5.92007 10.51L10.3001 10.13L12.0001 6.1L13.7101 10.14L18.0901 10.52L14.7701 13.4L15.7701 17.68L12.0001 15.4Z\"/></svg>",
	"sticky-note": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for sticky-note\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.5631 21C13.1202 21 13.6521 20.7676 14.0306 20.3588L20.4675 14.5669C20.8098 14.1972 21 13.712 21 13.2081L21 5C21 3.89543 20.1046 3 19 3L5 3C3.89543 3 3 3.89543 3 5L3 19C3 20.1046 3.89543 21 5 21H12.5631ZM11 19H5L5 5L19 5L19 12H13C11.8954 12 11 12.8954 11 14V19ZM18.2668 14L13 18.5281V14H18.2668Z\"/></svg>",
	sunset: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for sunset\"><path d=\"M12 8C15.3137 8 18 10.6863 18 14C18 15.0932 17.7061 16.1173 17.1953 17H6.80469C6.29387 16.1173 6 15.0932 6 14C6 10.6863 8.68629 8 12 8Z\"/><path d=\"M11 4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V4Z\"/><path d=\"M22 13C22.5523 13 23 13.4477 23 14C23 14.5523 22.5523 15 22 15H20C19.4477 15 19 14.5523 19 14C19 13.4477 19.4477 13 20 13H22Z\"/><path d=\"M4 13C4.55228 13 5 13.4477 5 14C5 14.5523 4.55228 15 4 15H2C1.44772 15 1 14.5523 1 14C1 13.4477 1.44772 13 2 13H4Z\"/><path d=\"M18.364 6.22188C18.7545 5.83135 19.3877 5.83135 19.7782 6.22188C20.1687 6.6124 20.1687 7.24557 19.7782 7.63609L18.364 9.0503C17.9734 9.44083 17.3403 9.44083 16.9498 9.0503C16.5592 8.65978 16.5592 8.02662 16.9498 7.63609L18.364 6.22188Z\"/><path d=\"M7.05025 7.63603C7.44077 8.02656 7.44077 8.65972 7.05025 9.05025C6.65972 9.44077 6.02656 9.44077 5.63603 9.05025L4.22182 7.63603C3.8313 7.24551 3.8313 6.61234 4.22182 6.22182C4.61235 5.8313 5.24551 5.8313 5.63603 6.22182L7.05025 7.63603Z\"/><path d=\"M1 20C1 19.4477 1.44772 19 2 19H22C22.5523 19 23 19.4477 23 20C23 20.5523 22.5523 21 22 21H2C1.44772 21 1 20.5523 1 20Z\"/></svg>",
	"sync-disabled": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" alt=\"Icon for sync-disabled\"><path d=\"M20.386 3.7a1 1 0 0 0-1.414 0L3.543 19.13a1 1 0 1 0 1.414 1.414l2.186-2.186a8.008 8.008 0 0 0 7.707 1.12c.639-.243.744-1.055.26-1.539-.313-.313-.788-.386-1.209-.246a6.009 6.009 0 0 1-5.328-.765l8.354-8.354a5.992 5.992 0 0 1 1.064 3.76l-1.042-1.04a1 1 0 0 0-1.414 1.414l3.536 3.536 3.535-3.536a1 1 0 1 0-1.414-1.414L19.985 12.5a7.986 7.986 0 0 0-1.627-5.359l2.028-2.028a1 1 0 0 0 0-1.414ZM1.394 11.293a1 1 0 1 0 1.414 1.414l1.208-1.208a8.018 8.018 0 0 0 .643 3.685l1.548-1.547.015-.016a6.028 6.028 0 0 1-.213-1.955l1.04 1.04a1 1 0 0 0 1.416-1.413L4.929 7.758l-3.535 3.535ZM15.185 4.66a8.029 8.029 0 0 0-6.035-.138c-.638.243-.744 1.056-.26 1.54.313.313.788.386 1.209.246a6.028 6.028 0 0 1 3.522-.086l1.564-1.563Z\"/></svg>",
	"sync-issue": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" alt=\"Icon for sync-issue\"><path d=\"M8.465 11.293a1 1 0 0 1-1.414 1.414l-1.041-1.04a6 6 0 0 0 7.892 6.026c.42-.14.895-.068 1.208.246.484.483.378 1.296-.26 1.539a8.002 8.002 0 0 1-10.835-7.979l-1.208 1.208a1 1 0 1 1-1.414-1.414L4.93 7.758l3.536 3.535Zm.685-6.77A8.002 8.002 0 0 1 19.984 12.5l1.208-1.208a1 1 0 0 1 1.414 1.414l-3.535 3.535-3.536-3.535a1 1 0 0 1 1.415-1.414l1.041 1.041a6.001 6.001 0 0 0-7.893-6.026c-.42.14-.895.067-1.208-.246-.484-.484-.379-1.296.26-1.54ZM12 13.998a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 8a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1Z\"/></svg>",
	sync: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" alt=\"Icon for sync\"><path d=\"M12.707 21.192a1 1 0 0 1-1.414 1.415L7.757 19.07l3.536-3.536a1 1 0 0 1 1.414 1.415l-1.04 1.04a6 6 0 0 0 6.026-7.892c-.141-.42-.068-.895.246-1.208.483-.484 1.295-.379 1.538.26A8.002 8.002 0 0 1 11.5 19.984l1.208 1.208ZM12.334 6.01a6 6 0 0 0-6.026 7.892c.14.42.067.895-.247 1.208-.483.484-1.295.379-1.538-.26A8.002 8.002 0 0 1 12.5 4.016l-1.208-1.208a1 1 0 1 1 1.414-1.415l3.536 3.536-3.536 3.535a1 1 0 1 1-1.414-1.414l1.04-1.04Z\"/></svg>",
	templates: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for templates\"><path d=\"M4 4V13H10V4H4ZM12 9.89949V13H15.1005L12 9.89949ZM12 6.58579L15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289L20.9497 7.53553C21.3403 7.92606 21.3403 8.55922 20.9497 8.94975L16.8995 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V15C2 14.6357 2.09739 14.2942 2.26756 14C2.09739 13.7058 2 13.3643 2 13V4C2 2.89543 2.89543 2 4 2H10C11.1046 2 12 2.89543 12 4V6.58579ZM4 15V20H20V15H4ZM13.1716 8.24264L16 11.0711L18.8284 8.24264L16 5.41421L13.1716 8.24264Z\"/></svg>",
	"test-tube": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for test-tube\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.9999 3C15.5522 3 15.9999 3.44772 15.9999 4V5C15.9999 5.55228 15.5522 6 14.9999 6C14.4477 6 13.9999 5.55228 13.9999 5V4C13.9999 3.44772 14.4477 3 14.9999 3Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 5C18.5522 5 19 5.44772 19 6V8C19 8.55228 18.5522 9 18 9C17.4477 9 16.9999 8.55228 16.9999 8V6C16.9999 5.44772 17.4477 5 18 5Z\"/><path d=\"M19 3C19 3.55228 18.5522 4 18 4C17.4477 4 16.9999 3.55228 16.9999 3C16.9999 2.44772 17.4477 2 18 2C18.5522 2 19 2.44772 19 3Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.6066 6.29289C13.2161 5.90237 12.5829 5.90237 12.1924 6.29289C11.8019 6.68342 11.8019 7.31658 12.1924 7.70711L12.5459 8.06064L4.76772 15.8388C3.59614 17.0104 3.59614 18.9099 4.76772 20.0815C5.93929 21.253 7.83879 21.253 9.01036 20.0815L16.7886 12.3033L17.1421 12.6569C17.5327 13.0474 18.1658 13.0474 18.5563 12.6569C18.9469 12.2663 18.9469 11.6332 18.5563 11.2426L13.6066 6.29289ZM13.9601 9.47485L8.43497 15H11.2634L15.3743 10.8891L13.9601 9.47485Z\"/></svg>",
	"thumbs-down-filled": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" alt=\"Icon for thumbs-down-filled\"><path d=\"M14.75 4.502a5.75 5.75 0 0 1 5.75 5.75v3a1.75 1.75 0 0 1-1.75 1.75h-3.305l.581 2.906A1.75 1.75 0 0 1 14.41 20a.752.752 0 0 1-.713-.414L11 14.192v-9.69h3.75Zm-5.75 0v8.5H4.75a.75.75 0 0 1-.75-.75v-7a.75.75 0 0 1 .75-.75H9Z\"/></svg>",
	"thumbs-down": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for thumbs-down\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.5 20.5C13.1212 20.5 12.775 20.286 12.6056 19.9472L9.38197 13.5H2.5V2.5H14.5C18.366 2.5 21.5 5.63401 21.5 9.5V12.5C21.5 14.1569 20.1569 15.5 18.5 15.5H16.7198L17.0021 16.9117C17.3734 18.768 15.9535 20.5 14.0604 20.5H13.5ZM11 4.5H14.5C17.2614 4.5 19.5 6.73858 19.5 9.5V12.5C19.5 13.0523 19.0523 13.5 18.5 13.5H14.2802L15.041 17.3039C15.161 17.9039 14.7195 18.465 14.1172 18.4984L11 12.2639V4.5ZM9 4.5V11.5H4.5V4.5H9Z\"/></svg>",
	"thumbs-up-filled": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" alt=\"Icon for thumbs-up-filled\"><path d=\"M9 19.498H4.75a.75.75 0 0 1-.75-.75v-7a.75.75 0 0 1 .75-.75H9v8.5Zm5.41-15.497a1.75 1.75 0 0 1 1.616 2.091l-.58 2.906h3.304c.966 0 1.75.784 1.75 1.75v3a5.75 5.75 0 0 1-5.75 5.75H11v-9.69l2.696-5.393a.752.752 0 0 1 .713-.414Z\"/></svg>",
	"thumbs-up": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for thumbs-up\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.5 2.5C13.1212 2.5 12.775 2.714 12.6056 3.05279L9.38197 9.5H2.5V20.5H14.5C18.366 20.5 21.5 17.366 21.5 13.5V10.5C21.5 8.84315 20.1569 7.5 18.5 7.5H16.7198L17.0021 6.08835C17.3734 4.23197 15.9535 2.5 14.0604 2.5H13.5ZM11 18.5H14.5C17.2614 18.5 19.5 16.2614 19.5 13.5V10.5C19.5 9.94772 19.0523 9.5 18.5 9.5H14.2802L15.041 5.69612C15.161 5.09605 14.7195 4.53499 14.1172 4.50157L11 10.7361V18.5ZM9 18.5V11.5H4.5V18.5H9Z\"/></svg>",
	translate: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" alt=\"Icon for translate\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.516 3a.94.94 0 0 0-.941.94v1.15H2.94a.941.941 0 1 0 0 1.882h7.362a7.422 7.422 0 0 1-1.787 3.958 7.42 7.42 0 0 1-1.422-2.425.94.94 0 1 0-1.774.627 9.303 9.303 0 0 0 1.785 3.043 7.422 7.422 0 0 1-4.164 1.278.94.94 0 0 0 0 1.881 9.3 9.3 0 0 0 5.575-1.855 9.303 9.303 0 0 0 4.11 1.74l-.763 1.525-.016.034-1.385 2.77a.94.94 0 0 0 1.683.841l1.133-2.267h5.806l1.134 2.267a.941.941 0 0 0 1.683-.841l-1.385-2.769a.863.863 0 0 0-.018-.036l-3.476-6.951a.94.94 0 0 0-1.682 0l-1.82 3.639a7.424 7.424 0 0 1-3.593-1.256 9.303 9.303 0 0 0 2.27-5.203h1.894a.94.94 0 1 0 0-1.881H9.456V3.94a.94.94 0 0 0-.94-.94Zm6.426 11.794a1.024 1.024 0 0 1-.02.039l-.703 1.407h3.924l-1.962-3.924-1.24 2.478h.001Z\"/></svg>",
	"trending-down": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for trending-down\"><path d=\"M3.2984 6.28743C3.69194 5.89995 4.32508 5.90486 4.71257 6.2984L9.53846 11.1997L11.9028 8.7984C12.0908 8.6075 12.3475 8.5 12.6154 8.5C12.8833 8.5 13.14 8.6075 13.328 8.7984L19 14.5591V11C19 10.4477 19.4477 10 20 10C20.5523 10 21 10.4477 21 11V17C21 17.5523 20.5523 18 20 18H14C13.4477 18 13 17.5523 13 17C13 16.4477 13.4477 16 14 16H17.612L12.6154 10.9253L10.251 13.3266C10.0631 13.5175 9.80637 13.625 9.53846 13.625C9.27056 13.625 9.01386 13.5175 8.8259 13.3266L3.28743 7.7016C2.89995 7.30806 2.90486 6.67492 3.2984 6.28743Z\"/></svg>",
	"trending-up": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for trending-up\"><path d=\"M13.328 15.2016C13.14 15.3925 12.8833 15.5 12.6154 15.5C12.3475 15.5 12.0908 15.3925 11.9028 15.2016L9.53846 12.8003L4.71257 17.7016C4.32508 18.0951 3.69194 18.1001 3.2984 17.7126C2.90486 17.3251 2.89995 16.6919 3.28743 16.2984L8.8259 10.6734C9.01386 10.4825 9.27056 10.375 9.53846 10.375C9.80637 10.375 10.0631 10.4825 10.251 10.6734L12.6154 13.0747L17.612 8H14C13.4477 8 13 7.55228 13 7C13 6.44772 13.4477 6 14 6H20C20.5523 6 21 6.44772 21 7V13C21 13.5523 20.5523 14 20 14C19.4477 14 19 13.5523 19 13V9.44093L13.328 15.2016Z\"/></svg>",
	undo: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for undo\"><path d=\"M12 5C13.9327 5 15.6841 5.7846 16.9497 7.05025C18.2154 8.31591 19 10.0673 19 12C19 13.9327 18.2154 15.6841 16.9497 16.9497C15.6841 18.2154 13.9327 19 12 19C10.0673 19 8.3159 18.2154 7.05025 16.9497C6.65972 16.5592 6.65972 15.9261 7.05025 15.5355C7.44077 15.145 8.07394 15.145 8.46446 15.5355C9.37038 16.4415 10.619 17 12 17C13.381 17 14.6296 16.4415 15.5355 15.5355C16.4414 14.6296 17 13.381 17 12C17 10.619 16.4414 9.37038 15.5355 8.46447C14.6296 7.55855 13.381 7 12 7C10.8737 7 9.83545 7.37152 8.99935 8H10.75C11.3023 8 11.75 8.44772 11.75 9C11.75 9.55228 11.3023 10 10.75 10H6.75C6.19772 10 5.75 9.55228 5.75 9V5C5.75 4.44772 6.19772 4 6.75 4C7.30228 4 7.75 4.44772 7.75 5V6.4375C8.92801 5.53635 10.402 5 12 5Z\"/></svg>",
	unpin: "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for unpin\"><g clip-path=\"url(#{{UNIQUE_ID}}__clip0_2596_12779)\"><path d=\"M0.86162 0.861633C1.08953 0.633727 1.44169 0.605567 1.70049 0.776672L1.80498 0.861633L15.138 14.1956L14.6663 14.6663L14.1956 15.138L11.0579 12.0003H8.66728V14.6663C8.66728 15.0344 8.36833 15.3331 8.00029 15.3333C7.6321 15.3333 7.3333 15.0345 7.3333 14.6663V12.0003H4.00029C3.64675 12.0003 3.30697 11.8596 3.05693 11.6097C2.80714 11.3598 2.66648 11.0206 2.66631 10.6673V10.1595L2.67119 10.0208C2.6939 9.69752 2.7956 9.38338 2.96709 9.10675C3.16311 8.79074 3.44367 8.53596 3.77666 8.37042L4.95928 7.77179L4.96318 7.76984L5.04326 7.72296C5.1193 7.6709 5.18472 7.60357 5.23369 7.52472C5.28259 7.44586 5.31356 7.35714 5.32646 7.26593L5.3333 7.17316V6.2757L0.86162 1.80499L0.776659 1.7005C0.605554 1.4417 0.633714 1.08954 0.86162 0.861633ZM15.138 14.1956C15.3982 14.456 15.3983 14.8777 15.138 15.138C14.8777 15.3983 14.456 15.3982 14.1956 15.138L15.138 14.1956ZM6.62627 7.56866C6.57951 7.80064 6.49231 8.02395 6.3665 8.22687C6.17114 8.54181 5.89138 8.79566 5.55986 8.96124L5.56084 8.96222L4.37432 9.56183L4.37041 9.56378C4.2594 9.61898 4.16524 9.70451 4.0999 9.80988C4.03475 9.91512 4.00039 10.0367 4.00029 10.1605V10.6673H7.99053C7.99367 10.6673 7.99714 10.6663 8.00029 10.6663C8.00356 10.6663 8.0068 10.6672 8.01006 10.6673H9.7249L6.62627 7.56866ZM10.6663 0.666321C11.1967 0.666345 11.7063 0.877207 12.0813 1.25226C12.4562 1.62724 12.6662 2.13608 12.6663 2.66632C12.6663 3.19652 12.4561 3.70536 12.0813 4.08038C11.7532 4.40851 11.3223 4.61104 10.8645 4.65656L10.6663 4.66632V6.22687C10.6662 6.59485 10.3683 6.89271 10.0003 6.89288C9.63218 6.89288 9.33342 6.59496 9.3333 6.22687V4.66632C9.33339 4.31284 9.47398 3.97391 9.72392 3.72394C9.97387 3.47402 10.3129 3.33342 10.6663 3.33331C10.8431 3.33329 11.013 3.26297 11.138 3.138C11.263 3.01298 11.3333 2.84311 11.3333 2.66632C11.3332 2.4897 11.2628 2.32055 11.138 2.19562C11.013 2.07062 10.8431 2.00033 10.6663 2.00031H5.26006C4.89187 2.00031 4.59307 1.7015 4.59307 1.33331C4.59307 0.965123 4.89187 0.666321 5.26006 0.666321H10.6663Z\"/></g><defs><clipPath id=\"{{UNIQUE_ID}}__clip0_2596_12779\"><rect width=\"16\" height=\"16\"/></clipPath></defs></svg>",
	upload: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for upload\"><path d=\"M12.0001 22C12.5524 22 13.0001 21.5523 13.0001 21L13.0001 9.82997L16.2947 13.1163C16.6844 13.5051 17.3154 13.5047 17.7047 13.1154C18.0943 12.7258 18.0943 12.0941 17.7047 11.7045L12.7072 6.70708C12.3167 6.31656 11.6835 6.31656 11.293 6.70708L6.29553 11.7045C5.90593 12.0941 5.90593 12.7258 6.29553 13.1154C6.68479 13.5047 7.31579 13.5051 7.70553 13.1163L11.0001 9.82997L11.0001 21C11.0001 21.5523 11.4478 22 12.0001 22Z\"/><path d=\"M18.0001 2.99997C18.0001 3.55225 17.5524 3.99997 17.0001 3.99997L7.00012 3.99997C6.44784 3.99997 6.00012 3.55226 6.00012 2.99997C6.00012 2.44769 6.44784 1.99997 7.00012 1.99997L17.0001 1.99997C17.5524 1.99997 18.0001 2.44768 18.0001 2.99997Z\"/></svg>",
	"user-add": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" alt=\"Icon for user-add\"><path d=\"M7.93 4.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm5 14.5c.552 0 1.008-.451.917-.996a6.002 6.002 0 0 0-11.835 0c-.091.545.365.996.917.996h10ZM19 11h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2V9a1 1 0 1 1 2 0v2Z\"/></svg>",
	"user-group": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for user-group\"><path d=\"M7.92936 4.5C5.99636 4.5 4.42936 6.067 4.42936 8C4.42936 9.933 5.99636 11.5 7.92936 11.5C9.86136 11.4976 11.4269 9.932 11.4294 8C11.4294 6.067 9.86236 4.5 7.92936 4.5Z\"/><path d=\"M12.9294 19C13.4816 19 13.9381 18.5489 13.8471 18.0042C13.3728 15.1644 10.9038 13 7.92936 13C4.9549 13 2.48597 15.1644 2.01162 18.0042C1.92062 18.5489 2.37707 19 2.92936 19H12.9294Z\"/><path d=\"M12.5694 8C12.5694 6.067 14.1364 4.5 16.0694 4.5C18.0024 4.5 19.5694 6.067 19.5694 8C19.567 9.932 18.0014 11.4976 16.0694 11.5C14.1364 11.5 12.5694 9.933 12.5694 8Z\"/><path d=\"M21.9871 18.0042C22.0781 18.5489 21.6217 19 21.0694 19H15.737C15.8628 18.6034 15.9006 18.1584 15.8198 17.6747C15.5502 16.0612 14.7987 14.6113 13.718 13.4783C14.44 13.1704 15.2348 13 16.0694 13C19.0438 13 21.5128 15.1644 21.9871 18.0042Z\"/></svg>",
	user: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for user\"><path d=\"M12 2C9.243 2 7 4.243 7 7C7 9.757 9.243 12 12 12C14.757 12 17 9.757 17 7C17 4.243 14.757 2 12 2Z\"/><path d=\"M20 22C20.5523 22 21 21.5523 21 21C21 17.141 17.859 14 14 14H10C6.14 14 3 17.141 3 21C3 21.5523 3.44772 22 4 22H5H12H19H20Z\"/></svg>",
	"view-calendar": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for view-calendar\"><path d=\"M7 12H9V14H7V12Z\"/><path d=\"M7 16H9V18H7V16Z\"/><path d=\"M13 12H11V14H13V12Z\"/><path d=\"M11 16H13V18H11V16Z\"/><path d=\"M17 12H15V14H17V12Z\"/><path d=\"M15 16H17V18H15V16Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 22H19C20.103 22 21 21.103 21 20V6C21 4.897 20.103 4 19 4H17V3C17 2.44772 16.5523 2 16 2C15.4477 2 15 2.44772 15 3V4H9V3C9 2.44772 8.55229 2 8 2C7.44772 2 7 2.44772 7 3V4H5C3.897 4 3 4.897 3 6V20C3 21.103 3.897 22 5 22ZM19.001 20L19.0003 10H5V20H19.001Z\"/></svg>",
	"view-chart": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for view-chart\"><path d=\"M4 3C3.44772 3 3 3.44772 3 4V20C3 20.553 3.447 21 4 21H20C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19H5V4C5 3.44772 4.55229 3 4 3Z\"/><path d=\"M14.7702 14.0984C15.15 14.4702 15.7638 14.4702 16.1436 14.0984L20.2987 10.031C20.6836 9.65419 20.6836 9.03466 20.2987 8.65789C19.9252 8.2923 19.328 8.2923 18.9546 8.65789L15.4569 12.0818L13.2298 9.90159C12.85 9.52983 12.2362 9.52983 11.8564 9.90159L7.70133 13.969C7.31644 14.3458 7.31644 14.9653 7.70133 15.3421C8.07479 15.7077 8.67199 15.7077 9.04545 15.3421L12.5431 11.9182L14.7702 14.0984Z\"/></svg>",
	"view-large-grid": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for view-large-grid\"><path d=\"M4 5C4 4.44772 4.44772 4 5 4H7C7.55229 4 8 4.44772 8 5V7C8 7.55228 7.55229 8 7 8H5C4.44772 8 4 7.55228 4 7V5Z\"/><path d=\"M16 5C16 4.44772 16.4477 4 17 4H19C19.5523 4 20 4.44772 20 5V7C20 7.55228 19.5523 8 19 8H17C16.4477 8 16 7.55228 16 7V5Z\"/><path d=\"M10 5C10 4.44772 10.4477 4 11 4H13C13.5523 4 14 4.44772 14 5V7C14 7.55228 13.5523 8 13 8H11C10.4477 8 10 7.55228 10 7V5Z\"/><path d=\"M4 11C4 10.4477 4.44772 10 5 10H7C7.55229 10 8 10.4477 8 11V13C8 13.5523 7.55229 14 7 14H5C4.44772 14 4 13.5523 4 13V11Z\"/><path d=\"M16 11C16 10.4477 16.4477 10 17 10H19C19.5523 10 20 10.4477 20 11V13C20 13.5523 19.5523 14 19 14H17C16.4477 14 16 13.5523 16 13V11Z\"/><path d=\"M10 11C10 10.4477 10.4477 10 11 10H13C13.5523 10 14 10.4477 14 11V13C14 13.5523 13.5523 14 13 14H11C10.4477 14 10 13.5523 10 13V11Z\"/><path d=\"M4 17C4 16.4477 4.44772 16 5 16H7C7.55229 16 8 16.4477 8 17V19C8 19.5523 7.55229 20 7 20H5C4.44772 20 4 19.5523 4 19V17Z\"/><path d=\"M16 17C16 16.4477 16.4477 16 17 16H19C19.5523 16 20 16.4477 20 17V19C20 19.5523 19.5523 20 19 20H17C16.4477 20 16 19.5523 16 19V17Z\"/><path d=\"M10 17C10 16.4477 10.4477 16 11 16H13C13.5523 16 14 16.4477 14 17V19C14 19.5523 13.5523 20 13 20H11C10.4477 20 10 19.5523 10 19V17Z\"/></svg>",
	"view-list": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for view-list\"><path d=\"M8 6C8 5.44772 8.44772 5 9 5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H9C8.44772 7 8 6.55228 8 6Z\"/><path d=\"M8 12C8 11.4477 8.44772 11 9 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H9C8.44772 13 8 12.5523 8 12Z\"/><path d=\"M8 18C8 17.4477 8.44772 17 9 17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H9C8.44772 19 8 18.5523 8 18Z\"/><path d=\"M6 6C6 6.82843 5.32843 7.5 4.5 7.5C3.67157 7.5 3 6.82843 3 6C3 5.17157 3.67157 4.5 4.5 4.5C5.32843 4.5 6 5.17157 6 6Z\"/><path d=\"M6 12C6 12.8284 5.32843 13.5 4.5 13.5C3.67157 13.5 3 12.8284 3 12C3 11.1716 3.67157 10.5 4.5 10.5C5.32843 10.5 6 11.1716 6 12Z\"/><path d=\"M6 18C6 18.8284 5.32843 19.5 4.5 19.5C3.67157 19.5 3 18.8284 3 18C3 17.1716 3.67157 16.5 4.5 16.5C5.32843 16.5 6 17.1716 6 18Z\"/></svg>",
	"view-live": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for view-live\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 4C2 2.89543 2.89543 2 4 2H6C6.55228 2 7 2.44772 7 3C7 3.55228 6.55228 4 6 4H4V6C4 6.55228 3.55228 7 3 7C2.44772 7 2 6.55228 2 6V4Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 2C21.1046 2 22 2.89543 22 4V6C22 6.55228 21.5523 7 21 7C20.4477 7 20 6.55228 20 6V4H18C17.4477 4 17 3.55228 17 3C17 2.44772 17.4477 2 18 2L20 2Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 20C22 21.1046 21.1046 22 20 22H18C17.4477 22 17 21.5523 17 21C17 20.4477 17.4477 20 18 20H20V18C20 17.4477 20.4477 17 21 17C21.5523 17 22 17.4477 22 18V20Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 22C2.89543 22 2 21.1046 2 20L2 18C2 17.4477 2.44772 17 3 17C3.55228 17 4 17.4477 4 18V20H6C6.55228 20 7 20.4477 7 21C7 21.5523 6.55228 22 6 22H4Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 8.5C8.33416 8.5 6.71869 10.8974 6.15909 12.0078C6.107 12.1111 6.107 12.2222 6.15909 12.3255C6.71869 13.4359 8.33416 15.8333 12 15.8333C15.6676 15.8333 17.2822 13.4355 17.8411 12.3256C17.8931 12.2223 17.8931 12.1114 17.8411 12.0081C17.2816 10.8979 15.6662 8.5 12 8.5ZM4.37309 11.1077C5.08797 9.68921 7.24141 6.5 12 6.5C16.759 6.5 18.9124 9.68981 19.6271 11.1081C19.9643 11.7772 19.9645 12.5558 19.6274 13.2251C18.913 14.6437 16.7604 17.8333 12 17.8333C7.24141 17.8333 5.08797 14.6441 4.37309 13.2257C4.03567 12.5561 4.03567 11.7772 4.37309 11.1077Z\"/><path d=\"M14.3333 12.1667C14.3333 13.4553 13.2887 14.5 12 14.5C10.7113 14.5 9.66666 13.4553 9.66666 12.1667C9.66666 10.878 10.7113 9.83333 12 9.83333C13.2887 9.83333 14.3333 10.878 14.3333 12.1667Z\"/></svg>",
	"view-small-grid": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for view-small-grid\"><path d=\"M13 18C13 18.5523 13.4477 19 14 19H18C18.5523 19 19 18.5523 19 18V14C19 13.4477 18.5523 13 18 13H14C13.4477 13 13 13.4477 13 14V18Z\"/><path d=\"M5 18C5 18.5523 5.44772 19 6 19H10C10.5523 19 11 18.5523 11 18V14C11 13.4477 10.5523 13 10 13H6C5.44772 13 5 13.4477 5 14V18Z\"/><path d=\"M13 10C13 10.5523 13.4477 11 14 11H18C18.5523 11 19 10.5523 19 10V6C19 5.44772 18.5523 5 18 5H14C13.4477 5 13 5.44772 13 6V10Z\"/><path d=\"M5 10C5 10.5523 5.44772 11 6 11H10C10.5523 11 11 10.5523 11 10V6C11 5.44772 10.5523 5 10 5H6C5.44772 5 5 5.44772 5 6V10Z\"/></svg>",
	"view-table": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for view-table\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 21L5 21C3.897 21 3 20.103 3 19L3 5C3 3.897 3.897 3 5 3L19 3C20.103 3 21 3.897 21 5L21 19C21 20.103 20.103 21 19 21ZM8 19L5 19L5 16L8 16L8 19ZM5 6L8 6L8 9L5 9L5 6ZM19 19L10 19L10 16L19.0004 16L19 19ZM10 6L19 6L19.0014 9L10 9L10 6ZM19.0011 11L19.0007 14L10 14L10 11L19.0011 11ZM5 14L5 11L8 11L8 14L5 14Z\"/></svg>",
	views: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for views\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 19.6126C3 20.2951 3.6687 20.7771 4.31623 20.5613L9 19L14.3675 20.7892C14.7781 20.926 15.2219 20.926 15.6325 20.7892L20.3162 19.2279C20.7246 19.0918 21 18.7097 21 18.2792V4.38743C21 3.70487 20.3313 3.2229 19.6838 3.43874L15 5L9.63246 3.21082C9.22192 3.07397 8.77808 3.07397 8.36755 3.21082L3.68377 4.77208C3.27543 4.90819 3 5.29033 3 5.72076V19.6126ZM9 16.8918L15 18.8918V7.10818L9 5.10818V16.8918Z\"/></svg>",
	"visibility-off": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for visibility-off\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.8818 6.998C11.628 6.998 11.3815 7.00669 11.1422 7.02338L9.37363 5.2548C10.1369 5.09094 10.9712 4.998 11.8818 4.998C18.0667 4.998 20.7292 9.28514 21.5266 10.9564C21.8427 11.619 21.8429 12.3767 21.5269 13.0394C21.2292 13.6639 20.6713 14.6533 19.7666 15.6478L18.3526 14.2337C19.0489 13.4532 19.4822 12.6807 19.7216 12.1787C19.7778 12.0607 19.7778 11.9357 19.7215 11.8176C19.0616 10.4345 16.9287 6.998 11.8818 6.998Z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.23725 13.04C3.03485 14.7115 5.69747 18.998 11.8818 18.998C13.7227 18.998 15.2514 18.6184 16.5118 18.0412L19.1466 20.6758C19.537 21.0661 20.1701 21.0659 20.5598 20.675C20.9488 20.2849 20.9484 19.6535 20.5588 19.264L16.851 15.5561L14.5884 13.2936L10.5862 9.2914L8.79012 7.49529L5.00083 3.70599C4.61088 3.31604 3.97868 3.31593 3.5886 3.70574C3.19831 4.09575 3.1982 4.72835 3.58837 5.11849L5.47639 7.0064C3.66241 8.35421 2.67234 10.0442 2.23725 10.956C1.92092 11.6189 1.92092 12.3771 2.23725 13.04ZM4.04229 11.8173C3.9859 11.9355 3.9859 12.0605 4.04229 12.1787C4.70239 13.5621 6.83531 16.998 11.8818 16.998C13.0662 16.998 14.0901 16.8089 14.9721 16.5015L13.1758 14.7054C12.784 14.8929 12.3452 14.998 11.8818 14.998C10.225 14.998 8.88181 13.6549 8.88181 11.998C8.88181 11.5347 8.98684 11.0959 9.17438 10.7042L6.91148 8.4414C5.28685 9.55034 4.42152 11.0225 4.04229 11.8173Z\"/></svg>",
	"visibility-on": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for visibility-on\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 7C6.95353 7 4.82061 10.4359 4.16051 11.8193C4.10413 11.9375 4.10413 12.0625 4.16051 12.1807C4.82061 13.5641 6.95353 17 12 17C17.0489 17 19.1805 13.5636 19.8398 12.1807C19.8961 12.0627 19.8961 11.9377 19.8397 11.8196C19.1798 10.4365 17.0469 7 12 7ZM2.35548 10.958C3.15307 9.28646 5.81569 5 12 5C18.1849 5 20.8474 9.28714 21.6448 10.9584C21.9609 11.621 21.9611 12.3787 21.6451 13.0414C20.8482 14.713 18.1868 19 12 19C5.8157 19 3.15307 14.7135 2.35548 13.042C2.03914 12.3791 2.03914 11.6209 2.35548 10.958Z\"/><path d=\"M15 12C15 13.6569 13.6569 15 12 15C10.3432 15 9.00004 13.6569 9.00004 12C9.00004 10.3431 10.3432 9 12 9C13.6569 9 15 10.3431 15 12Z\"/></svg>",
	warning: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"Icon for warning\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.1346 19.501C1.74864 20.1677 2.2297 21.0021 3.00003 21.0021H21C21.7704 21.0021 22.2514 20.1677 21.8655 19.501L12.8655 3.49689C12.4803 2.8316 11.5198 2.8316 11.1346 3.49689L2.1346 19.501ZM11 13.0021C11 13.5543 11.4477 14.0021 12 14.0021C12.5523 14.0021 13 13.5543 13 13.0021V10.0021C13 9.44978 12.5523 9.00206 12 9.00206C11.4477 9.00206 11 9.44978 11 10.0021V13.0021ZM11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17Z\"/></svg>"
}, A = {
	"100x100_balance": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 68.5L86 68.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M43.8773 78.9961L49.5681 69.2404C49.761 68.9096 50.2389 68.9096 50.4319 69.2404L56.1227 78.9961C56.5116 79.6628 56.0308 80.5 55.259 80.5H44.741C43.9692 80.5 43.4884 79.6628 43.8773 78.9961Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><circle cx=\"71.5444\" cy=\"52\" r=\"11\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><circle cx=\"71.5444\" cy=\"52\" r=\"11\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><circle cx=\"32\" cy=\"46\" r=\"16\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><circle cx=\"32\" cy=\"46\" r=\"16\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"100x100_bell": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2856)\"><path d=\"M50 69H75.6787C77.1141 69 78.4395 69.7691 79.1517 71.0154L82 76H105.5V113.5H-2V76H18L20.8483 71.0154C21.5605 69.7691 22.8859 69 24.3213 69H50Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linejoin=\"round\"/><path d=\"M54 35H46\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M50 43L50 35\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><rect x=\"46\" y=\"62.5\" width=\"8\" height=\"6.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M76.8907 60.0026C77.0112 61.1006 76.1046 62 75 62H25C23.8954 62 22.9888 61.1006 23.1093 60.0026C24.4078 48.1734 37.0704 39 50.0001 39C62.9297 39 75.5922 48.1734 76.8907 60.0026Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></g><defs><clipPath id=\"clip0_25031_2856\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_binoculars-intelligence": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1221_2536)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M61 33C66.5228 33 71 37.4772 71 43C71 48.5228 66.5228 53 61 53C57.6649 53 54.7113 51.3671 52.8945 48.8574H47.1055C45.2887 51.3671 42.3351 53 39 53C33.4772 53 29 48.5228 29 43C29 37.4772 33.4772 33 39 33C42.2716 33 45.1766 34.5711 47.001 37H52.999C54.8234 34.5711 57.7284 33 61 33ZM39 37C35.6863 37 33 39.6863 33 43C33 46.3137 35.6863 49 39 49C42.3137 49 45 46.3137 45 43C45 39.6863 42.3137 37 39 37ZM61 37C57.6863 37 55 39.6863 55 43C55 46.3137 57.6863 49 61 49C64.3137 49 67 46.3137 67 43C67 39.6863 64.3137 37 61 37Z\" fill=\"var(--prism-color-icon-intelligence-default, #A87EFF)\"/><path d=\"M35.1993 62.9674V75.0879C35.1993 75.5916 34.791 76 34.2872 76H15.9402M35.1993 62.9674L37.1561 56.839C37.1848 56.7493 37.1958 56.6551 37.2102 56.5621C37.2844 56.0845 37.7278 55.7376 38.2262 55.7818C40.4478 55.9792 42.9834 55.8774 44.9524 54.3023C47.2327 52.9341 50 46.0932 46.3206 46.0932H44M35.1993 62.9674H20.0448M20.0448 62.9674L26.1391 37.1563C27.1111 33.0394 30.7861 30.131 35.0162 30.131H64.6914C68.9215 30.131 72.5965 33.0394 73.5685 37.1563L79.6628 62.9674M20.0448 62.9674C18.6766 62.9674 16.0553 62.6017 15.0281 63.4235C12.7478 65.2477 13.8992 69.2042 14.5721 71.8955C15.0281 73.7197 15.4842 74.6318 15.9402 76M15.9402 76H-20V120H120V76H83.7674M64.5083 62.9674V75.0879C64.5083 75.5916 64.9167 76 65.4204 76H83.7674M64.5083 62.9674L62.5515 56.839C62.5229 56.7493 62.5119 56.6551 62.4974 56.5621C62.4233 56.0845 61.9798 55.7376 61.4814 55.7818C59.2598 55.9792 56.7242 55.8774 54.7553 54.3023C52.475 52.9341 50 46.0932 53.3871 46.0932H56M64.5083 62.9674H79.6628M79.6628 62.9674C81.031 62.9674 83.6523 62.6017 84.6795 63.4235C86.9598 65.2477 85.8084 69.2042 85.1355 71.8955C84.6795 73.7197 84.2234 74.6318 83.7674 76\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/></g><defs><clipPath id=\"clip0_1221_2536\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_binoculars": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2862)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M61 33C66.5228 33 71 37.4772 71 43C71 48.5228 66.5228 53 61 53C57.6649 53 54.7113 51.3671 52.8945 48.8574H47.1055C45.2887 51.3671 42.3351 53 39 53C33.4772 53 29 48.5228 29 43C29 37.4772 33.4772 33 39 33C42.2716 33 45.1766 34.5711 47.001 37H52.999C54.8234 34.5711 57.7284 33 61 33ZM39 37C35.6863 37 33 39.6863 33 43C33 46.3137 35.6863 49 39 49C42.3137 49 45 46.3137 45 43C45 39.6863 42.3137 37 39 37ZM61 37C57.6863 37 55 39.6863 55 43C55 46.3137 57.6863 49 61 49C64.3137 49 67 46.3137 67 43C67 39.6863 64.3137 37 61 37Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M35.1993 62.9674V75.0879C35.1993 75.5916 34.791 76 34.2872 76H15.9402M35.1993 62.9674L37.1561 56.839C37.1848 56.7493 37.1958 56.6551 37.2102 56.5621C37.2844 56.0845 37.7278 55.7376 38.2262 55.7818C40.4478 55.9792 42.9834 55.8774 44.9524 54.3023C47.2327 52.9341 50 46.0932 46.3206 46.0932H44M35.1993 62.9674H20.0448M20.0448 62.9674L26.1391 37.1563C27.1111 33.0394 30.7861 30.131 35.0162 30.131H64.6914C68.9215 30.131 72.5965 33.0394 73.5685 37.1563L79.6628 62.9674M20.0448 62.9674C18.6766 62.9674 16.0553 62.6017 15.0281 63.4235C12.7478 65.2477 13.8992 69.2042 14.5721 71.8955C15.0281 73.7197 15.4842 74.6318 15.9402 76M15.9402 76H-20V120H120V76H83.7674M64.5083 62.9674V75.0879C64.5083 75.5916 64.9167 76 65.4204 76H83.7674M64.5083 62.9674L62.5515 56.839C62.5229 56.7493 62.5119 56.6551 62.4974 56.5621C62.4233 56.0845 61.9798 55.7376 61.4814 55.7818C59.2598 55.9792 56.7242 55.8774 54.7553 54.3023C52.475 52.9341 50 46.0932 53.3871 46.0932H56M64.5083 62.9674H79.6628M79.6628 62.9674C81.031 62.9674 83.6523 62.6017 84.6795 63.4235C86.9598 65.2477 85.8084 69.2042 85.1355 71.8955C84.6795 73.7197 84.2234 74.6318 83.7674 76\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></g><defs><clipPath id=\"clip0_25031_2862\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_chart-table": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_26725_5885)\"><path d=\"M37.1232 61.423L39.8925 65.637C40.6186 66.7418 42.4259 66.6586 43.0228 65.4929L46.3849 58.9258C46.9433 57.8352 48.5926 57.6725 49.4006 58.6284L53 62.8867V71.5H30V67L34.1213 61.3589C34.8401 60.375 36.4571 60.4096 37.1232 61.423Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M60 76H59.5V76.5H60V76ZM120 76H120.5V75.5H120V76ZM23 76V76.5H23.5V76H23ZM-20 76V75.5H-20.5V76H-20ZM120 118V118.5H120.5V118H120ZM-20 118H-20.5V118.5H-20V118ZM30 71.5H29.5V72H30V71.5ZM53 72C53.2761 72 53.5 71.7761 53.5 71.5C53.5 71.2239 53.2761 71 53 71V72ZM30.5 57C30.5 56.7239 30.2761 56.5 30 56.5C29.7239 56.5 29.5 56.7239 29.5 57H30.5ZM60 76V76.5H120V76V75.5H60V76ZM23 76V75.5H-20V76V76.5H23V76ZM58 50V50.5C58.8284 50.5 59.5 51.1716 59.5 52H60H60.5C60.5 50.6193 59.3807 49.5 58 49.5V50ZM25 50V49.5C23.6193 49.5 22.5 50.6193 22.5 52H23H23.5C23.5 51.1716 24.1716 50.5 25 50.5V50ZM40 50V50.5H58V50V49.5H40V50ZM75 26V26.5C75.8284 26.5 76.5 27.1716 76.5 28H77H77.5C77.5 26.6193 76.3807 25.5 75 25.5V26ZM42 26V25.5C40.6193 25.5 39.5 26.6193 39.5 28H40H40.5C40.5 27.1716 41.1716 26.5 42 26.5V26ZM40 28H39.5V50H40H40.5V28H40ZM66 42V42.5H73V42V41.5H66V42ZM44 34V34.5H51V34V33.5H44V34ZM66 50V50.5H73V50V49.5H66V50ZM55 42V42.5H62V42V41.5H55V42ZM44 42V42.5H51V42V41.5H44V42ZM76 58V57.5H66V58V58.5H76V58ZM77 57H76.5C76.5 57.2761 76.2761 57.5 76 57.5V58V58.5C76.8284 58.5 77.5 57.8284 77.5 57H77ZM23 52H22.5V76H23H23.5V52H23ZM25 50V50.5H40V50V49.5H25V50ZM77 28H76.5V57H77H77.5V28H77ZM42 26V26.5H75V26V25.5H42V26ZM55 34V34.5H62V34V33.5H55V34ZM66 34V34.5H73V34V33.5H66V34ZM120 76H119.5V118H120H120.5V76H120ZM120 118V117.5H-20V118V118.5H120V118ZM-20 118H-19.5V76H-20H-20.5V118H-20ZM60 52H59.5V58H60H60.5V52H60ZM60 58H59.5V76H60H60.5V58H60ZM66 58V57.5H60V58V58.5H66V58ZM30 71.5V72H53V71.5V71H30V71.5ZM30 57H29.5V71.5H30H30.5V57H30Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></g><defs><clipPath id=\"clip0_26725_5885\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_chart": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2878)\"><path d=\"M63.2162 38.1099C61.4017 41.5225 62.6972 45.7599 66.1098 47.5744C69.5224 49.389 73.7599 48.0935 75.5744 44.6808C77.3889 41.2682 76.0934 37.0308 72.6808 35.2162C69.2681 33.4017 65.0307 34.6972 63.2162 38.1099Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M-2 82L16.6354 46.8999C19.8857 40.7779 27.1974 40.9929 30.2091 47.2989L42.7313 73.519C46.0146 80.3937 54.1869 79.8761 56.8856 72.6224L72.0883 31.7605C74.613 24.9745 82.0709 23.9624 85.7244 29.91L102 56.4059\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></g><defs><clipPath id=\"clip0_25031_2878\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_comment": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2870)\"><path d=\"M78.7598 32.1887C79.7601 35.9221 77.5446 39.7595 73.8113 40.7598C70.0779 41.7601 66.2405 39.5446 65.2402 35.8113C64.2399 32.0779 66.4554 28.2405 70.1887 27.2402C73.9221 26.2399 77.7595 28.4554 78.7598 32.1887Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M32 76H-16C-18.2091 76 -20 77.7909 -20 80V116C-20 118.209 -18.2091 120 -16 120H116C118.209 120 120 118.209 120 116V80C120 77.7909 118.209 76 116 76H40.0671C39.231 76 38.7641 75.0349 39.2831 74.3793L46.2989 65.5172C47.0576 64.5589 48.2128 64 49.4351 64H66C70.4183 64 74 60.4183 74 56V40C74 35.5817 70.4183 32 66 32H34C29.5817 32 26 35.5817 26 40V56C26 60.4183 29.5817 64 34 64H36V72C36 74.2091 34.2091 76 32 76Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M36 43H60\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M36 51H64\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></g><defs><clipPath id=\"clip0_25031_2870\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_compset": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M45 15L41 22H33L29 15L33 8L41 8L45 15Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M69 15L65 22H57L53 15L57 8L65 8L69 15Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M57 22L53 29H45L41 22L45 15L53 15L57 22Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M76 78L72 85H64L60 78L64 71H72L76 78Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M64 85L60 92H52L48 85L52 78H60L64 85Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M78 64C78 65.1046 77.1046 66 76 66L63.5352 66C63.2008 66 62.8886 66.1671 62.7031 66.4453L59.8321 70.7519C59.4362 71.3457 58.5638 71.3457 58.1679 70.7519L55.2969 66.4453C55.1114 66.1671 54.7992 66 54.4648 66L48 66C46.8954 66 46 65.1046 46 64L46 54C46 52.8954 46.8954 52 48 52L76 52C77.1046 52 78 52.8954 78 54L78 64Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M50 57H64\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M50 61H74\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M29.168 20.2454C29.5638 19.6516 30.4362 19.6516 30.832 20.2454L33.7031 24.552C33.8886 24.8302 34.2008 24.9973 34.5352 24.9973H86C87.1046 24.9973 88 25.8927 88 26.9973V44.9973C88 46.1019 87.1046 46.9973 86 46.9973H14C12.8954 46.9973 12 46.1019 12 44.9973V26.9973C12 25.8927 12.8954 24.9973 14 24.9973H25.4648C25.7992 24.9973 26.1114 24.8302 26.2969 24.552L29.168 20.2454ZM76.9961 31.137C76.6229 30.2845 75.3795 30.2838 75.0049 31.135L74.0205 33.3567L71.498 33.5627L71.3301 33.5891C70.5189 33.7768 70.1679 34.8313 70.8838 35.426L70.8828 35.427L72.7871 37.009L72.2188 39.3518C71.9854 40.3144 73.049 40.9591 73.8262 40.5081L73.8252 40.5071L75.999 39.2512L78.1738 40.5129L78.3223 40.5852C79.0282 40.8631 79.8782 40.3393 79.8105 39.5344L79.7812 39.3577L79.2119 37.0149L81.1172 35.4329L81.1162 35.4319C81.8794 34.798 81.4303 33.6406 80.5039 33.5686H80.5049L77.9795 33.3625L76.9951 31.137H76.9961ZM24.5371 31.3381C24.3384 30.8842 23.6616 30.8842 23.4629 31.3381L22.3584 33.8313L19.5361 34.0618C19.0219 34.101 18.8116 34.7172 19.2031 35.0422L21.3477 36.8245L20.7041 39.47C20.5874 39.9519 21.1312 40.3332 21.5752 40.0754L24 38.6741L26.4248 40.0803C26.8688 40.3381 27.4124 39.9576 27.2959 39.4758L26.6523 36.8303L28.7969 35.0481C29.1884 34.723 28.9781 34.1059 28.4639 34.0667L25.6416 33.8372L24.5371 31.3381ZM37.5371 31.3381C37.3384 30.8842 36.6616 30.8842 36.4629 31.3381L35.3584 33.8313L32.5361 34.0618C32.0219 34.101 31.8116 34.7172 32.2031 35.0422L34.3477 36.8245L33.7041 39.47C33.5874 39.9519 34.1312 40.3332 34.5752 40.0754L37 38.6741L39.4248 40.0803C39.8688 40.3381 40.4124 39.9576 40.2959 39.4758L39.6523 36.8303L41.7969 35.0481C42.1884 34.723 41.9781 34.1059 41.4639 34.0667L38.6416 33.8372L37.5371 31.3381ZM50.5371 31.3381C50.3384 30.8842 49.6616 30.8842 49.4629 31.3381L48.3584 33.8313L45.5361 34.0618C45.0219 34.101 44.8116 34.7172 45.2031 35.0422L47.3477 36.8245L46.7041 39.47C46.5874 39.9519 47.1312 40.3332 47.5752 40.0754L50 38.6741L52.4248 40.0803C52.8688 40.3381 53.4124 39.9576 53.2959 39.4758L52.6523 36.8303L54.7969 35.0481C55.1884 34.723 54.9781 34.1059 54.4639 34.0667L51.6416 33.8372L50.5371 31.3381ZM63.5371 31.3381C63.3384 30.8842 62.6616 30.8842 62.4629 31.3381L61.3584 33.8313L58.5361 34.0618C58.0219 34.101 57.8116 34.7172 58.2031 35.0422L60.3477 36.8245L59.7041 39.47C59.5874 39.9519 60.1312 40.3332 60.5752 40.0754L63 38.6741L65.4248 40.0803C65.8688 40.3381 66.4124 39.9576 66.2959 39.4758L65.6523 36.8303L67.7969 35.0481C68.1884 34.723 67.9781 34.1059 67.4639 34.0667L64.6416 33.8372L63.5371 31.3381ZM76 31.4973C76.0247 31.4973 76.0446 31.5037 76.0566 31.511C76.0661 31.5167 76.0729 31.5242 76.0791 31.5383L76.0801 31.5403L77.1846 34.0393L77.3047 34.3118L77.6016 34.3362L80.4238 34.5657H80.4258C80.4546 34.5679 80.4692 34.5765 80.4766 34.5823C80.4856 34.5895 80.4931 34.6 80.4971 34.6116C80.5008 34.6228 80.5002 34.6313 80.499 34.636L80.4775 34.6633L78.333 36.4456L78.0938 36.6448L78.167 36.9485L78.8096 39.594C78.8131 39.6091 78.8108 39.6146 78.8096 39.6174C78.8071 39.6233 78.7998 39.6349 78.7842 39.6458C78.7686 39.6565 78.7505 39.6623 78.7334 39.6633C78.7259 39.6638 78.7176 39.6636 78.708 39.6614L78.6758 39.6487L76.251 38.2415L76.001 38.0959L75.75 38.2415L73.3252 39.6418L73.3242 39.6428C73.3003 39.6567 73.2814 39.6594 73.2666 39.6584C73.2495 39.6574 73.2314 39.6507 73.2158 39.6399C73.2002 39.629 73.1929 39.6174 73.1904 39.6116C73.1892 39.6087 73.1869 39.6031 73.1904 39.5881L73.833 36.9426L73.9062 36.6399L73.667 36.4397L71.5225 34.6575L71.501 34.6311C71.4998 34.6265 71.499 34.6172 71.5029 34.6057C71.5069 34.5942 71.5144 34.5836 71.5234 34.5764C71.5308 34.5706 71.5455 34.562 71.5742 34.5598H71.5762L74.3984 34.3303L74.6953 34.3059L74.8154 34.0344L75.9199 31.5403L75.9209 31.5383C75.9271 31.5242 75.9339 31.5167 75.9434 31.511C75.9554 31.5037 75.9753 31.4973 76 31.4973Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><circle cx=\"4\" cy=\"4\" r=\"4\" transform=\"matrix(1 0 0 -1 26 18)\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M63 77C63 79.2091 61.2091 81 59 81C56.7909 81 55 79.2091 55 77C55 74.7909 56.7909 73 59 73C61.2091 73 63 74.7909 63 77Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"100x100_critical": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24.5355 69.9619C22.5829 68.0093 22.5829 64.8435 24.5355 62.8909L59.8909 27.5355C61.8435 25.5829 65.0093 25.5829 66.9619 27.5355C68.9146 29.4881 68.9146 32.654 66.9619 34.6066L31.6066 69.9619C29.654 71.9145 26.4882 71.9145 24.5355 69.9619Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M55.9376 60.9376C56.7243 60.151 57.9996 60.151 58.7863 60.9376L66.3368 68.4882C67.1234 69.2748 67.1234 70.5502 66.3368 71.3368C65.5502 72.1234 64.2748 72.1234 63.4882 71.3368L55.9376 63.7862C55.151 62.9996 55.151 61.7242 55.9376 60.9376Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M38.7824 55.8535L30.1403 64.4956C28.5782 66.0577 28.5782 68.5904 30.1403 70.1525V70.1525C31.7024 71.7146 34.235 71.7146 35.7971 70.1525L53.4748 52.4748M30.4938 29.4939L46.4037 45.4038C47.1848 46.1848 48.4511 46.1848 49.2321 45.4038L65.4956 29.1403C67.0577 27.5782 69.5904 27.5782 71.1525 29.1403V29.1403C72.7145 30.7024 72.7145 33.2351 71.1525 34.7972L53.4748 52.4748M53.4748 52.4748L71.1525 70.1525\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></svg>",
	"100x100_data-trend": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2884)\"><circle cx=\"84\" cy=\"22\" r=\"10\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M19 76V65C19 62.7908 20.7908 61 23 61H36V51.5C36 49.2908 37.7908 47.5 40 47.5H53V40C53 37.7908 54.7908 36 57 36L67.3431 36C68.404 36 69.4214 35.5786 70.1715 34.8284L81 24M19 76L-20 76V120H120V76L81 76V43.5L63 43.5V55L45 55V68L27 68V81C27 83.2091 25.2091 85 23 85C20.7908 85 19 83.2091 19 81V76ZM81 24L69 24M81 24V36\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></g><defs><clipPath id=\"clip0_25031_2884\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_demand-map": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2927)\"><path d=\"M-8 18V18.5H48V18V17.5H-8V18ZM52 22H51.5V78H52H52.5V22H52ZM48 82V81.5H-8V82V82.5H48V82ZM-12 78H-11.5V22H-12H-12.5V78H-12ZM-8 82V81.5C-9.933 81.5 -11.5 79.933 -11.5 78H-12H-12.5C-12.5 80.4853 -10.4853 82.5 -8 82.5V82ZM52 78H51.5C51.5 79.933 49.933 81.5 48 81.5V82V82.5C50.4853 82.5 52.5 80.4853 52.5 78H52ZM48 18V18.5C49.933 18.5 51.5 20.067 51.5 22H52H52.5C52.5 19.5147 50.4853 17.5 48 17.5V18ZM-8 18V17.5C-10.4853 17.5 -12.5 19.5147 -12.5 22H-12H-11.5C-11.5 20.067 -9.933 18.5 -8 18.5V18Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M5 25H25\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><rect x=\"2.5\" y=\"32.5\" width=\"7\" height=\"7\" rx=\"1.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"14.5\" y=\"32.5\" width=\"7\" height=\"7\" rx=\"1.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"26.5\" y=\"32.5\" width=\"7\" height=\"7\" rx=\"1.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"38\" y=\"32\" width=\"8\" height=\"8\" rx=\"2\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"14\" y=\"44\" width=\"8\" height=\"8\" rx=\"2\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"2.5\" y=\"44.5\" width=\"7\" height=\"7\" rx=\"1.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"26.5\" y=\"44.5\" width=\"7\" height=\"7\" rx=\"1.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"38.5\" y=\"44.5\" width=\"7\" height=\"7\" rx=\"1.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"14\" y=\"56\" width=\"8\" height=\"8\" rx=\"2\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"38\" y=\"56\" width=\"8\" height=\"8\" rx=\"2\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"2.5\" y=\"68.5\" width=\"7\" height=\"7\" rx=\"1.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"14.5\" y=\"68.5\" width=\"7\" height=\"7\" rx=\"1.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M72 32.1818C72 30.9768 72.9768 30 74.1818 30H81.8182C83.0232 30 84 30.9768 84 32.1818V39.8182C84 41.0232 83.0232 42 81.8182 42H74.1818C72.9768 42 72 41.0232 72 39.8182V32.1818Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M47.5 36L70 36\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-dasharray=\"3 3\"/><path d=\"M47.5 60L70 60\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-dasharray=\"3 3\"/><path d=\"M36 72H70\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-dasharray=\"3 3\"/><mask id=\"mask0_25031_2927\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"74\" y=\"56\" width=\"8\" height=\"8\"><path d=\"M74 57.7778C74 56.7959 74.7959 56 75.7778 56H80.2222C81.2041 56 82 56.7959 82 57.7778V62.2222C82 63.2041 81.2041 64 80.2222 64H75.7778C74.7959 64 74 63.2041 74 62.2222V57.7778Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></mask><g mask=\"url(#mask0_25031_2927)\"><path d=\"M81.3535 56.3535L74.3535 63.3535M80.3535 54.3535L73.3535 61.3535M83.3535 57.3535L76.3535 64.3535\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M75.7773 56.5H80.2227C80.928 56.5002 81.4998 57.072 81.5 57.7773V62.2227C81.4998 62.928 80.928 63.4998 80.2227 63.5H75.7773C75.072 63.4998 74.5002 62.928 74.5 62.2227V57.7773C74.5002 57.072 75.072 56.5002 75.7773 56.5Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></g><mask id=\"mask1_25031_2927\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"74\" y=\"68\" width=\"8\" height=\"8\"><path d=\"M74 69.7778C74 68.7959 74.7959 68 75.7778 68H80.2222C81.2041 68 82 68.7959 82 69.7778V74.2222C82 75.2041 81.2041 76 80.2222 76H75.7778C74.7959 76 74 75.2041 74 74.2222V69.7778Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></mask><g mask=\"url(#mask1_25031_2927)\"><path d=\"M81 69L74 76M80 67L73 74M83 70L76 77\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-dasharray=\"1 2\"/><path d=\"M75.7773 68.5H80.2227C80.928 68.5002 81.4998 69.072 81.5 69.7773V74.2227C81.4998 74.928 80.928 75.4998 80.2227 75.5H75.7773C75.072 75.4998 74.5002 74.928 74.5 74.2227V69.7773C74.5002 69.072 75.072 68.5002 75.7773 68.5Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></g><mask id=\"mask2_25031_2927\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"26\" y=\"68\" width=\"8\" height=\"8\"><path d=\"M26 69.7778C26 68.7959 26.7959 68 27.7778 68H32.2222C33.2041 68 34 68.7959 34 69.7778V74.2222C34 75.2041 33.2041 76 32.2222 76H27.7778C26.7959 76 26 75.2041 26 74.2222V69.7778Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></mask><g mask=\"url(#mask2_25031_2927)\"><path d=\"M33 69L26 76M32 67L25 74M35 70L28 77\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-dasharray=\"1 2\"/><path d=\"M27.7773 68.5H32.2227C32.928 68.5002 33.4998 69.072 33.5 69.7773V74.2227C33.4998 74.928 32.928 75.4998 32.2227 75.5H27.7773C27.072 75.4998 26.5002 74.928 26.5 74.2227V69.7773C26.5002 69.072 27.072 68.5002 27.7773 68.5Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></g><mask id=\"mask3_25031_2927\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"26\" y=\"56\" width=\"8\" height=\"8\"><path d=\"M26 57.7778C26 56.7959 26.7959 56 27.7778 56H32.2222C33.2041 56 34 56.7959 34 57.7778V62.2222C34 63.2041 33.2041 64 32.2222 64H27.7778C26.7959 64 26 63.2041 26 62.2222V57.7778Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></mask><g mask=\"url(#mask3_25031_2927)\"><path d=\"M33.3535 56.3535L26.3535 63.3535M32.3535 54.3535L25.3535 61.3535M35.3535 57.3535L28.3535 64.3535\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M27.7773 56.5H32.2227C32.928 56.5002 33.4998 57.072 33.5 57.7773V62.2227C33.4998 62.928 32.928 63.4998 32.2227 63.5H27.7773C27.072 63.4998 26.5002 62.928 26.5 62.2227V57.7773C26.5002 57.072 27.072 56.5002 27.7773 56.5Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></g><mask id=\"mask4_25031_2927\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"2\" y=\"56\" width=\"8\" height=\"8\"><path d=\"M2 57.7778C2 56.7959 2.79594 56 3.77778 56H8.22222C9.20406 56 10 56.7959 10 57.7778V62.2222C10 63.2041 9.20406 64 8.22222 64H3.77778C2.79594 64 2 63.2041 2 62.2222V57.7778Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></mask><g mask=\"url(#mask4_25031_2927)\"><path d=\"M9.35352 56.3535L2.35352 63.3535M8.35352 54.3535L1.35352 61.3535M11.3535 57.3535L4.35352 64.3535\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M3.77734 56.5H8.22266C8.92801 56.5002 9.49977 57.072 9.5 57.7773V62.2227C9.49977 62.928 8.92801 63.4998 8.22266 63.5H3.77734C3.07199 63.4998 2.50023 62.928 2.5 62.2227V57.7773C2.50023 57.072 3.07199 56.5002 3.77734 56.5Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></g></g><defs><clipPath id=\"clip0_25031_2927\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_disconnected": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2875)\"><path d=\"M29.8787 54.1213L24.6943 58.8321C22.0264 60.9911 21.7098 64.9439 24 67.5L25.418 69.3308C27.7261 71.9069 25.8978 76 22.4389 76H-20V121H120V76L74.0198 76C68.7871 76 66.0619 69.7693 69.6141 65.927L77.6412 57.2442C81.2169 53.3765 79.4008 47.0941 74.313 45.7308L69.8221 44.5275M40.8389 48.1109L45.0815 43.8683M35.3588 42.6308L39.6014 38.3882\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M32.7072 39.9792L29.8788 42.8076C26.7546 45.9318 26.7546 50.9971 29.8788 54.1213C33.003 57.2455 38.0683 57.2455 41.1925 54.1213L44.0209 51.2929L40.8389 48.1109L35.3589 42.6308L32.7072 39.9792Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M60.3017 33.6943L64.1654 34.7295C68.4331 35.8731 70.9657 40.2598 69.8222 44.5275C68.6787 48.7952 64.292 51.3279 60.0243 50.1844L56.1606 49.1491L60.3017 33.6943Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></g><defs><clipPath id=\"clip0_25031_2875\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_empty": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M80.5 47.0675L66 53.5C66 53.5 63.8054 50.3168 63 49.75C60.4875 47.9485 48.3869 41.3752 43.2082 36.8611L50.1355 34L80.5 47.0675Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M28.1501 43.0812C28.919 43.7464 28.9097 44.7185 29 45.75L29.5612 51L19.1134 47.2856C18.8976 47.2088 18.89 46.9064 19.1017 46.8189L28.1501 43.0812Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M17.2819 48L13.2276 54.213C12.7496 54.9455 13.0555 55.9432 13.8565 56.2641L19.0288 58.3364M82.71 48L86.7707 54.2228C87.2467 54.9522 86.9523 55.9429 86.1581 56.2711C84.6047 56.9131 82.8379 57.652 80.9631 58.4416M19.0288 58.3364L43.0115 67.9448C43.6256 68.1908 44.3232 67.945 44.6597 67.3642L48.4264 60.8624C49.1251 59.6564 50.9306 60.164 50.9306 61.5664V83.8621L50.9964 61.6126C50.999 60.2053 52.8157 59.7051 53.5066 60.9216L57.1419 67.3223C57.4826 67.9221 58.194 68.1741 58.8182 67.9047C62.1641 66.4606 72.6303 61.9509 80.9631 58.4416M19.0288 58.3364V76.0527L50.6153 88C61.1441 84.0176 80.9631 76.0527 80.9631 76.0527V58.4416M19 47L43.0082 57M58.8316 56.9583C62.1811 55.4553 72.6584 50.7619 81 47.1095\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M66 54C65.2386 52.6396 63.6724 50.761 62.6804 50.0673C59.3954 47.7264 40.4855 37.2765 40.4856 33.7808V19.6913C40.4854 19.0649 39.7273 18.7615 39.304 19.2226L34.0879 24.8608C33.7005 25.2795 33.158 25.5171 32.5901 25.5171H27.8955C27.3276 25.5171 26.7852 25.2795 26.3978 24.8608L21.1817 19.2226C20.7583 18.7615 20.0002 19.0649 20 19.6913V33.7808C20.0001 37.9195 22.7974 41.4101 26.5861 42.431C27.8483 42.7711 28.9537 43.74 29.0528 45.0435L29.56 51.7128\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M56 23.1538C56 17.546 60.4772 13 66 13C71.5228 13 76 17.546 76 23.1538C76 27.3599 73.4814 30.9686 69.892 32.5099C67.8621 33.3816 66 35.0986 66 37.3077V46\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></svg>",
	"100x100_exit": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2887)\"><path d=\"M43 34L66.6286 24.5486C67.2855 24.2858 68 24.7696 68 25.477V76L43 86V34Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M33.9945 24C32.89 24 32 24.8954 32 26V76H-20V120H120V76H68V26C68 24.8954 67.1119 24 66.0073 24C59.8047 24 40.848 24 33.9945 24Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linejoin=\"round\"/><path d=\"M49.25 56.5L53 55\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g><defs><clipPath id=\"clip0_25031_2887\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_flowchart": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M42 66C42 64.8954 42.8954 64 44 64H56C57.1046 64 58 64.8954 58 66V78C58 79.1046 57.1046 80 56 80H44C42.8954 80 42 79.1046 42 78V66Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M13 66C13 64.8954 13.8954 64 15 64H27C28.1046 64 29 64.8954 29 66V78C29 79.1046 28.1046 80 27 80H15C13.8954 80 13 79.1046 13 78V66Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M70 66C70 64.8954 70.8954 64 72 64H84C85.1046 64 86 64.8954 86 66V78C86 79.1046 85.1046 80 84 80H72C70.8954 80 70 79.1046 70 78V66Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M20 21.4004C20 20.2958 20.8954 19.4004 22 19.4004H78C79.1046 19.4004 80 20.2958 80 21.4004V37.4004C80 38.505 79.1046 39.4004 78 39.4004H22C20.8954 39.4004 20 38.505 20 37.4004V21.4004Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M50 39.4004L50 50.6504M50 64.4004L50 50.6504M50 50.6504L23 50.6504C21.8954 50.6504 21 51.5458 21 52.6504L21 64.4004M50 50.6504L77 50.6504C78.1046 50.6504 79 51.5458 79 52.6504L79 64.4004\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/></svg>",
	"100x100_heatmap": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M52 47L48 54H40L36 47L40 40H48L52 47Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M64 54L60 61H52L48 54L52 47H60L64 54Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M52 61L48 68H40L36 61L40 54H48L52 61Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28 47L24 54H16L12 47L16 40H24L28 47Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28 61L24 68H16L12 61L16 54H24L28 61Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40 68L36 75H28L24 68L28 61H36L40 68Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M88 54L84 61H76L72 54L76 47H84L88 54Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M76 47L72 54H64L60 47L64 40H72L76 47Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M64 40L60 47H52L48 40L52 33H60L64 40Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40 40L36 47H28L24 40L28 33H36L40 40Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M52 33L48 40H40L36 33L40 26L48 26L52 33Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M41 56L35.25 66H23.75L18 56L23.75 46H35.25L41 56Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M27.0329 26.1568C26.8867 26.3053 26.687 26.3889 26.4786 26.3889C26.2703 26.3889 26.0706 26.3053 25.9244 26.1568L24.0855 24.2891L20.332 28.1012C20.0306 28.4073 19.5382 28.4111 19.2321 28.1098C18.926 27.8084 18.9222 27.3159 19.2236 27.0099L23.5313 22.6349C23.6774 22.4864 23.8771 22.4028 24.0855 22.4028C24.2938 22.4028 24.4935 22.4864 24.6397 22.6349L26.4786 24.5025L30.3649 20.5556H27.5556C27.126 20.5556 26.7778 20.2073 26.7778 19.7778C26.7778 19.3482 27.126 19 27.5556 19H32.2222C32.6518 19 33 19.3482 33 19.7778V24.4444C33 24.874 32.6518 25.2222 32.2222 25.2222C31.7927 25.2222 31.4444 24.874 31.4444 24.4444V21.6763L27.0329 26.1568Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M64.9803 72.3974C66.3719 70.4447 66.1918 67.7163 64.44 65.9645C62.4873 64.0118 59.3215 64.0118 57.3689 65.9645C55.4163 67.9171 55.4163 71.0829 57.3689 73.0355C59.1207 74.7874 61.8491 74.9675 63.8018 73.5759L67.9755 77.7496C68.3009 78.075 68.8286 78.075 69.154 77.7496C69.4794 77.4241 69.4794 76.8965 69.154 76.5711L64.9803 72.3974ZM63.2614 67.143C64.5632 68.4447 64.5632 70.5553 63.2614 71.857C61.9597 73.1588 59.8491 73.1588 58.5474 71.857C57.2456 70.5553 57.2456 68.4447 58.5474 67.143C59.8491 65.8412 61.9597 65.8412 63.2614 67.143Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M65.2624 20.1627L65.3251 20.122C65.5706 19.9626 65.8818 19.9436 66.1448 20.0721L73.1431 23.4909L76.5676 21.2669C77.1466 20.8909 77.9208 21.0555 78.2968 21.6345C78.6728 22.2135 78.5082 22.9876 77.9292 23.3636L74.5047 25.5876L74.7814 33.3713C74.7918 33.6639 74.648 33.9404 74.4025 34.0998L74.3397 34.1406C73.8716 34.4446 73.2427 34.2114 73.086 33.6756L71.3247 27.6527L68.0574 29.7745L67.9097 31.957C67.892 32.2187 67.7522 32.4568 67.5322 32.5996L67.379 32.6991C66.9243 32.9944 66.3132 32.7838 66.137 32.271L65.3673 30.031L63.634 28.4167C63.2372 28.0472 63.2934 27.4033 63.748 27.108L63.9012 27.0085C64.1212 26.8656 64.3956 26.8347 64.6419 26.925L66.6958 27.6778L69.9631 25.556L65.1773 21.4972C64.7515 21.1361 64.7942 20.4668 65.2624 20.1627Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"100x100_hotel": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2891)\"><path d=\"M32 62C32 66.4183 28.4183 70 24 70C19.5817 70 16 66.4183 16 62C16 57.5817 19.5817 54 24 54C28.4183 54 32 57.5817 32 62Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M87 52C87 58.0751 82.0751 63 76 63C69.9249 63 65 58.0751 65 52C65 45.9249 69.9249 41 76 41C82.0751 41 87 45.9249 87 52Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M32 37V28.9982C32 26.789 33.7909 25 36 25H52C54.2091 25 56 26.7909 56 29V51C56 53.2091 57.7909 55 60 55H72C74.2091 55 76 56.7909 76 59V72C76 74.2091 77.7909 76 80 76H120V121H-20V76H20C22.2091 76 24 74.2091 24 72V41C24 38.7909 25.7909 37 28 37H32ZM32 37H36M50 77V59C50 56.7909 51.7909 55 54 55H69.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M48 33L48 37\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M40 44L40 48\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M65 70L65 76\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M32 44L32 48\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g><defs><clipPath id=\"clip0_25031_2891\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_info": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2898)\"><circle cx=\"50\" cy=\"42\" r=\"15\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M42.5 66H57.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M-20 120V76H38C40.2091 76 42 74.2091 42 72V62.9533C42 61.3634 41.0379 59.9552 39.6769 59.1334C33.8775 55.6317 30 49.2686 30 42C30 30.9543 38.9543 22 50 22C61.0457 22 70 30.9543 70 42C70 49.2686 66.1225 55.6317 60.3231 59.1334C58.9621 59.9552 58 61.3634 58 62.9533V72C58 74.2091 59.7909 76 62 76H120V120H-20Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M48 47.0299H55.9851C58.2025 47.0299 60 45.2248 60 43.0074V43.0074C60 40.7983 58.2091 39 56 39V39C53.7909 39 52 40.7909 52 43V66M48 47.0299V43.0075C48 40.8012 46.2137 39.0116 44.0075 39.0075V39.0075C41.7954 39.0033 40 40.801 40 43.0131V43.0131C40 45.2284 41.7959 47.0299 44.0112 47.0299H48ZM48 47.0299V66\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></g><defs><clipPath id=\"clip0_25031_2898\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_leadtime": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2986)\"><path d=\"M4 8C4 5.79086 5.79086 4 8 4H18H26H54C56.2091 4 58 5.79086 58 8V42C58 44.2091 56.2091 46 54 46H8C5.79086 46 4 44.2091 4 42V8Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"10.5\" y=\"36.5\" width=\"41\" height=\"5\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M11 39C11 37.8954 11.8954 37 13 37H33V41H13C11.8954 41 11 40.1046 11 39Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"10.5\" y=\"26.5\" width=\"41\" height=\"5\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M11 29C11 27.8954 11.8954 27 13 27H41V31H13C11.8954 31 11 30.1046 11 29Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"10.5\" y=\"16.5\" width=\"41\" height=\"5\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M11 19C11 17.8954 11.8954 17 13 17H23V21H13C11.8954 21 11 20.1046 11 19Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M10 11H24\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M36 58C36 55.7909 37.7909 54 40 54H50H58H86C88.2091 54 90 55.7909 90 58V92C90 94.2091 88.2091 96 86 96H40C37.7909 96 36 94.2091 36 92V58Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"42.5\" y=\"86.5\" width=\"41\" height=\"5\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M43 89C43 87.8954 43.8954 87 45 87H66V91H45C43.8954 91 43 90.1046 43 89Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"42.5\" y=\"76.5\" width=\"41\" height=\"5\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M43 79C43 77.8954 43.8954 77 45 77H58V81H45C43.8954 81 43 80.1046 43 79Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"42.5\" y=\"66.5\" width=\"41\" height=\"5\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M43 69C43 67.8954 43.8954 67 45 67H73V71H45C43.8954 71 43 70.1046 43 69Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M42 61H56\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M66 8C66 5.79086 67.7909 4 70 4H80H88H116C118.209 4 120 5.79086 120 8V42C120 44.2091 118.209 46 116 46H70C67.7909 46 66 44.2091 66 42V8Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M-26 58C-26 55.7909 -24.2091 54 -22 54H-12H-4H24C26.2091 54 28 55.7909 28 58V92C28 94.2091 26.2091 96 24 96H-22C-24.2091 96 -26 94.2091 -26 92V58Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></g><defs><clipPath id=\"clip0_25031_2986\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_length-of-stay": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24 32H24.5V31.488L23.9882 31.5001L24 32ZM24 66H23.5H24ZM28 70V70.5V70ZM74 70H74.5V69.5H74V70ZM70 74V74.5V74ZM24 74V74.5V74ZM20 70H19.5H20ZM23.7939 32.0049L23.7821 31.5048L23.7686 31.5055L23.7939 32.0049ZM24 32H23.5V66H24H24.5V32H24ZM24 66H23.5C23.5 68.4853 25.5147 70.5 28 70.5V70V69.5C26.067 69.5 24.5 67.933 24.5 66H24ZM28 70V70.5H74V70V69.5H28V70ZM74 70H73.5C73.5 71.933 71.933 73.5 70 73.5V74V74.5C72.4853 74.5 74.5 72.4853 74.5 70H74ZM70 74V73.5H24V74V74.5H70V74ZM24 74V73.5C22.067 73.5 20.5 71.933 20.5 70H20H19.5C19.5 72.4853 21.5147 74.5 24 74.5V74ZM20 70H20.5V36H20H19.5V70H20ZM20 36H20.5C20.5 34.1276 21.9705 32.598 23.8193 32.5042L23.7939 32.0049L23.7686 31.5055C21.3906 31.6262 19.5 33.5924 19.5 36H20ZM23.7939 32.0049L23.8058 32.5047L24.0118 32.4999L24 32L23.9882 31.5001L23.7821 31.505L23.7939 32.0049Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M27 29V63C27 65.2091 28.7909 67 31 67H77C77 69.2091 75.2091 71 73 71H27C24.7909 71 23 69.2091 23 67V33C23 30.86 24.6806 29.1121 26.7939 29.0049L27 29Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M27 29C27 26.7909 28.7909 25 31 25H41H49H77C79.2091 25 81 26.7909 81 29V63C81 65.2091 79.2091 67 77 67H31C28.7909 67 27 65.2091 27 63V29Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M33 37H51M33 43.5H51M56 43.5H75M33 49.5H51M56 49.5H68M33 55.5H51M56 55.5H72\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></svg>",
	"100x100_list": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2903)\"><path d=\"M50 38L66 38M50 52L66 52M50 66H66M26 24H74C75.1046 24 76 24.8954 76 26V76H120V120H-20V76H24V26C24 24.8954 24.8954 24 26 24ZM41.8627 50.965C42.4344 53.0983 41.1684 55.2911 39.035 55.8627C36.9017 56.4344 34.7089 55.1684 34.1373 53.035C33.5656 50.9017 34.8316 48.7089 36.965 48.1373C39.0983 47.5656 41.2911 48.8316 41.8627 50.965ZM41.8627 64.965C42.4344 67.0983 41.1684 69.2911 39.035 69.8627C36.9017 70.4344 34.7089 69.1684 34.1373 67.035C33.5656 64.9017 34.8316 62.7089 36.965 62.1373C39.0983 61.5656 41.2911 62.8316 41.8627 64.965Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M42.8284 36.7062C43.543 39.3729 41.9604 42.1139 39.2938 42.8284C36.6271 43.543 33.8861 41.9604 33.1716 39.2938C32.457 36.6271 34.0396 33.8861 36.7062 33.1716C39.3729 32.457 42.1139 34.0396 42.8284 36.7062Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></g><defs><clipPath id=\"clip0_25031_2903\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_liveshop": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"50\" cy=\"50\" r=\"18\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M31.9106 37.4757C29.4449 41.0302 28 45.3464 28 50C28 62.1503 37.8497 72 50 72H56M68.8117 61.4132C70.8349 58.0857 72 54.1789 72 50C72 37.8497 62.1503 28 50 28H44M44 28L52 20M44 28L52 36M56 72L48 64M56 72L48 80\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></svg>",
	"100x100_lock": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M26 44V36C26 22.7452 36.7452 12 50 12V12C63.2548 12 74 22.7452 74 36V36\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 46C18 44.8954 18.8954 44 20 44H80C81.1046 44 82 44.8954 82 46V87C82 87.5523 81.5523 88 81 88H19C18.4477 88 18 87.5523 18 87V80.5H30C30.2761 80.5 30.5 80.2761 30.5 80C30.5 79.7239 30.2761 79.5 30 79.5H18V76.5H26C26.2761 76.5 26.5 76.2761 26.5 76C26.5 75.7239 26.2761 75.5 26 75.5H18V72.5H22C22.2761 72.5 22.5 72.2761 22.5 72C22.5 71.7239 22.2761 71.5 22 71.5H18V46ZM56 62C56 64.0642 54.9576 65.8849 53.3706 66.9645L54.219 73.7519C54.3682 74.9456 53.4374 76 52.2344 76H47.7656C46.5626 76 45.6318 74.9456 45.781 73.7519L46.6294 66.9645C45.0424 65.8849 44 64.0642 44 62C44 58.6863 46.6863 56 50 56C53.3137 56 56 58.6863 56 62Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M82 36H90\" stroke=\"var(--prism-color-icon-brand-default, #fd8237)\" stroke-linecap=\"round\"/><path d=\"M82 39.0002L85.4641 41.0002\" stroke=\"var(--prism-color-icon-brand-default, #fd8237)\" stroke-linecap=\"round\"/><path d=\"M82 33.5L87.1962 30.5\" stroke=\"var(--prism-color-icon-brand-default, #fd8237)\" stroke-linecap=\"round\"/></svg>",
	"100x100_market-insight-leadtime": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_2986)\"><path d=\"M4 8C4 5.79086 5.79086 4 8 4H18H26H54C56.2091 4 58 5.79086 58 8V42C58 44.2091 56.2091 46 54 46H8C5.79086 46 4 44.2091 4 42V8Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"10.5\" y=\"36.5\" width=\"41\" height=\"5\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M11 39C11 37.8954 11.8954 37 13 37H33V41H13C11.8954 41 11 40.1046 11 39Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"10.5\" y=\"26.5\" width=\"41\" height=\"5\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M11 29C11 27.8954 11.8954 27 13 27H41V31H13C11.8954 31 11 30.1046 11 29Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"10.5\" y=\"16.5\" width=\"41\" height=\"5\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M11 19C11 17.8954 11.8954 17 13 17H23V21H13C11.8954 21 11 20.1046 11 19Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M10 11H24\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M36 58C36 55.7909 37.7909 54 40 54H50H58H86C88.2091 54 90 55.7909 90 58V92C90 94.2091 88.2091 96 86 96H40C37.7909 96 36 94.2091 36 92V58Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"42.5\" y=\"86.5\" width=\"41\" height=\"5\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M43 89C43 87.8954 43.8954 87 45 87H66V91H45C43.8954 91 43 90.1046 43 89Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"42.5\" y=\"76.5\" width=\"41\" height=\"5\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M43 79C43 77.8954 43.8954 77 45 77H58V81H45C43.8954 81 43 80.1046 43 79Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"42.5\" y=\"66.5\" width=\"41\" height=\"5\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M43 69C43 67.8954 43.8954 67 45 67H73V71H45C43.8954 71 43 70.1046 43 69Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M42 61H56\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M66 8C66 5.79086 67.7909 4 70 4H80H88H116C118.209 4 120 5.79086 120 8V42C120 44.2091 118.209 46 116 46H70C67.7909 46 66 44.2091 66 42V8Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M-26 58C-26 55.7909 -24.2091 54 -22 54H-12H-4H24C26.2091 54 28 55.7909 28 58V92C28 94.2091 26.2091 96 24 96H-22C-24.2091 96 -26 94.2091 -26 92V58Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></g><defs><clipPath id=\"clip0_25031_2986\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_opportunities": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.5 19V37H18C16.8954 37 16 36.1046 16 35V21C16 19.8954 16.8954 19 18 19H19.5ZM26 28C25.7239 28 25.5 28.2239 25.5 28.5C25.5 28.7761 25.7239 29 26 29H40C40.2761 29 40.5 28.7761 40.5 28.5C40.5 28.2239 40.2761 28 40 28H26ZM44 28C43.7239 28 43.5 28.2239 43.5 28.5C43.5 28.7761 43.7239 29 44 29H54C54.2761 29 54.5 28.7761 54.5 28.5C54.5 28.2239 54.2761 28 54 28H44ZM58 28C57.7239 28 57.5 28.2239 57.5 28.5C57.5 28.7761 57.7239 29 58 29H74C74.2761 29 74.5 28.7761 74.5 28.5C74.5 28.2239 74.2761 28 74 28H58ZM78 19C79.1046 19 80 19.8954 80 21V35C80 36.1046 79.1046 37 78 37H20.5V19H78Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M26 41.5H86C86.8284 41.5 87.5 42.1716 87.5 43V57C87.5 57.8284 86.8284 58.5 86 58.5H26C25.1716 58.5 24.5 57.8284 24.5 57V43C24.5 42.1716 25.1716 41.5 26 41.5Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M34 50.5H48M52 50.5H62M66 50.5H82\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M28 41V59\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M18 63.5H78C78.8284 63.5 79.5 64.1716 79.5 65V79C79.5 79.8284 78.8284 80.5 78 80.5H18C17.1716 80.5 16.5 79.8284 16.5 79V65C16.5 64.1716 17.1716 63.5 18 63.5Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M26 72.5H40M44 72.5H54M58 72.5H74\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M20 63V81\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></svg>",
	"100x100_out-of-sync": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_3069)\"><path d=\"M43.292 62.7621C46.2458 71.781 55.774 77.0173 65.0522 74.5312C74.3305 72.0451 79.964 62.7462 78.0126 53.4588L43.292 62.7621Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M49.3357 13.2004C39.8736 13.9282 32.5245 21.9403 32.7362 31.5434C32.9479 41.1466 40.643 48.827 50.128 49.1371L49.3357 13.2004Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M50.0001 71.9996V71.4996V71.9996ZM36.3107 66.4363C36.0944 66.2647 35.7799 66.301 35.6083 66.5174C35.4367 66.7337 35.4731 67.0482 35.6894 67.2198L36.3107 66.4363ZM72.0001 49.9996H71.5001H72.0001ZM28.0001 49.9996H28.5001H28.0001ZM50.0001 27.9996V27.4996V27.9996ZM61.1535 31.6151C61.3895 31.7586 61.697 31.6836 61.8405 31.4476C61.984 31.2117 61.909 30.9041 61.673 30.7607L61.1535 31.6151ZM28.0001 55.9996L27.6465 56.3532L28.0001 56.7067L28.3536 56.3532L28.0001 55.9996ZM72.0001 43.9996L72.3536 43.646L72.0001 43.2925L71.6465 43.646L72.0001 43.9996ZM20.3536 47.6461C20.1584 47.4508 19.8418 47.4508 19.6465 47.6461C19.4513 47.8413 19.4513 48.1579 19.6465 48.3532L20.3536 47.6461ZM36.3536 48.3532C36.5489 48.1579 36.5489 47.8413 36.3536 47.646C36.1584 47.4508 35.8418 47.4508 35.6465 47.646L36.3536 48.3532ZM63.6465 51.646C63.4513 51.8413 63.4513 52.1579 63.6465 52.3532C63.8418 52.5484 64.1584 52.5484 64.3536 52.3532L63.6465 51.646ZM79.6465 52.3532C79.8418 52.5484 80.1584 52.5484 80.3536 52.3532C80.5489 52.1579 80.5489 51.8413 80.3536 51.646L79.6465 52.3532ZM50.0001 71.9996V71.4996C45.4728 71.4996 40.2335 69.5468 36.3107 66.4363L36.0001 66.828L35.6894 67.2198C39.7665 70.4527 45.2201 72.4996 50.0001 72.4996V71.9996ZM72.0001 49.9996H71.5001C71.5001 61.8737 61.8742 71.4996 50.0001 71.4996V71.9996V72.4996C62.4265 72.4996 72.5001 62.426 72.5001 49.9996H72.0001ZM28.0001 49.9996H28.5001C28.5001 38.1255 38.126 28.4996 50.0001 28.4996V27.9996V27.4996C37.5737 27.4996 27.5001 37.5732 27.5001 49.9996H28.0001ZM50.0001 27.9996V28.4996C54.0848 28.4996 57.9021 29.6382 61.1535 31.6151L61.4133 31.1879L61.673 30.7607C58.2695 28.6913 54.2732 27.4996 50.0001 27.4996V27.9996ZM28.0001 49.9996H27.5001V55.9996H28.0001H28.5001V49.9996H28.0001ZM72.0001 49.9996H72.5001V43.9996H72.0001H71.5001V49.9996H72.0001ZM28.0001 55.9996L28.3536 55.6461L20.3536 47.6461L20.0001 47.9996L19.6465 48.3532L27.6465 56.3532L28.0001 55.9996ZM28.0001 55.9996L28.3536 56.3532L36.3536 48.3532L36.0001 47.9996L35.6465 47.646L27.6465 55.6461L28.0001 55.9996ZM72.0001 43.9996L71.6465 43.646L63.6465 51.646L64.0001 51.9996L64.3536 52.3532L72.3536 44.3532L72.0001 43.9996ZM72.0001 43.9996L71.6465 44.3532L79.6465 52.3532L80.0001 51.9996L80.3536 51.646L72.3536 43.646L72.0001 43.9996ZM88.4143 14.4138L88.0607 14.0603L14.0608 88.0603L14.4143 88.4138L14.7679 88.7674L88.7679 14.7674L88.4143 14.4138Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M65.9881 10.0002C69.0822 9.99811 72.1245 10.7936 74.8216 12.31L66.0002 28.0002L65.9881 10.0002Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></g><defs><clipPath id=\"clip0_25031_3069\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_pace": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 37.5H14.9918C15.3112 37.5 15.6113 37.6525 15.7996 37.9105L27.9482 54.5586C28.4087 55.1897 29.3825 55.0727 29.6804 54.3505L44.6939 17.9542C45.0158 17.1737 46.1003 17.1188 46.4995 17.8627L55.6311 34.8806C56.0057 35.5789 57.005 35.5847 57.3878 34.8909L63.6508 23.5392C64.0254 22.8602 64.9969 22.8476 65.389 23.5166L72.7102 36.0057C72.8897 36.3119 73.218 36.5 73.5729 36.5H100\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linejoin=\"round\"/><circle cx=\"57\" cy=\"36\" r=\"4\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M56.168 43.248C56.5638 42.6543 57.4362 42.6543 57.832 43.248L60.7031 47.5547C60.8886 47.8329 61.2008 48 61.5352 48H91C92.1046 48 93 48.8954 93 50V82C93 83.1045 92.1046 84 91 84H41C39.8954 84 39 83.1045 39 82V50C39 48.8954 39.8954 48 41 48H52.4648C52.7992 48 53.1114 47.8329 53.2969 47.5547L56.168 43.248ZM45 75.5C44.7239 75.5 44.5 75.7239 44.5 76C44.5 76.2761 44.7239 76.5 45 76.5H63C63.2761 76.5 63.5 76.2761 63.5 76C63.5 75.7239 63.2761 75.5 63 75.5H45ZM68 75.5C67.7239 75.5 67.5 75.7239 67.5 76C67.5 76.2761 67.7239 76.5 68 76.5H84C84.2761 76.5 84.5 76.2761 84.5 76C84.5 75.7239 84.2761 75.5 84 75.5H68ZM45 69.5C44.7239 69.5 44.5 69.7239 44.5 70C44.5 70.2761 44.7239 70.5 45 70.5H63C63.2761 70.5 63.5 70.2761 63.5 70C63.5 69.7239 63.2761 69.5 63 69.5H45ZM68 69.5C67.7239 69.5 67.5 69.7239 67.5 70C67.5 70.2761 67.7239 70.5 68 70.5H80C80.2761 70.5 80.5 70.2761 80.5 70C80.5 69.7239 80.2761 69.5 80 69.5H68ZM45 63.5C44.7239 63.5 44.5 63.7239 44.5 64C44.5 64.2761 44.7239 64.5 45 64.5H63C63.2761 64.5 63.5 64.2761 63.5 64C63.5 63.7239 63.2761 63.5 63 63.5H45ZM68 63.5C67.7239 63.5 67.5 63.7239 67.5 64C67.5 64.2761 67.7239 64.5 68 64.5H87C87.2761 64.5 87.5 64.2761 87.5 64C87.5 63.7239 87.2761 63.5 87 63.5H68ZM45 57C44.7239 57 44.5 57.2239 44.5 57.5C44.5 57.7761 44.7239 58 45 58H63C63.2761 58 63.5 57.7761 63.5 57.5C63.5 57.2239 63.2761 57 63 57H45Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"100x100_profile": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_3050)\"><path d=\"M170 76L119 76L79.5 76C73.1487 76 68 70.8513 68 64.5V64.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linejoin=\"round\"/><path d=\"M65.7609 22.8203C66.8278 22.5344 67.9245 23.1676 68.2104 24.2345L78.5632 62.8715C78.849 63.9384 78.2159 65.0351 77.1489 65.321L46.2393 73.6032C45.1724 73.8891 44.0757 73.2559 43.7898 72.189L33.4371 33.552C33.1512 32.485 33.7844 31.3884 34.8513 31.1025L65.7609 22.8203ZM56.9796 51.871C52.1664 53.1607 49.1916 58.3236 49.3822 64.2595L69.7525 58.8013C66.9496 53.5655 61.7927 50.5816 56.9796 51.871ZM53.8738 40.2799C51.2068 40.9947 49.6238 43.7365 50.3382 46.4036C51.0529 49.0708 53.7947 50.6536 56.462 49.9392C59.1293 49.2244 60.7122 46.4828 59.9975 43.8154C59.2827 41.1483 56.541 39.5652 53.8738 40.2799Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M47.4229 31.6556L55.1503 29.5851\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M52 31L50.8587 27.4494C48.8763 21.2818 43.0072 17.2074 36.5358 17.506L36.0014 17.5307C26.0177 17.9915 19.7216 28.4677 24 37.5V37.5L28.9299 49.3625C30.8952 54.0915 30.8952 59.4085 28.9299 64.1375V64.1375C25.9451 71.3196 18.9315 76 11.1538 76H-70V133H170V76\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linejoin=\"round\"/></g><defs><clipPath id=\"clip0_25031_3050\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_progress": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_3042)\"><path d=\"M71.0439 24H28.9561C26.0793 24 23.6073 26.0419 23.0641 28.8669L14.312 74.3777C14.1309 75.3194 13.3069 76 12.348 76H-20V120H120V76H87.652C86.6931 76 85.8691 75.3194 85.688 74.3777L76.9359 28.8669C76.3927 26.0419 73.9207 24 71.0439 24Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M50 24L50 56\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M63.5 24L63.5 56\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M36.5 23.9998L32.2066 56.9556\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M48.3184 56.7236C51.7849 55.7948 55.3475 57.8518 56.2764 61.3184C57.2052 64.7849 55.1482 68.3475 51.6816 69.2764C48.2151 70.2052 44.6525 68.1482 43.7236 64.6816C42.7948 61.2151 44.8518 57.6525 48.3184 56.7236Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M61.8184 56.7236C65.2849 55.7948 68.8475 57.8518 69.7764 61.3184C70.7052 64.7849 68.6482 68.3475 65.1816 69.2764C61.7151 70.2052 58.1525 68.1482 57.2236 64.6816C56.2948 61.2151 58.3518 57.6525 61.8184 56.7236Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M25.2162 59.1792C23.4017 62.5918 24.6972 66.8293 28.1098 68.6438C31.5224 70.4583 35.7599 69.1628 37.5744 65.7502C39.3889 62.3375 38.0934 58.1001 34.6808 56.2856C31.2681 54.4711 27.0307 55.7666 25.2162 59.1792Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></g><defs><clipPath id=\"clip0_25031_3042\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_rocket": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M56 83.1132C56 84.4602 55.5551 85.7695 54.7345 86.8377L50 93L45.2655 86.8377C44.4449 85.7695 44 84.4602 44 83.1132L44 83C44 79.6863 46.6863 77 50 77C53.3137 77 56 79.6863 56 83L56 83.1132Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M79.3915 81.9879C79.7038 82.0571 80 81.8201 80 81.5011V68.3196C80 68.0732 79.9086 67.8355 79.7433 67.6524L64 50.2044V78.1763C64 78.41 64.1628 78.6124 64.3915 78.6631L79.3915 81.9879Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M20.6085 81.9879C20.2962 82.0571 20 81.8201 20 81.5011L20 68.3196C20 68.0732 20.0914 67.8355 20.2567 67.6524L36 50.2044L36 78.1763C36 78.41 35.8372 78.6124 35.6085 78.6631L20.6085 81.9879Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M36 35.5549C36 33.5509 36.756 31.6202 38.1177 30.1467L48.8971 18.4821C49.4911 17.8393 50.5089 17.8393 51.1029 18.4821L61.8823 30.1467C63.244 31.6202 64 33.5509 64 35.5549V73.1458H50H36V35.5549Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><circle cx=\"50\" cy=\"38\" r=\"6\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"100x100_search": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M75.733 68.1995C77.5373 70.0037 77.5373 72.9291 75.733 74.7333C73.9287 76.5375 71.0034 76.5375 69.1992 74.7333L58.2542 63.7884C59.5241 62.947 60.7296 61.9676 61.8484 60.8487C62.9672 59.7299 63.9467 58.5244 64.788 57.2545L75.733 68.1995Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><circle cx=\"45.5\" cy=\"44.5\" r=\"23.5\" transform=\"rotate(-90 45.5 44.5)\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M42 30C35.9249 30 31 34.9249 31 41\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M67.5651 60.0326C66.5642 63.2114 64.21 65.5656 61.0312 66.5664\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></svg>",
	"100x100_send": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M41 61.5L44.5 72.5L31.5 56.5L60.5 43.5L41 61.5Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M50.5 65.5L67 73.5L74 27L26 54L41 61.5M50.5 65.5L44.5 72.5L41 61.5M50.5 65.5L45.5 63M41 61.5L63.5 40.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>",
	"100x100_success": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.1263 38.126C22.8529 36.3994 25.6522 36.3994 27.3788 38.126L44.5907 55.3379C46.3173 57.0645 46.3173 59.8639 44.5907 61.5905C42.8641 63.3171 40.0647 63.3171 38.3381 61.5905L21.1263 44.3786C19.3996 42.652 19.3996 39.8526 21.1263 38.126Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M41.8435 61.4042C41.0568 60.6176 41.0568 59.3423 41.8435 58.5556L50.9748 49.4243C51.7614 48.6376 53.0368 48.6376 53.8234 49.4243C54.6101 50.2109 54.6101 51.4862 53.8234 52.2729L44.6921 61.4042C43.9054 62.1909 42.6301 62.1909 41.8435 61.4042Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M39.7661 57.7191L28.4524 46.4053C26.8903 44.8432 24.3577 44.8432 22.7956 46.4053V46.4053C21.2335 47.9674 21.2335 50.5001 22.7956 52.0622L38.3519 67.6185C39.133 68.3996 40.3997 68.3992 41.1808 67.6181C56.4651 52.3338 68.7152 40.0837 80.7989 28\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></svg>",
	"100x100_sync": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"74\" cy=\"59\" r=\"10\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M74 57L73.6465 57.3536L74 57.7071L74.3536 57.3536L74 57ZM83.3536 48.3535C83.5488 48.1583 83.5488 47.8417 83.3536 47.6464C83.1583 47.4512 82.8417 47.4512 82.6464 47.6464L83.3536 48.3535ZM65.3536 47.6465C65.1583 47.4512 64.8417 47.4512 64.6464 47.6465C64.4512 47.8417 64.4512 48.1583 64.6464 48.3536L65.3536 47.6465ZM70 27V26.5V27ZM62 27V27.5V27ZM58 31H57.5H58ZM58 34H58.5H58ZM54 38V37.5V38ZM46 38V38.5V38ZM42 42H42.5H42ZM42 48H41.5H42ZM74 31H74.5H74ZM26 50L26.3535 49.6465L26 49.2929L25.6464 49.6465L26 50ZM16.6464 58.6465C16.4512 58.8417 16.4512 59.1583 16.6464 59.3536C16.8417 59.5488 17.1583 59.5488 17.3536 59.3536L16.6464 58.6465ZM34.6464 59.3535C34.8417 59.5488 35.1583 59.5488 35.3536 59.3535C35.5488 59.1583 35.5488 58.8417 35.3536 58.6464L34.6464 59.3535ZM30 74V74.5V74ZM70 74V73.5V74ZM74 70H74.5H74ZM74.5 66C74.5 65.7239 74.2761 65.5 74 65.5C73.7239 65.5 73.5 65.7239 73.5 66H74.5ZM26 70H26.5H26ZM74 57L74.3536 57.3536L83.3536 48.3535L83 48L82.6464 47.6464L73.6465 56.6464L74 57ZM74 57L74.3536 56.6464L65.3536 47.6465L65 48L64.6464 48.3536L73.6465 57.3536L74 57ZM70 27V26.5L62 26.5V27V27.5L70 27.5V27ZM58 31H57.5V34H58H58.5V31H58ZM54 38V37.5H46V38V38.5H54V38ZM42 42H41.5L41.5 48H42H42.5L42.5 42H42ZM74 31H73.5L73.5 57H74H74.5L74.5 31H74ZM42 48H41.5C41.5 49.933 39.933 51.5 38 51.5V52V52.5C40.4853 52.5 42.5 50.4853 42.5 48H42ZM46 38V37.5C43.5147 37.5 41.5 39.5147 41.5 42H42H42.5C42.5 40.067 44.067 38.5 46 38.5V38ZM58 34H57.5C57.5 35.933 55.933 37.5 54 37.5V38V38.5C56.4853 38.5 58.5 36.4853 58.5 34H58ZM62 27V26.5C59.5147 26.5 57.5 28.5147 57.5 31H58H58.5C58.5 29.067 60.067 27.5 62 27.5V27ZM70 27V27.5C71.933 27.5 73.5 29.067 73.5 31H74H74.5C74.5 28.5147 72.4853 26.5 70 26.5V27ZM26 50L25.6464 49.6465L16.6464 58.6465L17 59L17.3536 59.3536L26.3535 50.3536L26 50ZM26 50L25.6464 50.3536L34.6464 59.3535L35 59L35.3536 58.6464L26.3535 49.6465L26 50ZM30 74V74.5H70V74V73.5H30V74ZM74 70H74.5V66H74H73.5V70H74ZM26 70H26.5L26.5 50H26H25.5L25.5 70H26ZM70 74V74.5C72.4853 74.5 74.5 72.4853 74.5 70H74H73.5C73.5 71.933 71.933 73.5 70 73.5V74ZM30 74V73.5C28.067 73.5 26.5 71.933 26.5 70H26H25.5C25.5 72.4853 27.5147 74.5 30 74.5V74Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></svg>",
	"100x100_tangled": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_3085)\"><path d=\"M52 24L53.6397 28.4158L57.4064 25.5875L56.3985 30.1887L61.0963 29.8458L57.7608 33.1717L61.8982 35.4231L57.2941 36.4177L59.5575 40.5486L55.1465 38.8961L54.8173 43.5949L52 39.82L49.1827 43.5949L48.8535 38.8961L44.4425 40.5486L46.7059 36.4177L42.1018 35.4231L46.2392 33.1717L42.9037 29.8458L47.6015 30.1887L46.5936 25.5875L50.3603 28.4158L52 24Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M-20 76H17.0568C24.8401 76 30.3523 68.3976 27.9328 61L24.8062 51.4402C23.9287 48.7573 25.9279 46 28.7507 46V46C30.4977 46 32.0576 47.094 32.6527 48.7365L34.4206 53.6163C36.5144 59.3958 32.2333 65.5 26.0863 65.5V65.5C22.9497 65.5 20.0466 63.8424 18.4523 61.1411L16.4689 57.7803C9.92515 46.6925 13.8706 32.3887 25.1734 26.2236V26.2236C34.9493 20.8913 47.1983 24.653 52.2963 34.5532L62.9223 55.1886C66.8744 62.8635 61.3024 72 52.6698 72V72C45.2732 72 39.789 65.135 41.4227 57.9211L45.1923 41.2746C45.8624 38.3157 43.613 35.5 40.5792 35.5V35.5C36.4907 35.5 34.3281 40.337 37.0544 43.3839L40.4484 47.177C44.9415 52.1985 53.2399 48.6018 52.6476 41.8898L52.138 36.1145C51.4686 28.5285 57.4463 22 65.0618 22V22C73.5228 22 79.7198 29.9682 77.6365 38.1686L71.5439 62.1507C70.7445 65.2971 67.912 67.5 64.6656 67.5V67.5C58.7363 67.5 55.4215 60.6598 59.0954 56.0059L69.5663 42.7423C70.9335 41.0104 73.0185 40 75.225 40V40C80.1017 40 83.5715 44.7408 82.097 49.3893L79.3656 58C76.5388 66.9115 83.1907 76 92.5398 76H120V120H-20V76Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></g><defs><clipPath id=\"clip0_25031_3085\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_upload": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M33.0071 20.4636C40.2069 18.5345 47.607 22.8068 49.5364 30.0065C49.8065 31.0145 49.9545 32.0267 49.9905 33.027C51.7805 33.2238 53.3518 34.4915 53.846 36.3356C54.0906 37.2488 54.0353 38.1714 53.7415 38.9997H11.1214C10.356 34.2504 13.2948 29.5979 18.0423 28.3259C20.0598 27.7854 22.0992 27.9384 23.9095 28.6364C25.4116 24.757 28.681 21.6227 33.0071 20.4636Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M52 48.5V69C52 71.2091 50.2091 73 48 73H30C21.7157 73 15 66.2843 15 58C15 50.415 20.6298 44.145 27.9387 43.1405C29.8634 38.368 34.5384 35 40 35C41.3943 35 42.7374 35.2195 43.9965 35.6259C46.7921 30.4875 52.2388 27 58.5 27C67.6127 27 75 34.3873 75 43.5C75 44.7914 74.8516 46.0482 74.571 47.2542C80.5193 48.4475 85 53.7005 85 60C85 67.1797 79.1797 73 72 73H60M52 48.5L44 56.5M52 48.5L60 56.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></svg>",
	"100x100_vault": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25031_3101)\"><path d=\"M74 24H26C24.8954 24 24 24.8954 24 26V72C24 74.2091 22.2091 76 20 76H-20V120H120V76H80C77.7909 76 76 74.2091 76 72V26C76 24.8954 75.1046 24 74 24Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M66 32C67.1046 32 68 32.8954 68 34V70C68 71.1046 67.1046 72 66 72H32V32H66ZM54.2422 47.7568C51.8992 45.4143 48.1008 45.4143 45.7578 47.7568C43.4147 50.1 43.4147 53.899 45.7578 56.2422C48.101 58.5853 51.899 58.5853 54.2422 56.2422C56.5853 53.899 56.5853 50.1 54.2422 47.7568Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M66 32C67.1046 32 68 32.8954 68 34V70C68 71.1046 67.1046 72 66 72H32V32H66ZM54.2422 47.7568C51.8992 45.4143 48.1008 45.4143 45.7578 47.7568C43.4147 50.1 43.4147 53.899 45.7578 56.2422C48.1009 58.5853 51.8991 58.5853 54.2422 56.2422C56.5853 53.899 56.5853 50.1 54.2422 47.7568Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M54.2426 56.2422L57.0711 59.0706M45.7574 56.2422L42.9289 59.0706M45.7574 47.7569L42.9289 44.9285M54.2426 47.7569L57.0711 44.9285\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M31 36.5H33\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M31 68H33\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></g><defs><clipPath id=\"clip0_25031_3101\"><rect width=\"100\" height=\"100\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"100x100_warning": "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M50 63.5C46.134 63.5 43 66.634 43 70.5C43 74.366 46.134 77.5 50 77.5C53.866 77.5 57 74.366 57 70.5C57 66.634 53.866 63.5 50 63.5Z\" stroke=\"var(--prism-color-icon-brand-default, #fd8237)\" stroke-width=\"4\"/><path d=\"M44.5432 30.4754L44.0453 30.5206L44.5432 30.4754ZM47.7747 66.0213L47.9975 66.4689L48.3036 66.3165L48.2726 65.976L47.7747 66.0213ZM52.2253 66.0213L51.7274 65.976L51.6964 66.3165L52.0025 66.4689L52.2253 66.0213ZM55.4568 30.4754L54.9588 30.4301L55.4568 30.4754ZM44.5432 30.4754L45.0412 30.4301C44.7761 27.5141 47.072 25 50 25V24.5V24C46.484 24 43.7269 27.0191 44.0453 30.5206L44.5432 30.4754ZM47.7747 66.0213L48.2726 65.976L45.0412 30.4301L44.5432 30.4754L44.0453 30.5206L47.2767 66.0666L47.7747 66.0213ZM47.7747 66.0213L47.5518 65.5737C45.7439 66.4737 44.5 68.3411 44.5 70.5H45H45.5C45.5 68.735 46.5161 67.2064 47.9975 66.4689L47.7747 66.0213ZM45 70.5H44.5C44.5 73.5376 46.9624 76 50 76V75.5V75C47.5147 75 45.5 72.9853 45.5 70.5H45ZM50 75.5V76C53.0376 76 55.5 73.5376 55.5 70.5H55H54.5C54.5 72.9853 52.4853 75 50 75V75.5ZM55 70.5H55.5C55.5 68.3411 54.2561 66.4737 52.4482 65.5737L52.2253 66.0213L52.0025 66.4689C53.4839 67.2064 54.5 68.735 54.5 70.5H55ZM55.4568 30.4754L54.9588 30.4301L51.7274 65.976L52.2253 66.0213L52.7233 66.0666L55.9547 30.5206L55.4568 30.4754ZM50 24.5V25C52.928 25 55.2239 27.5141 54.9588 30.4301L55.4568 30.4754L55.9547 30.5206C56.2731 27.0191 53.516 24 50 24V24.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></svg>",
	"200x200_auto-mapping": "<svg width=\"200\" height=\"200\" viewBox=\"0 0 200 200\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M65.5 132.125L97.25 107.375\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"1.2\" stroke-dasharray=\"7.2 7.2\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M161.75 104.375C161.75 102.718 160.407 101.375 158.75 101.375L123.875 101.417L120.5 103.625L115.625 105.266L112.915 103.46L112.625 101.434L103.355 101.445L102.454 103.46L101 104.375V113.375C101 115.032 102.343 116.375 104 116.375H158.75C160.407 116.375 161.75 115.032 161.75 113.375V104.375ZM105.875 108.875C105.875 106.39 107.89 104.375 110.375 104.375C112.86 104.375 114.875 106.39 114.875 108.875C114.875 111.36 112.86 113.375 110.375 113.375C107.89 113.375 105.875 111.36 105.875 108.875ZM118.625 108.875C118.625 108.668 118.793 108.5 119 108.5H156.5L156.575 108.507C156.746 108.542 156.875 108.694 156.875 108.875C156.875 109.056 156.746 109.208 156.575 109.243L156.5 109.25H119C118.793 109.25 118.625 109.082 118.625 108.875Z\" fill=\"var(--prism-color-icon-intelligence-default, #A87EFF)\"/><path d=\"M49 130.875H56.5C60.6421 130.875 64 134.233 64 138.375C64 142.517 60.6421 145.875 56.5 145.875C52.3579 145.875 49 142.517 49 138.375V130.875Z\" fill=\"var(--prism-color-icon-intelligence-default, #A87EFF)\"/><path d=\"M112.541 102.883C112.541 103.56 112.392 104.201 112.125 104.777C111.41 106.321 109.848 107.392 108.035 107.392C107.381 107.392 106.759 107.252 106.197 107.001C104.625 106.298 103.529 104.719 103.529 102.883C103.529 100.393 105.546 98.375 108.035 98.375C110.523 98.375 112.541 100.393 112.541 102.883Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M168.5 131.991C168.831 131.991 169.1 131.722 169.1 131.391C169.1 131.059 168.831 130.791 168.5 130.791V131.991ZM131 130.791C130.669 130.791 130.4 131.059 130.4 131.391C130.4 131.722 130.669 131.991 131 131.991V130.791ZM106.197 107.001L106.443 106.453L106.197 107.001ZM112.125 104.777L111.581 104.525L112.125 104.777ZM126.5 131.391H125.9C125.9 133.543 124.154 135.288 122 135.288V135.888V136.488C124.816 136.488 127.1 134.206 127.1 131.391H126.5ZM122 135.888V135.288C119.846 135.288 118.1 133.543 118.1 131.391H117.5H116.9C116.9 134.206 119.184 136.488 122 136.488V135.888ZM117.5 131.391H118.1C118.1 129.239 119.846 127.494 122 127.494V126.894V126.294C119.184 126.294 116.9 128.575 116.9 131.391H117.5ZM122 126.894V127.494C124.154 127.494 125.9 129.239 125.9 131.391H126.5H127.1C127.1 128.575 124.816 126.294 122 126.294V126.894ZM168.5 131.391V130.791H131V131.391V131.991H168.5V131.391ZM116 123.896V124.496H170.75V123.896V123.296H116V123.896ZM173.75 126.894H173.15V135.888H173.75H174.35V126.894H173.75ZM170.75 138.886V138.286H116V138.886V139.486H170.75V138.886ZM113 135.888H113.6V126.894H113H112.4V135.888H113ZM116 138.886V138.286C114.674 138.286 113.6 137.212 113.6 135.888H113H112.4C112.4 137.875 114.012 139.486 116 139.486V138.886ZM173.75 135.888H173.15C173.15 137.212 172.076 138.286 170.75 138.286V138.886V139.486C172.738 139.486 174.35 137.875 174.35 135.888H173.75ZM170.75 123.896V124.496C172.076 124.496 173.15 125.57 173.15 126.894H173.75H174.35C174.35 124.906 172.738 123.296 170.75 123.296V123.896ZM116 123.896V123.296C114.012 123.296 112.4 124.906 112.4 126.894H113H113.6C113.6 125.57 114.674 124.496 116 124.496V123.896ZM101 120.898H100.4V128.393H101H101.6V120.898H101ZM104 131.391V131.991H108.5V131.391V130.791H104V131.391ZM101 128.393H100.4C100.4 130.38 102.012 131.991 104 131.991V131.391V130.791C102.674 130.791 101.6 129.717 101.6 128.393H101ZM114.794 108.895H114.194C114.194 111.054 112.445 112.803 110.288 112.803V113.403V114.003C113.108 114.003 115.394 111.716 115.394 108.895H114.794ZM110.288 113.403V112.803C108.131 112.803 106.382 111.054 106.382 108.895H105.782H105.182C105.182 111.716 107.468 114.003 110.288 114.003V113.403ZM103.529 102.883H104.129C104.129 100.725 105.878 98.975 108.035 98.975V98.375V97.775C105.215 97.775 102.929 100.062 102.929 102.883H103.529ZM108.035 98.375V98.975C110.192 98.975 111.941 100.725 111.941 102.883H112.541H113.141C113.141 100.062 110.855 97.775 108.035 97.775V98.375ZM108.035 107.392V106.792C107.467 106.792 106.928 106.671 106.443 106.453L106.197 107.001L105.952 107.549C106.589 107.834 107.294 107.992 108.035 107.992V107.392ZM106.197 107.001L106.443 106.453C105.078 105.843 104.129 104.474 104.129 102.883H103.529H102.929C102.929 104.963 104.172 106.752 105.952 107.549L106.197 107.001ZM105.782 108.895H106.382C106.382 108.307 106.511 107.752 106.742 107.253L106.197 107.001L105.653 106.749C105.351 107.402 105.182 108.13 105.182 108.895H105.782ZM112.541 102.883H111.941C111.941 103.471 111.812 104.026 111.581 104.525L112.125 104.777L112.67 105.029C112.972 104.376 113.141 103.649 113.141 102.883H112.541ZM112.125 104.777L111.581 104.525C110.96 105.865 109.605 106.792 108.035 106.792V107.392V107.992C110.09 107.992 111.86 106.777 112.67 105.029L112.125 104.777ZM112.125 104.777L111.88 105.325C113.245 105.935 114.194 107.304 114.194 108.895H114.794H115.394C115.394 106.815 114.151 105.026 112.37 104.229L112.125 104.777Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M33.0063 130.493L32.452 130.263V130.263L33.0063 130.493ZM33.9546 130.347L34.4136 129.961V129.961L33.9546 130.347ZM29.395 141.419L29.304 140.826H29.304L29.395 141.419ZM28.7925 140.665L29.3469 140.895H29.3469L28.7925 140.665ZM40.7123 139.684L40.8032 140.277H40.8032L40.7123 139.684ZM41.0581 138.785L40.5991 139.172L41.0581 138.785ZM34.407 155.046L34.8299 154.621H34.8299L34.407 155.046ZM34.407 154.302L34.8299 154.728H34.8299L34.407 154.302ZM41.8931 161.741L42.316 162.166H42.316L41.8931 161.741ZM41.1445 161.741L40.7216 162.166H40.7216L41.1445 161.741ZM48.6305 154.302L48.2076 154.728L48.6305 154.302ZM48.6305 155.046L48.2076 154.621L48.6305 155.046ZM41.8931 147.608L42.316 147.182L41.8931 147.608ZM41.1445 147.608L40.7216 147.182L41.1445 147.608ZM59.8449 163.407L59.9504 162.817L59.8449 163.407ZM57.2805 159.743L56.6901 159.637L57.2805 159.743ZM67.2325 164.192L67.823 164.299V164.299L67.2325 164.192ZM66.6179 164.617L66.5125 165.207L66.6179 164.617ZM65.885 153.798L65.9905 153.207L65.885 153.798ZM68.4494 157.462L67.859 157.355L68.4494 157.462ZM59.112 152.589L59.0066 153.179L59.112 152.589ZM58.4974 153.013L59.0878 153.12L58.4974 153.013ZM40.7123 139.684L40.6214 139.091L29.304 140.826L29.395 141.419L29.4859 142.012L40.8032 140.277L40.7123 139.684ZM28.7925 140.665L29.3469 140.895L33.5606 130.722L33.0063 130.493L32.452 130.263L28.2382 140.436L28.7925 140.665ZM33.9546 130.347L33.4956 130.734L40.5991 139.172L41.0581 138.785L41.5171 138.399L34.4136 129.961L33.9546 130.347ZM33.0063 130.493L33.5606 130.722C33.5586 130.727 33.5531 130.735 33.545 130.741C33.5383 130.746 33.5331 130.748 33.5302 130.748C33.5274 130.749 33.5222 130.749 33.5148 130.746C33.5058 130.743 33.4986 130.737 33.4956 130.734L33.9546 130.347L34.4136 129.961C33.8556 129.298 32.7849 129.459 32.452 130.263L33.0063 130.493ZM29.395 141.419L29.304 140.826C29.3039 140.826 29.3062 140.826 29.3105 140.826C29.3145 140.827 29.3189 140.828 29.323 140.829C29.3308 140.833 29.336 140.837 29.3395 140.841C29.3429 140.846 29.3473 140.853 29.3491 140.865C29.3513 140.879 29.3488 140.89 29.3469 140.895L28.7925 140.665L28.2382 140.436C27.8888 141.279 28.609 142.147 29.4859 142.012L29.395 141.419ZM40.7123 139.684L40.8032 140.277C41.6833 140.142 42.1045 139.096 41.5171 138.399L41.0581 138.785L40.5991 139.172C40.5962 139.168 40.5903 139.158 40.5883 139.144C40.5865 139.133 40.5883 139.124 40.5905 139.118C40.5926 139.112 40.5966 139.106 40.6036 139.1C40.6072 139.097 40.6112 139.095 40.6151 139.093C40.6191 139.091 40.6215 139.091 40.6214 139.091L40.7123 139.684ZM41.8931 147.608L41.4702 148.034L48.2076 154.728L48.6305 154.302L49.0534 153.877L42.316 147.182L41.8931 147.608ZM48.6305 155.046L48.2076 154.621L41.4702 161.315L41.8931 161.741L42.316 162.166L49.0534 155.472L48.6305 155.046ZM41.1445 161.741L41.5674 161.315L34.8299 154.621L34.407 155.046L33.9841 155.472L40.7216 162.166L41.1445 161.741ZM34.407 154.302L34.8299 154.728L41.5674 148.034L41.1445 147.608L40.7216 147.182L33.9841 153.877L34.407 154.302ZM34.407 155.046L34.8299 154.621C34.8593 154.65 34.8593 154.699 34.8299 154.728L34.407 154.302L33.9841 153.877C33.5413 154.317 33.5413 155.032 33.9841 155.472L34.407 155.046ZM41.8931 161.741L41.4702 161.315C41.4975 161.288 41.5401 161.288 41.5674 161.315L41.1445 161.741L40.7216 162.166C41.1623 162.604 41.8753 162.604 42.316 162.166L41.8931 161.741ZM48.6305 154.302L48.2076 154.728C48.1782 154.699 48.1782 154.65 48.2076 154.621L48.6305 155.046L49.0534 155.472C49.4963 155.032 49.4963 154.317 49.0534 153.877L48.6305 154.302ZM41.8931 147.608L42.316 147.182C41.8753 146.744 41.1623 146.744 40.7216 147.182L41.1445 147.608L41.5674 148.034C41.5401 148.061 41.4975 148.061 41.4702 148.034L41.8931 147.608ZM59.112 152.589L59.0066 153.179L65.7796 154.389L65.885 153.798L65.9905 153.207L59.2174 151.998L59.112 152.589ZM68.4494 157.462L67.859 157.355L66.6421 164.085L67.2325 164.192L67.823 164.299L69.0398 157.569L68.4494 157.462ZM66.6179 164.617L66.7234 164.026L59.9504 162.817L59.8449 163.407L59.7395 163.998L66.5125 165.207L66.6179 164.617ZM57.2805 159.743L57.871 159.85L59.0878 153.12L58.4974 153.013L57.907 152.907L56.6901 159.637L57.2805 159.743ZM59.8449 163.407L59.9504 162.817C58.5473 162.566 57.6204 161.236 57.871 159.85L57.2805 159.743L56.6901 159.637C56.3203 161.682 57.6896 163.632 59.7395 163.998L59.8449 163.407ZM67.2325 164.192L66.6421 164.085C66.6499 164.042 66.6887 164.02 66.7234 164.026L66.6179 164.617L66.5125 165.207C67.1226 165.316 67.7118 164.913 67.823 164.299L67.2325 164.192ZM65.885 153.798L65.7796 154.389C67.1827 154.639 68.1095 155.97 67.859 157.355L68.4494 157.462L69.0398 157.569C69.4097 155.523 68.0403 153.573 65.9905 153.207L65.885 153.798ZM59.112 152.589L59.2174 151.998C58.6073 151.889 58.0181 152.292 57.907 152.907L58.4974 153.013L59.0878 153.12C59.0801 153.163 59.0412 153.186 59.0066 153.179L59.112 152.589Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M123.486 61.8118L123.833 61.3224L122.938 60.6879L122.886 61.7832L123.486 61.8118ZM126.486 64.3225L126.906 63.8944L126.906 63.8944L126.486 64.3225ZM133.786 80.1057L134.385 80.0626V80.0625L133.786 80.1057ZM128.825 96.7737L129.303 97.1371L129.303 97.1371L128.825 96.7737ZM117.864 104.918L118.074 105.48L117.864 104.918ZM112.621 101.76L112.033 101.878L112.033 101.878L112.621 101.76ZM115.846 96.1448L115.594 95.6002L115.594 95.6002L115.846 96.1448ZM121.759 91.3958L122.236 91.7591L122.236 91.7591L121.759 91.3958ZM124.93 80.7444L125.528 80.7012V80.7012L124.93 80.7444ZM120.264 70.6584L120.684 70.2303L120.684 70.2303L120.264 70.6584ZM119.536 69.9885L119.141 69.5375L118.623 69.9917L119.144 70.4422L119.536 69.9885ZM100.49 58.8899L101.078 59.0111L101.299 57.9397L100.277 58.3292L100.49 58.8899ZM100.25 61.2502H99.6502V61.2503L100.25 61.2502ZM102.266 67.7913L102.532 68.3288L103.15 68.0226L102.762 67.4532L102.266 67.7913ZM99.5022 69.5422L99.1302 69.0715L99.1301 69.0715L99.5022 69.5422ZM93.7825 79.0696L93.1921 78.9625L93.1921 78.9625L93.7825 79.0696ZM95.7922 89.9993L95.2786 90.3093L95.2786 90.3094L95.7922 89.9993ZM101.162 95.3547L101.471 94.8403L101.471 94.8402L101.162 95.3547ZM103.766 101.284L104.338 101.465L104.338 101.465L103.766 101.284ZM98.2161 103.862L97.9469 104.398L97.947 104.398L98.2161 103.862ZM88.1907 94.5891L87.677 94.8992L87.677 94.8992L88.1907 94.5891ZM85.0452 77.4856L84.4548 77.3785L84.4548 77.3785L85.0452 77.4856ZM93.9963 62.5754L93.6243 62.1047L93.6243 62.1047L93.9963 62.5754ZM123.486 61.8118L123.138 62.3011C124.172 63.0342 125.151 63.8526 126.065 64.7506L126.486 64.3225L126.906 63.8944C125.946 62.9518 124.918 62.0924 123.833 61.3224L123.486 61.8118ZM126.486 64.3225L126.065 64.7506C130.235 68.845 132.768 74.3202 133.188 80.1489L133.786 80.1057L134.385 80.0625C133.943 73.9425 131.284 68.1935 126.906 63.8944L126.486 64.3225ZM133.786 80.1057L133.188 80.1489C133.608 85.9776 131.887 91.76 128.348 96.4103L128.825 96.7737L129.303 97.1371C133.019 92.2542 134.826 86.1828 134.385 80.0626L133.786 80.1057ZM128.825 96.7737L128.348 96.4103C125.589 100.036 121.873 102.779 117.653 104.356L117.864 104.918L118.074 105.48C122.504 103.824 126.406 100.944 129.303 97.1371L128.825 96.7737ZM117.864 104.918L117.653 104.356C115.671 105.097 113.627 103.726 113.21 101.642L112.621 101.76L112.033 101.878C112.567 104.541 115.267 106.529 118.074 105.48L117.864 104.918ZM112.621 101.76L113.21 101.642C112.794 99.5647 114.171 97.5802 116.098 96.6894L115.846 96.1448L115.594 95.6002C113.326 96.649 111.477 99.0988 112.033 101.878L112.621 101.76ZM115.846 96.1448L116.098 96.6894C118.498 95.5797 120.612 93.894 122.236 91.7591L121.759 91.3958L121.282 91.0324C119.776 93.0102 117.818 94.572 115.594 95.6002L115.846 96.1448ZM121.759 91.3958L122.236 91.7591C124.643 88.597 125.814 84.6649 125.528 80.7012L124.93 80.7444L124.331 80.7875C124.596 84.4596 123.511 88.1026 121.282 91.0324L121.759 91.3958ZM124.93 80.7444L125.528 80.7012C125.243 76.7377 123.52 73.0145 120.684 70.2303L120.264 70.6584L119.844 71.0866C122.47 73.666 124.067 77.1155 124.331 80.7875L124.93 80.7444ZM120.264 70.6584L120.684 70.2303C120.439 69.9893 120.187 69.7578 119.929 69.5348L119.536 69.9885L119.144 70.4422C119.384 70.6497 119.617 70.8643 119.844 71.0866L120.264 70.6584ZM119.536 69.9885L119.932 70.4395C122.346 68.3212 123.922 65.2672 124.085 61.8403L123.486 61.8118L122.886 61.7832C122.739 64.8716 121.32 67.6249 119.141 69.5375L119.536 69.9885ZM100.49 58.8899L99.9028 58.7687C99.7375 59.5702 99.6502 60.4004 99.6502 61.2502H100.25H100.85C100.85 60.4827 100.929 59.7338 101.078 59.0111L100.49 58.8899ZM100.25 61.2502L99.6502 61.2503C99.6503 63.8009 100.433 66.1695 101.77 68.1293L102.266 67.7913L102.762 67.4532C101.556 65.6858 100.85 63.5516 100.85 61.2502L100.25 61.2502ZM102.266 67.7913L101.999 67.2537C100.989 67.7548 100.027 68.3629 99.1302 69.0715L99.5022 69.5422L99.8742 70.013C100.705 69.3562 101.597 68.7929 102.532 68.3288L102.266 67.7913ZM99.5022 69.5422L99.1301 69.0715C96.0127 71.5356 93.9013 75.0526 93.1921 78.9625L93.7825 79.0696L94.3728 79.1767C95.0299 75.5543 96.986 72.2958 99.8743 70.013L99.5022 69.5422ZM93.7825 79.0696L93.1921 78.9625C92.483 82.8725 93.225 86.9074 95.2786 90.3093L95.7922 89.9993L96.3059 89.6892C94.4033 86.5374 93.7159 82.7991 94.3728 79.1766L93.7825 79.0696ZM95.7922 89.9993L95.2786 90.3094C96.6652 92.6062 98.5859 94.5085 100.854 95.8692L101.162 95.3547L101.471 94.8402C99.37 93.5795 97.5905 91.8171 96.3059 89.6892L95.7922 89.9993ZM101.162 95.3547L100.854 95.8692C102.674 96.9614 103.83 99.0829 103.194 101.104L103.766 101.284L104.338 101.465C105.19 98.7612 103.614 96.1263 101.471 94.8403L101.162 95.3547ZM103.766 101.284L103.194 101.104C102.555 103.131 100.377 104.275 98.4852 103.325L98.2161 103.862L97.947 104.398C100.625 105.741 103.522 104.055 104.338 101.465L103.766 101.284ZM98.2161 103.862L98.4852 103.325C94.4597 101.305 91.0589 98.179 88.7043 94.279L88.1907 94.5891L87.677 94.8992C90.1493 98.9942 93.7201 102.277 97.9469 104.398L98.2161 103.862ZM88.1907 94.5891L88.7043 94.279C85.6841 89.2761 84.5928 83.3427 85.6355 77.5927L85.0452 77.4856L84.4548 77.3785C83.3599 83.4161 84.5058 89.6461 87.677 94.8992L88.1907 94.5891ZM85.0452 77.4856L85.6355 77.5927C86.6784 71.8424 89.7835 66.6699 94.3684 63.0462L93.9963 62.5754L93.6243 62.1047C88.8102 65.9097 85.5498 71.3408 84.4548 77.3785L85.0452 77.4856ZM93.9963 62.5754L94.3684 63.0462C96.2999 61.5195 98.4392 60.3137 100.704 59.4506L100.49 58.8899L100.277 58.3292C97.8992 59.2352 95.6529 60.5013 93.6243 62.1047L93.9963 62.5754Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M115.992 50.375C114.712 49.8903 113.325 49.625 111.875 49.625C105.455 49.625 100.25 54.8297 100.25 61.25C100.25 67.6703 105.455 72.875 111.875 72.875C118.295 72.875 123.5 67.6703 123.5 61.25C123.5 60.7417 123.467 60.2411 123.404 59.75M115.992 50.375L139.875 27.5M115.992 50.375C119.931 51.8672 122.849 55.4387 123.404 59.75M123.404 59.75L148.625 45.5M112.712 59.9899H111.876M112.712 59.9899L112.947 56.8175C112.991 56.2284 112.247 55.9374 111.879 56.3997L107.774 61.5642C107.461 61.9574 107.741 62.5376 108.243 62.5376H110.73C110.908 62.5376 111.048 62.6968 111.033 62.8825L110.809 65.67C110.762 66.2599 111.507 66.5549 111.876 66.0924L115.972 60.9644C116.286 60.5714 116.006 59.9899 115.503 59.9899H112.712ZM120.5 61.25C120.5 66.0135 116.638 69.875 111.875 69.875C107.112 69.875 103.25 66.0135 103.25 61.25C103.25 56.4865 107.112 52.625 111.875 52.625C116.638 52.625 120.5 56.4865 120.5 61.25Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"1.2\" stroke-miterlimit=\"16\" stroke-linecap=\"round\"/></svg>",
	"200x200_benchmark-focus": "<svg width=\"200\" height=\"200\" viewBox=\"0 0 320 320\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M148 221L207 162\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M232.714 283V253.323C232.714 248.163 231.696 243.054 229.716 238.289L221.915 219.504C221.276 217.964 220.788 216.365 220.459 214.729L213.379 179.496L207 161.946L208.472 161.47C211.595 160.459 215.007 161.689 216.767 164.46L224.542 176.704L232.782 188.071C235.369 191.639 240.525 192.067 243.664 188.974L247.699 185C249.541 183.185 250.334 180.559 249.804 178.028L247.258 165.869C246.642 162.928 244.568 160.505 241.757 159.442L228.522 154.437C223.967 152.715 220.953 148.354 220.953 143.484C220.953 143.238 221.184 143.058 221.423 143.117L252.471 150.883C254.222 151.321 255.684 152.525 256.449 154.16L267 176.704M275 184L271.108 146.623L265.988 117L264.345 117.695C260.553 119.3 258.206 123.144 258.513 127.251L260.048 147.816V161.5M280.568 193L287.523 163.99L290.938 132.566C290.968 132.291 290.716 132.069 290.446 132.134L289.766 132.3C285.999 133.215 283.053 136.148 282.124 139.912L277.5 158.625L273.5 168M284 180L288.249 174.2L293.203 167.96V167.96C296.72 163.529 300.339 169.775 297.4 174.609L289.865 187L281.202 199.472C281.05 199.69 280.919 199.922 280.809 200.164L267.728 228.987C265.284 234.371 264.269 240.295 264.782 246.186L267.637 279\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M105 218L156.5 166.5M226 97L168 155\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M186 220L196 210\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M98 176L129.418 144.582M175 99L143.981 130.019\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M94 137L104.391 126.609M132 99L121.016 109.984\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M132.5 128.5H141.5C143.709 128.5 145.5 130.291 145.5 132.5C145.5 134.709 143.709 136.5 141.5 136.5V137.5C143.709 137.5 145.5 139.291 145.5 141.5C145.5 143.709 143.709 145.5 141.5 145.5H132.5C130.291 145.5 128.5 143.709 128.5 141.5C128.5 139.291 130.291 137.5 132.5 137.5V136.5C130.291 136.5 128.5 134.709 128.5 132.5C128.5 130.291 130.291 128.5 132.5 128.5Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M165.203 151.666C165.337 151.445 165.663 151.445 165.797 151.666L174.45 165.987C174.584 166.208 174.427 166.5 174.153 166.5H156.847C156.573 166.5 156.416 166.208 156.55 165.987L165.203 151.666Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M104.9 109.5H121.1C121.321 109.5 121.5 109.679 121.5 109.9V126.1C121.5 126.321 121.321 126.5 121.1 126.5H104.9C104.679 126.5 104.5 126.321 104.5 126.1V109.9C104.5 109.679 104.679 109.5 104.9 109.5Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M194.85 195.5H205.9C208.441 195.5 210.5 197.559 210.5 200.1V211.15C210.5 211.343 210.343 211.5 210.15 211.5H199.1C196.559 211.5 194.5 209.441 194.5 206.9V195.85C194.5 195.657 194.657 195.5 194.85 195.5Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M206.8 144.4H216.8C222.323 144.4 226.8 148.877 226.8 154.4C226.8 159.923 222.323 164.4 216.8 164.4C211.277 164.4 206.8 159.923 206.8 154.4V144.4Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M214.737 240H88C83.5817 240 80 236.418 80 232V88C80 83.5817 83.5817 80 88 80H232C236.418 80 240 83.5817 240 88V144.561\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></svg>",
	"200x200_cm-maximize": "<svg width=\"200\" height=\"200\" viewBox=\"0 0 320 320\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M71.8895 229.487L76.9887 210.481C77.6971 207.841 79.2901 205.523 81.5023 203.913L84.5482 201.697M93.831 287L92.9104 273.523C92.7569 271.276 91.8245 269.153 90.2735 267.518L69.2802 245.387C66.4187 242.37 65.3312 238.086 66.408 234.073L70.8276 217.6C71.2699 215.951 72.4985 214.627 74.1106 214.061L75.6106 213.535M78.2628 224.881L83.9146 203.815C85.0137 199.719 87.6524 196.203 91.2815 194L104.272 186.115M127 279.973L123.62 266.937C121.926 260.403 121.955 253.542 123.705 247.022L125.467 240.454C126.325 237.255 126.362 233.891 125.575 230.674L118.779 202.914C118.664 202.444 118.618 201.96 118.642 201.477L119.094 192.365C119.118 191.894 118.81 191.461 118.342 191.407C115.697 191.102 113.157 192.769 112.448 195.414L110.188 203.835C109.409 206.74 109.209 209.769 109.6 212.75L110.352 218.48C110.579 220.211 108.84 221.535 107.229 220.859L103.879 219.451C101.501 218.452 100.138 215.937 100.601 213.402L101.365 209.224C102.442 203.338 105.119 197.86 109.104 193.391L109.611 192.823C112.54 189.539 112.71 184.637 110.017 181.158C109.863 180.96 109.569 180.946 109.398 181.129L105.061 185.769L96.1971 194.359C94.0584 196.431 92.5218 199.044 91.7505 201.919L86.9369 219.86\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M237.495 134.355L237.895 134.055L237.495 134.355ZM229.534 128.448L229.363 128.918L229.534 128.448ZM200.422 117.843L200.593 117.373H200.593L200.422 117.843ZM195.525 113.729L195.958 113.479L195.525 113.729ZM196.355 99.3911L195.989 99.7321L196.355 99.3911ZM200.263 103.582L200.629 103.241L200.263 103.582ZM201.244 104.198L201.392 103.72H201.392L201.244 104.198ZM210.688 107.128L210.836 106.65L210.688 107.128ZM217.628 100.592L218.113 100.472L217.628 100.592ZM215.789 93.1163L215.304 93.2357L215.789 93.1163ZM206.72 83.6106L206.862 83.1312L206.72 83.6106ZM205.882 83.3621L205.74 83.8414H205.74L205.882 83.3621ZM201.146 85.149L201.569 85.4149L201.146 85.149ZM196.405 92.6946L195.982 92.4286L196.405 92.6946ZM195.799 78.7075L196.242 78.9386L195.799 78.7075ZM207.593 73.2602L207.482 73.7476L207.593 73.2602ZM231.042 74.591C231.227 74.7961 231.543 74.8125 231.748 74.6277C231.953 74.4428 231.97 74.1267 231.785 73.9215L231.042 74.591ZM213.259 54.1105L213.631 53.7758C213.623 53.7668 213.614 53.7582 213.605 53.7498L213.259 54.1105ZM195.67 37.2216L196.017 36.861C195.906 36.7546 195.753 36.7051 195.601 36.7265C195.449 36.748 195.315 36.8381 195.238 36.9709L195.67 37.2216ZM194.957 38.4527L194.524 38.202V38.202L194.957 38.4527ZM195.787 47.3714L195.408 47.6976L195.787 47.3714ZM206.77 60.1248L207.178 59.8356C207.169 59.8228 207.159 59.8104 207.149 59.7985L206.77 60.1248ZM217.049 75.4927C217.208 75.718 217.521 75.7711 217.746 75.6115C217.971 75.4518 218.024 75.1397 217.865 74.9144L217.049 75.4927ZM239.601 75.191C239.714 75.4431 240.009 75.5562 240.262 75.4436C240.514 75.331 240.627 75.0353 240.514 74.7832L239.601 75.191ZM232.018 56.9873L232.475 56.7834C232.467 56.7662 232.459 56.7494 232.449 56.7331L232.018 56.9873ZM219.202 35.2801L219.633 35.0259L219.633 35.0259L219.202 35.2801ZM216.662 43.5288L216.205 43.7321L216.662 43.5288ZM223.176 58.1588L223.661 58.0401C223.654 58.011 223.644 57.9827 223.632 57.9554L223.176 58.1588ZM224.835 67.053C224.901 67.3213 225.171 67.4856 225.44 67.42C225.708 67.3544 225.872 67.0838 225.807 66.8155L224.835 67.053ZM218.319 35.1573L218.663 35.5193V35.5193L218.319 35.1573ZM237.767 70.456C237.757 70.732 237.973 70.9634 238.249 70.973C238.525 70.9825 238.757 70.7665 238.766 70.4906L237.767 70.456ZM238.501 63.7025L238.001 63.6786L238.001 63.6852L238.501 63.7025ZM238.868 56.0321L239.367 56.056L238.868 56.0321ZM245.666 71.187L246.165 71.1716C246.165 71.1615 246.165 71.1514 246.164 71.1413L245.666 71.187ZM246.04 83.383L245.54 83.3983V83.3983L246.04 83.383ZM246.114 84.0049L246.603 83.9018V83.9018L246.114 84.0049ZM249.151 98.4152L249.64 98.312L249.151 98.4152ZM255.516 111.063L255.142 111.395L255.516 111.063ZM272.626 131.139C272.809 131.346 273.125 131.365 273.331 131.182C273.538 130.999 273.557 130.683 273.374 130.476L272.626 131.139ZM243.902 51.946L244.4 51.9003L243.902 51.946ZM187.774 94.0987L187.331 93.8675L187.774 94.0987ZM188.192 95.3677L188.379 94.9036L188.192 95.3677ZM187.409 99.6368L187.842 99.3872L187.409 99.6368ZM187.646 98.4246L187.929 98.8372L187.646 98.4246ZM252.227 154L252.627 153.7L237.895 134.055L237.495 134.355L237.095 134.655L251.827 154.3L252.227 154ZM229.534 128.448L229.705 127.978L200.593 117.373L200.422 117.843L200.251 118.313L229.363 128.918L229.534 128.448ZM195.525 113.729L195.958 113.479L187.842 99.3872L187.409 99.6368L186.975 99.8863L195.092 113.978L195.525 113.729ZM196.355 99.3911L195.989 99.7321L199.898 103.923L200.263 103.582L200.629 103.241L196.721 99.0501L196.355 99.3911ZM201.244 104.198L201.096 104.675L210.539 107.605L210.688 107.128L210.836 106.65L201.392 103.72L201.244 104.198ZM217.628 100.592L218.113 100.472L216.275 92.9969L215.789 93.1163L215.304 93.2357L217.142 100.711L217.628 100.592ZM206.72 83.6106L206.862 83.1312L206.024 82.8827L205.882 83.3621L205.74 83.8414L206.578 84.0899L206.72 83.6106ZM201.146 85.149L200.722 84.883L195.982 92.4286L196.405 92.6946L196.829 92.9606L201.569 85.4149L201.146 85.149ZM187.774 94.0987L188.217 94.3299L196.242 78.9386L195.799 78.7075L195.355 78.4763L187.331 93.8675L187.774 94.0987ZM207.593 73.2602L207.482 73.7476L221.115 76.8643L221.226 76.3769L221.338 75.8895L207.705 72.7728L207.593 73.2602ZM195.799 78.7075L196.242 78.9386C198.372 74.8539 202.99 72.7208 207.482 73.7476L207.593 73.2602L207.705 72.7728C202.77 71.6446 197.695 73.9883 195.355 78.4763L195.799 78.7075ZM196.405 92.6946L195.982 92.4286C194.358 95.0143 191.136 96.0104 188.379 94.9036L188.192 95.3677L188.006 95.8317C191.206 97.116 194.944 95.9614 196.829 92.9606L196.405 92.6946ZM205.882 83.3621L206.024 82.8827C204.008 82.285 201.841 83.1026 200.722 84.883L201.146 85.149L201.569 85.4149C202.449 84.0145 204.154 83.3712 205.74 83.8414L205.882 83.3621ZM215.789 93.1163L216.275 92.9969C215.112 88.2704 211.529 84.5151 206.862 83.1312L206.72 83.6106L206.578 84.0899C210.905 85.3728 214.226 88.8541 215.304 93.2357L215.789 93.1163ZM200.263 103.582L199.898 103.923C200.225 104.274 200.638 104.533 201.096 104.675L201.244 104.198L201.392 103.72C201.101 103.63 200.837 103.464 200.629 103.241L200.263 103.582ZM187.646 98.4246L187.929 98.8372C190.432 97.1227 193.869 97.4584 195.989 99.7321L196.355 99.3911L196.721 99.0501C194.259 96.4105 190.271 96.0216 187.364 98.0121L187.646 98.4246ZM200.422 117.843L200.593 117.373C198.638 116.661 196.997 115.282 195.958 113.479L195.525 113.729L195.092 113.978C196.248 115.985 198.074 117.52 200.251 118.313L200.422 117.843ZM210.688 107.128L210.539 107.605C214.979 108.983 219.223 104.986 218.113 100.472L217.628 100.592L217.142 100.711C218.066 104.469 214.533 107.797 210.836 106.65L210.688 107.128ZM237.495 134.355L237.895 134.055C235.813 131.278 232.967 129.167 229.705 127.978L229.534 128.448L229.363 128.918C232.442 130.04 235.129 132.033 237.095 134.655L237.495 134.355ZM231.414 74.2563L231.785 73.9215L213.631 53.7758L213.259 54.1105L212.888 54.4452L231.042 74.591L231.414 74.2563ZM213.259 54.1105L213.605 53.7498L196.017 36.861L195.67 37.2216L195.324 37.5823L212.913 54.4711L213.259 54.1105ZM195.67 37.2216L195.238 36.9709L194.524 38.202L194.957 38.4527L195.389 38.7035L196.103 37.4724L195.67 37.2216ZM195.787 47.3714L195.408 47.6976L206.391 60.451L206.77 60.1248L207.149 59.7985L196.166 47.0451L195.787 47.3714ZM206.77 60.1248L206.362 60.4139L217.049 75.4927L217.457 75.2035L217.865 74.9144L207.178 59.8356L206.77 60.1248ZM194.957 38.4527L194.524 38.202C192.767 41.2327 193.122 45.0431 195.408 47.6976L195.787 47.3714L196.166 47.0451C194.158 44.7132 193.846 41.3658 195.389 38.7035L194.957 38.4527ZM240.058 74.9871L240.514 74.7832L232.475 56.7834L232.018 56.9873L231.562 57.1912L239.601 75.191L240.058 74.9871ZM232.018 56.9873L232.449 56.7331L219.633 35.0259L219.202 35.2801L218.772 35.5343L231.588 57.2415L232.018 56.9873ZM216.662 43.5288L216.205 43.7321L222.719 58.3622L223.176 58.1588L223.632 57.9554L217.119 43.3254L216.662 43.5288ZM223.176 58.1588L222.69 58.2775L224.835 67.053L225.321 66.9343L225.807 66.8155L223.661 58.0401L223.176 58.1588ZM218.319 35.1573L217.974 34.7953C215.554 37.101 214.846 40.6789 216.205 43.7321L216.662 43.5288L217.119 43.3254C215.931 40.6585 216.55 37.5332 218.663 35.5193L218.319 35.1573ZM219.202 35.2801L219.633 35.0259C219.283 34.4331 218.472 34.3205 217.974 34.7953L218.319 35.1573L218.663 35.5193C218.696 35.4883 218.749 35.4957 218.772 35.5343L219.202 35.2801ZM238.266 70.4733L238.766 70.4906L239 63.7198L238.501 63.7025L238.001 63.6852L237.767 70.456L238.266 70.4733ZM238.501 63.7025L239 63.7264L239.367 56.056L238.868 56.0321L238.368 56.0082L238.001 63.6786L238.501 63.7025ZM243.902 51.946L243.404 51.9916L245.168 71.2326L245.666 71.187L246.164 71.1413L244.4 51.9003L243.902 51.946ZM245.666 71.187L245.166 71.2023L245.54 83.3983L246.04 83.383L246.539 83.3677L246.165 71.1716L245.666 71.187ZM246.114 84.0049L245.625 84.108L248.662 98.5183L249.151 98.4152L249.64 98.312L246.603 83.9018L246.114 84.0049ZM255.516 111.063L255.142 111.395L272.626 131.139L273 130.807L273.374 130.476L255.891 110.732L255.516 111.063ZM249.151 98.4152L248.662 98.5183C249.67 103.299 251.903 107.737 255.142 111.395L255.516 111.063L255.891 110.732C252.766 107.203 250.612 102.924 249.64 98.312L249.151 98.4152ZM246.04 83.383L245.54 83.3983C245.547 83.6369 245.576 83.8744 245.625 84.108L246.114 84.0049L246.603 83.9018C246.566 83.726 246.545 83.5472 246.539 83.3677L246.04 83.383ZM238.868 56.0321L239.367 56.056C239.469 53.9145 240.961 52.1355 242.972 51.6123L242.846 51.1285L242.72 50.6446C240.293 51.2761 238.492 53.4224 238.368 56.0082L238.868 56.0321ZM243.902 51.946L244.4 51.9003C244.328 51.1175 243.607 50.4138 242.72 50.6446L242.846 51.1285L242.972 51.6123C243.07 51.5868 243.161 51.6091 243.24 51.6726C243.324 51.7399 243.391 51.8532 243.404 51.9916L243.902 51.946ZM187.774 94.0987L187.331 93.8675C186.969 94.5609 187.191 95.5042 188.006 95.8317L188.192 95.3677L188.379 94.9036C188.2 94.8318 188.083 94.5868 188.217 94.3299L187.774 94.0987ZM187.409 99.6368L187.842 99.3872C187.715 99.1667 187.782 98.9376 187.929 98.8372L187.646 98.4246L187.364 98.0121C186.725 98.4498 186.627 99.2814 186.975 99.8863L187.409 99.6368Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M112 107.5C112 108.881 113.119 110 114.5 110C115.881 110 117 108.881 117 107.5C117 106.119 115.881 105 114.5 105C113.119 105 112 106.119 112 107.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M119 107.5C119 108.881 120.119 110 121.5 110C122.881 110 124 108.881 124 107.5C124 106.119 122.881 105 121.5 105C120.119 105 119 106.119 119 107.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M125 107.5C125 108.881 126.119 110 127.5 110C128.881 110 130 108.881 130 107.5C130 106.119 128.881 105 127.5 105C126.119 105 125 106.119 125 107.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M128 118H104V142M128 118V142M128 118H152M128 142H104M128 142H152M128 142V166M104 142V166H128M152 118V142M152 118H176M152 142H176M152 142V166M176 118V142M176 118H198M176 142H200M176 142V166M200 142V166M200 142V119M128 166H152M128 166V190H152M152 166H176M152 166V190M176 166H200M176 166V190H152M200 166V178C200 184.627 194.627 190 188 190H113M104 185V109C104 102.373 109.373 97 116 97H189\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M121 158H129C133.418 158 137 161.582 137 166C137 170.418 133.418 174 129 174C124.582 174 121 170.418 121 166V158Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M146 130H153.5C157.642 130 161 133.358 161 137.5C161 141.642 157.642 145 153.5 145C149.358 145 146 141.642 146 137.5V130Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M169 158H179C184.523 158 189 162.477 189 168C189 173.523 184.523 178 179 178C173.477 178 169 173.523 169 168V158Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"200x200_currencies": "<svg width=\"200\" height=\"200\" viewBox=\"0 0 200 200\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M147.918 138.75L148.194 138.603L147.981 138.204L147.683 138.544L147.918 138.75ZM148.995 140.769L148.72 140.916V140.916L148.995 140.769ZM149.259 144.653L148.966 144.545L149.259 144.653ZM128.738 183.764C128.746 183.937 128.892 184.07 129.065 184.062C129.237 184.054 129.37 183.908 129.362 183.735L129.05 183.75L128.738 183.764ZM128.917 180.89L129.229 180.876L128.917 180.89ZM160.2 133.555L160.427 133.34V133.34L160.2 133.555ZM157.716 130.929L157.943 130.714L157.943 130.714L157.716 130.929ZM159.934 145.888L160.24 145.949L159.934 145.888ZM157.746 155.313C157.713 155.482 157.823 155.647 157.992 155.68C158.161 155.714 158.326 155.604 158.359 155.435L158.053 155.374L157.746 155.313ZM147.359 133.112L147.626 132.95L147.359 133.112ZM151.757 140.395L151.489 140.557L151.757 140.395ZM152.546 146.339L152.846 146.425H152.846L152.546 146.339ZM150.651 156.188C150.685 156.357 150.849 156.467 151.019 156.434C151.188 156.4 151.298 156.236 151.264 156.066L150.958 156.127L150.651 156.188ZM141 145.455L141.306 145.391C141.289 145.311 141.241 145.24 141.173 145.195L141 145.455ZM144.827 158.024C144.904 158.178 145.092 158.242 145.246 158.165C145.401 158.088 145.464 157.901 145.387 157.746L145.107 157.885L144.827 158.024ZM141.31 150.49L141.583 150.338L141.31 150.49ZM126.809 144.576L126.86 144.267C126.769 144.253 126.677 144.278 126.607 144.338C126.537 144.397 126.497 144.484 126.497 144.576H126.809ZM135.816 154.364L136.128 154.378L135.816 154.364ZM135.584 160.787C135.592 160.96 135.738 161.093 135.911 161.085C136.083 161.077 136.216 160.931 136.208 160.759L135.896 160.773L135.584 160.787ZM115.252 169.264L115.542 169.379L115.252 169.264ZM110.96 179.24C110.896 179.401 110.974 179.582 111.135 179.646C111.295 179.71 111.477 179.631 111.54 179.471L111.25 179.355L110.96 179.24ZM148.239 145.935L148.539 145.848L148.239 145.935ZM142.739 139.896L142.625 140.187L142.739 139.896ZM134.659 136.717L134.773 136.427L134.773 136.427L134.659 136.717ZM149.123 127.539L148.883 127.739V127.739L149.123 127.539ZM157.971 138.173L157.731 138.373V138.373L157.971 138.173ZM137.384 143.045L137.557 142.785L137.384 143.045ZM134.72 145.865L134.77 145.557L134.72 145.865ZM134.584 156.65L134.572 156.963H134.572L134.584 156.65ZM129.895 150.124L130.014 149.835L129.895 150.124ZM134.276 151.94L134.156 152.229L134.276 151.94ZM133.433 173.658L133.309 173.371L133.433 173.658ZM143.17 169.449L143.046 169.162L143.17 169.449ZM157.038 136.924L156.788 137.112L157.038 136.924ZM157.803 138.459C157.907 138.597 158.103 138.625 158.241 138.521C158.379 138.417 158.406 138.221 158.302 138.083L158.053 138.271L157.803 138.459ZM156.12 160.726L156.339 160.948L156.12 160.726ZM160.791 156.127L161.011 156.35C161.017 156.343 161.023 156.337 161.029 156.33L160.791 156.127ZM149.045 127.522L149.178 127.804V127.804L149.045 127.522ZM157.639 130.926L157.432 130.692L157.432 130.692L157.639 130.926ZM134.51 136.806L134.82 136.843L134.82 136.843L134.51 136.806ZM147.918 138.75L147.642 138.897L148.72 140.916L148.995 140.769L149.271 140.622L148.194 138.603L147.918 138.75ZM149.259 144.653L148.966 144.545L148.144 146.767L148.438 146.875L148.731 146.983L149.553 144.762L149.259 144.653ZM131.875 156.875L132.144 157.034C132.549 156.35 132.947 155.873 133.462 155.302C133.978 154.73 134.613 154.061 135.468 153.01L135.226 152.812L134.984 152.615C134.141 153.65 133.522 154.302 132.997 154.884C132.471 155.467 132.042 155.979 131.606 156.716L131.875 156.875ZM139.375 148.157L139.61 148.363C139.934 147.993 140.229 147.709 140.53 147.421C140.832 147.134 141.142 146.84 141.483 146.458L141.25 146.25L141.017 146.042C140.695 146.402 140.402 146.68 140.099 146.969C139.796 147.258 139.484 147.558 139.14 147.952L139.375 148.157ZM145.346 141.771L145.577 141.982C146.752 140.699 147.306 140.045 147.615 139.656C147.771 139.46 147.864 139.332 147.939 139.228C148.013 139.127 148.068 139.053 148.153 138.956L147.918 138.75L147.683 138.544C147.579 138.663 147.511 138.755 147.434 138.86C147.359 138.963 147.273 139.082 147.126 139.267C146.83 139.64 146.288 140.281 145.116 141.56L145.346 141.771ZM148.995 140.769L148.72 140.916C149.317 142.035 149.406 143.356 148.966 144.545L149.259 144.653L149.553 144.762C150.055 143.405 149.952 141.898 149.271 140.622L148.995 140.769ZM129.05 183.75L129.362 183.735L129.229 180.876L128.917 180.89L128.605 180.905L128.738 183.764L129.05 183.75ZM160.2 133.555L160.427 133.34L157.943 130.714L157.716 130.929L157.489 131.144L159.973 133.77L160.2 133.555ZM159.934 145.888L159.627 145.827L157.746 155.313L158.053 155.374L158.359 155.435L160.24 145.949L159.934 145.888ZM147.359 133.112L147.091 133.273L151.489 140.557L151.757 140.395L152.024 140.233L147.626 132.95L147.359 133.112ZM152.546 146.339L152.246 146.252L150.16 153.53L150.46 153.616L150.76 153.702L152.846 146.425L152.546 146.339ZM150.46 153.616L150.153 153.677L150.651 156.188L150.958 156.127L151.264 156.066L150.766 153.555L150.46 153.616ZM141 145.455L140.694 145.519L142.188 152.675L142.493 152.612L142.799 152.548L141.306 145.391L141 145.455ZM142.493 152.612L142.213 152.75L144.827 158.024L145.107 157.885L145.387 157.746L142.773 152.473L142.493 152.612ZM142.493 152.612L142.766 152.459L141.583 150.338L141.31 150.49L141.037 150.642L142.221 152.764L142.493 152.612ZM126.809 144.576H126.497V145.505H126.809H127.122V144.576H126.809ZM135.816 154.364L135.504 154.349L135.397 156.678L135.71 156.692L136.022 156.706L136.128 154.378L135.816 154.364ZM135.71 156.692L135.397 156.706L135.584 160.787L135.896 160.773L136.208 160.759L136.022 156.678L135.71 156.692ZM115.252 169.264L114.961 169.149L110.96 179.24L111.25 179.355L111.54 179.471L115.542 169.379L115.252 169.264ZM150.46 153.616L150.76 153.529L148.539 145.848L148.239 145.935L147.939 146.022L150.16 153.703L150.46 153.616ZM142.739 139.896L142.854 139.605L134.773 136.427L134.659 136.717L134.544 137.008L142.625 140.187L142.739 139.896ZM149.123 127.539L148.883 127.739L157.731 138.373L157.971 138.173L158.211 137.973L149.363 127.339L149.123 127.539ZM137.384 143.045L137.211 143.305L140.826 145.715L141 145.455L141.173 145.195L137.557 142.785L137.384 143.045ZM134.72 145.865L134.77 145.557L126.86 144.267L126.809 144.576L126.759 144.884L134.669 146.174L134.72 145.865ZM135.71 156.692L135.721 156.38L134.595 156.338L134.584 156.65L134.572 156.963L135.698 157.004L135.71 156.692ZM129.895 150.124L129.775 150.412L134.156 152.229L134.276 151.94L134.396 151.651L130.014 149.835L129.895 150.124ZM133.433 173.658L133.557 173.945L143.294 169.736L143.17 169.449L143.046 169.162L133.309 173.371L133.433 173.658ZM157.038 136.924L156.788 137.112L157.803 138.459L158.053 138.271L158.302 138.083L157.287 136.736L157.038 136.924ZM156.12 160.726L156.339 160.948L161.011 156.35L160.791 156.127L160.572 155.904L155.901 160.503L156.12 160.726ZM115.252 169.264L115.542 169.379C118.616 161.628 126.239 156.654 134.572 156.963L134.584 156.65L134.595 156.338C125.998 156.02 118.133 161.152 114.961 169.149L115.252 169.264ZM135.816 154.364L136.128 154.378C136.182 153.195 135.49 152.105 134.396 151.651L134.276 151.94L134.156 152.229C135.007 152.581 135.546 153.429 135.504 154.349L135.816 154.364ZM126.809 145.505H126.497C126.497 147.653 127.791 149.59 129.775 150.412L129.895 150.124L130.014 149.835C128.264 149.109 127.122 147.4 127.122 145.505H126.809ZM148.239 145.935L148.539 145.848C147.715 142.998 145.614 140.692 142.854 139.605L142.739 139.896L142.625 140.187C145.205 141.202 147.168 143.358 147.939 146.022L148.239 145.935ZM151.757 140.395L151.489 140.557C152.522 142.267 152.796 144.331 152.246 146.252L152.546 146.339L152.846 146.425C153.445 144.336 153.147 142.093 152.024 140.233L151.757 140.395ZM149.045 127.522L148.911 127.239C146.637 128.314 145.791 131.12 147.091 133.273L147.359 133.112L147.626 132.95C146.517 131.114 147.239 128.721 149.178 127.804L149.045 127.522ZM159.934 145.888L160.24 145.949C160.801 143.12 160.056 140.189 158.211 137.973L157.971 138.173L157.731 138.373C159.455 140.444 160.151 143.183 159.627 145.827L159.934 145.888ZM157.639 130.926L157.432 130.692C155.576 132.336 155.295 135.132 156.788 137.112L157.038 136.924L157.287 136.736C155.991 135.016 156.234 132.588 157.847 131.16L157.639 130.926ZM157.716 130.929L157.943 130.714C157.807 130.57 157.581 130.56 157.432 130.692L157.639 130.926L157.847 131.16C157.743 131.252 157.585 131.245 157.489 131.144L157.716 130.929ZM134.51 136.806L134.2 136.769C133.891 139.341 135.055 141.868 137.211 143.305L137.384 143.045L137.557 142.785C135.598 141.479 134.539 139.182 134.82 136.843L134.51 136.806ZM143.17 169.449L143.294 169.736C148.148 167.637 152.571 164.658 156.339 160.948L156.12 160.726L155.901 160.503C152.187 164.158 147.829 167.094 143.046 169.162L143.17 169.449ZM160.2 133.555L159.973 133.77C165.794 139.924 166.044 149.475 160.553 155.925L160.791 156.127L161.029 156.33C166.727 149.637 166.468 139.726 160.427 133.34L160.2 133.555ZM141.31 150.49L141.583 150.338C140.161 147.787 137.652 146.027 134.77 145.557L134.72 145.865L134.669 146.174C137.363 146.613 139.708 148.258 141.037 150.642L141.31 150.49ZM149.045 127.522L149.178 127.804C149.076 127.852 148.955 127.825 148.883 127.739L149.123 127.539L149.363 127.339C149.253 127.207 149.067 127.165 148.911 127.239L149.045 127.522ZM134.51 136.806L134.82 136.843C134.805 136.976 134.668 137.057 134.544 137.008L134.659 136.717L134.773 136.427C134.516 136.326 134.233 136.495 134.2 136.769L134.51 136.806ZM128.917 180.89L129.229 180.876C129.091 177.891 130.814 175.131 133.557 173.945L133.433 173.658L133.309 173.371C130.327 174.66 128.454 177.66 128.605 180.905L128.917 180.89Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M45.625 134.375L46.7036 123.025C46.7898 122.119 47.4454 121.369 48.3321 121.162C49.5623 120.876 50.7683 121.723 50.9166 122.977L51.25 125.797M32.5 174.725L40.544 166.613C43.3829 163.75 44.6665 159.693 43.9914 155.718L42.7736 148.548C41.9069 143.445 43.0524 138.205 45.9695 133.929L53.111 123.46C53.1934 123.339 53.2964 123.234 53.4153 123.148L62.9474 116.315C62.9964 116.28 63.0649 116.293 63.0969 116.344C64.5561 118.676 64.3258 121.686 62.529 123.768L55.5078 131.904C55.4182 132.007 55.3509 132.129 55.3101 132.259L54.1153 136.095M54.1153 136.095L50.9735 140.594M54.1153 136.095L56.7621 132.306C57.3375 131.482 58.0727 130.782 58.9239 130.248L72.8781 121.489C74.0342 120.764 75.5614 121.384 75.8845 122.71L75.9968 123.171C76.2191 124.083 75.9113 125.043 75.2001 125.656L62.6113 136.507C61.9786 137.053 61.4413 137.7 61.0219 138.423L56.6287 145.99M53.2356 181.25L66.5551 163.275C68.3679 160.828 69.511 157.951 69.8715 154.928L70.5781 149.001L75.378 137.019C75.8129 135.934 75.4985 134.691 74.5995 133.943M61.7812 153.519L62.6084 150.545C62.8935 149.52 63.3084 148.535 63.8429 147.616L71.37 134.661C72.0278 133.528 73.5201 133.202 74.5995 133.943M67.8133 132.061L76.1543 128.006C76.8382 127.674 77.6628 127.921 78.0509 128.575C78.7918 129.823 78.4199 131.434 77.2066 132.231L74.5995 133.943\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"0.625\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M112.45 27.2721C113.703 27.0154 114.472 27.5808 114.756 28.9686L115.183 31.0501C118.409 30.6032 121.161 31.0298 123.44 32.3301C124.172 32.7157 124.611 33.2683 124.759 33.9879C124.885 34.6046 124.761 35.1924 124.386 35.7513C124 36.2587 123.495 36.5766 122.868 36.705C122.294 36.8227 121.683 36.7605 121.035 36.5184C119.509 35.7065 117.864 35.3742 116.099 35.5216L117.79 43.7708C119.21 43.8011 120.74 43.9695 122.38 44.276C124.073 44.5718 125.593 45.2242 126.942 46.2331C128.343 47.2313 129.26 48.784 129.692 50.8913C130.208 53.4097 129.695 55.6838 128.153 57.7136C126.652 59.6813 124.441 61.0985 121.519 61.9653L122.356 66.0513C122.64 67.439 122.156 68.2613 120.904 68.518C119.651 68.7747 118.882 68.2092 118.598 66.8215L117.745 62.6584C115.823 62.8379 113.985 62.7594 112.23 62.4229C110.465 62.0349 108.986 61.3205 107.794 60.2795C107.323 59.8404 107.03 59.3382 106.914 58.7728C106.787 58.1561 106.938 57.5629 107.365 56.9934C107.781 56.3724 108.329 55.9924 109.008 55.8534C109.373 55.7785 109.728 55.786 110.073 55.876C110.459 55.904 110.788 56.0507 111.06 56.3163C112.535 57.4066 114.447 57.9787 116.797 58.0327L114.822 48.3958C113.297 48.3869 111.793 48.2132 110.309 47.8746C108.826 47.5359 107.53 46.9179 106.421 46.0204C105.313 45.1229 104.59 43.8518 104.253 42.2071C103.779 39.8943 104.172 37.8322 105.432 36.0207C106.745 34.1986 108.748 32.8242 111.44 31.8974L110.998 29.7388C110.713 28.3511 111.198 27.5288 112.45 27.2721ZM118.738 48.3965L120.602 57.4938C122.074 56.9779 123.169 56.2179 123.888 55.2137C124.659 54.1988 124.918 53.0746 124.665 51.8411C124.402 50.5562 123.706 49.6813 122.577 49.2164C121.5 48.7408 120.221 48.4675 118.738 48.3965ZM112.373 36.446C109.858 37.4435 108.816 38.9958 109.248 41.1031C109.437 42.0282 109.924 42.6783 110.708 43.0532C111.481 43.3767 112.531 43.5899 113.858 43.693L112.373 36.446Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M118.816 105.244C119.887 105.026 120.976 104.895 122.084 104.851C123.177 104.808 124.298 104.894 125.448 105.109C125.854 105.235 126.161 105.418 126.384 105.649C126.608 105.881 126.76 106.176 126.835 106.544C126.925 106.989 126.842 107.438 126.559 107.906L126.55 107.922C126.323 108.353 125.972 108.615 125.471 108.716C125.249 108.762 124.984 108.759 124.67 108.697L124.655 108.694C123.861 108.574 122.961 108.5 121.955 108.472L121.956 108.472C120.979 108.434 120.002 108.515 119.026 108.713C117.053 109.115 115.444 110.009 114.214 111.398L113.974 111.682C112.765 113.166 112.042 114.886 111.807 116.834L111.755 117.264L120.407 115.503C120.742 115.435 121.025 115.487 121.277 115.65L121.287 115.657L121.298 115.663C121.573 115.812 121.762 116.068 121.846 116.482C121.921 116.852 121.871 117.173 121.707 117.465C121.544 117.701 121.289 117.867 120.904 117.945L111.826 119.793L111.983 120.564C112.14 121.335 112.366 122.092 112.662 122.834L112.759 123.077L121.583 121.281C121.902 121.216 122.183 121.28 122.447 121.481L122.466 121.495L122.487 121.507C122.762 121.656 122.951 121.913 123.036 122.327C123.125 122.765 123.068 123.06 122.932 123.261C122.794 123.463 122.533 123.632 122.08 123.724L114.202 125.327L114.565 125.733C115.578 126.864 116.825 127.707 118.302 128.263L118.314 128.268C119.839 128.772 121.467 128.844 123.192 128.493C124.402 128.247 125.552 127.823 126.641 127.223C127.697 126.641 128.498 126.035 129.024 125.4C129.448 125.102 129.806 124.934 130.104 124.873C130.563 124.78 130.967 124.868 131.339 125.14C131.721 125.419 131.953 125.78 132.045 126.234C132.158 126.785 132.02 127.349 131.577 127.938L131.368 128.191L131.362 128.199C130.796 128.871 129.787 129.57 128.295 130.285C126.811 130.996 125.312 131.505 123.797 131.813C120.996 132.383 118.37 132.172 115.912 131.187C113.499 130.193 111.562 128.587 110.094 126.363L109.979 126.187L107.799 126.63C107.346 126.722 107.039 126.669 106.834 126.537C106.63 126.405 106.463 126.155 106.374 125.717C106.299 125.347 106.348 125.024 106.512 124.733C106.723 124.426 106.984 124.252 107.302 124.187L108.753 123.892L108.619 123.546C108.328 122.795 108.093 121.985 107.916 121.115L107.813 120.609L106.623 120.851C106.238 120.93 105.938 120.877 105.695 120.723C105.431 120.519 105.26 120.242 105.185 119.872C105.099 119.449 105.156 119.14 105.309 118.908C105.526 118.64 105.795 118.477 106.126 118.409L107.596 118.11L107.6 117.859C107.658 114.735 108.652 112.04 110.581 109.758C112.553 107.471 115.29 105.962 118.816 105.244Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"0.625\"/><path d=\"M85.0548 65.9899C85.4878 66.2962 85.7737 66.763 85.8959 67.427L85.899 67.4412L85.9027 67.4546C86.0817 68.0953 85.9971 68.6228 85.679 69.0727C85.478 69.3569 85.1721 69.5855 84.738 69.7468L84.7347 69.748L71.8362 74.7097L71.2913 74.9187L75.605 77.9706C75.8847 78.1686 76.0381 78.4305 76.0747 78.7778L76.076 78.7895L76.0781 78.8017C76.1481 79.1826 76.0731 79.5207 75.8503 79.8356C75.6616 80.1021 75.4066 80.248 75.0563 80.2764L75.0439 80.2771L75.033 80.279C74.7209 80.3285 74.4252 80.2592 74.1324 80.0521L69.0955 76.4887L67.1863 79.1873L72.2232 82.7507C72.5029 82.9487 72.6562 83.2106 72.6929 83.5579L72.6942 83.5696L72.6963 83.5819C72.7662 83.9627 72.6912 84.3008 72.4684 84.6157C72.2798 84.8823 72.0247 85.0281 71.6745 85.0565L71.662 85.0572L71.6511 85.0591C71.339 85.1086 71.0434 85.0394 70.7506 84.8323L65.7137 81.2688L64.3922 83.1367C64.0939 83.5583 63.6817 83.798 63.1283 83.8563L63.1207 83.8569L63.1125 83.8583C62.6097 83.9381 62.0958 83.8076 61.5584 83.4274C61.0212 83.0473 60.7278 82.6065 60.6356 82.1059C60.5413 81.5935 60.6434 81.1312 60.9482 80.7002L62.2697 78.8323L57.1747 75.2277C56.8858 75.0233 56.6963 74.7529 56.6008 74.4054C56.5459 74.0978 56.6093 73.8135 56.8062 73.5351C57.035 73.2117 57.3176 73.0171 57.6594 72.9329C58.0466 72.874 58.3688 72.9491 58.6473 73.1461L63.7424 76.7507L65.6515 74.0521L60.5565 70.4475C60.2676 70.2432 60.0782 69.9728 59.9827 69.6253C59.9278 69.3176 59.9912 69.0333 60.1881 68.755C60.4168 68.4316 60.6995 68.237 61.0412 68.1527C61.4284 68.0939 61.7506 68.1689 62.0291 68.366L66.4035 71.4607L66.4179 70.874L66.7433 57.0291C66.7877 56.5958 66.9178 56.238 67.1244 55.9459C67.4488 55.4876 67.9076 55.2223 68.5307 55.1536L68.5375 55.1524L68.5451 55.1518C69.2047 55.0471 69.7618 55.1705 70.2393 55.5082C70.4781 55.6772 70.685 55.8984 70.8588 56.1762C70.9873 56.3815 71.057 56.654 71.0435 57.0126L71.0323 57.1722L71.0311 57.1857L70.3545 69.41C70.3202 69.8288 70.4021 70.2283 70.7315 70.4614C71.0845 70.7112 71.4992 70.6922 71.9083 70.5092L83.2094 65.8016L83.2218 65.796C83.6211 65.6092 83.9485 65.5677 84.2187 65.628C84.5386 65.6994 84.8159 65.8208 85.0548 65.9899Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"0.625\"/><path d=\"M159.277 74.0043C160.384 74.2782 161.272 74.6483 161.953 75.1068L161.956 75.1089C162.706 75.5988 163.223 76.0523 163.53 76.465L163.539 76.4752C163.848 76.8548 163.924 77.2841 163.749 77.8066C163.628 78.171 163.383 78.4841 162.992 78.7439L162.988 78.7466C162.687 78.9541 162.378 78.998 162.03 78.8821C161.921 78.8456 161.763 78.7449 161.557 78.5388C161.332 78.3142 161.049 78.0468 160.709 77.7367C160.33 77.3914 159.833 77.1222 159.232 76.9214C157.878 76.4695 156.664 76.5882 155.635 77.3228C154.625 78.0441 153.837 79.3285 153.241 81.1134C153.048 81.6922 152.892 82.237 152.772 82.7459C152.652 83.2539 152.562 83.7483 152.502 84.229L152.47 84.4828L159.521 86.8367C159.924 86.9711 160.125 87.1936 160.198 87.4951L160.204 87.5176L160.212 87.5389C160.346 87.8676 160.357 88.1871 160.249 88.5099C160.141 88.8325 159.941 89.0807 159.637 89.2628L159.625 89.2702L159.614 89.2779C159.395 89.4366 159.103 89.4831 158.684 89.3433L152.078 87.1379L152.001 87.4747C151.899 87.9288 151.796 88.383 151.694 88.8371C151.594 89.2794 151.457 89.7604 151.284 90.2797C150.926 91.3537 150.429 92.408 149.796 93.4429C149.19 94.412 148.437 95.1336 147.535 95.6172L146.896 95.96L157.829 99.6095C158.392 99.7976 158.672 100.067 158.777 100.38L158.781 100.392L158.786 100.403C158.95 100.792 158.965 101.161 158.844 101.524C158.723 101.888 158.478 102.201 158.087 102.461C157.747 102.686 157.36 102.72 156.882 102.519L156.871 102.514L141.393 97.3472C141.048 97.232 140.829 97.0139 140.712 96.6721C140.597 96.246 140.606 95.8505 140.731 95.477C140.819 95.2125 140.945 95.0227 141.1 94.8907C141.254 94.7593 141.453 94.6703 141.712 94.6338L141.711 94.6325C143.365 94.4197 144.734 93.7223 145.799 92.5369L145.798 92.5356C146.882 91.3927 147.67 90.0972 148.153 88.6487C148.255 88.3438 148.34 88.0459 148.408 87.7557L148.471 87.4679C148.559 87.0579 148.639 86.6695 148.713 86.3029L148.767 86.0327L145.134 84.8199C144.721 84.6819 144.48 84.4601 144.359 84.1688C144.232 83.7821 144.228 83.4614 144.318 83.1914C144.425 82.8687 144.626 82.6197 144.931 82.4376L144.939 82.4333L144.948 82.4268C145.239 82.2255 145.568 82.179 145.971 82.3133L148.97 83.3146L149.023 82.944C149.095 82.4359 149.175 81.9058 149.262 81.354C149.406 80.7816 149.587 80.1722 149.803 79.5258C150.609 77.11 151.803 75.4774 153.357 74.5733C154.909 73.6712 156.87 73.464 159.276 74.0031L159.277 74.0043Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"0.625\"/></svg>",
	"200x200_custom-hierarchy": "<svg width=\"200\" height=\"200\" viewBox=\"0 0 200 200\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M108.139 104.5C110.069 106.151 112.665 106.921 115.268 106.496L125.741 104.783C127.965 104.419 130.221 105.216 131.724 106.895L137.938 113.838C139.231 115.283 139.701 117.286 139.185 119.155L139.09 119.5H115.384L111.391 117.414C109.209 116.274 106.532 116.754 104.882 118.582L104.105 119.443L104.172 119.5H61.0002C59.3434 119.5 58.0002 118.157 58.0002 116.5V107.5C58.0004 105.843 59.3435 104.5 61.0002 104.5H108.139ZM65.5002 109C63.8435 109 62.5004 110.343 62.5002 112C62.5002 113.657 63.8434 115 65.5002 115C67.157 115 68.5002 113.657 68.5002 112C68.5001 110.343 67.1569 109 65.5002 109ZM73.3752 111.625C73.1682 111.625 73.0004 111.793 73.0002 112C73.0002 112.207 73.1681 112.375 73.3752 112.375H113.125C113.332 112.375 113.5 112.207 113.5 112C113.5 111.793 113.332 111.625 113.125 111.625H73.3752Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M126.718 81.0576C127.049 81.0576 127.318 80.7889 127.318 80.4576C127.318 80.1262 127.049 79.8576 126.718 79.8576V81.0576ZM89.6096 73.5668C89.941 73.5668 90.2096 73.2982 90.2096 72.9668C90.2096 72.6354 89.941 72.3668 89.6096 72.3668V73.5668ZM49.0296 72.3668C48.6982 72.3668 48.4296 72.6354 48.4296 72.9668C48.4296 73.2982 48.6982 73.5668 49.0296 73.5668V72.3668ZM101.633 93.0428C101.965 93.0428 102.233 92.7741 102.233 92.4428C102.233 92.1114 101.965 91.8428 101.633 91.8428V93.0428ZM61.0533 91.8428C60.7219 91.8428 60.4533 92.1114 60.4533 92.4428C60.4533 92.7741 60.7219 93.0428 61.0533 93.0428V91.8428ZM89.6096 54.0908C89.941 54.0908 90.2096 53.8222 90.2096 53.4908C90.2096 53.1594 89.941 52.8908 89.6096 52.8908V54.0908ZM49.0296 52.8908C48.6982 52.8908 48.4296 53.1594 48.4296 53.4908C48.4296 53.8222 48.6982 54.0908 49.0296 54.0908V52.8908ZM101.633 131.995C101.965 131.995 102.233 131.726 102.233 131.395C102.233 131.063 101.965 130.795 101.633 130.795V131.995ZM61.0533 130.795C60.7219 130.795 60.4533 131.063 60.4533 131.395C60.4533 131.726 60.7219 131.995 61.0533 131.995V130.795ZM147.712 160.37L147.348 160.847L147.712 160.37ZM135.577 151.106L135.941 150.629L135.577 151.106ZM132.835 148.553L133.285 148.156L132.835 148.553ZM114.989 128.349L115.438 127.951C115.418 127.929 115.397 127.908 115.374 127.889L114.989 128.349ZM104.243 119.353L103.798 118.95C103.689 119.071 103.633 119.231 103.645 119.394C103.656 119.557 103.733 119.708 103.858 119.813L104.243 119.353ZM105.022 118.493L105.467 118.895L105.022 118.493ZM111.544 117.326L111.267 117.858L111.544 117.326ZM121.204 122.356L120.927 122.889C120.938 122.894 120.949 122.9 120.96 122.905L121.204 122.356ZM130.838 126.644L131.082 126.096L130.838 126.644ZM138.26 123.155L138.838 123.315L138.26 123.155ZM139.392 119.065L138.814 118.905L139.392 119.065ZM138.143 113.754L137.696 114.154L138.143 113.754ZM131.917 106.82L132.364 106.419L131.917 106.82ZM125.922 104.711L125.826 104.118L125.922 104.711ZM115.429 106.421L115.525 107.013L115.429 106.421ZM106.555 101.736L106.391 101.159L106.555 101.736ZM129.679 95.1456L129.514 94.5686L129.679 95.1456ZM133.499 95.7816L133.157 96.2741L133.499 95.7816ZM106.387 102.15L106.906 101.849L106.387 102.15ZM140.208 85.4016L140.693 85.0487C140.685 85.0377 140.677 85.0271 140.668 85.0167L140.208 85.4016ZM125.745 68.1023L126.205 67.7175C126.088 67.5773 125.913 67.4981 125.73 67.5025C125.548 67.5069 125.377 67.5943 125.266 67.7399L125.745 68.1023ZM124.937 69.1683L124.459 68.8059L124.937 69.1683ZM124.731 77.5519L124.236 77.8905L124.731 77.5519ZM133.458 90.3179L133.979 90.0199C133.971 90.0061 133.962 89.9925 133.953 89.9793L133.458 90.3179ZM138.104 99.6464C138.269 99.934 138.635 100.034 138.923 99.8692C139.211 99.7047 139.31 99.3381 139.146 99.0505L138.104 99.6464ZM157.416 90.5202L157.991 90.3491C157.983 90.3246 157.975 90.3007 157.964 90.2774L157.416 90.5202ZM147.831 68.8556L148.38 68.6129V68.6129L147.831 68.8556ZM147.349 68.7597L147.762 69.1945V69.1945L147.349 68.7597ZM146.968 69.1219L146.554 68.6871V68.6871L146.968 69.1219ZM144.854 76.9221L145.431 76.755L144.854 76.9221ZM148.877 90.7938L149.472 90.7186C149.468 90.6875 149.462 90.6568 149.453 90.6267L148.877 90.7938ZM149.28 98.7675C149.321 99.0962 149.621 99.3291 149.95 99.2875C150.279 99.246 150.512 98.9458 150.47 98.617L149.28 98.7675ZM161.724 96.8715L161.131 96.7831C161.13 96.7901 161.129 96.7971 161.128 96.8042L161.724 96.8715ZM162.604 90.9679L162.01 90.8795L162.604 90.9679ZM167.834 93.7093L167.234 93.6956V93.6956L167.834 93.7093ZM167.586 104.57L168.184 104.62C168.185 104.608 168.185 104.596 168.186 104.583L167.586 104.57ZM166.634 115.905L166.036 115.855V115.855L166.634 115.905ZM166.638 116.501L167.235 116.443V116.443L166.638 116.501ZM168.955 140.099L168.358 140.157L168.955 140.099ZM37.0059 65.476V66.076H127.935V65.476V64.876H37.0059V65.476ZM126.718 80.4576V79.8576H37.0059V80.4576V81.0576H126.718V80.4576ZM34 77.4613H34.6V68.4723H34H33.4V77.4613H34ZM37.0059 80.4576V79.8576C35.6754 79.8576 34.6 78.7829 34.6 77.4613H34H33.4C33.4 79.4492 35.0162 81.0576 37.0059 81.0576V80.4576ZM127.935 65.476V66.076C129.266 66.076 130.341 67.1507 130.341 68.4723H130.941H131.541C131.541 66.4843 129.925 64.876 127.935 64.876V65.476ZM37.0059 65.476V64.876C35.0162 64.876 33.4 66.4843 33.4 68.4723H34H34.6C34.6 67.1507 35.6754 66.076 37.0059 66.076V65.476ZM44.5207 72.9668H43.9207C43.9207 74.2884 42.8454 75.3631 41.5148 75.3631V75.9631V76.5631C43.5045 76.5631 45.1207 74.9548 45.1207 72.9668H44.5207ZM41.5148 75.9631V75.3631C40.1842 75.3631 39.1089 74.2884 39.1089 72.9668H38.5089H37.9089C37.9089 74.9548 39.5251 76.5631 41.5148 76.5631V75.9631ZM38.5089 72.9668H39.1089C39.1089 71.6452 40.1842 70.5705 41.5148 70.5705V69.9705V69.3705C39.5251 69.3705 37.9089 70.9788 37.9089 72.9668H38.5089ZM41.5148 69.9705V70.5705C42.8454 70.5705 43.9207 71.6452 43.9207 72.9668H44.5207H45.1207C45.1207 70.9788 43.5045 69.3705 41.5148 69.3705V69.9705ZM89.6096 72.9668V72.3668H49.0296V72.9668V73.5668H89.6096V72.9668ZM49.0316 84.952V85.552H129.79V84.952V84.352H49.0316V84.952ZM46.0237 96.9372H46.6237V87.9483H46.0237H45.4237V96.9372H46.0237ZM112.881 99.9335V99.3335H49.0296V99.9335V100.534H112.881V99.9335ZM46.0237 96.9372H45.4237C45.4237 98.9252 47.0399 100.534 49.0296 100.534V99.9335V99.3335C47.699 99.3335 46.6237 98.2589 46.6237 96.9372H46.0237ZM49.0316 84.952V84.352C47.0424 84.352 45.4237 85.9598 45.4237 87.9483H46.0237H46.6237C46.6237 86.6272 47.7005 85.552 49.0316 85.552V84.952ZM56.5444 92.4428H55.9444C55.9444 93.7644 54.8691 94.8391 53.5385 94.8391V95.4391V96.0391C55.5282 96.0391 57.1444 94.4308 57.1444 92.4428H56.5444ZM53.5385 95.4391V94.8391C52.2079 94.8391 51.1326 93.7644 51.1326 92.4428H50.5326H49.9326C49.9326 94.4308 51.5488 96.0391 53.5385 96.0391V95.4391ZM50.5326 92.4428H51.1326C51.1326 91.1211 52.2079 90.0465 53.5385 90.0465V89.4465V88.8465C51.5488 88.8465 49.9326 90.4548 49.9326 92.4428H50.5326ZM53.5385 89.4465V90.0465C54.8691 90.0465 55.9444 91.1211 55.9444 92.4428H56.5444H57.1444C57.1444 90.4548 55.5282 88.8465 53.5385 88.8465V89.4465ZM101.633 92.4428V91.8428H61.0533V92.4428V93.0428H101.633V92.4428ZM34 48.9964H34.6C34.6 47.6747 35.6754 46.6001 37.0059 46.6001V46.0001V45.4001C35.0162 45.4001 33.4 47.0084 33.4 48.9964H34ZM37.0059 46.0001V46.6001H127.935V46.0001V45.4001H37.0059V46.0001ZM127.935 46.0001V46.6001C129.266 46.6001 130.341 47.6747 130.341 48.9964H130.941H131.541C131.541 47.0084 129.925 45.4001 127.935 45.4001V46.0001ZM130.941 48.9964H130.341V57.9853H130.941H131.541V48.9964H130.941ZM130.941 57.9853H130.341C130.341 59.3069 129.266 60.3816 127.935 60.3816V60.9816V61.5816C129.925 61.5816 131.541 59.9733 131.541 57.9853H130.941ZM127.935 60.9816V60.3816H37.0059V60.9816V61.5816H127.935V60.9816ZM37.0059 60.9816V60.3816C35.6754 60.3816 34.6 59.3069 34.6 57.9853H34H33.4C33.4 59.9733 35.0162 61.5816 37.0059 61.5816V60.9816ZM34 57.9853H34.6V48.9964H34H33.4V57.9853H34ZM44.5207 53.4908H43.9207C43.9207 54.8125 42.8454 55.8871 41.5148 55.8871V56.4871V57.0871C43.5045 57.0871 45.1207 55.4788 45.1207 53.4908H44.5207ZM41.5148 56.4871V55.8871C40.1842 55.8871 39.1089 54.8125 39.1089 53.4908H38.5089H37.9089C37.9089 55.4788 39.5251 57.0871 41.5148 57.0871V56.4871ZM38.5089 53.4908H39.1089C39.1089 52.1692 40.1842 51.0945 41.5148 51.0945V50.4945V49.8945C39.5251 49.8945 37.9089 51.5028 37.9089 53.4908H38.5089ZM41.5148 50.4945V51.0945C42.8454 51.0945 43.9207 52.1692 43.9207 53.4908H44.5207H45.1207C45.1207 51.5028 43.5045 49.8945 41.5148 49.8945V50.4945ZM89.6096 53.4908V52.8908H49.0296V53.4908V54.0908H89.6096V53.4908ZM46.0237 135.889H46.6237V126.9H46.0237H45.4237V135.889H46.0237ZM49.0296 123.904V124.504H109.68V123.904V123.304H49.0296V123.904ZM46.0237 135.889H45.4237C45.4237 137.877 47.0399 139.485 49.0296 139.485V138.885V138.285C47.6991 138.285 46.6237 137.211 46.6237 135.889H46.0237ZM46.0237 126.9H46.6237C46.6237 125.579 47.699 124.504 49.0296 124.504V123.904V123.304C47.0399 123.304 45.4237 124.912 45.4237 126.9H46.0237ZM56.5444 131.395H55.9444C55.9444 132.716 54.8691 133.791 53.5385 133.791V134.391V134.991C55.5282 134.991 57.1444 133.383 57.1444 131.395H56.5444ZM53.5385 134.391V133.791C52.2079 133.791 51.1326 132.716 51.1326 131.395H50.5326H49.9326C49.9326 133.383 51.5488 134.991 53.5385 134.991V134.391ZM50.5326 131.395H51.1326C51.1326 130.073 52.2079 128.998 53.5385 128.998V128.398V127.798C51.5488 127.798 49.9326 129.407 49.9326 131.395H50.5326ZM53.5385 128.398V128.998C54.8691 128.998 55.9444 130.073 55.9444 131.395H56.5444H57.1444C57.1444 129.407 55.5282 127.798 53.5385 127.798V128.398ZM101.633 131.395V130.795H61.0533V131.395V131.995H101.633V131.395ZM147.712 160.37L148.076 159.893L135.941 150.629L135.577 151.106L135.213 151.582L147.348 160.847L147.712 160.37ZM132.835 148.553L133.285 148.156L115.438 127.951L114.989 128.349L114.539 128.746L132.386 148.951L132.835 148.553ZM114.989 128.349L115.374 127.889L104.628 118.893L104.243 119.353L103.858 119.813L114.603 128.809L114.989 128.349ZM104.243 119.353L104.688 119.755L105.467 118.895L105.022 118.493L104.577 118.09L103.798 118.95L104.243 119.353ZM111.544 117.326L111.267 117.858L120.927 122.889L121.204 122.356L121.481 121.824L111.821 116.794L111.544 117.326ZM121.204 122.356L120.96 122.905L130.594 127.192L130.838 126.644L131.082 126.096L121.448 121.808L121.204 122.356ZM138.26 123.155L138.838 123.315L139.971 119.225L139.392 119.065L138.814 118.905L137.682 122.994L138.26 123.155ZM138.143 113.754L138.589 113.353L132.364 106.419L131.917 106.82L131.471 107.221L137.696 114.154L138.143 113.754ZM125.922 104.711L125.826 104.118L115.332 105.829L115.429 106.421L115.525 107.013L126.019 105.303L125.922 104.711ZM106.555 101.736L106.719 102.313L129.843 95.7227L129.679 95.1456L129.514 94.5686L106.391 101.159L106.555 101.736ZM133.499 95.7816L133.157 96.2741L148.494 106.947L148.836 106.454L149.179 105.962L133.842 95.2891L133.499 95.7816ZM106.387 102.15L106.906 101.849C107.011 102.03 106.916 102.257 106.719 102.313L106.555 101.736L106.391 101.159C105.839 101.317 105.579 101.951 105.868 102.451L106.387 102.15ZM115.429 106.421L115.332 105.829C111.966 106.378 108.611 104.792 106.906 101.849L106.387 102.15L105.868 102.451C107.823 105.826 111.668 107.642 115.525 107.013L115.429 106.421ZM131.917 106.82L132.364 106.419C130.721 104.589 128.256 103.722 125.826 104.118L125.922 104.711L126.019 105.303C128.046 104.972 130.102 105.696 131.471 107.221L131.917 106.82ZM139.392 119.065L139.971 119.225C140.542 117.16 140.022 114.948 138.589 113.353L138.143 113.754L137.696 114.154C138.856 115.446 139.276 117.235 138.814 118.905L139.392 119.065ZM105.022 118.493L105.467 118.895C106.936 117.272 109.322 116.845 111.267 117.858L111.544 117.326L111.821 116.794C109.393 115.529 106.413 116.062 104.577 118.09L105.022 118.493ZM130.838 126.644L130.594 127.192C133.952 128.687 137.859 126.852 138.838 123.315L138.26 123.155L137.682 122.994C136.899 125.821 133.773 127.294 131.082 126.096L130.838 126.644ZM135.577 151.106L135.941 150.629C134.977 149.893 134.088 149.065 133.285 148.156L132.835 148.553L132.386 148.951C133.24 149.918 134.187 150.799 135.213 151.582L135.577 151.106ZM129.679 95.1456L129.843 95.7227C130.975 95.4001 132.192 95.6028 133.157 96.2741L133.499 95.7816L133.842 95.2891C132.581 94.4119 130.992 94.1474 129.514 94.5686L129.679 95.1456ZM155.312 169L155.831 168.699C153.853 165.283 151.217 162.291 148.076 159.893L147.712 160.37L147.348 160.847C150.364 163.149 152.894 166.022 154.793 169.301L155.312 169ZM156.784 108.191L157.269 107.838L140.693 85.0487L140.208 85.4016L139.722 85.7545L156.299 108.544L156.784 108.191ZM140.208 85.4016L140.668 85.0167L126.205 67.7175L125.745 68.1023L125.284 68.4872L139.747 85.7864L140.208 85.4016ZM125.745 68.1023L125.266 67.7399L124.459 68.8059L124.937 69.1683L125.415 69.5307L126.223 68.4647L125.745 68.1023ZM124.731 77.5519L124.236 77.8905L132.962 90.6565L133.458 90.3179L133.953 89.9793L125.227 77.2133L124.731 77.5519ZM133.458 90.3179L132.937 90.6159L138.104 99.6464L138.625 99.3484L139.146 99.0505L133.979 90.0199L133.458 90.3179ZM124.937 69.1683L124.459 68.8059C122.438 71.473 122.348 75.1282 124.236 77.8905L124.731 77.5519L125.227 77.2133C123.63 74.8772 123.706 71.7865 125.415 69.5307L124.937 69.1683ZM163.79 111.944L164.365 111.773L157.991 90.3491L157.416 90.5202L156.841 90.6913L163.215 112.115L163.79 111.944ZM157.416 90.5202L157.964 90.2774L148.38 68.6129L147.831 68.8556L147.283 69.0984L156.867 90.7629L157.416 90.5202ZM147.349 68.7597L146.935 68.3249L146.554 68.6871L146.968 69.1219L147.381 69.5567L147.762 69.1945L147.349 68.7597ZM144.854 76.9221L144.278 77.0892L148.301 90.9609L148.877 90.7938L149.453 90.6267L145.431 76.755L144.854 76.9221ZM148.877 90.7938L148.282 90.869L149.28 98.7675L149.875 98.6923L150.47 98.617L149.472 90.7186L148.877 90.7938ZM146.968 69.1219L146.554 68.6871C144.285 70.8456 143.407 74.084 144.278 77.0892L144.854 76.9221L145.431 76.755C144.684 74.1812 145.436 71.4068 147.381 69.5567L146.968 69.1219ZM147.831 68.8556L148.38 68.6129C148.128 68.0422 147.386 67.8963 146.935 68.3249L147.349 68.7597L147.762 69.1945C147.613 69.3364 147.367 69.289 147.283 69.0984L147.831 68.8556ZM161.059 102.764L161.655 102.832L162.321 96.9389L161.724 96.8715L161.128 96.8042L160.462 102.697L161.059 102.764ZM161.724 96.8715L162.318 96.9599L163.197 91.0563L162.604 90.9679L162.01 90.8795L161.131 96.7831L161.724 96.8715ZM167.834 93.7093L167.234 93.6956L166.986 104.556L167.586 104.57L168.186 104.583L168.434 93.7229L167.834 93.7093ZM167.586 104.57L166.988 104.519L166.036 115.855L166.634 115.905L167.232 115.955L168.184 104.62L167.586 104.57ZM166.638 116.501L166.041 116.56L168.358 140.157L168.955 140.099L169.552 140.04L167.235 116.443L166.638 116.501ZM168.955 140.099L168.358 140.157C168.8 144.669 170.402 148.99 173.009 152.704L173.5 152.359L173.991 152.015C171.503 148.47 169.975 144.345 169.552 140.04L168.955 140.099ZM166.634 115.905L166.036 115.855C166.016 116.09 166.018 116.325 166.041 116.56L166.638 116.501L167.235 116.443C167.219 116.281 167.218 116.118 167.232 115.955L166.634 115.905ZM167.834 93.7093L168.434 93.7229C168.487 91.3943 167.227 89.4456 165.777 88.6517C165.048 88.2525 164.186 88.1073 163.424 88.4983C162.659 88.8906 162.182 89.7269 162.01 90.8795L162.604 90.9679L163.197 91.0563C163.338 90.1131 163.682 89.7146 163.972 89.566C164.264 89.4161 164.688 89.4238 165.201 89.7043C166.234 90.27 167.277 91.7877 167.234 93.6956L167.834 93.7093ZM130.941 68.4723H130.341V74.4649H130.941H131.541V68.4723H130.941ZM124.296 138.885V138.285H49.0296V138.885V139.485H124.296V138.885ZM34 84.952H33.4V89.4465H34H34.6V84.952H34ZM34 89.4465H33.4V128.398H34H34.6V89.4465H34ZM37.0059 131.395V131.995H41.6304V131.395V130.795H37.0059V131.395ZM34 128.398H33.4C33.4 130.386 35.0162 131.995 37.0059 131.995V131.395V130.795C35.6754 130.795 34.6 129.72 34.6 128.398H34ZM46.1393 104.428H45.5393V108.922H46.1393H46.7393V104.428H46.1393ZM49.1452 111.919V112.519H53.5385V111.919V111.319H49.1452V111.919ZM46.1393 108.922H45.5393C45.5393 110.91 47.1555 112.519 49.1452 112.519V111.919V111.319C47.8146 111.319 46.7393 110.244 46.7393 108.922H46.1393ZM37.0059 92.4428V93.0428H41.6304V92.4428V91.8428H37.0059V92.4428ZM34 89.4465H33.4C33.4 91.4345 35.0162 93.0428 37.0059 93.0428V92.4428V91.8428C35.6754 91.8428 34.6 90.7681 34.6 89.4465H34Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/></svg>",
	"200x200_destination-database": "<svg width=\"200\" height=\"200\" viewBox=\"0 0 201 200\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M58 93C58.8284 93 59.5 93.6716 59.5 94.5C59.5 95.3284 58.8284 96 58 96C57.1716 96 56.5 95.3284 56.5 94.5C56.5 93.6716 57.1716 93 58 93Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M62 93C62.8284 93 63.5 93.6716 63.5 94.5C63.5 95.3284 62.8284 96 62 96C61.1716 96 60.5 95.3284 60.5 94.5C60.5 93.6716 61.1716 93 62 93Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M66 93C66.8284 93 67.5 93.6716 67.5 94.5C67.5 95.3284 66.8284 96 66 96C65.1716 96 64.5 95.3284 64.5 94.5C64.5 93.6716 65.1716 93 66 93Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M132.5 46.5C134.985 46.5 137 48.5147 137 51V66.5H137.5C139.985 66.5 142 68.5147 142 71V73.5H143.5C145.985 73.5 148 75.5147 148 78V126C148 128.485 145.985 130.5 143.5 130.5H142V133C142 135.485 139.985 137.5 137.5 137.5H135V142C135 144.209 133.209 146 131 146H55L54.7939 145.995C52.6806 145.888 51 144.14 51 142V57C51 54.5148 53.0147 52.5 55.5 52.5H57V51C57 48.5147 59.0147 46.5 61.5 46.5H132.5ZM52 142C52 143.657 53.3431 145 55 145H62.5V131H52V142ZM123.5 131V145H131C132.657 145 134 143.657 134 142V131H123.5ZM63.5 145H77.5V131H63.5V145ZM78.5 145H92.5V131H78.5V145ZM93.5 145H107.5V131H93.5V145ZM108.5 145H122.5V131H108.5V145ZM55.5 53.5C53.567 53.5 52 55.067 52 57V89.3555C52.733 88.5246 53.805 88 55 88H57V64.0078C57 61.5237 59.0135 59.5 61.5 59.5H130V57C130 55.067 128.433 53.5 126.5 53.5H55.5ZM123.5 116V130H134V116H123.5ZM52 130H62.5V116H52V130ZM63.5 130H77.5V116H63.5V130ZM78.5 130H92.5V116H78.5V130ZM93.5 130H107.5V116H93.5V130ZM108.5 130H122.5V116H108.5V130ZM72.5 74.5C70.567 74.5 69 76.067 69 78V80.5H137.5C139.985 80.5 142 82.5147 142 85V129.5H143.5C145.433 129.5 147 127.933 147 126V78C147 76.067 145.433 74.5 143.5 74.5H72.5ZM123.5 102.5V115H134V102.5H123.5ZM52 115H62.5V102.5H52V115ZM63.5 115H77.5V102.5H63.5V115ZM78.5 115H92.5V102.5H78.5V115ZM93.5 115H107.5V102.5H93.5V115ZM108.5 115H122.5V102.5H108.5V115ZM55 89C53.3949 89 52.0842 90.2606 52.0039 91.8457L52 92V101.5H134V92C134 90.3431 132.657 89 131 89H55ZM66.5 67.5C64.567 67.5 63 69.067 63 71V82.1865C63.8242 81.1608 65.0837 80.5 66.5 80.5H68V78C68 75.5147 70.0147 73.5 72.5 73.5H141V71C141 69.067 139.433 67.5 137.5 67.5H66.5ZM61.5 47.5C59.567 47.5 58 49.067 58 51V52.5H126.5C128.985 52.5 131 54.5147 131 57V59.5H132.5C133.914 59.5 135.175 60.1522 136 61.1719V51C136 49.067 134.433 47.5 132.5 47.5H61.5ZM62 88V71C62 68.5147 64.0147 66.5 66.5 66.5H136V64C136 62.067 134.433 60.5 132.5 60.5H61.5C59.5682 60.5 58 62.0736 58 64.0078V88H62ZM131 88C133.209 88 135 89.7909 135 92V136.5H137.5C139.433 136.5 141 134.933 141 133V85C141 83.067 139.433 81.5 137.5 81.5H66.5C64.5695 81.5 63 83.0802 63 85.0156V88H131Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M93.0001 128.95L88.0502 124C85.3166 121.266 85.3166 116.834 88.0502 114.101C90.784 111.367 95.2162 111.367 97.9498 114.101C100.683 116.834 100.683 121.266 97.9498 124L93.0001 128.95Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"200x200_hand": "<svg width=\"200\" height=\"200\" viewBox=\"0 0 320 320\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M64 123H40V146.95M64 123V146.95M64 123H88M64 146.95H40M64 146.95H88M64 146.95V170.899M40 146.95V170.899M88 123V146.95M88 123H112M88 146.95H112M88 146.95V170.899M112 123V146.95M112 123H136M112 146.95H136M112 146.95V170.899M136 123V146.95M136 123H160M136 146.95H160M136 146.95V170.899M160 123V146.95M160 123H184M160 146.95H184M160 146.95V170.899M184 123V146.95M184 123H208M184 146.95H208M184 146.95V170.899M208 123V146.95M208 123H232M208 146.95H232M208 146.95V170.899M232 123V146.95M232 123H256V146.95M232 146.95H256M232 146.95V170.899M256 146.95V170.899M64 170.899H40M64 170.899H88M64 170.899V194.849M40 170.899V194.849H64M88 170.899H112M88 170.899V194.849M112 170.899H136M112 170.899V194.849M136 170.899H160M136 170.899V194.849M160 170.899H184M160 170.899V194.849M184 170.899H208M184 170.899V194.849M208 170.899H232M208 170.899V194.849M232 170.899H256M232 170.899V194.849M256 170.899V194.849H232M64 194.849H88M64 194.849V218H88M88 194.849H112M88 194.849V218M112 194.849H136M112 194.849V218M136 194.849H160M136 194.849V218H112M160 194.849H184M160 194.849V215.505M184 194.849H208M184 194.849V215.505M208 194.849H232M208 194.849V218H232V194.849M88 218H112M152.137 218H52C45.3726 218 40 212.627 40 206V114C40 107.373 45.3726 102 52 102H244C250.627 102 256 107.373 256 114V206C256 212.627 250.627 218 244 218H191.5M166.047 218H173.543\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M48 112.5C48 113.881 49.1193 115 50.5 115C51.8807 115 53 113.881 53 112.5C53 111.119 51.8807 110 50.5 110C49.1193 110 48 111.119 48 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M55 112.5C55 113.881 56.1193 115 57.5 115C58.8807 115 60 113.881 60 112.5C60 111.119 58.8807 110 57.5 110C56.1193 110 55 111.119 55 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M61 112.5C61 113.881 62.1193 115 63.5 115C64.8807 115 66 113.881 66 112.5C66 111.119 64.8807 110 63.5 110C62.1193 110 61 111.119 61 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M158.97 247.607L158.95 248.106L158.951 248.106L158.97 247.607ZM164.35 240.761L164.258 240.27L164.35 240.761ZM141.065 225.052L140.883 225.518H140.883L141.065 225.052ZM154.937 223L155.23 222.594L155.219 222.587L154.937 223ZM141.025 224.891L140.646 224.565H140.646L141.025 224.891ZM302.736 254.424C302.97 254.57 303.279 254.499 303.424 254.264C303.57 254.03 303.499 253.721 303.264 253.576L302.736 254.424ZM285.268 242.962L285.533 242.538L285.268 242.962ZM264.876 240.602L264.716 240.128L264.876 240.602ZM237.422 249.893L237.582 250.367L237.422 249.893ZM214.242 247.51L213.989 247.941L214.242 247.51ZM193.487 235.313L193.74 234.882L193.487 235.313ZM192.419 234.562L192.099 234.946L192.419 234.562ZM173.16 218.519L173.48 218.135L173.16 218.519ZM194.373 219.861L194.065 220.255L194.373 219.861ZM203.311 226.858L203.003 227.252C203.039 227.28 203.078 227.304 203.121 227.321L203.311 226.858ZM220.746 234.027L220.936 233.565L220.746 234.027ZM233.518 231.69L233.859 232.055H233.859L233.518 231.69ZM234.828 230.464L234.486 230.098L234.828 230.464ZM251.293 220.051L251.477 220.516L251.293 220.051ZM173.189 218.204L172.946 217.767L173.189 218.204ZM223.936 251.499C224.212 251.518 224.451 251.311 224.47 251.035C224.49 250.76 224.282 250.521 224.007 250.501L223.936 251.499ZM185.397 245.215L185.691 244.812L185.397 245.215ZM149.935 219.329L149.652 218.917C149.518 219.009 149.437 219.16 149.435 219.322C149.433 219.484 149.509 219.638 149.64 219.733L149.935 219.329ZM152.097 217.842L151.814 217.43H151.814L152.097 217.842ZM165.724 217.855L166.008 217.444L165.724 217.855ZM181.406 228.681L181.122 229.093L181.406 228.681ZM184.547 230.23L184.701 229.754L184.547 230.23ZM269.702 204.066L269.874 203.597L269.702 204.066ZM195.79 249.014L195.809 248.515L158.989 247.107L158.97 247.607L158.951 248.106L195.771 249.514L195.79 249.014ZM164.35 240.761L164.442 241.253L175.9 239.105L175.808 238.614L175.716 238.122L164.258 240.27L164.35 240.761ZM175.808 238.614L175.896 239.106L176.534 238.992L176.446 238.5L176.359 238.008L175.721 238.121L175.808 238.614ZM175.808 238.614L175.99 238.148L141.247 224.586L141.065 225.052L140.883 225.518L175.626 239.079L175.808 238.614ZM154.937 223L154.644 223.405L157.069 225.156L157.362 224.751L157.655 224.345L155.23 222.595L154.937 223ZM141.065 225.052L141.247 224.586C141.502 224.686 141.583 225.009 141.404 225.217L141.025 224.891L140.646 224.565C140.375 224.88 140.497 225.367 140.883 225.518L141.065 225.052ZM158.807 247.437H159.307C159.307 244.409 161.465 241.811 164.442 241.253L164.35 240.761L164.258 240.27C160.808 240.916 158.307 243.928 158.307 247.437H158.807ZM141.025 224.891L141.404 225.217C144.619 221.483 150.595 220.639 154.655 223.413L154.937 223L155.219 222.587C150.729 219.519 144.185 220.453 140.646 224.565L141.025 224.891ZM158.97 247.607L158.991 247.107C159.167 247.114 159.307 247.26 159.307 247.437H158.807H158.307C158.307 247.796 158.591 248.092 158.95 248.106L158.97 247.607ZM303 254L303.264 253.576L285.533 242.538L285.268 242.962L285.004 243.386L302.736 254.424L303 254ZM264.876 240.602L264.716 240.128L237.261 249.42L237.422 249.893L237.582 250.367L265.036 241.075L264.876 240.602ZM214.242 247.51L214.495 247.079L193.74 234.882L193.487 235.313L193.234 235.744L213.989 247.941L214.242 247.51ZM192.419 234.562L192.739 234.178L173.48 218.135L173.16 218.519L172.84 218.903L192.099 234.946L192.419 234.562ZM194.373 219.861L194.065 220.255L203.003 227.252L203.311 226.858L203.619 226.465L194.682 219.468L194.373 219.861ZM203.311 226.858L203.121 227.321L220.556 234.49L220.746 234.027L220.936 233.565L203.501 226.396L203.311 226.858ZM233.518 231.69L233.859 232.055L235.17 230.829L234.828 230.464L234.486 230.098L233.176 231.325L233.518 231.69ZM251.293 220.051L251.477 220.516L258.833 217.616L258.649 217.151L258.466 216.686L251.11 219.586L251.293 220.051ZM234.828 230.464L235.17 230.829C239.907 226.395 245.44 222.897 251.477 220.516L251.293 220.051L251.11 219.586C244.956 222.013 239.316 225.579 234.486 230.098L234.828 230.464ZM220.746 234.027L220.556 234.49C225.085 236.352 230.284 235.4 233.859 232.055L233.518 231.69L233.176 231.325C229.887 234.403 225.103 235.278 220.936 233.565L220.746 234.027ZM173.189 218.204L173.432 218.64C180.008 214.979 188.139 215.616 194.065 220.255L194.373 219.861L194.682 219.468C188.439 214.58 179.873 213.91 172.946 217.767L173.189 218.204ZM173.16 218.519L173.48 218.135C173.646 218.273 173.621 218.535 173.432 218.64L173.189 218.204L172.946 217.767C172.521 218.003 172.466 218.592 172.84 218.903L173.16 218.519ZM193.487 235.313L193.74 234.882C193.388 234.675 193.053 234.439 192.739 234.178L192.419 234.562L192.099 234.946C192.455 235.243 192.834 235.509 193.234 235.744L193.487 235.313ZM237.422 249.893L237.261 249.42C229.693 251.981 221.384 251.127 214.495 247.079L214.242 247.51L213.989 247.941C221.127 252.136 229.738 253.021 237.582 250.367L237.422 249.893ZM285.268 242.962L285.533 242.538C279.304 238.66 271.666 237.776 264.716 240.128L264.876 240.602L265.036 241.075C271.703 238.819 279.03 239.667 285.004 243.386L285.268 242.962ZM223.972 251L224.007 250.501L195.825 248.516L195.79 249.014L195.755 249.513L223.936 251.499L223.972 251ZM185.397 245.215L185.691 244.812L150.23 218.925L149.935 219.329L149.64 219.733L185.102 245.619L185.397 245.215ZM149.935 219.329L150.218 219.741L152.381 218.254L152.097 217.842L151.814 217.43L149.652 218.917L149.935 219.329ZM165.724 217.855L165.44 218.267L181.122 229.093L181.406 228.681L181.69 228.27L166.008 217.444L165.724 217.855ZM184.547 230.23L184.394 230.705L188.895 232.155L189.049 231.679L189.202 231.203L184.701 229.754L184.547 230.23ZM302 215.943L302.172 215.474L269.874 203.597L269.702 204.066L269.529 204.535L301.827 216.412L302 215.943ZM269.702 204.066L269.874 203.597C266.103 202.21 262.115 201.5 258.096 201.5V202V202.5C261.998 202.5 265.868 203.189 269.529 204.535L269.702 204.066ZM181.406 228.681L181.122 229.093C182.128 229.787 183.23 230.331 184.394 230.705L184.547 230.23L184.701 229.754C183.63 229.409 182.615 228.909 181.69 228.27L181.406 228.681ZM152.097 217.842L152.381 218.254C156.315 215.549 161.511 215.554 165.44 218.267L165.724 217.855L166.008 217.444C161.738 214.496 156.09 214.49 151.814 217.43L152.097 217.842ZM195.79 249.014L195.825 248.516C192.166 248.258 188.654 246.974 185.691 244.812L185.397 245.215L185.102 245.619C188.216 247.893 191.908 249.242 195.755 249.513L195.79 249.014Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M235.157 163.802C232.206 160.514 232.206 155.182 235.157 151.894C238.108 148.606 242.892 148.606 245.843 151.894C248.794 155.182 248.794 160.514 245.843 163.802L240.5 169.756L235.157 163.802Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M50.9907 188.174C48.2241 185.091 48.2241 180.093 50.9907 177.01C53.7573 173.928 58.2427 173.928 61.0093 177.01C63.7759 180.093 63.7759 185.091 61.0093 188.174L56 193.756L50.9907 188.174Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M87.5 170L93.864 163.636C97.3787 160.121 97.3787 154.423 93.864 150.908C90.3492 147.393 84.6508 147.393 81.136 150.908C77.6213 154.423 77.6213 160.121 81.136 163.636L87.5 170Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M112.15 135.064L105.786 128.7C102.271 125.186 102.271 119.487 105.786 115.972C109.301 112.458 114.999 112.458 118.514 115.972C122.029 119.487 122.029 125.186 118.514 128.7L112.15 135.064Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M136.588 194.198L130.931 188.541C127.807 185.417 127.807 180.351 130.931 177.227C134.055 174.103 139.121 174.103 142.245 177.227C145.369 180.351 145.369 185.417 142.245 188.541L136.588 194.198Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"200x200_manual-mapping": "<svg width=\"200\" height=\"200\" viewBox=\"0 0 200 200\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M65.5 132.187L97.25 107.437\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"1.2\" stroke-dasharray=\"7.2 7.2\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M161.75 104.438C161.75 102.781 160.407 101.438 158.75 101.438L117.5 101.438L116 105.188L114.5 104.438L112.25 102.188H104C103.65 102.188 103.314 102.247 103.002 102.358L102.875 104.063L101 107.063V113.438C101 115.094 102.343 116.438 104 116.438H158.75C160.407 116.438 161.75 115.094 161.75 113.438V104.438ZM105.5 108.938C105.5 106.452 107.515 104.438 110 104.438C112.485 104.438 114.5 106.452 114.5 108.938C114.5 111.423 112.485 113.438 110 113.438C107.515 113.438 105.5 111.423 105.5 108.938ZM118.625 108.938C118.625 108.73 118.793 108.563 119 108.563H156.5L156.575 108.57C156.746 108.605 156.875 108.756 156.875 108.938C156.875 109.119 156.746 109.27 156.575 109.305L156.5 109.313H119C118.793 109.313 118.625 109.145 118.625 108.938Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M49 130.938H56.5C60.6421 130.938 64 134.295 64 138.438C64 142.58 60.6421 145.938 56.5 145.938C52.3579 145.938 49 142.58 49 138.438V130.938Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M112.541 102.911C112.541 103.587 112.392 104.229 112.125 104.805C111.41 106.351 109.848 107.422 108.035 107.422C107.381 107.422 106.759 107.282 106.197 107.031C104.625 106.327 103.529 104.747 103.529 102.911C103.529 100.419 105.546 98.3992 108.035 98.3992C110.523 98.3992 112.541 100.419 112.541 102.911Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M168.5 132.037C168.831 132.037 169.1 131.769 169.1 131.438C169.1 131.106 168.831 130.838 168.5 130.838V132.037ZM131 130.838C130.669 130.838 130.4 131.106 130.4 131.438C130.4 131.769 130.669 132.037 131 132.037V130.838ZM160.675 37.4317C160.909 37.1972 160.908 36.8173 160.674 36.5831C160.44 36.349 160.06 36.3492 159.825 36.5837L160.675 37.4317ZM146.503 50.7714L146.079 50.3474H146.079L146.503 50.7714ZM140.928 59.1347L141.483 59.3635V59.3635L140.928 59.1347ZM135.84 71.4649L136.395 71.6938L135.84 71.4649ZM134.303 74.3546L133.803 74.0226L134.303 74.3546ZM121.262 93.9796L120.763 93.6475C120.746 93.6725 120.731 93.6988 120.719 93.726L121.262 93.9796ZM116.088 105.077L115.814 105.612C115.96 105.686 116.129 105.698 116.283 105.645C116.437 105.592 116.563 105.479 116.632 105.331L116.088 105.077ZM115.185 104.616L115.459 104.082L115.459 104.082L115.185 104.616ZM112.728 99.3816L113.314 99.5121L112.728 99.3816ZM114.798 90.0973L115.384 90.2279C115.387 90.2159 115.389 90.2038 115.391 90.1917L114.798 90.0973ZM116.247 81.0034L116.839 81.0978V81.0978L116.247 81.0034ZM111.624 75.5374L111.629 74.9374L111.624 75.5374ZM107.914 75.5095L107.91 76.1095L107.914 75.5095ZM103.71 77.7667L103.207 77.4387L103.71 77.7667ZM99.2574 84.5865L98.755 84.2585L99.2574 84.5865ZM98.8281 90.1186L99.3751 89.8721L98.8281 90.1186ZM102.641 98.578L103.188 98.3315L102.641 98.578ZM100.685 107.121L101.2 106.812L100.685 107.121ZM89.9009 89.1195L89.3862 89.4278L89.9009 89.1195ZM89.5762 85.7543L89.012 85.5502L89.5762 85.7543ZM95.6953 70.6097C95.8081 70.2981 95.6469 69.9541 95.3353 69.8413C95.0238 69.7285 94.6797 69.8897 94.567 70.2013L95.6953 70.6097ZM101.073 107.168L101.497 107.592L101.073 107.168ZM95.2713 63.689C95.48 63.4315 95.4404 63.0537 95.183 62.8451C94.9255 62.6364 94.5477 62.676 94.339 62.9334L95.2713 63.689ZM79.2945 82.4511L78.8284 82.0733C78.8199 82.0838 78.8117 82.0946 78.804 82.1056L79.2945 82.4511ZM67.9447 98.5649L67.4541 98.2193C67.3488 98.3689 67.3174 98.5584 67.369 98.734C67.4206 98.9096 67.5495 99.052 67.719 99.1208L67.9447 98.5649ZM69.0274 99.0043L68.8017 99.5603L69.0274 99.0043ZM76.1554 97.2775L76.6103 97.6687L76.1554 97.2775ZM84.9703 87.0275L84.5457 86.6035C84.5352 86.614 84.5251 86.625 84.5154 86.6363L84.9703 87.0275ZM91.7333 81.105C91.9675 80.8705 91.9673 80.4906 91.7328 80.2565C91.4984 80.0223 91.1185 80.0225 90.8843 80.257L91.7333 81.105ZM96.7088 57.0659C96.9912 56.8925 97.0795 56.523 96.9062 56.2407C96.7328 55.9583 96.3633 55.8699 96.0809 56.0433L96.7088 57.0659ZM79.7359 66.7836L79.4219 66.2723C79.4002 66.2856 79.3794 66.3003 79.3596 66.3162L79.7359 66.7836ZM63.5979 79.7735L63.9741 80.2409L63.9741 80.2409L63.5979 79.7735ZM63.6257 80.2021L63.3133 80.7143H63.3133L63.6257 80.2021ZM64.0176 80.4411L63.7052 80.9533H63.7052L64.0176 80.4411ZM71.0834 80.4552L71.3938 80.9686H71.3938L71.0834 80.4552ZM81.8934 73.9202L81.6695 73.3636C81.6395 73.3756 81.6106 73.3901 81.583 73.4067L81.8934 73.9202ZM88.3126 71.9842C88.6201 71.8605 88.769 71.511 88.6453 71.2036C88.5216 70.8961 88.1721 70.7472 87.8647 70.8709L88.3126 71.9842ZM88.8751 61.5852C89.2026 61.5346 89.4271 61.2281 89.3764 60.9006C89.3258 60.5731 89.0193 60.3487 88.6918 60.3993L88.8751 61.5852ZM84.1288 61.7117L84.1974 62.3078C84.2051 62.3069 84.2128 62.3059 84.2205 62.3047L84.1288 61.7117ZM78.9436 62.3083L79.0122 62.9044V62.9044L78.9436 62.3083ZM80.1328 57.2646L80.275 57.8475L80.1328 57.2646ZM89.3091 55.0254L89.2026 54.435C89.1906 54.4371 89.1787 54.4397 89.1669 54.4426L89.3091 55.0254ZM99.0991 53.259L98.9926 52.6686L99.0991 53.259ZM99.6016 53.1205L99.3904 52.5589L99.3903 52.5589L99.6016 53.1205ZM119.012 45.8197L119.223 46.3813V46.3812L119.012 45.8197ZM128.343 39.2091L128.803 39.5947V39.5947L128.343 39.2091ZM135.742 31.3231C135.955 31.0692 135.921 30.6908 135.667 30.4778C135.414 30.2649 135.035 30.298 134.822 30.5519L135.742 31.3231ZM106.197 107.031L106.443 106.484L106.197 107.031ZM112.125 104.805L111.581 104.553L112.125 104.805ZM126.5 131.438H125.9C125.9 133.591 124.154 135.338 122 135.338V135.938V136.537C124.817 136.537 127.1 134.254 127.1 131.438H126.5ZM122 135.938V135.338C119.846 135.338 118.1 133.591 118.1 131.438H117.5H116.9C116.9 134.254 119.183 136.537 122 136.537V135.938ZM117.5 131.438H118.1C118.1 129.284 119.846 127.538 122 127.538V126.938V126.338C119.183 126.338 116.9 128.621 116.9 131.438H117.5ZM122 126.938V127.538C124.154 127.538 125.9 129.284 125.9 131.438H126.5H127.1C127.1 128.621 124.817 126.338 122 126.338V126.938ZM168.5 131.438V130.838H131V131.438V132.037H168.5V131.438ZM116 123.938V124.537H170.75V123.938V123.338H116V123.938ZM173.75 126.938H173.15V135.938H173.75H174.35V126.938H173.75ZM170.75 138.938V138.338H116V138.938V139.538H170.75V138.938ZM113 135.938H113.6V126.938H113H112.4V135.938H113ZM116 138.938V138.338C114.675 138.338 113.6 137.263 113.6 135.938H113H112.4C112.4 137.926 114.012 139.538 116 139.538V138.938ZM173.75 135.938H173.15C173.15 137.263 172.075 138.338 170.75 138.338V138.938V139.538C172.738 139.538 174.35 137.926 174.35 135.938H173.75ZM170.75 123.938V124.537C172.075 124.537 173.15 125.612 173.15 126.938H173.75H174.35C174.35 124.949 172.738 123.338 170.75 123.338V123.938ZM116 123.938V123.338C114.012 123.338 112.4 124.949 112.4 126.938H113H113.6C113.6 125.612 114.675 124.537 116 124.537V123.938ZM101 120.938H100.4V128.438H101H101.6V120.938H101ZM104 131.438V132.037H108.5V131.438V130.838H104V131.438ZM101 128.438H100.4C100.4 130.426 102.012 132.037 104 132.037V131.438V130.838C102.675 130.838 101.6 129.763 101.6 128.438H101ZM114.794 108.926H114.194C114.194 111.087 112.444 112.838 110.288 112.838V113.438V114.037C113.108 114.037 115.394 111.748 115.394 108.926H114.794ZM110.288 113.438V112.838C108.131 112.838 106.382 111.087 106.382 108.926H105.782H105.182C105.182 111.748 107.467 114.037 110.288 114.037V113.438ZM103.529 102.911H104.129C104.129 100.75 105.879 98.9992 108.035 98.9992V98.3992V97.7992C105.214 97.7992 102.929 100.088 102.929 102.911H103.529ZM108.035 98.3992V98.9992C110.191 98.9992 111.941 100.75 111.941 102.911H112.541H113.141C113.141 100.088 110.856 97.7992 108.035 97.7992V98.3992ZM160.25 37.0077L159.825 36.5837L146.079 50.3474L146.503 50.7714L146.928 51.1954L160.675 37.4317L160.25 37.0077ZM140.928 59.1347L140.373 58.9058L135.286 71.2361L135.84 71.4649L136.395 71.6938L141.483 59.3635L140.928 59.1347ZM134.303 74.3546L133.803 74.0226L120.763 93.6475L121.262 93.9796L121.762 94.3117L134.803 74.6867L134.303 74.3546ZM121.262 93.9796L120.719 93.726L115.544 104.824L116.088 105.077L116.632 105.331L121.806 94.2331L121.262 93.9796ZM116.088 105.077L116.361 104.543L115.459 104.082L115.185 104.616L114.912 105.15L115.814 105.612L116.088 105.077ZM112.728 99.3816L113.314 99.5121L115.384 90.2279L114.798 90.0973L114.213 89.9667L112.143 99.251L112.728 99.3816ZM114.798 90.0973L115.391 90.1917L116.839 81.0978L116.247 81.0034L115.654 80.909L114.206 90.0029L114.798 90.0973ZM111.624 75.5374L111.629 74.9374L107.919 74.9095L107.914 75.5095L107.91 76.1095L111.62 76.1374L111.624 75.5374ZM103.71 77.7667L103.207 77.4387L98.755 84.2585L99.2574 84.5865L99.7598 84.9145L104.212 78.0947L103.71 77.7667ZM98.8281 90.1186L98.2811 90.3652L102.094 98.8246L102.641 98.578L103.188 98.3315L99.3751 89.8721L98.8281 90.1186ZM100.685 107.121L101.2 106.812L90.4156 88.8111L89.9009 89.1195L89.3862 89.4278L100.171 107.429L100.685 107.121ZM89.5762 85.7543L90.1404 85.9585L95.6953 70.6097L95.1312 70.4055L94.567 70.2013L89.012 85.5502L89.5762 85.7543ZM101.073 107.168L100.648 106.744C100.81 106.582 101.082 106.616 101.2 106.812L100.685 107.121L100.171 107.429C100.454 107.902 101.107 107.983 101.497 107.592L101.073 107.168ZM102.641 98.578L102.094 98.8246C103.303 101.509 102.728 104.662 100.648 106.744L101.073 107.168L101.497 107.592C103.929 105.157 104.602 101.47 103.188 98.3315L102.641 98.578ZM99.2574 84.5865L98.755 84.2585C97.566 86.0796 97.3874 88.3821 98.2811 90.3652L98.8281 90.1186L99.3751 89.8721C98.6496 88.2622 98.7947 86.3928 99.7598 84.9145L99.2574 84.5865ZM107.914 75.5095L107.919 74.9095C106.021 74.8952 104.246 75.8483 103.207 77.4387L103.71 77.7667L104.212 78.0947C105.027 76.846 106.421 76.0983 107.91 76.1095L107.914 75.5095ZM115.185 104.616L115.459 104.082C113.787 103.227 112.905 101.347 113.314 99.5121L112.728 99.3816L112.143 99.251C111.615 101.619 112.753 104.046 114.912 105.15L115.185 104.616ZM116.247 81.0034L116.839 81.0978C117.351 77.8816 114.884 74.9619 111.629 74.9374L111.624 75.5374L111.62 76.1374C114.139 76.1563 116.051 78.4164 115.654 80.909L116.247 81.0034ZM135.84 71.4649L135.286 71.2361C134.883 72.211 134.387 73.1443 133.803 74.0226L134.303 74.3546L134.803 74.6867C135.43 73.7434 135.963 72.7409 136.395 71.6938L135.84 71.4649ZM89.9009 89.1195L90.4156 88.8111C89.8999 87.9502 89.7988 86.9025 90.1404 85.9585L89.5762 85.7543L89.012 85.5502C88.5476 86.8332 88.6851 88.2574 89.3862 89.4278L89.9009 89.1195ZM146.503 50.7714L146.079 50.3474C143.633 52.7965 141.694 55.7049 140.373 58.9058L140.928 59.1347L141.483 59.3635C142.743 56.3085 144.594 53.5327 146.928 51.1954L146.503 50.7714ZM94.8052 63.3112L94.339 62.9334L78.8284 82.0733L79.2945 82.4511L79.7607 82.8289L95.2713 63.689L94.8052 63.3112ZM79.2945 82.4511L78.804 82.1056L67.4541 98.2193L67.9447 98.5649L68.4352 98.9104L79.785 82.7966L79.2945 82.4511ZM67.9447 98.5649L67.719 99.1208L68.8017 99.5603L69.0274 99.0043L69.253 98.4484L68.1703 98.0089L67.9447 98.5649ZM76.1554 97.2775L76.6103 97.6687L85.4252 87.4187L84.9703 87.0275L84.5154 86.6363L75.7005 96.8862L76.1554 97.2775ZM84.9703 87.0275L85.3948 87.4515L91.7333 81.105L91.3088 80.681L90.8843 80.257L84.5457 86.6035L84.9703 87.0275ZM69.0274 99.0043L68.8017 99.5603C71.5406 100.672 74.6823 99.9106 76.6103 97.6687L76.1554 97.2775L75.7005 96.8862C74.1082 98.7378 71.5142 99.3661 69.253 98.4484L69.0274 99.0043ZM96.3949 56.5546L96.0809 56.0433L79.4219 66.2723L79.7359 66.7836L80.0498 67.2949L96.7088 57.0659L96.3949 56.5546ZM79.7359 66.7836L79.3596 66.3162L63.2216 79.3061L63.5979 79.7735L63.9741 80.2409L80.1121 67.251L79.7359 66.7836ZM63.6257 80.2021L63.3133 80.7143L63.7052 80.9533L64.0176 80.4411L64.3301 79.9289L63.9382 79.6898L63.6257 80.2021ZM71.0834 80.4552L71.3938 80.9686L82.2038 74.4337L81.8934 73.9202L81.583 73.4067L70.773 79.9417L71.0834 80.4552ZM81.8934 73.9202L82.1174 74.4768L88.3126 71.9842L88.0887 71.4275L87.8647 70.8709L81.6695 73.3636L81.8934 73.9202ZM64.0176 80.4411L63.7052 80.9533C66.0649 82.3927 69.0284 82.3986 71.3938 80.9686L71.0834 80.4552L70.773 79.9417C68.7907 81.14 66.3075 81.1351 64.3301 79.9289L64.0176 80.4411ZM63.5979 79.7735L63.2216 79.3061C62.7566 79.6805 62.8033 80.4032 63.3133 80.7143L63.6257 80.2021L63.9382 79.6898C64.1379 79.8117 64.1561 80.0944 63.9741 80.2409L63.5979 79.7735ZM88.7835 60.9922L88.6918 60.3993L84.0372 61.1188L84.1288 61.7117L84.2205 62.3047L88.8751 61.5852L88.7835 60.9922ZM84.1288 61.7117L84.0603 61.1157L78.875 61.7123L78.9436 62.3083L79.0122 62.9044L84.1974 62.3078L84.1288 61.7117ZM80.1328 57.2646L80.275 57.8475L89.4513 55.6083L89.3091 55.0254L89.1669 54.4426L79.9905 56.6818L80.1328 57.2646ZM89.3091 55.0254L89.4156 55.6159L99.2057 53.8495L99.0991 53.259L98.9926 52.6686L89.2026 54.435L89.3091 55.0254ZM99.6016 53.1205L99.8128 53.682L119.223 46.3813L119.012 45.8197L118.801 45.2581L99.3904 52.5589L99.6016 53.1205ZM119.012 45.8197L119.223 46.3812C122.946 44.981 126.245 42.6436 128.803 39.5947L128.343 39.2091L127.884 38.8235C125.459 41.7144 122.33 43.9305 118.801 45.2581L119.012 45.8197ZM99.0991 53.259L99.2057 53.8495C99.4127 53.8122 99.6159 53.7561 99.8128 53.682L99.6016 53.1205L99.3903 52.5589C99.2613 52.6074 99.1282 52.6441 98.9926 52.6686L99.0991 53.259ZM128.343 39.2091L128.803 39.5947L135.742 31.3231L135.282 30.9375L134.822 30.5519L127.884 38.8235L128.343 39.2091ZM80.1328 57.2646L79.9905 56.6818C77.9754 57.1735 76.5708 58.6976 76.2048 60.1301C76.0207 60.8507 76.0827 61.6438 76.6082 62.2267C77.1348 62.8106 77.9819 63.0229 79.0122 62.9044L78.9436 62.3083L78.875 61.7123C78.0501 61.8072 77.6647 61.6064 77.4995 61.4231C77.3331 61.2386 77.244 60.9102 77.3674 60.4271C77.6165 59.4524 78.6616 58.2412 80.275 57.8475L80.1328 57.2646ZM108.035 107.422V106.822C107.467 106.822 106.928 106.701 106.443 106.484L106.197 107.031L105.952 107.579C106.589 107.864 107.294 108.022 108.035 108.022V107.422ZM106.197 107.031L106.443 106.484C105.078 105.873 104.129 104.502 104.129 102.911H103.529H102.929C102.929 104.992 104.171 106.782 105.952 107.579L106.197 107.031ZM105.782 108.926H106.382C106.382 108.338 106.511 107.782 106.742 107.283L106.197 107.031L105.653 106.779C105.351 107.433 105.182 108.16 105.182 108.926H105.782ZM112.541 102.911H111.941C111.941 103.499 111.812 104.055 111.581 104.553L112.125 104.805L112.67 105.057C112.972 104.404 113.141 103.676 113.141 102.911H112.541ZM112.125 104.805L111.581 104.553C110.96 105.895 109.605 106.822 108.035 106.822V107.422V108.022C110.09 108.022 111.86 106.807 112.67 105.057L112.125 104.805ZM112.125 104.805L111.88 105.353C113.244 105.964 114.194 107.334 114.194 108.926H114.794H115.394C115.394 106.845 114.151 105.055 112.37 104.258L112.125 104.805Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M33.0063 130.532L33.5607 130.761L33.0063 130.532ZM33.9546 130.387L34.4137 130V130L33.9546 130.387ZM29.395 141.466L29.304 140.873H29.304L29.395 141.466ZM28.7925 140.712L29.3469 140.941L28.7925 140.712ZM40.7123 139.73L40.8033 140.323L40.7123 139.73ZM41.0581 138.83L40.599 139.216L41.0581 138.83ZM34.407 155.102L34.8301 154.677H34.8301L34.407 155.102ZM34.407 154.358L34.8301 154.783L34.407 154.358ZM41.8931 161.801L42.3161 162.227H42.3161L41.8931 161.801ZM41.1445 161.801L40.7214 162.227H40.7214L41.1445 161.801ZM48.6305 154.358L48.2075 154.783L48.6305 154.358ZM48.6305 155.102L48.2075 154.677L48.6305 155.102ZM41.8931 147.659L42.3161 147.233L41.8931 147.659ZM41.1445 147.659L40.7214 147.233L41.1445 147.659ZM59.8449 163.469L59.7394 164.06L59.8449 163.469ZM57.2805 159.803L56.6901 159.696L57.2805 159.803ZM67.2325 164.254L67.823 164.361L67.2325 164.254ZM66.6179 164.679L66.7234 164.088L66.6179 164.679ZM65.885 153.853L65.7795 154.444L65.885 153.853ZM68.4494 157.52L67.859 157.413L68.4494 157.52ZM59.112 152.643L59.2175 152.052H59.2175L59.112 152.643ZM58.4974 153.068L59.0878 153.175L58.4974 153.068ZM40.7123 139.73L40.6213 139.137L29.304 140.873L29.395 141.466L29.4859 142.059L40.8033 140.323L40.7123 139.73ZM28.7925 140.712L29.3469 140.941L33.5607 130.761L33.0063 130.532L32.4519 130.303L28.2381 140.482L28.7925 140.712ZM33.9546 130.387L33.4954 130.773L40.599 139.216L41.0581 138.83L41.5173 138.444L34.4137 130L33.9546 130.387ZM33.0063 130.532L33.5607 130.761C33.5587 130.766 33.5532 130.774 33.5452 130.78C33.5385 130.785 33.5332 130.787 33.5303 130.787C33.5274 130.788 33.5221 130.788 33.5147 130.785C33.5056 130.782 33.4985 130.776 33.4954 130.773L33.9546 130.387L34.4137 130C33.8556 129.337 32.7847 129.499 32.4519 130.303L33.0063 130.532ZM29.395 141.466L29.304 140.873C29.3038 140.873 29.3063 140.872 29.3105 140.873C29.3146 140.873 29.319 140.875 29.3231 140.876C29.331 140.879 29.3362 140.884 29.3396 140.888C29.343 140.892 29.3473 140.9 29.3492 140.911C29.3513 140.925 29.3488 140.937 29.3469 140.941L28.7925 140.712L28.2381 140.482C27.8892 141.325 28.6083 142.193 29.4859 142.059L29.395 141.466ZM40.7123 139.73L40.8033 140.323C41.6838 140.188 42.1041 139.141 41.5173 138.444L41.0581 138.83L40.599 139.216C40.5961 139.213 40.5903 139.203 40.5882 139.189C40.5865 139.178 40.5883 139.169 40.5904 139.164C40.5926 139.158 40.5965 139.152 40.6034 139.146C40.607 139.143 40.611 139.141 40.6149 139.139C40.619 139.137 40.6214 139.137 40.6213 139.137L40.7123 139.73ZM41.8931 147.659L41.47 148.084L48.2075 154.783L48.6305 154.358L49.0536 153.933L42.3161 147.233L41.8931 147.659ZM48.6305 155.102L48.2075 154.677L41.47 161.376L41.8931 161.801L42.3161 162.227L49.0536 155.528L48.6305 155.102ZM41.1445 161.801L41.5675 161.376L34.8301 154.677L34.407 155.102L33.984 155.528L40.7214 162.227L41.1445 161.801ZM34.407 154.358L34.8301 154.783L41.5675 148.084L41.1445 147.659L40.7214 147.233L33.984 153.933L34.407 154.358ZM34.407 155.102L34.8301 154.677C34.8593 154.706 34.8593 154.754 34.8301 154.783L34.407 154.358L33.984 153.933C33.5413 154.373 33.5413 155.088 33.984 155.528L34.407 155.102ZM41.8931 161.801L41.47 161.376C41.4973 161.349 41.5402 161.349 41.5675 161.376L41.1445 161.801L40.7214 162.227C41.1622 162.665 41.8754 162.665 42.3161 162.227L41.8931 161.801ZM48.6305 154.358L48.2075 154.783C48.1783 154.754 48.1783 154.706 48.2075 154.677L48.6305 155.102L49.0536 155.528C49.4962 155.088 49.4962 154.373 49.0536 153.933L48.6305 154.358ZM41.8931 147.659L42.3161 147.233C41.8754 146.795 41.1622 146.795 40.7214 147.233L41.1445 147.659L41.5675 148.084C41.5402 148.112 41.4973 148.112 41.47 148.084L41.8931 147.659ZM59.112 152.643L59.0065 153.234L65.7795 154.444L65.885 153.853L65.9905 153.262L59.2175 152.052L59.112 152.643ZM68.4494 157.52L67.859 157.413L66.6421 164.147L67.2325 164.254L67.823 164.361L69.0398 157.626L68.4494 157.52ZM66.6179 164.679L66.7234 164.088L59.9504 162.879L59.8449 163.469L59.7394 164.06L66.5124 165.27L66.6179 164.679ZM57.2805 159.803L57.871 159.909L59.0878 153.175L58.4974 153.068L57.907 152.961L56.6901 159.696L57.2805 159.803ZM59.8449 163.469L59.9504 162.879C58.5476 162.628 57.6203 161.296 57.871 159.909L57.2805 159.803L56.6901 159.696C56.3204 161.742 57.6893 163.694 59.7394 164.06L59.8449 163.469ZM67.2325 164.254L66.6421 164.147C66.6498 164.105 66.6884 164.082 66.7234 164.088L66.6179 164.679L66.5124 165.27C67.1229 165.379 67.7119 164.976 67.823 164.361L67.2325 164.254ZM65.885 153.853L65.7795 154.444C67.1823 154.694 68.1096 156.026 67.859 157.413L68.4494 157.52L69.0398 157.626C69.4096 155.58 68.0407 153.629 65.9905 153.262L65.885 153.853ZM59.112 152.643L59.2175 152.052C58.607 151.943 58.018 152.347 57.907 152.961L58.4974 153.068L59.0878 153.175C59.0802 153.217 59.0415 153.24 59.0065 153.234L59.112 152.643Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/></svg>",
	"200x200_maximize": "<svg width=\"200\" height=\"200\" viewBox=\"0 0 320 320\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M71.8895 229.487L76.9887 210.481C77.6971 207.841 79.2901 205.523 81.5023 203.913L84.5482 201.697M93.831 287L92.9104 273.523C92.7569 271.276 91.8245 269.153 90.2735 267.518L69.2802 245.387C66.4187 242.37 65.3312 238.086 66.408 234.073L70.8276 217.6C71.2699 215.951 72.4985 214.627 74.1106 214.061L75.6106 213.535M78.2628 224.881L83.9146 203.815C85.0137 199.719 87.6524 196.203 91.2815 194L104.272 186.115M127 279.973L123.62 266.937C121.926 260.403 121.955 253.542 123.705 247.022L125.467 240.454C126.325 237.255 126.362 233.891 125.575 230.674L118.779 202.914C118.664 202.444 118.618 201.96 118.642 201.477L119.094 192.365C119.118 191.894 118.81 191.461 118.342 191.407C115.697 191.102 113.157 192.769 112.448 195.414L110.188 203.835C109.409 206.74 109.209 209.769 109.6 212.75L110.352 218.48C110.579 220.211 108.84 221.535 107.229 220.859L103.879 219.451C101.501 218.452 100.138 215.937 100.601 213.402L101.365 209.224C102.442 203.338 105.119 197.86 109.104 193.391L109.611 192.823C112.54 189.539 112.71 184.637 110.017 181.158C109.863 180.96 109.569 180.946 109.398 181.129L105.061 185.769L96.1971 194.359C94.0584 196.431 92.5218 199.044 91.7505 201.919L86.9369 219.86\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M237.495 134.355L237.895 134.055L237.495 134.355ZM229.534 128.448L229.363 128.918L229.534 128.448ZM200.422 117.843L200.593 117.373H200.593L200.422 117.843ZM195.525 113.729L195.958 113.479L195.525 113.729ZM196.355 99.3911L195.989 99.7321L196.355 99.3911ZM200.263 103.582L200.629 103.241L200.263 103.582ZM201.244 104.198L201.392 103.72H201.392L201.244 104.198ZM210.688 107.128L210.836 106.65L210.688 107.128ZM217.628 100.592L218.113 100.472L217.628 100.592ZM215.789 93.1163L215.304 93.2357L215.789 93.1163ZM206.72 83.6106L206.862 83.1312L206.72 83.6106ZM205.882 83.3621L205.74 83.8414H205.74L205.882 83.3621ZM201.146 85.149L201.569 85.4149L201.146 85.149ZM196.405 92.6946L195.982 92.4286L196.405 92.6946ZM195.799 78.7075L196.242 78.9386L195.799 78.7075ZM207.593 73.2602L207.482 73.7476L207.593 73.2602ZM231.042 74.591C231.227 74.7961 231.543 74.8125 231.748 74.6277C231.953 74.4428 231.97 74.1267 231.785 73.9215L231.042 74.591ZM213.259 54.1105L213.631 53.7758C213.623 53.7668 213.614 53.7582 213.605 53.7498L213.259 54.1105ZM195.67 37.2216L196.017 36.861C195.906 36.7546 195.753 36.7051 195.601 36.7265C195.449 36.748 195.315 36.8381 195.238 36.9709L195.67 37.2216ZM194.957 38.4527L194.524 38.202V38.202L194.957 38.4527ZM195.787 47.3714L195.408 47.6976L195.787 47.3714ZM206.77 60.1248L207.178 59.8356C207.169 59.8228 207.159 59.8104 207.149 59.7985L206.77 60.1248ZM217.049 75.4927C217.208 75.718 217.521 75.7711 217.746 75.6115C217.971 75.4518 218.024 75.1397 217.865 74.9144L217.049 75.4927ZM239.601 75.191C239.714 75.4431 240.009 75.5562 240.262 75.4436C240.514 75.331 240.627 75.0353 240.514 74.7832L239.601 75.191ZM232.018 56.9873L232.475 56.7834C232.467 56.7662 232.459 56.7494 232.449 56.7331L232.018 56.9873ZM219.202 35.2801L219.633 35.0259L219.633 35.0259L219.202 35.2801ZM216.662 43.5288L216.205 43.7321L216.662 43.5288ZM223.176 58.1588L223.661 58.0401C223.654 58.011 223.644 57.9827 223.632 57.9554L223.176 58.1588ZM224.835 67.053C224.901 67.3213 225.171 67.4856 225.44 67.42C225.708 67.3544 225.872 67.0838 225.807 66.8155L224.835 67.053ZM218.319 35.1573L218.663 35.5193V35.5193L218.319 35.1573ZM237.767 70.456C237.757 70.732 237.973 70.9634 238.249 70.973C238.525 70.9825 238.757 70.7665 238.766 70.4906L237.767 70.456ZM238.501 63.7025L238.001 63.6786L238.001 63.6852L238.501 63.7025ZM238.868 56.0321L239.367 56.056L238.868 56.0321ZM245.666 71.187L246.165 71.1716C246.165 71.1615 246.165 71.1514 246.164 71.1413L245.666 71.187ZM246.04 83.383L245.54 83.3983V83.3983L246.04 83.383ZM246.114 84.0049L246.603 83.9018V83.9018L246.114 84.0049ZM249.151 98.4152L249.64 98.312L249.151 98.4152ZM255.516 111.063L255.142 111.395L255.516 111.063ZM272.626 131.139C272.809 131.346 273.125 131.365 273.331 131.182C273.538 130.999 273.557 130.683 273.374 130.476L272.626 131.139ZM243.902 51.946L244.4 51.9003L243.902 51.946ZM187.774 94.0987L187.331 93.8675L187.774 94.0987ZM188.192 95.3677L188.379 94.9036L188.192 95.3677ZM187.409 99.6368L187.842 99.3872L187.409 99.6368ZM187.646 98.4246L187.929 98.8372L187.646 98.4246ZM252.227 154L252.627 153.7L237.895 134.055L237.495 134.355L237.095 134.655L251.827 154.3L252.227 154ZM229.534 128.448L229.705 127.978L200.593 117.373L200.422 117.843L200.251 118.313L229.363 128.918L229.534 128.448ZM195.525 113.729L195.958 113.479L187.842 99.3872L187.409 99.6368L186.975 99.8863L195.092 113.978L195.525 113.729ZM196.355 99.3911L195.989 99.7321L199.898 103.923L200.263 103.582L200.629 103.241L196.721 99.0501L196.355 99.3911ZM201.244 104.198L201.096 104.675L210.539 107.605L210.688 107.128L210.836 106.65L201.392 103.72L201.244 104.198ZM217.628 100.592L218.113 100.472L216.275 92.9969L215.789 93.1163L215.304 93.2357L217.142 100.711L217.628 100.592ZM206.72 83.6106L206.862 83.1312L206.024 82.8827L205.882 83.3621L205.74 83.8414L206.578 84.0899L206.72 83.6106ZM201.146 85.149L200.722 84.883L195.982 92.4286L196.405 92.6946L196.829 92.9606L201.569 85.4149L201.146 85.149ZM187.774 94.0987L188.217 94.3299L196.242 78.9386L195.799 78.7075L195.355 78.4763L187.331 93.8675L187.774 94.0987ZM207.593 73.2602L207.482 73.7476L221.115 76.8643L221.226 76.3769L221.338 75.8895L207.705 72.7728L207.593 73.2602ZM195.799 78.7075L196.242 78.9386C198.372 74.8539 202.99 72.7208 207.482 73.7476L207.593 73.2602L207.705 72.7728C202.77 71.6446 197.695 73.9883 195.355 78.4763L195.799 78.7075ZM196.405 92.6946L195.982 92.4286C194.358 95.0143 191.136 96.0104 188.379 94.9036L188.192 95.3677L188.006 95.8317C191.206 97.116 194.944 95.9614 196.829 92.9606L196.405 92.6946ZM205.882 83.3621L206.024 82.8827C204.008 82.285 201.841 83.1026 200.722 84.883L201.146 85.149L201.569 85.4149C202.449 84.0145 204.154 83.3712 205.74 83.8414L205.882 83.3621ZM215.789 93.1163L216.275 92.9969C215.112 88.2704 211.529 84.5151 206.862 83.1312L206.72 83.6106L206.578 84.0899C210.905 85.3728 214.226 88.8541 215.304 93.2357L215.789 93.1163ZM200.263 103.582L199.898 103.923C200.225 104.274 200.638 104.533 201.096 104.675L201.244 104.198L201.392 103.72C201.101 103.63 200.837 103.464 200.629 103.241L200.263 103.582ZM187.646 98.4246L187.929 98.8372C190.432 97.1227 193.869 97.4584 195.989 99.7321L196.355 99.3911L196.721 99.0501C194.259 96.4105 190.271 96.0216 187.364 98.0121L187.646 98.4246ZM200.422 117.843L200.593 117.373C198.638 116.661 196.997 115.282 195.958 113.479L195.525 113.729L195.092 113.978C196.248 115.985 198.074 117.52 200.251 118.313L200.422 117.843ZM210.688 107.128L210.539 107.605C214.979 108.983 219.223 104.986 218.113 100.472L217.628 100.592L217.142 100.711C218.066 104.469 214.533 107.797 210.836 106.65L210.688 107.128ZM237.495 134.355L237.895 134.055C235.813 131.278 232.967 129.167 229.705 127.978L229.534 128.448L229.363 128.918C232.442 130.04 235.129 132.033 237.095 134.655L237.495 134.355ZM231.414 74.2563L231.785 73.9215L213.631 53.7758L213.259 54.1105L212.888 54.4452L231.042 74.591L231.414 74.2563ZM213.259 54.1105L213.605 53.7498L196.017 36.861L195.67 37.2216L195.324 37.5823L212.913 54.4711L213.259 54.1105ZM195.67 37.2216L195.238 36.9709L194.524 38.202L194.957 38.4527L195.389 38.7035L196.103 37.4724L195.67 37.2216ZM195.787 47.3714L195.408 47.6976L206.391 60.451L206.77 60.1248L207.149 59.7985L196.166 47.0451L195.787 47.3714ZM206.77 60.1248L206.362 60.4139L217.049 75.4927L217.457 75.2035L217.865 74.9144L207.178 59.8356L206.77 60.1248ZM194.957 38.4527L194.524 38.202C192.767 41.2327 193.122 45.0431 195.408 47.6976L195.787 47.3714L196.166 47.0451C194.158 44.7132 193.846 41.3658 195.389 38.7035L194.957 38.4527ZM240.058 74.9871L240.514 74.7832L232.475 56.7834L232.018 56.9873L231.562 57.1912L239.601 75.191L240.058 74.9871ZM232.018 56.9873L232.449 56.7331L219.633 35.0259L219.202 35.2801L218.772 35.5343L231.588 57.2415L232.018 56.9873ZM216.662 43.5288L216.205 43.7321L222.719 58.3622L223.176 58.1588L223.632 57.9554L217.119 43.3254L216.662 43.5288ZM223.176 58.1588L222.69 58.2775L224.835 67.053L225.321 66.9343L225.807 66.8155L223.661 58.0401L223.176 58.1588ZM218.319 35.1573L217.974 34.7953C215.554 37.101 214.846 40.6789 216.205 43.7321L216.662 43.5288L217.119 43.3254C215.931 40.6585 216.55 37.5332 218.663 35.5193L218.319 35.1573ZM219.202 35.2801L219.633 35.0259C219.283 34.4331 218.472 34.3205 217.974 34.7953L218.319 35.1573L218.663 35.5193C218.696 35.4883 218.749 35.4957 218.772 35.5343L219.202 35.2801ZM238.266 70.4733L238.766 70.4906L239 63.7198L238.501 63.7025L238.001 63.6852L237.767 70.456L238.266 70.4733ZM238.501 63.7025L239 63.7264L239.367 56.056L238.868 56.0321L238.368 56.0082L238.001 63.6786L238.501 63.7025ZM243.902 51.946L243.404 51.9916L245.168 71.2326L245.666 71.187L246.164 71.1413L244.4 51.9003L243.902 51.946ZM245.666 71.187L245.166 71.2023L245.54 83.3983L246.04 83.383L246.539 83.3677L246.165 71.1716L245.666 71.187ZM246.114 84.0049L245.625 84.108L248.662 98.5183L249.151 98.4152L249.64 98.312L246.603 83.9018L246.114 84.0049ZM255.516 111.063L255.142 111.395L272.626 131.139L273 130.807L273.374 130.476L255.891 110.732L255.516 111.063ZM249.151 98.4152L248.662 98.5183C249.67 103.299 251.903 107.737 255.142 111.395L255.516 111.063L255.891 110.732C252.766 107.203 250.612 102.924 249.64 98.312L249.151 98.4152ZM246.04 83.383L245.54 83.3983C245.547 83.6369 245.576 83.8744 245.625 84.108L246.114 84.0049L246.603 83.9018C246.566 83.726 246.545 83.5472 246.539 83.3677L246.04 83.383ZM238.868 56.0321L239.367 56.056C239.469 53.9145 240.961 52.1355 242.972 51.6123L242.846 51.1285L242.72 50.6446C240.293 51.2761 238.492 53.4224 238.368 56.0082L238.868 56.0321ZM243.902 51.946L244.4 51.9003C244.328 51.1175 243.607 50.4138 242.72 50.6446L242.846 51.1285L242.972 51.6123C243.07 51.5868 243.161 51.6091 243.24 51.6726C243.324 51.7399 243.391 51.8532 243.404 51.9916L243.902 51.946ZM187.774 94.0987L187.331 93.8675C186.969 94.5609 187.191 95.5042 188.006 95.8317L188.192 95.3677L188.379 94.9036C188.2 94.8318 188.083 94.5868 188.217 94.3299L187.774 94.0987ZM187.409 99.6368L187.842 99.3872C187.715 99.1667 187.782 98.9376 187.929 98.8372L187.646 98.4246L187.364 98.0121C186.725 98.4498 186.627 99.2814 186.975 99.8863L187.409 99.6368Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M112 107.5C112 108.881 113.119 110 114.5 110C115.881 110 117 108.881 117 107.5C117 106.119 115.881 105 114.5 105C113.119 105 112 106.119 112 107.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M119 107.5C119 108.881 120.119 110 121.5 110C122.881 110 124 108.881 124 107.5C124 106.119 122.881 105 121.5 105C120.119 105 119 106.119 119 107.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M125 107.5C125 108.881 126.119 110 127.5 110C128.881 110 130 108.881 130 107.5C130 106.119 128.881 105 127.5 105C126.119 105 125 106.119 125 107.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M128 118H104V142M128 118V142M128 118H152M128 142H104M128 142H152M128 142V166M104 142V166H128M152 118V142M152 118H176M152 142H176M152 142V166M176 118V142M176 118H198M176 142H200M176 142V166M200 142V166M200 142V119M128 166H152M128 166V190H152M152 166H176M152 166V190M176 166H200M176 166V190H152M200 166V178C200 184.627 194.627 190 188 190H113M104 185V109C104 102.373 109.373 97 116 97H189\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M121 158H129C133.418 158 137 161.582 137 166C137 170.418 133.418 174 129 174C124.582 174 121 170.418 121 166V158Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M146 130H153.5C157.642 130 161 133.358 161 137.5C161 141.642 157.642 145 153.5 145C149.358 145 146 141.642 146 137.5V130Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M169 158H179C184.523 158 189 162.477 189 168C189 173.523 184.523 178 179 178C173.477 178 169 173.523 169 168V158Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"200x200_ri-single-platform": "<svg width=\"200\" height=\"200\" viewBox=\"0 0 320 320\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M126.567 186.606L109.567 216.051C105.287 223.465 95.8071 226.005 88.3936 221.725C80.9801 217.444 78.44 207.965 82.7202 200.551L99.7202 171.106C104 163.693 113.48 161.153 120.894 165.433C128.307 169.713 130.847 179.193 126.567 186.606Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M171.371 184.964L191.182 191.304C195.968 192.836 198.606 197.958 197.075 202.744L190.734 222.555C190.549 223.134 189.93 223.452 189.352 223.267L169.541 216.927C164.755 215.395 162.117 210.273 163.648 205.487L169.989 185.676C170.174 185.098 170.793 184.779 171.371 184.964Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M222 193.5C230.56 193.5 237.5 200.44 237.5 209C237.5 217.56 230.56 224.5 222 224.5C213.44 224.5 206.5 217.56 206.5 209V193.5H222Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M157.511 194.603L157.715 223.403C157.719 224.01 157.23 224.506 156.623 224.511L127.823 224.715C127.216 224.719 126.72 224.23 126.715 223.623L126.511 194.823C126.507 194.216 126.996 193.72 127.603 193.715L156.403 193.511C157.01 193.507 157.506 193.996 157.511 194.603Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M203.536 148.134C204.316 147.441 205.536 147.83 205.771 148.846L214.22 185.353C214.464 186.411 213.469 187.323 212.463 187.003L176.011 175.394C175.005 175.074 174.721 173.754 175.532 173.032L203.536 148.134Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M136.939 174.763C133.973 166.147 138.554 156.757 147.17 153.791C155.787 150.825 165.176 155.405 168.142 164.022C171.108 172.638 166.528 182.028 157.911 184.994L142.31 190.364L136.939 174.763Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M132.237 115.829C132.199 114.629 133.66 114.127 134.368 115.096L142.681 126.474L142.898 126.772L156.055 122.251C157.104 121.89 158.114 123.149 157.445 124.152L149.786 135.645L149.592 135.935L149.797 136.217L158.143 147.641C158.505 148.136 158.456 148.703 158.178 149.108C157.903 149.51 157.419 149.73 156.869 149.548L143.848 145.218L143.485 145.098L143.273 145.415L135.662 156.834C135.341 157.316 134.824 157.44 134.36 157.292C133.892 157.144 133.505 156.726 133.486 156.113L133.048 141.972L133.036 141.624L132.705 141.514L119.599 137.156C118.455 136.775 118.478 135.162 119.528 134.802L132.685 130.281L132.673 129.913L132.237 115.829Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M190.817 119.611L199.317 134.334C201.526 138.16 200.215 143.053 196.389 145.262C192.562 147.471 187.67 146.16 185.461 142.334L184.595 142.834C186.804 146.66 185.493 151.553 181.666 153.762C177.84 155.971 172.947 154.66 170.738 150.834L162.238 136.111C160.029 132.285 161.34 127.392 165.166 125.183C168.993 122.974 173.885 124.285 176.095 128.111L176.961 127.611C174.751 123.785 176.062 118.892 179.889 116.683C183.715 114.474 188.608 115.785 190.817 119.611Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M178 101C178 110.941 169.941 119 160 119C150.059 119 142 110.941 142 101C142 91.0589 150.059 83 160 83C169.941 83 178 91.0589 178 101Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M26 271L33.6195 263.138C37.5515 259.081 38.9479 253.197 37.2584 247.806L32.0014 231.031C31.699 230.066 31.4682 229.08 31.311 228.081L28.511 210.288C28.5101 210.283 28.5137 210.277 28.5193 210.276L29.3365 210.056C31.4525 209.487 33.6036 210.845 34 213M37.0172 239L34.2432 225.089C34.0817 224.279 34.0184 223.452 34.0549 222.627L34.9655 202L36.8129 202.649C38.9425 203.397 40.3344 205.447 40.2433 207.702L39.9448 215.092C39.9242 215.6 39.9795 216.11 40.1087 216.602L41 220M40.5556 237L39.1058 230.082C38.3985 226.706 39.0786 223.188 40.993 220.32L55.8149 198.111C55.853 198.054 55.9341 198.046 55.9823 198.095C58.9104 201.079 59.3606 205.701 57.0635 209.194L50.1389 219.723M45.125 235.079L44.3722 227.577C44.1464 225.327 45.2842 223.159 47.2641 222.066L67.2303 211.046C67.2714 211.023 67.324 211.045 67.3348 211.091C68.3276 215.29 66.5015 219.651 62.8127 221.889L56.956 225.443C54.3274 227.039 52.8988 230.044 53.3217 233.09L55.1553 246.296C55.6982 250.206 60.266 252.068 63.3875 249.651L72.5 242.595L79.2878 235.018C81.2883 232.785 84.7682 232.733 86.8348 234.905L87 235.079L80.625 244.251L67.9021 268.366C66.8923 270.28 65.5453 271.995 63.9258 273.431L52 284\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M290 233L280.814 227.043C276.074 223.969 273.396 218.547 273.836 212.914L275.205 195.388C275.284 194.38 275.288 193.367 275.217 192.359L273.964 174.391C273.963 174.385 273.959 174.38 273.953 174.38L273.841 174.376C271.22 174.279 269.043 176.378 269.043 179M272.059 203.675L271.649 189.496C271.626 188.671 271.502 187.851 271.282 187.055L265.777 167.155L264.122 168.201C262.214 169.406 261.316 171.716 261.91 173.894L263.887 181.145C264 181.56 264.06 181.987 264.067 182.417L264.136 186.97M267.509 202.572L267.374 195.505C267.308 192.057 265.857 188.78 263.35 186.413L243.933 168.085C243.883 168.038 243.802 168.048 243.766 168.107C241.58 171.671 242.176 176.276 245.197 179.166L254.302 187.878M262.968 201.568L262.077 194.589C261.751 192.041 259.944 189.927 257.478 189.206L236.328 183.029C236.282 183.016 236.235 183.05 236.235 183.097C236.22 187.416 238.969 191.26 243.061 192.641L249.425 194.789C252.318 195.766 254.362 198.359 254.635 201.4L255.589 212.027C256.182 218.628 251.809 224.653 245.35 226.137L242.137 226.875L231.546 227.458C229.537 227.569 227.778 228.842 227.045 230.716L226.17 232.954L239.656 235.73L249.767 237.102C254.215 237.705 258.277 239.95 261.153 243.396L267.305 250.767\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M249 213L161.732 61.9963C160.962 60.6639 159.038 60.6639 158.268 61.9963L71 213\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></svg>",
	"200x200_usp": "<svg width=\"200\" height=\"200\" viewBox=\"0 0 320 320\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M157.761 219.526L163 222.525L156.992 222.929L160.426 227.927L154.839 225.657L155.786 231.666L151.727 227.173L150 233L148.272 227.173L144.214 231.666L145.16 225.657L139.574 227.927L143.007 222.929L137 222.525L142.238 219.526L139.572 218H141.616L143.509 219.083L144.282 219.526L140.422 221.736L144.849 222.033L142.32 225.715L146.436 224.043L145.736 228.47L148.728 225.159L150 229.455L151.272 225.159L154.263 228.47L153.564 224.043L157.679 225.715L155.151 222.033L159.577 221.736L155.718 219.526L158.383 218H160.428L157.761 219.526Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M64 122.8H40V146.8M64 122.8V146.8M64 122.8H88M64 146.8H40M64 146.8H88M64 146.8V170.8M40 146.8V170.8M88 122.8V146.8M88 122.8H112M88 146.8H112M88 146.8V170.8M112 122.8V146.8M112 122.8H136M112 146.8H136M112 146.8V170.8M136 122.8V146.8M136 122.8H160M136 146.8H160M136 146.8V170.8M160 122.8V146.8M160 122.8H184M160 146.8H184M160 146.8V170.8M184 122.8V146.8M184 122.8H208M184 146.8H208M184 146.8V170.8M208 122.8V146.8M208 122.8H232M208 146.8H232M208 146.8V170.8M232 122.8V146.8M232 122.8H256M232 146.8H256M232 146.8V170.8M256 122.8V146.8M256 122.8H280V146.8M256 146.8H280M256 146.8V170.8M280 146.8V170.8M64 170.8H40M64 170.8H88M64 170.8V194.8M40 170.8V194.8H64M88 170.8H112M88 170.8V194.8M112 170.8H136M112 170.8V194.8M136 170.8H160M136 170.8V194.8M160 170.8H184M160 170.8V194.8M184 170.8H208M184 170.8V194.8M208 170.8H232M208 170.8V194.8M232 170.8H256M232 170.8V194.8M256 170.8H280M256 170.8V194.8M280 170.8V194.8H256M64 194.8H88M64 194.8V218H88M88 194.8H112M88 194.8V218M112 194.8H136M112 194.8V218M136 194.8H160M136 194.8V218M160 194.8H184M160 194.8V218M184 194.8H208M184 194.8V218M208 194.8H232M208 194.8V218M232 194.8H256M232 194.8V218M256 194.8V218H232M88 218H112M112 218H136M136 218H160M160 218H184M184 218H208M208 218H232M52 218H268C274.627 218 280 212.627 280 206V114C280 107.373 274.627 102 268 102H52C45.3726 102 40 107.373 40 114V206C40 212.627 45.3726 218 52 218Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M48 112.5C48 113.881 49.1193 115 50.5 115C51.8807 115 53 113.881 53 112.5C53 111.119 51.8807 110 50.5 110C49.1193 110 48 111.119 48 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M55 112.5C55 113.881 56.1193 115 57.5 115C58.8807 115 60 113.881 60 112.5C60 111.119 58.8807 110 57.5 110C56.1193 110 55 111.119 55 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M61 112.5C61 113.881 62.1193 115 63.5 115C64.8807 115 66 113.881 66 112.5C66 111.119 64.8807 110 63.5 110C62.1193 110 61 111.119 61 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M184.5 135H196C202.351 135 207.5 140.149 207.5 146.5C207.5 152.851 202.351 158 196 158C189.649 158 184.5 152.851 184.5 146.5V135Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M88.5 171V179C88.5 183.418 92.0817 187 96.5 187C100.918 187 104.5 183.418 104.5 179C104.5 174.582 100.918 171 96.5 171L88.5 171Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M208.5 207V195.5C208.5 189.149 213.649 184 220 184C226.351 184 231.5 189.149 231.5 195.5C231.5 201.851 226.351 207 220 207L208.5 207Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M123.353 91.8654C125.892 90.119 129.313 90.3338 131.492 92.5468L129.837 94.228C132.789 94.861 135 97.4415 135 100.53H131.312C131.721 100.983 132.058 101.479 132.324 102H131.172C130.998 101.727 130.799 101.464 130.575 101.215L129.041 99.5145H133.901C133.489 97.3947 131.813 95.6899 129.63 95.2218L127.825 94.835L130.008 92.6172C128.213 91.3958 125.794 91.4125 123.913 92.7065L122.353 93.7797V90.1148C120.266 90.5333 118.588 92.2366 118.127 94.4531L117.746 96.284L115.561 94.0683C114.532 95.6253 114.397 97.6451 115.175 99.3964L115.812 100.83H113.099C113.178 101.237 113.305 101.629 113.473 102H112.388C112.137 101.317 112 100.581 112 99.814H114.264C113.188 97.393 113.588 94.4964 115.492 92.5627L117.148 94.2428C117.772 91.2451 120.312 89.0004 123.353 89V91.8654Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M231 102H230V90.1351C227.588 90.5942 225.456 91.8062 223.871 93.5073L223 94.4422V90.1351C220.588 90.5942 218.456 91.8062 216.871 93.5073L216 94.4422V90.1351C210.869 91.1114 207 95.4883 207 100.737L207.012 101.244C207.024 101.498 207.048 101.75 207.078 102H206.073C206.047 101.765 206.025 101.529 206.014 101.29L206 100.737C206 94.8017 210.535 89.895 216.43 89.0788L217 89V92.0125C218.753 90.4731 220.972 89.4191 223.43 89.0788L224 89V92.0125C225.753 90.4731 227.972 89.4191 230.43 89.0788L231 89V102Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></svg>",
	"320x320_message-sent": "<svg width=\"320\" height=\"320\" viewBox=\"0 0 320 320\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M48 112.5C48 113.881 49.1193 115 50.5 115C51.8807 115 53 113.881 53 112.5C53 111.119 51.8807 110 50.5 110C49.1193 110 48 111.119 48 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M55 112.5C55 113.881 56.1193 115 57.5 115C58.8807 115 60 113.881 60 112.5C60 111.119 58.8807 110 57.5 110C56.1193 110 55 111.119 55 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M61 112.5C61 113.881 62.1193 115 63.5 115C64.8807 115 66 113.881 66 112.5C66 111.119 64.8807 110 63.5 110C62.1193 110 61 111.119 61 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M225.584 218H52C45.3727 218 40.0003 212.628 40 206V183.287L209.368 112.768L223.374 121.977L225.555 133.313L232.337 127.068L247.781 136.955L260.204 91.6011H260.206L225.584 218Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M40 122.8V122.3C39.7239 122.3 39.5 122.524 39.5 122.8H40ZM280 122.8H280.5C280.5 122.524 280.276 122.3 280 122.3V122.8ZM40 194.8H39.5C39.5 195.076 39.7239 195.3 40 195.3V194.8ZM280 194.8V195.3C280.276 195.3 280.5 195.076 280.5 194.8H280ZM64 218H63.5C63.5 218.276 63.7239 218.5 64 218.5V218ZM256 218V218.5C256.276 218.5 256.5 218.276 256.5 218H256ZM247.782 136.954L247.512 137.375C247.646 137.461 247.813 137.478 247.961 137.421C248.109 137.364 248.222 137.239 248.264 137.086L247.782 136.954ZM225.556 133.312L225.065 133.407C225.099 133.585 225.227 133.731 225.399 133.787C225.572 133.844 225.761 133.803 225.894 133.68L225.556 133.312ZM248.486 104.174C248.709 104.011 248.757 103.698 248.593 103.476C248.43 103.253 248.117 103.205 247.895 103.368L248.486 104.174ZM260.206 91.6011L260.689 91.7332C260.739 91.5489 260.68 91.352 260.537 91.2258C260.393 91.0996 260.191 91.0661 260.014 91.1395L260.206 91.6011ZM209.362 112.764L209.17 112.302C208.999 112.373 208.881 112.533 208.864 112.717C208.847 112.901 208.933 113.08 209.087 113.181L209.362 112.764ZM227.942 123.578C227.711 123.427 227.401 123.491 227.249 123.722C227.098 123.952 227.162 124.262 227.392 124.414L227.942 123.578ZM219 123.3C219.276 123.3 219.5 123.076 219.5 122.8C219.5 122.524 219.276 122.3 219 122.3V123.3ZM253.5 122.3C253.224 122.3 253 122.524 253 122.8C253 123.076 253.224 123.3 253.5 123.3V122.3ZM40 122.8V123.3H64V122.8V122.3H40V122.8ZM64 122.8H63.5V146.8H64H64.5V122.8H64ZM64 146.8V146.3H40V146.8V147.3H64V146.8ZM40 146.8H40.5V122.8H40H39.5V146.8H40ZM64 122.8V123.3H88V122.8V122.3H64V122.8ZM88 122.8H87.5V146.8H88H88.5V122.8H88ZM88 146.8V146.3H64V146.8V147.3H88V146.8ZM88 122.8V123.3H112V122.8V122.3H88V122.8ZM112 122.8H111.5V146.8H112H112.5V122.8H112ZM112 146.8V146.3H88V146.8V147.3H112V146.8ZM112 122.8V123.3H136V122.8V122.3H112V122.8ZM136 122.8H135.5V146.8H136H136.5V122.8H136ZM136 146.8V146.3H112V146.8V147.3H136V146.8ZM136 122.8V123.3H160V122.8V122.3H136V122.8ZM160 122.8H159.5V146.8H160H160.5V122.8H160ZM160 146.8V146.3H136V146.8V147.3H160V146.8ZM160 122.8V123.3H184V122.8V122.3H160V122.8ZM184 122.8H183.5V146.8H184H184.5V122.8H184ZM184 146.8V146.3H160V146.8V147.3H184V146.8ZM184 122.8V123.3H208V122.8V122.3H184V122.8ZM208 122.8H207.5V146.8H208H208.5V122.8H208ZM208 146.8V146.3H184V146.8V147.3H208V146.8ZM232 146.8V146.3H208V146.8V147.3H232V146.8ZM256 122.8H255.5V146.8H256H256.5V122.8H256ZM256 146.8V146.3H232V146.8V147.3H256V146.8ZM256 122.8V123.3H280V122.8V122.3H256V122.8ZM280 122.8H279.5V146.8H280H280.5V122.8H280ZM280 146.8V146.3H256V146.8V147.3H280V146.8ZM64 146.8H63.5V170.8H64H64.5V146.8H64ZM64 170.8V170.3H40V170.8V171.3H64V170.8ZM40 170.8H40.5V146.8H40H39.5V170.8H40ZM88 146.8H87.5V170.8H88H88.5V146.8H88ZM88 170.8V170.3H64V170.8V171.3H88V170.8ZM112 146.8H111.5V170.8H112H112.5V146.8H112ZM112 170.8V170.3H88V170.8V171.3H112V170.8ZM136 146.8H135.5V170.8H136H136.5V146.8H136ZM136 170.8V170.3H112V170.8V171.3H136V170.8ZM160 146.8H159.5V170.8H160H160.5V146.8H160ZM160 170.8V170.3H136V170.8V171.3H160V170.8ZM184 146.8H183.5V170.8H184H184.5V146.8H184ZM184 170.8V170.3H160V170.8V171.3H184V170.8ZM208 146.8H207.5V170.8H208H208.5V146.8H208ZM208 170.8V170.3H184V170.8V171.3H208V170.8ZM232 146.8H231.5V170.8H232H232.5V146.8H232ZM232 170.8V170.3H208V170.8V171.3H232V170.8ZM256 146.8H255.5V170.8H256H256.5V146.8H256ZM256 170.8V170.3H232V170.8V171.3H256V170.8ZM280 146.8H279.5V170.8H280H280.5V146.8H280ZM280 170.8V170.3H256V170.8V171.3H280V170.8ZM64 170.8H63.5V194.8H64H64.5V170.8H64ZM64 194.8V194.3H40V194.8V195.3H64V194.8ZM40 194.8H40.5V170.8H40H39.5V194.8H40ZM88 170.8H87.5V194.8H88H88.5V170.8H88ZM88 194.8V194.3H64V194.8V195.3H88V194.8ZM112 170.8H111.5V194.8H112H112.5V170.8H112ZM112 194.8V194.3H88V194.8V195.3H112V194.8ZM136 170.8H135.5V194.8H136H136.5V170.8H136ZM136 194.8V194.3H112V194.8V195.3H136V194.8ZM160 170.8H159.5V194.8H160H160.5V170.8H160ZM160 194.8V194.3H136V194.8V195.3H160V194.8ZM184 170.8H183.5V194.8H184H184.5V170.8H184ZM184 194.8V194.3H160V194.8V195.3H184V194.8ZM208 170.8H207.5V194.8H208H208.5V170.8H208ZM208 194.8V194.3H184V194.8V195.3H208V194.8ZM232 170.8H231.5V194.8H232H232.5V170.8H232ZM232 194.8V194.3H208V194.8V195.3H232V194.8ZM256 170.8H255.5V194.8H256H256.5V170.8H256ZM256 194.8V194.3H232V194.8V195.3H256V194.8ZM280 170.8H279.5V194.8H280H280.5V170.8H280ZM280 194.8V194.3H256V194.8V195.3H280V194.8ZM64 194.8H63.5V218H64H64.5V194.8H64ZM88 194.8H87.5V218H88H88.5V194.8H88ZM88 218V217.5H64V218V218.5H88V218ZM112 194.8H111.5V218H112H112.5V194.8H112ZM112 218V217.5H88V218V218.5H112V218ZM136 194.8H135.5V218H136H136.5V194.8H136ZM136 218V217.5H112V218V218.5H136V218ZM160 194.8H159.5V218H160H160.5V194.8H160ZM160 218V217.5H136V218V218.5H160V218ZM184 194.8H183.5V218H184H184.5V194.8H184ZM184 218V217.5H160V218V218.5H184V218ZM208 194.8H207.5V218H208H208.5V194.8H208ZM208 218V217.5H184V218V218.5H208V218ZM232 194.8H231.5V218H232H232.5V194.8H232ZM232 218V217.5H208V218V218.5H232V218ZM256 194.8H255.5V218H256H256.5V194.8H256ZM256 218V217.5H232V218V218.5H256V218ZM280 114H279.5V206H280H280.5V114H280ZM268 218V217.5H52V218V218.5H268V218ZM40 206H40.5V114H40H39.5V206H40ZM52 218V217.5C45.6487 217.5 40.5 212.351 40.5 206H40H39.5C39.5 212.904 45.0964 218.5 52 218.5V218ZM280 206H279.5C279.5 212.351 274.351 217.5 268 217.5V218V218.5C274.904 218.5 280.5 212.904 280.5 206H280ZM268 102V102.5C274.351 102.5 279.5 107.649 279.5 114H280H280.5C280.5 107.096 274.904 101.5 268 101.5V102ZM52 102V101.5C45.0964 101.5 39.5 107.096 39.5 114H40H40.5C40.5 107.649 45.6487 102.5 52 102.5V102ZM268 102V101.5H257.5V102V102.5H268V102ZM232 134.8H231.5V146.8H232H232.5V134.8H232ZM52 102V102.5H235V102V101.5H52V102ZM247.782 136.954L248.051 136.533L232.608 126.646L232.338 127.067L232.068 127.488L247.512 137.375L247.782 136.954ZM232.338 127.067L231.999 126.7L225.217 132.945L225.556 133.312L225.894 133.68L232.677 127.435L232.338 127.067ZM225.556 133.312L226.047 133.218L223.866 121.883L223.375 121.977L222.884 122.071L225.065 133.407L225.556 133.312ZM223.375 121.977L223.671 122.38L248.486 104.174L248.19 103.771L247.895 103.368L223.079 121.574L223.375 121.977ZM247.782 136.954L248.264 137.086L260.689 91.7332L260.206 91.6011L259.724 91.469L247.299 136.822L247.782 136.954ZM260.206 91.6011L260.014 91.1395L209.17 112.302L209.362 112.764L209.554 113.225L260.398 92.0627L260.206 91.6011ZM209.362 112.764L209.087 113.181L223.1 122.395L223.375 121.977L223.65 121.559L209.637 112.346L209.362 112.764ZM232.338 127.067L232.613 126.65L227.942 123.578L227.667 123.996L227.392 124.414L232.063 127.485L232.338 127.067ZM208 122.8V123.3H219V122.8V122.3H208V122.8ZM256 122.8V122.3H253.5V122.8V123.3H256V122.8Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/></svg>",
	"320x320_skyline": "<svg width=\"320\" height=\"320\" viewBox=\"0 0 320 320\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M85.169 104.569C85.169 112.339 78.8632 118.638 71.0845 118.638C63.3058 118.638 57 112.339 57 104.569C57 96.7989 63.3058 90.5 71.0845 90.5C78.8632 90.5 85.169 96.7989 85.169 104.569Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M271 118C271 134.845 257.345 148.5 240.5 148.5C223.655 148.5 210 134.845 210 118C210 101.155 223.655 87.5 240.5 87.5C257.345 87.5 271 101.155 271 118Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M219.354 180.5C219.078 180.5 218.854 180.724 218.854 181C218.854 181.276 219.078 181.5 219.354 181.5V180.5ZM246.403 206.5C246.403 206.776 246.627 207 246.903 207C247.179 207 247.403 206.776 247.403 206.5H246.403ZM247.403 199C247.403 198.724 247.179 198.5 246.903 198.5C246.627 198.5 246.403 198.724 246.403 199H247.403ZM162.986 213.519L163.437 213.303L162.986 213.519ZM150.441 187.299L149.99 187.515L150.441 187.299ZM136.844 186.9L136.402 186.665L136.844 186.9ZM120.435 217.751L119.993 217.517L120.435 217.751ZM190.729 176.23L191.197 176.404L190.729 176.23ZM177.165 212.622L176.696 212.448L177.165 212.622ZM203.552 176.071L203.088 176.257L203.552 176.071ZM204.865 180.686C204.968 180.942 205.259 181.067 205.515 180.964C205.772 180.861 205.896 180.57 205.793 180.314L204.865 180.686ZM29 163.5C28.7239 163.5 28.5 163.724 28.5 164C28.5 164.276 28.7239 164.5 29 164.5V163.5ZM79.6071 104.5C79.8832 104.5 80.1071 104.276 80.1071 104C80.1071 103.724 79.8832 103.5 79.6071 103.5V104.5ZM75.1 104C75.1 104.276 75.3239 104.5 75.6 104.5C75.8761 104.5 76.1 104.276 76.1 104H75.1ZM127.692 130.5C127.968 130.5 128.192 130.276 128.192 130C128.192 129.724 127.968 129.5 127.692 129.5V130.5ZM104.151 188C104.151 188.276 104.375 188.5 104.651 188.5C104.927 188.5 105.151 188.276 105.151 188H104.151ZM173.773 163.5C174.05 163.5 174.273 163.276 174.273 163C174.273 162.724 174.05 162.5 173.773 162.5V163.5ZM283.986 238V237.5H258.423V238V238.5H283.986V238ZM292 230H292.5V139H292H291.5V230H292ZM283.986 131V130.5H259.926V131V131.5H283.986V131ZM251.911 139H251.411V173H251.911H252.411V139H251.911ZM243.897 181V180.5H219.354V181V181.5H243.897V181ZM251.911 173H251.411C251.411 177.141 248.048 180.5 243.897 180.5V181V181.5C248.599 181.5 252.411 177.695 252.411 173H251.911ZM259.926 131V130.5C255.224 130.5 251.411 134.305 251.411 139H251.911H252.411C252.411 134.859 255.775 131.5 259.926 131.5V131ZM292 139H292.5C292.5 134.305 288.687 130.5 283.986 130.5V131V131.5C288.137 131.5 291.5 134.859 291.5 139H292ZM283.986 238V238.5C288.687 238.5 292.5 234.695 292.5 230H292H291.5C291.5 234.141 288.137 237.5 283.986 237.5V238ZM246.903 206.5H247.403V199H246.903H246.403V206.5H246.903ZM87.8321 222V222.5H113.356V222V221.5H87.8321V222ZM162.986 213.519L163.437 213.303L150.892 187.083L150.441 187.299L149.99 187.515L162.535 213.735L162.986 213.519ZM136.844 186.9L136.402 186.665L119.993 217.517L120.435 217.751L120.876 217.986L137.285 187.135L136.844 186.9ZM190.729 176.23L190.26 176.055L176.696 212.448L177.165 212.622L177.633 212.797L191.197 176.404L190.729 176.23ZM150.441 187.299L150.892 187.083C149.314 183.785 146.574 182.022 143.747 181.939C140.918 181.856 138.108 183.458 136.402 186.665L136.844 186.9L137.285 187.135C138.835 184.22 141.316 182.868 143.717 182.939C146.121 183.009 148.551 184.507 149.99 187.515L150.441 187.299ZM162.986 213.519L162.535 213.735C164.255 217.331 167.301 219.059 170.326 218.868C173.348 218.677 176.223 216.58 177.633 212.797L177.165 212.622L176.696 212.448C175.403 215.918 172.834 217.707 170.263 217.87C167.697 218.032 165.005 216.581 163.437 213.303L162.986 213.519ZM203.552 176.071L203.088 176.257L204.865 180.686L205.329 180.5L205.793 180.314L204.016 175.885L203.552 176.071ZM197.171 171.76V172.26C199.777 172.26 202.12 173.844 203.088 176.257L203.552 176.071L204.016 175.885C202.896 173.091 200.185 171.26 197.171 171.26V171.76ZM190.729 176.23L191.197 176.404C192.126 173.913 194.508 172.26 197.171 172.26V171.76V171.26C194.091 171.26 191.335 173.172 190.26 176.055L190.729 176.23ZM113.356 222V222.5C116.506 222.5 119.399 220.764 120.876 217.986L120.435 217.751L119.993 217.517C118.69 219.967 116.137 221.5 113.356 221.5V222ZM268.942 221H268.442V237.5H268.942H269.442V221H268.942ZM29 164V164.5H42.5416V164V163.5H29V164ZM50.5558 156H51.0558V112H50.5558H50.0558V156H50.5558ZM58.5699 104V104.5H79.6071V104V103.5H58.5699V104ZM50.5558 112H51.0558C51.0558 107.859 54.4191 104.5 58.5699 104.5V104V103.5C53.8685 103.5 50.0558 107.305 50.0558 112H50.5558ZM42.5416 164V164.5C47.243 164.5 51.0558 160.695 51.0558 156H50.5558H50.0558C50.0558 160.141 46.6924 163.5 42.5416 163.5V164ZM75.6 104H76.1V91H75.6H75.1V104H75.6ZM83.6142 83V83.5H103.65V83V82.5H83.6142V83ZM111.664 91H111.164V122H111.664H112.164V91H111.664ZM119.678 130V130.5H127.692V130V129.5H119.678V130ZM111.664 122H111.164C111.164 126.695 114.976 130.5 119.678 130.5V130V129.5C115.527 129.5 112.164 126.141 112.164 122H111.664ZM103.65 83V83.5C107.8 83.5 111.164 86.8587 111.164 91H111.664H112.164C112.164 86.3047 108.351 82.5 103.65 82.5V83ZM75.6 91H76.1C76.1 86.8587 79.4634 83.5 83.6142 83.5V83V82.5C78.9128 82.5 75.1 86.3047 75.1 91H75.6ZM104.651 188H105.151V138H104.651H104.151V188H104.651ZM112.665 130V130.5H134.704V130V129.5H112.665V130ZM142.719 138H142.219V155H142.719H143.219V138H142.719ZM150.733 163V163.5H173.773V163V162.5H150.733V163ZM142.719 155H142.219C142.219 159.695 146.031 163.5 150.733 163.5V163V162.5C146.582 162.5 143.219 159.141 143.219 155H142.719ZM134.704 130V130.5C138.855 130.5 142.219 133.859 142.219 138H142.719H143.219C143.219 133.305 139.406 129.5 134.704 129.5V130ZM104.651 138H105.151C105.151 133.859 108.515 130.5 112.665 130.5V130V129.5C107.964 129.5 104.151 133.305 104.151 138H104.651ZM33.508 222H34.008V197H33.508H33.008V222H33.508ZM41.5221 189V189.5H65.5823V189V188.5H41.5221V189ZM73.5965 197H73.0965V214H73.5965H74.0965V197H73.5965ZM81.6106 222V222.5H104.651V222V221.5H81.6106V222ZM73.5965 214H73.0965C73.0965 218.695 76.9092 222.5 81.6106 222.5V222V221.5C77.4598 221.5 74.0965 218.141 74.0965 214H73.5965ZM65.5823 189V189.5C69.7331 189.5 73.0965 192.859 73.0965 197H73.5965H74.0965C74.0965 192.305 70.2837 188.5 65.5823 188.5V189ZM33.508 197H34.008C34.008 192.859 37.3713 189.5 41.5221 189.5V189V188.5C36.8207 188.5 33.008 192.305 33.008 197H33.508Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/></svg>",
	"320x320_trial-end": "<svg width=\"320\" height=\"320\" viewBox=\"0 0 320 320\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M64 122.8H40V146.8M64 122.8V146.8M64 122.8H88M64 146.8H40M64 146.8H88M64 146.8V170.8M40 146.8V170.8M88 122.8V146.8M88 122.8H112M88 146.8H112M88 146.8V170.8M112 122.8V146.8M112 122.8H136M112 146.8H136M112 146.8V170.8M136 122.8V146.8M136 122.8H160M136 146.8H160M136 146.8V170.8M160 122.8V146.8M160 122.8H184M160 146.8H184M160 146.8V170.8M184 122.8V146.8M184 122.8H208M184 146.8H208M184 146.8V170.8M208 122.8V146.8M208 122.8H232M208 146.8H232M208 146.8V170.8M232 122.8V146.8M232 122.8H256M232 146.8H256M232 146.8V170.8M256 122.8V146.8M256 122.8H280V146.8M256 146.8H280M256 146.8V170.8M280 146.8V170.8M64 170.8H40M64 170.8H88M64 170.8V194.8M40 170.8V194.8H64M88 170.8H112M88 170.8V194.8M112 170.8H136M112 170.8V194.8M136 170.8H160M136 170.8V194.8M160 170.8H184M160 170.8V194.8M184 170.8H208M184 170.8V194.8M208 170.8H232M208 170.8V194.8M232 170.8H256M232 170.8V194.8M256 170.8H280M256 170.8V194.8M280 170.8V194.8H256M64 194.8H88M64 194.8V218H88M88 194.8H112M88 194.8V218M112 194.8H136M112 194.8V218M136 194.8H160M136 194.8V218M160 194.8H184M160 194.8V218M184 194.8H208M184 194.8V218M208 194.8H232M208 194.8V218M232 194.8H256M232 194.8V218M256 194.8V218H232M88 218H112M112 218H136M136 218H160M160 218H184M184 218H208M208 218H232M52 218H268C274.627 218 280 212.627 280 206V114C280 107.373 274.627 102 268 102H52C45.3726 102 40 107.373 40 114V206C40 212.627 45.3726 218 52 218Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M48 112.5C48 113.881 49.1193 115 50.5 115C51.8807 115 53 113.881 53 112.5C53 111.119 51.8807 110 50.5 110C49.1193 110 48 111.119 48 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M55 112.5C55 113.881 56.1193 115 57.5 115C58.8807 115 60 113.881 60 112.5C60 111.119 58.8807 110 57.5 110C56.1193 110 55 111.119 55 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M61 112.5C61 113.881 62.1193 115 63.5 115C64.8807 115 66 113.881 66 112.5C66 111.119 64.8807 110 63.5 110C62.1193 110 61 111.119 61 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M112 226C112 224.895 112.895 224 114 224H206C207.105 224 208 224.895 208 226C208 227.105 207.105 228 206 228H114C112.895 228 112 227.105 112 226Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M136 234C136 232.895 136.895 232 138 232H182C183.105 232 184 232.895 184 234C184 235.105 183.105 236 182 236H138C136.895 236 136 235.105 136 234Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M160 190C181.372 190 200.134 201.175 210.763 218H109.237C119.866 201.175 138.628 190 160 190Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/></svg>",
	"320x320_trial-middle": "<svg width=\"320\" height=\"320\" viewBox=\"0 0 320 320\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M64 122.8H40V146.8M64 122.8V146.8M64 122.8H88M64 146.8H40M64 146.8H88M64 146.8V170.8M40 146.8V170.8M88 122.8V146.8M88 122.8H112M88 146.8H112M88 146.8V170.8M112 122.8V146.8M112 122.8H136M112 146.8H136M112 146.8V170.8M136 122.8V146.8M136 122.8H160M136 146.8H160M136 146.8V170.8M160 122.8V146.8M160 122.8H184M160 146.8H184M160 146.8V170.8M184 122.8V146.8M184 122.8H208M184 146.8H208M184 146.8V170.8M208 122.8V146.8M208 122.8H232M208 146.8H232M208 146.8V170.8M232 122.8V146.8M232 122.8H256M232 146.8H256M232 146.8V170.8M256 122.8V146.8M256 122.8H280V146.8M256 146.8H280M256 146.8V170.8M280 146.8V170.8M64 170.8H40M64 170.8H88M64 170.8V194.8M40 170.8V194.8H64M88 170.8H112M88 170.8V194.8M112 170.8H136M112 170.8V194.8M136 170.8H160M136 170.8V194.8M160 170.8H184M160 170.8V194.8M184 170.8H208M184 170.8V194.8M208 170.8H232M208 170.8V194.8M232 170.8H256M232 170.8V194.8M256 170.8H280M256 170.8V194.8M280 170.8V194.8H256M64 194.8H88M64 194.8V218H88M88 194.8H112M88 194.8V218M112 194.8H136M112 194.8V218M136 194.8H160M136 194.8V218M160 194.8H184M160 194.8V218M184 194.8H208M184 194.8V218M208 194.8H232M208 194.8V218M232 194.8H256M232 194.8V218M256 194.8V218H232M88 218H112M112 218H136M136 218H160M160 218H184M184 218H208M208 218H232M52 218H268C274.627 218 280 212.627 280 206V114C280 107.373 274.627 102 268 102H52C45.3726 102 40 107.373 40 114V206C40 212.627 45.3726 218 52 218Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M48 112.5C48 113.881 49.1193 115 50.5 115C51.8807 115 53 113.881 53 112.5C53 111.119 51.8807 110 50.5 110C49.1193 110 48 111.119 48 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M55 112.5C55 113.881 56.1193 115 57.5 115C58.8807 115 60 113.881 60 112.5C60 111.119 58.8807 110 57.5 110C56.1193 110 55 111.119 55 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M61 112.5C61 113.881 62.1193 115 63.5 115C64.8807 115 66 113.881 66 112.5C66 111.119 64.8807 110 63.5 110C62.1193 110 61 111.119 61 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M108 226C108 224.895 108.895 224 110 224H210C211.105 224 212 224.895 212 226C212 227.105 211.105 228 210 228H110C108.895 228 108 227.105 108 226Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M133 234C133 232.895 133.895 232 135 232H185C186.105 232 187 232.895 187 234C187 235.105 186.105 236 185 236H135C133.895 236 133 235.105 133 234Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M160 140C193.137 140 220 166.863 220 200C220 206.271 219.037 212.318 217.252 218H102.748C100.963 212.318 100 206.271 100 200C100 166.863 126.863 140 160 140Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/></svg>",
	"320x320_trial-start": "<svg width=\"320\" height=\"320\" viewBox=\"0 0 320 320\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M64 122.8H40V146.8M64 122.8V146.8M64 122.8H88M64 146.8H40M64 146.8H88M64 146.8V170.8M40 146.8V170.8M88 122.8V146.8M88 122.8H112M88 146.8H112M88 146.8V170.8M112 122.8V146.8M112 122.8H136M112 146.8H136M112 146.8V170.8M136 122.8V146.8M136 122.8H160M136 146.8H160M136 146.8V170.8M160 122.8V146.8M160 122.8H184M160 146.8H184M160 146.8V170.8M184 122.8V146.8M184 122.8H208M184 146.8H208M184 146.8V170.8M208 122.8V146.8M208 122.8H232M208 146.8H232M208 146.8V170.8M232 122.8V146.8M232 122.8H256M232 146.8H256M232 146.8V170.8M256 122.8V146.8M256 122.8H280V146.8M256 146.8H280M256 146.8V170.8M280 146.8V170.8M64 170.8H40M64 170.8H88M64 170.8V194.8M40 170.8V194.8H64M88 170.8H112M88 170.8V194.8M112 170.8H136M112 170.8V194.8M136 170.8H160M136 170.8V194.8M160 170.8H184M160 170.8V194.8M184 170.8H208M184 170.8V194.8M208 170.8H232M208 170.8V194.8M232 170.8H256M232 170.8V194.8M256 170.8H280M256 170.8V194.8M280 170.8V194.8H256M64 194.8H88M64 194.8V218H88M88 194.8H112M88 194.8V218M112 194.8H136M112 194.8V218M136 194.8H160M136 194.8V218M160 194.8H184M160 194.8V218M184 194.8H208M184 194.8V218M208 194.8H232M208 194.8V218M232 194.8H256M232 194.8V218M256 194.8V218H232M88 218H112M112 218H136M136 218H160M160 218H184M184 218H208M208 218H232M52 218H268C274.627 218 280 212.627 280 206V114C280 107.373 274.627 102 268 102H52C45.3726 102 40 107.373 40 114V206C40 212.627 45.3726 218 52 218Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M48 112.5C48 113.881 49.1193 115 50.5 115C51.8807 115 53 113.881 53 112.5C53 111.119 51.8807 110 50.5 110C49.1193 110 48 111.119 48 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M55 112.5C55 113.881 56.1193 115 57.5 115C58.8807 115 60 113.881 60 112.5C60 111.119 58.8807 110 57.5 110C56.1193 110 55 111.119 55 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M61 112.5C61 113.881 62.1193 115 63.5 115C64.8807 115 66 113.881 66 112.5C66 111.119 64.8807 110 63.5 110C62.1193 110 61 111.119 61 112.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M128 226C128 224.895 128.895 224 130 224H190C191.105 224 192 224.895 192 226C192 227.105 191.105 228 190 228H130C128.895 228 128 227.105 128 226Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M142 234C142 232.895 142.895 232 144 232H176C177.105 232 178 232.895 178 234C178 235.105 177.105 236 176 236H144C142.895 236 142 235.105 142 234Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M160 110C193.137 110 220 136.863 220 170C220 189.627 210.575 207.053 196.005 218H123.995C109.425 207.053 100 189.627 100 170C100 136.863 126.863 110 160 110Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/></svg>",
	"40x40-room-hierarchy": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M25 23C25 22.4477 25.4477 22 26 22H34C34.5523 22 35 22.4477 35 23V29C35 29.5523 34.5523 30 34 30H26C25.4477 30 25 29.5523 25 29V23Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M25 11C25 10.4477 25.4477 10 26 10H34C34.5523 10 35 10.4477 35 11V17C35 17.5523 34.5523 18 34 18H26C25.4477 18 25 17.5523 25 17V11Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M20 14.5L20 23C20 24.1046 20.8954 25 22 25L25 25M20 14.5L15.5 14.5M20 14.5L24.5 14.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11V17C16 17.5523 15.5523 18 15 18H7C6.44772 18 6 17.5523 6 17V11Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/></svg>",
	"40x40_ai": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"9.5\" y=\"9.5\" width=\"21\" height=\"21\" rx=\"2.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M35.0002 20.5C35.2764 20.5 35.5002 20.2761 35.5002 20C35.5002 19.7238 35.2764 19.5 35.0002 19.5V20.5ZM33.0002 17.5C33.2764 17.5 33.5002 17.2761 33.5002 17C33.5002 16.7238 33.2764 16.5 33.0002 16.5V17.5ZM33.0002 23.5C33.2764 23.5 33.5002 23.2761 33.5002 23C33.5002 22.7238 33.2764 22.5 33.0002 22.5V23.5ZM20.5002 31V30.5H19.5002V31H20.5002ZM19.5002 35C19.5002 35.2761 19.7241 35.5 20.0002 35.5C20.2764 35.5 20.5002 35.2761 20.5002 35H19.5002ZM23.5002 31V30.5H22.5002V31H23.5002ZM22.5002 33C22.5002 33.2761 22.7241 33.5 23.0002 33.5C23.2764 33.5 23.5002 33.2761 23.5002 33H22.5002ZM17.5002 31V30.5H16.5002V31H17.5002ZM16.5002 33C16.5002 33.2761 16.7241 33.5 17.0002 33.5C17.2764 33.5 17.5002 33.2761 17.5002 33H16.5002ZM20.5002 4.99997C20.5002 4.72383 20.2764 4.49997 20.0002 4.49997C19.7241 4.49997 19.5002 4.72383 19.5002 4.99997H20.5002ZM17.5002 6.99997C17.5002 6.72383 17.2764 6.49997 17.0002 6.49997C16.7241 6.49997 16.5002 6.72383 16.5002 6.99997H17.5002ZM23.5002 6.99997C23.5002 6.72383 23.2764 6.49997 23.0002 6.49997C22.7241 6.49997 22.5002 6.72383 22.5002 6.99997H23.5002ZM5.00024 19.5C4.7241 19.5 4.50024 19.7238 4.50024 20C4.50024 20.2761 4.7241 20.5 5.00024 20.5V19.5ZM7.00024 22.5C6.7241 22.5 6.50024 22.7238 6.50024 23C6.50024 23.2761 6.7241 23.5 7.00024 23.5V22.5ZM7.00024 16.5C6.7241 16.5 6.50024 16.7238 6.50024 17C6.50024 17.2761 6.7241 17.5 7.00024 17.5V16.5ZM31.0002 20V20.5H35.0002V20V19.5H31.0002V20ZM31.0002 17V17.5H33.0002V17V16.5H31.0002V17ZM31.0002 23V23.5H33.0002V23V22.5H31.0002V23ZM20.0002 31H19.5002V35H20.0002H20.5002V31H20.0002ZM23.0002 31H22.5002V33H23.0002H23.5002V31H23.0002ZM17.0002 31H16.5002V33H17.0002H17.5002V31H17.0002ZM20.0002 8.99997H20.5002V4.99997H20.0002H19.5002V8.99997H20.0002ZM17.0002 8.99997H17.5002V6.99997H17.0002H16.5002V8.99997H17.0002ZM23.0002 8.99997H23.5002V6.99997H23.0002H22.5002V8.99997H23.0002ZM9.00024 20V19.5H5.00024V20V20.5H9.00024V20ZM9.00024 23V22.5H7.00024V23V23.5H9.00024V23ZM9.00024 17V16.5H7.00024V17V17.5H9.00024V17Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M20 20.58C20.08 20.8067 20.0067 20.92 19.78 20.92H17.42C17.1933 20.92 17.12 20.8067 17.2 20.58L18.3 17.56C18.38 17.3467 18.48 17.24 18.6 17.24C18.72 17.24 18.82 17.3467 18.9 17.56L20 20.58Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28.5 12.5C28.5 11.9477 28.0523 11.5 27.5 11.5H12.5C11.9477 11.5 11.5 11.9477 11.5 12.5V27.5C11.5 28.0523 11.9477 28.5 12.5 28.5H27.5C28.0523 28.5 28.5 28.0523 28.5 27.5V12.5ZM15.16 24.06C15.2667 24.1533 15.38 24.2 15.5 24.2C15.7 24.2 15.8467 24.0867 15.94 23.86L16.6 22.14C16.7067 21.8733 16.8933 21.74 17.16 21.74H20.04C20.3067 21.74 20.4933 21.8733 20.6 22.14L21.26 23.86C21.3533 24.0867 21.5 24.2 21.7 24.2C21.82 24.2 21.9333 24.1533 22.04 24.06C22.1467 23.9667 22.2 23.8533 22.2 23.72C22.2 23.6667 22.1867 23.6 22.16 23.52L19.4 16.44C19.2667 16.08 19 15.9 18.6 15.9C18.44 15.9 18.28 15.9467 18.12 16.04C17.9733 16.12 17.8667 16.2533 17.8 16.44L15.04 23.52C15.0133 23.6 15 23.6667 15 23.72C15 23.8533 15.0533 23.9667 15.16 24.06ZM23.8278 24.06C23.9211 24.1533 24.0345 24.2 24.1678 24.2C24.3145 24.2 24.4345 24.1533 24.5278 24.06C24.6211 23.9667 24.6678 23.86 24.6678 23.74V16.36C24.6678 16.2133 24.6211 16.1 24.5278 16.02C24.4345 15.94 24.3145 15.9 24.1678 15.9C24.0345 15.9 23.9211 15.94 23.8278 16.02C23.7478 16.1 23.7078 16.2133 23.7078 16.36V23.74C23.7078 23.86 23.7478 23.9667 23.8278 24.06Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"40x40_automation-lightbulb": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.3299 18.9049L19.0465 13.0537C19.272 12.568 20 12.7288 20 13.2643V15.8846C20 16.1608 20.2239 16.3846 20.5 16.3846H23.2166C23.582 16.3846 23.824 16.7638 23.6701 17.0952L20.9535 22.9463C20.728 23.432 20 23.2713 20 22.7358V20.1154C20 19.8393 19.7761 19.6154 19.5 19.6154H16.7834C16.418 19.6154 16.176 19.2363 16.3299 18.9049Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M8 17H6\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-linecap=\"round\"/><path d=\"M34 17H32\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-linecap=\"round\"/><path d=\"M11.5148 25.4853L10.1006 26.8995\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-linecap=\"round\"/><path d=\"M29.8996 7.10056L28.4854 8.51477\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-linecap=\"round\"/><path d=\"M11.5148 8.5148L10.1006 7.10059\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-linecap=\"round\"/><path d=\"M29.8996 26.8996L28.4854 25.4854\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-linecap=\"round\"/><path d=\"M29 17C29 20.1204 27.412 22.8699 25 24.4845C23.717 25.3432 23.2571 26.9584 23.0922 28.0061C23.0063 28.5517 22.5523 29 22 29H18C17.4477 29 16.9937 28.5517 16.9078 28.0061C16.7429 26.9584 16.283 25.3432 15 24.4845C12.588 22.8699 11 20.1204 11 17C11 12.0294 15.0294 8 20 8C24.9706 8 29 12.0294 29 17Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M18 29H22V31C22 31.5523 21.5523 32 21 32H19C18.4477 32 18 31.5523 18 31V29Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-linejoin=\"round\"/></svg>",
	"40x40_balance": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.5 24.2693L33.5 24.2693\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M17.2272 29.1213L19.7856 24.8573C19.8827 24.6954 20.1173 24.6954 20.2144 24.8573L22.7728 29.1213C22.8728 29.288 22.7528 29.5 22.5585 29.5H17.4415C17.2472 29.5 17.1272 29.288 17.2272 29.1213Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><circle cx=\"28\" cy=\"18\" r=\"4\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><circle cx=\"13\" cy=\"16\" r=\"6\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"40x40_building-corporate": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 10C11 9.44772 11.4477 9 12 9H28C28.5523 9 29 9.44772 29 10V34H11V10Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linejoin=\"round\"/><path d=\"M29 14H33C33.5523 14 34 14.4477 34 15V34\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linejoin=\"round\"/><path d=\"M11 14H7C6.44772 14 6 14.4477 6 15V34\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linejoin=\"round\"/><path d=\"M16 27C16 26.4477 16.4477 26 17 26H23C23.5523 26 24 26.4477 24 27V34H16V27Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linejoin=\"round\"/><rect x=\"14\" y=\"5\" width=\"12\" height=\"13\" rx=\"2\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M20 34L20 26\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M34 34L6 34\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>",
	"40x40_building-hotel": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 10C10 8.89543 10.8954 8 12 8H28C29.1046 8 30 8.89543 30 10V32H10V10Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linejoin=\"round\"/><path d=\"M18 26.375C18 26.1679 18.1492 26 18.3333 26H21.6667C21.8508 26 22 26.1679 22 26.375V31.625C22 31.8321 21.8508 32 21.6667 32H18.3333C18.1492 32 18 31.8321 18 31.625V26.375Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M25.5 26L25.5 28\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M25.5 21L25.5 23\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M34 32L6 32\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M22 21L22 23\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M18 21L18 23\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M18 16L18 18\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M22 16L22 18\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M25.5 16L25.5 18\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M14 26L14 28\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M14 21L14 23\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M14 16L14 18\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M30 12L10 12\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>",
	"40x40_ebook": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M31.1543 7.00403C32.7394 7.08434 34 8.39502 34 10.0001V26.0001L33.9961 26.1544C33.9184 27.6885 32.6883 28.9185 31.1543 28.9962L31 29.0001H9L8.8457 28.9962C7.31166 28.9185 6.08163 27.6885 6.00391 26.1544L6 26.0001V10.0001C6 8.39502 7.26055 7.08434 8.8457 7.00403L9 7.00012H10V8.00012H9C7.89543 8.00012 7 8.89555 7 10.0001V26.0001C7 27.1047 7.89543 28.0001 9 28.0001H31C32.1046 28.0001 33 27.1047 33 26.0001V10.0001C33 8.89555 32.1046 8.00012 31 8.00012H30V7.00012H31L31.1543 7.00403Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M12 33.0001H28\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M14.5 33.0001L16 28.5001\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M25.5 33.0001L24 28.5001\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M27 19.7121V4.7121H16.3939C14.5195 4.7121 13 6.23162 13 8.10604V19.9999\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M27 22.7121V17.7121H15.5C14.1193 17.7121 13 18.8314 13 20.2121C13 21.5928 14.1193 22.7121 15.5 22.7121H27Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M18 20V25.4077C18 25.9565 18.66 26.2091 19.0053 25.7924L20 24.5919L20.9947 25.7924C21.34 26.2091 22 25.9565 22 25.4077V20L18 20Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"40x40_export-data": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"10\" y=\"21\" width=\"6\" height=\"13\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"17\" y=\"28\" width=\"6\" height=\"6\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"24\" y=\"24\" width=\"6\" height=\"10\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M16.2503 14C14.2234 14 9.54922 14 7.49691 14C6.94463 14 6.5 14.4477 6.5 15V33C6.5 33.5523 6.94772 34 7.5 34H32.5012C33.0535 34 33.5012 33.5523 33.5012 33V15C33.5012 14.4477 33.0535 14 32.5012 14H23.7509\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linejoin=\"round\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.6465 6.64645C19.8418 6.45118 20.1584 6.45118 20.3536 6.64645L23.5356 9.82843C23.7309 10.0237 23.7309 10.3403 23.5356 10.5355C23.3404 10.7308 23.0238 10.7308 22.8285 10.5355L20.5001 8.20711V16C20.5001 16.2761 20.2762 16.5 20.0001 16.5C19.724 16.5 19.5001 16.2761 19.5001 16V8.20711L17.1717 10.5355C16.9764 10.7308 16.6598 10.7308 16.4646 10.5355C16.2693 10.3403 16.2693 10.0237 16.4646 9.82843L19.6465 6.64645Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></svg>",
	"40x40_intersect": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.127 26.4385C16.7567 26.478 16.3808 26.5 16 26.5C15.2253 26.5 14.4701 26.4161 13.7432 26.2568C13.5839 25.5299 13.5 24.7747 13.5 24C13.5 23.6189 13.521 23.2426 13.5605 22.8721L17.127 26.4385ZM21.5371 24.9199C20.5651 25.5246 19.4877 25.9738 18.3379 26.2354L13.7637 21.6621C14.0252 20.5121 14.4743 19.4341 15.0791 18.4619L21.5371 24.9199ZM24.5859 22.04C23.969 22.9154 23.2226 23.6918 22.373 24.3418L15.6572 17.626C16.3072 16.7766 17.0838 16.0299 17.959 15.4131L24.5859 22.04ZM26.332 17.8574C26.1201 19.0445 25.7088 20.1609 25.1338 21.1738L18.8252 14.8652C19.838 14.2903 20.9547 13.879 22.1416 13.667L26.332 17.8574ZM24 13.5C24.7747 13.5 25.5299 13.5839 26.2568 13.7432C26.4161 14.4701 26.5 15.2253 26.5 16C26.5 16.199 26.4924 16.3965 26.4814 16.5928L23.4062 13.5176C23.6028 13.5066 23.8007 13.5 24 13.5Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><circle cx=\"16\" cy=\"16\" r=\"10\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><circle cx=\"24\" cy=\"24\" r=\"10\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></svg>",
	"40x40_layers": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M31.9268 22.9648C32.1393 22.8701 32.3966 22.9343 32.5371 23.1308C32.6776 23.3275 32.6545 23.5914 32.4961 23.7617L32.4209 23.8291L20.6065 32.2656L20.3155 32.4726L20.0244 32.2656L8.20901 23.8291L8.13381 23.7617C7.9755 23.5914 7.9524 23.3275 8.0928 23.1308C8.23332 22.9343 8.49064 22.8702 8.70315 22.9648L8.79104 23.0146L20.3145 31.2431L31.8389 23.0146L31.9268 22.9648Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #333645)\"/><path d=\"M23.7061 22.4512L20.3154 24.873L16.9238 22.4512L20.3154 20.0303L23.7061 22.4512Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M19.502 19.4492L16.1104 21.8701L12.7051 19.4385L16.0957 17.0176L19.502 19.4492Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M27.9248 19.4385L24.5195 21.8701L21.1289 19.4492L24.5352 17.0176L27.9248 19.4385Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M23.7207 16.4365L20.3154 18.8682L16.9102 16.4365L20.3154 14.0049L23.7207 16.4365Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M15.2822 16.4365L11.8906 18.8574L8.5 16.4365L11.8906 14.0146L15.2822 16.4365Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M32.1299 16.4365L28.7393 18.8574L25.3486 16.4365L28.7393 14.0146L32.1299 16.4365Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M19.502 13.4238L16.0957 15.8555L12.7051 13.4336L16.1104 11.002L19.502 13.4238Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M27.9248 13.4336L24.5352 15.8555L21.1289 13.4238L24.5195 11.002L27.9248 13.4336Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M23.7061 10.4209L20.3154 12.8428L16.9238 10.4209L20.3154 8L23.7061 10.4209Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M20.4193 27.1846C20.6439 27.0245 20.9561 27.0764 21.1166 27.3008C21.277 27.5255 21.2251 27.8385 21.0003 27.999L20.6068 28.2803L20.3158 28.4873L20.0248 28.2803L19.6312 27.999C19.4066 27.8386 19.3548 27.5265 19.515 27.3017C19.6554 27.1051 19.9119 27.0404 20.1244 27.1348L20.2123 27.1846L20.3158 27.2578L20.4193 27.1846ZM17.1517 25.6142C17.292 25.4177 17.5486 25.353 17.7611 25.4473L17.849 25.498L18.6371 26.0596C18.8618 26.22 18.9137 26.5331 18.7533 26.7578C18.6128 26.9543 18.3563 27.0183 18.1439 26.9238L18.056 26.874L17.2679 26.3115C17.0435 26.1511 16.9915 25.8389 17.1517 25.6142ZM22.8695 25.4473C23.0821 25.3526 23.3394 25.4175 23.4798 25.6142C23.64 25.8389 23.5872 26.1511 23.3627 26.3115L22.5755 26.874L22.4877 26.9238C22.2752 27.0184 22.0188 26.9542 21.8783 26.7578C21.7178 26.5331 21.7698 26.22 21.9945 26.0596L22.7816 25.498L22.8695 25.4473ZM14.7884 23.9267C14.9289 23.73 15.1862 23.6651 15.3988 23.7598L15.4867 23.8105L16.2738 24.373C16.4985 24.5335 16.5505 24.8456 16.39 25.0703C16.2495 25.2667 15.993 25.3317 15.7806 25.2373L15.6927 25.1865L14.9056 24.624C14.681 24.4636 14.6282 24.1515 14.7884 23.9267ZM24.3568 24.373L24.9378 25.1865C24.7131 25.3467 24.401 25.2949 24.2406 25.0703C24.0803 24.8457 24.1324 24.5336 24.3568 24.373ZM25.1449 23.8105C25.3696 23.6501 25.6817 23.702 25.8421 23.9267C26.0026 24.1515 25.9506 24.4635 25.7259 24.624L24.9378 25.1865L24.6478 24.7793L24.3568 24.373L25.1449 23.8105ZM12.4261 22.2392C12.5666 22.0428 12.8231 21.9778 13.0355 22.0723L13.1234 22.123L13.9105 22.6855C14.1352 22.8459 14.1879 23.1581 14.0277 23.3828C13.8872 23.5795 13.6299 23.6444 13.4173 23.5498L13.3294 23.499L12.5423 22.9365C12.3176 22.776 12.2657 22.464 12.4261 22.2392ZM27.5082 22.123L27.7982 22.5303L28.0892 22.9365L27.3011 23.499L27.2132 23.5498C27.0008 23.6442 26.7442 23.5794 26.6039 23.3828C26.4434 23.1581 26.4954 22.846 26.7201 22.6855L27.5082 22.123ZM27.5082 22.123C27.7329 21.9628 28.045 22.0146 28.2054 22.2392C28.3658 22.4638 28.3136 22.776 28.0892 22.9365L27.5082 22.123ZM10.0628 20.5517C10.2033 20.3553 10.4598 20.2912 10.6722 20.3857L10.7601 20.4355L11.5482 20.998C11.7727 21.1585 11.8246 21.4707 11.6644 21.6953C11.504 21.92 11.1919 21.9719 10.9671 21.8115L10.1791 21.25L10.1029 21.1826C9.94461 21.0123 9.92246 20.7484 10.0628 20.5517ZM29.9584 20.3857C30.1708 20.2912 30.4272 20.3553 30.5677 20.5517C30.7282 20.7765 30.6762 21.0895 30.4515 21.25L29.6644 21.8115L29.5765 21.8623C29.364 21.9569 29.1066 21.892 28.9662 21.6953C28.806 21.4706 28.8588 21.1584 29.0834 20.998L29.8705 20.4355L29.9584 20.3857ZM8.09312 19.1455C8.23366 18.9488 8.49092 18.8847 8.70347 18.9795L8.79136 19.0293L9.18492 19.3105C9.40954 19.4709 9.46131 19.7831 9.30113 20.0078C9.14074 20.2324 8.82857 20.2852 8.60386 20.125L8.20933 19.8437C7.98473 19.6832 7.93269 19.3702 8.09312 19.1455ZM31.4457 19.3105L32.0267 20.125C31.8021 20.2851 31.4899 20.2331 31.3294 20.0088C31.169 19.784 31.2209 19.471 31.4457 19.3105ZM31.8392 19.0293C32.0639 18.8688 32.377 18.9209 32.5375 19.1455C32.6979 19.3702 32.6458 19.6832 32.4212 19.8437L32.0267 20.125L31.7367 19.7178L31.4457 19.3105L31.8392 19.0293Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #333645)\"/></svg>",
	"40x40_payments": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"11.5\" y=\"14.5\" width=\"23\" height=\"16\" rx=\"1.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M25.2507 7.70115C26.3174 7.41559 27.4139 8.04865 27.6999 9.11521L29.0085 14H12.9997C11.8953 14.0001 10.9997 14.8955 10.9997 16V29C10.9997 29.0397 11.0033 29.079 11.0056 29.1181L10.3317 29.2988C9.26498 29.5846 8.1686 28.9514 7.88253 27.8847L4.5173 15.3271C4.23161 14.2604 4.86477 13.164 5.93136 12.8779L25.2507 7.70115Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><line x1=\"12\" y1=\"17.5\" x2=\"34\" y2=\"17.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><line x1=\"12\" y1=\"20.5\" x2=\"34\" y2=\"20.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M14.5 25.5H21.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M14.5 27.5H18.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><rect x=\"24.5\" y=\"25.5\" width=\"5\" height=\"2\" rx=\"1\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M30.5 25C31.3284 25 32 25.6716 32 26.5C32 27.3284 31.3284 28 30.5 28H28.5C29.1529 28 29.707 27.5823 29.9131 27H30.5C30.7761 27 31 26.7761 31 26.5C31 26.2239 30.7761 26 30.5 26H29.9131C29.707 25.4177 29.1529 25 28.5 25H30.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></svg>",
	"40x40_price-tag": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.2836 13.6338C14.4893 12.5655 15.499 11.8522 16.5619 12.0254L24.4164 13.3057C24.9576 13.3939 25.4376 13.7046 25.7435 14.1631L32.6508 24.5176C33.2636 25.4364 33.0211 26.6862 32.1088 27.3086L22.8168 33.6455C21.9044 34.2678 20.6681 34.0279 20.0551 33.1094L16.6654 28.0274C16.8913 27.9162 17.0961 27.7801 17.2777 27.6152C17.3451 27.5539 17.4063 27.4888 17.4642 27.4229L20.8812 32.5459C21.1878 33.0049 21.806 33.1246 22.2621 32.8135L31.5531 26.4766C32.0094 26.1654 32.1311 25.5405 31.8246 25.0811L24.9174 14.7266C24.7644 14.4974 24.5248 14.342 24.2543 14.2979L16.3998 13.0186C15.8684 12.932 15.363 13.2882 15.2601 13.8223L14.0297 20.2158C13.5892 20.3258 13.2178 20.5055 12.9144 20.7559L14.2836 13.6338ZM15.431 24.7363C15.5383 24.7648 15.64 24.7992 15.7367 24.835L16.6742 26.2393C16.6207 26.4341 16.5152 26.6048 16.3549 26.751C16.2484 26.8536 16.1234 26.9373 15.9818 27.0039L15.431 26.1768V24.7363ZM14.4681 24.5313V24.7334L14.3051 24.4902C14.3593 24.504 14.4133 24.5192 14.4681 24.5313ZM13.7845 21.6299C13.7902 21.8174 13.8473 22.0014 13.9525 22.1592L14.4681 22.9317V23.2764C14.1472 23.1804 13.8998 23.0706 13.726 22.9473C13.5521 22.8102 13.4652 22.6187 13.4652 22.3721C13.4652 22.0548 13.5714 21.8074 13.7845 21.6299Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M25.7228 21.5845C25.9525 21.4314 26.263 21.4934 26.4161 21.7231C26.5689 21.9528 26.507 22.2634 26.2775 22.4165L17.2775 28.4155C17.0477 28.5687 16.7373 28.5066 16.5841 28.2768C16.5468 28.2208 16.5223 28.1602 16.5099 28.0981C16.7988 27.9767 17.055 27.8166 17.2775 27.6147C17.5248 27.3895 17.707 27.1329 17.8273 26.8462L25.7228 21.5845Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M19 31L28 25\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-linecap=\"round\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.4023 12.5555C14.1578 11.8321 15.3437 11.8129 16.1221 12.5116L22.3359 18.0897C22.7585 18.469 23 19.0102 23 19.578V32.0057C23 33.1103 22.1046 34.0057 21 34.0057H9C7.89543 34.0057 7 33.1103 7 32.0057V19.5399C7 18.9944 7.22319 18.4728 7.61719 18.0956L13.4023 12.5555Z\" fill=\"var(--prism-color-icon-brand-default, #FD8237)\"/><path d=\"M20.2241 9.70933L19.7246 9.73164L19.7246 9.73164L20.2241 9.70933ZM16.5288 5.10422L16.3988 5.58704V5.58704L16.5288 5.10422ZM11.021 7.23191L11.4418 7.50196L11.021 7.23191ZM10.2384 10.2375L10.7375 10.207L10.7375 10.207L10.2384 10.2375ZM11.3814 13.1253L10.9966 13.4446V13.4446L11.3814 13.1253ZM13.887 15.2661C14.1548 15.3335 14.4265 15.171 14.4939 14.9032C14.5613 14.6354 14.3988 14.3637 14.131 14.2963L14.009 14.7812L13.887 15.2661ZM19.3921 12.7016L19.8084 12.9786C20.4552 12.0064 20.7757 10.8535 20.7236 9.68703L20.2241 9.70933L19.7246 9.73164C19.7672 10.6861 19.505 11.6293 18.9758 12.4247L19.3921 12.7016ZM20.2241 9.70933L20.7236 9.68703C20.6715 8.52053 20.2495 7.40086 19.5188 6.49015L19.1288 6.80308L18.7388 7.116C19.3367 7.86113 19.682 8.77722 19.7246 9.73164L20.2241 9.70933ZM19.1288 6.80308L19.5188 6.49015C18.788 5.57944 17.7863 4.92494 16.6588 4.62141L16.5288 5.10422L16.3988 5.58704C17.3213 5.83538 18.1409 6.37088 18.7388 7.116L19.1288 6.80308ZM16.5288 5.10422L16.6588 4.62141C15.5312 4.31789 14.3364 4.38109 13.2471 4.80186L13.4273 5.26827L13.6075 5.73468C14.4987 5.39041 15.4763 5.3387 16.3988 5.58704L16.5288 5.10422ZM13.4273 5.26827L13.2471 4.80186C12.1579 5.22264 11.2309 5.97915 10.6002 6.96187L11.021 7.23191L11.4418 7.50196C11.9578 6.69791 12.7163 6.07895 13.6075 5.73468L13.4273 5.26827ZM11.021 7.23191L10.6002 6.96187C9.96959 7.94459 9.66808 9.10252 9.73934 10.268L10.2384 10.2375L10.7375 10.207C10.6792 9.2534 10.9259 8.306 11.4418 7.50196L11.021 7.23191ZM10.2384 10.2375L9.73934 10.268C9.8106 11.4335 10.2509 12.5461 10.9966 13.4446L11.3814 13.1253L11.7662 12.806C11.1561 12.0709 10.7958 11.1606 10.7375 10.207L10.2384 10.2375ZM11.3814 13.1253L10.9966 13.4446C11.7423 14.3432 12.7546 14.9811 13.887 15.2661L14.009 14.7812L14.131 14.2963C13.2045 14.0632 12.3763 13.5412 11.7662 12.806L11.3814 13.1253Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/></svg>",
	"40x40_question": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 6.5C27.4558 6.5 33.5 12.5442 33.5 20C33.5 27.4558 27.4558 33.5 20 33.5C18.1362 33.5 16.3617 33.1226 14.748 32.4404C14.4364 32.3087 14.0826 32.2765 13.7432 32.3691L7.66309 34.0283C7.27874 34.1329 6.93204 33.7671 7.05664 33.3887L8.69336 28.4189C8.83906 27.9763 8.76658 27.5027 8.53027 27.123C7.24362 25.0558 6.5 22.6155 6.5 20C6.5 12.5442 12.5442 6.50007 20 6.5Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M19.6811 27C19.287 27 18.9448 26.8589 18.6544 26.5767C18.3848 26.3163 18.25 26.0016 18.25 25.6326C18.25 25.2419 18.3848 24.9163 18.6544 24.6558C18.9448 24.3737 19.287 24.2326 19.6811 24.2326C20.0544 24.2326 20.3759 24.3737 20.6455 24.6558C20.9152 24.9163 21.05 25.2419 21.05 25.6326C21.05 26.0016 20.9152 26.3163 20.6455 26.5767C20.3759 26.8589 20.0544 27 19.6811 27Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M20.6125 21.8199C20.6125 22.0939 20.5153 22.3258 20.3208 22.5154C20.1458 22.7051 19.9222 22.7999 19.65 22.7999C19.3778 22.7999 19.1444 22.7051 18.95 22.5154C18.775 22.3258 18.6875 22.0939 18.6875 21.8199V21.0612C18.6875 20.4501 18.8528 19.9548 19.1833 19.5754C19.5333 19.1961 19.8833 18.8589 20.2333 18.5638C20.5639 18.2899 20.8653 17.9843 21.1375 17.6471C21.4291 17.2888 21.575 16.8673 21.575 16.3826C21.575 15.9189 21.4194 15.5501 21.1083 15.2761C20.8166 14.9811 20.418 14.8335 19.9125 14.8335C19.4847 14.8335 19.1444 14.9495 18.8917 15.1813C18.6389 15.4131 18.493 15.7398 18.4542 16.1613C18.4347 16.3931 18.3278 16.6039 18.1333 16.7935C17.9583 16.9621 17.7444 17.0464 17.4917 17.0464C17.2389 17.0464 17.0056 16.9411 16.7917 16.7303C16.5972 16.5196 16.5 16.2772 16.5 16.0032C16.5 15.4553 16.6556 14.96 16.9667 14.5174C17.2778 14.0538 17.6861 13.6849 18.1917 13.411C18.7167 13.137 19.2903 13 19.9125 13C20.943 13 21.7986 13.3056 22.4791 13.9168C23.1597 14.5069 23.5 15.2761 23.5 16.2245C23.5 17.1097 23.3152 17.7946 22.9458 18.2793C22.5958 18.7641 22.1972 19.1856 21.75 19.5438C21.4389 19.7967 21.1666 20.0496 20.9333 20.3025C20.7194 20.5344 20.6125 20.7873 20.6125 21.0612V21.8199Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"40x40_range-vertical": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6 33.5C6 33.2239 6.22386 33 6.5 33H10V34H6.5C6.22386 34 6 33.7761 6 33.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M30 33H33.5C33.7761 33 34 33.2239 34 33.5C34 33.7761 33.7761 34 33.5 34H30V33Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"18\" y=\"33\" width=\"4\" height=\"1\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"24\" y=\"33\" width=\"4\" height=\"1\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"12\" y=\"33\" width=\"4\" height=\"1\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M19.6204 9.44312C19.8199 9.21031 20.1806 9.21031 20.3801 9.44312L25.2922 15.1746C25.5702 15.4988 25.3402 15.9994 24.9133 15.9998H23.0002V23.9998H24.9133C25.3402 24.0001 25.57 24.5007 25.2922 24.825L20.3801 30.5574C20.1806 30.7901 19.8199 30.7901 19.6204 30.5574L14.7073 24.825C14.4298 24.5006 14.6602 23.9998 15.0872 23.9998H17.0002V15.9998H15.0872C14.66 15.9998 14.4294 15.4989 14.7073 15.1746L19.6204 9.44312Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M6 6.5C6 6.22386 6.22386 6 6.5 6H10V7H6.5C6.22386 7 6 6.77614 6 6.5Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M30 6H33.5C33.7761 6 34 6.22386 34 6.5C34 6.77614 33.7761 7 33.5 7H30V6Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"18\" y=\"6\" width=\"4\" height=\"1\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"24\" y=\"6\" width=\"4\" height=\"1\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"12\" y=\"6\" width=\"4\" height=\"1\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></svg>",
	"40x40_rocket": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25999_16796)\"><path d=\"M13.8568 31.0882C13.3494 31.5956 12.6885 31.9213 11.977 32.0145L7.87204 32.5524L8.40994 28.4474C8.50317 27.7359 8.8288 27.0751 9.33624 26.5677L9.3789 26.525C10.6272 25.2767 12.6511 25.2767 13.8995 26.525C15.1478 27.7733 15.1478 29.7972 13.8995 31.0456L13.8568 31.0882Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M6.37174 19.2636C5.79925 18.9365 5.69453 18.1545 6.16078 17.6883L8.82963 15.0195C9.43122 14.4179 10.2089 14.0238 11.0498 13.8944L19.5501 12.5867L10.779 21.3577C10.6196 21.5172 10.3732 21.5502 10.1774 21.4383L6.37174 19.2636Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M21.1609 34.0527C21.488 34.6252 22.27 34.7299 22.7362 34.2637L25.405 31.5948C26.0066 30.9932 26.4007 30.2155 26.5301 29.3746L27.8378 20.8743L19.0668 29.6454C18.9073 29.8049 18.8743 30.0513 18.9862 30.247L21.1609 34.0527Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M23.1468 8.98995C24.5243 7.61238 26.3572 6.78483 28.3016 6.66257L32.4303 6.40296C33.3315 6.34629 34.0781 7.09292 34.0215 7.99413L33.7618 12.1228C33.6396 14.0672 32.812 15.9001 31.4345 17.2776L20.9433 27.7688L12.6556 19.4812L23.1468 8.98995Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><circle cx=\"28.1008\" cy=\"12.3236\" r=\"2.13101\" transform=\"rotate(45 28.1008 12.3236)\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M15.2927 25.1318L22.0736 18.351\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></g><defs><clipPath id=\"clip0_25999_16796\"><rect width=\"40\" height=\"40\" fill=\"var(--prism-color-elevation-surface, #ffffff)\"/></clipPath></defs></svg>",
	"40x40_rounding": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.0312 6C22.9417 6.10723 22.8555 6.21974 22.7754 6.33984C22.4021 6.88117 22.2158 7.57212 22.2158 8.41211C22.2158 9.08405 22.3837 9.68147 22.7197 10.2041C23.0557 10.708 23.4852 11.1096 24.0078 11.4082C24.549 11.7068 25.137 11.8564 25.7715 11.8564C26.0887 11.8564 26.3967 11.8371 26.6953 11.7998C26.994 11.7438 27.3028 11.6222 27.6201 11.4355C27.6572 11.4173 27.6943 11.4268 27.7314 11.4639C27.7874 11.5012 27.7971 11.5388 27.7598 11.5762C27.4985 12.1547 27.1528 12.705 26.7236 13.2275C26.2943 13.7315 25.8745 14.1706 25.4639 14.5439C25.0719 14.8985 24.7544 15.1505 24.5117 15.2998C24.3438 15.4117 24.2598 15.5518 24.2598 15.7197C24.2598 16.1117 24.4653 16.3076 24.876 16.3076C24.9318 16.3076 24.9969 16.2988 25.0713 16.2803C25.146 16.2616 25.2492 16.2143 25.3799 16.1396C25.8651 15.8597 26.3594 15.4397 26.8633 14.8799C27.3859 14.3012 27.8627 13.6479 28.292 12.9199C28.7399 12.1733 29.0942 11.4263 29.3555 10.6797C29.6354 9.9331 29.7754 9.25169 29.7754 8.63574C29.7754 7.73985 29.5978 7.00244 29.2432 6.42383C29.1532 6.27242 29.0565 6.13101 28.9521 6H34V22H18V6H23.0312ZM26.8701 6C27.1569 6.1073 27.4258 6.26654 27.6758 6.47949C28.1984 6.89016 28.46 7.53478 28.46 8.41211C28.4599 9.19593 28.2079 9.79346 27.7041 10.2041C27.2188 10.5961 26.6581 10.792 26.0234 10.792C25.4449 10.7919 24.885 10.596 24.3438 10.2041C23.8024 9.79346 23.5313 9.19604 23.5312 8.41211C23.5312 7.59078 23.7744 6.95581 24.2598 6.50781C24.5058 6.28075 24.7713 6.11196 25.0557 6H26.8701Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"18\" y=\"22\" width=\"4\" height=\"1\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"24\" y=\"22\" width=\"4\" height=\"1\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"30\" y=\"22\" width=\"4\" height=\"1\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25.968 26.035C26.9012 26.0351 27.685 26.2966 28.3196 26.8192C28.9541 27.3231 29.2717 28.0229 29.2717 28.9188C29.2717 29.3854 29.1597 29.8429 28.9358 30.2908C28.7305 30.7201 28.3945 31.0473 27.928 31.2713C28.6184 31.57 29.1224 31.9899 29.4397 32.5311C29.7193 32.9916 29.8752 33.4813 29.9084 33.9998H28.6174C28.5724 33.4855 28.3618 33.0142 27.9836 32.5867C27.573 32.1015 26.91 31.8592 25.9954 31.8592C25.0809 31.8592 24.409 32.1016 23.9797 32.5867C23.618 33.0142 23.4164 33.4855 23.3733 33.9998H22.0833C22.1165 33.4812 22.2724 32.9917 22.552 32.5311C22.8693 31.9898 23.3731 31.5699 24.0637 31.2713C23.5971 31.0473 23.2516 30.7202 23.0276 30.2908C22.8223 29.8429 22.72 29.3854 22.72 28.9188C22.72 28.0229 23.0278 27.3231 23.6438 26.8192C24.2785 26.2965 25.0534 26.035 25.968 26.035ZM25.968 27.0711C25.3894 27.0711 24.8943 27.2487 24.4836 27.6033C24.0918 27.9393 23.8958 28.3776 23.8958 28.9188C23.8958 29.4413 24.0918 29.8892 24.4836 30.2625C24.8943 30.6358 25.3894 30.8231 25.968 30.8231C26.5465 30.823 27.0312 30.6357 27.4231 30.2625C27.8338 29.8892 28.0393 29.4414 28.0393 28.9188C28.0393 28.3775 27.8337 27.9393 27.4231 27.6033C27.0312 27.2488 26.5464 27.0712 25.968 27.0711Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"18\" y=\"6\" width=\"1\" height=\"28\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><rect x=\"33\" y=\"6\" width=\"1\" height=\"28\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M8.59558 25.28C8.39024 25.28 8.23158 25.2147 8.11958 25.084C8.02624 24.972 7.97958 24.8413 7.97958 24.692C7.97958 24.6173 7.99824 24.524 8.03558 24.412L11.8716 16.124C11.9649 15.9373 12.0116 15.76 12.0116 15.592C12.0116 15.2933 11.7782 15.144 11.3116 15.144H6.88758C6.70091 15.144 6.54224 15.088 6.41158 14.976C6.28091 14.864 6.21558 14.724 6.21558 14.556C6.21558 14.3507 6.28091 14.2013 6.41158 14.108C6.54224 13.996 6.70091 13.94 6.88758 13.94H12.2636C12.6929 13.94 13.0009 14.0427 13.1876 14.248C13.3929 14.4533 13.4956 14.7147 13.4956 15.032C13.4956 15.2747 13.4396 15.5547 13.3276 15.872L9.26758 24.832C9.13691 25.1307 8.91291 25.28 8.59558 25.28Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/></svg>",
	"40x40_scheduling": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M33 22.0723C32.6799 21.8871 32.3462 21.7232 32 21.583V15H8V30C8 31.1046 8.89543 32 10 32H21.584C21.7242 32.3462 21.888 32.6799 22.0732 33H10L9.8457 32.9961C8.31166 32.9184 7.08163 31.6883 7.00391 30.1543L7 30V14H33V22.0723Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><circle cx=\"29\" cy=\"29\" r=\"7.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M28.5 26V29.5H32\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M7 10C7 8.34315 8.34315 7 10 7L30 7C31.6569 7 33 8.34315 33 10V15L7 15L7 10Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M20 6L20 9\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M24.5 9V6\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M15.5 6V9\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M28 19H26\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M23 19H21\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M11.25 20H17.75C17.8881 20 18 19.8881 18 19.75V17.25C18 17.1119 17.8881 17 17.75 17H11.25C11.1119 17 11 17.1119 11 17.25V19.75C11 19.8881 11.1119 20 11.25 20Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M23 24H21\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M18 24H16\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M18 28H16\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M13 28H11\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/><path d=\"M13 24H11\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></svg>",
	"40x40_screen-api": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M33.5 14.5V30C33.5 31.3807 32.3807 32.5 31 32.5H9C7.61929 32.5 6.5 31.3807 6.5 30V14.5H33.5Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M28.1937 27.715C28.0537 27.715 27.9347 27.666 27.8367 27.568C27.7527 27.47 27.7107 27.358 27.7107 27.232V19.483C27.7107 19.329 27.7527 19.21 27.8367 19.126C27.9347 19.042 28.0537 19 28.1937 19C28.3477 19 28.4737 19.042 28.5717 19.126C28.6697 19.21 28.7187 19.329 28.7187 19.483V27.232C28.7187 27.358 28.6697 27.47 28.5717 27.568C28.4737 27.666 28.3477 27.715 28.1937 27.715Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M20.5211 27.715C20.3811 27.715 20.2621 27.666 20.1641 27.568C20.0801 27.47 20.0381 27.358 20.0381 27.232V20.134C20.0381 19.826 20.1291 19.595 20.3111 19.441C20.4931 19.287 20.7101 19.21 20.9621 19.21H23.3141C24.0001 19.21 24.6021 19.413 25.1201 19.819C25.6521 20.225 25.9181 20.806 25.9181 21.562C25.9181 22.36 25.6591 22.99 25.1411 23.452C24.6371 23.9 24.0351 24.124 23.3351 24.124H21.6551C21.2491 24.124 21.0461 24.369 21.0461 24.859V27.232C21.0461 27.358 20.9971 27.47 20.8991 27.568C20.8011 27.666 20.6751 27.715 20.5211 27.715ZM21.6551 23.326H23.0831C23.3631 23.326 23.6431 23.27 23.9231 23.158C24.2031 23.046 24.4341 22.864 24.6161 22.612C24.8121 22.36 24.9101 22.024 24.9101 21.604C24.9101 21.072 24.7281 20.687 24.3641 20.449C24.0141 20.211 23.6151 20.092 23.1671 20.092H21.6551C21.2351 20.092 21.0251 20.337 21.0251 20.827V22.591C21.0251 22.843 21.0601 23.032 21.1301 23.158C21.2141 23.27 21.3891 23.326 21.6551 23.326Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M11.525 27.715C11.399 27.715 11.28 27.666 11.168 27.568C11.056 27.47 11 27.351 11 27.211C11 27.155 11.014 27.085 11.042 27.001L13.94 19.567C14.01 19.371 14.122 19.231 14.276 19.147C14.444 19.049 14.612 19 14.78 19C15.2 19 15.48 19.189 15.62 19.567L18.518 27.001C18.546 27.085 18.56 27.155 18.56 27.211C18.56 27.351 18.504 27.47 18.392 27.568C18.28 27.666 18.161 27.715 18.035 27.715C17.825 27.715 17.671 27.596 17.573 27.358L16.88 25.552C16.768 25.272 16.572 25.132 16.292 25.132H13.268C12.988 25.132 12.792 25.272 12.68 25.552L11.987 27.358C11.889 27.596 11.735 27.715 11.525 27.715ZM13.541 24.271H16.019C16.257 24.271 16.334 24.152 16.25 23.914L15.095 20.743C15.011 20.519 14.906 20.407 14.78 20.407C14.654 20.407 14.549 20.519 14.465 20.743L13.31 23.914C13.226 24.152 13.303 24.271 13.541 24.271Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M31 7C32.6569 7 34 8.34315 34 10V15H6V10C6 8.34315 7.34315 7 9 7H31ZM9 10C8.44772 10 8 10.4477 8 11C8 11.5523 8.44772 12 9 12C9.55228 12 10 11.5523 10 11C10 10.4477 9.55228 10 9 10ZM13 10C12.4477 10 12 10.4477 12 11C12 11.5523 12.4477 12 13 12C13.5523 12 14 11.5523 14 11C14 10.4477 13.5523 10 13 10ZM17 10C16.4477 10 16 10.4477 16 11C16 11.5523 16.4477 12 17 12C17.5523 12 18 11.5523 18 11C18 10.4477 17.5523 10 17 10Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"40x40_search-chart": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.13176 32.6526C4.74124 32.2621 4.74124 31.6289 5.13176 31.2384L10.7886 25.5815L14.3241 29.1171L8.66729 34.7739C8.27677 35.1645 7.6436 35.1645 7.25308 34.7739L5.13176 32.6526Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M12.3286 8.48535C17.4054 3.40854 25.6366 3.40854 30.7134 8.48535C35.7902 13.5622 35.7902 21.7933 30.7134 26.8701C25.6366 31.9469 17.4054 31.9469 12.3286 26.8701C7.2518 21.7933 7.2518 13.5622 12.3286 8.48535Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M16.5 12C17.0523 12 17.5 12.4477 17.5 13V23H15.5V13C15.5 12.4477 15.9477 12 16.5 12Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M21 15C21 14.4477 20.5523 14 20 14C19.4477 14 19 14.4477 19 15V23H21V15Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M23.5 10C24.0523 10 24.5 10.4477 24.5 11V23H22.5V11C22.5 10.4477 22.9477 10 23.5 10Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M27 16C27.5523 16 28 16.4477 28 17V23H26V17C26 16.4477 26.4477 16 27 16Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M14.5 23H29\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></svg>",
	"40x40_trending-up-down": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"11\" y=\"21\" width=\"6\" height=\"13\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"18\" y=\"26\" width=\"6\" height=\"8\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><rect x=\"25\" y=\"30\" width=\"6\" height=\"4.28571\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M6 13V12H9.37947C9.90994 12 10.4187 12.2107 10.7938 12.5859L16.8145 18.6072L16.0885 19.2955L10.0866 13.2929C9.89908 13.1054 9.64471 13 9.37947 13H6Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M18.8048 22.012L21.4393 24.6468C22.025 25.2327 22.9749 25.2328 23.5607 24.6469L26.1464 22.0612C26.3417 21.866 26.6583 21.866 26.8535 22.0612L32.2928 27.5005H31.4999C31.2238 27.5005 30.9999 27.7244 30.9999 28.0005C30.9999 28.2767 31.2238 28.5005 31.4999 28.5005H33.4999C33.7761 28.5005 33.9999 28.2767 33.9999 28.0005V26.0005C33.9999 25.7244 33.7761 25.5005 33.4999 25.5005C33.2238 25.5005 32.9999 25.7244 32.9999 26.0005V26.7934L27.5606 21.3541C26.9748 20.7683 26.0251 20.7683 25.4393 21.3541L22.8536 23.9398C22.6583 24.1351 22.3417 24.1351 22.1465 23.9398L19.5307 21.3238L18.8048 22.012Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M6 28.5005V27.5005H9.37947C9.64471 27.5005 9.89908 27.3951 10.0866 27.2076L21.4393 15.8537C22.025 15.2678 22.9749 15.2677 23.5607 15.8536L26.1464 18.4393C26.3417 18.6345 26.6583 18.6345 26.8535 18.4393L32.2928 12.9999H31.4999C31.2238 12.9999 30.9999 12.7761 30.9999 12.4999C30.9999 12.2238 31.2238 11.9999 31.4999 11.9999H33.4999C33.7761 11.9999 33.9999 12.2238 33.9999 12.4999V14.4999C33.9999 14.7761 33.7761 14.9999 33.4999 14.9999C33.2238 14.9999 32.9999 14.7761 32.9999 14.4999V13.707L27.5606 19.1464C26.9748 19.7322 26.0251 19.7322 25.4393 19.1464L22.8536 16.5607C22.6583 16.3654 22.3417 16.3654 22.1465 16.5607L10.7938 27.9146C10.4187 28.2897 9.90994 28.5005 9.37947 28.5005H6Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\"/><path d=\"M6 6V30C6 32.2091 7.79086 34 10 34H34\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\"/></svg>",
	"40x40_verified": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M25.9924 25.9695L28.0163 30.2309C28.1828 30.5815 27.8993 30.9703 27.5094 30.9259L25.8624 30.7387C25.6784 30.7177 25.4991 30.7971 25.3951 30.9454L24.4526 32.2898C24.2327 32.6034 23.7445 32.5576 23.5784 32.2077L21.1541 27.1031\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M13.7957 25.9695L11.7718 30.2309C11.6053 30.5815 11.8888 30.9703 12.2787 30.9259L13.9257 30.7387C14.1097 30.7177 14.289 30.7971 14.393 30.9454L15.3355 32.2898C15.5554 32.6034 16.0435 32.5576 16.2097 32.2077L18.634 27.1031\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M19.452 7.32241C19.7154 7.13031 20.0727 7.13031 20.336 7.32241L22.4539 8.86728C22.5826 8.96119 22.7379 9.01166 22.8973 9.01135L25.5187 9.00636C25.8447 9.00574 26.1337 9.21575 26.2339 9.52596L27.0392 12.0206C27.0881 12.1723 27.1841 12.3044 27.3132 12.3978L29.4369 13.9346C29.701 14.1257 29.8114 14.4655 29.7101 14.7753L28.8953 17.2669C28.8457 17.4183 28.8457 17.5817 28.8953 17.7331L29.7101 20.2247C29.8114 20.5345 29.701 20.8743 29.4369 21.0654L27.3132 22.6022C27.1841 22.6956 27.0881 22.8277 27.0392 22.9794L26.2339 25.474C26.1337 25.7843 25.8447 25.9943 25.5187 25.9936L22.8973 25.9886C22.7379 25.9883 22.5826 26.0388 22.4539 26.1327L20.336 27.6776C20.0727 27.8697 19.7154 27.8697 19.452 27.6776L17.3342 26.1327C17.2055 26.0388 17.0502 25.9883 16.8908 25.9886L14.2694 25.9936C13.9434 25.9943 13.6544 25.7843 13.5542 25.474L12.7489 22.9794C12.7 22.8277 12.604 22.6956 12.4749 22.6022L10.3512 21.0654C10.0871 20.8743 9.97668 20.5345 10.078 20.2247L10.8928 17.7331C10.9423 17.5817 10.9423 17.4183 10.8928 17.2669L10.078 14.7753C9.97668 14.4655 10.0871 14.1257 10.3512 13.9346L12.4749 12.3978C12.604 12.3044 12.7 12.1723 12.7489 12.0206L13.5542 9.52596C13.6544 9.21575 13.9434 9.00574 14.2694 9.00636L16.8908 9.01135C17.0502 9.01166 17.2055 8.96119 17.3342 8.86728L19.452 7.32241Z\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2e3d4b)\" stroke-linejoin=\"round\"/><path d=\"M19.8943 11.3235C23.3053 11.3236 26.0701 14.0892 26.0701 17.5002C26.0699 20.9112 23.3052 23.6759 19.8943 23.676C16.4832 23.676 13.7177 20.9113 13.7175 17.5002C13.7175 14.0891 16.4831 11.3235 19.8943 11.3235ZM23.2927 15.2131C22.9301 14.9325 22.3898 14.978 22.0876 15.3147L19.1248 18.6174L17.6472 17.2473C17.3143 16.9374 16.7721 16.9374 16.4392 17.2473C16.1051 17.5565 16.1051 18.0612 16.4392 18.3704L18.5769 20.3557C18.7468 20.5134 18.9799 20.5977 19.2205 20.5872C19.4598 20.5775 19.6848 20.4735 19.8386 20.302L23.4021 16.3313C23.704 15.9946 23.6551 15.4937 23.2927 15.2131Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>"
}, j = {
	inherit: O["prism-icon--inherit"],
	default: O["prism-icon--default"],
	"default-inverse": O["prism-icon--default-inverse"],
	emphasis: O["prism-icon--emphasis"],
	subdued: O["prism-icon--subdued"],
	info: O["prism-icon--info"],
	success: O["prism-icon--success"],
	warning: O["prism-icon--warning"],
	critical: O["prism-icon--critical"],
	intelligence: O["prism-icon--intelligence"],
	brand: O["prism-icon--brand"],
	"on-info": O["prism-icon--on-info"],
	"on-success": O["prism-icon--on-success"],
	"on-warning": O["prism-icon--on-warning"],
	"on-critical": O["prism-icon--on-critical"],
	"on-intelligence": O["prism-icon--on-intelligence"],
	"on-brand": O["prism-icon--on-brand"],
	disabled: O["prism-icon--disabled"]
}, M = {
	"extra-small": O["prism-icon--extra-small"],
	small: O["prism-icon--small"],
	medium: O["prism-icon--medium"],
	large: O["prism-icon--large"]
};
function N(e) {
	let t = (0, x.c)(14), n, r, i, a;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({name: r, color: n, size: a, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a);
	let o = (0, S.useId)(), s = n ? j[n] : j.default, c = a ? M[a] : M.medium, l = k[r];
	l === void 0 && (console.error(`Icon "${r}" does not exist`), l = "");
	let u;
	t[5] !== l || t[6] !== o ? (u = l.replaceAll("{{UNIQUE_ID}}", o), t[5] = l, t[6] = o, t[7] = u) : u = t[7], l = u;
	let d = `${O["prism-icon"]} ${c} ${s}`, f;
	t[8] === l ? f = t[9] : (f = { __html: l }, t[8] = l, t[9] = f);
	let p;
	return t[10] !== i || t[11] !== d || t[12] !== f ? (p = /* @__PURE__ */ (0, C.jsx)("span", {
		className: d,
		dangerouslySetInnerHTML: f,
		...i
	}), t[10] = i, t[11] = d, t[12] = f, t[13] = p) : p = t[13], p;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/_virtual/_rolldown/runtime.js
var P = Object.create, F = Object.defineProperty, I = Object.getOwnPropertyDescriptor, L = Object.getOwnPropertyNames, ee = Object.getPrototypeOf, R = Object.prototype.hasOwnProperty, z = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), te = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = L(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !R.call(e, s) && s !== n && F(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = I(t, s)) || r.enumerable
	});
	return e;
}, B = (e, t, n) => (n = e == null ? {} : P(ee(e)), te(t || !e || !e.__esModule ? F(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), V = /* @__PURE__ */ z(((e, t) => {
	(function() {
		var e = {}.hasOwnProperty;
		function n() {
			for (var e = "", t = 0; t < arguments.length; t++) {
				var n = arguments[t];
				n && (e = i(e, r(n)));
			}
			return e;
		}
		function r(t) {
			if (typeof t == "string" || typeof t == "number") return t;
			if (typeof t != "object") return "";
			if (Array.isArray(t)) return n.apply(null, t);
			if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]")) return t.toString();
			var r = "";
			for (var a in t) e.call(t, a) && t[a] && (r = i(r, a));
			return r;
		}
		function i(e, t) {
			return t ? e ? e + " " + t : e + t : e;
		}
		t !== void 0 && t.exports ? (n.default = n, t.exports = n) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
			return n;
		}) : window.classNames = n;
	})();
}));
V();
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/accordion.module.js
var ne = {
	"prism-accordion": "_prism-accordion_7hrcp_7",
	"prism-accordion__item": "_prism-accordion__item_7hrcp_14",
	"prism-accordion__header": "_prism-accordion__header_7hrcp_36",
	"prism-accordion__content": "_prism-accordion__content_7hrcp_58",
	"prism-accordion__chevron": "_prism-accordion__chevron_7hrcp_64"
}, re = /* @__PURE__ */ B(V(), 1);
function ie(e) {
	let t = (0, x.c)(9), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, re.default)(ne["prism-accordion__chevron"], n), t[3] = n, t[4] = i);
	let a;
	t[5] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ (0, C.jsx)(N, {
		name: "chevron-down",
		size: "small"
	}), t[5] = a) : a = t[5];
	let o;
	return t[6] !== r || t[7] !== i ? (o = /* @__PURE__ */ (0, C.jsx)("span", {
		className: i,
		...r,
		children: a
	}), t[6] = r, t[7] = i, t[8] = o) : o = t[8], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/accordion/content.js
var ae = /* @__PURE__ */ B(V(), 1);
function oe(e) {
	let t = (0, x.c)(10), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({className: r, children: n, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a;
	t[4] === r ? a = t[5] : (a = (0, ae.default)(ne["prism-accordion__content"], r), t[4] = r, t[5] = a);
	let o;
	return t[6] !== n || t[7] !== i || t[8] !== a ? (o = /* @__PURE__ */ (0, C.jsx)("div", {
		className: a,
		...i,
		children: n
	}), t[6] = n, t[7] = i, t[8] = a, t[9] = o) : o = t[9], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/accordion/context.js
var H = (0, S.createContext)(void 0);
function se() {
	let e = (0, S.useContext)(H);
	if (e === void 0) throw Error("useAccordionContext must be used within an Accordion parent component");
	return e;
}
var ce = (0, S.createContext)(void 0);
function le() {
	let e = (0, S.useContext)(ce);
	if (e === void 0) throw Error("useAccordionItemContext must be used within an Accordion.Item parent component");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/accordion/header.js
var ue = /* @__PURE__ */ B(V(), 1);
function de(e) {
	let t = (0, x.c)(16), n, r, i, a;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({className: r, children: n, onClick: i, ...a} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a);
	let { disabled: o } = le(), s;
	t[5] !== o || t[6] !== i ? (s = (e) => {
		if (o) {
			e.preventDefault();
			return;
		}
		i?.(e);
	}, t[5] = o, t[6] = i, t[7] = s) : s = t[7];
	let c = s, l;
	t[8] === r ? l = t[9] : (l = (0, ue.default)(ne["prism-accordion__header"], r), t[8] = r, t[9] = l);
	let u = o ? -1 : void 0, d;
	return t[10] !== n || t[11] !== c || t[12] !== a || t[13] !== l || t[14] !== u ? (d = /* @__PURE__ */ (0, C.jsx)("summary", {
		className: l,
		onClick: c,
		tabIndex: u,
		...a,
		children: n
	}), t[10] = n, t[11] = c, t[12] = a, t[13] = l, t[14] = u, t[15] = d) : d = t[15], d;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/accordion/item.js
var fe = /* @__PURE__ */ B(V(), 1);
function pe(e) {
	let t = (0, x.c)(20), n, r, i, a, o;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5]) : ({defaultOpen: i, disabled: o, className: r, children: n, ...a} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o);
	let s = o === void 0 ? !1 : o, { groupName: c } = se(), l;
	t[6] === r ? l = t[7] : (l = (0, fe.default)(ne["prism-accordion__item"], r), t[6] = r, t[7] = l);
	let u = s ? "" : void 0, d = s ? void 0 : c, f;
	t[8] === s ? f = t[9] : (f = { disabled: s }, t[8] = s, t[9] = f);
	let p;
	t[10] !== n || t[11] !== f ? (p = /* @__PURE__ */ (0, C.jsx)(ce.Provider, {
		value: f,
		children: n
	}), t[10] = n, t[11] = f, t[12] = p) : p = t[12];
	let m;
	return t[13] !== i || t[14] !== a || t[15] !== l || t[16] !== u || t[17] !== d || t[18] !== p ? (m = /* @__PURE__ */ (0, C.jsx)("details", {
		className: l,
		"data-disabled": u,
		name: d,
		open: i,
		...a,
		children: p
	}), t[13] = i, t[14] = a, t[15] = l, t[16] = u, t[17] = d, t[18] = p, t[19] = m) : m = t[19], m;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/accordion.js
var me = /* @__PURE__ */ B(V(), 1);
function he(e) {
	let t = (0, x.c)(16), n, r, i, a;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({multiple: a, className: r, children: n, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a);
	let o = a === void 0 ? !1 : a, s = (0, S.useId)(), c = o ? void 0 : s, l;
	t[5] === c ? l = t[6] : (l = { groupName: c }, t[5] = c, t[6] = l);
	let u;
	t[7] === r ? u = t[8] : (u = (0, me.default)(ne["prism-accordion"], r), t[7] = r, t[8] = u);
	let d;
	t[9] !== n || t[10] !== i || t[11] !== u ? (d = /* @__PURE__ */ (0, C.jsx)("div", {
		className: u,
		...i,
		children: n
	}), t[9] = n, t[10] = i, t[11] = u, t[12] = d) : d = t[12];
	let f;
	return t[13] !== l || t[14] !== d ? (f = /* @__PURE__ */ (0, C.jsx)(H.Provider, {
		value: l,
		children: d
	}), t[13] = l, t[14] = d, t[15] = f) : f = t[15], f;
}
he.Item = pe, he.Header = de, he.Content = oe, he.Chevron = ie;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/loading-spinner.module.js
var ge = {
	"prism-loading--spinner": "_prism-loading--spinner_1fib5_1",
	"prism-loading-spin": "_prism-loading-spin_1fib5_1"
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/loading-spinner.js
function _e(e) {
	let t = (0, x.c)(27), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({color: r, size: i, ...n} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a = r === void 0 ? "default" : r, o = i === void 0 ? "medium" : i, s = j[a], c = M[o], l = (0, S.useId)(), u = `${ge["prism-loading--spinner"]} ${c} ${s}`, d = `spinner-secondHalf-${l}`, f, p;
	t[4] === Symbol.for("react.memo_cache_sentinel") ? (f = /* @__PURE__ */ (0, C.jsx)("stop", {
		offset: "0%",
		stopColor: "currentColor",
		stopOpacity: "0"
	}), p = /* @__PURE__ */ (0, C.jsx)("stop", {
		offset: "100%",
		stopColor: "currentColor",
		stopOpacity: "0.7"
	}), t[4] = f, t[5] = p) : (f = t[4], p = t[5]);
	let m;
	t[6] === d ? m = t[7] : (m = /* @__PURE__ */ (0, C.jsxs)("linearGradient", {
		id: d,
		children: [f, p]
	}), t[6] = d, t[7] = m);
	let h = `spinner-firstHalf-${l}`, g, _;
	t[8] === Symbol.for("react.memo_cache_sentinel") ? (_ = /* @__PURE__ */ (0, C.jsx)("stop", {
		offset: "0%",
		stopColor: "currentColor",
		stopOpacity: "1"
	}), g = /* @__PURE__ */ (0, C.jsx)("stop", {
		offset: "100%",
		stopColor: "currentColor",
		stopOpacity: "0.7"
	}), t[8] = g, t[9] = _) : (g = t[8], _ = t[9]);
	let v;
	t[10] === h ? v = t[11] : (v = /* @__PURE__ */ (0, C.jsxs)("linearGradient", {
		id: h,
		children: [_, g]
	}), t[10] = h, t[11] = v);
	let y;
	t[12] !== v || t[13] !== m ? (y = /* @__PURE__ */ (0, C.jsxs)("defs", { children: [m, v] }), t[12] = v, t[13] = m, t[14] = y) : y = t[14];
	let b = `url(#spinner-secondHalf-${l})`, w;
	t[15] === b ? w = t[16] : (w = /* @__PURE__ */ (0, C.jsx)("path", {
		d: "M 1 12 A 4.5 4.5 0 0 1 23 12",
		fill: "transparent",
		stroke: b
	}), t[15] = b, t[16] = w);
	let T = `url(#spinner-firstHalf-${l})`, E;
	t[17] === T ? E = t[18] : (E = /* @__PURE__ */ (0, C.jsx)("path", {
		d: "M 23 12 A 4.5 4.5 0 0 1 1 12",
		fill: "transparent",
		stroke: T
	}), t[17] = T, t[18] = E);
	let D;
	t[19] !== w || t[20] !== E ? (D = /* @__PURE__ */ (0, C.jsxs)("g", {
		strokeWidth: "2",
		children: [w, E]
	}), t[19] = w, t[20] = E, t[21] = D) : D = t[21];
	let O;
	return t[22] !== n || t[23] !== y || t[24] !== D || t[25] !== u ? (O = /* @__PURE__ */ (0, C.jsxs)("svg", {
		className: u,
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg",
		...n,
		"aria-hidden": "true",
		children: [y, D]
	}), t[22] = n, t[23] = y, t[24] = D, t[25] = u, t[26] = O) : O = t[26], O;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/button.module.js
var ve = {
	"prism-button__label": "_prism-button__label_jx6oj_1",
	"prism-button--loading": "_prism-button--loading_jx6oj_7",
	"prism-button--loading-spinner": "_prism-button--loading-spinner_jx6oj_15"
}, ye = /* @__PURE__ */ B(V(), 1), be = {
	primary: "default-inverse",
	secondary: "default",
	critical: "default-inverse",
	"critical-secondary": "critical",
	warning: "on-warning",
	success: "default-inverse",
	intelligence: "default-inverse",
	"intelligence-secondary": "on-intelligence",
	brand: "default-inverse",
	ghost: "default",
	unstyled: "default"
};
function xe(e) {
	let t = (0, x.c)(58), n, r, i, a, o, s, c, l, u, d, f, p;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11], p = t[12]) : ({buttonType: u, children: n, className: d, href: r, icon: i, iconAfter: a, iconBefore: o, isDisabled: s, isLoading: c, loadingMessage: f, size: p, ...l} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u, t[10] = d, t[11] = f, t[12] = p);
	let m = u === void 0 ? "primary" : u, h = d === void 0 ? "" : d, g = f === void 0 ? "Loading" : f, _ = p === void 0 ? "medium" : p, v = !n, y = n ? "small" : _, b = s ? "disabled" : be[m], S = `prism-button--${_}`, w = `prism-button--${m}`, T;
	t[13] !== h || t[14] !== v || t[15] !== c || t[16] !== S || t[17] !== w ? (T = (0, ye.default)(ve["prism-button"], "prism-button", S, w, {
		"prism-button--icon-only": v,
		[ve["prism-button--loading"]]: c
	}, h), t[13] = h, t[14] = v, t[15] = c, t[16] = S, t[17] = w, t[18] = T) : T = t[18];
	let E = T, D;
	t[19] !== o || t[20] !== b || t[21] !== y ? (D = o && /* @__PURE__ */ (0, C.jsx)(N, {
		color: b,
		name: o,
		size: y
	}), t[19] = o, t[20] = b, t[21] = y, t[22] = D) : D = t[22];
	let O;
	t[23] === n ? O = t[24] : (O = n && /* @__PURE__ */ (0, C.jsx)("span", {
		className: ve["prism-button__label"],
		children: n
	}), t[23] = n, t[24] = O);
	let k;
	t[25] !== i || t[26] !== b || t[27] !== y ? (k = i && /* @__PURE__ */ (0, C.jsx)(N, {
		color: b,
		name: i,
		size: y
	}), t[25] = i, t[26] = b, t[27] = y, t[28] = k) : k = t[28];
	let A;
	t[29] !== a || t[30] !== b || t[31] !== y ? (A = a && /* @__PURE__ */ (0, C.jsx)(N, {
		color: b,
		name: a,
		size: y
	}), t[29] = a, t[30] = b, t[31] = y, t[32] = A) : A = t[32];
	let j;
	t[33] !== y || t[34] !== c ? (j = c && /* @__PURE__ */ (0, C.jsx)("span", {
		className: ve["prism-button--loading-spinner"],
		children: /* @__PURE__ */ (0, C.jsx)(_e, {
			color: "inherit",
			size: y
		})
	}), t[33] = y, t[34] = c, t[35] = j) : j = t[35];
	let M;
	t[36] !== k || t[37] !== A || t[38] !== j || t[39] !== D || t[40] !== O ? (M = /* @__PURE__ */ (0, C.jsxs)(C.Fragment, { children: [
		D,
		O,
		k,
		A,
		j
	] }), t[36] = k, t[37] = A, t[38] = j, t[39] = D, t[40] = O, t[41] = M) : M = t[41];
	let P = M;
	if (r !== void 0) {
		let e = l, n;
		return t[42] !== E || t[43] !== P || t[44] !== r || t[45] !== e ? (n = /* @__PURE__ */ (0, C.jsx)("a", {
			className: E,
			href: r,
			...e,
			children: P
		}), t[42] = E, t[43] = P, t[44] = r, t[45] = e, t[46] = n) : n = t[46], n;
	}
	let F = c ? g : "", I;
	t[47] === F ? I = t[48] : (I = /* @__PURE__ */ (0, C.jsx)("span", {
		"aria-live": "polite",
		className: "sr-only",
		children: F
	}), t[47] = F, t[48] = I);
	let L = c || void 0, ee = l, R;
	t[49] !== E || t[50] !== P || t[51] !== s || t[52] !== L || t[53] !== ee ? (R = /* @__PURE__ */ (0, C.jsx)("button", {
		"aria-busy": L,
		className: E,
		disabled: s,
		type: "button",
		...ee,
		children: P
	}), t[49] = E, t[50] = P, t[51] = s, t[52] = L, t[53] = ee, t[54] = R) : R = t[54];
	let z;
	return t[55] !== I || t[56] !== R ? (z = /* @__PURE__ */ (0, C.jsxs)(C.Fragment, { children: [I, R] }), t[55] = I, t[56] = R, t[57] = z) : z = t[57], z;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/illustration.module.js
var Se = { illustration: "_illustration_1ah42_1" };
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/illustration.js
function Ce(e) {
	let t = (0, x.c)(12), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({name: r, className: n, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a = A[r];
	a ||= (console.error(`Illustration "${String(r)}" does not exist`), "");
	let o;
	t[4] === n ? o = t[5] : (o = [Se.illustration, n].filter(Boolean), t[4] = n, t[5] = o);
	let s = o.join(" "), c;
	t[6] === a ? c = t[7] : (c = { __html: a }, t[6] = a, t[7] = c);
	let l;
	return t[8] !== s || t[9] !== i || t[10] !== c ? (l = /* @__PURE__ */ (0, C.jsx)("div", {
		className: s,
		dangerouslySetInnerHTML: c,
		...i
	}), t[8] = s, t[9] = i, t[10] = c, t[11] = l) : l = t[11], l;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/useRefWithInit.js
var we = {};
function Te(e, t) {
	let n = S.useRef(we);
	return n.current === we && (n.current = e(t)), n;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/useStableCallback.js
var Ee = S[`useInsertionEffect${Math.random().toFixed(1)}`.slice(0, -3)], De = Ee && Ee !== S.useLayoutEffect ? Ee : (e) => e();
function U(e) {
	let t = Te(Oe).current;
	return t.next = e, De(t.effect), t.trampoline;
}
function Oe() {
	let e = {
		next: void 0,
		callback: ke,
		trampoline: (...t) => e.callback?.(...t),
		effect: () => {
			e.callback = e.next;
		}
	};
	return e;
}
function ke() {
	if (process.env.NODE_ENV !== "production") throw Error("Base UI: Cannot call an event handler while rendering.");
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@floating-ui_utils@0.2.11/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.js
function Ae() {
	return typeof window < "u";
}
function je(e) {
	return Pe(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Me(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ne(e) {
	return ((Pe(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Pe(e) {
	return Ae() ? e instanceof Node || e instanceof Me(e).Node : !1;
}
function Fe(e) {
	return Ae() ? e instanceof Element || e instanceof Me(e).Element : !1;
}
function Ie(e) {
	return Ae() ? e instanceof HTMLElement || e instanceof Me(e).HTMLElement : !1;
}
function Le(e) {
	return !Ae() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Me(e).ShadowRoot;
}
function Re(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = Ye(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function ze(e) {
	return /^(table|td|th)$/.test(je(e));
}
function Be(e) {
	try {
		if (e.matches(":popover-open")) return !0;
	} catch {}
	try {
		return e.matches(":modal");
	} catch {
		return !1;
	}
}
var Ve = /transform|translate|scale|rotate|perspective|filter/, He = /paint|layout|strict|content/, Ue = (e) => !!e && e !== "none", We;
function Ge(e) {
	let t = Fe(e) ? Ye(e) : e;
	return Ue(t.transform) || Ue(t.translate) || Ue(t.scale) || Ue(t.rotate) || Ue(t.perspective) || !qe() && (Ue(t.backdropFilter) || Ue(t.filter)) || Ve.test(t.willChange || "") || He.test(t.contain || "");
}
function Ke(e) {
	let t = Ze(e);
	for (; Ie(t) && !Je(t);) {
		if (Ge(t)) return t;
		if (Be(t)) return null;
		t = Ze(t);
	}
	return null;
}
function qe() {
	return We ??= typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none"), We;
}
function Je(e) {
	return /^(html|body|#document)$/.test(je(e));
}
function Ye(e) {
	return Me(e).getComputedStyle(e);
}
function Xe(e) {
	return Fe(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function Ze(e) {
	if (je(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Le(e) && e.host || Ne(e);
	return Le(t) ? t.host : t;
}
function Qe(e) {
	let t = Ze(e);
	return Je(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ie(t) && Re(t) ? t : Qe(t);
}
function $e(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = Qe(e), i = r === e.ownerDocument?.body, a = Me(r);
	if (i) {
		let e = et(a);
		return t.concat(a, a.visualViewport || [], Re(r) ? r : [], e && n ? $e(e) : []);
	} else return t.concat(r, $e(r, [], n));
}
function et(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/detectBrowser.js
var tt = typeof navigator < "u", nt = ft(), rt = mt(), it = pt(), at = typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter:none"), ot = nt.platform === "MacIntel" && nt.maxTouchPoints > 1 ? !0 : /iP(hone|ad|od)|iOS/.test(nt.platform), st = tt && /firefox/i.test(it), ct = tt && /apple/i.test(navigator.vendor);
tt && /Edg/i.test(it);
var lt = tt && /android/i.test(rt) || /android/i.test(it), ut = tt && rt.toLowerCase().startsWith("mac") && !navigator.maxTouchPoints, dt = it.includes("jsdom/");
function ft() {
	if (!tt) return {
		platform: "",
		maxTouchPoints: -1
	};
	let e = navigator.userAgentData;
	return e?.platform ? {
		platform: e.platform,
		maxTouchPoints: navigator.maxTouchPoints
	} : {
		platform: navigator.platform ?? "",
		maxTouchPoints: navigator.maxTouchPoints ?? -1
	};
}
function pt() {
	if (!tt) return "";
	let e = navigator.userAgentData;
	return e && Array.isArray(e.brands) ? e.brands.map(({ brand: e, version: t }) => `${e}/${t}`).join(" ") : navigator.userAgent;
}
function mt() {
	if (!tt) return "";
	let e = navigator.userAgentData;
	return e?.platform ? e.platform : navigator.platform ?? "";
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/owner.js
function ht(e) {
	return e?.ownerDocument || document;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/useIsoLayoutEffect.js
var W = typeof document < "u" ? S.useLayoutEffect : () => {}, gt = [];
function _t(e) {
	S.useEffect(e, gt);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/useTimeout.js
var vt = 0, yt = class e {
	static create() {
		return new e();
	}
	currentId = vt;
	start(e, t) {
		this.clear(), this.currentId = setTimeout(() => {
			this.currentId = vt, t();
		}, e);
	}
	isStarted() {
		return this.currentId !== vt;
	}
	clear = () => {
		this.currentId !== vt && (clearTimeout(this.currentId), this.currentId = vt);
	};
	disposeEffect = () => this.clear;
};
function bt() {
	let e = Te(yt.create).current;
	return _t(e.disposeEffect), e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/useAnimationFrame.js
var xt = null, St = globalThis.requestAnimationFrame, Ct = new class {
	callbacks = [];
	callbacksCount = 0;
	nextId = 1;
	startId = 1;
	isScheduled = !1;
	tick = (e) => {
		this.isScheduled = !1;
		let t = this.callbacks, n = this.callbacksCount;
		if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, n > 0) for (let n = 0; n < t.length; n += 1) t[n]?.(e);
	};
	request(e) {
		let t = this.nextId;
		this.nextId += 1, this.callbacks.push(e), this.callbacksCount += 1;
		let n = process.env.NODE_ENV !== "production" && St !== requestAnimationFrame && (St = requestAnimationFrame, !0);
		return (!this.isScheduled || n) && (requestAnimationFrame(this.tick), this.isScheduled = !0), t;
	}
	cancel(e) {
		let t = e - this.startId;
		t < 0 || t >= this.callbacks.length || (this.callbacks[t] = null, --this.callbacksCount);
	}
}(), wt = class e {
	static create() {
		return new e();
	}
	static request(e) {
		return Ct.request(e);
	}
	static cancel(e) {
		return Ct.cancel(e);
	}
	currentId = xt;
	request(e) {
		this.cancel(), this.currentId = Ct.request(() => {
			this.currentId = xt, e();
		});
	}
	cancel = () => {
		this.currentId !== xt && (Ct.cancel(this.currentId), this.currentId = xt);
	};
	disposeEffect = () => this.cancel;
};
function Tt() {
	let e = Te(wt.create).current;
	return _t(e.disposeEffect), e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/empty.js
function Et() {}
var Dt = Object.freeze([]), Ot = Object.freeze({}), kt = {}, At = {}, jt = "";
function Mt(e) {
	if (typeof document > "u") return !1;
	let t = ht(e);
	return Me(t).innerWidth - t.documentElement.clientWidth > 0;
}
function Nt(e) {
	if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u") return !1;
	let t = ht(e), n = t.documentElement, r = t.body, i = Re(n) ? n : r, a = i.style.overflowY, o = n.style.scrollbarGutter;
	n.style.scrollbarGutter = "stable", i.style.overflowY = "scroll";
	let s = i.offsetWidth;
	i.style.overflowY = "hidden";
	let c = i.offsetWidth;
	return i.style.overflowY = a, n.style.scrollbarGutter = o, s === c;
}
function Pt(e) {
	let t = ht(e), n = t.documentElement, r = t.body, i = Re(n) ? n : r, a = {
		overflowY: i.style.overflowY,
		overflowX: i.style.overflowX
	};
	return Object.assign(i.style, {
		overflowY: "hidden",
		overflowX: "hidden"
	}), () => {
		Object.assign(i.style, a);
	};
}
function Ft(e) {
	let t = ht(e), n = t.documentElement, r = t.body, i = Me(n), a = 0, o = 0, s = !1, c = wt.create();
	if (at && (i.visualViewport?.scale ?? 1) !== 1) return () => {};
	function l() {
		let t = i.getComputedStyle(n), c = i.getComputedStyle(r), l = (t.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
		a = n.scrollTop, o = n.scrollLeft, kt = {
			scrollbarGutter: n.style.scrollbarGutter,
			overflowY: n.style.overflowY,
			overflowX: n.style.overflowX
		}, jt = n.style.scrollBehavior, At = {
			position: r.style.position,
			height: r.style.height,
			width: r.style.width,
			boxSizing: r.style.boxSizing,
			overflowY: r.style.overflowY,
			overflowX: r.style.overflowX,
			scrollBehavior: r.style.scrollBehavior
		};
		let u = n.scrollHeight > n.clientHeight, d = n.scrollWidth > n.clientWidth, f = t.overflowY === "scroll" || c.overflowY === "scroll", p = t.overflowX === "scroll" || c.overflowX === "scroll", m = Math.max(0, i.innerWidth - r.clientWidth), h = Math.max(0, i.innerHeight - r.clientHeight), g = parseFloat(c.marginTop) + parseFloat(c.marginBottom), _ = parseFloat(c.marginLeft) + parseFloat(c.marginRight), v = Re(n) ? n : r;
		if (s = Nt(e), s) {
			n.style.scrollbarGutter = l, v.style.overflowY = "hidden", v.style.overflowX = "hidden";
			return;
		}
		Object.assign(n.style, {
			scrollbarGutter: l,
			overflowY: "hidden",
			overflowX: "hidden"
		}), (u || f) && (n.style.overflowY = "scroll"), (d || p) && (n.style.overflowX = "scroll"), Object.assign(r.style, {
			position: "relative",
			height: g || h ? `calc(100dvh - ${g + h}px)` : "100dvh",
			width: _ || m ? `calc(100vw - ${_ + m}px)` : "100vw",
			boxSizing: "border-box",
			overflow: "hidden",
			scrollBehavior: "unset"
		}), r.scrollTop = a, r.scrollLeft = o, n.setAttribute("data-base-ui-scroll-locked", ""), n.style.scrollBehavior = "unset";
	}
	function u() {
		Object.assign(n.style, kt), Object.assign(r.style, At), s || (n.scrollTop = a, n.scrollLeft = o, n.removeAttribute("data-base-ui-scroll-locked"), n.style.scrollBehavior = jt);
	}
	function d() {
		u(), c.request(l);
	}
	return l(), i.addEventListener("resize", d), () => {
		c.cancel(), u(), typeof i.removeEventListener == "function" && i.removeEventListener("resize", d);
	};
}
var It = new class {
	lockCount = 0;
	restore = null;
	timeoutLock = yt.create();
	timeoutUnlock = yt.create();
	acquire(e) {
		return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(e)), this.release;
	}
	release = () => {
		--this.lockCount, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
	};
	unlock = () => {
		this.lockCount === 0 && this.restore && (this.restore?.(), this.restore = null);
	};
	lock(e) {
		if (this.lockCount === 0 || this.restore !== null) return;
		let t = ht(e).documentElement, n = Me(t).getComputedStyle(t).overflowY;
		if (n === "hidden" || n === "clip") {
			this.restore = Et;
			return;
		}
		this.restore = ot || !Mt(e) ? Pt(e) : Ft(e);
	}
}();
function Lt(e = !0, t = null) {
	W(() => {
		if (e) return It.acquire(t);
	}, [e, t]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/utils/constants.js
var Rt = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", zt = "ArrowLeft", Bt = "ArrowRight", Vt = "ArrowUp", Ht = "ArrowDown";
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/utils/element.js
function Ut(e) {
	let t = e.activeElement;
	for (; t?.shadowRoot?.activeElement != null;) t = t.shadowRoot.activeElement;
	return t;
}
function G(e, t) {
	if (!e || !t) return !1;
	let n = t.getRootNode?.();
	if (e.contains(t)) return !0;
	if (n && Le(n)) {
		let n = t;
		for (; n;) {
			if (e === n) return !0;
			n = n.parentNode || n.host;
		}
	}
	return !1;
}
function Wt(e, t) {
	if (!Fe(e)) return !1;
	let n = e;
	if (t.hasElement(n)) return !n.hasAttribute("data-trigger-disabled");
	for (let [, e] of t.entries()) if (G(e, n)) return !e.hasAttribute("data-trigger-disabled");
	return !1;
}
function Gt(e) {
	return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function Kt(e, t) {
	if (t == null) return !1;
	if ("composedPath" in e) return e.composedPath().includes(t);
	let n = e;
	return n.target != null && t.contains(n.target);
}
function qt(e) {
	return e.matches("html,body");
}
function Jt(e) {
	return Ie(e) && e.matches("input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])");
}
function Yt(e) {
	return e ? e.getAttribute("role") === "combobox" && Jt(e) : !1;
}
function Xt(e) {
	if (!e || dt) return !0;
	try {
		return e.matches(":focus-visible");
	} catch {
		return !0;
	}
}
function Zt(e) {
	return e ? e.hasAttribute("data-base-ui-focusable") ? e : e.querySelector("[data-base-ui-focusable]") || e : null;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/reason-parts.js
var Qt = "none", $t = "trigger-press", en = "trigger-hover", tn = "trigger-focus", nn = "outside-press", rn = "item-press", an = "close-press", on = "increment-press", sn = "decrement-press", cn = "input-change", ln = "input-clear", un = "input-blur", dn = "input-press", fn = "focus-out", pn = "escape-key", mn = "list-navigation", hn = "keyboard", gn = "imperative-action", _n = "window-resize";
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/createBaseUIEventDetails.js
function K(e, t, n, r) {
	let i = !1, a = !1, o = r ?? Ot;
	return {
		reason: e,
		event: t ?? new Event("base-ui"),
		cancel() {
			i = !0;
		},
		allowPropagation() {
			a = !0;
		},
		get isCanceled() {
			return i;
		},
		get isPropagationAllowed() {
			return a;
		},
		trigger: n,
		...o
	};
}
function vn(e, t, n) {
	let r = n ?? Ot;
	return {
		reason: e,
		event: t ?? new Event("base-ui"),
		...r
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/utils/nodes.js
function yn(e, t, n = !0) {
	return e.filter((e) => e.parentId === t && (!n || e.context?.open)).flatMap((t) => [t, ...yn(e, t.id, n)]);
}
function bn(e, t) {
	let n = [], r = e.find((e) => e.id === t)?.parentId;
	for (; r;) {
		let t = e.find((e) => e.id === r);
		r = t?.parentId, t && (n = n.concat(t));
	}
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/utils/event.js
function xn(e) {
	e.preventDefault(), e.stopPropagation();
}
function Sn(e) {
	return "nativeEvent" in e;
}
function Cn(e) {
	return e.pointerType === "" && e.isTrusted ? !0 : lt && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function wn(e) {
	return dt ? !1 : !lt && e.width === 0 && e.height === 0 || lt && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function Tn(e, t) {
	let n = ["mouse", "pen"];
	return t || n.push("", void 0), n.includes(e);
}
function En(e) {
	let t = e.type;
	return t === "click" || t === "mousedown" || t === "keydown" || t === "keyup";
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/utils/createAttribute.js
function Dn(e) {
	return `data-base-ui-${e}`;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/safeReact.js
var On = { ...S }, kn = 0;
function An(e, t = "mui") {
	let [n, r] = S.useState(e), i = e || n;
	return S.useEffect(() => {
		n ?? (kn += 1, r(`${t}-${kn}`));
	}, [n, t]), i;
}
var jn = On.useId;
function Mn(e, t) {
	if (jn !== void 0) {
		let n = jn();
		return e ?? (t ? `${t}-${n}` : n);
	}
	return An(e, t);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/utils/createEventEmitter.js
function Nn() {
	let e = /* @__PURE__ */ new Map();
	return {
		emit(t, n) {
			e.get(t)?.forEach((e) => e(n));
		},
		on(t, n) {
			e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
		},
		off(t, n) {
			e.get(t)?.delete(n);
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/components/FloatingTreeStore.js
var Pn = class {
	nodesRef = { current: [] };
	events = Nn();
	addNode(e) {
		this.nodesRef.current.push(e);
	}
	removeNode(e) {
		let t = this.nodesRef.current.findIndex((t) => t === e);
		t !== -1 && this.nodesRef.current.splice(t, 1);
	}
}, Fn = /* @__PURE__ */ S.createContext(null);
process.env.NODE_ENV !== "production" && (Fn.displayName = "FloatingNodeContext");
var In = /* @__PURE__ */ S.createContext(null);
process.env.NODE_ENV !== "production" && (In.displayName = "FloatingTreeContext");
var Ln = () => S.useContext(Fn)?.id || null, Rn = (e) => {
	let t = S.useContext(In);
	return e ?? t;
};
function zn(e) {
	let t = Mn(), n = Rn(e), r = Ln();
	return W(() => {
		if (!t) return;
		let e = {
			id: t,
			parentId: r
		};
		return n?.addNode(e), () => {
			n?.removeNode(e);
		};
	}, [
		n,
		t,
		r
	]), t;
}
function Bn(e) {
	let { children: t, id: n } = e, r = Ln();
	return /* @__PURE__ */ (0, C.jsx)(Fn.Provider, {
		value: S.useMemo(() => ({
			id: n,
			parentId: r
		}), [n, r]),
		children: t
	});
}
function Vn(e) {
	let { children: t, externalTree: n } = e, r = Te(() => n ?? new Pn()).current;
	return /* @__PURE__ */ (0, C.jsx)(In.Provider, {
		value: r,
		children: t
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useDismiss.js
var Hn = {
	intentional: "onClick",
	sloppy: "onPointerDown"
};
function Un() {
	return !1;
}
function Wn(e) {
	return {
		escapeKey: typeof e == "boolean" ? e : e?.escapeKey ?? !1,
		outsidePress: typeof e == "boolean" ? e : e?.outsidePress ?? !0
	};
}
function Gn(e, t = {}) {
	let n = "rootStore" in e ? e.rootStore : e, r = n.useState("open"), i = n.useState("floatingElement"), { dataRef: a } = n.context, { enabled: o = !0, escapeKey: s = !0, outsidePress: c = !0, outsidePressEvent: l = "sloppy", referencePress: u = Un, referencePressEvent: d = "sloppy", bubbles: f, externalTree: p } = t, m = Rn(p), h = U(typeof c == "function" ? c : () => !1), g = typeof c == "function" ? h : c, _ = g !== !1, v = U(() => l), y = S.useRef(!1), b = S.useRef(!1), x = S.useRef(!1), { escapeKey: C, outsidePress: w } = Wn(f), T = S.useRef(null), E = bt(), D = bt(), O = U(() => {
		D.clear(), a.current.insideReactTree = !1;
	}), k = S.useRef(!1), A = S.useRef(""), j = U(u), M = U((e) => {
		if (!r || !o || !s || e.key !== "Escape" || k.current) return;
		let t = a.current.floatingContext?.nodeId, i = m ? yn(m.nodesRef.current, t) : [];
		if (!C && i.length > 0) {
			let e = !0;
			if (i.forEach((t) => {
				t.context?.open && !t.context.dataRef.current.__escapeKeyBubbles && (e = !1);
			}), !e) return;
		}
		let c = K(pn, Sn(e) ? e.nativeEvent : e);
		n.setOpen(!1, c), !C && !c.isPropagationAllowed && e.stopPropagation();
	}), N = U(() => {
		a.current.insideReactTree = !0, D.start(0, O);
	});
	S.useEffect(() => {
		if (!r || !o) return;
		a.current.__escapeKeyBubbles = C, a.current.__outsidePressBubbles = w;
		let e = new yt(), t = new yt();
		function c() {
			e.clear(), k.current = !0;
		}
		function l() {
			e.start(qe() ? 5 : 0, () => {
				k.current = !1;
			});
		}
		function u() {
			x.current = !0, t.start(0, () => {
				x.current = !1;
			});
		}
		function d() {
			y.current = !1, b.current = !1;
		}
		function f() {
			let e = A.current, t = e === "pen" || !e ? "mouse" : e, n = v(), r = typeof n == "function" ? n() : n;
			return typeof r == "string" ? r : r[t];
		}
		function p(e) {
			let t = f();
			return t === "intentional" && e.type !== "click" || t === "sloppy" && e.type === "click";
		}
		function h(e) {
			let t = a.current.floatingContext?.nodeId, r = m && yn(m.nodesRef.current, t).some((t) => Kt(e, t.context?.elements.floating));
			return Kt(e, n.select("floatingElement")) || Kt(e, n.select("domReferenceElement")) || r;
		}
		function S(e) {
			if (p(e)) {
				O();
				return;
			}
			if (a.current.insideReactTree) {
				O();
				return;
			}
			let r = Gt(e), i = `[${Dn("inert")}]`, o = Array.from(ht(n.select("floatingElement")).querySelectorAll(i)), s = Fe(r) ? r.getRootNode() : null;
			Le(s) && (o = o.concat(Array.from(s.querySelectorAll(i))));
			let c = n.context.triggerElements;
			if (r && (c.hasElement(r) || c.hasMatchingElement((e) => G(e, r)))) return;
			let l = Fe(r) ? r : null;
			for (; l && !Je(l);) {
				let e = Ze(l);
				if (Je(e) || !Fe(e)) break;
				l = e;
			}
			if (o.length && Fe(r) && !qt(r) && !G(r, n.select("floatingElement")) && o.every((e) => !G(l, e))) return;
			if (Ie(r) && !("touches" in e)) {
				let t = Je(r), n = Ye(r), i = /auto|scroll/, a = t || i.test(n.overflowX), o = t || i.test(n.overflowY), s = a && r.clientWidth > 0 && r.scrollWidth > r.clientWidth, c = o && r.clientHeight > 0 && r.scrollHeight > r.clientHeight, l = n.direction === "rtl", u = c && (l ? e.offsetX <= r.offsetWidth - r.clientWidth : e.offsetX > r.clientWidth), d = s && e.offsetY > r.clientHeight;
				if (u || d) return;
			}
			if (h(e)) return;
			if (f() === "intentional" && x.current) {
				t.clear(), x.current = !1;
				return;
			}
			if (typeof g == "function" && !g(e)) return;
			let u = a.current.floatingContext?.nodeId, d = m ? yn(m.nodesRef.current, u) : [];
			if (d.length > 0) {
				let e = !0;
				if (d.forEach((t) => {
					t.context?.open && !t.context.dataRef.current.__outsidePressBubbles && (e = !1);
				}), !e) return;
			}
			n.setOpen(!1, K(nn, e)), O();
		}
		function D(e) {
			f() !== "sloppy" || e.pointerType === "touch" || !n.select("open") || !o || Kt(e, n.select("floatingElement")) || Kt(e, n.select("domReferenceElement")) || S(e);
		}
		function j(e) {
			if (f() !== "sloppy" || !n.select("open") || !o || Kt(e, n.select("floatingElement")) || Kt(e, n.select("domReferenceElement"))) return;
			let t = e.touches[0];
			t && (T.current = {
				startTime: Date.now(),
				startX: t.clientX,
				startY: t.clientY,
				dismissOnTouchEnd: !1,
				dismissOnMouseDown: !0
			}, E.start(1e3, () => {
				T.current && (T.current.dismissOnTouchEnd = !1, T.current.dismissOnMouseDown = !1);
			}));
		}
		function N(e) {
			A.current = "touch";
			let t = Gt(e);
			function n() {
				j(e), t?.removeEventListener(e.type, n);
			}
			t?.addEventListener(e.type, n);
		}
		function P(e) {
			if (E.clear(), e.type === "pointerdown" && (A.current = e.pointerType), e.type === "mousedown" && T.current && !T.current.dismissOnMouseDown) return;
			let t = Gt(e);
			function n() {
				e.type === "pointerdown" ? D(e) : S(e), t?.removeEventListener(e.type, n);
			}
			t?.addEventListener(e.type, n);
		}
		function F(e) {
			if (!y.current) return;
			let n = b.current;
			if (d(), f() === "intentional") {
				if (e.type === "pointercancel") {
					n && u();
					return;
				}
				if (!h(e)) {
					if (n) {
						u();
						return;
					}
					typeof g == "function" && !g(e) || (t.clear(), x.current = !0, O());
				}
			}
		}
		function I(e) {
			if (f() !== "sloppy" || !T.current || Kt(e, n.select("floatingElement")) || Kt(e, n.select("domReferenceElement"))) return;
			let t = e.touches[0];
			if (!t) return;
			let r = Math.abs(t.clientX - T.current.startX), i = Math.abs(t.clientY - T.current.startY), a = Math.sqrt(r * r + i * i);
			a > 5 && (T.current.dismissOnTouchEnd = !0), a > 10 && (S(e), E.clear(), T.current = null);
		}
		function L(e) {
			let t = Gt(e);
			function n() {
				I(e), t?.removeEventListener(e.type, n);
			}
			t?.addEventListener(e.type, n);
		}
		function ee(e) {
			f() !== "sloppy" || !T.current || Kt(e, n.select("floatingElement")) || Kt(e, n.select("domReferenceElement")) || (T.current.dismissOnTouchEnd && S(e), E.clear(), T.current = null);
		}
		function R(e) {
			let t = Gt(e);
			function n() {
				ee(e), t?.removeEventListener(e.type, n);
			}
			t?.addEventListener(e.type, n);
		}
		let z = ht(i);
		return s && (z.addEventListener("keydown", M), z.addEventListener("compositionstart", c), z.addEventListener("compositionend", l)), _ && (z.addEventListener("click", P, !0), z.addEventListener("pointerdown", P, !0), z.addEventListener("pointerup", F, !0), z.addEventListener("pointercancel", F, !0), z.addEventListener("mousedown", P, !0), z.addEventListener("mouseup", F, !0), z.addEventListener("touchstart", N, !0), z.addEventListener("touchmove", L, !0), z.addEventListener("touchend", R, !0)), () => {
			s && (z.removeEventListener("keydown", M), z.removeEventListener("compositionstart", c), z.removeEventListener("compositionend", l)), _ && (z.removeEventListener("click", P, !0), z.removeEventListener("pointerdown", P, !0), z.removeEventListener("pointerup", F, !0), z.removeEventListener("pointercancel", F, !0), z.removeEventListener("mousedown", P, !0), z.removeEventListener("mouseup", F, !0), z.removeEventListener("touchstart", N, !0), z.removeEventListener("touchmove", L, !0), z.removeEventListener("touchend", R, !0)), e.clear(), t.clear(), d(), x.current = !1;
		};
	}, [
		a,
		i,
		s,
		_,
		g,
		r,
		o,
		C,
		w,
		M,
		O,
		v,
		m,
		n,
		E
	]), S.useEffect(O, [g, O]);
	let P = S.useMemo(() => ({
		onKeyDown: M,
		[Hn[d]]: (e) => {
			j() && n.setOpen(!1, K("trigger-press", e.nativeEvent));
		},
		...d !== "intentional" && { onClick(e) {
			j() && n.setOpen(!1, K("trigger-press", e.nativeEvent));
		} }
	}), [
		M,
		n,
		d,
		j
	]), F = U((e) => {
		if (!r || !o || e.button !== 0) return;
		let t = Gt(e.nativeEvent);
		G(n.select("floatingElement"), t) && (y.current || (y.current = !0, b.current = !1));
	}), I = U((e) => {
		!r || !o || (e.defaultPrevented || e.nativeEvent.defaultPrevented) && y.current && (b.current = !0);
	}), L = S.useMemo(() => ({
		onKeyDown: M,
		onPointerDown: I,
		onMouseDown: I,
		onClickCapture: N,
		onMouseDownCapture(e) {
			N(), F(e);
		},
		onPointerDownCapture(e) {
			N(), F(e);
		},
		onMouseUpCapture: N,
		onTouchEndCapture: N,
		onTouchMoveCapture: N
	}), [
		M,
		N,
		F,
		I
	]);
	return S.useMemo(() => o ? {
		reference: P,
		floating: L,
		trigger: P
	} : {}, [
		o,
		P,
		L
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/useTransitionStatus.js
function Kn(e, t = !1, n = !1) {
	let [r, i] = S.useState(e && t ? "idle" : void 0), [a, o] = S.useState(e);
	return e && !a && (o(!0), i("starting")), !e && a && r !== "ending" && !n && i("ending"), !e && !a && r === "ending" && i(void 0), W(() => {
		if (!e && a && r !== "ending" && n) {
			let e = wt.request(() => {
				i("ending");
			});
			return () => {
				wt.cancel(e);
			};
		}
	}, [
		e,
		a,
		r,
		n
	]), W(() => {
		if (!e || t) return;
		let n = wt.request(() => {
			i(void 0);
		});
		return () => {
			wt.cancel(n);
		};
	}, [t, e]), W(() => {
		if (!e || !t) return;
		e && a && r !== "idle" && i("starting");
		let n = wt.request(() => {
			i("idle");
		});
		return () => {
			wt.cancel(n);
		};
	}, [
		t,
		e,
		a,
		i,
		r
	]), S.useMemo(() => ({
		mounted: a,
		setMounted: o,
		transitionStatus: r
	}), [a, r]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/resolveRef.js
function qn(e) {
	return e == null ? e : "current" in e ? e.current : e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/stateAttributesMapping.js
var Jn = /* @__PURE__ */ function(e) {
	return e.startingStyle = "data-starting-style", e.endingStyle = "data-ending-style", e;
}({}), Yn = { [Jn.startingStyle]: "" }, Xn = { [Jn.endingStyle]: "" }, Zn = { transitionStatus(e) {
	return e === "starting" ? Yn : e === "ending" ? Xn : null;
} }, Qn = /* @__PURE__ */ o(((e) => {
	var t = m();
	function n(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function r() {}
	var i = {
		d: {
			f: r,
			r: function() {
				throw Error(n(522));
			},
			D: r,
			C: r,
			L: r,
			m: r,
			X: r,
			S: r,
			M: r
		},
		p: 0,
		findDOMNode: null
	}, a = Symbol.for("react.portal");
	function o(e, t, n) {
		var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
		return {
			$$typeof: a,
			key: r == null ? null : "" + r,
			children: e,
			containerInfo: t,
			implementation: n
		};
	}
	var s = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
	function c(e, t) {
		if (e === "font") return "";
		if (typeof t == "string") return t === "use-credentials" ? t : "";
	}
	e.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i, e.createPortal = function(e, t) {
		var r = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
		if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) throw Error(n(299));
		return o(e, t, null, r);
	}, e.flushSync = function(e) {
		var t = s.T, n = i.p;
		try {
			if (s.T = null, i.p = 2, e) return e();
		} finally {
			s.T = t, i.p = n, i.d.f();
		}
	}, e.preconnect = function(e, t) {
		typeof e == "string" && (t ? (t = t.crossOrigin, t = typeof t == "string" ? t === "use-credentials" ? t : "" : void 0) : t = null, i.d.C(e, t));
	}, e.prefetchDNS = function(e) {
		typeof e == "string" && i.d.D(e);
	}, e.preinit = function(e, t) {
		if (typeof e == "string" && t && typeof t.as == "string") {
			var n = t.as, r = c(n, t.crossOrigin), a = typeof t.integrity == "string" ? t.integrity : void 0, o = typeof t.fetchPriority == "string" ? t.fetchPriority : void 0;
			n === "style" ? i.d.S(e, typeof t.precedence == "string" ? t.precedence : void 0, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o
			}) : n === "script" && i.d.X(e, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0
			});
		}
	}, e.preinitModule = function(e, t) {
		if (typeof e == "string") if (typeof t == "object" && t) {
			if (t.as == null || t.as === "script") {
				var n = c(t.as, t.crossOrigin);
				i.d.M(e, {
					crossOrigin: n,
					integrity: typeof t.integrity == "string" ? t.integrity : void 0,
					nonce: typeof t.nonce == "string" ? t.nonce : void 0
				});
			}
		} else t ?? i.d.M(e);
	}, e.preload = function(e, t) {
		if (typeof e == "string" && typeof t == "object" && t && typeof t.as == "string") {
			var n = t.as, r = c(n, t.crossOrigin);
			i.d.L(e, n, {
				crossOrigin: r,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0,
				type: typeof t.type == "string" ? t.type : void 0,
				fetchPriority: typeof t.fetchPriority == "string" ? t.fetchPriority : void 0,
				referrerPolicy: typeof t.referrerPolicy == "string" ? t.referrerPolicy : void 0,
				imageSrcSet: typeof t.imageSrcSet == "string" ? t.imageSrcSet : void 0,
				imageSizes: typeof t.imageSizes == "string" ? t.imageSizes : void 0,
				media: typeof t.media == "string" ? t.media : void 0
			});
		}
	}, e.preloadModule = function(e, t) {
		if (typeof e == "string") if (t) {
			var n = c(t.as, t.crossOrigin);
			i.d.m(e, {
				as: typeof t.as == "string" && t.as !== "script" ? t.as : void 0,
				crossOrigin: n,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0
			});
		} else i.d.m(e);
	}, e.requestFormReset = function(e) {
		i.d.r(e);
	}, e.unstable_batchedUpdates = function(e, t) {
		return e(t);
	}, e.useFormState = function(e, t, n) {
		return s.H.useFormState(e, t, n);
	}, e.useFormStatus = function() {
		return s.H.useHostTransitionStatus();
	}, e.version = "19.2.4";
})), $n = /* @__PURE__ */ o(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t() {}
		function n(e) {
			return "" + e;
		}
		function r(e, t, r) {
			var i = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
			try {
				n(i);
				var a = !1;
			} catch {
				a = !0;
			}
			return a && (console.error("The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", typeof Symbol == "function" && Symbol.toStringTag && i[Symbol.toStringTag] || i.constructor.name || "Object"), n(i)), {
				$$typeof: u,
				key: i == null ? null : "" + i,
				children: e,
				containerInfo: t,
				implementation: r
			};
		}
		function i(e, t) {
			if (e === "font") return "";
			if (typeof t == "string") return t === "use-credentials" ? t : "";
		}
		function a(e) {
			return e === null ? "`null`" : e === void 0 ? "`undefined`" : e === "" ? "an empty string" : "something with type \"" + typeof e + "\"";
		}
		function o(e) {
			return e === null ? "`null`" : e === void 0 ? "`undefined`" : e === "" ? "an empty string" : typeof e == "string" ? JSON.stringify(e) : typeof e == "number" ? "`" + e + "`" : "something with type \"" + typeof e + "\"";
		}
		function s() {
			var e = d.H;
			return e === null && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem."), e;
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var c = m(), l = {
			d: {
				f: t,
				r: function() {
					throw Error("Invalid form element. requestFormReset must be passed a form that was rendered by React.");
				},
				D: t,
				C: t,
				L: t,
				m: t,
				X: t,
				S: t,
				M: t
			},
			p: 0,
			findDOMNode: null
		}, u = Symbol.for("react.portal"), d = c.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
		typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), e.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = l, e.createPortal = function(e, t) {
			var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
			if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) throw Error("Target container is not a DOM element.");
			return r(e, t, null, n);
		}, e.flushSync = function(e) {
			var t = d.T, n = l.p;
			try {
				if (d.T = null, l.p = 2, e) return e();
			} finally {
				d.T = t, l.p = n, l.d.f() && console.error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
			}
		}, e.preconnect = function(e, t) {
			typeof e == "string" && e ? t != null && typeof t != "object" ? console.error("ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.", o(t)) : t != null && typeof t.crossOrigin != "string" && console.error("ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.", a(t.crossOrigin)) : console.error("ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", a(e)), typeof e == "string" && (t ? (t = t.crossOrigin, t = typeof t == "string" ? t === "use-credentials" ? t : "" : void 0) : t = null, l.d.C(e, t));
		}, e.prefetchDNS = function(e) {
			if (typeof e != "string" || !e) console.error("ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", a(e));
			else if (1 < arguments.length) {
				var t = arguments[1];
				typeof t == "object" && t.hasOwnProperty("crossOrigin") ? console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", o(t)) : console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", o(t));
			}
			typeof e == "string" && l.d.D(e);
		}, e.preinit = function(e, t) {
			if (typeof e == "string" && e ? typeof t != "object" || !t ? console.error("ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.", o(t)) : t.as !== "style" && t.as !== "script" && console.error("ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are \"style\" and \"script\".", o(t.as)) : console.error("ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", a(e)), typeof e == "string" && t && typeof t.as == "string") {
				var n = t.as, r = i(n, t.crossOrigin), s = typeof t.integrity == "string" ? t.integrity : void 0, c = typeof t.fetchPriority == "string" ? t.fetchPriority : void 0;
				n === "style" ? l.d.S(e, typeof t.precedence == "string" ? t.precedence : void 0, {
					crossOrigin: r,
					integrity: s,
					fetchPriority: c
				}) : n === "script" && l.d.X(e, {
					crossOrigin: r,
					integrity: s,
					fetchPriority: c,
					nonce: typeof t.nonce == "string" ? t.nonce : void 0
				});
			}
		}, e.preinitModule = function(e, t) {
			var n = "";
			if (typeof e == "string" && e || (n += " The `href` argument encountered was " + a(e) + "."), t !== void 0 && typeof t != "object" ? n += " The `options` argument encountered was " + a(t) + "." : t && "as" in t && t.as !== "script" && (n += " The `as` option encountered was " + o(t.as) + "."), n) console.error("ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s", n);
			else switch (n = t && typeof t.as == "string" ? t.as : "script", n) {
				case "script": break;
				default: n = o(n), console.error("ReactDOM.preinitModule(): Currently the only supported \"as\" type for this function is \"script\" but received \"%s\" instead. This warning was generated for `href` \"%s\". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)", n, e);
			}
			typeof e == "string" && (typeof t == "object" && t ? (t.as == null || t.as === "script") && (n = i(t.as, t.crossOrigin), l.d.M(e, {
				crossOrigin: n,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0
			})) : t ?? l.d.M(e));
		}, e.preload = function(e, t) {
			var n = "";
			if (typeof e == "string" && e || (n += " The `href` argument encountered was " + a(e) + "."), typeof t != "object" || !t ? n += " The `options` argument encountered was " + a(t) + "." : typeof t.as == "string" && t.as || (n += " The `as` option encountered was " + a(t.as) + "."), n && console.error("ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel=\"preload\" as=\"...\" />` tag.%s", n), typeof e == "string" && typeof t == "object" && t && typeof t.as == "string") {
				n = t.as;
				var r = i(n, t.crossOrigin);
				l.d.L(e, n, {
					crossOrigin: r,
					integrity: typeof t.integrity == "string" ? t.integrity : void 0,
					nonce: typeof t.nonce == "string" ? t.nonce : void 0,
					type: typeof t.type == "string" ? t.type : void 0,
					fetchPriority: typeof t.fetchPriority == "string" ? t.fetchPriority : void 0,
					referrerPolicy: typeof t.referrerPolicy == "string" ? t.referrerPolicy : void 0,
					imageSrcSet: typeof t.imageSrcSet == "string" ? t.imageSrcSet : void 0,
					imageSizes: typeof t.imageSizes == "string" ? t.imageSizes : void 0,
					media: typeof t.media == "string" ? t.media : void 0
				});
			}
		}, e.preloadModule = function(e, t) {
			var n = "";
			typeof e == "string" && e || (n += " The `href` argument encountered was " + a(e) + "."), t !== void 0 && typeof t != "object" ? n += " The `options` argument encountered was " + a(t) + "." : t && "as" in t && typeof t.as != "string" && (n += " The `as` option encountered was " + a(t.as) + "."), n && console.error("ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel=\"modulepreload\" as=\"...\" />` tag.%s", n), typeof e == "string" && (t ? (n = i(t.as, t.crossOrigin), l.d.m(e, {
				as: typeof t.as == "string" && t.as !== "script" ? t.as : void 0,
				crossOrigin: n,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0
			})) : l.d.m(e));
		}, e.requestFormReset = function(e) {
			l.d.r(e);
		}, e.unstable_batchedUpdates = function(e, t) {
			return e(t);
		}, e.useFormState = function(e, t, n) {
			return s().useFormState(e, t, n);
		}, e.useFormStatus = function() {
			return s().useHostTransitionStatus();
		}, e.version = "19.2.4", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
})), er = /* @__PURE__ */ o(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
			if (process.env.NODE_ENV !== "production") throw Error("^_^");
			try {
				__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
			} catch (e) {
				console.error(e);
			}
		}
	}
	process.env.NODE_ENV === "production" ? (n(), t.exports = Qn()) : t.exports = $n();
})), tr = /* @__PURE__ */ c(er());
function nr(e, t = !1, n = !0) {
	let r = Tt();
	return U((i, a = null) => {
		r.cancel();
		function o() {
			tr.flushSync(i);
		}
		let s = qn(e);
		if (s == null) return;
		let c = s;
		if (typeof c.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) i();
		else {
			function e() {
				let e = Jn.startingStyle;
				if (!c.hasAttribute(e)) {
					r.request(i);
					return;
				}
				let t = new MutationObserver(() => {
					c.hasAttribute(e) || (t.disconnect(), i());
				});
				t.observe(c, {
					attributes: !0,
					attributeFilter: [e]
				}), a?.addEventListener("abort", () => t.disconnect(), { once: !0 });
			}
			function i() {
				Promise.all(c.getAnimations().map((e) => e.finished)).then(() => {
					a?.aborted || o();
				}).catch(() => {
					let e = c.getAnimations();
					if (n) {
						if (a?.aborted) return;
						o();
					} else e.length > 0 && e.some((e) => e.pending || e.playState !== "finished") && i();
				});
			}
			if (t) {
				e();
				return;
			}
			r.request(i);
		}
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/useOpenChangeComplete.js
function rr(e) {
	let { enabled: t = !0, open: n, ref: r, onComplete: i } = e, a = U(i), o = nr(r, n, !1);
	S.useEffect(() => {
		if (!t) return;
		let e = new AbortController();
		return o(a, e.signal), () => {
			e.abort();
		};
	}, [
		t,
		n,
		a,
		o
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/popups/popupStoreUtils.js
function ir(e, t) {
	let n = S.useRef(null), r = S.useRef(null);
	return S.useCallback((i) => {
		if (e !== void 0) {
			if (n.current !== null) {
				let e = n.current, i = r.current, a = t.context.triggerElements.getById(e);
				i && a === i && t.context.triggerElements.delete(e), n.current = null, r.current = null;
			}
			i !== null && (n.current = e, r.current = i, t.context.triggerElements.add(e, i));
		}
	}, [t, e]);
}
function ar(e, t, n, r) {
	let i = n.useState("isMountedByTrigger", e), a = ir(e, n), o = U((t) => {
		if (a(t), !t || !n.select("open")) return;
		let i = n.select("activeTriggerId");
		if (i === e) {
			n.update({
				activeTriggerElement: t,
				...r
			});
			return;
		}
		i ?? n.update({
			activeTriggerId: e,
			activeTriggerElement: t,
			...r
		});
	});
	return W(() => {
		i && n.update({
			activeTriggerElement: t.current,
			...r
		});
	}, [
		i,
		n,
		t,
		...Object.values(r)
	]), {
		registerTrigger: o,
		isMountedByThisTrigger: i
	};
}
function or(e) {
	let t = e.useState("open");
	W(() => {
		if (t && !e.select("activeTriggerId") && e.context.triggerElements.size === 1) {
			let t = e.context.triggerElements.entries().next();
			if (!t.done) {
				let [n, r] = t.value;
				e.update({
					activeTriggerId: n,
					activeTriggerElement: r
				});
			}
		}
	}, [t, e]);
}
function sr(e, t, n) {
	let { mounted: r, setMounted: i, transitionStatus: a } = Kn(e);
	t.useSyncedValues({
		mounted: r,
		transitionStatus: a
	});
	let o = U(() => {
		i(!1), t.update({
			activeTriggerId: null,
			activeTriggerElement: null,
			mounted: !1
		}), n?.(), t.context.onOpenChangeComplete?.(!1);
	});
	return rr({
		enabled: !t.useState("preventUnmountingOnClose"),
		open: e,
		ref: t.context.popupRef,
		onComplete() {
			e || o();
		}
	}), {
		forceUnmount: o,
		transitionStatus: a
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/formatErrorMessage.js
function cr(e, t) {
	return function(n, ...r) {
		let i = new URL(e);
		return i.searchParams.set("code", n.toString()), r.forEach((e) => i.searchParams.append("args[]", e)), `${t} error #${n}; visit ${i} for the full message.`;
	};
}
var lr = cr("https://base-ui.com/production-error", "Base UI"), ur = (e, t, n) => {
	if (t.length === 1 && t[0] === n) {
		let t = !1;
		try {
			let n = {};
			e(n) === n && (t = !0);
		} catch {}
		if (t) {
			let e;
			try {
				throw Error();
			} catch (t) {
				({stack: e} = t);
			}
			console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", { stack: e });
		}
	}
}, dr = (e, t, n) => {
	let { memoize: r, memoizeOptions: i } = t, { inputSelectorResults: a, inputSelectorResultsCopy: o } = e, s = r(() => ({}), ...i);
	if (s.apply(null, a) !== s.apply(null, o)) {
		let e;
		try {
			throw Error();
		} catch (t) {
			({stack: e} = t);
		}
		console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
			arguments: n,
			firstInputs: a,
			secondInputs: o,
			stack: e
		});
	}
}, fr = {
	inputStabilityCheck: "once",
	identityFunctionCheck: "once"
}, pr = /* @__PURE__ */ Symbol("NOT_FOUND");
function mr(e, t = `expected a function, instead received ${typeof e}`) {
	if (typeof e != "function") throw TypeError(t);
}
function hr(e, t = `expected an object, instead received ${typeof e}`) {
	if (typeof e != "object") throw TypeError(t);
}
function gr(e, t = "expected all items to be functions, instead received the following types: ") {
	if (!e.every((e) => typeof e == "function")) {
		let n = e.map((e) => typeof e == "function" ? `function ${e.name || "unnamed"}()` : typeof e).join(", ");
		throw TypeError(`${t}[${n}]`);
	}
}
var _r = (e) => Array.isArray(e) ? e : [e];
function vr(e) {
	let t = Array.isArray(e[0]) ? e[0] : e;
	return gr(t, "createSelector expects all input-selectors to be functions, but received the following types: "), t;
}
function yr(e, t) {
	let n = [], { length: r } = e;
	for (let i = 0; i < r; i++) n.push(e[i].apply(null, t));
	return n;
}
var br = (e, t) => {
	let { identityFunctionCheck: n, inputStabilityCheck: r } = {
		...fr,
		...t
	};
	return {
		identityFunctionCheck: {
			shouldRun: n === "always" || n === "once" && e,
			run: ur
		},
		inputStabilityCheck: {
			shouldRun: r === "always" || r === "once" && e,
			run: dr
		}
	};
};
function xr(e) {
	let t;
	return {
		get(n) {
			return t && e(t.key, n) ? t.value : pr;
		},
		put(e, n) {
			t = {
				key: e,
				value: n
			};
		},
		getEntries() {
			return t ? [t] : [];
		},
		clear() {
			t = void 0;
		}
	};
}
function Sr(e, t) {
	let n = [];
	function r(e) {
		let r = n.findIndex((n) => t(e, n.key));
		if (r > -1) {
			let e = n[r];
			return r > 0 && (n.splice(r, 1), n.unshift(e)), e.value;
		}
		return pr;
	}
	function i(t, i) {
		r(t) === pr && (n.unshift({
			key: t,
			value: i
		}), n.length > e && n.pop());
	}
	function a() {
		return n;
	}
	function o() {
		n = [];
	}
	return {
		get: r,
		put: i,
		getEntries: a,
		clear: o
	};
}
var Cr = (e, t) => e === t;
function wr(e) {
	return function(t, n) {
		if (t === null || n === null || t.length !== n.length) return !1;
		let { length: r } = t;
		for (let i = 0; i < r; i++) if (!e(t[i], n[i])) return !1;
		return !0;
	};
}
function Tr(e, t) {
	let { equalityCheck: n = Cr, maxSize: r = 1, resultEqualityCheck: i } = typeof t == "object" ? t : { equalityCheck: t }, a = wr(n), o = 0, s = r <= 1 ? xr(a) : Sr(r, a);
	function c() {
		let t = s.get(arguments);
		if (t === pr) {
			if (t = e.apply(null, arguments), o++, i) {
				let e = s.getEntries().find((e) => i(e.value, t));
				e && (t = e.value, o !== 0 && o--);
			}
			s.put(arguments, t);
		}
		return t;
	}
	return c.clearCache = () => {
		s.clear(), c.resetResultsCount();
	}, c.resultsCount = () => o, c.resetResultsCount = () => {
		o = 0;
	}, c;
}
var Er = class {
	constructor(e) {
		this.value = e;
	}
	deref() {
		return this.value;
	}
}, Dr = typeof WeakRef < "u" ? WeakRef : Er, Or = 0, kr = 1;
function Ar() {
	return {
		s: Or,
		v: void 0,
		o: null,
		p: null
	};
}
function jr(e, t = {}) {
	let n = Ar(), { resultEqualityCheck: r } = t, i, a = 0;
	function o() {
		let t = n, { length: o } = arguments;
		for (let e = 0, n = o; e < n; e++) {
			let n = arguments[e];
			if (typeof n == "function" || typeof n == "object" && n) {
				let e = t.o;
				e === null && (t.o = e = /* @__PURE__ */ new WeakMap());
				let r = e.get(n);
				r === void 0 ? (t = Ar(), e.set(n, t)) : t = r;
			} else {
				let e = t.p;
				e === null && (t.p = e = /* @__PURE__ */ new Map());
				let r = e.get(n);
				r === void 0 ? (t = Ar(), e.set(n, t)) : t = r;
			}
		}
		let s = t, c;
		if (t.s === kr) c = t.v;
		else if (c = e.apply(null, arguments), a++, r) {
			let e = i?.deref?.() ?? i;
			e != null && r(e, c) && (c = e, a !== 0 && a--), i = typeof c == "object" && c || typeof c == "function" ? new Dr(c) : c;
		}
		return s.s = kr, s.v = c, c;
	}
	return o.clearCache = () => {
		n = Ar(), o.resetResultsCount();
	}, o.resultsCount = () => a, o.resetResultsCount = () => {
		a = 0;
	}, o;
}
function Mr(e, ...t) {
	let n = typeof e == "function" ? {
		memoize: e,
		memoizeOptions: t
	} : e, r = (...e) => {
		let t = 0, r = 0, i, a = {}, o = e.pop();
		typeof o == "object" && (a = o, o = e.pop()), mr(o, `createSelector expects an output function after the inputs, but received: [${typeof o}]`);
		let { memoize: s, memoizeOptions: c = [], argsMemoize: l = jr, argsMemoizeOptions: u = [], devModeChecks: d = {} } = {
			...n,
			...a
		}, f = _r(c), p = _r(u), m = vr(e), h = s(function() {
			return t++, o.apply(null, arguments);
		}, ...f), g = !0, _ = l(function() {
			r++;
			let e = yr(m, arguments);
			if (i = h.apply(null, e), process.env.NODE_ENV !== "production") {
				let { identityFunctionCheck: t, inputStabilityCheck: n } = br(g, d);
				if (t.shouldRun && t.run(o, e, i), n.shouldRun) {
					let t = yr(m, arguments);
					n.run({
						inputSelectorResults: e,
						inputSelectorResultsCopy: t
					}, {
						memoize: s,
						memoizeOptions: f
					}, arguments);
				}
				g &&= !1;
			}
			return i;
		}, ...p);
		return Object.assign(_, {
			resultFunc: o,
			memoizedResultFunc: h,
			dependencies: m,
			dependencyRecomputations: () => r,
			resetDependencyRecomputations: () => {
				r = 0;
			},
			lastResult: () => i,
			recomputations: () => t,
			resetRecomputations: () => {
				t = 0;
			},
			memoize: s,
			argsMemoize: l
		});
	};
	return Object.assign(r, { withTypes: () => r }), r;
}
var Nr = /* @__PURE__ */ Mr(jr), Pr = Object.assign((e, t = Nr) => {
	hr(e, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`);
	let n = Object.keys(e);
	return t(n.map((t) => e[t]), (...e) => e.reduce((e, t, r) => (e[n[r]] = t, e), {}));
}, { withTypes: () => Pr }), Fr = Mr({
	memoize: Tr,
	memoizeOptions: {
		maxSize: 1,
		equalityCheck: Object.is
	}
}), q = (e, t, n, r, i, a, ...o) => {
	if (o.length > 0) throw Error(process.env.NODE_ENV === "production" ? lr(1) : "Unsupported number of selectors");
	let s;
	if (e && t && n && r && i && a) s = (o, s, c, l) => a(e(o, s, c, l), t(o, s, c, l), n(o, s, c, l), r(o, s, c, l), i(o, s, c, l), s, c, l);
	else if (e && t && n && r && i) s = (a, o, s, c) => i(e(a, o, s, c), t(a, o, s, c), n(a, o, s, c), r(a, o, s, c), o, s, c);
	else if (e && t && n && r) s = (i, a, o, s) => r(e(i, a, o, s), t(i, a, o, s), n(i, a, o, s), a, o, s);
	else if (e && t && n) s = (r, i, a, o) => n(e(r, i, a, o), t(r, i, a, o), i, a, o);
	else if (e && t) s = (n, r, i, a) => t(e(n, r, i, a), r, i, a);
	else if (e) s = e;
	else throw Error("Missing arguments");
	return s;
}, Ir = (...e) => {
	let t = /* @__PURE__ */ new WeakMap(), n = 1, r = e[e.length - 1], i = e.length - 1 || 1, a = r.length - i;
	if (a > 3) throw Error(process.env.NODE_ENV === "production" ? lr(2) : "Unsupported number of arguments");
	return (i, o, s, c) => {
		let l = i.__cacheKey__;
		l || (l = { id: n }, i.__cacheKey__ = l, n += 1);
		let u = t.get(l);
		if (!u) {
			let n = e, i = [
				void 0,
				void 0,
				void 0
			];
			switch (a) {
				case 0: break;
				case 1:
					n = [
						...e.slice(0, -1),
						() => i[0],
						r
					];
					break;
				case 2:
					n = [
						...e.slice(0, -1),
						() => i[0],
						() => i[1],
						r
					];
					break;
				case 3:
					n = [
						...e.slice(0, -1),
						() => i[0],
						() => i[1],
						() => i[2],
						r
					];
					break;
				default: throw Error(process.env.NODE_ENV === "production" ? lr(2) : "Unsupported number of arguments");
			}
			u = Fr(...n), u.selectorArgs = i, t.set(l, u);
		}
		switch (u.selectorArgs[0] = o, u.selectorArgs[1] = s, u.selectorArgs[2] = c, a) {
			case 0: return u(i);
			case 1: return u(i, o);
			case 2: return u(i, o, s);
			case 3: return u(i, o, s, c);
			default: throw Error("unreachable");
		}
	};
}, Lr = 19;
function Rr(e) {
	return Lr >= e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/_virtual/builtin_esm-external-require-react.js
var zr = /* @__PURE__ */ z(((e, t) => {
	t.exports = { ...S };
}));
zr();
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/use-sync-external-store@1.6.0_react@19.2.4/node_modules/use-sync-external-store/cjs/use-sync-external-store-shim.production.js
var Br = /* @__PURE__ */ z(((e) => {
	var t = zr();
	function n(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var r = typeof Object.is == "function" ? Object.is : n, i = t.useState, a = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
	function c(e, t) {
		var n = t(), r = i({ inst: {
			value: n,
			getSnapshot: t
		} }), c = r[0].inst, u = r[1];
		return o(function() {
			c.value = n, c.getSnapshot = t, l(c) && u({ inst: c });
		}, [
			e,
			n,
			t
		]), a(function() {
			return l(c) && u({ inst: c }), e(function() {
				l(c) && u({ inst: c });
			});
		}, [e]), s(n), n;
	}
	function l(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !r(e, n);
		} catch {
			return !0;
		}
	}
	function u(e, t) {
		return t();
	}
	var d = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? u : c;
	e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? d : t.useSyncExternalStore;
}));
Br();
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/use-sync-external-store@1.6.0_react@19.2.4/node_modules/use-sync-external-store/cjs/use-sync-external-store-shim.development.js
var Vr = /* @__PURE__ */ z(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e, t) {
			return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
		}
		function n(e, t) {
			d || a.startTransition === void 0 || (d = !0, console.error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
			var n = t();
			if (!f) {
				var i = t();
				o(n, i) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
			}
			i = s({ inst: {
				value: n,
				getSnapshot: t
			} });
			var p = i[0].inst, m = i[1];
			return l(function() {
				p.value = n, p.getSnapshot = t, r(p) && m({ inst: p });
			}, [
				e,
				n,
				t
			]), c(function() {
				return r(p) && m({ inst: p }), e(function() {
					r(p) && m({ inst: p });
				});
			}, [e]), u(n), n;
		}
		function r(e) {
			var t = e.getSnapshot;
			e = e.value;
			try {
				var n = t();
				return !o(e, n);
			} catch {
				return !0;
			}
		}
		function i(e, t) {
			return t();
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var a = zr(), o = typeof Object.is == "function" ? Object.is : t, s = a.useState, c = a.useEffect, l = a.useLayoutEffect, u = a.useDebugValue, d = !1, f = !1, p = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? i : n;
		e.useSyncExternalStore = a.useSyncExternalStore === void 0 ? p : a.useSyncExternalStore, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
}));
Vr();
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/use-sync-external-store@1.6.0_react@19.2.4/node_modules/use-sync-external-store/shim/index.js
var Hr = /* @__PURE__ */ z(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = Br() : t.exports = Vr();
}));
Hr();
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/use-sync-external-store@1.6.0_react@19.2.4/node_modules/use-sync-external-store/cjs/use-sync-external-store-shim/with-selector.production.js
var Ur = /* @__PURE__ */ z(((e) => {
	var t = zr(), n = Hr();
	function r(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var i = typeof Object.is == "function" ? Object.is : r, a = n.useSyncExternalStore, o = t.useRef, s = t.useEffect, c = t.useMemo, l = t.useDebugValue;
	e.useSyncExternalStoreWithSelector = function(e, t, n, r, u) {
		var d = o(null);
		if (d.current === null) {
			var f = {
				hasValue: !1,
				value: null
			};
			d.current = f;
		} else f = d.current;
		d = c(function() {
			function e(e) {
				if (!a) {
					if (a = !0, o = e, e = r(e), u !== void 0 && f.hasValue) {
						var t = f.value;
						if (u(t, e)) return s = t;
					}
					return s = e;
				}
				if (t = s, i(o, e)) return t;
				var n = r(e);
				return u !== void 0 && u(t, n) ? (o = e, t) : (o = e, s = n);
			}
			var a = !1, o, s, c = n === void 0 ? null : n;
			return [function() {
				return e(t());
			}, c === null ? void 0 : function() {
				return e(c());
			}];
		}, [
			t,
			n,
			r,
			u
		]);
		var p = a(e, d[0], d[1]);
		return s(function() {
			f.hasValue = !0, f.value = p;
		}, [p]), l(p), p;
	};
}));
Ur();
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/use-sync-external-store@1.6.0_react@19.2.4/node_modules/use-sync-external-store/cjs/use-sync-external-store-shim/with-selector.development.js
var Wr = /* @__PURE__ */ z(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e, t) {
			return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var n = zr(), r = Hr(), i = typeof Object.is == "function" ? Object.is : t, a = r.useSyncExternalStore, o = n.useRef, s = n.useEffect, c = n.useMemo, l = n.useDebugValue;
		e.useSyncExternalStoreWithSelector = function(e, t, n, r, u) {
			var d = o(null);
			if (d.current === null) {
				var f = {
					hasValue: !1,
					value: null
				};
				d.current = f;
			} else f = d.current;
			d = c(function() {
				function e(e) {
					if (!a) {
						if (a = !0, o = e, e = r(e), u !== void 0 && f.hasValue) {
							var t = f.value;
							if (u(t, e)) return s = t;
						}
						return s = e;
					}
					if (t = s, i(o, e)) return t;
					var n = r(e);
					return u !== void 0 && u(t, n) ? (o = e, t) : (o = e, s = n);
				}
				var a = !1, o, s, c = n === void 0 ? null : n;
				return [function() {
					return e(t());
				}, c === null ? void 0 : function() {
					return e(c());
				}];
			}, [
				t,
				n,
				r,
				u
			]);
			var p = a(e, d[0], d[1]);
			return s(function() {
				f.hasValue = !0, f.value = p;
			}, [p]), l(p), p;
		}, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
}));
Wr();
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/use-sync-external-store@1.6.0_react@19.2.4/node_modules/use-sync-external-store/shim/with-selector.js
var Gr = /* @__PURE__ */ z(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = Ur() : t.exports = Wr();
}));
Gr();
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/fastHooks.js
var Kr = [], qr = void 0;
function Jr() {
	return qr;
}
function Yr(e) {
	Kr.push(e);
}
function Xr(e) {
	let t = (t, n) => {
		let r = Te(Qr).current, i;
		try {
			qr = r;
			for (let e of Kr) e.before(r);
			i = e(t, n);
			for (let e of Kr) e.after(r);
			r.didInitialize = !0;
		} finally {
			qr = void 0;
		}
		return i;
	};
	return t.displayName = e.displayName || e.name, t;
}
function Zr(e) {
	return /* @__PURE__ */ S.forwardRef(Xr(e));
}
function Qr() {
	return { didInitialize: !1 };
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/store/useStore.js
var $r = Hr(), ei = Gr(), ti = Rr(19) ? ri : ii;
function J(e, t, n, r, i) {
	return ti(e, t, n, r, i);
}
function ni(e, t, n, r, i) {
	let a = S.useCallback(() => t(e.getSnapshot(), n, r, i), [
		e,
		t,
		n,
		r,
		i
	]);
	return (0, $r.useSyncExternalStore)(e.subscribe, a, a);
}
Yr({
	before(e) {
		e.syncIndex = 0, e.didInitialize || (e.syncTick = 1, e.syncHooks = [], e.didChangeStore = !0, e.getSnapshot = () => {
			let t = !1;
			for (let n = 0; n < e.syncHooks.length; n += 1) {
				let r = e.syncHooks[n], i = r.selector(r.store.state, r.a1, r.a2, r.a3);
				(r.didChange || !Object.is(r.value, i)) && (t = !0, r.value = i, r.didChange = !1);
			}
			return t && (e.syncTick += 1), e.syncTick;
		});
	},
	after(e) {
		e.syncHooks.length > 0 && (e.didChangeStore && (e.didChangeStore = !1, e.subscribe = (t) => {
			let n = /* @__PURE__ */ new Set();
			for (let t of e.syncHooks) n.add(t.store);
			let r = [];
			for (let e of n) r.push(e.subscribe(t));
			return () => {
				for (let e of r) e();
			};
		}), (0, $r.useSyncExternalStore)(e.subscribe, e.getSnapshot, e.getSnapshot));
	}
});
function ri(e, t, n, r, i) {
	let a = Jr();
	if (!a) return ni(e, t, n, r, i);
	let o = a.syncIndex;
	a.syncIndex += 1;
	let s;
	return a.didInitialize ? (s = a.syncHooks[o], (s.store !== e || s.selector !== t || !Object.is(s.a1, n) || !Object.is(s.a2, r) || !Object.is(s.a3, i)) && (s.store !== e && (a.didChangeStore = !0), s.store = e, s.selector = t, s.a1 = n, s.a2 = r, s.a3 = i, s.didChange = !0)) : (s = {
		store: e,
		selector: t,
		a1: n,
		a2: r,
		a3: i,
		value: t(e.getSnapshot(), n, r, i),
		didChange: !1
	}, a.syncHooks.push(s)), s.value;
}
function ii(e, t, n, r, i) {
	return (0, ei.useSyncExternalStoreWithSelector)(e.subscribe, e.getSnapshot, e.getSnapshot, (e) => t(e, n, r, i));
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/store/Store.js
var ai = class {
	constructor(e) {
		this.state = e, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
	}
	subscribe = (e) => (this.listeners.add(e), () => {
		this.listeners.delete(e);
	});
	getSnapshot = () => this.state;
	setState(e) {
		if (this.state === e) return;
		this.state = e, this.updateTick += 1;
		let t = this.updateTick;
		for (let n of this.listeners) {
			if (t !== this.updateTick) return;
			n(e);
		}
	}
	update(e) {
		for (let t in e) if (!Object.is(this.state[t], e[t])) {
			this.setState({
				...this.state,
				...e
			});
			return;
		}
	}
	set(e, t) {
		Object.is(this.state[e], t) || this.setState({
			...this.state,
			[e]: t
		});
	}
	notifyAll() {
		let e = { ...this.state };
		this.setState(e);
	}
	use(e, t, n, r) {
		return J(this, e, t, n, r);
	}
}, oi = class extends ai {
	constructor(e, t = {}, n) {
		super(e), this.context = t, this.selectors = n;
	}
	useSyncedValue(e, t) {
		S.useDebugValue(e), W(() => {
			this.state[e] !== t && this.set(e, t);
		}, [e, t]);
	}
	useSyncedValueWithCleanup(e, t) {
		let n = this;
		W(() => (n.state[e] !== t && n.set(e, t), () => {
			n.set(e, void 0);
		}), [
			n,
			e,
			t
		]);
	}
	useSyncedValues(e) {
		let t = this;
		if (process.env.NODE_ENV !== "production") {
			S.useDebugValue(e, (e) => Object.keys(e));
			let t = S.useRef(Object.keys(e)).current, n = Object.keys(e);
			(t.length !== n.length || t.some((e, t) => e !== n[t])) && console.error("ReactStore.useSyncedValues expects the same prop keys on every render. Keys should be stable.");
		}
		W(() => {
			t.update(e);
		}, [t, ...Object.values(e)]);
	}
	useControlledProp(e, t) {
		S.useDebugValue(e);
		let n = t !== void 0;
		if (W(() => {
			n && !Object.is(this.state[e], t) && super.setState({
				...this.state,
				[e]: t
			});
		}, [
			e,
			t,
			n
		]), process.env.NODE_ENV !== "production") {
			let t = this.controlledValues ??= /* @__PURE__ */ new Map();
			t.has(e) || t.set(e, n);
			let r = t.get(e);
			r !== void 0 && r !== n && console.error(`A component is changing the ${n ? "" : "un"}controlled state of ${e.toString()} to be ${n ? "un" : ""}controlled. Elements should not switch from uncontrolled to controlled (or vice versa).`);
		}
	}
	select(e, t, n, r) {
		let i = this.selectors[e];
		return i(this.state, t, n, r);
	}
	useState(e, t, n, r) {
		return S.useDebugValue(e), J(this, this.selectors[e], t, n, r);
	}
	useContextCallback(e, t) {
		S.useDebugValue(e);
		let n = U(t ?? Et);
		this.context[e] = n;
	}
	useStateSetter(e) {
		let t = S.useRef(void 0);
		return t.current === void 0 && (t.current = (t) => {
			this.set(e, t);
		}), t.current;
	}
	observe(e, t) {
		let n;
		n = typeof e == "function" ? e : this.selectors[e];
		let r = n(this.state);
		return t(r, r, this), this.subscribe((e) => {
			let i = n(e);
			if (!Object.is(r, i)) {
				let e = r;
				r = i, t(i, e, this);
			}
		});
	}
}, si = {
	open: q((e) => e.open),
	domReferenceElement: q((e) => e.domReferenceElement),
	referenceElement: q((e) => e.positionReference ?? e.referenceElement),
	floatingElement: q((e) => e.floatingElement),
	floatingId: q((e) => e.floatingId)
}, ci = class extends oi {
	constructor(e) {
		let { nested: t, noEmit: n, onOpenChange: r, triggerElements: i, ...a } = e;
		super({
			...a,
			positionReference: a.referenceElement,
			domReferenceElement: a.referenceElement
		}, {
			onOpenChange: r,
			dataRef: { current: {} },
			events: Nn(),
			nested: t,
			noEmit: n,
			triggerElements: i
		}, si);
	}
	setOpen = (e, t) => {
		if ((!e || !this.state.open || En(t.event)) && (this.context.dataRef.current.openEvent = e ? t.event : void 0), !this.context.noEmit) {
			let n = {
				open: e,
				reason: t.reason,
				nativeEvent: t.event,
				nested: this.context.nested,
				triggerElement: t.trigger
			};
			this.context.events.emit("openchange", n);
		}
		this.context.onOpenChange?.(e, t);
	};
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useSyncedFloatingRootContext.js
function li(e) {
	let { popupStore: t, noEmit: n = !1, treatPopupAsFloatingElement: r = !1, onOpenChange: i } = e, a = Mn(), o = Ln() != null, s = t.useState("open"), c = t.useState("activeTriggerElement"), l = t.useState(r ? "popupElement" : "positionerElement"), u = t.context.triggerElements, d = Te(() => new ci({
		open: s,
		referenceElement: c,
		floatingElement: l,
		triggerElements: u,
		onOpenChange: i,
		floatingId: a,
		nested: o,
		noEmit: n
	})).current;
	return W(() => {
		let e = {
			open: s,
			floatingId: a,
			referenceElement: c,
			floatingElement: l
		};
		Fe(c) && (e.domReferenceElement = c), d.state.positionReference === d.state.referenceElement && (e.positionReference = c), d.update(e);
	}, [
		s,
		a,
		c,
		l,
		d
	]), d.context.onOpenChange = i, d.context.nested = o, d.context.noEmit = n, d;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useInteractions.js
function ui(e = []) {
	let t = e.map((e) => e?.reference), n = e.map((e) => e?.floating), r = e.map((e) => e?.item), i = e.map((e) => e?.trigger), a = S.useCallback((t) => di(t, e, "reference"), t), o = S.useCallback((t) => di(t, e, "floating"), n), s = S.useCallback((t) => di(t, e, "item"), r), c = S.useCallback((t) => di(t, e, "trigger"), i);
	return S.useMemo(() => ({
		getReferenceProps: a,
		getFloatingProps: o,
		getItemProps: s,
		getTriggerProps: c
	}), [
		a,
		o,
		s,
		c
	]);
}
function di(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i = n === "item", a = {};
	n === "floating" && (a.tabIndex = -1, a["data-base-ui-focusable"] = "");
	for (let t in e) i && e && (t === "active" || t === "selected") || (a[t] = e[t]);
	for (let o = 0; o < t.length; o += 1) {
		let s, c = t[o]?.[n];
		s = typeof c == "function" ? e ? c(e) : null : c, s && fi(a, s, i, r);
	}
	return fi(a, e, i, r), a;
}
function fi(e, t, n, r) {
	for (let i in t) {
		let a = t[i];
		n && (i === "active" || i === "selected") || (i.startsWith("on") ? (r.has(i) || r.set(i, []), typeof a == "function" && (r.get(i)?.push(a), e[i] = (...e) => r.get(i)?.map((t) => t(...e)).find((e) => e !== void 0))) : e[i] = a);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useRole.js
var pi = new Map([
	["select", "listbox"],
	["combobox", "listbox"],
	["label", !1]
]);
function mi(e, t = {}) {
	let n = "rootStore" in e ? e.rootStore : e, r = n.useState("open"), i = n.useState("floatingId"), a = n.useState("domReferenceElement"), o = n.useState("floatingElement"), { role: s = "dialog" } = t, c = Mn(), l = a?.id || c, u = S.useMemo(() => Zt(o)?.id || i, [o, i]), d = pi.get(s) ?? s, f = Ln() != null, p = S.useMemo(() => d === "tooltip" || s === "label" ? Ot : {
		"aria-haspopup": d === "alertdialog" ? "dialog" : d,
		"aria-expanded": "false",
		...d === "listbox" && { role: "combobox" },
		...d === "menu" && f && { role: "menuitem" },
		...s === "select" && { "aria-autocomplete": "none" },
		...s === "combobox" && { "aria-autocomplete": "list" }
	}, [
		d,
		f,
		s
	]), m = S.useMemo(() => d === "tooltip" || s === "label" ? { [`aria-${s === "label" ? "labelledby" : "describedby"}`]: r ? u : void 0 } : {
		...p,
		"aria-expanded": r ? "true" : "false",
		"aria-controls": r ? u : void 0,
		...d === "menu" && { id: l }
	}, [
		d,
		u,
		r,
		l,
		s,
		p
	]), h = S.useMemo(() => {
		let e = {
			id: u,
			...d && { role: d }
		};
		return d === "tooltip" || s === "label" ? e : {
			...e,
			...d === "menu" && { "aria-labelledby": l }
		};
	}, [
		d,
		u,
		l,
		s
	]), g = S.useCallback(({ active: e, selected: t }) => {
		let n = {
			role: "option",
			...e && { id: `${u}-fui-option` }
		};
		switch (s) {
			case "select":
			case "combobox": return {
				...n,
				"aria-selected": t
			};
			default:
		}
		return {};
	}, [u, s]);
	return S.useMemo(() => ({
		reference: m,
		floating: h,
		item: g,
		trigger: p
	}), [
		m,
		h,
		p,
		g
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/useEnhancedClickHandler.js
function hi(e) {
	let t = S.useRef(""), n = S.useCallback((n) => {
		n.defaultPrevented || (t.current = n.pointerType, e(n, n.pointerType));
	}, [e]);
	return {
		onClick: S.useCallback((n) => {
			if (n.detail === 0) {
				e(n, "keyboard");
				return;
			}
			"pointerType" in n ? e(n, n.pointerType) : e(n, t.current), t.current = "";
		}, [e]),
		onPointerDown: n
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/useValueChanged.js
function gi(e, t) {
	let n = S.useRef(e), r = U(t);
	W(() => {
		n.current !== e && r(n.current);
	}, [e, r]), W(() => {
		n.current = e;
	}, [e]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/useOpenInteractionType.js
function _i(e) {
	let [t, n] = S.useState(null), r = U((t, r) => {
		e || n(r || (ot ? "touch" : ""));
	});
	gi(e, (t) => {
		t && !e && n(null);
	});
	let { onClick: i, onPointerDown: a } = hi(r);
	return S.useMemo(() => ({
		openMethod: t,
		triggerProps: {
			onClick: i,
			onPointerDown: a
		}
	}), [
		t,
		i,
		a
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/dialog/root/useDialogRoot.js
function vi(e) {
	let { store: t, parentContext: n, actionsRef: r } = e, i = t.useState("open"), a = t.useState("disablePointerDismissal"), o = t.useState("modal"), s = t.useState("popupElement"), { openMethod: c, triggerProps: l } = _i(i);
	or(t);
	let { forceUnmount: u } = sr(i, t), d = U((e) => {
		let n = K(e);
		return n.preventUnmountOnClose = () => {
			t.set("preventUnmountingOnClose", !0);
		}, n;
	}), f = S.useCallback(() => {
		t.setOpen(!1, d(gn));
	}, [t, d]);
	S.useImperativeHandle(r, () => ({
		unmount: u,
		close: f
	}), [u, f]);
	let p = li({
		popupStore: t,
		onOpenChange: t.setOpen,
		treatPopupAsFloatingElement: !0,
		noEmit: !0
	}), [m, h] = S.useState(0), g = m === 0, _ = mi(p), v = Gn(p, {
		outsidePressEvent() {
			return t.context.internalBackdropRef.current || t.context.backdropRef.current ? "intentional" : {
				mouse: o === "trap-focus" ? "sloppy" : "intentional",
				touch: "sloppy"
			};
		},
		outsidePress(e) {
			if (!t.context.outsidePressEnabledRef.current || "button" in e && e.button !== 0 || "touches" in e && e.touches.length !== 1) return !1;
			let n = Gt(e);
			if (g && !a) {
				let e = n;
				return o && (t.context.internalBackdropRef.current || t.context.backdropRef.current) ? t.context.internalBackdropRef.current === e || t.context.backdropRef.current === e || G(e, s) && !e?.hasAttribute("data-base-ui-portal") : !0;
			}
			return !1;
		},
		escapeKey: g
	});
	Lt(i && o === !0, s);
	let { getReferenceProps: y, getFloatingProps: b, getTriggerProps: x } = ui([_, v]);
	t.useContextCallback("onNestedDialogOpen", (e) => {
		h(e + 1);
	}), t.useContextCallback("onNestedDialogClose", () => {
		h(0);
	}), S.useEffect(() => (n?.onNestedDialogOpen && i && n.onNestedDialogOpen(m), n?.onNestedDialogClose && !i && n.onNestedDialogClose(), () => {
		n?.onNestedDialogClose && i && n.onNestedDialogClose();
	}), [
		i,
		n,
		m
	]);
	let C = S.useMemo(() => y(l), [y, l]), w = S.useMemo(() => x(l), [x, l]), T = S.useMemo(() => b(), [b]);
	t.useSyncedValues({
		openMethod: c,
		activeTriggerProps: C,
		inactiveTriggerProps: w,
		popupProps: T,
		floatingRootContext: p,
		nestedOpenDialogCount: m
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/dialog/root/DialogRootContext.js
var yi = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (yi.displayName = "DialogRootContext");
function bi(e) {
	let t = S.useContext(yi);
	if (e === !1 && t === void 0) throw Error(process.env.NODE_ENV === "production" ? lr(27) : "Base UI: DialogRootContext is missing. Dialog parts must be placed within <Dialog.Root>.");
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/popups/popupTriggerMap.js
var xi = class {
	constructor() {
		this.elementsSet = /* @__PURE__ */ new Set(), this.idMap = /* @__PURE__ */ new Map();
	}
	add(e, t) {
		let n = this.idMap.get(e);
		if (n !== t && (n !== void 0 && this.elementsSet.delete(n), this.elementsSet.add(t), this.idMap.set(e, t), process.env.NODE_ENV !== "production" && this.elementsSet.size !== this.idMap.size)) throw Error("Base UI: A trigger element cannot be registered under multiple IDs in PopupTriggerMap.");
	}
	delete(e) {
		let t = this.idMap.get(e);
		t && (this.elementsSet.delete(t), this.idMap.delete(e));
	}
	hasElement(e) {
		return this.elementsSet.has(e);
	}
	hasMatchingElement(e) {
		for (let t of this.elementsSet) if (e(t)) return !0;
		return !1;
	}
	getById(e) {
		return this.idMap.get(e);
	}
	entries() {
		return this.idMap.entries();
	}
	elements() {
		return this.elementsSet.values();
	}
	get size() {
		return this.idMap.size;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/utils/getEmptyRootContext.js
function Si() {
	return new ci({
		open: !1,
		floatingElement: null,
		referenceElement: null,
		triggerElements: new xi(),
		floatingId: "",
		nested: !1,
		noEmit: !1,
		onOpenChange: void 0
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/popups/store.js
function Ci() {
	return {
		open: !1,
		openProp: void 0,
		mounted: !1,
		transitionStatus: "idle",
		floatingRootContext: Si(),
		preventUnmountingOnClose: !1,
		payload: void 0,
		activeTriggerId: null,
		activeTriggerElement: null,
		triggerIdProp: void 0,
		popupElement: null,
		positionerElement: null,
		activeTriggerProps: Ot,
		inactiveTriggerProps: Ot,
		popupProps: Ot
	};
}
var wi = q((e) => e.triggerIdProp ?? e.activeTriggerId), Ti = {
	open: q((e) => e.openProp ?? e.open),
	mounted: q((e) => e.mounted),
	transitionStatus: q((e) => e.transitionStatus),
	floatingRootContext: q((e) => e.floatingRootContext),
	preventUnmountingOnClose: q((e) => e.preventUnmountingOnClose),
	payload: q((e) => e.payload),
	activeTriggerId: wi,
	activeTriggerElement: q((e) => e.mounted ? e.activeTriggerElement : null),
	isTriggerActive: q((e, t) => t !== void 0 && wi(e) === t),
	isOpenedByTrigger: q((e, t) => t !== void 0 && wi(e) === t && e.open),
	isMountedByTrigger: q((e, t) => t !== void 0 && wi(e) === t && e.mounted),
	triggerProps: q((e, t) => t ? e.activeTriggerProps : e.inactiveTriggerProps),
	popupProps: q((e) => e.popupProps),
	popupElement: q((e) => e.popupElement),
	positionerElement: q((e) => e.positionerElement)
}, Ei = {
	...Ti,
	modal: q((e) => e.modal),
	nested: q((e) => e.nested),
	nestedOpenDialogCount: q((e) => e.nestedOpenDialogCount),
	disablePointerDismissal: q((e) => e.disablePointerDismissal),
	openMethod: q((e) => e.openMethod),
	descriptionElementId: q((e) => e.descriptionElementId),
	titleElementId: q((e) => e.titleElementId),
	viewportElement: q((e) => e.viewportElement),
	role: q((e) => e.role)
}, Di = class extends oi {
	constructor(e) {
		super(Oi(e), {
			popupRef: /* @__PURE__ */ S.createRef(),
			backdropRef: /* @__PURE__ */ S.createRef(),
			internalBackdropRef: /* @__PURE__ */ S.createRef(),
			outsidePressEnabledRef: { current: !0 },
			triggerElements: new xi(),
			onOpenChange: void 0,
			onOpenChangeComplete: void 0
		}, Ei);
	}
	setOpen = (e, t) => {
		if (t.preventUnmountOnClose = () => {
			this.set("preventUnmountingOnClose", !0);
		}, !e && t.trigger == null && this.state.activeTriggerId != null && (t.trigger = this.state.activeTriggerElement ?? void 0), this.context.onOpenChange?.(e, t), t.isCanceled) return;
		let n = {
			open: e,
			nativeEvent: t.event,
			reason: t.reason,
			nested: this.state.nested
		};
		this.state.floatingRootContext.context.events?.emit("openchange", n);
		let r = { open: e }, i = t.trigger?.id ?? null;
		(i || e) && (r.activeTriggerId = i, r.activeTriggerElement = t.trigger ?? null), this.update(r);
	};
};
function Oi(e = {}) {
	return {
		...Ci(),
		modal: !0,
		disablePointerDismissal: !1,
		popupElement: null,
		viewportElement: null,
		descriptionElementId: void 0,
		titleElementId: void 0,
		openMethod: null,
		nested: !1,
		nestedOpenDialogCount: 0,
		role: "dialog",
		...e
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/alert-dialog/root/AlertDialogRoot.js
function ki(e) {
	let { children: t, open: n, defaultOpen: r = !1, onOpenChange: i, onOpenChangeComplete: a, actionsRef: o, handle: s, triggerId: c, defaultTriggerId: l = null } = e, u = bi(), d = !!u, f = Te(() => s?.store ?? new Di({
		open: r,
		openProp: n,
		activeTriggerId: l,
		triggerIdProp: c,
		modal: !0,
		disablePointerDismissal: !0,
		nested: d,
		role: "alertdialog"
	})).current;
	f.useControlledProp("openProp", n), f.useControlledProp("triggerIdProp", c), f.useSyncedValue("nested", d), f.useContextCallback("onOpenChange", i), f.useContextCallback("onOpenChangeComplete", a);
	let p = f.useState("payload");
	vi({
		store: f,
		actionsRef: o,
		parentContext: u?.store.context,
		onOpenChange: i,
		triggerIdProp: c
	});
	let m = S.useMemo(() => ({ store: f }), [f]);
	return /* @__PURE__ */ (0, C.jsx)(yi.Provider, {
		value: m,
		children: typeof t == "function" ? t({ payload: p }) : t
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/useMergedRefs.js
function Ai(e, t, n, r) {
	let i = Te(Mi).current;
	return Ni(i, e, t, n, r) && Fi(i, [
		e,
		t,
		n,
		r
	]), i.callback;
}
function ji(e) {
	let t = Te(Mi).current;
	return Pi(t, e) && Fi(t, e), t.callback;
}
function Mi() {
	return {
		callback: null,
		cleanup: null,
		refs: []
	};
}
function Ni(e, t, n, r, i) {
	return e.refs[0] !== t || e.refs[1] !== n || e.refs[2] !== r || e.refs[3] !== i;
}
function Pi(e, t) {
	return e.refs.length !== t.length || e.refs.some((e, n) => e !== t[n]);
}
function Fi(e, t) {
	if (e.refs = t, t.every((e) => e == null)) {
		e.callback = null;
		return;
	}
	e.callback = (n) => {
		if (e.cleanup &&= (e.cleanup(), null), n != null) {
			let r = Array(t.length).fill(null);
			for (let e = 0; e < t.length; e += 1) {
				let i = t[e];
				if (i != null) switch (typeof i) {
					case "function": {
						let t = i(n);
						typeof t == "function" && (r[e] = t);
						break;
					}
					case "object":
						i.current = n;
						break;
					default:
				}
			}
			e.cleanup = () => {
				for (let e = 0; e < t.length; e += 1) {
					let n = t[e];
					if (n != null) switch (typeof n) {
						case "function": {
							let t = r[e];
							typeof t == "function" ? t() : n(null);
							break;
						}
						case "object":
							n.current = null;
							break;
						default:
					}
				}
			};
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/getReactElementRef.js
function Ii(e) {
	if (!/* @__PURE__ */ S.isValidElement(e)) return null;
	let t = e, n = t.props;
	return (Rr(19) ? n?.ref : t.ref) ?? null;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/mergeObjects.js
function Li(e, t) {
	if (e && !t) return e;
	if (!e && t) return t;
	if (e || t) return {
		...e,
		...t
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/warn.js
var Ri;
process.env.NODE_ENV !== "production" && (Ri = /* @__PURE__ */ new Set());
function zi(...e) {
	if (process.env.NODE_ENV !== "production") {
		let t = e.join(" ");
		Ri.has(t) || (Ri.add(t), console.warn(`Base UI: ${t}`));
	}
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/getStateAttributesProps.js
function Bi(e, t) {
	let n = {};
	for (let r in e) {
		let i = e[r];
		if (t?.hasOwnProperty(r)) {
			let e = t[r](i);
			e != null && Object.assign(n, e);
			continue;
		}
		i === !0 ? n[`data-${r.toLowerCase()}`] = "" : i && (n[`data-${r.toLowerCase()}`] = i.toString());
	}
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/resolveClassName.js
function Vi(e, t) {
	return typeof e == "function" ? e(t) : e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/resolveStyle.js
function Hi(e, t) {
	return typeof e == "function" ? e(t) : e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/merge-props/mergeProps.js
var Ui = {};
function Wi(e, t, n, r, i) {
	let a = { ...Xi(e, Ui) };
	return t && (a = Ki(a, t)), n && (a = Ki(a, n)), r && (a = Ki(a, r)), i && (a = Ki(a, i)), a;
}
function Gi(e) {
	if (e.length === 0) return Ui;
	if (e.length === 1) return Xi(e[0], Ui);
	let t = { ...Xi(e[0], Ui) };
	for (let n = 1; n < e.length; n += 1) t = Ki(t, e[n]);
	return t;
}
function Ki(e, t) {
	return Yi(t) ? t(e) : qi(e, t);
}
function qi(e, t) {
	if (!t) return e;
	for (let n in t) {
		let r = t[n];
		switch (n) {
			case "style":
				e[n] = Li(e.style, r);
				break;
			case "className":
				e[n] = $i(e.className, r);
				break;
			default: Ji(n, r) ? e[n] = Zi(e[n], r) : e[n] = r;
		}
	}
	return e;
}
function Ji(e, t) {
	let n = e.charCodeAt(0), r = e.charCodeAt(1), i = e.charCodeAt(2);
	return n === 111 && r === 110 && i >= 65 && i <= 90 && (typeof t == "function" || t === void 0);
}
function Yi(e) {
	return typeof e == "function";
}
function Xi(e, t) {
	return Yi(e) ? e(t) : e ?? Ui;
}
function Zi(e, t) {
	return t ? e ? (n) => {
		if (ea(n)) {
			let r = n;
			Qi(r);
			let i = t(r);
			return r.baseUIHandlerPrevented || e?.(r), i;
		}
		let r = t(n);
		return e?.(n), r;
	} : t : e;
}
function Qi(e) {
	return e.preventBaseUIHandler = () => {
		e.baseUIHandlerPrevented = !0;
	}, e;
}
function $i(e, t) {
	return t ? e ? t + " " + e : t : e;
}
function ea(e) {
	return typeof e == "object" && !!e && "nativeEvent" in e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/useRenderElement.js
function Y(e, t, n = {}) {
	let r = t.render, i = X(t, n);
	return n.enabled === !1 ? null : na(e, r, i, n.state ?? Ot);
}
function X(e, t = {}) {
	let { className: n, style: r, render: i } = e, { state: a = Ot, ref: o, props: s, stateAttributesMapping: c, enabled: l = !0 } = t, u = l ? Vi(n, a) : void 0, d = l ? Hi(r, a) : void 0, f = l ? Bi(a, c) : Ot, p = l ? Li(f, Array.isArray(s) ? Gi(s) : s) ?? Ot : Ot;
	return typeof document < "u" && (l ? Array.isArray(o) ? p.ref = ji([
		p.ref,
		Ii(i),
		...o
	]) : p.ref = Ai(p.ref, Ii(i), o) : Ai(null, null)), l ? (u !== void 0 && (p.className = $i(p.className, u)), d !== void 0 && (p.style = Li(p.style, d)), p) : Ot;
}
var ta = Symbol.for("react.lazy");
function na(e, t, n, r) {
	if (t) {
		if (typeof t == "function") return process.env.NODE_ENV !== "production" && ra(t), t(n, r);
		let e = Wi(n, t.props);
		e.ref = n.ref;
		let i = t;
		if (i?.$$typeof === ta && (i = S.Children.toArray(t)[0]), process.env.NODE_ENV !== "production" && !/* @__PURE__ */ S.isValidElement(i)) throw Error([
			"Base UI: The `render` prop was provided an invalid React element as `React.isValidElement(render)` is `false`.",
			"A valid React element must be provided to the `render` prop because it is cloned with props to replace the default element.",
			"https://base-ui.com/r/invalid-render-prop"
		].join("\n"));
		return /* @__PURE__ */ S.cloneElement(i, e);
	}
	if (e && typeof e == "string") return ia(e, n);
	throw Error(process.env.NODE_ENV === "production" ? lr(8) : "Base UI: Render element or function are not defined.");
}
function ra(e) {
	let t = e.name;
	if (t.length === 0) return;
	let n = t.charCodeAt(0);
	n < 65 || n > 90 || zi(`The \`render\` prop received a function named \`${t}\` that starts with an uppercase letter.`, "This usually means a React component was passed directly as `render={Component}`.", "Base UI calls `render` as a plain function, which can break the Rules of Hooks during reconciliation.", "If this is an intentional render callback, rename it to start with a lowercase letter.", "Use `render={<Component />}` or `render={(props) => <Component {...props} />}` instead.", "https://base-ui.com/r/invalid-render-prop");
}
function ia(e, t) {
	return e === "button" ? /* @__PURE__ */ (0, S.createElement)("button", {
		type: "button",
		...t,
		key: t.key
	}) : e === "img" ? /* @__PURE__ */ (0, S.createElement)("img", {
		alt: "",
		...t,
		key: t.key
	}) : /* @__PURE__ */ S.createElement(e, t);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/popupStateMapping.js
var aa = function(e) {
	return e.open = "data-open", e.closed = "data-closed", e[e.startingStyle = Jn.startingStyle] = "startingStyle", e[e.endingStyle = Jn.endingStyle] = "endingStyle", e.anchorHidden = "data-anchor-hidden", e.side = "data-side", e.align = "data-align", e;
}({}), oa = /* @__PURE__ */ function(e) {
	return e.popupOpen = "data-popup-open", e.pressed = "data-pressed", e;
}({}), sa = { [oa.popupOpen]: "" }, ca = {
	[oa.popupOpen]: "",
	[oa.pressed]: ""
}, la = { [aa.open]: "" }, ua = { [aa.closed]: "" }, da = { [aa.anchorHidden]: "" }, fa = { open(e) {
	return e ? sa : null;
} }, pa = { open(e) {
	return e ? ca : null;
} }, ma = {
	open(e) {
		return e ? la : ua;
	},
	anchorHidden(e) {
		return e ? da : null;
	}
}, ha = {
	...ma,
	...Zn
}, ga = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, forceRender: i = !1, ...a } = e, { store: o } = bi(), s = o.useState("open"), c = o.useState("nested"), l = o.useState("mounted");
	return Y("div", e, {
		state: {
			open: s,
			transitionStatus: o.useState("transitionStatus")
		},
		ref: [o.context.backdropRef, t],
		stateAttributesMapping: ha,
		props: [{
			role: "presentation",
			hidden: !l,
			style: {
				userSelect: "none",
				WebkitUserSelect: "none"
			}
		}, a],
		enabled: i || !c
	});
});
process.env.NODE_ENV !== "production" && (ga.displayName = "DialogBackdrop");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@floating-ui_utils@0.2.11/node_modules/@floating-ui/utils/dist/floating-ui.utils.js
var _a = [
	"top",
	"right",
	"bottom",
	"left"
], va = Math.min, ya = Math.max, ba = Math.round, xa = Math.floor, Sa = (e) => ({
	x: e,
	y: e
}), Ca = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function wa(e, t, n) {
	return ya(e, va(t, n));
}
function Ta(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function Ea(e) {
	return e.split("-")[0];
}
function Da(e) {
	return e.split("-")[1];
}
function Oa(e) {
	return e === "x" ? "y" : "x";
}
function ka(e) {
	return e === "y" ? "height" : "width";
}
function Aa(e) {
	let t = e[0];
	return t === "t" || t === "b" ? "y" : "x";
}
function ja(e) {
	return Oa(Aa(e));
}
function Ma(e, t, n) {
	n === void 0 && (n = !1);
	let r = Da(e), i = ja(e), a = ka(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = Va(o)), [o, Va(o)];
}
function Na(e) {
	let t = Va(e);
	return [
		Pa(e),
		t,
		Pa(t)
	];
}
function Pa(e) {
	return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var Fa = ["left", "right"], Ia = ["right", "left"], La = ["top", "bottom"], Ra = ["bottom", "top"];
function za(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? Ia : Fa : t ? Fa : Ia;
		case "left":
		case "right": return t ? La : Ra;
		default: return [];
	}
}
function Ba(e, t, n, r) {
	let i = Da(e), a = za(Ea(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(Pa)))), a;
}
function Va(e) {
	let t = Ea(e);
	return Ca[t] + e.slice(t.length);
}
function Ha(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function Ua(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : Ha(e);
}
function Wa(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/utils/composite.js
function Ga(e, t, n) {
	return Math.floor(e / t) !== n;
}
function Ka(e, t) {
	return t < 0 || t >= e.current.length;
}
function qa(e, t) {
	return Ya(e, { disabledIndices: t });
}
function Ja(e, t) {
	return Ya(e, {
		decrement: !0,
		startingIndex: e.current.length,
		disabledIndices: t
	});
}
function Ya(e, { startingIndex: t = -1, decrement: n = !1, disabledIndices: r, amount: i = 1 } = {}) {
	let a = t;
	do
		a += n ? -i : i;
	while (a >= 0 && a <= e.current.length - 1 && eo(e, a, r));
	return a;
}
function Xa(e, { event: t, orientation: n, loopFocus: r, rtl: i, cols: a, disabledIndices: o, minIndex: s, maxIndex: c, prevIndex: l, stopEvent: u = !1 }) {
	let d = l, f;
	if (t.key === "ArrowUp" ? f = "up" : t.key === "ArrowDown" && (f = "down"), f) {
		let n = [], i = [], p = !1, m = 0;
		{
			let t = null, r = -1;
			e.current.forEach((e, a) => {
				if (e == null) return;
				m += 1;
				let o = e.closest("[role=\"row\"]");
				o && (p = !0), (o !== t || r === -1) && (t = o, r += 1, n[r] = []), n[r].push(a), i[a] = r;
			});
		}
		let h = !1, g = 0;
		if (p) for (let e of n) {
			let t = e.length;
			t > g && (g = t), t !== a && (h = !0);
		}
		let _ = h && m < e.current.length, v = g || a, y = (t) => {
			if (!h || l === -1) return;
			let a = i[l];
			if (a == null) return;
			let s = n[a].indexOf(l), c = t === "up" ? -1 : 1;
			for (let t = a + c, i = 0; i < n.length; i += 1, t += c) {
				if (t < 0 || t >= n.length) {
					if (!r || _) return;
					t = t < 0 ? n.length - 1 : 0;
				}
				let i = n[t];
				for (let t = Math.min(s, i.length - 1); t >= 0; --t) {
					let n = i[t];
					if (!eo(e, n, o)) return n;
				}
			}
		}, b = (t) => {
			if (!_ || l === -1) return;
			let n = l % v, i = t === "up" ? -v : v, a = c - c % v, s = xa(c / v) + 1;
			for (let t = l - n + i, u = 0; u < s; u += 1, t += i) {
				if (t < 0 || t > c) {
					if (!r) return;
					t = t < 0 ? a : 0;
				}
				let i = Math.min(t + v - 1, c);
				for (let r = Math.min(t + n, i); r >= t; --r) if (!eo(e, r, o)) return r;
			}
		};
		u && xn(t);
		let x = y(f) ?? b(f);
		if (x !== void 0) d = x;
		else if (l === -1) d = f === "up" ? c : s;
		else if (d = Ya(e, {
			startingIndex: l,
			amount: v,
			decrement: f === "up",
			disabledIndices: o
		}), r) {
			if (f === "up" && (l - v < s || d < 0)) {
				let e = l % v, t = c % v, n = c - (t - e);
				d = t === e ? c : t > e ? n : n - v;
			}
			f === "down" && l + v > c && (d = Ya(e, {
				startingIndex: l % v - v,
				amount: v,
				disabledIndices: o
			}));
		}
		Ka(e, d) && (d = l);
	}
	if (n === "both") {
		let n = xa(l / a);
		t.key === (i ? "ArrowLeft" : "ArrowRight") && (u && xn(t), l % a === a - 1 ? r && (d = Ya(e, {
			startingIndex: l - l % a - 1,
			disabledIndices: o
		})) : (d = Ya(e, {
			startingIndex: l,
			disabledIndices: o
		}), r && Ga(d, a, n) && (d = Ya(e, {
			startingIndex: l - l % a - 1,
			disabledIndices: o
		}))), Ga(d, a, n) && (d = l)), t.key === (i ? "ArrowRight" : "ArrowLeft") && (u && xn(t), l % a === 0 ? r && (d = Ya(e, {
			startingIndex: l + (a - l % a),
			decrement: !0,
			disabledIndices: o
		})) : (d = Ya(e, {
			startingIndex: l,
			decrement: !0,
			disabledIndices: o
		}), r && Ga(d, a, n) && (d = Ya(e, {
			startingIndex: l + (a - l % a),
			decrement: !0,
			disabledIndices: o
		}))), Ga(d, a, n) && (d = l));
		let s = xa(c / a) === n;
		Ka(e, d) && (d = r && s ? t.key === (i ? "ArrowRight" : "ArrowLeft") ? c : Ya(e, {
			startingIndex: l - l % a - 1,
			disabledIndices: o
		}) : l);
	}
	return d;
}
function Za(e, t, n) {
	let r = [], i = 0;
	return e.forEach(({ width: e, height: a }, o) => {
		if (e > t && process.env.NODE_ENV !== "production") throw Error(`[Floating UI]: Invalid grid - item width at index ${o} is greater than grid columns`);
		let s = !1;
		for (n && (i = 0); !s;) {
			let n = [];
			for (let r = 0; r < e; r += 1) for (let e = 0; e < a; e += 1) n.push(i + r + e * t);
			i % t + e <= t && n.every((e) => r[e] == null) ? (n.forEach((e) => {
				r[e] = o;
			}), s = !0) : i += 1;
		}
	}), [...r];
}
function Qa(e, t, n, r, i) {
	if (e === -1) return -1;
	let a = n.indexOf(e), o = t[e];
	switch (i) {
		case "tl": return a;
		case "tr": return o ? a + o.width - 1 : a;
		case "bl": return o ? a + (o.height - 1) * r : a;
		case "br": return n.lastIndexOf(e);
		default: return -1;
	}
}
function $a(e, t) {
	return t.flatMap((t, n) => e.includes(t) ? [n] : []);
}
function eo(e, t, n) {
	if (typeof n == "function" ? n(t) : n?.includes(t) ?? !1) return !0;
	let r = e.current[t];
	return r ? to(r) ? !n && (r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true") : !0 : !1;
}
function to(e) {
	return Ye(e).display !== "none";
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/tabbable@6.4.0/node_modules/tabbable/dist/index.esm.js
var no = /* @__PURE__ */ [
	"input:not([inert]):not([inert] *)",
	"select:not([inert]):not([inert] *)",
	"textarea:not([inert]):not([inert] *)",
	"a[href]:not([inert]):not([inert] *)",
	"button:not([inert]):not([inert] *)",
	"[tabindex]:not(slot):not([inert]):not([inert] *)",
	"audio[controls]:not([inert]):not([inert] *)",
	"video[controls]:not([inert]):not([inert] *)",
	"[contenteditable]:not([contenteditable=\"false\"]):not([inert]):not([inert] *)",
	"details>summary:first-of-type:not([inert]):not([inert] *)",
	"details:not([inert]):not([inert] *)"
].join(","), ro = typeof Element > "u", io = ro ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, ao = !ro && Element.prototype.getRootNode ? function(e) {
	return e?.getRootNode?.call(e);
} : function(e) {
	return e?.ownerDocument;
}, oo = function(e, t) {
	t === void 0 && (t = !0);
	var n = e?.getAttribute?.call(e, "inert");
	return n === "" || n === "true" || t && e && (typeof e.closest == "function" ? e.closest("[inert]") : oo(e.parentNode));
}, so = function(e) {
	var t = e?.getAttribute?.call(e, "contenteditable");
	return t === "" || t === "true";
}, co = function(e, t, n) {
	if (oo(e)) return [];
	var r = Array.prototype.slice.apply(e.querySelectorAll(no));
	return t && io.call(e, no) && r.unshift(e), r = r.filter(n), r;
}, lo = function(e, t, n) {
	for (var r = [], i = Array.from(e); i.length;) {
		var a = i.shift();
		if (!oo(a, !1)) if (a.tagName === "SLOT") {
			var o = a.assignedElements(), s = lo(o.length ? o : a.children, !0, n);
			n.flatten ? r.push.apply(r, s) : r.push({
				scopeParent: a,
				candidates: s
			});
		} else {
			io.call(a, no) && n.filter(a) && (t || !e.includes(a)) && r.push(a);
			var c = a.shadowRoot || typeof n.getShadowRoot == "function" && n.getShadowRoot(a), l = !oo(c, !1) && (!n.shadowRootFilter || n.shadowRootFilter(a));
			if (c && l) {
				var u = lo(c === !0 ? a.children : c.children, !0, n);
				n.flatten ? r.push.apply(r, u) : r.push({
					scopeParent: a,
					candidates: u
				});
			} else i.unshift.apply(i, a.children);
		}
	}
	return r;
}, uo = function(e) {
	return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, fo = function(e) {
	if (!e) throw Error("No node provided");
	return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || so(e)) && !uo(e) ? 0 : e.tabIndex;
}, po = function(e, t) {
	var n = fo(e);
	return n < 0 && t && !uo(e) ? 0 : n;
}, mo = function(e, t) {
	return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, ho = function(e) {
	return e.tagName === "INPUT";
}, go = function(e) {
	return ho(e) && e.type === "hidden";
}, _o = function(e) {
	return e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(e) {
		return e.tagName === "SUMMARY";
	});
}, vo = function(e, t) {
	for (var n = 0; n < e.length; n++) if (e[n].checked && e[n].form === t) return e[n];
}, yo = function(e) {
	if (!e.name) return !0;
	var t = e.form || ao(e), n = function(e) {
		return t.querySelectorAll("input[type=\"radio\"][name=\"" + e + "\"]");
	}, r;
	if (typeof window < "u" && window.CSS !== void 0 && typeof window.CSS.escape == "function") r = n(window.CSS.escape(e.name));
	else try {
		r = n(e.name);
	} catch (e) {
		return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1;
	}
	var i = vo(r, e.form);
	return !i || i === e;
}, bo = function(e) {
	return ho(e) && e.type === "radio";
}, xo = function(e) {
	return bo(e) && !yo(e);
}, So = function(e) {
	var t = e && ao(e), n = t?.host, r = !1;
	if (t && t !== e) {
		var i, a, o;
		for (r = !!((i = n) != null && (a = i.ownerDocument) != null && a.contains(n) || e != null && (o = e.ownerDocument) != null && o.contains(e)); !r && n;) {
			var s, c;
			t = ao(n), n = t?.host, r = !!((s = n) != null && (c = s.ownerDocument) != null && c.contains(n));
		}
	}
	return r;
}, Co = function(e) {
	var t = e.getBoundingClientRect(), n = t.width, r = t.height;
	return n === 0 && r === 0;
}, wo = function(e, t) {
	var n = t.displayCheck, r = t.getShadowRoot;
	if (n === "full-native" && "checkVisibility" in e) return !e.checkVisibility({
		checkOpacity: !1,
		opacityProperty: !1,
		contentVisibilityAuto: !0,
		visibilityProperty: !0,
		checkVisibilityCSS: !0
	});
	if (getComputedStyle(e).visibility === "hidden") return !0;
	var i = io.call(e, "details>summary:first-of-type") ? e.parentElement : e;
	if (io.call(i, "details:not([open]) *")) return !0;
	if (!n || n === "full" || n === "full-native" || n === "legacy-full") {
		if (typeof r == "function") {
			for (var a = e; e;) {
				var o = e.parentElement, s = ao(e);
				if (o && !o.shadowRoot && r(o) === !0) return Co(e);
				e = e.assignedSlot ? e.assignedSlot : !o && s !== e.ownerDocument ? s.host : o;
			}
			e = a;
		}
		if (So(e)) return !e.getClientRects().length;
		if (n !== "legacy-full") return !0;
	} else if (n === "non-zero-area") return Co(e);
	return !1;
}, To = function(e) {
	if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName)) for (var t = e.parentElement; t;) {
		if (t.tagName === "FIELDSET" && t.disabled) {
			for (var n = 0; n < t.children.length; n++) {
				var r = t.children.item(n);
				if (r.tagName === "LEGEND") return io.call(t, "fieldset[disabled] *") ? !0 : !r.contains(e);
			}
			return !0;
		}
		t = t.parentElement;
	}
	return !1;
}, Eo = function(e, t) {
	return !(t.disabled || go(t) || wo(t, e) || _o(t) || To(t));
}, Do = function(e, t) {
	return !(xo(t) || fo(t) < 0 || !Eo(e, t));
}, Oo = function(e) {
	var t = parseInt(e.getAttribute("tabindex"), 10);
	return !!(isNaN(t) || t >= 0);
}, ko = function(e) {
	var t = [], n = [];
	return e.forEach(function(e, r) {
		var i = !!e.scopeParent, a = i ? e.scopeParent : e, o = po(a, i), s = i ? ko(e.candidates) : a;
		o === 0 ? i ? t.push.apply(t, s) : t.push(a) : n.push({
			documentOrder: r,
			tabIndex: o,
			item: e,
			isScope: i,
			content: s
		});
	}), n.sort(mo).reduce(function(e, t) {
		return t.isScope ? e.push.apply(e, t.content) : e.push(t.content), e;
	}, []).concat(t);
}, Ao = function(e, t) {
	return t ||= {}, ko(t.getShadowRoot ? lo([e], t.includeContainer, {
		filter: Do.bind(null, t),
		flatten: !1,
		getShadowRoot: t.getShadowRoot,
		shadowRootFilter: Oo
	}) : co(e, t.includeContainer, Do.bind(null, t)));
}, jo = function(e, t) {
	return t ||= {}, t.getShadowRoot ? lo([e], t.includeContainer, {
		filter: Eo.bind(null, t),
		flatten: !0,
		getShadowRoot: t.getShadowRoot
	}) : co(e, t.includeContainer, Eo.bind(null, t));
}, Mo = function(e, t) {
	if (t ||= {}, !e) throw Error("No node provided");
	return io.call(e, no) === !1 ? !1 : Do(t, e);
}, No = () => ({
	getShadowRoot: !0,
	displayCheck: typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
});
function Po(e, t) {
	let n = Ao(e, No()), r = n.length;
	if (r === 0) return;
	let i = Ut(ht(e)), a = n.indexOf(i);
	return n[a === -1 ? t === 1 ? 0 : r - 1 : a + t];
}
function Fo(e) {
	return Po(ht(e).body, 1) || e;
}
function Io(e) {
	return Po(ht(e).body, -1) || e;
}
function Lo(e, t) {
	if (!e) return null;
	let n = Ao(ht(e).body, No()), r = n.length;
	if (r === 0) return null;
	let i = n.indexOf(e);
	return i === -1 ? null : n[(i + t + r) % r];
}
function Ro(e) {
	return Lo(e, 1);
}
function zo(e) {
	return Lo(e, -1);
}
function Bo(e, t) {
	let n = t || e.currentTarget, r = e.relatedTarget;
	return !r || !G(n, r);
}
function Vo(e) {
	Ao(e, No()).forEach((e) => {
		e.dataset.tabindex = e.getAttribute("tabindex") || "", e.setAttribute("tabindex", "-1");
	});
}
function Ho(e) {
	e.querySelectorAll("[data-tabindex]").forEach((e) => {
		let t = e.dataset.tabindex;
		delete e.dataset.tabindex, t ? e.setAttribute("tabindex", t) : e.removeAttribute("tabindex");
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/constants.js
var Uo = { style: { transition: "none" } }, Wo = "data-base-ui-click-trigger", Go = "data-base-ui-swipe-ignore", Ko = "data-swipe-ignore", qo = `[${Go}]`, Jo = `[${Ko}]`, Yo = { fallbackAxisSide: "none" }, Xo = { fallbackAxisSide: "end" }, Zo = {
	clipPath: "inset(50%)",
	position: "fixed",
	top: 0,
	left: 0
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/useValueAsRef.js
function Qo(e) {
	let t = Te($o, e).current;
	return t.next = e, W(t.effect), t;
}
function $o(e) {
	let t = {
		current: e,
		next: e,
		effect: () => {
			t.current = t.next;
		}
	};
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/visuallyHidden.js
var es = {
	clipPath: "inset(50%)",
	overflow: "hidden",
	whiteSpace: "nowrap",
	border: 0,
	padding: 0,
	width: 1,
	height: 1,
	margin: -1
}, ts = {
	...es,
	position: "fixed",
	top: 0,
	left: 0
}, ns = {
	...es,
	position: "absolute"
}, rs = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let [n, r] = S.useState();
	W(() => {
		ct && r("button");
	}, []);
	let i = {
		tabIndex: 0,
		role: n
	};
	return /* @__PURE__ */ (0, C.jsx)("span", {
		...e,
		ref: t,
		style: ts,
		"aria-hidden": n ? void 0 : !0,
		...i,
		"data-base-ui-focus-guard": ""
	});
});
process.env.NODE_ENV !== "production" && (rs.displayName = "FocusGuard");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/utils/enqueueFocus.js
var is = 0;
function as(e, t = {}) {
	let { preventScroll: n = !1, cancelPrevious: r = !0, sync: i = !1 } = t;
	r && cancelAnimationFrame(is);
	let a = () => e?.focus({ preventScroll: n });
	i ? a() : is = requestAnimationFrame(a);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/utils/markOthers.js
var os = {
	inert: /* @__PURE__ */ new WeakMap(),
	"aria-hidden": /* @__PURE__ */ new WeakMap()
}, ss = "data-base-ui-inert", cs = {
	inert: /* @__PURE__ */ new WeakSet(),
	"aria-hidden": /* @__PURE__ */ new WeakSet()
}, ls = /* @__PURE__ */ new WeakMap(), us = 0;
function ds(e) {
	return cs[e];
}
function fs(e) {
	return e ? Le(e) ? e.host : fs(e.parentNode) : null;
}
var ps = (e, t) => t.map((t) => {
	if (e.contains(t)) return t;
	let n = fs(t);
	return e.contains(n) ? n : null;
}).filter((e) => e != null), ms = (e) => {
	let t = /* @__PURE__ */ new Set();
	return e.forEach((e) => {
		let n = e;
		for (; n && !t.has(n);) t.add(n), n = n.parentNode;
	}), t;
}, hs = (e, t, n) => {
	let r = [], i = (e) => {
		!e || n.has(e) || Array.from(e.children).forEach((e) => {
			je(e) !== "script" && (t.has(e) ? i(e) : r.push(e));
		});
	};
	return i(e), r;
};
function gs(e, t, n, r, { mark: i = !0, markerIgnoreElements: a = [] }) {
	let o = r ? "inert" : n ? "aria-hidden" : null, s = null, c = null, l = ps(t, e), u = i ? ps(t, a) : [], d = new Set(u), f = i ? hs(t, ms(l), new Set(l)).filter((e) => !d.has(e)) : [], p = [], m = [];
	if (o) {
		let e = os[o], n = ds(o);
		c = n, s = e;
		let r = ps(t, Array.from(t.querySelectorAll("[aria-live]"))), i = l.concat(r);
		hs(t, ms(i), new Set(i)).forEach((t) => {
			let r = t.getAttribute(o), i = r !== null && r !== "false", a = (e.get(t) || 0) + 1;
			e.set(t, a), p.push(t), a === 1 && i && n.add(t), i || t.setAttribute(o, o === "inert" ? "" : "true");
		});
	}
	return i && f.forEach((e) => {
		let t = (ls.get(e) || 0) + 1;
		ls.set(e, t), m.push(e), t === 1 && e.setAttribute(ss, "");
	}), us += 1, () => {
		s && p.forEach((e) => {
			let t = (s.get(e) || 0) - 1;
			s.set(e, t), t || (!c?.has(e) && o && e.removeAttribute(o), c?.delete(e));
		}), i && m.forEach((e) => {
			let t = (ls.get(e) || 0) - 1;
			ls.set(e, t), t || e.removeAttribute(ss);
		}), --us, us || (os.inert = /* @__PURE__ */ new WeakMap(), os["aria-hidden"] = /* @__PURE__ */ new WeakMap(), cs.inert = /* @__PURE__ */ new WeakSet(), cs["aria-hidden"] = /* @__PURE__ */ new WeakSet(), ls = /* @__PURE__ */ new WeakMap());
	};
}
function _s(e, t = {}) {
	let { ariaHidden: n = !1, inert: r = !1, mark: i = !0, markerIgnoreElements: a = [] } = t, o = ht(e[0]).body;
	return gs(e, o, n, r, {
		mark: i,
		markerIgnoreElements: a
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/components/FloatingPortal.js
var vs = /* @__PURE__ */ S.createContext(null);
process.env.NODE_ENV !== "production" && (vs.displayName = "PortalContext");
var ys = () => S.useContext(vs), bs = Dn("portal");
function xs(e = {}) {
	let { ref: t, container: n, componentProps: r = Ot, elementProps: i } = e, a = Mn(), o = ys()?.portalNode, [s, c] = S.useState(null), [l, u] = S.useState(null), d = U((e) => {
		e !== null && u(e);
	}), f = S.useRef(null);
	W(() => {
		if (n === null) {
			f.current && (f.current = null, u(null), c(null));
			return;
		}
		if (a == null) return;
		let e = (n && (Pe(n) ? n : n.current)) ?? o ?? document.body;
		if (e == null) {
			f.current && (f.current = null, u(null), c(null));
			return;
		}
		f.current !== e && (f.current = e, u(null), c(e));
	}, [
		n,
		o,
		a
	]);
	let p = Y("div", r, {
		ref: [t, d],
		props: [{
			id: a,
			[bs]: ""
		}, i]
	});
	return {
		portalNode: l,
		portalSubtree: s && p ? /* @__PURE__ */ tr.createPortal(p, s) : null
	};
}
var Ss = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { children: n, container: r, className: i, render: a, renderGuards: o, ...s } = e, { portalNode: c, portalSubtree: l } = xs({
		container: r,
		ref: t,
		componentProps: e,
		elementProps: s
	}), u = S.useRef(null), d = S.useRef(null), f = S.useRef(null), p = S.useRef(null), [m, h] = S.useState(null), g = m?.modal, _ = m?.open, v = typeof o == "boolean" ? o : !!m && !m.modal && m.open && !!c;
	S.useEffect(() => {
		if (!c || g) return;
		function e(e) {
			c && e.relatedTarget && Bo(e) && (e.type === "focusin" ? Ho : Vo)(c);
		}
		return c.addEventListener("focusin", e, !0), c.addEventListener("focusout", e, !0), () => {
			c.removeEventListener("focusin", e, !0), c.removeEventListener("focusout", e, !0);
		};
	}, [c, g]), S.useEffect(() => {
		!c || _ || Ho(c);
	}, [_, c]);
	let y = S.useMemo(() => ({
		beforeOutsideRef: u,
		afterOutsideRef: d,
		beforeInsideRef: f,
		afterInsideRef: p,
		portalNode: c,
		setFocusManagerState: h
	}), [c]);
	return /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [l, /* @__PURE__ */ (0, C.jsxs)(vs.Provider, {
		value: y,
		children: [
			v && c && /* @__PURE__ */ (0, C.jsx)(rs, {
				"data-type": "outside",
				ref: u,
				onFocus: (e) => {
					Bo(e, c) ? f.current?.focus() : Io(m ? m.domReference : null)?.focus();
				}
			}),
			v && c && /* @__PURE__ */ (0, C.jsx)("span", {
				"aria-owns": c.id,
				style: Zo
			}),
			c && /* @__PURE__ */ tr.createPortal(n, c),
			v && c && /* @__PURE__ */ (0, C.jsx)(rs, {
				"data-type": "outside",
				ref: d,
				onFocus: (e) => {
					Bo(e, c) ? p.current?.focus() : (Fo(m ? m.domReference : null)?.focus(), m?.closeOnFocusOut && m?.onOpenChange(!1, K("focus-out", e.nativeEvent)));
				}
			})
		]
	})] });
});
process.env.NODE_ENV !== "production" && (Ss.displayName = "FloatingPortal");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/components/FloatingFocusManager.js
function Cs(e, t) {
	let n = Me(e.target);
	return e instanceof n.KeyboardEvent ? "keyboard" : e instanceof n.FocusEvent ? t || "keyboard" : "pointerType" in e ? e.pointerType || "keyboard" : "touches" in e ? "touch" : e instanceof n.MouseEvent ? t || (e.detail === 0 ? "keyboard" : "mouse") : "";
}
var ws = 20, Ts = [];
function Es() {
	Ts = Ts.filter((e) => e.deref()?.isConnected);
}
function Ds(e) {
	Es(), e && je(e) !== "body" && (Ts.push(new WeakRef(e)), Ts.length > ws && (Ts = Ts.slice(-ws)));
}
function Os() {
	return Es(), Ts[Ts.length - 1]?.deref();
}
function ks(e) {
	if (!e) return null;
	let t = No();
	return Mo(e, t) ? e : Ao(e, t)[0] || e;
}
function As(e) {
	return !e || !e.isConnected ? !1 : typeof e.checkVisibility == "function" ? e.checkVisibility() : to(e);
}
function js(e, t) {
	if (!t.current.includes("floating") && !e.getAttribute("role")?.includes("dialog")) return;
	let n = No(), r = jo(e, n).filter((e) => {
		let t = e.getAttribute("data-tabindex") || "";
		return Mo(e, n) || e.hasAttribute("data-tabindex") && !t.startsWith("-");
	}), i = e.getAttribute("tabindex");
	t.current.includes("floating") || r.length === 0 ? i !== "0" && e.setAttribute("tabindex", "0") : (i !== "-1" || e.hasAttribute("data-tabindex") && e.getAttribute("data-tabindex") !== "-1") && (e.setAttribute("tabindex", "-1"), e.setAttribute("data-tabindex", "-1"));
}
function Ms(e) {
	let { context: t, children: n, disabled: r = !1, initialFocus: i = !0, returnFocus: a = !0, restoreFocus: o = !1, modal: s = !0, closeOnFocusOut: c = !0, openInteractionType: l = "", nextFocusableElement: u, previousFocusableElement: d, beforeContentFocusGuardRef: f, externalTree: p, getInsideElements: m } = e, h = "rootStore" in t ? t.rootStore : t, g = h.useState("open"), _ = h.useState("domReferenceElement"), v = h.useState("floatingElement"), { events: y, dataRef: b } = h.context, x = U(() => b.current.floatingContext?.nodeId), w = i === !1, T = Yt(_) && w, E = S.useRef(["content"]), D = Qo(i), O = Qo(a), k = Qo(l), A = Rn(p), j = ys(), M = S.useRef(!1), N = S.useRef(!1), P = S.useRef(!1), F = S.useRef(-1), I = S.useRef(""), L = S.useRef(""), ee = S.useRef(null), R = S.useRef(null), z = Ai(ee, f, j?.beforeInsideRef), te = Ai(R, j?.afterInsideRef), B = bt(), V = bt(), ne = Tt(), re = j != null, ie = Zt(v), ae = U((e = ie) => e ? Ao(e, No()) : []), oe = U(() => m?.().filter((e) => e != null) ?? []), H = U((e) => {
		let t = ae(e);
		return E.current.map(() => t).filter(Boolean).flat();
	});
	S.useEffect(() => {
		if (r || !s) return;
		function e(e) {
			e.key === "Tab" && G(ie, Ut(ht(ie))) && ae().length === 0 && !T && xn(e);
		}
		let t = ht(ie);
		return t.addEventListener("keydown", e), () => {
			t.removeEventListener("keydown", e);
		};
	}, [
		r,
		_,
		ie,
		s,
		E,
		T,
		ae,
		H
	]), S.useEffect(() => {
		if (r || !g) return;
		let e = ht(ie);
		function t() {
			P.current = !1;
		}
		function n(e) {
			let t = Gt(e), n = oe();
			P.current = !(G(v, t) || G(_, t) || G(j?.portalNode, t) || n.some((e) => e === t || G(e, t))), L.current = e.pointerType || "keyboard", t?.closest("[data-base-ui-click-trigger]") && (N.current = !0);
		}
		function i() {
			L.current = "keyboard";
		}
		return e.addEventListener("pointerdown", n, !0), e.addEventListener("pointerup", t, !0), e.addEventListener("pointercancel", t, !0), e.addEventListener("keydown", i, !0), () => {
			e.removeEventListener("pointerdown", n, !0), e.removeEventListener("pointerup", t, !0), e.removeEventListener("pointercancel", t, !0), e.removeEventListener("keydown", i, !0);
		};
	}, [
		r,
		v,
		_,
		ie,
		g,
		j,
		oe
	]), S.useEffect(() => {
		if (r || !c) return;
		let e = ht(ie);
		function t() {
			N.current = !0, V.start(0, () => {
				N.current = !1;
			});
		}
		function n(e) {
			let t = Gt(e), n = ae().indexOf(t);
			n !== -1 && (F.current = n);
		}
		function i(t) {
			let n = t.relatedTarget, r = t.currentTarget, i = Gt(t);
			queueMicrotask(() => {
				let a = x(), c = h.context.triggerElements, l = oe(), f = n?.hasAttribute(Dn("focus-guard")) && [
					ee.current,
					R.current,
					j?.beforeInsideRef.current,
					j?.afterInsideRef.current,
					j?.beforeOutsideRef.current,
					j?.afterOutsideRef.current,
					qn(d),
					qn(u)
				].includes(n), p = !(G(_, n) || G(v, n) || G(n, v) || G(j?.portalNode, n) || l.some((e) => e === n || G(e, n)) || n != null && c.hasElement(n) || c.hasMatchingElement((e) => G(e, n)) || f || A && (yn(A.nodesRef.current, a).find((e) => G(e.context?.elements.floating, n) || G(e.context?.elements.domReference, n)) || bn(A.nodesRef.current, a).find((e) => [e.context?.elements.floating, Zt(e.context?.elements.floating)].includes(n) || e.context?.elements.domReference === n)));
				if (r === _ && ie && js(ie, E), o && r !== _ && !As(i) && Ut(e) === e.body) {
					if (Ie(ie) && (ie.focus(), o === "popup")) {
						ne.request(() => {
							ie.focus();
						});
						return;
					}
					let e = F.current, t = ae(), n = t[e] || t[t.length - 1] || ie;
					Ie(n) && n.focus();
				}
				if (b.current.insideReactTree) {
					b.current.insideReactTree = !1;
					return;
				}
				(T || !s) && n && p && !N.current && (T || n !== Os()) && (M.current = !0, h.setOpen(!1, K("focus-out", t)));
			});
		}
		function a() {
			P.current || (b.current.insideReactTree = !0, B.start(0, () => {
				b.current.insideReactTree = !1;
			}));
		}
		let l = Ie(_) ? _ : null, f = [];
		if (!(!v && !l)) return l && (l.addEventListener("focusout", i), l.addEventListener("pointerdown", t), f.push(() => {
			l.removeEventListener("focusout", i), l.removeEventListener("pointerdown", t);
		})), v && (v.addEventListener("focusin", n), v.addEventListener("focusout", i), j && (v.addEventListener("focusout", a, !0), f.push(() => {
			v.removeEventListener("focusout", a, !0);
		})), f.push(() => {
			v.removeEventListener("focusin", n), v.removeEventListener("focusout", i);
		})), () => {
			f.forEach((e) => {
				e();
			});
		};
	}, [
		r,
		_,
		v,
		ie,
		s,
		A,
		j,
		h,
		c,
		o,
		ae,
		T,
		x,
		E,
		b,
		B,
		V,
		ne,
		u,
		d,
		oe
	]), S.useEffect(() => {
		if (r || !v || !g) return;
		let e = Array.from(j?.portalNode?.querySelectorAll(`[${Dn("portal")}]`) || []), t = (A ? bn(A.nodesRef.current, x()) : []).find((e) => Yt(e.context?.elements.domReference || null))?.context?.elements.domReference, n = _s([
			...[
				v,
				...e,
				ee.current,
				R.current,
				j?.beforeOutsideRef.current,
				j?.afterOutsideRef.current,
				...oe()
			],
			t,
			qn(d),
			qn(u),
			T ? _ : null
		].filter((e) => e != null), {
			ariaHidden: s || T,
			mark: !1
		}), i = _s([v, ...e].filter((e) => e != null));
		return () => {
			i(), n();
		};
	}, [
		g,
		r,
		_,
		v,
		s,
		E,
		j,
		T,
		A,
		x,
		u,
		d,
		oe
	]), W(() => {
		if (!g || r || !Ie(ie)) return;
		let e = Ut(ht(ie));
		queueMicrotask(() => {
			let t = H(ie), n = D.current, r = typeof n == "function" ? n(k.current || "") : n;
			if (r === void 0 || r === !1) return;
			let i;
			i = r === !0 || r === null ? t[0] || ie : qn(r), i = i || t[0] || ie, !G(ie, e) && as(i, { preventScroll: i === ie });
		});
	}, [
		r,
		g,
		ie,
		w,
		H,
		D,
		k
	]), W(() => {
		if (r || !ie) return;
		let e = ht(ie);
		Ds(Ut(e));
		function t(e) {
			if (e.open || (I.current = Cs(e.nativeEvent, L.current)), e.reason === "trigger-hover" && e.nativeEvent.type === "mouseleave" && (M.current = !0), e.reason === "outside-press") if (e.nested) M.current = !1;
			else if (Cn(e.nativeEvent) || wn(e.nativeEvent)) M.current = !1;
			else {
				let e = !1;
				document.createElement("div").focus({ get preventScroll() {
					return e = !0, !1;
				} }), e ? M.current = !1 : M.current = !0;
			}
		}
		y.on("openchange", t);
		function n() {
			let e = O.current, t = typeof e == "function" ? e(I.current) : e;
			if (t === void 0 || t === !1) return null;
			if (t === null && (t = !0), typeof t == "boolean") {
				let e = _ || Os();
				return e && e.isConnected ? e : null;
			}
			let n = _ || Os();
			return qn(t) || n || null;
		}
		return () => {
			y.off("openchange", t);
			let r = Ut(e), i = oe(), a = G(v, r) || i.some((e) => e === r || G(e, r)) || A && yn(A.nodesRef.current, x(), !1).some((e) => G(e.context?.elements.floating, r)), o = n();
			queueMicrotask(() => {
				let t = ks(o), n = typeof O.current != "boolean";
				O.current && !M.current && Ie(t) && (!(!n && t !== r && r !== e.body) || a) && t.focus({ preventScroll: !0 }), M.current = !1;
			});
		};
	}, [
		r,
		v,
		ie,
		O,
		b,
		y,
		A,
		_,
		x,
		oe
	]), W(() => {
		if (!at || g || !v) return;
		let e = Ut(ht(v));
		!Ie(e) || !Jt(e) || G(v, e) && e.blur();
	}, [g, v]), W(() => {
		if (!(r || !j)) return j.setFocusManagerState({
			modal: s,
			closeOnFocusOut: c,
			open: g,
			onOpenChange: h.setOpen,
			domReference: _
		}), () => {
			j.setFocusManagerState(null);
		};
	}, [
		r,
		j,
		s,
		g,
		h,
		c,
		_
	]), W(() => {
		if (!(r || !ie)) return js(ie, E), () => {
			queueMicrotask(Es);
		};
	}, [
		r,
		ie,
		E
	]);
	let se = !r && (s ? !T : !0) && (re || s);
	return /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [
		se && /* @__PURE__ */ (0, C.jsx)(rs, {
			"data-type": "inside",
			ref: z,
			onFocus: (e) => {
				if (s) {
					let e = H();
					as(e[e.length - 1]);
				} else j?.portalNode && (M.current = !1, Bo(e, j.portalNode) ? Fo(_)?.focus() : qn(d ?? j.beforeOutsideRef)?.focus());
			}
		}),
		n,
		se && /* @__PURE__ */ (0, C.jsx)(rs, {
			"data-type": "inside",
			ref: te,
			onFocus: (e) => {
				s ? as(H()[0]) : j?.portalNode && (c && (M.current = !0), Bo(e, j.portalNode) ? Io(_)?.focus() : qn(u ?? j.afterOutsideRef)?.focus());
			}
		})
	] });
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/dialog/popup/DialogPopupCssVars.js
var Ns = /* @__PURE__ */ function(e) {
	return e.nestedDialogs = "--nested-dialogs", e;
}({}), Ps = function(e) {
	return e[e.open = aa.open] = "open", e[e.closed = aa.closed] = "closed", e[e.startingStyle = aa.startingStyle] = "startingStyle", e[e.endingStyle = aa.endingStyle] = "endingStyle", e.nested = "data-nested", e.nestedDialogOpen = "data-nested-dialog-open", e;
}({}), Fs = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Fs.displayName = "DialogPortalContext");
function Is() {
	let e = S.useContext(Fs);
	if (e === void 0) throw Error(process.env.NODE_ENV === "production" ? lr(26) : "Base UI: <Dialog.Portal> is missing.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/composite/composite.js
var Ls = "ArrowUp", Rs = "ArrowDown", zs = "ArrowLeft", Bs = "ArrowRight", Vs = "Home", Hs = new Set([zs, Bs]), Us = new Set([
	zs,
	Bs,
	Vs,
	"End"
]), Ws = new Set([Ls, Rs]), Gs = new Set([
	Ls,
	Rs,
	Vs,
	"End"
]), Ks = new Set([...Hs, ...Ws]), qs = new Set([
	...Ks,
	Vs,
	"End"
]), Js = new Set([
	Ls,
	Rs,
	zs,
	Bs,
	Vs,
	"End"
]), Ys = new Set([
	"Shift",
	"Control",
	"Alt",
	"Meta"
]);
function Xs(e) {
	return Ie(e) && e.tagName === "INPUT";
}
function Zs(e) {
	return !!(Xs(e) && e.selectionStart != null || Ie(e) && e.tagName === "TEXTAREA");
}
function Qs(e, t, n, r) {
	if (!e || !t || !t.scrollTo) return;
	let i = e.scrollLeft, a = e.scrollTop, o = e.clientWidth < e.scrollWidth, s = e.clientHeight < e.scrollHeight;
	if (o && r !== "vertical") {
		let r = $s(e, t, "left"), a = ec(e), o = ec(t);
		n === "ltr" && (r + t.offsetWidth + o.scrollMarginRight > e.scrollLeft + e.clientWidth - a.scrollPaddingRight ? i = r + t.offsetWidth + o.scrollMarginRight - e.clientWidth + a.scrollPaddingRight : r - o.scrollMarginLeft < e.scrollLeft + a.scrollPaddingLeft && (i = r - o.scrollMarginLeft - a.scrollPaddingLeft)), n === "rtl" && (r - o.scrollMarginRight < e.scrollLeft + a.scrollPaddingLeft ? i = r - o.scrollMarginLeft - a.scrollPaddingLeft : r + t.offsetWidth + o.scrollMarginRight > e.scrollLeft + e.clientWidth - a.scrollPaddingRight && (i = r + t.offsetWidth + o.scrollMarginRight - e.clientWidth + a.scrollPaddingRight));
	}
	if (s && r !== "horizontal") {
		let n = $s(e, t, "top"), r = ec(e), i = ec(t);
		n - i.scrollMarginTop < e.scrollTop + r.scrollPaddingTop ? a = n - i.scrollMarginTop - r.scrollPaddingTop : n + t.offsetHeight + i.scrollMarginBottom > e.scrollTop + e.clientHeight - r.scrollPaddingBottom && (a = n + t.offsetHeight + i.scrollMarginBottom - e.clientHeight + r.scrollPaddingBottom);
	}
	e.scrollTo({
		left: i,
		top: a,
		behavior: "auto"
	});
}
function $s(e, t, n) {
	let r = n === "left" ? "offsetLeft" : "offsetTop", i = 0;
	for (; t.offsetParent && (i += t[r], t.offsetParent !== e);) t = t.offsetParent;
	return i;
}
function ec(e) {
	let t = getComputedStyle(e);
	return {
		scrollMarginTop: parseFloat(t.scrollMarginTop) || 0,
		scrollMarginRight: parseFloat(t.scrollMarginRight) || 0,
		scrollMarginBottom: parseFloat(t.scrollMarginBottom) || 0,
		scrollMarginLeft: parseFloat(t.scrollMarginLeft) || 0,
		scrollPaddingTop: parseFloat(t.scrollPaddingTop) || 0,
		scrollPaddingRight: parseFloat(t.scrollPaddingRight) || 0,
		scrollPaddingBottom: parseFloat(t.scrollPaddingBottom) || 0,
		scrollPaddingLeft: parseFloat(t.scrollPaddingLeft) || 0
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/dialog/popup/DialogPopup.js
var tc = {
	...ma,
	...Zn,
	nestedDialogOpen(e) {
		return e ? { [Ps.nestedDialogOpen]: "" } : null;
	}
}, nc = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, finalFocus: r, initialFocus: i, render: a, ...o } = e, { store: s } = bi(), c = s.useState("descriptionElementId"), l = s.useState("disablePointerDismissal"), u = s.useState("floatingRootContext"), d = s.useState("popupProps"), f = s.useState("modal"), p = s.useState("mounted"), m = s.useState("nested"), h = s.useState("nestedOpenDialogCount"), g = s.useState("open"), _ = s.useState("openMethod"), v = s.useState("titleElementId"), y = s.useState("transitionStatus"), b = s.useState("role");
	Is(), rr({
		open: g,
		ref: s.context.popupRef,
		onComplete() {
			g && s.context.onOpenChangeComplete?.(!0);
		}
	});
	function x(e) {
		return e === "touch" ? s.context.popupRef.current : !0;
	}
	let S = i === void 0 ? x : i, w = Y("div", e, {
		state: {
			open: g,
			nested: m,
			transitionStatus: y,
			nestedDialogOpen: h > 0
		},
		props: [
			d,
			{
				"aria-labelledby": v ?? void 0,
				"aria-describedby": c ?? void 0,
				role: b,
				tabIndex: -1,
				hidden: !p,
				onKeyDown(e) {
					Js.has(e.key) && e.stopPropagation();
				},
				style: { [Ns.nestedDialogs]: h }
			},
			o
		],
		ref: [
			t,
			s.context.popupRef,
			s.useStateSetter("popupElement")
		],
		stateAttributesMapping: tc
	});
	return /* @__PURE__ */ (0, C.jsx)(Ms, {
		context: u,
		openInteractionType: _,
		disabled: !p,
		closeOnFocusOut: !l,
		initialFocus: S,
		returnFocus: r,
		modal: f !== !1,
		restoreFocus: "popup",
		children: w
	});
});
process.env.NODE_ENV !== "production" && (nc.displayName = "DialogPopup");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/inertValue.js
function rc(e) {
	return Rr(19) ? e : e ? "true" : void 0;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/InternalBackdrop.js
var ic = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { cutout: n, ...r } = e, i;
	if (n) {
		let e = n?.getBoundingClientRect();
		i = `polygon(
      0% 0%,
      100% 0%,
      100% 100%,
      0% 100%,
      0% 0%,
      ${e.left}px ${e.top}px,
      ${e.left}px ${e.bottom}px,
      ${e.right}px ${e.bottom}px,
      ${e.right}px ${e.top}px,
      ${e.left}px ${e.top}px
    )`;
	}
	return /* @__PURE__ */ (0, C.jsx)("div", {
		ref: t,
		role: "presentation",
		"data-base-ui-inert": "",
		...r,
		style: {
			position: "fixed",
			inset: 0,
			userSelect: "none",
			WebkitUserSelect: "none",
			clipPath: i
		}
	});
});
process.env.NODE_ENV !== "production" && (ic.displayName = "InternalBackdrop");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/dialog/portal/DialogPortal.js
var ac = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { keepMounted: n = !1, ...r } = e, { store: i } = bi(), a = i.useState("mounted"), o = i.useState("modal"), s = i.useState("open");
	return a || n ? /* @__PURE__ */ (0, C.jsx)(Fs.Provider, {
		value: n,
		children: /* @__PURE__ */ (0, C.jsxs)(Ss, {
			ref: t,
			...r,
			children: [a && o === !0 && /* @__PURE__ */ (0, C.jsx)(ic, {
				ref: i.context.internalBackdropRef,
				inert: rc(!s)
			}), e.children]
		})
	}) : null;
});
process.env.NODE_ENV !== "production" && (ac.displayName = "DialogPortal");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/alert.module.js
var oc = {
	"prism-alert-container": "_prism-alert-container_xzgez_1",
	"prism-alert-dialog": "_prism-alert-dialog_xzgez_9",
	"show-alert-dialog": "_show-alert-dialog_xzgez_1",
	"prism-alert-backdrop": "_prism-alert-backdrop_xzgez_65"
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/alert/button.js
function sc(e) {
	let t = (0, x.c)(5), { type: n, className: r, onClick: i, children: a } = e, o;
	return t[0] !== a || t[1] !== r || t[2] !== i || t[3] !== n ? (o = /* @__PURE__ */ (0, C.jsx)(xe, {
		buttonType: n,
		className: r,
		onClick: i,
		children: a
	}), t[0] = a, t[1] = r, t[2] = i, t[3] = n, t[4] = o) : o = t[4], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/alert/footer.module.js
var cc = { footer: "_footer_b34lz_1" };
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/alert/footer.js
function lc(e) {
	let t = (0, x.c)(2), { children: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)("div", {
		className: cc.footer,
		children: n
	}), t[0] = n, t[1] = r), r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/alert/illustration.module.js
var uc = { illustration: "_illustration_1azg1_1" };
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/alert/illustration.js
function dc(e) {
	let t = (0, x.c)(2), { name: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)("div", {
		className: uc.illustration,
		children: /* @__PURE__ */ (0, C.jsx)(Ce, { name: n })
	}), t[0] = n, t[1] = r), r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/alert/text.module.js
var fc = { text: "_text_1fe1f_1" };
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/alert/text.js
function pc(e) {
	let t = (0, x.c)(2), { children: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)("p", {
		className: fc.text,
		children: n
	}), t[0] = n, t[1] = r), r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/alert/title.module.js
var mc = { title: "_title_1gudr_1" };
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/alert/title.js
function hc(e) {
	let t = (0, x.c)(2), { children: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)("h1", {
		className: mc.title,
		children: n
	}), t[0] = n, t[1] = r), r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/alert.js
function gc(e) {
	let t = (0, x.c)(9), { open: n, children: r, onOpenChange: i } = e, a;
	t[0] === i ? a = t[1] : (a = (e) => {
		i?.(e);
	}, t[0] = i, t[1] = a);
	let o = a, s;
	t[2] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ (0, C.jsx)(ga, { className: oc["prism-alert-backdrop"] }), t[2] = s) : s = t[2];
	let c;
	t[3] === r ? c = t[4] : (c = /* @__PURE__ */ (0, C.jsxs)(ac, {
		className: oc["prism-alert-container"],
		children: [s, /* @__PURE__ */ (0, C.jsx)(nc, {
			"aria-modal": "true",
			className: oc["prism-alert-dialog"],
			children: r
		})]
	}), t[3] = r, t[4] = c);
	let l;
	return t[5] !== o || t[6] !== n || t[7] !== c ? (l = /* @__PURE__ */ (0, C.jsx)(ki, {
		onOpenChange: o,
		open: n,
		children: c
	}), t[5] = o, t[6] = n, t[7] = c, t[8] = l) : l = t[8], l;
}
gc.Illustration = dc, gc.Title = hc, gc.Text = pc, gc.Footer = lc, gc.Button = sc;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/badge.module.js
var _c = {
	badge: "_badge_1qe7z_1",
	"badge-neutral": "_badge-neutral_1qe7z_16",
	"badge-info": "_badge-info_1qe7z_21",
	"badge-unsafe_critical": "_badge-unsafe_critical_1qe7z_26",
	"badge-success": "_badge-success_1qe7z_31",
	"badge-danger": "_badge-danger_1qe7z_36",
	"badge-warning": "_badge-warning_1qe7z_41",
	"badge-intelligence": "_badge-intelligence_1qe7z_46",
	"badge-brand": "_badge-brand_1qe7z_51",
	"badge-small": "_badge-small_1qe7z_56"
}, vc = {
	brand: "brand",
	danger: "critical",
	info: "info",
	intelligence: "intelligence",
	neutral: "emphasis",
	success: "success",
	unsafe_critical: "default-inverse",
	warning: "warning"
};
function yc(e) {
	let t = (0, x.c)(19), n, r, i, a, o, s;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6]) : ({type: s, children: n, className: r, iconName: i, isSmall: a, ...o} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s);
	let c = s === void 0 ? "neutral" : s, l = _c[`badge-${c}`], u = a ? _c["badge-small"] : "", d = vc[c], f;
	t[7] !== r || t[8] !== u || t[9] !== l ? (f = [
		_c.badge,
		l,
		u,
		r
	].filter(Boolean), t[7] = r, t[8] = u, t[9] = l, t[10] = f) : f = t[10];
	let p = f.join(" "), m;
	t[11] !== d || t[12] !== i ? (m = i && /* @__PURE__ */ (0, C.jsx)(N, {
		color: d,
		name: i,
		size: "small"
	}), t[11] = d, t[12] = i, t[13] = m) : m = t[13];
	let h;
	return t[14] !== n || t[15] !== p || t[16] !== o || t[17] !== m ? (h = /* @__PURE__ */ (0, C.jsxs)("div", {
		className: p,
		...o,
		children: [m, n]
	}), t[14] = n, t[15] = p, t[16] = o, t[17] = m, t[18] = h) : h = t[18], h;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/constants.js
var bc = {
	info: "info",
	success: "success",
	warning: "warning",
	critical: "critical",
	intelligence: "intelligence",
	brand: "brand"
}, xc = {
	...bc,
	[bc.info]: "primary",
	[bc.intelligence]: "intelligence"
}, Sc = {
	top: "top",
	bottom: "bottom",
	island: "island"
}, Cc = {
	"prism-checkbox": "_prism-checkbox_3fxr8_1",
	"prism-checkbox__checkmark": "_prism-checkbox__checkmark_3fxr8_6",
	"prism-checkbox__icon--checked": "_prism-checkbox__icon--checked_3fxr8_30",
	"prism-checkbox__icon--indeterminate": "_prism-checkbox__icon--indeterminate_3fxr8_31",
	"prism-checkbox--error": "_prism-checkbox--error_3fxr8_46",
	"prism-checkbox--warning": "_prism-checkbox--warning_3fxr8_50",
	"prism-checkbox--secondary": "_prism-checkbox--secondary_3fxr8_174"
}, wc = /* @__PURE__ */ B(V(), 1);
function Tc(e) {
	let t = (0, x.c)(33), n, r, i, a, o, s, c, l;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8]) : ({className: n, disabled: r, isSecondary: o, isSmall: s, hasError: i, hasWarning: a, onChange: c, ...l} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l);
	let u;
	t[9] !== n || t[10] !== i || t[11] !== a || t[12] !== o || t[13] !== s ? (u = (0, wc.default)(Cc["prism-checkbox"], "text-300--regular", {
		"text-200--regular": s,
		[Cc["prism-checkbox--secondary"]]: o,
		[Cc["prism-checkbox--error"]]: i,
		[Cc["prism-checkbox--warning"]]: a
	}, n), t[9] = n, t[10] = i, t[11] = a, t[12] = o, t[13] = s, t[14] = u) : u = t[14];
	let d = u, f;
	t[15] === s ? f = t[16] : (f = (0, wc.default)(Cc["prism-checkbox__checkmark"], { [Cc["prism-checkbox__checkmark--small"]]: s }), t[15] = s, t[16] = f);
	let p = f, m;
	t[17] !== r || t[18] !== c || t[19] !== l ? (m = /* @__PURE__ */ (0, C.jsx)("input", {
		disabled: r,
		...l,
		onChange: c,
		type: "checkbox"
	}), t[17] = r, t[18] = c, t[19] = l, t[20] = m) : m = t[20];
	let h = r ? "disabled" : "default-inverse", g;
	t[21] === h ? g = t[22] : (g = /* @__PURE__ */ (0, C.jsx)("span", {
		className: Cc["prism-checkbox__icon--checked"],
		children: /* @__PURE__ */ (0, C.jsx)(N, {
			color: h,
			name: "checkmark",
			size: "small"
		})
	}), t[21] = h, t[22] = g);
	let _ = r ? "disabled" : "default-inverse", v;
	t[23] === _ ? v = t[24] : (v = /* @__PURE__ */ (0, C.jsx)("span", {
		className: Cc["prism-checkbox__icon--indeterminate"],
		children: /* @__PURE__ */ (0, C.jsx)(N, {
			color: _,
			name: "minus",
			size: "small"
		})
	}), t[23] = _, t[24] = v);
	let y;
	t[25] !== p || t[26] !== g || t[27] !== v ? (y = /* @__PURE__ */ (0, C.jsxs)("span", {
		className: p,
		children: [g, v]
	}), t[25] = p, t[26] = g, t[27] = v, t[28] = y) : y = t[28];
	let b;
	return t[29] !== d || t[30] !== m || t[31] !== y ? (b = /* @__PURE__ */ (0, C.jsxs)("div", {
		className: d,
		children: [m, y]
	}), t[29] = d, t[30] = m, t[31] = y, t[32] = b) : b = t[32], b;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner.module.js
var Ec = {
	"prism-banner": "_prism-banner_6z9p6_1",
	"prism-banner--info": "_prism-banner--info_6z9p6_10",
	"prism-banner--success": "_prism-banner--success_6z9p6_15",
	"prism-banner--warning": "_prism-banner--warning_6z9p6_20",
	"prism-banner--critical": "_prism-banner--critical_6z9p6_25",
	"prism-banner--intelligence": "_prism-banner--intelligence_6z9p6_30",
	"prism-banner--brand": "_prism-banner--brand_6z9p6_35",
	"prism-banner--island": "_prism-banner--island_6z9p6_40",
	"prism-banner--top": "_prism-banner--top_6z9p6_44",
	"prism-banner--bottom": "_prism-banner--bottom_6z9p6_48",
	"prism-banner--full-width": "_prism-banner--full-width_6z9p6_52",
	"prism-banner__inner": "_prism-banner__inner_6z9p6_56"
}, Dc = (0, S.createContext)(void 0), Oc = () => {
	let e = (0, S.useContext)(Dc);
	if (!e) throw Error("useBannerContext must be used within a BannerProvider");
	return e;
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/button.js
function kc(e) {
	let t = (0, x.c)(8), { buttonType: n, iconAfter: r, iconBefore: i, disabled: a, onClick: o, children: s } = e, { isLoading: c, bannerStyle: l } = Oc(), u = n ?? xc[l ?? "info"], d;
	return t[0] !== s || t[1] !== a || t[2] !== r || t[3] !== i || t[4] !== c || t[5] !== o || t[6] !== u ? (d = /* @__PURE__ */ (0, C.jsx)(xe, {
		buttonType: u,
		iconAfter: r,
		iconBefore: i,
		isDisabled: a,
		isLoading: c,
		onClick: o,
		children: s
	}), t[0] = s, t[1] = a, t[2] = r, t[3] = i, t[4] = c, t[5] = o, t[6] = u, t[7] = d) : d = t[7], d;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/checkbox.module.js
var Ac = {
	"banner-checkbox": "_banner-checkbox_19dyo_1",
	"banner-checkbox__label": "_banner-checkbox__label_19dyo_6"
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/checkbox.js
function jc(e) {
	let t = (0, x.c)(9), { checked: n, disabled: r, onChange: i, children: a } = e, o;
	t[0] !== n || t[1] !== r || t[2] !== i ? (o = /* @__PURE__ */ (0, C.jsx)(Tc, {
		checked: n,
		disabled: r,
		onChange: i
	}), t[0] = n, t[1] = r, t[2] = i, t[3] = o) : o = t[3];
	let s;
	t[4] === a ? s = t[5] : (s = /* @__PURE__ */ (0, C.jsx)("span", {
		className: `${Ac["banner-checkbox__label"]} text-300--regular`,
		children: a
	}), t[4] = a, t[5] = s);
	let c;
	return t[6] !== o || t[7] !== s ? (c = /* @__PURE__ */ (0, C.jsxs)("label", {
		className: Ac["banner-checkbox"],
		children: [o, s]
	}), t[6] = o, t[7] = s, t[8] = c) : c = t[8], c;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/close-button.module.js
var Mc = {
	"close-btn": "_close-btn_1eez8_1",
	"close-btn--full-width": "_close-btn--full-width_1eez8_6"
}, Nc = /* @__PURE__ */ B(V(), 1);
function Pc(e) {
	let t = (0, x.c)(5), { onClick: n } = e, { fullWidth: r } = Oc(), i;
	t[0] === r ? i = t[1] : (i = (0, Nc.default)(Mc["close-btn"], { [Mc["close-btn--full-width"]]: r }), t[0] = r, t[1] = i);
	let a = i, o;
	return t[2] !== a || t[3] !== n ? (o = /* @__PURE__ */ (0, C.jsx)(xe, {
		"aria-label": "Close",
		buttonType: "ghost",
		className: a,
		icon: "cross",
		onClick: n,
		size: "small"
	}), t[2] = a, t[3] = n, t[4] = o) : o = t[4], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/content.module.js
var Fc = {
	content: "_content_v9oqs_1",
	"content--full-width": "_content--full-width_v9oqs_9"
}, Ic = /* @__PURE__ */ B(V(), 1);
function Lc(e) {
	let t = (0, x.c)(5), { children: n } = e, { fullWidth: r } = Oc(), i;
	t[0] === r ? i = t[1] : (i = (0, Ic.default)(Fc.content, { [Fc["content--full-width"]]: r }), t[0] = r, t[1] = i);
	let a = i, o;
	return t[2] !== n || t[3] !== a ? (o = /* @__PURE__ */ (0, C.jsx)("div", {
		className: a,
		children: n
	}), t[2] = n, t[3] = a, t[4] = o) : o = t[4], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/content-text.module.js
var Rc = {
	"content-text": "_content-text_18zyj_1",
	"content-text--full-width": "_content-text--full-width_18zyj_8"
}, zc = /* @__PURE__ */ B(V(), 1);
function Bc(e) {
	let t = (0, x.c)(5), { children: n } = e, { fullWidth: r } = Oc(), i;
	t[0] === r ? i = t[1] : (i = (0, zc.default)(Rc["content-text"], { [Rc["content-text--full-width"]]: r }), t[0] = r, t[1] = i);
	let a = i, o;
	return t[2] !== n || t[3] !== a ? (o = /* @__PURE__ */ (0, C.jsx)("div", {
		className: a,
		children: n
	}), t[2] = n, t[3] = a, t[4] = o) : o = t[4], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/footer.module.js
var Vc = {
	footer: "_footer_18ioq_1",
	"footer--full-width": "_footer--full-width_18ioq_7"
}, Hc = /* @__PURE__ */ B(V(), 1);
function Uc(e) {
	let t = (0, x.c)(5), { children: n } = e, { fullWidth: r } = Oc(), i;
	t[0] === r ? i = t[1] : (i = (0, Hc.default)(Vc.footer, { [Vc["footer--full-width"]]: r }), t[0] = r, t[1] = i);
	let a = i, o;
	return t[2] !== n || t[3] !== a ? (o = /* @__PURE__ */ (0, C.jsx)("footer", {
		className: a,
		children: n
	}), t[2] = n, t[3] = a, t[4] = o) : o = t[4], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/icon.module.js
var Wc = {
	icon: "_icon_q42l2_1",
	"icon-fullwidth": "_icon-fullwidth_q42l2_7"
}, Gc = /* @__PURE__ */ B(V(), 1);
function Kc(e) {
	let t = (0, x.c)(9), { icon: n } = e, { fullWidth: r, isLoading: i, bannerStyle: a } = Oc(), o;
	t[0] === r ? o = t[1] : (o = (0, Gc.default)(Wc.icon, { [Wc["icon-fullwidth"]]: r }), t[0] = r, t[1] = o);
	let s = o, c;
	t[2] !== a || t[3] !== n || t[4] !== s || t[5] !== i ? (c = i ? /* @__PURE__ */ (0, C.jsx)("div", {
		className: s,
		children: /* @__PURE__ */ (0, C.jsx)(_e, {
			"aria-hidden": "true",
			color: a,
			size: "medium"
		})
	}) : n ? /* @__PURE__ */ (0, C.jsx)("div", {
		className: s,
		children: /* @__PURE__ */ (0, C.jsx)(N, {
			"aria-hidden": "true",
			color: a,
			name: n,
			size: "medium"
		})
	}) : null, t[2] = a, t[3] = n, t[4] = s, t[5] = i, t[6] = c) : c = t[6];
	let l;
	return t[7] === c ? l = t[8] : (l = /* @__PURE__ */ (0, C.jsx)(C.Fragment, { children: c }), t[7] = c, t[8] = l), l;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/link.js
var qc = /* @__PURE__ */ B(V(), 1);
function Jc(e) {
	let t = (0, x.c)(20), n, r, i, a, o, s, c;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7]) : ({children: n, rel: s, target: c, href: i, icon: a, className: r, ...o} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c);
	let l = s === void 0 ? "noopener noreferrer" : s, u = c === void 0 ? "_blank" : c, d;
	t[8] === r ? d = t[9] : (d = (0, qc.default)("prism-link", "prism-link--secondary", r), t[8] = r, t[9] = d);
	let f = d, p;
	t[10] === a ? p = t[11] : (p = a && /* @__PURE__ */ (0, C.jsx)(N, {
		"aria-hidden": "true",
		color: "inherit",
		name: "link-out",
		size: "small"
	}), t[10] = a, t[11] = p);
	let m;
	return t[12] !== n || t[13] !== f || t[14] !== i || t[15] !== l || t[16] !== o || t[17] !== p || t[18] !== u ? (m = /* @__PURE__ */ (0, C.jsxs)("a", {
		className: f,
		href: i,
		rel: l,
		target: u,
		...o,
		children: [n, p]
	}), t[12] = n, t[13] = f, t[14] = i, t[15] = l, t[16] = o, t[17] = p, t[18] = u, t[19] = m) : m = t[19], m;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/link-button.module.js
var Yc = { "link-button": "_link-button_1yat2_1" }, Xc = /* @__PURE__ */ B(V(), 1);
function Zc(e) {
	let t = (0, x.c)(16), n, r, i, a, o;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5]) : ({children: n, onClick: a, icon: i, className: r, ...o} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o);
	let s;
	t[6] === r ? s = t[7] : (s = (0, Xc.default)(Yc["link-button"], "prism-link", "prism-link--secondary", "text-300--regular", r), t[6] = r, t[7] = s);
	let c = s, l;
	t[8] === i ? l = t[9] : (l = i && /* @__PURE__ */ (0, C.jsx)(N, {
		"aria-hidden": "true",
		color: "inherit",
		name: "link-out",
		size: "small"
	}), t[8] = i, t[9] = l);
	let u;
	return t[10] !== n || t[11] !== c || t[12] !== a || t[13] !== o || t[14] !== l ? (u = /* @__PURE__ */ (0, C.jsxs)("button", {
		className: c,
		onClick: a,
		tabIndex: 0,
		...o,
		children: [n, l]
	}), t[10] = n, t[11] = c, t[12] = a, t[13] = o, t[14] = l, t[15] = u) : u = t[15], u;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/message.js
function Qc(e) {
	let t = (0, x.c)(2), { children: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)("p", {
		className: "text-300--regular",
		children: n
	}), t[0] = n, t[1] = r), r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner/title.module.js
var $c = {
	title: "_title_rjc9u_1",
	"title--info": "_title--info_rjc9u_7",
	"title--success": "_title--success_rjc9u_11",
	"title--warning": "_title--warning_rjc9u_15",
	"title--critical": "_title--critical_rjc9u_19",
	"title--intelligence": "_title--intelligence_rjc9u_23",
	"title--brand": "_title--brand_rjc9u_27"
}, el = /* @__PURE__ */ B(V(), 1), tl = {
	info: "title--info",
	success: "title--success",
	warning: "title--warning",
	critical: "title--critical",
	intelligence: "title--intelligence",
	brand: "title--brand"
};
function nl(e) {
	let t = (0, x.c)(5), { children: n } = e, { bannerStyle: r } = Oc(), i = $c[tl[r] ?? tl.info], a;
	t[0] === i ? a = t[1] : (a = (0, el.default)($c.title, i), t[0] = i, t[1] = a);
	let o = a, s;
	return t[2] !== n || t[3] !== o ? (s = /* @__PURE__ */ (0, C.jsx)("h2", {
		className: o,
		children: n
	}), t[2] = n, t[3] = o, t[4] = s) : s = t[4], s;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/banner.js
var rl = /* @__PURE__ */ B(V(), 1), il = {
	info: "prism-banner--info",
	success: "prism-banner--success",
	warning: "prism-banner--warning",
	critical: "prism-banner--critical",
	intelligence: "prism-banner--intelligence",
	brand: "prism-banner--brand"
}, al = {
	top: "prism-banner--top",
	bottom: "prism-banner--bottom",
	island: "prism-banner--island"
};
function ol(e) {
	let t = (0, x.c)(26), n, r, i, a, o, s, c;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7]) : ({bannerStyle: s, isLoading: i, isOneLine: a, position: c, children: n, className: r, ...o} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c);
	let l = s === void 0 ? bc.info : s, u = c === void 0 ? Sc.top : c, d = !a, f = Ec[il[l] ?? il.info], p = Ec[al[u] ?? al.top], m;
	t[8] !== r || t[9] !== d || t[10] !== f || t[11] !== p ? (m = (0, rl.default)(Ec["prism-banner"], f, p, { [Ec["prism-banner--full-width"]]: d }, r), t[8] = r, t[9] = d, t[10] = f, t[11] = p, t[12] = m) : m = t[12];
	let h = m, g;
	t[13] !== l || t[14] !== d || t[15] !== i ? (g = {
		bannerStyle: l,
		fullWidth: d,
		isLoading: i
	}, t[13] = l, t[14] = d, t[15] = i, t[16] = g) : g = t[16];
	let _;
	t[17] === n ? _ = t[18] : (_ = /* @__PURE__ */ (0, C.jsx)("div", {
		className: Ec["prism-banner__inner"],
		children: n
	}), t[17] = n, t[18] = _);
	let v;
	t[19] !== h || t[20] !== o || t[21] !== _ ? (v = /* @__PURE__ */ (0, C.jsx)("section", {
		className: h,
		...o,
		children: _
	}), t[19] = h, t[20] = o, t[21] = _, t[22] = v) : v = t[22];
	let y;
	return t[23] !== g || t[24] !== v ? (y = /* @__PURE__ */ (0, C.jsx)(Dc.Provider, {
		value: g,
		children: v
	}), t[23] = g, t[24] = v, t[25] = y) : y = t[25], y;
}
ol.Button = kc, ol.CloseButton = Pc, ol.Checkbox = jc, ol.Content = Lc, ol.ContentText = Bc, ol.Footer = Uc, ol.Icon = Kc, ol.Message = Qc, ol.Link = Jc, ol.LinkButton = Zc, ol.Title = nl;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/breadcrumb.module.js
var sl = { "prism-breadcrumb__list": "_prism-breadcrumb__list_hicci_1" }, cl = {
	"prism-breadcrumb__item": "_prism-breadcrumb__item_fxeyc_1",
	"prism-breadcrumb__label": "_prism-breadcrumb__label_fxeyc_20",
	"prism-breadcrumb__label--current": "_prism-breadcrumb__label--current_fxeyc_32"
}, ll = /* @__PURE__ */ B(V(), 1);
function ul(e) {
	let t = (0, x.c)(17), n, r, i, a;
	if (t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({isCurrent: i, children: n, className: r, ...a} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a), i) {
		let e;
		t[5] === r ? e = t[6] : (e = (0, ll.default)(cl["prism-breadcrumb__label"], cl["prism-breadcrumb__label--current"], r), t[5] = r, t[6] = e);
		let i;
		return t[7] !== n || t[8] !== a || t[9] !== e ? (i = /* @__PURE__ */ (0, C.jsx)("li", {
			className: cl["prism-breadcrumb__item"],
			children: /* @__PURE__ */ (0, C.jsx)("span", {
				"aria-current": "page",
				className: e,
				...a,
				children: n
			})
		}), t[7] = n, t[8] = a, t[9] = e, t[10] = i) : i = t[10], i;
	}
	let o;
	t[11] === r ? o = t[12] : (o = (0, ll.default)(cl["prism-breadcrumb__label"], "prism-link", "prism-link--secondary", "prism-link--standalone", r), t[11] = r, t[12] = o);
	let s;
	return t[13] !== n || t[14] !== a || t[15] !== o ? (s = /* @__PURE__ */ (0, C.jsx)("li", {
		className: cl["prism-breadcrumb__item"],
		children: /* @__PURE__ */ (0, C.jsx)("a", {
			className: o,
			...a,
			children: n
		})
	}), t[13] = n, t[14] = a, t[15] = o, t[16] = s) : s = t[16], s;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/breadcrumb.js
function dl(e) {
	let t = (0, x.c)(10), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({children: n, className: r, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a;
	t[4] === n ? a = t[5] : (a = /* @__PURE__ */ (0, C.jsx)("ol", {
		className: sl["prism-breadcrumb__list"],
		children: n
	}), t[4] = n, t[5] = a);
	let o;
	return t[6] !== r || t[7] !== i || t[8] !== a ? (o = /* @__PURE__ */ (0, C.jsx)("nav", {
		"aria-label": "Breadcrumb",
		className: r,
		...i,
		children: a
	}), t[6] = r, t[7] = i, t[8] = a, t[9] = o) : o = t[9], o;
}
dl.Item = ul;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/button-group.module.js
var fl = {
	"prism-button-group": "_prism-button-group_1ufq0_1",
	"prism-button-group--checkbox": "_prism-button-group--checkbox_1ufq0_6"
}, pl = (0, S.createContext)(void 0);
function ml() {
	let e = (0, S.useContext)(pl);
	if (e === void 0) throw Error("useButtonGroupContext must be used within a ButtonGroup parent component");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/button-group/button.module.js
var hl = {
	button: "_button_19kwt_1",
	active: "_active_19kwt_29",
	checkbox: "_checkbox_19kwt_41"
}, gl = /* @__PURE__ */ B(V(), 1), _l = (e, t, n) => e ? t ? e.includes(n) : n === e : !1;
function vl(e) {
	let t = (0, x.c)(25), n, r, i, a;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({iconBefore: r, value: a, children: n, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a);
	let { checkedValue: o, onChange: s, isDisabled: c, isSmall: l } = ml(), u = Array.isArray(o), d, f, p;
	if (t[5] !== o || t[6] !== u || t[7] !== s || t[8] !== a) {
		d = _l(o, u, a);
		let e;
		t[12] !== s || t[13] !== a ? (e = () => {
			s(a);
		}, t[12] = s, t[13] = a, t[14] = e) : e = t[14], f = e, p = (0, gl.default)(hl.button, {
			[hl.active]: d,
			[hl.checkbox]: u
		}), t[5] = o, t[6] = u, t[7] = s, t[8] = a, t[9] = d, t[10] = f, t[11] = p;
	} else d = t[9], f = t[10], p = t[11];
	let m = p, h = d ? "true" : "false", g = d ? "primary" : "secondary", _ = l ? "small" : "medium", v;
	return t[15] !== m || t[16] !== n || t[17] !== f || t[18] !== r || t[19] !== c || t[20] !== i || t[21] !== h || t[22] !== g || t[23] !== _ ? (v = /* @__PURE__ */ (0, C.jsx)(xe, {
		"aria-pressed": h,
		buttonType: g,
		className: m,
		iconBefore: r,
		isDisabled: c,
		onClick: f,
		size: _,
		...i,
		children: n
	}), t[15] = m, t[16] = n, t[17] = f, t[18] = r, t[19] = c, t[20] = i, t[21] = h, t[22] = g, t[23] = _, t[24] = v) : v = t[24], v;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/button-group.js
var yl = /* @__PURE__ */ B(V(), 1);
function bl(e) {
	let t = (0, x.c)(28), n, r, i, a, o, s, c;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7]) : ({isDisabled: o, isSmall: s, onChange: i, value: c, children: n, className: r, ...a} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c);
	let l = o === void 0 ? !1 : o, u = s === void 0 ? !1 : s, d = Array.isArray(c), f = d ? "group" : "radiogroup", p;
	t[8] !== d || t[9] !== i || t[10] !== c ? (p = (e) => {
		if (d) {
			let t = c;
			t.includes(e) ? i(t.filter((t) => t !== e)) : i([...t, e]);
		} else e !== c && i(e);
	}, t[8] = d, t[9] = i, t[10] = c, t[11] = p) : p = t[11];
	let m = p, h;
	t[12] !== r || t[13] !== d ? (h = (0, yl.default)({ [fl["prism-button-group--checkbox"]]: d }, fl["prism-button-group"], r), t[12] = r, t[13] = d, t[14] = h) : h = t[14];
	let g = h, _;
	t[15] !== m || t[16] !== l || t[17] !== u || t[18] !== c ? (_ = {
		isDisabled: l,
		isSmall: u,
		onChange: m,
		checkedValue: c
	}, t[15] = m, t[16] = l, t[17] = u, t[18] = c, t[19] = _) : _ = t[19];
	let v;
	t[20] !== n || t[21] !== _ ? (v = /* @__PURE__ */ (0, C.jsx)(pl, {
		value: _,
		children: n
	}), t[20] = n, t[21] = _, t[22] = v) : v = t[22];
	let y;
	return t[23] !== g || t[24] !== a || t[25] !== f || t[26] !== v ? (y = /* @__PURE__ */ (0, C.jsx)("div", {
		className: g,
		role: f,
		...a,
		children: v
	}), t[23] = g, t[24] = a, t[25] = f, t[26] = v, t[27] = y) : y = t[27], y;
}
bl.Button = vl;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/card.module.js
var xl = {
	"prism-card": "_prism-card_179ee_1",
	"prism-card__header": "_prism-card__header_179ee_10",
	"prism-card__header--border": "_prism-card__header--border_179ee_18",
	"prism-card-title": "_prism-card-title_179ee_22",
	"prism-card-title--disabled": "_prism-card-title--disabled_179ee_27",
	"prism-card__header__after": "_prism-card__header__after_179ee_31",
	"prism-card__content": "_prism-card__content_179ee_36",
	"prism-card__content--default-padding": "_prism-card__content--default-padding_179ee_41",
	"prism-card__footer": "_prism-card__footer_179ee_46",
	"prism-card--secondary": "_prism-card--secondary_179ee_52",
	"prism-card--parent": "_prism-card--parent_179ee_80"
}, Sl = (0, S.createContext)(void 0);
function Cl() {
	let e = (0, S.useContext)(Sl);
	if (e === void 0) throw Error("useCardContext must be used within a Card parent component");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/card/content.js
var wl = /* @__PURE__ */ B(V(), 1);
function Tl(e) {
	let t = (0, x.c)(9), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let { hasPadding: i } = Cl(), a;
	t[3] !== n || t[4] !== i ? (a = (0, wl.default)(xl["prism-card__content"], { [xl["prism-card__content--default-padding"]]: i }, n), t[3] = n, t[4] = i, t[5] = a) : a = t[5];
	let o = a, s;
	return t[6] !== o || t[7] !== r ? (s = /* @__PURE__ */ (0, C.jsx)("div", {
		className: o,
		...r
	}), t[6] = o, t[7] = r, t[8] = s) : s = t[8], s;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/card/footer.js
var El = /* @__PURE__ */ B(V(), 1);
function Dl(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, El.default)(xl["prism-card__footer"], n), t[3] = n, t[4] = i);
	let a = i, o;
	return t[5] !== a || t[6] !== r ? (o = /* @__PURE__ */ (0, C.jsx)("footer", {
		className: a,
		...r
	}), t[5] = a, t[6] = r, t[7] = o) : o = t[7], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/card/header/after.js
var Ol = /* @__PURE__ */ B(V(), 1);
function kl(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, Ol.default)(xl["prism-card__header__after"], n), t[3] = n, t[4] = i);
	let a = i, o;
	return t[5] !== a || t[6] !== r ? (o = /* @__PURE__ */ (0, C.jsx)("div", {
		className: a,
		...r
	}), t[5] = a, t[6] = r, t[7] = o) : o = t[7], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/card/header/title.js
var Al = /* @__PURE__ */ B(V(), 1);
function jl(e) {
	let t = (0, x.c)(7), { children: n, disabled: r, className: i } = e, { isSecondary: a } = Cl(), o;
	t[0] !== i || t[1] !== r ? (o = (0, Al.default)(xl["prism-card-title"], { [xl["prism-card-title--disabled"]]: r }, i), t[0] = i, t[1] = r, t[2] = o) : o = t[2];
	let s = o, c = a ? "h4" : "h3", l;
	return t[3] !== c || t[4] !== n || t[5] !== s ? (l = /* @__PURE__ */ (0, C.jsx)(c, {
		className: s,
		children: n
	}), t[3] = c, t[4] = n, t[5] = s, t[6] = l) : l = t[6], l;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/card/header.js
var Ml = /* @__PURE__ */ B(V(), 1);
function Nl(e) {
	let t = (0, x.c)(10), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({hasBorder: r, className: n, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i), Cl();
	let a;
	t[4] !== n || t[5] !== r ? (a = (0, Ml.default)(xl["prism-card__header"], { [xl["prism-card__header--border"]]: r }, n), t[4] = n, t[5] = r, t[6] = a) : a = t[6];
	let o = a, s;
	return t[7] !== o || t[8] !== i ? (s = /* @__PURE__ */ (0, C.jsx)("header", {
		className: o,
		...i
	}), t[7] = o, t[8] = i, t[9] = s) : s = t[9], s;
}
Nl.Title = jl, Nl.After = kl;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/card.js
var Pl = /* @__PURE__ */ B(V(), 1);
function Fl(e) {
	let t = (0, x.c)(21), n, r, i, a, o, s;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6]) : ({hasPadding: s, isParent: i, isSecondary: a, className: r, children: n, ...o} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s);
	let c = s === void 0 ? !0 : s, l;
	t[7] !== r || t[8] !== i || t[9] !== a ? (l = (0, Pl.default)(xl["prism-card"], {
		[xl["prism-card--secondary"]]: a,
		[xl["prism-card--parent"]]: i
	}, r), t[7] = r, t[8] = i, t[9] = a, t[10] = l) : l = t[10];
	let u = l, d;
	t[11] !== c || t[12] !== a ? (d = {
		hasPadding: c,
		isSecondary: a
	}, t[11] = c, t[12] = a, t[13] = d) : d = t[13];
	let f;
	t[14] !== n || t[15] !== d ? (f = /* @__PURE__ */ (0, C.jsx)(Sl, {
		value: d,
		children: n
	}), t[14] = n, t[15] = d, t[16] = f) : f = t[16];
	let p;
	return t[17] !== u || t[18] !== o || t[19] !== f ? (p = /* @__PURE__ */ (0, C.jsx)("article", {
		className: u,
		...o,
		children: f
	}), t[17] = u, t[18] = o, t[19] = f, t[20] = p) : p = t[20], p;
}
Fl.Header = Nl, Fl.Content = Tl, Fl.Footer = Dl;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/useBaseUiId.js
function Il(e) {
	return Mn(e, "base-ui");
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/useControlled.js
function Ll({ controlled: e, default: t, name: n, state: r = "value" }) {
	let { current: i } = S.useRef(e !== void 0), [a, o] = S.useState(t), s = i ? e : a;
	if (process.env.NODE_ENV !== "production") {
		S.useEffect(() => {
			i !== (e !== void 0) && console.error([
				`Base UI: A component is changing the ${i ? "" : "un"}controlled ${r} state of ${n} to be ${i ? "un" : ""}controlled.`,
				"Elements should not switch from uncontrolled to controlled (or vice versa).",
				`Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`,
				"The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",
				"More info: https://fb.me/react-controlled-components"
			].join("\n"));
		}, [
			r,
			n,
			e
		]);
		let { current: a } = S.useRef(t);
		S.useEffect(() => {
			!i && JSON.stringify(a) !== JSON.stringify(t) && console.error([`Base UI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join("\n"));
		}, [JSON.stringify(t)]);
	}
	return [s, S.useCallback((e) => {
		i || o(e);
	}, [])];
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/checkbox-group/CheckboxGroupContext.js
var Rl = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Rl.displayName = "CheckboxGroupContext");
function zl(e = !0) {
	let t = S.useContext(Rl);
	if (t === void 0 && !e) throw Error(process.env.NODE_ENV === "production" ? lr(3) : "Base UI: CheckboxGroupContext is missing. CheckboxGroup parts must be placed within <CheckboxGroup>.");
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/field/control/FieldControlDataAttributes.js
var Bl = /* @__PURE__ */ function(e) {
	return e.disabled = "data-disabled", e.valid = "data-valid", e.invalid = "data-invalid", e.touched = "data-touched", e.dirty = "data-dirty", e.filled = "data-filled", e.focused = "data-focused", e;
}({}), Vl = {
	badInput: !1,
	customError: !1,
	patternMismatch: !1,
	rangeOverflow: !1,
	rangeUnderflow: !1,
	stepMismatch: !1,
	tooLong: !1,
	tooShort: !1,
	typeMismatch: !1,
	valid: null,
	valueMissing: !1
}, Hl = {
	valid: null,
	touched: !1,
	dirty: !1,
	filled: !1,
	focused: !1
}, Ul = {
	disabled: !1,
	...Hl
}, Wl = { valid(e) {
	return e === null ? null : e ? { [Bl.valid]: "" } : { [Bl.invalid]: "" };
} }, Gl = /* @__PURE__ */ S.createContext({
	invalid: void 0,
	name: void 0,
	validityData: {
		state: Vl,
		errors: [],
		error: "",
		value: "",
		initialValue: null
	},
	setValidityData: Et,
	disabled: void 0,
	touched: Hl.touched,
	setTouched: Et,
	dirty: Hl.dirty,
	setDirty: Et,
	filled: Hl.filled,
	setFilled: Et,
	focused: Hl.focused,
	setFocused: Et,
	validate: () => null,
	validationMode: "onSubmit",
	validationDebounceTime: 0,
	shouldValidateOnChange: () => !1,
	state: Ul,
	markedDirtyRef: { current: !1 },
	validation: {
		getValidationProps: (e = Ot) => e,
		getInputValidationProps: (e = Ot) => e,
		inputRef: { current: null },
		commit: async () => {}
	}
});
process.env.NODE_ENV !== "production" && (Gl.displayName = "FieldRootContext");
function Kl(e = !0) {
	let t = S.useContext(Gl);
	if (t.setValidityData === Et && !e) throw Error(process.env.NODE_ENV === "production" ? lr(28) : "Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>.");
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/labelable-provider/LabelableContext.js
var ql = /* @__PURE__ */ S.createContext({
	controlId: void 0,
	registerControlId: Et,
	labelId: void 0,
	setLabelId: Et,
	messageIds: [],
	setMessageIds: Et,
	getDescriptionProps: (e) => e
});
process.env.NODE_ENV !== "production" && (ql.displayName = "LabelableContext");
function Jl() {
	return S.useContext(ql);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/form/FormContext.js
var Yl = /* @__PURE__ */ S.createContext({
	formRef: { current: { fields: /* @__PURE__ */ new Map() } },
	errors: {},
	clearErrors: Et,
	validationMode: "onSubmit",
	submitAttemptedRef: { current: !1 }
});
process.env.NODE_ENV !== "production" && (Yl.displayName = "FormContext");
function Xl() {
	return S.useContext(Yl);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/field/utils/getCombinedFieldValidityData.js
function Zl(e, t) {
	return {
		...e,
		state: {
			...e.state,
			valid: !t && e.state.valid
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/field/useField.js
function Ql(e) {
	let { enabled: t = !0, value: n, id: r, name: i, controlRef: a, commit: o } = e, { formRef: s } = Xl(), { invalid: c, markedDirtyRef: l, validityData: u, setValidityData: d } = Kl(), f = U(e.getValue);
	W(() => {
		if (!t) return;
		let e = n;
		e === void 0 && (e = f()), u.initialValue === null && e !== null && d((t) => ({
			...t,
			initialValue: e
		}));
	}, [
		t,
		d,
		n,
		u.initialValue,
		f
	]), W(() => {
		!t || !r || s.current.fields.set(r, {
			getValue: f,
			name: i,
			controlRef: a,
			validityData: Zl(u, c),
			validate(e = !0) {
				let t = n;
				t === void 0 && (t = f()), l.current = !0, e ? tr.flushSync(() => o(t)) : o(t);
			}
		});
	}, [
		o,
		a,
		t,
		s,
		f,
		r,
		c,
		l,
		i,
		u,
		n
	]), W(() => {
		let e = s.current.fields;
		return () => {
			r && e.delete(r);
		};
	}, [s, r]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/error.js
var $l;
process.env.NODE_ENV !== "production" && ($l = /* @__PURE__ */ new Set());
function eu(...e) {
	if (process.env.NODE_ENV !== "production") {
		let t = e.join(" ");
		$l.has(t) || ($l.add(t), console.error(`Base UI: ${t}`));
	}
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/composite/root/CompositeRootContext.js
var tu = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (tu.displayName = "CompositeRootContext");
function nu(e = !1) {
	let t = S.useContext(tu);
	if (t === void 0 && !e) throw Error(process.env.NODE_ENV === "production" ? lr(16) : "Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>.");
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/useFocusableWhenDisabled.js
function ru(e) {
	let { focusableWhenDisabled: t, disabled: n, composite: r = !1, tabIndex: i = 0, isNativeButton: a } = e, o = r && t !== !1, s = r && t === !1;
	return { props: S.useMemo(() => {
		let e = { onKeyDown(e) {
			n && t && e.key !== "Tab" && e.preventDefault();
		} };
		return r || (e.tabIndex = i, !a && n && (e.tabIndex = t ? i : -1)), (a && (t || o) || !a && n) && (e["aria-disabled"] = n), a && (!t || s) && (e.disabled = n), e;
	}, [
		r,
		n,
		t,
		o,
		s,
		a,
		i
	]) };
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/use-button/useButton.js
function iu(e = {}) {
	let { disabled: t = !1, focusableWhenDisabled: n, tabIndex: r = 0, native: i = !0, composite: a } = e, o = S.useRef(null), s = nu(!0), c = a ?? s !== void 0, { props: l } = ru({
		focusableWhenDisabled: n,
		disabled: t,
		composite: c,
		tabIndex: r,
		isNativeButton: i
	});
	process.env.NODE_ENV !== "production" && S.useEffect(() => {
		if (!o.current) return;
		let e = au(o.current);
		i ? e || eu(`A component that acts as a button expected a native <button> because the \`nativeButton\` prop is true. Rendering a non-<button> removes native button semantics, which can impact forms and accessibility. Use a real <button> in the \`render\` prop, or set \`nativeButton\` to \`false\`.${On.captureOwnerStack?.() || ""}`) : e && eu(`A component that acts as a button expected a non-<button> because the \`nativeButton\` prop is false. Rendering a <button> keeps native behavior while Base UI applies non-native attributes and handlers, which can add unintended extra attributes (such as \`role\` or \`aria-disabled\`). Use a non-<button> in the \`render\` prop, or set \`nativeButton\` to \`true\`.${On.captureOwnerStack?.() || ""}`);
	}, [i]);
	let u = S.useCallback(() => {
		let e = o.current;
		au(e) && c && t && l.disabled === void 0 && e.disabled && (e.disabled = !1);
	}, [
		t,
		l.disabled,
		c
	]);
	return W(u, [u]), {
		getButtonProps: S.useCallback((e = {}) => {
			let { onClick: n, onMouseDown: r, onKeyUp: a, onKeyDown: o, onPointerDown: s, ...u } = e;
			return Wi({
				type: i ? "button" : void 0,
				onClick(e) {
					if (t) {
						e.preventDefault();
						return;
					}
					n?.(e);
				},
				onMouseDown(e) {
					t || r?.(e);
				},
				onKeyDown(e) {
					if (t || (Qi(e), o?.(e), e.baseUIHandlerPrevented)) return;
					let r = e.target === e.currentTarget, a = e.currentTarget, s = au(a), l = !i && ou(a), u = r && (i ? s : !l), d = e.key === "Enter", f = e.key === " ", p = a.getAttribute("role"), m = p?.startsWith("menuitem") || p === "option" || p === "gridcell";
					if (r && c && f) {
						if (e.defaultPrevented && m) return;
						e.preventDefault(), l || i && s ? (a.click(), e.preventBaseUIHandler()) : u && (n?.(e), e.preventBaseUIHandler());
						return;
					}
					u && (!i && (f || d) && e.preventDefault(), !i && d && n?.(e));
				},
				onKeyUp(e) {
					if (!t) {
						if (Qi(e), a?.(e), e.target === e.currentTarget && i && c && au(e.currentTarget) && e.key === " ") {
							e.preventDefault();
							return;
						}
						e.baseUIHandlerPrevented || e.target === e.currentTarget && !i && !c && e.key === " " && n?.(e);
					}
				},
				onPointerDown(e) {
					if (t) {
						e.preventDefault();
						return;
					}
					s?.(e);
				}
			}, i ? void 0 : { role: "button" }, l, u);
		}, [
			t,
			l,
			c,
			i
		]),
		buttonRef: U((e) => {
			o.current = e, u();
		})
	};
}
function au(e) {
	return Ie(e) && e.tagName === "BUTTON";
}
function ou(e) {
	return !!(e?.tagName === "A" && e?.href);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/checkbox/root/CheckboxRootDataAttributes.js
var su = /* @__PURE__ */ function(e) {
	return e.checked = "data-checked", e.unchecked = "data-unchecked", e.indeterminate = "data-indeterminate", e.disabled = "data-disabled", e.readonly = "data-readonly", e.required = "data-required", e.valid = "data-valid", e.invalid = "data-invalid", e.touched = "data-touched", e.dirty = "data-dirty", e.filled = "data-filled", e.focused = "data-focused", e;
}({});
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/checkbox/utils/useStateAttributesMapping.js
function cu(e) {
	return S.useMemo(() => ({
		checked(t) {
			return e.indeterminate ? {} : t ? { [su.checked]: "" } : { [su.unchecked]: "" };
		},
		...Wl
	}), [e.indeterminate]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/field/item/FieldItemContext.js
var lu = /* @__PURE__ */ S.createContext({ disabled: !1 });
process.env.NODE_ENV !== "production" && (lu.displayName = "FieldItemContext");
function uu() {
	return S.useContext(lu);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/labelable-provider/useAriaLabelledBy.js
function du(e, t, n, r = !0, i) {
	let [a, o] = S.useState(), s = Il(i ? `${i}-label` : void 0), c = e ?? t ?? a;
	return W(() => {
		let i = e || t || !r ? void 0 : fu(n.current, s);
		a !== i && o(i);
	}), c;
}
function fu(e, t) {
	let n = pu(e);
	if (n) return !n.id && t && (n.id = t), n.id || void 0;
}
function pu(e) {
	if (!e) return;
	let t = e.parentElement;
	if (t && t.tagName === "LABEL") return t;
	let n = e.id;
	if (n) {
		let t = e.nextElementSibling;
		if (t && t.htmlFor === n) return t;
	}
	let r = e.labels;
	return r && r[0];
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/checkbox/root/CheckboxRootContext.js
var mu = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (mu.displayName = "CheckboxRootContext");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/checkbox/root/CheckboxRoot.js
var hu = "data-parent", gu = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { checked: n, className: r, defaultChecked: i = !1, "aria-labelledby": a, disabled: o = !1, id: s, indeterminate: c = !1, inputRef: l, name: u, onCheckedChange: d, parent: f = !1, readOnly: p = !1, render: m, required: h = !1, uncheckedValue: g, value: _, nativeButton: v = !1, ...y } = e, { clearErrors: b } = Xl(), { disabled: x, name: w, setDirty: T, setFilled: E, setFocused: D, setTouched: O, state: k, validationMode: A, validityData: j, shouldValidateOnChange: M, validation: N } = Kl(), P = uu(), { labelId: F, controlId: I, registerControlId: L, getDescriptionProps: ee } = Jl(), R = zl(), z = R?.parent, te = z && R.allValues, B = x || P.disabled || R?.disabled || o, V = w ?? u, ne = _ ?? V, re = Il(), ie = Il(), ae = I;
	te ? ae = f ? ie : `${z.id}-${ne}` : s && (ae = s);
	let oe = {};
	te && (f ? oe = R.parent.getParentProps() : ne && (oe = R.parent.getChildProps(ne)));
	let H = U(d), { checked: se = n, indeterminate: ce = c, onCheckedChange: le, ...ue } = oe, de = R?.value, fe = R?.setValue, pe = R?.defaultValue, me = S.useRef(null), he = Te(() => Symbol("checkbox-control")), ge = S.useRef(!1), { getButtonProps: _e, buttonRef: ve } = iu({
		disabled: B,
		native: v
	}), ye = R?.validation ?? N, [be, xe] = Ll({
		controlled: ne && de && !f ? de.includes(ne) : se,
		default: ne && pe && !f ? pe.includes(ne) : i,
		name: "Checkbox",
		state: "checked"
	});
	W(() => {
		L !== Et && (ge.current = !0, L(he.current, ae));
	}, [
		ae,
		R,
		L,
		f,
		he
	]), S.useEffect(() => {
		let e = he.current;
		return () => {
			!ge.current || L === Et || (ge.current = !1, L(e, void 0));
		};
	}, [L, he]), Ql({
		enabled: !R,
		id: re,
		commit: ye.commit,
		value: be,
		controlRef: me,
		name: V,
		getValue: () => be
	});
	let Se = S.useRef(null), Ce = Ai(l, Se, ye.inputRef), we = du(a, F, Se, !v, ae ?? void 0);
	W(() => {
		Se.current && (Se.current.indeterminate = ce, be && E(!0));
	}, [
		be,
		ce,
		E
	]), gi(be, () => {
		R && !f || (b(V), E(be), T(be !== j.initialValue), M() ? ye.commit(be) : ye.commit(be, !0));
	});
	let Ee = Wi({
		checked: be,
		disabled: B,
		name: f ? void 0 : V,
		id: v ? void 0 : ae ?? void 0,
		required: h,
		ref: Ce,
		style: V ? ns : ts,
		tabIndex: -1,
		type: "checkbox",
		"aria-hidden": !0,
		onChange(e) {
			if (e.nativeEvent.defaultPrevented) return;
			let t = e.target.checked, n = K(Qt, e.nativeEvent);
			le?.(t, n), H(t, n), !n.isCanceled && (xe(t), ne && de && fe && !f && fe(t ? [...de, ne] : de.filter((e) => e !== ne), n));
		},
		onFocus() {
			me.current?.focus();
		}
	}, _ === void 0 ? Ot : { value: (R ? be && _ : _) || "" }, ee, R ? ye.getValidationProps : ye.getInputValidationProps), De = te ? !!se : be, Oe = te && ce || c;
	S.useEffect(() => {
		if (!z || !ne) return;
		let e = z.disabledStatesRef.current;
		return e.set(ne, B), () => {
			e.delete(ne);
		};
	}, [
		z,
		B,
		ne
	]);
	let ke = S.useMemo(() => ({
		...k,
		checked: De,
		disabled: B,
		readOnly: p,
		required: h,
		indeterminate: Oe
	}), [
		k,
		De,
		B,
		p,
		h,
		Oe
	]), Ae = cu(ke), je = Y("span", e, {
		state: ke,
		ref: [
			ve,
			me,
			t,
			R?.registerControlRef
		],
		props: [
			{
				id: v ? ae ?? void 0 : re,
				role: "checkbox",
				"aria-checked": ce ? "mixed" : be,
				"aria-readonly": p || void 0,
				"aria-required": h || void 0,
				"aria-labelledby": we,
				[hu]: f ? "" : void 0,
				onFocus() {
					D(!0);
				},
				onBlur() {
					let e = Se.current;
					e && (O(!0), D(!1), A === "onBlur" && ye.commit(R ? de : e.checked));
				},
				onClick(e) {
					p || B || (e.preventDefault(), Se.current?.dispatchEvent(new PointerEvent("click", {
						bubbles: !0,
						shiftKey: e.shiftKey,
						ctrlKey: e.ctrlKey,
						altKey: e.altKey,
						metaKey: e.metaKey
					})));
				}
			},
			ee,
			ye.getValidationProps,
			y,
			ue,
			_e
		],
		stateAttributesMapping: Ae
	});
	return /* @__PURE__ */ (0, C.jsxs)(mu.Provider, {
		value: ke,
		children: [
			je,
			!be && !R && V && !f && g !== void 0 && /* @__PURE__ */ (0, C.jsx)("input", {
				type: "hidden",
				name: V,
				value: g
			}),
			/* @__PURE__ */ (0, C.jsx)("input", { ...Ee })
		]
	});
});
process.env.NODE_ENV !== "production" && (gu.displayName = "CheckboxRoot");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/checkbox-group/useCheckboxGroupParent.js
var _u = [];
function vu(e) {
	let { allValues: t = _u, value: n = _u, onValueChange: r } = e, i = S.useRef(n), a = S.useRef(/* @__PURE__ */ new Map()), [o, s] = S.useState("mixed"), c = Il(), l = n.length === t.length, u = n.length !== t.length && n.length > 0, d = U(r), f = S.useCallback(() => ({
		id: c,
		indeterminate: u,
		checked: l,
		"aria-controls": t.map((e) => `${c}-${e}`).join(" "),
		onCheckedChange(e, r) {
			let c = i.current, l = t.filter((e) => a.current.get(e) && c.includes(e)), u = t.filter((e) => !a.current.get(e) || a.current.get(e) && c.includes(e));
			if (c.length === u.length || c.length === 0) {
				n.length === u.length ? d(l, r) : d(u, r);
				return;
			}
			o === "mixed" ? (d(u, r), s("on")) : o === "on" ? (d(l, r), s("off")) : o === "off" && (d(c, r), s("mixed"));
		}
	}), [
		t,
		l,
		c,
		u,
		d,
		o,
		n.length
	]), p = S.useCallback((e) => ({
		checked: n.includes(e),
		onCheckedChange(t, r) {
			let a = n.slice();
			t ? a.push(e) : a.splice(a.indexOf(e), 1), i.current = a, d(a, r), s("mixed");
		}
	}), [d, n]);
	return S.useMemo(() => ({
		id: c,
		indeterminate: u,
		getParentProps: f,
		getChildProps: p,
		disabledStatesRef: a
	}), [
		c,
		u,
		f,
		p
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/areArraysEqual.js
function yu(e, t, n = (e, t) => e === t) {
	return e.length === t.length && e.every((e, r) => n(e, t[r]));
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/checkbox-group/CheckboxGroup.js
var bu = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { allValues: n, className: r, defaultValue: i, disabled: a = !1, id: o, onValueChange: s, render: c, value: l, ...u } = e, { disabled: d, name: f, state: p, validation: m, setFilled: h, setDirty: g, shouldValidateOnChange: _, validityData: v } = Kl(), { labelId: y, getDescriptionProps: b } = Jl(), { clearErrors: x } = Xl(), w = d || a, [T, E] = Ll({
		controlled: l,
		default: i,
		name: "CheckboxGroup",
		state: "value"
	}), D = U((e, t) => {
		s?.(e, t), !t.isCanceled && E(e);
	}), O = vu({
		allValues: n,
		value: l,
		onValueChange: s
	}), k = Il(o), A = S.useRef(null), j = S.useCallback((e) => {
		A.current == null && e != null && !e.hasAttribute("data-parent") && (A.current = e);
	}, []);
	Ql({
		enabled: !!f,
		id: k,
		commit: m.commit,
		value: T,
		controlRef: A,
		name: f,
		getValue: () => T
	});
	let M = T ?? Dt;
	gi(M, () => {
		f && x(f);
		let e = Array.isArray(v.initialValue) ? v.initialValue : Dt;
		h(M.length > 0), g(!yu(M, e)), _() ? m.commit(M) : m.commit(M, !0);
	});
	let N = {
		...p,
		disabled: w
	}, P = S.useMemo(() => ({
		allValues: n,
		value: T,
		defaultValue: i,
		setValue: D,
		parent: O,
		disabled: w,
		validation: m,
		registerControlRef: j
	}), [
		n,
		T,
		i,
		D,
		O,
		w,
		m,
		j
	]), F = Y("div", e, {
		state: N,
		ref: t,
		props: [
			{
				role: "group",
				"aria-labelledby": y
			},
			b,
			u
		],
		stateAttributesMapping: Wl
	});
	return /* @__PURE__ */ (0, C.jsx)(Rl.Provider, {
		value: P,
		children: F
	});
});
process.env.NODE_ENV !== "production" && (bu.displayName = "CheckboxGroup");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/checkbox-group.module.js
var xu = { "checkbox-group": "_checkbox-group_1m1v0_1" }, Su = (0, S.createContext)(void 0);
function Cu() {
	let e = (0, S.useContext)(Su);
	if (e === void 0) throw Error("useCheckboxGroupContext must be used within a CheckboxGroup parent component");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/checkbox-group/item.module.js
var wu = "_checkbox__checkmark_hwyfp_24", Tu = "_checkbox_hwyfp_1", Eu = {
	"checkbox-group-item": "_checkbox-group-item_hwyfp_1",
	"checkbox-group-item--nested": "_checkbox-group-item--nested_hwyfp_12",
	"checkbox-group-item__label": "_checkbox-group-item__label_hwyfp_16",
	checkbox__checkmark: wu,
	"checkbox__checkmark--small": "_checkbox__checkmark--small_hwyfp_40",
	checkbox: Tu
}, Du = /* @__PURE__ */ B(V(), 1);
function Ou(e) {
	let t = (0, x.c)(30), n, r, i, a, o, s, c;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7]) : ({children: n, className: r, disabled: i, nested: a, parent: o, value: c, ...s} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c);
	let { isSmall: l } = Cu(), u = (0, S.useId)(), d;
	t[8] !== r || t[9] !== a ? (d = (0, Du.default)(Eu["checkbox-group-item"], { [Eu["checkbox-group-item--nested"]]: a }, r), t[8] = r, t[9] = a, t[10] = d) : d = t[10];
	let f;
	t[11] === l ? f = t[12] : (f = (e, t) => /* @__PURE__ */ (0, C.jsx)("span", {
		...e,
		children: /* @__PURE__ */ (0, C.jsx)("span", {
			className: (0, Du.default)(Eu.checkbox__checkmark, { [Eu["checkbox__checkmark--small"]]: l }),
			children: t.indeterminate ? /* @__PURE__ */ (0, C.jsx)(N, {
				color: t.disabled ? "disabled" : "default-inverse",
				name: "minus",
				size: "small"
			}) : t.checked ? /* @__PURE__ */ (0, C.jsx)(N, {
				color: t.disabled ? "disabled" : "default-inverse",
				name: "checkmark",
				size: "small"
			}) : null
		})
	}), t[11] = l, t[12] = f);
	let p;
	t[13] !== i || t[14] !== u || t[15] !== o || t[16] !== f || t[17] !== c ? (p = /* @__PURE__ */ (0, C.jsx)(gu, {
		"aria-labelledby": u,
		className: Eu.checkbox,
		disabled: i,
		parent: o,
		render: f,
		value: c
	}), t[13] = i, t[14] = u, t[15] = o, t[16] = f, t[17] = c, t[18] = p) : p = t[18];
	let m = l ? "text-200--regular" : "text-300--regular", h;
	t[19] === m ? h = t[20] : (h = (0, Du.default)(Eu["checkbox-group-item__label"], m), t[19] = m, t[20] = h);
	let g;
	t[21] !== n || t[22] !== u || t[23] !== h ? (g = /* @__PURE__ */ (0, C.jsx)("span", {
		className: h,
		id: u,
		children: n
	}), t[21] = n, t[22] = u, t[23] = h, t[24] = g) : g = t[24];
	let _;
	return t[25] !== s || t[26] !== d || t[27] !== p || t[28] !== g ? (_ = /* @__PURE__ */ (0, C.jsxs)("label", {
		className: d,
		...s,
		children: [p, g]
	}), t[25] = s, t[26] = d, t[27] = p, t[28] = g, t[29] = _) : _ = t[29], _;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/checkbox-group/legend.js
var ku = /* @__PURE__ */ B(V(), 1);
function Au(e) {
	let t = (0, x.c)(10), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({children: n, className: r, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a;
	t[4] === r ? a = t[5] : (a = (0, ku.default)("text-200--bold", r), t[4] = r, t[5] = a);
	let o;
	return t[6] !== n || t[7] !== i || t[8] !== a ? (o = /* @__PURE__ */ (0, C.jsx)("legend", {
		className: a,
		...i,
		children: n
	}), t[6] = n, t[7] = i, t[8] = a, t[9] = o) : o = t[9], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/checkbox-group.js
var ju = /* @__PURE__ */ B(V(), 1);
function Mu(e) {
	let t = (0, x.c)(10), { allValues: n, children: r, className: i, disabled: a, isSmall: o, onChange: s, value: c } = e, l;
	t[0] !== r || t[1] !== i || t[2] !== o ? (l = (e) => /* @__PURE__ */ (0, C.jsx)("fieldset", {
		...e,
		className: (0, ju.default)(xu["checkbox-group"], i),
		children: /* @__PURE__ */ (0, C.jsx)(Su, {
			value: { isSmall: o },
			children: r
		})
	}), t[0] = r, t[1] = i, t[2] = o, t[3] = l) : l = t[3];
	let u;
	return t[4] !== n || t[5] !== a || t[6] !== s || t[7] !== l || t[8] !== c ? (u = /* @__PURE__ */ (0, C.jsx)(bu, {
		allValues: n,
		disabled: a,
		onValueChange: s,
		render: l,
		value: c
	}), t[4] = n, t[5] = a, t[6] = s, t[7] = l, t[8] = c, t[9] = u) : u = t[9], u;
}
Mu.Item = Ou, Mu.Legend = Au;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useClick.js
function Nu(e, t = {}) {
	let n = "rootStore" in e ? e.rootStore : e, r = n.context.dataRef, { enabled: i = !0, event: a = "click", toggle: o = !0, ignoreMouse: s = !1, stickIfOpen: c = !0, touchOpenDelay: l = 0, reason: u = $t } = t, d = S.useRef(void 0), f = Tt(), p = bt(), m = S.useMemo(() => ({
		onPointerDown(e) {
			d.current = e.pointerType;
		},
		onMouseDown(e) {
			let t = d.current, i = e.nativeEvent, m = n.select("open");
			if (e.button !== 0 || a === "click" || Tn(t, !0) && s) return;
			let h = r.current.openEvent, g = h?.type, _ = n.select("domReferenceElement") !== e.currentTarget, v = m && _ || !(m && o && (!(h && c) || g === "click" || g === "mousedown"));
			if (Jt(i.target)) {
				let e = K(u, i, i.target);
				v && t === "touch" && l > 0 ? p.start(l, () => {
					n.setOpen(!0, e);
				}) : n.setOpen(v, e);
				return;
			}
			let y = e.currentTarget;
			f.request(() => {
				let e = K(u, i, y);
				v && t === "touch" && l > 0 ? p.start(l, () => {
					n.setOpen(!0, e);
				}) : n.setOpen(v, e);
			});
		},
		onClick(e) {
			if (a === "mousedown-only") return;
			let t = d.current;
			if (a === "mousedown" && t) {
				d.current = void 0;
				return;
			}
			if (Tn(t, !0) && s) return;
			let i = n.select("open"), f = r.current.openEvent, m = n.select("domReferenceElement") !== e.currentTarget, h = i && m || !(i && o && (!(f && c) || En(f))), g = K(u, e.nativeEvent, e.currentTarget);
			h && t === "touch" && l > 0 ? p.start(l, () => {
				n.setOpen(!0, g);
			}) : n.setOpen(h, g);
		},
		onKeyDown() {
			d.current = void 0;
		}
	}), [
		r,
		a,
		s,
		n,
		c,
		o,
		f,
		p,
		l,
		u
	]);
	return S.useMemo(() => i ? { reference: m } : Ot, [i, m]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useFloatingRootContext.js
function Pu(e) {
	let { open: t = !1, onOpenChange: n, elements: r = {} } = e, i = Mn(), a = Ln() != null;
	if (process.env.NODE_ENV !== "production") {
		let e = r.reference;
		e && !Fe(e) && console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `context.setPositionReference()`", "instead.");
	}
	let o = Te(() => new ci({
		open: t,
		onOpenChange: n,
		referenceElement: r.reference ?? null,
		floatingElement: r.floating ?? null,
		triggerElements: new xi(),
		floatingId: i,
		nested: a,
		noEmit: !1
	})).current;
	return W(() => {
		let e = {
			open: t,
			floatingId: i
		};
		r.reference !== void 0 && (e.referenceElement = r.reference, e.domReferenceElement = Fe(r.reference) ? r.reference : null), r.floating !== void 0 && (e.floatingElement = r.floating), o.update(e);
	}, [
		t,
		i,
		r.reference,
		r.floating,
		o
	]), o.context.onOpenChange = n, o.context.nested = a, o.context.noEmit = !1, o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useListNavigation.js
var Fu = "Escape";
function Iu(e, t, n) {
	switch (e) {
		case "vertical": return t;
		case "horizontal": return n;
		default: return t || n;
	}
}
function Lu(e, t) {
	return Iu(t, e === "ArrowUp" || e === "ArrowDown", e === "ArrowLeft" || e === "ArrowRight");
}
function Ru(e, t, n) {
	return Iu(t, e === "ArrowDown", n ? e === "ArrowLeft" : e === "ArrowRight") || e === "Enter" || e === " " || e === "";
}
function zu(e, t, n) {
	return Iu(t, n ? e === zt : e === Bt, e === Ht);
}
function Bu(e, t, n, r) {
	return t === "both" || t === "horizontal" && r && r > 1 ? e === Fu : Iu(t, n ? e === Bt : e === zt, e === Vt);
}
function Vu(e, t) {
	let n = "rootStore" in e ? e.rootStore : e, r = n.useState("open"), i = n.useState("floatingElement"), a = n.useState("domReferenceElement"), o = n.context.dataRef, { listRef: s, activeIndex: c, onNavigate: l = () => {}, enabled: u = !0, selectedIndex: d = null, allowEscape: f = !1, loopFocus: p = !1, nested: m = !1, rtl: h = !1, virtual: g = !1, focusItemOnOpen: _ = "auto", focusItemOnHover: v = !0, openOnArrowKeyDown: y = !0, disabledIndices: b = void 0, orientation: x = "vertical", parentOrientation: C, cols: w = 1, id: T, resetOnPointerLeave: E = !0, externalTree: D } = t;
	process.env.NODE_ENV !== "production" && (f && (p || console.warn("`useListNavigation` looping must be enabled to allow escaping."), g || console.warn("`useListNavigation` must be virtual to allow escaping.")), x === "vertical" && w > 1 && console.warn("In grid list navigation mode (`cols` > 1), the `orientation` should", "be either \"horizontal\" or \"both\"."));
	let O = Qo(Zt(i)), k = Ln(), A = Rn(D);
	W(() => {
		o.current.orientation = x;
	}, [o, x]);
	let j = Yt(a), M = S.useRef(_), N = S.useRef(d ?? -1), P = S.useRef(null), F = S.useRef(!0), I = U((e) => {
		l(N.current === -1 ? null : N.current, e);
	}), L = S.useRef(I), ee = S.useRef(!!i), R = S.useRef(r), z = S.useRef(!1), te = S.useRef(!1), B = Qo(b), V = Qo(r), ne = Qo(d), re = Qo(E), ie = U(() => {
		function e(e) {
			g ? A?.events.emit("virtualfocus", e) : as(e, {
				sync: z.current,
				preventScroll: !0
			});
		}
		let t = s.current[N.current], n = te.current;
		t && e(t), (z.current ? (e) => e() : requestAnimationFrame)(() => {
			let r = s.current[N.current] || t;
			r && (t || e(r), oe && (n || !F.current) && r.scrollIntoView?.({
				block: "nearest",
				inline: "nearest"
			}));
		});
	});
	W(() => {
		u && (r && i ? (N.current = d ?? -1, M.current && d != null && (te.current = !0, I())) : ee.current && (N.current = -1, L.current()));
	}, [
		u,
		r,
		i,
		d,
		I
	]), W(() => {
		if (u) {
			if (!r) {
				z.current = !1;
				return;
			}
			if (i) if (c == null) {
				if (z.current = !1, ne.current != null) return;
				if (ee.current && (N.current = -1, ie()), (!R.current || !ee.current) && M.current && (P.current != null || M.current === !0 && P.current == null)) {
					let e = 0, t = () => {
						s.current[0] == null ? (e < 2 && (e ? requestAnimationFrame : queueMicrotask)(t), e += 1) : (N.current = P.current == null || Ru(P.current, x, h) || m ? qa(s) : Ja(s), P.current = null, I());
					};
					t();
				}
			} else Ka(s, c) || (N.current = c, ie(), te.current = !1);
		}
	}, [
		u,
		r,
		i,
		c,
		ne,
		m,
		s,
		x,
		h,
		I,
		ie,
		B
	]), W(() => {
		if (!u || i || !A || g || !ee.current) return;
		let e = A.nodesRef.current, t = e.find((e) => e.id === k)?.context?.elements.floating, n = Ut(ht(i)), r = e.some((e) => e.context && G(e.context.elements.floating, n));
		t && !r && F.current && t.focus({ preventScroll: !0 });
	}, [
		u,
		i,
		A,
		k,
		g
	]), W(() => {
		L.current = I, R.current = r, ee.current = !!i;
	}), W(() => {
		r || (P.current = null, M.current = _);
	}, [r, _]);
	let ae = c != null, oe = S.useMemo(() => {
		function e(e) {
			if (!V.current) return;
			let t = s.current.indexOf(e.currentTarget);
			t !== -1 && N.current !== t && (N.current = t, I(e));
		}
		return {
			onFocus(t) {
				z.current = !0, e(t);
			},
			onClick: ({ currentTarget: e }) => e.focus({ preventScroll: !0 }),
			onMouseMove(t) {
				z.current = !0, te.current = !1, v && e(t);
			},
			onPointerLeave(e) {
				if (!V.current || !F.current || e.pointerType === "touch") return;
				z.current = !0;
				let t = e.relatedTarget;
				if (!(!v || s.current.includes(t)) && re.current && (as(null, { sync: !0 }), N.current = -1, I(e), !g)) {
					let e = O.current, t = Ut(ht(e));
					e && G(e, t) && e.focus({ preventScroll: !0 });
				}
			}
		};
	}, [
		V,
		O,
		v,
		s,
		I,
		re,
		g
	]), H = S.useCallback(() => C ?? A?.nodesRef.current.find((e) => e.id === k)?.context?.dataRef?.current.orientation, [
		k,
		A,
		C
	]), se = U((e) => {
		if (F.current = !1, z.current = !0, e.which === 229 || !V.current && e.currentTarget === O.current) return;
		if (m && Bu(e.key, x, h, w)) {
			Lu(e.key, H()) || xn(e), n.setOpen(!1, K(mn, e.nativeEvent)), Ie(a) && (g ? A?.events.emit("virtualfocus", a) : a.focus());
			return;
		}
		let t = N.current, i = qa(s, b), o = Ja(s, b);
		if (j || (e.key === "Home" && (xn(e), N.current = i, I(e)), e.key === "End" && (xn(e), N.current = o, I(e))), w > 1) {
			let t = Array.from({ length: s.current.length }, () => ({
				width: 1,
				height: 1
			})), n = Za(t, w, !1), r = n.findIndex((e) => e != null && !eo(s, e, b)), a = n.reduce((e, t, n) => t != null && !eo(s, t, b) ? n : e, -1), c = n[Xa({ current: n.map((e) => e == null ? null : s.current[e]) }, {
				event: e,
				orientation: x,
				loopFocus: p,
				rtl: h,
				cols: w,
				disabledIndices: $a([...(typeof b == "function" ? null : b) || s.current.map((e, t) => eo(s, t, b) ? t : void 0), void 0], n),
				minIndex: r,
				maxIndex: a,
				prevIndex: Qa(N.current > o ? i : N.current, t, n, w, e.key === "ArrowDown" ? "bl" : e.key === (h ? "ArrowLeft" : "ArrowRight") ? "tr" : "tl"),
				stopEvent: !0
			})];
			if (c != null && (N.current = c, I(e)), x === "both") return;
		}
		if (Lu(e.key, x)) {
			if (xn(e), r && !g && Ut(e.currentTarget.ownerDocument) === e.currentTarget) {
				N.current = Ru(e.key, x, h) ? i : o, I(e);
				return;
			}
			Ru(e.key, x, h) ? p ? t >= o ? f && t !== s.current.length ? N.current = -1 : (z.current = !1, N.current = i) : N.current = Ya(s, {
				startingIndex: t,
				disabledIndices: b
			}) : N.current = Math.min(o, Ya(s, {
				startingIndex: t,
				disabledIndices: b
			})) : p ? t <= i ? f && t !== -1 ? N.current = s.current.length : (z.current = !1, N.current = o) : N.current = Ya(s, {
				startingIndex: t,
				decrement: !0,
				disabledIndices: b
			}) : N.current = Math.max(i, Ya(s, {
				startingIndex: t,
				decrement: !0,
				disabledIndices: b
			})), Ka(s, N.current) && (N.current = -1), I(e);
		}
	}), ce = S.useMemo(() => g && r && ae && { "aria-activedescendant": `${T}-${c}` }, [
		g,
		r,
		ae,
		T,
		c
	]), le = S.useMemo(() => ({
		"aria-orientation": x === "both" ? void 0 : x,
		...j ? {} : ce,
		onKeyDown(e) {
			if (e.key === "Tab" && e.shiftKey && r && !g) {
				let t = Gt(e.nativeEvent);
				if (t && !G(O.current, t)) return;
				xn(e), n.setOpen(!1, K(fn, e.nativeEvent)), Ie(a) && a.focus();
				return;
			}
			se(e);
		},
		onPointerMove() {
			F.current = !0;
		}
	}), [
		ce,
		se,
		O,
		x,
		j,
		n,
		r,
		g,
		a
	]), ue = S.useMemo(() => {
		function e(e) {
			_ === "auto" && Cn(e.nativeEvent) && (M.current = !g);
		}
		function t(e) {
			M.current = _, _ === "auto" && wn(e.nativeEvent) && (M.current = !0);
		}
		return {
			onKeyDown(e) {
				let t = n.select("open");
				F.current = !1;
				let r = e.key.startsWith("Arrow"), i = zu(e.key, H(), h), a = Lu(e.key, x), o = (m ? i : a) || e.key === "Enter" || e.key.trim() === "";
				if (g && t) return se(e);
				if (!(!t && !y && r)) {
					if (o) {
						let t = Lu(e.key, H());
						P.current = m && t ? null : e.key;
					}
					if (m) {
						i && (xn(e), t ? (N.current = qa(s, B.current), I(e)) : n.setOpen(!0, K("list-navigation", e.nativeEvent, e.currentTarget)));
						return;
					}
					a && (ne.current != null && (N.current = ne.current), xn(e), !t && y ? n.setOpen(!0, K("list-navigation", e.nativeEvent, e.currentTarget)) : se(e), t && I(e));
				}
			},
			onFocus(e) {
				n.select("open") && !g && (N.current = -1, I(e));
			},
			onPointerDown: t,
			onPointerEnter: t,
			onMouseDown: e,
			onClick: e
		};
	}, [
		se,
		B,
		_,
		s,
		m,
		I,
		n,
		y,
		x,
		H,
		h,
		ne,
		g
	]), de = S.useMemo(() => ({
		...ce,
		...ue
	}), [ce, ue]);
	return S.useMemo(() => u ? {
		reference: de,
		floating: le,
		item: oe,
		trigger: ue
	} : {}, [
		u,
		de,
		le,
		ue,
		oe
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/useOnFirstRender.js
function Hu(e) {
	let t = S.useRef(!0);
	t.current && (t.current = !1, e());
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/root/ComboboxRootContext.js
var Uu = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Uu.displayName = "ComboboxRootContext");
var Wu = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Wu.displayName = "ComboboxFloatingContext");
var Gu = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Gu.displayName = "ComboboxDerivedItemsContext");
var Ku = /* @__PURE__ */ S.createContext("");
process.env.NODE_ENV !== "production" && (Ku.displayName = "ComboboxInputValueContext");
function qu() {
	let e = S.useContext(Uu);
	if (!e) throw Error(process.env.NODE_ENV === "production" ? lr(22) : "Base UI: ComboboxRootContext is missing. Combobox parts must be placed within <Combobox.Root>.");
	return e;
}
function Ju() {
	let e = S.useContext(Wu);
	if (!e) throw Error(process.env.NODE_ENV === "production" ? lr(23) : "Base UI: ComboboxFloatingContext is missing. Combobox parts must be placed within <Combobox.Root>.");
	return e;
}
function Yu() {
	let e = S.useContext(Gu);
	if (!e) throw Error(process.env.NODE_ENV === "production" ? lr(24) : "Base UI: ComboboxItemsContext is missing. Combobox parts must be placed within <Combobox.Root>.");
	return e;
}
function Xu() {
	return S.useContext(Ku);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/itemEquality.js
var Zu = (e, t) => Object.is(e, t);
function Qu(e, t, n) {
	return e == null || t == null ? Object.is(e, t) : n(e, t);
}
function $u(e, t, n) {
	return !e || e.length === 0 ? !1 : e.some((e) => e === void 0 ? !1 : Qu(t, e, n));
}
function ed(e, t, n) {
	return !e || e.length === 0 ? -1 : e.findIndex((e) => e === void 0 ? !1 : Qu(e, t, n));
}
function td(e, t, n) {
	return e.filter((e) => !Qu(t, e, n));
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/serializeValue.js
function nd(e) {
	if (e == null) return "";
	if (typeof e == "string") return e;
	try {
		return JSON.stringify(e);
	} catch {
		return String(e);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/resolveValueLabel.js
function rd(e) {
	return e != null && e.length > 0 && typeof e[0] == "object" && e[0] != null && "items" in e[0];
}
function id(e) {
	if (!Array.isArray(e)) return e != null && "null" in e;
	let t = e;
	if (rd(t)) {
		for (let e of t) for (let t of e.items) if (t && t.value == null && t.label != null) return !0;
		return !1;
	}
	for (let e of t) if (e && e.value == null && e.label != null) return !0;
	return !1;
}
function ad(e, t) {
	if (t && e != null) return t(e) ?? "";
	if (e && typeof e == "object") {
		if ("label" in e && e.label != null) return String(e.label);
		if ("value" in e) return String(e.value);
	}
	return nd(e);
}
function od(e, t) {
	return t && e != null ? t(e) ?? "" : e && typeof e == "object" && "value" in e && "label" in e ? nd(e.value) : nd(e);
}
function sd(e, t, n) {
	function r() {
		return ad(e, n);
	}
	if (n && e != null) return n(e);
	if (e && typeof e == "object" && "label" in e && e.label != null) return e.label;
	if (t && !Array.isArray(t)) return t[e] ?? r();
	if (Array.isArray(t)) {
		let n = t, i = rd(n) ? n.flatMap((e) => e.items) : n;
		if (typeof e != "object" || !e) {
			let t = i.find((t) => t.value === e);
			return t && t.label != null ? t.label : r();
		}
		if ("value" in e) {
			let t = i.find((t) => t && t.value === e.value);
			if (t && t.label != null) return t.label;
		}
	}
	return r();
}
function cd(e, t, n) {
	return e.reduce((e, r, i) => (i > 0 && e.push(", "), e.push(/* @__PURE__ */ (0, C.jsx)(S.Fragment, { children: sd(r, t, n) }, i)), e), []);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/store.js
var Z = {
	id: q((e) => e.id),
	labelId: q((e) => e.labelId),
	query: q((e) => e.query),
	items: q((e) => e.items),
	selectedValue: q((e) => e.selectedValue),
	hasSelectionChips: q((e) => {
		let t = e.selectedValue;
		return Array.isArray(t) && t.length > 0;
	}),
	hasSelectedValue: q((e) => {
		let { selectedValue: t, selectionMode: n } = e;
		return t == null ? !1 : n === "multiple" && Array.isArray(t) ? t.length > 0 : !0;
	}),
	hasNullItemLabel: q((e, t) => t ? id(e.items) : !1),
	open: q((e) => e.open),
	mounted: q((e) => e.mounted),
	forceMounted: q((e) => e.forceMounted),
	inline: q((e) => e.inline),
	activeIndex: q((e) => e.activeIndex),
	selectedIndex: q((e) => e.selectedIndex),
	isActive: q((e, t) => e.activeIndex === t),
	isSelected: q((e, t) => {
		let n = e.isItemEqualToValue, r = e.selectedValue;
		return Array.isArray(r) ? r.some((e) => Qu(t, e, n)) : Qu(t, r, n);
	}),
	transitionStatus: q((e) => e.transitionStatus),
	popupProps: q((e) => e.popupProps),
	inputProps: q((e) => e.inputProps),
	triggerProps: q((e) => e.triggerProps),
	getItemProps: q((e) => e.getItemProps),
	positionerElement: q((e) => e.positionerElement),
	listElement: q((e) => e.listElement),
	triggerElement: q((e) => e.triggerElement),
	inputElement: q((e) => e.inputElement),
	inputGroupElement: q((e) => e.inputGroupElement),
	popupSide: q((e) => e.popupSide),
	openMethod: q((e) => e.openMethod),
	inputInsidePopup: q((e) => e.inputInsidePopup),
	selectionMode: q((e) => e.selectionMode),
	listRef: q((e) => e.listRef),
	labelsRef: q((e) => e.labelsRef),
	popupRef: q((e) => e.popupRef),
	emptyRef: q((e) => e.emptyRef),
	inputRef: q((e) => e.inputRef),
	keyboardActiveRef: q((e) => e.keyboardActiveRef),
	chipsContainerRef: q((e) => e.chipsContainerRef),
	clearRef: q((e) => e.clearRef),
	valuesRef: q((e) => e.valuesRef),
	allValuesRef: q((e) => e.allValuesRef),
	name: q((e) => e.name),
	disabled: q((e) => e.disabled),
	readOnly: q((e) => e.readOnly),
	required: q((e) => e.required),
	grid: q((e) => e.grid),
	isGrouped: q((e) => e.isGrouped),
	virtualized: q((e) => e.virtualized),
	onOpenChangeComplete: q((e) => e.onOpenChangeComplete),
	openOnInputClick: q((e) => e.openOnInputClick),
	itemToStringLabel: q((e) => e.itemToStringLabel),
	isItemEqualToValue: q((e) => e.isItemEqualToValue),
	modal: q((e) => e.modal),
	autoHighlight: q((e) => e.autoHighlight),
	submitOnItemClick: q((e) => e.submitOnItemClick)
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/labelable-provider/useLabelableId.js
function ld(e = {}) {
	let { id: t, implicit: n = !1, controlRef: r } = e, { controlId: i, registerControlId: a } = Jl(), o = Il(t), s = n ? i : void 0, c = Te(() => Symbol("labelable-control")), l = S.useRef(!1), u = S.useRef(t != null), d = U(() => {
		!l.current || a === Et || (l.current = !1, a(c.current, void 0));
	});
	return W(() => {
		if (a === Et) return;
		let e;
		if (n) {
			let n = r?.current;
			e = Fe(n) && n.closest("label") != null ? t ?? null : s ?? o;
		} else if (t != null) u.current = !0, e = t;
		else if (u.current) e = o;
		else {
			d();
			return;
		}
		if (e === void 0) {
			d();
			return;
		}
		l.current = !0, a(c.current, e);
	}, [
		t,
		r,
		s,
		a,
		n,
		o,
		c,
		d
	]), S.useEffect(() => d, [d]), i ?? o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/root/utils/index.js
function ud(e, t) {
	return (n, r) => {
		if (n == null) return !1;
		let i = ad(n, t);
		return e.contains(i, r);
	};
}
function dd(e, t, n) {
	return (r, i) => {
		if (r == null) return !1;
		if (!i) return !0;
		let a = ad(r, t), o = n == null ? "" : ad(n, t);
		return o && e.contains(o, i) && o.length === i.length ? !0 : e.contains(a, i);
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/root/utils/useFilter.js
var fd = /* @__PURE__ */ new Map();
function pd(e) {
	return Array.isArray(e) ? e.map((e) => pd(e)).join(",") : e == null ? "" : String(e);
}
function md(e = {}) {
	let t = {
		usage: "search",
		sensitivity: "base",
		ignorePunctuation: !0,
		...e
	}, n = `${pd(e.locale)}|${JSON.stringify(t)}`, r = fd.get(n);
	if (r) return r;
	let i = new Intl.Collator(e.locale, t), a = {
		contains(e, t, n) {
			if (!t) return !0;
			let r = ad(e, n);
			for (let e = 0; e <= r.length - t.length; e += 1) if (i.compare(r.slice(e, e + t.length), t) === 0) return !0;
			return !1;
		},
		startsWith(e, t, n) {
			if (!t) return !0;
			let r = ad(e, n);
			return i.compare(r.slice(0, t.length), t) === 0;
		},
		endsWith(e, t, n) {
			if (!t) return !0;
			let r = ad(e, n), a = t.length;
			return r.length >= a && i.compare(r.slice(r.length - a), t) === 0;
		}
	};
	return fd.set(n, a), a;
}
var hd = md, gd = Symbol("none"), _d = {
	value: gd,
	index: -1
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/root/AriaCombobox.js
function vd(e) {
	let { id: t, onOpenChangeComplete: n, defaultSelectedValue: r = null, selectedValue: i, onSelectedValueChange: a, defaultInputValue: o, inputValue: s, selectionMode: c = "none", onItemHighlighted: l, name: u, disabled: d = !1, readOnly: f = !1, required: p = !1, inputRef: m, grid: h = !1, items: g, filteredItems: _, filter: v, openOnInputClick: y = !0, autoHighlight: b = !1, keepHighlight: x = !1, highlightItemOnHover: w = !0, loopFocus: T = !0, itemToStringLabel: E, itemToStringValue: D, isItemEqualToValue: O = Zu, virtualized: k = !1, inline: A = !1, fillInputOnItemPress: j = !0, modal: M = !1, limit: N = -1, autoComplete: P = "list", formAutoComplete: F, locale: I, submitOnItemClick: L = !1 } = e, { clearErrors: ee } = Xl(), { setDirty: R, validityData: z, shouldValidateOnChange: te, setFilled: B, name: V, disabled: ne, setTouched: re, setFocused: ie, validationMode: ae, validation: oe } = Kl(), H = ld({ id: t }), se = hd({ locale: I }), [ce, le] = S.useState(!1), [ue, de] = S.useState(null), fe = S.useRef([]), pe = S.useRef([]), me = S.useRef(null), he = S.useRef(null), ge = S.useRef(null), _e = S.useRef(null), ve = S.useRef(null), ye = S.useRef(!0), be = S.useRef(!1), xe = S.useRef(null), Se = S.useRef(null), Ce = S.useRef(null), we = S.useRef(_d), Ee = S.useRef(null), De = S.useRef([]), Oe = S.useRef([]), ke = ne || d, Ae = V ?? u, je = c === "multiple", Me = c === "single", Ne = s !== void 0 || o !== void 0, Pe = g !== void 0, Fe = _ !== void 0, Ie;
	Ie = b === "always" ? "always" : b ? "input-change" : !1;
	let [Le, Re] = Ll({
		controlled: i,
		default: je ? r ?? Dt : r,
		name: "Combobox",
		state: "selectedValue"
	}), ze = S.useMemo(() => v === null ? () => !0 : v === void 0 ? Me && !ce ? dd(se, E, Le) : ud(se, E) : v, [
		v,
		Me,
		Le,
		ce,
		se,
		E
	]), Be = Te(() => Ne ? o ?? "" : Me ? ad(Le, E) : "").current, [Ve, He] = Ll({
		controlled: s,
		default: Be,
		name: "Combobox",
		state: "inputValue"
	}), [Ue, We] = Ll({
		controlled: e.open,
		default: e.defaultOpen,
		name: "Combobox",
		state: "open"
	}), Ge = rd(g), Ke = ue ?? (Ve === "" ? "" : String(Ve).trim()), qe = Me ? ad(Le, E) : "", Je = Me && !ce && Ke !== "" && qe !== "" && qe.length === Ke.length && se.contains(qe, Ke), Ye = Je ? "" : Ke, Xe = Pe && Fe && Je, Ze = S.useMemo(() => g ? Ge ? g.flatMap((e) => e.items) : g : Dt, [g, Ge]), Qe = S.useMemo(() => {
		if (_ && !Xe) return _;
		if (!g) return Dt;
		if (Ge) {
			let e = g, t = [], n = 0;
			for (let r of e) {
				if (N > -1 && n >= N) break;
				let e = Ye === "" ? r.items : r.items.filter((e) => ze(e, Ye, E));
				if (e.length === 0) continue;
				let i = N > -1 ? N - n : Infinity, a = e.slice(0, i);
				if (a.length > 0) {
					let e = {
						...r,
						items: a
					};
					t.push(e), n += a.length;
				}
			}
			return t;
		}
		if (Ye === "") return N > -1 ? Ze.slice(0, N) : Ze;
		let e = [];
		for (let t of Ze) {
			if (N > -1 && e.length >= N) break;
			ze(t, Ye, E) && e.push(t);
		}
		return e;
	}, [
		_,
		Xe,
		g,
		Ge,
		Ye,
		N,
		ze,
		E,
		Ze
	]), $e = S.useMemo(() => Ge ? Qe.flatMap((e) => e.items) : Qe, [Qe, Ge]), et = Te(() => new ai({
		id: H,
		labelId: void 0,
		selectedValue: Le,
		open: Ue,
		filter: ze,
		query: Ke,
		items: g,
		selectionMode: c,
		listRef: fe,
		labelsRef: pe,
		popupRef: me,
		emptyRef: ve,
		inputRef: he,
		startDismissRef: ge,
		endDismissRef: _e,
		keyboardActiveRef: ye,
		chipsContainerRef: xe,
		clearRef: Se,
		valuesRef: De,
		allValuesRef: Oe,
		selectionEventRef: Ce,
		name: Ae,
		disabled: ke,
		readOnly: f,
		required: p,
		grid: h,
		isGrouped: Ge,
		virtualized: k,
		openOnInputClick: y,
		itemToStringLabel: E,
		isItemEqualToValue: O,
		modal: M,
		autoHighlight: Ie,
		submitOnItemClick: L,
		hasInputValue: Ne,
		mounted: !1,
		forceMounted: !1,
		transitionStatus: "idle",
		inline: A,
		activeIndex: null,
		selectedIndex: null,
		popupProps: {},
		inputProps: {},
		triggerProps: {},
		positionerElement: null,
		listElement: null,
		triggerElement: null,
		inputElement: null,
		inputGroupElement: null,
		popupSide: null,
		openMethod: null,
		inputInsidePopup: !0,
		onOpenChangeComplete: n || Et,
		setOpen: Et,
		setInputValue: Et,
		setSelectedValue: Et,
		setIndices: Et,
		onItemHighlighted: Et,
		handleSelection: Et,
		getItemProps: () => Ot,
		forceMount: Et,
		requestSubmit: Et
	})).current, tt = c === "none" ? Ve : Le, nt = S.useMemo(() => c === "none" ? tt : Array.isArray(Le) ? Le.map((e) => od(e, D)) : od(Le, D), [
		tt,
		D,
		c,
		Le
	]), rt = U(l), it = U(n), at = J(et, Z.activeIndex), ot = J(et, Z.selectedIndex), st = J(et, Z.positionerElement), ct = J(et, Z.listElement), lt = J(et, Z.triggerElement), ut = J(et, Z.inputElement), dt = J(et, Z.inputGroupElement), ft = J(et, Z.inline), pt = J(et, Z.inputInsidePopup), mt = Qo(lt), { mounted: ht, setMounted: gt, transitionStatus: _t } = Kn(Ue), { openMethod: vt, triggerProps: yt } = _i(Ue);
	Ql({
		id: H,
		name: Ae,
		commit: oe.commit,
		value: tt,
		controlRef: pt ? mt : he,
		getValue: () => nt
	});
	let bt = U(() => {
		g ? pe.current = $e.map((e) => ad(e, E)) : et.set("forceMounted", !0);
	}), xt = S.useRef(Le);
	W(() => {
		Le !== xt.current && bt();
	}, [bt, Le]);
	let St = U((e) => {
		et.update(e);
		let t = e.type || "none";
		if (e.activeIndex !== void 0) if (e.activeIndex === null) we.current !== _d && (we.current = _d, rt(void 0, vn(t, void 0, { index: -1 })));
		else {
			let n = De.current[e.activeIndex];
			we.current = {
				value: n,
				index: e.activeIndex
			}, rt(n, vn(t, void 0, { index: e.activeIndex }));
		}
	}), Ct = U((t, n) => {
		if (be.current = n.reason === "input-clear", e.onInputValueChange?.(t, n), !n.isCanceled) {
			if (n.reason === "input-change") {
				let e = n.event, r = e.inputType;
				if (e.type === "compositionend" || r != null && r !== "" && r !== "insertReplacementText") {
					let e = t.trim() !== "";
					e && le(!0), Ee.current = { hasQuery: e }, e && Ie && et.state.activeIndex == null && et.set("activeIndex", 0);
				}
			}
			He(t);
		}
	}), wt = U((t, n) => {
		if (Ue !== t && (n.reason === "escape-key" && Pe && $e.length === 0 && !et.state.emptyRef.current && n.allowPropagation(), e.onOpenChange?.(t, n), !n.isCanceled && (!t && ce && (Me ? (ft || de(Ke), Ke === "" && le(!1)) : je && (ft || pt ? St({ activeIndex: null }) : de(Ke), Ct("", K("input-clear", n.event)))), We(t), !t && pt && (n.reason === "focus-out" || n.reason === "outside-press") && (re(!0), ie(!1), ae === "onBlur")))) {
			let e = c === "none" ? Ve : Le;
			oe.commit(e);
		}
	}), Tt = U((e, t) => {
		a?.(e, t), !t.isCanceled && (Re(e), (c === "none" && me.current && j || Me && !et.state.inputInsidePopup) && Ct(ad(e, E), K(t.reason, t.event)), Me && e != null && t.reason !== "input-change" && ce && !ft && de(Ke));
	}), kt = U((e, t) => {
		let n = t;
		if (n === void 0) {
			if (at === null) return;
			n = De.current[at];
		}
		let r = Gt(e), i = Ce.current ?? e;
		Ce.current = null;
		let a = K(rn, i), o = r?.closest("a")?.getAttribute("href");
		if (o) {
			o.startsWith("#") && wt(!1, a);
			return;
		}
		if (je) {
			let e = Array.isArray(Le) ? Le : [];
			if (Tt($u(e, n, et.state.isItemEqualToValue) ? td(e, n, et.state.isItemEqualToValue) : [...e, n], a), !(he.current && he.current.value.trim() !== "")) return;
			et.state.inputInsidePopup ? Ct("", K(ln, a.event)) : wt(!1, a);
		} else Tt(n, a), wt(!1, a);
	}), At = U(() => {
		if (!et.state.submitOnItemClick) return;
		let e = et.state.inputElement?.form;
		e && typeof e.requestSubmit == "function" && e.requestSubmit();
	}), jt = U(() => {
		if (gt(!1), it?.(!1), le(!1), de(null), St(c === "none" ? {
			activeIndex: null,
			selectedIndex: null
		} : { activeIndex: null }), je && he.current && he.current.value !== "" && !be.current && Ct("", K("input-clear")), Me) if (et.state.inputInsidePopup) he.current && he.current.value !== "" && Ct("", K("input-clear"));
		else {
			let e = ad(Le, E);
			he.current && he.current.value !== e && Ct(e, K(e === "" ? "input-clear" : "none"));
		}
	}), Mt = S.useMemo(() => ft && st ? { current: st.closest("[role=\"dialog\"]") } : me, [ft, st]);
	rr({
		enabled: !e.actionsRef,
		open: Ue,
		ref: Mt,
		onComplete() {
			Ue || jt();
		}
	}), S.useImperativeHandle(e.actionsRef, () => ({ unmount: jt }), [jt]), W(function() {
		if (Ue || c === "none") return;
		let e = g ? Ze : Oe.current;
		if (je) {
			let t = Array.isArray(Le) ? Le : [], n = t[t.length - 1], r = ed(e, n, O);
			St({ selectedIndex: r === -1 ? null : r });
		} else {
			let t = ed(e, Le, O);
			St({ selectedIndex: t === -1 ? null : t });
		}
	}, [
		Ue,
		Le,
		g,
		c,
		Ze,
		je,
		O,
		St
	]), W(() => {
		g && (De.current = $e, fe.current.length = $e.length);
	}, [g, $e]), W(() => {
		let e = Ee.current;
		if (e && (e.hasQuery ? Ie && et.set("activeIndex", 0) : Ie === "always" && et.set("activeIndex", 0), Ee.current = null), !Ue && !ft) return;
		let t = Pe || Fe ? $e : De.current, n = et.state.activeIndex;
		if (n == null) {
			if (Ie === "always" && t.length > 0) {
				et.set("activeIndex", 0);
				return;
			}
			we.current !== _d && (we.current = _d, et.state.onItemHighlighted(void 0, vn("none", void 0, { index: -1 })));
			return;
		}
		if (n >= t.length) {
			we.current !== _d && (we.current = _d, et.state.onItemHighlighted(void 0, vn("none", void 0, { index: -1 }))), et.set("activeIndex", null);
			return;
		}
		let r = t[n], i = we.current.value, a = i !== gd && Qu(r, i, et.state.isItemEqualToValue);
		(we.current.index !== n || !a) && (we.current = {
			value: r,
			index: n
		}, et.state.onItemHighlighted(r, vn("none", void 0, { index: n })));
	}, [
		at,
		Ie,
		Fe,
		Pe,
		$e,
		ft,
		Ue,
		et
	]), W(() => {
		if (c === "none") {
			B(String(Ve) !== "");
			return;
		}
		B(je ? Array.isArray(Le) && Le.length > 0 : Le != null);
	}, [
		B,
		c,
		Ve,
		Le,
		je
	]), S.useEffect(() => {
		Pe && Ie && $e.length === 0 && St({ activeIndex: null });
	}, [
		Pe,
		Ie,
		$e.length,
		St
	]), gi(Ke, () => {
		!Ue || Ke === "" || Ke === String(Be) || le(!0);
	}), gi(Le, () => {
		if (c !== "none" && (ee(Ae), R(Le !== z.initialValue), te() ? oe.commit(Le) : oe.commit(Le, !0), Me && !Ne && !pt)) {
			let e = ad(Le, E);
			Ve !== e && Ct(e, K("none"));
		}
	}), gi(Ve, () => {
		c === "none" && (ee(Ae), R(Ve !== z.initialValue), te() ? oe.commit(Ve) : oe.commit(Ve, !0));
	}), gi(g, () => {
		if (!Me || Ne || pt || ce) return;
		let e = ad(Le, E);
		Ve !== e && Ct(e, K("none"));
	});
	let Nt = Pu({
		open: ft ? !0 : Ue,
		onOpenChange: wt,
		elements: {
			reference: pt ? lt : ut,
			floating: st
		}
	}), Pt, Ft;
	ft || (Pt = h ? "grid" : "listbox", Ft = Ue ? "true" : "false");
	let { getReferenceProps: It, getFloatingProps: Lt, getItemProps: Rt } = ui([
		S.useMemo(() => {
			let e = ut?.tagName === "INPUT", t = ut == null || e, n = t || Ue, r = t ? {
				autoComplete: "off",
				spellCheck: "false",
				autoCorrect: "off",
				autoCapitalize: "none"
			} : {};
			return n && (r.role = "combobox", r["aria-expanded"] = Ft, r["aria-haspopup"] = Pt, r["aria-controls"] = Ue ? ct?.id : void 0, r["aria-autocomplete"] = P), {
				reference: r,
				floating: { role: "presentation" }
			};
		}, [
			ut,
			Ue,
			Ft,
			Pt,
			ct?.id,
			P
		]),
		Nu(Nt, {
			enabled: !f && !ke && y,
			event: "mousedown-only",
			toggle: !1,
			touchOpenDelay: pt ? 0 : 50,
			reason: dn
		}),
		Gn(Nt, {
			enabled: !f && !ke && !ft,
			outsidePressEvent: {
				mouse: "sloppy",
				touch: "intentional"
			},
			bubbles: ft ? !0 : void 0,
			outsidePress(e) {
				let t = Gt(e);
				return !G(lt, t) && !G(Se.current, t) && !G(xe.current, t) && !G(dt, t);
			}
		}),
		Vu(Nt, {
			enabled: !f && !ke,
			id: H,
			listRef: fe,
			activeIndex: at,
			selectedIndex: ot,
			virtual: !0,
			loopFocus: T,
			allowEscape: T && !Ie,
			focusItemOnOpen: ce || c === "none" && !Ie ? !1 : "auto",
			focusItemOnHover: w,
			resetOnPointerLeave: !x,
			cols: h ? 2 : 1,
			orientation: h ? "horizontal" : void 0,
			disabledIndices: Dt,
			onNavigate(e, t) {
				!t && !Ue || _t === "ending" || St(t ? {
					activeIndex: e,
					type: ye.current ? "keyboard" : "pointer"
				} : { activeIndex: e });
			}
		})
	]);
	Hu(() => {
		et.update({
			inline: A,
			popupProps: Lt(),
			inputProps: It(),
			triggerProps: yt,
			getItemProps: Rt,
			setOpen: wt,
			setInputValue: Ct,
			setSelectedValue: Tt,
			setIndices: St,
			onItemHighlighted: rt,
			handleSelection: kt,
			forceMount: bt,
			requestSubmit: At
		});
	}), W(() => {
		et.update({
			id: H,
			selectedValue: Le,
			open: Ue,
			mounted: ht,
			transitionStatus: _t,
			items: g,
			inline: A,
			popupProps: Lt(),
			inputProps: It(),
			triggerProps: yt,
			openMethod: vt,
			getItemProps: Rt,
			selectionMode: c,
			name: Ae,
			disabled: ke,
			readOnly: f,
			required: p,
			grid: h,
			isGrouped: Ge,
			virtualized: k,
			onOpenChangeComplete: it,
			openOnInputClick: y,
			itemToStringLabel: E,
			modal: M,
			autoHighlight: Ie,
			isItemEqualToValue: O,
			submitOnItemClick: L,
			hasInputValue: Ne,
			requestSubmit: At
		});
	}, [
		et,
		H,
		Le,
		Ue,
		ht,
		_t,
		g,
		Lt,
		It,
		Rt,
		vt,
		yt,
		c,
		Ae,
		ke,
		f,
		p,
		oe,
		h,
		Ge,
		k,
		it,
		y,
		E,
		M,
		O,
		L,
		Ne,
		A,
		At,
		Ie
	]);
	let zt = Ai(m, oe.inputRef), Bt = S.useMemo(() => ({
		query: Ke,
		hasItems: Pe,
		filteredItems: Qe,
		flatFilteredItems: $e
	}), [
		Ke,
		Pe,
		Qe,
		$e
	]), Vt = S.useMemo(() => Array.isArray(tt) ? "" : od(tt, D), [tt, D]), Ht = je && Array.isArray(Le) && Le.length > 0, Ut = je || c === "none" ? void 0 : Ae, Wt = S.useMemo(() => !je || !Array.isArray(Le) || !Ae ? null : Le.map((e) => {
		let t = od(e, D);
		return /* @__PURE__ */ (0, C.jsx)("input", {
			type: "hidden",
			name: Ae,
			value: t
		}, t);
	}), [
		je,
		Le,
		Ae,
		D
	]), Kt = /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [
		e.children,
		/* @__PURE__ */ (0, C.jsx)("input", {
			...oe.getInputValidationProps({
				onFocus() {
					if (pt) {
						lt?.focus();
						return;
					}
					(he.current || lt)?.focus();
				},
				onChange(e) {
					if (e.nativeEvent.defaultPrevented) return;
					let t = e.target.value, n = K(Qt, e.nativeEvent);
					function r() {
						if (je) return;
						if (c === "none") {
							R(t !== z.initialValue), Ct(t, n), te() && oe.commit(t);
							return;
						}
						let e = De.current.find((e) => od(e, D).toLowerCase() === t.toLowerCase());
						e != null && (R(e !== z.initialValue), Tt?.(e, n), te() && oe.commit(e));
					}
					g ? r() : (bt(), queueMicrotask(r));
				}
			}),
			id: H && Ut == null ? `${H}-hidden-input` : void 0,
			name: Ut,
			autoComplete: F,
			disabled: ke,
			required: p && !Ht,
			readOnly: f,
			value: Vt,
			ref: zt,
			style: Ut ? ns : ts,
			tabIndex: -1,
			"aria-hidden": !0
		}),
		Wt
	] });
	return /* @__PURE__ */ (0, C.jsx)(Uu.Provider, {
		value: et,
		children: /* @__PURE__ */ (0, C.jsx)(Wu.Provider, {
			value: Nt,
			children: /* @__PURE__ */ (0, C.jsx)(Gu.Provider, {
				value: Bt,
				children: /* @__PURE__ */ (0, C.jsx)(Ku.Provider, {
					value: Ve,
					children: Kt
				})
			})
		})
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/root/ComboboxRoot.js
function yd(e) {
	let { multiple: t = !1, defaultValue: n, value: r, onValueChange: i, autoComplete: a, ...o } = e;
	return /* @__PURE__ */ (0, C.jsx)(vd, {
		...o,
		selectionMode: t ? "multiple" : "single",
		selectedValue: r,
		defaultSelectedValue: n,
		onSelectedValueChange: i,
		formAutoComplete: a
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/combobox/context.js
var bd = (0, S.createContext)(void 0);
function xd() {
	let e = (0, S.useContext)(bd);
	if (e === void 0) throw Error("useComboboxContext must be used within a Combobox parent component");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/resolveAriaLabelledBy.js
function Sd(e, t) {
	return e ?? t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/utils/stateAttributesMapping.js
var Cd = {
	...pa,
	...Wl,
	popupSide: (e) => e ? { "data-popup-side": e } : null,
	listEmpty: (e) => e ? { "data-list-empty": "" } : null
}, wd = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (wd.displayName = "ComboboxChipsContext");
function Td() {
	return S.useContext(wd);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/positioner/ComboboxPositionerContext.js
var Ed = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ed.displayName = "ComboboxPositionerContext");
function Dd(e) {
	let t = S.useContext(Ed);
	if (t === void 0 && !e) throw Error(process.env.NODE_ENV === "production" ? lr(21) : "Base UI: <Combobox.Popup> and <Combobox.Arrow> must be used within the <Combobox.Positioner> component");
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/direction-provider/DirectionContext.js
var Od = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Od.displayName = "DirectionContext");
function kd() {
	return S.useContext(Od)?.direction ?? "ltr";
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/utils/ComboboxInternalDismissButton.js
var Ad = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let n = qu(), { buttonRef: r, getButtonProps: i } = iu({ native: !1 });
	return /* @__PURE__ */ (0, C.jsx)("span", {
		ref: Ai(t, r),
		...i({ onClick: U((e) => {
			n.state.setOpen(!1, K(an, e.nativeEvent, e.currentTarget));
		}) }),
		"aria-label": "Dismiss",
		tabIndex: void 0,
		style: ns
	});
});
process.env.NODE_ENV !== "production" && (Ad.displayName = "ComboboxInternalDismissButton");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/input/ComboboxInput.js
var jd = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, disabled: i = !1, id: a, ...o } = e, { state: s, disabled: c, setTouched: l, setFocused: u, validationMode: d, validation: f } = Kl(), { labelId: p } = Jl(), m = Td(), h = !!Dd(!0), g = qu(), { filteredItems: _ } = Yu(), v = Xu(), y = kd(), b = J(g, Z.required), x = J(g, Z.disabled), w = J(g, Z.readOnly), T = J(g, Z.name), E = J(g, Z.selectionMode), D = J(g, Z.autoHighlight), O = J(g, Z.inputProps), k = J(g, Z.triggerProps), A = J(g, Z.open), j = J(g, Z.mounted), M = J(g, Z.selectedValue), N = J(g, Z.popupSide), P = J(g, Z.positionerElement), F = J(g, Z.id), I = J(g, Z.inline), L = J(g, Z.modal), ee = !!D, R = j && P ? N : null, z = c || x || i, te = _.length === 0, B = h || I, V = !B || L, ne = Il(a ?? (B ? void 0 : F)), re = Sd(p, void 0), ie = h ? Hl : s, [ae, oe] = S.useState(null), H = S.useRef(!1), se = S.useRef(null), ce = S.useRef(!1), le = U((e) => {
		let t = h || g.state.inline;
		t && !g.state.hasInputValue && g.state.setInputValue("", K("none")), g.update({
			inputElement: e,
			inputInsidePopup: t
		});
	}), ue = h || !f ? o : f.getValidationProps(o), de = {
		...ie,
		open: A,
		disabled: z,
		readOnly: w,
		popupSide: R,
		listEmpty: te
	};
	function fe(e) {
		if (!m) return;
		let t, { highlightedChipIndex: n } = m;
		if (n !== void 0) {
			if (e.key === "ArrowLeft") e.preventDefault(), t = n > 0 ? n - 1 : void 0;
			else if (e.key === "ArrowRight") e.preventDefault(), t = n < M.length - 1 ? n + 1 : void 0;
			else if (e.key === "Backspace" || e.key === "Delete") {
				e.preventDefault();
				let r = n >= M.length - 1 ? M.length - 2 : n;
				t = r >= 0 ? r : void 0, g.state.setIndices({
					activeIndex: null,
					selectedIndex: null,
					type: "keyboard"
				});
			}
			return t;
		}
		return e.key === "ArrowLeft" && (e.currentTarget.selectionStart ?? 0) === 0 && M.length > 0 ? (e.preventDefault(), t = Math.max(M.length - 1, 0)) : e.key === "Backspace" && e.currentTarget.value === "" && M.length > 0 && (g.state.setIndices({
			activeIndex: null,
			selectedIndex: null,
			type: "keyboard"
		}), e.preventDefault()), t;
	}
	let pe = Y("input", e, {
		state: de,
		ref: [
			t,
			g.state.inputRef,
			le
		],
		props: [
			O,
			k,
			{
				type: "text",
				value: e.value ?? ae ?? v,
				"aria-readonly": w || void 0,
				"aria-required": b || void 0,
				"aria-labelledby": re,
				disabled: z,
				readOnly: w,
				required: E === "none" ? b : void 0,
				...E === "none" && T && { name: T },
				id: ne,
				onFocus() {
					if (u(!0), !I || !ce.current) return;
					ce.current = !1;
					let e = se.current;
					e == null || !Object.hasOwn(g.state.valuesRef.current, e) || g.state.setIndices({ activeIndex: e });
				},
				onBlur() {
					l(!0), u(!1);
					let e = g.state.activeIndex;
					if (I && e !== null && D !== "always" && (se.current = e, ce.current = !0, g.state.setIndices({ activeIndex: null })), d === "onBlur") {
						let e = E === "none" ? v : M;
						f.commit(e);
					}
				},
				onCompositionStart(e) {
					lt || (H.current = !0, oe(e.currentTarget.value));
				},
				onCompositionEnd(e) {
					H.current = !1;
					let t = e.currentTarget.value;
					oe(null), g.state.setInputValue(t, K(cn, e.nativeEvent));
				},
				onChange(e) {
					let t = e.nativeEvent.inputType, n = !t || t === "insertReplacementText", r = H.current || !n;
					if (H.current) {
						let t = e.currentTarget.value;
						oe(t), t === "" && !g.state.openOnInputClick && !g.state.inputInsidePopup && g.state.setOpen(!1, K("input-clear", e.nativeEvent));
						let n = t.trim(), i = ee && n !== "";
						!w && !z && n && r && (g.state.setOpen(!0, K("input-change", e.nativeEvent)), ee || g.state.setIndices({
							activeIndex: null,
							selectedIndex: null,
							type: g.state.keyboardActiveRef.current ? "keyboard" : "pointer"
						})), A && g.state.activeIndex !== null && !i && g.state.setIndices({
							activeIndex: null,
							selectedIndex: null,
							type: g.state.keyboardActiveRef.current ? "keyboard" : "pointer"
						});
						return;
					}
					g.state.setInputValue(e.currentTarget.value, K(cn, e.nativeEvent));
					let i = e.currentTarget.value === "", a = K(ln, e.nativeEvent);
					i && !g.state.inputInsidePopup && (E === "single" && g.state.setSelectedValue(null, a), g.state.openOnInputClick || g.state.setOpen(!1, a));
					let o = e.currentTarget.value.trim();
					!w && !z && o && r && (g.state.setOpen(!0, K("input-change", e.nativeEvent)), ee || g.state.setIndices({
						activeIndex: null,
						selectedIndex: null,
						type: g.state.keyboardActiveRef.current ? "keyboard" : "pointer"
					})), A && g.state.activeIndex !== null && !ee && g.state.setIndices({
						activeIndex: null,
						selectedIndex: null,
						type: g.state.keyboardActiveRef.current ? "keyboard" : "pointer"
					});
				},
				onKeyDown(e) {
					if (z || w || e.ctrlKey || e.shiftKey || e.altKey || e.metaKey) return;
					g.state.keyboardActiveRef.current = !0;
					let t = e.currentTarget, n = t.scrollWidth - t.clientWidth, r = y === "rtl";
					if (e.key === "Home") {
						xn(e);
						let n = st && r ? t.value.length : 0;
						t.setSelectionRange(n, n), t.scrollLeft = 0;
						return;
					}
					if (e.key === "End") {
						xn(e);
						let i = st && r ? 0 : t.value.length;
						t.setSelectionRange(i, i), t.scrollLeft = r ? -n : n;
						return;
					}
					if (!j && e.key === "Escape") {
						let t = E === "multiple" && Array.isArray(M) ? M.length === 0 : M === null, n = K(pn, e.nativeEvent), r = E === "multiple" ? [] : null;
						g.state.setInputValue("", n), g.state.setSelectedValue(r, n), !t && !g.state.inline && !n.isPropagationAllowed && e.stopPropagation();
						return;
					}
					if (m && e.key === "Backspace" && t.value === "" && m.highlightedChipIndex === void 0 && Array.isArray(M) && M.length > 0) {
						let t = M.slice(0, -1);
						g.state.setIndices({
							activeIndex: null,
							selectedIndex: null,
							type: g.state.keyboardActiveRef.current ? "keyboard" : "pointer"
						}), g.state.setSelectedValue(t, K(Qt, e.nativeEvent));
						return;
					}
					let i = m?.highlightedChipIndex !== void 0, a = fe(e);
					if (m?.setHighlightedChipIndex(a), a === void 0 ? i && g.state.inputRef.current?.focus() : m?.chipsRef.current[a]?.focus(), e.which !== 229 && e.key === "Enter" && A) {
						let t = g.state.activeIndex, n = e.nativeEvent;
						if (t === null) {
							if (I) return;
							g.state.setOpen(!1, K(Qt, n));
							return;
						}
						xn(e);
						let r = g.state.listRef.current[t];
						r && (g.state.selectionEventRef.current = n, r.click(), g.state.selectionEventRef.current = null);
					}
				},
				onPointerMove() {
					g.state.keyboardActiveRef.current = !1;
				},
				onPointerDown() {
					g.state.keyboardActiveRef.current = !1;
				}
			},
			ue
		],
		stateAttributesMapping: Cd
	});
	return /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [A && V && /* @__PURE__ */ (0, C.jsx)(Ad, { ref: g.state.startDismissRef }), pe] });
});
process.env.NODE_ENV !== "production" && (jd.displayName = "ComboboxInput");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/collection/GroupCollectionContext.js
var Md = /* @__PURE__ */ S.createContext(null);
process.env.NODE_ENV !== "production" && (Md.displayName = "GroupCollectionContext");
function Nd() {
	return S.useContext(Md);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/collection/ComboboxCollection.js
function Pd(e) {
	let { children: t } = e, { filteredItems: n } = Yu(), r = Nd(), i = r ? r.items : n;
	return i ? /* @__PURE__ */ (0, C.jsx)(S.Fragment, { children: i.map(t) }) : null;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/composite/list/CompositeListContext.js
var Fd = /* @__PURE__ */ S.createContext({
	register: () => {},
	unregister: () => {},
	subscribeMapChange: () => () => {},
	elementsRef: { current: [] },
	nextIndexRef: { current: 0 }
});
process.env.NODE_ENV !== "production" && (Fd.displayName = "CompositeListContext");
function Id() {
	return S.useContext(Fd);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/composite/list/CompositeList.js
function Ld(e) {
	let { children: t, elementsRef: n, labelsRef: r, onMapChange: i } = e, a = U(i), o = S.useRef(0), s = Te(zd).current, c = Te(Rd).current, [l, u] = S.useState(0), d = S.useRef(l), f = U((e, t) => {
		c.set(e, t ?? null), d.current += 1, u(d.current);
	}), p = U((e) => {
		c.delete(e), d.current += 1, u(d.current);
	}), m = S.useMemo(() => {
		let e = /* @__PURE__ */ new Map();
		return Array.from(c.keys()).filter((e) => e.isConnected).sort(Bd).forEach((t, n) => {
			let r = c.get(t) ?? {};
			e.set(t, {
				...r,
				index: n
			});
		}), e;
	}, [c, l]);
	W(() => {
		if (typeof MutationObserver != "function" || m.size === 0) return;
		let e = new MutationObserver((e) => {
			let t = /* @__PURE__ */ new Set(), n = (e) => t.has(e) ? t.delete(e) : t.add(e);
			e.forEach((e) => {
				e.removedNodes.forEach(n), e.addedNodes.forEach(n);
			}), t.size === 0 && (d.current += 1, u(d.current));
		});
		return m.forEach((t, n) => {
			n.parentElement && e.observe(n.parentElement, { childList: !0 });
		}), () => {
			e.disconnect();
		};
	}, [m]), W(() => {
		d.current === l && (n.current.length !== m.size && (n.current.length = m.size), r && r.current.length !== m.size && (r.current.length = m.size), o.current = m.size), a(m);
	}, [
		a,
		m,
		n,
		r,
		l
	]), W(() => () => {
		n.current = [];
	}, [n]), W(() => () => {
		r && (r.current = []);
	}, [r]);
	let h = U((e) => (s.add(e), () => {
		s.delete(e);
	}));
	W(() => {
		s.forEach((e) => e(m));
	}, [s, m]);
	let g = S.useMemo(() => ({
		register: f,
		unregister: p,
		subscribeMapChange: h,
		elementsRef: n,
		labelsRef: r,
		nextIndexRef: o
	}), [
		f,
		p,
		h,
		n,
		r,
		o
	]);
	return /* @__PURE__ */ (0, C.jsx)(Fd.Provider, {
		value: g,
		children: t
	});
}
function Rd() {
	return /* @__PURE__ */ new Map();
}
function zd() {
	return /* @__PURE__ */ new Set();
}
function Bd(e, t) {
	let n = e.compareDocumentPosition(t);
	return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/list/ComboboxList.js
var Vd = /* @__PURE__ */ S.forwardRef(function(e, t) {
	var n;
	let { render: r, className: i, children: a, ...o } = e, s = qu(), c = Ju(), l = !!Dd(!0), { filteredItems: u } = Yu(), d = J(s, Z.items), f = J(s, Z.labelsRef), p = J(s, Z.listRef), m = J(s, Z.selectionMode), h = J(s, Z.grid), g = J(s, Z.popupProps), _ = J(s, Z.disabled), v = J(s, Z.readOnly), y = J(s, Z.virtualized), b = m === "multiple", x = u.length === 0, w = U((e) => {
		s.set("positionerElement", e);
	}), T = U((e) => {
		s.set("listElement", e);
	}), E = S.useMemo(() => typeof a == "function" ? n ||= /* @__PURE__ */ (0, C.jsx)(Pd, { children: a }) : a, [a]), D = { empty: x }, O = c.useState("floatingId"), k = Y("div", e, {
		state: D,
		ref: [
			t,
			T,
			l ? null : w
		],
		props: [
			g,
			{
				children: E,
				tabIndex: -1,
				id: O,
				role: h ? "grid" : "listbox",
				"aria-multiselectable": b ? "true" : void 0,
				onKeyDown(e) {
					if (!(_ || v) && e.key === "Enter") {
						let t = s.state.activeIndex;
						if (t == null) return;
						xn(e);
						let n = e.nativeEvent, r = s.state.listRef.current[t];
						r && (s.state.selectionEventRef.current = n, r.click(), s.state.selectionEventRef.current = null);
					}
				},
				onKeyDownCapture() {
					s.state.keyboardActiveRef.current = !0;
				},
				onPointerMoveCapture() {
					s.state.keyboardActiveRef.current = !1;
				}
			},
			o
		]
	});
	return y ? k : /* @__PURE__ */ (0, C.jsx)(Ld, {
		elementsRef: p,
		labelsRef: d ? void 0 : f,
		children: k
	});
});
process.env.NODE_ENV !== "production" && (Vd.displayName = "ComboboxList");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/portal/ComboboxPortalContext.js
var Hd = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Hd.displayName = "ComboboxPortalContext");
function Ud() {
	let e = S.useContext(Hd);
	if (e === void 0) throw Error(process.env.NODE_ENV === "production" ? lr(20) : "Base UI: <Combobox.Portal> is missing.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/portal/ComboboxPortal.js
var Wd = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { keepMounted: n = !1, ...r } = e, i = qu(), a = J(i, Z.mounted), o = J(i, Z.forceMounted);
	return a || n || o ? /* @__PURE__ */ (0, C.jsx)(Hd.Provider, {
		value: n,
		children: /* @__PURE__ */ (0, C.jsx)(Ss, {
			ref: t,
			...r
		})
	}) : null;
});
process.env.NODE_ENV !== "production" && (Wd.displayName = "ComboboxPortal");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@floating-ui_core@1.7.5/node_modules/@floating-ui/core/dist/floating-ui.core.js
function Gd(e, t, n) {
	let { reference: r, floating: i } = e, a = Aa(t), o = ja(t), s = ka(o), c = Ea(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (Da(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end":
			p[o] += f * (n && l ? -1 : 1);
			break;
	}
	return p;
}
async function Kd(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = Ta(t, e), p = Ua(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = Wa(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = Wa(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var qd = 50, Jd = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = o.detectOverflow ? o : {
		...o,
		detectOverflow: Kd
	}, c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = Gd(l, r, c), f = r, p = 0, m = {};
	for (let n = 0; n < a.length; n++) {
		let h = a[n];
		if (!h) continue;
		let { name: g, fn: _ } = h, { x: v, y, data: b, reset: x } = await _({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: m,
			rects: l,
			platform: s,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = v ?? u, d = y ?? d, m[g] = {
			...m[g],
			...b
		}, x && p < qd && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : x.rects), {x: u, y: d} = Gd(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: m
	};
}, Yd = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = Ta(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = Ea(r), _ = Aa(o), v = Ea(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [Va(o)] : Na(o)), x = p !== "none";
			!d && x && b.push(...Ba(o, m, p, y));
			let S = [o, ...b], C = await s.detectOverflow(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = Ma(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (!(u === "alignment" && _ !== Aa(t)) || T.every((e) => Aa(e.placement) === _ ? e.overflows[0] > 0 : !0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = Aa(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement":
						n = o;
						break;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
};
function Xd(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function Zd(e) {
	return _a.some((t) => e[t] >= 0);
}
var Qd = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n, platform: r } = t, { strategy: i = "referenceHidden", ...a } = Ta(e, t);
			switch (i) {
				case "referenceHidden": {
					let e = Xd(await r.detectOverflow(t, {
						...a,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: Zd(e)
					} };
				}
				case "escaped": {
					let e = Xd(await r.detectOverflow(t, {
						...a,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: Zd(e)
					} };
				}
				default: return {};
			}
		}
	};
}, $d = /* @__PURE__ */ new Set(["left", "top"]);
async function ef(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = Ea(n), s = Da(n), c = Aa(n) === "y", l = $d.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = Ta(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var tf = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await ef(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, nf = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i, platform: a } = t, { mainAxis: o = !0, crossAxis: s = !1, limiter: c = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...l } = Ta(e, t), u = {
				x: n,
				y: r
			}, d = await a.detectOverflow(t, l), f = Aa(Ea(i)), p = Oa(f), m = u[p], h = u[f];
			if (o) {
				let e = p === "y" ? "top" : "left", t = p === "y" ? "bottom" : "right", n = m + d[e], r = m - d[t];
				m = wa(n, m, r);
			}
			if (s) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = h + d[e], r = h - d[t];
				h = wa(n, h, r);
			}
			let g = c.fn({
				...t,
				[p]: m,
				[f]: h
			});
			return {
				...g,
				data: {
					x: g.x - n,
					y: g.y - r,
					enabled: {
						[p]: o,
						[f]: s
					}
				}
			};
		}
	};
}, rf = function(e) {
	return e === void 0 && (e = {}), {
		options: e,
		fn(t) {
			let { x: n, y: r, placement: i, rects: a, middlewareData: o } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = Ta(e, t), u = {
				x: n,
				y: r
			}, d = Aa(i), f = Oa(d), p = u[f], m = u[d], h = Ta(s, t), g = typeof h == "number" ? {
				mainAxis: h,
				crossAxis: 0
			} : {
				mainAxis: 0,
				crossAxis: 0,
				...h
			};
			if (c) {
				let e = f === "y" ? "height" : "width", t = a.reference[f] - a.floating[e] + g.mainAxis, n = a.reference[f] + a.reference[e] - g.mainAxis;
				p < t ? p = t : p > n && (p = n);
			}
			if (l) {
				let e = f === "y" ? "width" : "height", t = $d.has(Ea(i)), n = a.reference[d] - a.floating[e] + (t && o.offset?.[d] || 0) + (t ? 0 : g.crossAxis), r = a.reference[d] + a.reference[e] + (t ? 0 : o.offset?.[d] || 0) - (t ? g.crossAxis : 0);
				m < n ? m = n : m > r && (m = r);
			}
			return {
				[f]: p,
				[d]: m
			};
		}
	};
}, af = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			var n, r;
			let { placement: i, rects: a, platform: o, elements: s } = t, { apply: c = () => {}, ...l } = Ta(e, t), u = await o.detectOverflow(t, l), d = Ea(i), f = Da(i), p = Aa(i) === "y", { width: m, height: h } = a.floating, g, _;
			d === "top" || d === "bottom" ? (g = d, _ = f === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (_ = d, g = f === "end" ? "top" : "bottom");
			let v = h - u.top - u.bottom, y = m - u.left - u.right, b = va(h - u[g], v), x = va(m - u[_], y), S = !t.middlewareData.shift, C = b, w = x;
			if ((n = t.middlewareData.shift) != null && n.enabled.x && (w = y), (r = t.middlewareData.shift) != null && r.enabled.y && (C = v), S && !f) {
				let e = ya(u.left, 0), t = ya(u.right, 0), n = ya(u.top, 0), r = ya(u.bottom, 0);
				p ? w = m - 2 * (e !== 0 || t !== 0 ? e + t : ya(u.left, u.right)) : C = h - 2 * (n !== 0 || r !== 0 ? n + r : ya(u.top, u.bottom));
			}
			await c({
				...t,
				availableWidth: w,
				availableHeight: C
			});
			let T = await o.getDimensions(s.floating);
			return m !== T.width || h !== T.height ? { reset: { rects: !0 } } : {};
		}
	};
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@floating-ui_dom@1.7.6/node_modules/@floating-ui/dom/dist/floating-ui.dom.js
function of(e) {
	let t = Ye(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = Ie(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = ba(n) !== a || ba(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function sf(e) {
	return Fe(e) ? e : e.contextElement;
}
function cf(e) {
	let t = sf(e);
	if (!Ie(t)) return Sa(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = of(t), o = (a ? ba(n.width) : n.width) / r, s = (a ? ba(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var lf = /* @__PURE__ */ Sa(0);
function uf(e) {
	let t = Me(e);
	return !qe() || !t.visualViewport ? lf : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function df(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== Me(e) ? !1 : t;
}
function ff(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = sf(e), o = Sa(1);
	t && (r ? Fe(r) && (o = cf(r)) : o = cf(e));
	let s = df(a, n, r) ? uf(a) : Sa(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = Me(a), t = r && Fe(r) ? Me(r) : r, n = e, i = et(n);
		for (; i && r && t !== n;) {
			let e = cf(i), t = i.getBoundingClientRect(), r = Ye(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = Me(i), i = et(n);
		}
	}
	return Wa({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function pf(e, t) {
	let n = Xe(e).scrollLeft;
	return t ? t.left + n : ff(Ne(e)).left + n;
}
function mf(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - pf(e, n),
		y: n.top + t.scrollTop
	};
}
function hf(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = Ne(r), s = t ? Be(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = Sa(1), u = Sa(0), d = Ie(r);
	if ((d || !d && !a) && ((je(r) !== "body" || Re(o)) && (c = Xe(r)), d)) {
		let e = ff(r);
		l = cf(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? mf(o, c) : Sa(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function gf(e) {
	return Array.from(e.getClientRects());
}
function _f(e) {
	let t = Ne(e), n = Xe(e), r = e.ownerDocument.body, i = ya(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = ya(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + pf(e), s = -n.scrollTop;
	return Ye(r).direction === "rtl" && (o += ya(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
var vf = 25;
function yf(e, t) {
	let n = Me(e), r = Ne(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = qe();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	let l = pf(r);
	if (l <= 0) {
		let e = r.ownerDocument, t = e.body, n = getComputedStyle(t), i = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, o = Math.abs(r.clientWidth - t.clientWidth - i);
		o <= vf && (a -= o);
	} else l <= vf && (a += l);
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
function bf(e, t) {
	let n = ff(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Ie(e) ? cf(e) : Sa(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function xf(e, t, n) {
	let r;
	if (t === "viewport") r = yf(e, n);
	else if (t === "document") r = _f(Ne(e));
	else if (Fe(t)) r = bf(t, n);
	else {
		let n = uf(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return Wa(r);
}
function Sf(e, t) {
	let n = Ze(e);
	return n === t || !Fe(n) || Je(n) ? !1 : Ye(n).position === "fixed" || Sf(n, t);
}
function Cf(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = $e(e, [], !1).filter((e) => Fe(e) && je(e) !== "body"), i = null, a = Ye(e).position === "fixed", o = a ? Ze(e) : e;
	for (; Fe(o) && !Je(o);) {
		let t = Ye(o), n = Ge(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && (i.position === "absolute" || i.position === "fixed") || Re(o) && !n && Sf(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = Ze(o);
	}
	return t.set(e, r), r;
}
function wf(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Be(t) ? [] : Cf(t, this._c) : [].concat(n), r], o = xf(t, a[0], i), s = o.top, c = o.right, l = o.bottom, u = o.left;
	for (let e = 1; e < a.length; e++) {
		let n = xf(t, a[e], i);
		s = ya(n.top, s), c = va(n.right, c), l = va(n.bottom, l), u = ya(n.left, u);
	}
	return {
		width: c - u,
		height: l - s,
		x: u,
		y: s
	};
}
function Tf(e) {
	let { width: t, height: n } = of(e);
	return {
		width: t,
		height: n
	};
}
function Ef(e, t, n) {
	let r = Ie(t), i = Ne(t), a = n === "fixed", o = ff(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = Sa(0);
	function l() {
		c.x = pf(i);
	}
	if (r || !r && !a) if ((je(t) !== "body" || Re(i)) && (s = Xe(t)), r) {
		let e = ff(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	} else i && l();
	a && !r && i && l();
	let u = i && !r && !a ? mf(i, s) : Sa(0);
	return {
		x: o.left + s.scrollLeft - c.x - u.x,
		y: o.top + s.scrollTop - c.y - u.y,
		width: o.width,
		height: o.height
	};
}
function Df(e) {
	return Ye(e).position === "static";
}
function Of(e, t) {
	if (!Ie(e) || Ye(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return Ne(e) === n && (n = n.ownerDocument.body), n;
}
function kf(e, t) {
	let n = Me(e);
	if (Be(e)) return n;
	if (!Ie(e)) {
		let t = Ze(e);
		for (; t && !Je(t);) {
			if (Fe(t) && !Df(t)) return t;
			t = Ze(t);
		}
		return n;
	}
	let r = Of(e, t);
	for (; r && ze(r) && Df(r);) r = Of(r, t);
	return r && Je(r) && Df(r) && !Ge(r) ? n : r || Ke(e) || n;
}
var Af = async function(e) {
	let t = this.getOffsetParent || kf, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: Ef(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function jf(e) {
	return Ye(e).direction === "rtl";
}
var Mf = {
	convertOffsetParentRelativeRectToViewportRelativeRect: hf,
	getDocumentElement: Ne,
	getClippingRect: wf,
	getOffsetParent: kf,
	getElementRects: Af,
	getClientRects: gf,
	getDimensions: Tf,
	getScale: cf,
	isElement: Fe,
	isRTL: jf
};
function Nf(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Pf(e, t) {
	let n = null, r, i = Ne(e);
	function a() {
		var e;
		clearTimeout(r), (e = n) == null || e.disconnect(), n = null;
	}
	function o(s, c) {
		s === void 0 && (s = !1), c === void 0 && (c = 1), a();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (s || t(), !f || !p) return;
		let m = xa(d), h = xa(i.clientWidth - (u + f)), g = xa(i.clientHeight - (d + p)), _ = xa(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: ya(0, va(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (n !== c) {
				if (!y) return o();
				n ? o(!1, n) : r = setTimeout(() => {
					o(!1, 1e-7);
				}, 1e3);
			}
			n === 1 && !Nf(l, e.getBoundingClientRect()) && o(), y = !1;
		}
		try {
			n = new IntersectionObserver(b, {
				...v,
				root: i.ownerDocument
			});
		} catch {
			n = new IntersectionObserver(b, v);
		}
		n.observe(e);
	}
	return o(!0), a;
}
function Ff(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = sf(e), u = i || a ? [...l ? $e(l) : [], ...t ? $e(t) : []] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n, { passive: !0 }), a && e.addEventListener("resize", n);
	});
	let d = l && s ? Pf(l, n) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && t && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), t && p.observe(t));
	let m, h = c ? ff(e) : null;
	c && g();
	function g() {
		let t = ff(e);
		h && !Nf(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var Q = tf, If = nf, Lf = Yd, Rf = af, zf = Qd, Bf = rf, Vf = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: Mf,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return Jd(e, t, {
		...i,
		platform: a
	});
}, Hf = typeof document < "u" ? S.useLayoutEffect : function() {};
function Uf(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n !== t.length) return !1;
			for (r = n; r-- !== 0;) if (!Uf(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !Uf(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function Wf(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Gf(e, t) {
	let n = Wf(e);
	return Math.round(t * n) / n;
}
function Kf(e) {
	let t = S.useRef(e);
	return Hf(() => {
		t.current = e;
	}), t;
}
function qf(e) {
	e === void 0 && (e = {});
	let { placement: t = "bottom", strategy: n = "absolute", middleware: r = [], platform: i, elements: { reference: a, floating: o } = {}, transform: s = !0, whileElementsMounted: c, open: l } = e, [u, d] = S.useState({
		x: 0,
		y: 0,
		strategy: n,
		placement: t,
		middlewareData: {},
		isPositioned: !1
	}), [f, p] = S.useState(r);
	Uf(f, r) || p(r);
	let [m, h] = S.useState(null), [g, _] = S.useState(null), v = S.useCallback((e) => {
		e !== C.current && (C.current = e, h(e));
	}, []), y = S.useCallback((e) => {
		e !== w.current && (w.current = e, _(e));
	}, []), b = a || m, x = o || g, C = S.useRef(null), w = S.useRef(null), T = S.useRef(u), E = c != null, D = Kf(c), O = Kf(i), k = Kf(l), A = S.useCallback(() => {
		if (!C.current || !w.current) return;
		let e = {
			placement: t,
			strategy: n,
			middleware: f
		};
		O.current && (e.platform = O.current), Vf(C.current, w.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: k.current !== !1
			};
			j.current && !Uf(T.current, t) && (T.current = t, tr.flushSync(() => {
				d(t);
			}));
		});
	}, [
		f,
		t,
		n,
		O,
		k
	]);
	Hf(() => {
		l === !1 && T.current.isPositioned && (T.current.isPositioned = !1, d((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [l]);
	let j = S.useRef(!1);
	Hf(() => (j.current = !0, () => {
		j.current = !1;
	}), []), Hf(() => {
		if (b && (C.current = b), x && (w.current = x), b && x) {
			if (D.current) return D.current(b, x, A);
			A();
		}
	}, [
		b,
		x,
		A,
		D,
		E
	]);
	let M = S.useMemo(() => ({
		reference: C,
		floating: w,
		setReference: v,
		setFloating: y
	}), [v, y]), N = S.useMemo(() => ({
		reference: b,
		floating: x
	}), [b, x]), P = S.useMemo(() => {
		let e = {
			position: n,
			left: 0,
			top: 0
		};
		if (!N.floating) return e;
		let t = Gf(N.floating, u.x), r = Gf(N.floating, u.y);
		return s ? {
			...e,
			transform: "translate(" + t + "px, " + r + "px)",
			...Wf(N.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: n,
			left: t,
			top: r
		};
	}, [
		n,
		s,
		N.floating,
		u.x,
		u.y
	]);
	return S.useMemo(() => ({
		...u,
		update: A,
		refs: M,
		elements: N,
		floatingStyles: P
	}), [
		u,
		A,
		M,
		N,
		P
	]);
}
var Jf = (e, t) => {
	let n = Q(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Yf = (e, t) => {
	let n = If(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Xf = (e, t) => ({
	fn: Bf(e).fn,
	options: [e, t]
}), Zf = (e, t) => {
	let n = Lf(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Qf = (e, t) => {
	let n = Rf(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, $f = (e, t) => {
	let n = zf(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useFloating.js
function ep(e = {}) {
	let { nodeId: t, externalTree: n } = e, r = Pu(e), i = e.rootContext || r, a = {
		reference: i.useState("referenceElement"),
		floating: i.useState("floatingElement"),
		domReference: i.useState("domReferenceElement")
	}, [o, s] = S.useState(null), c = S.useRef(null), l = Rn(n);
	W(() => {
		a.domReference && (c.current = a.domReference);
	}, [a.domReference]);
	let u = qf({
		...e,
		elements: {
			...a,
			...o && { reference: o }
		}
	}), d = S.useCallback((e) => {
		let t = Fe(e) ? {
			getBoundingClientRect: () => e.getBoundingClientRect(),
			getClientRects: () => e.getClientRects(),
			contextElement: e
		} : e;
		s(t), u.refs.setReference(t);
	}, [u.refs]), [f, p] = S.useState(null), [m, h] = S.useState(null);
	i.useSyncedValue("referenceElement", f), i.useSyncedValue("domReferenceElement", Fe(f) ? f : null), i.useSyncedValue("floatingElement", m);
	let g = S.useCallback((e) => {
		(Fe(e) || e === null) && (c.current = e, p(e)), (Fe(u.refs.reference.current) || u.refs.reference.current === null || e !== null && !Fe(e)) && u.refs.setReference(e);
	}, [u.refs, p]), _ = S.useCallback((e) => {
		h(e), u.refs.setFloating(e);
	}, [u.refs]), v = S.useMemo(() => ({
		...u.refs,
		setReference: g,
		setFloating: _,
		setPositionReference: d,
		domReference: c
	}), [
		u.refs,
		g,
		_,
		d
	]), y = S.useMemo(() => ({
		...u.elements,
		domReference: a.domReference
	}), [u.elements, a.domReference]), b = i.useState("open"), x = i.useState("floatingId"), C = S.useMemo(() => ({
		...u,
		dataRef: i.context.dataRef,
		open: b,
		onOpenChange: i.setOpen,
		events: i.context.events,
		floatingId: x,
		refs: v,
		elements: y,
		nodeId: t,
		rootStore: i
	}), [
		u,
		v,
		y,
		t,
		i,
		b,
		x
	]);
	return W(() => {
		i.context.dataRef.current.floatingContext = C;
		let e = l?.nodesRef.current.find((e) => e.id === t);
		e && (e.context = C);
	}), S.useMemo(() => ({
		...u,
		context: C,
		refs: v,
		elements: y,
		rootStore: i
	}), [
		u,
		v,
		y,
		C,
		i
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/middleware/arrow.js
var tp = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0, offsetParent: d = "real" } = Ta(e, t) || {};
		if (l == null) return {};
		let f = Ua(u), p = {
			x: n,
			y: r
		}, m = ja(i), h = ka(m), g = await o.getDimensions(l), _ = m === "y", v = _ ? "top" : "left", y = _ ? "bottom" : "right", b = _ ? "clientHeight" : "clientWidth", x = a.reference[h] + a.reference[m] - p[m] - a.floating[h], S = p[m] - a.reference[m], C = d === "real" ? await o.getOffsetParent?.(l) : s.floating, w = s.floating[b] || a.floating[h];
		(!w || !await o.isElement?.(C)) && (w = s.floating[b] || a.floating[h]);
		let T = x / 2 - S / 2, E = w / 2 - g[h] / 2 - 1, D = Math.min(f[v], E), O = Math.min(f[y], E), k = D, A = w - g[h] - O, j = w / 2 - g[h] / 2 + T, M = wa(k, j, A), N = !c.arrow && Da(i) != null && j !== M && a.reference[h] / 2 - (j < k ? D : O) - g[h] / 2 < 0, P = N ? j < k ? j - k : j - A : 0;
		return {
			[m]: p[m] + P,
			data: {
				[m]: M,
				centerOffset: j - M - P,
				...N && { alignmentOffset: P }
			},
			reset: N
		};
	}
}), np = (e, t) => ({
	...tp(e),
	options: [e, t]
}), rp = {
	name: "hide",
	async fn(e) {
		let { width: t, height: n, x: r, y: i } = e.rects.reference, a = t === 0 && n === 0 && r === 0 && i === 0;
		return { data: { referenceHidden: (await $f().fn(e)).data?.referenceHidden || a } };
	}
}, ip = {
	sideX: "left",
	sideY: "top"
}, ap = {
	name: "adaptiveOrigin",
	async fn(e) {
		let { x: t, y: n, rects: { floating: r }, elements: { floating: i }, platform: a, strategy: o, placement: s } = e, c = Me(i), l = c.getComputedStyle(i);
		if (!(l.transitionDuration !== "0s" && l.transitionDuration !== "")) return {
			x: t,
			y: n,
			data: ip
		};
		let u = await a.getOffsetParent?.(i), d = {
			width: 0,
			height: 0
		};
		if (o === "fixed" && c?.visualViewport) d = {
			width: c.visualViewport.width,
			height: c.visualViewport.height
		};
		else if (u === c) {
			let e = ht(i);
			d = {
				width: e.documentElement.clientWidth,
				height: e.documentElement.clientHeight
			};
		} else await a.isElement?.(u) && (d = await a.getDimensions(u));
		let f = Ea(s), p = t, m = n;
		f === "left" && (p = d.width - (t + r.width)), f === "top" && (m = d.height - (n + r.height));
		let h = f === "left" ? "right" : ip.sideX, g = f === "top" ? "bottom" : ip.sideY;
		return {
			x: p,
			y: m,
			data: {
				sideX: h,
				sideY: g
			}
		};
	}
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/useAnchorPositioning.js
function op(e, t, n) {
	let r = e === "inline-start" || e === "inline-end";
	return {
		top: "top",
		right: r ? n ? "inline-start" : "inline-end" : "right",
		bottom: "bottom",
		left: r ? n ? "inline-end" : "inline-start" : "left"
	}[t];
}
function sp(e, t, n) {
	let { rects: r, placement: i } = e;
	return {
		side: op(t, Ea(i), n),
		align: Da(i) || "center",
		anchor: {
			width: r.reference.width,
			height: r.reference.height
		},
		positioner: {
			width: r.floating.width,
			height: r.floating.height
		}
	};
}
function cp(e) {
	let { anchor: t, positionMethod: n = "absolute", side: r = "bottom", sideOffset: i = 0, align: a = "center", alignOffset: o = 0, collisionBoundary: s, collisionPadding: c = 5, sticky: l = !1, arrowPadding: u = 5, disableAnchorTracking: d = !1, keepMounted: f = !1, floatingRootContext: p, mounted: m, collisionAvoidance: h, shiftCrossAxis: g = !1, nodeId: _, adaptiveOrigin: v, lazyFlip: y = !1, externalTree: b } = e, [x, C] = S.useState(null);
	!m && x !== null && C(null);
	let w = h.side || "flip", T = h.align || "flip", E = h.fallbackAxisSide || "end", D = typeof t == "function" ? t : void 0, O = U(D), k = D ? O : t, A = Qo(t), j = kd() === "rtl", M = x || {
		top: "top",
		right: "right",
		bottom: "bottom",
		left: "left",
		"inline-end": j ? "left" : "right",
		"inline-start": j ? "right" : "left"
	}[r], N = a === "center" ? M : `${M}-${a}`, P = c, F = r === "bottom" ? 1 : 0, I = r === "top" ? 1 : 0, L = r === "right" ? 1 : 0, ee = r === "left" ? 1 : 0;
	typeof P == "number" ? P = {
		top: P + F,
		right: P + ee,
		bottom: P + I,
		left: P + L
	} : P &&= {
		top: (P.top || 0) + F,
		right: (P.right || 0) + ee,
		bottom: (P.bottom || 0) + I,
		left: (P.left || 0) + L
	};
	let R = {
		boundary: s === "clipping-ancestors" ? "clippingAncestors" : s,
		padding: P
	}, z = S.useRef(null), te = Qo(i), B = Qo(o), V = [Jf((e) => {
		let t = sp(e, r, j), n = typeof te.current == "function" ? te.current(t) : te.current, i = typeof B.current == "function" ? B.current(t) : B.current;
		return {
			mainAxis: n,
			crossAxis: i,
			alignmentAxis: i
		};
	}, [
		typeof i == "function" ? 0 : i,
		typeof o == "function" ? 0 : o,
		j,
		r
	])], ne = T === "none" && w !== "shift", re = !ne && (l || g || w === "shift"), ie = w === "none" ? null : Zf({
		...R,
		padding: {
			top: P.top + 1,
			right: P.right + 1,
			bottom: P.bottom + 1,
			left: P.left + 1
		},
		mainAxis: !g && w === "flip",
		crossAxis: T === "flip" ? "alignment" : !1,
		fallbackAxisSideDirection: E
	}), ae = ne ? null : Yf((e) => {
		let t = ht(e.elements.floating).documentElement;
		return {
			...R,
			rootBoundary: g ? {
				x: 0,
				y: 0,
				width: t.clientWidth,
				height: t.clientHeight
			} : void 0,
			mainAxis: T !== "none",
			crossAxis: re,
			limiter: l || g ? void 0 : Xf((e) => {
				if (!z.current) return {};
				let { width: t, height: n } = z.current.getBoundingClientRect(), r = Aa(Ea(e.placement)), i = r === "y" ? t : n, a = r === "y" ? P.left + P.right : P.top + P.bottom;
				return { offset: i / 2 + a / 2 };
			})
		};
	}, [
		R,
		l,
		g,
		P,
		T
	]);
	w === "shift" || T === "shift" || a === "center" ? V.push(ae, ie) : V.push(ie, ae), V.push(Qf({
		...R,
		apply({ elements: { floating: e }, availableWidth: t, availableHeight: n, rects: r }) {
			let i = e.style;
			i.setProperty("--available-width", `${t}px`), i.setProperty("--available-height", `${n}px`);
			let a = window.devicePixelRatio || 1, { x: o, y: s, width: c, height: l } = r.reference, u = (Math.round((o + c) * a) - Math.round(o * a)) / a, d = (Math.round((s + l) * a) - Math.round(s * a)) / a;
			i.setProperty("--anchor-width", `${u}px`), i.setProperty("--anchor-height", `${d}px`);
		}
	}), np(() => ({
		element: z.current || document.createElement("div"),
		padding: u,
		offsetParent: "floating"
	}), [u]), {
		name: "transformOrigin",
		fn(e) {
			let { elements: t, middlewareData: n, placement: a, rects: o, y: s } = e, c = Ea(a), l = Aa(c), u = z.current, d = n.arrow?.x || 0, f = n.arrow?.y || 0, p = u?.clientWidth || 0, m = u?.clientHeight || 0, h = d + p / 2, g = f + m / 2, _ = Math.abs(n.shift?.y || 0), v = o.reference.height / 2, y = typeof i == "function" ? i(sp(e, r, j)) : i, b = _ > y, x = {
				top: `${h}px calc(100% + ${y}px)`,
				bottom: `${h}px ${-y}px`,
				left: `calc(100% + ${y}px) ${g}px`,
				right: `${-y}px ${g}px`
			}[c], S = `${h}px ${o.reference.y + v - s}px`;
			return t.floating.style.setProperty("--transform-origin", re && l === "y" && b ? S : x), {};
		}
	}, rp, v), W(() => {
		!m && p && p.update({
			referenceElement: null,
			floatingElement: null,
			domReferenceElement: null
		});
	}, [m, p]);
	let oe = S.useMemo(() => ({
		elementResize: !d && typeof ResizeObserver < "u",
		layoutShift: !d && typeof IntersectionObserver < "u"
	}), [d]), { refs: H, elements: se, x: ce, y: le, middlewareData: ue, update: de, placement: fe, context: pe, isPositioned: me, floatingStyles: he } = ep({
		rootContext: p,
		placement: N,
		middleware: V,
		strategy: n,
		whileElementsMounted: f ? void 0 : (...e) => Ff(...e, oe),
		nodeId: _,
		externalTree: b
	}), { sideX: ge, sideY: _e } = ue.adaptiveOrigin || ip, ve = me ? n : "fixed", ye = S.useMemo(() => {
		let e = v ? {
			position: ve,
			[ge]: ce,
			[_e]: le
		} : {
			position: ve,
			...he
		};
		return me || (e.opacity = 0), e;
	}, [
		v,
		ve,
		ge,
		ce,
		_e,
		le,
		he,
		me
	]), be = S.useRef(null);
	W(() => {
		if (!m) return;
		let e = A.current, t = typeof e == "function" ? e() : e, n = (lp(t) ? t.current : t) || null;
		n !== be.current && (H.setPositionReference(n), be.current = n);
	}, [
		m,
		H,
		k,
		A
	]), S.useEffect(() => {
		if (!m) return;
		let e = A.current;
		typeof e != "function" && lp(e) && e.current !== be.current && (H.setPositionReference(e.current), be.current = e.current);
	}, [
		m,
		H,
		k,
		A
	]), S.useEffect(() => {
		if (f && m && se.domReference && se.floating) return Ff(se.domReference, se.floating, de, oe);
	}, [
		f,
		m,
		se,
		de,
		oe
	]);
	let xe = Ea(fe), Se = op(r, xe, j), Ce = Da(fe) || "center", we = !!ue.hide?.referenceHidden;
	W(() => {
		y && m && me && C(xe);
	}, [
		y,
		m,
		me,
		xe
	]);
	let Te = S.useMemo(() => ({
		position: "absolute",
		top: ue.arrow?.y,
		left: ue.arrow?.x
	}), [ue.arrow]), Ee = ue.arrow?.centerOffset !== 0;
	return S.useMemo(() => ({
		positionerStyles: ye,
		arrowStyles: Te,
		arrowRef: z,
		arrowUncentered: Ee,
		side: Se,
		align: Ce,
		physicalSide: xe,
		anchorHidden: we,
		refs: H,
		context: pe,
		isPositioned: me,
		update: de
	}), [
		ye,
		Te,
		z,
		Ee,
		Se,
		Ce,
		xe,
		we,
		H,
		pe,
		me,
		de
	]);
}
function lp(e) {
	return e != null && "current" in e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/getDisabledMountTransitionStyles.js
function up(e) {
	return e === "starting" ? Uo : Ot;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/positioner/ComboboxPositioner.js
var dp = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, anchor: i, positionMethod: a = "absolute", side: o = "bottom", align: s = "center", sideOffset: c = 0, alignOffset: l = 0, collisionBoundary: u = "clipping-ancestors", collisionPadding: d = 5, arrowPadding: f = 5, sticky: p = !1, disableAnchorTracking: m = !1, collisionAvoidance: h = Yo, ...g } = e, _ = qu(), { filteredItems: v } = Yu(), y = Ju(), b = Ud(), x = J(_, Z.modal), w = J(_, Z.open), T = J(_, Z.mounted), E = J(_, Z.openMethod), D = J(_, Z.triggerElement), O = J(_, Z.inputElement), k = J(_, Z.inputGroupElement), A = J(_, Z.inputInsidePopup), j = J(_, Z.transitionStatus), M = v.length === 0, N = cp({
		anchor: i ?? (A ? D : k ?? O),
		floatingRootContext: y,
		positionMethod: a,
		mounted: T,
		side: o,
		sideOffset: c,
		align: s,
		alignOffset: l,
		arrowPadding: f,
		collisionBoundary: u,
		collisionPadding: d,
		sticky: p,
		disableAnchorTracking: m,
		keepMounted: b,
		collisionAvoidance: h,
		lazyFlip: !0
	});
	Lt(w && x && E !== "touch", D);
	let P = S.useMemo(() => {
		let e = { ...N.positionerStyles };
		return w || (e.pointerEvents = "none"), {
			role: "presentation",
			hidden: !T,
			style: e
		};
	}, [
		w,
		T,
		N.positionerStyles
	]), F = {
		open: w,
		side: N.side,
		align: N.align,
		anchorHidden: N.anchorHidden,
		empty: M
	};
	W(() => {
		_.set("popupSide", N.side);
	}, [_, N.side]);
	let I = S.useMemo(() => ({
		side: N.side,
		align: N.align,
		arrowRef: N.arrowRef,
		arrowUncentered: N.arrowUncentered,
		arrowStyles: N.arrowStyles,
		anchorHidden: N.anchorHidden,
		isPositioned: N.isPositioned
	}), [
		N.side,
		N.align,
		N.arrowRef,
		N.arrowUncentered,
		N.arrowStyles,
		N.anchorHidden,
		N.isPositioned
	]), L = Y("div", e, {
		state: F,
		ref: [t, U((e) => {
			_.set("positionerElement", e);
		})],
		props: [
			P,
			up(j),
			g
		],
		stateAttributesMapping: ma
	});
	return /* @__PURE__ */ (0, C.jsxs)(Ed.Provider, {
		value: I,
		children: [T && x && /* @__PURE__ */ (0, C.jsx)(ic, {
			inert: rc(!w),
			cutout: k ?? O ?? D
		}), L]
	});
});
process.env.NODE_ENV !== "production" && (dp.displayName = "ComboboxPositioner");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/popup/ComboboxPopup.js
var fp = {
	...ma,
	...Zn
}, pp = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, initialFocus: i, finalFocus: a, ...o } = e, s = qu(), c = Dd(), l = Ju(), { filteredItems: u } = Yu(), d = J(s, Z.mounted), f = J(s, Z.open), p = J(s, Z.openMethod), m = J(s, Z.transitionStatus), h = J(s, Z.inputInsidePopup), g = J(s, Z.inputElement), _ = J(s, Z.modal), v = u.length === 0;
	rr({
		open: f,
		ref: s.state.popupRef,
		onComplete() {
			f && s.state.onOpenChangeComplete(!0);
		}
	});
	let y = Y("div", e, {
		state: {
			open: f,
			side: c.side,
			align: c.align,
			anchorHidden: c.anchorHidden,
			transitionStatus: m,
			empty: v
		},
		ref: [t, s.state.popupRef],
		props: [
			{
				role: h ? "dialog" : "presentation",
				tabIndex: -1,
				onFocus(e) {
					let t = Gt(e.nativeEvent);
					p !== "touch" && (G(s.state.listElement, t) || t === e.currentTarget) && s.state.inputRef.current?.focus();
				}
			},
			up(m),
			o
		],
		stateAttributesMapping: fp
	}), b = i === void 0 ? h ? (e) => e === "touch" ? s.state.popupRef.current : g : !1 : i, x;
	x = a ?? (h ? void 0 : !1);
	let w = !h || _;
	return /* @__PURE__ */ (0, C.jsx)(Ms, {
		context: l,
		disabled: !d,
		modal: w,
		openInteractionType: p,
		initialFocus: b,
		returnFocus: x,
		getInsideElements: () => [s.state.startDismissRef.current, s.state.endDismissRef.current],
		children: /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [y, w && /* @__PURE__ */ (0, C.jsx)(Ad, { ref: s.state.endDismissRef })] })
	});
});
process.env.NODE_ENV !== "production" && (pp.displayName = "ComboboxPopup");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/combobox.module.js
var mp = {
	"prism-combobox__trigger": "_prism-combobox__trigger_1u5hg_1",
	"prism-combobox__trigger--error": "_prism-combobox__trigger--error_1u5hg_36",
	"prism-combobox__trigger--warning": "_prism-combobox__trigger--warning_1u5hg_48",
	"prism-combobox__trigger--small": "_prism-combobox__trigger--small_1u5hg_60",
	"prism-combobox__trigger-label": "_prism-combobox__trigger-label_1u5hg_66",
	"prism-combobox__trigger-label--placeholder": "_prism-combobox__trigger-label--placeholder_1u5hg_70",
	"prism-combobox__trigger-value": "_prism-combobox__trigger-value_1u5hg_74",
	"prism-combobox__chevron": "_prism-combobox__chevron_1u5hg_81",
	"prism-combobox__positioner": "_prism-combobox__positioner_1u5hg_92",
	"prism-combobox__popup": "_prism-combobox__popup_1u5hg_98",
	"prism-combobox__search": "_prism-combobox__search_1u5hg_123",
	"prism-combobox__search-wrapper": "_prism-combobox__search-wrapper_1u5hg_128",
	"prism-combobox__search-input": "_prism-combobox__search-input_1u5hg_147",
	"prism-combobox__search-icon": "_prism-combobox__search-icon_1u5hg_161",
	"prism-combobox__list": "_prism-combobox__list_1u5hg_168",
	"prism-combobox__item": "_prism-combobox__item_1u5hg_173",
	"prism-combobox__item-content": "_prism-combobox__item-content_1u5hg_182"
}, hp = /* @__PURE__ */ B(V(), 1);
function gp(e) {
	let t = (0, x.c)(12), n = e.searchLabel ?? "Search", r;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (r = (0, hp.default)("text-300--regular", mp["prism-combobox__search-input"]), t[0] = r) : r = t[0];
	let i = e.placeholder ?? "Search…", a;
	t[1] !== n || t[2] !== i ? (a = /* @__PURE__ */ (0, C.jsx)(jd, {
		"aria-label": n,
		className: r,
		placeholder: i
	}), t[1] = n, t[2] = i, t[3] = a) : a = t[3];
	let o;
	t[4] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ (0, C.jsx)("span", {
		className: mp["prism-combobox__search-icon"],
		children: /* @__PURE__ */ (0, C.jsx)(N, {
			name: "search",
			size: "small"
		})
	}), t[4] = o) : o = t[4];
	let s;
	t[5] === a ? s = t[6] : (s = /* @__PURE__ */ (0, C.jsx)("div", {
		className: mp["prism-combobox__search"],
		children: /* @__PURE__ */ (0, C.jsxs)("div", {
			className: mp["prism-combobox__search-wrapper"],
			children: [a, o]
		})
	}), t[5] = a, t[6] = s);
	let c;
	t[7] === e.children ? c = t[8] : (c = /* @__PURE__ */ (0, C.jsx)(Vd, {
		className: mp["prism-combobox__list"],
		children: e.children
	}), t[7] = e.children, t[8] = c);
	let l;
	return t[9] !== s || t[10] !== c ? (l = /* @__PURE__ */ (0, C.jsx)(Wd, { children: /* @__PURE__ */ (0, C.jsx)(dp, {
		align: "start",
		className: mp["prism-combobox__positioner"],
		sideOffset: 4,
		children: /* @__PURE__ */ (0, C.jsxs)(pp, {
			className: mp["prism-combobox__popup"],
			children: [s, c]
		})
	}) }), t[9] = s, t[10] = c, t[11] = l) : l = t[11], l;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/composite/list/useCompositeListItem.js
var _p = /* @__PURE__ */ function(e) {
	return e[e.None = 0] = "None", e[e.GuessFromOrder = 1] = "GuessFromOrder", e;
}({});
function vp(e = {}) {
	let { label: t, metadata: n, textRef: r, indexGuessBehavior: i, index: a } = e, { register: o, unregister: s, subscribeMapChange: c, elementsRef: l, labelsRef: u, nextIndexRef: d } = Id(), f = S.useRef(-1), [p, m] = S.useState(a ?? (i === _p.GuessFromOrder ? () => {
		if (f.current === -1) {
			let e = d.current;
			d.current += 1, f.current = e;
		}
		return f.current;
	} : -1)), h = S.useRef(null), g = S.useCallback((e) => {
		if (h.current = e, p !== -1 && e !== null && (l.current[p] = e, u)) {
			let n = t !== void 0;
			u.current[p] = n ? t : r?.current?.textContent ?? e.textContent;
		}
	}, [
		p,
		l,
		u,
		t,
		r
	]);
	return W(() => {
		if (a != null) return;
		let e = h.current;
		if (e) return o(e, n), () => {
			s(e);
		};
	}, [
		a,
		o,
		s,
		n
	]), W(() => {
		if (a == null) return c((e) => {
			let t = h.current ? e.get(h.current)?.index : null;
			t != null && m(t);
		});
	}, [
		a,
		c,
		m
	]), S.useMemo(() => ({
		ref: g,
		index: p
	}), [p, g]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/item/ComboboxItemContext.js
var yp = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (yp.displayName = "ComboboxItemContext");
function bp() {
	let e = S.useContext(yp);
	if (!e) throw Error(process.env.NODE_ENV === "production" ? lr(19) : "Base UI: ComboboxItemContext is missing. ComboboxItem parts must be placed within <Combobox.Item>.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/row/ComboboxRowContext.js
var xp = /* @__PURE__ */ S.createContext(!1);
process.env.NODE_ENV !== "production" && (xp.displayName = "ComboboxRowContext");
function Sp() {
	return S.useContext(xp);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/item/ComboboxItem.js
var Cp = /* @__PURE__ */ S.memo(/* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, value: i = null, index: a, disabled: o = !1, nativeButton: s = !1, ...c } = e, l = S.useRef(!1), u = S.useRef(null), d = vp({
		index: a,
		textRef: u,
		indexGuessBehavior: _p.GuessFromOrder
	}), f = qu(), p = Sp(), { flatFilteredItems: m, hasItems: h } = Yu(), g = J(f, Z.open), _ = J(f, Z.selectionMode), v = J(f, Z.readOnly), y = J(f, Z.virtualized), b = J(f, Z.isItemEqualToValue), x = _ !== "none", w = a ?? (y ? ed(m, i, b) : d.index), T = d.index !== -1, E = J(f, Z.id), D = J(f, Z.isActive, w), O = J(f, Z.isSelected, i), k = J(f, Z.getItemProps), A = S.useRef(null), j = E != null && T ? `${E}-${w}` : void 0, M = O && x;
	W(() => {
		if (!(T && (y || a != null))) return;
		let e = f.state.listRef.current;
		return e[w] = A.current, () => {
			delete e[w];
		};
	}, [
		T,
		y,
		w,
		a,
		f
	]), W(() => {
		if (!T || h) return;
		let e = f.state.valuesRef.current;
		return e[w] = i, _ !== "none" && f.state.allValuesRef.current.push(i), () => {
			delete e[w];
		};
	}, [
		T,
		h,
		w,
		i,
		f,
		_
	]), W(() => {
		if (!g) {
			l.current = !1;
			return;
		}
		if (!T || h) return;
		let e = f.state.selectedValue;
		Qu(i, Array.isArray(e) ? e[e.length - 1] : e, b) && f.set("selectedIndex", w);
	}, [
		T,
		h,
		g,
		f,
		w,
		i,
		b
	]);
	let N = {
		disabled: o,
		selected: M,
		highlighted: D
	}, P = k({
		active: D,
		selected: M
	});
	P.id = void 0, P.onFocus = void 0;
	let { getButtonProps: F, buttonRef: I } = iu({
		disabled: o,
		focusableWhenDisabled: !0,
		native: s,
		composite: !0
	});
	function L(e) {
		function t() {
			f.state.handleSelection(e, i);
		}
		f.state.submitOnItemClick ? (tr.flushSync(t), f.state.requestSubmit()) : t();
	}
	let ee = {
		id: j,
		role: p ? "gridcell" : "option",
		"aria-selected": x ? M : void 0,
		tabIndex: void 0,
		onPointerDownCapture(e) {
			l.current = !0, e.preventDefault();
		},
		onClick(e) {
			o || v || L(e.nativeEvent);
		},
		onMouseUp(e) {
			let t = l.current;
			l.current = !1, !(o || v || e.button !== 0 || t || !D) && L(e.nativeEvent);
		}
	}, R = Y("div", e, {
		ref: [
			I,
			t,
			d.ref,
			A
		],
		state: N,
		props: [
			P,
			ee,
			c,
			F
		]
	}), z = S.useMemo(() => ({
		selected: M,
		textRef: u
	}), [M, u]);
	return /* @__PURE__ */ (0, C.jsx)(yp.Provider, {
		value: z,
		children: R
	});
}));
process.env.NODE_ENV !== "production" && (Cp.displayName = "ComboboxItem");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/item-indicator/ComboboxItemIndicator.js
var wp = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let n = e.keepMounted ?? !1, { selected: r } = bp();
	return n || r ? /* @__PURE__ */ (0, C.jsx)(Tp, {
		...e,
		ref: t
	}) : null;
});
process.env.NODE_ENV !== "production" && (wp.displayName = "ComboboxItemIndicator");
var Tp = /* @__PURE__ */ S.memo(/* @__PURE__ */ S.forwardRef((e, t) => {
	let { render: n, className: r, keepMounted: i, ...a } = e, { selected: o } = bp(), s = S.useRef(null), { transitionStatus: c, setMounted: l } = Kn(o), u = Y("span", e, {
		ref: [t, s],
		state: {
			selected: o,
			transitionStatus: c
		},
		props: [{
			"aria-hidden": !0,
			children: "✔️"
		}, a],
		stateAttributesMapping: Zn
	});
	return rr({
		open: o,
		ref: s,
		onComplete() {
			o || l(!1);
		}
	}), u;
}));
process.env.NODE_ENV !== "production" && (Tp.displayName = "Inner");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/combobox/option.js
var Ep = /* @__PURE__ */ B(V(), 1);
function Dp(e) {
	let t = (0, x.c)(8), { children: n, disabled: r, value: i } = e, a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = (0, Ep.default)("text-300--regular", mp["prism-combobox__item-content"]), t[0] = a) : a = t[0];
	let o;
	t[1] === n ? o = t[2] : (o = /* @__PURE__ */ (0, C.jsx)("span", {
		className: a,
		children: n
	}), t[1] = n, t[2] = o);
	let s;
	t[3] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ (0, C.jsx)(wp, { children: /* @__PURE__ */ (0, C.jsx)(N, {
		name: "checkmark",
		size: "small"
	}) }), t[3] = s) : s = t[3];
	let c;
	return t[4] !== r || t[5] !== o || t[6] !== i ? (c = /* @__PURE__ */ (0, C.jsxs)(Cp, {
		className: mp["prism-combobox__item"],
		disabled: r,
		value: i,
		children: [o, s]
	}), t[4] = r, t[5] = o, t[6] = i, t[7] = c) : c = t[7], c;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/value/ComboboxValue.js
function Op(e) {
	let { children: t, placeholder: n } = e, r = qu(), i = J(r, Z.itemToStringLabel), a = J(r, Z.selectedValue), o = J(r, Z.items), s = J(r, Z.selectionMode) === "multiple", c = J(r, Z.hasSelectedValue), l = !c && n != null && t == null, u = J(r, Z.hasNullItemLabel, l), d = null;
	return d = typeof t == "function" ? t(a) : t ?? (!c && n != null && !u ? n : s && Array.isArray(a) ? cd(a, o, i) : sd(a, o, i)), /* @__PURE__ */ (0, C.jsx)(S.Fragment, { children: d });
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useTypeahead.js
function kp(e, t) {
	let n = "rootStore" in e ? e.rootStore : e, r = n.context.dataRef, i = n.useState("open"), { listRef: a, elementsRef: o, activeIndex: s, onMatch: c, onTypingChange: l, enabled: u = !0, resetMs: d = 750, selectedIndex: f = null } = t, p = bt(), m = S.useRef(""), h = S.useRef(f ?? s ?? -1), g = S.useRef(null);
	W(() => {
		!i && f !== null || (p.clear(), g.current = null, m.current !== "" && (m.current = ""));
	}, [
		i,
		f,
		p
	]), W(() => {
		i && m.current === "" && (h.current = f ?? s ?? -1);
	}, [
		i,
		f,
		s
	]);
	let _ = U((e) => {
		e ? r.current.typing || (r.current.typing = e, l?.(e)) : r.current.typing && (r.current.typing = e, l?.(e));
	}), v = U((e) => {
		function t(e) {
			let t = o?.current[e];
			return !t || to(t);
		}
		function n(e, n, r = 0) {
			if (e.length === 0) return -1;
			let i = (r % e.length + e.length) % e.length, a = n.toLocaleLowerCase();
			for (let n = 0; n < e.length; n += 1) {
				let r = (i + n) % e.length;
				if (!(!e[r]?.toLocaleLowerCase().startsWith(a) || !t(r))) return r;
			}
			return -1;
		}
		let r = a.current;
		if (m.current.length > 0 && e.key === " " && (xn(e), _(!0)), m.current.length > 0 && m.current[0] !== " " && n(r, m.current) === -1 && e.key !== " " && _(!1), r == null || e.key.length !== 1 || e.ctrlKey || e.metaKey || e.altKey) return;
		i && e.key !== " " && (xn(e), _(!0));
		let l = m.current === "";
		l && (h.current = f ?? s ?? -1), r.every((e) => e ? e[0]?.toLocaleLowerCase() !== e[1]?.toLocaleLowerCase() : !0) && m.current === e.key && (m.current = "", h.current = g.current), m.current += e.key, p.start(d, () => {
			m.current = "", h.current = g.current, _(!1);
		});
		let u = ((l ? f ?? s ?? -1 : h.current) ?? 0) + 1, v = n(r, m.current, u);
		v === -1 ? e.key !== " " && (m.current = "", _(!1)) : (c?.(v), g.current = v);
	}), y = U((e) => {
		let t = e.relatedTarget, r = n.select("domReferenceElement"), i = n.select("floatingElement"), a = G(r, t), o = G(i, t);
		a || o || (p.clear(), m.current = "", h.current = g.current, _(!1));
	}), b = S.useMemo(() => ({
		onKeyDown: v,
		onBlur: y
	}), [v, y]), x = S.useMemo(() => ({
		onKeyDown: v,
		onBlur: y
	}), [v, y]);
	return S.useMemo(() => u ? {
		reference: b,
		floating: x
	} : {}, [
		u,
		b,
		x
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/getPseudoElementBounds.js
function Ap(e) {
	let t = e.getBoundingClientRect();
	if (process.env.NODE_ENV !== "production") return t;
	let n = window.getComputedStyle(e, "::before"), r = window.getComputedStyle(e, "::after");
	if (!(n.content !== "none" || r.content !== "none")) return t;
	let i = parseFloat(n.width) || 0, a = parseFloat(n.height) || 0, o = parseFloat(r.width) || 0, s = parseFloat(r.height) || 0, c = Math.max(t.width, i, o), l = Math.max(t.height, a, s), u = c - t.width, d = l - t.height;
	return {
		left: t.left - u / 2,
		right: t.right + u / 2,
		top: t.top - d / 2,
		bottom: t.bottom + d / 2
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/combobox/trigger/ComboboxTrigger.js
var jp = 2, Mp = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, nativeButton: i = !0, disabled: a = !1, id: o, ...s } = e, { state: c, disabled: l, setTouched: u, setFocused: d, validationMode: f, validation: p } = Kl(), { labelId: m } = Jl(), h = qu(), { filteredItems: g } = Yu(), _ = J(h, Z.selectionMode), v = J(h, Z.disabled), y = J(h, Z.readOnly), b = J(h, Z.required), x = J(h, Z.mounted), C = J(h, Z.popupSide), w = J(h, Z.positionerElement), T = J(h, Z.listElement), E = J(h, Z.triggerProps), D = J(h, Z.triggerElement), O = J(h, Z.inputInsidePopup), k = J(h, Z.id), A = J(h, Z.labelId), j = J(h, Z.open), M = J(h, Z.selectedValue), N = J(h, Z.activeIndex), P = J(h, Z.selectedIndex), F = J(h, Z.hasSelectedValue), I = Ju(), L = Xu(), ee = bt(), R = l || v || a, z = g.length === 0, te = x && w ? C : null;
	ld({ id: O ? o : void 0 });
	let B = O ? o ?? k : o, V = Sd(m, A), ne = S.useRef("");
	function re(e) {
		ne.current = e.pointerType;
	}
	let ie = I.useState("domReferenceElement");
	S.useEffect(() => {
		O && D && D !== ie && I.set("domReferenceElement", D);
	}, [
		D,
		ie,
		I,
		O
	]);
	let { reference: ae } = kp(I, {
		enabled: !j && !y && !v && _ === "single",
		listRef: h.state.labelsRef,
		activeIndex: N,
		selectedIndex: P,
		onMatch(e) {
			let t = h.state.valuesRef.current[e];
			t !== void 0 && h.state.setSelectedValue(t, K("none"));
		}
	}), { reference: oe } = Nu(I, {
		enabled: !y && !v,
		event: "mousedown"
	}), { buttonRef: H, getButtonProps: se } = iu({
		native: i,
		disabled: R
	}), ce = {
		...c,
		open: j,
		disabled: R,
		popupSide: te,
		listEmpty: z,
		placeholder: !F
	};
	return Y("button", e, {
		ref: [
			t,
			H,
			U((e) => {
				h.set("triggerElement", e);
			})
		],
		state: ce,
		props: [
			E,
			oe,
			ae,
			{
				id: B,
				tabIndex: O ? 0 : -1,
				role: O ? "combobox" : void 0,
				"aria-expanded": j ? "true" : "false",
				"aria-haspopup": O ? "dialog" : "listbox",
				"aria-controls": j ? T?.id : void 0,
				"aria-required": O && b || void 0,
				"aria-labelledby": V,
				onPointerDown: re,
				onPointerEnter: re,
				onFocus() {
					d(!0), !(R || y) && ee.start(0, h.state.forceMount);
				},
				onBlur(e) {
					if (!G(w, e.relatedTarget) && (u(!0), d(!1), f === "onBlur")) {
						let e = _ === "none" ? L : M;
						p.commit(e);
					}
				},
				onMouseDown(e) {
					if (R || y || (O || I.set("domReferenceElement", e.currentTarget), h.state.forceMount(), ne.current !== "touch" && (h.state.inputRef.current?.focus(), O || e.preventDefault()), j)) return;
					let t = ht(e.currentTarget);
					function n(e) {
						if (!D) return;
						let t = Gt(e), n = h.state.positionerElement, r = h.state.listElement;
						if (G(D, t) || G(n, t) || G(r, t) || t === D) return;
						let i = Ap(D), a = e.clientX >= i.left - jp && e.clientX <= i.right + jp, o = e.clientY >= i.top - jp && e.clientY <= i.bottom + jp;
						a && o || h.state.setOpen(!1, K("cancel-open", e));
					}
					O && t.addEventListener("mouseup", n, { once: !0 });
				},
				onKeyDown(e) {
					R || y || (e.key === "ArrowDown" || e.key === "ArrowUp") && (xn(e), h.state.setOpen(!0, K("list-navigation", e.nativeEvent)), h.state.inputRef.current?.focus());
				}
			},
			p ? p.getValidationProps(s) : s,
			se
		],
		stateAttributesMapping: Cd
	});
});
process.env.NODE_ENV !== "production" && (Mp.displayName = "ComboboxTrigger");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/combobox/trigger.js
var Np = /* @__PURE__ */ B(V(), 1);
function Pp(e) {
	let t = (0, x.c)(26), { hasError: n, hasWarning: r, isSmall: i } = xd(), a;
	t[0] !== n || t[1] !== r || t[2] !== i ? (a = (0, Np.default)(mp["prism-combobox__trigger"], {
		[mp["prism-combobox__trigger--error"]]: n,
		[mp["prism-combobox__trigger--warning"]]: r,
		[mp["prism-combobox__trigger--small"]]: i
	}), t[0] = n, t[1] = r, t[2] = i, t[3] = a) : a = t[3];
	let o = a, s = i ? "text-200--medium" : "text-300--medium", c;
	t[4] === s ? c = t[5] : (c = (0, Np.default)(s, mp["prism-combobox__trigger-label"], mp["prism-combobox__trigger-value"]), t[4] = s, t[5] = c);
	let l = c, u;
	t[6] === s ? u = t[7] : (u = (0, Np.default)(s, mp["prism-combobox__trigger-label"], mp["prism-combobox__trigger-label--placeholder"]), t[6] = s, t[7] = u);
	let d;
	t[8] !== e.placeholder || t[9] !== u ? (d = /* @__PURE__ */ (0, C.jsx)("span", {
		className: u,
		children: e.placeholder
	}), t[8] = e.placeholder, t[9] = u, t[10] = d) : d = t[10];
	let f = d, p;
	t[11] !== f || t[12] !== e.children ? (p = (t) => t == null ? f : e.children(t), t[11] = f, t[12] = e.children, t[13] = p) : p = t[13];
	let m = p, h = e["aria-label"], g = e.children ? m : void 0, _;
	t[14] !== f || t[15] !== g ? (_ = /* @__PURE__ */ (0, C.jsx)(Op, {
		placeholder: f,
		children: g
	}), t[14] = f, t[15] = g, t[16] = _) : _ = t[16];
	let v;
	t[17] !== _ || t[18] !== l ? (v = /* @__PURE__ */ (0, C.jsx)("span", {
		className: l,
		children: _
	}), t[17] = _, t[18] = l, t[19] = v) : v = t[19];
	let y;
	t[20] === Symbol.for("react.memo_cache_sentinel") ? (y = /* @__PURE__ */ (0, C.jsx)("span", {
		"aria-hidden": "true",
		className: mp["prism-combobox__chevron"],
		children: /* @__PURE__ */ (0, C.jsx)(N, {
			color: "inherit",
			name: "chevron-down",
			size: "small"
		})
	}), t[20] = y) : y = t[20];
	let b;
	return t[21] !== e.id || t[22] !== h || t[23] !== v || t[24] !== o ? (b = /* @__PURE__ */ (0, C.jsxs)(Mp, {
		"aria-label": h,
		className: o,
		id: e.id,
		children: [v, y]
	}), t[21] = e.id, t[22] = h, t[23] = v, t[24] = o, t[25] = b) : b = t[25], b;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/combobox.js
function Fp(e) {
	let t = (0, x.c)(18), { children: n, defaultValue: r, disabled: i, hasError: a, hasWarning: o, isSmall: s, name: c, onChange: l, options: u, unsafe_open: d, value: f } = e, p;
	t[0] === l ? p = t[1] : (p = l && ((e) => l(e)), t[0] = l, t[1] = p);
	let m;
	t[2] !== a || t[3] !== o || t[4] !== s ? (m = {
		hasError: a,
		hasWarning: o,
		isSmall: s
	}, t[2] = a, t[3] = o, t[4] = s, t[5] = m) : m = t[5];
	let h;
	t[6] !== n || t[7] !== m ? (h = /* @__PURE__ */ (0, C.jsx)(bd, {
		value: m,
		children: n
	}), t[6] = n, t[7] = m, t[8] = h) : h = t[8];
	let g;
	return t[9] !== r || t[10] !== i || t[11] !== c || t[12] !== u || t[13] !== p || t[14] !== h || t[15] !== d || t[16] !== f ? (g = /* @__PURE__ */ (0, C.jsx)(yd, {
		defaultValue: r,
		disabled: i,
		items: u,
		name: c,
		onValueChange: p,
		open: d,
		value: f,
		children: h
	}), t[9] = r, t[10] = i, t[11] = c, t[12] = u, t[13] = p, t[14] = h, t[15] = d, t[16] = f, t[17] = g) : g = t[17], g;
}
Fp.Trigger = Pp, Fp.Menu = gp, Fp.Option = Dp;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/drawer/body.module.js
var Ip = { body: "_body_43ihv_1" }, Lp = /* @__PURE__ */ B(V(), 1);
function Rp(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, Lp.default)(Ip.body, n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)("div", {
		className: i,
		...r
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/drawer/content.module.js
var zp = { content: "_content_1gpqn_1" }, Bp = /* @__PURE__ */ B(V(), 1);
function Vp(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, Bp.default)(zp.content, n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)("section", {
		className: i,
		...r
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/drawer/footer.module.js
var Hp = { footer: "_footer_1lv5w_1" }, Up = /* @__PURE__ */ B(V(), 1);
function Wp(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, Up.default)(Hp.footer, n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)("footer", {
		className: i,
		...r
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/drawer/header.module.js
var Gp = { header: "_header_kgrn9_1" }, Kp = { title: "_title_1sp5y_1" }, qp = /* @__PURE__ */ B(V(), 1);
function Jp(e) {
	let t = (0, x.c)(10), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({className: r, children: n, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a;
	t[4] === r ? a = t[5] : (a = (0, qp.default)(Kp.title, r), t[4] = r, t[5] = a);
	let o;
	return t[6] !== n || t[7] !== i || t[8] !== a ? (o = /* @__PURE__ */ (0, C.jsx)("h3", {
		className: a,
		...i,
		children: n
	}), t[6] = n, t[7] = i, t[8] = a, t[9] = o) : o = t[9], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/drawer/header.js
var Yp = /* @__PURE__ */ B(V(), 1);
function Xp(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, Yp.default)(Gp.header, n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)("header", {
		className: i,
		...r
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
Xp.Title = Jp;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/drawer/panel.module.js
var Zp = {
	panel: "_panel_1wrw3_1",
	"panel--closed": "_panel--closed_1wrw3_16",
	"size--small": "_size--small_1wrw3_20",
	"size--medium": "_size--medium_1wrw3_24",
	"size--large": "_size--large_1wrw3_28"
}, Qp = /* @__PURE__ */ B(V(), 1), $p = {
	small: "size--small",
	medium: "size--medium",
	large: "size--large"
};
function em(e) {
	let t = (0, x.c)(15), n, r, i, a, o;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5]) : ({children: n, className: r, open: i, size: o, ...a} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o);
	let s = Zp[$p[o === void 0 ? "medium" : o]], c = !i, l;
	t[6] !== r || t[7] !== s || t[8] !== c ? (l = (0, Qp.default)(Zp.panel, s, { [Zp["panel--closed"]]: c }, r), t[6] = r, t[7] = s, t[8] = c, t[9] = l) : l = t[9];
	let u = !i, d;
	return t[10] !== n || t[11] !== a || t[12] !== l || t[13] !== u ? (d = /* @__PURE__ */ (0, C.jsx)("aside", {
		className: l,
		inert: u,
		...a,
		children: n
	}), t[10] = n, t[11] = a, t[12] = l, t[13] = u, t[14] = d) : d = t[14], d;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/drawer/root.module.js
var tm = { root: "_root_rejbf_1" }, nm = /* @__PURE__ */ B(V(), 1);
function rm(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, nm.default)(tm.root, n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)("div", {
		className: i,
		...r
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/drawer.js
function im(e) {
	let t = (0, x.c)(2), n;
	return t[0] === e ? n = t[1] : (n = /* @__PURE__ */ (0, C.jsx)(rm, { ...e }), t[0] = e, t[1] = n), n;
}
im.Root = rm, im.Content = Vp, im.Panel = em, im.Header = Xp, im.Body = Rp, im.Footer = Wp;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/root/PopoverRootContext.js
var am = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (am.displayName = "PopoverRootContext");
function om(e) {
	let t = S.useContext(am);
	if (t === void 0 && !e) throw Error(process.env.NODE_ENV === "production" ? lr(47) : "Base UI: PopoverRootContext is missing. Popover parts must be placed within <Popover.Root>.");
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/store/PopoverStore.js
function sm() {
	return {
		...Ci(),
		disabled: !1,
		modal: !1,
		instantType: void 0,
		openMethod: null,
		openChangeReason: null,
		titleElementId: void 0,
		descriptionElementId: void 0,
		stickIfOpen: !0,
		nested: !1,
		openOnHover: !1,
		closeDelay: 0,
		hasViewport: !1
	};
}
var cm = {
	...Ti,
	disabled: q((e) => e.disabled),
	instantType: q((e) => e.instantType),
	openMethod: q((e) => e.openMethod),
	openChangeReason: q((e) => e.openChangeReason),
	modal: q((e) => e.modal),
	stickIfOpen: q((e) => e.stickIfOpen),
	titleElementId: q((e) => e.titleElementId),
	descriptionElementId: q((e) => e.descriptionElementId),
	openOnHover: q((e) => e.openOnHover),
	closeDelay: q((e) => e.closeDelay),
	hasViewport: q((e) => e.hasViewport)
}, lm = class e extends oi {
	constructor(e) {
		let t = {
			...sm(),
			...e
		};
		t.open && e?.mounted === void 0 && (t.mounted = !0), super(t, {
			popupRef: /* @__PURE__ */ S.createRef(),
			backdropRef: /* @__PURE__ */ S.createRef(),
			internalBackdropRef: /* @__PURE__ */ S.createRef(),
			onOpenChange: void 0,
			onOpenChangeComplete: void 0,
			triggerFocusTargetRef: /* @__PURE__ */ S.createRef(),
			beforeContentFocusGuardRef: /* @__PURE__ */ S.createRef(),
			stickIfOpenTimeout: new yt(),
			triggerElements: new xi()
		}, cm);
	}
	setOpen = (e, t) => {
		let n = t.reason === en, r = t.reason === "trigger-press" && t.event.detail === 0, i = !e && (t.reason === "escape-key" || t.reason == null);
		if (t.preventUnmountOnClose = () => {
			this.set("preventUnmountingOnClose", !0);
		}, this.context.onOpenChange?.(e, t), t.isCanceled) return;
		let a = {
			open: e,
			nativeEvent: t.event,
			reason: t.reason,
			nested: this.state.nested,
			triggerElement: t.trigger
		};
		this.state.floatingRootContext.context.events?.emit("openchange", a);
		let o = () => {
			let n = {
				open: e,
				openChangeReason: t.reason
			}, r = t.trigger?.id ?? null;
			(r || e) && (n.activeTriggerId = r, n.activeTriggerElement = t.trigger ?? null), this.update(n);
		};
		n ? (this.set("stickIfOpen", !0), this.context.stickIfOpenTimeout.start(500, () => {
			this.set("stickIfOpen", !1);
		}), tr.flushSync(o)) : o(), r || i ? this.set("instantType", r ? "click" : "dismiss") : t.reason === "focus-out" ? this.set("instantType", "focus") : this.set("instantType", void 0);
	};
	static useStore(t, n) {
		let r = Te(() => new e(n)).current, i = t ?? r;
		return _t(r.disposeEffect), i;
	}
	disposeEffect = () => this.context.stickIfOpenTimeout.disposeEffect();
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/root/PopoverRoot.js
function um({ props: e }) {
	let { children: t, open: n, defaultOpen: r = !1, onOpenChange: i, onOpenChangeComplete: a, modal: o = !1, handle: s, triggerId: c, defaultTriggerId: l = null } = e, u = lm.useStore(s?.store, {
		modal: o,
		open: r,
		openProp: n,
		activeTriggerId: l,
		triggerIdProp: c
	});
	Hu(() => {
		n === void 0 && u.state.open === !1 && r === !0 && u.update({
			open: !0,
			activeTriggerId: l
		});
	}), u.useControlledProp("openProp", n), u.useControlledProp("triggerIdProp", c);
	let d = u.useState("open"), f = u.useState("positionerElement"), p = u.useState("payload"), m = u.useState("openChangeReason");
	u.useContextCallback("onOpenChange", i), u.useContextCallback("onOpenChangeComplete", a);
	let { openMethod: h, triggerProps: g } = _i(d);
	or(u);
	let { forceUnmount: _ } = sr(d, u, () => {
		u.update({
			stickIfOpen: !0,
			openChangeReason: null
		});
	});
	Lt(d && o === !0 && m !== "trigger-hover" && h !== "touch", f), S.useEffect(() => {
		d || u.context.stickIfOpenTimeout.clear();
	}, [u, d]);
	let v = S.useCallback((e) => {
		let t = K(e);
		return t.preventUnmountOnClose = () => {
			u.set("preventUnmountingOnClose", !0);
		}, t;
	}, [u]), y = S.useCallback(() => {
		u.setOpen(!1, v(gn));
	}, [u, v]);
	S.useImperativeHandle(e.actionsRef, () => ({
		unmount: _,
		close: y
	}), [_, y]);
	let b = li({
		popupStore: u,
		onOpenChange: u.setOpen
	}), { getReferenceProps: x, getFloatingProps: w, getTriggerProps: T } = ui([Gn(b, { outsidePressEvent: {
		mouse: o === "trap-focus" ? "sloppy" : "intentional",
		touch: "sloppy"
	} }), mi(b)]), E = S.useMemo(() => x(g), [x, g]), D = S.useMemo(() => T(g), [T, g]), O = S.useMemo(() => w(), [w]);
	u.useSyncedValues({
		modal: o,
		openMethod: h,
		activeTriggerProps: E,
		inactiveTriggerProps: D,
		popupProps: O,
		floatingRootContext: b,
		nested: Ln() != null
	});
	let k = S.useMemo(() => ({ store: u }), [u]);
	return /* @__PURE__ */ (0, C.jsx)(am.Provider, {
		value: k,
		children: typeof t == "function" ? t({ payload: p }) : t
	});
}
function dm(e) {
	return om(!0) ? /* @__PURE__ */ (0, C.jsx)(um, { props: e }) : /* @__PURE__ */ (0, C.jsx)(Vn, { children: /* @__PURE__ */ (0, C.jsx)(um, { props: e }) });
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useHoverShared.js
function fm(e, t) {
	return t != null && !Tn(t) ? 0 : typeof e == "function" ? e() : e;
}
function pm(e, t, n) {
	let r = fm(e, n);
	return typeof r == "number" ? r : r?.[t];
}
function mm(e) {
	return typeof e == "function" ? e() : e;
}
function hm(e, t) {
	return t || e === "click" || e === "mousedown";
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useHoverInteractionSharedState.js
var gm = `button,a,[role="button"],select,[tabindex]:not([tabindex="-1"]),${Rt}`;
function _m(e) {
	return e ? !!e.closest(gm) : !1;
}
var vm = class e {
	constructor() {
		this.pointerType = void 0, this.interactedInside = !1, this.handler = void 0, this.blockMouseMove = !0, this.performedPointerEventsMutation = !1, this.pointerEventsScopeElement = null, this.pointerEventsReferenceElement = null, this.pointerEventsFloatingElement = null, this.restTimeoutPending = !1, this.openChangeTimeout = new yt(), this.restTimeout = new yt(), this.handleCloseOptions = void 0;
	}
	static create() {
		return new e();
	}
	dispose = () => {
		this.openChangeTimeout.clear(), this.restTimeout.clear();
	};
	disposeEffect = () => this.dispose;
};
function ym(e) {
	e.performedPointerEventsMutation && (e.pointerEventsScopeElement?.style.removeProperty("pointer-events"), e.pointerEventsReferenceElement?.style.removeProperty("pointer-events"), e.pointerEventsFloatingElement?.style.removeProperty("pointer-events"), e.performedPointerEventsMutation = !1, e.pointerEventsScopeElement = null, e.pointerEventsReferenceElement = null, e.pointerEventsFloatingElement = null);
}
function bm(e, t) {
	let { scopeElement: n, referenceElement: r, floatingElement: i } = t;
	ym(e), e.performedPointerEventsMutation = !0, e.pointerEventsScopeElement = n, e.pointerEventsReferenceElement = r, e.pointerEventsFloatingElement = i, n.style.pointerEvents = "none", r.style.pointerEvents = "auto", i.style.pointerEvents = "auto";
}
function xm(e) {
	let t = Te(vm.create).current, n = e.context.dataRef.current;
	return n.hoverInteractionState ||= t, _t(n.hoverInteractionState.disposeEffect), n.hoverInteractionState;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useHoverReferenceInteraction.js
var Sm = { current: null };
function Cm(e, t = {}) {
	let n = "rootStore" in e ? e.rootStore : e, { dataRef: r, events: i } = n.context, { enabled: a = !0, delay: o = 0, handleClose: s = null, mouseOnly: c = !1, restMs: l = 0, move: u = !0, triggerElementRef: d = Sm, externalTree: f, isActiveTrigger: p = !0, getHandleCloseContext: m } = t, h = Rn(f), g = xm(n), _ = Qo(s), v = Qo(o), y = Qo(l), b = Qo(a);
	p && (g.handleCloseOptions = _.current?.__options);
	let x = U(() => hm(r.current.openEvent?.type, g.interactedInside)), C = U((e) => Wt(e, n.context.triggerElements)), w = U((e, t, r) => {
		let i = n.context.triggerElements;
		if (i.hasElement(t)) return !e || !G(e, t);
		if (!Fe(r)) return !1;
		let a = r;
		return i.hasMatchingElement((e) => G(e, a)) && (!e || !G(e, a));
	}), T = S.useCallback((e, t = !0) => {
		let r = pm(v.current, "close", g.pointerType);
		r ? g.openChangeTimeout.start(r, () => {
			n.setOpen(!1, K(en, e)), h?.events.emit("floating.closed", e);
		}) : t && (g.openChangeTimeout.clear(), n.setOpen(!1, K("trigger-hover", e)), h?.events.emit("floating.closed", e));
	}, [
		v,
		n,
		g,
		h
	]), E = U(() => {
		g.handler &&= (ht(n.select("domReferenceElement")).removeEventListener("mousemove", g.handler), void 0);
	});
	S.useEffect(() => E, [E]);
	let D = U(() => {
		ym(g);
	});
	return S.useEffect(() => {
		if (!a) return;
		function e(e) {
			e.open || (E(), g.openChangeTimeout.clear(), g.restTimeout.clear(), g.blockMouseMove = !0, g.restTimeoutPending = !1);
		}
		return i.on("openchange", e), () => {
			i.off("openchange", e);
		};
	}, [
		a,
		i,
		g,
		E
	]), S.useEffect(() => {
		if (!a) return;
		let e = d.current ?? (p ? n.select("domReferenceElement") : null);
		if (!Fe(e)) return;
		function t(e) {
			if (g.openChangeTimeout.clear(), g.blockMouseMove = !1, c && !Tn(g.pointerType) || mm(y.current) > 0 && !pm(v.current, "open")) return;
			let t = pm(v.current, "open", g.pointerType), r = e.currentTarget ?? null, i = n.select("domReferenceElement"), a = r == null ? !1 : w(i, r, e.target), o = n.select("open"), s = !o || a;
			a && o ? n.setOpen(!0, K(en, e, r)) : t ? g.openChangeTimeout.start(t, () => {
				s && n.setOpen(!0, K("trigger-hover", e, r));
			}) : s && n.setOpen(!0, K("trigger-hover", e, r));
		}
		function i(e) {
			if (x()) {
				D();
				return;
			}
			E();
			let t = ht(n.select("domReferenceElement"));
			g.restTimeout.clear(), g.restTimeoutPending = !1;
			let i = r.current.floatingContext ?? m?.();
			if (!C(e.relatedTarget)) {
				if (_.current && i) {
					n.select("open") || g.openChangeTimeout.clear();
					let r = d.current;
					g.handler = _.current({
						...i,
						tree: h,
						x: e.clientX,
						y: e.clientY,
						onClose() {
							D(), E(), b.current && !x() && r === n.select("domReferenceElement") && T(e, !0);
						}
					}), t.addEventListener("mousemove", g.handler), g.handler(e);
					return;
				}
				(g.pointerType !== "touch" || !G(n.select("floatingElement"), e.relatedTarget)) && T(e);
			}
		}
		return u && e.addEventListener("mousemove", t, { once: !0 }), e.addEventListener("mouseenter", t), e.addEventListener("mouseleave", i), () => {
			u && e.removeEventListener("mousemove", t), e.removeEventListener("mouseenter", t), e.removeEventListener("mouseleave", i);
		};
	}, [
		E,
		D,
		r,
		v,
		T,
		n,
		a,
		_,
		g,
		p,
		w,
		x,
		C,
		c,
		u,
		y,
		d,
		h,
		b,
		m
	]), S.useMemo(() => {
		if (!a) return;
		function e(e) {
			g.pointerType = e.pointerType;
		}
		return {
			onPointerDown: e,
			onPointerEnter: e,
			onMouseMove(e) {
				let { nativeEvent: t } = e, r = e.currentTarget, i = n.select("domReferenceElement"), a = n.select("open"), o = w(i, r, e.target);
				if (c && !Tn(g.pointerType)) return;
				let s = mm(y.current);
				if (a && !o || s === 0 || !o && g.restTimeoutPending && e.movementX ** 2 + e.movementY ** 2 < 2) return;
				g.restTimeout.clear();
				function l() {
					if (g.restTimeoutPending = !1, x()) return;
					let e = n.select("open");
					!g.blockMouseMove && (!e || o) && n.setOpen(!0, K("trigger-hover", t, r));
				}
				g.pointerType === "touch" ? tr.flushSync(() => {
					l();
				}) : o && a ? l() : (g.restTimeoutPending = !0, g.restTimeout.start(s, l));
			}
		};
	}, [
		a,
		g,
		x,
		w,
		c,
		n,
		y
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/safePolygon.js
var wm = .1, Tm = wm * wm, Em = .5;
function Dm(e, t, n, r, i, a) {
	return r >= t != a >= t && e <= (i - n) * (t - r) / (a - r) + n;
}
function Om(e, t, n, r, i, a, o, s, c, l) {
	let u = !1;
	return Dm(e, t, n, r, i, a) && (u = !u), Dm(e, t, i, a, o, s) && (u = !u), Dm(e, t, o, s, c, l) && (u = !u), Dm(e, t, c, l, n, r) && (u = !u), u;
}
function km(e, t, n) {
	return e >= n.x && e <= n.x + n.width && t >= n.y && t <= n.y + n.height;
}
function Am(e, t, n, r, i, a) {
	return e >= Math.min(n, i) && e <= Math.max(n, i) && t >= Math.min(r, a) && t <= Math.max(r, a);
}
function jm(e = {}) {
	let { blockPointerEvents: t = !1 } = e, n = new yt(), r = ({ x: e, y: t, placement: r, elements: i, onClose: a, nodeId: o, tree: s }) => {
		let c = r?.split("-")[0], l = !1, u = null, d = null, f = typeof performance < "u" ? performance.now() : 0;
		function p(e, t) {
			let n = performance.now(), r = n - f;
			if (u === null || d === null || r === 0) return u = e, d = t, f = n, !1;
			let i = e - u, a = t - d, o = i * i + a * a, s = r * r * Tm;
			return u = e, d = t, f = n, o < s;
		}
		function m() {
			n.clear(), a();
		}
		return function(r) {
			n.clear();
			let a = i.domReference, u = i.floating;
			if (!a || !u || c == null || e == null || t == null) return;
			let { clientX: d, clientY: f } = r, h = Gt(r), g = r.type === "mouseleave", _ = G(u, h), v = G(a, h);
			if (_ && (l = !0, !g)) return;
			if (v && (l = !1, !g)) {
				l = !0;
				return;
			}
			if (g && Fe(r.relatedTarget) && G(u, r.relatedTarget)) return;
			function y() {
				return !!(s && yn(s.nodesRef.current, o).length > 0);
			}
			function b() {
				y() || m();
			}
			if (y()) return;
			let x = a.getBoundingClientRect(), S = u.getBoundingClientRect(), C = e > S.right - S.width / 2, w = t > S.bottom - S.height / 2, T = S.width > x.width, E = S.height > x.height, D = (T ? x : S).left, O = (T ? x : S).right, k = (E ? x : S).top, A = (E ? x : S).bottom;
			if (c === "top" && t >= x.bottom - 1 || c === "bottom" && t <= x.top + 1 || c === "left" && e >= x.right - 1 || c === "right" && e <= x.left + 1) {
				b();
				return;
			}
			let j = !1;
			switch (c) {
				case "top":
					j = Am(d, f, D, x.top + 1, O, S.bottom - 1);
					break;
				case "bottom":
					j = Am(d, f, D, S.top + 1, O, x.bottom - 1);
					break;
				case "left":
					j = Am(d, f, S.right - 1, A, x.left + 1, k);
					break;
				case "right":
					j = Am(d, f, x.right - 1, A, S.left + 1, k);
					break;
				default:
			}
			if (j) return;
			if (l && !km(d, f, x)) {
				b();
				return;
			}
			if (!g && p(d, f)) {
				b();
				return;
			}
			let M = !1;
			switch (c) {
				case "top": {
					let n = T ? Em / 2 : Em * 4, r = T || C ? e + n : e - n, i = T ? e - n : C ? e + n : e - n, a = t + Em + 1, o = C || T ? S.bottom - Em : S.top, s = C ? T ? S.bottom - Em : S.top : S.bottom - Em;
					M = Om(d, f, r, a, i, a, S.left, o, S.right, s);
					break;
				}
				case "bottom": {
					let n = T ? Em / 2 : Em * 4, r = T || C ? e + n : e - n, i = T ? e - n : C ? e + n : e - n, a = t - Em, o = C || T ? S.top + Em : S.bottom, s = C ? T ? S.top + Em : S.bottom : S.top + Em;
					M = Om(d, f, r, a, i, a, S.left, o, S.right, s);
					break;
				}
				case "left": {
					let n = E ? Em / 2 : Em * 4, r = E || w ? t + n : t - n, i = E ? t - n : w ? t + n : t - n, a = e + Em + 1, o = w || E ? S.right - Em : S.left, s = w ? E ? S.right - Em : S.left : S.right - Em;
					M = Om(d, f, o, S.top, s, S.bottom, a, r, a, i);
					break;
				}
				case "right": {
					let n = E ? Em / 2 : Em * 4, r = E || w ? t + n : t - n, i = E ? t - n : w ? t + n : t - n, a = e - Em, o = w || E ? S.left + Em : S.right, s = w ? E ? S.left + Em : S.right : S.left + Em;
					M = Om(d, f, a, r, a, i, o, S.top, s, S.bottom);
					break;
				}
				default:
			}
			M ? l || n.start(40, b) : b();
		};
	};
	return r.__options = { blockPointerEvents: t }, r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/trigger/PopoverTrigger.js
var Mm = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, disabled: i = !1, nativeButton: a = !0, handle: o, payload: s, openOnHover: c = !1, delay: l = 300, closeDelay: u = 0, id: d, ...f } = e, p = om(!0), m = o?.store ?? p?.store;
	if (!m) throw Error(process.env.NODE_ENV === "production" ? lr(74) : "Base UI: <Popover.Trigger> must be either used within a <Popover.Root> component or provided with a handle.");
	let h = Il(d), g = m.useState("isTriggerActive", h), _ = m.useState("floatingRootContext"), v = m.useState("isOpenedByTrigger", h), y = S.useRef(null), { registerTrigger: b, isMountedByThisTrigger: x } = ar(h, y, m, {
		payload: s,
		disabled: i,
		openOnHover: c,
		closeDelay: u
	}), w = m.useState("openChangeReason"), T = m.useState("stickIfOpen"), E = m.useState("openMethod"), D = Cm(_, {
		enabled: _ != null && c && (E !== "touch" || w !== "trigger-press"),
		mouseOnly: !0,
		move: !1,
		handleClose: jm(),
		restMs: l,
		delay: { close: u },
		triggerElementRef: y,
		isActiveTrigger: g
	}), O = ui([Nu(_, {
		enabled: _ != null,
		stickIfOpen: T
	})]), k = m.useState("triggerProps", x), A = {
		disabled: i,
		open: v
	}, { getButtonProps: j, buttonRef: M } = iu({
		disabled: i,
		native: a
	}), N = S.useMemo(() => ({ open(e) {
		return e && w === "trigger-press" ? pa.open(e) : fa.open(e);
	} }), [w]), P = Y("button", e, {
		state: A,
		ref: [
			M,
			t,
			b,
			y
		],
		props: [
			O.getReferenceProps(),
			D,
			k,
			{
				[Wo]: "",
				id: h
			},
			f,
			j
		],
		stateAttributesMapping: N
	}), F = S.useRef(null), I = U((e) => {
		tr.flushSync(() => {
			m.setOpen(!1, K(fn, e.nativeEvent, e.currentTarget));
		}), zo(F.current)?.focus();
	}), L = U((e) => {
		let t = m.select("positionerElement");
		if (t && Bo(e, t)) m.context.beforeContentFocusGuardRef.current?.focus();
		else {
			tr.flushSync(() => {
				m.setOpen(!1, K(fn, e.nativeEvent, e.currentTarget));
			});
			let n = Ro(m.context.triggerFocusTargetRef.current || y.current);
			for (; n !== null && G(t, n);) {
				let e = n;
				if (n = Fo(n), n === e) break;
			}
			n?.focus();
		}
	});
	return g ? /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [
		/* @__PURE__ */ (0, C.jsx)(rs, {
			ref: F,
			onFocus: I
		}),
		/* @__PURE__ */ (0, C.jsx)(S.Fragment, { children: P }, h),
		/* @__PURE__ */ (0, C.jsx)(rs, {
			ref: m.context.triggerFocusTargetRef,
			onFocus: L
		})
	] }) : /* @__PURE__ */ (0, C.jsx)(S.Fragment, { children: P }, h);
});
process.env.NODE_ENV !== "production" && (Mm.displayName = "PopoverTrigger");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/portal/PopoverPortalContext.js
var Nm = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Nm.displayName = "PopoverPortalContext");
function Pm() {
	let e = S.useContext(Nm);
	if (e === void 0) throw Error(process.env.NODE_ENV === "production" ? lr(45) : "Base UI: <Popover.Portal> is missing.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/portal/PopoverPortal.js
var Fm = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { keepMounted: n = !1, ...r } = e, { store: i } = om();
	return i.useState("mounted") || n ? /* @__PURE__ */ (0, C.jsx)(Nm.Provider, {
		value: n,
		children: /* @__PURE__ */ (0, C.jsx)(Ss, {
			ref: t,
			...r
		})
	}) : null;
});
process.env.NODE_ENV !== "production" && (Fm.displayName = "PopoverPortal");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/positioner/PopoverPositionerContext.js
var Im = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Im.displayName = "PopoverPositionerContext");
function Lm() {
	let e = S.useContext(Im);
	if (!e) throw Error(process.env.NODE_ENV === "production" ? lr(46) : "Base UI: PopoverPositionerContext is missing. PopoverPositioner parts must be placed within <Popover.Positioner>.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/positioner/PopoverPositioner.js
var Rm = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, anchor: i, positionMethod: a = "absolute", side: o = "bottom", align: s = "center", sideOffset: c = 0, alignOffset: l = 0, collisionBoundary: u = "clipping-ancestors", collisionPadding: d = 5, arrowPadding: f = 5, sticky: p = !1, disableAnchorTracking: m = !1, collisionAvoidance: h = Xo, ...g } = e, { store: _ } = om(), v = Pm(), y = zn(), b = _.useState("floatingRootContext"), x = _.useState("mounted"), w = _.useState("open"), T = _.useState("openChangeReason"), E = _.useState("activeTriggerElement"), D = _.useState("modal"), O = _.useState("positionerElement"), k = _.useState("instantType"), A = _.useState("transitionStatus"), j = _.useState("hasViewport"), M = S.useRef(null), N = nr(O, !1, !1), P = cp({
		anchor: i,
		floatingRootContext: b,
		positionMethod: a,
		mounted: x,
		side: o,
		sideOffset: c,
		align: s,
		alignOffset: l,
		arrowPadding: f,
		collisionBoundary: u,
		collisionPadding: d,
		sticky: p,
		disableAnchorTracking: m,
		keepMounted: v,
		nodeId: y,
		collisionAvoidance: h,
		adaptiveOrigin: j ? ap : void 0
	}), F = S.useMemo(() => {
		let e = {};
		return w || (e.pointerEvents = "none"), {
			role: "presentation",
			hidden: !x,
			style: {
				...P.positionerStyles,
				...e
			}
		};
	}, [
		w,
		x,
		P.positionerStyles
	]), I = S.useMemo(() => ({
		props: F,
		...P
	}), [F, P]), L = b.useState("domReferenceElement");
	W(() => {
		let e = L, t = M.current;
		if (e && (M.current = e), t && e && e !== t) {
			_.set("instantType", void 0);
			let e = new AbortController();
			return N(() => {
				_.set("instantType", "trigger-change");
			}, e.signal), () => {
				e.abort();
			};
		}
	}, [
		L,
		N,
		_
	]);
	let ee = {
		open: w,
		side: I.side,
		align: I.align,
		anchorHidden: I.anchorHidden,
		instant: k
	}, R = S.useCallback((e) => {
		_.set("positionerElement", e);
	}, [_]), z = Y("div", e, {
		state: ee,
		props: [
			I.props,
			up(A),
			g
		],
		ref: [t, R],
		stateAttributesMapping: ma
	});
	return /* @__PURE__ */ (0, C.jsxs)(Im.Provider, {
		value: I,
		children: [x && D === !0 && T !== "trigger-hover" && /* @__PURE__ */ (0, C.jsx)(ic, {
			ref: _.context.internalBackdropRef,
			inert: rc(!w),
			cutout: E
		}), /* @__PURE__ */ (0, C.jsx)(Bn, {
			id: y,
			children: z
		})]
	});
});
process.env.NODE_ENV !== "production" && (Rm.displayName = "PopoverPositioner");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useHoverFloatingInteraction.js
function zm(e, t = {}) {
	let n = "rootStore" in e ? e.rootStore : e, r = n.useState("open"), i = n.useState("floatingElement"), a = n.useState("domReferenceElement"), { dataRef: o } = n.context, { enabled: s = !0, closeDelay: c = 0 } = t, l = xm(n), u = Rn(), d = Ln(), f = U(() => hm(o.current.openEvent?.type, l.interactedInside)), p = U(() => {
		let e = o.current.openEvent?.type;
		return e?.includes("mouse") && e !== "mousedown";
	}), m = U((e) => Wt(e, n.context.triggerElements)), h = S.useCallback((e) => {
		let t = pm(c, "close", l.pointerType), r = () => {
			n.setOpen(!1, K(en, e)), u?.events.emit("floating.closed", e);
		};
		t ? l.openChangeTimeout.start(t, r) : (l.openChangeTimeout.clear(), r());
	}, [
		c,
		n,
		l,
		u
	]), g = U(() => {
		ym(l);
	}), _ = U((e) => {
		let t = Gt(e);
		if (!_m(t)) {
			l.interactedInside = !1;
			return;
		}
		l.interactedInside = t?.closest("[aria-haspopup]") != null;
	});
	W(() => {
		r || (l.pointerType = void 0, l.restTimeoutPending = !1, l.interactedInside = !1, g());
	}, [
		r,
		l,
		g
	]), S.useEffect(() => g, [g]), W(() => {
		if (s && r && l.handleCloseOptions?.blockPointerEvents && p() && Fe(a) && i) {
			let e = a, t = i, n = ht(i), r = u?.nodesRef.current.find((e) => e.id === d)?.context?.elements.floating;
			return r && (r.style.pointerEvents = ""), bm(l, {
				scopeElement: l.handleCloseOptions?.getScope?.() ?? l.pointerEventsScopeElement ?? r ?? e.closest("[data-rootownerid]") ?? n.body,
				referenceElement: e,
				floatingElement: t
			}), () => {
				g();
			};
		}
	}, [
		s,
		r,
		a,
		i,
		l,
		p,
		u,
		d,
		g
	]);
	let v = bt();
	S.useEffect(() => {
		if (!s) return;
		function e() {
			l.openChangeTimeout.clear(), v.clear(), u?.events.off("floating.closed", r), g();
		}
		function t(e) {
			if (u && d && yn(u.nodesRef.current, d).length > 0) {
				u.events.on("floating.closed", r);
				return;
			}
			if (!m(e.relatedTarget)) {
				if (l.handler) {
					l.handler(e);
					return;
				}
				g(), f() || h(e);
			}
		}
		function r(e) {
			!u || !d || yn(u.nodesRef.current, d).length > 0 || v.start(0, () => {
				u.events.off("floating.closed", r), n.setOpen(!1, K("trigger-hover", e)), u.events.emit("floating.closed", e);
			});
		}
		let a = i;
		return a && (a.addEventListener("mouseenter", e), a.addEventListener("mouseleave", t), a.addEventListener("pointerdown", _, !0)), () => {
			a && (a.removeEventListener("mouseenter", e), a.removeEventListener("mouseleave", t), a.removeEventListener("pointerdown", _, !0)), u?.events.off("floating.closed", r);
		};
	}, [
		s,
		i,
		n,
		o,
		f,
		m,
		h,
		g,
		_,
		l,
		u,
		d,
		v
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/toolbar/root/ToolbarRootContext.js
var Bm = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Bm.displayName = "ToolbarRootContext");
function Vm(e) {
	let t = S.useContext(Bm);
	if (t === void 0 && !e) throw Error(process.env.NODE_ENV === "production" ? lr(69) : "Base UI: ToolbarRootContext is missing. Toolbar parts must be placed within <Toolbar.Root>.");
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/closePart.js
var Hm = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Hm.displayName = "ClosePartContext");
function Um() {
	let [e, t] = S.useState(0), n = U(() => (t((e) => e + 1), () => {
		t((e) => Math.max(0, e - 1));
	}));
	return {
		context: S.useMemo(() => ({ register: n }), [n]),
		hasClosePart: e > 0
	};
}
function Wm(e) {
	let { value: t, children: n } = e;
	return /* @__PURE__ */ (0, C.jsx)(Hm.Provider, {
		value: t,
		children: n
	});
}
function Gm() {
	let e = S.useContext(Hm);
	W(() => e?.register(), [e]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/popup/PopoverPopup.js
var Km = {
	...ma,
	...Zn
}, qm = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, initialFocus: i, finalFocus: a, ...o } = e, { store: s } = om(), c = Lm(), l = Vm(!0) != null, { context: u, hasClosePart: d } = Um(), f = s.useState("open"), p = s.useState("openMethod"), m = s.useState("instantType"), h = s.useState("transitionStatus"), g = s.useState("popupProps"), _ = s.useState("titleElementId"), v = s.useState("descriptionElementId"), y = s.useState("modal"), b = s.useState("mounted"), x = s.useState("openChangeReason"), w = s.useState("activeTriggerElement"), T = s.useState("floatingRootContext");
	rr({
		open: f,
		ref: s.context.popupRef,
		onComplete() {
			f && s.context.onOpenChangeComplete?.(!0);
		}
	});
	let E = s.useState("disabled"), D = s.useState("openOnHover"), O = s.useState("closeDelay");
	zm(T, {
		enabled: D && !E,
		closeDelay: O
	});
	function k(e) {
		return e === "touch" ? s.context.popupRef.current : !0;
	}
	let A = i === void 0 ? k : i, j = {
		open: f,
		side: c.side,
		align: c.align,
		instant: m,
		transitionStatus: h
	}, M = y !== !1 && d, N = S.useCallback((e) => {
		s.set("popupElement", e);
	}, [s]), P = Y("div", e, {
		state: j,
		ref: [
			t,
			s.context.popupRef,
			N
		],
		props: [
			g,
			{
				"aria-labelledby": _,
				"aria-describedby": v,
				onKeyDown(e) {
					l && Js.has(e.key) && e.stopPropagation();
				}
			},
			up(h),
			o
		],
		stateAttributesMapping: Km
	});
	return /* @__PURE__ */ (0, C.jsx)(Ms, {
		context: T,
		openInteractionType: p,
		modal: M,
		disabled: !b || x === "trigger-hover",
		initialFocus: A,
		returnFocus: a,
		restoreFocus: "popup",
		previousFocusableElement: Ie(w) ? w : void 0,
		nextFocusableElement: s.context.triggerFocusTargetRef,
		beforeContentFocusGuardRef: s.context.beforeContentFocusGuardRef,
		children: /* @__PURE__ */ (0, C.jsx)(Wm, {
			value: u,
			children: P
		})
	});
});
process.env.NODE_ENV !== "production" && (qm.displayName = "PopoverPopup");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/arrow/PopoverArrow.js
var Jm = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, ...i } = e, { store: a } = om(), o = a.useState("open"), { arrowRef: s, side: c, align: l, arrowUncentered: u, arrowStyles: d } = Lm();
	return Y("div", e, {
		state: {
			open: o,
			side: c,
			align: l,
			uncentered: u
		},
		ref: [t, s],
		props: [{
			style: d,
			"aria-hidden": !0
		}, i],
		stateAttributesMapping: ma
	});
});
process.env.NODE_ENV !== "production" && (Jm.displayName = "PopoverArrow");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/title/PopoverTitle.js
var Ym = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, ...i } = e, { store: a } = om(), o = Il(i.id);
	return W(() => (a.set("titleElementId", o), () => {
		a.set("titleElementId", void 0);
	}), [a, o]), Y("h2", e, {
		ref: t,
		props: [{ id: o }, i]
	});
});
process.env.NODE_ENV !== "production" && (Ym.displayName = "PopoverTitle");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/description/PopoverDescription.js
var Xm = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, ...i } = e, { store: a } = om(), o = Il(i.id);
	return W(() => (a.set("descriptionElementId", o), () => {
		a.set("descriptionElementId", void 0);
	}), [a, o]), Y("p", e, {
		ref: t,
		props: [{ id: o }, i]
	});
});
process.env.NODE_ENV !== "production" && (Xm.displayName = "PopoverDescription"), V(), V();
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/dialog/root/DialogRoot.js
function Zm(e) {
	let { children: t, open: n, defaultOpen: r = !1, onOpenChange: i, onOpenChangeComplete: a, disablePointerDismissal: o = !1, modal: s = !0, actionsRef: c, handle: l, triggerId: u, defaultTriggerId: d = null } = e, f = bi(!0), p = !!f, m = Te(() => l?.store ?? new Di({
		open: r,
		openProp: n,
		activeTriggerId: d,
		triggerIdProp: u,
		modal: s,
		disablePointerDismissal: o,
		nested: p
	})).current;
	Hu(() => {
		n === void 0 && m.state.open === !1 && r === !0 && m.update({
			open: !0,
			activeTriggerId: d
		});
	}), m.useControlledProp("openProp", n), m.useControlledProp("triggerIdProp", u), m.useSyncedValues({
		disablePointerDismissal: o,
		nested: p,
		modal: s
	}), m.useContextCallback("onOpenChange", i), m.useContextCallback("onOpenChangeComplete", a);
	let h = m.useState("payload");
	vi({
		store: m,
		actionsRef: c,
		parentContext: f?.store.context,
		onOpenChange: i,
		triggerIdProp: u
	});
	let g = S.useMemo(() => ({ store: m }), [m]);
	return /* @__PURE__ */ (0, C.jsx)(yi.Provider, {
		value: g,
		children: typeof t == "function" ? t({ payload: h }) : t
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/modal.module.js
var Qm = {
	container: "_container_1q7rb_1",
	modal: "_modal_1q7rb_10",
	backdrop: "_backdrop_1q7rb_27"
}, $m = { content: "_content_1u5rz_1" }, eh = /* @__PURE__ */ B(V(), 1);
function th(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, eh.default)($m.content, n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)("div", {
		className: i,
		...r
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/modal/footer.module.js
var nh = { footer: "_footer_vyk5l_1" }, rh = /* @__PURE__ */ B(V(), 1);
function ih(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, rh.default)(nh.footer, n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)("div", {
		className: i,
		...r
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/modal/header.module.js
var ah = { header: "_header_rhpmi_1" }, oh = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, disabled: i = !1, nativeButton: a = !0, ...o } = e, { store: s } = bi(), c = s.useState("open");
	function l(e) {
		c && s.setOpen(!1, K("close-press", e.nativeEvent));
	}
	let { getButtonProps: u, buttonRef: d } = iu({
		disabled: i,
		native: a
	});
	return Y("button", e, {
		state: { disabled: i },
		ref: [t, d],
		props: [
			{ onClick: l },
			o,
			u
		]
	});
});
process.env.NODE_ENV !== "production" && (oh.displayName = "DialogClose");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/modal/header/close.js
function sh(e) {
	let t = (0, x.c)(2), n;
	return t[0] === e ? n = t[1] : (n = /* @__PURE__ */ (0, C.jsx)(oh, { render: (t) => /* @__PURE__ */ (0, C.jsx)(xe, {
		"aria-label": "Close modal",
		buttonType: "ghost",
		icon: "cross",
		...t,
		...e
	}) }), t[0] = e, t[1] = n), n;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/dialog/title/DialogTitle.js
var ch = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, id: i, ...a } = e, { store: o } = bi(), s = Il(i);
	return o.useSyncedValueWithCleanup("titleElementId", s), Y("h2", e, {
		ref: t,
		props: [{ id: s }, a]
	});
});
process.env.NODE_ENV !== "production" && (ch.displayName = "DialogTitle");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/modal/header/title.module.js
var lh = { title: "_title_ni006_1" }, uh = /* @__PURE__ */ B(V(), 1);
function dh(e) {
	let t = (0, x.c)(10), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({className: r, children: n, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a;
	t[4] === r ? a = t[5] : (a = (0, uh.default)(lh.title, r, "heading-3"), t[4] = r, t[5] = a);
	let o;
	return t[6] !== n || t[7] !== i || t[8] !== a ? (o = /* @__PURE__ */ (0, C.jsx)(ch, {
		className: a,
		...i,
		children: n
	}), t[6] = n, t[7] = i, t[8] = a, t[9] = o) : o = t[9], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/modal/header.js
var fh = /* @__PURE__ */ B(V(), 1);
function ph(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, fh.default)(ah.header, n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)("div", {
		className: i,
		...r
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
ph.Title = dh, ph.Close = sh;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/modal.js
function mh(e) {
	let t = (0, x.c)(13), { children: n, onOpenChange: r, open: i, unsafe_modal: a, unsafe_portalContainer: o } = e, s;
	t[0] === r ? s = t[1] : (s = function(e) {
		r && r(e);
	}, t[0] = r, t[1] = s);
	let c = s, l;
	t[2] === Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ (0, C.jsx)(ga, {
		className: Qm.backdrop,
		"data-testid": "modal-backdrop"
	}), t[2] = l) : l = t[2];
	let u;
	t[3] === n ? u = t[4] : (u = /* @__PURE__ */ (0, C.jsx)(nc, {
		"aria-modal": "true",
		className: Qm.modal,
		children: n
	}), t[3] = n, t[4] = u);
	let d;
	t[5] !== u || t[6] !== o ? (d = /* @__PURE__ */ (0, C.jsxs)(ac, {
		className: Qm.container,
		container: o,
		children: [l, u]
	}), t[5] = u, t[6] = o, t[7] = d) : d = t[7];
	let f;
	return t[8] !== c || t[9] !== i || t[10] !== d || t[11] !== a ? (f = /* @__PURE__ */ (0, C.jsx)(Zm, {
		modal: a,
		onOpenChange: c,
		open: i,
		children: d
	}), t[8] = c, t[9] = i, t[10] = d, t[11] = a, t[12] = f) : f = t[12], f;
}
mh.Header = ph, mh.Content = th, mh.Footer = ih;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/getCssDimensions.js
function hh(e) {
	let t = Ye(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = Ie(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r;
	return (ba(n) !== a || ba(r) !== o) && (n = a, r = o), {
		width: n,
		height: r
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/root/NavigationMenuRootContext.js
var gh = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (gh.displayName = "NavigationMenuRootContext"), process.env.NODE_ENV !== "production" && (gh.displayName = "NavigationMenuRootContext");
function _h(e) {
	let t = S.useContext(gh);
	if (t === void 0 && !e) throw Error(process.env.NODE_ENV === "production" ? lr(41) : "Base UI: NavigationMenuRootContext is missing. Navigation Menu parts must be placed within <NavigationMenu.Root>.");
	return t;
}
var vh = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (vh.displayName = "NavigationMenuTreeContext");
function yh() {
	return S.useContext(vh);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/popup/NavigationMenuPopupCssVars.js
var bh = /* @__PURE__ */ function(e) {
	return e.popupWidth = "--popup-width", e.popupHeight = "--popup-height", e;
}({}), xh = /* @__PURE__ */ function(e) {
	return e.availableWidth = "--available-width", e.availableHeight = "--available-height", e.anchorWidth = "--anchor-width", e.anchorHeight = "--anchor-height", e.transformOrigin = "--transform-origin", e.positionerWidth = "--positioner-width", e.positionerHeight = "--positioner-height", e;
}({}), Sh = new Set([
	en,
	nn,
	fn
]);
function Ch(e, t) {
	let { width: n, height: r } = hh(e);
	n === 0 || r === 0 || (e.style.setProperty(bh.popupWidth, `${n}px`), e.style.setProperty(bh.popupHeight, `${r}px`), t.style.setProperty(xh.positionerWidth, `${n}px`), t.style.setProperty(xh.positionerHeight, `${r}px`));
}
var wh = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { defaultValue: n = null, value: r, onValueChange: i, actionsRef: a, delay: o = 50, closeDelay: s = 50, orientation: c = "horizontal", onOpenChangeComplete: l } = e, u = Ln() != null, d = _h(!0), [f, p] = Ll({
		controlled: r,
		default: n,
		name: "NavigationMenu",
		state: "value"
	}), m = f != null, h = S.useRef(void 0), g = S.useRef(null), [_, v] = S.useState(null), [y, b] = S.useState(null), [x, w] = S.useState(null), [T, E] = S.useState(null), [D, O] = S.useState(null), [k, A] = S.useState(void 0), [j, M] = S.useState(!1), N = S.useRef(null), P = S.useRef(null), F = S.useRef(null), I = S.useRef(null), L = S.useRef(null), ee = S.useRef(null), { mounted: R, setMounted: z, transitionStatus: te } = Kn(m);
	S.useEffect(() => {
		M(!1);
	}, [f]);
	let B = U((e, t) => {
		e || (h.current = t.reason, O(null), A(void 0), _ && y && Ch(y, _)), e !== f && i?.(e, t), !t.isCanceled && (p(e), u && !e && t.reason === "link-press" && d && d.setValue(null, t));
	}), V = U(() => {
		let e = Ut(ht(g.current));
		!(h.current && Sh.has(h.current)) && Ie(N.current) && (e === ht(y).body || G(y, e)) && y && (N.current.focus({ preventScroll: !0 }), N.current = void 0), z(!1), l?.(!1), O(null), A(void 0), P.current = null, h.current = void 0;
	});
	rr({
		enabled: !a,
		open: m,
		ref: { current: y },
		onComplete() {
			m || V();
		}
	}), rr({
		enabled: !a,
		open: m,
		ref: { current: T },
		onComplete() {
			m || V();
		}
	});
	let ne = S.useMemo(() => ({
		open: m,
		value: f,
		setValue: B,
		mounted: R,
		transitionStatus: te,
		positionerElement: _,
		setPositionerElement: v,
		popupElement: y,
		setPopupElement: b,
		viewportElement: x,
		setViewportElement: w,
		viewportTargetElement: T,
		setViewportTargetElement: E,
		activationDirection: D,
		setActivationDirection: O,
		floatingRootContext: k,
		setFloatingRootContext: A,
		currentContentRef: P,
		nested: u,
		rootRef: g,
		beforeInsideRef: F,
		afterInsideRef: I,
		beforeOutsideRef: L,
		afterOutsideRef: ee,
		prevTriggerElementRef: N,
		delay: o,
		closeDelay: s,
		orientation: c,
		viewportInert: j,
		setViewportInert: M
	}), [
		m,
		f,
		B,
		R,
		te,
		_,
		y,
		x,
		T,
		D,
		k,
		u,
		o,
		s,
		c,
		j
	]), re = /* @__PURE__ */ (0, C.jsx)(gh.Provider, {
		value: ne,
		children: /* @__PURE__ */ (0, C.jsx)(Th, {
			componentProps: e,
			forwardedRef: t,
			children: e.children
		})
	});
	return u ? re : /* @__PURE__ */ (0, C.jsx)(Vn, { children: re });
});
process.env.NODE_ENV !== "production" && (wh.displayName = "NavigationMenuRoot");
function Th(e) {
	let { className: t, render: n, defaultValue: r, value: i, onValueChange: a, actionsRef: o, delay: s, closeDelay: c, orientation: l, onOpenChangeComplete: u, ...d } = e.componentProps, f = zn(), { rootRef: p, nested: m } = _h(), { open: h } = _h(), g = {
		open: h,
		nested: m
	}, _ = Y(m ? "div" : "nav", e.componentProps, {
		state: g,
		ref: [e.forwardedRef, p],
		props: d
	});
	return /* @__PURE__ */ (0, C.jsx)(vh.Provider, {
		value: f,
		children: /* @__PURE__ */ (0, C.jsx)(Bn, {
			id: f,
			children: _
		})
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/navigation-menu.module.js
var Eh = {
	"prism-navigation-menu": "_prism-navigation-menu_15viv_1",
	"prism-navigation-menu__positioner": "_prism-navigation-menu__positioner_15viv_7",
	"prism-navigation-menu__popup": "_prism-navigation-menu__popup_15viv_13",
	"prism-navigation-menu__viewport": "_prism-navigation-menu__viewport_15viv_37"
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/isElementDisabled.js
function Dh(e) {
	return e == null || e.hasAttribute("disabled") || e.getAttribute("aria-disabled") === "true";
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/composite/constants.js
var Oh = "data-composite-item-active", kh = [];
function Ah(e) {
	let { itemSizes: t, cols: n = 1, loopFocus: r = !0, dense: i = !1, orientation: a = "both", direction: o, highlightedIndex: s, onHighlightedIndexChange: c, rootRef: l, enableHomeAndEndKeys: u = !1, stopEventPropagation: d = !1, disabledIndices: f, modifierKeys: p = kh } = e, [m, h] = S.useState(0), g = n > 1, _ = S.useRef(null), v = Ai(_, l), y = S.useRef([]), b = S.useRef(!1), x = s ?? m, C = U((e, t = !1) => {
		if ((c ?? h)(e), t) {
			let t = y.current[e];
			Qs(_.current, t, o, a);
		}
	}), w = U((e) => {
		if (e.size === 0 || b.current) return;
		b.current = !0;
		let t = Array.from(e.keys()), n = t.find((e) => e?.hasAttribute("data-composite-item-active")) ?? null, r = n ? t.indexOf(n) : -1;
		r !== -1 && C(r), Qs(_.current, n, o, a);
	}), T = S.useMemo(() => ({
		"aria-orientation": a === "both" ? void 0 : a,
		ref: v,
		onFocus(e) {
			!_.current || !Zs(e.target) || e.target.setSelectionRange(0, e.target.value.length ?? 0);
		},
		onKeyDown(e) {
			let s = u ? qs : Ks;
			if (!s.has(e.key) || jh(e, p) || !_.current) return;
			let c = o === "rtl", l = c ? zs : Bs, m = {
				horizontal: l,
				vertical: Rs,
				both: l
			}[a], h = c ? Bs : zs, v = {
				horizontal: h,
				vertical: Ls,
				both: h
			}[a];
			if (Zs(e.target) && !Dh(e.target)) {
				let t = e.target.selectionStart, n = e.target.selectionEnd, r = e.target.value ?? "";
				if (t == null || e.shiftKey || t !== n || e.key !== v && t < r.length || e.key !== m && t > 0) return;
			}
			let b = x, S = qa(y, f), w = Ja(y, f);
			if (g) {
				let o = t || Array.from({ length: y.current.length }, () => ({
					width: 1,
					height: 1
				})), s = Za(o, n, i), l = s.findIndex((e) => e != null && !eo(y, e, f)), u = s.reduce((e, t, n) => t != null && !eo(y, t, f) ? n : e, -1);
				b = s[Xa({ current: s.map((e) => e ? y.current[e] : null) }, {
					event: e,
					orientation: a,
					loopFocus: r,
					cols: n,
					disabledIndices: $a([...f || y.current.map((e, t) => eo(y, t) ? t : void 0), void 0], s),
					minIndex: l,
					maxIndex: u,
					prevIndex: Qa(x > w ? S : x, o, s, n, e.key === "ArrowDown" ? "bl" : e.key === "ArrowRight" ? "tr" : "tl"),
					rtl: c
				})];
			}
			let T = {
				horizontal: [l],
				vertical: [Rs],
				both: [l, Rs]
			}[a], E = {
				horizontal: [h],
				vertical: [Ls],
				both: [h, Ls]
			}[a], D = g ? s : {
				horizontal: u ? Us : Hs,
				vertical: u ? Gs : Ws,
				both: s
			}[a];
			u && (e.key === "Home" ? b = S : e.key === "End" && (b = w)), b === x && (T.includes(e.key) || E.includes(e.key)) && (b = r && b === w && T.includes(e.key) ? S : r && b === S && E.includes(e.key) ? w : Ya(y, {
				startingIndex: b,
				decrement: E.includes(e.key),
				disabledIndices: f
			})), b !== x && !Ka(y, b) && (d && e.stopPropagation(), D.has(e.key) && e.preventDefault(), C(b, !0), queueMicrotask(() => {
				y.current[b]?.focus();
			}));
		}
	}), [
		n,
		i,
		o,
		f,
		y,
		u,
		x,
		g,
		t,
		r,
		v,
		p,
		C,
		a,
		d
	]);
	return S.useMemo(() => ({
		props: T,
		highlightedIndex: x,
		onHighlightedIndexChange: C,
		elementsRef: y,
		disabledIndices: f,
		onMapChange: w,
		relayKeyboardEvent: T.onKeyDown
	}), [
		T,
		x,
		C,
		y,
		f,
		w
	]);
}
function jh(e, t) {
	for (let n of Ys.values()) if (!t.includes(n) && e.getModifierState(n)) return !0;
	return !1;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/composite/root/CompositeRoot.js
function Mh(e) {
	let { render: t, className: n, refs: r = Dt, props: i = Dt, state: a = Ot, stateAttributesMapping: o, highlightedIndex: s, onHighlightedIndexChange: c, orientation: l, dense: u, itemSizes: d, loopFocus: f, cols: p, enableHomeAndEndKeys: m, onMapChange: h, stopEventPropagation: g = !0, rootRef: _, disabledIndices: v, modifierKeys: y, highlightItemOnHover: b = !1, tag: x = "div", ...w } = e, { props: T, highlightedIndex: E, onHighlightedIndexChange: D, elementsRef: O, onMapChange: k, relayKeyboardEvent: A } = Ah({
		itemSizes: d,
		cols: p,
		loopFocus: f,
		dense: u,
		orientation: l,
		highlightedIndex: s,
		onHighlightedIndexChange: c,
		rootRef: _,
		stopEventPropagation: g,
		enableHomeAndEndKeys: m,
		direction: kd(),
		disabledIndices: v,
		modifierKeys: y
	}), j = Y(x, e, {
		state: a,
		ref: r,
		props: [
			T,
			...i,
			w
		],
		stateAttributesMapping: o
	}), M = S.useMemo(() => ({
		highlightedIndex: E,
		onHighlightedIndexChange: D,
		highlightItemOnHover: b,
		relayKeyboardEvent: A
	}), [
		E,
		D,
		b,
		A
	]);
	return /* @__PURE__ */ (0, C.jsx)(tu.Provider, {
		value: M,
		children: /* @__PURE__ */ (0, C.jsx)(Ld, {
			elementsRef: O,
			onMapChange: (e) => {
				h?.(e), k(e);
			},
			children: j
		})
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/item/NavigationMenuItemContext.js
var Nh = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Nh.displayName = "NavigationMenuItemContext");
function Ph() {
	let e = S.useContext(Nh);
	if (!e) throw Error(process.env.NODE_ENV === "production" ? lr(39) : "Base UI: NavigationMenuItem parts must be used within a <NavigationMenu.Item>.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/content/NavigationMenuContent.js
var Fh = {
	...ma,
	...Zn,
	activationDirection(e) {
		return e ? { "data-activation-direction": e } : null;
	}
}, Ih = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, keepMounted: i = !1, ...a } = e, { mounted: o, viewportElement: s, value: c, activationDirection: l, currentContentRef: u, viewportTargetElement: d } = _h(), { value: f } = Ph(), p = yh(), m = o && c === f, h = S.useRef(null), [g, _] = S.useState(!1), [v, y] = S.useState(!1), { mounted: b, setMounted: x, transitionStatus: w } = Kn(m);
	b && !o && x(!1), rr({
		ref: h,
		open: m,
		onComplete() {
			m || x(!1);
		}
	}), W(() => {
		m && h.current && (u.current = h.current);
	}, [m, u]);
	let T = {
		open: m,
		transitionStatus: w,
		activationDirection: l
	}, E = S.useCallback((e) => {
		e && (u.current = e);
	}, [u]), D = {
		onFocus(e) {
			Gt(e.nativeEvent)?.hasAttribute("data-base-ui-focus-guard") || y(!0);
		},
		onBlur(e) {
			G(e.currentTarget, e.relatedTarget) || y(!1);
		}
	}, O = !m && b ? {
		style: {
			position: "absolute",
			top: 0,
			left: 0
		},
		inert: rc(!v),
		...D
	} : D, k = d || s, A = i && !b, j = i && !k && !g;
	return i && k && !g && _(!0), j ? /* @__PURE__ */ (0, C.jsx)(Mh, {
		render: r,
		className: n,
		state: T,
		refs: [t],
		props: [
			O,
			{ hidden: !0 },
			a
		],
		stateAttributesMapping: Fh
	}) : !k || !b && !i ? null : /* @__PURE__ */ tr.createPortal(/* @__PURE__ */ (0, C.jsx)(Bn, {
		id: p,
		children: /* @__PURE__ */ (0, C.jsx)(Mh, {
			render: r,
			className: n,
			state: T,
			refs: [
				t,
				h,
				E
			],
			props: [
				O,
				A ? { hidden: !0 } : Ot,
				a
			],
			stateAttributesMapping: Fh
		})
	}), k);
});
process.env.NODE_ENV !== "production" && (Ih.displayName = "NavigationMenuContent");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/navigation-menu/content.module.js
var Lh = { "prism-navigation-menu__content-list": "_prism-navigation-menu__content-list_1sbk6_1" };
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/composite/item/useCompositeItem.js
function Rh(e = {}) {
	let { highlightItemOnHover: t, highlightedIndex: n, onHighlightedIndexChange: r } = nu(), { ref: i, index: a } = vp(e), o = n === a, s = S.useRef(null), c = Ai(i, s);
	return {
		compositeProps: S.useMemo(() => ({
			tabIndex: o ? 0 : -1,
			onFocus() {
				r(a);
			},
			onMouseMove() {
				let e = s.current;
				if (!t || !e) return;
				let n = e.hasAttribute("disabled") || e.ariaDisabled === "true";
				!o && !n && e.focus();
			}
		}), [
			o,
			r,
			a,
			t
		]),
		compositeRef: c,
		index: a
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/composite/item/CompositeItem.js
function zh(e) {
	let { render: t, className: n, state: r = Ot, props: i = Dt, refs: a = Dt, metadata: o, stateAttributesMapping: s, tag: c = "div", ...l } = e, { compositeProps: u, compositeRef: d } = Rh({ metadata: o });
	return Y(c, e, {
		state: r,
		ref: [...a, d],
		props: [
			u,
			...i,
			l
		],
		stateAttributesMapping: s
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/utils/isOutsideMenuEvent.js
function Bh({ currentTarget: e, relatedTarget: t }, n) {
	let { popupElement: r, viewportElement: i, rootRef: a, tree: o, nodeId: s } = n, c = o ? yn(o.nodesRef.current, s).some((e) => G(e.context?.elements.floating, t)) : [];
	if (!r) return !G(a.current, t) && !c;
	let l = r || i;
	return !G(l, e) && !G(l, t) && !G(a.current, t) && !c && !(G(l, t) && t?.hasAttribute("data-base-ui-focus-guard"));
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/link/NavigationMenuLink.js
var Vh = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, active: i = !1, closeOnClick: a = !1, ...o } = e, { setValue: s, popupElement: c, positionerElement: l, rootRef: u } = _h(), d = yh(), f = Rn();
	return /* @__PURE__ */ (0, C.jsx)(zh, {
		tag: "a",
		render: r,
		className: n,
		state: { active: i },
		refs: [t],
		props: [{
			"aria-current": i ? "page" : void 0,
			tabIndex: void 0,
			onClick(e) {
				a && s(null, K("link-press", e.nativeEvent));
			},
			onBlur(e) {
				l && c && Bh({
					currentTarget: e.currentTarget,
					relatedTarget: e.relatedTarget
				}, {
					popupElement: c,
					rootRef: u,
					tree: f,
					nodeId: d
				}) && s(null, K("focus-out", e.nativeEvent));
			}
		}, o]
	});
});
process.env.NODE_ENV !== "production" && (Vh.displayName = "NavigationMenuLink");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/navigation-menu/content/item.module.js
var Hh = { "prism-navigation-menu__content-item": "_prism-navigation-menu__content-item_imzoc_1" }, Uh = /* @__PURE__ */ B(V(), 1);
function Wh(e) {
	let t = (0, x.c)(17), n, r, i, a, o;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5]) : ({active: a, children: n, className: r, closeOnClick: o, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o);
	let s = a === void 0 ? !1 : a, c = o === void 0 ? !0 : o, l;
	t[6] === r ? l = t[7] : (l = (0, Uh.default)(Hh["prism-navigation-menu__content-item"], r), t[6] = r, t[7] = l);
	let u;
	t[8] === s ? u = t[9] : (u = s ? /* @__PURE__ */ (0, C.jsx)(N, {
		"aria-hidden": !0,
		name: "checkmark",
		size: "small"
	}) : null, t[8] = s, t[9] = u);
	let d;
	return t[10] !== s || t[11] !== n || t[12] !== c || t[13] !== i || t[14] !== l || t[15] !== u ? (d = /* @__PURE__ */ (0, C.jsx)("li", { children: /* @__PURE__ */ (0, C.jsxs)(Vh, {
		...i,
		active: s,
		className: l,
		closeOnClick: c,
		children: [n, u]
	}) }), t[10] = s, t[11] = n, t[12] = c, t[13] = i, t[14] = l, t[15] = u, t[16] = d) : d = t[16], d;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/navigation-menu/content.js
function Gh(e) {
	let t = (0, x.c)(10), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({children: n, className: r, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a;
	t[4] === n ? a = t[5] : (a = /* @__PURE__ */ (0, C.jsx)("ul", {
		className: Lh["prism-navigation-menu__content-list"],
		children: n
	}), t[4] = n, t[5] = a);
	let o;
	return t[6] !== r || t[7] !== i || t[8] !== a ? (o = /* @__PURE__ */ (0, C.jsx)(Ih, {
		className: r,
		...i,
		children: a
	}), t[6] = r, t[7] = i, t[8] = a, t[9] = o) : o = t[9], o;
}
Gh.Item = Wh;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/item/NavigationMenuItem.js
var Kh = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, value: i, ...a } = e, o = Il(), s = i ?? o, c = Y("li", e, {
		ref: t,
		props: a
	}), l = S.useMemo(() => ({ value: s }), [s]);
	return /* @__PURE__ */ (0, C.jsx)(Nh.Provider, {
		value: l,
		children: c
	});
});
process.env.NODE_ENV !== "production" && (Kh.displayName = "NavigationMenuItem");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/navigation-menu/item.module.js
var qh = { "prism-navigation-menu__item": "_prism-navigation-menu__item_nsh0i_1" }, Jh = /* @__PURE__ */ B(V(), 1);
function Yh(e) {
	let t = (0, x.c)(12), n, r, i, a;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({active: a, children: n, className: r, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a);
	let o = a === void 0 ? !1 : a, s;
	t[5] === r ? s = t[6] : (s = (0, Jh.default)(qh["prism-navigation-menu__item"], r), t[5] = r, t[6] = s);
	let c = o || void 0, l;
	return t[7] !== n || t[8] !== i || t[9] !== s || t[10] !== c ? (l = /* @__PURE__ */ (0, C.jsx)(Kh, {
		className: s,
		"data-active": c,
		...i,
		children: n
	}), t[7] = n, t[8] = i, t[9] = s, t[10] = c, t[11] = l) : l = t[11], l;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/navigation-menu/link.js
function Xh(e) {
	let t = (0, x.c)(8), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({children: n, className: r, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a;
	return t[4] !== n || t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)(Vh, {
		className: r,
		...i,
		children: n
	}), t[4] = n, t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/utils/constants.js
var Zh = "data-base-ui-navigation-menu-trigger", Qh = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Qh.displayName = "NavigationMenuDismissContext");
function $h() {
	return S.useContext(Qh);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/list/NavigationMenuList.js
var eg = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, ...i } = e, { orientation: a, open: o, floatingRootContext: s, positionerElement: c, value: l, closeDelay: u, viewportElement: d, nested: f } = _h(), p = S.useMemo(() => Si(), []), m = s || p, h = c ? !0 : !l;
	zm(m, {
		enabled: !!s && (c || d ? !0 : !l),
		closeDelay: u
	});
	let g = Gn(m, {
		enabled: h,
		outsidePressEvent: "intentional",
		outsidePress(e) {
			return Gt(e)?.closest(`[${Zh}]`) === null;
		}
	}), _ = s ? g : void 0, v = { open: o }, y = f ? { "aria-orientation": a } : { onKeyDown(e) {
		(a === "horizontal" && (e.key === "ArrowLeft" || e.key === "ArrowRight") || a === "vertical" && (e.key === "ArrowUp" || e.key === "ArrowDown")) && e.stopPropagation();
	} }, b = [
		_?.floating || Ot,
		y,
		i
	], x = Y("ul", e, {
		state: v,
		ref: t,
		props: b,
		enabled: f
	});
	return f ? /* @__PURE__ */ (0, C.jsx)(Qh.Provider, {
		value: _,
		children: x
	}) : /* @__PURE__ */ (0, C.jsx)(Qh.Provider, {
		value: _,
		children: /* @__PURE__ */ (0, C.jsx)(Mh, {
			render: r,
			className: n,
			state: v,
			refs: [t],
			props: b,
			loopFocus: !1,
			orientation: a,
			tag: "ul"
		})
	});
});
process.env.NODE_ENV !== "production" && (eg.displayName = "NavigationMenuList");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/navigation-menu/list.module.js
var tg = { "prism-navigation-menu__list": "_prism-navigation-menu__list_9itko_1" }, ng = /* @__PURE__ */ B(V(), 1);
function rg(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, ng.default)(tg["prism-navigation-menu__list"], n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)(eg, {
		className: i,
		...r
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/portal/NavigationMenuPortalContext.js
var ig = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (ig.displayName = "NavigationMenuPortalContext");
function ag() {
	let e = S.useContext(ig);
	if (e === void 0) throw Error(process.env.NODE_ENV === "production" ? lr(40) : "Base UI: <NavigationMenu.Portal> is missing.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/portal/NavigationMenuPortal.js
var og = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { keepMounted: n = !1, ...r } = e, { mounted: i } = _h();
	return i || n ? /* @__PURE__ */ (0, C.jsx)(ig.Provider, {
		value: n,
		children: /* @__PURE__ */ (0, C.jsx)(Ss, {
			ref: t,
			...r
		})
	}) : null;
});
process.env.NODE_ENV !== "production" && (og.displayName = "NavigationMenuPortal");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/positioner/NavigationMenuPositionerContext.js
var sg = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (sg.displayName = "NavigationMenuPositionerContext");
function cg(e = !1) {
	let t = S.useContext(sg);
	if (!t && !e) throw Error(process.env.NODE_ENV === "production" ? lr(42) : "Base UI: NavigationMenuPositionerContext is missing. NavigationMenuPositioner parts must be placed within <NavigationMenu.Positioner>.");
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/positioner/NavigationMenuPositioner.js
var lg = Si(), ug = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { open: n, mounted: r, positionerElement: i, setPositionerElement: a, floatingRootContext: o, nested: s, transitionStatus: c } = _h(), { className: l, render: u, anchor: d, positionMethod: f = "absolute", side: p = "bottom", align: m = "center", sideOffset: h = 0, alignOffset: g = 0, collisionBoundary: _ = "clipping-ancestors", collisionPadding: v = 5, collisionAvoidance: y = s ? Xo : Yo, arrowPadding: b = 5, sticky: x = !1, disableAnchorTracking: w = !1, ...T } = e, E = ag(), D = yh(), O = bt(), [k, A] = S.useState(!1), j = S.useRef(null), M = S.useRef(null);
	S.useEffect(() => {
		if (!i) return;
		function e(e) {
			i && Bo(e) && (e.type === "focusin" ? Ho : Vo)(i);
		}
		return i.addEventListener("focusin", e, !0), i.addEventListener("focusout", e, !0), () => {
			i.removeEventListener("focusin", e, !0), i.removeEventListener("focusout", e, !0);
		};
	}, [i]);
	let N = (o || lg).useState("domReferenceElement"), P = cp({
		anchor: d ?? N ?? M,
		positionMethod: f,
		mounted: r,
		side: p,
		sideOffset: h,
		align: m,
		alignOffset: g,
		arrowPadding: b,
		collisionBoundary: _,
		collisionPadding: v,
		sticky: x,
		disableAnchorTracking: w,
		keepMounted: E,
		floatingRootContext: o,
		collisionAvoidance: y,
		nodeId: D,
		adaptiveOrigin: ap
	}), F = S.useMemo(() => {
		let e = {};
		return n || (e.pointerEvents = "none"), {
			role: "presentation",
			hidden: !r,
			style: {
				...P.positionerStyles,
				...e
			}
		};
	}, [
		n,
		r,
		P.positionerStyles
	]), I = {
		open: n,
		side: P.side,
		align: P.align,
		anchorHidden: P.anchorHidden,
		instant: k
	};
	S.useEffect(() => {
		if (!n) return;
		function e() {
			tr.flushSync(() => {
				A(!0);
			}), O.start(100, () => {
				A(!1);
			});
		}
		let t = Me(i);
		return t.addEventListener("resize", e), () => {
			t.removeEventListener("resize", e);
		};
	}, [
		n,
		O,
		i
	]);
	let L = Y("div", e, {
		state: I,
		ref: [
			t,
			a,
			j
		],
		props: [
			F,
			up(c),
			T
		],
		stateAttributesMapping: ma
	});
	return /* @__PURE__ */ (0, C.jsx)(sg.Provider, {
		value: P,
		children: L
	});
});
process.env.NODE_ENV !== "production" && (ug.displayName = "NavigationMenuPositioner");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/viewport/NavigationMenuViewport.js
var dg = Si();
function fg({ children: e }) {
	let { beforeInsideRef: t, beforeOutsideRef: n, afterInsideRef: r, afterOutsideRef: i, positionerElement: a, viewportElement: o, floatingRootContext: s } = _h(), c = !!cg(!0), l = a || o;
	return !s && !c ? e : /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [
		/* @__PURE__ */ (0, C.jsx)(rs, {
			ref: t,
			onFocus: (e) => {
				l && Bo(e, l) ? Fo(l)?.focus() : n.current?.focus();
			}
		}),
		e,
		/* @__PURE__ */ (0, C.jsx)(rs, {
			ref: r,
			onFocus: (e) => {
				l && Bo(e, l) ? Io(l)?.focus() : i.current?.focus();
			}
		})
	] });
}
var pg = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, children: i, id: a, ...o } = e, s = Mn(a), { setViewportElement: c, setViewportTargetElement: l, floatingRootContext: u, prevTriggerElementRef: d, viewportInert: f, setViewportInert: p } = _h(), m = !!cg(!0), h = (u || dg).useState("domReferenceElement");
	W(() => {
		h && (d.current = h);
	}, [h, d]);
	let g = Y("div", e, {
		ref: [t, c],
		props: [{
			id: s,
			onBlur(e) {
				let t = e.relatedTarget, n = e.currentTarget;
				t && !G(n, t) && t !== h && p(!0);
			},
			...!m && f && { inert: rc(!0) },
			children: m ? i : /* @__PURE__ */ (0, C.jsx)(fg, { children: /* @__PURE__ */ (0, C.jsx)("div", {
				ref: l,
				children: i
			}) })
		}, o]
	});
	return m ? /* @__PURE__ */ (0, C.jsx)(fg, { children: g }) : g;
});
process.env.NODE_ENV !== "production" && (pg.displayName = "NavigationMenuViewport");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/popup/NavigationMenuPopup.js
var mg = {
	...ma,
	...Zn
}, hg = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, id: i, ...a } = e, { open: o, transitionStatus: s, setPopupElement: c } = _h(), l = cg(), u = kd(), d = Il(i), f = {
		open: o,
		transitionStatus: s,
		side: l.side,
		align: l.align,
		anchorHidden: l.anchorHidden
	}, p = l.side === "top", m = l.side === "left";
	return u === "rtl" ? (p ||= l.side === "inline-end", m ||= l.side === "inline-end") : (p ||= l.side === "inline-start", m ||= l.side === "inline-start"), Y("nav", e, {
		state: f,
		ref: [t, c],
		props: [{
			id: d,
			tabIndex: -1,
			style: p ? {
				position: "absolute",
				[l.side === "top" ? "bottom" : "top"]: "0",
				[m ? "right" : "left"]: "0"
			} : {}
		}, a],
		stateAttributesMapping: mg
	});
});
process.env.NODE_ENV !== "production" && (hg.displayName = "NavigationMenuPopup");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/navigation-menu/portal.js
function gg() {
	let e = (0, x.c)(1), t;
	return e[0] === Symbol.for("react.memo_cache_sentinel") ? (t = /* @__PURE__ */ (0, C.jsx)(og, { children: /* @__PURE__ */ (0, C.jsx)(ug, {
		className: Eh["prism-navigation-menu__positioner"],
		sideOffset: 10,
		children: /* @__PURE__ */ (0, C.jsx)(hg, {
			className: Eh["prism-navigation-menu__popup"],
			children: /* @__PURE__ */ (0, C.jsx)(pg, { className: Eh["prism-navigation-menu__viewport"] })
		})
	}) }), e[0] = t) : t = e[0], t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/navigation-menu/trigger/NavigationMenuTrigger.js
var _g = {
	width: 0,
	height: 0
}, vg = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, nativeButton: i = !0, disabled: a, ...o } = e, { value: s, setValue: c, mounted: l, open: u, positionerElement: d, setActivationDirection: f, setFloatingRootContext: p, popupElement: m, viewportElement: h, transitionStatus: g, rootRef: _, beforeOutsideRef: v, afterOutsideRef: y, afterInsideRef: b, beforeInsideRef: x, prevTriggerElementRef: w, currentContentRef: T, delay: E, closeDelay: D, orientation: O, setViewportInert: k, nested: A } = _h(), { value: j } = Ph(), M = yh(), N = Rn(), P = $h(), F = bt(), I = Tt(), L = Tt(), ee = Tt(), R = Tt(), [z, te] = S.useState(null), [B, V] = S.useState(!0), [ne, re] = S.useState(""), ie = S.useRef(null), ae = S.useRef(!1), oe = S.useRef(_g), H = S.useRef(null), se = S.useRef(!1), ce = u && s === j, le = Qo(ce), ue = d ? !0 : !s, de = d || h, fe = de ? !0 : !s, pe = nr(m, !1, !1), me = S.useCallback((e) => {
		ie.current = e, te(e);
	}, []);
	S.useEffect(() => {
		H.current?.abort();
	}, [ce]);
	function he() {
		m && (m.style.setProperty(bh.popupWidth, "auto"), m.style.setProperty(bh.popupHeight, "auto"));
	}
	function ge() {
		!m || !d || (m.style.removeProperty(bh.popupWidth), m.style.removeProperty(bh.popupHeight), d.style.removeProperty(xh.positionerWidth), d.style.removeProperty(xh.positionerHeight));
	}
	function _e(e, t) {
		!m || !d || (m.style.setProperty(bh.popupWidth, `${e}px`), m.style.setProperty(bh.popupHeight, `${t}px`), d.style.setProperty(xh.positionerWidth, `${e}px`), d.style.setProperty(xh.positionerHeight, `${t}px`));
	}
	function ve() {
		H.current = new AbortController(), pe(he, H.current.signal);
	}
	let ye = U((e, t, n = {}) => {
		if (!m || !d) return;
		let { syncPositioner: r = !1 } = n;
		ge();
		let { width: i, height: a } = hh(m), o = i || oe.current.width, s = a || oe.current.height;
		(t === 0 || e === 0) && (e = o, t = s), m.style.setProperty(bh.popupWidth, `${e}px`), m.style.setProperty(bh.popupHeight, `${t}px`), d.style.setProperty(xh.positionerWidth, `${r ? e : o}px`), d.style.setProperty(xh.positionerHeight, `${r ? t : s}px`), R.request(() => {
			m.style.setProperty(bh.popupWidth, `${o}px`), m.style.setProperty(bh.popupHeight, `${s}px`), r && (d.style.setProperty(xh.positionerWidth, `${o}px`), d.style.setProperty(xh.positionerHeight, `${s}px`)), ve();
		});
	}), be = U((e, t) => {
		!m || !d || (R.cancel(), L.cancel(), H.current?.abort(), H.current = null, !(e === 0 || t === 0) && (_e(e, t), L.request(() => {
			L.request(() => {
				ge();
				let { width: n, height: r } = hh(m), i = n || e || oe.current.width, a = r || t || oe.current.height;
				_e(e, t), R.request(() => {
					_e(i, a), ve();
				});
			});
		})));
	}), xe = U(() => {
		if (!m || !d) return;
		R.cancel(), H.current?.abort(), H.current = null, ge();
		let { width: e, height: t } = hh(m);
		e === 0 || t === 0 || (oe.current = {
			width: e,
			height: t
		}, he(), d.style.setProperty(xh.positionerWidth, `${e}px`), d.style.setProperty(xh.positionerHeight, `${t}px`));
	}), Se = U(() => {
		if (!m) return {
			size: oe.current,
			syncPositioner: !1
		};
		let e = m.style.getPropertyValue(bh.popupWidth), t = m.style.getPropertyValue(bh.popupHeight);
		return e !== "" && e !== "auto" && t !== "" && t !== "auto" ? {
			size: {
				width: m.offsetWidth || oe.current.width,
				height: m.offsetHeight || oe.current.height
			},
			syncPositioner: !0
		} : {
			size: oe.current,
			syncPositioner: !1
		};
	});
	S.useEffect(() => {
		u || (F.clear(), L.cancel(), ee.cancel(), R.cancel(), H.current?.abort(), H.current = null, se.current = !1, re(""));
	}, [
		F,
		u,
		L,
		ee,
		R
	]), S.useEffect(() => {
		l || (oe.current = _g);
	}, [l]), S.useEffect(() => {
		if (!m || typeof ResizeObserver != "function") return;
		let e = new ResizeObserver(() => {
			oe.current = {
				width: m.offsetWidth,
				height: m.offsetHeight
			};
		});
		return e.observe(m), () => {
			e.disconnect();
		};
	}, [m]), S.useEffect(() => {
		if (!u || !ce || !m || !d) return;
		let e = Me(d);
		function t() {
			ee.cancel(), ee.request(xe);
		}
		return e.addEventListener("resize", t), () => {
			ee.cancel(), e.removeEventListener("resize", t);
		};
	}, [
		u,
		ce,
		m,
		d,
		ee,
		xe
	]), S.useEffect(() => {
		let e = T.current;
		if (!e || !m || !ce || typeof MutationObserver != "function") return;
		let t = new MutationObserver(() => {
			if (g === "starting" || m.hasAttribute(Jn.startingStyle)) {
				xe();
				return;
			}
			let { size: e, syncPositioner: t } = Se();
			if (t) {
				be(e.width, e.height);
				return;
			}
			ye(e.width, e.height);
		});
		return t.observe(e, {
			childList: !0,
			subtree: !0,
			characterData: !0
		}), () => {
			t.disconnect();
		};
	}, [
		T,
		m,
		ce,
		g,
		Se,
		be,
		ye,
		xe
	]), S.useEffect(() => (ce && u && m && ae.current && (ae.current = !1, I.request(() => {
		v.current?.focus();
	})), () => {
		I.cancel();
	}), [
		v,
		I,
		ce,
		u,
		m
	]), W(() => {
		if (le.current && u && m) {
			if (g === "starting" && T.current?.querySelector("[data-nested]") != null) return R.request(xe), () => {
				R.cancel();
			};
			if (se.current) {
				se.current = !1;
				return;
			}
			ye(0, 0);
		}
	}, [
		T,
		ye,
		le,
		u,
		m,
		R,
		xe,
		g
	]);
	function Ce(e, t) {
		let n = t.reason === en;
		if (!ue || ne === "touch" && n || !e && s !== j) return;
		function r() {
			n && (V(!0), F.clear(), F.start(500, () => {
				V(!1);
			})), e ? c(j, t) : (c(null, t), re(""));
		}
		n ? tr.flushSync(r) : r();
	}
	let we = Pu({
		open: u,
		onOpenChange: Ce,
		elements: {
			reference: z,
			floating: de
		}
	}), Te = xm(we);
	S.useEffect(() => {
		u || (we.context.dataRef.current.openEvent = void 0, Te.pointerType = void 0, Te.interactedInside = !1, Te.restTimeoutPending = !1, Te.openChangeTimeout.clear(), Te.restTimeout.clear(), ym(Te));
	}, [
		we,
		Te,
		u
	]);
	let Ee = U(() => !A || d || !ie.current || !de ? null : bg(ie.current, de, M));
	function De() {
		return ie.current?.closest("ul") ?? null;
	}
	let Oe = Cm(we, {
		enabled: fe,
		move: !1,
		handleClose: jm({
			blockPointerEvents: ne !== "touch" && (!at || A),
			getScope: De
		}),
		restMs: l && d ? 0 : E,
		delay: { close: D },
		triggerElementRef: ie,
		getHandleCloseContext: Ee
	}), { getReferenceProps: ke } = ui([S.useMemo(() => Oe ? { reference: Oe } : void 0, [Oe]), Nu(we, {
		enabled: ue,
		stickIfOpen: B,
		toggle: ce
	})]);
	W(() => {
		ce && (p(we), w.current = z);
	}, [
		ce,
		we,
		p,
		w,
		z
	]);
	function Ae(e) {
		tr.flushSync(() => {
			let t = w.current?.getBoundingClientRect();
			if (l && t && z) {
				let e = z.getBoundingClientRect(), n = e.left > t.left, r = e.top > t.top;
				O === "horizontal" && e.left !== t.left ? f(n ? "right" : "left") : O === "vertical" && e.top !== t.top && f(r ? "down" : "up");
			}
			if (e.type !== "click" && s != null && (we.context.dataRef.current.openEvent = void 0), !(ne === "touch" && e.type !== "click") && (s != null && c(j, K(e.type === "mouseenter" ? "trigger-hover" : "trigger-press", e.nativeEvent)), e.type === "mouseenter" && A && !d && ne !== "touch" && de && Ie(e.currentTarget))) {
				let t = De();
				if (!t) return;
				bm(Te, {
					scopeElement: t,
					referenceElement: e.currentTarget,
					floatingElement: de
				});
			}
		});
	}
	let je = U((e) => {
		if (!m || !d) {
			Ae(e);
			return;
		}
		let { width: t, height: n } = hh(m), r = s != null && s !== j && (e.type === "click" || ne !== "touch");
		Ae(e), r && (se.current = !0), ye(t, n);
	}), Ne = { open: ce };
	function Pe(e) {
		re(e.pointerType);
	}
	let Fe = {
		tabIndex: 0,
		onMouseEnter: je,
		onClick: je,
		onPointerEnter: Pe,
		onPointerDown: Pe,
		"aria-expanded": ce,
		"aria-controls": ce ? m?.id : void 0,
		[Zh]: "",
		onFocus() {
			ce && k(!1);
		},
		onMouseMove() {
			ae.current = !1;
		},
		onKeyDown(e) {
			if (ae.current = !0, A) return;
			let t = O === "horizontal" && e.key === "ArrowDown", n = O === "vertical" && e.key === "ArrowRight";
			(t || n) && (c(j, K("list-navigation", e.nativeEvent)), je(e), xn(e));
		},
		onBlur(e) {
			d && m && Bh({
				currentTarget: e.currentTarget,
				relatedTarget: e.relatedTarget
			}, {
				popupElement: m,
				rootRef: _,
				tree: N,
				nodeId: M
			}) && c(null, K("focus-out", e.nativeEvent));
		}
	}, { getButtonProps: Le, buttonRef: Re } = iu({
		disabled: a,
		focusableWhenDisabled: !0,
		native: i
	}), ze = de;
	return /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [/* @__PURE__ */ (0, C.jsx)(zh, {
		tag: "button",
		render: r,
		className: n,
		state: Ne,
		stateAttributesMapping: pa,
		refs: [
			t,
			me,
			Re
		],
		props: [
			ke,
			P?.reference || Dt,
			Fe,
			o,
			Le
		]
	}), ce && /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [
		/* @__PURE__ */ (0, C.jsx)(rs, {
			ref: v,
			onFocus: (e) => {
				ze && Bo(e, ze) ? x.current?.focus() : Io(z)?.focus();
			}
		}),
		/* @__PURE__ */ (0, C.jsx)("span", {
			"aria-owns": h?.id,
			style: Zo
		}),
		/* @__PURE__ */ (0, C.jsx)(rs, {
			ref: y,
			onFocus: (e) => {
				if (ze && Bo(e, ze)) (b.current && Mo(b.current) ? b.current : z)?.focus();
				else {
					let t = Fo(z);
					A && !d && ze && t && G(ze, t) && (t = Ro(b.current)), t?.focus(), (!A || d) && !G(_.current, t) && c(null, K("focus-out", e.nativeEvent));
				}
			}
		})
	] })] });
});
process.env.NODE_ENV !== "production" && (vg.displayName = "NavigationMenuTrigger");
function yg(e, t) {
	let n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), i = n.left + n.width / 2, a = n.top + n.height / 2, o = r.left + r.width / 2, s = r.top + r.height / 2, c = o - i, l = s - a;
	return Math.abs(c) >= Math.abs(l) ? c >= 0 ? "right" : "left" : l >= 0 ? "bottom" : "top";
}
function bg(e, t, n) {
	return {
		placement: yg(e, t),
		elements: {
			domReference: e,
			floating: t
		},
		nodeId: n
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/navigation-menu/trigger.module.js
var xg = {
	"prism-navigation-menu__trigger-chevron": "_prism-navigation-menu__trigger-chevron_61el8_1",
	"prism-navigation-menu__trigger": "_prism-navigation-menu__trigger_61el8_1"
}, Sg = /* @__PURE__ */ B(V(), 1);
function Cg(e) {
	let t = (0, x.c)(11), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({children: n, className: r, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a;
	t[4] === r ? a = t[5] : (a = (0, Sg.default)(xg["prism-navigation-menu__trigger"], r), t[4] = r, t[5] = a);
	let o;
	t[6] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ (0, C.jsx)("span", {
		className: xg["prism-navigation-menu__trigger-chevron"],
		children: /* @__PURE__ */ (0, C.jsx)(N, {
			"aria-hidden": !0,
			name: "chevron-down",
			size: "small"
		})
	}), t[6] = o) : o = t[6];
	let s;
	return t[7] !== n || t[8] !== i || t[9] !== a ? (s = /* @__PURE__ */ (0, C.jsxs)(vg, {
		className: a,
		...i,
		children: [n, o]
	}), t[7] = n, t[8] = i, t[9] = a, t[10] = s) : s = t[10], s;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/navigation-menu.js
var wg = /* @__PURE__ */ B(V(), 1);
function Tg(e) {
	let t = (0, x.c)(11), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({children: n, className: r, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a;
	t[4] === r ? a = t[5] : (a = (0, wg.default)(Eh["prism-navigation-menu"], r), t[4] = r, t[5] = a);
	let o;
	t[6] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ (0, C.jsx)(gg, {}), t[6] = o) : o = t[6];
	let s;
	return t[7] !== n || t[8] !== i || t[9] !== a ? (s = /* @__PURE__ */ (0, C.jsxs)(wh, {
		className: a,
		orientation: "horizontal",
		...i,
		children: [n, o]
	}), t[7] = n, t[8] = i, t[9] = a, t[10] = s) : s = t[10], s;
}
Tg.List = rg, Tg.Item = Yh, Tg.Link = Xh, Tg.Trigger = Cg, Tg.Content = Gh;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/useForcedRerendering.js
function Eg() {
	let [, e] = S.useState({});
	return S.useCallback(() => {
		e({});
	}, []);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/formatNumber.js
var Dg = /* @__PURE__ */ new Map();
function Og(e, t) {
	let n = JSON.stringify({
		locale: e,
		options: t
	}), r = Dg.get(n);
	if (r) return r;
	let i = new Intl.NumberFormat(e, t);
	return Dg.set(n, i), i;
}
function kg(e, t, n) {
	return e == null ? "" : Og(t, n).format(e);
}
function Ag(e, t, n) {
	return kg(e, t, {
		...n,
		maximumFractionDigits: 20
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/useInterval.js
var jg = 0, Mg = class e extends yt {
	static create() {
		return new e();
	}
	start(e, t) {
		this.clear(), this.currentId = setInterval(() => {
			t();
		}, e);
	}
	clear = () => {
		this.currentId !== jg && (clearInterval(this.currentId), this.currentId = jg);
	};
};
function Ng() {
	let e = Te(Mg.create).current;
	return _t(e.disposeEffect), e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/number-field/root/NumberFieldRootContext.js
var Pg = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Pg.displayName = "NumberFieldRootContext");
function Fg() {
	let e = S.useContext(Pg);
	if (e === void 0) throw Error(process.env.NODE_ENV === "production" ? lr(43) : "Base UI: NumberFieldRootContext is missing. NumberField parts must be placed within <NumberField.Root>.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/number-field/utils/stateAttributesMapping.js
var Ig = {
	inputValue: () => null,
	value: () => null,
	...Wl
}, Lg = [
	"零",
	"〇",
	"一",
	"二",
	"三",
	"四",
	"五",
	"六",
	"七",
	"八",
	"九"
], Rg = {
	零: "0",
	〇: "0",
	一: "1",
	二: "2",
	三: "3",
	四: "4",
	五: "5",
	六: "6",
	七: "7",
	八: "8",
	九: "9"
}, zg = [
	"٠",
	"١",
	"٢",
	"٣",
	"٤",
	"٥",
	"٦",
	"٧",
	"٨",
	"٩"
], Bg = [
	"۰",
	"۱",
	"۲",
	"۳",
	"۴",
	"۵",
	"۶",
	"۷",
	"۸",
	"۹"
], Vg = [
	"０",
	"１",
	"２",
	"３",
	"４",
	"５",
	"６",
	"７",
	"８",
	"９"
], Hg = [
	"%",
	"٪",
	"％",
	"﹪"
], Ug = ["‰", "؉"], Wg = [
	"−",
	"－",
	"‒",
	"–",
	"—",
	"﹣"
], Gg = ["＋", "﹢"], Kg = RegExp(`[${zg.join("")}]`, "g"), qg = RegExp(`[${Bg.join("")}]`, "g"), Jg = RegExp(`[${Vg.join("")}]`, "g"), Yg = RegExp(`[${Lg.join("")}]`, "g"), Xg = RegExp(`[${Hg.join("")}]`), Zg = RegExp(`[${Ug.join("")}]`), Qg = /[٠١٢٣٤٥٦٧٨٩]/, $g = /[۰۱۲۳۴۵۶۷۸۹]/, e_ = /[零〇一二三四五六七八九]/, t_ = RegExp(`[${Vg.join("")}]`), n_ = [
	".",
	",",
	"．",
	"，",
	"٫",
	"٬"
], r_ = /\p{Zs}/u, i_ = ["+", ...Gg], a_ = ["-", ...Wg], o_ = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), s_ = (e) => e.replace(/[-\\\]^]/g, (e) => `\\${e}`), c_ = (e) => `[${e.map(s_).join("")}]`, l_ = c_(["-"].concat(Wg)), u_ = c_(["+"].concat(Gg)), d_ = new RegExp(l_, "gu"), f_ = new RegExp(u_, "gu"), p_ = new RegExp(l_), m_ = new RegExp(u_);
function h_(e, t) {
	let n = Og(e, t).formatToParts(11111.1), r = {};
	return n.forEach((e) => {
		r[e.type] = e.value;
	}), Og(e).formatToParts(.1).forEach((e) => {
		e.type === "decimal" && (r[e.type] = e.value);
	}), r;
}
function g_(e, t, n) {
	if (e == null) return null;
	let r = String(e).replace(/\p{Cf}/gu, "").trim();
	r = r.replace(d_, "-").replace(f_, "+");
	let i = !1, a = r.match(/([+-])\s*$/);
	a && (a[1] === "-" && (i = !0), r = r.replace(/([+-])\s*$/, ""));
	let o = r.match(/^\s*([+-])/);
	o && (o[1] === "-" && (i = !0), r = r.replace(/^\s*[+-]/, ""));
	let s = t;
	s === void 0 && (Qg.test(r) || $g.test(r) ? s = "ar" : e_.test(r) && (s = "zh"));
	let { group: c, decimal: l, currency: u } = h_(s, n), d = Og(s, n).formatToParts(1).filter((e) => e.type === "unit").map((e) => o_(e.value)), f = d.length ? new RegExp(d.join("|"), "g") : null, p = null;
	c && (p = /\p{Zs}/u.test(c) ? /\p{Zs}/gu : c === "'" || c === "’" ? /['’]/g : new RegExp(o_(c), "g"));
	let m = [
		{
			regex: c ? p : null,
			replacement: ""
		},
		{
			regex: l ? new RegExp(o_(l), "g") : null,
			replacement: "."
		},
		{
			regex: /．/g,
			replacement: "."
		},
		{
			regex: /，/g,
			replacement: ""
		},
		{
			regex: /٫/g,
			replacement: "."
		},
		{
			regex: /٬/g,
			replacement: ""
		},
		{
			regex: u ? new RegExp(o_(u), "g") : null,
			replacement: ""
		},
		{
			regex: f,
			replacement: ""
		},
		{
			regex: Kg,
			replacement: (e) => String(zg.indexOf(e))
		},
		{
			regex: qg,
			replacement: (e) => String(Bg.indexOf(e))
		},
		{
			regex: Jg,
			replacement: (e) => String(Vg.indexOf(e))
		},
		{
			regex: Yg,
			replacement: (e) => Rg[e]
		}
	].reduce((e, { regex: t, replacement: n }) => t ? e.replace(t, n) : e, r), h = m.lastIndexOf(".");
	if (h !== -1 && (m = `${m.slice(0, h).replace(/\./g, "")}.${m.slice(h + 1).replace(/\./g, "")}`), /^[-+]?Infinity$/i.test(r) || /[∞]/.test(r)) return null;
	let g = (i ? "-" : "") + m, _ = parseFloat(g), v = n?.style, y = v === "unit" && n?.unit === "percent", b = Xg.test(e) || v === "percent";
	return Zg.test(e) ? _ /= 1e3 : !y && b && (_ /= 100), Number.isNaN(_) ? null : _;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/clamp.js
function __(e, t = -(2 ** 53 - 1), n = 2 ** 53 - 1) {
	return Math.max(t, Math.min(e, n));
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/number-field/utils/validate.js
var v_ = 1e-10;
function y_(e) {
	let t = Og("en-US").resolvedOptions(), n = e?.minimumFractionDigits ?? t.minimumFractionDigits ?? 0;
	return {
		maximumFractionDigits: Math.max(e?.maximumFractionDigits ?? t.maximumFractionDigits ?? 20, n),
		minimumFractionDigits: n
	};
}
function b_(e, t) {
	if (!Number.isFinite(e)) return e;
	let n = Math.min(Math.max(t, 0), 20);
	return Number(e.toFixed(n));
}
function x_(e, t) {
	let { maximumFractionDigits: n } = y_(t);
	return b_(e, n);
}
function S_(e, t, n, r = "directional") {
	if (n === 0) return e;
	let i = Math.abs(n), a = Math.sign(n), o = i * v_ * a, s = r === "nearest" ? n : i, c = (e - t + o) / s, l;
	return l = r === "nearest" ? Math.round(c) : a > 0 ? Math.floor(c) : Math.ceil(c), t + l * (r === "nearest" ? n : i);
}
function C_(e, { step: t, minWithDefault: n, maxWithDefault: r, minWithZeroDefault: i, format: a, snapOnStep: o, small: s, clamp: c }) {
	if (e === null) return e;
	let l = c ? __(e, n, r) : e;
	if (t != null && o) {
		if (t === 0) return x_(l, a);
		let e = i;
		return !s && n !== -(2 ** 53 - 1) && (e = n), x_(S_(l, e, t, s ? "nearest" : "directional"), a);
	}
	return x_(l, a);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/number-field/root/NumberFieldRoot.js
var w_ = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { id: n, min: r, max: i, smallStep: a = .1, step: o = 1, largeStep: s = 10, required: c = !1, disabled: l = !1, readOnly: u = !1, name: d, defaultValue: f, value: p, onValueChange: m, onValueCommitted: h, allowWheelScrub: g = !1, snapOnStep: _ = !1, allowOutOfRange: v = !1, format: y, locale: b, render: x, className: w, inputRef: T, ...E } = e, { setDirty: D, validityData: O, disabled: k, setFilled: A, invalid: j, name: M, state: N, validation: P, shouldValidateOnChange: F } = Kl(), I = k || l, L = M ?? d, ee = o === "any" ? 1 : o, [R, z] = S.useState(!1), te = r ?? -(2 ** 53 - 1), B = i ?? 2 ** 53 - 1, V = r ?? 0, ne = y?.style, re = S.useRef(null), ie = Ai(T, P.inputRef), ae = ld({ id: n }), [oe, H] = Ll({
		controlled: p,
		default: f,
		name: "NumberField",
		state: "value"
	}), se = oe ?? null, ce = Qo(se);
	W(() => {
		A(se !== null);
	}, [A, se]);
	let le = Eg(), ue = Qo(y), de = S.useRef(!1), fe = U((e, t) => {
		de.current = !1, h?.(e, t);
	}), pe = bt(), me = Ng(), he = bt(), ge = S.useRef(!1), _e = S.useRef(0), ve = S.useRef(!0), ye = S.useRef(null), be = S.useRef(() => {}), [xe, Se] = S.useState(() => p === void 0 ? kg(se, b, y) : T_(se, b, y)), [Ce, we] = S.useState("numeric"), Te = U(() => {
		let { decimal: e, group: t, currency: n, literal: r } = h_(b, y), i = /* @__PURE__ */ new Set();
		n_.forEach((e) => i.add(e)), e && i.add(e), t && (i.add(t), r_.test(t) && i.add(" "));
		let a = ne === "percent" || ne === "unit" && y?.unit === "percent", o = ne === "percent" || ne === "unit" && y?.unit === "permille";
		return a && Hg.forEach((e) => i.add(e)), o && Ug.forEach((e) => i.add(e)), ne === "currency" && n && i.add(n), r && (Array.from(r).forEach((e) => i.add(e)), r_.test(r) && i.add(" ")), i_.forEach((e) => i.add(e)), te < 0 && a_.forEach((e) => i.add(e)), i;
	}), Ee = U((e) => e?.altKey ? a : e?.shiftKey ? s : ee), De = U((e, t) => {
		let n = t.event, r = t.direction, i = t.reason, a = !v || !(i === "input-change" || i === "input-blur" || i === "input-paste" || i === "input-clear" || i === "none"), o = C_(e, {
			step: r ? Ee(n) * r : void 0,
			format: ue.current,
			minWithDefault: te,
			maxWithDefault: B,
			minWithZeroDefault: V,
			snapOnStep: _,
			small: n?.altKey ?? !1,
			clamp: a
		}), s = t.reason === "input-change" || t.reason === "input-clear" || t.reason === "input-blur" || t.reason === "input-paste" || t.reason === "none", c = o !== se || s && (e !== se || ve.current === !1);
		if (c) {
			if (ye.current = o, m?.(o, t), t.isCanceled) return c;
			H(o), D(o !== O.initialValue), de.current = !0;
		}
		return ve.current && Se(kg(o, b, y)), le(), c;
	}), Oe = U((e, { direction: t, currentValue: n, event: i, reason: a }) => {
		let o = n ?? ce.current;
		return De(typeof o == "number" ? o + e * t : Math.max(0, r ?? 0), K(a, i, void 0, { direction: t }));
	}), ke = U(() => {
		he.clear(), pe.clear(), me.clear(), be.current(), _e.current = 0;
	}), Ae = U((e, t) => {
		if (ke(), !re.current) return;
		let n = Me(re.current);
		function r(e) {
			e.preventDefault();
		}
		n.addEventListener("contextmenu", r), be.current = () => {
			n.removeEventListener("contextmenu", r);
		}, n.addEventListener("pointerup", (t) => {
			ge.current = !1, ke(), fe(ye.current ?? ce.current, vn(e ? on : sn, t));
		}, { once: !0 });
		function i() {
			return Oe(Ee(t) ?? 1, {
				direction: e ? 1 : -1,
				event: t,
				reason: e ? "increment-press" : "decrement-press"
			});
		}
		if (!i()) {
			ke();
			return;
		}
		pe.start(400, () => {
			me.start(60, () => {
				i() || ke();
			});
		});
	});
	W(function() {
		if (!ve.current) return;
		let e = p === void 0 ? kg(se, b, y) : T_(se, b, y);
		e !== xe && Se(e);
	}), W(function() {
		if (!ot) return;
		let e = "text";
		te >= 0 && (e = "decimal"), we(e);
	}, [te, ne]), S.useEffect(() => () => ke(), [ke]), S.useEffect(function() {
		let e = re.current;
		if (I || u || !g || !e) return;
		function t(e) {
			e.ctrlKey || ht(re.current).activeElement !== re.current || (e.preventDefault(), Oe(Ee(e) ?? 1, {
				direction: e.deltaY > 0 ? -1 : 1,
				event: e,
				reason: "wheel"
			}));
		}
		return e.addEventListener("wheel", t), () => {
			e.removeEventListener("wheel", t);
		};
	}, [
		g,
		Oe,
		I,
		u,
		s,
		ee,
		Ee
	]);
	let je = S.useMemo(() => ({
		...N,
		disabled: I,
		readOnly: u,
		required: c,
		value: se,
		inputValue: xe,
		scrubbing: R
	}), [
		N,
		I,
		u,
		c,
		se,
		xe,
		R
	]), Ne = S.useMemo(() => ({
		inputRef: re,
		inputValue: xe,
		value: se,
		startAutoChange: Ae,
		stopAutoChange: ke,
		minWithDefault: te,
		maxWithDefault: B,
		disabled: I,
		readOnly: u,
		id: ae,
		setValue: De,
		incrementValue: Oe,
		getStepAmount: Ee,
		allowInputSyncRef: ve,
		formatOptionsRef: ue,
		valueRef: ce,
		lastChangedValueRef: ye,
		hasPendingCommitRef: de,
		isPressedRef: ge,
		intentionalTouchCheckTimeout: he,
		movesAfterTouchRef: _e,
		name: L,
		required: c,
		invalid: j,
		inputMode: Ce,
		getAllowedNonNumericKeys: Te,
		min: r,
		max: i,
		setInputValue: Se,
		locale: b,
		isScrubbing: R,
		setIsScrubbing: z,
		state: je,
		onValueCommitted: fe
	}), [
		re,
		xe,
		se,
		Ae,
		ke,
		te,
		B,
		I,
		u,
		ae,
		De,
		Oe,
		Ee,
		ue,
		ce,
		he,
		L,
		c,
		j,
		Ce,
		Te,
		r,
		i,
		Se,
		b,
		R,
		je,
		fe
	]), Pe = Y("div", e, {
		ref: t,
		state: je,
		props: E,
		stateAttributesMapping: Ig
	});
	return /* @__PURE__ */ (0, C.jsxs)(Pg.Provider, {
		value: Ne,
		children: [Pe, /* @__PURE__ */ (0, C.jsx)("input", {
			...P.getInputValidationProps({
				onFocus() {
					re.current?.focus();
				},
				onChange(e) {
					if (e.nativeEvent.defaultPrevented) return;
					let t = e.currentTarget.valueAsNumber, n = Number.isNaN(t) ? null : t, r = K(Qt, e.nativeEvent);
					D(n !== O.initialValue), De(n, r), F() && P.commit(n);
				}
			}),
			ref: ie,
			type: "number",
			name: L,
			value: se ?? "",
			min: r,
			max: i,
			step: o,
			disabled: I,
			required: c,
			"aria-hidden": !0,
			tabIndex: -1,
			style: L ? ns : ts
		})]
	});
});
process.env.NODE_ENV !== "production" && (w_.displayName = "NumberFieldRoot");
function T_(e, t, n) {
	return n?.maximumFractionDigits != null || n?.minimumFractionDigits != null ? kg(e, t, n) : Ag(e, t, n);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/number-field/input/NumberFieldInput.js
var E_ = {
	...Wl,
	...Ig
}, D_ = new Set([
	"Backspace",
	"Delete",
	"ArrowLeft",
	"ArrowRight",
	"Tab",
	"Enter",
	"Escape"
]), O_ = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, ...i } = e, { allowInputSyncRef: a, disabled: o, formatOptionsRef: s, getAllowedNonNumericKeys: c, getStepAmount: l, id: u, incrementValue: d, inputMode: f, inputValue: p, max: m, min: h, name: g, readOnly: _, required: v, setValue: y, state: b, setInputValue: x, locale: C, inputRef: w, value: T, onValueCommitted: E, lastChangedValueRef: D, hasPendingCommitRef: O, valueRef: k } = Fg(), { clearErrors: A } = Xl(), { validationMode: j, setTouched: M, setFocused: N, invalid: P, shouldValidateOnChange: F, validation: I } = Kl(), { labelId: L } = Jl(), ee = S.useRef(!1), R = S.useRef(!1);
	return Ql({
		id: u,
		commit: I.commit,
		value: T,
		controlRef: w,
		name: g,
		getValue: () => T ?? null
	}), gi(T, (e) => {
		let t = F();
		if (A(g), t && I.commit(T), !(e === T || t)) {
			if (R.current) {
				R.current = !1;
				return;
			}
			I.commit(T, !0);
		}
	}), Y("input", e, {
		ref: [t, w],
		state: b,
		props: [
			{
				id: u,
				required: v,
				disabled: o,
				readOnly: _,
				inputMode: f,
				value: p,
				type: "text",
				autoComplete: "off",
				autoCorrect: "off",
				spellCheck: "false",
				"aria-roledescription": "Number field",
				"aria-invalid": P || void 0,
				"aria-labelledby": L,
				suppressHydrationWarning: !0,
				onFocus(e) {
					if (e.defaultPrevented || _ || o || (N(!0), ee.current)) return;
					ee.current = !0;
					let t = e.currentTarget, n = t.value.length;
					t.setSelectionRange(n, n);
				},
				onBlur(e) {
					if (e.defaultPrevented || _ || o) return;
					M(!0), N(!1);
					let t = !a.current, n = O.current;
					if (a.current = !0, p.trim() === "") {
						y(null, K(ln, e.nativeEvent)), j === "onBlur" && I.commit(null), E(null, vn(ln, e.nativeEvent));
						return;
					}
					let r = s.current, i = g_(p, C, r);
					if (i === null) return;
					let c = r?.maximumFractionDigits != null || r?.minimumFractionDigits != null, l = r?.maximumFractionDigits, u = c && typeof l == "number" ? Number(i.toFixed(l)) : i, d = vn(un, e.nativeEvent), f = T !== u, m = t || f || n;
					j === "onBlur" && I.commit(u), f && (R.current = !0, y(u, K("input-blur", e.nativeEvent))), m && E(u, d);
					let h = kg(u, C, r), g = Ag(i, C, r);
					!(!c && i === T && p === g) && p !== h && x(h);
				},
				onChange(e) {
					if (e.nativeEvent.defaultPrevented) return;
					a.current = !1;
					let t = e.target.value;
					if (t.trim() === "") {
						x(t), y(null, K(ln, e.nativeEvent));
						return;
					}
					let n = c();
					if (!Array.from(t).every((e) => {
						let t = e >= "0" && e <= "9", r = Qg.test(e), i = e_.test(e), a = $g.test(e), o = t_.test(e), s = p_.test(e);
						return t || r || i || a || o || s || n.has(e);
					})) return;
					let r = g_(t, C, s.current);
					x(t), r !== null && y(r, K("input-change", e.nativeEvent));
				},
				onKeyDown(e) {
					if (e.defaultPrevented || _ || o) return;
					let t = e.nativeEvent;
					a.current = !0;
					let n = c(), r = n.has(e.key), { decimal: i, currency: u, percentSign: f } = h_(C, s.current), g = e.currentTarget.selectionStart, v = e.currentTarget.selectionEnd, b = g === 0 && v === p.length, x = (e) => g != null && v != null && e >= g && e < v;
					if (p_.test(e.key) && Array.from(n).some((e) => p_.test(e || ""))) {
						let e = p.search(d_), t = e != null && e !== -1 && x(e);
						r = !(p_.test(p) || m_.test(p)) || b || t;
					}
					if (m_.test(e.key) && Array.from(n).some((e) => m_.test(e || ""))) {
						let e = p.search(f_), t = e != null && e !== -1 && x(e);
						r = !(p_.test(p) || m_.test(p)) || b || t;
					}
					[
						i,
						u,
						f
					].forEach((t) => {
						if (e.key === t) {
							let e = x(p.indexOf(t));
							r = !p.includes(t) || b || e;
						}
					});
					let S = e.key >= "0" && e.key <= "9", w = Qg.test(e.key), T = e_.test(e.key), O = t_.test(e.key), A = D_.has(e.key);
					if (e.which === 229 || e.altKey || e.ctrlKey || e.metaKey || r || S || w || O || T || A) return;
					let j = g_(p, C, s.current), M = l(e) ?? 1;
					xn(e);
					let N = vn(hn, t);
					e.key === "ArrowUp" ? (d(M, {
						direction: 1,
						currentValue: j,
						event: t,
						reason: hn
					}), E(D.current ?? k.current, N)) : e.key === "ArrowDown" ? (d(M, {
						direction: -1,
						currentValue: j,
						event: t,
						reason: hn
					}), E(D.current ?? k.current, N)) : e.key === "Home" && h != null ? (y(h, K(hn, t)), E(D.current ?? k.current, N)) : e.key === "End" && m != null && (y(m, K("keyboard", t)), E(D.current ?? k.current, N));
				},
				onPaste(e) {
					if (e.defaultPrevented || _ || o) return;
					e.preventDefault();
					let t = (e.clipboardData || window.Clipboard).getData("text/plain"), n = g_(t, C, s.current);
					n !== null && (a.current = !1, y(n, K("input-paste", e.nativeEvent)), x(t));
				}
			},
			I.getValidationProps(),
			i
		],
		stateAttributesMapping: E_
	});
});
process.env.NODE_ENV !== "production" && (O_.displayName = "NumberFieldInput"), V();
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/popover/close/PopoverClose.js
var k_ = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, disabled: i = !1, nativeButton: a = !0, ...o } = e, { buttonRef: s, getButtonProps: c } = iu({
		disabled: i,
		focusableWhenDisabled: !1,
		native: a
	}), { store: l } = om();
	return Gm(), Y("button", e, {
		ref: [t, s],
		props: [
			{ onClick(e) {
				l.setOpen(!1, K(an, e.nativeEvent, e.currentTarget));
			} },
			o,
			c
		]
	});
});
process.env.NODE_ENV !== "production" && (k_.displayName = "PopoverClose");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/popover/close.js
function A_(e) {
	let t = (0, x.c)(2), { children: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)(k_, { render: n }), t[0] = n, t[1] = r), r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/popover.module.js
var j_ = { "prism-popover__popup": "_prism-popover__popup_c1w7v_1" };
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/popover/content.js
function M_(e) {
	let t = (0, x.c)(11), { anchor: n, "aria-label": r, "aria-labelledby": i, children: a, id: o, role: s, side: c, sideOffset: l } = e, u = s === void 0 ? "dialog" : s, d = c === void 0 ? "bottom" : c, f = l === void 0 ? 8 : l, p;
	t[0] !== r || t[1] !== i || t[2] !== a || t[3] !== o || t[4] !== u ? (p = /* @__PURE__ */ (0, C.jsx)(qm, {
		"aria-label": r,
		"aria-labelledby": i,
		className: j_["prism-popover__popup"],
		id: o,
		role: u,
		children: a
	}), t[0] = r, t[1] = i, t[2] = a, t[3] = o, t[4] = u, t[5] = p) : p = t[5];
	let m;
	return t[6] !== n || t[7] !== d || t[8] !== f || t[9] !== p ? (m = /* @__PURE__ */ (0, C.jsx)(Fm, { children: /* @__PURE__ */ (0, C.jsx)(Rm, {
		anchor: n,
		className: j_["prism-popover__positioner"],
		side: d,
		sideOffset: f,
		children: p
	}) }), t[6] = n, t[7] = d, t[8] = f, t[9] = p, t[10] = m) : m = t[10], m;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/popover.js
function N_(e) {
	let t = (0, x.c)(4), { children: n, onOpenChange: r, open: i } = e, a;
	return t[0] !== n || t[1] !== r || t[2] !== i ? (a = /* @__PURE__ */ (0, C.jsx)(dm, {
		onOpenChange: r,
		open: i,
		children: n
	}), t[0] = n, t[1] = r, t[2] = i, t[3] = a) : a = t[3], a;
}
N_.Content = M_, N_.Close = A_;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/radio-group.module.js
var P_ = {
	"radio-group": "_radio-group_ft2lk_1",
	"radio-group--horizontal": "_radio-group--horizontal_ft2lk_7"
}, F_ = (0, S.createContext)(void 0);
function I_() {
	let e = (0, S.useContext)(F_);
	if (e === void 0) throw Error("useRadioGroupContext must be used within a RadioGroup parent component");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/radio-group/input.module.js
var L_ = {
	radio: "_radio_1yoiy_2",
	"radio-circle": "_radio-circle_1yoiy_15",
	"radio-circle--small": "_radio-circle--small_1yoiy_32",
	"radio-text": "_radio-text_1yoiy_36",
	"radio--disabled": "_radio--disabled_1yoiy_74"
}, R_ = /* @__PURE__ */ B(V(), 1);
function z_(e) {
	let t = (0, x.c)(31), n, r, i, a, o;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5]) : ({children: n, className: r, disabled: i, value: o, ...a} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o);
	let { disabled: s, isSmall: c, name: l, onChange: u, value: d } = I_(), f = d === o, p = i || s, m = !c, h;
	t[6] !== r || t[7] !== p || t[8] !== c || t[9] !== m ? (h = (0, R_.default)(L_.radio, {
		[L_["radio--disabled"]]: p,
		"text-200--regular": c,
		"text-300--regular": m
	}, r), t[6] = r, t[7] = p, t[8] = c, t[9] = m, t[10] = h) : h = t[10];
	let g = h, _;
	t[11] === c ? _ = t[12] : (_ = (0, R_.default)(L_["radio-circle"], { [L_["radio-circle--small"]]: c }), t[11] = c, t[12] = _);
	let v = _, y;
	t[13] === u ? y = t[14] : (y = (e) => u(e.target.value), t[13] = u, t[14] = y);
	let b;
	t[15] !== f || t[16] !== p || t[17] !== l || t[18] !== y || t[19] !== o ? (b = /* @__PURE__ */ (0, C.jsx)("input", {
		checked: f,
		disabled: p,
		name: l,
		onChange: y,
		type: "radio",
		value: o
	}), t[15] = f, t[16] = p, t[17] = l, t[18] = y, t[19] = o, t[20] = b) : b = t[20];
	let S;
	t[21] === v ? S = t[22] : (S = /* @__PURE__ */ (0, C.jsx)("span", {
		"aria-hidden": "true",
		className: v
	}), t[21] = v, t[22] = S);
	let w;
	t[23] === n ? w = t[24] : (w = /* @__PURE__ */ (0, C.jsx)("div", {
		className: L_["radio-text"],
		children: n
	}), t[23] = n, t[24] = w);
	let T;
	return t[25] !== g || t[26] !== a || t[27] !== b || t[28] !== S || t[29] !== w ? (T = /* @__PURE__ */ (0, C.jsxs)("label", {
		className: g,
		...a,
		children: [
			b,
			S,
			w
		]
	}), t[25] = g, t[26] = a, t[27] = b, t[28] = S, t[29] = w, t[30] = T) : T = t[30], T;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/radio-group.js
var B_ = /* @__PURE__ */ B(V(), 1);
function V_(e) {
	let t = (0, x.c)(26), n, r, i, a, o, s, c, l, u;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9]) : ({disabled: i, isHorizontal: a, isSmall: o, name: s, onChange: c, value: u, children: n, className: r, ...l} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u);
	let d;
	t[10] !== r || t[11] !== a ? (d = (0, B_.default)(P_["radio-group"], { [P_["radio-group--horizontal"]]: a }, r), t[10] = r, t[11] = a, t[12] = d) : d = t[12];
	let f = d, p;
	t[13] !== i || t[14] !== o || t[15] !== s || t[16] !== c || t[17] !== u ? (p = {
		disabled: i,
		isSmall: o,
		name: s,
		value: u,
		onChange: c
	}, t[13] = i, t[14] = o, t[15] = s, t[16] = c, t[17] = u, t[18] = p) : p = t[18];
	let m;
	t[19] !== n || t[20] !== p ? (m = /* @__PURE__ */ (0, C.jsx)(F_, {
		value: p,
		children: n
	}), t[19] = n, t[20] = p, t[21] = m) : m = t[21];
	let h;
	return t[22] !== f || t[23] !== l || t[24] !== m ? (h = /* @__PURE__ */ (0, C.jsx)("fieldset", {
		className: f,
		role: "radiogroup",
		...l,
		children: m
	}), t[22] = f, t[23] = l, t[24] = m, t[25] = h) : h = t[25], h;
}
V_.Input = z_;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/root/SelectRootContext.js
var H_ = /* @__PURE__ */ S.createContext(null);
process.env.NODE_ENV !== "production" && (H_.displayName = "SelectRootContext");
var U_ = /* @__PURE__ */ S.createContext(null);
process.env.NODE_ENV !== "production" && (U_.displayName = "SelectFloatingContext");
function W_() {
	let e = S.useContext(H_);
	if (e === null) throw Error(process.env.NODE_ENV === "production" ? lr(60) : "Base UI: SelectRootContext is missing. Select parts must be placed within <Select.Root>.");
	return e;
}
function G_() {
	let e = S.useContext(U_);
	if (e === null) throw Error(process.env.NODE_ENV === "production" ? lr(61) : "Base UI: SelectFloatingContext is missing. Select parts must be placed within <Select.Root>.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/store.js
var K_ = {
	id: q((e) => e.id),
	labelId: q((e) => e.labelId),
	modal: q((e) => e.modal),
	multiple: q((e) => e.multiple),
	items: q((e) => e.items),
	itemToStringLabel: q((e) => e.itemToStringLabel),
	itemToStringValue: q((e) => e.itemToStringValue),
	isItemEqualToValue: q((e) => e.isItemEqualToValue),
	value: q((e) => e.value),
	hasSelectedValue: q((e) => {
		let { value: t, multiple: n, itemToStringValue: r } = e;
		return t == null ? !1 : n && Array.isArray(t) ? t.length > 0 : od(t, r) !== "";
	}),
	hasNullItemLabel: q((e, t) => t ? id(e.items) : !1),
	open: q((e) => e.open),
	mounted: q((e) => e.mounted),
	forceMount: q((e) => e.forceMount),
	transitionStatus: q((e) => e.transitionStatus),
	openMethod: q((e) => e.openMethod),
	activeIndex: q((e) => e.activeIndex),
	selectedIndex: q((e) => e.selectedIndex),
	isActive: q((e, t) => e.activeIndex === t),
	isSelected: q((e, t, n) => {
		let r = e.isItemEqualToValue, i = e.value;
		return e.multiple ? Array.isArray(i) && i.some((e) => Qu(n, e, r)) : e.selectedIndex === t && e.selectedIndex !== null ? !0 : Qu(n, i, r);
	}),
	isSelectedByFocus: q((e, t) => e.selectedIndex === t),
	popupProps: q((e) => e.popupProps),
	triggerProps: q((e) => e.triggerProps),
	triggerElement: q((e) => e.triggerElement),
	positionerElement: q((e) => e.positionerElement),
	listElement: q((e) => e.listElement),
	scrollUpArrowVisible: q((e) => e.scrollUpArrowVisible),
	scrollDownArrowVisible: q((e) => e.scrollDownArrowVisible),
	hasScrollArrows: q((e) => e.hasScrollArrows)
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/root/SelectRoot.js
function q_(e) {
	let { id: t, value: n, defaultValue: r = null, onValueChange: i, open: a, defaultOpen: o = !1, onOpenChange: s, name: c, autoComplete: l, disabled: u = !1, readOnly: d = !1, required: f = !1, modal: p = !0, actionsRef: m, inputRef: h, onOpenChangeComplete: g, items: _, multiple: v = !1, itemToStringLabel: y, itemToStringValue: b, isItemEqualToValue: x = Zu, highlightItemOnHover: w = !0, children: T } = e, { clearErrors: E } = Xl(), { setDirty: D, setTouched: O, setFocused: k, shouldValidateOnChange: A, validityData: j, setFilled: M, name: N, disabled: P, validation: F, validationMode: I } = Kl(), L = ld({ id: t }), ee = P || u, R = N ?? c, [z, te] = Ll({
		controlled: n,
		default: v ? r ?? Dt : r,
		name: "Select",
		state: "value"
	}), [B, V] = Ll({
		controlled: a,
		default: o,
		name: "Select",
		state: "open"
	}), ne = S.useRef([]), re = S.useRef([]), ie = S.useRef(null), ae = S.useRef(null), oe = S.useRef(0), H = S.useRef(null), se = S.useRef([]), ce = S.useRef(!1), le = S.useRef(!1), ue = S.useRef(null), de = S.useRef({
		allowSelectedMouseUp: !1,
		allowUnselectedMouseUp: !1
	}), fe = S.useRef(!1), { mounted: pe, setMounted: me, transitionStatus: he } = Kn(B), { openMethod: ge, triggerProps: _e } = _i(B), ve = Te(() => new ai({
		id: L,
		labelId: void 0,
		modal: p,
		multiple: v,
		itemToStringLabel: y,
		itemToStringValue: b,
		isItemEqualToValue: x,
		value: z,
		open: B,
		mounted: pe,
		transitionStatus: he,
		items: _,
		forceMount: !1,
		openMethod: null,
		activeIndex: null,
		selectedIndex: null,
		popupProps: {},
		triggerProps: {},
		triggerElement: null,
		positionerElement: null,
		listElement: null,
		scrollUpArrowVisible: !1,
		scrollDownArrowVisible: !1,
		hasScrollArrows: !1
	})).current, ye = J(ve, K_.activeIndex), be = J(ve, K_.selectedIndex), xe = J(ve, K_.triggerElement), Se = J(ve, K_.positionerElement), Ce = S.useMemo(() => v && Array.isArray(z) && z.length === 0 ? "" : od(z, b), [
		v,
		z,
		b
	]), we = S.useMemo(() => v && Array.isArray(z) ? z.map((e) => od(e, b)) : od(z, b), [
		v,
		z,
		b
	]), Ee = Qo(ve.state.triggerElement);
	Ql({
		id: L,
		commit: F.commit,
		value: z,
		controlRef: Ee,
		name: R,
		getValue: () => we
	});
	let De = S.useRef(z);
	W(() => {
		z !== De.current && ve.set("forceMount", !0);
	}, [ve, z]), W(() => {
		M(v ? Array.isArray(z) && z.length > 0 : z != null);
	}, [
		v,
		z,
		M
	]), W(function() {
		if (B) return;
		let e = se.current;
		if (v) {
			let t = Array.isArray(z) ? z : [];
			if (t.length === 0) {
				ve.set("selectedIndex", null);
				return;
			}
			let n = t[t.length - 1], r = ed(e, n, x);
			ve.set("selectedIndex", r === -1 ? null : r);
			return;
		}
		let t = ed(e, z, x);
		ve.set("selectedIndex", t === -1 ? null : t);
	}, [
		v,
		B,
		z,
		se,
		x,
		ve
	]), gi(z, () => {
		E(R), D(z !== j.initialValue), A() ? F.commit(z) : F.commit(z, !0);
	});
	let Oe = U((e, t) => {
		if (s?.(e, t), !t.isCanceled && (V(e), !e && (t.reason === "focus-out" || t.reason === "outside-press") && (O(!0), k(!1), I === "onBlur" && F.commit(z)), !e && ve.state.activeIndex !== null)) {
			let e = ne.current[ve.state.activeIndex];
			queueMicrotask(() => {
				e?.setAttribute("tabindex", "-1");
			});
		}
	}), ke = U(() => {
		me(!1), ve.set("activeIndex", null), g?.(!1);
	});
	rr({
		enabled: !m,
		open: B,
		ref: ie,
		onComplete() {
			B || ke();
		}
	}), S.useImperativeHandle(m, () => ({ unmount: ke }), [ke]);
	let Ae = U((e, t) => {
		i?.(e, t), !t.isCanceled && te(e);
	}), je = U(() => {
		let e = ve.state.listElement || ie.current;
		if (!e) return;
		let t = e.scrollTop, n = e.scrollTop + e.clientHeight, r = t > 1, i = n < e.scrollHeight - 1;
		ve.state.scrollUpArrowVisible !== r && ve.set("scrollUpArrowVisible", r), ve.state.scrollDownArrowVisible !== i && ve.set("scrollDownArrowVisible", i);
	}), Me = Pu({
		open: B,
		onOpenChange: Oe,
		elements: {
			reference: xe,
			floating: Se
		}
	}), { getReferenceProps: Ne, getFloatingProps: Pe, getItemProps: Fe } = ui([
		Nu(Me, {
			enabled: !d && !ee,
			event: "mousedown"
		}),
		Gn(Me, { bubbles: !1 }),
		Vu(Me, {
			enabled: !d && !ee,
			listRef: ne,
			activeIndex: ye,
			selectedIndex: be,
			disabledIndices: Dt,
			onNavigate(e) {
				e === null && !B || ve.set("activeIndex", e);
			},
			focusItemOnHover: !1
		}),
		kp(Me, {
			enabled: !d && !ee && (B || !v),
			listRef: re,
			activeIndex: ye,
			selectedIndex: be,
			onMatch(e) {
				B ? ve.set("activeIndex", e) : Ae(se.current[e], K("none"));
			},
			onTypingChange(e) {
				ce.current = e;
			}
		})
	]), Ie = S.useMemo(() => Wi(Ne(), _e, L ? { id: L } : Ot), [
		Ne,
		_e,
		L
	]);
	Hu(() => {
		ve.update({
			popupProps: Pe(),
			triggerProps: Ie
		});
	}), W(() => {
		ve.update({
			id: L,
			modal: p,
			multiple: v,
			value: z,
			open: B,
			mounted: pe,
			transitionStatus: he,
			popupProps: Pe(),
			triggerProps: Ie,
			items: _,
			itemToStringLabel: y,
			itemToStringValue: b,
			isItemEqualToValue: x,
			openMethod: ge
		});
	}, [
		ve,
		L,
		p,
		v,
		z,
		B,
		pe,
		he,
		Pe,
		Ie,
		_,
		y,
		b,
		x,
		ge
	]);
	let Le = S.useMemo(() => ({
		store: ve,
		name: R,
		required: f,
		disabled: ee,
		readOnly: d,
		multiple: v,
		itemToStringLabel: y,
		itemToStringValue: b,
		highlightItemOnHover: w,
		setValue: Ae,
		setOpen: Oe,
		listRef: ne,
		popupRef: ie,
		scrollHandlerRef: ae,
		handleScrollArrowVisibility: je,
		scrollArrowsMountedCountRef: oe,
		getItemProps: Fe,
		events: Me.context.events,
		valueRef: H,
		valuesRef: se,
		labelsRef: re,
		typingRef: ce,
		selectionRef: de,
		selectedItemTextRef: ue,
		validation: F,
		onOpenChangeComplete: g,
		keyboardActiveRef: le,
		alignItemWithTriggerActiveRef: fe,
		initialValueRef: De
	}), [
		ve,
		R,
		f,
		ee,
		d,
		v,
		y,
		b,
		w,
		Ae,
		Oe,
		Fe,
		Me.context.events,
		F,
		g,
		je
	]), Re = Ai(h, F.inputRef), ze = v && Array.isArray(z) && z.length > 0, Be = v ? void 0 : R, Ve = S.useMemo(() => !v || !Array.isArray(z) || !R ? null : z.map((e) => {
		let t = od(e, b);
		return /* @__PURE__ */ (0, C.jsx)("input", {
			type: "hidden",
			name: R,
			value: t
		}, t);
	}), [
		v,
		z,
		R,
		b
	]);
	return /* @__PURE__ */ (0, C.jsx)(H_.Provider, {
		value: Le,
		children: /* @__PURE__ */ (0, C.jsxs)(U_.Provider, {
			value: Me,
			children: [
				T,
				/* @__PURE__ */ (0, C.jsx)("input", {
					...F.getInputValidationProps({
						onFocus() {
							ve.state.triggerElement?.focus({ focusVisible: !0 });
						},
						onChange(e) {
							if (e.nativeEvent.defaultPrevented) return;
							let t = e.target.value, n = K(Qt, e.nativeEvent);
							function r() {
								if (v) return;
								let e = se.current.find((e) => od(e, b).toLowerCase() === t.toLowerCase());
								e != null && (D(e !== j.initialValue), Ae(e, n), A() && F.commit(e));
							}
							ve.set("forceMount", !0), queueMicrotask(r);
						}
					}),
					id: L && Be == null ? `${L}-hidden-input` : void 0,
					name: Be,
					autoComplete: l,
					value: Ce,
					disabled: ee,
					required: f && !ze,
					readOnly: d,
					ref: Re,
					style: R ? ns : ts,
					tabIndex: -1,
					"aria-hidden": !0
				}),
				Ve
			]
		})
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/select/context.js
var J_ = (0, S.createContext)(void 0);
function Y_() {
	let e = (0, S.useContext)(J_);
	if (e === void 0) throw Error("useSelectContext must be used within a Select parent component");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/portal/SelectPortalContext.js
var X_ = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (X_.displayName = "SelectPortalContext");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/portal/SelectPortal.js
var Z_ = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { store: n } = W_(), r = J(n, K_.mounted), i = J(n, K_.forceMount);
	return r || i ? /* @__PURE__ */ (0, C.jsx)(X_.Provider, {
		value: !0,
		children: /* @__PURE__ */ (0, C.jsx)(Ss, {
			ref: t,
			...e
		})
	}) : null;
});
process.env.NODE_ENV !== "production" && (Z_.displayName = "SelectPortal");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/positioner/SelectPositionerContext.js
var Q_ = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Q_.displayName = "SelectPositionerContext");
function $_() {
	let e = S.useContext(Q_);
	if (!e) throw Error(process.env.NODE_ENV === "production" ? lr(59) : "Base UI: SelectPositionerContext is missing. SelectPositioner parts must be placed within <Select.Positioner>.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/popup/utils.js
function ev(e, t) {
	e && Object.assign(e.style, t);
}
var tv = {
	position: "relative",
	maxHeight: "100%",
	overflowX: "hidden",
	overflowY: "auto"
}, nv = { position: "fixed" }, rv = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { anchor: n, positionMethod: r = "absolute", className: i, render: a, side: o = "bottom", align: s = "center", sideOffset: c = 0, alignOffset: l = 0, collisionBoundary: u = "clipping-ancestors", collisionPadding: d, arrowPadding: f = 5, sticky: p = !1, disableAnchorTracking: m, alignItemWithTrigger: h = !0, collisionAvoidance: g = Yo, ..._ } = e, { store: v, listRef: y, labelsRef: b, alignItemWithTriggerActiveRef: x, selectedItemTextRef: w, valuesRef: T, initialValueRef: E, popupRef: D, setValue: O } = W_(), k = G_(), A = J(v, K_.open), j = J(v, K_.mounted), M = J(v, K_.modal), N = J(v, K_.value), P = J(v, K_.openMethod), F = J(v, K_.positionerElement), I = J(v, K_.triggerElement), L = J(v, K_.isItemEqualToValue), ee = J(v, K_.transitionStatus), R = S.useRef(null), z = S.useRef(null), [te, B] = S.useState(h), V = j && te && P !== "touch";
	!j && te !== h && B(h), W(() => {
		j || (K_.scrollUpArrowVisible(v.state) && v.set("scrollUpArrowVisible", !1), K_.scrollDownArrowVisible(v.state) && v.set("scrollDownArrowVisible", !1));
	}, [v, j]), S.useImperativeHandle(x, () => V), Lt((V || M) && A && P !== "touch", I);
	let ne = cp({
		anchor: n,
		floatingRootContext: k,
		positionMethod: r,
		mounted: j,
		side: o,
		sideOffset: c,
		align: s,
		alignOffset: l,
		arrowPadding: f,
		collisionBoundary: u,
		collisionPadding: d,
		sticky: p,
		disableAnchorTracking: m ?? V,
		collisionAvoidance: g,
		keepMounted: !0
	}), re = V ? "none" : ne.side, ie = V ? nv : ne.positionerStyles, ae = S.useMemo(() => {
		let e = {};
		return A || (e.pointerEvents = "none"), {
			role: "presentation",
			hidden: !j,
			style: {
				...ie,
				...e
			}
		};
	}, [
		A,
		j,
		ie
	]), oe = {
		open: A,
		side: re,
		align: ne.align,
		anchorHidden: ne.anchorHidden
	}, H = Y("div", e, {
		ref: [t, U((e) => {
			v.set("positionerElement", e);
		})],
		state: oe,
		stateAttributesMapping: ma,
		props: [
			ae,
			up(ee),
			_
		]
	}), se = S.useRef(0), ce = U((e) => {
		if (e.size === 0 && se.current === 0 || T.current.length === 0) return;
		let t = se.current;
		if (se.current = e.size, e.size === t) return;
		let n = K(Qt);
		if (t !== 0 && !v.state.multiple && N !== null && ed(T.current, N, L) === -1) {
			let e = E.current, t = e != null && ed(T.current, e, L) !== -1 ? e : null;
			O(t, n), t === null && (v.set("selectedIndex", null), w.current = null);
		}
		if (t !== 0 && v.state.multiple && Array.isArray(N)) {
			let e = (e) => ed(T.current, e, L) !== -1, t = N.filter((t) => e(t));
			(t.length !== N.length || t.some((e) => !$u(N, e, L))) && (O(t, n), t.length === 0 && (v.set("selectedIndex", null), w.current = null));
		}
		if (A && V) {
			v.update({
				scrollUpArrowVisible: !1,
				scrollDownArrowVisible: !1
			});
			let e = { height: "" };
			ev(F, e), ev(D.current, e);
		}
	}), le = S.useMemo(() => ({
		...ne,
		side: re,
		alignItemWithTriggerActive: V,
		setControlledAlignItemWithTrigger: B,
		scrollUpArrowRef: R,
		scrollDownArrowRef: z
	}), [
		ne,
		re,
		V,
		B
	]);
	return /* @__PURE__ */ (0, C.jsx)(Ld, {
		elementsRef: y,
		labelsRef: b,
		onMapChange: ce,
		children: /* @__PURE__ */ (0, C.jsxs)(Q_.Provider, {
			value: le,
			children: [j && M && /* @__PURE__ */ (0, C.jsx)(ic, {
				inert: rc(!A),
				cutout: I
			}), H]
		})
	});
});
process.env.NODE_ENV !== "production" && (rv.displayName = "SelectPositioner");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/csp-provider/CSPContext.js
var iv = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (iv.displayName = "CSPContext");
var av = { disableStyleElements: !1 };
function ov() {
	return S.useContext(iv) ?? av;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/styles.js
var sv = "base-ui-disable-scrollbar", cv = {
	className: sv,
	getElement(e) {
		return /* @__PURE__ */ (0, C.jsx)("style", {
			nonce: e,
			href: sv,
			precedence: "base-ui:low",
			children: `.${sv}{scrollbar-width:none}.${sv}::-webkit-scrollbar{display:none}`
		});
	}
};
process.env.NODE_ENV !== "production" && (cv.getElement.displayName = "styleDisableScrollbar.getElement");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/isMouseWithinBounds.js
function lv(e) {
	let t = e.currentTarget.getBoundingClientRect();
	return t.top + 1 <= e.clientY && e.clientY <= t.bottom - 1 && t.left + 1 <= e.clientX && e.clientX <= t.right - 1;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/popup/SelectPopup.js
var uv = 1, dv = {
	...ma,
	...Zn
}, fv = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, finalFocus: i, ...a } = e, { store: o, popupRef: s, onOpenChangeComplete: c, setOpen: l, valueRef: u, selectedItemTextRef: d, keyboardActiveRef: f, multiple: p, handleScrollArrowVisibility: m, scrollHandlerRef: h, highlightItemOnHover: g } = W_(), { side: _, align: v, alignItemWithTriggerActive: y, setControlledAlignItemWithTrigger: b, scrollDownArrowRef: x, scrollUpArrowRef: w } = $_(), T = Vm(!0) != null, E = G_(), { nonce: D, disableStyleElements: O } = ov(), k = bt(), A = J(o, K_.id), j = J(o, K_.open), M = J(o, K_.mounted), N = J(o, K_.popupProps), P = J(o, K_.transitionStatus), F = J(o, K_.triggerElement), I = J(o, K_.positionerElement), L = J(o, K_.listElement), ee = S.useRef(0), R = S.useRef(!1), z = S.useRef(0), te = S.useRef(!1), B = S.useRef({}), V = Tt(), ne = U((e) => {
		if (!I || !s.current || !te.current) return;
		if (R.current || !y) {
			m();
			return;
		}
		let t = I.style.top === "0px", n = I.style.bottom === "0px", r = I.getBoundingClientRect().height, i = ht(I), a = getComputedStyle(I), o = parseFloat(a.marginTop), c = parseFloat(a.marginBottom), l = pv(getComputedStyle(s.current)), u = Math.min(i.documentElement.clientHeight - o - c, l), d = e.scrollTop, f = mv(e), p = 0, h = null, g = !1, _ = !1, v = (e) => {
			I.style.height = `${e}px`;
		}, b = (t, n) => {
			let i = __(t, 0, u - r);
			i > 0 && v(r + i), e.scrollTop = n, u - (r + i) <= uv && (R.current = !0), m();
		};
		if (t) {
			let e = f - d, t = r + e, n = Math.min(t, u);
			if (p = n, e <= uv) {
				b(e, f);
				return;
			}
			u - n > uv ? _ = !0 : g = !0;
		} else if (n) {
			let e = d, t = r + e, n = Math.min(t, u), i = t - u;
			if (p = n, e <= uv) {
				b(e, 0);
				return;
			}
			u - n > uv ? h = 0 : (g = !0, d < f && (h = d - (e - i)));
		}
		if (p = Math.ceil(p), p !== 0 && v(p), _ || h != null) {
			let t = mv(e), n = _ ? t : __(h, 0, t);
			Math.abs(e.scrollTop - n) > uv && (e.scrollTop = n);
		}
		(g || p >= u - uv) && (R.current = !0), m();
	});
	S.useImperativeHandle(h, () => ne, [ne]), rr({
		open: j,
		ref: s,
		onComplete() {
			j && c?.(!0);
		}
	});
	let re = {
		open: j,
		transitionStatus: P,
		side: _,
		align: v
	};
	W(() => {
		!I || !s.current || Object.keys(B.current).length || (B.current = {
			top: I.style.top || "0",
			left: I.style.left || "0",
			right: I.style.right,
			height: I.style.height,
			bottom: I.style.bottom,
			minHeight: I.style.minHeight,
			maxHeight: I.style.maxHeight,
			marginTop: I.style.marginTop,
			marginBottom: I.style.marginBottom
		});
	}, [s, I]), W(() => {
		j || y || (te.current = !1, R.current = !1, ee.current = 0, z.current = 0, ev(I, B.current));
	}, [
		j,
		y,
		I,
		s
	]), W(() => {
		let e = s.current;
		if (!(!j || !F || !I || !e || o.state.transitionStatus === "ending")) {
			if (!y) {
				te.current = !0, V.request(m), e.style.removeProperty("--transform-origin");
				return;
			}
			queueMicrotask(() => {
				let t = vv(e);
				e.style.removeProperty("--transform-origin");
				try {
					let t = getComputedStyle(I), n = getComputedStyle(e), r = ht(F), i = Me(I), a = hv(F), o = gv(F.getBoundingClientRect(), a), s = gv(I.getBoundingClientRect(), a), c = o.left, l = o.height, f = L || e, p = f.scrollHeight, h = parseFloat(n.borderBottomWidth), g = parseFloat(t.marginTop) || 10, _ = parseFloat(t.marginBottom) || 10, v = parseFloat(t.minHeight) || 100, y = pv(n), x = r.documentElement.clientHeight - g - _, S = r.documentElement.clientWidth, C = x - o.bottom + l, w = d.current, T = u.current, E, D = 0, O = 0;
					if (w && T) {
						let e = gv(T.getBoundingClientRect(), a);
						E = gv(w.getBoundingClientRect(), a);
						let t = e.left - c, n = E.left - s.left, r = e.top - o.top + e.height / 2, i = E.top - s.top + E.height / 2;
						D = t - n, O = i - r;
					}
					let k = C + O + _ + h, A = Math.min(x, k), j = x - g - _, M = k - A, N = Math.max(5, c + D), P = S - 5, z = Math.max(0, N + s.width - P);
					I.style.left = `${N - z}px`, I.style.height = `${A}px`, I.style.maxHeight = "auto", I.style.marginTop = `${g}px`, I.style.marginBottom = `${_}px`, e.style.height = "100%";
					let V = mv(f), ne = M >= V - uv;
					ne && (A = Math.min(x, s.height) - (M - V));
					let re = o.top < 20 || o.bottom > x - 20 || Math.ceil(A) + uv < Math.min(p, v), ie = (i.visualViewport?.scale ?? 1) !== 1 && at;
					if (re || ie) {
						te.current = !0, ev(I, B.current), tr.flushSync(() => b(!1));
						return;
					}
					if (ne) {
						let e = Math.max(0, x - k);
						I.style.top = s.height >= j ? "0" : `${e}px`, I.style.height = `${A}px`, f.scrollTop = mv(f), ee.current = Math.max(v, A);
					} else I.style.bottom = "0", ee.current = Math.max(v, A), f.scrollTop = M;
					if (E) {
						let t = s.top, n = s.height, r = E.top + E.height / 2, i = __(n > 0 ? (r - t) / n * 100 : 50, 0, 100);
						e.style.setProperty("--transform-origin", `50% ${i}%`);
					}
					(ee.current === x || A >= y) && (R.current = !0), m(), setTimeout(() => {
						te.current = !0;
					});
				} finally {
					t();
				}
			});
		}
	}, [
		o,
		j,
		I,
		F,
		u,
		d,
		s,
		m,
		y,
		b,
		V,
		x,
		w,
		L
	]), S.useEffect(() => {
		if (!y || !I || !j) return;
		let e = Me(I);
		function t(e) {
			l(!1, K(_n, e));
		}
		return e.addEventListener("resize", t), () => {
			e.removeEventListener("resize", t);
		};
	}, [
		l,
		y,
		I,
		j
	]);
	let ie = {
		...L ? {
			role: "presentation",
			"aria-orientation": void 0
		} : {
			role: "listbox",
			"aria-multiselectable": p || void 0,
			id: `${A}-list`
		},
		onKeyDown(e) {
			f.current = !0, T && Js.has(e.key) && e.stopPropagation();
		},
		onMouseMove() {
			f.current = !1;
		},
		onPointerLeave(e) {
			if (!g || lv(e) || e.pointerType === "touch") return;
			let t = e.currentTarget;
			k.start(0, () => {
				o.set("activeIndex", null), t.focus({ preventScroll: !0 });
			});
		},
		onScroll(e) {
			L || ne(e.currentTarget);
		},
		...y && { style: L ? { height: "100%" } : tv }
	}, ae = Y("div", e, {
		ref: [t, s],
		state: re,
		stateAttributesMapping: dv,
		props: [
			N,
			ie,
			up(P),
			{ className: !L && y ? cv.className : void 0 },
			a
		]
	});
	return /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [!O && cv.getElement(D), /* @__PURE__ */ (0, C.jsx)(Ms, {
		context: E,
		modal: !1,
		disabled: !M,
		returnFocus: i,
		restoreFocus: !0,
		children: ae
	})] });
});
process.env.NODE_ENV !== "production" && (fv.displayName = "SelectPopup");
function pv(e) {
	let t = e.maxHeight || "";
	return t.endsWith("px") && parseFloat(t) || Infinity;
}
function mv(e) {
	return Math.max(0, e.scrollHeight - e.clientHeight);
}
function hv(e) {
	return Mf.getScale(e);
}
function gv(e, t) {
	return Wa({
		x: e.x / t.x,
		y: e.y / t.y,
		width: e.width / t.x,
		height: e.height / t.y
	});
}
var _v = [
	["transform", "none"],
	["scale", "1"],
	["translate", "0 0"]
];
function vv(e) {
	let { style: t } = e, n = {};
	for (let [e, r] of _v) n[e] = t.getPropertyValue(e), t.setProperty(e, r, "important");
	return () => {
		for (let [e] of _v) {
			let r = n[e];
			r ? t.setProperty(e, r) : t.removeProperty(e);
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/list/SelectList.js
var yv = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, ...i } = e, { store: a, scrollHandlerRef: o } = W_(), { alignItemWithTriggerActive: s } = $_(), c = J(a, K_.hasScrollArrows), l = J(a, K_.openMethod), u = J(a, K_.multiple), d = {
		id: `${J(a, K_.id)}-list`,
		role: "listbox",
		"aria-multiselectable": u || void 0,
		onScroll(e) {
			o.current?.(e.currentTarget);
		},
		...s && { style: tv },
		className: c && l !== "touch" ? cv.className : void 0
	};
	return Y("div", e, {
		ref: [t, U((e) => {
			a.set("listElement", e);
		})],
		props: [d, i]
	});
});
process.env.NODE_ENV !== "production" && (yv.displayName = "SelectList");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/select.module.js
var bv = {
	"prism-select__trigger": "_prism-select__trigger_1nepf_1",
	"prism-select__value": "_prism-select__value_1nepf_21",
	"prism-select__trigger--small": "_prism-select__trigger--small_1nepf_28",
	"prism-select": "_prism-select_1nepf_1",
	"prism-select__trigger--warning": "_prism-select__trigger--warning_1nepf_57",
	"prism-select__trigger--error": "_prism-select__trigger--error_1nepf_69",
	"prism-select__positioner": "_prism-select__positioner_1nepf_81",
	"prism-select__popup": "_prism-select__popup_1nepf_94",
	"prism-select__list": "_prism-select__list_1nepf_114",
	"prism-select__item-single": "_prism-select__item-single_1nepf_124",
	"prism-select__item-multiple": "_prism-select__item-multiple_1nepf_142"
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/select/menu.js
function xv(e) {
	let t = (0, x.c)(2), { children: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)(Z_, { children: /* @__PURE__ */ (0, C.jsx)(rv, {
		align: "start",
		alignItemWithTrigger: !1,
		className: bv["prism-select__positioner"],
		sideOffset: 4,
		children: /* @__PURE__ */ (0, C.jsx)(fv, {
			className: bv["prism-select__popup"],
			children: /* @__PURE__ */ (0, C.jsx)(yv, {
				className: bv["prism-select__list"],
				children: n
			})
		})
	}) }), t[0] = n, t[1] = r), r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/item/SelectItemContext.js
var Sv = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Sv.displayName = "SelectItemContext");
function Cv() {
	let e = S.useContext(Sv);
	if (!e) throw Error(process.env.NODE_ENV === "production" ? lr(57) : "Base UI: SelectItemContext is missing. SelectItem parts must be placed within <Select.Item>.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/item/SelectItem.js
var wv = /* @__PURE__ */ S.memo(/* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, value: i = null, label: a, disabled: o = !1, nativeButton: s = !1, ...c } = e, l = S.useRef(null), u = vp({
		label: a,
		textRef: l,
		indexGuessBehavior: _p.GuessFromOrder
	}), { store: d, getItemProps: f, setOpen: p, setValue: m, selectionRef: h, typingRef: g, valuesRef: _, keyboardActiveRef: v, multiple: y, highlightItemOnHover: b } = W_(), x = bt(), w = J(d, K_.isActive, u.index), T = J(d, K_.isSelected, u.index, i), E = J(d, K_.isSelectedByFocus, u.index), D = J(d, K_.isItemEqualToValue), O = u.index, k = O !== -1, A = S.useRef(null), j = Qo(O);
	W(() => {
		if (!k) return;
		let e = _.current;
		return e[O] = i, () => {
			delete e[O];
		};
	}, [
		k,
		O,
		i,
		_
	]), W(() => {
		if (!k) return;
		let e = d.state.value, t = e;
		y && Array.isArray(e) && e.length > 0 && (t = e[e.length - 1]), t !== void 0 && Qu(i, t, D) && d.set("selectedIndex", O);
	}, [
		k,
		O,
		y,
		D,
		d,
		i
	]);
	let M = {
		disabled: o,
		selected: T,
		highlighted: w
	}, N = f({
		active: w,
		selected: T
	});
	N.onFocus = void 0, N.id = void 0;
	let P = S.useRef(null), F = S.useRef("mouse"), I = S.useRef(!1), { getButtonProps: L, buttonRef: ee } = iu({
		disabled: o,
		focusableWhenDisabled: !0,
		native: s,
		composite: !0
	});
	function R(e) {
		let t = d.state.value;
		if (y) {
			let n = Array.isArray(t) ? t : [];
			m(T ? td(n, i, D) : [...n, i], K(rn, e));
		} else m(i, K(rn, e)), p(!1, K(rn, e));
	}
	let z = {
		role: "option",
		"aria-selected": T,
		tabIndex: w ? 0 : -1,
		onFocus() {
			d.set("activeIndex", O);
		},
		onMouseEnter() {
			!v.current && d.state.selectedIndex === null && b && d.set("activeIndex", O);
		},
		onMouseMove() {
			b && d.set("activeIndex", O);
		},
		onMouseLeave(e) {
			!b || v.current || lv(e) || x.start(0, () => {
				d.state.activeIndex === O && d.set("activeIndex", null);
			});
		},
		onTouchStart() {
			h.current = {
				allowSelectedMouseUp: !1,
				allowUnselectedMouseUp: !1
			};
		},
		onKeyDown(e) {
			P.current = e.key, d.set("activeIndex", O), e.key === " " && g.current && e.preventDefault();
		},
		onClick(e) {
			I.current = !1, !(e.type === "keydown" && P.current === null) && (o || e.type === "keydown" && P.current === " " && g.current || F.current !== "touch" && !w || (P.current = null, R(e.nativeEvent)));
		},
		onPointerEnter(e) {
			F.current = e.pointerType;
		},
		onPointerDown(e) {
			F.current = e.pointerType, I.current = !0;
		},
		onMouseUp() {
			if (o) return;
			if (I.current) {
				I.current = !1;
				return;
			}
			let e = !h.current.allowSelectedMouseUp && T, t = !h.current.allowUnselectedMouseUp && !T;
			e || t || F.current !== "touch" && !w || A.current?.click();
		}
	}, te = Y("div", e, {
		ref: [
			ee,
			t,
			u.ref,
			A
		],
		state: M,
		props: [
			N,
			z,
			c,
			L
		]
	}), B = S.useMemo(() => ({
		selected: T,
		indexRef: j,
		textRef: l,
		selectedByFocus: E,
		hasRegistered: k
	}), [
		T,
		j,
		l,
		E,
		k
	]);
	return /* @__PURE__ */ (0, C.jsx)(Sv.Provider, {
		value: B,
		children: te
	});
}));
process.env.NODE_ENV !== "production" && (wv.displayName = "SelectItem");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/item-indicator/SelectItemIndicator.js
var Tv = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let n = e.keepMounted ?? !1, { selected: r } = Cv();
	return n || r ? /* @__PURE__ */ (0, C.jsx)(Ev, {
		...e,
		ref: t
	}) : null;
});
process.env.NODE_ENV !== "production" && (Tv.displayName = "SelectItemIndicator");
var Ev = /* @__PURE__ */ S.memo(/* @__PURE__ */ S.forwardRef((e, t) => {
	let { render: n, className: r, keepMounted: i, ...a } = e, { selected: o } = Cv(), s = S.useRef(null), { transitionStatus: c, setMounted: l } = Kn(o), u = Y("span", e, {
		ref: [t, s],
		state: {
			selected: o,
			transitionStatus: c
		},
		props: [{
			"aria-hidden": !0,
			children: "✔️"
		}, a],
		stateAttributesMapping: Zn
	});
	return rr({
		open: o,
		ref: s,
		onComplete() {
			o || l(!1);
		}
	}), u;
}));
process.env.NODE_ENV !== "production" && (Ev.displayName = "Inner");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/item-text/SelectItemText.js
var Dv = /* @__PURE__ */ S.memo(/* @__PURE__ */ S.forwardRef(function(e, t) {
	let { indexRef: n, textRef: r, selectedByFocus: i, hasRegistered: a } = Cv(), { selectedItemTextRef: o } = W_(), { className: s, render: c, ...l } = e;
	return Y("div", e, {
		ref: [
			S.useCallback((e) => {
				if (!e || !a) return;
				let t = o.current === null || !o.current.isConnected;
				(i || t && n.current === 0) && (o.current = e);
			}, [
				o,
				n,
				i,
				a
			]),
			t,
			r
		],
		props: l
	});
}));
process.env.NODE_ENV !== "production" && (Dv.displayName = "SelectItemText");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/select/option.js
var Ov = /* @__PURE__ */ B(V(), 1);
function kv(e) {
	let t = (0, x.c)(14), { value: n, children: r } = e, { multiple: i } = Y_();
	if (i) {
		let e;
		t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = (0, Ov.default)(bv["prism-select__item-multiple"]), t[0] = e) : e = t[0];
		let i;
		t[1] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ (0, C.jsx)(Tv, {
			keepMounted: !0,
			render: Av
		}), t[1] = i) : i = t[1];
		let a;
		t[2] === r ? a = t[3] : (a = /* @__PURE__ */ (0, C.jsx)(Dv, {
			className: "text-300--regular",
			children: r
		}), t[2] = r, t[3] = a);
		let o;
		return t[4] !== a || t[5] !== n ? (o = /* @__PURE__ */ (0, C.jsxs)(wv, {
			className: e,
			value: n,
			children: [i, a]
		}), t[4] = a, t[5] = n, t[6] = o) : o = t[6], o;
	}
	let a;
	t[7] === Symbol.for("react.memo_cache_sentinel") ? (a = (0, Ov.default)(bv["prism-select__item-single"]), t[7] = a) : a = t[7];
	let o;
	t[8] === r ? o = t[9] : (o = /* @__PURE__ */ (0, C.jsx)(Dv, {
		className: "text-300--regular",
		children: r
	}), t[8] = r, t[9] = o);
	let s;
	t[10] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ (0, C.jsx)(Tv, { children: /* @__PURE__ */ (0, C.jsx)(N, { name: "checkmark" }) }), t[10] = s) : s = t[10];
	let c;
	return t[11] !== o || t[12] !== n ? (c = /* @__PURE__ */ (0, C.jsxs)(wv, {
		className: a,
		value: n,
		children: [o, s]
	}), t[11] = o, t[12] = n, t[13] = c) : c = t[13], c;
}
function Av(e, t) {
	return /* @__PURE__ */ (0, C.jsx)(Tc, {
		checked: t.selected,
		readOnly: !0
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/trigger/SelectTrigger.js
var jv = 2, Mv = 400, Nv = 200, Pv = {
	...pa,
	...Wl,
	value: () => null
}, Fv = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, id: i, disabled: a = !1, nativeButton: o = !0, ...s } = e, { setTouched: c, setFocused: l, validationMode: u, state: d, disabled: f } = Kl(), { labelId: p } = Jl(), { store: m, setOpen: h, selectionRef: g, validation: _, readOnly: v, required: y, alignItemWithTriggerActiveRef: b, disabled: x, keyboardActiveRef: C } = W_(), w = f || x || a, T = J(m, K_.open), E = J(m, K_.value), D = J(m, K_.triggerProps), O = J(m, K_.positionerElement), k = J(m, K_.listElement), A = J(m, K_.id), j = J(m, K_.labelId), M = J(m, K_.hasSelectedValue), N = !M && T, P = J(m, K_.hasNullItemLabel, N), F = i ?? A, I = Sd(p, j);
	ld({ id: F });
	let L = Qo(O), ee = S.useRef(null), { getButtonProps: R, buttonRef: z } = iu({
		disabled: w,
		native: o
	}), te = Ai(t, ee, z, U((e) => {
		m.set("triggerElement", e);
	})), B = bt(), V = bt(), ne = bt(), re = bt();
	S.useEffect(() => {
		if (T) return M || P ? re.start(Nv, () => {
			g.current.allowUnselectedMouseUp = !0, ne.start(Nv, () => {
				g.current.allowSelectedMouseUp = !0;
			});
		}) : ne.start(Mv, () => {
			g.current.allowUnselectedMouseUp = !0, g.current.allowSelectedMouseUp = !0;
		}), () => {
			ne.clear(), re.clear();
		};
		g.current = {
			allowSelectedMouseUp: !1,
			allowUnselectedMouseUp: !1
		}, V.clear();
	}, [
		T,
		M,
		P,
		g,
		V,
		ne,
		re
	]);
	let ie = S.useMemo(() => k?.id ?? Zt(O)?.id, [k, O]), ae = Wi(D, {
		id: F,
		role: "combobox",
		"aria-expanded": T ? "true" : "false",
		"aria-haspopup": "listbox",
		"aria-controls": T ? ie : void 0,
		"aria-labelledby": I,
		"aria-readonly": v || void 0,
		"aria-required": y || void 0,
		tabIndex: w ? -1 : 0,
		ref: te,
		onFocus(e) {
			l(!0), T && b.current && h(!1, K("none", e.nativeEvent)), B.start(0, () => {
				m.set("forceMount", !0);
			});
		},
		onBlur(e) {
			G(O, e.relatedTarget) || (c(!0), l(!1), u === "onBlur" && _.commit(E));
		},
		onPointerMove() {
			C.current = !1;
		},
		onKeyDown() {
			C.current = !0;
		},
		onMouseDown(e) {
			if (T) return;
			let t = ht(e.currentTarget);
			function n(e) {
				if (!ee.current) return;
				let t = e.target;
				if (G(ee.current, t) || G(L.current, t) || t === ee.current) return;
				let n = Ap(ee.current);
				e.clientX >= n.left - jv && e.clientX <= n.right + jv && e.clientY >= n.top - jv && e.clientY <= n.bottom + jv || h(!1, K("cancel-open", e));
			}
			V.start(0, () => {
				t.addEventListener("mouseup", n, { once: !0 });
			});
		}
	}, _.getValidationProps, s, R);
	ae.role = "combobox";
	let oe = {
		...d,
		open: T,
		disabled: w,
		value: E,
		readOnly: v,
		placeholder: !M
	};
	return Y("button", e, {
		ref: [t, ee],
		state: oe,
		stateAttributesMapping: Pv,
		props: ae
	});
});
process.env.NODE_ENV !== "production" && (Fv.displayName = "SelectTrigger");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/value/SelectValue.js
var Iv = { value: () => null }, Lv = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, children: i, placeholder: a, ...o } = e, { store: s, valueRef: c } = W_(), l = J(s, K_.value), u = J(s, K_.items), d = J(s, K_.itemToStringLabel), f = J(s, K_.hasSelectedValue), p = !f && a != null && i == null, m = J(s, K_.hasNullItemLabel, p), h = {
		value: l,
		placeholder: !f
	}, g = null;
	return g = typeof i == "function" ? i(l) : i ?? (!f && a != null && !m ? a : Array.isArray(l) ? cd(l, u, d) : sd(l, u, d)), Y("span", e, {
		state: h,
		ref: [t, c],
		props: [{ children: g }, o],
		stateAttributesMapping: Iv
	});
});
process.env.NODE_ENV !== "production" && (Lv.displayName = "SelectValue");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/select/icon/SelectIcon.js
var Rv = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, ...i } = e, { store: a } = W_();
	return Y("span", e, {
		state: { open: J(a, K_.open) },
		ref: t,
		props: [{
			"aria-hidden": !0,
			children: "▼"
		}, i],
		stateAttributesMapping: fa
	});
});
process.env.NODE_ENV !== "production" && (Rv.displayName = "SelectIcon");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/select/trigger.js
var zv = /* @__PURE__ */ B(V(), 1);
function Bv(e) {
	let t = (0, x.c)(12), { hasError: n, hasWarning: r, isSmall: i } = Y_(), a;
	t[0] !== n || t[1] !== r || t[2] !== i ? (a = (0, zv.default)(bv["prism-select__trigger"], {
		[bv["prism-select__trigger--error"]]: n,
		[bv["prism-select__trigger--warning"]]: r,
		[bv["prism-select__trigger--small"]]: i
	}), t[0] = n, t[1] = r, t[2] = i, t[3] = a) : a = t[3];
	let o = a, s = e["aria-label"], c;
	t[4] === Symbol.for("react.memo_cache_sentinel") ? (c = (0, zv.default)("text-300--regular", bv["prism-select__value"]), t[4] = c) : c = t[4];
	let l;
	t[5] === e.children ? l = t[6] : (l = /* @__PURE__ */ (0, C.jsx)(Lv, {
		className: c,
		children: e.children
	}), t[5] = e.children, t[6] = l);
	let u;
	t[7] === Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ (0, C.jsx)(Rv, { children: /* @__PURE__ */ (0, C.jsx)(N, {
		color: "inherit",
		name: "chevron-down"
	}) }), t[7] = u) : u = t[7];
	let d;
	return t[8] !== s || t[9] !== l || t[10] !== o ? (d = /* @__PURE__ */ (0, C.jsxs)(Fv, {
		"aria-label": s,
		className: o,
		children: [l, u]
	}), t[8] = s, t[9] = l, t[10] = o, t[11] = d) : d = t[11], d;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/select.js
function Vv(e) {
	let t = (0, x.c)(18), { disabled: n, children: r, hasError: i, hasWarning: a, isSmall: o, multiple: s, name: c, options: l, onChange: u, value: d } = e, f;
	t[0] === u ? f = t[1] : (f = u && ((e) => u(e)), t[0] = u, t[1] = f);
	let p;
	t[2] !== i || t[3] !== a || t[4] !== o || t[5] !== s ? (p = {
		multiple: s,
		hasError: i,
		hasWarning: a,
		isSmall: o
	}, t[2] = i, t[3] = a, t[4] = o, t[5] = s, t[6] = p) : p = t[6];
	let m;
	t[7] !== r || t[8] !== p ? (m = /* @__PURE__ */ (0, C.jsx)(J_, {
		value: p,
		children: r
	}), t[7] = r, t[8] = p, t[9] = m) : m = t[9];
	let h;
	return t[10] !== n || t[11] !== s || t[12] !== c || t[13] !== l || t[14] !== f || t[15] !== m || t[16] !== d ? (h = /* @__PURE__ */ (0, C.jsx)(q_, {
		disabled: n,
		items: l,
		multiple: s,
		name: c,
		onValueChange: f,
		value: d,
		children: m
	}), t[10] = n, t[11] = s, t[12] = c, t[13] = l, t[14] = f, t[15] = m, t[16] = d, t[17] = h) : h = t[17], h;
}
Vv.Trigger = Bv, Vv.Menu = xv, Vv.Option = kv;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/table.module.js
var Hv = {
	"prism-table": "_prism-table_tni29_1",
	"prism-table--bordered": "_prism-table--bordered_tni29_8",
	"prism-table__header": "_prism-table__header_tni29_13",
	"prism-table__header-cell": "_prism-table__header-cell_tni29_17",
	"prism-table__row": "_prism-table__row_tni29_30",
	"prism-table__cell": "_prism-table__cell_tni29_38",
	"prism-table__foot": "_prism-table__foot_tni29_50",
	"prism-table__body": "_prism-table__body_tni29_61",
	"prism-table__row--selected": "_prism-table__row--selected_tni29_65",
	"prism-table__row--active": "_prism-table__row--active_tni29_69",
	"prism-table__skeleton-bar": "_prism-table__skeleton-bar_tni29_92",
	"prism-table-pulse": "_prism-table-pulse_tni29_1"
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/table/body.js
function Uv(e) {
	let t = (0, x.c)(2), n;
	return t[0] === e ? n = t[1] : (n = /* @__PURE__ */ (0, C.jsx)("tbody", {
		className: Hv["prism-table__body"],
		...e
	}), t[0] = e, t[1] = n), n;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/table/cell.js
var Wv = /* @__PURE__ */ B(V(), 1);
function Gv(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, Wv.default)(Hv["prism-table__cell"], n), t[3] = n, t[4] = i);
	let a = i, o;
	return t[5] !== a || t[6] !== r ? (o = /* @__PURE__ */ (0, C.jsx)("td", {
		className: a,
		...r
	}), t[5] = a, t[6] = r, t[7] = o) : o = t[7], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/table/foot.js
function Kv(e) {
	let t = (0, x.c)(2), n;
	return t[0] === e ? n = t[1] : (n = /* @__PURE__ */ (0, C.jsx)("tfoot", {
		className: Hv["prism-table__foot"],
		...e
	}), t[0] = e, t[1] = n), n;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/table/header/cell.js
var qv = /* @__PURE__ */ B(V(), 1);
function Jv(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, qv.default)(Hv["prism-table__header-cell"], n), t[3] = n, t[4] = i);
	let a = i, o;
	return t[5] !== a || t[6] !== r ? (o = /* @__PURE__ */ (0, C.jsx)("th", {
		className: a,
		...r
	}), t[5] = a, t[6] = r, t[7] = o) : o = t[7], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/table/header.js
function Yv(e) {
	let t = (0, x.c)(2), n;
	return t[0] === e ? n = t[1] : (n = /* @__PURE__ */ (0, C.jsx)("thead", {
		className: Hv["prism-table__header"],
		...e
	}), t[0] = e, t[1] = n), n;
}
Yv.Cell = Jv;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/table/row.js
var Xv = /* @__PURE__ */ B(V(), 1);
function Zv(e) {
	let t = (0, x.c)(12), n, r, i, a;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({isSelected: i, isActive: r, className: n, ...a} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a);
	let o;
	t[5] !== n || t[6] !== r || t[7] !== i ? (o = (0, Xv.default)(Hv["prism-table__row"], {
		[Hv["prism-table__row--selected"]]: i,
		[Hv["prism-table__row--active"]]: r
	}, n), t[5] = n, t[6] = r, t[7] = i, t[8] = o) : o = t[8];
	let s;
	return t[9] !== a || t[10] !== o ? (s = /* @__PURE__ */ (0, C.jsx)("tr", {
		className: o,
		...a
	}), t[9] = a, t[10] = o, t[11] = s) : s = t[11], s;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/table/skeleton-bar.js
function Qv(e) {
	let t = (0, x.c)(2), { width: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)("div", {
		className: Hv["prism-table__skeleton-bar"],
		style: { width: n }
	}), t[0] = n, t[1] = r), r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/table.js
var $v = /* @__PURE__ */ B(V(), 1);
function ey(e) {
	let t = (0, x.c)(12), n, r, i, a;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({bordered: a, className: r, children: n, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a);
	let o = a === void 0 ? !0 : a, s;
	t[5] !== o || t[6] !== r ? (s = (0, $v.default)(Hv["prism-table"], { [Hv["prism-table--bordered"]]: o }, r), t[5] = o, t[6] = r, t[7] = s) : s = t[7];
	let c;
	return t[8] !== n || t[9] !== i || t[10] !== s ? (c = /* @__PURE__ */ (0, C.jsx)("table", {
		className: s,
		...i,
		children: n
	}), t[8] = n, t[9] = i, t[10] = s, t[11] = c) : c = t[11], c;
}
ey.Header = Yv, ey.Body = Uv, ey.Foot = Kv, ey.Row = Zv, ey.Cell = Gv, ey.SkeletonBar = Qv;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tabs/root/TabsRootContext.js
var ty = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (ty.displayName = "TabsRootContext");
function ny() {
	let e = S.useContext(ty);
	if (e === void 0) throw Error(process.env.NODE_ENV === "production" ? lr(64) : "Base UI: TabsRootContext is missing. Tabs parts must be placed within <Tabs.Root>.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tabs/root/TabsRootDataAttributes.js
var ry = /* @__PURE__ */ function(e) {
	return e.activationDirection = "data-activation-direction", e.orientation = "data-orientation", e;
}({}), iy = { tabActivationDirection: (e) => ({ [ry.activationDirection]: e }) }, ay = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, defaultValue: r = 0, onValueChange: i, orientation: a = "horizontal", render: o, value: s, ...c } = e, l = kd(), u = Object.hasOwn(e, "defaultValue"), d = S.useRef([]), [f, p] = S.useState(() => /* @__PURE__ */ new Map()), [m, h] = Ll({
		controlled: s,
		default: r,
		name: "Tabs",
		state: "value"
	}), g = s !== void 0, [_, v] = S.useState(() => /* @__PURE__ */ new Map()), [y, b] = S.useState("none"), x = U((e, t) => {
		i?.(e, t), !t.isCanceled && (h(e), b(t.activationDirection));
	}), w = U((e, t) => {
		p((n) => {
			if (n.get(e) === t) return n;
			let r = new Map(n);
			return r.set(e, t), r;
		});
	}), T = U((e, t) => {
		p((n) => {
			if (!n.has(e) || n.get(e) !== t) return n;
			let r = new Map(n);
			return r.delete(e), r;
		});
	}), E = S.useCallback((e) => f.get(e), [f]), D = S.useCallback((e) => {
		for (let t of _.values()) if (e === t?.value) return t?.id;
	}, [_]), O = S.useCallback((e) => {
		if (e === void 0) return null;
		for (let [t, n] of _.entries()) if (n != null && e === (n.value ?? n.index)) return t;
		return null;
	}, [_]), k = S.useMemo(() => ({
		direction: l,
		getTabElementBySelectedValue: O,
		getTabIdByPanelValue: D,
		getTabPanelIdByValue: E,
		onValueChange: x,
		orientation: a,
		registerMountedTabPanel: w,
		setTabMap: v,
		unregisterMountedTabPanel: T,
		tabActivationDirection: y,
		value: m
	}), [
		l,
		O,
		D,
		E,
		x,
		a,
		w,
		v,
		T,
		y,
		m
	]), A = S.useMemo(() => {
		for (let e of _.values()) if (e != null && e.value === m) return e;
	}, [_, m]), j = S.useMemo(() => {
		for (let e of _.values()) if (e != null && !e.disabled) return e.value;
	}, [_]);
	W(() => {
		if (g || _.size === 0) return;
		let e = A?.disabled;
		if (u && e && m === r || !e && !(A == null && m !== null)) return;
		let t = j ?? null;
		m !== t && (h(t), b("none"));
	}, [
		r,
		j,
		u,
		g,
		A,
		b,
		h,
		_,
		m
	]);
	let M = Y("div", e, {
		state: {
			orientation: a,
			tabActivationDirection: y
		},
		ref: t,
		props: c,
		stateAttributesMapping: iy
	});
	return /* @__PURE__ */ (0, C.jsx)(ty.Provider, {
		value: k,
		children: /* @__PURE__ */ (0, C.jsx)(Ld, {
			elementsRef: d,
			children: M
		})
	});
});
process.env.NODE_ENV !== "production" && (ay.displayName = "TabsRoot");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/tabs/container.module.js
var oy = { "prism-tabs__container": "_prism-tabs__container_1wrwr_1" }, sy = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (sy.displayName = "TabsListContext");
function cy() {
	let e = S.useContext(sy);
	if (e === void 0) throw Error(process.env.NODE_ENV === "production" ? lr(65) : "Base UI: TabsListContext is missing. TabsList parts must be placed within <Tabs.List>.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tabs/list/TabsList.js
var ly = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { activateOnFocus: n = !1, className: r, loopFocus: i = !0, render: a, ...o } = e, { getTabElementBySelectedValue: s, onValueChange: c, orientation: l, value: u, setTabMap: d, tabActivationDirection: f } = ny(), [p, m] = S.useState(0), [h, g] = S.useState(null), _ = S.useRef(/* @__PURE__ */ new Set()), v = S.useRef(/* @__PURE__ */ new Set()), y = S.useRef(null), b = U(() => {
		_.current.forEach((e) => {
			e();
		});
	});
	S.useEffect(() => {
		if (typeof ResizeObserver > "u") return;
		let e = new ResizeObserver(() => {
			_.current.size && b();
		});
		return y.current = e, h && e.observe(h), v.current.forEach((t) => {
			e.observe(t);
		}), () => {
			e.disconnect(), y.current = null;
		};
	}, [h, b]);
	let x = U((e) => (_.current.add(e), () => {
		_.current.delete(e);
	})), w = U((e) => (v.current.add(e), y.current?.observe(e), () => {
		v.current.delete(e), y.current?.unobserve(e);
	})), T = dy(u, l, h, s), E = U((e, t) => {
		e !== u && (t.activationDirection = T(e), c(e, t));
	}), D = {
		orientation: l,
		tabActivationDirection: f
	}, O = {
		"aria-orientation": l === "vertical" ? "vertical" : void 0,
		role: "tablist"
	}, k = S.useMemo(() => ({
		activateOnFocus: n,
		highlightedTabIndex: p,
		registerIndicatorUpdateListener: x,
		registerTabResizeObserverElement: w,
		onTabActivation: E,
		setHighlightedTabIndex: m,
		tabsListElement: h
	}), [
		n,
		p,
		x,
		w,
		E,
		m,
		h
	]);
	return /* @__PURE__ */ (0, C.jsx)(sy.Provider, {
		value: k,
		children: /* @__PURE__ */ (0, C.jsx)(Mh, {
			render: a,
			className: r,
			state: D,
			refs: [t, g],
			props: [O, o],
			stateAttributesMapping: iy,
			highlightedIndex: p,
			enableHomeAndEndKeys: !0,
			loopFocus: i,
			orientation: l,
			onHighlightedIndexChange: m,
			onMapChange: d,
			disabledIndices: Dt
		})
	});
});
process.env.NODE_ENV !== "production" && (ly.displayName = "TabsList");
function uy(e, t) {
	let { left: n, top: r } = e.getBoundingClientRect(), { left: i, top: a } = t.getBoundingClientRect();
	return {
		left: n - i,
		top: r - a
	};
}
function dy(e, t, n, r) {
	let [i, a] = S.useState(null);
	return W(() => {
		if (e == null || n == null) {
			a(null);
			return;
		}
		let i = r(e);
		if (i == null) {
			a(null);
			return;
		}
		let { left: o, top: s } = uy(i, n);
		a(t === "horizontal" ? o : s);
	}, [
		t,
		r,
		n,
		e
	]), S.useCallback((o) => {
		if (o === e) return "none";
		if (o == null) return a(null), "none";
		if (o != null && n != null) {
			let e = r(o);
			if (e != null) {
				let { left: r, top: o } = uy(e, n);
				if (i == null) return a(t === "horizontal" ? r : o), "none";
				if (t === "horizontal") {
					if (r < i) return a(r), "left";
					if (r > i) return a(r), "right";
				} else if (o < i) return a(o), "up";
				else if (o > i) return a(o), "down";
			}
		}
		return "none";
	}, [
		r,
		t,
		i,
		n,
		e
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/tabs/container/list.module.js
var fy = { "prism-tabs__list": "_prism-tabs__list_ej88h_1" }, py = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, disabled: r = !1, render: i, value: a, id: o, nativeButton: s = !0, ...c } = e, { value: l, getTabPanelIdByValue: u, orientation: d } = ny(), { activateOnFocus: f, highlightedTabIndex: p, onTabActivation: m, registerTabResizeObserverElement: h, setHighlightedTabIndex: g, tabsListElement: _ } = cy(), v = Il(o), { compositeProps: y, compositeRef: b, index: x } = Rh({ metadata: S.useMemo(() => ({
		disabled: r,
		id: v,
		value: a
	}), [
		r,
		v,
		a
	]) }), C = a === l, w = S.useRef(!1), T = S.useRef(null);
	S.useEffect(() => {
		let e = T.current;
		if (e) return h(e);
	}, [h]), W(() => {
		if (w.current) {
			w.current = !1;
			return;
		}
		if (!(C && x > -1 && p !== x)) return;
		let e = _;
		if (e != null) {
			let t = Ut(ht(e));
			if (t && G(e, t)) return;
		}
		r || g(x);
	}, [
		C,
		x,
		p,
		g,
		r,
		_
	]);
	let { getButtonProps: E, buttonRef: D } = iu({
		disabled: r,
		native: s,
		focusableWhenDisabled: !0
	}), O = u(a), k = S.useRef(!1), A = S.useRef(!1);
	function j(e) {
		C || r || m(a, K("none", e.nativeEvent, void 0, { activationDirection: "none" }));
	}
	function M(e) {
		C || (x > -1 && !r && g(x), !r && f && (!k.current || k.current && A.current) && m(a, K("none", e.nativeEvent, void 0, { activationDirection: "none" })));
	}
	function N(e) {
		if (C || r) return;
		k.current = !0;
		function t() {
			k.current = !1, A.current = !1;
		}
		(!e.button || e.button === 0) && (A.current = !0, ht(e.currentTarget).addEventListener("pointerup", t, { once: !0 }));
	}
	return Y("button", e, {
		state: {
			disabled: r,
			active: C,
			orientation: d
		},
		ref: [
			t,
			D,
			b,
			T
		],
		props: [
			y,
			{
				role: "tab",
				"aria-controls": O,
				"aria-selected": C,
				id: v,
				onClick: j,
				onFocus: M,
				onPointerDown: N,
				[Oh]: C ? "" : void 0,
				onKeyDownCapture() {
					w.current = !0;
				}
			},
			c,
			E
		]
	});
});
process.env.NODE_ENV !== "production" && (py.displayName = "TabsTab");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/tabs/container/list/tab.module.js
var my = { "prism-tabs__tab": "_prism-tabs__tab_15qv9_1" }, hy = /* @__PURE__ */ B(V(), 1);
function gy(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, hy.default)(my["prism-tabs__tab"], n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)(py, {
		className: i,
		...r
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/tabs/container/list.js
var _y = /* @__PURE__ */ B(V(), 1);
function vy(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, _y.default)(fy["prism-tabs__list"], n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)(ly, {
		className: i,
		...r
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
vy.Tab = gy;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/tabs/container.js
var yy = /* @__PURE__ */ B(V(), 1);
function by(e) {
	let t = (0, x.c)(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = (0, yy.default)(oy["prism-tabs__container"], n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ (0, C.jsx)("div", {
		className: i,
		...r
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
by.List = vy;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tabs/panel/TabsPanelDataAttributes.js
var xy = function(e) {
	return e.index = "data-index", e.activationDirection = "data-activation-direction", e.orientation = "data-orientation", e.hidden = "data-hidden", e[e.startingStyle = Jn.startingStyle] = "startingStyle", e[e.endingStyle = Jn.endingStyle] = "endingStyle", e;
}({}), Sy = {
	...iy,
	...Zn
}, Cy = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, value: r, render: i, keepMounted: a = !1, ...o } = e, { value: s, getTabIdByPanelValue: c, orientation: l, tabActivationDirection: u, registerMountedTabPanel: d, unregisterMountedTabPanel: f } = ny(), p = Il(), { ref: m, index: h } = vp({ metadata: S.useMemo(() => ({
		id: p,
		value: r
	}), [p, r]) }), g = r === s, { mounted: _, transitionStatus: v, setMounted: y } = Kn(g), b = !_, x = c(r), C = {
		hidden: b,
		orientation: l,
		tabActivationDirection: u,
		transitionStatus: v
	}, w = S.useRef(null), T = Y("div", e, {
		state: C,
		ref: [
			t,
			m,
			w
		],
		props: [{
			"aria-labelledby": x,
			hidden: b,
			id: p,
			role: "tabpanel",
			tabIndex: g ? 0 : -1,
			inert: rc(!g),
			[xy.index]: h
		}, o],
		stateAttributesMapping: Sy
	});
	return rr({
		open: g,
		ref: w,
		onComplete() {
			g || y(!1);
		}
	}), W(() => {
		if (!(b && !a) && p != null) return d(r, p), () => {
			f(r, p);
		};
	}, [
		b,
		a,
		r,
		p,
		d,
		f
	]), a || _ ? T : null;
});
process.env.NODE_ENV !== "production" && (Cy.displayName = "TabsPanel");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/tabs/panel.js
function wy(e) {
	let t = (0, x.c)(2), n;
	return t[0] === e ? n = t[1] : (n = /* @__PURE__ */ (0, C.jsx)(Cy, { ...e }), t[0] = e, t[1] = n), n;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/tabs.js
function Ty(e) {
	let t = (0, x.c)(5), { children: n, defaultValue: r, onValueChange: i, value: a } = e, o;
	return t[0] !== n || t[1] !== r || t[2] !== i || t[3] !== a ? (o = /* @__PURE__ */ (0, C.jsx)(ay, {
		defaultValue: r,
		onValueChange: i,
		value: a,
		children: n
	}), t[0] = n, t[1] = r, t[2] = i, t[3] = a, t[4] = o) : o = t[4], o;
}
Ty.Container = by, Ty.Panel = wy;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/toast/provider/ToastProviderContext.js
var Ey = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ey.displayName = "ToastContext");
function Dy() {
	let e = S.useContext(Ey);
	if (!e) throw Error(process.env.NODE_ENV === "production" ? lr(73) : "Base UI: useToastManager must be used within <Toast.Provider>.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_utils@0.2.6_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/utils/esm/generateId.js
var Oy = 0;
function ky(e) {
	return Oy += 1, `${e}-${Math.random().toString(36).slice(2, 6)}-${Oy}`;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/toast/utils/resolvePromiseOptions.js
function Ay(e, t) {
	if (typeof e == "string") return { description: e };
	if (typeof e == "function") {
		let n = e(t);
		return typeof n == "string" ? { description: n } : n;
	}
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/toast/store.js
var jy = Ir((e) => e.toasts, (e) => {
	let t = /* @__PURE__ */ new Map(), n = 0, r = 0;
	return e.forEach((e, i) => {
		let a = e.transitionStatus === "ending";
		t.set(e.id, {
			value: e,
			domIndex: i,
			visibleIndex: a ? -1 : n,
			offsetY: r
		}), r += e.height || 0, a || (n += 1);
	}), t;
}), $ = {
	toasts: q((e) => e.toasts),
	isEmpty: q((e) => e.toasts.length === 0),
	toast: q(jy, (e, t) => e.get(t)?.value),
	toastIndex: q(jy, (e, t) => e.get(t)?.domIndex ?? -1),
	toastOffsetY: q(jy, (e, t) => e.get(t)?.offsetY ?? 0),
	toastVisibleIndex: q(jy, (e, t) => e.get(t)?.visibleIndex ?? -1),
	hovering: q((e) => e.hovering),
	focused: q((e) => e.focused),
	expanded: q((e) => e.hovering || e.focused),
	expandedOrOutOfFocus: q((e) => e.hovering || e.focused || !e.isWindowFocused),
	prevFocusElement: q((e) => e.prevFocusElement)
}, My = class extends oi {
	timers = /* @__PURE__ */ new Map();
	areTimersPaused = !1;
	constructor(e) {
		super(e, {}, $);
	}
	setFocused(e) {
		this.set("focused", e);
	}
	setHovering(e) {
		this.set("hovering", e);
	}
	setIsWindowFocused(e) {
		this.set("isWindowFocused", e);
	}
	setPrevFocusElement(e) {
		this.set("prevFocusElement", e);
	}
	setViewport = (e) => {
		this.set("viewport", e);
	};
	disposeEffect = () => () => {
		this.timers.forEach((e) => {
			e.timeout?.clear();
		}), this.timers.clear();
	};
	removeToast(e) {
		let t = $.toastIndex(this.state, e);
		if (t === -1) return;
		this.state.toasts[t]?.onRemove?.();
		let n = [...this.state.toasts];
		n.splice(t, 1), this.setToasts(n);
	}
	addToast = (e) => {
		let { toasts: t, timeout: n, limit: r } = this.state, i = e.id || ky("toast"), a = {
			...e,
			id: i,
			transitionStatus: "starting"
		}, o = [a, ...t], s = o.filter((e) => e.transitionStatus !== "ending");
		if (s.length > r) {
			let e = s.length - r, t = s.slice(-e), n = new Set(t.map((e) => e.id));
			this.setToasts(o.map((e) => {
				let t = n.has(e.id);
				return e.limited === t ? e : {
					...e,
					limited: t
				};
			}));
		} else this.setToasts(o.map((e) => e.limited ? {
			...e,
			limited: !1
		} : e));
		let c = a.timeout ?? n;
		return a.type !== "loading" && c > 0 && this.scheduleTimer(i, c, () => this.closeToast(i)), $.expandedOrOutOfFocus(this.state) && this.pauseTimers(), i;
	};
	updateToast = (e, t) => {
		this.updateToastInternal(e, t);
	};
	updateToastInternal = (e, t) => {
		let { timeout: n, toasts: r } = this.state, i = $.toast(this.state, e) ?? null;
		if (!i || i.transitionStatus === "ending") return;
		let a = {
			...i,
			...t
		};
		this.setToasts(r.map((n) => n.id === e ? {
			...n,
			...t
		} : n));
		let o = a.timeout ?? n, s = i?.timeout ?? n, c = Object.hasOwn(t, "timeout"), l = a.transitionStatus !== "ending" && a.type !== "loading" && o > 0, u = this.timers.has(e), d = s !== o, f = i?.type === "loading";
		if (!l && u) {
			this.timers.get(e)?.timeout?.clear(), this.timers.delete(e);
			return;
		}
		if (l && (!u || d || c || f)) {
			let t = this.timers.get(e);
			t && (t.timeout?.clear(), this.timers.delete(e)), this.scheduleTimer(e, o, () => this.closeToast(e)), $.expandedOrOutOfFocus(this.state) && this.pauseTimers();
		}
	};
	closeToast = (e) => {
		let t = e === void 0, { limit: n, toasts: r } = this.state, i;
		if (t) i = r, this.timers.forEach((e) => {
			e.timeout?.clear();
		}), this.timers.clear();
		else {
			let t = $.toast(this.state, e);
			if (!t) return;
			i = [t];
			let n = this.timers.get(e);
			n?.timeout && (n.timeout.clear(), this.timers.delete(e));
		}
		let a = 0, o = { toasts: r.map((r) => {
			if (t || r.id === e) return {
				...r,
				transitionStatus: "ending",
				height: 0
			};
			if (r.transitionStatus === "ending") return r;
			let i = a >= n;
			return a += 1, r.limited === i ? r : {
				...r,
				limited: i
			};
		}) };
		(t || r.length === 1) && (o.hovering = !1, o.focused = !1), this.update(o), i.forEach((e) => {
			e.transitionStatus !== "ending" && e.onClose?.();
		}), this.handleFocusManagement(e);
	};
	promiseToast = (e, t) => {
		let n = Ay(t.loading), r = this.addToast({
			...n,
			type: "loading"
		}), i = e.then((e) => {
			let n = Ay(t.success, e);
			return this.updateToast(r, {
				...n,
				type: "success",
				timeout: n.timeout
			}), e;
		}).catch((e) => {
			let n = Ay(t.error, e);
			return this.updateToast(r, {
				...n,
				type: "error",
				timeout: n.timeout
			}), Promise.reject(e);
		});
		return {}.hasOwnProperty.call(t, "setPromise") && t.setPromise(i), i;
	};
	pauseTimers() {
		this.areTimersPaused || (this.areTimersPaused = !0, this.timers.forEach((e) => {
			if (e.timeout) {
				e.timeout.clear();
				let t = Date.now() - e.start, n = e.delay - t;
				e.remaining = n > 0 ? n : 0;
			}
		}));
	}
	resumeTimers() {
		this.areTimersPaused && (this.areTimersPaused = !1, this.timers.forEach((e, t) => {
			e.remaining = e.remaining > 0 ? e.remaining : e.delay, e.timeout ??= yt.create(), e.timeout.start(e.remaining, () => {
				this.timers.delete(t), e.callback();
			}), e.start = Date.now();
		}));
	}
	restoreFocusToPrevElement() {
		this.state.prevFocusElement?.focus({ preventScroll: !0 });
	}
	handleDocumentPointerDown = (e) => {
		if (e.pointerType !== "touch") return;
		let t = Gt(e);
		G(this.state.viewport, t) || (this.resumeTimers(), this.update({
			hovering: !1,
			focused: !1
		}));
	};
	scheduleTimer(e, t, n) {
		let r = Date.now(), i = !$.expandedOrOutOfFocus(this.state), a = i ? yt.create() : void 0;
		a?.start(t, () => {
			this.timers.delete(e), n();
		}), this.timers.set(e, {
			timeout: a,
			start: i ? r : 0,
			delay: t,
			remaining: t,
			callback: n
		});
	}
	setToasts(e) {
		let t = { toasts: e };
		e.length === 0 && (t.hovering = !1, t.focused = !1), this.update(t);
	}
	handleFocusManagement(e) {
		let t = Ut(ht(this.state.viewport));
		if (!this.state.viewport || !G(this.state.viewport, t) || !Xt(t)) return;
		if (e === void 0) {
			this.restoreFocusToPrevElement();
			return;
		}
		let n = $.toasts(this.state), r = $.toastIndex(this.state, e), i = null, a = r + 1;
		for (; a < n.length;) {
			if (n[a].transitionStatus !== "ending") {
				i = n[a];
				break;
			}
			a += 1;
		}
		if (!i) for (a = r - 1; a >= 0;) {
			if (n[a].transitionStatus !== "ending") {
				i = n[a];
				break;
			}
			--a;
		}
		i ? i.ref?.current?.focus() : this.restoreFocusToPrevElement();
	}
}, Ny = function(e) {
	let { children: t, timeout: n = 5e3, limit: r = 3, toastManager: i } = e, a = Te(() => new My({
		timeout: n,
		limit: r,
		viewport: null,
		toasts: [],
		hovering: !1,
		focused: !1,
		isWindowFocused: !0,
		prevFocusElement: null
	})).current;
	return _t(a.disposeEffect), S.useEffect(function() {
		if (i) return i[" subscribe"](({ action: e, options: t }) => {
			let n = t.id;
			e === "promise" && t.promise ? a.promiseToast(t.promise, t) : e === "update" && n ? a.updateToast(n, t) : e === "close" ? a.closeToast(n) : a.addToast(t);
		});
	}, [
		a,
		n,
		i
	]), a.useSyncedValues({
		timeout: n,
		limit: r
	}), /* @__PURE__ */ (0, C.jsx)(Ey.Provider, {
		value: a,
		children: t
	});
};
process.env.NODE_ENV !== "production" && (Ny.displayName = "ToastProvider");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/toast/viewport/ToastViewportCssVars.js
var Py = /* @__PURE__ */ function(e) {
	return e.frontmostHeight = "--toast-frontmost-height", e;
}({}), Fy = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, children: i, ...a } = e, o = Dy(), s = bt(), c = S.useRef(!1), l = S.useRef(!1), u = o.useState("isEmpty"), d = o.useState("toasts"), f = o.useState("focused"), p = o.useState("expanded"), m = o.useState("prevFocusElement"), h = d[0]?.height ?? 0, g = S.useMemo(() => d.some((e) => e.transitionStatus === "ending"), [d]);
	S.useEffect(() => {
		let e = o.state.viewport;
		if (!e) return;
		function t(t) {
			u || t.key === "F6" && t.target !== e && (t.preventDefault(), o.setPrevFocusElement(Ut(ht(e))), e?.focus({ preventScroll: !0 }), o.pauseTimers(), o.setFocused(!0));
		}
		let n = Me(e);
		return n.addEventListener("keydown", t), () => {
			n.removeEventListener("keydown", t);
		};
	}, [o, u]), S.useEffect(() => {
		let e = o.state.viewport;
		if (!e || u) return;
		let t = Me(e);
		function n(e) {
			e.target === t && (o.setIsWindowFocused(!1), o.pauseTimers());
		}
		function r(n) {
			if (n.relatedTarget || n.target === t) return;
			let r = Gt(n), i = Ut(ht(e));
			(!G(e, r) || !Xt(i)) && o.resumeTimers(), s.start(0, () => o.setIsWindowFocused(!0));
		}
		return t.addEventListener("blur", n, !0), t.addEventListener("focus", r, !0), () => {
			t.removeEventListener("blur", n, !0), t.removeEventListener("focus", r, !0);
		};
	}, [
		o,
		s,
		u
	]), S.useEffect(() => {
		let e = o.state.viewport;
		if (!e || u) return;
		let t = ht(e);
		return t.addEventListener("pointerdown", o.handleDocumentPointerDown, !0), () => {
			t.removeEventListener("pointerdown", o.handleDocumentPointerDown, !0);
		};
	}, [u, o]);
	function _(e) {
		let t = o.state.viewport;
		t && (c.current = !0, e.relatedTarget === t ? d[0]?.ref?.current?.focus() : o.restoreFocusToPrevElement());
	}
	function v(e) {
		e.key === "Tab" && e.shiftKey && e.target === o.state.viewport && (e.preventDefault(), o.restoreFocusToPrevElement(), o.resumeTimers());
	}
	S.useEffect(() => {
		!o.state.isWindowFocused || g || !l.current || (o.resumeTimers(), o.setHovering(!1), l.current = !1);
	}, [g, o]);
	function y() {
		o.pauseTimers(), o.setHovering(!0), l.current = !1;
	}
	function b() {
		g ? l.current = !0 : (o.resumeTimers(), o.setHovering(!1));
	}
	function x() {
		if (c.current) {
			c.current = !1;
			return;
		}
		f || Xt(ht(o.state.viewport).activeElement) && (o.setFocused(!0), o.pauseTimers());
	}
	function w(e) {
		!f || G(o.state.viewport, e.relatedTarget) || (o.setFocused(!1), o.resumeTimers());
	}
	let T = {
		tabIndex: -1,
		role: "region",
		"aria-live": "polite",
		"aria-atomic": !1,
		"aria-relevant": "additions text",
		"aria-label": "Notifications",
		onMouseEnter: y,
		onMouseMove: y,
		onMouseLeave: b,
		onFocus: x,
		onBlur: w,
		onKeyDown: v,
		onClick: x
	}, E = { expanded: p }, D = Y("div", e, {
		ref: [t, o.setViewport],
		state: E,
		props: [
			T,
			{ style: { [Py.frontmostHeight]: h ? `${h}px` : void 0 } },
			a,
			{ children: /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [
				!u && m && /* @__PURE__ */ (0, C.jsx)(rs, { onFocus: _ }),
				i,
				!u && m && /* @__PURE__ */ (0, C.jsx)(rs, { onFocus: _ })
			] }) }
		]
	}), O = S.useMemo(() => d.filter((e) => e.priority === "high"), [d]);
	return /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [
		!u && m && /* @__PURE__ */ (0, C.jsx)(rs, { onFocus: _ }),
		D,
		!f && O.length > 0 && /* @__PURE__ */ (0, C.jsx)("div", {
			style: ts,
			children: O.map((e) => /* @__PURE__ */ (0, C.jsxs)("div", {
				role: "alert",
				"aria-atomic": !0,
				children: [/* @__PURE__ */ (0, C.jsx)("div", { children: e.title }), /* @__PURE__ */ (0, C.jsx)("div", { children: e.description })]
			}, e.id))
		})
	] });
});
process.env.NODE_ENV !== "production" && (Fy.displayName = "ToastViewport");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/utils/FloatingPortalLite.js
var Iy = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { children: n, container: r, className: i, render: a, ...o } = e, { portalNode: s, portalSubtree: c } = xs({
		container: r,
		ref: t,
		componentProps: e,
		elementProps: o
	});
	return !c && !s ? null : /* @__PURE__ */ (0, C.jsxs)(S.Fragment, { children: [c, s && /* @__PURE__ */ tr.createPortal(n, s)] });
});
process.env.NODE_ENV !== "production" && (Iy.displayName = "FloatingPortalLite");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/toast/root/ToastRootContext.js
var Ly = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ly.displayName = "ToastRootContext");
function Ry() {
	let e = S.useContext(Ly);
	if (!e) throw Error(process.env.NODE_ENV === "production" ? lr(66) : "Base UI: ToastRootContext is missing. Toast parts must be used within <Toast.Root>.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/toast/root/ToastRootCssVars.js
var zy = /* @__PURE__ */ function(e) {
	return e.index = "--toast-index", e.offsetY = "--toast-offset-y", e.height = "--toast-height", e.swipeMovementX = "--toast-swipe-movement-x", e.swipeMovementY = "--toast-swipe-movement-y", e;
}({}), By = {
	...Zn,
	swipeDirection(e) {
		return e ? { "data-swipe-direction": e } : null;
	}
}, Vy = 40, Hy = 10, Uy = .5, Wy = 1, Gy = `${qo},${Jo}`;
function Ky(e, t, n) {
	switch (e) {
		case "up": return -n;
		case "down": return n;
		case "left": return -t;
		case "right": return t;
		default: return 0;
	}
}
function qy(e) {
	let t = window.getComputedStyle(e).transform, n = 0, r = 0, i = 1;
	if (t && t !== "none") {
		let e = t.match(/matrix(?:3d)?\(([^)]+)\)/);
		if (e) {
			let t = e[1].split(", ").map(parseFloat);
			t.length === 6 ? (n = t[4], r = t[5], i = Math.sqrt(t[0] * t[0] + t[1] * t[1])) : t.length === 16 && (n = t[12], r = t[13], i = t[0]);
		}
	}
	return {
		x: n,
		y: r,
		scale: i
	};
}
var Jy = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { toast: n, render: r, className: i, swipeDirection: a = ["down", "right"], ...o } = e, s = n.positionerProps?.anchor !== void 0, c = [];
	s || (c = Array.isArray(a) ? a : [a]);
	let l = c.length > 0, u = Dy(), [d, f] = S.useState(void 0), [p, m] = S.useState(!1), [h, g] = S.useState(!1), [_, v] = S.useState(!1), [y, b] = S.useState({
		x: 0,
		y: 0
	}), [x, w] = S.useState({
		x: 0,
		y: 0,
		scale: 1
	}), [T, E] = S.useState(), [D, O] = S.useState(), [k, A] = S.useState(null), j = S.useRef(null), M = S.useRef({
		x: 0,
		y: 0
	}), N = S.useRef({
		x: 0,
		y: 0,
		scale: 1
	}), P = S.useRef(void 0), F = S.useRef(0), I = S.useRef(!1), L = S.useRef({
		x: 0,
		y: 0
	}), ee = S.useRef(!1), R = u.useState("toastIndex", n.id), z = u.useState("toastVisibleIndex", n.id), te = u.useState("toastOffsetY", n.id), B = u.useState("focused"), V = u.useState("expanded");
	rr({
		open: n.transitionStatus !== "ending",
		ref: j,
		onComplete() {
			n.transitionStatus === "ending" && u.removeToast(n.id);
		}
	});
	let ne = U((e = !1) => {
		let t = j.current;
		if (!t) return;
		let r = t.style.height;
		t.style.height = "auto";
		let i = t.offsetHeight;
		t.style.height = r;
		function a() {
			u.updateToastInternal(n.id, {
				ref: j,
				height: i,
				...n.transitionStatus === "starting" ? { transitionStatus: void 0 } : {}
			});
		}
		e ? tr.flushSync(a) : a();
	});
	W(ne, [ne]);
	function re(e, t) {
		let n = e, r = t;
		return !c.includes("left") && !c.includes("right") ? n = e > 0 ? e ** Uy : -(Math.abs(e) ** Uy) : (!c.includes("right") && e > 0 && (n = e ** Uy), !c.includes("left") && e < 0 && (n = -(Math.abs(e) ** Uy))), !c.includes("up") && !c.includes("down") ? r = t > 0 ? t ** Uy : -(Math.abs(t) ** Uy) : (!c.includes("down") && t > 0 && (r = t ** Uy), !c.includes("up") && t < 0 && (r = -(Math.abs(t) ** Uy))), {
			x: n,
			y: r
		};
	}
	function ie(e) {
		if (e.button !== 0) return;
		e.pointerType === "touch" && u.pauseTimers();
		let t = Gt(e.nativeEvent);
		if (!(t && t.closest(`button,a,input,textarea,[role="button"],${Gy}`))) {
			if (I.current = !1, P.current = void 0, F.current = 0, M.current = {
				x: e.clientX,
				y: e.clientY
			}, L.current = M.current, j.current) {
				let e = qy(j.current);
				N.current = e, w(e), b({
					x: e.x,
					y: e.y
				});
			}
			u.setHovering(!0), m(!0), g(!1), A(null), ee.current = !0, j.current?.setPointerCapture(e.pointerId);
		}
	}
	function ae(e) {
		if (!p) return;
		e.preventDefault(), ee.current &&= (M.current = {
			x: e.clientX,
			y: e.clientY
		}, !1);
		let { clientY: t, clientX: n, movementX: r, movementY: i } = e;
		(i < 0 && t > L.current.y || i > 0 && t < L.current.y) && (L.current = {
			x: L.current.x,
			y: t
		}), (r < 0 && n > L.current.x || r > 0 && n < L.current.x) && (L.current = {
			x: n,
			y: L.current.y
		});
		let a = n - M.current.x, o = t - M.current.y, s = t - L.current.y, l = n - L.current.x;
		if (!h && Math.sqrt(a * a + o * o) >= Wy && (g(!0), k === null)) {
			let e = c.includes("left") || c.includes("right"), t = c.includes("up") || c.includes("down");
			e && t && A(Math.abs(a) > Math.abs(o) ? "horizontal" : "vertical");
		}
		let u;
		if (!P.current) k === "vertical" ? o > 0 ? u = "down" : o < 0 && (u = "up") : k === "horizontal" ? a > 0 ? u = "right" : a < 0 && (u = "left") : u = Math.abs(a) >= Math.abs(o) ? a > 0 ? "right" : "left" : o > 0 ? "down" : "up", u && c.includes(u) && (P.current = u, F.current = Ky(u, a, o), f(u));
		else {
			let e = P.current, t = Ky(e, l, s);
			t > Vy ? (I.current = !1, f(e)) : !(c.includes("left") && c.includes("right")) && !(c.includes("up") && c.includes("down")) && F.current - t >= Hy && (I.current = !0);
		}
		let d = re(a, o), m = N.current.x, _ = N.current.y;
		k === "horizontal" ? (c.includes("left") || c.includes("right")) && (m += d.x) : (k === "vertical" || (c.includes("left") || c.includes("right")) && (m += d.x), (c.includes("up") || c.includes("down")) && (_ += d.y)), b({
			x: m,
			y: _
		});
	}
	function oe(e) {
		if (!p) return;
		if (m(!1), g(!1), A(null), j.current?.releasePointerCapture(e.pointerId), I.current) {
			b({
				x: x.x,
				y: x.y
			}), f(void 0);
			return;
		}
		let t = !1, r = y.x - x.x, i = y.y - x.y, a;
		for (let e of c) {
			switch (e) {
				case "right":
					r > Vy && (t = !0, a = "right");
					break;
				case "left":
					r < -Vy && (t = !0, a = "left");
					break;
				case "down":
					i > Vy && (t = !0, a = "down");
					break;
				case "up":
					i < -Vy && (t = !0, a = "up");
					break;
				default: break;
			}
			if (t) break;
		}
		t ? (f(a), v(!0), u.closeToast(n.id)) : (b({
			x: x.x,
			y: x.y
		}), f(void 0));
	}
	function H(e) {
		if (e.key === "Escape") {
			if (!j.current || !G(j.current, Ut(ht(j.current)))) return;
			u.closeToast(n.id);
		}
	}
	S.useEffect(() => {
		if (!l) return;
		let e = j.current;
		if (!e) return;
		function t(t) {
			G(e, t.target) && t.preventDefault();
		}
		return e.addEventListener("touchmove", t, { passive: !1 }), () => {
			e.removeEventListener("touchmove", t);
		};
	}, [l]);
	function se() {
		if (!p && y.x === x.x && y.y === x.y && !_) return {
			[zy.swipeMovementX]: "0px",
			[zy.swipeMovementY]: "0px"
		};
		let e = y.x - x.x, t = y.y - x.y;
		return {
			transition: p ? "none" : void 0,
			transform: p ? `translateX(${y.x}px) translateY(${y.y}px) scale(${x.scale})` : void 0,
			[zy.swipeMovementX]: `${e}px`,
			[zy.swipeMovementY]: `${t}px`
		};
	}
	let ce = n.priority === "high", le = {
		role: ce ? "alertdialog" : "dialog",
		tabIndex: 0,
		"aria-modal": !1,
		"aria-labelledby": T,
		"aria-describedby": D,
		"aria-hidden": ce && !B ? !0 : void 0,
		onPointerDown: l ? ie : void 0,
		onPointerMove: l ? ae : void 0,
		onPointerUp: l ? oe : void 0,
		onKeyDown: H,
		inert: rc(n.limited),
		style: {
			...se(),
			[zy.index]: n.transitionStatus === "ending" ? R : z,
			[zy.offsetY]: `${te}px`,
			[zy.height]: n.height ? `${n.height}px` : void 0
		}
	}, ue = S.useMemo(() => ({
		rootRef: j,
		toast: n,
		titleId: T,
		setTitleId: E,
		descriptionId: D,
		setDescriptionId: O,
		swiping: p,
		swipeDirection: d,
		recalculateHeight: ne,
		index: R,
		visibleIndex: z,
		expanded: V
	}), [
		n,
		T,
		D,
		p,
		d,
		ne,
		R,
		z,
		V
	]), de = {
		transitionStatus: n.transitionStatus,
		expanded: V,
		limited: n.limited || !1,
		type: n.type,
		swiping: ue.swiping,
		swipeDirection: ue.swipeDirection
	}, fe = Y("div", e, {
		ref: [t, ue.rootRef],
		state: de,
		stateAttributesMapping: By,
		props: [le, o]
	});
	return /* @__PURE__ */ (0, C.jsx)(Ly.Provider, {
		value: ue,
		children: fe
	});
});
process.env.NODE_ENV !== "production" && (Jy.displayName = "ToastRoot");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/toast/content/ToastContent.js
var Yy = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, ...i } = e, { visibleIndex: a, expanded: o, recalculateHeight: s } = Ry(), c = S.useRef(null);
	return W(() => {
		let e = c.current;
		if (!e || (s(), typeof ResizeObserver != "function" || typeof MutationObserver != "function")) return;
		let t = new ResizeObserver(() => s(!0)), n = new MutationObserver(() => s(!0));
		return t.observe(e), n.observe(e, {
			childList: !0,
			subtree: !0,
			characterData: !0
		}), () => {
			t.disconnect(), n.disconnect();
		};
	}, [s]), Y("div", e, {
		ref: [t, c],
		state: {
			expanded: o,
			behind: a > 0
		},
		props: i
	});
});
process.env.NODE_ENV !== "production" && (Yy.displayName = "ToastContent");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/toast/description/ToastDescription.js
var Xy = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, id: i, children: a, ...o } = e, { toast: s, setDescriptionId: c } = Ry(), l = a ?? s.description, u = !!l, d = Mn(i);
	W(() => {
		if (u) return c(d), () => {
			c(void 0);
		};
	}, [
		u,
		d,
		c
	]);
	let f = Y("p", e, {
		ref: t,
		state: { type: s.type },
		props: {
			...o,
			id: d,
			children: l
		}
	});
	return u ? f : null;
});
process.env.NODE_ENV !== "production" && (Xy.displayName = "ToastDescription");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/toast/close/ToastClose.js
var Zy = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, disabled: i, nativeButton: a = !0, ...o } = e, s = Dy(), { toast: c } = Ry(), l = s.useState("expanded"), [u, d] = S.useState(!1), { getButtonProps: f, buttonRef: p } = iu({
		disabled: i,
		native: a
	}), m = { type: c.type };
	return Y("button", e, {
		ref: [t, p],
		state: m,
		props: [
			{
				"aria-hidden": !l && !u,
				onClick() {
					s.closeToast(c.id);
				},
				onFocus() {
					d(!0);
				},
				onBlur() {
					d(!1);
				}
			},
			o,
			f
		]
	});
});
process.env.NODE_ENV !== "production" && (Zy.displayName = "ToastClose"), V();
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/toggle-group/ToggleGroupContext.js
var Qy = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Qy.displayName = "ToggleGroupContext");
function $y(e = !0) {
	let t = S.useContext(Qy);
	if (t === void 0 && !e) throw Error(process.env.NODE_ENV === "production" ? lr(7) : "Base UI: ToggleGroupContext is missing. ToggleGroup parts must be placed within <ToggleGroup>.");
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/toggle-group/ToggleGroupDataAttributes.js
var eb = /* @__PURE__ */ function(e) {
	return e.disabled = "data-disabled", e.orientation = "data-orientation", e.multiple = "data-multiple", e;
}({}), tb = { multiple(e) {
	return e ? { [eb.multiple]: "" } : null;
} }, nb = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { defaultValue: n, disabled: r = !1, loopFocus: i = !0, onValueChange: a, orientation: o = "horizontal", multiple: s = !1, value: c, className: l, render: u, ...d } = e, f = Vm(!0), p = S.useMemo(() => {
		if (c === void 0) return n ?? [];
	}, [c, n]), m = S.useMemo(() => c !== void 0 || n !== void 0, [c, n]), h = (f?.disabled ?? !1) || r, [g, _] = Ll({
		controlled: c,
		default: p,
		name: "ToggleGroup",
		state: "value"
	}), v = U((e, t, n) => {
		let r;
		if (s ? (r = g.slice(), t ? r.push(e) : r.splice(g.indexOf(e), 1)) : r = t ? [e] : [], Array.isArray(r)) {
			if (a?.(r, n), n.isCanceled) return;
			_(r);
		}
	}), y = {
		disabled: h,
		multiple: s,
		orientation: o
	}, b = S.useMemo(() => ({
		disabled: h,
		orientation: o,
		setGroupValue: v,
		value: g,
		isValueInitialized: m
	}), [
		h,
		o,
		v,
		g,
		m
	]), x = { role: "group" }, w = Y("div", e, {
		enabled: !!f,
		state: y,
		ref: t,
		props: [x, d],
		stateAttributesMapping: tb
	});
	return /* @__PURE__ */ (0, C.jsx)(Qy.Provider, {
		value: b,
		children: f ? w : /* @__PURE__ */ (0, C.jsx)(Mh, {
			render: u,
			className: l,
			state: y,
			refs: [t],
			props: [x, d],
			stateAttributesMapping: tb,
			loopFocus: i,
			enableHomeAndEndKeys: !0
		})
	});
});
process.env.NODE_ENV !== "production" && (nb.displayName = "ToggleGroup");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/toggle-group.module.js
var rb = { "prism-toggle-group": "_prism-toggle-group_79hve_1" }, ib = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, defaultPressed: r = !1, disabled: i = !1, form: a, onPressedChange: o, pressed: s, render: c, type: l, value: u, nativeButton: d = !0, ...f } = e, p = Il(u || void 0), m = $y(), h = m?.value ?? [], g = m ? void 0 : r, _ = (i || m?.disabled) ?? !1;
	process.env.NODE_ENV !== "production" && W(() => {
		m && u === void 0 && m.isValueInitialized && eu("A `<Toggle>` component rendered in a `<ToggleGroup>` has no explicit `value` prop.", "This will cause issues between the Toggle Group and Toggle values.", "Provide the `<Toggle>` with a `value` prop matching the `<ToggleGroup>` values prop type.");
	}, [
		m,
		u,
		m?.isValueInitialized
	]);
	let [v, y] = Ll({
		controlled: m ? p !== void 0 && h.indexOf(p) > -1 : s,
		default: g,
		name: "Toggle",
		state: "pressed"
	}), b = U((e, t) => {
		p && m?.setGroupValue?.(p, e, t), o?.(e, t);
	}), { getButtonProps: x, buttonRef: S } = iu({
		disabled: _,
		native: d
	}), w = {
		disabled: _,
		pressed: v
	}, T = [S, t], E = [
		{
			"aria-pressed": v,
			onClick(e) {
				let t = !v, n = K(Qt, e.nativeEvent);
				b(t, n), !n.isCanceled && y(t);
			}
		},
		f,
		x
	], D = Y("button", e, {
		enabled: !m,
		state: w,
		ref: T,
		props: E
	});
	return m ? /* @__PURE__ */ (0, C.jsx)(zh, {
		tag: "button",
		render: c,
		className: n,
		state: w,
		refs: T,
		props: E
	}) : D;
});
process.env.NODE_ENV !== "production" && (ib.displayName = "Toggle");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/toggle-group/button.module.js
var ab = { "prism-toggle-group__button": "_prism-toggle-group__button_bhwb0_1" }, ob = /* @__PURE__ */ B(V(), 1);
function sb(e) {
	let t = (0, x.c)(10), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({className: n, value: i, ...r} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a;
	t[4] === n ? a = t[5] : (a = (0, ob.default)(ab["prism-toggle-group__button"], "text-300--medium", n), t[4] = n, t[5] = a);
	let o;
	return t[6] !== r || t[7] !== a || t[8] !== i ? (o = /* @__PURE__ */ (0, C.jsx)(ib, {
		className: a,
		value: i,
		...r
	}), t[6] = r, t[7] = a, t[8] = i, t[9] = o) : o = t[9], o;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/toggle-group.js
var cb = /* @__PURE__ */ B(V(), 1);
function lb(e) {
	let t = (0, x.c)(14), n, r, i, a;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({className: n, onValueChange: r, value: a, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a);
	let o;
	t[5] === n ? o = t[6] : (o = (0, cb.default)(rb["prism-toggle-group"], n), t[5] = n, t[6] = o);
	let s;
	t[7] === r ? s = t[8] : (s = (e) => r?.(e), t[7] = r, t[8] = s);
	let c;
	return t[9] !== i || t[10] !== o || t[11] !== s || t[12] !== a ? (c = /* @__PURE__ */ (0, C.jsx)(nb, {
		className: o,
		onValueChange: s,
		value: a,
		...i
	}), t[9] = i, t[10] = o, t[11] = s, t[12] = a, t[13] = c) : c = t[13], c;
}
lb.Button = sb;
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useClientPoint.js
function ub(e, t) {
	let n = null, r = null, i = !1;
	return {
		contextElement: e || void 0,
		getBoundingClientRect() {
			let a = e?.getBoundingClientRect() || {
				width: 0,
				height: 0,
				x: 0,
				y: 0
			}, o = t.axis === "x" || t.axis === "both", s = t.axis === "y" || t.axis === "both", c = ["mouseenter", "mousemove"].includes(t.dataRef.current.openEvent?.type || "") && t.pointerType !== "touch", l = a.width, u = a.height, d = a.x, f = a.y;
			return n == null && t.x && o && (n = a.x - t.x), r == null && t.y && s && (r = a.y - t.y), d -= n || 0, f -= r || 0, l = 0, u = 0, !i || c ? (l = t.axis === "y" ? a.width : 0, u = t.axis === "x" ? a.height : 0, d = o && t.x != null ? t.x : d, f = s && t.y != null ? t.y : f) : i && !c && (u = t.axis === "x" ? a.height : u, l = t.axis === "y" ? a.width : l), i = !0, {
				width: l,
				height: u,
				x: d,
				y: f,
				top: f,
				right: d + l,
				bottom: f + u,
				left: d
			};
		}
	};
}
function db(e) {
	return e != null && e.clientX != null;
}
function fb(e, t = {}) {
	let n = "rootStore" in e ? e.rootStore : e, r = n.useState("open"), i = n.useState("floatingElement"), a = n.useState("domReferenceElement"), o = n.context.dataRef, { enabled: s = !0, axis: c = "both" } = t, l = S.useRef(!1), u = S.useRef(null), [d, f] = S.useState(), [p, m] = S.useState([]), h = U((e, t, r) => {
		l.current || o.current.openEvent && !db(o.current.openEvent) || n.set("positionReference", ub(r ?? a, {
			x: e,
			y: t,
			axis: c,
			dataRef: o,
			pointerType: d
		}));
	}), g = U((e) => {
		r ? u.current || m([]) : h(e.clientX, e.clientY, e.currentTarget);
	}), _ = Tn(d) ? i : r, v = S.useCallback(() => {
		if (!_ || !s) return;
		let e = Me(i);
		function t(n) {
			G(i, Gt(n)) ? (e.removeEventListener("mousemove", t), u.current = null) : h(n.clientX, n.clientY);
		}
		if (!o.current.openEvent || db(o.current.openEvent)) {
			e.addEventListener("mousemove", t);
			let n = () => {
				e.removeEventListener("mousemove", t), u.current = null;
			};
			return u.current = n, n;
		}
		n.set("positionReference", a);
	}, [
		_,
		s,
		i,
		o,
		a,
		n,
		h
	]);
	S.useEffect(() => v(), [v, p]), S.useEffect(() => {
		s && !i && (l.current = !1);
	}, [s, i]), S.useEffect(() => {
		!s && r && (l.current = !0);
	}, [s, r]);
	let y = S.useMemo(() => {
		function e(e) {
			f(e.pointerType);
		}
		return {
			onPointerDown: e,
			onPointerEnter: e,
			onMouseMove: g,
			onMouseEnter: g
		};
	}, [g]);
	return S.useMemo(() => s ? {
		reference: y,
		trigger: y
	} : {}, [s, y]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tooltip/root/TooltipRootContext.js
var pb = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (pb.displayName = "TooltipRootContext");
function mb(e) {
	let t = S.useContext(pb);
	if (t === void 0 && !e) throw Error(process.env.NODE_ENV === "production" ? lr(72) : "Base UI: TooltipRootContext is missing. Tooltip parts must be placed within <Tooltip.Root>.");
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tooltip/store/TooltipStore.js
var hb = {
	...Ti,
	disabled: q((e) => e.disabled),
	instantType: q((e) => e.instantType),
	isInstantPhase: q((e) => e.isInstantPhase),
	trackCursorAxis: q((e) => e.trackCursorAxis),
	disableHoverablePopup: q((e) => e.disableHoverablePopup),
	lastOpenChangeReason: q((e) => e.openChangeReason),
	closeOnClick: q((e) => e.closeOnClick),
	closeDelay: q((e) => e.closeDelay),
	hasViewport: q((e) => e.hasViewport)
}, gb = class e extends oi {
	constructor(e) {
		super({
			..._b(),
			...e
		}, {
			popupRef: /* @__PURE__ */ S.createRef(),
			onOpenChange: void 0,
			onOpenChangeComplete: void 0,
			triggerElements: new xi()
		}, hb);
	}
	setOpen = (e, t) => {
		let n = t.reason, r = n === en, i = e && n === "trigger-focus", a = !e && (n === "trigger-press" || n === "escape-key");
		if (t.preventUnmountOnClose = () => {
			this.set("preventUnmountingOnClose", !0);
		}, this.context.onOpenChange?.(e, t), t.isCanceled) return;
		let o = () => {
			let r = {
				open: e,
				openChangeReason: n
			};
			i ? r.instantType = "focus" : a ? r.instantType = "dismiss" : n === "trigger-hover" && (r.instantType = void 0);
			let o = t.trigger?.id ?? null;
			(o || e) && (r.activeTriggerId = o, r.activeTriggerElement = t.trigger ?? null), this.update(r);
		};
		r ? tr.flushSync(o) : o();
	};
	static useStore(t, n) {
		let r = Te(() => new e(n)).current, i = t ?? r, a = li({
			popupStore: i,
			onOpenChange: i.setOpen
		});
		return i.state.floatingRootContext = a, i;
	}
};
function _b() {
	return {
		...Ci(),
		disabled: !1,
		instantType: void 0,
		isInstantPhase: !1,
		trackCursorAxis: "none",
		disableHoverablePopup: !1,
		openChangeReason: null,
		closeOnClick: !0,
		closeDelay: 0,
		hasViewport: !1
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tooltip/root/TooltipRoot.js
var vb = Xr(function(e) {
	let { disabled: t = !1, defaultOpen: n = !1, open: r, disableHoverablePopup: i = !1, trackCursorAxis: a = "none", actionsRef: o, onOpenChange: s, onOpenChangeComplete: c, handle: l, triggerId: u, defaultTriggerId: d = null, children: f } = e, p = gb.useStore(l?.store, {
		open: n,
		openProp: r,
		activeTriggerId: d,
		triggerIdProp: u
	});
	Hu(() => {
		r === void 0 && p.state.open === !1 && n === !0 && p.update({
			open: !0,
			activeTriggerId: d
		});
	}), p.useControlledProp("openProp", r), p.useControlledProp("triggerIdProp", u), p.useContextCallback("onOpenChange", s), p.useContextCallback("onOpenChangeComplete", c);
	let m = p.useState("open"), h = !t && m, g = p.useState("activeTriggerId"), _ = p.useState("payload");
	p.useSyncedValues({
		trackCursorAxis: a,
		disableHoverablePopup: i
	}), W(() => {
		m && t && p.setOpen(!1, K("disabled"));
	}, [
		m,
		t,
		p
	]), p.useSyncedValue("disabled", t), or(p);
	let { forceUnmount: v, transitionStatus: y } = sr(h, p), b = p.useState("isInstantPhase"), x = p.useState("instantType"), w = p.useState("lastOpenChangeReason"), T = S.useRef(null);
	W(() => {
		y === "ending" && w === "none" || y !== "ending" && b ? (x !== "delay" && (T.current = x), p.set("instantType", "delay")) : T.current !== null && (p.set("instantType", T.current), T.current = null);
	}, [
		y,
		b,
		w,
		x,
		p
	]), W(() => {
		h && (g ?? p.set("payload", void 0));
	}, [
		p,
		g,
		h
	]);
	let E = S.useCallback(() => {
		p.setOpen(!1, yb(p, gn));
	}, [p]);
	S.useImperativeHandle(o, () => ({
		unmount: v,
		close: E
	}), [v, E]);
	let D = p.useState("floatingRootContext"), { getReferenceProps: O, getFloatingProps: k, getTriggerProps: A } = ui([Gn(D, {
		enabled: !t,
		referencePress: () => p.select("closeOnClick")
	}), fb(D, {
		enabled: !t && a !== "none",
		axis: a === "none" ? void 0 : a
	})]), j = S.useMemo(() => O(), [O]), M = S.useMemo(() => A(), [A]), N = S.useMemo(() => k(), [k]);
	return p.useSyncedValues({
		activeTriggerProps: j,
		inactiveTriggerProps: M,
		popupProps: N
	}), /* @__PURE__ */ (0, C.jsx)(pb.Provider, {
		value: p,
		children: typeof f == "function" ? f({ payload: _ }) : f
	});
});
process.env.NODE_ENV !== "production" && (vb.displayName = "TooltipRoot");
function yb(e, t) {
	let n = K(t);
	return n.preventUnmountOnClose = () => {
		e.set("preventUnmountingOnClose", !0);
	}, n;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tooltip/portal/TooltipPortalContext.js
var bb = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (bb.displayName = "TooltipPortalContext");
function xb() {
	let e = S.useContext(bb);
	if (e === void 0) throw Error(process.env.NODE_ENV === "production" ? lr(70) : "Base UI: <Tooltip.Portal> is missing.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tooltip/portal/TooltipPortal.js
var Sb = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { keepMounted: n = !1, ...r } = e;
	return mb().useState("mounted") || n ? /* @__PURE__ */ (0, C.jsx)(bb.Provider, {
		value: n,
		children: /* @__PURE__ */ (0, C.jsx)(Iy, {
			ref: t,
			...r
		})
	}) : null;
});
process.env.NODE_ENV !== "production" && (Sb.displayName = "TooltipPortal");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tooltip/positioner/TooltipPositionerContext.js
var Cb = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Cb.displayName = "TooltipPositionerContext");
function wb() {
	let e = S.useContext(Cb);
	if (e === void 0) throw Error(process.env.NODE_ENV === "production" ? lr(71) : "Base UI: TooltipPositionerContext is missing. TooltipPositioner parts must be placed within <Tooltip.Positioner>.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tooltip/positioner/TooltipPositioner.js
var Tb = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { render: n, className: r, anchor: i, positionMethod: a = "absolute", side: o = "top", align: s = "center", sideOffset: c = 0, alignOffset: l = 0, collisionBoundary: u = "clipping-ancestors", collisionPadding: d = 5, arrowPadding: f = 5, sticky: p = !1, disableAnchorTracking: m = !1, collisionAvoidance: h = Xo, ...g } = e, _ = mb(), v = xb(), y = _.useState("open"), b = _.useState("mounted"), x = _.useState("trackCursorAxis"), w = _.useState("disableHoverablePopup"), T = _.useState("floatingRootContext"), E = _.useState("instantType"), D = _.useState("transitionStatus"), O = cp({
		anchor: i,
		positionMethod: a,
		floatingRootContext: T,
		mounted: b,
		side: o,
		sideOffset: c,
		align: s,
		alignOffset: l,
		collisionBoundary: u,
		collisionPadding: d,
		sticky: p,
		arrowPadding: f,
		disableAnchorTracking: m,
		keepMounted: v,
		collisionAvoidance: h,
		adaptiveOrigin: _.useState("hasViewport") ? ap : void 0
	}), k = S.useMemo(() => {
		let e = {};
		return (!y || x === "both" || w) && (e.pointerEvents = "none"), {
			role: "presentation",
			hidden: !b,
			style: {
				...O.positionerStyles,
				...e
			}
		};
	}, [
		y,
		x,
		w,
		b,
		O.positionerStyles
	]), A = S.useMemo(() => ({
		open: y,
		side: O.side,
		align: O.align,
		anchorHidden: O.anchorHidden,
		instant: x === "none" ? E : "tracking-cursor"
	}), [
		y,
		O.side,
		O.align,
		O.anchorHidden,
		x,
		E
	]), j = S.useMemo(() => ({
		...A,
		arrowRef: O.arrowRef,
		arrowStyles: O.arrowStyles,
		arrowUncentered: O.arrowUncentered
	}), [
		A,
		O.arrowRef,
		O.arrowStyles,
		O.arrowUncentered
	]), M = Y("div", e, {
		state: A,
		props: [
			k,
			up(D),
			g
		],
		ref: [t, _.useStateSetter("positionerElement")],
		stateAttributesMapping: ma
	});
	return /* @__PURE__ */ (0, C.jsx)(Cb.Provider, {
		value: j,
		children: M
	});
});
process.env.NODE_ENV !== "production" && (Tb.displayName = "TooltipPositioner");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tooltip/popup/TooltipPopup.js
var Eb = {
	...ma,
	...Zn
}, Db = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, ...i } = e, a = mb(), { side: o, align: s } = wb(), c = a.useState("open"), l = a.useState("instantType"), u = a.useState("transitionStatus"), d = a.useState("popupProps"), f = a.useState("floatingRootContext");
	rr({
		open: c,
		ref: a.context.popupRef,
		onComplete() {
			c && a.context.onOpenChangeComplete?.(!0);
		}
	});
	let p = a.useState("disabled"), m = a.useState("closeDelay");
	return zm(f, {
		enabled: !p,
		closeDelay: m
	}), Y("div", e, {
		state: {
			open: c,
			side: o,
			align: s,
			instant: l,
			transitionStatus: u
		},
		ref: [
			t,
			a.context.popupRef,
			a.useStateSetter("popupElement")
		],
		props: [
			d,
			up(u),
			i
		],
		stateAttributesMapping: Eb
	});
});
process.env.NODE_ENV !== "production" && (Db.displayName = "TooltipPopup");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tooltip/arrow/TooltipArrow.js
var Ob = /* @__PURE__ */ S.forwardRef(function(e, t) {
	let { className: n, render: r, ...i } = e, a = mb().useState("instantType"), { open: o, arrowRef: s, side: c, align: l, arrowUncentered: u, arrowStyles: d } = wb();
	return Y("div", e, {
		state: {
			open: o,
			side: c,
			align: l,
			uncentered: u,
			instant: a
		},
		ref: [t, s],
		props: [{
			style: d,
			"aria-hidden": !0
		}, i],
		stateAttributesMapping: ma
	});
});
process.env.NODE_ENV !== "production" && (Ob.displayName = "TooltipArrow");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/tooltip.module.js
var kb = {
	"prism-tooltip__popup": "_prism-tooltip__popup_1odsj_1",
	"prism-tooltip__arrow": "_prism-tooltip__arrow_1odsj_38"
};
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/tooltip/content.js
function Ab(e) {
	let t = (0, x.c)(6), { children: n, side: r } = e, i = r === void 0 ? "top" : r, a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ (0, C.jsx)(Ob, { className: kb["prism-tooltip__arrow"] }), t[0] = a) : a = t[0];
	let o;
	t[1] === n ? o = t[2] : (o = /* @__PURE__ */ (0, C.jsxs)(Db, {
		className: kb["prism-tooltip__popup"],
		role: "tooltip",
		children: [n, a]
	}), t[1] = n, t[2] = o);
	let s;
	return t[3] !== i || t[4] !== o ? (s = /* @__PURE__ */ (0, C.jsx)(Sb, { children: /* @__PURE__ */ (0, C.jsx)(Tb, {
		side: i,
		sideOffset: 8,
		children: o
	}) }), t[3] = i, t[4] = o, t[5] = s) : s = t[5], s;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/components/FloatingDelayGroup.js
var jb = /* @__PURE__ */ S.createContext({
	hasProvider: !1,
	timeoutMs: 0,
	delayRef: { current: 0 },
	initialDelayRef: { current: 0 },
	timeout: new yt(),
	currentIdRef: { current: null },
	currentContextRef: { current: null }
});
process.env.NODE_ENV !== "production" && (jb.displayName = "FloatingDelayGroupContext");
function Mb(e, t = { open: !1 }) {
	let n = "rootStore" in e ? e.rootStore : e, r = n.useState("floatingId"), { open: i } = t, { currentIdRef: a, delayRef: o, timeoutMs: s, initialDelayRef: c, currentContextRef: l, hasProvider: u, timeout: d } = S.useContext(jb), [f, p] = S.useState(!1);
	return W(() => {
		function e() {
			p(!1), l.current?.setIsInstantPhase(!1), a.current = null, l.current = null, o.current = c.current;
		}
		if (a.current && !i && a.current === r) {
			if (p(!1), s) {
				let t = r;
				return d.start(s, () => {
					n.select("open") || a.current && a.current !== t || e();
				}), () => {
					d.clear();
				};
			}
			e();
		}
	}, [
		i,
		r,
		a,
		o,
		s,
		c,
		l,
		d,
		n
	]), W(() => {
		if (!i) return;
		let e = l.current, t = a.current;
		d.clear(), l.current = {
			onOpenChange: n.setOpen,
			setIsInstantPhase: p
		}, a.current = r, o.current = {
			open: 0,
			close: pm(c.current, "close")
		}, t !== null && t !== r ? (p(!0), e?.setIsInstantPhase(!0), e?.onOpenChange(!1, K(Qt))) : (p(!1), e?.setIsInstantPhase(!1));
	}, [
		i,
		r,
		n,
		a,
		o,
		s,
		c,
		l,
		d
	]), W(() => () => {
		l.current = null;
	}, [l]), S.useMemo(() => ({
		hasProvider: u,
		delayRef: o,
		isInstantPhase: f
	}), [
		u,
		o,
		f
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useFocus.js
var Nb = ut && ct;
function Pb(e, t = {}) {
	let n = "rootStore" in e ? e.rootStore : e, { events: r, dataRef: i } = n.context, { enabled: a = !0, delay: o } = t, s = S.useRef(!1), c = S.useRef(null), l = bt(), u = S.useRef(!0);
	S.useEffect(() => {
		let e = n.select("domReferenceElement");
		if (!a) return;
		let t = Me(e);
		function r() {
			let e = n.select("domReferenceElement");
			!n.select("open") && Ie(e) && e === Ut(ht(e)) && (s.current = !0);
		}
		function i() {
			u.current = !0;
		}
		function o() {
			u.current = !1;
		}
		return t.addEventListener("blur", r), Nb && (t.addEventListener("keydown", i, !0), t.addEventListener("pointerdown", o, !0)), () => {
			t.removeEventListener("blur", r), Nb && (t.removeEventListener("keydown", i, !0), t.removeEventListener("pointerdown", o, !0));
		};
	}, [n, a]), S.useEffect(() => {
		if (!a) return;
		function e(e) {
			if (e.reason === "trigger-press" || e.reason === "escape-key") {
				let e = n.select("domReferenceElement");
				Fe(e) && (c.current = e, s.current = !0);
			}
		}
		return r.on("openchange", e), () => {
			r.off("openchange", e);
		};
	}, [
		r,
		a,
		n
	]);
	let d = S.useMemo(() => ({
		onMouseLeave() {
			s.current = !1, c.current = null;
		},
		onFocus(e) {
			let t = e.currentTarget;
			if (s.current) {
				if (c.current === t) return;
				s.current = !1, c.current = null;
			}
			let r = Gt(e.nativeEvent);
			if (Fe(r)) {
				if (Nb && !e.relatedTarget) {
					if (!u.current && !Jt(r)) return;
				} else if (!Xt(r)) return;
			}
			let i = Wt(e.relatedTarget, n.context.triggerElements), { nativeEvent: a, currentTarget: d } = e, f = typeof o == "function" ? o() : o;
			if (n.select("open") && i || f === 0 || f === void 0) {
				n.setOpen(!0, K(tn, a, d));
				return;
			}
			l.start(f, () => {
				s.current || n.setOpen(!0, K("trigger-focus", a, d));
			});
		},
		onBlur(e) {
			s.current = !1, c.current = null;
			let t = e.relatedTarget, r = e.nativeEvent, a = Fe(t) && t.hasAttribute(Dn("focus-guard")) && t.getAttribute("data-type") === "outside";
			l.start(0, () => {
				let e = n.select("domReferenceElement"), o = Ut(e ? e.ownerDocument : document);
				!t && o === e || G(i.current.floatingContext?.refs.floating.current, o) || G(e, o) || a || Wt(t ?? o, n.context.triggerElements) || n.setOpen(!1, K("trigger-focus", r));
			});
		}
	}), [
		i,
		n,
		l,
		o
	]);
	return S.useMemo(() => a ? {
		reference: d,
		trigger: d
	} : {}, [a, d]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tooltip/provider/TooltipProviderContext.js
var Fb = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Fb.displayName = "TooltipProviderContext");
function Ib() {
	return S.useContext(Fb);
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/node_modules/.pnpm/@base-ui_react@1.3.0_@types_react@19.2.14_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@base-ui/react/esm/tooltip/trigger/TooltipTriggerDataAttributes.js
var Lb = function(e) {
	return e[e.popupOpen = oa.popupOpen] = "popupOpen", e.triggerDisabled = "data-trigger-disabled", e;
}({}), Rb = Zr(function(e, t) {
	let { className: n, render: r, handle: i, payload: a, disabled: o, delay: s, closeOnClick: c = !0, closeDelay: l, id: u, ...d } = e, f = mb(!0), p = i?.store ?? f;
	if (!p) throw Error(process.env.NODE_ENV === "production" ? lr(82) : "Base UI: <Tooltip.Trigger> must be either used within a <Tooltip.Root> component or provided with a handle.");
	let m = Il(u), h = p.useState("isTriggerActive", m), g = p.useState("isOpenedByTrigger", m), _ = p.useState("floatingRootContext"), v = S.useRef(null), y = s ?? 600, b = l ?? 0, { registerTrigger: x, isMountedByThisTrigger: C } = ar(m, v, p, {
		payload: a,
		closeOnClick: c,
		closeDelay: b
	}), w = Ib(), { delayRef: T, isInstantPhase: E, hasProvider: D } = Mb(_, { open: g });
	p.useSyncedValue("isInstantPhase", E);
	let O = p.useState("disabled"), k = o ?? O, A = p.useState("trackCursorAxis"), j = p.useState("disableHoverablePopup"), M = Cm(_, {
		enabled: !k,
		mouseOnly: !0,
		move: !1,
		handleClose: !j && A !== "both" ? jm() : null,
		restMs() {
			let e = w?.delay, t = typeof T.current == "object" ? T.current.open : void 0, n = y;
			return D && (n = t === 0 ? 0 : s ?? e ?? y), n;
		},
		delay() {
			let e = typeof T.current == "object" ? T.current.close : void 0, t = b;
			return l == null && D && (t = e), { close: t };
		},
		triggerElementRef: v,
		isActiveTrigger: h
	}), N = Pb(_, { enabled: !k }).reference, P = { open: g }, F = p.useState("triggerProps", C);
	return Y("button", e, {
		state: P,
		ref: [
			t,
			x,
			v
		],
		props: [
			M,
			N,
			F,
			{
				onPointerDown() {
					p.set("closeOnClick", c);
				},
				id: m,
				[Lb.triggerDisabled]: k ? "" : void 0
			},
			d
		],
		stateAttributesMapping: fa
	});
});
process.env.NODE_ENV !== "production" && (Rb.displayName = "TooltipTrigger");
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/tooltip/trigger.js
function zb(e) {
	let t = (0, x.c)(2), { render: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)(Rb, {
		delay: 250,
		render: n
	}), t[0] = n, t[1] = r), r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-react@17.1.0_@date-fns+tz@1.5.0_@types+react@19.2.15_date-fns@4.4.0_c4cbe23c2de94ca33a7c31f02d30fa0b/node_modules/@mylighthouse/prism-react/dist/components/tooltip.js
function Bb(e) {
	let t = (0, x.c)(4), { children: n, onOpenChange: r, open: i } = e, a;
	return t[0] !== n || t[1] !== r || t[2] !== i ? (a = /* @__PURE__ */ (0, C.jsx)(vb, {
		onOpenChange: r,
		open: i,
		children: n
	}), t[0] = n, t[1] = r, t[2] = i, t[3] = a) : a = t[3], a;
}
Bb.Content = Ab, Bb.Trigger = zb;
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+fast-memoize@3.1.1/node_modules/@formatjs/fast-memoize/index.js
function Vb(e, t) {
	let n = t && t.cache ? t.cache : Zb, r = t && t.serializer ? t.serializer : Yb;
	return (t && t.strategy ? t.strategy : Kb)(e, {
		cache: n,
		serializer: r
	});
}
function Hb(e) {
	return e == null || typeof e == "number" || typeof e == "boolean";
}
function Ub(e, t, n, r) {
	let i = Hb(r) ? r : n(r), a = t.get(i);
	return a === void 0 && (a = e.call(this, r), t.set(i, a)), a;
}
function Wb(e, t, n) {
	let r = Array.prototype.slice.call(arguments, 3), i = n(r), a = t.get(i);
	return a === void 0 && (a = e.apply(this, r), t.set(i, a)), a;
}
function Gb(e, t, n, r, i) {
	return n.bind(t, e, r, i);
}
function Kb(e, t) {
	let n = e.length === 1 ? Ub : Wb;
	return Gb(e, this, n, t.cache.create(), t.serializer);
}
function qb(e, t) {
	return Gb(e, this, Wb, t.cache.create(), t.serializer);
}
function Jb(e, t) {
	return Gb(e, this, Ub, t.cache.create(), t.serializer);
}
var Yb = function() {
	return JSON.stringify(arguments);
}, Xb = class {
	cache;
	constructor() {
		this.cache = Object.create(null);
	}
	get(e) {
		return this.cache[e];
	}
	set(e, t) {
		this.cache[e] = t;
	}
}, Zb = { create: function() {
	return new Xb();
} }, Qb = {
	variadic: qb,
	monadic: Jb
}, $b = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function ex(e) {
	let t = {};
	return e.replace($b, (e) => {
		let n = e.length;
		switch (e[0]) {
			case "G":
				t.era = n === 4 ? "long" : n === 5 ? "narrow" : "short";
				break;
			case "y":
				t.year = n === 2 ? "2-digit" : "numeric";
				break;
			case "Y":
			case "u":
			case "U":
			case "r": throw RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
			case "q":
			case "Q": throw RangeError("`q/Q` (quarter) patterns are not supported");
			case "M":
			case "L":
				t.month = [
					"numeric",
					"2-digit",
					"short",
					"long",
					"narrow"
				][n - 1];
				break;
			case "w":
			case "W": throw RangeError("`w/W` (week) patterns are not supported");
			case "d":
				t.day = ["numeric", "2-digit"][n - 1];
				break;
			case "D":
			case "F":
			case "g": throw RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
			case "E":
				t.weekday = n === 4 ? "long" : n === 5 ? "narrow" : "short";
				break;
			case "e":
				if (n < 4) throw RangeError("`e..eee` (weekday) patterns are not supported");
				t.weekday = [
					"short",
					"long",
					"narrow",
					"short"
				][n - 4];
				break;
			case "c":
				if (n < 4) throw RangeError("`c..ccc` (weekday) patterns are not supported");
				t.weekday = [
					"short",
					"long",
					"narrow",
					"short"
				][n - 4];
				break;
			case "a":
				t.hour12 = !0;
				break;
			case "b":
			case "B": throw RangeError("`b/B` (period) patterns are not supported, use `a` instead");
			case "h":
				t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][n - 1];
				break;
			case "H":
				t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][n - 1];
				break;
			case "K":
				t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][n - 1];
				break;
			case "k":
				t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][n - 1];
				break;
			case "j":
			case "J":
			case "C": throw RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
			case "m":
				t.minute = ["numeric", "2-digit"][n - 1];
				break;
			case "s":
				t.second = ["numeric", "2-digit"][n - 1];
				break;
			case "S":
			case "A": throw RangeError("`S/A` (second) patterns are not supported, use `s` instead");
			case "z":
				t.timeZoneName = n < 4 ? "short" : "long";
				break;
			case "Z":
			case "O":
			case "v":
			case "V":
			case "X":
			case "x": throw RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
		}
		return "";
	}), t;
}
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+icu-skeleton-parser@2.1.3/node_modules/@formatjs/icu-skeleton-parser/regex.generated.js
var tx = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+icu-skeleton-parser@2.1.3/node_modules/@formatjs/icu-skeleton-parser/number.js
function nx(e) {
	if (e.length === 0) throw Error("Number skeleton cannot be empty");
	let t = e.split(tx).filter((e) => e.length > 0), n = [];
	for (let e of t) {
		let t = e.split("/");
		if (t.length === 0) throw Error("Invalid number skeleton");
		let [r, ...i] = t;
		for (let e of i) if (e.length === 0) throw Error("Invalid number skeleton");
		n.push({
			stem: r,
			options: i
		});
	}
	return n;
}
function rx(e) {
	return e.replace(/^(.*?)-/, "");
}
var ix = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, ax = /^(@+)?(\+|#+)?[rs]?$/g, ox = /(\*)(0+)|(#+)(0+)|(0+)/g, sx = /^(0+)$/;
function cx(e) {
	let t = {};
	return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(ax, function(e, n, r) {
		return typeof r == "string" ? r === "+" ? t.minimumSignificantDigits = n.length : n[0] === "#" ? t.maximumSignificantDigits = n.length : (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length + (typeof r == "string" ? r.length : 0)) : (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length), "";
	}), t;
}
function lx(e) {
	switch (e) {
		case "sign-auto": return { signDisplay: "auto" };
		case "sign-accounting":
		case "()": return { currencySign: "accounting" };
		case "sign-always":
		case "+!": return { signDisplay: "always" };
		case "sign-accounting-always":
		case "()!": return {
			signDisplay: "always",
			currencySign: "accounting"
		};
		case "sign-except-zero":
		case "+?": return { signDisplay: "exceptZero" };
		case "sign-accounting-except-zero":
		case "()?": return {
			signDisplay: "exceptZero",
			currencySign: "accounting"
		};
		case "sign-never":
		case "+_": return { signDisplay: "never" };
	}
}
function ux(e) {
	let t;
	if (e[0] === "E" && e[1] === "E" ? (t = { notation: "engineering" }, e = e.slice(2)) : e[0] === "E" && (t = { notation: "scientific" }, e = e.slice(1)), t) {
		let n = e.slice(0, 2);
		if (n === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : n === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !sx.test(e)) throw Error("Malformed concise eng/scientific notation");
		t.minimumIntegerDigits = e.length;
	}
	return t;
}
function dx(e) {
	return lx(e) || {};
}
function fx(e) {
	let t = {};
	for (let n of e) {
		switch (n.stem) {
			case "percent":
			case "%":
				t.style = "percent";
				continue;
			case "%x100":
				t.style = "percent", t.scale = 100;
				continue;
			case "currency":
				t.style = "currency", t.currency = n.options[0];
				continue;
			case "group-off":
			case ",_":
				t.useGrouping = !1;
				continue;
			case "precision-integer":
			case ".":
				t.maximumFractionDigits = 0;
				continue;
			case "measure-unit":
			case "unit":
				t.style = "unit", t.unit = rx(n.options[0]);
				continue;
			case "compact-short":
			case "K":
				t.notation = "compact", t.compactDisplay = "short";
				continue;
			case "compact-long":
			case "KK":
				t.notation = "compact", t.compactDisplay = "long";
				continue;
			case "scientific":
				t = {
					...t,
					notation: "scientific",
					...n.options.reduce((e, t) => ({
						...e,
						...dx(t)
					}), {})
				};
				continue;
			case "engineering":
				t = {
					...t,
					notation: "engineering",
					...n.options.reduce((e, t) => ({
						...e,
						...dx(t)
					}), {})
				};
				continue;
			case "notation-simple":
				t.notation = "standard";
				continue;
			case "unit-width-narrow":
				t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
				continue;
			case "unit-width-short":
				t.currencyDisplay = "code", t.unitDisplay = "short";
				continue;
			case "unit-width-full-name":
				t.currencyDisplay = "name", t.unitDisplay = "long";
				continue;
			case "unit-width-iso-code":
				t.currencyDisplay = "symbol";
				continue;
			case "scale":
				t.scale = parseFloat(n.options[0]);
				continue;
			case "rounding-mode-floor":
				t.roundingMode = "floor";
				continue;
			case "rounding-mode-ceiling":
				t.roundingMode = "ceil";
				continue;
			case "rounding-mode-down":
				t.roundingMode = "trunc";
				continue;
			case "rounding-mode-up":
				t.roundingMode = "expand";
				continue;
			case "rounding-mode-half-even":
				t.roundingMode = "halfEven";
				continue;
			case "rounding-mode-half-down":
				t.roundingMode = "halfTrunc";
				continue;
			case "rounding-mode-half-up":
				t.roundingMode = "halfExpand";
				continue;
			case "integer-width":
				if (n.options.length > 1) throw RangeError("integer-width stems only accept a single optional option");
				n.options[0].replace(ox, function(e, n, r, i, a, o) {
					if (n) t.minimumIntegerDigits = r.length;
					else if (i && a) throw Error("We currently do not support maximum integer digits");
					else if (o) throw Error("We currently do not support exact integer digits");
					return "";
				});
				continue;
		}
		if (sx.test(n.stem)) {
			t.minimumIntegerDigits = n.stem.length;
			continue;
		}
		if (ix.test(n.stem)) {
			if (n.options.length > 1) throw RangeError("Fraction-precision stems only accept a single optional option");
			n.stem.replace(ix, function(e, n, r, i, a, o) {
				return r === "*" ? t.minimumFractionDigits = n.length : i && i[0] === "#" ? t.maximumFractionDigits = i.length : a && o ? (t.minimumFractionDigits = a.length, t.maximumFractionDigits = a.length + o.length) : (t.minimumFractionDigits = n.length, t.maximumFractionDigits = n.length), "";
			});
			let e = n.options[0];
			e === "w" ? t = {
				...t,
				trailingZeroDisplay: "stripIfInteger"
			} : e && (t = {
				...t,
				...cx(e)
			});
			continue;
		}
		if (ax.test(n.stem)) {
			t = {
				...t,
				...cx(n.stem)
			};
			continue;
		}
		let e = lx(n.stem);
		e && (t = {
			...t,
			...e
		});
		let r = ux(n.stem);
		r && (t = {
			...t,
			...r
		});
	}
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+icu-messageformat-parser@3.5.3/node_modules/@formatjs/icu-messageformat-parser/types.js
var px = /* @__PURE__ */ function(e) {
	return e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag", e;
}({}), mx = /* @__PURE__ */ function(e) {
	return e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime", e;
}({});
function hx(e) {
	return e.type === px.literal;
}
function gx(e) {
	return e.type === px.argument;
}
function _x(e) {
	return e.type === px.number;
}
function vx(e) {
	return e.type === px.date;
}
function yx(e) {
	return e.type === px.time;
}
function bx(e) {
	return e.type === px.select;
}
function xx(e) {
	return e.type === px.plural;
}
function Sx(e) {
	return e.type === px.pound;
}
function Cx(e) {
	return e.type === px.tag;
}
function wx(e) {
	return !!(e && typeof e == "object" && e.type === mx.number);
}
function Tx(e) {
	return !!(e && typeof e == "object" && e.type === mx.dateTime);
}
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+icu-messageformat-parser@3.5.3/node_modules/@formatjs/icu-messageformat-parser/error.js
var Ex = /* @__PURE__ */ function(e) {
	return e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG", e;
}({}), Dx = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, Ox = {
	"001": ["H", "h"],
	419: [
		"h",
		"H",
		"hB",
		"hb"
	],
	AC: [
		"H",
		"h",
		"hb",
		"hB"
	],
	AD: ["H", "hB"],
	AE: [
		"h",
		"hB",
		"hb",
		"H"
	],
	AF: [
		"H",
		"hb",
		"hB",
		"h"
	],
	AG: [
		"h",
		"hb",
		"H",
		"hB"
	],
	AI: [
		"H",
		"h",
		"hb",
		"hB"
	],
	AL: [
		"h",
		"H",
		"hB"
	],
	AM: ["H", "hB"],
	AO: ["H", "hB"],
	AR: [
		"h",
		"H",
		"hB",
		"hb"
	],
	AS: ["h", "H"],
	AT: ["H", "hB"],
	AU: [
		"h",
		"hb",
		"H",
		"hB"
	],
	AW: ["H", "hB"],
	AX: ["H"],
	AZ: [
		"H",
		"hB",
		"h"
	],
	BA: [
		"H",
		"hB",
		"h"
	],
	BB: [
		"h",
		"hb",
		"H",
		"hB"
	],
	BD: [
		"h",
		"hB",
		"H"
	],
	BE: ["H", "hB"],
	BF: ["H", "hB"],
	BG: [
		"H",
		"hB",
		"h"
	],
	BH: [
		"h",
		"hB",
		"hb",
		"H"
	],
	BI: ["H", "h"],
	BJ: ["H", "hB"],
	BL: ["H", "hB"],
	BM: [
		"h",
		"hb",
		"H",
		"hB"
	],
	BN: [
		"hb",
		"hB",
		"h",
		"H"
	],
	BO: [
		"h",
		"H",
		"hB",
		"hb"
	],
	BQ: ["H"],
	BR: ["H", "hB"],
	BS: [
		"h",
		"hb",
		"H",
		"hB"
	],
	BT: ["h", "H"],
	BW: [
		"H",
		"h",
		"hb",
		"hB"
	],
	BY: ["H", "h"],
	BZ: [
		"H",
		"h",
		"hb",
		"hB"
	],
	CA: [
		"h",
		"hb",
		"H",
		"hB"
	],
	CC: [
		"H",
		"h",
		"hb",
		"hB"
	],
	CD: ["hB", "H"],
	CF: [
		"H",
		"h",
		"hB"
	],
	CG: ["H", "hB"],
	CH: [
		"H",
		"hB",
		"h"
	],
	CI: ["H", "hB"],
	CK: [
		"H",
		"h",
		"hb",
		"hB"
	],
	CL: [
		"h",
		"H",
		"hB",
		"hb"
	],
	CM: [
		"H",
		"h",
		"hB"
	],
	CN: [
		"H",
		"hB",
		"hb",
		"h"
	],
	CO: [
		"h",
		"H",
		"hB",
		"hb"
	],
	CP: ["H"],
	CR: [
		"h",
		"H",
		"hB",
		"hb"
	],
	CU: [
		"h",
		"H",
		"hB",
		"hb"
	],
	CV: ["H", "hB"],
	CW: ["H", "hB"],
	CX: [
		"H",
		"h",
		"hb",
		"hB"
	],
	CY: [
		"h",
		"H",
		"hb",
		"hB"
	],
	CZ: ["H"],
	DE: ["H", "hB"],
	DG: [
		"H",
		"h",
		"hb",
		"hB"
	],
	DJ: ["h", "H"],
	DK: ["H"],
	DM: [
		"h",
		"hb",
		"H",
		"hB"
	],
	DO: [
		"h",
		"H",
		"hB",
		"hb"
	],
	DZ: [
		"h",
		"hB",
		"hb",
		"H"
	],
	EA: [
		"H",
		"h",
		"hB",
		"hb"
	],
	EC: [
		"h",
		"H",
		"hB",
		"hb"
	],
	EE: ["H", "hB"],
	EG: [
		"h",
		"hB",
		"hb",
		"H"
	],
	EH: [
		"h",
		"hB",
		"hb",
		"H"
	],
	ER: ["h", "H"],
	ES: [
		"H",
		"hB",
		"h",
		"hb"
	],
	ET: [
		"hB",
		"hb",
		"h",
		"H"
	],
	FI: ["H"],
	FJ: [
		"h",
		"hb",
		"H",
		"hB"
	],
	FK: [
		"H",
		"h",
		"hb",
		"hB"
	],
	FM: [
		"h",
		"hb",
		"H",
		"hB"
	],
	FO: ["H", "h"],
	FR: ["H", "hB"],
	GA: ["H", "hB"],
	GB: [
		"H",
		"h",
		"hb",
		"hB"
	],
	GD: [
		"h",
		"hb",
		"H",
		"hB"
	],
	GE: [
		"H",
		"hB",
		"h"
	],
	GF: ["H", "hB"],
	GG: [
		"H",
		"h",
		"hb",
		"hB"
	],
	GH: ["h", "H"],
	GI: [
		"H",
		"h",
		"hb",
		"hB"
	],
	GL: ["H", "h"],
	GM: [
		"h",
		"hb",
		"H",
		"hB"
	],
	GN: ["H", "hB"],
	GP: ["H", "hB"],
	GQ: [
		"H",
		"hB",
		"h",
		"hb"
	],
	GR: [
		"h",
		"H",
		"hb",
		"hB"
	],
	GS: [
		"H",
		"h",
		"hb",
		"hB"
	],
	GT: [
		"h",
		"H",
		"hB",
		"hb"
	],
	GU: [
		"h",
		"hb",
		"H",
		"hB"
	],
	GW: ["H", "hB"],
	GY: [
		"h",
		"hb",
		"H",
		"hB"
	],
	HK: [
		"h",
		"hB",
		"hb",
		"H"
	],
	HN: [
		"h",
		"H",
		"hB",
		"hb"
	],
	HR: ["H", "hB"],
	HU: ["H", "h"],
	IC: [
		"H",
		"h",
		"hB",
		"hb"
	],
	ID: ["H"],
	IE: [
		"H",
		"h",
		"hb",
		"hB"
	],
	IL: ["H", "hB"],
	IM: [
		"H",
		"h",
		"hb",
		"hB"
	],
	IN: ["h", "H"],
	IO: [
		"H",
		"h",
		"hb",
		"hB"
	],
	IQ: [
		"h",
		"hB",
		"hb",
		"H"
	],
	IR: ["hB", "H"],
	IS: ["H"],
	IT: ["H", "hB"],
	JE: [
		"H",
		"h",
		"hb",
		"hB"
	],
	JM: [
		"h",
		"hb",
		"H",
		"hB"
	],
	JO: [
		"h",
		"hB",
		"hb",
		"H"
	],
	JP: [
		"H",
		"K",
		"h"
	],
	KE: [
		"hB",
		"hb",
		"H",
		"h"
	],
	KG: [
		"H",
		"h",
		"hB",
		"hb"
	],
	KH: [
		"hB",
		"h",
		"H",
		"hb"
	],
	KI: [
		"h",
		"hb",
		"H",
		"hB"
	],
	KM: [
		"H",
		"h",
		"hB",
		"hb"
	],
	KN: [
		"h",
		"hb",
		"H",
		"hB"
	],
	KP: [
		"h",
		"H",
		"hB",
		"hb"
	],
	KR: [
		"h",
		"H",
		"hB",
		"hb"
	],
	KW: [
		"h",
		"hB",
		"hb",
		"H"
	],
	KY: [
		"h",
		"hb",
		"H",
		"hB"
	],
	KZ: ["H", "hB"],
	LA: [
		"H",
		"hb",
		"hB",
		"h"
	],
	LB: [
		"h",
		"hB",
		"hb",
		"H"
	],
	LC: [
		"h",
		"hb",
		"H",
		"hB"
	],
	LI: [
		"H",
		"hB",
		"h"
	],
	LK: [
		"H",
		"h",
		"hB",
		"hb"
	],
	LR: [
		"h",
		"hb",
		"H",
		"hB"
	],
	LS: ["h", "H"],
	LT: [
		"H",
		"h",
		"hb",
		"hB"
	],
	LU: [
		"H",
		"h",
		"hB"
	],
	LV: [
		"H",
		"hB",
		"hb",
		"h"
	],
	LY: [
		"h",
		"hB",
		"hb",
		"H"
	],
	MA: [
		"H",
		"h",
		"hB",
		"hb"
	],
	MC: ["H", "hB"],
	MD: ["H", "hB"],
	ME: [
		"H",
		"hB",
		"h"
	],
	MF: ["H", "hB"],
	MG: ["H", "h"],
	MH: [
		"h",
		"hb",
		"H",
		"hB"
	],
	MK: [
		"H",
		"h",
		"hb",
		"hB"
	],
	ML: ["H"],
	MM: [
		"hB",
		"hb",
		"H",
		"h"
	],
	MN: [
		"H",
		"h",
		"hb",
		"hB"
	],
	MO: [
		"h",
		"hB",
		"hb",
		"H"
	],
	MP: [
		"h",
		"hb",
		"H",
		"hB"
	],
	MQ: ["H", "hB"],
	MR: [
		"h",
		"hB",
		"hb",
		"H"
	],
	MS: [
		"H",
		"h",
		"hb",
		"hB"
	],
	MT: ["H", "h"],
	MU: ["H", "h"],
	MV: ["H", "h"],
	MW: [
		"h",
		"hb",
		"H",
		"hB"
	],
	MX: [
		"h",
		"H",
		"hB",
		"hb"
	],
	MY: [
		"hb",
		"hB",
		"h",
		"H"
	],
	MZ: ["H", "hB"],
	NA: [
		"h",
		"H",
		"hB",
		"hb"
	],
	NC: ["H", "hB"],
	NE: ["H"],
	NF: [
		"H",
		"h",
		"hb",
		"hB"
	],
	NG: [
		"H",
		"h",
		"hb",
		"hB"
	],
	NI: [
		"h",
		"H",
		"hB",
		"hb"
	],
	NL: ["H", "hB"],
	NO: ["H", "h"],
	NP: [
		"H",
		"h",
		"hB"
	],
	NR: [
		"H",
		"h",
		"hb",
		"hB"
	],
	NU: [
		"H",
		"h",
		"hb",
		"hB"
	],
	NZ: [
		"h",
		"hb",
		"H",
		"hB"
	],
	OM: [
		"h",
		"hB",
		"hb",
		"H"
	],
	PA: [
		"h",
		"H",
		"hB",
		"hb"
	],
	PE: [
		"h",
		"H",
		"hB",
		"hb"
	],
	PF: [
		"H",
		"h",
		"hB"
	],
	PG: ["h", "H"],
	PH: [
		"h",
		"hB",
		"hb",
		"H"
	],
	PK: [
		"h",
		"hB",
		"H"
	],
	PL: ["H", "h"],
	PM: ["H", "hB"],
	PN: [
		"H",
		"h",
		"hb",
		"hB"
	],
	PR: [
		"h",
		"H",
		"hB",
		"hb"
	],
	PS: [
		"h",
		"hB",
		"hb",
		"H"
	],
	PT: ["H", "hB"],
	PW: ["h", "H"],
	PY: [
		"h",
		"H",
		"hB",
		"hb"
	],
	QA: [
		"h",
		"hB",
		"hb",
		"H"
	],
	RE: ["H", "hB"],
	RO: ["H", "hB"],
	RS: [
		"H",
		"hB",
		"h"
	],
	RU: ["H"],
	RW: ["H", "h"],
	SA: [
		"h",
		"hB",
		"hb",
		"H"
	],
	SB: [
		"h",
		"hb",
		"H",
		"hB"
	],
	SC: [
		"H",
		"h",
		"hB"
	],
	SD: [
		"h",
		"hB",
		"hb",
		"H"
	],
	SE: ["H"],
	SG: [
		"h",
		"hb",
		"H",
		"hB"
	],
	SH: [
		"H",
		"h",
		"hb",
		"hB"
	],
	SI: ["H", "hB"],
	SJ: ["H"],
	SK: ["H"],
	SL: [
		"h",
		"hb",
		"H",
		"hB"
	],
	SM: [
		"H",
		"h",
		"hB"
	],
	SN: [
		"H",
		"h",
		"hB"
	],
	SO: ["h", "H"],
	SR: ["H", "hB"],
	SS: [
		"h",
		"hb",
		"H",
		"hB"
	],
	ST: ["H", "hB"],
	SV: [
		"h",
		"H",
		"hB",
		"hb"
	],
	SX: [
		"H",
		"h",
		"hb",
		"hB"
	],
	SY: [
		"h",
		"hB",
		"hb",
		"H"
	],
	SZ: [
		"h",
		"hb",
		"H",
		"hB"
	],
	TA: [
		"H",
		"h",
		"hb",
		"hB"
	],
	TC: [
		"h",
		"hb",
		"H",
		"hB"
	],
	TD: [
		"h",
		"H",
		"hB"
	],
	TF: [
		"H",
		"h",
		"hB"
	],
	TG: ["H", "hB"],
	TH: ["H", "h"],
	TJ: ["H", "h"],
	TL: [
		"H",
		"hB",
		"hb",
		"h"
	],
	TM: ["H", "h"],
	TN: [
		"h",
		"hB",
		"hb",
		"H"
	],
	TO: ["h", "H"],
	TR: ["H", "hB"],
	TT: [
		"h",
		"hb",
		"H",
		"hB"
	],
	TW: [
		"hB",
		"hb",
		"h",
		"H"
	],
	TZ: [
		"hB",
		"hb",
		"H",
		"h"
	],
	UA: [
		"H",
		"hB",
		"h"
	],
	UG: [
		"hB",
		"hb",
		"H",
		"h"
	],
	UM: [
		"h",
		"hb",
		"H",
		"hB"
	],
	US: [
		"h",
		"hb",
		"H",
		"hB"
	],
	UY: [
		"h",
		"H",
		"hB",
		"hb"
	],
	UZ: [
		"H",
		"hB",
		"h"
	],
	VA: [
		"H",
		"h",
		"hB"
	],
	VC: [
		"h",
		"hb",
		"H",
		"hB"
	],
	VE: [
		"h",
		"H",
		"hB",
		"hb"
	],
	VG: [
		"h",
		"hb",
		"H",
		"hB"
	],
	VI: [
		"h",
		"hb",
		"H",
		"hB"
	],
	VN: ["H", "h"],
	VU: ["h", "H"],
	WF: ["H", "hB"],
	WS: ["h", "H"],
	XK: [
		"H",
		"hB",
		"h"
	],
	YE: [
		"h",
		"hB",
		"hb",
		"H"
	],
	YT: ["H", "hB"],
	ZA: [
		"H",
		"h",
		"hb",
		"hB"
	],
	ZM: [
		"h",
		"hb",
		"H",
		"hB"
	],
	ZW: ["H", "h"],
	"af-ZA": [
		"H",
		"h",
		"hB",
		"hb"
	],
	"ar-001": [
		"h",
		"hB",
		"hb",
		"H"
	],
	"ca-ES": [
		"H",
		"h",
		"hB"
	],
	"en-001": [
		"h",
		"hb",
		"H",
		"hB"
	],
	"en-HK": [
		"h",
		"hb",
		"H",
		"hB"
	],
	"en-IL": [
		"H",
		"h",
		"hb",
		"hB"
	],
	"en-MY": [
		"h",
		"hb",
		"H",
		"hB"
	],
	"es-BR": [
		"H",
		"h",
		"hB",
		"hb"
	],
	"es-ES": [
		"H",
		"h",
		"hB",
		"hb"
	],
	"es-GQ": [
		"H",
		"h",
		"hB",
		"hb"
	],
	"fr-CA": [
		"H",
		"h",
		"hB"
	],
	"gl-ES": [
		"H",
		"h",
		"hB"
	],
	"gu-IN": [
		"hB",
		"hb",
		"h",
		"H"
	],
	"hi-IN": [
		"hB",
		"h",
		"H"
	],
	"it-CH": [
		"H",
		"h",
		"hB"
	],
	"it-IT": [
		"H",
		"h",
		"hB"
	],
	"kn-IN": [
		"hB",
		"h",
		"H"
	],
	"ku-SY": ["H", "hB"],
	"ml-IN": [
		"hB",
		"h",
		"H"
	],
	"mr-IN": [
		"hB",
		"hb",
		"h",
		"H"
	],
	"pa-IN": [
		"hB",
		"hb",
		"h",
		"H"
	],
	"ta-IN": [
		"hB",
		"h",
		"hb",
		"H"
	],
	"te-IN": [
		"hB",
		"h",
		"H"
	],
	"zu-ZA": [
		"H",
		"hB",
		"hb",
		"h"
	]
};
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+icu-messageformat-parser@3.5.3/node_modules/@formatjs/icu-messageformat-parser/date-time-pattern-generator.js
function kx(e, t) {
	let n = "";
	for (let r = 0; r < e.length; r++) {
		let i = e.charAt(r);
		if (i === "j") {
			let a = 0;
			for (; r + 1 < e.length && e.charAt(r + 1) === i;) a++, r++;
			let o = 1 + (a & 1), s = a < 2 ? 1 : 3 + (a >> 1), c = Ax(t);
			for ((c == "H" || c == "k") && (s = 0); s-- > 0;) n += "a";
			for (; o-- > 0;) n = c + n;
		} else i === "J" ? n += "H" : n += i;
	}
	return n;
}
function Ax(e) {
	let t = e.hourCycle;
	if (t === void 0 && e.hourCycles && e.hourCycles.length && (t = e.hourCycles[0]), t) switch (t) {
		case "h24": return "k";
		case "h23": return "H";
		case "h12": return "h";
		case "h11": return "K";
		default: throw Error("Invalid hourCycle");
	}
	let n = e.language, r;
	return n !== "root" && (r = e.maximize().region), (Ox[r || ""] || Ox[n || ""] || Ox[`${n}-001`] || Ox["001"])[0];
}
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+icu-messageformat-parser@3.5.3/node_modules/@formatjs/icu-messageformat-parser/parser.js
var jx = RegExp(`^${Dx.source}*`), Mx = RegExp(`${Dx.source}*$`);
function Nx(e, t) {
	return {
		start: e,
		end: t
	};
}
var Px = !!Object.fromEntries, Fx = !!String.prototype.trimStart, Ix = !!String.prototype.trimEnd, Lx = Px ? Object.fromEntries : function(e) {
	let t = {};
	for (let [n, r] of e) t[n] = r;
	return t;
}, Rx = Fx ? function(e) {
	return e.trimStart();
} : function(e) {
	return e.replace(jx, "");
}, zx = Ix ? function(e) {
	return e.trimEnd();
} : function(e) {
	return e.replace(Mx, "");
}, Bx = /* @__PURE__ */ RegExp("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
function Vx(e, t) {
	return Bx.lastIndex = t, Bx.exec(e)[1] ?? "";
}
var Hx = class {
	message;
	position;
	locale;
	ignoreTag;
	requiresOtherClause;
	shouldParseSkeletons;
	constructor(e, t = {}) {
		this.message = e, this.position = {
			offset: 0,
			line: 1,
			column: 1
		}, this.ignoreTag = !!t.ignoreTag, this.locale = t.locale, this.requiresOtherClause = !!t.requiresOtherClause, this.shouldParseSkeletons = !!t.shouldParseSkeletons;
	}
	parse() {
		if (this.offset() !== 0) throw Error("parser can only be used once");
		return this.parseMessage(0, "", !1);
	}
	parseMessage(e, t, n) {
		let r = [];
		for (; !this.isEOF();) {
			let i = this.char();
			if (i === 123) {
				let t = this.parseArgument(e, n);
				if (t.err) return t;
				r.push(t.val);
			} else if (i === 125 && e > 0) break;
			else if (i === 35 && (t === "plural" || t === "selectordinal")) {
				let e = this.clonePosition();
				this.bump(), r.push({
					type: px.pound,
					location: Nx(e, this.clonePosition())
				});
			} else if (i === 60 && !this.ignoreTag && this.peek() === 47) {
				if (n) break;
				return this.error(Ex.UNMATCHED_CLOSING_TAG, Nx(this.clonePosition(), this.clonePosition()));
			} else if (i === 60 && !this.ignoreTag && Ux(this.peek() || 0)) {
				let n = this.parseTag(e, t);
				if (n.err) return n;
				r.push(n.val);
			} else {
				let n = this.parseLiteral(e, t);
				if (n.err) return n;
				r.push(n.val);
			}
		}
		return {
			val: r,
			err: null
		};
	}
	parseTag(e, t) {
		let n = this.clonePosition();
		this.bump();
		let r = this.parseTagName();
		if (this.bumpSpace(), this.bumpIf("/>")) return {
			val: {
				type: px.literal,
				value: `<${r}/>`,
				location: Nx(n, this.clonePosition())
			},
			err: null
		};
		if (this.bumpIf(">")) {
			let i = this.parseMessage(e + 1, t, !0);
			if (i.err) return i;
			let a = i.val, o = this.clonePosition();
			if (this.bumpIf("</")) {
				if (this.isEOF() || !Ux(this.char())) return this.error(Ex.INVALID_TAG, Nx(o, this.clonePosition()));
				let e = this.clonePosition();
				return r === this.parseTagName() ? (this.bumpSpace(), this.bumpIf(">") ? {
					val: {
						type: px.tag,
						value: r,
						children: a,
						location: Nx(n, this.clonePosition())
					},
					err: null
				} : this.error(Ex.INVALID_TAG, Nx(o, this.clonePosition()))) : this.error(Ex.UNMATCHED_CLOSING_TAG, Nx(e, this.clonePosition()));
			} else return this.error(Ex.UNCLOSED_TAG, Nx(n, this.clonePosition()));
		} else return this.error(Ex.INVALID_TAG, Nx(n, this.clonePosition()));
	}
	parseTagName() {
		let e = this.offset();
		for (this.bump(); !this.isEOF() && Gx(this.char());) this.bump();
		return this.message.slice(e, this.offset());
	}
	parseLiteral(e, t) {
		let n = this.clonePosition(), r = "";
		for (;;) {
			let n = this.tryParseQuote(t);
			if (n) {
				r += n;
				continue;
			}
			let i = this.tryParseUnquoted(e, t);
			if (i) {
				r += i;
				continue;
			}
			let a = this.tryParseLeftAngleBracket();
			if (a) {
				r += a;
				continue;
			}
			break;
		}
		let i = Nx(n, this.clonePosition());
		return {
			val: {
				type: px.literal,
				value: r,
				location: i
			},
			err: null
		};
	}
	tryParseLeftAngleBracket() {
		return !this.isEOF() && this.char() === 60 && (this.ignoreTag || !Wx(this.peek() || 0)) ? (this.bump(), "<") : null;
	}
	tryParseQuote(e) {
		if (this.isEOF() || this.char() !== 39) return null;
		switch (this.peek()) {
			case 39: return this.bump(), this.bump(), "'";
			case 123:
			case 60:
			case 62:
			case 125: break;
			case 35:
				if (e === "plural" || e === "selectordinal") break;
				return null;
			default: return null;
		}
		this.bump();
		let t = [this.char()];
		for (this.bump(); !this.isEOF();) {
			let e = this.char();
			if (e === 39) if (this.peek() === 39) t.push(39), this.bump();
			else {
				this.bump();
				break;
			}
			else t.push(e);
			this.bump();
		}
		return String.fromCodePoint(...t);
	}
	tryParseUnquoted(e, t) {
		if (this.isEOF()) return null;
		let n = this.char();
		return n === 60 || n === 123 || n === 35 && (t === "plural" || t === "selectordinal") || n === 125 && e > 0 ? null : (this.bump(), String.fromCodePoint(n));
	}
	parseArgument(e, t) {
		let n = this.clonePosition();
		if (this.bump(), this.bumpSpace(), this.isEOF()) return this.error(Ex.EXPECT_ARGUMENT_CLOSING_BRACE, Nx(n, this.clonePosition()));
		if (this.char() === 125) return this.bump(), this.error(Ex.EMPTY_ARGUMENT, Nx(n, this.clonePosition()));
		let r = this.parseIdentifierIfPossible().value;
		if (!r) return this.error(Ex.MALFORMED_ARGUMENT, Nx(n, this.clonePosition()));
		if (this.bumpSpace(), this.isEOF()) return this.error(Ex.EXPECT_ARGUMENT_CLOSING_BRACE, Nx(n, this.clonePosition()));
		switch (this.char()) {
			case 125: return this.bump(), {
				val: {
					type: px.argument,
					value: r,
					location: Nx(n, this.clonePosition())
				},
				err: null
			};
			case 44: return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(Ex.EXPECT_ARGUMENT_CLOSING_BRACE, Nx(n, this.clonePosition())) : this.parseArgumentOptions(e, t, r, n);
			default: return this.error(Ex.MALFORMED_ARGUMENT, Nx(n, this.clonePosition()));
		}
	}
	parseIdentifierIfPossible() {
		let e = this.clonePosition(), t = this.offset(), n = Vx(this.message, t), r = t + n.length;
		return this.bumpTo(r), {
			value: n,
			location: Nx(e, this.clonePosition())
		};
	}
	parseArgumentOptions(e, t, n, r) {
		let i = this.clonePosition(), a = this.parseIdentifierIfPossible().value, o = this.clonePosition();
		switch (a) {
			case "": return this.error(Ex.EXPECT_ARGUMENT_TYPE, Nx(i, o));
			case "number":
			case "date":
			case "time": {
				this.bumpSpace();
				let e = null;
				if (this.bumpIf(",")) {
					this.bumpSpace();
					let t = this.clonePosition(), n = this.parseSimpleArgStyleIfPossible();
					if (n.err) return n;
					let r = zx(n.val);
					if (r.length === 0) return this.error(Ex.EXPECT_ARGUMENT_STYLE, Nx(this.clonePosition(), this.clonePosition()));
					e = {
						style: r,
						styleLocation: Nx(t, this.clonePosition())
					};
				}
				let t = this.tryParseArgumentClose(r);
				if (t.err) return t;
				let i = Nx(r, this.clonePosition());
				if (e && e.style.startsWith("::")) {
					let t = Rx(e.style.slice(2));
					if (a === "number") {
						let r = this.parseNumberSkeletonFromString(t, e.styleLocation);
						return r.err ? r : {
							val: {
								type: px.number,
								value: n,
								location: i,
								style: r.val
							},
							err: null
						};
					} else {
						if (t.length === 0) return this.error(Ex.EXPECT_DATE_TIME_SKELETON, i);
						let r = t;
						this.locale && (r = kx(t, this.locale));
						let o = {
							type: mx.dateTime,
							pattern: r,
							location: e.styleLocation,
							parsedOptions: this.shouldParseSkeletons ? ex(r) : {}
						};
						return {
							val: {
								type: a === "date" ? px.date : px.time,
								value: n,
								location: i,
								style: o
							},
							err: null
						};
					}
				}
				return {
					val: {
						type: a === "number" ? px.number : a === "date" ? px.date : px.time,
						value: n,
						location: i,
						style: e?.style ?? null
					},
					err: null
				};
			}
			case "plural":
			case "selectordinal":
			case "select": {
				let i = this.clonePosition();
				if (this.bumpSpace(), !this.bumpIf(",")) return this.error(Ex.EXPECT_SELECT_ARGUMENT_OPTIONS, Nx(i, { ...i }));
				this.bumpSpace();
				let o = this.parseIdentifierIfPossible(), s = 0;
				if (a !== "select" && o.value === "offset") {
					if (!this.bumpIf(":")) return this.error(Ex.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, Nx(this.clonePosition(), this.clonePosition()));
					this.bumpSpace();
					let e = this.tryParseDecimalInteger(Ex.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, Ex.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
					if (e.err) return e;
					this.bumpSpace(), o = this.parseIdentifierIfPossible(), s = e.val;
				}
				let c = this.tryParsePluralOrSelectOptions(e, a, t, o);
				if (c.err) return c;
				let l = this.tryParseArgumentClose(r);
				if (l.err) return l;
				let u = Nx(r, this.clonePosition());
				return a === "select" ? {
					val: {
						type: px.select,
						value: n,
						options: Lx(c.val),
						location: u
					},
					err: null
				} : {
					val: {
						type: px.plural,
						value: n,
						options: Lx(c.val),
						offset: s,
						pluralType: a === "plural" ? "cardinal" : "ordinal",
						location: u
					},
					err: null
				};
			}
			default: return this.error(Ex.INVALID_ARGUMENT_TYPE, Nx(i, o));
		}
	}
	tryParseArgumentClose(e) {
		return this.isEOF() || this.char() !== 125 ? this.error(Ex.EXPECT_ARGUMENT_CLOSING_BRACE, Nx(e, this.clonePosition())) : (this.bump(), {
			val: !0,
			err: null
		});
	}
	parseSimpleArgStyleIfPossible() {
		let e = 0, t = this.clonePosition();
		for (; !this.isEOF();) switch (this.char()) {
			case 39: {
				this.bump();
				let e = this.clonePosition();
				if (!this.bumpUntil("'")) return this.error(Ex.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, Nx(e, this.clonePosition()));
				this.bump();
				break;
			}
			case 123:
				e += 1, this.bump();
				break;
			case 125:
				if (e > 0) --e;
				else return {
					val: this.message.slice(t.offset, this.offset()),
					err: null
				};
				break;
			default:
				this.bump();
				break;
		}
		return {
			val: this.message.slice(t.offset, this.offset()),
			err: null
		};
	}
	parseNumberSkeletonFromString(e, t) {
		let n = [];
		try {
			n = nx(e);
		} catch {
			return this.error(Ex.INVALID_NUMBER_SKELETON, t);
		}
		return {
			val: {
				type: mx.number,
				tokens: n,
				location: t,
				parsedOptions: this.shouldParseSkeletons ? fx(n) : {}
			},
			err: null
		};
	}
	tryParsePluralOrSelectOptions(e, t, n, r) {
		let i = !1, a = [], o = /* @__PURE__ */ new Set(), { value: s, location: c } = r;
		for (;;) {
			if (s.length === 0) {
				let e = this.clonePosition();
				if (t !== "select" && this.bumpIf("=")) {
					let t = this.tryParseDecimalInteger(Ex.EXPECT_PLURAL_ARGUMENT_SELECTOR, Ex.INVALID_PLURAL_ARGUMENT_SELECTOR);
					if (t.err) return t;
					c = Nx(e, this.clonePosition()), s = this.message.slice(e.offset, this.offset());
				} else break;
			}
			if (o.has(s)) return this.error(t === "select" ? Ex.DUPLICATE_SELECT_ARGUMENT_SELECTOR : Ex.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, c);
			s === "other" && (i = !0), this.bumpSpace();
			let r = this.clonePosition();
			if (!this.bumpIf("{")) return this.error(t === "select" ? Ex.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : Ex.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, Nx(this.clonePosition(), this.clonePosition()));
			let l = this.parseMessage(e + 1, t, n);
			if (l.err) return l;
			let u = this.tryParseArgumentClose(r);
			if (u.err) return u;
			a.push([s, {
				value: l.val,
				location: Nx(r, this.clonePosition())
			}]), o.add(s), this.bumpSpace(), {value: s, location: c} = this.parseIdentifierIfPossible();
		}
		return a.length === 0 ? this.error(t === "select" ? Ex.EXPECT_SELECT_ARGUMENT_SELECTOR : Ex.EXPECT_PLURAL_ARGUMENT_SELECTOR, Nx(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !i ? this.error(Ex.MISSING_OTHER_CLAUSE, Nx(this.clonePosition(), this.clonePosition())) : {
			val: a,
			err: null
		};
	}
	tryParseDecimalInteger(e, t) {
		let n = 1, r = this.clonePosition();
		this.bumpIf("+") || this.bumpIf("-") && (n = -1);
		let i = !1, a = 0;
		for (; !this.isEOF();) {
			let e = this.char();
			if (e >= 48 && e <= 57) i = !0, a = a * 10 + (e - 48), this.bump();
			else break;
		}
		let o = Nx(r, this.clonePosition());
		return i ? (a *= n, Number.isSafeInteger(a) ? {
			val: a,
			err: null
		} : this.error(t, o)) : this.error(e, o);
	}
	offset() {
		return this.position.offset;
	}
	isEOF() {
		return this.offset() === this.message.length;
	}
	clonePosition() {
		return {
			offset: this.position.offset,
			line: this.position.line,
			column: this.position.column
		};
	}
	char() {
		let e = this.position.offset;
		if (e >= this.message.length) throw Error("out of bound");
		let t = this.message.codePointAt(e);
		if (t === void 0) throw Error(`Offset ${e} is at invalid UTF-16 code unit boundary`);
		return t;
	}
	error(e, t) {
		return {
			val: null,
			err: {
				kind: e,
				message: this.message,
				location: t
			}
		};
	}
	bump() {
		if (this.isEOF()) return;
		let e = this.char();
		e === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += e < 65536 ? 1 : 2);
	}
	bumpIf(e) {
		if (this.message.startsWith(e, this.offset())) {
			for (let t = 0; t < e.length; t++) this.bump();
			return !0;
		}
		return !1;
	}
	bumpUntil(e) {
		let t = this.offset(), n = this.message.indexOf(e, t);
		return n >= 0 ? (this.bumpTo(n), !0) : (this.bumpTo(this.message.length), !1);
	}
	bumpTo(e) {
		if (this.offset() > e) throw Error(`targetOffset ${e} must be greater than or equal to the current offset ${this.offset()}`);
		for (e = Math.min(e, this.message.length);;) {
			let t = this.offset();
			if (t === e) break;
			if (t > e) throw Error(`targetOffset ${e} is at invalid UTF-16 code unit boundary`);
			if (this.bump(), this.isEOF()) break;
		}
	}
	bumpSpace() {
		for (; !this.isEOF() && Kx(this.char());) this.bump();
	}
	peek() {
		if (this.isEOF()) return null;
		let e = this.char(), t = this.offset();
		return this.message.charCodeAt(t + (e >= 65536 ? 2 : 1)) ?? null;
	}
};
function Ux(e) {
	return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function Wx(e) {
	return Ux(e) || e === 47;
}
function Gx(e) {
	return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function Kx(e) {
	return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+icu-messageformat-parser@3.5.3/node_modules/@formatjs/icu-messageformat-parser/index.js
function qx(e) {
	e.forEach((e) => {
		if (delete e.location, bx(e) || xx(e)) for (let t in e.options) delete e.options[t].location, qx(e.options[t].value);
		else _x(e) && wx(e.style) || (vx(e) || yx(e)) && Tx(e.style) ? delete e.style.location : Cx(e) && qx(e.children);
	});
}
function Jx(e, t = {}) {
	t = {
		shouldParseSkeletons: !0,
		requiresOtherClause: !0,
		...t
	};
	let n = new Hx(e, t).parse();
	if (n.err) {
		let e = SyntaxError(Ex[n.err.kind]);
		throw e.location = n.err.location, e.originalMessage = n.err.message, e;
	}
	return t?.captureLocation || qx(n.val), n.val;
}
//#endregion
//#region ../../node_modules/.pnpm/intl-messageformat@11.2.0/node_modules/intl-messageformat/src/error.js
var Yx = /* @__PURE__ */ function(e) {
	return e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API", e;
}({}), Xx = class extends Error {
	code;
	originalMessage;
	constructor(e, t, n) {
		super(e), this.code = t, this.originalMessage = n;
	}
	toString() {
		return `[formatjs Error: ${this.code}] ${this.message}`;
	}
}, Zx = class extends Xx {
	constructor(e, t, n, r) {
		super(`Invalid values for "${e}": "${t}". Options are "${Object.keys(n).join("\", \"")}"`, Yx.INVALID_VALUE, r);
	}
}, Qx = class extends Xx {
	constructor(e, t, n) {
		super(`Value for "${e}" must be of type ${t}`, Yx.INVALID_VALUE, n);
	}
}, $x = class extends Xx {
	constructor(e, t) {
		super(`The intl string context variable "${e}" was not provided to the string "${t}"`, Yx.MISSING_VALUE, t);
	}
}, eS = /* @__PURE__ */ function(e) {
	return e[e.literal = 0] = "literal", e[e.object = 1] = "object", e;
}({});
function tS(e) {
	return e.length < 2 ? e : e.reduce((e, t) => {
		let n = e[e.length - 1];
		return !n || n.type !== eS.literal || t.type !== eS.literal ? e.push(t) : n.value += t.value, e;
	}, []);
}
function nS(e) {
	return typeof e == "function";
}
function rS(e, t, n, r, i, a, o) {
	if (e.length === 1 && hx(e[0])) return [{
		type: eS.literal,
		value: e[0].value
	}];
	let s = [];
	for (let c of e) {
		if (hx(c)) {
			s.push({
				type: eS.literal,
				value: c.value
			});
			continue;
		}
		if (Sx(c)) {
			typeof a == "number" && s.push({
				type: eS.literal,
				value: n.getNumberFormat(t).format(a)
			});
			continue;
		}
		let { value: e } = c;
		if (!(i && e in i)) throw new $x(e, o);
		let l = i[e];
		if (gx(c)) {
			(!l || typeof l == "string" || typeof l == "number" || typeof l == "bigint") && (l = typeof l == "string" || typeof l == "number" || typeof l == "bigint" ? String(l) : ""), s.push({
				type: typeof l == "string" ? eS.literal : eS.object,
				value: l
			});
			continue;
		}
		if (vx(c)) {
			let e = typeof c.style == "string" ? r.date[c.style] : Tx(c.style) ? c.style.parsedOptions : void 0;
			s.push({
				type: eS.literal,
				value: n.getDateTimeFormat(t, e).format(l)
			});
			continue;
		}
		if (yx(c)) {
			let e = typeof c.style == "string" ? r.time[c.style] : Tx(c.style) ? c.style.parsedOptions : r.time.medium;
			s.push({
				type: eS.literal,
				value: n.getDateTimeFormat(t, e).format(l)
			});
			continue;
		}
		if (_x(c)) {
			let e = typeof c.style == "string" ? r.number[c.style] : wx(c.style) ? c.style.parsedOptions : void 0;
			if (e && e.scale) {
				let t = e.scale || 1;
				if (typeof l == "bigint") {
					if (!Number.isInteger(t)) throw TypeError(`Cannot apply fractional scale ${t} to bigint value. Scale must be an integer when formatting bigint.`);
					l *= BigInt(t);
				} else l *= t;
			}
			s.push({
				type: eS.literal,
				value: n.getNumberFormat(t, e).format(l)
			});
			continue;
		}
		if (Cx(c)) {
			let { children: e, value: l } = c, u = i[l];
			if (!nS(u)) throw new Qx(l, "function", o);
			let d = u(rS(e, t, n, r, i, a).map((e) => e.value));
			Array.isArray(d) || (d = [d]), s.push(...d.map((e) => ({
				type: typeof e == "string" ? eS.literal : eS.object,
				value: e
			})));
		}
		if (bx(c)) {
			let e = l, a = (Object.prototype.hasOwnProperty.call(c.options, e) ? c.options[e] : void 0) || c.options.other;
			if (!a) throw new Zx(c.value, l, Object.keys(c.options), o);
			s.push(...rS(a.value, t, n, r, i));
			continue;
		}
		if (xx(c)) {
			let e = `=${l}`, a = Object.prototype.hasOwnProperty.call(c.options, e) ? c.options[e] : void 0;
			if (!a) {
				if (!Intl.PluralRules) throw new Xx("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", Yx.MISSING_INTL_API, o);
				let e = typeof l == "bigint" ? Number(l) : l, r = n.getPluralRules(t, { type: c.pluralType }).select(e - (c.offset || 0));
				a = (Object.prototype.hasOwnProperty.call(c.options, r) ? c.options[r] : void 0) || c.options.other;
			}
			if (!a) throw new Zx(c.value, l, Object.keys(c.options), o);
			let u = typeof l == "bigint" ? Number(l) : l;
			s.push(...rS(a.value, t, n, r, i, u - (c.offset || 0)));
			continue;
		}
	}
	return tS(s);
}
//#endregion
//#region ../../node_modules/.pnpm/intl-messageformat@11.2.0/node_modules/intl-messageformat/src/core.js
function iS(e, t) {
	return t ? {
		...e,
		...t,
		...Object.keys(e).reduce((n, r) => (n[r] = {
			...e[r],
			...t[r]
		}, n), {})
	} : e;
}
function aS(e, t) {
	return t ? Object.keys(e).reduce((n, r) => (n[r] = iS(e[r], t[r]), n), { ...e }) : e;
}
function oS(e) {
	return { create() {
		return {
			get(t) {
				return e[t];
			},
			set(t, n) {
				e[t] = n;
			}
		};
	} };
}
function sS(e = {
	number: {},
	dateTime: {},
	pluralRules: {}
}) {
	return {
		getNumberFormat: Vb((...e) => new Intl.NumberFormat(...e), {
			cache: oS(e.number),
			strategy: Qb.variadic
		}),
		getDateTimeFormat: Vb((...e) => new Intl.DateTimeFormat(...e), {
			cache: oS(e.dateTime),
			strategy: Qb.variadic
		}),
		getPluralRules: Vb((...e) => new Intl.PluralRules(...e), {
			cache: oS(e.pluralRules),
			strategy: Qb.variadic
		})
	};
}
var cS = class e {
	ast;
	locales;
	resolvedLocale;
	formatters;
	formats;
	message;
	formatterCache = {
		number: {},
		dateTime: {},
		pluralRules: {}
	};
	constructor(t, n = e.defaultLocale, r, i) {
		if (this.locales = n, this.resolvedLocale = e.resolveLocale(n), typeof t == "string") {
			if (this.message = t, !e.__parse) throw TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
			let { ...n } = i || {};
			this.ast = e.__parse(t, {
				...n,
				locale: this.resolvedLocale
			});
		} else this.ast = t;
		if (!Array.isArray(this.ast)) throw TypeError("A message must be provided as a String or AST.");
		this.formats = aS(e.formats, r), this.formatters = i && i.formatters || sS(this.formatterCache);
	}
	format = (e) => {
		let t = this.formatToParts(e);
		if (t.length === 1) return t[0].value;
		let n = t.reduce((e, t) => (!e.length || t.type !== eS.literal || typeof e[e.length - 1] != "string" ? e.push(t.value) : e[e.length - 1] += t.value, e), []);
		return n.length <= 1 ? n[0] || "" : n;
	};
	formatToParts = (e) => rS(this.ast, this.locales, this.formatters, this.formats, e, void 0, this.message);
	resolvedOptions = () => ({ locale: this.resolvedLocale?.toString() || Intl.NumberFormat.supportedLocalesOf(this.locales)[0] });
	getAst = () => this.ast;
	static memoizedDefaultLocale = null;
	static get defaultLocale() {
		return e.memoizedDefaultLocale ||= new Intl.NumberFormat().resolvedOptions().locale, e.memoizedDefaultLocale;
	}
	static resolveLocale = (e) => {
		if (Intl.Locale === void 0) return;
		let t = Intl.NumberFormat.supportedLocalesOf(e);
		return t.length > 0 ? new Intl.Locale(t[0]) : new Intl.Locale(typeof e == "string" ? e : e[0]);
	};
	static __parse = Jx;
	static formats = {
		number: {
			integer: { maximumFractionDigits: 0 },
			currency: { style: "currency" },
			percent: { style: "percent" }
		},
		date: {
			short: {
				month: "numeric",
				day: "numeric",
				year: "2-digit"
			},
			medium: {
				month: "short",
				day: "numeric",
				year: "numeric"
			},
			long: {
				month: "long",
				day: "numeric",
				year: "numeric"
			},
			full: {
				weekday: "long",
				month: "long",
				day: "numeric",
				year: "numeric"
			}
		},
		time: {
			short: {
				hour: "numeric",
				minute: "numeric"
			},
			medium: {
				hour: "numeric",
				minute: "numeric",
				second: "numeric"
			},
			long: {
				hour: "numeric",
				minute: "numeric",
				second: "numeric",
				timeZoneName: "short"
			},
			full: {
				hour: "numeric",
				minute: "numeric",
				second: "numeric",
				timeZoneName: "short"
			}
		}
	};
}, lS = /* @__PURE__ */ function(e) {
	return e.FORMAT_ERROR = "FORMAT_ERROR", e.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", e.INVALID_CONFIG = "INVALID_CONFIG", e.MISSING_DATA = "MISSING_DATA", e.MISSING_TRANSLATION = "MISSING_TRANSLATION", e;
}({}), uS = class e extends Error {
	code;
	constructor(t, n, r) {
		let i = r ? r instanceof Error ? r : Error(String(r)) : void 0;
		super(`[@formatjs/intl Error ${t}] ${n}
${i ? `\n${i.message}\n${i.stack}` : ""}`), this.code = t, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, e);
	}
}, dS = class extends uS {
	constructor(e, t) {
		super(lS.UNSUPPORTED_FORMATTER, e, t);
	}
}, fS = class extends uS {
	constructor(e, t) {
		super(lS.INVALID_CONFIG, e, t);
	}
}, pS = class extends uS {
	constructor(e, t) {
		super(lS.MISSING_DATA, e, t);
	}
}, mS = class extends uS {
	descriptor;
	locale;
	constructor(e, t, n) {
		super(lS.FORMAT_ERROR, `${e}
Locale: ${t}
`, n), this.locale = t;
	}
}, hS = class extends mS {
	descriptor;
	locale;
	constructor(e, t, n, r) {
		super(`${e}
MessageID: ${n?.id}
Default Message: ${n?.defaultMessage}
Description: ${n?.description}
`, t, r), this.descriptor = n, this.locale = t;
	}
}, gS = class extends uS {
	descriptor;
	constructor(e, t) {
		super(lS.MISSING_TRANSLATION, `Missing message: "${e.id}" for locale "${t}", using ${e.defaultMessage ? `default message (${typeof e.defaultMessage == "string" ? e.defaultMessage : e.defaultMessage.map((e) => e.value ?? JSON.stringify(e)).join()})` : "id"} as fallback.`), this.descriptor = e;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+intl@4.1.4_typescript@5.9.3/node_modules/@formatjs/intl/src/utils.js
function _S(e, t, n = Error) {
	if (!e) throw new n(t);
}
function vS(e, t, n = {}) {
	return t.reduce((t, r) => (r in e ? t[r] = e[r] : r in n && (t[r] = n[r]), t), {});
}
var yS = {
	formats: {},
	messages: {},
	timeZone: void 0,
	defaultLocale: "en",
	defaultFormats: {},
	fallbackOnEmptyString: !0,
	onError: (e) => {
		process.env.NODE_ENV !== "production" && console.error(e);
	},
	onWarn: (e) => {
		process.env.NODE_ENV !== "production" && console.warn(e);
	}
};
function bS() {
	return {
		dateTime: {},
		number: {},
		message: {},
		relativeTime: {},
		pluralRules: {},
		list: {},
		displayNames: {}
	};
}
function xS(e) {
	return { create() {
		return {
			get(t) {
				return e[t];
			},
			set(t, n) {
				e[t] = n;
			}
		};
	} };
}
function SS(e = bS()) {
	let t = Intl.RelativeTimeFormat, n = Intl.ListFormat, r = Intl.DisplayNames, i = Vb((...e) => new Intl.DateTimeFormat(...e), {
		cache: xS(e.dateTime),
		strategy: Qb.variadic
	}), a = Vb((...e) => new Intl.NumberFormat(...e), {
		cache: xS(e.number),
		strategy: Qb.variadic
	}), o = Vb((...e) => new Intl.PluralRules(...e), {
		cache: xS(e.pluralRules),
		strategy: Qb.variadic
	});
	return {
		getDateTimeFormat: i,
		getNumberFormat: a,
		getMessageFormat: Vb((e, t, n, r) => new cS(e, t, n, {
			formatters: {
				getNumberFormat: a,
				getDateTimeFormat: i,
				getPluralRules: o
			},
			...r
		}), {
			cache: xS(e.message),
			strategy: Qb.variadic
		}),
		getRelativeTimeFormat: Vb((...e) => new t(...e), {
			cache: xS(e.relativeTime),
			strategy: Qb.variadic
		}),
		getPluralRules: o,
		getListFormat: Vb((...e) => new n(...e), {
			cache: xS(e.list),
			strategy: Qb.variadic
		}),
		getDisplayNames: Vb((...e) => new r(...e), {
			cache: xS(e.displayNames),
			strategy: Qb.variadic
		})
	};
}
function CS(e, t, n, r) {
	let i = e && e[t], a;
	if (i && (a = i[n]), a) return a;
	r(new dS(`No ${t} format named: ${n}`));
}
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+intl@4.1.4_typescript@5.9.3/node_modules/@formatjs/intl/src/message.js
function wS(e, t) {
	return Object.keys(e).reduce((n, r) => (n[r] = {
		timeZone: t,
		...e[r]
	}, n), {});
}
function TS(e, t) {
	return Object.keys({
		...e,
		...t
	}).reduce((n, r) => (n[r] = {
		...e[r],
		...t[r]
	}, n), {});
}
function ES(e, t) {
	if (!t) return e;
	let n = cS.formats;
	return {
		...n,
		...e,
		date: TS(wS(n.date, t), wS(e.date || {}, t)),
		time: TS(wS(n.time, t), wS(e.time || {}, t))
	};
}
var DS = ({ locale: e, formats: t, messages: n, defaultLocale: r, defaultFormats: i, fallbackOnEmptyString: a, onError: o, timeZone: s, defaultRichTextElements: c }, l, u = { id: "" }, d, f) => {
	let { id: p, defaultMessage: m } = u;
	_S(!!p, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
	let h = String(p), g = n && Object.prototype.hasOwnProperty.call(n, h) && n[h];
	if (Array.isArray(g) && g.length === 1 && g[0].type === px.literal) return g[0].value;
	if (d = {
		...c,
		...d
	}, t = ES(t, s), i = ES(i, s), !g) {
		if (a === !1 && g === "") return g;
		if ((!m || e && e.toLowerCase() !== r.toLowerCase()) && o(new gS(u, e)), m) try {
			return l.getMessageFormat(m, r, i, f).format(d);
		} catch (t) {
			return o(new hS(`Error formatting default message for: "${h}", rendering default message verbatim`, e, u, t)), typeof m == "string" ? m : h;
		}
		return h;
	}
	try {
		return l.getMessageFormat(g, e, t, {
			formatters: l,
			...f
		}).format(d);
	} catch (t) {
		o(new hS(`Error formatting message: "${h}", using ${m ? "default message" : "id"} as fallback.`, e, u, t));
	}
	if (m) try {
		return l.getMessageFormat(m, r, i, f).format(d);
	} catch (t) {
		o(new hS(`Error formatting the default message for: "${h}", rendering message verbatim`, e, u, t));
	}
	return typeof g == "string" ? g : typeof m == "string" ? m : h;
}, OS = [
	"formatMatcher",
	"timeZone",
	"hour12",
	"weekday",
	"era",
	"year",
	"month",
	"day",
	"hour",
	"minute",
	"second",
	"timeZoneName",
	"hourCycle",
	"dateStyle",
	"timeStyle",
	"calendar",
	"numberingSystem",
	"fractionalSecondDigits"
];
function kS({ locale: e, formats: t, onError: n, timeZone: r }, i, a, o = {}) {
	let { format: s } = o, c = vS(o, OS, {
		...r && { timeZone: r },
		...s && CS(t, i, s, n)
	});
	return i === "time" && !c.hour && !c.minute && !c.second && !c.timeStyle && !c.dateStyle && (c = {
		...c,
		hour: "numeric",
		minute: "numeric"
	}), a(e, c);
}
function AS(e, t, n, r = {}) {
	let i = typeof n == "string" ? new Date(n || 0) : n;
	try {
		return kS(e, "date", t, r).format(i);
	} catch (t) {
		e.onError(new mS("Error formatting date.", e.locale, t));
	}
	return String(i);
}
function jS(e, t, n, r = {}) {
	let i = typeof n == "string" ? new Date(n || 0) : n;
	try {
		return kS(e, "time", t, r).format(i);
	} catch (t) {
		e.onError(new mS("Error formatting time.", e.locale, t));
	}
	return String(i);
}
function MS(e, t, n, r, i = {}) {
	let a = typeof n == "string" ? new Date(n || 0) : n, o = typeof r == "string" ? new Date(r || 0) : r;
	try {
		return kS(e, "dateTimeRange", t, i).formatRange(a, o);
	} catch (t) {
		e.onError(new mS("Error formatting date time range.", e.locale, t));
	}
	return String(a);
}
function NS(e, t, n, r = {}) {
	let i = typeof n == "string" ? new Date(n || 0) : n;
	try {
		return kS(e, "date", t, r).formatToParts(i);
	} catch (t) {
		e.onError(new mS("Error formatting date.", e.locale, t));
	}
	return [];
}
function PS(e, t, n, r = {}) {
	let i = typeof n == "string" ? new Date(n || 0) : n;
	try {
		return kS(e, "time", t, r).formatToParts(i);
	} catch (t) {
		e.onError(new mS("Error formatting time.", e.locale, t));
	}
	return [];
}
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+intl@4.1.4_typescript@5.9.3/node_modules/@formatjs/intl/src/displayName.js
var FS = [
	"style",
	"type",
	"fallback",
	"languageDisplay"
];
function IS({ locale: e, onError: t }, n, r, i) {
	Intl.DisplayNames || t(new Xx("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", Yx.MISSING_INTL_API));
	let a = vS(i, FS);
	try {
		return n(e, a).of(r);
	} catch (n) {
		t(new mS("Error formatting display name.", e, n));
	}
}
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+intl@4.1.4_typescript@5.9.3/node_modules/@formatjs/intl/src/list.js
var LS = ["type", "style"], RS = Date.now();
function zS(e) {
	return `${RS}_${e}_${RS}`;
}
function BS(e, t, n, r = {}) {
	let i = VS(e, t, n, r).reduce((e, t) => {
		let n = t.value;
		return typeof n == "string" && typeof e[e.length - 1] == "string" ? e[e.length - 1] += n : e.push(n), e;
	}, []);
	return i.length === 1 ? i[0] : i.length === 0 ? "" : i;
}
function VS({ locale: e, onError: t }, n, r, i = {}) {
	Intl.ListFormat || t(new Xx("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", Yx.MISSING_INTL_API));
	let a = vS(i, LS);
	try {
		let t = {}, i = Array.from(r).map((e, n) => {
			if (typeof e == "object" && e) {
				let r = zS(n);
				return t[r] = e, r;
			}
			return String(e);
		});
		return n(e, a).formatToParts(i).map((e) => e.type === "literal" ? e : {
			...e,
			value: t[e.value] || e.value
		});
	} catch (n) {
		t(new mS("Error formatting list.", e, n));
	}
	return r;
}
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+intl@4.1.4_typescript@5.9.3/node_modules/@formatjs/intl/src/plural.js
var HS = ["type"];
function US({ locale: e, onError: t }, n, r, i = {}) {
	Intl.PluralRules || t(new Xx("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", Yx.MISSING_INTL_API));
	let a = vS(i, HS);
	try {
		return n(e, a).select(r);
	} catch (n) {
		t(new mS("Error formatting plural.", e, n));
	}
	return "other";
}
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+intl@4.1.4_typescript@5.9.3/node_modules/@formatjs/intl/src/relativeTime.js
var WS = ["numeric", "style"];
function GS({ locale: e, formats: t, onError: n }, r, i = {}) {
	let { format: a } = i;
	return r(e, vS(i, WS, !!a && CS(t, "relative", a, n) || {}));
}
function KS(e, t, n, r, i = {}) {
	r ||= "second", Intl.RelativeTimeFormat || e.onError(new Xx("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", Yx.MISSING_INTL_API));
	try {
		return GS(e, t, i).format(n, r);
	} catch (t) {
		e.onError(new mS("Error formatting relative time.", e.locale, t));
	}
	return String(n);
}
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+intl@4.1.4_typescript@5.9.3/node_modules/@formatjs/intl/src/number.js
var qS = [
	"style",
	"currency",
	"unit",
	"unitDisplay",
	"useGrouping",
	"minimumIntegerDigits",
	"minimumFractionDigits",
	"maximumFractionDigits",
	"minimumSignificantDigits",
	"maximumSignificantDigits",
	"compactDisplay",
	"currencyDisplay",
	"currencySign",
	"notation",
	"signDisplay",
	"unit",
	"unitDisplay",
	"numberingSystem",
	"trailingZeroDisplay",
	"roundingPriority",
	"roundingIncrement",
	"roundingMode"
];
function JS({ locale: e, formats: t, onError: n }, r, i = {}) {
	let { format: a } = i;
	return r(e, vS(i, qS, a && CS(t, "number", a, n) || {}));
}
function YS(e, t, n, r = {}) {
	try {
		return JS(e, t, r).format(n);
	} catch (t) {
		e.onError(new mS("Error formatting number.", e.locale, t));
	}
	return String(n);
}
function XS(e, t, n, r = {}) {
	try {
		return JS(e, t, r).formatToParts(n);
	} catch (t) {
		e.onError(new mS("Error formatting number.", e.locale, t));
	}
	return [];
}
//#endregion
//#region ../../node_modules/.pnpm/@formatjs+intl@4.1.4_typescript@5.9.3/node_modules/@formatjs/intl/src/create-intl.js
function ZS(e) {
	return typeof (e ? e[Object.keys(e)[0]] : void 0) == "string";
}
function QS(e) {
	e.onWarn && e.defaultRichTextElements && ZS(e.messages || {}) && e.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $S(e, t) {
	let n = SS(t), r = {
		...yS,
		...e
	}, { locale: i, defaultLocale: a, onError: o } = r;
	return i ? !Intl.NumberFormat.supportedLocalesOf(i).length && o ? o(new pS(`Missing locale data for locale: "${i}" in Intl.NumberFormat. Using default locale: "${a}" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details`)) : !Intl.DateTimeFormat.supportedLocalesOf(i).length && o && o(new pS(`Missing locale data for locale: "${i}" in Intl.DateTimeFormat. Using default locale: "${a}" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details`)) : (o && o(new fS(`"locale" was not configured, using "${a}" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details`)), r.locale = r.defaultLocale || "en"), QS(r), {
		...r,
		formatters: n,
		formatNumber: YS.bind(null, r, n.getNumberFormat),
		formatNumberToParts: XS.bind(null, r, n.getNumberFormat),
		formatRelativeTime: KS.bind(null, r, n.getRelativeTimeFormat),
		formatDate: AS.bind(null, r, n.getDateTimeFormat),
		formatDateToParts: NS.bind(null, r, n.getDateTimeFormat),
		formatTime: jS.bind(null, r, n.getDateTimeFormat),
		formatDateTimeRange: MS.bind(null, r, n.getDateTimeFormat),
		formatTimeToParts: PS.bind(null, r, n.getDateTimeFormat),
		formatPlural: US.bind(null, r, n.getPluralRules),
		formatMessage: DS.bind(null, r, n),
		$t: DS.bind(null, r, n),
		formatList: BS.bind(null, r, n.getListFormat),
		formatListToParts: VS.bind(null, r, n.getListFormat),
		formatDisplayName: IS.bind(null, r, n.getDisplayNames)
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-intl@10.1.0_@types+react@19.2.15_react@19.2.4_typescript@5.9.3/node_modules/react-intl/src/utils.js
function eC(e, t, n = Error) {
	if (!e) throw new n(t);
}
function tC(e) {
	eC(e, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var nC = {
	...yS,
	textComponent: S.Fragment
}, rC = (e) => S.Children.toArray(e).map((e, t) => S.isValidElement(e) ? /* @__PURE__ */ (0, C.jsx)(S.Fragment, { children: e }, t) : e);
function iC(e) {
	return function(t) {
		return e(rC(t));
	};
}
function aC(e, t) {
	if (e === t) return !0;
	if (!e || !t) return !1;
	var n = Object.keys(e), r = Object.keys(t), i = n.length;
	if (r.length !== i) return !1;
	for (var a = 0; a < i; a++) {
		var o = n[a];
		if (e[o] !== t[o] || !Object.prototype.hasOwnProperty.call(t, o)) return !1;
	}
	return !0;
}
//#endregion
//#region ../../node_modules/.pnpm/react-intl@10.1.0_@types+react@19.2.15_react@19.2.4_typescript@5.9.3/node_modules/react-intl/src/components/context.js
var oC = S.createContext(null), sC = oC.Provider;
//#endregion
//#region ../../node_modules/.pnpm/react-intl@10.1.0_@types+react@19.2.15_react@19.2.4_typescript@5.9.3/node_modules/react-intl/src/components/useIntl.js
function cC() {
	let e = S.useContext(oC);
	return tC(e), e;
}
//#endregion
//#region ../../node_modules/.pnpm/react-intl@10.1.0_@types+react@19.2.15_react@19.2.4_typescript@5.9.3/node_modules/react-intl/src/components/createFormattedComponent.js
var lC = /* @__PURE__ */ function(e) {
	return e.formatDate = "FormattedDate", e.formatTime = "FormattedTime", e.formatNumber = "FormattedNumber", e.formatList = "FormattedList", e.formatDisplayName = "FormattedDisplayName", e;
}(lC || {}), uC = /* @__PURE__ */ function(e) {
	return e.formatDate = "FormattedDateParts", e.formatTime = "FormattedTimeParts", e.formatNumber = "FormattedNumberParts", e.formatList = "FormattedListParts", e;
}(uC || {}), dC = (e) => {
	let t = cC(), { value: n, children: r, ...i } = e;
	return r(t.formatNumberToParts(n, i));
};
dC.displayName = "FormattedNumberParts", dC.displayName = "FormattedNumberParts";
function fC(e) {
	let t = (t) => {
		let n = cC(), { value: r, children: i, ...a } = t, o = typeof r == "string" ? new Date(r || 0) : r;
		return i(e === "formatDate" ? n.formatDateToParts(o, a) : n.formatTimeToParts(o, a));
	};
	return t.displayName = uC[e], t;
}
function pC(e) {
	let t = (t) => {
		let n = cC(), { value: r, children: i, ...a } = t, o = n[e](r, a);
		return typeof i == "function" ? i(o) : /* @__PURE__ */ (0, C.jsx)(n.textComponent || S.Fragment, { children: o });
	};
	return t.displayName = lC[e], t;
}
//#endregion
//#region ../../node_modules/.pnpm/react-intl@10.1.0_@types+react@19.2.15_react@19.2.4_typescript@5.9.3/node_modules/react-intl/src/components/createIntl.js
function mC(e) {
	return e && Object.keys(e).reduce((t, n) => {
		let r = e[n];
		return t[n] = nS(r) ? iC(r) : r, t;
	}, {});
}
var hC = (e, t, n, r, ...i) => {
	let a = DS(e, t, n, mC(r), ...i);
	return Array.isArray(a) ? rC(a) : a;
}, gC = ({ defaultRichTextElements: e, ...t }, n) => {
	let r = mC(e), i = $S({
		...nC,
		...t,
		defaultRichTextElements: r
	}, n), a = {
		locale: i.locale,
		timeZone: i.timeZone,
		fallbackOnEmptyString: i.fallbackOnEmptyString,
		formats: i.formats,
		defaultLocale: i.defaultLocale,
		defaultFormats: i.defaultFormats,
		messages: i.messages,
		onError: i.onError,
		defaultRichTextElements: r
	};
	return {
		...i,
		formatMessage: hC.bind(null, a, i.formatters),
		$t: hC.bind(null, a, i.formatters)
	};
};
//#endregion
//#region ../../node_modules/.pnpm/react-intl@10.1.0_@types+react@19.2.15_react@19.2.4_typescript@5.9.3/node_modules/react-intl/src/components/message.js
function _C(e, t) {
	let { values: n, ...r } = e, { values: i, ...a } = t;
	return aC(i, n) && aC(r, a);
}
function vC(e) {
	let { formatMessage: t, textComponent: n = S.Fragment } = cC(), { id: r, description: i, defaultMessage: a, values: o, children: s, tagName: c = n, ignoreTag: l } = e, u = t({
		id: r,
		description: i,
		defaultMessage: a
	}, o, { ignoreTag: l });
	return typeof s == "function" ? s(Array.isArray(u) ? u : [u]) : c ? /* @__PURE__ */ (0, C.jsx)(c, { children: u }) : /* @__PURE__ */ (0, C.jsx)(C.Fragment, { children: u });
}
vC.displayName = "FormattedMessage";
var yC = S.memo(vC, _C);
yC.displayName = "MemoizedFormattedMessage", pC("formatDate"), pC("formatTime");
var bC = pC("formatNumber");
pC("formatList"), pC("formatDisplayName"), fC("formatDate"), fC("formatTime");
//#endregion
//#region src/compatibility-router/router-context.ts
var xC = (0, S.createContext)(null);
function SC() {
	let e = (0, S.useContext)(xC);
	if (!e) throw Error("`compatibility-router` hooks and components must be used inside <RouterProvider>");
	return e;
}
//#endregion
//#region src/compatibility-router/link.tsx
function CC(e) {
	return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
}
function wC(e) {
	let t = (0, x.c)(26), n, r, i, a, o, s, c;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7]) : ({to: c, params: i, search: o, onClick: r, target: s, children: n, ...a} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c);
	let { buildHref: l, navigate: u } = SC(), d;
	t[8] !== l || t[9] !== i || t[10] !== o || t[11] !== c ? (d = l({
		to: c,
		params: i,
		search: o
	}), t[8] = l, t[9] = i, t[10] = o, t[11] = c, t[12] = d) : d = t[12];
	let f = d, p;
	t[13] !== u || t[14] !== r || t[15] !== i || t[16] !== o || t[17] !== s || t[18] !== c ? (p = function(e) {
		r?.(e), !e.defaultPrevented && e.button === 0 && (CC(e) || s && s !== "_self" || (e.preventDefault(), u({
			to: c,
			params: i,
			search: o
		})));
	}, t[13] = u, t[14] = r, t[15] = i, t[16] = o, t[17] = s, t[18] = c, t[19] = p) : p = t[19];
	let m = p, h;
	return t[20] !== n || t[21] !== m || t[22] !== f || t[23] !== a || t[24] !== s ? (h = /* @__PURE__ */ (0, C.jsx)("a", {
		...a,
		href: f,
		onClick: m,
		target: s,
		children: n
	}), t[20] = n, t[21] = m, t[22] = f, t[23] = a, t[24] = s, t[25] = h) : h = t[25], h;
}
//#endregion
//#region src/compatibility-router/router-provider.tsx
function TC(e) {
	let t = (0, x.c)(6), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({children: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	return t[3] !== n || t[4] !== r ? (i = /* @__PURE__ */ (0, C.jsx)(xC, {
		value: r,
		children: n
	}), t[3] = n, t[4] = r, t[5] = i) : i = t[5], i;
}
//#endregion
//#region src/compatibility-router/use-navigate.ts
function EC() {
	let e = (0, x.c)(2), { navigate: t } = SC(), n;
	return e[0] === t ? n = e[1] : (n = function(e) {
		let { to: n, params: r, search: i, replace: a } = e;
		t({
			to: n,
			params: r,
			search: i,
			replace: a
		});
	}, e[0] = t, e[1] = n), n;
}
var DC = {
	trigger: "_trigger_1fjqr_3",
	items: "_items_1fjqr_11",
	item: "_item_1fjqr_11"
}, OC = {
	destination: "/daas/$destinationId/settings/personal",
	hotel: "/hotel/$hotelId/settings/personal",
	market: "/market/$marketId/settings/personal"
}, kC = {
	destination: null,
	hotel: "/hotel/$hotelId/revpak/exports",
	market: "/market/$marketId/revpak/exports"
};
function AC(e) {
	return Array.from(e.querySelectorAll("[role=\"menuitem\"]"));
}
function jC(e) {
	let t = (0, x.c)(7), { icon: n, label: r } = e, i;
	t[0] === n ? i = t[1] : (i = n ? /* @__PURE__ */ (0, C.jsx)(N, {
		color: "inherit",
		name: n,
		size: "small"
	}) : null, t[0] = n, t[1] = i);
	let a;
	t[2] === r ? a = t[3] : (a = /* @__PURE__ */ (0, C.jsx)(yC, { id: r }), t[2] = r, t[3] = a);
	let o;
	return t[4] !== i || t[5] !== a ? (o = /* @__PURE__ */ (0, C.jsxs)(C.Fragment, { children: [i, a] }), t[4] = i, t[5] = a, t[6] = o) : o = t[6], o;
}
function MC(e) {
	let t = (0, x.c)(7), { icon: n, label: r, onSelect: i, to: a } = e, o;
	t[0] !== n || t[1] !== r ? (o = /* @__PURE__ */ (0, C.jsx)(jC, {
		icon: n,
		label: r
	}), t[0] = n, t[1] = r, t[2] = o) : o = t[2];
	let s;
	return t[3] !== i || t[4] !== o || t[5] !== a ? (s = /* @__PURE__ */ (0, C.jsx)(wC, {
		className: DC.item,
		onClick: i,
		role: "menuitem",
		to: a,
		children: o
	}), t[3] = i, t[4] = o, t[5] = a, t[6] = s) : s = t[6], s;
}
function NC(e) {
	let t = (0, x.c)(6), { icon: n, label: r, onSelect: i } = e, a;
	t[0] !== n || t[1] !== r ? (a = /* @__PURE__ */ (0, C.jsx)(jC, {
		icon: n,
		label: r
	}), t[0] = n, t[1] = r, t[2] = a) : a = t[2];
	let o;
	return t[3] !== i || t[4] !== a ? (o = /* @__PURE__ */ (0, C.jsx)("button", {
		className: DC.item,
		onClick: i,
		role: "menuitem",
		type: "button",
		children: a
	}), t[3] = i, t[4] = a, t[5] = o) : o = t[5], o;
}
function PC(e) {
	let t = (0, x.c)(79), { kind: n, hasRebranding: r, isDemoMode: i, isMyHotels: a, onAccountAction: o } = e, s = r === void 0 ? !1 : r, c = i === void 0 ? !1 : i, l = a === void 0 ? !1 : a, { formatMessage: u } = cC(), { hasFeature: d } = T(), { isActive: f } = SC(), [p, m] = (0, S.useState)(!1), h = (0, S.useRef)(null), g = (0, S.useRef)(!1), _ = (0, S.useId)(), v = (0, S.useId)(), y = OC[n], b = kC[n], w;
	t[0] === d ? w = t[1] : (w = d("user.staff"), t[0] = d, t[1] = w);
	let E = w, D;
	t[2] !== d || t[3] !== n ? (D = n !== "destination" && d("user.app_demo_mode"), t[2] = d, t[3] = n, t[4] = D) : D = t[4];
	let O = D, k;
	t[5] !== d || t[6] !== b ? (k = b !== null && d("spider.revpak_library"), t[5] = d, t[6] = b, t[7] = k) : k = t[7];
	let A = k, j = n === "destination" || !s, M;
	t[8] !== f || t[9] !== b ? (M = b !== null && f({ to: b }), t[8] = f, t[9] = b, t[10] = M) : M = t[10];
	let N = M, P;
	t[11] === Symbol.for("react.memo_cache_sentinel") ? (P = function() {
		m(!1);
	}, t[11] = P) : P = t[11];
	let F = P, I;
	t[12] === Symbol.for("react.memo_cache_sentinel") ? (I = function() {
		F(), h.current?.focus();
	}, t[12] = I) : I = t[12];
	let L = I, ee;
	t[13] === o ? ee = t[14] : (ee = function(e) {
		o(e), L();
	}, t[13] = o, t[14] = ee);
	let R = ee, z;
	t[15] === Symbol.for("react.memo_cache_sentinel") ? (z = function(e) {
		e.key !== "ArrowDown" && e.key !== "ArrowUp" || (e.preventDefault(), g.current = e.key === "ArrowUp", m(!0));
	}, t[15] = z) : z = t[15];
	let te = z, B;
	t[16] === Symbol.for("react.memo_cache_sentinel") ? (B = function(e) {
		if (e === null || !g.current) return;
		g.current = !1;
		let t = AC(e);
		t[t.length - 1]?.focus();
	}, t[16] = B) : B = t[16];
	let V = B, ne;
	t[17] === Symbol.for("react.memo_cache_sentinel") ? (ne = function(e) {
		if (e.key === "Tab") {
			L();
			return;
		}
		let t = AC(e.currentTarget), n = t.findIndex(FC), r = t.length - 1, i;
		bb68: switch (e.key) {
			case "ArrowDown":
				i = n === r ? 0 : n + 1;
				break bb68;
			case "ArrowUp":
				i = n <= 0 ? r : n - 1;
				break bb68;
			case "Home":
				i = 0;
				break bb68;
			case "End":
				i = r;
				break bb68;
			default: return;
		}
		e.preventDefault(), t[i]?.focus();
	}, t[17] = ne) : ne = t[17];
	let re = ne, ie = p ? v : void 0, ae;
	t[18] === u ? ae = t[19] : (ae = u({ id: "menu.my_account" }), t[18] = u, t[19] = ae);
	let oe = N || void 0, H;
	t[20] === p ? H = t[21] : (H = () => {
		m(!p);
	}, t[20] = p, t[21] = H);
	let se;
	t[22] !== p || t[23] !== ie || t[24] !== ae || t[25] !== oe || t[26] !== H || t[27] !== _ ? (se = /* @__PURE__ */ (0, C.jsx)(xe, {
		"aria-controls": ie,
		"aria-expanded": p,
		"aria-haspopup": "menu",
		"aria-label": ae,
		buttonType: "ghost",
		className: DC.trigger,
		"data-active": oe,
		icon: "circle-user",
		id: _,
		onClick: H,
		onKeyDown: te,
		ref: h,
		type: "button"
	}), t[22] = p, t[23] = ie, t[24] = ae, t[25] = oe, t[26] = H, t[27] = _, t[28] = se) : se = t[28];
	let ce;
	t[29] === Symbol.for("react.memo_cache_sentinel") ? (ce = (e, t) => {
		let n = h.current?.contains(t.event.target) === !0;
		t.reason === "outside-press" && n || (t.reason === "outside-press" ? F() : L());
	}, t[29] = ce) : ce = t[29];
	let le;
	t[30] === y ? le = t[31] : (le = /* @__PURE__ */ (0, C.jsx)(MC, {
		icon: "circle-user",
		label: "menu.my_account",
		onSelect: L,
		to: y
	}), t[30] = y, t[31] = le);
	let ue;
	t[32] !== b || t[33] !== A ? (ue = A ? /* @__PURE__ */ (0, C.jsx)(MC, {
		icon: "bookmark-filled",
		label: "menu.spider.revpak-library",
		onSelect: L,
		to: b
	}) : null, t[32] = b, t[33] = A, t[34] = ue) : ue = t[34];
	let de;
	t[35] === R ? de = t[36] : (de = /* @__PURE__ */ (0, C.jsx)(NC, {
		icon: "circle-question-mark",
		label: "menu.help",
		onSelect: () => {
			R("help");
		}
	}), t[35] = R, t[36] = de);
	let fe;
	t[37] !== R || t[38] !== j ? (fe = j ? /* @__PURE__ */ (0, C.jsx)(NC, {
		icon: "refer-friend",
		label: "menu.refer_a_friend",
		onSelect: () => {
			R("refer-a-friend");
		}
	}) : null, t[37] = R, t[38] = j, t[39] = fe) : fe = t[39];
	let pe;
	t[40] === R ? pe = t[41] : (pe = /* @__PURE__ */ (0, C.jsx)(NC, {
		icon: "logout",
		label: "menu.logout",
		onSelect: () => {
			R("logout");
		}
	}), t[40] = R, t[41] = pe);
	let me;
	t[42] !== E || t[43] !== n || t[44] !== R ? (me = E && n === "hotel" ? /* @__PURE__ */ (0, C.jsxs)(C.Fragment, { children: [/* @__PURE__ */ (0, C.jsx)(NC, {
		label: "menu.admin",
		onSelect: () => {
			R("admin");
		}
	}), /* @__PURE__ */ (0, C.jsx)(NC, {
		label: "menu.admin_subscription",
		onSelect: () => {
			R("admin-subscription");
		}
	})] }) : null, t[42] = E, t[43] = n, t[44] = R, t[45] = me) : me = t[45];
	let he;
	t[46] !== l || t[47] !== E || t[48] !== n || t[49] !== R ? (he = E && n === "market" && l ? /* @__PURE__ */ (0, C.jsx)(NC, {
		label: "menu.admin_user",
		onSelect: () => {
			R("admin-user");
		}
	}) : null, t[46] = l, t[47] = E, t[48] = n, t[49] = R, t[50] = he) : he = t[50];
	let ge;
	t[51] !== E || t[52] !== n || t[53] !== R ? (ge = E && n === "market" ? /* @__PURE__ */ (0, C.jsx)(NC, {
		label: "menu.admin_market",
		onSelect: () => {
			R("admin-market");
		}
	}) : null, t[51] = E, t[52] = n, t[53] = R, t[54] = ge) : ge = t[54];
	let _e;
	t[55] !== O || t[56] !== c || t[57] !== R ? (_e = O ? /* @__PURE__ */ (0, C.jsx)(NC, {
		label: c ? "menu.disable_demo" : "menu.enable_demo",
		onSelect: () => {
			R("toggle-demo");
		}
	}) : null, t[55] = O, t[56] = c, t[57] = R, t[58] = _e) : _e = t[58];
	let ve;
	t[59] !== le || t[60] !== ue || t[61] !== de || t[62] !== fe || t[63] !== pe || t[64] !== me || t[65] !== he || t[66] !== ge || t[67] !== _e ? (ve = /* @__PURE__ */ (0, C.jsxs)("div", {
		className: DC.items,
		onKeyDown: re,
		ref: V,
		role: "none",
		children: [
			le,
			ue,
			de,
			fe,
			pe,
			me,
			he,
			ge,
			_e
		]
	}), t[59] = le, t[60] = ue, t[61] = de, t[62] = fe, t[63] = pe, t[64] = me, t[65] = he, t[66] = ge, t[67] = _e, t[68] = ve) : ve = t[68];
	let ye;
	t[69] !== v || t[70] !== ve || t[71] !== _ ? (ye = /* @__PURE__ */ (0, C.jsx)(N_.Content, {
		anchor: h,
		"aria-labelledby": _,
		id: v,
		role: "menu",
		side: "bottom",
		sideOffset: 4,
		children: ve
	}), t[69] = v, t[70] = ve, t[71] = _, t[72] = ye) : ye = t[72];
	let be;
	t[73] !== p || t[74] !== ye ? (be = /* @__PURE__ */ (0, C.jsx)(N_, {
		onOpenChange: ce,
		open: p,
		children: ye
	}), t[73] = p, t[74] = ye, t[75] = be) : be = t[75];
	let Se;
	return t[76] !== se || t[77] !== be ? (Se = /* @__PURE__ */ (0, C.jsxs)(C.Fragment, { children: [se, be] }), t[76] = se, t[77] = be, t[78] = Se) : Se = t[78], Se;
}
function FC(e) {
	return e === document.activeElement;
}
//#endregion
//#region src/general/domain/product-names.ts
var IC = {
	rate_insight: "general.rate_insight",
	revenue_insight: "general.revenue_insight",
	spider_analytics: "general.spider",
	business_intelligence: "general.bi",
	parity_insight: "general.parity_insight",
	market_insight: "general.market_insight",
	pricing_assistant: "general.pricing_assistant",
	benchmark_insight: "general.benchmark_insight",
	rates: "general.rate_insight",
	par_strategy: "general.parity_insight",
	par_manager: "general.parity_manager",
	spider: "general.spider",
	bi: "general.bi"
}, LC = [
	"market_insight",
	"rate_insight",
	"rates",
	"pricing_assistant",
	"par_strategy",
	"par_manager",
	"bi",
	"business_intelligence",
	"spider",
	"spider_analytics",
	"revenue_insight",
	"benchmark_insight",
	"parity_insight"
];
//#endregion
//#region src/general/domain/format-account.ts
function RC(e) {
	return e.startsWith("_");
}
function zC(e, t) {
	return e === "" ? "" : e === "general.myhotels" ? t({ id: "general.myhotels" }) : `${t({ id: "general.myhotels" })} - ${t({ id: e })}`;
}
function BC(e, t, { isDemoMode: n = !1, isStaff: r = !1 } = {}) {
	if (e.type === "hotel") return n ? e.name : e.brandCode ? `${e.brandCode} - ${e.name}` : e.name;
	if (e.type === "market") {
		let i = RC(e.id) ? zC(e.name, t) : e.name;
		return r && RC(e.id) && e.ownerEmail && !n ? `${i} (${e.ownerEmail})` : i;
	}
	return e.name;
}
function VC(e, t) {
	return e.type === "hotel" && e.brandCode ? `${e.brandCode}-${e.name}` : e.type === "market" && RC(e.id) ? zC(e.name, t) : e.name;
}
function HC(e, t) {
	return e.plans.length > 0 ? e.plans.join(", ") : LC.filter((t) => e.products.includes(t)).map((e) => t({ id: IC[e] })).join(", ");
}
//#endregion
//#region src/general/components/header/account-selector.module.css
var UC = "_trigger_sg76u_3", WC = "_name_sg76u_39", GC = "_chevron_sg76u_46", KC = "_popup_sg76u_58", qC = "_search_sg76u_64", JC = "_input_sg76u_95", YC = "_list_sg76u_113", XC = "_item_sg76u_118", ZC = {
	trigger: UC,
	name: WC,
	chevron: GC,
	popup: KC,
	search: qC,
	"search-wrapper": "_search-wrapper_sg76u_69",
	"search-icon": "_search-icon_sg76u_88",
	input: JC,
	list: YC,
	item: XC,
	"option-text": "_option-text_sg76u_133",
	"option-label": "_option-label_sg76u_141",
	"option-sub-label": "_option-sub-label_sg76u_147"
}, QC = "account-selector-name", $C = "account-selector-popup", ew = "account-selector-list";
function tw(e) {
	return `account-selector-option-${e}`;
}
var nw = {
	hotel: "business-type-hotel",
	market: "business-type-market",
	destination: "location-pin"
}, rw = 250;
function iw(e, t) {
	return e.type === "hotel" ? t.hotelinfoId !== void 0 && e.hotelinfoId === t.hotelinfoId : e.type === t.type && e.id === t.id;
}
function aw(e) {
	let t = (0, x.c)(84), { current: n, search: r, onSelect: i, isDemoMode: a, isStaff: o } = e, { formatMessage: s } = cC(), [c, l] = (0, S.useState)(!1), [u, d] = (0, S.useState)(""), f;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (f = [], t[0] = f) : f = t[0];
	let [p, m] = (0, S.useState)(f), [h, g] = (0, S.useState)(null), _ = (0, S.useRef)(null), v = (0, S.useRef)(null), y = (0, S.useRef)(0), b = (0, S.useRef)(void 0), w;
	t[1] === s ? w = t[2] : (w = s({ id: "general.search_placeholder" }), t[1] = s, t[2] = w);
	let T = w, E;
	if (t[3] !== p || t[4] !== n) {
		let e;
		t[6] === n ? e = t[7] : (e = (e) => !iw(e, n), t[6] = n, t[7] = e), E = p.filter(e), t[3] = p, t[4] = n, t[5] = E;
	} else E = t[5];
	let D = E, O;
	t[8] === r ? O = t[9] : (O = function(e) {
		y.current += 1;
		let t = y.current;
		r(e, 0).then((e) => {
			t === y.current && m(e.accounts);
		}).catch(() => {
			t === y.current && m([]);
		});
	}, t[8] = r, t[9] = O);
	let k = O, A;
	t[10] === Symbol.for("react.memo_cache_sentinel") ? (A = function() {
		clearTimeout(b.current);
	}, t[10] = A) : A = t[10];
	let j = A, M;
	t[11] === k ? M = t[12] : (M = function(e) {
		j(), b.current = setTimeout(() => {
			k(e);
		}, rw);
	}, t[11] = k, t[12] = M);
	let P = M, F, I;
	t[13] === Symbol.for("react.memo_cache_sentinel") ? (F = () => j, I = [], t[13] = F, t[14] = I) : (F = t[13], I = t[14]), (0, S.useEffect)(F, I);
	let L;
	t[15] === k ? L = t[16] : (L = function() {
		l(!0), k("");
	}, t[15] = k, t[16] = L);
	let ee = L, R;
	t[17] === Symbol.for("react.memo_cache_sentinel") ? (R = function() {
		j(), l(!1), d(""), m([]), g(null);
	}, t[17] = R) : R = t[17];
	let z = R, te;
	t[18] === Symbol.for("react.memo_cache_sentinel") ? (te = function() {
		z(), _.current?.focus();
	}, t[18] = te) : te = t[18];
	let B = te, V;
	t[19] === Symbol.for("react.memo_cache_sentinel") ? (V = function(e) {
		g(e), v.current?.querySelector(`[id="${tw(e)}"]`)?.scrollIntoView({ block: "nearest" });
	}, t[19] = V) : V = t[19];
	let ne = V, re;
	t[20] === D.length ? re = t[21] : (re = function(e) {
		return e === null || e === D.length - 1 ? 0 : e + 1;
	}, t[20] = D.length, t[21] = re);
	let ie = re, ae;
	t[22] === D.length ? ae = t[23] : (ae = function(e) {
		return e === null || e === 0 ? D.length - 1 : e - 1;
	}, t[22] = D.length, t[23] = ae);
	let oe = ae, H;
	t[24] === i ? H = t[25] : (H = function(e) {
		i(e), B();
	}, t[24] = i, t[25] = H);
	let se = H, ce;
	t[26] !== h || t[27] !== ie || t[28] !== oe || t[29] !== se || t[30] !== D ? (ce = function(e) {
		if (e.key === "Escape") {
			B();
			return;
		}
		if (e.key === "Tab") {
			z();
			return;
		}
		if (e.key === "Enter") {
			e.preventDefault();
			let t = h === null ? void 0 : D[h];
			t && se(t);
			return;
		}
		D.length !== 0 && (e.key === "ArrowDown" ? (e.preventDefault(), ne(ie(h))) : e.key === "ArrowUp" ? (e.preventDefault(), ne(oe(h))) : e.key === "Home" ? (e.preventDefault(), ne(0)) : e.key === "End" && (e.preventDefault(), ne(D.length - 1)));
	}, t[26] = h, t[27] = ie, t[28] = oe, t[29] = se, t[30] = D, t[31] = ce) : ce = t[31];
	let le = ce, ue = c ? ew : void 0, de = c ? "" : void 0, fe;
	t[32] !== c || t[33] !== ee ? (fe = () => {
		c ? z() : ee();
	}, t[32] = c, t[33] = ee, t[34] = fe) : fe = t[34];
	let pe;
	t[35] !== n || t[36] !== s || t[37] !== a || t[38] !== o ? (pe = BC(n, s, {
		isDemoMode: a,
		isStaff: o
	}), t[35] = n, t[36] = s, t[37] = a, t[38] = o, t[39] = pe) : pe = t[39];
	let me;
	t[40] === pe ? me = t[41] : (me = /* @__PURE__ */ (0, C.jsx)("span", {
		className: `${ZC.name} text-300--medium`,
		id: QC,
		children: pe
	}), t[40] = pe, t[41] = me);
	let he;
	t[42] === Symbol.for("react.memo_cache_sentinel") ? (he = /* @__PURE__ */ (0, C.jsx)("span", {
		"aria-hidden": !0,
		className: ZC.chevron,
		children: /* @__PURE__ */ (0, C.jsx)(N, {
			color: "inherit",
			name: "chevron-down",
			size: "small"
		})
	}), t[42] = he) : he = t[42];
	let ge;
	t[43] !== a || t[44] !== c || t[45] !== ue || t[46] !== de || t[47] !== fe || t[48] !== me ? (ge = /* @__PURE__ */ (0, C.jsxs)("button", {
		"aria-controls": ue,
		"aria-expanded": c,
		"aria-haspopup": "listbox",
		"aria-labelledby": QC,
		className: ZC.trigger,
		"data-open": de,
		disabled: a,
		onClick: fe,
		ref: _,
		type: "button",
		children: [me, he]
	}), t[43] = a, t[44] = c, t[45] = ue, t[46] = de, t[47] = fe, t[48] = me, t[49] = ge) : ge = t[49];
	let _e;
	t[50] === Symbol.for("react.memo_cache_sentinel") ? (_e = (e, t) => {
		t.reason === "outside-press" ? z() : B();
	}, t[50] = _e) : _e = t[50];
	let ve;
	t[51] === h ? ve = t[52] : (ve = h === null ? void 0 : tw(h), t[51] = h, t[52] = ve);
	let ye;
	t[53] === P ? ye = t[54] : (ye = (e) => {
		d(e.target.value), g(null), P(e.target.value);
	}, t[53] = P, t[54] = ye);
	let be;
	t[55] !== le || t[56] !== T || t[57] !== u || t[58] !== ve || t[59] !== ye ? (be = /* @__PURE__ */ (0, C.jsx)("input", {
		"aria-activedescendant": ve,
		"aria-autocomplete": "list",
		"aria-controls": ew,
		"aria-expanded": !0,
		"aria-label": T,
		className: `${ZC.input} text-300--regular`,
		onChange: ye,
		onKeyDown: le,
		placeholder: T,
		ref: sw,
		role: "combobox",
		type: "search",
		value: u
	}), t[55] = le, t[56] = T, t[57] = u, t[58] = ve, t[59] = ye, t[60] = be) : be = t[60];
	let xe;
	t[61] === Symbol.for("react.memo_cache_sentinel") ? (xe = /* @__PURE__ */ (0, C.jsx)("span", {
		"aria-hidden": !0,
		className: ZC["search-icon"],
		children: /* @__PURE__ */ (0, C.jsx)(N, {
			name: "search",
			size: "small"
		})
	}), t[61] = xe) : xe = t[61];
	let Se;
	t[62] === be ? Se = t[63] : (Se = /* @__PURE__ */ (0, C.jsx)("div", {
		className: ZC.search,
		children: /* @__PURE__ */ (0, C.jsxs)("div", {
			className: ZC["search-wrapper"],
			children: [be, xe]
		})
	}), t[62] = be, t[63] = Se);
	let Ce;
	if (t[64] !== s || t[65] !== h || t[66] !== se || t[67] !== D) {
		let e;
		t[69] !== s || t[70] !== h || t[71] !== se ? (e = (e, t) => {
			let n = VC(e, s), r = HC(e, s), i = nw[e.type];
			return /* @__PURE__ */ (0, C.jsxs)("li", {
				"aria-label": n,
				"aria-selected": t === h,
				className: `${ZC.item} text-300--regular`,
				"data-highlighted": t === h ? "" : void 0,
				id: tw(t),
				onClick: () => {
					se(e);
				},
				onMouseDown: ow,
				onPointerMove: () => {
					g(t);
				},
				role: "option",
				children: [/* @__PURE__ */ (0, C.jsx)(N, {
					"aria-hidden": !0,
					"data-testid": i,
					name: i,
					size: "small"
				}), /* @__PURE__ */ (0, C.jsxs)("span", {
					className: ZC["option-text"],
					children: [/* @__PURE__ */ (0, C.jsx)("span", {
						className: ZC["option-label"],
						children: n
					}), r && /* @__PURE__ */ (0, C.jsx)("span", {
						className: `${ZC["option-sub-label"]} text-200--regular`,
						title: r,
						children: r
					})]
				})]
			}, `${e.type}-${e.id}`);
		}, t[69] = s, t[70] = h, t[71] = se, t[72] = e) : e = t[72], Ce = D.map(e), t[64] = s, t[65] = h, t[66] = se, t[67] = D, t[68] = Ce;
	} else Ce = t[68];
	let we;
	t[73] === Ce ? we = t[74] : (we = /* @__PURE__ */ (0, C.jsx)("ul", {
		className: ZC.list,
		id: ew,
		ref: v,
		role: "listbox",
		children: Ce
	}), t[73] = Ce, t[74] = we);
	let Te;
	t[75] !== Se || t[76] !== we ? (Te = /* @__PURE__ */ (0, C.jsx)(N_.Content, {
		anchor: _,
		"aria-labelledby": QC,
		id: $C,
		side: "bottom",
		sideOffset: 4,
		children: /* @__PURE__ */ (0, C.jsxs)("div", {
			className: ZC.popup,
			children: [Se, we]
		})
	}), t[75] = Se, t[76] = we, t[77] = Te) : Te = t[77];
	let Ee;
	t[78] !== c || t[79] !== Te ? (Ee = /* @__PURE__ */ (0, C.jsx)(N_, {
		onOpenChange: _e,
		open: c,
		children: Te
	}), t[78] = c, t[79] = Te, t[80] = Ee) : Ee = t[80];
	let De;
	return t[81] !== ge || t[82] !== Ee ? (De = /* @__PURE__ */ (0, C.jsxs)(C.Fragment, { children: [ge, Ee] }), t[81] = ge, t[82] = Ee, t[83] = De) : De = t[83], De;
}
function ow(e) {
	e.preventDefault();
}
function sw(e) {
	e?.focus();
}
//#endregion
//#region ../../node_modules/.pnpm/@mylighthouse+prism-logo@1.0.0/node_modules/@mylighthouse/prism-logo/dist/index.mjs
var cw = {
	"logo-color-with-text": "<svg width=\"190\" height=\"40\" viewBox=\"0 0 190 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"logo-color-with-text\"><g clip-path=\"url(#{{UNIQUE_ID}}__Type=Type5, Color=Color__a)\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"><path d=\"M35.077 8h-2.744v23.884h2.744V8Zm7.439 7.597h-2.743v16.287h2.743V15.597Zm-1.397-7.116c-.993 0-1.683.68-1.683 1.659 0 .978.69 1.675 1.683 1.675.993 0 1.717-.697 1.717-1.675 0-.979-.707-1.659-1.717-1.659Zm19.659 9.786c-1.245-1.742-3.4-3.002-6.362-3.002-4.73 0-8.332 3.55-8.332 8.426 0 4.893 3.602 8.525 8.332 8.525 2.962 0 5.167-1.31 6.362-3.019v1.908c0 3.317-2.44 5.44-6.278 5.44-2.306 0-4.326-.895-5.84-2.504l-1.801 1.758c1.784 2.056 4.56 3.201 7.64 3.201 5.505 0 9.023-3.234 9.023-8.293v-15.11h-2.744v2.67Zm-6.093 11.511c-3.45 0-5.89-2.72-5.89-6.087 0-3.35 2.44-5.988 5.89-5.988 3.535 0 6.127 2.637 6.127 5.988 0 3.367-2.592 6.087-6.127 6.087Zm21.729-14.513c-2.625 0-4.595 1.277-5.52 2.786V8h-2.76v23.884h2.743v-9.188c0-2.97 2.289-4.893 5.117-4.893 2.962 0 4.645 1.658 4.645 4.826v9.255h2.727v-9.902c-.017-4.196-2.626-6.717-6.952-6.717Zm17.892 14.529c-1.683 0-2.861-.928-2.861-3.068V17.92h5.437v-2.322h-5.454v-5.225h-2.693v5.225h-3.063v2.322h3.046v9.238c0 3.318 2.121 5.06 5.302 5.06 1.347 0 2.777-.333 3.484-.73l-.37-2.323c-.791.398-1.919.63-2.828.63Zm15.233-14.529c-2.626 0-4.595 1.277-5.521 2.786V8h-2.76v23.884h2.743v-9.188c0-2.97 2.289-4.893 5.117-4.893 2.962 0 4.645 1.658 4.645 4.826v9.255h2.71v-9.902c0-4.196-2.609-6.717-6.934-6.717Zm18.969 0c-5.033 0-8.786 3.715-8.786 8.476 0 4.76 3.753 8.475 8.786 8.475 5.032 0 8.786-3.715 8.786-8.476-.017-4.76-3.754-8.475-8.786-8.475Zm0 14.447c-3.484 0-6.043-2.621-6.043-5.971 0-3.351 2.559-5.972 6.043-5.972s6.042 2.621 6.042 5.972c0 3.35-2.575 5.97-6.042 5.97Zm23.934-4.91c0 2.969-2.256 4.876-5.117 4.876-2.945 0-4.612-1.642-4.612-4.81v-9.271h-2.726v9.918c0 4.18 2.592 6.701 6.9 6.701 2.66 0 4.612-1.26 5.538-2.786v2.454h2.743V15.597h-2.743v9.205h.017Zm13.213-2.272c-2.811-.664-4.124-1.078-4.124-2.638 0-1.343 1.346-2.206 3.45-2.206 2.138 0 3.501.98 4.292 2.123l1.869-1.525c-.977-1.593-3.182-3.02-6.161-3.02-3.4 0-6.143 1.825-6.143 4.678 0 3.119 2.508 4.197 6.042 4.976 2.794.614 3.922 1.078 3.922 2.588 0 1.393-1.532 2.288-3.686 2.288-2.39 0-4.023-1.127-4.932-2.753l-2.104 1.51c1.195 2.239 3.619 3.665 7.036 3.665 3.467 0 6.43-1.824 6.43-4.71-.017-3.003-2.34-4.13-5.891-4.976Zm24.22.381c0-4.777-3.838-7.646-7.961-7.646-4.696 0-8.5 3.699-8.5 8.476 0 4.776 3.669 8.475 8.634 8.475 3.097 0 5.773-1.393 7.288-3.699l-2.087-1.492c-1.195 1.658-2.895 2.736-5.218 2.736-3.433 0-5.705-2.388-5.874-5.357h13.617c.084-.465.101-1.012.101-1.493Zm-13.6-.73c.404-2.687 2.794-4.461 5.639-4.461 2.811 0 5.032 1.774 5.217 4.461h-10.856ZM9 26.996h13.5a1.501 1.501 0 0 0 0-3.002H11.516L9 26.996Zm3.052-14.521a1.5 1.5 0 0 0-2.296-1.928L0 22.177v4.668l12.052-14.37Z\"/><path d=\"M22.502 29H4.714L16.5 14.945l3.76-4.482a1.5 1.5 0 1 0-2.298-1.928L.8 28.997l-.8.954V32h22.502a1.5 1.5 0 0 0 0-3Z\"/></g><defs><clipPath id=\"{{UNIQUE_ID}}__Type=Type5, Color=Color__a\"><path fill=\"var(--prism-color-icon-inverse, #FFFFFF)\" d=\"M0 0h189.875v40H0z\"/></clipPath></defs></svg>",
	"logo-color": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"logo-color\"><path d=\"M17 26.997h13.5a1.501 1.501 0 0 0 0-3.003H19.516L17 26.997Zm3.052-14.521a1.5 1.5 0 0 0-2.296-1.928L8 22.178v4.668l12.052-14.37Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/><path d=\"M30.502 29H12.714L24.5 14.946l3.76-4.48a1.5 1.5 0 1 0-2.298-1.929L8.8 28.998l-.8.954V32h22.502a1.5 1.5 0 0 0 0-3Z\" fill=\"var(--prism-color-icon-brand-default, #fd8237)\"/></svg>",
	"logo-dark-with-text": "<svg width=\"190\" height=\"40\" viewBox=\"0 0 190 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"logo-dark-with-text\"><g clip-path=\"url(#{{UNIQUE_ID}}__Type=Full logo, Color=Default__a)\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"><path d=\"M35.077 8h-2.744v23.884h2.744V8Zm7.439 7.597h-2.743v16.287h2.743V15.597Zm-1.397-7.116c-.993 0-1.683.68-1.683 1.659 0 .978.69 1.675 1.683 1.675.993 0 1.717-.697 1.717-1.675 0-.979-.707-1.659-1.717-1.659Zm19.659 9.786c-1.245-1.742-3.4-3.002-6.362-3.002-4.73 0-8.332 3.55-8.332 8.426 0 4.893 3.602 8.525 8.332 8.525 2.962 0 5.167-1.31 6.362-3.019v1.908c0 3.317-2.44 5.44-6.278 5.44-2.306 0-4.326-.895-5.84-2.504l-1.801 1.758c1.784 2.056 4.56 3.201 7.64 3.201 5.505 0 9.023-3.234 9.023-8.293v-15.11h-2.744v2.67Zm-6.093 11.511c-3.45 0-5.89-2.72-5.89-6.087 0-3.35 2.44-5.988 5.89-5.988 3.535 0 6.127 2.637 6.127 5.988 0 3.367-2.592 6.087-6.127 6.087Zm21.729-14.513c-2.625 0-4.595 1.277-5.52 2.786V8h-2.76v23.884h2.743v-9.188c0-2.97 2.289-4.893 5.117-4.893 2.962 0 4.645 1.658 4.645 4.826v9.255h2.727v-9.902c-.017-4.196-2.626-6.717-6.952-6.717Zm17.892 14.529c-1.683 0-2.861-.928-2.861-3.068V17.92h5.437v-2.322h-5.454v-5.225h-2.693v5.225h-3.063v2.322h3.046v9.238c0 3.318 2.121 5.06 5.302 5.06 1.347 0 2.777-.333 3.484-.73l-.37-2.323c-.791.398-1.919.63-2.828.63Zm15.233-14.529c-2.626 0-4.595 1.277-5.521 2.786V8h-2.76v23.884h2.743v-9.188c0-2.97 2.289-4.893 5.117-4.893 2.962 0 4.645 1.658 4.645 4.826v9.255h2.71v-9.902c0-4.196-2.609-6.717-6.934-6.717Zm18.969 0c-5.033 0-8.786 3.715-8.786 8.476 0 4.76 3.753 8.475 8.786 8.475 5.032 0 8.786-3.715 8.786-8.476-.017-4.76-3.754-8.475-8.786-8.475Zm0 14.447c-3.484 0-6.043-2.621-6.043-5.971 0-3.351 2.559-5.972 6.043-5.972s6.042 2.621 6.042 5.972c0 3.35-2.575 5.97-6.042 5.97Zm23.934-4.91c0 2.969-2.256 4.876-5.117 4.876-2.945 0-4.612-1.642-4.612-4.81v-9.271h-2.726v9.918c0 4.18 2.592 6.701 6.9 6.701 2.66 0 4.612-1.26 5.538-2.786v2.454h2.743V15.597h-2.743v9.205h.017Zm13.213-2.272c-2.811-.664-4.124-1.078-4.124-2.638 0-1.343 1.346-2.206 3.45-2.206 2.138 0 3.501.98 4.292 2.123l1.869-1.525c-.977-1.593-3.182-3.02-6.161-3.02-3.4 0-6.143 1.825-6.143 4.678 0 3.119 2.508 4.197 6.042 4.976 2.794.614 3.922 1.078 3.922 2.588 0 1.393-1.532 2.288-3.686 2.288-2.39 0-4.023-1.127-4.932-2.753l-2.104 1.51c1.195 2.239 3.619 3.665 7.036 3.665 3.467 0 6.43-1.824 6.43-4.71-.017-3.003-2.34-4.13-5.891-4.976Zm24.22.381c0-4.777-3.838-7.646-7.961-7.646-4.696 0-8.5 3.699-8.5 8.476 0 4.776 3.669 8.475 8.634 8.475 3.097 0 5.773-1.393 7.288-3.699l-2.087-1.492c-1.195 1.658-2.895 2.736-5.218 2.736-3.433 0-5.705-2.388-5.874-5.357h13.617c.084-.465.101-1.012.101-1.493Zm-13.6-.73c.404-2.687 2.794-4.461 5.639-4.461 2.811 0 5.032 1.774 5.217 4.461h-10.856ZM9 26.996h13.5a1.501 1.501 0 0 0 0-3.002H11.516L9 26.996Zm3.052-14.521a1.5 1.5 0 0 0-2.296-1.928L0 22.177v4.668l12.052-14.37Z\"/><path d=\"M22.502 29H4.714L16.5 14.945l3.76-4.482a1.5 1.5 0 1 0-2.298-1.928L.8 28.997l-.8.954V32h22.502a1.5 1.5 0 0 0 0-3Z\"/></g><defs><clipPath id=\"{{UNIQUE_ID}}__Type=Full logo, Color=Default__a\"><path fill=\"var(--prism-color-icon-inverse, #FFFFFF)\" d=\"M0 0h189.875v40H0z\"/></clipPath></defs></svg>",
	"logo-dark": "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" alt=\"logo-dark\"><path d=\"M17 26.997h13.5a1.501 1.501 0 0 0 0-3.003H19.516L17 26.997Zm3.052-14.521a1.5 1.5 0 0 0-2.296-1.928L8 22.178v4.668l12.052-14.37Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/><path d=\"M30.502 29H12.714L24.5 14.946l3.76-4.48a1.5 1.5 0 1 0-2.298-1.929L8.8 28.998l-.8.954V32h22.502a1.5 1.5 0 0 0 0-3Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/></svg>"
};
//#endregion
//#region src/general/components/header/home-link.tsx
function lw(e) {
	let t = (0, x.c)(5), { children: n } = e, { formatMessage: r } = cC(), i;
	t[0] === r ? i = t[1] : (i = r({ id: "menu.home" }), t[0] = r, t[1] = i);
	let a;
	return t[2] !== n || t[3] !== i ? (a = /* @__PURE__ */ (0, C.jsx)("a", {
		"aria-label": i,
		href: "/",
		children: n
	}), t[2] = n, t[3] = i, t[4] = a) : a = t[4], a;
}
//#endregion
//#region src/general/components/header/logo.module.css
var uw = "_cycle_188ag_1", dw = {
	"default-logo": "_default-logo_188ag_1",
	"holidays-logo": "_holidays-logo_188ag_2",
	"holidays-container": "_holidays-container_188ag_6",
	"holidays-logo-1": "_holidays-logo-1_188ag_16",
	cycle: uw,
	"holidays-logo-2": "_holidays-logo-2_188ag_25",
	"holidays-logo-3": "_holidays-logo-3_188ag_29"
}, fw = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8 27.0002V24.3335H10L8 27.0002Z\" fill=\"var(--prism-color-general-brand-500, #FD8237)\"/>\n<path d=\"M29.6667 12.6669C25.6667 6.66685 21 11.3336 21 11.3336\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path d=\"M10.0002 27.9998C8.79031 27.3399 7.90211 26.11 7.50023 24.9524C6.4001 21.7833 8.02577 19.9075 10.0002 20.4998\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path d=\"M12 21.5C12 21.5 15 24 15.5 23.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path d=\"M17 26.9972H30.5C30.8982 26.9972 31.2801 26.839 31.5617 26.5574C31.8433 26.2758 32.0015 25.8939 32.0015 25.4957C32.0015 25.0975 31.8433 24.7156 31.5617 24.434C31.2801 24.1524 30.8982 23.9942 30.5 23.9942H19.516L17 26.9972ZM20.052 12.4762C20.2913 12.1699 20.4023 11.7827 20.3618 11.3962C20.3212 11.0097 20.1322 10.6539 19.8346 10.404C19.5369 10.1541 19.1539 10.0294 18.7662 10.0563C18.3784 10.0832 18.0163 10.2596 17.756 10.5482L8 22.1782V26.8462L20.052 12.4762Z\" fill=\"var(--prism-color-general-brand-500, #FD8237)\"/>\n<path d=\"M30.502 29.0001H12.714L24.5 14.9461L28.26 10.4661C28.5158 10.1614 28.6401 9.76752 28.6055 9.37116C28.5709 8.9748 28.3802 8.60842 28.0755 8.35262C27.7708 8.09682 27.3769 7.97255 26.9805 8.00715C26.5842 8.04175 26.2178 8.23239 25.962 8.53712L8.8 28.9981L8 29.9521V32.0001H30.502C30.8998 32.0001 31.2814 31.8421 31.5627 31.5608C31.844 31.2795 32.002 30.8979 32.002 30.5001C32.002 30.1023 31.844 29.7207 31.5627 29.4394C31.2814 29.1581 30.8998 29.0001 30.502 29.0001Z\" fill=\"var(--prism-color-general-brand-500, #FD8237)\"/>\n<path d=\"M17.0004 14.4998C13.5004 13.9998 14.5004 18.9998 15.5004 20.9998C16.5004 22.9998 19.5004 26.9998 16.5004 24.4998\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path d=\"M9.99997 28C8.79008 27.34 7.5 25 7.5 21.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.6909 11.3745C17.6454 11.6209 16.6618 12.3186 16.1408 13.221C15.2434 14.7755 14.3083 19.3799 15.9026 20.3004C17.4969 21.2208 21.0168 18.1088 21.9143 16.5544C22.4354 15.6519 22.5478 14.4512 22.2384 13.4226L18.6909 11.3745Z\" fill=\"#98E3B3\"/>\n<path d=\"M19.0658 10.8212C19.434 10.1835 20.2493 9.96495 20.8871 10.3331L22.0418 10.9998C22.6795 11.368 22.898 12.1835 22.5298 12.8212L22.1965 13.3985L18.7324 11.3985L19.0658 10.8212Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.0771 30.7883C10.4507 31.7953 11.2644 32.6853 12.2243 33.0909C13.8776 33.7896 18.5623 34.1491 19.2789 32.4533C19.9955 30.7576 16.4727 27.6487 14.8193 26.95C13.8595 26.5444 12.6541 26.5811 11.6716 27.015L10.0771 30.7883Z\" fill=\"#FFDE96\"/>\n<path d=\"M9.48167 30.4843C8.80337 30.1977 8.48586 29.4155 8.7725 28.7372L9.29151 27.509C9.57815 26.8307 10.3604 26.5132 11.0387 26.7998L11.6528 27.0593L10.0957 30.7439L9.48167 30.4843Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28.5127 15.1484C28.2475 16.1893 28.4109 17.3841 28.9698 18.2635C29.9326 19.7783 33.5818 22.7378 35.1355 21.7503C36.6892 20.7628 35.559 16.2024 34.5962 14.6875C34.0373 13.8081 33.0249 13.1529 31.9699 12.9512L28.5127 15.1484Z\" fill=\"#ADD8FF\"/>\n<path d=\"M28.1955 14.5603C27.8006 13.9388 27.9842 13.1148 28.6056 12.7198L29.7309 12.0046C30.3524 11.6096 31.1764 11.7932 31.5714 12.4147L31.929 12.9774L28.5531 15.1229L28.1955 14.5603Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n</svg>\n", pw = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8 27.0002V24.3335H10L8 27.0002Z\" fill=\"var(--prism-color-general-brand-500, #FD8237)\"/>\n<path d=\"M29.6667 12.6669C25.6667 6.66685 21 11.3336 21 11.3336\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path d=\"M10.0002 27.9998C8.79031 27.3399 7.90211 26.11 7.50023 24.9524C6.4001 21.7833 8.02577 19.9075 10.0002 20.4998\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path d=\"M12 21.5C12 21.5 15 24 15.5 23.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path d=\"M17 26.9972H30.5C30.8982 26.9972 31.2801 26.839 31.5617 26.5574C31.8433 26.2758 32.0015 25.8939 32.0015 25.4957C32.0015 25.0975 31.8433 24.7156 31.5617 24.434C31.2801 24.1524 30.8982 23.9942 30.5 23.9942H19.516L17 26.9972ZM20.052 12.4762C20.2913 12.1699 20.4023 11.7827 20.3618 11.3962C20.3212 11.0097 20.1322 10.6539 19.8346 10.404C19.5369 10.1541 19.1539 10.0294 18.7662 10.0563C18.3784 10.0832 18.0163 10.2596 17.756 10.5482L8 22.1782V26.8462L20.052 12.4762Z\" fill=\"var(--prism-color-general-brand-500, #FD8237)\"/>\n<path d=\"M30.502 29.0001H12.714L24.5 14.9461L28.26 10.4661C28.5158 10.1614 28.6401 9.76752 28.6055 9.37116C28.5709 8.9748 28.3802 8.60842 28.0755 8.35262C27.7708 8.09682 27.3769 7.97255 26.9805 8.00715C26.5842 8.04175 26.2178 8.23239 25.962 8.53712L8.8 28.9981L8 29.9521V32.0001H30.502C30.8998 32.0001 31.2814 31.8421 31.5627 31.5608C31.844 31.2795 32.002 30.8979 32.002 30.5001C32.002 30.1023 31.844 29.7207 31.5627 29.4394C31.2814 29.1581 30.8998 29.0001 30.502 29.0001Z\" fill=\"var(--prism-color-general-brand-500, #FD8237)\"/>\n<path d=\"M17.0004 14.4998C13.5004 13.9998 14.5004 18.9998 15.5004 20.9998C16.5004 22.9998 19.5004 26.9998 16.5004 24.4998\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path d=\"M9.99997 28C8.79008 27.34 7.5 25 7.5 21.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.6909 11.3745C17.6454 11.6209 16.6618 12.3186 16.1408 13.221C15.2434 14.7755 14.3083 19.3799 15.9026 20.3004C17.4969 21.2208 21.0168 18.1088 21.9143 16.5544C22.4354 15.6519 22.5478 14.4512 22.2384 13.4226L18.6909 11.3745Z\" fill=\"#ADD8FF\"/>\n<path d=\"M19.0658 10.8212C19.434 10.1835 20.2493 9.96495 20.8871 10.3331L22.0418 10.9998C22.6795 11.368 22.898 12.1835 22.5298 12.8212L22.1965 13.3985L18.7324 11.3985L19.0658 10.8212Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.0771 30.7883C10.4507 31.7953 11.2644 32.6853 12.2243 33.0909C13.8776 33.7896 18.5623 34.1491 19.2789 32.4533C19.9955 30.7576 16.4727 27.6487 14.8193 26.95C13.8595 26.5444 12.6541 26.5811 11.6716 27.015L10.0771 30.7883Z\" fill=\"#98E3B3\"/>\n<path d=\"M9.48167 30.4843C8.80337 30.1977 8.48586 29.4155 8.7725 28.7372L9.29151 27.509C9.57815 26.8307 10.3604 26.5132 11.0387 26.7998L11.6528 27.0593L10.0957 30.7439L9.48167 30.4843Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28.5127 15.1484C28.2475 16.1893 28.4109 17.3841 28.9698 18.2635C29.9326 19.7784 33.5818 22.7378 35.1355 21.7503C36.6892 20.7628 35.559 16.2024 34.5962 14.6875C34.0373 13.8081 33.0249 13.1529 31.9699 12.9512L28.5127 15.1484Z\" fill=\"#FFDE96\"/>\n<path d=\"M28.1955 14.5603C27.8006 13.9388 27.9842 13.1148 28.6056 12.7198L29.7309 12.0046C30.3524 11.6096 31.1764 11.7932 31.5714 12.4147L31.929 12.9774L28.5531 15.1229L28.1955 14.5603Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n</svg>\n", mw = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8 27.0002V24.3335H10L8 27.0002Z\" fill=\"var(--prism-color-general-brand-500, #FD8237)\"/>\n<path d=\"M29.6667 12.6669C25.6667 6.66685 21 11.3336 21 11.3336\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path d=\"M10.0002 27.9998C8.79031 27.3399 7.90211 26.11 7.50023 24.9524C6.4001 21.7833 8.02577 19.9075 10.0002 20.4998\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path d=\"M12 21.5C12 21.5 15 24 15.5 23.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path d=\"M17 26.9972H30.5C30.8982 26.9972 31.2801 26.839 31.5617 26.5574C31.8433 26.2758 32.0015 25.8939 32.0015 25.4957C32.0015 25.0975 31.8433 24.7156 31.5617 24.434C31.2801 24.1524 30.8982 23.9942 30.5 23.9942H19.516L17 26.9972ZM20.052 12.4762C20.2913 12.1699 20.4023 11.7827 20.3618 11.3962C20.3212 11.0097 20.1322 10.6539 19.8346 10.404C19.5369 10.1541 19.1539 10.0294 18.7662 10.0563C18.3784 10.0832 18.0163 10.2596 17.756 10.5482L8 22.1782V26.8462L20.052 12.4762Z\" fill=\"var(--prism-color-general-brand-500, #FD8237)\"/>\n<path d=\"M30.502 29.0001H12.714L24.5 14.9461L28.26 10.4661C28.5158 10.1614 28.6401 9.76752 28.6055 9.37116C28.5709 8.9748 28.3802 8.60842 28.0755 8.35262C27.7708 8.09682 27.3769 7.97255 26.9805 8.00715C26.5842 8.04175 26.2178 8.23239 25.962 8.53712L8.8 28.9981L8 29.9521V32.0001H30.502C30.8998 32.0001 31.2814 31.8421 31.5627 31.5608C31.844 31.2795 32.002 30.8979 32.002 30.5001C32.002 30.1023 31.844 29.7207 31.5627 29.4394C31.2814 29.1581 30.8998 29.0001 30.502 29.0001Z\" fill=\"var(--prism-color-general-brand-500, #FD8237)\"/>\n<path d=\"M17.0004 14.4998C13.5004 13.9998 14.5004 18.9998 15.5004 20.9998C16.5004 22.9998 19.5004 26.9998 16.5004 24.4998\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path d=\"M10 28C8.79008 27.34 7.5 25 7.5 21.5\" stroke=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\" stroke-width=\"2\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.6909 11.3745C17.6454 11.6209 16.6618 12.3186 16.1408 13.221C15.2434 14.7755 14.3083 19.3799 15.9026 20.3004C17.4969 21.2208 21.0168 18.1088 21.9143 16.5544C22.4354 15.6519 22.5478 14.4512 22.2384 13.4226L18.6909 11.3745Z\" fill=\"#FFDE96\"/>\n<path d=\"M19.0658 10.8212C19.434 10.1835 20.2493 9.96495 20.8871 10.3331L22.0418 10.9998C22.6795 11.368 22.898 12.1835 22.5298 12.8212L22.1965 13.3985L18.7324 11.3985L19.0658 10.8212Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.0771 30.7883C10.4507 31.7953 11.2644 32.6853 12.2243 33.0909C13.8776 33.7896 18.5623 34.1491 19.2789 32.4533C19.9955 30.7576 16.4727 27.6487 14.8193 26.95C13.8595 26.5444 12.6541 26.5811 11.6716 27.015L10.0771 30.7883Z\" fill=\"#ADD8FF\"/>\n<path d=\"M9.48167 30.4843C8.80337 30.1977 8.48586 29.4155 8.7725 28.7372L9.29151 27.509C9.57815 26.8307 10.3604 26.5132 11.0387 26.7998L11.6528 27.0593L10.0957 30.7439L9.48167 30.4843Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28.5127 15.1484C28.2475 16.1893 28.4109 17.3841 28.9698 18.2635C29.9326 19.7783 33.5818 22.7378 35.1355 21.7503C36.6892 20.7628 35.559 16.2024 34.5962 14.6875C34.0373 13.8081 33.0249 13.1529 31.9699 12.9512L28.5127 15.1484Z\" fill=\"#98E3B3\"/>\n<path d=\"M28.1955 14.5603C27.8006 13.9388 27.9842 13.1148 28.6056 12.7198L29.7309 12.0046C30.3524 11.6096 31.1764 11.7932 31.5714 12.4147L31.929 12.9774L28.5531 15.1229L28.1955 14.5603Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n</svg>\n", hw = "<svg width=\"298\" height=\"169\" viewBox=\"0 0 298 169\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M73.5001 46C76.2615 46 78.5 48.2387 78.5001 51V120C78.5001 122.761 76.2615 125 73.5001 125C70.7387 125 68.5001 122.761 68.5001 120V83.9317C68.337 79.5077 67.1629 75.1477 65.0284 71.1993C61.7801 65.1909 56.5164 60.5207 50.1641 58.0108C43.8118 55.5009 36.7777 55.3122 30.2999 57.4776C23.8221 59.643 18.3151 64.0233 14.7491 69.8487C11.1831 75.6741 9.78683 82.5713 10.8048 89.3252C11.8227 96.0791 15.19 102.258 20.3145 106.773C25.439 111.289 31.9922 113.852 38.8204 114.012C43.9749 114.133 49.0372 112.878 53.502 110.419C55.9159 109.089 59.0425 109.391 60.7657 111.542C62.4886 113.693 62.1548 116.864 59.8018 118.299C53.4511 122.171 46.0922 124.165 38.587 123.989C29.4103 123.774 20.6028 120.329 13.7159 114.261C6.82917 108.192 2.30362 99.889 0.935617 90.8125C-0.432381 81.7359 1.44507 72.4675 6.23737 64.6387C11.0297 56.8099 18.4302 50.9219 27.1358 48.0118C35.8413 45.1017 45.2943 45.3556 53.8311 48.7286C59.4824 50.9615 64.4924 54.467 68.5001 58.9239V51C68.5001 48.2387 70.7387 46.0001 73.5001 46Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M68.5001 51C68.5001 48.2387 70.7387 46.0001 73.5001 46C76.2615 46 78.5 48.2387 78.5001 51V120C78.5001 122.761 76.2615 125 73.5001 125C70.7387 125 68.5001 122.761 68.5001 120V51Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M106 51C106 49.067 104.433 47.5 102.5 47.5C100.567 47.5 99 49.067 99 51V94C99 95.933 100.567 97.5 102.5 97.5C104.433 97.5 106 95.933 106 94V51ZM109 94C109 97.5899 106.09 100.5 102.5 100.5C98.9101 100.5 96 97.5899 96 94V51C96 47.4101 98.9101 44.5 102.5 44.5C106.09 44.5 109 47.4101 109 51V94Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M97.5 110C97.5 107.239 99.7386 105 102.5 105C105.261 105 107.5 107.239 107.5 110V120C107.5 122.761 105.261 125 102.5 125C99.7386 125 97.5 122.761 97.5 120V110Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M130.5 0C127.739 0 125.5 2.23858 125.5 5V120C125.5 122.761 127.739 125 130.5 125C133.261 125 135.5 122.761 135.5 120V83.9316C135.663 79.5077 136.837 75.1476 138.972 71.1992C142.22 65.1909 147.484 60.5207 153.836 58.0107C160.188 55.5009 167.222 55.3121 173.7 57.4775C180.178 59.643 185.685 64.0233 189.251 69.8486C192.817 75.6741 194.213 82.5712 193.195 89.3252C192.177 96.079 188.81 102.258 183.685 106.773C178.561 111.289 172.008 113.852 165.18 114.012C160.025 114.132 154.963 112.878 150.498 110.419C148.084 109.089 144.957 109.391 143.234 111.542C141.511 113.693 141.845 116.864 144.198 118.299C150.549 122.171 157.908 124.165 165.413 123.989C174.59 123.774 183.397 120.329 190.284 114.261C197.171 108.192 201.696 99.889 203.064 90.8125C204.432 81.7359 202.555 72.4675 197.763 64.6387C192.97 56.8098 185.57 50.9219 176.864 48.0117C168.159 45.1017 158.706 45.3556 150.169 48.7285C144.518 50.9614 139.508 54.467 135.5 58.9238V5C135.5 2.2386 133.261 3.71088e-05 130.5 0Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M233.086 62.3996C231.027 60.5682 227.842 60.738 226.288 63.0143C221.662 69.7919 219.267 77.8972 219.518 86.184C219.821 96.1426 223.923 105.608 230.983 112.638C238.044 119.667 247.527 123.728 257.487 123.987C267.446 124.246 277.128 120.684 284.544 114.03C291.96 107.377 296.549 98.1378 297.368 88.2083C298.188 78.2789 295.176 68.4123 288.951 60.6332C282.726 52.8541 273.76 47.7524 263.892 46.3749C255.681 45.2287 247.364 46.7336 240.126 50.5998C237.695 51.8982 237.182 55.046 238.78 57.2913C240.378 59.5367 243.482 60.0164 245.967 58.8263C251.078 56.3794 256.829 55.4658 262.512 56.2592C269.855 57.2841 276.527 61.0803 281.159 66.8688C285.791 72.6572 288.032 79.9989 287.422 87.3874C286.812 94.7759 283.398 101.651 277.879 106.602C272.361 111.552 265.157 114.203 257.746 114.01C250.335 113.818 243.279 110.796 238.025 105.565C232.771 100.334 229.719 93.2913 229.494 85.8811C229.32 80.1453 230.85 74.5263 233.835 69.7107C235.287 67.3683 235.146 64.231 233.086 62.3996Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M110.5 32C110.5 36.4183 106.918 40 102.5 40C98.0817 40 94.5 36.4183 94.5 32C94.5 27.5817 98.0817 24 102.5 24C106.918 24 110.5 27.5817 110.5 32Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M277.746 154.364C277.639 153.464 277.207 152.766 276.449 152.268C275.692 151.771 274.763 151.523 273.662 151.523C272.857 151.523 272.152 151.653 271.549 151.913C270.951 152.174 270.483 152.532 270.146 152.988C269.815 153.443 269.649 153.961 269.649 154.541C269.649 155.027 269.764 155.444 269.995 155.793C270.232 156.136 270.534 156.423 270.901 156.654C271.268 156.879 271.652 157.065 272.055 157.213C272.457 157.355 272.827 157.471 273.165 157.56L275.011 158.057C275.485 158.181 276.011 158.353 276.591 158.572C277.177 158.791 277.737 159.09 278.269 159.468C278.808 159.841 279.252 160.321 279.601 160.907C279.95 161.493 280.125 162.212 280.125 163.064C280.125 164.046 279.867 164.934 279.352 165.727C278.843 166.52 278.098 167.151 277.115 167.618C276.139 168.086 274.952 168.32 273.555 168.32C272.253 168.32 271.126 168.109 270.173 167.689C269.226 167.269 268.48 166.683 267.935 165.931C267.397 165.18 267.092 164.307 267.021 163.312H269.294C269.353 163.999 269.584 164.567 269.986 165.017C270.395 165.461 270.91 165.792 271.531 166.011C272.158 166.224 272.833 166.331 273.555 166.331C274.396 166.331 275.15 166.195 275.819 165.923C276.488 165.644 277.018 165.26 277.408 164.768C277.799 164.271 277.994 163.691 277.994 163.028C277.994 162.425 277.825 161.933 277.488 161.555C277.151 161.176 276.707 160.868 276.156 160.631C275.606 160.395 275.011 160.187 274.372 160.01L272.135 159.371C270.714 158.962 269.59 158.379 268.761 157.622C267.932 156.864 267.518 155.873 267.518 154.648C267.518 153.63 267.793 152.742 268.344 151.984C268.9 151.221 269.646 150.629 270.581 150.209C271.522 149.783 272.573 149.57 273.733 149.57C274.905 149.57 275.946 149.78 276.858 150.2C277.769 150.614 278.491 151.182 279.024 151.904C279.563 152.627 279.847 153.446 279.876 154.364H277.746Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M248.397 149.818V168H246.266L236.358 153.724H236.181V168H233.979V149.818H236.11L246.053 164.129H246.23V149.818H248.397Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M215.277 158.909C215.277 160.827 214.931 162.484 214.238 163.881C213.546 165.277 212.596 166.355 211.388 167.112C210.181 167.87 208.802 168.249 207.251 168.249C205.701 168.249 204.322 167.87 203.114 167.112C201.907 166.355 200.957 165.277 200.265 163.881C199.572 162.484 199.226 160.827 199.226 158.909C199.226 156.991 199.572 155.334 200.265 153.938C200.957 152.541 201.907 151.464 203.114 150.706C204.322 149.948 205.701 149.57 207.251 149.57C208.802 149.57 210.181 149.948 211.388 150.706C212.596 151.464 213.546 152.541 214.238 153.938C214.931 155.334 215.277 156.991 215.277 158.909ZM213.146 158.909C213.146 157.335 212.883 156.006 212.356 154.923C211.835 153.84 211.128 153.02 210.234 152.464C209.347 151.907 208.352 151.629 207.251 151.629C206.151 151.629 205.153 151.907 204.26 152.464C203.372 153.02 202.665 153.84 202.138 154.923C201.617 156.006 201.357 157.335 201.357 158.909C201.357 160.483 201.617 161.812 202.138 162.895C202.665 163.978 203.372 164.798 204.26 165.354C205.153 165.911 206.151 166.189 207.251 166.189C208.352 166.189 209.347 165.911 210.234 165.354C211.128 164.798 211.835 163.978 212.356 162.895C212.883 161.812 213.146 160.483 213.146 158.909Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M180.522 149.818V168H178.32V149.818H180.522Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M146.286 151.771V149.818H159.922V151.771H154.205V168H152.003V151.771H146.286Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M125.681 149.818H127.883V161.857C127.883 163.099 127.59 164.209 127.004 165.186C126.424 166.156 125.604 166.923 124.545 167.485C123.486 168.041 122.243 168.32 120.816 168.32C119.39 168.32 118.147 168.041 117.088 167.485C116.028 166.923 115.206 166.156 114.62 165.186C114.04 164.209 113.75 163.099 113.75 161.857V149.818H115.951V161.679C115.951 162.567 116.147 163.357 116.537 164.049C116.928 164.736 117.484 165.277 118.206 165.674C118.934 166.065 119.804 166.26 120.816 166.26C121.828 166.26 122.698 166.065 123.426 165.674C124.154 165.277 124.711 164.736 125.095 164.049C125.486 163.357 125.681 162.567 125.681 161.679V149.818Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M84.6871 168V149.818H86.8888V166.047H95.3405V168H84.6871Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M65.985 158.909C65.985 160.827 65.6388 162.484 64.9463 163.881C64.2538 165.277 63.3039 166.355 62.0965 167.112C60.8891 167.87 59.5101 168.249 57.9594 168.249C56.4088 168.249 55.0297 167.87 53.8224 167.112C52.615 166.355 51.665 165.277 50.9726 163.881C50.2801 162.484 49.9339 160.827 49.9339 158.909C49.9339 156.991 50.2801 155.334 50.9726 153.938C51.665 152.541 52.615 151.464 53.8224 150.706C55.0297 149.948 56.4088 149.57 57.9594 149.57C59.5101 149.57 60.8891 149.948 62.0965 150.706C63.3039 151.464 64.2538 152.541 64.9463 153.938C65.6388 155.334 65.985 156.991 65.985 158.909ZM63.8543 158.909C63.8543 157.335 63.5909 156.006 63.0642 154.923C62.5434 153.84 61.8361 153.02 60.9424 152.464C60.0546 151.907 59.0603 151.629 57.9594 151.629C56.8586 151.629 55.8613 151.907 54.9676 152.464C54.0798 153.02 53.3725 153.84 52.8458 154.923C52.325 156.006 52.0645 157.335 52.0645 158.909C52.0645 160.483 52.325 161.812 52.8458 162.895C53.3725 163.978 54.0798 164.798 54.9676 165.354C55.8613 165.911 56.8586 166.189 57.9594 166.189C59.0603 166.189 60.0546 165.911 60.9424 165.354C61.8361 164.798 62.5434 163.978 63.0642 162.895C63.5909 161.812 63.8543 160.483 63.8543 158.909Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n<path d=\"M29.6449 154.364C29.5384 153.464 29.1063 152.766 28.3487 152.268C27.5911 151.771 26.6619 151.523 25.5611 151.523C24.7562 151.523 24.0518 151.653 23.4482 151.913C22.8504 152.174 22.3828 152.532 22.0455 152.988C21.714 153.443 21.5483 153.961 21.5483 154.541C21.5483 155.027 21.6637 155.444 21.8945 155.793C22.1313 156.136 22.4331 156.423 22.8001 156.654C23.167 156.879 23.5517 157.065 23.9542 157.213C24.3567 157.355 24.7266 157.471 25.0639 157.56L26.9105 158.057C27.384 158.181 27.9107 158.353 28.4908 158.572C29.0767 158.791 29.636 159.09 30.1687 159.468C30.7073 159.841 31.1512 160.321 31.5004 160.907C31.8496 161.493 32.0241 162.212 32.0241 163.064C32.0241 164.046 31.7667 164.934 31.2518 165.727C30.7428 166.52 29.997 167.151 29.0146 167.618C28.038 168.086 26.8513 168.32 25.4545 168.32C24.1525 168.32 23.025 168.109 22.0721 167.689C21.1251 167.269 20.3794 166.683 19.8349 165.931C19.2963 165.18 18.9915 164.307 18.9205 163.312H21.1932C21.2524 163.999 21.4832 164.567 21.8857 165.017C22.294 165.461 22.8089 165.792 23.4304 166.011C24.0578 166.224 24.7325 166.331 25.4545 166.331C26.295 166.331 27.0496 166.195 27.7184 165.923C28.3872 165.644 28.9169 165.26 29.3075 164.768C29.6982 164.271 29.8935 163.691 29.8935 163.028C29.8935 162.425 29.7248 161.933 29.3874 161.555C29.0501 161.176 28.6062 160.868 28.0558 160.631C27.5053 160.395 26.9105 160.187 26.2713 160.01L24.0341 159.371C22.6136 158.962 21.4891 158.379 20.6605 157.622C19.8319 156.864 19.4176 155.873 19.4176 154.648C19.4176 153.63 19.6928 152.742 20.2433 151.984C20.7996 151.221 21.5453 150.629 22.4805 150.209C23.4215 149.783 24.4721 149.57 25.6321 149.57C26.804 149.57 27.8456 149.78 28.7571 150.2C29.6686 150.614 30.3906 151.182 30.9233 151.904C31.4619 152.627 31.746 153.446 31.7756 154.364H29.6449Z\" fill=\"var(--prism-color-icon-neutral-subdued, #66768A)\"/>\n</svg>\n", gw = "<svg width=\"348\" height=\"64\" viewBox=\"0 0 348 64\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M181.959 1.15703C178.871 4.21266 182.035 9.72241 186.016 8.22412C188.482 7.29651 189.35 3.82855 187.7 1.49829C186.701 0.08675 183.248 -0.118631 181.959 1.15703ZM252.775 1.29238C251.592 2.58581 251.622 6.19696 252.826 7.26985C255.617 9.75951 259.401 8.07204 259.401 4.33704C259.401 3.18889 259.013 1.93988 258.474 1.34987C257.256 0.0177669 253.972 -0.0156787 252.775 1.29238ZM96.8874 3.122C93.8278 4.12173 92.5327 4.89569 89.8978 7.2986C85.597 11.2217 83.4352 17.3711 83.4352 25.6825C83.4352 34.0734 85.5938 40.1407 90.0134 44.1715C94.1056 47.9039 96.4173 48.6768 103.489 48.6768C109.173 48.6768 109.762 48.5775 112.654 47.1289C119.723 43.5883 123.559 36.043 123.559 25.6825C123.559 15.2008 119.494 7.44806 112.204 4.02975C108.954 2.50533 100.337 1.99475 96.8874 3.122ZM71.3922 6.72792C69.5822 7.59125 69.3049 9.53009 70.8181 10.7467C71.9542 11.6602 72.0535 12.1034 71.9452 15.7615C71.8364 19.4255 68.2117 38.8395 67.0994 41.7137C66.6705 42.8232 66.576 42.725 66.0071 40.5766C65.6649 39.2831 63.9098 33.6391 62.1072 28.0342L58.8295 17.8436L55.4065 17.692L51.9835 17.5405L47.7635 30.1654C43.795 42.0388 43.5198 42.6701 43.1422 40.7689C42.9209 39.6573 41.6697 32.7507 40.3614 25.4212C39.0532 18.0918 37.7312 10.8606 37.4244 9.35136L36.8666 6.60772H33.5023C31.6521 6.60772 30.0397 6.78384 29.9192 6.99967C29.745 7.31271 34.9573 34.2124 37.9742 48.5681L38.6101 51.595L42.36 51.4424L46.1094 51.2898L50.4497 38.5614C54.29 27.3005 54.8324 26.0348 55.1561 27.5869C55.3574 28.5516 57.1827 34.3483 59.2124 40.4679L62.9031 51.595L66.6626 51.4424L70.422 51.2898L74.0066 36.1345C79.3959 13.3513 79.6388 10.626 76.5549 7.57453C74.98 6.01562 73.4214 5.76059 71.3922 6.72792ZM0.894934 6.90979C0.310793 7.49196 0.402164 50.9078 0.98789 51.2658C1.25725 51.4304 5.00029 51.5872 9.30635 51.6138C18.2808 51.6692 22.3756 50.7521 26.2253 47.8245C33.2493 42.483 33.0296 32.1878 25.8049 28.1053L23.1668 26.6143L24.4734 25.7672C28.0438 23.4526 30.0249 18.6651 28.9892 14.8575C28.1383 11.7328 26.5237 9.89121 23.2312 8.29101C20.4309 6.93017 19.8943 6.86118 10.7979 6.69186C5.56912 6.59466 1.11306 6.69291 0.894934 6.90979ZM109.347 7.67748C111.977 9.00488 114.301 12.5005 115.194 16.4718C115.557 18.0887 115.855 22.2334 115.855 25.6825C115.855 33.0867 115.095 36.9565 113 40.2254C110.903 43.4974 107.984 44.9455 103.489 44.9455C99.0111 44.9455 96.0745 43.4953 94 40.2583C91.7627 36.7679 91.0787 33.3548 91.0787 25.6825C91.0787 15.2212 92.9933 10.0678 97.7435 7.74124C100.884 6.20271 106.367 6.17292 109.347 7.67748ZM164.822 8.91499C164.087 11.8029 161.996 14.3119 159.87 14.8569C156.485 15.725 156.797 18.6275 160.275 18.6275H162.003L162.193 30.7779C162.366 41.8209 162.482 43.1159 163.471 44.9847C165.522 48.8597 165.484 48.8545 188.655 48.5483L209.121 48.2781V46.7793C209.121 45.5214 208.904 45.2799 207.776 45.2799C207.037 45.2799 205.826 44.6805 205.086 43.9478L203.739 42.6157L203.921 33.1039C204.082 24.6974 204.228 23.3794 205.174 21.7631C207.474 17.8347 213.19 17.0722 215.668 20.363C216.709 21.7448 216.795 22.6604 217.043 34.9958L217.307 48.1542H223.117C228.921 48.1542 228.927 48.1532 228.927 46.8812C228.927 45.8616 228.558 45.5162 227.078 45.1493C224.024 44.3926 223.908 43.9661 223.921 33.5523C223.931 25.3334 224.065 23.8252 224.96 21.8738C226.715 18.049 231.952 16.9416 234.829 19.7876C236.627 21.5671 237.113 25.3387 237.113 37.5121V48.4155H263.521H289.929L289.932 46.7171C289.934 45.7832 290.085 43.4571 290.267 41.5486C290.569 38.3879 290.505 38.0493 289.546 37.7477C287.819 37.2058 286.859 37.9265 286.499 40.0346C285.861 43.7696 284.919 44.2348 277.993 44.2348C273.261 44.2348 271.999 44.0895 272.316 43.5815C272.54 43.2225 276.608 37.0919 281.357 29.9584C288.007 19.9705 289.954 16.6662 289.828 15.587L289.664 14.1854L277.818 14.0443C270.446 13.957 265.772 14.1007 265.444 14.4253C265.154 14.7116 264.811 16.9505 264.681 19.3999L264.445 23.8534H265.821C266.943 23.8534 267.419 23.3941 268.396 21.3711L269.595 18.8888L275.524 18.7409L281.452 18.5935L272.619 31.9579C263.905 45.1409 263.763 45.3186 262.2 45.0328C259.349 44.5117 259.296 44.2107 259.296 28.7282V14.4665L258.107 14.1723C257.453 14.0103 254.78 13.9471 252.165 14.0317L247.412 14.1854V15.7318C247.412 17.056 247.658 17.3278 249.125 17.6246C252.484 18.3045 252.429 18.0746 252.429 31.4311C252.429 45.0855 252.54 44.6967 248.508 45.1462C246.508 45.3693 245.976 45.2131 244.811 44.0607L243.451 42.7145L243.448 32.8918C243.444 22.398 243.053 19.8875 240.995 17.1898C237.35 12.4112 229.207 12.2387 224.683 16.8449L222.473 19.0947L221.758 17.772C220.034 14.5857 215.033 12.8617 210.454 13.8755C208.325 14.3469 207.13 15.0174 205.481 16.6651L203.311 18.8339V17.2624C203.311 14.2831 202.518 13.8624 197.228 14.0328L192.484 14.1854V15.7318C192.484 17.0654 192.727 17.3272 194.249 17.6356C195.22 17.8321 196.29 18.2648 196.626 18.5977C197.053 19.0205 197.237 22.8213 197.237 31.2419V43.2821L195.923 44.3351C194.903 45.1519 194.092 45.3301 192.304 45.1305C188.208 44.6737 188.292 44.9941 187.994 28.6697L187.73 14.1854L178.356 14.0427L168.981 13.9001V10.2539V6.60772H167.195C165.524 6.60772 165.371 6.75666 164.822 8.91499ZM19.0667 12.7676C21.1994 14.072 22.1532 15.818 22.1532 18.4169C22.1532 23.1025 18.8385 25.4212 12.1394 25.4212H7.89301V18.7147C7.89301 15.0257 8.071 11.8269 8.28912 11.6058C8.50725 11.3848 10.6051 11.3012 12.9512 11.4203C16.1275 11.5813 17.6898 11.9257 19.0667 12.7676ZM141.962 13.8823C139.616 14.6312 137.616 16.0019 136.405 17.6889L135.254 19.2922L134.911 17.2614C134.312 13.7124 134.623 13.8739 128.718 14.0365L123.295 14.1854V15.7443C123.295 17.1527 123.495 17.3356 125.365 17.6361C126.503 17.819 127.751 18.397 128.137 18.9206C128.693 19.6721 128.841 23.9015 128.841 39.0276C128.841 60.3736 129.026 59.307 125.144 60.2931C123.667 60.6684 123.295 61.019 123.295 62.0365V63.3096H132.01H140.724V62.0365C140.724 61.018 140.355 60.6705 138.876 60.2994C137.859 60.0444 136.759 59.5594 136.432 59.2213C136.086 58.8649 135.69 55.5547 135.49 51.3473L135.144 44.0879L136.702 45.7377C138.832 47.9938 141.391 48.9381 145.378 48.9381C154.207 48.9381 158.275 42.6011 157.783 29.6156C157.465 21.2253 155.642 17.3184 150.93 14.9275C148.673 13.7819 143.986 13.2358 141.962 13.8823ZM302.828 13.8624C296.184 15.5598 292.723 20.6949 292.177 29.6642C291.746 36.7339 293.345 41.87 297.1 45.478C301.975 50.1626 312.748 50.1689 317.131 45.4895C319.633 42.8175 318.265 39.129 315.649 41.4948C313.246 43.6677 311.086 44.3544 307.316 44.1438C304.7 43.9975 303.429 43.6667 302.587 42.9131C300.828 41.339 299.49 38.3498 299.109 35.1395L298.765 32.2375L309.267 32.0959L319.769 31.9537L319.733 28.2955C319.668 21.7265 316.826 16.5146 312.285 14.6369C310.087 13.7281 304.988 13.3106 302.828 13.8624ZM336.954 14.0547C335.874 14.4404 334.467 15.6053 333.521 16.8972C332.639 18.1012 331.766 19.1004 331.581 19.1182C331.396 19.136 331.085 18.0929 330.889 16.8005C330.465 14.0014 329.989 13.8028 324.252 14.0291L320.298 14.1854V15.7318C320.298 17.056 320.544 17.3278 322.011 17.6246C325.361 18.3029 325.315 18.1174 325.315 31.0068C325.315 38.066 325.098 43.1368 324.77 43.743C324.437 44.3602 323.413 44.8786 322.129 45.0819C320.251 45.3792 320.034 45.5695 320.034 46.9146V48.4155H329.575H339.117L338.95 46.9821C338.8 45.6933 338.518 45.5115 336.155 45.1796C334.613 44.9627 333.249 44.4339 332.854 43.8998C332.382 43.2612 332.181 40.714 332.181 35.3605C332.181 27.1113 332.945 22.8025 334.888 20.1028C335.807 18.8255 336.302 18.5977 337.861 18.7299C339.818 18.8961 340.357 19.4699 340.889 21.9538C341.181 23.3146 341.363 23.4213 342.874 23.1223C347.718 22.1639 349.097 17.622 345.378 14.882C343.684 13.6351 339.327 13.2071 336.954 14.0547ZM180.6 18.6275C181.594 19.6105 181.657 20.3693 181.657 31.394C181.657 41.3526 181.532 43.2382 180.827 43.9364C180.37 44.3879 179.835 44.773 179.638 44.7918C173.778 45.3583 172.13 45.2131 170.71 44.0053L169.245 42.7595L169.085 30.6932L168.925 18.6275L172.518 18.6196C174.494 18.6149 176.467 18.3834 176.903 18.1049C178.149 17.3084 179.453 17.4924 180.6 18.6275ZM309.865 18.8579C311.533 20.2465 312.639 23.1485 312.639 26.1351V28.0342H305.767H298.895L299.221 25.8132C299.689 22.6243 301.428 19.2499 303.053 18.3766C305.261 17.1898 308.103 17.3905 309.865 18.8579ZM147.599 19.369C150.249 21.0868 150.759 22.9546 150.759 30.9231C150.759 41.6871 149.288 44.2348 143.075 44.2348C140.702 44.2348 140.132 44.0147 138.613 42.5118C136.308 40.2311 135.708 37.8146 135.733 30.9085C135.761 22.9217 137.043 19.7437 140.682 18.6411C142.821 17.992 145.99 18.3259 147.599 19.369ZM19.9466 31.6449C23.3516 33.3637 24.7982 36.6796 23.7784 40.4271C22.6471 44.5833 18.4186 46.8477 11.7876 46.8477H7.89301V38.7856C7.89301 29.4463 7.4615 30.0562 13.8216 30.3953C16.474 30.5364 18.6167 30.9738 19.9466 31.6449Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/></svg>", _w = "<svg width=\"84\" height=\"30\" viewBox=\"0 0 84 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M69.732 1.37515C65.9717 1.85179 62.9464 3.79298 61.4508 6.68873C61.147 7.27691 60.8328 8.19678 60.7199 8.82824C60.6771 9.06752 60.6443 9.58958 60.647 9.98838C60.655 11.182 60.8881 12.1301 61.4527 13.2658C62.5609 15.4951 64.7531 17.3438 67.6288 18.4746C67.9957 18.6188 68.9485 18.9519 69.7461 19.2147C71.4926 19.7903 72.0023 19.9989 72.5134 20.3473C72.9683 20.6574 73.2225 21.0065 73.3138 21.4464C73.5732 22.696 72.3394 23.561 70.2971 23.5612C68.5895 23.5613 67.1262 23.114 65.9671 22.2375C65.2082 21.6635 64.7947 21.1726 63.7417 19.5952C62.7273 18.0757 62.3104 17.7323 61.4801 17.7323C61.1078 17.7323 61.0051 17.7558 60.7678 17.8952C60.404 18.1091 60.1203 18.54 59.9968 19.0664C59.7234 20.2322 60.2974 23.1718 61.1183 24.8091C61.7305 26.0302 62.3508 26.5596 63.7694 27.0715C65.7825 27.7979 68.3285 28.2376 70.8829 28.3C72.8017 28.3468 74.0975 28.226 75.6627 27.854C79.9029 26.8462 82.7416 24.148 83.4432 20.4586C83.5614 19.8367 83.5749 18.471 83.4692 17.8193C83.1155 15.6378 81.9562 14.0726 79.6685 12.6882C78.3795 11.9082 77.2514 11.4573 74.8216 10.751C72.5133 10.0801 72.004 9.88101 71.4252 9.42328C70.4898 8.68352 70.4994 7.19327 71.4436 6.5679C72.3214 5.98644 73.913 5.99543 75.1979 6.58907C75.9834 6.95202 76.6036 7.41201 77.867 8.56855C78.2179 8.88979 78.6501 9.27431 78.8275 9.42299C80.1771 10.5549 81.4786 10.6285 82.4019 9.62525C82.914 9.0688 83.09 8.48032 83.0392 7.49409C82.9932 6.59899 82.8122 5.94241 82.3657 5.05027C81.6762 3.67279 80.3077 2.29281 79.323 1.98213C79.0076 1.88259 78.53 1.94477 77.9484 2.16114C77.6803 2.26091 77.3435 2.34432 77.1999 2.34658C77.0464 2.34902 76.459 2.21473 75.7739 2.02064C75.1331 1.83914 74.2195 1.611 73.7436 1.51372C72.9738 1.35629 72.7408 1.33437 71.6313 1.31464C70.7727 1.29939 70.181 1.31824 69.732 1.37515ZM6.92487 1.40508C3.07114 1.73862 0.909873 2.7423 0.712883 4.29004C0.630281 4.93867 0.999377 5.39912 2.02337 5.92513C2.34165 6.08859 2.69439 6.31737 2.80715 6.4335C3.33072 6.97261 3.41518 8.08408 3.41472 14.4259C3.41425 20.1564 3.34337 21.4739 2.97236 22.6483C2.78581 23.2388 2.54757 23.4838 1.75642 23.8986C0.786261 24.4073 0.460322 24.8182 0.458988 25.5342C0.455739 27.2678 2.88279 28.2037 7.37755 28.2019C11.2576 28.2005 13.7215 27.4885 14.361 26.184C14.4975 25.9056 14.5232 25.7797 14.5232 25.3891C14.5232 24.9994 14.4974 24.8725 14.3622 24.5967C14.2228 24.3123 14.1323 24.2211 13.6868 23.9159C13.4038 23.7221 13.1002 23.4783 13.0121 23.3742C12.7703 23.0882 12.5371 22.5454 12.3938 21.9348C12.2751 21.429 12.2651 21.241 12.2633 19.5015C12.2615 17.6412 12.2633 17.6126 12.397 17.3411C12.7137 16.6979 13.2786 16.5627 15.8852 16.506C18.3611 16.4522 18.8398 16.5434 19.0589 17.111C19.1512 17.3503 19.1641 17.5717 19.1631 18.8924C19.1614 20.8906 19.0124 21.9127 18.5879 22.838C18.3438 23.3699 18.1063 23.6325 17.5363 24.0007C16.7419 24.5138 16.6135 24.7522 16.6524 25.6418C16.6714 26.077 16.7061 26.2574 16.8084 26.4543C17.2321 27.269 18.3678 27.801 20.2623 28.0721C21.2871 28.2188 25.0123 28.216 26.2121 28.0677C28.61 27.7712 29.8286 27.2383 30.2605 26.2972C30.3832 26.03 30.4109 25.8832 30.4101 25.5052C30.4085 24.7462 30.191 24.45 29.2527 23.9285C28.6805 23.6104 28.3074 23.2373 28.1461 22.822C28.0451 22.5619 28.0383 22.2076 28.0214 16.3691C28.0033 10.1112 28.0386 8.47603 28.2134 7.47356C28.3904 6.4589 28.5664 6.19747 29.3216 5.82744C29.9361 5.52639 30.3045 5.20289 30.5108 4.78333C30.6205 4.56012 30.647 4.41162 30.6481 4.01369C30.6494 3.58914 30.627 3.47458 30.4868 3.18919C30.0039 2.20568 28.4964 1.60271 26.0091 1.39806C25.0756 1.32126 21.885 1.36093 21.1075 1.45897C19.0857 1.71402 17.8922 2.11682 17.2472 2.76185C16.8819 3.12718 16.7568 3.46077 16.7576 4.06752C16.7586 4.84133 17.0568 5.26234 17.9559 5.75905C18.6494 6.14225 18.8529 6.47648 19.048 7.5521C19.1963 8.37051 19.2436 11.0326 19.1152 11.3394C18.9153 11.8172 18.3776 11.9001 15.4692 11.9016C13.2537 11.9027 12.9729 11.8729 12.6667 11.6041C12.309 11.29 12.2608 11.0251 12.2666 9.40831C12.2725 7.79839 12.3607 7.09941 12.6253 6.56598C12.7674 6.27961 12.8489 6.20362 13.4216 5.82356C14.572 5.06025 14.7915 4.7632 14.8313 3.91549C14.8533 3.44569 14.8403 3.34917 14.7218 3.10432C14.3377 2.31079 13.241 1.77359 11.4204 1.4871C10.7108 1.37549 7.86678 1.32358 6.92487 1.40508ZM33.679 1.61025C32.5784 1.8769 31.8588 2.59758 31.7939 3.49836C31.7371 4.28638 32.016 4.69597 32.8538 5.05514C33.9575 5.52825 34.3151 5.91556 34.5971 6.94303C34.7427 7.47402 34.7646 9.12843 34.6585 11.5836C34.6075 12.764 34.5134 15.1785 34.4494 16.9492C34.294 21.2518 34.21 22.0913 33.8358 23.0853C33.5618 23.8135 33.264 24.1731 32.5638 24.6215C31.8396 25.0852 31.6901 25.3533 31.7351 26.1073C31.7899 27.0257 32.377 27.637 33.4479 27.8907C33.7811 27.9697 34.1099 27.9787 35.6382 27.9505C36.6272 27.9324 38.1933 27.8873 39.1186 27.8502C40.9133 27.7785 43.7474 27.8062 45.9343 27.9167C47.608 28.0012 50.1697 27.9581 50.9519 27.8322C52.6822 27.5537 54.1203 27.0236 55.3156 26.2239C55.8886 25.8405 56.9087 24.8229 57.2869 24.2575C57.9046 23.3342 58.3677 22.1916 58.5563 21.1256C58.7068 20.2753 58.6939 19.082 58.5272 18.4283C58.1803 17.0678 57.2983 15.8067 56.0423 14.8754C55.7803 14.6812 55.2013 14.3372 54.7556 14.111C54.3098 13.8849 53.9047 13.642 53.8552 13.5714C53.7403 13.4073 53.7402 13.0251 53.855 12.805C53.9039 12.7111 54.2036 12.3893 54.5209 12.09C55.4127 11.2488 55.9217 10.4098 56.2474 9.2445C56.3935 8.72163 56.404 8.60782 56.4008 7.5811C56.3975 6.55914 56.386 6.44255 56.2434 5.97786C56.0284 5.27685 55.8483 4.89215 55.4976 4.38488C54.5101 2.95641 52.8013 2.05812 50.3138 1.65996C49.3188 1.50067 47.172 1.48803 45.1802 1.62979C43.0715 1.77986 42.1977 1.78067 38.8865 1.63577C35.8097 1.50108 34.1629 1.49302 33.679 1.61025ZM45.7799 5.5971C46.2403 5.8079 46.6335 6.19892 46.8862 6.69749C47.2261 7.36775 47.3311 7.85292 47.3664 8.91525C47.4372 11.0473 46.9191 12.1751 45.7023 12.537C44.8689 12.7848 44.1487 12.7392 43.8815 12.4216C43.624 12.1158 43.6035 11.8382 43.624 8.94426L43.6431 6.24695L43.7881 5.95692C44.0057 5.52175 44.2963 5.38868 44.9552 5.42267C45.329 5.44193 45.5371 5.48596 45.7799 5.5971ZM45.888 16.4912C46.9863 16.7203 47.7615 17.5287 48.0812 18.7786C48.2487 19.4336 48.3326 20.5973 48.2596 21.2516C48.0605 23.0344 47.2687 23.8829 45.6915 24.0036C44.4031 24.1023 44.0172 23.7315 43.7521 22.1408C43.6754 21.6808 43.6541 21.1284 43.6492 19.4725C43.6437 17.602 43.6538 17.3564 43.746 17.1174C43.9431 16.6068 44.2778 16.4337 45.0759 16.4297C45.3535 16.4283 45.7189 16.4559 45.888 16.4912Z\" fill=\"#1C8BF7\"/>\n</svg>\n", vw = "<svg width=\"500\" height=\"233\" viewBox=\"0 0 500 233\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_26814_26094)\">\n<path d=\"M219.63 136.769C222.06 124.629 230.16 116.929 241.91 116.929C253.25 116.929 261.36 124.629 262.97 136.769C263.026 137.212 262.982 137.662 262.842 138.086C262.702 138.51 262.469 138.897 262.16 139.219C261.885 139.604 261.519 139.917 261.096 140.129C260.673 140.342 260.204 140.448 259.73 140.439H222.46C221.994 140.409 221.539 140.286 221.121 140.076C220.704 139.867 220.333 139.575 220.03 139.219C219.698 138.448 219.561 137.606 219.63 136.769ZM241.91 107.279C221.24 107.279 208.28 122.669 208.28 146.179C208.28 169.689 221.64 185.059 242.28 185.059C254.84 185.059 265.37 180.199 270.64 171.289C271.039 170.541 271.248 169.707 271.248 168.859C271.248 168.012 271.039 167.177 270.64 166.429C270.259 165.685 269.676 165.063 268.958 164.633C268.24 164.203 267.417 163.984 266.58 163.999H265.79C264.954 163.984 264.13 164.203 263.412 164.633C262.695 165.063 262.112 165.685 261.73 166.429C258.08 172.099 251.19 175.349 242.28 175.349C228.5 175.349 220 165.209 219.18 149.349H269.83C271.067 149.401 272.274 148.959 273.186 148.121C274.097 147.282 274.638 146.116 274.69 144.879V144.489C274.29 121.809 262.06 107.239 241.88 107.239L241.91 107.279Z\" fill=\"#18A7BC\"/>\n<path d=\"M298.62 79.209H297.41C294.726 79.209 292.55 81.3849 292.55 84.069V179.289C292.55 181.973 294.726 184.149 297.41 184.149H298.62C301.304 184.149 303.48 181.973 303.48 179.289V84.069C303.48 81.3849 301.304 79.209 298.62 79.209Z\" fill=\"#18A7BC\"/>\n<path d=\"M328.21 79.2193H327C326.385 79.1925 325.771 79.2871 325.193 79.4978C324.615 79.7086 324.084 80.0312 323.631 80.4473C323.177 80.8634 322.811 81.3648 322.551 81.9228C322.292 82.4809 322.146 83.0845 322.12 83.6993C322.11 83.8291 322.11 83.9595 322.12 84.0893V179.299C322.094 179.914 322.19 180.528 322.402 181.105C322.614 181.683 322.938 182.213 323.355 182.665C323.772 183.118 324.274 183.483 324.833 183.741C325.391 183.999 325.995 184.145 326.61 184.169H328.21C328.824 184.193 329.438 184.096 330.015 183.883C330.592 183.67 331.121 183.345 331.573 182.927C332.024 182.509 332.389 182.006 332.646 181.447C332.902 180.888 333.047 180.284 333.07 179.669V84.0793C333.054 82.7952 332.537 81.568 331.629 80.66C330.721 79.7519 329.494 79.2349 328.21 79.2193Z\" fill=\"#5D5CA7\"/>\n<path d=\"M400.32 151.329V155.769C400.32 167.109 390.6 175.619 378.04 175.619C368.31 175.619 361.84 170.409 361.84 162.619C361.84 154.519 367.51 150.479 379.66 149.619L397 148.499H397.41C397.768 148.484 398.124 148.54 398.46 148.663C398.796 148.787 399.104 148.975 399.367 149.217C399.629 149.46 399.842 149.751 399.992 150.076C400.142 150.401 400.226 150.752 400.24 151.109V151.329H400.32ZM383 107.169C370 107.169 359.51 112.369 355.45 121.739C355.166 122.486 355.062 123.289 355.147 124.084C355.231 124.879 355.501 125.643 355.935 126.314C356.37 126.984 356.956 127.544 357.646 127.946C358.337 128.348 359.113 128.582 359.91 128.629H360.72C361.654 128.621 362.566 128.351 363.355 127.851C364.143 127.351 364.775 126.64 365.18 125.799C367.61 120.599 374.08 117.299 382.53 117.299C394.28 117.299 400.35 122.509 400.35 133.089V136.339C400.31 137.118 400.009 137.861 399.496 138.449C398.983 139.036 398.287 139.434 397.52 139.579L378.07 140.399C360.23 141.679 350.61 149.709 350.61 162.669C350.61 176.049 361.14 185.369 376.13 185.369C386.66 185.369 395.58 180.489 400.42 172.369V179.309C400.369 180.551 400.813 181.763 401.655 182.679C402.497 183.594 403.668 184.137 404.91 184.189H406.09C407.333 184.235 408.543 183.786 409.454 182.94C410.365 182.094 410.904 180.921 410.95 179.679C410.96 179.556 410.96 179.432 410.95 179.309V132.689C411.33 116.889 400.77 107.169 382.95 107.169H383Z\" fill=\"#5D5CA7\"/>\n<path d=\"M489.05 146.069C489.05 163.889 480.55 175.239 466.37 175.239C452.19 175.239 443.28 163.889 443.28 146.069C443.28 128.249 452.18 116.889 466.37 116.889C480.15 117.389 489.05 128.229 489.05 146.069ZM468 107.169C457.07 107.169 447.73 112.369 443.29 121.339V84.0789C443.341 82.8364 442.897 81.6244 442.055 80.7093C441.213 79.7941 440.042 79.2509 438.8 79.1989C438.67 79.1889 438.54 79.1889 438.41 79.1989H437.2C436.585 79.1748 435.972 79.2721 435.395 79.4853C434.818 79.6985 434.288 80.0234 433.837 80.4413C433.386 80.8593 433.021 81.3621 432.764 81.9211C432.507 82.48 432.363 83.0842 432.34 83.6989V179.279C432.314 179.894 432.41 180.507 432.622 181.085C432.834 181.662 433.158 182.193 433.575 182.645C433.992 183.097 434.494 183.463 435.053 183.721C435.611 183.979 436.215 184.124 436.83 184.149H438C438.614 184.173 439.227 184.076 439.804 183.862C440.38 183.649 440.909 183.324 441.359 182.906C441.81 182.488 442.173 181.985 442.429 181.426C442.685 180.867 442.828 180.263 442.85 179.649C442.86 179.526 442.86 179.402 442.85 179.279V170.769C447.71 180.079 457.05 185.359 467.98 185.359C487.06 185.359 499.98 169.549 499.98 146.459C499.98 122.949 486.98 107.159 467.98 107.159L468 107.169Z\" fill=\"#5D5CA7\"/>\n<path d=\"M333.07 201.97C333.093 201.355 332.994 200.742 332.779 200.165C332.565 199.589 332.239 199.06 331.82 198.61C331.401 198.159 330.898 197.796 330.338 197.54C329.779 197.284 329.175 197.142 328.56 197.12H327C326.385 197.093 325.771 197.188 325.193 197.398C324.615 197.609 324.084 197.932 323.631 198.348C323.178 198.764 322.811 199.265 322.552 199.823C322.292 200.381 322.146 200.985 322.12 201.6V213.32C321.985 215.699 320.945 217.936 319.212 219.573C317.48 221.209 315.188 222.121 312.805 222.121C310.422 222.121 308.129 221.209 306.397 219.573C304.665 217.936 303.625 215.699 303.49 213.32V201.97C303.539 200.734 303.095 199.53 302.257 198.621C301.419 197.711 300.255 197.172 299.02 197.12H297.41C296.795 197.096 296.182 197.193 295.605 197.406C295.028 197.619 294.498 197.944 294.047 198.362C293.596 198.78 293.231 199.283 292.974 199.842C292.717 200.401 292.573 201.005 292.55 201.62V213.32C292.504 214.16 292.658 215 293 215.77C293.802 220.658 296.389 225.075 300.261 228.165C304.132 231.255 309.013 232.798 313.957 232.495C318.902 232.193 323.558 230.066 327.024 226.527C330.49 222.988 332.52 218.289 332.72 213.34V201.97H333.07Z\" fill=\"url(#paint0_linear_26814_26094)\"/>\n<path d=\"M305.12 49.2197C306.241 49.222 307.336 49.5554 308.268 50.1781C309.201 50.8008 309.928 51.685 310.36 52.7197C310.636 53.4102 310.782 54.146 310.79 54.8897C310.788 55.6341 310.642 56.371 310.36 57.0597C310.068 57.7526 309.647 58.3838 309.12 58.9197C308.593 59.4419 307.968 59.8533 307.28 60.1297C305.891 60.7025 304.332 60.701 302.945 60.1254C301.557 59.5498 300.455 58.4473 299.88 57.0597C299.585 56.3745 299.435 55.6357 299.44 54.8897C299.441 54.1443 299.59 53.4066 299.88 52.7197C300.161 52.0344 300.572 51.4097 301.09 50.8797C301.643 50.3536 302.291 49.9363 303 49.6497C303.673 49.3736 304.392 49.2276 305.12 49.2197Z\" fill=\"#18A7BC\"/>\n<path d=\"M320.51 20.0496C321.091 20.0412 321.671 20.0983 322.24 20.2196C322.785 20.3306 323.321 20.4878 323.84 20.6896C324.349 20.9127 324.838 21.1804 325.3 21.4896C325.766 21.8004 326.201 22.1554 326.6 22.5496C326.976 22.9413 327.311 23.3701 327.6 23.8296C327.915 24.2931 328.18 24.7893 328.39 25.3096C329.029 26.8634 329.196 28.5714 328.87 30.2196C328.761 30.7639 328.601 31.2964 328.39 31.8096C328.182 32.3309 327.917 32.8274 327.6 33.2896C327.316 33.7529 326.981 34.1823 326.6 34.5696C326.201 34.9639 325.766 35.3188 325.3 35.6296C324.838 35.9388 324.349 36.2065 323.84 36.4296C323.322 36.636 322.787 36.7934 322.24 36.8996C321.142 37.1297 320.008 37.1297 318.91 36.8996C317.812 36.7044 316.771 36.2709 315.86 35.6296C314.922 35.0185 314.119 34.2222 313.5 33.2896C313.185 32.8271 312.923 32.3306 312.72 31.8096C312.501 31.2983 312.337 30.7654 312.23 30.2196C312.02 29.1229 312.02 27.9963 312.23 26.8996C312.338 26.3543 312.502 25.8215 312.72 25.3096C312.926 24.7896 313.187 24.2934 313.5 23.8296C313.813 23.3745 314.165 22.9463 314.55 22.5496C314.949 22.1529 315.388 21.7977 315.86 21.4896C316.317 21.1785 316.803 20.9107 317.31 20.6896C317.829 20.4878 318.364 20.3306 318.91 20.2196C319.436 20.1077 319.972 20.0507 320.51 20.0496Z\" fill=\"#5D5CA7\"/>\n<path d=\"M306.33 0.319721C306.753 0.317744 307.172 0.402844 307.56 0.569721C307.952 0.725011 308.309 0.95846 308.608 1.25587C308.907 1.55328 309.143 1.90843 309.3 2.29972C309.468 2.69144 309.555 3.11335 309.555 3.53972C309.555 3.96609 309.468 4.388 309.3 4.77972C309.136 5.15642 308.898 5.49643 308.6 5.77972C308.306 6.0924 307.951 6.34221 307.557 6.51408C307.164 6.68594 306.74 6.77631 306.31 6.77972C305.882 6.77098 305.459 6.68634 305.06 6.52972C304.285 6.17802 303.668 5.55071 303.33 4.76972C303.01 3.97409 303.01 3.08535 303.33 2.28972C303.488 1.90802 303.715 1.55881 304 1.25972C304.283 0.963924 304.623 0.72911 305 0.569721C305.42 0.391625 305.874 0.306349 306.33 0.319721Z\" fill=\"#18A7BC\"/>\n<path d=\"M89.1504 146.069C89.1504 155.789 91.1504 163.069 94.8204 167.949C98.4904 172.829 104.14 175.639 111.82 175.639C119.5 175.639 124.82 173.209 128.82 167.949C132.82 163.069 134.49 155.389 134.49 146.069C134.49 136.339 132.49 129.069 128.82 124.189C124.76 119.316 119.094 116.882 111.82 116.889C104.547 116.896 98.8804 119.329 94.8204 124.189C91.1804 129.049 89.1504 136.339 89.1504 146.069ZM146.69 146.069C146.69 158.209 143.44 167.949 137.37 174.839C131.3 181.729 122.78 185.369 111.85 185.369C105.555 185.493 99.3571 183.799 94.0004 180.489C88.6607 177.247 84.4282 172.464 81.8604 166.769C78.8596 160.284 77.3363 153.214 77.4004 146.069C77.4004 133.919 80.6504 124.189 86.7204 117.299C92.7904 110.409 101.31 107.169 112.24 107.169C122.78 107.169 131.33 110.809 137.37 117.699C143.41 124.589 146.69 134.309 146.69 146.069Z\" fill=\"#18A7BC\"/>\n<path d=\"M186.8 175.64C188.699 175.717 190.6 175.582 192.47 175.24C193.043 175.3 193.618 175.151 194.09 174.82C195.72 174.42 196.93 176.45 196.93 178.06V180.06C196.909 180.892 196.622 181.695 196.111 182.352C195.6 183.009 194.891 183.485 194.09 183.71C193.29 183.71 192.47 184.12 191.66 184.12C189.519 184.442 187.354 184.576 185.19 184.52C170.59 184.52 163.296 176.823 163.31 161.43V121.34C163.356 120.421 163.035 119.521 162.418 118.838C161.801 118.156 160.939 117.746 160.02 117.7C159.897 117.69 159.773 117.69 159.65 117.7C152.71 117.7 152.71 116.49 152.71 115.27C152.667 114.374 152.922 113.489 153.436 112.755C153.95 112.02 154.694 111.476 155.55 111.21L161.63 107.97C162.84 107.57 163.26 106.75 163.63 105.54L167.3 93.7695C167.525 92.9713 168 92.2662 168.655 91.7571C169.31 91.248 170.111 90.9615 170.94 90.9395C171.416 90.9369 171.889 91.0282 172.33 91.2082C172.772 91.3882 173.173 91.6533 173.512 91.9886C173.851 92.3238 174.121 92.7225 174.306 93.1619C174.491 93.6013 174.587 94.0728 174.59 94.5495V104.3C174.588 104.778 174.682 105.253 174.864 105.696C175.046 106.138 175.314 106.541 175.652 106.88C175.99 107.219 176.392 107.488 176.834 107.671C177.277 107.855 177.751 107.95 178.23 107.95H192.42C192.899 107.948 193.373 108.041 193.816 108.224C194.259 108.406 194.661 108.674 195 109.012C195.339 109.35 195.608 109.752 195.792 110.194C195.975 110.637 196.07 111.111 196.07 111.59V112.82C196.072 113.296 195.981 113.769 195.801 114.21C195.621 114.652 195.356 115.053 195.021 115.392C194.685 115.731 194.287 116.001 193.847 116.186C193.408 116.37 192.936 116.467 192.46 116.47H178.25C177.771 116.466 177.297 116.556 176.854 116.736C176.41 116.916 176.007 117.182 175.667 117.519C175.327 117.855 175.057 118.255 174.872 118.696C174.687 119.138 174.591 119.611 174.59 120.09V160.62C174.412 164.403 175.558 168.129 177.83 171.16C178.786 172.642 180.123 173.84 181.701 174.628C183.279 175.416 185.04 175.765 186.8 175.64Z\" fill=\"#18A7BC\"/>\n<path d=\"M66.8 138.88C66.8 129.52 60.93 120.88 56.04 116.09C50.556 110.88 43.2321 108.054 35.67 108.23C30.6392 108.04 25.6598 109.3 21.3249 111.86C16.9901 114.42 13.4825 118.172 11.22 122.67V84.2197C11.22 82.8936 10.6932 81.6219 9.75554 80.6842C8.81786 79.7465 7.54609 79.2197 6.22001 79.2197H5.00001C3.67393 79.2197 2.40216 79.7465 1.46448 80.6842C0.526794 81.6219 9.84341e-06 82.8936 9.84341e-06 84.2197V180.29C-0.00130503 180.958 0.129123 181.619 0.383828 182.237C0.638533 182.854 1.01251 183.416 1.48437 183.888C1.95622 184.361 2.51668 184.736 3.13367 184.992C3.75065 185.248 4.41205 185.38 5.08001 185.38H6.08001C7.42823 185.377 8.72032 184.84 9.67272 183.885C10.6251 182.931 11.16 181.638 11.16 180.29V146.71C11.16 137.09 13.56 130.61 17.09 126.35C21.25 121.35 26.26 118.18 34.09 118.14C39.1619 117.987 44.0878 119.85 47.79 123.32L47.87 123.41C52.851 128.815 55.6267 135.89 55.65 143.24L55.79 180.19C55.7887 180.873 55.9227 181.55 56.1843 182.182C56.4459 182.814 56.8299 183.387 57.3142 183.87C57.7986 184.352 58.3736 184.734 59.0062 184.993C59.6388 185.252 60.3164 185.384 61 185.38H61.84C63.2121 185.374 64.526 184.825 65.4934 183.852C66.4608 182.879 67.0027 181.562 67 180.19L66.8 138.88Z\" fill=\"#18A7BC\"/>\n</g>\n<defs>\n<linearGradient id=\"paint0_linear_26814_26094\" x1=\"303.78\" y1=\"214.71\" x2=\"322.73\" y2=\"214.71\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#02A2A1\"/>\n<stop offset=\"1\" stop-color=\"#52509E\"/>\n</linearGradient>\n<clipPath id=\"clip0_26814_26094\">\n<rect width=\"500\" height=\"231.99\" fill=\"white\" transform=\"translate(0 0.319336)\"/>\n</clipPath>\n</defs>\n</svg>\n", yw = "<svg width=\"90\" height=\"31\" viewBox=\"0 0 90 31\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M0.720209 17.7712V11.0022H1.8029V17.7712H0.720209ZM1.27073 9.87402C1.0597 9.87402 0.87772 9.80498 0.724797 9.6669C0.574932 9.52881 0.5 9.36282 0.5 9.16892C0.5 8.97501 0.574932 8.80902 0.724797 8.67094C0.87772 8.53285 1.0597 8.46381 1.27073 8.46381C1.48177 8.46381 1.66221 8.53285 1.81208 8.67094C1.965 8.80902 2.04146 8.97501 2.04146 9.16892C2.04146 9.36282 1.965 9.52881 1.81208 9.6669C1.66221 9.80498 1.48177 9.87402 1.27073 9.87402Z\" fill=\"#248FF7\"/>\n<path d=\"M3.93274 17.7712V8.74585H9.56642V9.71537H5.07048V12.765H9.14435V13.7345H5.07048V17.7712H3.93274Z\" fill=\"#248FF7\"/>\n<path d=\"M13.7137 17.9122C13.0775 17.9122 12.5194 17.7668 12.0392 17.4759C11.5621 17.1851 11.1889 16.7782 10.9198 16.2552C10.6537 15.7323 10.5207 15.1212 10.5207 14.4219C10.5207 13.7168 10.6537 13.1013 10.9198 12.5755C11.1889 12.0496 11.5621 11.6412 12.0392 11.3503C12.5194 11.0595 13.0775 10.9141 13.7137 10.9141C14.3498 10.9141 14.9065 11.0595 15.3836 11.3503C15.8638 11.6412 16.2369 12.0496 16.503 12.5755C16.7721 13.1013 16.9067 13.7168 16.9067 14.4219C16.9067 15.1212 16.7721 15.7323 16.503 16.2552C16.2369 16.7782 15.8638 17.1851 15.3836 17.4759C14.9065 17.7668 14.3498 17.9122 13.7137 17.9122ZM13.7137 16.978C14.1969 16.978 14.5945 16.859 14.9065 16.621C15.2185 16.383 15.4494 16.0701 15.5992 15.6823C15.7491 15.2945 15.824 14.8744 15.824 14.4219C15.824 13.9695 15.7491 13.5479 15.5992 13.1572C15.4494 12.7664 15.2185 12.4506 14.9065 12.2097C14.5945 11.9688 14.1969 11.8483 13.7137 11.8483C13.2305 11.8483 12.8329 11.9688 12.5209 12.2097C12.2089 12.4506 11.978 12.7664 11.8281 13.1572C11.6783 13.5479 11.6034 13.9695 11.6034 14.4219C11.6034 14.8744 11.6783 15.2945 11.8281 15.6823C11.978 16.0701 12.2089 16.383 12.5209 16.621C12.8329 16.859 13.2305 16.978 13.7137 16.978Z\" fill=\"#248FF7\"/>\n<path d=\"M18.5594 17.7712V11.0022H19.6054V12.0246H19.6788C19.8073 11.6897 20.0397 11.4179 20.3762 11.2093C20.7126 11.0007 21.0918 10.8964 21.5139 10.8964C21.5934 10.8964 21.6928 10.8979 21.8121 10.9008C21.9314 10.9038 22.0216 10.9082 22.0828 10.9141V11.9717C22.0461 11.9629 21.962 11.9497 21.8305 11.932C21.702 11.9115 21.5659 11.9012 21.4222 11.9012C21.0796 11.9012 20.7738 11.9702 20.5046 12.1083C20.2385 12.2435 20.0275 12.4315 19.8715 12.6724C19.7186 12.9104 19.6421 13.1821 19.6421 13.4877V17.7712H18.5594Z\" fill=\"#248FF7\"/>\n<path d=\"M23.302 17.7712V8.74585H25.004V12.5666H29.3577V8.74585H31.0643V17.7712H29.3577V13.9372H25.004V17.7712H23.302Z\" fill=\"#248FF7\"/>\n<path d=\"M35.9158 17.9034C35.2277 17.9034 34.6313 17.758 34.1266 17.4671C33.622 17.1763 33.2305 16.7694 32.9522 16.2464C32.6769 15.7235 32.5393 15.1124 32.5393 14.4131C32.5393 13.7139 32.6769 13.1013 32.9522 12.5755C33.2305 12.0496 33.622 11.6412 34.1266 11.3503C34.6313 11.0595 35.2277 10.9141 35.9158 10.9141C36.604 10.9141 37.2004 11.0595 37.705 11.3503C38.2096 11.6412 38.5996 12.0496 38.8749 12.5755C39.1532 13.1013 39.2923 13.7139 39.2923 14.4131C39.2923 15.1124 39.1532 15.7235 38.8749 16.2464C38.5996 16.7694 38.2096 17.1763 37.705 17.4671C37.2004 17.758 36.604 17.9034 35.9158 17.9034ZM35.925 16.6254C36.2981 16.6254 36.6101 16.527 36.8609 16.3301C37.1117 16.1304 37.2982 15.863 37.4206 15.5281C37.546 15.1932 37.6087 14.82 37.6087 14.4087C37.6087 13.9945 37.546 13.6199 37.4206 13.285C37.2982 12.9471 37.1117 12.6783 36.8609 12.4785C36.6101 12.2787 36.2981 12.1788 35.925 12.1788C35.5427 12.1788 35.2246 12.2787 34.9707 12.4785C34.7199 12.6783 34.5319 12.9471 34.4065 13.285C34.2841 13.6199 34.2229 13.9945 34.2229 14.4087C34.2229 14.82 34.2841 15.1932 34.4065 15.5281C34.5319 15.863 34.7199 16.1304 34.9707 16.3301C35.2246 16.527 35.5427 16.6254 35.925 16.6254Z\" fill=\"#248FF7\"/>\n<path d=\"M46.2714 12.7914L44.7574 12.95C44.7146 12.8031 44.6397 12.6651 44.5326 12.5358C44.4286 12.4065 44.288 12.3022 44.1106 12.2229C43.9332 12.1436 43.716 12.1039 43.4591 12.1039C43.1135 12.1039 42.823 12.1759 42.5874 12.3199C42.355 12.4638 42.2403 12.6504 42.2434 12.8795C42.2403 13.0764 42.3152 13.2365 42.4682 13.3599C42.6242 13.4833 42.8811 13.5846 43.2389 13.664L44.4409 13.9107C45.1076 14.0488 45.6031 14.2677 45.9273 14.5674C46.2545 14.867 46.4197 15.2593 46.4228 15.744C46.4197 16.17 46.2897 16.5461 46.0328 16.8722C45.779 17.1954 45.4257 17.448 44.973 17.6302C44.5204 17.8123 44.0005 17.9034 43.4132 17.9034C42.5507 17.9034 41.8565 17.7301 41.3304 17.3834C40.8044 17.0338 40.4909 16.5475 40.3899 15.9247L42.0094 15.7749C42.0828 16.0804 42.2388 16.311 42.4773 16.4667C42.7159 16.6225 43.0263 16.7003 43.4086 16.7003C43.8032 16.7003 44.1197 16.6225 44.3583 16.4667C44.5999 16.311 44.7207 16.1186 44.7207 15.8894C44.7207 15.6955 44.6427 15.5354 44.4868 15.4091C44.3338 15.2828 44.0953 15.1858 43.7711 15.1182L42.5691 14.8759C41.8932 14.7407 41.3931 14.513 41.0689 14.1928C40.7447 13.8696 40.5842 13.4612 40.5872 12.9677C40.5842 12.5505 40.7019 12.1891 40.9405 11.8836C41.1821 11.5751 41.517 11.3371 41.9452 11.1697C42.3764 10.9993 42.8734 10.9141 43.4362 10.9141C44.262 10.9141 44.9119 11.083 45.3859 11.4208C45.8631 11.7587 46.1582 12.2156 46.2714 12.7914Z\" fill=\"#248FF7\"/>\n<path d=\"M47.7922 20.3096V11.0022H49.4254V12.1215H49.5217C49.6074 11.957 49.7282 11.7822 49.8842 11.5971C50.0401 11.4091 50.2512 11.249 50.5173 11.1168C50.7834 10.9816 51.1228 10.9141 51.5357 10.9141C52.0801 10.9141 52.571 11.0477 53.0084 11.3151C53.4488 11.5795 53.7975 11.9717 54.0544 12.4917C54.3143 13.0088 54.4443 13.6434 54.4443 14.3955C54.4443 15.1388 54.3174 15.7705 54.0636 16.2905C53.8097 16.8105 53.4641 17.2071 53.0267 17.4803C52.5894 17.7536 52.0939 17.8902 51.5403 17.8902C51.1366 17.8902 50.8017 17.8255 50.5356 17.6963C50.2695 17.567 50.0554 17.4113 49.8933 17.2291C49.7343 17.0441 49.6104 16.8692 49.5217 16.7047H49.4529V20.3096H47.7922ZM49.4208 14.3867C49.4208 14.8244 49.485 15.2078 49.6135 15.5369C49.745 15.8659 49.9331 16.123 50.1778 16.3081C50.4255 16.4903 50.7252 16.5813 51.077 16.5813C51.444 16.5813 51.7514 16.4873 51.9991 16.2993C52.2468 16.1083 52.4334 15.8483 52.5588 15.5193C52.6872 15.1873 52.7515 14.8098 52.7515 14.3867C52.7515 13.9666 52.6888 13.5934 52.5634 13.2673C52.438 12.9412 52.2514 12.6856 52.0037 12.5005C51.7559 12.3154 51.447 12.2229 51.077 12.2229C50.7222 12.2229 50.4209 12.3125 50.1732 12.4917C49.9255 12.6709 49.7374 12.9221 49.6089 13.2453C49.4835 13.5685 49.4208 13.9489 49.4208 14.3867Z\" fill=\"#248FF7\"/>\n<path d=\"M55.8665 17.7712V11.0022H57.5273V17.7712H55.8665ZM56.7015 10.0415C56.4384 10.0415 56.2121 9.95775 56.0225 9.79029C55.8329 9.61989 55.7381 9.4157 55.7381 9.17773C55.7381 8.93682 55.8329 8.73263 56.0225 8.56517C56.2121 8.39477 56.4384 8.30957 56.7015 8.30957C56.9676 8.30957 57.1939 8.39477 57.3805 8.56517C57.5701 8.73263 57.6649 8.93682 57.6649 9.17773C57.6649 9.4157 57.5701 9.61989 57.3805 9.79029C57.1939 9.95775 56.9676 10.0415 56.7015 10.0415Z\" fill=\"#248FF7\"/>\n<path d=\"M62.7538 11.0022V12.2361H58.7028V11.0022H62.7538ZM59.703 9.38045H61.3637V15.7352C61.3637 15.9497 61.3974 16.1142 61.4646 16.2288C61.535 16.3404 61.6267 16.4168 61.7399 16.4579C61.8531 16.4991 61.9785 16.5196 62.1161 16.5196C62.2201 16.5196 62.3149 16.5123 62.4005 16.4976C62.4892 16.4829 62.5565 16.4697 62.6024 16.4579L62.8822 17.7051C62.7935 17.7345 62.6666 17.7668 62.5015 17.802C62.3394 17.8373 62.1406 17.8579 61.9051 17.8637C61.4891 17.8755 61.1144 17.8153 60.7811 17.6831C60.4477 17.5479 60.1831 17.3393 59.9874 17.0573C59.7947 16.7752 59.6999 16.4227 59.703 15.9996V9.38045Z\" fill=\"#248FF7\"/>\n<path d=\"M66.1705 17.9078C65.7239 17.9078 65.3217 17.8314 64.9639 17.6786C64.6091 17.5229 64.3277 17.2938 64.1198 16.9912C63.9148 16.6886 63.8124 16.3154 63.8124 15.8718C63.8124 15.4899 63.8858 15.1741 64.0326 14.9243C64.1794 14.6746 64.3797 14.4748 64.6336 14.325C64.8874 14.1752 65.1734 14.062 65.4915 13.9857C65.8126 13.9063 66.1445 13.849 66.487 13.8138C66.8999 13.7727 67.2348 13.7359 67.4917 13.7036C67.7486 13.6684 67.9352 13.6155 68.0514 13.545C68.1707 13.4715 68.2303 13.3584 68.2303 13.2056V13.1792C68.2303 12.8472 68.1279 12.5901 67.923 12.408C67.718 12.2258 67.4229 12.1348 67.0375 12.1348C66.6308 12.1348 66.3081 12.22 66.0695 12.3904C65.834 12.5608 65.675 12.762 65.5924 12.9941L64.0418 12.7826C64.1641 12.3713 64.366 12.0275 64.6474 11.7514C64.9287 11.4723 65.2728 11.2637 65.6796 11.1256C66.0864 10.9846 66.5359 10.9141 67.0284 10.9141C67.3678 10.9141 67.7058 10.9522 68.0422 11.0286C68.3787 11.105 68.686 11.2313 68.9644 11.4076C69.2427 11.581 69.466 11.8175 69.6342 12.1171C69.8054 12.4168 69.8911 12.7914 69.8911 13.2409V17.7712H68.2946V16.8413H68.2395C68.1386 17.0294 67.9964 17.2056 67.8128 17.3702C67.6324 17.5318 67.4045 17.6625 67.1293 17.7624C66.8571 17.8593 66.5375 17.9078 66.1705 17.9078ZM66.6017 16.7356C66.9351 16.7356 67.2241 16.6724 67.4688 16.5461C67.7135 16.4168 67.9015 16.2464 68.0331 16.0349C68.1676 15.8233 68.2349 15.5927 68.2349 15.343V14.5453C68.1829 14.5865 68.0942 14.6247 67.9688 14.6599C67.8465 14.6952 67.7089 14.726 67.5559 14.7525C67.403 14.7789 67.2516 14.8024 67.1018 14.823C66.9519 14.8435 66.8219 14.8612 66.7118 14.8759C66.4641 14.9082 66.2423 14.9611 66.0466 15.0345C65.8508 15.108 65.6964 15.2108 65.5832 15.343C65.4701 15.4723 65.4135 15.6397 65.4135 15.8454C65.4135 16.1392 65.5251 16.361 65.7484 16.5108C65.9717 16.6607 66.2561 16.7356 66.6017 16.7356Z\" fill=\"#248FF7\"/>\n<path d=\"M73.2217 8.74585V17.7712H71.561V8.74585H73.2217Z\" fill=\"#248FF7\"/>\n<path d=\"M74.9295 17.7712V11.0022H76.5902V17.7712H74.9295ZM75.7645 10.0415C75.5014 10.0415 75.2751 9.95775 75.0855 9.79029C74.8959 9.61989 74.801 9.4157 74.801 9.17773C74.801 8.93682 74.8959 8.73263 75.0855 8.56517C75.2751 8.39477 75.5014 8.30957 75.7645 8.30957C76.0306 8.30957 76.2569 8.39477 76.4434 8.56517C76.6331 8.73263 76.7279 8.93682 76.7279 9.17773C76.7279 9.4157 76.6331 9.61989 76.4434 9.79029C76.2569 9.95775 76.0306 10.0415 75.7645 10.0415Z\" fill=\"#248FF7\"/>\n<path d=\"M81.8168 11.0022V12.2361H77.7658V11.0022H81.8168ZM78.766 9.38045H80.4267V15.7352C80.4267 15.9497 80.4603 16.1142 80.5276 16.2288C80.598 16.3404 80.6897 16.4168 80.8029 16.4579C80.9161 16.4991 81.0415 16.5196 81.1791 16.5196C81.2831 16.5196 81.3779 16.5123 81.4635 16.4976C81.5522 16.4829 81.6195 16.4697 81.6654 16.4579L81.9452 17.7051C81.8565 17.7345 81.7296 17.7668 81.5644 17.802C81.4023 17.8373 81.2035 17.8579 80.968 17.8637C80.5521 17.8755 80.1774 17.8153 79.8441 17.6831C79.5107 17.5479 79.2461 17.3393 79.0504 17.0573C78.8577 16.7752 78.7629 16.4227 78.766 15.9996V9.38045Z\" fill=\"#248FF7\"/>\n<path d=\"M84.2379 20.3096C84.0116 20.3096 83.8021 20.2919 83.6094 20.2567C83.4198 20.2244 83.2684 20.1862 83.1552 20.1421L83.5406 18.8994C83.7822 18.9669 83.9978 18.9993 84.1875 18.9963C84.3771 18.9934 84.5438 18.9361 84.6875 18.8244C84.8343 18.7157 84.9582 18.5336 85.0591 18.278L85.2013 17.9122L82.646 11.0022H84.4077L86.0317 16.1142H86.1051L87.7337 11.0022H89.5L86.6786 18.5909C86.5471 18.9493 86.3727 19.2563 86.1556 19.5119C85.9384 19.7705 85.6723 19.9673 85.3573 20.1024C85.0454 20.2405 84.6722 20.3096 84.2379 20.3096Z\" fill=\"#248FF7\"/>\n</svg>\n", bw = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"175 113 487 182\">\n  <defs>\n    <style>\n      .cls-2 {\n        fill: #002a4a;\n      }\n    </style>\n  </defs>\n  <g id=\"LAYOUT\">\n    <g>\n      <path class=\"cls-2\" d=\"M531.7,257c-.2.4-13.3,27.3-54.7,27.3s-70-8.2-70-80.2,45.4-80.5,63.7-80.5c-14.3,7.3-22.6,17.9-22.6,60.9v24.4c0,6.3.4,13.7,1.4,21.6,1.6,13.7,9.3,32.9,25.4,38.5,33.3,12.1,56.3-11.7,56.7-12.1Z\"/>\n      <path class=\"cls-2\" d=\"M209.7,284.4h6V123.7h-36.3v130.6h0v13.6c0,9.1,7.4,16.5,16.5,16.4h13.8Z\"/>\n      <path class=\"cls-2\" d=\"M561.4,123.7h-6v160.7h36.3v-130.6h0v-13.6c0-9.1-7.4-16.5-16.5-16.4h-13.8Z\"/>\n      <path class=\"cls-2\" d=\"M651,238.7h-2.8c-2.4,19.3-14.3,42.7-49.4,45.4v.3h52.3v-45.6Z\"/>\n      <path class=\"cls-2\" d=\"M531.7,169.3h-2.8c-2.4-19.3-14.3-42.7-49.4-45.4v-.3h52.3v45.6Z\"/>\n      <rect class=\"cls-2\" x=\"253.1\" y=\"123.7\" width=\"36.1\" height=\"160.7\"/>\n      <path class=\"cls-2\" d=\"M347.4,123.7v78.4h-45.5v2.8c19.8,2.8,43.1,13.9,45.5,53.4v26h36.1V123.7h-36.1Z\"/>\n    </g>\n  </g>\n</svg>", xw = "<svg width=\"90\" height=\"46\" viewBox=\"0 0 90 46\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M9.20974 43.8453H7.28855L3.56578 39.4169H1.48014V43.8453H0V32.707H3.11726C3.79005 32.707 4.35071 32.7519 4.79923 32.8416C5.24776 32.9264 5.65143 33.081 6.01025 33.3054C6.41393 33.5597 6.72789 33.8814 6.95216 34.2704C7.1814 34.6544 7.29603 35.1431 7.29603 35.7365C7.29603 36.5394 7.09419 37.2127 6.69052 37.7562C6.28684 38.2948 5.73117 38.7013 5.02349 38.9755L9.20974 43.8453ZM5.74861 35.8413C5.74861 35.5221 5.6913 35.2403 5.57668 34.996C5.46704 34.7466 5.28264 34.5372 5.02349 34.3676C4.8092 34.223 4.55503 34.1233 4.261 34.0684C3.96697 34.0086 3.6206 33.9786 3.22191 33.9786H1.48014V38.1826H2.97522C3.44369 38.1826 3.85234 38.1427 4.2012 38.0629C4.55005 37.9782 4.84658 37.8236 5.09077 37.5991C5.31504 37.3897 5.4795 37.1503 5.58415 36.881C5.69379 36.6068 5.74861 36.2602 5.74861 35.8413Z\" fill=\"#1C8BF7\"/>\n<path d=\"M17.6212 43.8453H10.2878V32.707H17.6212V34.0235H11.7679V37.0755H17.6212V38.3921H11.7679V42.5287H17.6212V43.8453Z\" fill=\"#1C8BF7\"/>\n<path d=\"M28.3949 32.707L24.3432 43.8453H22.3697L18.318 32.707H19.9028L23.3938 42.5063L26.8849 32.707H28.3949Z\" fill=\"#1C8BF7\"/>\n<path d=\"M37.0605 43.8453H29.7271V32.707H37.0605V34.0235H31.2073V37.0755H37.0605V38.3921H31.2073V42.5287H37.0605V43.8453Z\" fill=\"#1C8BF7\"/>\n<path d=\"M47.5502 43.8453H45.7187L40.441 33.8814V43.8453H39.0581V32.707H41.353L46.1672 41.8031V32.707H47.5502V43.8453Z\" fill=\"#1C8BF7\"/>\n<path d=\"M58.5332 39.372C58.5332 40.1799 58.4435 40.8855 58.2641 41.4889C58.0896 42.0874 57.8006 42.5861 57.3969 42.985C57.0132 43.364 56.5647 43.6408 56.0513 43.8153C55.538 43.9899 54.94 44.0771 54.2572 44.0771C53.5595 44.0771 52.9515 43.9849 52.4332 43.8004C51.9149 43.6159 51.4789 43.3441 51.125 42.985C50.7213 42.5761 50.4298 42.0824 50.2504 41.5039C50.076 40.9254 49.9888 40.2148 49.9888 39.372V32.707H51.4689V39.4468C51.4689 40.0502 51.5088 40.5265 51.5885 40.8756C51.6732 41.2246 51.8128 41.5413 52.0071 41.8256C52.2264 42.1497 52.5229 42.3941 52.8967 42.5586C53.2755 42.7232 53.729 42.8055 54.2572 42.8055C54.7905 42.8055 55.244 42.7257 55.6178 42.5661C55.9915 42.4015 56.2906 42.1547 56.5148 41.8256C56.7092 41.5413 56.8462 41.2172 56.926 40.8531C57.0107 40.4841 57.053 40.0278 57.053 39.4842V32.707H58.5332V39.372Z\" fill=\"#1C8BF7\"/>\n<path d=\"M68.3426 43.8453H61.0092V32.707H68.3426V34.0235H62.4893V37.0755H68.3426V38.3921H62.4893V42.5287H68.3426V43.8453Z\" fill=\"#1C8BF7\"/>\n<path d=\"M79.789 40.4342C79.789 40.9728 79.6794 41.454 79.4601 41.8779C79.2458 42.3018 78.9493 42.6534 78.5705 42.9327C78.132 43.2618 77.6486 43.4962 77.1203 43.6358C76.597 43.7754 75.9317 43.8453 75.1244 43.8453H70.2653V32.707H74.5861C75.4832 32.707 76.1385 32.7369 76.5522 32.7967C76.9708 32.8566 77.3844 32.9887 77.7931 33.1932C78.2167 33.4076 78.5307 33.6969 78.735 34.0609C78.9443 34.42 79.049 34.8314 79.049 35.2952C79.049 35.8338 78.9069 36.31 78.6229 36.7239C78.3388 37.1329 77.9376 37.452 77.4193 37.6814V37.7413C78.1469 37.8859 78.7225 38.1851 79.1462 38.6389C79.5748 39.0927 79.789 39.6912 79.789 40.4342ZM76.1111 35.8562C76.1111 35.6717 76.0638 35.4872 75.9691 35.3027C75.8794 35.1182 75.7174 34.981 75.4832 34.8913C75.2739 34.8115 75.0122 34.7691 74.6983 34.7641C74.3893 34.7541 73.9532 34.7491 73.3901 34.7491H73.121V37.1054H73.5695C74.023 37.1054 74.4092 37.098 74.7282 37.083C75.0471 37.068 75.2988 37.0182 75.4832 36.9334C75.7423 36.8187 75.9118 36.6716 75.9915 36.4921C76.0713 36.3075 76.1111 36.0956 76.1111 35.8562ZM76.8138 40.3893C76.8138 40.0353 76.744 39.7635 76.6045 39.574C76.4699 39.3795 76.2382 39.2349 75.9093 39.1401C75.685 39.0753 75.376 39.0404 74.9823 39.0354C74.5886 39.0304 74.1775 39.0279 73.7489 39.0279H73.121V41.8031H73.3303C74.1376 41.8031 74.7157 41.8006 75.0646 41.7956C75.4134 41.7906 75.7349 41.7258 76.0289 41.6011C76.3279 41.4765 76.5322 41.3119 76.6419 41.1074C76.7565 40.898 76.8138 40.6586 76.8138 40.3893Z\" fill=\"#1C8BF7\"/>\n<path d=\"M87.9447 43.8453H81.4262V41.8704H83.2502V34.6818H81.4262V32.707H87.9447V34.6818H86.1207V41.8704H87.9447V43.8453Z\" fill=\"#1C8BF7\"/>\n<path d=\"M1.16022 28.5792C1.16022 27.8046 1.36875 26.9673 1.78581 26.0671C2.22373 25.167 2.69292 24.2668 3.19339 23.3667C3.71472 22.4456 4.18391 21.5454 4.60097 20.6662C5.03889 19.787 5.25784 18.9706 5.25784 18.217C5.25784 17.9239 5.18486 17.6518 5.03889 17.4006C4.91377 17.1284 4.7678 16.8668 4.60097 16.6156C4.455 16.3434 4.31946 16.0818 4.19434 15.8306C4.06922 15.5584 4.00666 15.2653 4.00666 14.9513C4.00666 14.5955 4.14221 14.2501 4.4133 13.9151C4.70524 13.5802 5.02846 13.4127 5.38296 13.4127C5.38296 13.6011 5.39339 13.8314 5.41424 14.1035C5.43509 14.3547 5.4768 14.6059 5.53936 14.8571C5.62277 15.1083 5.73746 15.3386 5.88344 15.548C6.02941 15.7364 6.22751 15.8724 6.47775 15.9562C6.68628 15.391 6.99907 14.6583 7.41613 13.7581C7.85405 12.837 8.36495 11.8636 8.94883 10.8379C9.55357 9.7912 10.2 8.75498 10.8882 7.72923C11.5972 6.68255 12.3166 5.74054 13.0465 4.90319C13.7972 4.06585 14.5479 3.3855 15.2986 2.86216C16.0493 2.33882 16.7583 2.07715 17.4256 2.07715C17.9261 2.07715 18.3536 2.18182 18.7081 2.39115C19.0834 2.60049 19.3858 2.88309 19.6152 3.23897C19.8445 3.5739 20.0114 3.96118 20.1156 4.40078C20.2199 4.84039 20.272 5.29046 20.272 5.751C20.272 7.44663 19.9071 9.03759 19.1772 10.5239C18.4682 11.9892 17.5194 13.2871 16.3308 14.4175C15.163 15.527 13.8284 16.4376 12.327 17.1494C10.8256 17.8402 9.28248 18.2589 7.69765 18.4054L6.8531 19.63L3.22467 28.5792C3.05785 28.935 2.8806 29.1653 2.69292 29.27C2.5261 29.3746 2.30714 29.427 2.03605 29.427C1.45216 29.427 1.16022 29.1444 1.16022 28.5792ZM17.019 4.11818C16.4351 4.11818 15.8303 4.33798 15.2047 4.77759C14.6 5.19626 13.9953 5.751 13.3905 6.44181C12.7858 7.13263 12.2123 7.90717 11.6702 8.76545C11.128 9.62373 10.6484 10.482 10.2313 11.3403C9.81423 12.1776 9.48059 12.9731 9.23035 13.7267C9.00097 14.4803 8.88627 15.0979 8.88627 15.5794C8.88627 15.6212 8.88627 15.7468 8.88627 15.9562C8.90713 16.1655 8.91755 16.3016 8.91755 16.3644C10.2313 16.3016 11.4616 15.9457 12.6085 15.2967C13.7555 14.6269 14.746 13.7791 15.5801 12.7533C16.4142 11.7276 17.0711 10.5867 17.5507 9.33066C18.0303 8.05371 18.2701 6.78722 18.2701 5.5312C18.2701 4.94506 18.2076 4.56825 18.0825 4.40078C17.9573 4.21238 17.6028 4.11818 17.019 4.11818Z\" fill=\"#1C8BF7\"/>\n<path d=\"M20.4597 26.9777C20.4597 26.3497 20.5848 25.774 20.8351 25.2507C21.1062 24.7064 21.3981 24.1936 21.7109 23.7121C22.0237 23.2306 22.3052 22.7491 22.5554 22.2677C22.8265 21.7862 22.9621 21.2733 22.9621 20.729C22.9621 20.6034 22.9517 20.4569 22.9308 20.2894C22.9308 20.101 22.9099 19.9231 22.8682 19.7556C22.8474 19.5881 22.7848 19.4521 22.6806 19.3474C22.5971 19.2218 22.4825 19.159 22.3365 19.159C22.3156 19.159 22.2739 19.1695 22.2114 19.1904C22.1697 19.1904 22.1488 19.2009 22.1488 19.2218C21.8569 19.6195 21.5024 20.0696 21.0853 20.572C20.6891 21.0535 20.2616 21.535 19.8028 22.0165C19.3441 22.4979 18.8957 22.9585 18.4578 23.3981C18.0199 23.8377 17.6237 24.204 17.2692 24.4971C17.019 24.7274 16.6749 25.0414 16.237 25.4391C15.8199 25.8368 15.3924 26.2346 14.9545 26.6323C14.5374 27.0091 14.1621 27.3441 13.8284 27.6371C13.5156 27.9302 13.3384 28.0767 13.2967 28.0767L11.8578 26.8521C12.0455 26.8521 12.2332 26.8103 12.4209 26.7265C12.5877 26.6428 12.7545 26.5486 12.9213 26.4439C14.1725 25.6066 15.2986 24.6436 16.2995 23.5551C17.3213 22.4665 18.3223 21.2942 19.3024 20.0382C19.3441 19.9754 19.4483 19.7975 19.6152 19.5044C19.8028 19.1904 20.0009 18.845 20.2095 18.4682C20.418 18.0705 20.6265 17.6832 20.8351 17.3064C21.0436 16.9086 21.2 16.5946 21.3043 16.3644C21.4294 16.0922 21.5024 15.8724 21.5232 15.705C21.5649 15.5375 21.5962 15.4119 21.6171 15.3282C21.6588 15.2235 21.7213 15.1502 21.8047 15.1083C21.8881 15.0665 22.0654 15.0455 22.3365 15.0455C22.3782 15.0455 22.472 15.056 22.618 15.0769C22.7848 15.0979 22.8891 15.1188 22.9308 15.1397C23.2019 15.705 23.4417 16.2074 23.6502 16.647C23.8588 17.0866 24.036 17.5052 24.182 17.903C24.328 18.2798 24.4322 18.6671 24.4948 19.0648C24.5782 19.4625 24.6199 19.9022 24.6199 20.3836C24.3488 21.0744 24.0464 21.7862 23.7128 22.5189C23.3791 23.2306 23.0976 23.9109 22.8682 24.5599C22.6389 25.2088 22.4929 25.795 22.4303 26.3183C22.3886 26.8417 22.5033 27.2603 22.7744 27.5743C23.0663 27.8674 23.546 28.0244 24.2133 28.0453C24.9014 28.0663 25.8711 27.8883 27.1223 27.5115C27.4559 27.679 27.4872 27.8883 27.2161 28.1395C26.945 28.3698 26.5279 28.5896 25.9649 28.799C25.4227 29.0083 24.818 29.1862 24.1507 29.3328C23.5043 29.4584 22.9621 29.4898 22.5242 29.427C22.128 29.427 21.7943 29.3642 21.5232 29.2386C21.273 29.092 21.0645 28.9036 20.8976 28.6734C20.7517 28.4431 20.637 28.1814 20.5536 27.8883C20.491 27.5953 20.4597 27.2917 20.4597 26.9777Z\" fill=\"#1C8BF7\"/>\n<path d=\"M25.8711 27.7627C25.5166 26.9673 25.3602 26.1927 25.4019 25.4391C25.4436 24.6646 25.6104 23.9423 25.9024 23.2725C26.2152 22.5817 26.6114 21.9641 27.091 21.4198C27.5915 20.8546 28.1232 20.3732 28.6862 19.9754C29.2493 19.5567 29.8123 19.2427 30.3753 19.0334C30.9592 18.8241 31.4701 18.7403 31.908 18.7822C32.3459 18.8031 32.69 18.9601 32.9403 19.2532C33.1905 19.5463 33.2739 19.9964 33.1905 20.6034C33.1905 21.4198 32.9298 22.1316 32.4085 22.7387C31.908 23.3457 31.345 23.89 30.7194 24.3715C30.1147 24.853 29.5516 25.2926 29.0303 25.6903C28.5298 26.0671 28.2796 26.423 28.2796 26.7579C28.2796 26.9463 28.3839 27.0929 28.5924 27.1975C28.8218 27.3022 29.0824 27.3859 29.3744 27.4487C29.6663 27.4906 29.9583 27.522 30.2502 27.5429C30.5422 27.5639 30.7507 27.5848 30.8758 27.6057C32.836 27.1871 34.3061 26.9359 35.2862 26.8521C36.2663 26.7475 36.8815 26.7579 37.1317 26.8835C37.382 26.9882 37.3298 27.1661 36.9753 27.4173C36.6417 27.6476 36.1203 27.8988 35.4113 28.1709C34.7023 28.4221 33.8786 28.6524 32.9403 28.8618C32.0019 29.0711 31.0739 29.1967 30.1564 29.2386C29.2388 29.2595 28.3839 29.1653 27.5915 28.956C26.8199 28.7466 26.2464 28.3489 25.8711 27.7627ZM31.345 20.6034C30.9279 20.6034 30.5317 20.7186 30.1564 20.9488C29.781 21.1791 29.4369 21.4722 29.1241 21.828C28.8322 22.163 28.582 22.5398 28.3734 22.9585C28.1649 23.3562 28.0085 23.733 27.9042 24.0889C27.946 24.1098 27.9772 24.1203 27.9981 24.1203H28.0919C28.3839 24.1203 28.7175 23.9947 29.0929 23.7435C29.4682 23.4923 29.8227 23.1887 30.1564 22.8329C30.49 22.4561 30.7715 22.0688 31.0009 21.671C31.2303 21.2733 31.345 20.9174 31.345 20.6034Z\" fill=\"#1C8BF7\"/>\n<path d=\"M51.5203 29.427C51.1241 29.427 50.7592 29.3537 50.4255 29.2072C50.1127 29.0606 49.8521 28.8513 49.6435 28.5792C49.435 28.307 49.289 28.0035 49.2056 27.6685C49.1222 27.3127 49.1326 26.9359 49.2369 26.5381C49.2369 25.8682 49.3516 25.2507 49.581 24.6855C49.8312 24.0994 50.1023 23.5446 50.3943 23.0213C50.7071 22.477 50.9781 21.9432 51.2075 21.4198C51.4578 20.8756 51.5829 20.2999 51.5829 19.6928C51.1241 19.6928 50.6341 19.8394 50.1127 20.1324C49.5914 20.4255 49.0597 20.8128 48.5175 21.2942C47.9962 21.7757 47.4748 22.32 46.9535 22.9271C46.453 23.5132 45.9734 24.1098 45.5146 24.7169C45.0767 25.303 44.6909 25.8682 44.3573 26.4125C44.0445 26.9568 43.8047 27.4069 43.6379 27.7627C43.5962 27.7837 43.4919 27.8046 43.3251 27.8255C43.1582 27.8255 43.054 27.8255 43.0123 27.8255C42.6786 27.993 42.4701 27.993 42.3867 27.8255C42.3241 27.6371 42.3241 27.3545 42.3867 26.9777C42.4701 26.6009 42.5952 26.1822 42.762 25.7217C42.9289 25.2402 43.0853 24.7902 43.2312 24.3715C43.3981 23.9319 43.5232 23.576 43.6066 23.3039C43.69 23.0108 43.7004 22.8643 43.6379 22.8643C43.7004 22.7805 43.7734 22.6445 43.8568 22.4561C43.9402 22.2677 44.0237 22.0688 44.1071 21.8594C44.1905 21.6501 44.2635 21.4617 44.326 21.2942C44.3886 21.1058 44.4199 20.9593 44.4199 20.8546C44.4199 20.6662 44.3469 20.5511 44.2009 20.5092C44.0758 20.4464 43.9507 20.415 43.8255 20.415C43.4502 20.2057 43.0436 20.3313 42.6056 20.7918C42.1886 21.2314 41.7298 21.8699 41.2293 22.7073C40.7497 23.5237 40.218 24.4657 39.6341 25.5333C39.0711 26.58 38.4455 27.5953 37.7573 28.5792C37.2777 28.5792 36.9128 28.5164 36.6625 28.3907C36.4123 28.2651 36.2872 27.9511 36.2872 27.4487C36.454 27.2185 36.7042 26.7893 37.0379 26.1613C37.3715 25.5124 37.7469 24.8006 38.1639 24.0261C38.581 23.2515 39.0189 22.4665 39.4777 21.671C39.9573 20.8756 40.4056 20.2057 40.8227 19.6614C41.2606 19.0962 41.6464 18.7194 41.9801 18.531C42.3346 18.3217 42.6161 18.4159 42.8246 18.8136C43.1791 18.5833 43.5649 18.3845 43.9819 18.217C44.4199 18.0495 44.8578 17.9658 45.2957 17.9658C45.5876 17.9658 45.8274 18.06 46.0151 18.2484C46.2236 18.4159 46.38 18.6357 46.4843 18.9078C46.6094 19.159 46.7033 19.4311 46.7658 19.7242C46.8284 19.9964 46.8597 20.2371 46.8597 20.4464C47.089 20.2999 47.4644 20.0487 47.9857 19.6928C48.5279 19.316 49.1014 18.9392 49.7061 18.5624C50.3317 18.1856 50.9364 17.8611 51.5203 17.589C52.1251 17.2959 52.6151 17.1494 52.9905 17.1494C53.3241 17.1494 53.6056 17.275 53.835 17.5262C54.0852 17.7565 54.2104 18.0495 54.2104 18.4054C53.4597 20.2476 52.8653 21.7234 52.4274 22.8329C52.0104 23.9423 51.7289 24.8111 51.5829 25.4391C51.4578 26.0462 51.4578 26.4858 51.5829 26.7579C51.7289 27.0091 51.9791 27.208 52.3336 27.3545C52.8966 27.3545 53.4388 27.2603 53.9601 27.0719C54.4814 26.8835 54.9923 26.6742 55.4928 26.4439C56.0141 26.2136 56.5355 26.0043 57.0568 25.8159C57.5781 25.6275 58.1307 25.5333 58.7146 25.5333C58.7146 25.7636 58.6521 25.9834 58.5269 26.1927C58.4227 26.3811 58.2559 26.5277 58.0265 26.6323C57.8596 26.737 57.5573 26.9045 57.1194 27.1347C56.7023 27.3441 56.2435 27.5743 55.7431 27.8255C55.2426 28.0558 54.763 28.2861 54.3042 28.5163C53.8663 28.7466 53.5535 28.9036 53.3658 28.9874C52.9487 29.1758 52.6255 29.3014 52.3961 29.3642C52.1876 29.406 51.8957 29.427 51.5203 29.427Z\" fill=\"#1C8BF7\"/>\n<path d=\"M57.6198 27.3545C57.6198 27.0615 57.6511 26.8103 57.7137 26.6009C57.7762 26.3707 57.8909 26.0776 58.0577 25.7217C58.2037 25.5124 58.4644 25.1146 58.8397 24.5285C59.2359 23.9423 59.6426 23.3248 60.0596 22.6759C60.4976 22.0269 60.9042 21.4198 61.2795 20.8546C61.6757 20.2685 61.9468 19.8603 62.0928 19.63C62.2805 19.3579 62.4265 19.2113 62.5307 19.1904C62.635 19.1695 62.8331 19.159 63.125 19.159C63.3127 19.159 63.5108 19.1695 63.7193 19.1904C63.9487 19.2113 64.0947 19.3579 64.1573 19.63C63.8653 20.3418 63.4691 21.0221 62.9686 21.671C62.489 22.2991 62.0094 22.9271 61.5298 23.5551C61.071 24.1831 60.6644 24.832 60.3099 25.5019C59.9554 26.1508 59.7781 26.8521 59.7781 27.6057C59.8615 27.6057 59.9867 27.6162 60.1535 27.6371C60.3412 27.6581 60.5393 27.679 60.7478 27.6999C60.9563 27.7209 61.144 27.7418 61.3108 27.7627C61.4985 27.7837 61.634 27.7837 61.7175 27.7627C61.8426 27.7418 62.0511 27.6999 62.3431 27.6371C62.6558 27.5534 62.9791 27.4697 63.3127 27.3859C63.6672 27.3022 64.0009 27.2185 64.3137 27.1347C64.6265 27.051 64.8454 26.9882 64.9705 26.9463C64.9705 26.9882 64.9705 27.0615 64.9705 27.1661C64.9914 27.2499 65.0018 27.3127 65.0018 27.3545C65.0018 27.7732 64.8037 28.1186 64.4075 28.3907C64.0321 28.6629 63.5838 28.8827 63.0625 29.0502C62.562 29.1967 62.0407 29.3014 61.4985 29.3642C60.9772 29.406 60.5705 29.427 60.2786 29.427C59.9658 29.427 59.6426 29.3956 59.3089 29.3328C58.9961 29.249 58.7146 29.1234 58.4644 28.956C58.2141 28.7885 58.0056 28.5792 57.8388 28.3279C57.6928 28.0558 57.6198 27.7313 57.6198 27.3545ZM66.7222 8.95385C66.9933 8.95385 67.2435 8.96432 67.4729 8.98525C67.7023 9.00619 67.9004 9.05852 68.0672 9.14226C68.234 9.22599 68.3696 9.35159 68.4738 9.51906C68.5781 9.68653 68.6302 9.9168 68.6302 10.2099C68.6302 10.3355 68.6302 10.4715 68.6302 10.6181C68.6302 10.7646 68.6094 10.9111 68.5677 11.0577C68.5468 11.1833 68.4947 11.2984 68.4113 11.4031C68.3279 11.4868 68.1923 11.5287 68.0047 11.5287C67.7127 11.5287 67.4729 11.424 67.2852 11.2147C67.1184 11.0054 66.9933 10.7646 66.9099 10.4925C66.8265 10.1994 66.7743 9.90633 66.7535 9.61326C66.7326 9.32019 66.7222 9.10039 66.7222 8.95385Z\" fill=\"#1C8BF7\"/>\n<path d=\"M65.3772 27.7627C65.0227 26.9673 64.8663 26.1927 64.908 25.4391C64.9497 24.6646 65.1165 23.9423 65.4084 23.2725C65.7212 22.5817 66.1174 21.9641 66.5971 21.4198C67.0975 20.8546 67.6293 20.3732 68.1923 19.9754C68.7554 19.5567 69.3184 19.2427 69.8814 19.0334C70.4653 18.8241 70.9762 18.7403 71.4141 18.7822C71.852 18.8031 72.1961 18.9601 72.4464 19.2532C72.6966 19.5463 72.78 19.9964 72.6966 20.6034C72.6966 21.4198 72.4359 22.1316 71.9146 22.7387C71.4141 23.3457 70.8511 23.89 70.2255 24.3715C69.6208 24.853 69.0577 25.2926 68.5364 25.6903C68.0359 26.0671 67.7857 26.423 67.7857 26.7579C67.7857 26.9463 67.89 27.0929 68.0985 27.1975C68.3279 27.3022 68.5885 27.3859 68.8805 27.4487C69.1724 27.4906 69.4644 27.522 69.7563 27.5429C70.0482 27.5639 70.2568 27.5848 70.3819 27.6057C72.3421 27.1871 73.8122 26.9359 74.7923 26.8521C75.7724 26.7475 76.3876 26.7579 76.6378 26.8835C76.888 26.9882 76.8359 27.1661 76.4814 27.4173C76.1478 27.6476 75.6264 27.8988 74.9174 28.1709C74.2084 28.4221 73.3847 28.6524 72.4464 28.8618C71.508 29.0711 70.58 29.1967 69.6625 29.2386C68.7449 29.2595 67.89 29.1653 67.0975 28.956C66.326 28.7466 65.7525 28.3489 65.3772 27.7627ZM70.8511 20.6034C70.434 20.6034 70.0378 20.7186 69.6625 20.9488C69.2871 21.1791 68.943 21.4722 68.6302 21.828C68.3383 22.163 68.0881 22.5398 67.8795 22.9585C67.671 23.3562 67.5146 23.733 67.4103 24.0889C67.452 24.1098 67.4833 24.1203 67.5042 24.1203H67.598C67.89 24.1203 68.2236 23.9947 68.599 23.7435C68.9743 23.4923 69.3288 23.1887 69.6625 22.8329C69.9961 22.4561 70.2776 22.0688 70.507 21.671C70.7364 21.2733 70.8511 20.9174 70.8511 20.6034Z\" fill=\"#1C8BF7\"/>\n<path d=\"M82.8624 26.9777C82.8624 26.3497 82.9876 25.774 83.2378 25.2507C83.5089 24.7064 83.8008 24.1936 84.1136 23.7121C84.4264 23.2306 84.7079 22.7491 84.9582 22.2677C85.2293 21.7862 85.3648 21.2733 85.3648 20.729C85.3648 20.6034 85.3544 20.4569 85.3335 20.2894C85.3335 20.101 85.3127 19.9231 85.271 19.7556C85.2501 19.5881 85.1876 19.4521 85.0833 19.3474C84.9999 19.2218 84.8852 19.159 84.7392 19.159C84.7184 19.159 84.6767 19.1695 84.6141 19.1904C84.5724 19.1904 84.5515 19.2009 84.5515 19.2218C84.2596 19.6195 83.9051 20.0696 83.488 20.572C83.0918 21.0535 82.6643 21.535 82.2056 22.0165C81.7468 22.4979 81.2985 22.9585 80.8605 23.3981C80.4226 23.8377 80.0264 24.204 79.6719 24.4971C79.4217 24.7274 79.0776 25.0414 78.6397 25.4391C78.2226 25.8368 77.7952 26.2346 77.3572 26.6323C76.9402 27.0091 76.5648 27.3441 76.2312 27.6371C75.9184 27.9302 75.7411 28.0767 75.6994 28.0767L74.2606 26.8521C74.4482 26.8521 74.6359 26.8103 74.8236 26.7265C74.9904 26.6428 75.1572 26.5486 75.3241 26.4439C76.5752 25.6066 77.7013 24.6436 78.7023 23.5551C79.7241 22.4665 80.725 21.2942 81.7051 20.0382C81.7468 19.9754 81.8511 19.7975 82.0179 19.5044C82.2056 19.1904 82.4037 18.845 82.6122 18.4682C82.8207 18.0705 83.0293 17.6832 83.2378 17.3064C83.4463 16.9086 83.6027 16.5946 83.707 16.3644C83.8321 16.0922 83.9051 15.8724 83.9259 15.705C83.9677 15.5375 83.9989 15.4119 84.0198 15.3282C84.0615 15.2235 84.124 15.1502 84.2075 15.1083C84.2909 15.0665 84.4681 15.0455 84.7392 15.0455C84.7809 15.0455 84.8748 15.056 85.0207 15.0769C85.1876 15.0979 85.2918 15.1188 85.3335 15.1397C85.6046 15.705 85.8444 16.2074 86.053 16.647C86.2615 17.0866 86.4387 17.5052 86.5847 17.903C86.7307 18.2798 86.8349 18.6671 86.8975 19.0648C86.9809 19.4625 87.0226 19.9022 87.0226 20.3836C86.7515 21.0744 86.4492 21.7862 86.1155 22.5189C85.7819 23.2306 85.5004 23.9109 85.271 24.5599C85.0416 25.2088 84.8956 25.795 84.8331 26.3183C84.7914 26.8417 84.906 27.2603 85.1771 27.5743C85.4691 27.8674 85.9487 28.0244 86.616 28.0453C87.3041 28.0663 88.2738 27.8883 89.525 27.5115C89.8586 27.679 89.8899 27.8883 89.6188 28.1395C89.3477 28.3698 88.9307 28.5896 88.3676 28.799C87.8255 29.0083 87.2207 29.1862 86.5534 29.3328C85.907 29.4584 85.3648 29.4898 84.9269 29.427C84.5307 29.427 84.197 29.3642 83.9259 29.2386C83.6757 29.092 83.4672 28.9036 83.3004 28.6734C83.1544 28.4431 83.0397 28.1814 82.9563 27.8883C82.8937 27.5953 82.8624 27.2917 82.8624 26.9777Z\" fill=\"#1C8BF7\"/>\n</svg>\n", Sw = "<svg width=\"212\" height=\"53\" viewBox=\"0 0 212 53\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_26825_26318)\">\n<path d=\"M43.7754 41.2008L25.8203 51.5918C24.1909 52.5489 22.171 52.5489 20.5416 51.5918L2.62426 41.2008C1.01125 40.2625 0.013514 38.5423 0 36.6764V15.9246C0.013514 14.0587 1.01125 12.3385 2.62426 11.4002L20.5793 1.01675C22.2125 0.0738446 24.2248 0.0738446 25.858 1.01675L43.7754 11.3851C45.3951 12.3167 46.3953 14.0411 46.3996 15.9095V36.6538C46.3953 38.5222 45.3951 40.2466 43.7754 41.1781\" fill=\"#FFC337\"/>\n<path d=\"M40.6001 34.3314V18.2774C40.5968 17.0319 39.9301 15.8826 38.8506 15.2612L24.9451 7.22282C23.8652 6.5976 22.5335 6.5976 21.4536 7.22282L7.54053 15.2461C6.46107 15.8675 5.79441 17.0168 5.79102 18.2623V34.3314C5.79441 35.5769 6.46107 36.7263 7.54053 37.3477L21.4536 45.386C22.5335 46.0112 23.8652 46.0112 24.9451 45.386L38.8506 37.3552C39.9301 36.7338 40.5968 35.5844 40.6001 34.3389\" fill=\"#191919\"/>\n<path d=\"M33.6407 31.3223V21.2857C33.6398 20.6628 33.3063 20.0877 32.766 19.7776L24.0788 14.7555C23.5388 14.4383 22.8693 14.4383 22.3293 14.7555L13.6345 19.7701C13.0942 20.0802 12.7607 20.6552 12.7598 21.2782V31.3223C12.7638 31.9444 13.0965 32.518 13.6345 32.8304L22.3293 37.8449C22.8714 38.1544 23.5367 38.1544 24.0788 37.8449L32.766 32.8304C33.304 32.518 33.6367 31.9444 33.6407 31.3223Z\" fill=\"#FFC337\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M206.675 16.8156H205.921L205.876 16.2275H208.138V16.8156H207.347V18.9798H206.675V16.8156ZM210.031 17.4038L211.283 16.2275H211.441V18.9798H210.778V17.5245L210.091 18.188H209.978L209.285 17.5169V18.9798H208.621V16.2275H208.779L210.031 17.4038Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M200.205 35.5998H192.446V32.8098H200.205C201.663 32.8098 202.845 31.6282 202.845 30.1706C202.845 28.713 201.663 27.5314 200.205 27.5314H197.189C194.153 27.5314 191.692 25.0702 191.692 22.0343C191.692 18.9983 194.153 16.5371 197.189 16.5371H203.154V19.3272H197.189C195.694 19.3272 194.482 20.5392 194.482 22.0343C194.482 23.5293 195.694 24.7413 197.189 24.7413H200.205C202.189 24.6673 204.055 25.6835 205.069 27.3903C206.083 29.0971 206.083 31.2215 205.069 32.9283C204.055 34.6351 202.189 35.6512 200.205 35.5772\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M65.0179 16.1445C58.8947 16.1445 55.0488 20.5557 55.0488 26.1132C55.0488 31.6027 58.8645 36.0442 65.0179 36.0442C71.1714 36.0442 75.0173 31.6706 75.0173 26.1132C75.0173 20.5557 71.1412 16.1445 65.0179 16.1445ZM64.9878 19.1607C69.0825 19.1607 71.7747 22.177 71.7747 26.1132H71.8048C71.8048 29.9815 69.0524 32.9978 65.0179 32.9978C60.9835 32.9978 58.2839 30.0268 58.2839 26.1132C58.2839 22.1996 60.893 19.1607 64.9878 19.1607Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M95.2953 23.1954L89.2625 29.4767H88.531L82.4681 23.1954V35.5997H79.3311V16.5596H80.2133L88.8855 25.4425L97.6104 16.5596H98.4399V35.5997H95.2953V23.1954Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M121.161 35.5997H120.339L107.165 22.8409V35.5997H104.02V16.5596H104.85L118.016 29.1298V16.5596H121.161V35.5997Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M129.894 16.5596H126.749V35.6072H129.894V16.5596Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M169.054 27.5086H159.469V32.8097H170.765V35.5997H156.324V16.5596H170.765V19.3496H159.469V24.8392H169.054V27.5086Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M187.778 27.5086H178.193V32.8097H189.497V35.5997H175.049V16.5596H189.497V19.3496H178.193V24.8392H187.778V27.5086Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M148.55 25.6831V25.9697C150.481 26.4418 151.828 28.1892 151.792 30.1773C151.792 33.7591 148.964 35.599 144.643 35.599H135.504V16.5439H144.327C148.708 16.5439 151.189 18.3838 151.189 21.7167C151.25 23.4679 150.189 25.0635 148.55 25.6831ZM138.686 32.7939H144.779L144.726 32.809C146.906 32.809 148.497 31.791 148.497 29.9813C148.497 28.3299 147.004 27.2214 145.005 27.2214H142.849C142.257 27.2214 141.778 26.742 141.778 26.1506V25.7887C141.776 25.5034 141.888 25.2291 142.089 25.0267C142.29 24.8242 142.563 24.7104 142.849 24.7104H144.251C146.536 24.7104 147.901 23.6321 147.901 22.0485C147.901 20.2388 146.514 19.349 144.251 19.349H138.686V32.7939Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_26825_26318\">\n<rect width=\"212\" height=\"52\" fill=\"var(--prism-color-elevation-surface, #FFFFFF)\" transform=\"translate(0 0.30957)\"/>\n</clipPath>\n</defs>\n</svg>\n", Cw = "<svg width=\"456\" height=\"321\" viewBox=\"0 0 456 321\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M258.37 62.8096C225.57 58.4096 186.77 74.5096 172.869 105.61C169.17 113.51 168.469 122.41 170.869 130.71C173.869 141.01 181.67 149.31 191.77 153.01V126.51H208.369V156.11H212.069V105.51H228.87V152.81C230.17 152.41 231.369 151.91 232.569 151.41V87.5096H249.169V141.41C257.77 134.41 263.47 124.61 265.37 113.71C266.87 105.31 265.169 96.6096 260.569 89.4096C259.869 91.3096 258.669 93.0096 256.969 94.3096C255.27 87.2096 251.57 81.5096 247.469 75.0096C272.77 82.4096 282.169 102.31 275.27 123.91C268.469 145.51 248.77 161.01 227.27 167.01C185.57 178.81 151.869 148.21 162.469 112.91C170.969 84.4096 201.07 63.3096 231.27 60.1096C233.57 57.6096 234.37 57.4096 235.87 54.3096L258.37 62.8096Z\" fill=\"#1C8BF7\"/>\n<path d=\"M182.67 142.81C173.17 127.61 173.47 117.01 178.77 104.61C196.17 63.7099 267.17 52.7099 290.07 87.61C323.07 137.81 247.07 202.21 193.57 193.61C194.27 199.01 194.27 201.51 192.27 206.31C185.17 192.11 175.57 181.01 166.37 167.61C179.07 179.51 196.37 183.41 213.87 180.71C254.37 174.31 296.87 135.01 283.37 96.41C268.47 53.7099 186.77 70.51 180.87 119.31C182.97 118.51 185.27 118.21 187.47 118.41C183.77 125.21 183.17 133.71 182.67 142.81Z\" fill=\"#1C8BF7\"/>\n<path d=\"M114.211 249.671L109.002 230.614L103.529 249.671H114.211ZM104.147 221.041C105.029 220.952 105.824 220.864 106.619 220.775C107.413 220.686 108.296 220.775 109.267 220.775C110.238 220.775 110.945 220.775 111.739 220.864C112.534 220.952 113.417 221.041 114.388 221.129L128.514 266.6C126.837 266.866 125.159 266.955 123.482 266.955C121.892 266.955 120.392 266.866 118.802 266.6L116.33 257.471H101.321L98.761 266.6C97.3484 266.866 95.8475 266.955 94.4349 266.955C92.934 266.955 91.4331 266.866 89.844 266.6L104.147 221.041ZM142.464 228.841H131.163C130.898 227.511 130.81 226.182 130.81 224.852C130.81 223.523 130.898 222.282 131.163 220.952H163.035C163.299 222.193 163.388 223.523 163.388 224.852C163.388 226.182 163.299 227.511 163.035 228.841H151.822V266.423L149.527 266.6C148.82 266.689 148.026 266.689 147.319 266.689C146.613 266.689 145.818 266.689 145.024 266.6C144.229 266.512 143.346 266.423 142.552 266.335L142.464 228.841ZM169.391 221.041H195.083C195.348 222.282 195.436 223.611 195.436 224.941C195.436 226.27 195.348 227.6 195.083 228.93H178.573V238.768H191.64C191.905 240.009 192.081 241.339 192.081 242.668C192.081 243.998 191.993 245.327 191.728 246.657H178.573V258.623H195.525C195.789 259.864 195.878 261.194 195.878 262.523C195.878 263.853 195.789 265.182 195.525 266.512H169.48L169.391 221.041ZM55.6766 221.041C57.5306 220.864 59.2964 220.686 60.8856 220.509C62.4747 220.332 64.3288 220.332 66.2711 220.332C68.5666 220.332 70.8621 220.509 73.0693 220.952C75.1882 221.307 77.3071 222.104 79.1611 223.257C80.9269 224.32 82.4278 225.827 83.4872 227.6C84.635 229.727 85.253 232.121 85.1647 234.514C85.1647 236.021 84.9881 237.527 84.5467 238.946C84.1935 240.187 83.6638 241.339 82.9575 242.402C82.3395 243.289 81.6332 244.175 80.8386 244.884C80.2206 245.505 79.426 246.037 78.7197 246.568L77.6602 247.278L88.6962 266.423L86.0476 266.689C85.1647 266.778 84.1935 266.778 83.2224 266.778C81.6332 266.778 80.044 266.689 78.5431 266.423L66.536 245.327L68.0369 244.53C68.6549 244.264 69.3612 243.909 70.1558 243.377C71.0387 242.934 71.8332 242.314 72.6278 241.693C73.4224 240.984 74.1287 240.098 74.5702 239.123C75.0999 238.059 75.4531 236.818 75.3648 235.577C75.3648 232.918 74.5702 230.968 73.0693 229.727C71.3918 228.398 69.3612 227.777 67.2423 227.866C66.3594 227.866 65.5648 227.955 64.7702 228.043V266.423C63.9756 266.512 63.2693 266.6 62.4747 266.689C61.6801 266.778 60.9738 266.778 60.2675 266.778H57.9721C57.1775 266.778 56.3829 266.6 55.5 266.512L55.6766 221.041ZM214.771 239.389C215.742 239.389 216.714 239.3 217.685 239.123C218.568 238.946 219.362 238.591 220.069 238.148C220.775 237.616 221.305 236.996 221.569 236.198C222.011 235.223 222.187 234.159 222.099 233.096C222.099 232.032 221.923 231.057 221.481 230.082C221.04 229.373 220.51 228.752 219.804 228.22C219.097 227.777 218.303 227.423 217.508 227.334C216.625 227.157 215.831 227.157 214.948 227.157C213.977 227.157 213.005 227.245 212.034 227.334V239.477H214.771V239.389ZM212.034 259.509C212.652 259.598 213.359 259.687 214.065 259.687C214.771 259.775 215.566 259.775 216.184 259.775C217.067 259.775 218.038 259.687 218.921 259.509C219.892 259.332 220.775 258.978 221.658 258.534C222.541 258.003 223.247 257.382 223.777 256.496C224.395 255.432 224.659 254.28 224.571 253.039C224.571 251.887 224.395 250.823 223.953 249.759C223.512 248.873 222.894 248.164 222.187 247.632C221.393 247.1 220.422 246.657 219.451 246.48C218.303 246.303 217.067 246.125 215.919 246.125H212.123L212.034 259.509ZM259.268 259.509C265.713 259.509 268.98 254.28 268.98 243.821C268.98 238.591 268.185 234.691 266.596 232.121C265.095 229.55 262.27 228.043 259.268 228.22C252.647 228.22 249.38 233.45 249.38 243.909C249.38 254.368 252.735 259.509 259.268 259.509ZM259.268 267.221C256.267 267.31 253.265 266.689 250.44 265.448C248.056 264.296 245.937 262.7 244.348 260.573C242.67 258.357 241.522 255.875 240.816 253.216C240.022 250.203 239.668 247.012 239.668 243.909C239.668 240.807 240.022 237.616 240.816 234.514C241.522 231.855 242.758 229.284 244.348 227.068C245.937 224.941 248.056 223.257 250.44 222.104C256.09 219.711 262.447 219.711 268.097 222.104C270.481 223.257 272.6 224.941 274.189 227.068C275.866 229.284 277.102 231.855 277.809 234.514C278.603 237.616 278.957 240.718 278.957 243.909C278.957 247.1 278.603 250.203 277.809 253.216C277.102 255.875 275.866 258.357 274.277 260.573C272.688 262.7 270.569 264.385 268.185 265.448C265.272 266.6 262.27 267.221 259.268 267.221ZM307.12 249.671L301.911 230.614L296.438 249.671H307.12ZM297.055 221.041C297.938 220.952 298.733 220.864 299.528 220.775C300.322 220.686 301.205 220.775 302.176 220.775C303.147 220.775 303.854 220.775 304.648 220.864C305.443 220.952 306.326 221.041 307.297 221.129L321.423 266.6C319.746 266.866 318.068 266.955 316.391 266.955C314.801 266.955 313.3 266.866 311.711 266.6L309.151 257.471H294.142L291.582 266.6C290.169 266.866 288.668 266.955 287.256 266.955C285.755 266.955 284.165 266.866 282.665 266.6L297.055 221.041ZM326.985 221.041C328.839 220.864 330.605 220.686 332.194 220.509C333.783 220.332 335.637 220.332 337.58 220.332C339.875 220.332 342.171 220.509 344.378 220.952C346.497 221.395 348.616 222.104 350.47 223.257C352.235 224.32 353.736 225.827 354.884 227.6C356.032 229.727 356.65 232.121 356.562 234.602C356.562 236.109 356.385 237.616 355.943 239.034C355.59 240.275 355.061 241.427 354.354 242.491C353.207 244.175 351.794 245.593 350.117 246.657L349.057 247.366L360.093 266.512L357.444 266.778C356.562 266.866 355.59 266.866 354.619 266.866C353.03 266.866 351.441 266.778 349.94 266.512L338.109 245.416L339.61 244.618C340.228 244.352 340.935 243.909 341.729 243.466C342.612 242.934 343.407 242.402 344.113 241.693C344.908 240.984 345.614 240.098 346.144 239.123C346.673 238.059 347.026 236.818 346.938 235.577C346.938 232.918 346.144 230.968 344.643 229.727C342.965 228.398 340.935 227.777 338.816 227.866C337.933 227.866 337.138 227.955 336.344 228.043V266.423C335.549 266.512 334.843 266.6 334.048 266.689C333.254 266.778 332.547 266.778 331.841 266.778C331.135 266.778 330.34 266.778 329.545 266.689C328.751 266.6 327.956 266.6 327.073 266.423L326.985 221.041ZM374.396 259.066L375.808 259.155H377.927C379.781 259.155 381.547 258.978 383.313 258.534C384.902 258.091 386.403 257.294 387.639 256.141C388.963 254.812 389.934 253.216 390.552 251.443C391.965 246.48 391.965 241.162 390.552 236.198C389.934 234.425 388.963 232.741 387.639 231.411C386.491 230.259 384.99 229.373 383.489 228.93C381.9 228.398 380.223 228.22 378.457 228.22H376.426C375.72 228.22 375.102 228.309 374.396 228.398V259.066ZM365.214 221.041C366.979 220.864 368.834 220.686 370.776 220.509C372.718 220.332 374.837 220.332 377.221 220.332C385.167 220.332 391.17 222.282 395.32 226.27C399.469 230.259 401.5 236.198 401.5 244.087C401.5 251.975 399.381 257.914 395.232 261.637C391.082 265.36 384.814 267.31 376.515 267.31C374.396 267.31 372.365 267.221 370.599 267.132C368.833 267.044 366.979 266.778 365.214 266.6V221.041ZM202.852 221.041C204.177 220.864 205.766 220.686 207.532 220.509C209.297 220.42 211.505 220.332 214.153 220.332C216.36 220.332 218.568 220.509 220.687 220.864C222.541 221.218 224.395 221.839 226.072 222.814C227.573 223.7 228.809 224.852 229.692 226.359C230.663 228.132 231.105 230.082 231.016 232.032C231.016 233.273 230.84 234.602 230.398 235.755C230.045 236.907 229.515 237.882 228.809 238.857C228.191 239.655 227.396 240.452 226.514 240.984C225.719 241.516 224.836 241.871 223.953 242.048C225.013 242.225 226.16 242.491 227.132 242.934C229.692 243.909 231.811 245.859 232.959 248.43C233.665 250.025 234.018 251.887 233.93 253.659C234.018 255.964 233.488 258.357 232.429 260.396C231.458 262.08 229.957 263.498 228.279 264.562C226.425 265.625 224.395 266.335 222.276 266.689C219.892 267.044 217.508 267.221 215.036 267.221C213.094 267.221 211.151 267.221 209.386 267.044C207.532 266.866 205.324 266.778 202.941 266.423L202.852 221.041Z\" fill=\"#1C8BF7\"/>\n</svg>\n", ww = "<svg width=\"152\" height=\"60\" viewBox=\"0 0 152 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M0.847544 37.3947C0.219418 37.3292 -0.174602 36.6896 0.0768127 36.115C5.33561 24.0968 18.0009 16.3027 31.8354 17.7458C32.0068 17.7637 32.1777 17.7831 32.3482 17.8038C32.8572 17.8659 33.2141 18.3259 33.1604 18.8317L32.6409 23.7289C32.5877 24.2313 32.1471 24.602 31.6376 24.602C23.4489 24.6013 16.3028 30.1346 14.2684 37.9358C14.1451 38.4089 13.6984 38.7352 13.2084 38.6841L0.847544 37.3947Z\" fill=\"#00E2FF\"/>\n<path d=\"M4.45391 22.5287C3.90695 22.2155 3.80924 21.4723 4.27446 21.0487C14.0388 12.1579 28.8556 10.1366 40.9436 17.0575C41.0946 17.1439 41.2444 17.2315 41.3932 17.3202C41.8328 17.5821 41.9702 18.1463 41.7137 18.5867L39.2192 22.8713C38.9645 23.3089 38.41 23.4699 37.9446 23.2643C30.4379 19.9487 21.6087 22.1291 16.5344 28.4589C16.2278 28.8414 15.6859 28.9594 15.2592 28.7151L4.45391 22.5287Z\" fill=\"#00BDEA\"/>\n<path d=\"M15.6191 9.75993C15.3033 9.21752 15.5934 8.52547 16.2099 8.38929C29.1488 5.53107 42.9997 11.1274 49.9787 23.1147C50.0658 23.2644 50.1514 23.4145 50.2356 23.5651C50.4842 24.0099 50.3188 24.5666 49.8746 24.8209L45.554 27.2946C45.1128 27.5472 44.5514 27.4117 44.252 27.0029C39.4228 20.4096 30.6774 17.9208 23.0916 20.8865C22.6332 21.0657 22.1044 20.8992 21.858 20.476L15.6191 9.75993Z\" fill=\"#008CB9\"/>\n<path d=\"M35.291 4.93677C35.291 4.31044 35.8912 3.85494 36.4937 4.04271C49.1397 7.9834 58.3129 19.6977 58.3129 33.539C58.3129 33.7122 58.3113 33.885 58.3083 34.0574C58.2993 34.5659 57.8754 34.9659 57.3625 34.9659H52.3735C51.864 34.9659 51.4462 34.5702 51.393 34.0677C50.5357 25.9628 44.2171 19.4701 36.1523 18.2768C35.665 18.2047 35.291 17.7983 35.291 17.3097V4.93677Z\" fill=\"#007394\"/>\n<path d=\"M38.8316 54.7209H33.4447L30.2068 49.4077C29.9648 49.0046 29.7325 48.6446 29.5099 48.3278C29.2872 48.011 29.0598 47.7423 28.8274 47.5215C28.6048 47.2911 28.3676 47.1183 28.116 47.0031C27.874 46.8783 27.6078 46.8159 27.3174 46.8159H26.0542V54.7209H21.3643V34.0729H28.7984C33.8513 34.0729 36.3777 35.9448 36.3777 39.6885C36.3777 40.4084 36.2664 41.0756 36.0438 41.6899C35.8212 42.2947 35.5066 42.8418 35.1 43.3314C34.6934 43.821 34.1998 44.2433 33.619 44.5985C33.0479 44.9537 32.409 45.232 31.7024 45.4336V45.4912C32.0121 45.5872 32.3122 45.7456 32.6026 45.9664C32.893 46.1776 33.1737 46.4272 33.4447 46.7151C33.7158 47.0031 33.9723 47.3151 34.2143 47.6511C34.466 47.9774 34.6934 48.299 34.8967 48.6158L38.8316 54.7209ZM26.0542 37.5574V43.3026H28.0869C29.0936 43.3026 29.9019 43.0146 30.5117 42.4387C31.1313 41.8531 31.441 41.1284 31.441 40.2644C31.441 38.4598 30.352 37.5574 28.1741 37.5574H26.0542Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M49.9215 54.7209H40.2541V38.7354H49.5505V41.6672H43.885V45.2232H49.1571V48.1439H43.885V51.8003H49.9215V54.7209Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M66.5209 38.7354L60.9678 54.7209H56.8535L51.3678 38.7354H55.2797L58.6408 49.8606C58.8207 50.4626 58.9294 50.9939 58.9668 51.4547H59.0343C59.0867 50.9568 59.2029 50.4105 59.3828 49.816L62.7214 38.7354H66.5209Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M78.6014 54.7209H68.934V38.7354H78.2304V41.6672H72.5649V45.2232H77.837V48.1439H72.5649V51.8003H78.6014V54.7209Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M96.1675 54.7209H92.5029L85.8594 44.677C85.4697 44.0899 85.1999 43.6477 85.05 43.3504H85.0051C85.065 43.9152 85.095 44.7773 85.095 45.9367V54.7209H81.6665V38.7354H85.5784L91.9746 48.4672C92.2669 48.9056 92.5367 49.3404 92.784 49.7714H92.8289C92.769 49.3998 92.739 48.6678 92.739 47.5754V38.7354H96.1675V54.7209Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M113.475 47.7983C113.475 52.5992 111.219 54.9996 106.708 54.9996C102.331 54.9996 100.143 52.6549 100.143 47.9655V38.7354H103.785V48.0101C103.785 50.5963 104.804 51.8895 106.843 51.8895C108.844 51.8895 109.844 50.6409 109.844 48.1439V38.7354H113.475V47.7983Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M127.141 54.7209H117.473V38.7354H126.77V41.6672H121.104V45.2232H126.376V48.1439H121.104V51.8003H127.141V54.7209Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M74.0615 36.4413H72.9614V34.0458H69.8543V36.4413H68.7588V30.9186H69.8543V33.2409H72.9614V30.9186H74.0615V36.4413Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M85.953 36.5337C85.0017 36.5337 84.2392 36.2757 83.6653 35.7596C83.0945 35.2435 82.8092 34.5721 82.8092 33.7454C82.8092 32.8571 83.1007 32.1484 83.6837 31.6195C84.2668 31.0906 85.0585 30.8262 86.0589 30.8262C86.9857 30.8262 87.7314 31.0829 88.296 31.5964C88.8637 32.1099 89.1476 32.7813 89.1476 33.6106C89.1476 34.5118 88.8576 35.2243 88.2776 35.7481C87.6976 36.2718 86.9227 36.5337 85.953 36.5337ZM86.0037 31.6311C85.3991 31.6311 84.9066 31.8198 84.5261 32.1972C84.1486 32.5746 83.9599 33.0714 83.9599 33.6876C83.9599 34.3013 84.144 34.7955 84.5123 35.1704C84.8805 35.5452 85.3623 35.7327 85.9576 35.7327C86.5898 35.7327 87.0885 35.5542 87.4536 35.1973C87.8188 34.8404 88.0014 34.3411 88.0014 33.6992C88.0014 33.0394 87.8234 32.5297 87.4674 32.1703C87.1145 31.8108 86.6266 31.6311 86.0037 31.6311Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M101.73 31.6966H99.8331V36.4413H98.7375V31.6966H96.8457V30.9186H101.73V31.6966Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M113.943 36.4413H110.238V30.9186H113.796V31.6966H111.333V33.2602H113.603V34.0343H111.333V35.6672H113.943V36.4413Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M126.313 36.4413H122.659V30.9186H123.754V35.6672H126.313V36.4413Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M129.59 54.8435C129.418 54.8435 129.27 54.7822 129.146 54.6596C129.026 54.537 128.966 54.3902 128.966 54.2193C128.966 54.0484 129.026 53.9016 129.146 53.779C129.27 53.6526 129.418 53.5895 129.59 53.5895C129.766 53.5895 129.916 53.6526 130.04 53.779C130.164 53.9016 130.225 54.0484 130.225 54.2193C130.225 54.3902 130.164 54.537 130.04 54.6596C129.916 54.7822 129.766 54.8435 129.59 54.8435Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M135.689 54.459C135.246 54.7228 134.722 54.8547 134.115 54.8547C133.294 54.8547 132.631 54.5909 132.125 54.0632C131.623 53.5319 131.372 52.8444 131.372 52.0009C131.372 51.0608 131.644 50.3065 132.187 49.738C132.73 49.1657 133.455 48.8796 134.362 48.8796C134.868 48.8796 135.314 48.9725 135.7 49.1583V50.0947C135.273 49.7974 134.816 49.6488 134.328 49.6488C133.74 49.6488 133.257 49.8587 132.878 50.2786C132.504 50.6948 132.316 51.2429 132.316 51.9229C132.316 52.5917 132.492 53.1194 132.845 53.5058C133.201 53.8923 133.676 54.0855 134.272 54.0855C134.774 54.0855 135.246 53.9202 135.689 53.5895V54.459Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M139.488 54.8547C138.638 54.8547 137.957 54.589 137.448 54.0576C136.942 53.5226 136.689 52.8147 136.689 51.934C136.689 50.9754 136.953 50.2266 137.482 49.6878C138.01 49.149 138.724 48.8796 139.623 48.8796C140.481 48.8796 141.15 49.1416 141.63 49.6655C142.113 50.1894 142.355 50.9159 142.355 51.8449C142.355 52.7552 142.094 53.4854 141.573 54.0354C141.056 54.5816 140.361 54.8547 139.488 54.8547ZM139.556 49.6488C138.964 49.6488 138.495 49.8495 138.15 50.2508C137.806 50.6484 137.633 51.1983 137.633 51.9006C137.633 52.5769 137.808 53.1101 138.156 53.5003C138.505 53.8904 138.971 54.0855 139.556 54.0855C140.151 54.0855 140.608 53.8941 140.927 53.5114C141.249 53.1287 141.41 52.5843 141.41 51.8783C141.41 51.1649 141.249 50.6149 140.927 50.2285C140.608 49.842 140.151 49.6488 139.556 49.6488Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M152 54.7209H151.078V51.4435C151.078 50.8119 150.978 50.3548 150.78 50.0724C150.585 49.79 150.255 49.6488 149.791 49.6488C149.397 49.6488 149.062 49.8272 148.785 50.1839C148.511 50.5406 148.374 50.9679 148.374 51.4658V54.7209H147.452V51.3321C147.452 50.2099 147.016 49.6488 146.143 49.6488C145.738 49.6488 145.405 49.8179 145.142 50.156C144.88 50.4904 144.749 50.927 144.749 51.4658V54.7209H143.827V49.0134H144.749V49.9163H144.771C145.18 49.2252 145.776 48.8796 146.559 48.8796C146.952 48.8796 147.295 48.9892 147.587 49.2085C147.88 49.424 148.08 49.7082 148.189 50.0613C148.616 49.2735 149.253 48.8796 150.1 48.8796C151.366 48.8796 152 49.6544 152 51.2039V54.7209Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n</svg>\n", Tw = "<svg width=\"2071\" height=\"453\" viewBox=\"0 0 2071 453\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g transform=\"translate(-0.010188,452.991878) scale(0.100000,-0.100000)\"\nfill=\"#10537F\" stroke=\"none\">\n<path d=\"M1185 4519 c-561 -59 -949 -347 -1079 -801 -37 -129 -49 -244 -43\n-398 14 -327 126 -549 369 -731 160 -119 368 -202 798 -319 344 -94 440 -130\n545 -205 107 -76 154 -175 141 -296 -22 -213 -212 -333 -551 -346 -351 -13\n-725 101 -1020 312 -49 36 -92 65 -95 65 -7 0 -250 -623 -250 -641 0 -23 147\n-124 280 -193 194 -100 411 -168 670 -212 131 -22 449 -30 580 -15 506 58 856\n277 1030 644 131 275 142 634 29 909 -83 201 -257 368 -503 483 -132 62 -264\n106 -555 185 -365 99 -475 137 -564 198 -66 46 -107 92 -134 150 -23 48 -25\n64 -21 140 10 187 120 303 346 364 96 26 354 31 472 9 182 -33 436 -132 617\n-241 39 -23 54 -28 58 -18 70 194 225 635 225 640 0 12 -141 95 -241 142 -310\n147 -732 214 -1104 175z\"/>\n<path d=\"M4308 3445 c-536 -76 -954 -414 -1112 -897 -51 -156 -61 -229 -61\n-443 0 -173 3 -214 23 -305 75 -335 258 -605 536 -792 281 -187 596 -267 1009\n-255 411 11 727 130 951 356 l69 69 -202 219 c-112 120 -206 219 -209 220 -4\n2 -41 -24 -82 -57 -157 -126 -309 -179 -540 -187 -121 -4 -161 -2 -245 16\n-221 45 -401 176 -484 352 -22 46 -43 96 -47 112 l-6 27 990 0 990 0 8 77 c10\n117 -2 365 -24 468 -114 530 -491 899 -1029 1006 -139 27 -396 34 -535 14z\nm406 -595 c204 -52 353 -188 427 -392 49 -133 126 -118 -606 -118 -598 0 -635\n1 -635 17 0 43 56 181 102 249 81 121 202 205 352 244 99 26 258 26 360 0z\"/>\n<path d=\"M7835 3445 c-226 -35 -410 -119 -557 -254 l-58 -53 0 141 0 141 -370\n0 -370 0 0 -1315 0 -1315 385 0 384 0 3 743 c4 733 4 743 26 822 78 279 242\n419 507 432 264 13 426 -101 501 -353 17 -54 18 -126 21 -852 l4 -792 384 0\n385 0 0 653 c0 649 6 809 35 922 69 268 269 424 545 425 191 0 346 -89 419\n-243 68 -143 65 -101 68 -970 l4 -787 385 0 385 0 -4 883 c-3 859 -4 884 -25\n972 -11 50 -32 122 -45 160 -153 443 -527 673 -1057 652 -338 -14 -617 -131\n-824 -347 -57 -59 -71 -69 -78 -56 -5 9 -31 42 -57 74 -139 167 -353 280 -599\n317 -116 18 -286 18 -397 0z\"/>\n<path d=\"M12990 3450 c-235 -32 -426 -118 -572 -257 l-58 -56 0 141 0 142\n-370 0 -370 0 0 -1710 0 -1710 385 0 385 0 0 526 0 527 48 -45 c97 -91 246\n-176 372 -211 165 -48 405 -61 590 -32 683 103 1121 673 1086 1411 -17 375\n-140 675 -371 910 -180 182 -377 287 -647 345 -106 23 -372 33 -478 19z m240\n-651 c112 -30 185 -73 276 -164 91 -90 139 -176 175 -311 31 -113 31 -325 0\n-439 -68 -253 -225 -416 -461 -481 -88 -24 -262 -24 -350 0 -239 65 -402 238\n-466 496 -27 107 -25 315 5 425 32 123 83 217 161 299 171 179 407 241 660\n175z\"/>\n<path d=\"M16116 3444 c-455 -61 -839 -329 -1034 -719 -54 -108 -87 -205 -114\n-328 -32 -148 -32 -436 0 -584 88 -408 325 -711 702 -897 222 -110 420 -155\n711 -163 460 -13 789 89 1062 330 37 33 72 68 78 79 10 19 9 21 -338 397 l-59\n65 -62 -50 c-77 -63 -155 -109 -234 -141 -186 -75 -463 -84 -658 -21 -228 73\n-375 221 -444 446 l-7 22 990 0 990 0 5 43 c20 162 13 338 -20 502 -19 91 -74\n255 -111 329 -107 214 -298 413 -505 529 -262 147 -618 207 -952 161z m399\n-589 c179 -45 328 -162 404 -316 22 -46 47 -109 55 -139 l13 -55 -635 -3\nc-349 -1 -637 0 -639 2 -9 9 31 134 64 200 25 50 59 94 112 146 129 128 257\n178 456 179 68 1 134 -5 170 -14z\"/>\n<path d=\"M19708 3449 c-173 -20 -360 -86 -494 -175 -32 -21 -88 -69 -126 -107\nl-68 -68 0 161 0 160 -370 0 -370 0 0 -1315 0 -1315 384 0 385 0 3 703 c4 688\n4 704 26 782 52 187 161 333 302 403 117 58 204 75 383 75 l157 0 0 353 0 354\n-67 -1 c-38 -1 -102 -6 -145 -10z\"/>\n<path d=\"M20218 1463 c-105 -40 -191 -129 -224 -231 -25 -80 -16 -202 19 -274\n30 -61 103 -135 163 -166 180 -91 407 -14 494 169 67 142 42 293 -67 410 -69\n73 -137 103 -247 106 -68 3 -103 -1 -138 -14z\"/>\n</g>\n</svg>\n", Ew = "<svg width=\"400\" height=\"153\" viewBox=\"0 0 400 153\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M203.4 5.71953C263.7 5.61953 324.1 5.61953 384.4 5.71953C384.4 34.7195 384.5 63.8195 384.4 92.8195C360.3 92.5195 336.2 93.0195 312 92.8195C284.8 92.6195 257.6 93.2195 230.4 92.4195C238 92.6195 246.1 90.3195 251.6 84.8195C252 84.7195 253 84.6195 253.4 84.6195V87.8195L254.5 87.7195C254.5 88.4195 254.6 89.9195 254.6 90.6195C261.3 91.0195 268.1 90.7195 274.8 90.8195C274.6 89.4195 274.5 88.0195 274.3 86.6195L273.7 86.7195C273.5 84.8195 273.2 83.0195 272.8 81.1195C272.6 70.2195 273 59.2195 272.5 48.3195C271.9 46.9195 271.3 45.4195 270.6 44.0195C270.6 43.7195 270.8 43.0195 270.8 42.6195L269.4 42.5195C269.5 42.1195 269.6 41.4195 269.7 41.0195C267.5 38.5195 264.8 36.3195 261.7 35.2195V34.7195H258.6L258.7 33.8195C256.8 33.7195 255 33.6195 253.1 33.4195C246.2 32.3195 239 32.3195 232.1 33.5195C230.6 33.6195 229 33.7195 227.5 33.8195C227.5 34.0195 227.6 34.3195 227.6 34.4195C225.9 34.7195 224.3 35.1195 222.7 35.6195C221.4 36.5195 220.1 37.5195 218.9 38.5195C218.6 38.5195 218 38.6195 217.6 38.6195L217.5 39.4195C216.3 40.5195 215.4 41.8195 214.6 43.0195C214 44.8195 213.4 46.5195 212.7 48.2195V50.4195C219.5 50.6195 226.3 52.1195 233.1 51.8195C233.7 49.1195 235.9 47.5195 238 46.0195C241.5 45.4195 245.1 45.5195 248.6 45.7195L251.5 48.6195V53.1195C247.7 54.2195 243.9 55.4195 240 56.4195C238.7 56.6195 237.4 56.8195 236.2 57.0195C233.2 57.7195 230.2 58.4195 227.2 58.8195C225.5 59.3195 223.7 59.8195 222 60.4195C221.8 60.4195 221.3 60.5195 221.1 60.5195C219.7 61.2195 218.3 62.0195 216.8 62.7195C215.4 63.8195 214.1 65.0195 213 66.3195L212.4 66.6195C212.5 67.0195 212.6 67.9195 212.7 68.4195L211.5 68.7195V69.9195C210.2 73.2195 210.5 76.8195 211.1 80.2195C211.9 82.1195 212.8 84.0195 214.4 85.3195C214.4 85.6195 214.4 86.2195 214.5 86.5195L215.3 86.4195C217.2 88.5195 219.7 89.7195 222.2 90.9195C224.2 91.3195 226.3 91.8195 228.3 92.2195C220.1 92.9195 211.9 92.5195 203.7 92.6195C203.5 63.7195 203.5 34.7195 203.4 5.71953ZM356.3 17.6195C355.3 18.1195 354.4 18.5195 353.4 19.0195V19.9195C353 19.8195 352.3 19.7195 351.9 19.7195C350.9 20.4195 349.9 21.1195 348.9 21.9195H348C346.8 22.4195 345.6 23.0195 344.4 23.5195C344.3 27.0195 344.3 30.5195 344.3 34.0195C341.6 34.0195 339 34.1195 336.4 34.1195C336.2 39.4195 336.4 44.8195 336.3 50.1195H344.3C344.4 59.9195 344.1 69.7195 344.6 79.6195C345.5 82.1195 346.5 84.6195 347.6 87.0195L348 86.9195C349.9 89.2195 352.4 90.9195 355.3 91.5195L355.2 92.0195C361.3 92.3195 367.4 92.3195 373.5 91.9195V91.2195C375.2 91.1195 376.8 91.0195 378.5 90.8195L378.2 82.1195H377.5C377.5 80.1195 377.4 78.0195 377.3 76.0195C376 76.1195 374.7 76.1195 373.4 76.2195V77.1195C371 77.1195 368.7 76.7195 366.4 75.8195C365.8 67.2195 366.2 58.6195 366.1 50.1195H377.5C377.6 45.0195 377.5 39.9195 377.5 34.8195C373.7 34.7195 370 34.7195 366.2 34.9195L366.5 33.1195L365.4 33.3195C365.5 26.7195 365.5 20.1195 365.4 13.5195C362.4 14.5195 359.4 16.0195 356.3 17.6195ZM286.5 33.9195C286.3 52.9195 286.3 71.8195 286.5 90.8195C293.8 90.8195 301.1 90.9195 308.4 90.7195C308.3 80.5195 308.1 70.4195 308.7 60.2195C309.3 58.5195 309.8 56.8195 310.5 55.1195C310.5 54.8195 310.4 54.2195 310.3 53.9195L311.7 53.8195V51.8195C312.2 51.8195 313.1 51.9195 313.6 51.9195L313.5 50.8195C317 49.0195 320.8 50.0195 324.4 51.0195C324.8 50.1195 325.2 49.1195 325.6 48.2195C326.7 45.5195 327.9 42.9195 328.9 40.2195C329.6 38.7195 330 37.1195 331.3 36.0195C330.7 35.7195 329.5 35.0195 329 34.6195L328.4 34.7195C327 34.1195 325.6 33.5195 324.2 32.8195C321.5 32.7195 318.8 32.7195 316.1 33.0195C313.9 34.2195 311.6 35.4195 310.3 37.6195L309.9 37.7195C308.7 39.6195 307.5 41.6195 306.9 43.7195C306.8 40.4195 306.8 37.1195 306.7 33.8195C299.8 34.0195 293.1 34.0195 286.5 33.9195ZM40.9 32.9195C43.6 32.2195 46.3 31.6195 49 31.1195C54.7 30.7195 60.4 30.8195 66.1 31.1195C69.7 31.7195 73.2 32.5195 76.5 34.0195L76.7 34.9195C77.1 34.8195 78 34.7195 78.5 34.6195L78.4 35.4195C80 36.4195 81.4 37.6195 82.6 39.0195C83.6 40.7195 84.7 42.4195 85.7 44.0195C85.8 44.9195 85.9 45.8195 86.1 46.7195C81.2 47.6195 76.1 47.4195 71.2 48.3195C69.2 48.5195 67.2 48.6195 65.1 48.7195C63.8 43.3195 57.6 42.3195 52.9 42.7195C51.2 43.6195 49.7 44.7195 48.3 46.0195C48.6 47.6195 49.1 49.1195 49.7 50.5195C54 52.0195 58.5 52.8195 63.1 53.0195C65.4 53.5195 67.7 53.8195 70 54.3195C71.1 54.5195 72.1 54.8195 73.2 55.0195L77.1 56.2195C78.5 56.9195 79.8 57.5195 81.2 58.2195C83.1 60.0195 85 61.9195 86.7 63.9195C88.6 67.7195 89.1 71.9195 88.5 76.0195L86.4 81.4195L86 81.5195C85.5 82.3195 84.9 83.2195 84.4 84.0195C82.3 86.1195 80 88.0195 77.4 89.3195C76.3 89.7195 75.2 90.2195 74.2 90.7195C64.6 93.8195 54.6 93.3195 45 92.2195C43.3 91.8195 41.7 91.5195 40 91.0195C38.5 90.4195 37.1 89.9195 35.6 89.3195V89.0195C32.8 87.5195 30.7 85.1195 28.6 82.7195C27.2 80.3195 26.1 77.7195 26 74.8195C32.4 74.7195 38.6 73.4195 45 73.4195C45.8 73.2195 47.3 72.9195 48 72.7195C48.5 74.0195 49.1 75.3195 49.6 76.6195L50.5 76.4195L50.4 77.6195H51.5V78.9195C51.9 78.8195 52.8 78.7195 53.3 78.6195L53.4 79.7195C55.9 80.2195 58.5 80.6195 61 80.6195C62.8 79.9195 64.5 79.2195 66.2 78.5195C67.9 76.4195 67.9 73.6195 66.4 71.4195L65.3 71.8195L65.6 70.8195C64.9 70.7195 63.6 70.5195 62.9 70.4195C61 69.8195 59 69.4195 57.1 68.9195C53.7 68.5195 50.4 67.7195 47.1 66.9195C46 66.7195 45 66.6195 43.9 66.4195C41.1 65.5195 38.3 64.5195 35.6 63.3195V62.9195C35.2 62.6195 34.5 62.0195 34.1 61.6195L33.4 61.8195L33.3 61.2195C31.5 59.4195 30.1 57.3195 28.9 55.1195C28.2 50.5195 27.5 45.1195 30.4 41.1195V39.9195L31.5 39.8195L31.4 38.7195H32.4V37.6195L33.5 37.7195L33.4 36.9195C35.8 35.4195 38.2 34.0195 40.9 32.9195ZM127.8 34.1195C133.4 31.1195 139.7 30.4195 146 31.0195C147.9 31.7195 149.8 32.3195 151.6 32.9195V33.9195C152 33.8195 152.7 33.7195 153 33.7195C153.9 34.7195 154.9 35.7195 155.9 36.7195H156.6L156.5 37.8195L157.1 38.0195C157.6 39.4195 158.9 40.0195 160.2 40.6195L160.4 38.9195H161.2C161.5 38.6195 162 38.0195 162.3 37.7195C163.8 36.4195 165.4 35.2195 166.9 33.9195C176 29.2195 188.2 29.7195 195.5 37.4195C195.5 37.6195 195.5 38.1195 195.6 38.3195C196.8 39.6195 197.6 41.1195 197.9 42.8195L198.2 42.7195C198.5 43.9195 198.8 45.2195 199.2 46.4195C200.1 61.5195 199.4 76.7195 199.7 91.8195C192.3 91.8195 184.9 91.8195 177.5 91.9195C177.2 90.7195 176.9 89.5195 176.7 88.3195C177.8 81.4195 176.9 74.3195 177.2 67.3195C177 61.1195 178.6 53.4195 173 49.1195C170.2 48.6195 167.4 48.5195 164.8 50.0195C163.9 51.1195 162.9 52.3195 161.9 53.4195C161.1 56.7195 160.5 60.0195 160.6 63.4195V92.0195C153.1 91.9195 145.7 92.0195 138.2 92.0195C138.3 79.7195 138.2 67.3195 138.2 55.0195L137.7 54.9195C137.3 53.6195 136.8 52.4195 136.4 51.1195C132.1 47.0195 124.2 49.0195 122.9 54.9195H122.4C121.8 67.3195 122.2 79.6195 122.2 92.0195C114.5 92.1195 106.9 92.0195 99.3 92.0195C99.4 72.1195 99.3 52.2195 99.3 32.3195C106.3 32.2195 113.4 32.3195 120.4 32.3195C120.4 35.0195 120.4 37.7195 120.3 40.3195C120.7 40.2195 121.4 40.0195 121.8 39.8195C123.2 38.0195 124.9 36.4195 126.7 34.9195L127.5 35.1195C127.6 34.7195 127.7 34.3195 127.8 34.1195Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M247 65.1193C248.5 64.8193 250.1 64.6193 251.6 64.3193C251.6 67.8193 251.6 71.3193 250.4 74.7193C250.3 74.7193 250 74.8193 249.8 74.9193C248.9 75.9193 248.1 77.0193 247.2 78.0193L245.6 77.6193C245.5 78.0193 245.4 78.8193 245.3 79.2193C245 79.1193 244.4 79.0193 244.2 79.0193C241.3 80.5193 238 79.9193 234.8 79.7193C232.2 77.6193 232 74.4193 232.5 71.2193C235.5 68.6193 239.2 67.2193 243.1 66.6193L247 65.1193ZM102.7 105.819C105 105.719 107.2 105.719 109.5 105.719C109.5 115.519 109.4 125.219 109.5 135.019C107.2 135.019 104.9 135.019 102.7 134.919C102.8 125.219 102.8 115.519 102.7 105.819ZM374 108.319C375.4 107.619 376.8 107.019 378.3 106.319V113.819H382.6C382.6 114.819 382.7 116.919 382.7 117.919H378.3C378.2 122.319 378.1 126.719 378.5 131.019C379.9 130.819 381.2 130.419 382.5 129.919C382.5 132.119 384.2 135.819 380.4 135.119L380.5 135.719C378.1 135.619 375.8 135.219 373.4 134.719L373.3 134.219C372.4 133.119 371.2 131.919 371.5 130.319C371.4 126.119 371.5 122.019 371.4 117.819C370.6 117.819 369.1 117.819 368.4 117.719V113.619C369.2 113.619 370.7 113.719 371.4 113.719C371.4 112.219 371.4 110.719 371.5 109.219C372.2 109.119 373.4 108.519 374 108.319ZM162 114.219C167.1 113.419 172.6 112.919 177.5 115.019L177.4 116.019L178.7 115.919C178.7 116.219 178.6 116.819 178.6 117.119C180.3 122.919 178.6 129.119 179.8 135.019C177.8 134.919 175.8 134.919 173.7 134.819C173.6 134.119 173.4 132.819 173.2 132.119C172.2 133.019 171.1 133.919 170.1 134.819C167.1 135.819 163.8 135.719 160.9 134.619C160.1 134.119 159.4 133.719 158.6 133.219C158.6 133.019 158.5 132.519 158.4 132.319C155.9 129.219 157.9 125.219 160.9 123.419C164.8 122.319 168.9 122.019 172.8 120.819C172.6 119.819 172.5 118.819 172.3 117.919C170 117.719 167.8 117.719 165.5 117.719V118.919L164.4 118.819L164.5 120.119C162.2 120.019 160 119.619 157.9 118.719C159.2 117.119 160.6 115.619 162 114.219ZM169.4 124.619C167.7 125.219 166 125.419 164.2 125.719C163.9 127.519 163.6 129.419 163.3 131.219C166.1 131.519 168.9 131.819 171.7 131.919C172.8 129.519 173.4 126.819 173.9 124.219C172.4 124.319 170.9 124.419 169.4 124.619ZM229.3 113.719C231.1 113.719 233 113.719 234.8 113.819C234.8 114.319 234.7 115.419 234.6 116.019C235.3 115.819 236 115.719 236.8 115.619C240 112.319 245.7 113.319 249.7 114.919L249.5 115.919L250.5 115.819C252.6 122.019 251.1 128.619 251.6 135.019H245.2C245.3 129.619 245.3 124.119 244.5 118.819L243.4 119.019L243.5 117.819C240.6 117.419 237.6 117.819 235.7 120.319C235.5 125.219 235.5 130.119 235.6 135.019C233.3 135.019 231.1 135.019 228.8 134.919C229 127.819 228.2 120.719 229.3 113.719ZM30.2996 113.819C32.0996 113.819 33.7996 113.719 35.4996 113.719C35.8996 114.219 36.5996 115.419 36.9996 115.919L39.9996 113.819C43.0996 113.719 46.5996 112.819 49.2996 114.719H50.2996L50.3996 115.819L51.0996 115.719L52.2996 116.919C55.7996 122.219 54.9996 129.719 50.0996 134.019L49.7996 133.819C48.4996 134.519 47.1996 135.119 45.8996 135.819C44.2996 135.619 42.5996 135.519 40.9996 135.319C39.4996 134.519 37.9996 133.819 36.4996 133.219C36.5996 136.519 36.5996 139.719 36.5996 143.019H30.0996C30.3996 133.219 30.3996 123.519 30.2996 113.819ZM39.7996 131.019C41.6996 131.019 43.5996 131.019 45.5996 130.919L45.4996 130.219C45.7996 129.819 46.3996 129.119 46.7996 128.719L47.3996 128.919C47.5996 126.119 47.6996 123.219 47.3996 120.419C45.3996 117.919 42.4996 117.319 39.4996 117.819L39.3996 118.519C35.2996 121.319 36.0996 128.119 39.7996 131.019ZM305 114.319C309 113.319 313.5 112.819 317.2 114.719H318.3L318.2 115.919L319.4 115.719V116.819L320.6 116.719L320.1 117.919L321 117.819C321.3 118.619 322 120.319 322.3 121.119L322.6 125.919C317.1 125.819 311.7 126.019 306.2 125.819C306.4 127.019 306.6 128.119 306.8 129.319C307.3 129.519 308.2 129.819 308.6 130.019L308.4 131.019C308.8 130.919 309.6 130.819 310 130.819C310.5 131.019 311.6 131.619 312.1 131.819C313.5 130.919 314.8 129.919 315.8 128.619C317.9 128.719 320 128.919 322 129.019C321.1 131.519 319.3 133.319 317.1 134.619L313.8 135.519C312.1 135.619 310.5 135.619 308.8 135.619C307.5 135.119 306.1 134.719 304.8 134.319C303.8 133.619 302.8 133.019 301.8 132.319L300.6 130.319C299.1 127.319 299.3 123.919 299.4 120.719L299.8 120.619C300.8 118.019 302.9 116.119 305 114.319ZM307.9 118.019C307.8 118.519 307.5 119.419 307.3 119.919L306.6 119.819C306.5 120.819 306.5 121.719 306.4 122.719C309.6 122.619 312.7 122.619 315.9 122.719C315.8 120.719 314.9 118.919 313.5 117.519C311.6 117.719 309.8 117.819 307.9 118.019Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n</svg>\n", Dw = "<svg width=\"616\" height=\"189\" viewBox=\"0 0 616 189\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_26802_25948)\">\n<path d=\"M49.8153 159.701V162.772H39.5701V188.877H36.4413V162.588H26.1348V159.701H49.8153Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M76.8699 159.701V188.877H73.6184V175.61H58.2199V188.693H55.2139V159.701H58.3426V172.6H73.6184V159.701H76.8699Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M87.4831 172.539H100.857V175.61H87.4831V185.683H102.698V188.693H84.293V159.701H102.698V162.711H87.4831V172.539Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M136.5 186.052C139.415 186.05 142.298 185.443 144.967 184.271V187.28C142.154 188.39 139.156 188.953 136.132 188.939C127.176 188.939 122.636 183.964 122.636 174.013C122.636 164.062 127.176 159.087 136.132 159.087C139.163 159.057 142.168 159.643 144.967 160.807V163.817C142.297 162.646 139.415 162.039 136.5 162.035C129.139 162.035 125.765 165.782 125.765 174.013C125.765 182.244 129.139 186.052 136.5 186.052Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M176.439 174.074C176.439 184.025 171.899 189 162.942 189C153.985 189 149.445 184.025 149.445 174.074C149.445 164.124 153.985 159.148 162.942 159.148C171.899 159.148 176.439 164.185 176.439 174.074ZM173.31 174.074C173.31 165.844 170.12 162.097 162.942 162.097C155.764 162.097 152.574 165.844 152.574 174.074C152.574 182.305 155.764 186.052 162.942 186.052C170.12 186.052 173.31 182.367 173.31 174.074Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M209.628 159.701V188.877H206.499V164.676L196.315 179.541L186.07 164.676V188.693H182.818V159.701H186.193L196.315 174.32L206.253 159.701H209.628Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M237.725 168.546C237.725 174.32 234.105 177.514 227.664 177.514H220.425V188.693H217.296V159.701H227.664C234.105 159.701 237.725 162.711 237.725 168.546ZM234.596 168.546C234.596 165.721 233.737 162.404 227.234 162.404H220.425V174.381H226.989C233.737 174.504 234.596 171.31 234.596 168.546Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M264.964 188.693H261.59L258.093 179.602H245.394L241.958 188.693H238.646L250.24 159.701H253.369L264.964 188.693ZM256.927 176.408L251.835 163.079L246.744 176.408H256.927Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M293.921 159.701V188.877H290.424L273.001 164.308V188.877H269.934V159.701H273.492L290.853 184.271V159.701H293.921Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M323.184 159.701L312.387 175.487V188.877H309.258V175.303L298.338 159.701H302.141L310.792 171.986L319.38 159.701H323.184Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M360.361 159.701V162.711H345.638V172.723H358.521V175.794H345.638V188.877H342.509V159.701H360.361Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M391.342 174.074C391.342 184.025 386.802 189 377.845 189C368.888 189 364.349 184.025 364.349 174.074C364.349 164.124 368.888 159.148 377.845 159.148C386.802 159.148 391.342 164.185 391.342 174.074ZM388.213 174.074C388.213 165.844 385.023 162.097 377.845 162.097C370.668 162.097 367.477 165.844 367.477 174.074C367.477 182.305 370.668 186.052 377.845 186.052C385.023 186.052 388.213 182.367 388.213 174.074Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M419.563 188.693H415.82L408.213 176.9H400.79V188.693H397.661V159.701H408.336C414.471 159.701 418.213 162.588 418.213 168.178C418.331 170.159 417.714 172.114 416.48 173.668C415.245 175.221 413.481 176.263 411.526 176.593L419.563 188.693ZM415.084 168.239C415.084 165.536 414.287 162.527 408.213 162.527H400.79V173.951H408.213C414.287 173.951 415.084 170.88 415.084 168.239Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M460.114 159.701V162.772H449.684V188.877H446.556V162.588H436.249V159.701H460.114Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M489.254 174.074C489.254 184.025 484.776 189 475.757 189C466.739 189 462.261 184.025 462.261 174.074C462.261 164.124 466.801 159.148 475.757 159.148C484.714 159.148 489.254 164.185 489.254 174.074ZM486.125 174.074C486.125 165.844 482.935 162.097 475.757 162.097C468.58 162.097 465.451 165.844 465.451 174.074C465.451 182.305 468.58 186.052 475.757 186.052C482.935 186.052 486.125 182.367 486.125 174.074Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M519.13 159.701V176.9C519.247 178.524 519.029 180.155 518.488 181.691C517.948 183.227 517.097 184.636 515.989 185.828C514.881 187.02 513.539 187.971 512.048 188.621C510.557 189.272 508.947 189.607 507.321 189.607C505.694 189.607 504.085 189.272 502.594 188.621C501.102 187.971 499.761 187.02 498.653 185.828C497.544 184.636 496.694 183.227 496.153 181.691C495.613 180.155 495.394 178.524 495.511 176.9V159.701H498.64V176.9C498.64 183.042 501.462 186.113 507.351 186.113C513.241 186.113 516.002 183.104 516.002 176.9V159.701H519.13Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M548.333 188.693H544.591L536.984 176.9H529.56V188.693H526.432V159.701H537.106C543.241 159.701 546.983 162.588 546.983 168.178C547.102 170.159 546.484 172.114 545.25 173.668C544.016 175.221 542.251 176.263 540.296 176.593L548.333 188.693ZM543.855 168.239C543.855 165.536 543.057 162.527 536.984 162.527H529.56V173.951H536.984C543.057 173.951 543.855 170.88 543.855 168.239Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M557.29 159.701V188.877H554.1V159.701H557.29Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M582.81 181.261C582.81 186.113 579.007 189 572.504 189C569.516 189.063 566.561 188.365 563.915 186.973V183.534C566.391 185.15 569.304 185.964 572.259 185.868C575.633 185.868 579.682 185.069 579.682 181.261C579.682 172.723 563.608 177.023 563.608 167.256C563.608 163.325 566.246 159.148 573.67 159.148C576.202 159.158 578.699 159.746 580.97 160.868V164.124C578.833 162.925 576.426 162.29 573.976 162.281C569.375 162.281 566.798 164.001 566.798 167.256C566.676 173.644 582.81 170.082 582.81 181.261Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M616 159.701V188.877H612.871V164.676L602.565 179.541L592.319 164.676V188.693H588.945V159.701H592.319L602.319 174.504L612.626 159.701H616Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M224.106 42.0137H193.063V132.06H224.106V42.0137Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M224.412 15.9088C224.412 19.0578 223.479 22.1361 221.73 24.7535C219.982 27.371 217.496 29.41 214.589 30.6123C211.682 31.8145 208.484 32.126 205.401 31.5072C202.317 30.8883 199.486 29.3671 197.266 27.136C195.046 24.905 193.538 22.0646 192.932 18.9746C192.326 15.8846 192.649 12.684 193.861 9.77813C195.073 6.87229 197.119 4.39196 199.74 2.6513C202.361 0.910643 205.439 -0.0120399 208.584 0.000118632C210.668 0.00010296 212.731 0.412031 214.656 1.21227C216.58 2.01251 218.328 3.1853 219.798 4.66337C221.269 6.14143 222.433 7.89568 223.225 9.82545C224.017 11.7552 224.42 13.8225 224.412 15.9088Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M293.307 40.7236C277.779 40.9302 262.496 44.6246 248.584 51.5342V131.999H279.626V65.2316C282.467 64.4703 285.397 64.0984 288.338 64.126C302.571 64.126 303.491 69.8998 303.491 74.0766V131.999H334.472V78.929C334.717 55.281 319.012 40.7236 293.307 40.7236Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M448.519 41.9523H408.888L389.931 63.8191V8.16943H358.95V131.999H389.931V106.201L392.999 102.946L415.023 131.999H452.445L411.894 81.6319L448.519 41.9523Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M128.832 40.7236C123.722 40.716 118.618 41.0649 113.556 41.7678V7.67773H82.3297V107.798H60.8577C60.1516 107.798 59.4525 107.658 58.8009 107.385C58.1493 107.113 57.5582 106.714 57.0618 106.211C56.5653 105.708 56.1735 105.112 55.9089 104.457C55.6443 103.801 55.5123 103.1 55.5204 102.393V7.67773H28.8951C26.2571 26.9647 17.8524 35.2569 0 34.8883V54.2367H23.9873C23.9873 54.2367 23.9873 113.08 23.9873 113.695C23.9873 118.582 25.9263 123.269 29.3778 126.725C32.8293 130.18 37.5106 132.122 42.3918 132.122H113.372V65.4158C116.067 64.6371 118.85 64.2037 121.654 64.1259C136.071 64.1259 137.482 69.8997 137.482 74.0765V131.999H168.524V78.929C168.524 55.8337 154.107 40.7236 128.832 40.7236Z\" fill=\"var(--prism-color-text-neutral-emphasis, #1F2124)\"/>\n<path d=\"M496.493 8.10791V98.2776H465.451V8.10791H496.493Z\" fill=\"#1ECAD3\"/>\n<path d=\"M496.923 125.242C496.935 128.391 496.014 131.473 494.275 134.097C492.536 136.722 490.059 138.77 487.157 139.984C484.255 141.197 481.058 141.521 477.972 140.914C474.885 140.307 472.048 138.797 469.82 136.575C467.592 134.352 466.072 131.518 465.454 128.43C464.836 125.342 465.147 122.14 466.348 119.23C467.549 116.319 469.585 113.831 472.2 112.08C474.814 110.33 477.888 109.395 481.034 109.395C485.237 109.395 489.269 111.063 492.247 114.033C495.225 117.003 496.907 121.034 496.923 125.242Z\" fill=\"#1ECAD3\"/>\n<path d=\"M616 8.10791V132.122H588.515L544.345 58.4137V132.122H516.554V8.10791H544.345L588.209 82.4917V8.10791H616Z\" fill=\"#1ECAD3\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_26802_25948\">\n<rect width=\"616\" height=\"189\" fill=\"var(--prism-color-elevation-surface, #FFFFFF)\"/>\n</clipPath>\n</defs>\n</svg>\n", Ow = "<svg width=\"70\" height=\"24\" viewBox=\"0 0 70 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_26768_24793)\">\n<mask id=\"mask0_26768_24793\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"1\" y=\"0\" width=\"69\" height=\"24\">\n<path d=\"M69.167 0H1.16699V24H69.167V0Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask0_26768_24793)\">\n<path d=\"M19.1216 4.95617C19.1216 4.19522 19.3885 3.54183 19.9224 2.98805C20.4563 2.43825 21.0946 2.16335 21.8335 2.16335C22.5995 2.16335 23.2417 2.43825 23.764 2.98805C24.2863 3.53785 24.5455 4.19522 24.5455 4.95617C24.5455 5.74502 24.2824 6.40637 23.764 6.94422C23.2417 7.48207 22.5995 7.749 21.8335 7.749C21.0946 7.749 20.4602 7.48207 19.9224 6.94422C19.3885 6.40637 19.1216 5.74502 19.1216 4.95617ZM16.6766 9.44223H25.7293V0L1.16699 2.63745V9.44223H8.88504V18.7649H16.6766V9.44223ZM17.9765 20.6534H25.7332V10.741H17.9765V20.6534ZM43.3435 7.27888H44.1443V1.72908C41.7264 1.6494 39.5521 2.16335 37.6294 3.26295C36.4185 3.95617 35.3701 4.85259 34.4764 5.94821V3.89641H27.0292V18.7649H34.4764V16.3267C34.4764 14.6215 34.8594 13.0757 35.6216 11.6853C36.3876 10.2948 37.4437 9.21514 38.7939 8.43825C40.1441 7.66534 41.6606 7.27888 43.3435 7.27888ZM53.8083 16.2869C53.8083 16.5737 53.7193 16.8127 53.5413 16.996C53.3634 17.1793 53.1351 17.2709 52.8527 17.2709H43.2622C42.9837 17.2709 42.7516 17.1793 42.5736 16.996C42.3956 16.8127 42.3067 16.5777 42.3067 16.2869C42.3067 16 42.3956 15.761 42.5736 15.5777C42.7516 15.3944 42.9798 15.3028 43.2622 15.3028H52.8527C53.1313 15.3028 53.3634 15.3944 53.5413 15.5777C53.7193 15.7649 53.8083 16 53.8083 16.2869ZM59.3869 20.243C60.0485 19.0757 60.3812 17.757 60.3812 16.2908C60.3812 14.8207 60.0485 13.506 59.3869 12.3386C58.7254 11.1713 57.8278 10.255 56.6943 9.58566C55.5608 8.91633 54.2686 8.58167 52.8179 8.58167H43.3435C41.8927 8.58167 40.5928 8.91633 39.4477 9.58566C38.3026 10.255 37.3973 11.1713 36.7357 12.3386C36.0742 13.506 35.7415 14.8247 35.7415 16.2908C35.7415 17.761 36.0703 19.0797 36.7357 20.243C37.3973 21.4104 38.3026 22.3267 39.4477 22.996C40.5928 23.6653 41.8927 24 43.3435 24H52.8179C54.2686 24 55.5608 23.6653 56.6943 22.996C57.8278 22.3267 58.7254 21.4104 59.3869 20.243ZM69.167 18.7649V2.63745L61.3754 0V18.7649H69.167Z\" fill=\"#B51F1F\"/>\n</g>\n</g>\n<defs>\n<clipPath id=\"clip0_26768_24793\">\n<rect width=\"69\" height=\"24\" fill=\"white\" transform=\"translate(0.5)\"/>\n</clipPath>\n</defs>\n</svg>\n", kw = "<svg width=\"400\" height=\"85\" viewBox=\"0 0 400 85\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_26769_25275)\">\n<path d=\"M397.751 56.7983C396.511 56.7983 395.503 57.805 395.503 59.0444C395.503 60.2839 396.511 61.2905 397.751 61.2905C398.992 61.2905 400 60.2839 400 59.0444C400 57.805 398.992 56.7983 397.751 56.7983ZM397.751 60.9343C396.706 60.9343 395.859 60.0842 395.859 59.0444C395.859 57.9996 396.71 57.1545 397.751 57.1545C398.797 57.1545 399.648 58.0045 399.648 59.0444C399.648 60.0843 398.797 60.9343 397.751 60.9343ZM398.483 58.6597C398.483 58.2514 398.193 58.0092 397.766 58.0092H397.048V60.0558H397.399V59.3151H397.784L398.155 60.0558H398.535L398.127 59.2392C398.346 59.1394 398.483 58.9398 398.483 58.6597ZM397.751 58.9969H397.404V58.318H397.751C397.989 58.318 398.132 58.4366 398.132 58.6551C398.132 58.8782 397.984 58.9969 397.751 58.9969ZM126.83 34.0667V28.6343H118.493V60.9533H126.83V41.5744C126.83 38.0651 129.083 36.3413 132.596 36.3413H137.16V28.6344H133.262C130.21 28.6343 127.558 30.225 126.83 34.0667ZM144.97 15.8511C142.118 15.8511 139.931 18.102 139.931 20.9511C139.931 23.7338 142.118 25.9847 144.97 25.9847C147.822 25.9847 150.009 23.7338 150.009 20.9511C150.009 18.1018 147.822 15.8511 144.97 15.8511ZM140.811 60.9534H149.129V28.6343H140.811V60.9534ZM188.755 44.7938C188.755 54.0203 181.268 61.4995 172.032 61.4995C168.305 61.4995 164.925 60.2791 162.216 58.2181V70.4412H153.897V28.6343H162.216V31.3694C164.925 29.3086 168.305 28.0882 172.032 28.0882C181.268 28.0882 188.755 35.5673 188.755 44.7938ZM180.384 44.7938C180.384 39.784 176.315 35.7191 171.3 35.7191C166.285 35.7191 162.216 39.784 162.216 44.7938C162.216 49.8036 166.285 53.8684 171.3 53.8684C176.315 53.8684 180.384 49.8084 180.384 44.7938ZM333.34 41.9589L328.487 40.6293C325.293 39.7982 324.052 38.82 324.052 37.1343C324.052 35.4912 325.801 34.3421 328.302 34.3421C330.683 34.3421 332.551 35.8996 332.551 37.894V38.0791H340.219V37.894C340.219 32.0294 335.432 28.088 328.302 28.088C321.243 28.088 316.113 32.0246 316.113 37.4523C316.113 41.6738 318.913 44.8554 323.8 46.1755L328.449 47.4434C331.981 48.4216 333.293 49.5044 333.293 51.4466C333.293 53.4932 331.396 54.8703 328.572 54.8703C325.63 54.8703 323.648 53.0087 323.648 50.2451V50.0599H315.51V50.2451C315.51 56.8742 320.853 61.5088 328.506 61.5088C335.879 61.5088 341.231 56.9834 341.231 50.7532C341.231 47.6951 339.862 43.6969 333.34 41.9589ZM218.266 28.6343H226.584V60.9533H218.266V58.218C215.556 60.279 212.176 61.4994 208.449 61.4994C199.213 61.4994 191.726 54.0203 191.726 44.7936C191.726 35.567 199.213 28.088 208.449 28.088C212.176 28.088 215.556 29.3084 218.266 31.3693V28.6343ZM218.266 44.7938C218.266 39.7793 214.196 35.7191 209.181 35.7191C204.166 35.7191 200.097 39.784 200.097 44.7938C200.097 49.8036 204.166 53.8684 209.181 53.8684C214.201 53.8684 218.266 49.8084 218.266 44.7938ZM256.622 17.1332H264.941V60.958H256.622V58.2228C253.913 60.2838 250.533 61.5041 246.806 61.5041C237.57 61.5041 230.083 54.025 230.083 44.7984C230.083 35.5718 237.57 28.0928 246.806 28.0928C250.533 28.0928 253.913 29.3132 256.622 31.3741V17.1332ZM256.622 44.7938C256.622 39.784 252.553 35.7191 247.538 35.7191C242.523 35.7191 238.454 39.784 238.454 44.7938C238.454 49.8036 242.518 53.8684 247.538 53.8684C252.553 53.8684 256.622 49.8084 256.622 44.7938ZM303.564 60.9534H311.883V28.6343H303.564V60.9534ZM307.723 15.8511C304.871 15.8511 302.684 18.102 302.684 20.9511C302.684 23.7338 304.871 25.9847 307.723 25.9847C310.575 25.9847 312.762 23.7338 312.762 20.9511C312.762 18.1018 310.575 15.8511 307.723 15.8511ZM377.187 44.7938C377.187 54.0203 369.701 61.4995 360.464 61.4995C351.228 61.4995 343.741 54.0204 343.741 44.7938C343.741 35.5671 351.228 28.0882 360.464 28.0882C369.701 28.0882 377.187 35.5673 377.187 44.7938ZM369.548 44.7938C369.548 39.784 365.479 35.7191 360.464 35.7191C355.449 35.7191 351.38 39.784 351.38 44.7938C351.38 49.8036 355.444 53.8684 360.464 53.8684C365.479 53.8684 369.548 49.8084 369.548 44.7938ZM122.571 17.1332H90.6602V24.5458H102.473V60.9533H110.763V24.5458H122.576V17.1332H122.571ZM283.951 52.1019L276.549 28.6344H267.812L278.912 60.9534H288.923L300.089 28.6344H291.352L283.951 52.1019ZM389.375 34.0667V28.6343H381.038V60.9533H389.375V41.5744C389.375 38.0651 391.629 36.3413 395.142 36.3413H399.705V28.6344H395.807C392.755 28.6343 390.108 30.225 389.375 34.0667Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n<path d=\"M42.5446 85C66.0413 85 85.0891 65.9721 85.0891 42.5C85.0891 19.0279 66.0413 0 42.5446 0C19.0478 0 0 19.0279 0 42.5C0 65.9721 19.0478 85 42.5446 85Z\" fill=\"#34E0A1\"/>\n<path d=\"M68.8226 34.209L73.9565 28.6293H62.5716C56.8721 24.7401 49.9889 22.4751 42.5448 22.4751C35.1101 22.4751 28.246 24.745 22.5559 28.6293H11.1426L16.2765 34.209C13.1296 37.0771 11.1569 41.2084 11.1569 45.7956C11.1569 54.4523 18.1828 61.4707 26.8486 61.4707C30.9652 61.4707 34.7157 59.8847 37.5156 57.2919L42.5449 62.7623L47.5742 57.2967C50.3741 59.8895 54.1198 61.4707 58.2364 61.4707C66.9022 61.4707 73.9375 54.4523 73.9375 45.7956C73.9422 41.2037 71.9695 37.0724 68.8226 34.209ZM26.8532 56.4039C20.9872 56.4039 16.2338 51.6555 16.2338 45.7956C16.2338 39.9358 20.9873 35.1872 26.8532 35.1872C32.7191 35.1872 37.4727 39.9358 37.4727 45.7956C37.4727 51.6555 32.7191 56.4039 26.8532 56.4039ZM42.5495 45.4869C42.5495 38.5064 37.468 32.5137 30.7607 29.9542C34.3876 28.4393 38.3664 27.5988 42.5448 27.5988C46.7231 27.5988 50.7066 28.4393 54.3336 29.9542C47.6312 32.5185 42.5495 38.5065 42.5495 45.4869ZM58.2412 56.4039C52.3752 56.4039 47.6216 51.6555 47.6216 45.7956C47.6216 39.9358 52.3752 35.1872 58.2412 35.1872C64.1072 35.1872 68.8606 39.9358 68.8606 45.7956C68.8606 51.6555 64.1071 56.4039 58.2412 56.4039ZM58.2412 40.2301C55.1656 40.2301 52.6747 42.7184 52.6747 45.7908C52.6747 48.8631 55.1656 51.3514 58.2412 51.3514C61.3167 51.3514 63.8076 48.8631 63.8076 45.7908C63.8075 42.7232 61.3167 40.2301 58.2412 40.2301ZM32.4196 45.7956C32.4196 48.8679 29.9287 51.3562 26.8532 51.3562C23.7777 51.3562 21.2868 48.8679 21.2868 45.7956C21.2868 42.7232 23.7777 40.2349 26.8532 40.2349C29.9287 40.2301 32.4196 42.7232 32.4196 45.7956Z\" fill=\"var(--prism-color-icon-neutral-emphasis, #2E3D4B)\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_26769_25275\">\n<rect width=\"400\" height=\"85\" fill=\"var(--prism-color-elevation-surface, #FFFFFF)\"/>\n</clipPath>\n</defs>\n</svg>\n", Aw = {
	container: "_container_1vbjf_1",
	logo: "_logo_1vbjf_7",
	divider: "_divider_1vbjf_13",
	"powered-by": "_powered-by_1vbjf_18",
	"powered-by-text": "_powered-by-text_1vbjf_23",
	"powered-by-logo": "_powered-by-logo_1vbjf_29"
}, jw = {
	aibosolutions: hw,
	bwoptimizer: gw,
	HotelBizness: _w,
	hotellabio: vw,
	iforhospitality: yw,
	ihcl: bw,
	JHMHotels: xw,
	omnibees: Sw,
	rateboard: Cw,
	revenuecl: ww,
	semper: Tw,
	smartplanet: Ew,
	thinkin: Dw,
	tirol: Ow,
	tripadvisor: kw
};
function Mw(e) {
	return e ? jw[e] : void 0;
}
function Nw(e) {
	let t = (0, x.c)(7), { logo: n } = e, r;
	t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)(lw, { children: /* @__PURE__ */ (0, C.jsx)("div", {
		className: Aw.logo,
		dangerouslySetInnerHTML: { __html: n },
		"data-testid": "reseller-logo-image"
	}) }), t[0] = n, t[1] = r);
	let i;
	t[2] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ (0, C.jsx)("div", { className: Aw.divider }), t[2] = i) : i = t[2];
	let a;
	t[3] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ (0, C.jsx)("span", {
		className: Aw["powered-by-text"],
		children: "Powered by"
	}), t[3] = a) : a = t[3];
	let o;
	t[4] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ (0, C.jsxs)("div", {
		className: Aw["powered-by"],
		children: [a, /* @__PURE__ */ (0, C.jsx)("div", {
			className: Aw["powered-by-logo"],
			dangerouslySetInnerHTML: { __html: cw["logo-dark"] }
		})]
	}), t[4] = o) : o = t[4];
	let s;
	return t[5] === r ? s = t[6] : (s = /* @__PURE__ */ (0, C.jsxs)("div", {
		className: Aw.container,
		"data-testid": "reseller-logo",
		children: [
			r,
			i,
			o
		]
	}), t[5] = r, t[6] = s), s;
}
//#endregion
//#region src/general/components/header/logo.tsx
function Pw() {
	let e = (0, x.c)(4), t = /* @__PURE__ */ new Date();
	if (t.getMonth() === 11 && t.getDate() >= 15 || t.getMonth() === 0 && t.getDate() <= 6) {
		let t;
		e[0] === Symbol.for("react.memo_cache_sentinel") ? (t = /* @__PURE__ */ (0, C.jsx)("div", {
			className: `${dw["holidays-logo"]} ${dw["holidays-logo-1"]}`,
			dangerouslySetInnerHTML: { __html: fw }
		}), e[0] = t) : t = e[0];
		let n;
		e[1] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ (0, C.jsx)("div", {
			className: `${dw["holidays-logo"]} ${dw["holidays-logo-2"]}`,
			dangerouslySetInnerHTML: { __html: pw }
		}), e[1] = n) : n = e[1];
		let r;
		return e[2] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ (0, C.jsxs)("div", {
			className: dw["holidays-container"],
			"data-testid": "holidays-logo",
			children: [
				t,
				n,
				/* @__PURE__ */ (0, C.jsx)("div", {
					className: `${dw["holidays-logo"]} ${dw["holidays-logo-3"]}`,
					dangerouslySetInnerHTML: { __html: mw }
				})
			]
		}), e[2] = r) : r = e[2], r;
	}
	let n;
	return e[3] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ (0, C.jsx)("div", {
		className: dw["default-logo"],
		dangerouslySetInnerHTML: { __html: cw["logo-color"] },
		"data-testid": "default-logo"
	}), e[3] = n) : n = e[3], n;
}
function Fw(e) {
	let t = (0, x.c)(5), { reseller: n } = e, r;
	t[0] === n ? r = t[1] : (r = Mw(n), t[0] = n, t[1] = r);
	let i = r;
	if (i) {
		let e;
		return t[2] === i ? e = t[3] : (e = /* @__PURE__ */ (0, C.jsx)(Nw, { logo: i }), t[2] = i, t[3] = e), e;
	}
	let a;
	return t[4] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ (0, C.jsx)(lw, { children: /* @__PURE__ */ (0, C.jsx)(Pw, {}) }), t[4] = a) : a = t[4], a;
}
//#endregion
//#region src/general/components/header/settings-button.tsx
function Iw(e) {
	let t = (0, x.c)(8), { to: n } = e, r = EC(), { formatMessage: i } = cC(), a;
	t[0] === i ? a = t[1] : (a = i({ id: "menu.settings" }), t[0] = i, t[1] = a);
	let o;
	t[2] !== r || t[3] !== n ? (o = () => {
		r({ to: n });
	}, t[2] = r, t[3] = n, t[4] = o) : o = t[4];
	let s;
	return t[5] !== a || t[6] !== o ? (s = /* @__PURE__ */ (0, C.jsx)(xe, {
		"aria-label": a,
		buttonType: "ghost",
		icon: "settings",
		onClick: o
	}), t[5] = a, t[6] = o, t[7] = s) : s = t[7], s;
}
//#endregion
//#region src/general/domain/tabs/has-route.ts
function Lw(e) {
	return "route" in e;
}
//#endregion
//#region src/general/domain/tabs/is-disabled-tab.ts
function Rw(e) {
	return "disabled" in e;
}
//#endregion
//#region src/general/tab-context.tsx
var zw = (0, S.createContext)(null);
function Bw() {
	let e = (0, S.useContext)(zw);
	if (!e) throw Error("`useTabs` must be used inside <TabProvider>");
	return e;
}
function Vw(e) {
	let t = (0, x.c)(6), { menuItems: n, shouldGroup: r, children: i } = e, a;
	t[0] !== n || t[1] !== r ? (a = {
		menuItems: n,
		shouldGroup: r
	}, t[0] = n, t[1] = r, t[2] = a) : a = t[2];
	let o;
	return t[3] !== i || t[4] !== a ? (o = /* @__PURE__ */ (0, C.jsx)(zw, {
		value: a,
		children: i
	}), t[3] = i, t[4] = a, t[5] = o) : o = t[5], o;
}
//#endregion
//#region src/general/components/header/tabs/is-tab-active.ts
function Hw(e, t) {
	return [e.route, ...e.activeMatch ?? []].some((n) => t({
		search: e.search,
		to: n
	}));
}
//#endregion
//#region src/general/components/header/tabs/tab-key.ts
function Uw(e) {
	return "route" in e ? e.search ? `${e.route}?${new URLSearchParams(e.search).toString()}` : e.route : e.href;
}
var Ww = { badge: "_badge_1nrkr_1" };
//#endregion
//#region src/general/components/header/tabs/components/tab-badge.tsx
function Gw(e) {
	let t = (0, x.c)(5), { label: n, type: r } = e, i = r === void 0 ? "brand" : r, a;
	t[0] === n ? a = t[1] : (a = /* @__PURE__ */ (0, C.jsx)(yC, { id: n }), t[0] = n, t[1] = a);
	let o;
	return t[2] !== a || t[3] !== i ? (o = /* @__PURE__ */ (0, C.jsx)(yc, {
		className: Ww.badge,
		type: i,
		children: a
	}), t[2] = a, t[3] = i, t[4] = o) : o = t[4], o;
}
var Kw = {
	item: "_item_2pr3c_6",
	disabled: "_disabled_2pr3c_21"
};
//#endregion
//#region src/general/components/header/tabs/components/tab-group-item.tsx
function qw(e) {
	let t = (0, x.c)(18), { label: n, childTabs: r } = e, { isActive: i } = SC(), a;
	if (t[0] !== r || t[1] !== i) {
		let e;
		t[3] === i ? e = t[4] : (e = (e) => Lw(e) && Hw(e, i), t[3] = i, t[4] = e), a = r.some(e), t[0] = r, t[1] = i, t[2] = a;
	} else a = t[2];
	let o;
	t[5] === n ? o = t[6] : (o = /* @__PURE__ */ (0, C.jsx)(Tg.Trigger, { children: /* @__PURE__ */ (0, C.jsx)(yC, { id: n }) }), t[5] = n, t[6] = o);
	let s;
	if (t[7] !== r || t[8] !== i) {
		let e;
		t[10] === i ? e = t[11] : (e = (e) => Rw(e) ? /* @__PURE__ */ (0, C.jsxs)(Tg.Content.Item, {
			"aria-disabled": !0,
			className: Kw.disabled,
			role: "link",
			children: [/* @__PURE__ */ (0, C.jsx)(yC, { id: e.label }), e.badge ? /* @__PURE__ */ (0, C.jsx)(Gw, {
				label: e.badge,
				type: e.badgeType
			}) : null]
		}, e.label) : /* @__PURE__ */ (0, C.jsxs)(Tg.Content.Item, {
			active: Hw(e, i),
			render: /* @__PURE__ */ (0, C.jsx)(wC, {
				search: e.search,
				to: e.route
			}),
			children: [/* @__PURE__ */ (0, C.jsx)(yC, { id: e.label }), e.badge ? /* @__PURE__ */ (0, C.jsx)(Gw, {
				label: e.badge,
				type: e.badgeType
			}) : null]
		}, Uw(e)), t[10] = i, t[11] = e), s = r.map(e), t[7] = r, t[8] = i, t[9] = s;
	} else s = t[9];
	let c;
	t[12] === s ? c = t[13] : (c = /* @__PURE__ */ (0, C.jsx)(Tg.Content, { children: s }), t[12] = s, t[13] = c);
	let l;
	return t[14] !== a || t[15] !== o || t[16] !== c ? (l = /* @__PURE__ */ (0, C.jsxs)(Tg.Item, {
		active: a,
		className: Kw.item,
		children: [o, c]
	}), t[14] = a, t[15] = o, t[16] = c, t[17] = l) : l = t[17], l;
}
//#endregion
//#region src/general/components/header/tabs/components/tab-link.tsx
function Jw(e) {
	let t = (0, x.c)(28), { tab: n, active: r } = e;
	if ("route" in n) {
		let e;
		t[0] !== n.route || t[1] !== n.search ? (e = /* @__PURE__ */ (0, C.jsx)(wC, {
			search: n.search,
			to: n.route
		}), t[0] = n.route, t[1] = n.search, t[2] = e) : e = t[2];
		let i;
		t[3] === n.label ? i = t[4] : (i = /* @__PURE__ */ (0, C.jsx)(yC, { id: n.label }), t[3] = n.label, t[4] = i);
		let a;
		t[5] === n.iconName ? a = t[6] : (a = n.iconName ? /* @__PURE__ */ (0, C.jsx)(N, {
			"aria-hidden": !0,
			name: n.iconName,
			size: "small"
		}) : null, t[5] = n.iconName, t[6] = a);
		let o;
		t[7] !== n.badge || t[8] !== n.badgeType ? (o = n.badge ? /* @__PURE__ */ (0, C.jsx)(Gw, {
			label: n.badge,
			type: n.badgeType
		}) : null, t[7] = n.badge, t[8] = n.badgeType, t[9] = o) : o = t[9];
		let s;
		t[10] !== r || t[11] !== e || t[12] !== i || t[13] !== a || t[14] !== o ? (s = /* @__PURE__ */ (0, C.jsxs)(Tg.Link, {
			active: r,
			render: e,
			children: [
				i,
				a,
				o
			]
		}), t[10] = r, t[11] = e, t[12] = i, t[13] = a, t[14] = o, t[15] = s) : s = t[15];
		let c;
		return t[16] !== r || t[17] !== s ? (c = /* @__PURE__ */ (0, C.jsx)(Tg.Item, {
			active: r,
			className: Kw.item,
			children: s
		}), t[16] = r, t[17] = s, t[18] = c) : c = t[18], c;
	}
	let i;
	t[19] === n.label ? i = t[20] : (i = /* @__PURE__ */ (0, C.jsx)(yC, { id: n.label }), t[19] = n.label, t[20] = i);
	let a;
	t[21] !== n.badge || t[22] !== n.badgeType ? (a = n.badge ? /* @__PURE__ */ (0, C.jsx)(Gw, {
		label: n.badge,
		type: n.badgeType
	}) : null, t[21] = n.badge, t[22] = n.badgeType, t[23] = a) : a = t[23];
	let o;
	return t[24] !== i || t[25] !== a || t[26] !== n.href ? (o = /* @__PURE__ */ (0, C.jsx)(Tg.Item, {
		className: Kw.item,
		children: /* @__PURE__ */ (0, C.jsxs)(Tg.Link, {
			href: n.href,
			rel: "noreferrer",
			target: "_blank",
			children: [i, a]
		})
	}), t[24] = i, t[25] = a, t[26] = n.href, t[27] = o) : o = t[27], o;
}
var Yw = {
	container: "_container_1s6p3_1",
	tabs: "_tabs_1s6p3_8",
	list: "_list_1s6p3_25"
};
//#endregion
//#region src/general/components/header/tabs/use-responsive-grouping.ts
function Xw(e) {
	let t = (0, x.c)(3), [n, r] = (0, S.useState)(!1), i, a;
	return t[0] === e ? (i = t[1], a = t[2]) : (i = () => {
		if (!e) return;
		let t = e, n = null, i = new ResizeObserver(function() {
			let e = t.clientWidth, i = t.scrollWidth;
			if (n !== null) {
				e > n && (n = null, r(!1));
				return;
			}
			i > e ? (n = i, r(!0)) : r(!1);
		});
		return i.observe(e), e.firstElementChild && i.observe(e.firstElementChild), () => {
			i.disconnect();
		};
	}, a = [e], t[0] = e, t[1] = i, t[2] = a), (0, S.useEffect)(i, a), n;
}
//#endregion
//#region src/general/components/header/tabs/index.tsx
function Zw() {
	let e = (0, x.c)(9), { menuItems: t, shouldGroup: n } = Bw(), { isActive: r } = SC(), [i, a] = (0, S.useState)(null), o = Xw(i), s = n || o;
	if (t.length === 0) return null;
	let c;
	if (e[0] !== r || e[1] !== s || e[2] !== t) {
		let n;
		e[4] !== r || e[5] !== s ? (n = (e) => "children" in e ? e.label === null || !e.alwaysGrouped && !s ? e.children.filter(Qw).filter(Lw).map((e) => /* @__PURE__ */ (0, C.jsx)(Jw, {
			active: Hw(e, r),
			tab: e
		}, Uw(e))) : /* @__PURE__ */ (0, C.jsx)(qw, {
			childTabs: e.children,
			label: e.label
		}, e.label) : /* @__PURE__ */ (0, C.jsx)(Jw, {
			active: "route" in e && Hw(e, r),
			tab: e
		}, Uw(e)), e[4] = r, e[5] = s, e[6] = n) : n = e[6], c = t.map(n), e[0] = r, e[1] = s, e[2] = t, e[3] = c;
	} else c = e[3];
	let l;
	return e[7] === c ? l = e[8] : (l = /* @__PURE__ */ (0, C.jsx)("div", {
		className: Yw.container,
		ref: a,
		children: /* @__PURE__ */ (0, C.jsx)(Tg, {
			className: Yw.tabs,
			children: /* @__PURE__ */ (0, C.jsx)(Tg.List, {
				className: Yw.list,
				children: c
			})
		})
	}), e[7] = c, e[8] = l), l;
}
function Qw(e) {
	return !Rw(e);
}
//#endregion
//#region src/general/components/header.tsx
function $w(e) {
	let t = (0, x.c)(2), { children: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)("header", {
		className: D.header,
		children: /* @__PURE__ */ (0, C.jsx)("div", {
			className: D.content,
			children: n
		})
	}), t[0] = n, t[1] = r), r;
}
$w.AccountMenu = PC, $w.AccountSelector = aw, $w.SettingsButton = Iw, $w.Tabs = Zw, $w.Logo = Fw;
//#endregion
//#region src/general/domain/tabs/destination-tabs.ts
function eT(e) {
	return e.hasFeature("app.daas.custom_reporting") ? [{
		label: "menu.destination",
		route: "/daas/$destinationId/reporting"
	}] : [];
}
//#endregion
//#region src/general/domain/tabs/tab-builder-helpers.ts
function tT({ children: e, label: t, alwaysGrouped: n = !1 }) {
	return e.length === 0 ? [] : e.length === 1 && !n ? e : n ? [{
		alwaysGrouped: n,
		children: e,
		label: t
	}] : [{
		children: e,
		label: t
	}];
}
//#endregion
//#region src/general/domain/tabs/hotel-tabs.ts
function nT(e) {
	if (e.hasFeature("app.market_insight")) return {
		label: "menu.market",
		route: "/hotel/$hotelId/market-insight"
	};
	if (e.hasFeature("app.market_insight_upsell")) return {
		iconName: "lock",
		label: "menu.market",
		route: "/hotel/$hotelId/market-insight-preview"
	};
	if (e.hasFeature("app.market_insight.no_data")) return {
		label: "menu.market",
		route: "/hotel/$hotelId/market-insight-unsupported-market"
	};
}
function rT(e) {
	return e.hasFeature("smart_insights.recommendations_hide_prima");
}
function iT(e) {
	return !rT(e) && e.hasFeature("app.pricing_assistant");
}
function aT(e) {
	return !rT(e) && e.hasFeature("app.smart_distribution");
}
function oT(e) {
	return e.hasFeature("app.channel_manager") && iT(e);
}
function sT(e) {
	return !oT(e) || e.hasRates;
}
function cT(e) {
	let t = [];
	return e.hasRates && (t.push({
		activeMatch: ["/hotel/$hotelId/rates", "/hotel/$hotelId/pricing-manager"],
		label: oT(e) ? "menu.monthly_view" : "menu.rates",
		route: iT(e) ? "/hotel/$hotelId/pricing-manager" : "/hotel/$hotelId/rates"
	}), aT(e) && oT(e) && t.push({
		label: "menu.weekly_view",
		route: "/hotel/$hotelId/channel-pricing"
	})), e.hasFeature("app.short_term_rental") && t.push({
		label: "menu.short_term_rental",
		route: "/hotel/$hotelId/short-term-rental"
	}), e.hasFeature("app.rate_strategy") && t.push({
		label: "menu.strategy",
		route: "/hotel/$hotelId/strategy"
	}), e.hasFeature("app.events") && sT(e) && t.push({
		label: "menu.events",
		route: "/hotel/$hotelId/events"
	}), (e.hasParity || e.hasParityAnalyticsStaff) && t.push({
		activeMatch: [
			"/hotel/$hotelId/parity/insight",
			"/hotel/$hotelId/parity/overview",
			"/hotel/$hotelId/parity/pos"
		],
		label: "menu.parity",
		route: "/hotel/$hotelId/parity/list"
	}), e.hasRanking && t.push({
		label: "ranking.ranking",
		route: "/hotel/$hotelId/ranking"
	}), !oT(e) && iT(e) && !e.hasRates && t.push({
		label: "menu.pricing_assistant",
		route: "/hotel/$hotelId/pricing-manager"
	}), t;
}
function lT(e) {
	return e.hasRates ? oT(e) ? "menu.pricing_distribution" : "menu.rates" : e.hasParity ? "menu.parity" : null;
}
function uT(e) {
	if (!oT(e) || e.hasRates) return [];
	let t = [];
	return iT(e) && t.push({
		label: "menu.monthly_view",
		route: "/hotel/$hotelId/pricing-manager"
	}), aT(e) && t.push({
		label: "menu.weekly_view",
		route: "/hotel/$hotelId/channel-pricing"
	}), e.hasFeature("app.events") && t.push({
		label: "menu.events",
		route: "/hotel/$hotelId/events"
	}), t;
}
function dT(e) {
	if (!(oT(e) || !aT(e))) return {
		badge: "general.new",
		badgeType: "brand",
		label: "menu.smart_distribution",
		route: "/hotel/$hotelId/channel-pricing"
	};
}
function fT(e, t) {
	return e.hasFeature("app.net_revenue.view") && t.hasToggle(u.BI_NET_REVENUE);
}
function pT(e, t) {
	return e.hasFeature("app.revenue_insight") || e.hasFeature("app.spider") || e.hasFeature("app.business_intelligence.budget_and_forecast") || fT(e, t);
}
function mT(e, t) {
	let n = [];
	return e.hasFeature("app.revenue_insight") && (n.push({
		label: "revenue_insight.view_selection.net_bookings",
		route: "/hotel/$hotelId/revenue",
		search: { selectedView: "net" }
	}), e.hasFeature("revenueinsight.cancellations") && n.push({
		label: "revenue_insight.view_selection.cancellations_only",
		route: "/hotel/$hotelId/revenue",
		search: { selectedView: "cancellations" }
	})), fT(e, t) && n.push({
		badge: "general.beta.2",
		badgeType: "info",
		label: "menu.net_revenue",
		route: "/hotel/$hotelId/net-revenue"
	}), e.hasFeature("app.spider") && (e.hasFeature("spider.hotel_snapshot") && n.push({
		label: "menu.spider.snapshot",
		route: "/hotel/$hotelId/snapshot"
	}), e.hasFeature("spider.day_by_day") && n.push({
		label: "menu.spider.day-by-day",
		route: "/hotel/$hotelId/day-by-day"
	}), e.hasFeature("spider.market_segment_drilldown") && n.push({
		label: "menu.spider.segment-drilldown",
		route: "/hotel/$hotelId/segment-drilldown"
	}), e.hasFeature("spider.account_analysis") && n.push({
		label: "menu.spider.accounts",
		route: "/hotel/$hotelId/accounts"
	}), e.hasFeature("spider.revpak") && n.push({
		label: "menu.spider.revpak",
		route: "/hotel/$hotelId/revpak"
	})), e.hasFeature("app.business_intelligence.budget_and_forecast") && n.push({
		label: "menu.budget",
		route: "/hotel/$hotelId/budget"
	}, {
		label: "menu.forecast",
		route: "/hotel/$hotelId/forecast"
	}), n;
}
function hT(e, t) {
	if (!pT(e, t) && e.hasFeature("business_intelligence.upsell")) return {
		iconName: "lock",
		label: "menu.performance",
		route: "/hotel/$hotelId/performance-preview"
	};
}
function gT(e, t) {
	return e.hasFeature("app.benchmark_insight") && t.benchmarkInsightIsLight;
}
function _T(e, t) {
	if (e.hasFeature("app.benchmark_insight") && !gT(e, t)) return {
		label: "demand.benchmark",
		route: "/hotel/$hotelId/benchmark-insight"
	};
}
function vT(e, t) {
	if (gT(e, t)) return {
		activeMatch: ["/hotel/$hotelId/benchmark-insight"],
		badge: "benchmark_insight.free",
		badgeType: "brand",
		label: "demand.benchmark",
		route: "/hotel/$hotelId/benchmark-insight/preview"
	};
	if (!e.hasFeature("app.benchmark_insight") && (e.hasFeature("benchmark_insight.light.upsell.app") || e.hasFeature("benchmark_insight.upsell.app"))) return {
		badge: "benchmark_insight.free",
		badgeType: "brand",
		label: "demand.benchmark",
		route: "/hotel/$hotelId/benchmark-insight/preview"
	};
}
function yT({ access: e, featureToggles: t, hotel: n }) {
	let r = [];
	e.hasFeature("overview.view") && r.push({
		label: "menu.overview",
		route: "/hotel/$hotelId/overview"
	});
	let i = nT(e);
	i && r.push(i), r.push(...tT({
		children: cT(e),
		label: lT(e)
	}));
	let a = hT(e, t);
	a && r.push(a), r.push(...tT({
		children: uT(e),
		label: "menu.pricing_distribution"
	}));
	let o = dT(e);
	o && r.push(o), e.hasFeature("app.channel_manager") && r.push({
		label: "menu.distribution",
		route: "/hotel/$hotelId/channel-manager"
	}), e.hasFeature("app.reservation_manager") && r.push({
		label: "menu.reservations",
		route: "/hotel/$hotelId/reservation-manager"
	}), e.hasFeature("app.review_manager") && r.push({
		label: "menu.reviews",
		route: "/hotel/$hotelId/reviews"
	});
	let s = _T(e, n);
	s && r.push(s), pT(e, t) && r.push(...tT({
		alwaysGrouped: !0,
		children: mT(e, t),
		label: "menu.bi"
	}));
	let c = vT(e, n);
	return c && r.push(c), r;
}
function bT(e) {
	return [
		e.hasFeature("overview.view"),
		e.hasRates || e.hasParity,
		e.hasFeature("app.market.revenue_insight"),
		e.hasFeature("app.market_insight"),
		e.hasFeature("app.benchmark_insight")
	].filter(Boolean).length > 1;
}
//#endregion
//#region src/general/domain/tabs/market-tabs.ts
function xT(e, t) {
	return e.hasFeature("app.market.reservations") && t.hasToggle(u.BI_SNAPSHOTS);
}
function ST(e, t) {
	return [
		e.hasFeature("app.market.revenue_insight"),
		e.hasFeature("app.market.spider"),
		e.hasFeature("spider.market.segment_drilldown"),
		e.hasFeature("spider.market.heatmap"),
		e.hasFeature("app.market.total_revenue"),
		e.hasFeature("app.business_intelligence.custom_reporting"),
		xT(e, t)
	].filter(Boolean).length > 1;
}
function CT(e) {
	if (!e.hasFeature("app.market.spider")) return [];
	let t = [{
		label: "menu.property_breakdown",
		route: "/market/$marketId/executive"
	}];
	return e.hasFeature("spider.market.segment_drilldown") && t.push({
		label: "menu.segment_drilldown",
		route: "/market/$marketId/segment-drilldown"
	}), e.hasFeature("spider.market.heatmap") && t.push({
		label: "menu.heatmap",
		route: "/market/$marketId/heatmap"
	}), t;
}
function wT(e, t) {
	let n = [];
	if (e.hasFeature("app.smart_insights") && n.push({
		label: "menu.portfolio_smart_insights",
		route: "/market/$marketId/smart-insights"
	}), e.hasRates && n.push({
		label: "menu.rates",
		route: "/market/$marketId/rates/hotel"
	}), e.hasFeature("app.market.distribution_insight.connectivity_manager") && n.push({
		alwaysGrouped: !0,
		children: [
			{
				label: "distribution.channel_performance",
				route: "/preview/market/$marketId/channel-performance"
			},
			{
				label: "distribution.error_analysis",
				route: "/preview/market/$marketId/error-analysis"
			},
			{
				disabled: !0,
				label: "distribution.brand_and_property"
			},
			{
				disabled: !0,
				label: "distribution.look_to_book"
			}
		],
		label: "menu.distribution"
	}), e.hasFeature("app.market.parity")) {
		let t = [{
			label: "menu.parity_insight",
			route: "/market/$marketId/parity/insight"
		}];
		e.hasFeature("app.market.parity_strategy") && t.push({
			label: "menu.parity_strategy",
			route: "/market/$marketId/parity/strategy"
		}), n.push(...tT({
			children: t,
			label: "menu.parity_insight"
		}));
	}
	e.hasFeature("app.market.parity_manager") && n.push(...tT({
		children: [{
			label: "menu.parity_manager",
			route: "/market/$marketId/parity/manager"
		}],
		label: "menu.parity_manager"
	}));
	let r = {
		label: "menu.bookings",
		route: "/market/$marketId/revenue"
	}, i = {
		label: "menu.total_revenue",
		route: "/market/$marketId/total-revenue"
	}, a = {
		label: "menu.custom_reporting",
		route: "/market/$marketId/custom-reporting"
	}, o = {
		label: "menu.snapshots",
		route: "/market/$marketId/snapshots"
	}, s = CT(e), c = xT(e, t);
	if (ST(e, t)) {
		let t = [];
		e.hasFeature("app.market.revenue_insight") && t.push(r), t.push(...s), e.hasFeature("app.market.total_revenue") && t.push(i), e.hasFeature("app.business_intelligence.custom_reporting") && t.push(a), c && t.push(o), n.push(...tT({
			alwaysGrouped: !0,
			children: t,
			label: "menu.bi"
		}));
	} else e.hasFeature("app.market.revenue_insight") && n.push(r), s.length > 0 && n.push(...tT({
		alwaysGrouped: s.length > 1,
		children: s,
		label: "menu.bi"
	})), e.hasFeature("app.market.total_revenue") && n.push(i), e.hasFeature("app.business_intelligence.custom_reporting") && n.push(a), c && n.push(o);
	return n;
}
//#endregion
//#region src/general/domain/tabs/tab-catalog.ts
function TT(e) {
	switch (e.kind) {
		case "destination": return eT(e.access);
		case "hotel": return yT({
			access: e.access,
			featureToggles: e.featureToggles,
			hotel: e.hotel
		});
		case "market": return wT(e.access, e.featureToggles);
	}
}
//#endregion
//#region src/daas-header.tsx
function ET(e) {
	let t = (0, x.c)(17), { accountMenuOptions: n, accountSelectorOptions: r, reseller: i } = e, a = T(), o;
	t[0] === a ? o = t[1] : (o = TT({
		access: a,
		kind: "destination"
	}), t[0] = a, t[1] = o);
	let s = o, c;
	t[2] === i ? c = t[3] : (c = /* @__PURE__ */ (0, C.jsx)($w.Logo, { reseller: i }), t[2] = i, t[3] = c);
	let l;
	t[4] === Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ (0, C.jsx)($w.Tabs, {}), t[4] = l) : l = t[4];
	let u;
	t[5] === r ? u = t[6] : (u = r && /* @__PURE__ */ (0, C.jsx)($w.AccountSelector, { ...r }), t[5] = r, t[6] = u);
	let d;
	t[7] === Symbol.for("react.memo_cache_sentinel") ? (d = /* @__PURE__ */ (0, C.jsx)($w.SettingsButton, { to: "/daas/$destinationId/settings" }), t[7] = d) : d = t[7];
	let f;
	t[8] === n ? f = t[9] : (f = n ? /* @__PURE__ */ (0, C.jsx)($w.AccountMenu, {
		kind: "destination",
		...n
	}) : null, t[8] = n, t[9] = f);
	let p;
	t[10] !== c || t[11] !== u || t[12] !== f ? (p = /* @__PURE__ */ (0, C.jsxs)($w, { children: [
		c,
		l,
		u,
		d,
		f
	] }), t[10] = c, t[11] = u, t[12] = f, t[13] = p) : p = t[13];
	let m;
	return t[14] !== s || t[15] !== p ? (m = /* @__PURE__ */ (0, C.jsx)(Vw, {
		menuItems: s,
		shouldGroup: !1,
		children: p
	}), t[14] = s, t[15] = p, t[16] = m) : m = t[16], m;
}
//#endregion
//#region src/general/components/settings-side-panel.module.css
var DT = "_content_14nxs_20", OT = {
	"side-panel": "_side-panel_14nxs_1",
	"settings-header": "_settings-header_14nxs_9",
	content: DT
}, kT = { link: "_link_1he2v_1" };
//#endregion
//#region src/general/components/settings-side-panel/link.tsx
function AT(e) {
	let t = (0, x.c)(3), { to: n, children: r } = e, i;
	return t[0] !== r || t[1] !== n ? (i = /* @__PURE__ */ (0, C.jsx)("li", { children: /* @__PURE__ */ (0, C.jsx)(wC, {
		className: kT.link,
		to: n,
		children: r
	}) }), t[0] = r, t[1] = n, t[2] = i) : i = t[2], i;
}
var jT = { list: "_list_17ali_1" };
//#endregion
//#region src/general/components/settings-side-panel/list.tsx
function MT(e) {
	let t = (0, x.c)(2), { children: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)("ul", {
		className: jT.list,
		children: n
	}), t[0] = n, t[1] = r), r;
}
//#endregion
//#region src/general/components/settings-side-panel/section.tsx
function NT(e) {
	let t = (0, x.c)(2), { children: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)("li", { children: n }), t[0] = n, t[1] = r), r;
}
var PT = { title: "_title_kbl7u_1" };
//#endregion
//#region src/general/components/settings-side-panel/title.tsx
function FT(e) {
	let t = (0, x.c)(2), { children: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ (0, C.jsx)("h4", {
		className: PT.title,
		children: n
	}), t[0] = n, t[1] = r), r;
}
//#endregion
//#region src/general/components/settings-side-panel.tsx
function IT(e) {
	let t = (0, x.c)(9), { children: n } = e, r = (0, S.useId)(), i;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ (0, C.jsx)(yC, { id: "menu.settings" }), t[0] = i) : i = t[0];
	let a;
	t[1] === r ? a = t[2] : (a = /* @__PURE__ */ (0, C.jsx)("div", {
		className: OT["settings-header"],
		children: /* @__PURE__ */ (0, C.jsx)("h4", {
			id: r,
			children: i
		})
	}), t[1] = r, t[2] = a);
	let o;
	t[3] === n ? o = t[4] : (o = /* @__PURE__ */ (0, C.jsx)("ul", {
		className: OT.content,
		children: n
	}), t[3] = n, t[4] = o);
	let s;
	return t[5] !== r || t[6] !== a || t[7] !== o ? (s = /* @__PURE__ */ (0, C.jsxs)("nav", {
		"aria-labelledby": r,
		className: OT["side-panel"],
		children: [a, o]
	}), t[5] = r, t[6] = a, t[7] = o, t[8] = s) : s = t[8], s;
}
IT.Section = NT, IT.Title = FT, IT.List = MT, IT.Link = AT;
//#endregion
//#region src/daas-settings-side-panel.tsx
function LT() {
	let e = (0, x.c)(3), t;
	e[0] === Symbol.for("react.memo_cache_sentinel") ? (t = /* @__PURE__ */ (0, C.jsx)(IT.Title, { children: /* @__PURE__ */ (0, C.jsx)(yC, { id: "settings.section.personal_settings" }) }), e[0] = t) : t = e[0];
	let n;
	e[1] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ (0, C.jsx)(IT.Link, {
		to: "/daas/$destinationId/settings/personal",
		children: /* @__PURE__ */ (0, C.jsx)(yC, { id: "settings.personal.title" })
	}), e[1] = n) : n = e[1];
	let r;
	return e[2] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ (0, C.jsx)(IT, { children: /* @__PURE__ */ (0, C.jsxs)(IT.Section, { children: [t, /* @__PURE__ */ (0, C.jsxs)(IT.List, { children: [n, /* @__PURE__ */ (0, C.jsx)(IT.Link, {
		to: "/daas/$destinationId/settings/theme",
		children: /* @__PURE__ */ (0, C.jsx)(yC, { id: "settings.theme.title" })
	})] })] }) }), e[2] = r) : r = e[2], r;
}
//#endregion
//#region src/general/feature-toggle-context.tsx
var RT = (0, S.createContext)(null);
function zT() {
	let e = (0, S.useContext)(RT);
	if (!e) throw Error("`useFeatureToggles` must be used inside <FeatureToggleProvider>");
	return e;
}
function BT(e) {
	let t = (0, x.c)(3), { featureToggles: n, children: r } = e, i;
	return t[0] !== r || t[1] !== n ? (i = /* @__PURE__ */ (0, C.jsx)(RT, {
		value: n,
		children: r
	}), t[0] = r, t[1] = n, t[2] = i) : i = t[2], i;
}
//#endregion
//#region src/hotel-header.tsx
function VT(e) {
	let t = (0, x.c)(23), { accountMenuOptions: n, accountSelectorOptions: r, children: i, hotel: a } = e, o = T(), s = zT(), c;
	t[0] !== o || t[1] !== s || t[2] !== a ? (c = TT({
		access: o,
		featureToggles: s,
		hotel: a,
		kind: "hotel"
	}), t[0] = o, t[1] = s, t[2] = a, t[3] = c) : c = t[3];
	let l = c, u;
	t[4] === o ? u = t[5] : (u = bT(o), t[4] = o, t[5] = u);
	let d;
	t[6] === a.reseller ? d = t[7] : (d = /* @__PURE__ */ (0, C.jsx)($w.Logo, { reseller: a.reseller }), t[6] = a.reseller, t[7] = d);
	let f;
	t[8] === Symbol.for("react.memo_cache_sentinel") ? (f = /* @__PURE__ */ (0, C.jsx)($w.Tabs, {}), t[8] = f) : f = t[8];
	let p;
	t[9] === r ? p = t[10] : (p = r && /* @__PURE__ */ (0, C.jsx)($w.AccountSelector, { ...r }), t[9] = r, t[10] = p);
	let m;
	t[11] === Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ (0, C.jsx)($w.SettingsButton, { to: "/hotel/$hotelId/settings" }), t[11] = m) : m = t[11];
	let h;
	t[12] === n ? h = t[13] : (h = n ? /* @__PURE__ */ (0, C.jsx)($w.AccountMenu, {
		kind: "hotel",
		...n
	}) : null, t[12] = n, t[13] = h);
	let g;
	t[14] !== i || t[15] !== d || t[16] !== p || t[17] !== h ? (g = /* @__PURE__ */ (0, C.jsxs)($w, { children: [
		d,
		f,
		i,
		p,
		m,
		h
	] }), t[14] = i, t[15] = d, t[16] = p, t[17] = h, t[18] = g) : g = t[18];
	let _;
	return t[19] !== l || t[20] !== u || t[21] !== g ? (_ = /* @__PURE__ */ (0, C.jsx)(Vw, {
		menuItems: l,
		shouldGroup: u,
		children: g
	}), t[19] = l, t[20] = u, t[21] = g, t[22] = _) : _ = t[22], _;
}
//#endregion
//#region src/hotel-settings-side-panel.tsx
function HT() {
	let e = (0, x.c)(5), t;
	e[0] === Symbol.for("react.memo_cache_sentinel") ? (t = /* @__PURE__ */ (0, C.jsx)(IT.Title, { children: /* @__PURE__ */ (0, C.jsx)(yC, { id: "settings.section.personal_settings" }) }), e[0] = t) : t = e[0];
	let n;
	e[1] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ (0, C.jsx)(IT.Link, {
		to: "/hotel/$hotelId/settings/personal",
		children: /* @__PURE__ */ (0, C.jsx)(yC, { id: "settings.personal.title" })
	}), e[1] = n) : n = e[1];
	let r;
	e[2] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ (0, C.jsxs)(IT.Section, { children: [t, /* @__PURE__ */ (0, C.jsxs)(IT.List, { children: [n, /* @__PURE__ */ (0, C.jsx)(IT.Link, {
		to: "/hotel/$hotelId/settings/theme",
		children: /* @__PURE__ */ (0, C.jsx)(yC, { id: "settings.theme.title" })
	})] })] }), e[2] = r) : r = e[2];
	let i;
	e[3] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ (0, C.jsx)(IT.Title, { children: /* @__PURE__ */ (0, C.jsx)(yC, { id: "settings.section.ai" }) }), e[3] = i) : i = e[3];
	let a;
	return e[4] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ (0, C.jsxs)(IT, { children: [r, /* @__PURE__ */ (0, C.jsxs)(IT.Section, { children: [i, /* @__PURE__ */ (0, C.jsx)(IT.List, { children: /* @__PURE__ */ (0, C.jsx)(IT.Link, {
		to: "/hotel/$hotelId/settings/smart-insights",
		children: /* @__PURE__ */ (0, C.jsx)(yC, { id: "settings.smart_insights.title" })
	}) })] })] }), e[4] = a) : a = e[4], a;
}
//#endregion
//#region src/market-header.tsx
function UT(e) {
	let t = (0, x.c)(19), { accountMenuOptions: n, accountSelectorOptions: r, reseller: i } = e, a = T(), o = zT(), s;
	t[0] !== a || t[1] !== o ? (s = TT({
		access: a,
		featureToggles: o,
		kind: "market"
	}), t[0] = a, t[1] = o, t[2] = s) : s = t[2];
	let c = s, l = c.length > 1, u;
	t[3] === i ? u = t[4] : (u = /* @__PURE__ */ (0, C.jsx)($w.Logo, { reseller: i }), t[3] = i, t[4] = u);
	let d;
	t[5] === Symbol.for("react.memo_cache_sentinel") ? (d = /* @__PURE__ */ (0, C.jsx)($w.Tabs, {}), t[5] = d) : d = t[5];
	let f;
	t[6] === r ? f = t[7] : (f = r && /* @__PURE__ */ (0, C.jsx)($w.AccountSelector, { ...r }), t[6] = r, t[7] = f);
	let p;
	t[8] === Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ (0, C.jsx)($w.SettingsButton, { to: "/market/$marketId/settings" }), t[8] = p) : p = t[8];
	let m;
	t[9] === n ? m = t[10] : (m = n ? /* @__PURE__ */ (0, C.jsx)($w.AccountMenu, {
		kind: "market",
		...n
	}) : null, t[9] = n, t[10] = m);
	let h;
	t[11] !== u || t[12] !== f || t[13] !== m ? (h = /* @__PURE__ */ (0, C.jsxs)($w, { children: [
		u,
		d,
		f,
		p,
		m
	] }), t[11] = u, t[12] = f, t[13] = m, t[14] = h) : h = t[14];
	let g;
	return t[15] !== c || t[16] !== l || t[17] !== h ? (g = /* @__PURE__ */ (0, C.jsx)(Vw, {
		menuItems: c,
		shouldGroup: l,
		children: h
	}), t[15] = c, t[16] = l, t[17] = h, t[18] = g) : g = t[18], g;
}
//#endregion
//#region src/market-settings-side-panel.tsx
function WT() {
	let e = (0, x.c)(3), t;
	e[0] === Symbol.for("react.memo_cache_sentinel") ? (t = /* @__PURE__ */ (0, C.jsx)(IT.Title, { children: /* @__PURE__ */ (0, C.jsx)(yC, { id: "settings.section.personal_settings" }) }), e[0] = t) : t = e[0];
	let n;
	e[1] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ (0, C.jsx)(IT.Link, {
		to: "/market/$marketId/settings/personal",
		children: /* @__PURE__ */ (0, C.jsx)(yC, { id: "settings.personal.title" })
	}), e[1] = n) : n = e[1];
	let r;
	return e[2] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ (0, C.jsx)(IT, { children: /* @__PURE__ */ (0, C.jsxs)(IT.Section, { children: [t, /* @__PURE__ */ (0, C.jsxs)(IT.List, { children: [n, /* @__PURE__ */ (0, C.jsx)(IT.Link, {
		to: "/market/$marketId/settings/theme",
		children: /* @__PURE__ */ (0, C.jsx)(yC, { id: "settings.theme.title" })
	})] })] }) }), e[2] = r) : r = e[2], r;
}
//#endregion
//#region ../../node_modules/.pnpm/scheduler@0.27.0/node_modules/scheduler/cjs/scheduler.production.js
var GT = /* @__PURE__ */ o(((e) => {
	function t(e, t) {
		var n = e.length;
		e.push(t);
		a: for (; 0 < n;) {
			var r = n - 1 >>> 1, a = e[r];
			if (0 < i(a, t)) e[r] = t, e[n] = a, n = r;
			else break a;
		}
	}
	function n(e) {
		return e.length === 0 ? null : e[0];
	}
	function r(e) {
		if (e.length === 0) return null;
		var t = e[0], n = e.pop();
		if (n !== t) {
			e[0] = n;
			a: for (var r = 0, a = e.length, o = a >>> 1; r < o;) {
				var s = 2 * (r + 1) - 1, c = e[s], l = s + 1, u = e[l];
				if (0 > i(c, n)) l < a && 0 > i(u, c) ? (e[r] = u, e[l] = n, r = l) : (e[r] = c, e[s] = n, r = s);
				else if (l < a && 0 > i(u, n)) e[r] = u, e[l] = n, r = l;
				else break a;
			}
		}
		return t;
	}
	function i(e, t) {
		var n = e.sortIndex - t.sortIndex;
		return n === 0 ? e.id - t.id : n;
	}
	if (e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
		var a = performance;
		e.unstable_now = function() {
			return a.now();
		};
	} else {
		var o = Date, s = o.now();
		e.unstable_now = function() {
			return o.now() - s;
		};
	}
	var c = [], l = [], u = 1, d = null, f = 3, p = !1, m = !1, h = !1, g = !1, _ = typeof setTimeout == "function" ? setTimeout : null, v = typeof clearTimeout == "function" ? clearTimeout : null, y = typeof setImmediate < "u" ? setImmediate : null;
	function b(e) {
		for (var i = n(l); i !== null;) {
			if (i.callback === null) r(l);
			else if (i.startTime <= e) r(l), i.sortIndex = i.expirationTime, t(c, i);
			else break;
			i = n(l);
		}
	}
	function x(e) {
		if (h = !1, b(e), !m) if (n(c) !== null) m = !0, S || (S = !0, O());
		else {
			var t = n(l);
			t !== null && j(x, t.startTime - e);
		}
	}
	var S = !1, C = -1, w = 5, T = -1;
	function E() {
		return g ? !0 : !(e.unstable_now() - T < w);
	}
	function D() {
		if (g = !1, S) {
			var t = e.unstable_now();
			T = t;
			var i = !0;
			try {
				a: {
					m = !1, h && (h = !1, v(C), C = -1), p = !0;
					var a = f;
					try {
						b: {
							for (b(t), d = n(c); d !== null && !(d.expirationTime > t && E());) {
								var o = d.callback;
								if (typeof o == "function") {
									d.callback = null, f = d.priorityLevel;
									var s = o(d.expirationTime <= t);
									if (t = e.unstable_now(), typeof s == "function") {
										d.callback = s, b(t), i = !0;
										break b;
									}
									d === n(c) && r(c), b(t);
								} else r(c);
								d = n(c);
							}
							if (d !== null) i = !0;
							else {
								var u = n(l);
								u !== null && j(x, u.startTime - t), i = !1;
							}
						}
						break a;
					} finally {
						d = null, f = a, p = !1;
					}
					i = void 0;
				}
			} finally {
				i ? O() : S = !1;
			}
		}
	}
	var O;
	if (typeof y == "function") O = function() {
		y(D);
	};
	else if (typeof MessageChannel < "u") {
		var k = new MessageChannel(), A = k.port2;
		k.port1.onmessage = D, O = function() {
			A.postMessage(null);
		};
	} else O = function() {
		_(D, 0);
	};
	function j(t, n) {
		C = _(function() {
			t(e.unstable_now());
		}, n);
	}
	e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(e) {
		e.callback = null;
	}, e.unstable_forceFrameRate = function(e) {
		0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : w = 0 < e ? Math.floor(1e3 / e) : 5;
	}, e.unstable_getCurrentPriorityLevel = function() {
		return f;
	}, e.unstable_next = function(e) {
		switch (f) {
			case 1:
			case 2:
			case 3:
				var t = 3;
				break;
			default: t = f;
		}
		var n = f;
		f = t;
		try {
			return e();
		} finally {
			f = n;
		}
	}, e.unstable_requestPaint = function() {
		g = !0;
	}, e.unstable_runWithPriority = function(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 3:
			case 4:
			case 5: break;
			default: e = 3;
		}
		var n = f;
		f = e;
		try {
			return t();
		} finally {
			f = n;
		}
	}, e.unstable_scheduleCallback = function(r, i, a) {
		var o = e.unstable_now();
		switch (typeof a == "object" && a ? (a = a.delay, a = typeof a == "number" && 0 < a ? o + a : o) : a = o, r) {
			case 1:
				var s = -1;
				break;
			case 2:
				s = 250;
				break;
			case 5:
				s = 1073741823;
				break;
			case 4:
				s = 1e4;
				break;
			default: s = 5e3;
		}
		return s = a + s, r = {
			id: u++,
			callback: i,
			priorityLevel: r,
			startTime: a,
			expirationTime: s,
			sortIndex: -1
		}, a > o ? (r.sortIndex = a, t(l, r), n(c) === null && r === n(l) && (h ? (v(C), C = -1) : h = !0, j(x, a - o))) : (r.sortIndex = s, t(c, r), m || p || (m = !0, S || (S = !0, O()))), r;
	}, e.unstable_shouldYield = E, e.unstable_wrapCallback = function(e) {
		var t = f;
		return function() {
			var n = f;
			f = t;
			try {
				return e.apply(this, arguments);
			} finally {
				f = n;
			}
		};
	};
})), KT = /* @__PURE__ */ o(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t() {
			if (x = !1, T) {
				var t = e.unstable_now();
				O = t;
				var n = !0;
				try {
					a: {
						y = !1, b && (b = !1, C(E), E = -1), v = !0;
						var a = _;
						try {
							b: {
								for (o(t), g = r(p); g !== null && !(g.expirationTime > t && c());) {
									var u = g.callback;
									if (typeof u == "function") {
										g.callback = null, _ = g.priorityLevel;
										var d = u(g.expirationTime <= t);
										if (t = e.unstable_now(), typeof d == "function") {
											g.callback = d, o(t), n = !0;
											break b;
										}
										g === r(p) && i(p), o(t);
									} else i(p);
									g = r(p);
								}
								if (g !== null) n = !0;
								else {
									var f = r(m);
									f !== null && l(s, f.startTime - t), n = !1;
								}
							}
							break a;
						} finally {
							g = null, _ = a, v = !1;
						}
						n = void 0;
					}
				} finally {
					n ? k() : T = !1;
				}
			}
		}
		function n(e, t) {
			var n = e.length;
			e.push(t);
			a: for (; 0 < n;) {
				var r = n - 1 >>> 1, i = e[r];
				if (0 < a(i, t)) e[r] = t, e[n] = i, n = r;
				else break a;
			}
		}
		function r(e) {
			return e.length === 0 ? null : e[0];
		}
		function i(e) {
			if (e.length === 0) return null;
			var t = e[0], n = e.pop();
			if (n !== t) {
				e[0] = n;
				a: for (var r = 0, i = e.length, o = i >>> 1; r < o;) {
					var s = 2 * (r + 1) - 1, c = e[s], l = s + 1, u = e[l];
					if (0 > a(c, n)) l < i && 0 > a(u, c) ? (e[r] = u, e[l] = n, r = l) : (e[r] = c, e[s] = n, r = s);
					else if (l < i && 0 > a(u, n)) e[r] = u, e[l] = n, r = l;
					else break a;
				}
			}
			return t;
		}
		function a(e, t) {
			var n = e.sortIndex - t.sortIndex;
			return n === 0 ? e.id - t.id : n;
		}
		function o(e) {
			for (var t = r(m); t !== null;) {
				if (t.callback === null) i(m);
				else if (t.startTime <= e) i(m), t.sortIndex = t.expirationTime, n(p, t);
				else break;
				t = r(m);
			}
		}
		function s(e) {
			if (b = !1, o(e), !y) if (r(p) !== null) y = !0, T || (T = !0, k());
			else {
				var t = r(m);
				t !== null && l(s, t.startTime - e);
			}
		}
		function c() {
			return x ? !0 : !(e.unstable_now() - O < D);
		}
		function l(t, n) {
			E = S(function() {
				t(e.unstable_now());
			}, n);
		}
		if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error()), e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
			var u = performance;
			e.unstable_now = function() {
				return u.now();
			};
		} else {
			var d = Date, f = d.now();
			e.unstable_now = function() {
				return d.now() - f;
			};
		}
		var p = [], m = [], h = 1, g = null, _ = 3, v = !1, y = !1, b = !1, x = !1, S = typeof setTimeout == "function" ? setTimeout : null, C = typeof clearTimeout == "function" ? clearTimeout : null, w = typeof setImmediate < "u" ? setImmediate : null, T = !1, E = -1, D = 5, O = -1;
		if (typeof w == "function") var k = function() {
			w(t);
		};
		else if (typeof MessageChannel < "u") {
			var A = new MessageChannel(), j = A.port2;
			A.port1.onmessage = t, k = function() {
				j.postMessage(null);
			};
		} else k = function() {
			S(t, 0);
		};
		e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(e) {
			e.callback = null;
		}, e.unstable_forceFrameRate = function(e) {
			0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D = 0 < e ? Math.floor(1e3 / e) : 5;
		}, e.unstable_getCurrentPriorityLevel = function() {
			return _;
		}, e.unstable_next = function(e) {
			switch (_) {
				case 1:
				case 2:
				case 3:
					var t = 3;
					break;
				default: t = _;
			}
			var n = _;
			_ = t;
			try {
				return e();
			} finally {
				_ = n;
			}
		}, e.unstable_requestPaint = function() {
			x = !0;
		}, e.unstable_runWithPriority = function(e, t) {
			switch (e) {
				case 1:
				case 2:
				case 3:
				case 4:
				case 5: break;
				default: e = 3;
			}
			var n = _;
			_ = e;
			try {
				return t();
			} finally {
				_ = n;
			}
		}, e.unstable_scheduleCallback = function(t, i, a) {
			var o = e.unstable_now();
			switch (typeof a == "object" && a ? (a = a.delay, a = typeof a == "number" && 0 < a ? o + a : o) : a = o, t) {
				case 1:
					var c = -1;
					break;
				case 2:
					c = 250;
					break;
				case 5:
					c = 1073741823;
					break;
				case 4:
					c = 1e4;
					break;
				default: c = 5e3;
			}
			return c = a + c, t = {
				id: h++,
				callback: i,
				priorityLevel: t,
				startTime: a,
				expirationTime: c,
				sortIndex: -1
			}, a > o ? (t.sortIndex = a, n(m, t), r(p) === null && t === r(m) && (b ? (C(E), E = -1) : b = !0, l(s, a - o))) : (t.sortIndex = c, n(p, t), y || v || (y = !0, T || (T = !0, k()))), t;
		}, e.unstable_shouldYield = c, e.unstable_wrapCallback = function(e) {
			var t = _;
			return function() {
				var n = _;
				_ = t;
				try {
					return e.apply(this, arguments);
				} finally {
					_ = n;
				}
			};
		}, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
})), qT = /* @__PURE__ */ o(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = GT() : t.exports = KT();
})), JT = /* @__PURE__ */ o(((e) => {
	var t = qT(), n = m(), r = er();
	function i(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function a(e) {
		return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
	}
	function o(e) {
		var t = e, n = e;
		if (e.alternate) for (; t.return;) t = t.return;
		else {
			e = t;
			do
				t = e, t.flags & 4098 && (n = t.return), e = t.return;
			while (e);
		}
		return t.tag === 3 ? n : null;
	}
	function s(e) {
		if (e.tag === 13) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function c(e) {
		if (e.tag === 31) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function l(e) {
		if (o(e) !== e) throw Error(i(188));
	}
	function u(e) {
		var t = e.alternate;
		if (!t) {
			if (t = o(e), t === null) throw Error(i(188));
			return t === e ? e : null;
		}
		for (var n = e, r = t;;) {
			var a = n.return;
			if (a === null) break;
			var s = a.alternate;
			if (s === null) {
				if (r = a.return, r !== null) {
					n = r;
					continue;
				}
				break;
			}
			if (a.child === s.child) {
				for (s = a.child; s;) {
					if (s === n) return l(a), e;
					if (s === r) return l(a), t;
					s = s.sibling;
				}
				throw Error(i(188));
			}
			if (n.return !== r.return) n = a, r = s;
			else {
				for (var c = !1, u = a.child; u;) {
					if (u === n) {
						c = !0, n = a, r = s;
						break;
					}
					if (u === r) {
						c = !0, r = a, n = s;
						break;
					}
					u = u.sibling;
				}
				if (!c) {
					for (u = s.child; u;) {
						if (u === n) {
							c = !0, n = s, r = a;
							break;
						}
						if (u === r) {
							c = !0, r = s, n = a;
							break;
						}
						u = u.sibling;
					}
					if (!c) throw Error(i(189));
				}
			}
			if (n.alternate !== r) throw Error(i(190));
		}
		if (n.tag !== 3) throw Error(i(188));
		return n.stateNode.current === n ? e : t;
	}
	function d(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e;
		for (e = e.child; e !== null;) {
			if (t = d(e), t !== null) return t;
			e = e.sibling;
		}
		return null;
	}
	var f = Object.assign, p = Symbol.for("react.element"), h = Symbol.for("react.transitional.element"), g = Symbol.for("react.portal"), _ = Symbol.for("react.fragment"), v = Symbol.for("react.strict_mode"), y = Symbol.for("react.profiler"), b = Symbol.for("react.consumer"), x = Symbol.for("react.context"), S = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), D = Symbol.for("react.activity"), O = Symbol.for("react.memo_cache_sentinel"), k = Symbol.iterator;
	function A(e) {
		return typeof e != "object" || !e ? null : (e = k && e[k] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var j = Symbol.for("react.client.reference");
	function M(e) {
		if (e == null) return null;
		if (typeof e == "function") return e.$$typeof === j ? null : e.displayName || e.name || null;
		if (typeof e == "string") return e;
		switch (e) {
			case _: return "Fragment";
			case y: return "Profiler";
			case v: return "StrictMode";
			case C: return "Suspense";
			case w: return "SuspenseList";
			case D: return "Activity";
		}
		if (typeof e == "object") switch (e.$$typeof) {
			case g: return "Portal";
			case x: return e.displayName || "Context";
			case b: return (e._context.displayName || "Context") + ".Consumer";
			case S:
				var t = e.render;
				return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
			case T: return t = e.displayName || null, t === null ? M(e.type) || "Memo" : t;
			case E:
				t = e._payload, e = e._init;
				try {
					return M(e(t));
				} catch {}
		}
		return null;
	}
	var N = Array.isArray, P = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, F = r.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, I = {
		pending: !1,
		data: null,
		method: null,
		action: null
	}, L = [], ee = -1;
	function R(e) {
		return { current: e };
	}
	function z(e) {
		0 > ee || (e.current = L[ee], L[ee] = null, ee--);
	}
	function te(e, t) {
		ee++, L[ee] = e.current, e.current = t;
	}
	var B = R(null), V = R(null), ne = R(null), re = R(null);
	function ie(e, t) {
		switch (te(ne, t), te(V, e), te(B, null), t.nodeType) {
			case 9:
			case 11:
				e = (e = t.documentElement) && (e = e.namespaceURI) ? Hd(e) : 0;
				break;
			default: if (e = t.tagName, t = t.namespaceURI) t = Hd(t), e = Ud(t, e);
			else switch (e) {
				case "svg":
					e = 1;
					break;
				case "math":
					e = 2;
					break;
				default: e = 0;
			}
		}
		z(B), te(B, e);
	}
	function ae() {
		z(B), z(V), z(ne);
	}
	function oe(e) {
		e.memoizedState !== null && te(re, e);
		var t = B.current, n = Ud(t, e.type);
		t !== n && (te(V, e), te(B, n));
	}
	function H(e) {
		V.current === e && (z(B), z(V)), re.current === e && (z(re), Qf._currentValue = I);
	}
	var se, ce;
	function le(e) {
		if (se === void 0) try {
			throw Error();
		} catch (e) {
			var t = e.stack.trim().match(/\n( *(at )?)/);
			se = t && t[1] || "", ce = -1 < e.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
		}
		return "\n" + se + e + ce;
	}
	var ue = !1;
	function de(e, t) {
		if (!e || ue) return "";
		ue = !0;
		var n = Error.prepareStackTrace;
		Error.prepareStackTrace = void 0;
		try {
			var r = { DetermineComponentFrameRoot: function() {
				try {
					if (t) {
						var n = function() {
							throw Error();
						};
						if (Object.defineProperty(n.prototype, "props", { set: function() {
							throw Error();
						} }), typeof Reflect == "object" && Reflect.construct) {
							try {
								Reflect.construct(n, []);
							} catch (e) {
								var r = e;
							}
							Reflect.construct(e, [], n);
						} else {
							try {
								n.call();
							} catch (e) {
								r = e;
							}
							e.call(n.prototype);
						}
					} else {
						try {
							throw Error();
						} catch (e) {
							r = e;
						}
						(n = e()) && typeof n.catch == "function" && n.catch(function() {});
					}
				} catch (e) {
					if (e && r && typeof e.stack == "string") return [e.stack, r.stack];
				}
				return [null, null];
			} };
			r.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
			var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, "name");
			i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
			var a = r.DetermineComponentFrameRoot(), o = a[0], s = a[1];
			if (o && s) {
				var c = o.split("\n"), l = s.split("\n");
				for (i = r = 0; r < c.length && !c[r].includes("DetermineComponentFrameRoot");) r++;
				for (; i < l.length && !l[i].includes("DetermineComponentFrameRoot");) i++;
				if (r === c.length || i === l.length) for (r = c.length - 1, i = l.length - 1; 1 <= r && 0 <= i && c[r] !== l[i];) i--;
				for (; 1 <= r && 0 <= i; r--, i--) if (c[r] !== l[i]) {
					if (r !== 1 || i !== 1) do
						if (r--, i--, 0 > i || c[r] !== l[i]) {
							var u = "\n" + c[r].replace(" at new ", " at ");
							return e.displayName && u.includes("<anonymous>") && (u = u.replace("<anonymous>", e.displayName)), u;
						}
					while (1 <= r && 0 <= i);
					break;
				}
			}
		} finally {
			ue = !1, Error.prepareStackTrace = n;
		}
		return (n = e ? e.displayName || e.name : "") ? le(n) : "";
	}
	function fe(e, t) {
		switch (e.tag) {
			case 26:
			case 27:
			case 5: return le(e.type);
			case 16: return le("Lazy");
			case 13: return e.child !== t && t !== null ? le("Suspense Fallback") : le("Suspense");
			case 19: return le("SuspenseList");
			case 0:
			case 15: return de(e.type, !1);
			case 11: return de(e.type.render, !1);
			case 1: return de(e.type, !0);
			case 31: return le("Activity");
			default: return "";
		}
	}
	function pe(e) {
		try {
			var t = "", n = null;
			do
				t += fe(e, n), n = e, e = e.return;
			while (e);
			return t;
		} catch (e) {
			return "\nError generating stack: " + e.message + "\n" + e.stack;
		}
	}
	var me = Object.prototype.hasOwnProperty, he = t.unstable_scheduleCallback, ge = t.unstable_cancelCallback, _e = t.unstable_shouldYield, ve = t.unstable_requestPaint, ye = t.unstable_now, be = t.unstable_getCurrentPriorityLevel, xe = t.unstable_ImmediatePriority, Se = t.unstable_UserBlockingPriority, Ce = t.unstable_NormalPriority, we = t.unstable_LowPriority, Te = t.unstable_IdlePriority, Ee = t.log, De = t.unstable_setDisableYieldValue, U = null, Oe = null;
	function ke(e) {
		if (typeof Ee == "function" && De(e), Oe && typeof Oe.setStrictMode == "function") try {
			Oe.setStrictMode(U, e);
		} catch {}
	}
	var Ae = Math.clz32 ? Math.clz32 : Ne, je = Math.log, Me = Math.LN2;
	function Ne(e) {
		return e >>>= 0, e === 0 ? 32 : 31 - (je(e) / Me | 0) | 0;
	}
	var Pe = 256, Fe = 262144, Ie = 4194304;
	function Le(e) {
		var t = e & 42;
		if (t !== 0) return t;
		switch (e & -e) {
			case 1: return 1;
			case 2: return 2;
			case 4: return 4;
			case 8: return 8;
			case 16: return 16;
			case 32: return 32;
			case 64: return 64;
			case 128: return 128;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072: return e & 261888;
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return e & 3932160;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return e & 62914560;
			case 67108864: return 67108864;
			case 134217728: return 134217728;
			case 268435456: return 268435456;
			case 536870912: return 536870912;
			case 1073741824: return 0;
			default: return e;
		}
	}
	function Re(e, t, n) {
		var r = e.pendingLanes;
		if (r === 0) return 0;
		var i = 0, a = e.suspendedLanes, o = e.pingedLanes;
		e = e.warmLanes;
		var s = r & 134217727;
		return s === 0 ? (s = r & ~a, s === 0 ? o === 0 ? n || (n = r & ~e, n !== 0 && (i = Le(n))) : i = Le(o) : i = Le(s)) : (r = s & ~a, r === 0 ? (o &= s, o === 0 ? n || (n = s & ~e, n !== 0 && (i = Le(n))) : i = Le(o)) : i = Le(r)), i === 0 ? 0 : t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048) ? t : i;
	}
	function ze(e, t) {
		return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
	}
	function Be(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 4:
			case 8:
			case 64: return t + 250;
			case 16:
			case 32:
			case 128:
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return t + 5e3;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return -1;
			case 67108864:
			case 134217728:
			case 268435456:
			case 536870912:
			case 1073741824: return -1;
			default: return -1;
		}
	}
	function Ve() {
		var e = Ie;
		return Ie <<= 1, !(Ie & 62914560) && (Ie = 4194304), e;
	}
	function He(e) {
		for (var t = [], n = 0; 31 > n; n++) t.push(e);
		return t;
	}
	function Ue(e, t) {
		e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
	}
	function We(e, t, n, r, i, a) {
		var o = e.pendingLanes;
		e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
		var s = e.entanglements, c = e.expirationTimes, l = e.hiddenUpdates;
		for (n = o & ~n; 0 < n;) {
			var u = 31 - Ae(n), d = 1 << u;
			s[u] = 0, c[u] = -1;
			var f = l[u];
			if (f !== null) for (l[u] = null, u = 0; u < f.length; u++) {
				var p = f[u];
				p !== null && (p.lane &= -536870913);
			}
			n &= ~d;
		}
		r !== 0 && Ge(e, r, 0), a !== 0 && i === 0 && e.tag !== 0 && (e.suspendedLanes |= a & ~(o & ~t));
	}
	function Ge(e, t, n) {
		e.pendingLanes |= t, e.suspendedLanes &= ~t;
		var r = 31 - Ae(t);
		e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930;
	}
	function Ke(e, t) {
		var n = e.entangledLanes |= t;
		for (e = e.entanglements; n;) {
			var r = 31 - Ae(n), i = 1 << r;
			i & t | e[r] & t && (e[r] |= t), n &= ~i;
		}
	}
	function qe(e, t) {
		var n = t & -t;
		return n = n & 42 ? 1 : Je(n), (n & (e.suspendedLanes | t)) === 0 ? n : 0;
	}
	function Je(e) {
		switch (e) {
			case 2:
				e = 1;
				break;
			case 8:
				e = 4;
				break;
			case 32:
				e = 16;
				break;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152:
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432:
				e = 128;
				break;
			case 268435456:
				e = 134217728;
				break;
			default: e = 0;
		}
		return e;
	}
	function Ye(e) {
		return e &= -e, 2 < e ? 8 < e ? e & 134217727 ? 32 : 268435456 : 8 : 2;
	}
	function Xe() {
		var e = F.p;
		return e === 0 ? (e = window.event, e === void 0 ? 32 : mp(e.type)) : e;
	}
	function Ze(e, t) {
		var n = F.p;
		try {
			return F.p = e, t();
		} finally {
			F.p = n;
		}
	}
	var Qe = Math.random().toString(36).slice(2), $e = "__reactFiber$" + Qe, et = "__reactProps$" + Qe, tt = "__reactContainer$" + Qe, nt = "__reactEvents$" + Qe, rt = "__reactListeners$" + Qe, it = "__reactHandles$" + Qe, at = "__reactResources$" + Qe, ot = "__reactMarker$" + Qe;
	function st(e) {
		delete e[$e], delete e[et], delete e[nt], delete e[rt], delete e[it];
	}
	function ct(e) {
		var t = e[$e];
		if (t) return t;
		for (var n = e.parentNode; n;) {
			if (t = n[tt] || n[$e]) {
				if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = ff(e); e !== null;) {
					if (n = e[$e]) return n;
					e = ff(e);
				}
				return t;
			}
			e = n, n = e.parentNode;
		}
		return null;
	}
	function lt(e) {
		if (e = e[$e] || e[tt]) {
			var t = e.tag;
			if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) return e;
		}
		return null;
	}
	function ut(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
		throw Error(i(33));
	}
	function dt(e) {
		var t = e[at];
		return t ||= e[at] = {
			hoistableStyles: /* @__PURE__ */ new Map(),
			hoistableScripts: /* @__PURE__ */ new Map()
		}, t;
	}
	function ft(e) {
		e[ot] = !0;
	}
	var pt = /* @__PURE__ */ new Set(), mt = {};
	function ht(e, t) {
		W(e, t), W(e + "Capture", t);
	}
	function W(e, t) {
		for (mt[e] = t, e = 0; e < t.length; e++) pt.add(t[e]);
	}
	var gt = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), _t = {}, vt = {};
	function yt(e) {
		return me.call(vt, e) ? !0 : me.call(_t, e) ? !1 : gt.test(e) ? vt[e] = !0 : (_t[e] = !0, !1);
	}
	function bt(e, t, n) {
		if (yt(t)) if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
					e.removeAttribute(t);
					return;
				case "boolean":
					var r = t.toLowerCase().slice(0, 5);
					if (r !== "data-" && r !== "aria-") {
						e.removeAttribute(t);
						return;
					}
			}
			e.setAttribute(t, "" + n);
		}
	}
	function xt(e, t, n) {
		if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(t);
					return;
			}
			e.setAttribute(t, "" + n);
		}
	}
	function St(e, t, n, r) {
		if (r === null) e.removeAttribute(n);
		else {
			switch (typeof r) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(n);
					return;
			}
			e.setAttributeNS(t, n, "" + r);
		}
	}
	function Ct(e) {
		switch (typeof e) {
			case "bigint":
			case "boolean":
			case "number":
			case "string":
			case "undefined": return e;
			case "object": return e;
			default: return "";
		}
	}
	function wt(e) {
		var t = e.type;
		return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
	}
	function Tt(e, t, n) {
		var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
		if (!e.hasOwnProperty(t) && r !== void 0 && typeof r.get == "function" && typeof r.set == "function") {
			var i = r.get, a = r.set;
			return Object.defineProperty(e, t, {
				configurable: !0,
				get: function() {
					return i.call(this);
				},
				set: function(e) {
					n = "" + e, a.call(this, e);
				}
			}), Object.defineProperty(e, t, { enumerable: r.enumerable }), {
				getValue: function() {
					return n;
				},
				setValue: function(e) {
					n = "" + e;
				},
				stopTracking: function() {
					e._valueTracker = null, delete e[t];
				}
			};
		}
	}
	function Et(e) {
		if (!e._valueTracker) {
			var t = wt(e) ? "checked" : "value";
			e._valueTracker = Tt(e, t, "" + e[t]);
		}
	}
	function Dt(e) {
		if (!e) return !1;
		var t = e._valueTracker;
		if (!t) return !0;
		var n = t.getValue(), r = "";
		return e && (r = wt(e) ? e.checked ? "true" : "false" : e.value), e = r, e === n ? !1 : (t.setValue(e), !0);
	}
	function Ot(e) {
		if (e ||= typeof document < "u" ? document : void 0, e === void 0) return null;
		try {
			return e.activeElement || e.body;
		} catch {
			return e.body;
		}
	}
	var kt = /[\n"\\]/g;
	function At(e) {
		return e.replace(kt, function(e) {
			return "\\" + e.charCodeAt(0).toString(16) + " ";
		});
	}
	function jt(e, t, n, r, i, a, o, s) {
		e.name = "", o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" ? e.type = o : e.removeAttribute("type"), t == null ? o !== "submit" && o !== "reset" || e.removeAttribute("value") : o === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + Ct(t)) : e.value !== "" + Ct(t) && (e.value = "" + Ct(t)), t == null ? n == null ? r != null && e.removeAttribute("value") : Nt(e, o, Ct(n)) : Nt(e, o, Ct(t)), i == null && a != null && (e.defaultChecked = !!a), i != null && (e.checked = i && typeof i != "function" && typeof i != "symbol"), s != null && typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" ? e.name = "" + Ct(s) : e.removeAttribute("name");
	}
	function Mt(e, t, n, r, i, a, o, s) {
		if (a != null && typeof a != "function" && typeof a != "symbol" && typeof a != "boolean" && (e.type = a), t != null || n != null) {
			if (!(a !== "submit" && a !== "reset" || t != null)) {
				Et(e);
				return;
			}
			n = n == null ? "" : "" + Ct(n), t = t == null ? n : "" + Ct(t), s || t === e.value || (e.value = t), e.defaultValue = t;
		}
		r ??= i, r = typeof r != "function" && typeof r != "symbol" && !!r, e.checked = s ? e.checked : !!r, e.defaultChecked = !!r, o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" && (e.name = o), Et(e);
	}
	function Nt(e, t, n) {
		t === "number" && Ot(e.ownerDocument) === e || e.defaultValue === "" + n || (e.defaultValue = "" + n);
	}
	function Pt(e, t, n, r) {
		if (e = e.options, t) {
			t = {};
			for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
			for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
		} else {
			for (n = "" + Ct(n), t = null, i = 0; i < e.length; i++) {
				if (e[i].value === n) {
					e[i].selected = !0, r && (e[i].defaultSelected = !0);
					return;
				}
				t !== null || e[i].disabled || (t = e[i]);
			}
			t !== null && (t.selected = !0);
		}
	}
	function Ft(e, t, n) {
		if (t != null && (t = "" + Ct(t), t !== e.value && (e.value = t), n == null)) {
			e.defaultValue !== t && (e.defaultValue = t);
			return;
		}
		e.defaultValue = n == null ? "" : "" + Ct(n);
	}
	function It(e, t, n, r) {
		if (t == null) {
			if (r != null) {
				if (n != null) throw Error(i(92));
				if (N(r)) {
					if (1 < r.length) throw Error(i(93));
					r = r[0];
				}
				n = r;
			}
			n ??= "", t = n;
		}
		n = Ct(t), e.defaultValue = n, r = e.textContent, r === n && r !== "" && r !== null && (e.value = r), Et(e);
	}
	function Lt(e, t) {
		if (t) {
			var n = e.firstChild;
			if (n && n === e.lastChild && n.nodeType === 3) {
				n.nodeValue = t;
				return;
			}
		}
		e.textContent = t;
	}
	var Rt = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
	function zt(e, t, n) {
		var r = t.indexOf("--") === 0;
		n == null || typeof n == "boolean" || n === "" ? r ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : r ? e.setProperty(t, n) : typeof n != "number" || n === 0 || Rt.has(t) ? t === "float" ? e.cssFloat = n : e[t] = ("" + n).trim() : e[t] = n + "px";
	}
	function Bt(e, t, n) {
		if (t != null && typeof t != "object") throw Error(i(62));
		if (e = e.style, n != null) {
			for (var r in n) !n.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf("--") === 0 ? e.setProperty(r, "") : r === "float" ? e.cssFloat = "" : e[r] = "");
			for (var a in t) r = t[a], t.hasOwnProperty(a) && n[a] !== r && zt(e, a, r);
		} else for (var o in t) t.hasOwnProperty(o) && zt(e, o, t[o]);
	}
	function Vt(e) {
		if (e.indexOf("-") === -1) return !1;
		switch (e) {
			case "annotation-xml":
			case "color-profile":
			case "font-face":
			case "font-face-src":
			case "font-face-uri":
			case "font-face-format":
			case "font-face-name":
			case "missing-glyph": return !1;
			default: return !0;
		}
	}
	var Ht = new Map([
		["acceptCharset", "accept-charset"],
		["htmlFor", "for"],
		["httpEquiv", "http-equiv"],
		["crossOrigin", "crossorigin"],
		["accentHeight", "accent-height"],
		["alignmentBaseline", "alignment-baseline"],
		["arabicForm", "arabic-form"],
		["baselineShift", "baseline-shift"],
		["capHeight", "cap-height"],
		["clipPath", "clip-path"],
		["clipRule", "clip-rule"],
		["colorInterpolation", "color-interpolation"],
		["colorInterpolationFilters", "color-interpolation-filters"],
		["colorProfile", "color-profile"],
		["colorRendering", "color-rendering"],
		["dominantBaseline", "dominant-baseline"],
		["enableBackground", "enable-background"],
		["fillOpacity", "fill-opacity"],
		["fillRule", "fill-rule"],
		["floodColor", "flood-color"],
		["floodOpacity", "flood-opacity"],
		["fontFamily", "font-family"],
		["fontSize", "font-size"],
		["fontSizeAdjust", "font-size-adjust"],
		["fontStretch", "font-stretch"],
		["fontStyle", "font-style"],
		["fontVariant", "font-variant"],
		["fontWeight", "font-weight"],
		["glyphName", "glyph-name"],
		["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
		["glyphOrientationVertical", "glyph-orientation-vertical"],
		["horizAdvX", "horiz-adv-x"],
		["horizOriginX", "horiz-origin-x"],
		["imageRendering", "image-rendering"],
		["letterSpacing", "letter-spacing"],
		["lightingColor", "lighting-color"],
		["markerEnd", "marker-end"],
		["markerMid", "marker-mid"],
		["markerStart", "marker-start"],
		["overlinePosition", "overline-position"],
		["overlineThickness", "overline-thickness"],
		["paintOrder", "paint-order"],
		["panose-1", "panose-1"],
		["pointerEvents", "pointer-events"],
		["renderingIntent", "rendering-intent"],
		["shapeRendering", "shape-rendering"],
		["stopColor", "stop-color"],
		["stopOpacity", "stop-opacity"],
		["strikethroughPosition", "strikethrough-position"],
		["strikethroughThickness", "strikethrough-thickness"],
		["strokeDasharray", "stroke-dasharray"],
		["strokeDashoffset", "stroke-dashoffset"],
		["strokeLinecap", "stroke-linecap"],
		["strokeLinejoin", "stroke-linejoin"],
		["strokeMiterlimit", "stroke-miterlimit"],
		["strokeOpacity", "stroke-opacity"],
		["strokeWidth", "stroke-width"],
		["textAnchor", "text-anchor"],
		["textDecoration", "text-decoration"],
		["textRendering", "text-rendering"],
		["transformOrigin", "transform-origin"],
		["underlinePosition", "underline-position"],
		["underlineThickness", "underline-thickness"],
		["unicodeBidi", "unicode-bidi"],
		["unicodeRange", "unicode-range"],
		["unitsPerEm", "units-per-em"],
		["vAlphabetic", "v-alphabetic"],
		["vHanging", "v-hanging"],
		["vIdeographic", "v-ideographic"],
		["vMathematical", "v-mathematical"],
		["vectorEffect", "vector-effect"],
		["vertAdvY", "vert-adv-y"],
		["vertOriginX", "vert-origin-x"],
		["vertOriginY", "vert-origin-y"],
		["wordSpacing", "word-spacing"],
		["writingMode", "writing-mode"],
		["xmlnsXlink", "xmlns:xlink"],
		["xHeight", "x-height"]
	]), Ut = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
	function G(e) {
		return Ut.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
	}
	function Wt() {}
	var Gt = null;
	function Kt(e) {
		return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
	}
	var qt = null, Jt = null;
	function Yt(e) {
		var t = lt(e);
		if (t && (e = t.stateNode)) {
			var n = e[et] || null;
			a: switch (e = t.stateNode, t.type) {
				case "input":
					if (jt(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, n.type === "radio" && t != null) {
						for (n = e; n.parentNode;) n = n.parentNode;
						for (n = n.querySelectorAll("input[name=\"" + At("" + t) + "\"][type=\"radio\"]"), t = 0; t < n.length; t++) {
							var r = n[t];
							if (r !== e && r.form === e.form) {
								var a = r[et] || null;
								if (!a) throw Error(i(90));
								jt(r, a.value, a.defaultValue, a.defaultValue, a.checked, a.defaultChecked, a.type, a.name);
							}
						}
						for (t = 0; t < n.length; t++) r = n[t], r.form === e.form && Dt(r);
					}
					break a;
				case "textarea":
					Ft(e, n.value, n.defaultValue);
					break a;
				case "select": t = n.value, t != null && Pt(e, !!n.multiple, t, !1);
			}
		}
	}
	var Xt = !1;
	function Zt(e, t, n) {
		if (Xt) return e(t, n);
		Xt = !0;
		try {
			return e(t);
		} finally {
			if (Xt = !1, (qt !== null || Jt !== null) && (yu(), qt && (t = qt, e = Jt, Jt = qt = null, Yt(t), e))) for (t = 0; t < e.length; t++) Yt(e[t]);
		}
	}
	function Qt(e, t) {
		var n = e.stateNode;
		if (n === null) return null;
		var r = n[et] || null;
		if (r === null) return null;
		n = r[t];
		a: switch (t) {
			case "onClick":
			case "onClickCapture":
			case "onDoubleClick":
			case "onDoubleClickCapture":
			case "onMouseDown":
			case "onMouseDownCapture":
			case "onMouseMove":
			case "onMouseMoveCapture":
			case "onMouseUp":
			case "onMouseUpCapture":
			case "onMouseEnter":
				(r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
				break a;
			default: e = !1;
		}
		if (e) return null;
		if (n && typeof n != "function") throw Error(i(231, t, typeof n));
		return n;
	}
	var $t = !(typeof window > "u" || window.document === void 0 || window.document.createElement === void 0), en = !1;
	if ($t) try {
		var tn = {};
		Object.defineProperty(tn, "passive", { get: function() {
			en = !0;
		} }), window.addEventListener("test", tn, tn), window.removeEventListener("test", tn, tn);
	} catch {
		en = !1;
	}
	var nn = null, rn = null, an = null;
	function on() {
		if (an) return an;
		var e, t = rn, n = t.length, r, i = "value" in nn ? nn.value : nn.textContent, a = i.length;
		for (e = 0; e < n && t[e] === i[e]; e++);
		var o = n - e;
		for (r = 1; r <= o && t[n - r] === i[a - r]; r++);
		return an = i.slice(e, 1 < r ? 1 - r : void 0);
	}
	function sn(e) {
		var t = e.keyCode;
		return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
	}
	function cn() {
		return !0;
	}
	function ln() {
		return !1;
	}
	function un(e) {
		function t(t, n, r, i, a) {
			for (var o in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = a, this.currentTarget = null, e) e.hasOwnProperty(o) && (t = e[o], this[o] = t ? t(i) : i[o]);
			return this.isDefaultPrevented = (i.defaultPrevented == null ? !1 === i.returnValue : i.defaultPrevented) ? cn : ln, this.isPropagationStopped = ln, this;
		}
		return f(t.prototype, {
			preventDefault: function() {
				this.defaultPrevented = !0;
				var e = this.nativeEvent;
				e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = cn);
			},
			stopPropagation: function() {
				var e = this.nativeEvent;
				e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = cn);
			},
			persist: function() {},
			isPersistent: cn
		}), t;
	}
	var dn = {
		eventPhase: 0,
		bubbles: 0,
		cancelable: 0,
		timeStamp: function(e) {
			return e.timeStamp || Date.now();
		},
		defaultPrevented: 0,
		isTrusted: 0
	}, fn = un(dn), pn = f({}, dn, {
		view: 0,
		detail: 0
	}), mn = un(pn), hn, gn, _n, K = f({}, pn, {
		screenX: 0,
		screenY: 0,
		clientX: 0,
		clientY: 0,
		pageX: 0,
		pageY: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		getModifierState: On,
		button: 0,
		buttons: 0,
		relatedTarget: function(e) {
			return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
		},
		movementX: function(e) {
			return "movementX" in e ? e.movementX : (e !== _n && (_n && e.type === "mousemove" ? (hn = e.screenX - _n.screenX, gn = e.screenY - _n.screenY) : gn = hn = 0, _n = e), hn);
		},
		movementY: function(e) {
			return "movementY" in e ? e.movementY : gn;
		}
	}), vn = un(K), yn = un(f({}, K, { dataTransfer: 0 })), bn = un(f({}, pn, { relatedTarget: 0 })), xn = un(f({}, dn, {
		animationName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), Sn = un(f({}, dn, { clipboardData: function(e) {
		return "clipboardData" in e ? e.clipboardData : window.clipboardData;
	} })), Cn = un(f({}, dn, { data: 0 })), wn = {
		Esc: "Escape",
		Spacebar: " ",
		Left: "ArrowLeft",
		Up: "ArrowUp",
		Right: "ArrowRight",
		Down: "ArrowDown",
		Del: "Delete",
		Win: "OS",
		Menu: "ContextMenu",
		Apps: "ContextMenu",
		Scroll: "ScrollLock",
		MozPrintableKey: "Unidentified"
	}, Tn = {
		8: "Backspace",
		9: "Tab",
		12: "Clear",
		13: "Enter",
		16: "Shift",
		17: "Control",
		18: "Alt",
		19: "Pause",
		20: "CapsLock",
		27: "Escape",
		32: " ",
		33: "PageUp",
		34: "PageDown",
		35: "End",
		36: "Home",
		37: "ArrowLeft",
		38: "ArrowUp",
		39: "ArrowRight",
		40: "ArrowDown",
		45: "Insert",
		46: "Delete",
		112: "F1",
		113: "F2",
		114: "F3",
		115: "F4",
		116: "F5",
		117: "F6",
		118: "F7",
		119: "F8",
		120: "F9",
		121: "F10",
		122: "F11",
		123: "F12",
		144: "NumLock",
		145: "ScrollLock",
		224: "Meta"
	}, En = {
		Alt: "altKey",
		Control: "ctrlKey",
		Meta: "metaKey",
		Shift: "shiftKey"
	};
	function Dn(e) {
		var t = this.nativeEvent;
		return t.getModifierState ? t.getModifierState(e) : (e = En[e]) ? !!t[e] : !1;
	}
	function On() {
		return Dn;
	}
	var kn = un(f({}, pn, {
		key: function(e) {
			if (e.key) {
				var t = wn[e.key] || e.key;
				if (t !== "Unidentified") return t;
			}
			return e.type === "keypress" ? (e = sn(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? Tn[e.keyCode] || "Unidentified" : "";
		},
		code: 0,
		location: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		repeat: 0,
		locale: 0,
		getModifierState: On,
		charCode: function(e) {
			return e.type === "keypress" ? sn(e) : 0;
		},
		keyCode: function(e) {
			return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		},
		which: function(e) {
			return e.type === "keypress" ? sn(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		}
	})), An = un(f({}, K, {
		pointerId: 0,
		width: 0,
		height: 0,
		pressure: 0,
		tangentialPressure: 0,
		tiltX: 0,
		tiltY: 0,
		twist: 0,
		pointerType: 0,
		isPrimary: 0
	})), jn = un(f({}, pn, {
		touches: 0,
		targetTouches: 0,
		changedTouches: 0,
		altKey: 0,
		metaKey: 0,
		ctrlKey: 0,
		shiftKey: 0,
		getModifierState: On
	})), Mn = un(f({}, dn, {
		propertyName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), Nn = un(f({}, K, {
		deltaX: function(e) {
			return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
		},
		deltaY: function(e) {
			return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
		},
		deltaZ: 0,
		deltaMode: 0
	})), Pn = un(f({}, dn, {
		newState: 0,
		oldState: 0
	})), Fn = [
		9,
		13,
		27,
		32
	], In = $t && "CompositionEvent" in window, Ln = null;
	$t && "documentMode" in document && (Ln = document.documentMode);
	var Rn = $t && "TextEvent" in window && !Ln, zn = $t && (!In || Ln && 8 < Ln && 11 >= Ln), Bn = " ", Vn = !1;
	function Hn(e, t) {
		switch (e) {
			case "keyup": return Fn.indexOf(t.keyCode) !== -1;
			case "keydown": return t.keyCode !== 229;
			case "keypress":
			case "mousedown":
			case "focusout": return !0;
			default: return !1;
		}
	}
	function Un(e) {
		return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
	}
	var Wn = !1;
	function Gn(e, t) {
		switch (e) {
			case "compositionend": return Un(t);
			case "keypress": return t.which === 32 ? (Vn = !0, Bn) : null;
			case "textInput": return e = t.data, e === Bn && Vn ? null : e;
			default: return null;
		}
	}
	function Kn(e, t) {
		if (Wn) return e === "compositionend" || !In && Hn(e, t) ? (e = on(), an = rn = nn = null, Wn = !1, e) : null;
		switch (e) {
			case "paste": return null;
			case "keypress":
				if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
					if (t.char && 1 < t.char.length) return t.char;
					if (t.which) return String.fromCharCode(t.which);
				}
				return null;
			case "compositionend": return zn && t.locale !== "ko" ? null : t.data;
			default: return null;
		}
	}
	var qn = {
		color: !0,
		date: !0,
		datetime: !0,
		"datetime-local": !0,
		email: !0,
		month: !0,
		number: !0,
		password: !0,
		range: !0,
		search: !0,
		tel: !0,
		text: !0,
		time: !0,
		url: !0,
		week: !0
	};
	function Jn(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t === "input" ? !!qn[e.type] : t === "textarea";
	}
	function Yn(e, t, n, r) {
		qt ? Jt ? Jt.push(r) : Jt = [r] : qt = r, t = Ed(t, "onChange"), 0 < t.length && (n = new fn("onChange", "change", null, n, r), e.push({
			event: n,
			listeners: t
		}));
	}
	var Xn = null, Zn = null;
	function Qn(e) {
		vd(e, 0);
	}
	function $n(e) {
		if (Dt(ut(e))) return e;
	}
	function tr(e, t) {
		if (e === "change") return t;
	}
	var nr = !1;
	if ($t) {
		var rr;
		if ($t) {
			var ir = "oninput" in document;
			if (!ir) {
				var ar = document.createElement("div");
				ar.setAttribute("oninput", "return;"), ir = typeof ar.oninput == "function";
			}
			rr = ir;
		} else rr = !1;
		nr = rr && (!document.documentMode || 9 < document.documentMode);
	}
	function or() {
		Xn && (Xn.detachEvent("onpropertychange", sr), Zn = Xn = null);
	}
	function sr(e) {
		if (e.propertyName === "value" && $n(Zn)) {
			var t = [];
			Yn(t, Zn, e, Kt(e)), Zt(Qn, t);
		}
	}
	function cr(e, t, n) {
		e === "focusin" ? (or(), Xn = t, Zn = n, Xn.attachEvent("onpropertychange", sr)) : e === "focusout" && or();
	}
	function lr(e) {
		if (e === "selectionchange" || e === "keyup" || e === "keydown") return $n(Zn);
	}
	function ur(e, t) {
		if (e === "click") return $n(t);
	}
	function dr(e, t) {
		if (e === "input" || e === "change") return $n(t);
	}
	function fr(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var pr = typeof Object.is == "function" ? Object.is : fr;
	function mr(e, t) {
		if (pr(e, t)) return !0;
		if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
		var n = Object.keys(e), r = Object.keys(t);
		if (n.length !== r.length) return !1;
		for (r = 0; r < n.length; r++) {
			var i = n[r];
			if (!me.call(t, i) || !pr(e[i], t[i])) return !1;
		}
		return !0;
	}
	function hr(e) {
		for (; e && e.firstChild;) e = e.firstChild;
		return e;
	}
	function gr(e, t) {
		var n = hr(e);
		e = 0;
		for (var r; n;) {
			if (n.nodeType === 3) {
				if (r = e + n.textContent.length, e <= t && r >= t) return {
					node: n,
					offset: t - e
				};
				e = r;
			}
			a: {
				for (; n;) {
					if (n.nextSibling) {
						n = n.nextSibling;
						break a;
					}
					n = n.parentNode;
				}
				n = void 0;
			}
			n = hr(n);
		}
	}
	function _r(e, t) {
		return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? _r(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
	}
	function vr(e) {
		e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
		for (var t = Ot(e.document); t instanceof e.HTMLIFrameElement;) {
			try {
				var n = typeof t.contentWindow.location.href == "string";
			} catch {
				n = !1;
			}
			if (n) e = t.contentWindow;
			else break;
			t = Ot(e.document);
		}
		return t;
	}
	function yr(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
	}
	var br = $t && "documentMode" in document && 11 >= document.documentMode, xr = null, Sr = null, Cr = null, wr = !1;
	function Tr(e, t, n) {
		var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
		wr || xr == null || xr !== Ot(r) || (r = xr, "selectionStart" in r && yr(r) ? r = {
			start: r.selectionStart,
			end: r.selectionEnd
		} : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
			anchorNode: r.anchorNode,
			anchorOffset: r.anchorOffset,
			focusNode: r.focusNode,
			focusOffset: r.focusOffset
		}), Cr && mr(Cr, r) || (Cr = r, r = Ed(Sr, "onSelect"), 0 < r.length && (t = new fn("onSelect", "select", null, t, n), e.push({
			event: t,
			listeners: r
		}), t.target = xr)));
	}
	function Er(e, t) {
		var n = {};
		return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
	}
	var Dr = {
		animationend: Er("Animation", "AnimationEnd"),
		animationiteration: Er("Animation", "AnimationIteration"),
		animationstart: Er("Animation", "AnimationStart"),
		transitionrun: Er("Transition", "TransitionRun"),
		transitionstart: Er("Transition", "TransitionStart"),
		transitioncancel: Er("Transition", "TransitionCancel"),
		transitionend: Er("Transition", "TransitionEnd")
	}, Or = {}, kr = {};
	$t && (kr = document.createElement("div").style, "AnimationEvent" in window || (delete Dr.animationend.animation, delete Dr.animationiteration.animation, delete Dr.animationstart.animation), "TransitionEvent" in window || delete Dr.transitionend.transition);
	function Ar(e) {
		if (Or[e]) return Or[e];
		if (!Dr[e]) return e;
		var t = Dr[e], n;
		for (n in t) if (t.hasOwnProperty(n) && n in kr) return Or[e] = t[n];
		return e;
	}
	var jr = Ar("animationend"), Mr = Ar("animationiteration"), Nr = Ar("animationstart"), Pr = Ar("transitionrun"), Fr = Ar("transitionstart"), q = Ar("transitioncancel"), Ir = Ar("transitionend"), Lr = /* @__PURE__ */ new Map(), Rr = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
	Rr.push("scrollEnd");
	function zr(e, t) {
		Lr.set(e, t), ht(t, [e]);
	}
	var Br = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, Vr = [], Hr = 0, Ur = 0;
	function Wr() {
		for (var e = Hr, t = Ur = Hr = 0; t < e;) {
			var n = Vr[t];
			Vr[t++] = null;
			var r = Vr[t];
			Vr[t++] = null;
			var i = Vr[t];
			Vr[t++] = null;
			var a = Vr[t];
			if (Vr[t++] = null, r !== null && i !== null) {
				var o = r.pending;
				o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i;
			}
			a !== 0 && Jr(n, i, a);
		}
	}
	function Gr(e, t, n, r) {
		Vr[Hr++] = e, Vr[Hr++] = t, Vr[Hr++] = n, Vr[Hr++] = r, Ur |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r);
	}
	function Kr(e, t, n, r) {
		return Gr(e, t, n, r), Yr(e);
	}
	function qr(e, t) {
		return Gr(e, null, null, t), Yr(e);
	}
	function Jr(e, t, n) {
		e.lanes |= n;
		var r = e.alternate;
		r !== null && (r.lanes |= n);
		for (var i = !1, a = e.return; a !== null;) a.childLanes |= n, r = a.alternate, r !== null && (r.childLanes |= n), a.tag === 22 && (e = a.stateNode, e === null || e._visibility & 1 || (i = !0)), e = a, a = a.return;
		return e.tag === 3 ? (a = e.stateNode, i && t !== null && (i = 31 - Ae(n), e = a.hiddenUpdates, r = e[i], r === null ? e[i] = [t] : r.push(t), t.lane = n | 536870912), a) : null;
	}
	function Yr(e) {
		if (50 < uu) throw uu = 0, du = null, Error(i(185));
		for (var t = e.return; t !== null;) e = t, t = e.return;
		return e.tag === 3 ? e.stateNode : null;
	}
	var Xr = {};
	function Zr(e, t, n, r) {
		this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
	}
	function Qr(e, t, n, r) {
		return new Zr(e, t, n, r);
	}
	function $r(e) {
		return e = e.prototype, !(!e || !e.isReactComponent);
	}
	function ei(e, t) {
		var n = e.alternate;
		return n === null ? (n = Qr(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n;
	}
	function ti(e, t) {
		e.flags &= 65011714;
		var n = e.alternate;
		return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}), e;
	}
	function J(e, t, n, r, a, o) {
		var s = 0;
		if (r = e, typeof e == "function") $r(e) && (s = 1);
		else if (typeof e == "string") s = Uf(e, n, B.current) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
		else a: switch (e) {
			case D: return e = Qr(31, n, t, a), e.elementType = D, e.lanes = o, e;
			case _: return ni(n.children, a, o, t);
			case v:
				s = 8, a |= 24;
				break;
			case y: return e = Qr(12, n, t, a | 2), e.elementType = y, e.lanes = o, e;
			case C: return e = Qr(13, n, t, a), e.elementType = C, e.lanes = o, e;
			case w: return e = Qr(19, n, t, a), e.elementType = w, e.lanes = o, e;
			default:
				if (typeof e == "object" && e) switch (e.$$typeof) {
					case x:
						s = 10;
						break a;
					case b:
						s = 9;
						break a;
					case S:
						s = 11;
						break a;
					case T:
						s = 14;
						break a;
					case E:
						s = 16, r = null;
						break a;
				}
				s = 29, n = Error(i(130, e === null ? "null" : typeof e, "")), r = null;
		}
		return t = Qr(s, n, t, a), t.elementType = e, t.type = r, t.lanes = o, t;
	}
	function ni(e, t, n, r) {
		return e = Qr(7, e, r, t), e.lanes = n, e;
	}
	function ri(e, t, n) {
		return e = Qr(6, e, null, t), e.lanes = n, e;
	}
	function ii(e) {
		var t = Qr(18, null, null, 0);
		return t.stateNode = e, t;
	}
	function ai(e, t, n) {
		return t = Qr(4, e.children === null ? [] : e.children, e.key, t), t.lanes = n, t.stateNode = {
			containerInfo: e.containerInfo,
			pendingChildren: null,
			implementation: e.implementation
		}, t;
	}
	var oi = /* @__PURE__ */ new WeakMap();
	function si(e, t) {
		if (typeof e == "object" && e) {
			var n = oi.get(e);
			return n === void 0 ? (t = {
				value: e,
				source: t,
				stack: pe(t)
			}, oi.set(e, t), t) : n;
		}
		return {
			value: e,
			source: t,
			stack: pe(t)
		};
	}
	var ci = [], li = 0, ui = null, di = 0, fi = [], pi = 0, mi = null, hi = 1, gi = "";
	function _i(e, t) {
		ci[li++] = di, ci[li++] = ui, ui = e, di = t;
	}
	function vi(e, t, n) {
		fi[pi++] = hi, fi[pi++] = gi, fi[pi++] = mi, mi = e;
		var r = hi;
		e = gi;
		var i = 32 - Ae(r) - 1;
		r &= ~(1 << i), n += 1;
		var a = 32 - Ae(t) + i;
		if (30 < a) {
			var o = i - i % 5;
			a = (r & (1 << o) - 1).toString(32), r >>= o, i -= o, hi = 1 << 32 - Ae(t) + i | n << i | r, gi = a + e;
		} else hi = 1 << a | n << i | r, gi = e;
	}
	function yi(e) {
		e.return !== null && (_i(e, 1), vi(e, 1, 0));
	}
	function bi(e) {
		for (; e === ui;) ui = ci[--li], ci[li] = null, di = ci[--li], ci[li] = null;
		for (; e === mi;) mi = fi[--pi], fi[pi] = null, gi = fi[--pi], fi[pi] = null, hi = fi[--pi], fi[pi] = null;
	}
	function xi(e, t) {
		fi[pi++] = hi, fi[pi++] = gi, fi[pi++] = mi, hi = t.id, gi = t.overflow, mi = e;
	}
	var Si = null, Ci = null, wi = !1, Ti = null, Ei = !1, Di = Error(i(519));
	function Oi(e) {
		throw Pi(si(Error(i(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML", "")), e)), Di;
	}
	function ki(e) {
		var t = e.stateNode, n = e.type, r = e.memoizedProps;
		switch (t[$e] = e, t[et] = r, n) {
			case "dialog":
				yd("cancel", t), yd("close", t);
				break;
			case "iframe":
			case "object":
			case "embed":
				yd("load", t);
				break;
			case "video":
			case "audio":
				for (n = 0; n < gd.length; n++) yd(gd[n], t);
				break;
			case "source":
				yd("error", t);
				break;
			case "img":
			case "image":
			case "link":
				yd("error", t), yd("load", t);
				break;
			case "details":
				yd("toggle", t);
				break;
			case "input":
				yd("invalid", t), Mt(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0);
				break;
			case "select":
				yd("invalid", t);
				break;
			case "textarea": yd("invalid", t), It(t, r.value, r.defaultValue, r.children);
		}
		n = r.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || t.textContent === "" + n || !0 === r.suppressHydrationWarning || Md(t.textContent, n) ? (r.popover != null && (yd("beforetoggle", t), yd("toggle", t)), r.onScroll != null && yd("scroll", t), r.onScrollEnd != null && yd("scrollend", t), r.onClick != null && (t.onclick = Wt), t = !0) : t = !1, t || Oi(e, !0);
	}
	function Ai(e) {
		for (Si = e.return; Si;) switch (Si.tag) {
			case 5:
			case 31:
			case 13:
				Ei = !1;
				return;
			case 27:
			case 3:
				Ei = !0;
				return;
			default: Si = Si.return;
		}
	}
	function ji(e) {
		if (e !== Si) return !1;
		if (!wi) return Ai(e), wi = !0, !1;
		var t = e.tag, n;
		if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = !(n !== "form" && n !== "button") || Wd(e.type, e.memoizedProps)), n = !n), n && Ci && Oi(e), Ai(e), t === 13) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			Ci = df(e);
		} else if (t === 31) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			Ci = df(e);
		} else t === 27 ? (t = Ci, Qd(e.type) ? (e = uf, uf = null, Ci = e) : Ci = t) : Ci = Si ? lf(e.stateNode.nextSibling) : null;
		return !0;
	}
	function Mi() {
		Ci = Si = null, wi = !1;
	}
	function Ni() {
		var e = Ti;
		return e !== null && (Xl === null ? Xl = e : Xl.push.apply(Xl, e), Ti = null), e;
	}
	function Pi(e) {
		Ti === null ? Ti = [e] : Ti.push(e);
	}
	var Fi = R(null), Ii = null, Li = null;
	function Ri(e, t, n) {
		te(Fi, t._currentValue), t._currentValue = n;
	}
	function zi(e) {
		e._currentValue = Fi.current, z(Fi);
	}
	function Bi(e, t, n) {
		for (; e !== null;) {
			var r = e.alternate;
			if ((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n) break;
			e = e.return;
		}
	}
	function Vi(e, t, n, r) {
		var a = e.child;
		for (a !== null && (a.return = e); a !== null;) {
			var o = a.dependencies;
			if (o !== null) {
				var s = a.child;
				o = o.firstContext;
				a: for (; o !== null;) {
					var c = o;
					o = a;
					for (var l = 0; l < t.length; l++) if (c.context === t[l]) {
						o.lanes |= n, c = o.alternate, c !== null && (c.lanes |= n), Bi(o.return, n, e), r || (s = null);
						break a;
					}
					o = c.next;
				}
			} else if (a.tag === 18) {
				if (s = a.return, s === null) throw Error(i(341));
				s.lanes |= n, o = s.alternate, o !== null && (o.lanes |= n), Bi(s, n, e), s = null;
			} else s = a.child;
			if (s !== null) s.return = a;
			else for (s = a; s !== null;) {
				if (s === e) {
					s = null;
					break;
				}
				if (a = s.sibling, a !== null) {
					a.return = s.return, s = a;
					break;
				}
				s = s.return;
			}
			a = s;
		}
	}
	function Hi(e, t, n, r) {
		e = null;
		for (var a = t, o = !1; a !== null;) {
			if (!o) {
				if (a.flags & 524288) o = !0;
				else if (a.flags & 262144) break;
			}
			if (a.tag === 10) {
				var s = a.alternate;
				if (s === null) throw Error(i(387));
				if (s = s.memoizedProps, s !== null) {
					var c = a.type;
					pr(a.pendingProps.value, s.value) || (e === null ? e = [c] : e.push(c));
				}
			} else if (a === re.current) {
				if (s = a.alternate, s === null) throw Error(i(387));
				s.memoizedState.memoizedState !== a.memoizedState.memoizedState && (e === null ? e = [Qf] : e.push(Qf));
			}
			a = a.return;
		}
		e !== null && Vi(t, e, n, r), t.flags |= 262144;
	}
	function Ui(e) {
		for (e = e.firstContext; e !== null;) {
			if (!pr(e.context._currentValue, e.memoizedValue)) return !0;
			e = e.next;
		}
		return !1;
	}
	function Wi(e) {
		Ii = e, Li = null, e = e.dependencies, e !== null && (e.firstContext = null);
	}
	function Gi(e) {
		return qi(Ii, e);
	}
	function Ki(e, t) {
		return Ii === null && Wi(e), qi(e, t);
	}
	function qi(e, t) {
		var n = t._currentValue;
		if (t = {
			context: t,
			memoizedValue: n,
			next: null
		}, Li === null) {
			if (e === null) throw Error(i(308));
			Li = t, e.dependencies = {
				lanes: 0,
				firstContext: t
			}, e.flags |= 524288;
		} else Li = Li.next = t;
		return n;
	}
	var Ji = typeof AbortController < "u" ? AbortController : function() {
		var e = [], t = this.signal = {
			aborted: !1,
			addEventListener: function(t, n) {
				e.push(n);
			}
		};
		this.abort = function() {
			t.aborted = !0, e.forEach(function(e) {
				return e();
			});
		};
	}, Yi = t.unstable_scheduleCallback, Xi = t.unstable_NormalPriority, Zi = {
		$$typeof: x,
		Consumer: null,
		Provider: null,
		_currentValue: null,
		_currentValue2: null,
		_threadCount: 0
	};
	function Qi() {
		return {
			controller: new Ji(),
			data: /* @__PURE__ */ new Map(),
			refCount: 0
		};
	}
	function $i(e) {
		e.refCount--, e.refCount === 0 && Yi(Xi, function() {
			e.controller.abort();
		});
	}
	var ea = null, Y = 0, X = 0, ta = null;
	function na(e, t) {
		if (ea === null) {
			var n = ea = [];
			Y = 0, X = ud(), ta = {
				status: "pending",
				value: void 0,
				then: function(e) {
					n.push(e);
				}
			};
		}
		return Y++, t.then(ra, ra), t;
	}
	function ra() {
		if (--Y === 0 && ea !== null) {
			ta !== null && (ta.status = "fulfilled");
			var e = ea;
			ea = null, X = 0, ta = null;
			for (var t = 0; t < e.length; t++) (0, e[t])();
		}
	}
	function ia(e, t) {
		var n = [], r = {
			status: "pending",
			value: null,
			reason: null,
			then: function(e) {
				n.push(e);
			}
		};
		return e.then(function() {
			r.status = "fulfilled", r.value = t;
			for (var e = 0; e < n.length; e++) (0, n[e])(t);
		}, function(e) {
			for (r.status = "rejected", r.reason = e, e = 0; e < n.length; e++) (0, n[e])(void 0);
		}), r;
	}
	var aa = P.S;
	P.S = function(e, t) {
		$l = ye(), typeof t == "object" && t && typeof t.then == "function" && na(e, t), aa !== null && aa(e, t);
	};
	var oa = R(null);
	function sa() {
		var e = oa.current;
		return e === null ? Pl.pooledCache : e;
	}
	function ca(e, t) {
		t === null ? te(oa, oa.current) : te(oa, t.pool);
	}
	function la() {
		var e = sa();
		return e === null ? null : {
			parent: Zi._currentValue,
			pool: e
		};
	}
	var ua = Error(i(460)), da = Error(i(474)), fa = Error(i(542)), pa = { then: function() {} };
	function ma(e) {
		return e = e.status, e === "fulfilled" || e === "rejected";
	}
	function ha(e, t, n) {
		switch (n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then(Wt, Wt), t = n), t.status) {
			case "fulfilled": return t.value;
			case "rejected": throw e = t.reason, ya(e), e;
			default:
				if (typeof t.status == "string") t.then(Wt, Wt);
				else {
					if (e = Pl, e !== null && 100 < e.shellSuspendCounter) throw Error(i(482));
					e = t, e.status = "pending", e.then(function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "fulfilled", n.value = e;
						}
					}, function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "rejected", n.reason = e;
						}
					});
				}
				switch (t.status) {
					case "fulfilled": return t.value;
					case "rejected": throw e = t.reason, ya(e), e;
				}
				throw _a = t, ua;
		}
	}
	function ga(e) {
		try {
			var t = e._init;
			return t(e._payload);
		} catch (e) {
			throw typeof e == "object" && e && typeof e.then == "function" ? (_a = e, ua) : e;
		}
	}
	var _a = null;
	function va() {
		if (_a === null) throw Error(i(459));
		var e = _a;
		return _a = null, e;
	}
	function ya(e) {
		if (e === ua || e === fa) throw Error(i(483));
	}
	var ba = null, xa = 0;
	function Sa(e) {
		var t = xa;
		return xa += 1, ba === null && (ba = []), ha(ba, e, t);
	}
	function Ca(e, t) {
		t = t.props.ref, e.ref = t === void 0 ? null : t;
	}
	function wa(e, t) {
		throw t.$$typeof === p ? Error(i(525)) : (e = Object.prototype.toString.call(t), Error(i(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e)));
	}
	function Ta(e) {
		function t(t, n) {
			if (e) {
				var r = t.deletions;
				r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n);
			}
		}
		function n(n, r) {
			if (!e) return null;
			for (; r !== null;) t(n, r), r = r.sibling;
			return null;
		}
		function r(e) {
			for (var t = /* @__PURE__ */ new Map(); e !== null;) e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling;
			return t;
		}
		function a(e, t) {
			return e = ei(e, t), e.index = 0, e.sibling = null, e;
		}
		function o(t, n, r) {
			return t.index = r, e ? (r = t.alternate, r === null ? (t.flags |= 67108866, n) : (r = r.index, r < n ? (t.flags |= 67108866, n) : r)) : (t.flags |= 1048576, n);
		}
		function s(t) {
			return e && t.alternate === null && (t.flags |= 67108866), t;
		}
		function c(e, t, n, r) {
			return t === null || t.tag !== 6 ? (t = ri(n, e.mode, r), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function l(e, t, n, r) {
			var i = n.type;
			return i === _ ? d(e, t, n.props.children, r, n.key) : t !== null && (t.elementType === i || typeof i == "object" && i && i.$$typeof === E && ga(i) === t.type) ? (t = a(t, n.props), Ca(t, n), t.return = e, t) : (t = J(n.type, n.key, n.props, null, e.mode, r), Ca(t, n), t.return = e, t);
		}
		function u(e, t, n, r) {
			return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? (t = ai(n, e.mode, r), t.return = e, t) : (t = a(t, n.children || []), t.return = e, t);
		}
		function d(e, t, n, r, i) {
			return t === null || t.tag !== 7 ? (t = ni(n, e.mode, r, i), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function f(e, t, n) {
			if (typeof t == "string" && t !== "" || typeof t == "number" || typeof t == "bigint") return t = ri("" + t, e.mode, n), t.return = e, t;
			if (typeof t == "object" && t) {
				switch (t.$$typeof) {
					case h: return n = J(t.type, t.key, t.props, null, e.mode, n), Ca(n, t), n.return = e, n;
					case g: return t = ai(t, e.mode, n), t.return = e, t;
					case E: return t = ga(t), f(e, t, n);
				}
				if (N(t) || A(t)) return t = ni(t, e.mode, n, null), t.return = e, t;
				if (typeof t.then == "function") return f(e, Sa(t), n);
				if (t.$$typeof === x) return f(e, Ki(e, t), n);
				wa(e, t);
			}
			return null;
		}
		function p(e, t, n, r) {
			var i = t === null ? null : t.key;
			if (typeof n == "string" && n !== "" || typeof n == "number" || typeof n == "bigint") return i === null ? c(e, t, "" + n, r) : null;
			if (typeof n == "object" && n) {
				switch (n.$$typeof) {
					case h: return n.key === i ? l(e, t, n, r) : null;
					case g: return n.key === i ? u(e, t, n, r) : null;
					case E: return n = ga(n), p(e, t, n, r);
				}
				if (N(n) || A(n)) return i === null ? d(e, t, n, r, null) : null;
				if (typeof n.then == "function") return p(e, t, Sa(n), r);
				if (n.$$typeof === x) return p(e, t, Ki(e, n), r);
				wa(e, n);
			}
			return null;
		}
		function m(e, t, n, r, i) {
			if (typeof r == "string" && r !== "" || typeof r == "number" || typeof r == "bigint") return e = e.get(n) || null, c(t, e, "" + r, i);
			if (typeof r == "object" && r) {
				switch (r.$$typeof) {
					case h: return e = e.get(r.key === null ? n : r.key) || null, l(t, e, r, i);
					case g: return e = e.get(r.key === null ? n : r.key) || null, u(t, e, r, i);
					case E: return r = ga(r), m(e, t, n, r, i);
				}
				if (N(r) || A(r)) return e = e.get(n) || null, d(t, e, r, i, null);
				if (typeof r.then == "function") return m(e, t, n, Sa(r), i);
				if (r.$$typeof === x) return m(e, t, n, Ki(t, r), i);
				wa(t, r);
			}
			return null;
		}
		function v(i, a, s, c) {
			for (var l = null, u = null, d = a, h = a = 0, g = null; d !== null && h < s.length; h++) {
				d.index > h ? (g = d, d = null) : g = d.sibling;
				var _ = p(i, d, s[h], c);
				if (_ === null) {
					d === null && (d = g);
					break;
				}
				e && d && _.alternate === null && t(i, d), a = o(_, a, h), u === null ? l = _ : u.sibling = _, u = _, d = g;
			}
			if (h === s.length) return n(i, d), wi && _i(i, h), l;
			if (d === null) {
				for (; h < s.length; h++) d = f(i, s[h], c), d !== null && (a = o(d, a, h), u === null ? l = d : u.sibling = d, u = d);
				return wi && _i(i, h), l;
			}
			for (d = r(d); h < s.length; h++) g = m(d, i, h, s[h], c), g !== null && (e && g.alternate !== null && d.delete(g.key === null ? h : g.key), a = o(g, a, h), u === null ? l = g : u.sibling = g, u = g);
			return e && d.forEach(function(e) {
				return t(i, e);
			}), wi && _i(i, h), l;
		}
		function y(a, s, c, l) {
			if (c == null) throw Error(i(151));
			for (var u = null, d = null, h = s, g = s = 0, _ = null, v = c.next(); h !== null && !v.done; g++, v = c.next()) {
				h.index > g ? (_ = h, h = null) : _ = h.sibling;
				var y = p(a, h, v.value, l);
				if (y === null) {
					h === null && (h = _);
					break;
				}
				e && h && y.alternate === null && t(a, h), s = o(y, s, g), d === null ? u = y : d.sibling = y, d = y, h = _;
			}
			if (v.done) return n(a, h), wi && _i(a, g), u;
			if (h === null) {
				for (; !v.done; g++, v = c.next()) v = f(a, v.value, l), v !== null && (s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
				return wi && _i(a, g), u;
			}
			for (h = r(h); !v.done; g++, v = c.next()) v = m(h, a, g, v.value, l), v !== null && (e && v.alternate !== null && h.delete(v.key === null ? g : v.key), s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
			return e && h.forEach(function(e) {
				return t(a, e);
			}), wi && _i(a, g), u;
		}
		function b(e, r, o, c) {
			if (typeof o == "object" && o && o.type === _ && o.key === null && (o = o.props.children), typeof o == "object" && o) {
				switch (o.$$typeof) {
					case h:
						a: {
							for (var l = o.key; r !== null;) {
								if (r.key === l) {
									if (l = o.type, l === _) {
										if (r.tag === 7) {
											n(e, r.sibling), c = a(r, o.props.children), c.return = e, e = c;
											break a;
										}
									} else if (r.elementType === l || typeof l == "object" && l && l.$$typeof === E && ga(l) === r.type) {
										n(e, r.sibling), c = a(r, o.props), Ca(c, o), c.return = e, e = c;
										break a;
									}
									n(e, r);
									break;
								} else t(e, r);
								r = r.sibling;
							}
							o.type === _ ? (c = ni(o.props.children, e.mode, c, o.key), c.return = e, e = c) : (c = J(o.type, o.key, o.props, null, e.mode, c), Ca(c, o), c.return = e, e = c);
						}
						return s(e);
					case g:
						a: {
							for (l = o.key; r !== null;) {
								if (r.key === l) if (r.tag === 4 && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
									n(e, r.sibling), c = a(r, o.children || []), c.return = e, e = c;
									break a;
								} else {
									n(e, r);
									break;
								}
								else t(e, r);
								r = r.sibling;
							}
							c = ai(o, e.mode, c), c.return = e, e = c;
						}
						return s(e);
					case E: return o = ga(o), b(e, r, o, c);
				}
				if (N(o)) return v(e, r, o, c);
				if (A(o)) {
					if (l = A(o), typeof l != "function") throw Error(i(150));
					return o = l.call(o), y(e, r, o, c);
				}
				if (typeof o.then == "function") return b(e, r, Sa(o), c);
				if (o.$$typeof === x) return b(e, r, Ki(e, o), c);
				wa(e, o);
			}
			return typeof o == "string" && o !== "" || typeof o == "number" || typeof o == "bigint" ? (o = "" + o, r !== null && r.tag === 6 ? (n(e, r.sibling), c = a(r, o), c.return = e, e = c) : (n(e, r), c = ri(o, e.mode, c), c.return = e, e = c), s(e)) : n(e, r);
		}
		return function(e, t, n, r) {
			try {
				xa = 0;
				var i = b(e, t, n, r);
				return ba = null, i;
			} catch (t) {
				if (t === ua || t === fa) throw t;
				var a = Qr(29, t, null, e.mode);
				return a.lanes = r, a.return = e, a;
			}
		};
	}
	var Ea = Ta(!0), Da = Ta(!1), Oa = !1;
	function ka(e) {
		e.updateQueue = {
			baseState: e.memoizedState,
			firstBaseUpdate: null,
			lastBaseUpdate: null,
			shared: {
				pending: null,
				lanes: 0,
				hiddenCallbacks: null
			},
			callbacks: null
		};
	}
	function Aa(e, t) {
		e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
			baseState: e.baseState,
			firstBaseUpdate: e.firstBaseUpdate,
			lastBaseUpdate: e.lastBaseUpdate,
			shared: e.shared,
			callbacks: null
		});
	}
	function ja(e) {
		return {
			lane: e,
			tag: 0,
			payload: null,
			callback: null,
			next: null
		};
	}
	function Ma(e, t, n) {
		var r = e.updateQueue;
		if (r === null) return null;
		if (r = r.shared, Nl & 2) {
			var i = r.pending;
			return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = Yr(e), Jr(e, null, n), t;
		}
		return Gr(e, r, t, n), Yr(e);
	}
	function Na(e, t, n) {
		if (t = t.updateQueue, t !== null && (t = t.shared, n & 4194048)) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, Ke(e, n);
		}
	}
	function Pa(e, t) {
		var n = e.updateQueue, r = e.alternate;
		if (r !== null && (r = r.updateQueue, n === r)) {
			var i = null, a = null;
			if (n = n.firstBaseUpdate, n !== null) {
				do {
					var o = {
						lane: n.lane,
						tag: n.tag,
						payload: n.payload,
						callback: null,
						next: null
					};
					a === null ? i = a = o : a = a.next = o, n = n.next;
				} while (n !== null);
				a === null ? i = a = t : a = a.next = t;
			} else i = a = t;
			n = {
				baseState: r.baseState,
				firstBaseUpdate: i,
				lastBaseUpdate: a,
				shared: r.shared,
				callbacks: r.callbacks
			}, e.updateQueue = n;
			return;
		}
		e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
	}
	var Fa = !1;
	function Ia() {
		if (Fa) {
			var e = ta;
			if (e !== null) throw e;
		}
	}
	function La(e, t, n, r) {
		Fa = !1;
		var i = e.updateQueue;
		Oa = !1;
		var a = i.firstBaseUpdate, o = i.lastBaseUpdate, s = i.shared.pending;
		if (s !== null) {
			i.shared.pending = null;
			var c = s, l = c.next;
			c.next = null, o === null ? a = l : o.next = l, o = c;
			var u = e.alternate;
			u !== null && (u = u.updateQueue, s = u.lastBaseUpdate, s !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c));
		}
		if (a !== null) {
			var d = i.baseState;
			o = 0, u = l = c = null, s = a;
			do {
				var p = s.lane & -536870913, m = p !== s.lane;
				if (m ? (Il & p) === p : (r & p) === p) {
					p !== 0 && p === X && (Fa = !0), u !== null && (u = u.next = {
						lane: 0,
						tag: s.tag,
						payload: s.payload,
						callback: null,
						next: null
					});
					a: {
						var h = e, g = s;
						p = t;
						var _ = n;
						switch (g.tag) {
							case 1:
								if (h = g.payload, typeof h == "function") {
									d = h.call(_, d, p);
									break a;
								}
								d = h;
								break a;
							case 3: h.flags = h.flags & -65537 | 128;
							case 0:
								if (h = g.payload, p = typeof h == "function" ? h.call(_, d, p) : h, p == null) break a;
								d = f({}, d, p);
								break a;
							case 2: Oa = !0;
						}
					}
					p = s.callback, p !== null && (e.flags |= 64, m && (e.flags |= 8192), m = i.callbacks, m === null ? i.callbacks = [p] : m.push(p));
				} else m = {
					lane: p,
					tag: s.tag,
					payload: s.payload,
					callback: s.callback,
					next: null
				}, u === null ? (l = u = m, c = d) : u = u.next = m, o |= p;
				if (s = s.next, s === null) {
					if (s = i.shared.pending, s === null) break;
					m = s, s = m.next, m.next = null, i.lastBaseUpdate = m, i.shared.pending = null;
				}
			} while (1);
			u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), Wl |= o, e.lanes = o, e.memoizedState = d;
		}
	}
	function Ra(e, t) {
		if (typeof e != "function") throw Error(i(191, e));
		e.call(t);
	}
	function za(e, t) {
		var n = e.callbacks;
		if (n !== null) for (e.callbacks = null, e = 0; e < n.length; e++) Ra(n[e], t);
	}
	var Ba = R(null), Va = R(0);
	function Ha(e, t) {
		e = Hl, te(Va, e), te(Ba, t), Hl = e | t.baseLanes;
	}
	function Ua() {
		te(Va, Hl), te(Ba, Ba.current);
	}
	function Wa() {
		Hl = Va.current, z(Ba), z(Va);
	}
	var Ga = R(null), Ka = null;
	function qa(e) {
		var t = e.alternate;
		te(Qa, Qa.current & 1), te(Ga, e), Ka === null && (t === null || Ba.current !== null || t.memoizedState !== null) && (Ka = e);
	}
	function Ja(e) {
		te(Qa, Qa.current), te(Ga, e), Ka === null && (Ka = e);
	}
	function Ya(e) {
		e.tag === 22 ? (te(Qa, Qa.current), te(Ga, e), Ka === null && (Ka = e)) : Xa(e);
	}
	function Xa() {
		te(Qa, Qa.current), te(Ga, Ga.current);
	}
	function Za(e) {
		z(Ga), Ka === e && (Ka = null), z(Qa);
	}
	var Qa = R(0);
	function $a(e) {
		for (var t = e; t !== null;) {
			if (t.tag === 13) {
				var n = t.memoizedState;
				if (n !== null && (n = n.dehydrated, n === null || of(n) || sf(n))) return t;
			} else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
				if (t.flags & 128) return t;
			} else if (t.child !== null) {
				t.child.return = t, t = t.child;
				continue;
			}
			if (t === e) break;
			for (; t.sibling === null;) {
				if (t.return === null || t.return === e) return null;
				t = t.return;
			}
			t.sibling.return = t.return, t = t.sibling;
		}
		return null;
	}
	var eo = 0, to = null, no = null, ro = null, io = !1, ao = !1, oo = !1, so = 0, co = 0, lo = null, uo = 0;
	function fo() {
		throw Error(i(321));
	}
	function po(e, t) {
		if (t === null) return !1;
		for (var n = 0; n < t.length && n < e.length; n++) if (!pr(e[n], t[n])) return !1;
		return !0;
	}
	function mo(e, t, n, r, i, a) {
		return eo = a, to = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, P.H = e === null || e.memoizedState === null ? js : Ms, oo = !1, a = n(r, i), oo = !1, ao && (a = go(t, n, r, i)), ho(e), a;
	}
	function ho(e) {
		P.H = As;
		var t = no !== null && no.next !== null;
		if (eo = 0, ro = no = to = null, io = !1, co = 0, lo = null, t) throw Error(i(300));
		e === null || Ys || (e = e.dependencies, e !== null && Ui(e) && (Ys = !0));
	}
	function go(e, t, n, r) {
		to = e;
		var a = 0;
		do {
			if (ao && (lo = null), co = 0, ao = !1, 25 <= a) throw Error(i(301));
			if (a += 1, ro = no = null, e.updateQueue != null) {
				var o = e.updateQueue;
				o.lastEffect = null, o.events = null, o.stores = null, o.memoCache != null && (o.memoCache.index = 0);
			}
			P.H = Ns, o = t(n, r);
		} while (ao);
		return o;
	}
	function _o() {
		var e = P.H, t = e.useState()[0];
		return t = typeof t.then == "function" ? wo(t) : t, e = e.useState()[0], (no === null ? null : no.memoizedState) !== e && (to.flags |= 1024), t;
	}
	function vo() {
		var e = so !== 0;
		return so = 0, e;
	}
	function yo(e, t, n) {
		t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
	}
	function bo(e) {
		if (io) {
			for (e = e.memoizedState; e !== null;) {
				var t = e.queue;
				t !== null && (t.pending = null), e = e.next;
			}
			io = !1;
		}
		eo = 0, ro = no = to = null, ao = !1, co = so = 0, lo = null;
	}
	function xo() {
		var e = {
			memoizedState: null,
			baseState: null,
			baseQueue: null,
			queue: null,
			next: null
		};
		return ro === null ? to.memoizedState = ro = e : ro = ro.next = e, ro;
	}
	function So() {
		if (no === null) {
			var e = to.alternate;
			e = e === null ? null : e.memoizedState;
		} else e = no.next;
		var t = ro === null ? to.memoizedState : ro.next;
		if (t !== null) ro = t, no = e;
		else {
			if (e === null) throw to.alternate === null ? Error(i(467)) : Error(i(310));
			no = e, e = {
				memoizedState: no.memoizedState,
				baseState: no.baseState,
				baseQueue: no.baseQueue,
				queue: no.queue,
				next: null
			}, ro === null ? to.memoizedState = ro = e : ro = ro.next = e;
		}
		return ro;
	}
	function Co() {
		return {
			lastEffect: null,
			events: null,
			stores: null,
			memoCache: null
		};
	}
	function wo(e) {
		var t = co;
		return co += 1, lo === null && (lo = []), e = ha(lo, e, t), t = to, (ro === null ? t.memoizedState : ro.next) === null && (t = t.alternate, P.H = t === null || t.memoizedState === null ? js : Ms), e;
	}
	function To(e) {
		if (typeof e == "object" && e) {
			if (typeof e.then == "function") return wo(e);
			if (e.$$typeof === x) return Gi(e);
		}
		throw Error(i(438, String(e)));
	}
	function Eo(e) {
		var t = null, n = to.updateQueue;
		if (n !== null && (t = n.memoCache), t == null) {
			var r = to.alternate;
			r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
				data: r.data.map(function(e) {
					return e.slice();
				}),
				index: 0
			})));
		}
		if (t ??= {
			data: [],
			index: 0
		}, n === null && (n = Co(), to.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0) for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = O;
		return t.index++, n;
	}
	function Do(e, t) {
		return typeof t == "function" ? t(e) : t;
	}
	function Oo(e) {
		return ko(So(), no, e);
	}
	function ko(e, t, n) {
		var r = e.queue;
		if (r === null) throw Error(i(311));
		r.lastRenderedReducer = n;
		var a = e.baseQueue, o = r.pending;
		if (o !== null) {
			if (a !== null) {
				var s = a.next;
				a.next = o.next, o.next = s;
			}
			t.baseQueue = a = o, r.pending = null;
		}
		if (o = e.baseState, a === null) e.memoizedState = o;
		else {
			t = a.next;
			var c = s = null, l = null, u = t, d = !1;
			do {
				var f = u.lane & -536870913;
				if (f === u.lane ? (eo & f) === f : (Il & f) === f) {
					var p = u.revertLane;
					if (p === 0) l !== null && (l = l.next = {
						lane: 0,
						revertLane: 0,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}), f === X && (d = !0);
					else if ((eo & p) === p) {
						u = u.next, p === X && (d = !0);
						continue;
					} else f = {
						lane: 0,
						revertLane: u.revertLane,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}, l === null ? (c = l = f, s = o) : l = l.next = f, to.lanes |= p, Wl |= p;
					f = u.action, oo && n(o, f), o = u.hasEagerState ? u.eagerState : n(o, f);
				} else p = {
					lane: f,
					revertLane: u.revertLane,
					gesture: u.gesture,
					action: u.action,
					hasEagerState: u.hasEagerState,
					eagerState: u.eagerState,
					next: null
				}, l === null ? (c = l = p, s = o) : l = l.next = p, to.lanes |= f, Wl |= f;
				u = u.next;
			} while (u !== null && u !== t);
			if (l === null ? s = o : l.next = c, !pr(o, e.memoizedState) && (Ys = !0, d && (n = ta, n !== null))) throw n;
			e.memoizedState = o, e.baseState = s, e.baseQueue = l, r.lastRenderedState = o;
		}
		return a === null && (r.lanes = 0), [e.memoizedState, r.dispatch];
	}
	function Ao(e) {
		var t = So(), n = t.queue;
		if (n === null) throw Error(i(311));
		n.lastRenderedReducer = e;
		var r = n.dispatch, a = n.pending, o = t.memoizedState;
		if (a !== null) {
			n.pending = null;
			var s = a = a.next;
			do
				o = e(o, s.action), s = s.next;
			while (s !== a);
			pr(o, t.memoizedState) || (Ys = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
		}
		return [o, r];
	}
	function jo(e, t, n) {
		var r = to, a = So(), o = wi;
		if (o) {
			if (n === void 0) throw Error(i(407));
			n = n();
		} else n = t();
		var s = !pr((no || a).memoizedState, n);
		if (s && (a.memoizedState = n, Ys = !0), a = a.queue, ns(Po.bind(null, r, a, e), [e]), a.getSnapshot !== t || s || ro !== null && ro.memoizedState.tag & 1) {
			if (r.flags |= 2048, Zo(9, { destroy: void 0 }, No.bind(null, r, a, n, t), null), Pl === null) throw Error(i(349));
			o || eo & 127 || Mo(r, t, n);
		}
		return n;
	}
	function Mo(e, t, n) {
		e.flags |= 16384, e = {
			getSnapshot: t,
			value: n
		}, t = to.updateQueue, t === null ? (t = Co(), to.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
	}
	function No(e, t, n, r) {
		t.value = n, t.getSnapshot = r, Fo(t) && Io(e);
	}
	function Po(e, t, n) {
		return n(function() {
			Fo(t) && Io(e);
		});
	}
	function Fo(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !pr(e, n);
		} catch {
			return !0;
		}
	}
	function Io(e) {
		var t = qr(e, 2);
		t !== null && mu(t, e, 2);
	}
	function Lo(e) {
		var t = xo();
		if (typeof e == "function") {
			var n = e;
			if (e = n(), oo) {
				ke(!0);
				try {
					n();
				} finally {
					ke(!1);
				}
			}
		}
		return t.memoizedState = t.baseState = e, t.queue = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: Do,
			lastRenderedState: e
		}, t;
	}
	function Ro(e, t, n, r) {
		return e.baseState = n, ko(e, no, typeof r == "function" ? r : Do);
	}
	function zo(e, t, n, r, a) {
		if (Ds(e)) throw Error(i(485));
		if (e = t.action, e !== null) {
			var o = {
				payload: a,
				action: e,
				next: null,
				isTransition: !0,
				status: "pending",
				value: null,
				reason: null,
				listeners: [],
				then: function(e) {
					o.listeners.push(e);
				}
			};
			P.T === null ? o.isTransition = !1 : n(!0), r(o), n = t.pending, n === null ? (o.next = t.pending = o, Bo(t, o)) : (o.next = n.next, t.pending = n.next = o);
		}
	}
	function Bo(e, t) {
		var n = t.action, r = t.payload, i = e.state;
		if (t.isTransition) {
			var a = P.T, o = {};
			P.T = o;
			try {
				var s = n(i, r), c = P.S;
				c !== null && c(o, s), Vo(e, t, s);
			} catch (n) {
				Uo(e, t, n);
			} finally {
				a !== null && o.types !== null && (a.types = o.types), P.T = a;
			}
		} else try {
			a = n(i, r), Vo(e, t, a);
		} catch (n) {
			Uo(e, t, n);
		}
	}
	function Vo(e, t, n) {
		typeof n == "object" && n && typeof n.then == "function" ? n.then(function(n) {
			Ho(e, t, n);
		}, function(n) {
			return Uo(e, t, n);
		}) : Ho(e, t, n);
	}
	function Ho(e, t, n) {
		t.status = "fulfilled", t.value = n, Wo(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, Bo(e, n)));
	}
	function Uo(e, t, n) {
		var r = e.pending;
		if (e.pending = null, r !== null) {
			r = r.next;
			do
				t.status = "rejected", t.reason = n, Wo(t), t = t.next;
			while (t !== r);
		}
		e.action = null;
	}
	function Wo(e) {
		e = e.listeners;
		for (var t = 0; t < e.length; t++) (0, e[t])();
	}
	function Go(e, t) {
		return t;
	}
	function Ko(e, t) {
		if (wi) {
			var n = Pl.formState;
			if (n !== null) {
				a: {
					var r = to;
					if (wi) {
						if (Ci) {
							b: {
								for (var i = Ci, a = Ei; i.nodeType !== 8;) {
									if (!a) {
										i = null;
										break b;
									}
									if (i = lf(i.nextSibling), i === null) {
										i = null;
										break b;
									}
								}
								a = i.data, i = a === "F!" || a === "F" ? i : null;
							}
							if (i) {
								Ci = lf(i.nextSibling), r = i.data === "F!";
								break a;
							}
						}
						Oi(r);
					}
					r = !1;
				}
				r && (t = n[0]);
			}
		}
		return n = xo(), n.memoizedState = n.baseState = t, r = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: Go,
			lastRenderedState: t
		}, n.queue = r, n = ws.bind(null, to, r), r.dispatch = n, r = Lo(!1), a = Es.bind(null, to, !1, r.queue), r = xo(), i = {
			state: t,
			dispatch: null,
			action: e,
			pending: null
		}, r.queue = i, n = zo.bind(null, to, i, a, n), i.dispatch = n, r.memoizedState = e, [
			t,
			n,
			!1
		];
	}
	function qo(e) {
		return Jo(So(), no, e);
	}
	function Jo(e, t, n) {
		if (t = ko(e, t, Go)[0], e = Oo(Do)[0], typeof t == "object" && t && typeof t.then == "function") try {
			var r = wo(t);
		} catch (e) {
			throw e === ua ? fa : e;
		}
		else r = t;
		t = So();
		var i = t.queue, a = i.dispatch;
		return n !== t.memoizedState && (to.flags |= 2048, Zo(9, { destroy: void 0 }, Yo.bind(null, i, n), null)), [
			r,
			a,
			e
		];
	}
	function Yo(e, t) {
		e.action = t;
	}
	function Xo(e) {
		var t = So(), n = no;
		if (n !== null) return Jo(t, n, e);
		So(), t = t.memoizedState, n = So();
		var r = n.queue.dispatch;
		return n.memoizedState = e, [
			t,
			r,
			!1
		];
	}
	function Zo(e, t, n, r) {
		return e = {
			tag: e,
			create: n,
			deps: r,
			inst: t,
			next: null
		}, t = to.updateQueue, t === null && (t = Co(), to.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
	}
	function Qo() {
		return So().memoizedState;
	}
	function $o(e, t, n, r) {
		var i = xo();
		to.flags |= e, i.memoizedState = Zo(1 | t, { destroy: void 0 }, n, r === void 0 ? null : r);
	}
	function es(e, t, n, r) {
		var i = So();
		r = r === void 0 ? null : r;
		var a = i.memoizedState.inst;
		no !== null && r !== null && po(r, no.memoizedState.deps) ? i.memoizedState = Zo(t, a, n, r) : (to.flags |= e, i.memoizedState = Zo(1 | t, a, n, r));
	}
	function ts(e, t) {
		$o(8390656, 8, e, t);
	}
	function ns(e, t) {
		es(2048, 8, e, t);
	}
	function rs(e) {
		to.flags |= 4;
		var t = to.updateQueue;
		if (t === null) t = Co(), to.updateQueue = t, t.events = [e];
		else {
			var n = t.events;
			n === null ? t.events = [e] : n.push(e);
		}
	}
	function is(e) {
		var t = So().memoizedState;
		return rs({
			ref: t,
			nextImpl: e
		}), function() {
			if (Nl & 2) throw Error(i(440));
			return t.impl.apply(void 0, arguments);
		};
	}
	function as(e, t) {
		return es(4, 2, e, t);
	}
	function os(e, t) {
		return es(4, 4, e, t);
	}
	function ss(e, t) {
		if (typeof t == "function") {
			e = e();
			var n = t(e);
			return function() {
				typeof n == "function" ? n() : t(null);
			};
		}
		if (t != null) return e = e(), t.current = e, function() {
			t.current = null;
		};
	}
	function cs(e, t, n) {
		n = n == null ? null : n.concat([e]), es(4, 4, ss.bind(null, t, e), n);
	}
	function ls() {}
	function us(e, t) {
		var n = So();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		return t !== null && po(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
	}
	function ds(e, t) {
		var n = So();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		if (t !== null && po(t, r[1])) return r[0];
		if (r = e(), oo) {
			ke(!0);
			try {
				e();
			} finally {
				ke(!1);
			}
		}
		return n.memoizedState = [r, t], r;
	}
	function fs(e, t, n) {
		return n === void 0 || eo & 1073741824 && !(Il & 261930) ? e.memoizedState = t : (e.memoizedState = n, e = pu(), to.lanes |= e, Wl |= e, n);
	}
	function ps(e, t, n, r) {
		return pr(n, t) ? n : Ba.current === null ? !(eo & 42) || eo & 1073741824 && !(Il & 261930) ? (Ys = !0, e.memoizedState = n) : (e = pu(), to.lanes |= e, Wl |= e, t) : (e = fs(e, n, r), pr(e, t) || (Ys = !0), e);
	}
	function ms(e, t, n, r, i) {
		var a = F.p;
		F.p = a !== 0 && 8 > a ? a : 8;
		var o = P.T, s = {};
		P.T = s, Es(e, !1, t, n);
		try {
			var c = i(), l = P.S;
			l !== null && l(s, c), typeof c == "object" && c && typeof c.then == "function" ? Ts(e, t, ia(c, r), fu(e)) : Ts(e, t, r, fu(e));
		} catch (n) {
			Ts(e, t, {
				then: function() {},
				status: "rejected",
				reason: n
			}, fu());
		} finally {
			F.p = a, o !== null && s.types !== null && (o.types = s.types), P.T = o;
		}
	}
	function hs() {}
	function gs(e, t, n, r) {
		if (e.tag !== 5) throw Error(i(476));
		var a = _s(e).queue;
		ms(e, a, t, I, n === null ? hs : function() {
			return vs(e), n(r);
		});
	}
	function _s(e) {
		var t = e.memoizedState;
		if (t !== null) return t;
		t = {
			memoizedState: I,
			baseState: I,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: Do,
				lastRenderedState: I
			},
			next: null
		};
		var n = {};
		return t.next = {
			memoizedState: n,
			baseState: n,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: Do,
				lastRenderedState: n
			},
			next: null
		}, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
	}
	function vs(e) {
		var t = _s(e);
		t.next === null && (t = e.alternate.memoizedState), Ts(e, t.next.queue, {}, fu());
	}
	function ys() {
		return Gi(Qf);
	}
	function bs() {
		return So().memoizedState;
	}
	function xs() {
		return So().memoizedState;
	}
	function Ss(e) {
		for (var t = e.return; t !== null;) {
			switch (t.tag) {
				case 24:
				case 3:
					var n = fu();
					e = ja(n);
					var r = Ma(t, e, n);
					r !== null && (mu(r, t, n), Na(r, t, n)), t = { cache: Qi() }, e.payload = t;
					return;
			}
			t = t.return;
		}
	}
	function Cs(e, t, n) {
		var r = fu();
		n = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Ds(e) ? Os(t, n) : (n = Kr(e, t, n, r), n !== null && (mu(n, e, r), ks(n, t, r)));
	}
	function ws(e, t, n) {
		Ts(e, t, n, fu());
	}
	function Ts(e, t, n, r) {
		var i = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		};
		if (Ds(e)) Os(t, i);
		else {
			var a = e.alternate;
			if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) try {
				var o = t.lastRenderedState, s = a(o, n);
				if (i.hasEagerState = !0, i.eagerState = s, pr(s, o)) return Gr(e, t, i, 0), Pl === null && Wr(), !1;
			} catch {}
			if (n = Kr(e, t, i, r), n !== null) return mu(n, e, r), ks(n, t, r), !0;
		}
		return !1;
	}
	function Es(e, t, n, r) {
		if (r = {
			lane: 2,
			revertLane: ud(),
			gesture: null,
			action: r,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Ds(e)) {
			if (t) throw Error(i(479));
		} else t = Kr(e, n, r, 2), t !== null && mu(t, e, 2);
	}
	function Ds(e) {
		var t = e.alternate;
		return e === to || t !== null && t === to;
	}
	function Os(e, t) {
		ao = io = !0;
		var n = e.pending;
		n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
	}
	function ks(e, t, n) {
		if (n & 4194048) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, Ke(e, n);
		}
	}
	var As = {
		readContext: Gi,
		use: To,
		useCallback: fo,
		useContext: fo,
		useEffect: fo,
		useImperativeHandle: fo,
		useLayoutEffect: fo,
		useInsertionEffect: fo,
		useMemo: fo,
		useReducer: fo,
		useRef: fo,
		useState: fo,
		useDebugValue: fo,
		useDeferredValue: fo,
		useTransition: fo,
		useSyncExternalStore: fo,
		useId: fo,
		useHostTransitionStatus: fo,
		useFormState: fo,
		useActionState: fo,
		useOptimistic: fo,
		useMemoCache: fo,
		useCacheRefresh: fo
	};
	As.useEffectEvent = fo;
	var js = {
		readContext: Gi,
		use: To,
		useCallback: function(e, t) {
			return xo().memoizedState = [e, t === void 0 ? null : t], e;
		},
		useContext: Gi,
		useEffect: ts,
		useImperativeHandle: function(e, t, n) {
			n = n == null ? null : n.concat([e]), $o(4194308, 4, ss.bind(null, t, e), n);
		},
		useLayoutEffect: function(e, t) {
			return $o(4194308, 4, e, t);
		},
		useInsertionEffect: function(e, t) {
			$o(4, 2, e, t);
		},
		useMemo: function(e, t) {
			var n = xo();
			t = t === void 0 ? null : t;
			var r = e();
			if (oo) {
				ke(!0);
				try {
					e();
				} finally {
					ke(!1);
				}
			}
			return n.memoizedState = [r, t], r;
		},
		useReducer: function(e, t, n) {
			var r = xo();
			if (n !== void 0) {
				var i = n(t);
				if (oo) {
					ke(!0);
					try {
						n(t);
					} finally {
						ke(!1);
					}
				}
			} else i = t;
			return r.memoizedState = r.baseState = i, e = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: e,
				lastRenderedState: i
			}, r.queue = e, e = e.dispatch = Cs.bind(null, to, e), [r.memoizedState, e];
		},
		useRef: function(e) {
			var t = xo();
			return e = { current: e }, t.memoizedState = e;
		},
		useState: function(e) {
			e = Lo(e);
			var t = e.queue, n = ws.bind(null, to, t);
			return t.dispatch = n, [e.memoizedState, n];
		},
		useDebugValue: ls,
		useDeferredValue: function(e, t) {
			return fs(xo(), e, t);
		},
		useTransition: function() {
			var e = Lo(!1);
			return e = ms.bind(null, to, e.queue, !0, !1), xo().memoizedState = e, [!1, e];
		},
		useSyncExternalStore: function(e, t, n) {
			var r = to, a = xo();
			if (wi) {
				if (n === void 0) throw Error(i(407));
				n = n();
			} else {
				if (n = t(), Pl === null) throw Error(i(349));
				Il & 127 || Mo(r, t, n);
			}
			a.memoizedState = n;
			var o = {
				value: n,
				getSnapshot: t
			};
			return a.queue = o, ts(Po.bind(null, r, o, e), [e]), r.flags |= 2048, Zo(9, { destroy: void 0 }, No.bind(null, r, o, n, t), null), n;
		},
		useId: function() {
			var e = xo(), t = Pl.identifierPrefix;
			if (wi) {
				var n = gi, r = hi;
				n = (r & ~(1 << 32 - Ae(r) - 1)).toString(32) + n, t = "_" + t + "R_" + n, n = so++, 0 < n && (t += "H" + n.toString(32)), t += "_";
			} else n = uo++, t = "_" + t + "r_" + n.toString(32) + "_";
			return e.memoizedState = t;
		},
		useHostTransitionStatus: ys,
		useFormState: Ko,
		useActionState: Ko,
		useOptimistic: function(e) {
			var t = xo();
			t.memoizedState = t.baseState = e;
			var n = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: null,
				lastRenderedState: null
			};
			return t.queue = n, t = Es.bind(null, to, !0, n), n.dispatch = t, [e, t];
		},
		useMemoCache: Eo,
		useCacheRefresh: function() {
			return xo().memoizedState = Ss.bind(null, to);
		},
		useEffectEvent: function(e) {
			var t = xo(), n = { impl: e };
			return t.memoizedState = n, function() {
				if (Nl & 2) throw Error(i(440));
				return n.impl.apply(void 0, arguments);
			};
		}
	}, Ms = {
		readContext: Gi,
		use: To,
		useCallback: us,
		useContext: Gi,
		useEffect: ns,
		useImperativeHandle: cs,
		useInsertionEffect: as,
		useLayoutEffect: os,
		useMemo: ds,
		useReducer: Oo,
		useRef: Qo,
		useState: function() {
			return Oo(Do);
		},
		useDebugValue: ls,
		useDeferredValue: function(e, t) {
			return ps(So(), no.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Oo(Do)[0], t = So().memoizedState;
			return [typeof e == "boolean" ? e : wo(e), t];
		},
		useSyncExternalStore: jo,
		useId: bs,
		useHostTransitionStatus: ys,
		useFormState: qo,
		useActionState: qo,
		useOptimistic: function(e, t) {
			return Ro(So(), no, e, t);
		},
		useMemoCache: Eo,
		useCacheRefresh: xs
	};
	Ms.useEffectEvent = is;
	var Ns = {
		readContext: Gi,
		use: To,
		useCallback: us,
		useContext: Gi,
		useEffect: ns,
		useImperativeHandle: cs,
		useInsertionEffect: as,
		useLayoutEffect: os,
		useMemo: ds,
		useReducer: Ao,
		useRef: Qo,
		useState: function() {
			return Ao(Do);
		},
		useDebugValue: ls,
		useDeferredValue: function(e, t) {
			var n = So();
			return no === null ? fs(n, e, t) : ps(n, no.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Ao(Do)[0], t = So().memoizedState;
			return [typeof e == "boolean" ? e : wo(e), t];
		},
		useSyncExternalStore: jo,
		useId: bs,
		useHostTransitionStatus: ys,
		useFormState: Xo,
		useActionState: Xo,
		useOptimistic: function(e, t) {
			var n = So();
			return no === null ? (n.baseState = e, [e, n.queue.dispatch]) : Ro(n, no, e, t);
		},
		useMemoCache: Eo,
		useCacheRefresh: xs
	};
	Ns.useEffectEvent = is;
	function Ps(e, t, n, r) {
		t = e.memoizedState, n = n(r, t), n = n == null ? t : f({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
	}
	var Fs = {
		enqueueSetState: function(e, t, n) {
			e = e._reactInternals;
			var r = fu(), i = ja(r);
			i.payload = t, n != null && (i.callback = n), t = Ma(e, i, r), t !== null && (mu(t, e, r), Na(t, e, r));
		},
		enqueueReplaceState: function(e, t, n) {
			e = e._reactInternals;
			var r = fu(), i = ja(r);
			i.tag = 1, i.payload = t, n != null && (i.callback = n), t = Ma(e, i, r), t !== null && (mu(t, e, r), Na(t, e, r));
		},
		enqueueForceUpdate: function(e, t) {
			e = e._reactInternals;
			var n = fu(), r = ja(n);
			r.tag = 2, t != null && (r.callback = t), t = Ma(e, r, n), t !== null && (mu(t, e, n), Na(t, e, n));
		}
	};
	function Is(e, t, n, r, i, a, o) {
		return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, a, o) : t.prototype && t.prototype.isPureReactComponent ? !mr(n, r) || !mr(i, a) : !0;
	}
	function Ls(e, t, n, r) {
		e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Fs.enqueueReplaceState(t, t.state, null);
	}
	function Rs(e, t) {
		var n = t;
		if ("ref" in t) for (var r in n = {}, t) r !== "ref" && (n[r] = t[r]);
		if (e = e.defaultProps) for (var i in n === t && (n = f({}, n)), e) n[i] === void 0 && (n[i] = e[i]);
		return n;
	}
	function zs(e) {
		Br(e);
	}
	function Bs(e) {
		console.error(e);
	}
	function Vs(e) {
		Br(e);
	}
	function Hs(e, t) {
		try {
			var n = e.onUncaughtError;
			n(t.value, { componentStack: t.stack });
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function Us(e, t, n) {
		try {
			var r = e.onCaughtError;
			r(n.value, {
				componentStack: n.stack,
				errorBoundary: t.tag === 1 ? t.stateNode : null
			});
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function Ws(e, t, n) {
		return n = ja(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
			Hs(e, t);
		}, n;
	}
	function Gs(e) {
		return e = ja(e), e.tag = 3, e;
	}
	function Ks(e, t, n, r) {
		var i = n.type.getDerivedStateFromError;
		if (typeof i == "function") {
			var a = r.value;
			e.payload = function() {
				return i(a);
			}, e.callback = function() {
				Us(t, n, r);
			};
		}
		var o = n.stateNode;
		o !== null && typeof o.componentDidCatch == "function" && (e.callback = function() {
			Us(t, n, r), typeof i != "function" && (nu === null ? nu = new Set([this]) : nu.add(this));
			var e = r.stack;
			this.componentDidCatch(r.value, { componentStack: e === null ? "" : e });
		});
	}
	function qs(e, t, n, r, a) {
		if (n.flags |= 32768, typeof r == "object" && r && typeof r.then == "function") {
			if (t = n.alternate, t !== null && Hi(t, n, a, !0), n = Ga.current, n !== null) {
				switch (n.tag) {
					case 31:
					case 13: return Ka === null ? Eu() : n.alternate === null && Ul === 0 && (Ul = 3), n.flags &= -257, n.flags |= 65536, n.lanes = a, r === pa ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = new Set([r]) : t.add(r), Gu(e, r, a)), !1;
					case 22: return n.flags |= 65536, r === pa ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
						transitions: null,
						markerInstances: null,
						retryQueue: new Set([r])
					}, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = new Set([r]) : n.add(r)), Gu(e, r, a)), !1;
				}
				throw Error(i(435, n.tag));
			}
			return Gu(e, r, a), Eu(), !1;
		}
		if (wi) return t = Ga.current, t === null ? (r !== Di && (t = Error(i(423), { cause: r }), Pi(si(t, n))), e = e.current.alternate, e.flags |= 65536, a &= -a, e.lanes |= a, r = si(r, n), a = Ws(e.stateNode, r, a), Pa(e, a), Ul !== 4 && (Ul = 2)) : (!(t.flags & 65536) && (t.flags |= 256), t.flags |= 65536, t.lanes = a, r !== Di && (e = Error(i(422), { cause: r }), Pi(si(e, n)))), !1;
		var o = Error(i(520), { cause: r });
		if (o = si(o, n), Yl === null ? Yl = [o] : Yl.push(o), Ul !== 4 && (Ul = 2), t === null) return !0;
		r = si(r, n), n = t;
		do {
			switch (n.tag) {
				case 3: return n.flags |= 65536, e = a & -a, n.lanes |= e, e = Ws(n.stateNode, r, e), Pa(n, e), !1;
				case 1: if (t = n.type, o = n.stateNode, !(n.flags & 128) && (typeof t.getDerivedStateFromError == "function" || o !== null && typeof o.componentDidCatch == "function" && (nu === null || !nu.has(o)))) return n.flags |= 65536, a &= -a, n.lanes |= a, a = Gs(a), Ks(a, e, n, r), Pa(n, a), !1;
			}
			n = n.return;
		} while (n !== null);
		return !1;
	}
	var Js = Error(i(461)), Ys = !1;
	function Xs(e, t, n, r) {
		t.child = e === null ? Da(t, null, n, r) : Ea(t, e.child, n, r);
	}
	function Zs(e, t, n, r, i) {
		n = n.render;
		var a = t.ref;
		if ("ref" in r) {
			var o = {};
			for (var s in r) s !== "ref" && (o[s] = r[s]);
		} else o = r;
		return Wi(t), r = mo(e, t, n, o, a, i), s = vo(), e !== null && !Ys ? (yo(e, t, i), xc(e, t, i)) : (wi && s && yi(t), t.flags |= 1, Xs(e, t, r, i), t.child);
	}
	function Qs(e, t, n, r, i) {
		if (e === null) {
			var a = n.type;
			return typeof a == "function" && !$r(a) && a.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = a, $s(e, t, a, r, i)) : (e = J(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
		}
		if (a = e.child, !Sc(e, i)) {
			var o = a.memoizedProps;
			if (n = n.compare, n = n === null ? mr : n, n(o, r) && e.ref === t.ref) return xc(e, t, i);
		}
		return t.flags |= 1, e = ei(a, r), e.ref = t.ref, e.return = t, t.child = e;
	}
	function $s(e, t, n, r, i) {
		if (e !== null) {
			var a = e.memoizedProps;
			if (mr(a, r) && e.ref === t.ref) if (Ys = !1, t.pendingProps = r = a, Sc(e, i)) e.flags & 131072 && (Ys = !0);
			else return t.lanes = e.lanes, xc(e, t, i);
		}
		return sc(e, t, n, r, i);
	}
	function ec(e, t, n, r) {
		var i = r.children, a = e === null ? null : e.memoizedState;
		if (e === null && t.stateNode === null && (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), r.mode === "hidden") {
			if (t.flags & 128) {
				if (a = a === null ? n : a.baseLanes | n, e !== null) {
					for (r = t.child = e.child, i = 0; r !== null;) i = i | r.lanes | r.childLanes, r = r.sibling;
					r = i & ~a;
				} else r = 0, t.child = null;
				return nc(e, t, a, n, r);
			}
			if (n & 536870912) t.memoizedState = {
				baseLanes: 0,
				cachePool: null
			}, e !== null && ca(t, a === null ? null : a.cachePool), a === null ? Ua() : Ha(t, a), Ya(t);
			else return r = t.lanes = 536870912, nc(e, t, a === null ? n : a.baseLanes | n, n, r);
		} else a === null ? (e !== null && ca(t, null), Ua(), Xa(t)) : (ca(t, a.cachePool), Ha(t, a), Xa(t), t.memoizedState = null);
		return Xs(e, t, i, n), t.child;
	}
	function tc(e, t) {
		return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), t.sibling;
	}
	function nc(e, t, n, r, i) {
		var a = sa();
		return a = a === null ? null : {
			parent: Zi._currentValue,
			pool: a
		}, t.memoizedState = {
			baseLanes: n,
			cachePool: a
		}, e !== null && ca(t, null), Ua(), Ya(t), e !== null && Hi(e, t, r, !0), t.childLanes = i, null;
	}
	function rc(e, t) {
		return t = gc({
			mode: t.mode,
			children: t.children
		}, e.mode), t.ref = e.ref, e.child = t, t.return = e, t;
	}
	function ic(e, t, n) {
		return Ea(t, e.child, null, n), e = rc(t, t.pendingProps), e.flags |= 2, Za(t), t.memoizedState = null, e;
	}
	function ac(e, t, n) {
		var r = t.pendingProps, a = (t.flags & 128) != 0;
		if (t.flags &= -129, e === null) {
			if (wi) {
				if (r.mode === "hidden") return e = rc(t, r), t.lanes = 536870912, tc(null, e);
				if (Ja(t), (e = Ci) ? (e = af(e, Ei), e = e !== null && e.data === "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: mi === null ? null : {
						id: hi,
						overflow: gi
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = ii(e), n.return = t, t.child = n, Si = t, Ci = null)) : e = null, e === null) throw Oi(t);
				return t.lanes = 536870912, null;
			}
			return rc(t, r);
		}
		var o = e.memoizedState;
		if (o !== null) {
			var s = o.dehydrated;
			if (Ja(t), a) if (t.flags & 256) t.flags &= -257, t = ic(e, t, n);
			else if (t.memoizedState !== null) t.child = e.child, t.flags |= 128, t = null;
			else throw Error(i(558));
			else if (Ys || Hi(e, t, n, !1), a = (n & e.childLanes) !== 0, Ys || a) {
				if (r = Pl, r !== null && (s = qe(r, n), s !== 0 && s !== o.retryLane)) throw o.retryLane = s, qr(e, s), mu(r, e, s), Js;
				Eu(), t = ic(e, t, n);
			} else e = o.treeContext, Ci = lf(s.nextSibling), Si = t, wi = !0, Ti = null, Ei = !1, e !== null && xi(t, e), t = rc(t, r), t.flags |= 4096;
			return t;
		}
		return e = ei(e.child, {
			mode: r.mode,
			children: r.children
		}), e.ref = t.ref, t.child = e, e.return = t, e;
	}
	function oc(e, t) {
		var n = t.ref;
		if (n === null) e !== null && e.ref !== null && (t.flags |= 4194816);
		else {
			if (typeof n != "function" && typeof n != "object") throw Error(i(284));
			(e === null || e.ref !== n) && (t.flags |= 4194816);
		}
	}
	function sc(e, t, n, r, i) {
		return Wi(t), n = mo(e, t, n, r, void 0, i), r = vo(), e !== null && !Ys ? (yo(e, t, i), xc(e, t, i)) : (wi && r && yi(t), t.flags |= 1, Xs(e, t, n, i), t.child);
	}
	function cc(e, t, n, r, i, a) {
		return Wi(t), t.updateQueue = null, n = go(t, r, n, i), ho(e), r = vo(), e !== null && !Ys ? (yo(e, t, a), xc(e, t, a)) : (wi && r && yi(t), t.flags |= 1, Xs(e, t, n, a), t.child);
	}
	function lc(e, t, n, r, i) {
		if (Wi(t), t.stateNode === null) {
			var a = Xr, o = n.contextType;
			typeof o == "object" && o && (a = Gi(o)), a = new n(r, a), t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = Fs, t.stateNode = a, a._reactInternals = t, a = t.stateNode, a.props = r, a.state = t.memoizedState, a.refs = {}, ka(t), o = n.contextType, a.context = typeof o == "object" && o ? Gi(o) : Xr, a.state = t.memoizedState, o = n.getDerivedStateFromProps, typeof o == "function" && (Ps(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof a.getSnapshotBeforeUpdate == "function" || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (o = a.state, typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), o !== a.state && Fs.enqueueReplaceState(a, a.state, null), La(t, r, a, i), Ia(), a.state = t.memoizedState), typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !0;
		} else if (e === null) {
			a = t.stateNode;
			var s = t.memoizedProps, c = Rs(n, s);
			a.props = c;
			var l = a.context, u = n.contextType;
			o = Xr, typeof u == "object" && u && (o = Gi(u));
			var d = n.getDerivedStateFromProps;
			u = typeof d == "function" || typeof a.getSnapshotBeforeUpdate == "function", s = t.pendingProps !== s, u || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s || l !== o) && Ls(t, a, r, o), Oa = !1;
			var f = t.memoizedState;
			a.state = f, La(t, r, a, i), Ia(), l = t.memoizedState, s || f !== l || Oa ? (typeof d == "function" && (Ps(t, n, d, r), l = t.memoizedState), (c = Oa || Is(t, n, c, r, f, l, o)) ? (u || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = o, r = c) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
		} else {
			a = t.stateNode, Aa(e, t), o = t.memoizedProps, u = Rs(n, o), a.props = u, d = t.pendingProps, f = a.context, l = n.contextType, c = Xr, typeof l == "object" && l && (c = Gi(l)), s = n.getDerivedStateFromProps, (l = typeof s == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (o !== d || f !== c) && Ls(t, a, r, c), Oa = !1, f = t.memoizedState, a.state = f, La(t, r, a, i), Ia();
			var p = t.memoizedState;
			o !== d || f !== p || Oa || e !== null && e.dependencies !== null && Ui(e.dependencies) ? (typeof s == "function" && (Ps(t, n, s, r), p = t.memoizedState), (u = Oa || Is(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && Ui(e.dependencies)) ? (l || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, p, c), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, p, c)), typeof a.componentDidUpdate == "function" && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = c, r = u) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
		}
		return a = r, oc(e, t), r = (t.flags & 128) != 0, a || r ? (a = t.stateNode, n = r && typeof n.getDerivedStateFromError != "function" ? null : a.render(), t.flags |= 1, e !== null && r ? (t.child = Ea(t, e.child, null, i), t.child = Ea(t, null, n, i)) : Xs(e, t, n, i), t.memoizedState = a.state, e = t.child) : e = xc(e, t, i), e;
	}
	function uc(e, t, n, r) {
		return Mi(), t.flags |= 256, Xs(e, t, n, r), t.child;
	}
	var dc = {
		dehydrated: null,
		treeContext: null,
		retryLane: 0,
		hydrationErrors: null
	};
	function fc(e) {
		return {
			baseLanes: e,
			cachePool: la()
		};
	}
	function pc(e, t, n) {
		return e = e === null ? 0 : e.childLanes & ~n, t && (e |= ql), e;
	}
	function mc(e, t, n) {
		var r = t.pendingProps, a = !1, o = (t.flags & 128) != 0, s;
		if ((s = o) || (s = e !== null && e.memoizedState === null ? !1 : (Qa.current & 2) != 0), s && (a = !0, t.flags &= -129), s = (t.flags & 32) != 0, t.flags &= -33, e === null) {
			if (wi) {
				if (a ? qa(t) : Xa(t), (e = Ci) ? (e = af(e, Ei), e = e !== null && e.data !== "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: mi === null ? null : {
						id: hi,
						overflow: gi
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = ii(e), n.return = t, t.child = n, Si = t, Ci = null)) : e = null, e === null) throw Oi(t);
				return sf(e) ? t.lanes = 32 : t.lanes = 536870912, null;
			}
			var c = r.children;
			return r = r.fallback, a ? (Xa(t), a = t.mode, c = gc({
				mode: "hidden",
				children: c
			}, a), r = ni(r, a, n, null), c.return = t, r.return = t, c.sibling = r, t.child = c, r = t.child, r.memoizedState = fc(n), r.childLanes = pc(e, s, n), t.memoizedState = dc, tc(null, r)) : (qa(t), hc(t, c));
		}
		var l = e.memoizedState;
		if (l !== null && (c = l.dehydrated, c !== null)) {
			if (o) t.flags & 256 ? (qa(t), t.flags &= -257, t = _c(e, t, n)) : t.memoizedState === null ? (Xa(t), c = r.fallback, a = t.mode, r = gc({
				mode: "visible",
				children: r.children
			}, a), c = ni(c, a, n, null), c.flags |= 2, r.return = t, c.return = t, r.sibling = c, t.child = r, Ea(t, e.child, null, n), r = t.child, r.memoizedState = fc(n), r.childLanes = pc(e, s, n), t.memoizedState = dc, t = tc(null, r)) : (Xa(t), t.child = e.child, t.flags |= 128, t = null);
			else if (qa(t), sf(c)) {
				if (s = c.nextSibling && c.nextSibling.dataset, s) var u = s.dgst;
				s = u, r = Error(i(419)), r.stack = "", r.digest = s, Pi({
					value: r,
					source: null,
					stack: null
				}), t = _c(e, t, n);
			} else if (Ys || Hi(e, t, n, !1), s = (n & e.childLanes) !== 0, Ys || s) {
				if (s = Pl, s !== null && (r = qe(s, n), r !== 0 && r !== l.retryLane)) throw l.retryLane = r, qr(e, r), mu(s, e, r), Js;
				of(c) || Eu(), t = _c(e, t, n);
			} else of(c) ? (t.flags |= 192, t.child = e.child, t = null) : (e = l.treeContext, Ci = lf(c.nextSibling), Si = t, wi = !0, Ti = null, Ei = !1, e !== null && xi(t, e), t = hc(t, r.children), t.flags |= 4096);
			return t;
		}
		return a ? (Xa(t), c = r.fallback, a = t.mode, l = e.child, u = l.sibling, r = ei(l, {
			mode: "hidden",
			children: r.children
		}), r.subtreeFlags = l.subtreeFlags & 65011712, u === null ? (c = ni(c, a, n, null), c.flags |= 2) : c = ei(u, c), c.return = t, r.return = t, r.sibling = c, t.child = r, tc(null, r), r = t.child, c = e.child.memoizedState, c === null ? c = fc(n) : (a = c.cachePool, a === null ? a = la() : (l = Zi._currentValue, a = a.parent === l ? a : {
			parent: l,
			pool: l
		}), c = {
			baseLanes: c.baseLanes | n,
			cachePool: a
		}), r.memoizedState = c, r.childLanes = pc(e, s, n), t.memoizedState = dc, tc(e.child, r)) : (qa(t), n = e.child, e = n.sibling, n = ei(n, {
			mode: "visible",
			children: r.children
		}), n.return = t, n.sibling = null, e !== null && (s = t.deletions, s === null ? (t.deletions = [e], t.flags |= 16) : s.push(e)), t.child = n, t.memoizedState = null, n);
	}
	function hc(e, t) {
		return t = gc({
			mode: "visible",
			children: t
		}, e.mode), t.return = e, e.child = t;
	}
	function gc(e, t) {
		return e = Qr(22, e, null, t), e.lanes = 0, e;
	}
	function _c(e, t, n) {
		return Ea(t, e.child, null, n), e = hc(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
	}
	function vc(e, t, n) {
		e.lanes |= t;
		var r = e.alternate;
		r !== null && (r.lanes |= t), Bi(e.return, t, n);
	}
	function yc(e, t, n, r, i, a) {
		var o = e.memoizedState;
		o === null ? e.memoizedState = {
			isBackwards: t,
			rendering: null,
			renderingStartTime: 0,
			last: r,
			tail: n,
			tailMode: i,
			treeForkCount: a
		} : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i, o.treeForkCount = a);
	}
	function bc(e, t, n) {
		var r = t.pendingProps, i = r.revealOrder, a = r.tail;
		r = r.children;
		var o = Qa.current, s = (o & 2) != 0;
		if (s ? (o = o & 1 | 2, t.flags |= 128) : o &= 1, te(Qa, o), Xs(e, t, r, n), r = wi ? di : 0, !s && e !== null && e.flags & 128) a: for (e = t.child; e !== null;) {
			if (e.tag === 13) e.memoizedState !== null && vc(e, n, t);
			else if (e.tag === 19) vc(e, n, t);
			else if (e.child !== null) {
				e.child.return = e, e = e.child;
				continue;
			}
			if (e === t) break a;
			for (; e.sibling === null;) {
				if (e.return === null || e.return === t) break a;
				e = e.return;
			}
			e.sibling.return = e.return, e = e.sibling;
		}
		switch (i) {
			case "forwards":
				for (n = t.child, i = null; n !== null;) e = n.alternate, e !== null && $a(e) === null && (i = n), n = n.sibling;
				n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), yc(t, !1, i, n, a, r);
				break;
			case "backwards":
			case "unstable_legacy-backwards":
				for (n = null, i = t.child, t.child = null; i !== null;) {
					if (e = i.alternate, e !== null && $a(e) === null) {
						t.child = i;
						break;
					}
					e = i.sibling, i.sibling = n, n = i, i = e;
				}
				yc(t, !0, n, null, a, r);
				break;
			case "together":
				yc(t, !1, null, null, void 0, r);
				break;
			default: t.memoizedState = null;
		}
		return t.child;
	}
	function xc(e, t, n) {
		if (e !== null && (t.dependencies = e.dependencies), Wl |= t.lanes, (n & t.childLanes) === 0) if (e !== null) {
			if (Hi(e, t, n, !1), (n & t.childLanes) === 0) return null;
		} else return null;
		if (e !== null && t.child !== e.child) throw Error(i(153));
		if (t.child !== null) {
			for (e = t.child, n = ei(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, n = n.sibling = ei(e, e.pendingProps), n.return = t;
			n.sibling = null;
		}
		return t.child;
	}
	function Sc(e, t) {
		return (e.lanes & t) === 0 ? (e = e.dependencies, !!(e !== null && Ui(e))) : !0;
	}
	function Cc(e, t, n) {
		switch (t.tag) {
			case 3:
				ie(t, t.stateNode.containerInfo), Ri(t, Zi, e.memoizedState.cache), Mi();
				break;
			case 27:
			case 5:
				oe(t);
				break;
			case 4:
				ie(t, t.stateNode.containerInfo);
				break;
			case 10:
				Ri(t, t.type, t.memoizedProps.value);
				break;
			case 31:
				if (t.memoizedState !== null) return t.flags |= 128, Ja(t), null;
				break;
			case 13:
				var r = t.memoizedState;
				if (r !== null) return r.dehydrated === null ? (n & t.child.childLanes) === 0 ? (qa(t), e = xc(e, t, n), e === null ? null : e.sibling) : mc(e, t, n) : (qa(t), t.flags |= 128, null);
				qa(t);
				break;
			case 19:
				var i = (e.flags & 128) != 0;
				if (r = (n & t.childLanes) !== 0, r ||= (Hi(e, t, n, !1), (n & t.childLanes) !== 0), i) {
					if (r) return bc(e, t, n);
					t.flags |= 128;
				}
				if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), te(Qa, Qa.current), r) break;
				return null;
			case 22: return t.lanes = 0, ec(e, t, n, t.pendingProps);
			case 24: Ri(t, Zi, e.memoizedState.cache);
		}
		return xc(e, t, n);
	}
	function wc(e, t, n) {
		if (e !== null) if (e.memoizedProps !== t.pendingProps) Ys = !0;
		else {
			if (!Sc(e, n) && !(t.flags & 128)) return Ys = !1, Cc(e, t, n);
			Ys = !!(e.flags & 131072);
		}
		else Ys = !1, wi && t.flags & 1048576 && vi(t, di, t.index);
		switch (t.lanes = 0, t.tag) {
			case 16:
				a: {
					var r = t.pendingProps;
					if (e = ga(t.elementType), t.type = e, typeof e == "function") $r(e) ? (r = Rs(e, r), t.tag = 1, t = lc(null, t, e, r, n)) : (t.tag = 0, t = sc(null, t, e, r, n));
					else {
						if (e != null) {
							var a = e.$$typeof;
							if (a === S) {
								t.tag = 11, t = Zs(null, t, e, r, n);
								break a;
							} else if (a === T) {
								t.tag = 14, t = Qs(null, t, e, r, n);
								break a;
							}
						}
						throw t = M(e) || e, Error(i(306, t, ""));
					}
				}
				return t;
			case 0: return sc(e, t, t.type, t.pendingProps, n);
			case 1: return r = t.type, a = Rs(r, t.pendingProps), lc(e, t, r, a, n);
			case 3:
				a: {
					if (ie(t, t.stateNode.containerInfo), e === null) throw Error(i(387));
					r = t.pendingProps;
					var o = t.memoizedState;
					a = o.element, Aa(e, t), La(t, r, null, n);
					var s = t.memoizedState;
					if (r = s.cache, Ri(t, Zi, r), r !== o.cache && Vi(t, [Zi], n, !0), Ia(), r = s.element, o.isDehydrated) if (o = {
						element: r,
						isDehydrated: !1,
						cache: s.cache
					}, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
						t = uc(e, t, r, n);
						break a;
					} else if (r !== a) {
						a = si(Error(i(424)), t), Pi(a), t = uc(e, t, r, n);
						break a;
					} else {
						switch (e = t.stateNode.containerInfo, e.nodeType) {
							case 9:
								e = e.body;
								break;
							default: e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
						}
						for (Ci = lf(e.firstChild), Si = t, wi = !0, Ti = null, Ei = !0, n = Da(t, null, r, n), t.child = n; n;) n.flags = n.flags & -3 | 4096, n = n.sibling;
					}
					else {
						if (Mi(), r === a) {
							t = xc(e, t, n);
							break a;
						}
						Xs(e, t, r, n);
					}
					t = t.child;
				}
				return t;
			case 26: return oc(e, t), e === null ? (n = Af(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : wi || (n = t.type, e = t.pendingProps, r = Vd(ne.current).createElement(n), r[$e] = t, r[et] = e, Fd(r, n, e), ft(r), t.stateNode = r) : t.memoizedState = Af(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null;
			case 27: return oe(t), e === null && wi && (r = t.stateNode = pf(t.type, t.pendingProps, ne.current), Si = t, Ei = !0, a = Ci, Qd(t.type) ? (uf = a, Ci = lf(r.firstChild)) : Ci = a), Xs(e, t, t.pendingProps.children, n), oc(e, t), e === null && (t.flags |= 4194304), t.child;
			case 5: return e === null && wi && ((a = r = Ci) && (r = nf(r, t.type, t.pendingProps, Ei), r === null ? a = !1 : (t.stateNode = r, Si = t, Ci = lf(r.firstChild), Ei = !1, a = !0)), a || Oi(t)), oe(t), a = t.type, o = t.pendingProps, s = e === null ? null : e.memoizedProps, r = o.children, Wd(a, o) ? r = null : s !== null && Wd(a, s) && (t.flags |= 32), t.memoizedState !== null && (a = mo(e, t, _o, null, null, n), Qf._currentValue = a), oc(e, t), Xs(e, t, r, n), t.child;
			case 6: return e === null && wi && ((e = n = Ci) && (n = rf(n, t.pendingProps, Ei), n === null ? e = !1 : (t.stateNode = n, Si = t, Ci = null, e = !0)), e || Oi(t)), null;
			case 13: return mc(e, t, n);
			case 4: return ie(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Ea(t, null, r, n) : Xs(e, t, r, n), t.child;
			case 11: return Zs(e, t, t.type, t.pendingProps, n);
			case 7: return Xs(e, t, t.pendingProps, n), t.child;
			case 8: return Xs(e, t, t.pendingProps.children, n), t.child;
			case 12: return Xs(e, t, t.pendingProps.children, n), t.child;
			case 10: return r = t.pendingProps, Ri(t, t.type, r.value), Xs(e, t, r.children, n), t.child;
			case 9: return a = t.type._context, r = t.pendingProps.children, Wi(t), a = Gi(a), r = r(a), t.flags |= 1, Xs(e, t, r, n), t.child;
			case 14: return Qs(e, t, t.type, t.pendingProps, n);
			case 15: return $s(e, t, t.type, t.pendingProps, n);
			case 19: return bc(e, t, n);
			case 31: return ac(e, t, n);
			case 22: return ec(e, t, n, t.pendingProps);
			case 24: return Wi(t), r = Gi(Zi), e === null ? (a = sa(), a === null && (a = Pl, o = Qi(), a.pooledCache = o, o.refCount++, o !== null && (a.pooledCacheLanes |= n), a = o), t.memoizedState = {
				parent: r,
				cache: a
			}, ka(t), Ri(t, Zi, a)) : ((e.lanes & n) !== 0 && (Aa(e, t), La(t, null, null, n), Ia()), a = e.memoizedState, o = t.memoizedState, a.parent === r ? (r = o.cache, Ri(t, Zi, r), r !== a.cache && Vi(t, [Zi], n, !0)) : (a = {
				parent: r,
				cache: r
			}, t.memoizedState = a, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = a), Ri(t, Zi, r))), Xs(e, t, t.pendingProps.children, n), t.child;
			case 29: throw t.pendingProps;
		}
		throw Error(i(156, t.tag));
	}
	function Tc(e) {
		e.flags |= 4;
	}
	function Ec(e, t, n, r, i) {
		if ((t = (e.mode & 32) != 0) && (t = !1), t) {
			if (e.flags |= 16777216, (i & 335544128) === i) if (e.stateNode.complete) e.flags |= 8192;
			else if (Cu()) e.flags |= 8192;
			else throw _a = pa, da;
		} else e.flags &= -16777217;
	}
	function Dc(e, t) {
		if (t.type !== "stylesheet" || t.state.loading & 4) e.flags &= -16777217;
		else if (e.flags |= 16777216, !Wf(t)) if (Cu()) e.flags |= 8192;
		else throw _a = pa, da;
	}
	function Oc(e, t) {
		t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag === 22 ? 536870912 : Ve(), e.lanes |= t, Jl |= t);
	}
	function kc(e, t) {
		if (!wi) switch (e.tailMode) {
			case "hidden":
				t = e.tail;
				for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
				n === null ? e.tail = null : n.sibling = null;
				break;
			case "collapsed":
				n = e.tail;
				for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
				r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
		}
	}
	function Ac(e) {
		var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
		if (t) for (var i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 65011712, r |= i.flags & 65011712, i.return = e, i = i.sibling;
		else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
		return e.subtreeFlags |= r, e.childLanes = n, t;
	}
	function jc(e, t, n) {
		var r = t.pendingProps;
		switch (bi(t), t.tag) {
			case 16:
			case 15:
			case 0:
			case 11:
			case 7:
			case 8:
			case 12:
			case 9:
			case 14: return Ac(t), null;
			case 1: return Ac(t), null;
			case 3: return n = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), zi(Zi), ae(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (ji(t) ? Tc(t) : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Ni())), Ac(t), null;
			case 26:
				var a = t.type, o = t.memoizedState;
				return e === null ? (Tc(t), o === null ? (Ac(t), Ec(t, a, null, r, n)) : (Ac(t), Dc(t, o))) : o ? o === e.memoizedState ? (Ac(t), t.flags &= -16777217) : (Tc(t), Ac(t), Dc(t, o)) : (e = e.memoizedProps, e !== r && Tc(t), Ac(t), Ec(t, a, e, r, n)), null;
			case 27:
				if (H(t), n = ne.current, a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Tc(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return Ac(t), null;
					}
					e = B.current, ji(t) ? ki(t, e) : (e = pf(a, r, n), t.stateNode = e, Tc(t));
				}
				return Ac(t), null;
			case 5:
				if (H(t), a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Tc(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return Ac(t), null;
					}
					if (o = B.current, ji(t)) ki(t, o);
					else {
						var s = Vd(ne.current);
						switch (o) {
							case 1:
								o = s.createElementNS("http://www.w3.org/2000/svg", a);
								break;
							case 2:
								o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
								break;
							default: switch (a) {
								case "svg":
									o = s.createElementNS("http://www.w3.org/2000/svg", a);
									break;
								case "math":
									o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
									break;
								case "script":
									o = s.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild);
									break;
								case "select":
									o = typeof r.is == "string" ? s.createElement("select", { is: r.is }) : s.createElement("select"), r.multiple ? o.multiple = !0 : r.size && (o.size = r.size);
									break;
								default: o = typeof r.is == "string" ? s.createElement(a, { is: r.is }) : s.createElement(a);
							}
						}
						o[$e] = t, o[et] = r;
						a: for (s = t.child; s !== null;) {
							if (s.tag === 5 || s.tag === 6) o.appendChild(s.stateNode);
							else if (s.tag !== 4 && s.tag !== 27 && s.child !== null) {
								s.child.return = s, s = s.child;
								continue;
							}
							if (s === t) break a;
							for (; s.sibling === null;) {
								if (s.return === null || s.return === t) break a;
								s = s.return;
							}
							s.sibling.return = s.return, s = s.sibling;
						}
						t.stateNode = o;
						a: switch (Fd(o, a, r), a) {
							case "button":
							case "input":
							case "select":
							case "textarea":
								r = !!r.autoFocus;
								break a;
							case "img":
								r = !0;
								break a;
							default: r = !1;
						}
						r && Tc(t);
					}
				}
				return Ac(t), Ec(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n), null;
			case 6:
				if (e && t.stateNode != null) e.memoizedProps !== r && Tc(t);
				else {
					if (typeof r != "string" && t.stateNode === null) throw Error(i(166));
					if (e = ne.current, ji(t)) {
						if (e = t.stateNode, n = t.memoizedProps, r = null, a = Si, a !== null) switch (a.tag) {
							case 27:
							case 5: r = a.memoizedProps;
						}
						e[$e] = t, e = !!(e.nodeValue === n || r !== null && !0 === r.suppressHydrationWarning || Md(e.nodeValue, n)), e || Oi(t, !0);
					} else e = Vd(e).createTextNode(r), e[$e] = t, t.stateNode = e;
				}
				return Ac(t), null;
			case 31:
				if (n = t.memoizedState, e === null || e.memoizedState !== null) {
					if (r = ji(t), n !== null) {
						if (e === null) {
							if (!r) throw Error(i(318));
							if (e = t.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(557));
							e[$e] = t;
						} else Mi(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						Ac(t), e = !1;
					} else n = Ni(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
					if (!e) return t.flags & 256 ? (Za(t), t) : (Za(t), null);
					if (t.flags & 128) throw Error(i(558));
				}
				return Ac(t), null;
			case 13:
				if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
					if (a = ji(t), r !== null && r.dehydrated !== null) {
						if (e === null) {
							if (!a) throw Error(i(318));
							if (a = t.memoizedState, a = a === null ? null : a.dehydrated, !a) throw Error(i(317));
							a[$e] = t;
						} else Mi(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						Ac(t), a = !1;
					} else a = Ni(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = a), a = !0;
					if (!a) return t.flags & 256 ? (Za(t), t) : (Za(t), null);
				}
				return Za(t), t.flags & 128 ? (t.lanes = n, t) : (n = r !== null, e = e !== null && e.memoizedState !== null, n && (r = t.child, a = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (a = r.alternate.memoizedState.cachePool.pool), o = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (o = r.memoizedState.cachePool.pool), o !== a && (r.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), Oc(t, t.updateQueue), Ac(t), null);
			case 4: return ae(), e === null && Sd(t.stateNode.containerInfo), Ac(t), null;
			case 10: return zi(t.type), Ac(t), null;
			case 19:
				if (z(Qa), r = t.memoizedState, r === null) return Ac(t), null;
				if (a = (t.flags & 128) != 0, o = r.rendering, o === null) if (a) kc(r, !1);
				else {
					if (Ul !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null;) {
						if (o = $a(e), o !== null) {
							for (t.flags |= 128, kc(r, !1), e = o.updateQueue, t.updateQueue = e, Oc(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null;) ti(n, e), n = n.sibling;
							return te(Qa, Qa.current & 1 | 2), wi && _i(t, r.treeForkCount), t.child;
						}
						e = e.sibling;
					}
					r.tail !== null && ye() > eu && (t.flags |= 128, a = !0, kc(r, !1), t.lanes = 4194304);
				}
				else {
					if (!a) if (e = $a(o), e !== null) {
						if (t.flags |= 128, a = !0, e = e.updateQueue, t.updateQueue = e, Oc(t, e), kc(r, !0), r.tail === null && r.tailMode === "hidden" && !o.alternate && !wi) return Ac(t), null;
					} else 2 * ye() - r.renderingStartTime > eu && n !== 536870912 && (t.flags |= 128, a = !0, kc(r, !1), t.lanes = 4194304);
					r.isBackwards ? (o.sibling = t.child, t.child = o) : (e = r.last, e === null ? t.child = o : e.sibling = o, r.last = o);
				}
				return r.tail === null ? (Ac(t), null) : (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = ye(), e.sibling = null, n = Qa.current, te(Qa, a ? n & 1 | 2 : n & 1), wi && _i(t, r.treeForkCount), e);
			case 22:
			case 23: return Za(t), Wa(), r = t.memoizedState !== null, e === null ? r && (t.flags |= 8192) : e.memoizedState !== null !== r && (t.flags |= 8192), r ? n & 536870912 && !(t.flags & 128) && (Ac(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Ac(t), n = t.updateQueue, n !== null && Oc(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== n && (t.flags |= 2048), e !== null && z(oa), null;
			case 24: return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), zi(Zi), Ac(t), null;
			case 25: return null;
			case 30: return null;
		}
		throw Error(i(156, t.tag));
	}
	function Mc(e, t) {
		switch (bi(t), t.tag) {
			case 1: return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 3: return zi(Zi), ae(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
			case 26:
			case 27:
			case 5: return H(t), null;
			case 31:
				if (t.memoizedState !== null) {
					if (Za(t), t.alternate === null) throw Error(i(340));
					Mi();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 13:
				if (Za(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
					if (t.alternate === null) throw Error(i(340));
					Mi();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 19: return z(Qa), null;
			case 4: return ae(), null;
			case 10: return zi(t.type), null;
			case 22:
			case 23: return Za(t), Wa(), e !== null && z(oa), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 24: return zi(Zi), null;
			case 25: return null;
			default: return null;
		}
	}
	function Nc(e, t) {
		switch (bi(t), t.tag) {
			case 3:
				zi(Zi), ae();
				break;
			case 26:
			case 27:
			case 5:
				H(t);
				break;
			case 4:
				ae();
				break;
			case 31:
				t.memoizedState !== null && Za(t);
				break;
			case 13:
				Za(t);
				break;
			case 19:
				z(Qa);
				break;
			case 10:
				zi(t.type);
				break;
			case 22:
			case 23:
				Za(t), Wa(), e !== null && z(oa);
				break;
			case 24: zi(Zi);
		}
	}
	function Pc(e, t) {
		try {
			var n = t.updateQueue, r = n === null ? null : n.lastEffect;
			if (r !== null) {
				var i = r.next;
				n = i;
				do {
					if ((n.tag & e) === e) {
						r = void 0;
						var a = n.create, o = n.inst;
						r = a(), o.destroy = r;
					}
					n = n.next;
				} while (n !== i);
			}
		} catch (e) {
			Wu(t, t.return, e);
		}
	}
	function Fc(e, t, n) {
		try {
			var r = t.updateQueue, i = r === null ? null : r.lastEffect;
			if (i !== null) {
				var a = i.next;
				r = a;
				do {
					if ((r.tag & e) === e) {
						var o = r.inst, s = o.destroy;
						if (s !== void 0) {
							o.destroy = void 0, i = t;
							var c = n, l = s;
							try {
								l();
							} catch (e) {
								Wu(i, c, e);
							}
						}
					}
					r = r.next;
				} while (r !== a);
			}
		} catch (e) {
			Wu(t, t.return, e);
		}
	}
	function Ic(e) {
		var t = e.updateQueue;
		if (t !== null) {
			var n = e.stateNode;
			try {
				za(t, n);
			} catch (t) {
				Wu(e, e.return, t);
			}
		}
	}
	function Lc(e, t, n) {
		n.props = Rs(e.type, e.memoizedProps), n.state = e.memoizedState;
		try {
			n.componentWillUnmount();
		} catch (n) {
			Wu(e, t, n);
		}
	}
	function Rc(e, t) {
		try {
			var n = e.ref;
			if (n !== null) {
				switch (e.tag) {
					case 26:
					case 27:
					case 5:
						var r = e.stateNode;
						break;
					case 30:
						r = e.stateNode;
						break;
					default: r = e.stateNode;
				}
				typeof n == "function" ? e.refCleanup = n(r) : n.current = r;
			}
		} catch (n) {
			Wu(e, t, n);
		}
	}
	function zc(e, t) {
		var n = e.ref, r = e.refCleanup;
		if (n !== null) if (typeof r == "function") try {
			r();
		} catch (n) {
			Wu(e, t, n);
		} finally {
			e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
		}
		else if (typeof n == "function") try {
			n(null);
		} catch (n) {
			Wu(e, t, n);
		}
		else n.current = null;
	}
	function Bc(e) {
		var t = e.type, n = e.memoizedProps, r = e.stateNode;
		try {
			a: switch (t) {
				case "button":
				case "input":
				case "select":
				case "textarea":
					n.autoFocus && r.focus();
					break a;
				case "img": n.src ? r.src = n.src : n.srcSet && (r.srcset = n.srcSet);
			}
		} catch (t) {
			Wu(e, e.return, t);
		}
	}
	function Vc(e, t, n) {
		try {
			var r = e.stateNode;
			Id(r, e.type, n, t), r[et] = t;
		} catch (t) {
			Wu(e, e.return, t);
		}
	}
	function Hc(e) {
		return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Qd(e.type) || e.tag === 4;
	}
	function Uc(e) {
		a: for (;;) {
			for (; e.sibling === null;) {
				if (e.return === null || Hc(e.return)) return null;
				e = e.return;
			}
			for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
				if (e.tag === 27 && Qd(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue a;
				e.child.return = e, e = e.child;
			}
			if (!(e.flags & 2)) return e.stateNode;
		}
	}
	function Wc(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(e, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = Wt));
		else if (r !== 4 && (r === 27 && Qd(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null)) for (Wc(e, t, n), e = e.sibling; e !== null;) Wc(e, t, n), e = e.sibling;
	}
	function Gc(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
		else if (r !== 4 && (r === 27 && Qd(e.type) && (n = e.stateNode), e = e.child, e !== null)) for (Gc(e, t, n), e = e.sibling; e !== null;) Gc(e, t, n), e = e.sibling;
	}
	function Kc(e) {
		var t = e.stateNode, n = e.memoizedProps;
		try {
			for (var r = e.type, i = t.attributes; i.length;) t.removeAttributeNode(i[0]);
			Fd(t, r, n), t[$e] = e, t[et] = n;
		} catch (t) {
			Wu(e, e.return, t);
		}
	}
	var qc = !1, Jc = !1, Yc = !1, Xc = typeof WeakSet == "function" ? WeakSet : Set, Zc = null;
	function Qc(e, t) {
		if (e = e.containerInfo, zd = sp, e = vr(e), yr(e)) {
			if ("selectionStart" in e) var n = {
				start: e.selectionStart,
				end: e.selectionEnd
			};
			else a: {
				n = (n = e.ownerDocument) && n.defaultView || window;
				var r = n.getSelection && n.getSelection();
				if (r && r.rangeCount !== 0) {
					n = r.anchorNode;
					var a = r.anchorOffset, o = r.focusNode;
					r = r.focusOffset;
					try {
						n.nodeType, o.nodeType;
					} catch {
						n = null;
						break a;
					}
					var s = 0, c = -1, l = -1, u = 0, d = 0, f = e, p = null;
					b: for (;;) {
						for (var m; f !== n || a !== 0 && f.nodeType !== 3 || (c = s + a), f !== o || r !== 0 && f.nodeType !== 3 || (l = s + r), f.nodeType === 3 && (s += f.nodeValue.length), (m = f.firstChild) !== null;) p = f, f = m;
						for (;;) {
							if (f === e) break b;
							if (p === n && ++u === a && (c = s), p === o && ++d === r && (l = s), (m = f.nextSibling) !== null) break;
							f = p, p = f.parentNode;
						}
						f = m;
					}
					n = c === -1 || l === -1 ? null : {
						start: c,
						end: l
					};
				} else n = null;
			}
			n ||= {
				start: 0,
				end: 0
			};
		} else n = null;
		for (Bd = {
			focusedElem: e,
			selectionRange: n
		}, sp = !1, Zc = t; Zc !== null;) if (t = Zc, e = t.child, t.subtreeFlags & 1028 && e !== null) e.return = t, Zc = e;
		else for (; Zc !== null;) {
			switch (t = Zc, o = t.alternate, e = t.flags, t.tag) {
				case 0:
					if (e & 4 && (e = t.updateQueue, e = e === null ? null : e.events, e !== null)) for (n = 0; n < e.length; n++) a = e[n], a.ref.impl = a.nextImpl;
					break;
				case 11:
				case 15: break;
				case 1:
					if (e & 1024 && o !== null) {
						e = void 0, n = t, a = o.memoizedProps, o = o.memoizedState, r = n.stateNode;
						try {
							var h = Rs(n.type, a);
							e = r.getSnapshotBeforeUpdate(h, o), r.__reactInternalSnapshotBeforeUpdate = e;
						} catch (e) {
							Wu(n, n.return, e);
						}
					}
					break;
				case 3:
					if (e & 1024) {
						if (e = t.stateNode.containerInfo, n = e.nodeType, n === 9) tf(e);
						else if (n === 1) switch (e.nodeName) {
							case "HEAD":
							case "HTML":
							case "BODY":
								tf(e);
								break;
							default: e.textContent = "";
						}
					}
					break;
				case 5:
				case 26:
				case 27:
				case 6:
				case 4:
				case 17: break;
				default: if (e & 1024) throw Error(i(163));
			}
			if (e = t.sibling, e !== null) {
				e.return = t.return, Zc = e;
				break;
			}
			Zc = t.return;
		}
	}
	function $c(e, t, n) {
		var r = n.flags;
		switch (n.tag) {
			case 0:
			case 11:
			case 15:
				ml(e, n), r & 4 && Pc(5, n);
				break;
			case 1:
				if (ml(e, n), r & 4) if (e = n.stateNode, t === null) try {
					e.componentDidMount();
				} catch (e) {
					Wu(n, n.return, e);
				}
				else {
					var i = Rs(n.type, t.memoizedProps);
					t = t.memoizedState;
					try {
						e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
					} catch (e) {
						Wu(n, n.return, e);
					}
				}
				r & 64 && Ic(n), r & 512 && Rc(n, n.return);
				break;
			case 3:
				if (ml(e, n), r & 64 && (e = n.updateQueue, e !== null)) {
					if (t = null, n.child !== null) switch (n.child.tag) {
						case 27:
						case 5:
							t = n.child.stateNode;
							break;
						case 1: t = n.child.stateNode;
					}
					try {
						za(e, t);
					} catch (e) {
						Wu(n, n.return, e);
					}
				}
				break;
			case 27: t === null && r & 4 && Kc(n);
			case 26:
			case 5:
				ml(e, n), t === null && r & 4 && Bc(n), r & 512 && Rc(n, n.return);
				break;
			case 12:
				ml(e, n);
				break;
			case 31:
				ml(e, n), r & 4 && al(e, n);
				break;
			case 13:
				ml(e, n), r & 4 && ol(e, n), r & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = Ju.bind(null, n), cf(e, n))));
				break;
			case 22:
				if (r = n.memoizedState !== null || qc, !r) {
					t = t !== null && t.memoizedState !== null || Jc, i = qc;
					var a = Jc;
					qc = r, (Jc = t) && !a ? gl(e, n, (n.subtreeFlags & 8772) != 0) : ml(e, n), qc = i, Jc = a;
				}
				break;
			case 30: break;
			default: ml(e, n);
		}
	}
	function el(e) {
		var t = e.alternate;
		t !== null && (e.alternate = null, el(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && st(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
	}
	var tl = null, nl = !1;
	function rl(e, t, n) {
		for (n = n.child; n !== null;) il(e, t, n), n = n.sibling;
	}
	function il(e, t, n) {
		if (Oe && typeof Oe.onCommitFiberUnmount == "function") try {
			Oe.onCommitFiberUnmount(U, n);
		} catch {}
		switch (n.tag) {
			case 26:
				Jc || zc(n, t), rl(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
				break;
			case 27:
				Jc || zc(n, t);
				var r = tl, i = nl;
				Qd(n.type) && (tl = n.stateNode, nl = !1), rl(e, t, n), mf(n.stateNode), tl = r, nl = i;
				break;
			case 5: Jc || zc(n, t);
			case 6:
				if (r = tl, i = nl, tl = null, rl(e, t, n), tl = r, nl = i, tl !== null) if (nl) try {
					(tl.nodeType === 9 ? tl.body : tl.nodeName === "HTML" ? tl.ownerDocument.body : tl).removeChild(n.stateNode);
				} catch (e) {
					Wu(n, t, e);
				}
				else try {
					tl.removeChild(n.stateNode);
				} catch (e) {
					Wu(n, t, e);
				}
				break;
			case 18:
				tl !== null && (nl ? (e = tl, $d(e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, n.stateNode), Np(e)) : $d(tl, n.stateNode));
				break;
			case 4:
				r = tl, i = nl, tl = n.stateNode.containerInfo, nl = !0, rl(e, t, n), tl = r, nl = i;
				break;
			case 0:
			case 11:
			case 14:
			case 15:
				Fc(2, n, t), Jc || Fc(4, n, t), rl(e, t, n);
				break;
			case 1:
				Jc || (zc(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function" && Lc(n, t, r)), rl(e, t, n);
				break;
			case 21:
				rl(e, t, n);
				break;
			case 22:
				Jc = (r = Jc) || n.memoizedState !== null, rl(e, t, n), Jc = r;
				break;
			default: rl(e, t, n);
		}
	}
	function al(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
			e = e.dehydrated;
			try {
				Np(e);
			} catch (e) {
				Wu(t, t.return, e);
			}
		}
	}
	function ol(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) try {
			Np(e);
		} catch (e) {
			Wu(t, t.return, e);
		}
	}
	function sl(e) {
		switch (e.tag) {
			case 31:
			case 13:
			case 19:
				var t = e.stateNode;
				return t === null && (t = e.stateNode = new Xc()), t;
			case 22: return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new Xc()), t;
			default: throw Error(i(435, e.tag));
		}
	}
	function cl(e, t) {
		var n = sl(e);
		t.forEach(function(t) {
			if (!n.has(t)) {
				n.add(t);
				var r = Yu.bind(null, e, t);
				t.then(r, r);
			}
		});
	}
	function ll(e, t) {
		var n = t.deletions;
		if (n !== null) for (var r = 0; r < n.length; r++) {
			var a = n[r], o = e, s = t, c = s;
			a: for (; c !== null;) {
				switch (c.tag) {
					case 27:
						if (Qd(c.type)) {
							tl = c.stateNode, nl = !1;
							break a;
						}
						break;
					case 5:
						tl = c.stateNode, nl = !1;
						break a;
					case 3:
					case 4:
						tl = c.stateNode.containerInfo, nl = !0;
						break a;
				}
				c = c.return;
			}
			if (tl === null) throw Error(i(160));
			il(o, s, a), tl = null, nl = !1, o = a.alternate, o !== null && (o.return = null), a.return = null;
		}
		if (t.subtreeFlags & 13886) for (t = t.child; t !== null;) dl(t, e), t = t.sibling;
	}
	var ul = null;
	function dl(e, t) {
		var n = e.alternate, r = e.flags;
		switch (e.tag) {
			case 0:
			case 11:
			case 14:
			case 15:
				ll(t, e), fl(e), r & 4 && (Fc(3, e, e.return), Pc(3, e), Fc(5, e, e.return));
				break;
			case 1:
				ll(t, e), fl(e), r & 512 && (Jc || n === null || zc(n, n.return)), r & 64 && qc && (e = e.updateQueue, e !== null && (r = e.callbacks, r !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? r : n.concat(r))));
				break;
			case 26:
				var a = ul;
				if (ll(t, e), fl(e), r & 512 && (Jc || n === null || zc(n, n.return)), r & 4) {
					var o = n === null ? null : n.memoizedState;
					if (r = e.memoizedState, n === null) if (r === null) if (e.stateNode === null) {
						a: {
							r = e.type, n = e.memoizedProps, a = a.ownerDocument || a;
							b: switch (r) {
								case "title":
									o = a.getElementsByTagName("title")[0], (!o || o[ot] || o[$e] || o.namespaceURI === "http://www.w3.org/2000/svg" || o.hasAttribute("itemprop")) && (o = a.createElement(r), a.head.insertBefore(o, a.querySelector("head > title"))), Fd(o, r, n), o[$e] = e, ft(o), r = o;
									break a;
								case "link":
									var s = Vf("link", "href", a).get(r + (n.href || ""));
									if (s) {
										for (var c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && o.getAttribute("rel") === (n.rel == null ? null : n.rel) && o.getAttribute("title") === (n.title == null ? null : n.title) && o.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
											s.splice(c, 1);
											break b;
										}
									}
									o = a.createElement(r), Fd(o, r, n), a.head.appendChild(o);
									break;
								case "meta":
									if (s = Vf("meta", "content", a).get(r + (n.content || ""))) {
										for (c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("content") === (n.content == null ? null : "" + n.content) && o.getAttribute("name") === (n.name == null ? null : n.name) && o.getAttribute("property") === (n.property == null ? null : n.property) && o.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && o.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
											s.splice(c, 1);
											break b;
										}
									}
									o = a.createElement(r), Fd(o, r, n), a.head.appendChild(o);
									break;
								default: throw Error(i(468, r));
							}
							o[$e] = e, ft(o), r = o;
						}
						e.stateNode = r;
					} else Hf(a, e.type, e.stateNode);
					else e.stateNode = If(a, r, e.memoizedProps);
					else o === r ? r === null && e.stateNode !== null && Vc(e, e.memoizedProps, n.memoizedProps) : (o === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : o.count--, r === null ? Hf(a, e.type, e.stateNode) : If(a, r, e.memoizedProps));
				}
				break;
			case 27:
				ll(t, e), fl(e), r & 512 && (Jc || n === null || zc(n, n.return)), n !== null && r & 4 && Vc(e, e.memoizedProps, n.memoizedProps);
				break;
			case 5:
				if (ll(t, e), fl(e), r & 512 && (Jc || n === null || zc(n, n.return)), e.flags & 32) {
					a = e.stateNode;
					try {
						Lt(a, "");
					} catch (t) {
						Wu(e, e.return, t);
					}
				}
				r & 4 && e.stateNode != null && (a = e.memoizedProps, Vc(e, a, n === null ? a : n.memoizedProps)), r & 1024 && (Yc = !0);
				break;
			case 6:
				if (ll(t, e), fl(e), r & 4) {
					if (e.stateNode === null) throw Error(i(162));
					r = e.memoizedProps, n = e.stateNode;
					try {
						n.nodeValue = r;
					} catch (t) {
						Wu(e, e.return, t);
					}
				}
				break;
			case 3:
				if (Bf = null, a = ul, ul = _f(t.containerInfo), ll(t, e), ul = a, fl(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
					Np(t.containerInfo);
				} catch (t) {
					Wu(e, e.return, t);
				}
				Yc && (Yc = !1, pl(e));
				break;
			case 4:
				r = ul, ul = _f(e.stateNode.containerInfo), ll(t, e), fl(e), ul = r;
				break;
			case 12:
				ll(t, e), fl(e);
				break;
			case 31:
				ll(t, e), fl(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, cl(e, r)));
				break;
			case 13:
				ll(t, e), fl(e), e.child.flags & 8192 && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && (Ql = ye()), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, cl(e, r)));
				break;
			case 22:
				a = e.memoizedState !== null;
				var l = n !== null && n.memoizedState !== null, u = qc, d = Jc;
				if (qc = u || a, Jc = d || l, ll(t, e), Jc = d, qc = u, fl(e), r & 8192) a: for (t = e.stateNode, t._visibility = a ? t._visibility & -2 : t._visibility | 1, a && (n === null || l || qc || Jc || hl(e)), n = null, t = e;;) {
					if (t.tag === 5 || t.tag === 26) {
						if (n === null) {
							l = n = t;
							try {
								if (o = l.stateNode, a) s = o.style, typeof s.setProperty == "function" ? s.setProperty("display", "none", "important") : s.display = "none";
								else {
									c = l.stateNode;
									var f = l.memoizedProps.style, p = f != null && f.hasOwnProperty("display") ? f.display : null;
									c.style.display = p == null || typeof p == "boolean" ? "" : ("" + p).trim();
								}
							} catch (e) {
								Wu(l, l.return, e);
							}
						}
					} else if (t.tag === 6) {
						if (n === null) {
							l = t;
							try {
								l.stateNode.nodeValue = a ? "" : l.memoizedProps;
							} catch (e) {
								Wu(l, l.return, e);
							}
						}
					} else if (t.tag === 18) {
						if (n === null) {
							l = t;
							try {
								var m = l.stateNode;
								a ? ef(m, !0) : ef(l.stateNode, !1);
							} catch (e) {
								Wu(l, l.return, e);
							}
						}
					} else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
						t.child.return = t, t = t.child;
						continue;
					}
					if (t === e) break a;
					for (; t.sibling === null;) {
						if (t.return === null || t.return === e) break a;
						n === t && (n = null), t = t.return;
					}
					n === t && (n = null), t.sibling.return = t.return, t = t.sibling;
				}
				r & 4 && (r = e.updateQueue, r !== null && (n = r.retryQueue, n !== null && (r.retryQueue = null, cl(e, n))));
				break;
			case 19:
				ll(t, e), fl(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, cl(e, r)));
				break;
			case 30: break;
			case 21: break;
			default: ll(t, e), fl(e);
		}
	}
	function fl(e) {
		var t = e.flags;
		if (t & 2) {
			try {
				for (var n, r = e.return; r !== null;) {
					if (Hc(r)) {
						n = r;
						break;
					}
					r = r.return;
				}
				if (n == null) throw Error(i(160));
				switch (n.tag) {
					case 27:
						var a = n.stateNode;
						Gc(e, Uc(e), a);
						break;
					case 5:
						var o = n.stateNode;
						n.flags & 32 && (Lt(o, ""), n.flags &= -33), Gc(e, Uc(e), o);
						break;
					case 3:
					case 4:
						var s = n.stateNode.containerInfo;
						Wc(e, Uc(e), s);
						break;
					default: throw Error(i(161));
				}
			} catch (t) {
				Wu(e, e.return, t);
			}
			e.flags &= -3;
		}
		t & 4096 && (e.flags &= -4097);
	}
	function pl(e) {
		if (e.subtreeFlags & 1024) for (e = e.child; e !== null;) {
			var t = e;
			pl(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
		}
	}
	function ml(e, t) {
		if (t.subtreeFlags & 8772) for (t = t.child; t !== null;) $c(e, t.alternate, t), t = t.sibling;
	}
	function hl(e) {
		for (e = e.child; e !== null;) {
			var t = e;
			switch (t.tag) {
				case 0:
				case 11:
				case 14:
				case 15:
					Fc(4, t, t.return), hl(t);
					break;
				case 1:
					zc(t, t.return);
					var n = t.stateNode;
					typeof n.componentWillUnmount == "function" && Lc(t, t.return, n), hl(t);
					break;
				case 27: mf(t.stateNode);
				case 26:
				case 5:
					zc(t, t.return), hl(t);
					break;
				case 22:
					t.memoizedState === null && hl(t);
					break;
				case 30:
					hl(t);
					break;
				default: hl(t);
			}
			e = e.sibling;
		}
	}
	function gl(e, t, n) {
		for (n &&= (t.subtreeFlags & 8772) != 0, t = t.child; t !== null;) {
			var r = t.alternate, i = e, a = t, o = a.flags;
			switch (a.tag) {
				case 0:
				case 11:
				case 15:
					gl(i, a, n), Pc(4, a);
					break;
				case 1:
					if (gl(i, a, n), r = a, i = r.stateNode, typeof i.componentDidMount == "function") try {
						i.componentDidMount();
					} catch (e) {
						Wu(r, r.return, e);
					}
					if (r = a, i = r.updateQueue, i !== null) {
						var s = r.stateNode;
						try {
							var c = i.shared.hiddenCallbacks;
							if (c !== null) for (i.shared.hiddenCallbacks = null, i = 0; i < c.length; i++) Ra(c[i], s);
						} catch (e) {
							Wu(r, r.return, e);
						}
					}
					n && o & 64 && Ic(a), Rc(a, a.return);
					break;
				case 27: Kc(a);
				case 26:
				case 5:
					gl(i, a, n), n && r === null && o & 4 && Bc(a), Rc(a, a.return);
					break;
				case 12:
					gl(i, a, n);
					break;
				case 31:
					gl(i, a, n), n && o & 4 && al(i, a);
					break;
				case 13:
					gl(i, a, n), n && o & 4 && ol(i, a);
					break;
				case 22:
					a.memoizedState === null && gl(i, a, n), Rc(a, a.return);
					break;
				case 30: break;
				default: gl(i, a, n);
			}
			t = t.sibling;
		}
	}
	function _l(e, t) {
		var n = null;
		e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && $i(n));
	}
	function vl(e, t) {
		e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && $i(e));
	}
	function yl(e, t, n, r) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) bl(e, t, n, r), t = t.sibling;
	}
	function bl(e, t, n, r) {
		var i = t.flags;
		switch (t.tag) {
			case 0:
			case 11:
			case 15:
				yl(e, t, n, r), i & 2048 && Pc(9, t);
				break;
			case 1:
				yl(e, t, n, r);
				break;
			case 3:
				yl(e, t, n, r), i & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && $i(e)));
				break;
			case 12:
				if (i & 2048) {
					yl(e, t, n, r), e = t.stateNode;
					try {
						var a = t.memoizedProps, o = a.id, s = a.onPostCommit;
						typeof s == "function" && s(o, t.alternate === null ? "mount" : "update", e.passiveEffectDuration, -0);
					} catch (e) {
						Wu(t, t.return, e);
					}
				} else yl(e, t, n, r);
				break;
			case 31:
				yl(e, t, n, r);
				break;
			case 13:
				yl(e, t, n, r);
				break;
			case 23: break;
			case 22:
				a = t.stateNode, o = t.alternate, t.memoizedState === null ? a._visibility & 2 ? yl(e, t, n, r) : (a._visibility |= 2, xl(e, t, n, r, (t.subtreeFlags & 10256) != 0 || !1)) : a._visibility & 2 ? yl(e, t, n, r) : Sl(e, t), i & 2048 && _l(o, t);
				break;
			case 24:
				yl(e, t, n, r), i & 2048 && vl(t.alternate, t);
				break;
			default: yl(e, t, n, r);
		}
	}
	function xl(e, t, n, r, i) {
		for (i &&= (t.subtreeFlags & 10256) != 0 || !1, t = t.child; t !== null;) {
			var a = e, o = t, s = n, c = r, l = o.flags;
			switch (o.tag) {
				case 0:
				case 11:
				case 15:
					xl(a, o, s, c, i), Pc(8, o);
					break;
				case 23: break;
				case 22:
					var u = o.stateNode;
					o.memoizedState === null ? (u._visibility |= 2, xl(a, o, s, c, i)) : u._visibility & 2 ? xl(a, o, s, c, i) : Sl(a, o), i && l & 2048 && _l(o.alternate, o);
					break;
				case 24:
					xl(a, o, s, c, i), i && l & 2048 && vl(o.alternate, o);
					break;
				default: xl(a, o, s, c, i);
			}
			t = t.sibling;
		}
	}
	function Sl(e, t) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) {
			var n = e, r = t, i = r.flags;
			switch (r.tag) {
				case 22:
					Sl(n, r), i & 2048 && _l(r.alternate, r);
					break;
				case 24:
					Sl(n, r), i & 2048 && vl(r.alternate, r);
					break;
				default: Sl(n, r);
			}
			t = t.sibling;
		}
	}
	var Cl = 8192;
	function wl(e, t, n) {
		if (e.subtreeFlags & Cl) for (e = e.child; e !== null;) Tl(e, t, n), e = e.sibling;
	}
	function Tl(e, t, n) {
		switch (e.tag) {
			case 26:
				wl(e, t, n), e.flags & Cl && e.memoizedState !== null && Gf(n, ul, e.memoizedState, e.memoizedProps);
				break;
			case 5:
				wl(e, t, n);
				break;
			case 3:
			case 4:
				var r = ul;
				ul = _f(e.stateNode.containerInfo), wl(e, t, n), ul = r;
				break;
			case 22:
				e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = Cl, Cl = 16777216, wl(e, t, n), Cl = r) : wl(e, t, n));
				break;
			default: wl(e, t, n);
		}
	}
	function El(e) {
		var t = e.alternate;
		if (t !== null && (e = t.child, e !== null)) {
			t.child = null;
			do
				t = e.sibling, e.sibling = null, e = t;
			while (e !== null);
		}
	}
	function Dl(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				Zc = r, Al(r, e);
			}
			El(e);
		}
		if (e.subtreeFlags & 10256) for (e = e.child; e !== null;) Ol(e), e = e.sibling;
	}
	function Ol(e) {
		switch (e.tag) {
			case 0:
			case 11:
			case 15:
				Dl(e), e.flags & 2048 && Fc(9, e, e.return);
				break;
			case 3:
				Dl(e);
				break;
			case 12:
				Dl(e);
				break;
			case 22:
				var t = e.stateNode;
				e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, kl(e)) : Dl(e);
				break;
			default: Dl(e);
		}
	}
	function kl(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				Zc = r, Al(r, e);
			}
			El(e);
		}
		for (e = e.child; e !== null;) {
			switch (t = e, t.tag) {
				case 0:
				case 11:
				case 15:
					Fc(8, t, t.return), kl(t);
					break;
				case 22:
					n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, kl(t));
					break;
				default: kl(t);
			}
			e = e.sibling;
		}
	}
	function Al(e, t) {
		for (; Zc !== null;) {
			var n = Zc;
			switch (n.tag) {
				case 0:
				case 11:
				case 15:
					Fc(8, n, t);
					break;
				case 23:
				case 22:
					if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
						var r = n.memoizedState.cachePool.pool;
						r != null && r.refCount++;
					}
					break;
				case 24: $i(n.memoizedState.cache);
			}
			if (r = n.child, r !== null) r.return = n, Zc = r;
			else a: for (n = e; Zc !== null;) {
				r = Zc;
				var i = r.sibling, a = r.return;
				if (el(r), r === n) {
					Zc = null;
					break a;
				}
				if (i !== null) {
					i.return = a, Zc = i;
					break a;
				}
				Zc = a;
			}
		}
	}
	var jl = {
		getCacheForType: function(e) {
			var t = Gi(Zi), n = t.data.get(e);
			return n === void 0 && (n = e(), t.data.set(e, n)), n;
		},
		cacheSignal: function() {
			return Gi(Zi).controller.signal;
		}
	}, Ml = typeof WeakMap == "function" ? WeakMap : Map, Nl = 0, Pl = null, Fl = null, Il = 0, Ll = 0, Rl = null, zl = !1, Bl = !1, Vl = !1, Hl = 0, Ul = 0, Wl = 0, Gl = 0, Kl = 0, ql = 0, Jl = 0, Yl = null, Xl = null, Zl = !1, Ql = 0, $l = 0, eu = Infinity, tu = null, nu = null, ru = 0, iu = null, au = null, ou = 0, su = 0, cu = null, lu = null, uu = 0, du = null;
	function fu() {
		return Nl & 2 && Il !== 0 ? Il & -Il : P.T === null ? Xe() : ud();
	}
	function pu() {
		if (ql === 0) if (!(Il & 536870912) || wi) {
			var e = Fe;
			Fe <<= 1, !(Fe & 3932160) && (Fe = 262144), ql = e;
		} else ql = 536870912;
		return e = Ga.current, e !== null && (e.flags |= 32), ql;
	}
	function mu(e, t, n) {
		(e === Pl && (Ll === 2 || Ll === 9) || e.cancelPendingCommit !== null) && (xu(e, 0), vu(e, Il, ql, !1)), Ue(e, n), (!(Nl & 2) || e !== Pl) && (e === Pl && (!(Nl & 2) && (Gl |= n), Ul === 4 && vu(e, Il, ql, !1)), rd(e));
	}
	function hu(e, t, n) {
		if (Nl & 6) throw Error(i(327));
		var r = !n && (t & 127) == 0 && (t & e.expiredLanes) === 0 || ze(e, t), a = r ? ku(e, t) : Du(e, t, !0), o = r;
		do {
			if (a === 0) {
				Bl && !r && vu(e, t, 0, !1);
				break;
			} else {
				if (n = e.current.alternate, o && !_u(n)) {
					a = Du(e, t, !1), o = !1;
					continue;
				}
				if (a === 2) {
					if (o = t, e.errorRecoveryDisabledLanes & o) var s = 0;
					else s = e.pendingLanes & -536870913, s = s === 0 ? s & 536870912 ? 536870912 : 0 : s;
					if (s !== 0) {
						t = s;
						a: {
							var c = e;
							a = Yl;
							var l = c.current.memoizedState.isDehydrated;
							if (l && (xu(c, s).flags |= 256), s = Du(c, s, !1), s !== 2) {
								if (Vl && !l) {
									c.errorRecoveryDisabledLanes |= o, Gl |= o, a = 4;
									break a;
								}
								o = Xl, Xl = a, o !== null && (Xl === null ? Xl = o : Xl.push.apply(Xl, o));
							}
							a = s;
						}
						if (o = !1, a !== 2) continue;
					}
				}
				if (a === 1) {
					xu(e, 0), vu(e, t, 0, !0);
					break;
				}
				a: {
					switch (r = e, o = a, o) {
						case 0:
						case 1: throw Error(i(345));
						case 4: if ((t & 4194048) !== t) break;
						case 6:
							vu(r, t, ql, !zl);
							break a;
						case 2:
							Xl = null;
							break;
						case 3:
						case 5: break;
						default: throw Error(i(329));
					}
					if ((t & 62914560) === t && (a = Ql + 300 - ye(), 10 < a)) {
						if (vu(r, t, ql, !zl), Re(r, 0, !0) !== 0) break a;
						ou = t, r.timeoutHandle = qd(gu.bind(null, r, n, Xl, tu, Zl, t, ql, Gl, Jl, zl, o, "Throttled", -0, 0), a);
						break a;
					}
					gu(r, n, Xl, tu, Zl, t, ql, Gl, Jl, zl, o, null, -0, 0);
				}
			}
			break;
		} while (1);
		rd(e);
	}
	function gu(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
		if (e.timeoutHandle = -1, d = t.subtreeFlags, d & 8192 || (d & 16785408) == 16785408) {
			d = {
				stylesheets: null,
				count: 0,
				imgCount: 0,
				imgBytes: 0,
				suspenseyImages: [],
				waitingForImages: !0,
				waitingForViewTransition: !1,
				unsuspend: Wt
			}, Tl(t, a, d);
			var m = (a & 62914560) === a ? Ql - ye() : (a & 4194048) === a ? $l - ye() : 0;
			if (m = qf(d, m), m !== null) {
				ou = a, e.cancelPendingCommit = m(Iu.bind(null, e, t, a, n, r, i, o, s, c, u, d, null, f, p)), vu(e, a, o, !l);
				return;
			}
		}
		Iu(e, t, a, n, r, i, o, s, c);
	}
	function _u(e) {
		for (var t = e;;) {
			var n = t.tag;
			if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) for (var r = 0; r < n.length; r++) {
				var i = n[r], a = i.getSnapshot;
				i = i.value;
				try {
					if (!pr(a(), i)) return !1;
				} catch {
					return !1;
				}
			}
			if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
			else {
				if (t === e) break;
				for (; t.sibling === null;) {
					if (t.return === null || t.return === e) return !0;
					t = t.return;
				}
				t.sibling.return = t.return, t = t.sibling;
			}
		}
		return !0;
	}
	function vu(e, t, n, r) {
		t &= ~Kl, t &= ~Gl, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
		for (var i = t; 0 < i;) {
			var a = 31 - Ae(i), o = 1 << a;
			r[a] = -1, i &= ~o;
		}
		n !== 0 && Ge(e, n, t);
	}
	function yu() {
		return Nl & 6 ? !0 : (id(0, !1), !1);
	}
	function bu() {
		if (Fl !== null) {
			if (Ll === 0) var e = Fl.return;
			else e = Fl, Li = Ii = null, bo(e), ba = null, xa = 0, e = Fl;
			for (; e !== null;) Nc(e.alternate, e), e = e.return;
			Fl = null;
		}
	}
	function xu(e, t) {
		var n = e.timeoutHandle;
		n !== -1 && (e.timeoutHandle = -1, Jd(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), ou = 0, bu(), Pl = e, Fl = n = ei(e.current, null), Il = t, Ll = 0, Rl = null, zl = !1, Bl = ze(e, t), Vl = !1, Jl = ql = Kl = Gl = Wl = Ul = 0, Xl = Yl = null, Zl = !1, t & 8 && (t |= t & 32);
		var r = e.entangledLanes;
		if (r !== 0) for (e = e.entanglements, r &= t; 0 < r;) {
			var i = 31 - Ae(r), a = 1 << i;
			t |= e[i], r &= ~a;
		}
		return Hl = t, Wr(), n;
	}
	function Su(e, t) {
		to = null, P.H = As, t === ua || t === fa ? (t = va(), Ll = 3) : t === da ? (t = va(), Ll = 4) : Ll = t === Js ? 8 : typeof t == "object" && t && typeof t.then == "function" ? 6 : 1, Rl = t, Fl === null && (Ul = 1, Hs(e, si(t, e.current)));
	}
	function Cu() {
		var e = Ga.current;
		return e === null ? !0 : (Il & 4194048) === Il ? Ka === null : (Il & 62914560) === Il || Il & 536870912 ? e === Ka : !1;
	}
	function wu() {
		var e = P.H;
		return P.H = As, e === null ? As : e;
	}
	function Tu() {
		var e = P.A;
		return P.A = jl, e;
	}
	function Eu() {
		Ul = 4, zl || (Il & 4194048) !== Il && Ga.current !== null || (Bl = !0), !(Wl & 134217727) && !(Gl & 134217727) || Pl === null || vu(Pl, Il, ql, !1);
	}
	function Du(e, t, n) {
		var r = Nl;
		Nl |= 2;
		var i = wu(), a = Tu();
		(Pl !== e || Il !== t) && (tu = null, xu(e, t)), t = !1;
		var o = Ul;
		a: do
			try {
				if (Ll !== 0 && Fl !== null) {
					var s = Fl, c = Rl;
					switch (Ll) {
						case 8:
							bu(), o = 6;
							break a;
						case 3:
						case 2:
						case 9:
						case 6:
							Ga.current === null && (t = !0);
							var l = Ll;
							if (Ll = 0, Rl = null, Nu(e, s, c, l), n && Bl) {
								o = 0;
								break a;
							}
							break;
						default: l = Ll, Ll = 0, Rl = null, Nu(e, s, c, l);
					}
				}
				Ou(), o = Ul;
				break;
			} catch (t) {
				Su(e, t);
			}
		while (1);
		return t && e.shellSuspendCounter++, Li = Ii = null, Nl = r, P.H = i, P.A = a, Fl === null && (Pl = null, Il = 0, Wr()), o;
	}
	function Ou() {
		for (; Fl !== null;) ju(Fl);
	}
	function ku(e, t) {
		var n = Nl;
		Nl |= 2;
		var r = wu(), a = Tu();
		Pl !== e || Il !== t ? (tu = null, eu = ye() + 500, xu(e, t)) : Bl = ze(e, t);
		a: do
			try {
				if (Ll !== 0 && Fl !== null) {
					t = Fl;
					var o = Rl;
					b: switch (Ll) {
						case 1:
							Ll = 0, Rl = null, Nu(e, t, o, 1);
							break;
						case 2:
						case 9:
							if (ma(o)) {
								Ll = 0, Rl = null, Mu(t);
								break;
							}
							t = function() {
								Ll !== 2 && Ll !== 9 || Pl !== e || (Ll = 7), rd(e);
							}, o.then(t, t);
							break a;
						case 3:
							Ll = 7;
							break a;
						case 4:
							Ll = 5;
							break a;
						case 7:
							ma(o) ? (Ll = 0, Rl = null, Mu(t)) : (Ll = 0, Rl = null, Nu(e, t, o, 7));
							break;
						case 5:
							var s = null;
							switch (Fl.tag) {
								case 26: s = Fl.memoizedState;
								case 5:
								case 27:
									var c = Fl;
									if (s ? Wf(s) : c.stateNode.complete) {
										Ll = 0, Rl = null;
										var l = c.sibling;
										if (l !== null) Fl = l;
										else {
											var u = c.return;
											u === null ? Fl = null : (Fl = u, Pu(u));
										}
										break b;
									}
							}
							Ll = 0, Rl = null, Nu(e, t, o, 5);
							break;
						case 6:
							Ll = 0, Rl = null, Nu(e, t, o, 6);
							break;
						case 8:
							bu(), Ul = 6;
							break a;
						default: throw Error(i(462));
					}
				}
				Au();
				break;
			} catch (t) {
				Su(e, t);
			}
		while (1);
		return Li = Ii = null, P.H = r, P.A = a, Nl = n, Fl === null ? (Pl = null, Il = 0, Wr(), Ul) : 0;
	}
	function Au() {
		for (; Fl !== null && !_e();) ju(Fl);
	}
	function ju(e) {
		var t = wc(e.alternate, e, Hl);
		e.memoizedProps = e.pendingProps, t === null ? Pu(e) : Fl = t;
	}
	function Mu(e) {
		var t = e, n = t.alternate;
		switch (t.tag) {
			case 15:
			case 0:
				t = cc(n, t, t.pendingProps, t.type, void 0, Il);
				break;
			case 11:
				t = cc(n, t, t.pendingProps, t.type.render, t.ref, Il);
				break;
			case 5: bo(t);
			default: Nc(n, t), t = Fl = ti(t, Hl), t = wc(n, t, Hl);
		}
		e.memoizedProps = e.pendingProps, t === null ? Pu(e) : Fl = t;
	}
	function Nu(e, t, n, r) {
		Li = Ii = null, bo(t), ba = null, xa = 0;
		var i = t.return;
		try {
			if (qs(e, i, t, n, Il)) {
				Ul = 1, Hs(e, si(n, e.current)), Fl = null;
				return;
			}
		} catch (t) {
			if (i !== null) throw Fl = i, t;
			Ul = 1, Hs(e, si(n, e.current)), Fl = null;
			return;
		}
		t.flags & 32768 ? (wi || r === 1 ? e = !0 : Bl || Il & 536870912 ? e = !1 : (zl = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = Ga.current, r !== null && r.tag === 13 && (r.flags |= 16384))), Fu(t, e)) : Pu(t);
	}
	function Pu(e) {
		var t = e;
		do {
			if (t.flags & 32768) {
				Fu(t, zl);
				return;
			}
			e = t.return;
			var n = jc(t.alternate, t, Hl);
			if (n !== null) {
				Fl = n;
				return;
			}
			if (t = t.sibling, t !== null) {
				Fl = t;
				return;
			}
			Fl = t = e;
		} while (t !== null);
		Ul === 0 && (Ul = 5);
	}
	function Fu(e, t) {
		do {
			var n = Mc(e.alternate, e);
			if (n !== null) {
				n.flags &= 32767, Fl = n;
				return;
			}
			if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
				Fl = e;
				return;
			}
			Fl = e = n;
		} while (e !== null);
		Ul = 6, Fl = null;
	}
	function Iu(e, t, n, r, a, o, s, c, l) {
		e.cancelPendingCommit = null;
		do
			Vu();
		while (ru !== 0);
		if (Nl & 6) throw Error(i(327));
		if (t !== null) {
			if (t === e.current) throw Error(i(177));
			if (o = t.lanes | t.childLanes, o |= Ur, We(e, n, o, s, c, l), e === Pl && (Fl = Pl = null, Il = 0), au = t, iu = e, ou = n, su = o, cu = a, lu = r, t.subtreeFlags & 10256 || t.flags & 10256 ? (e.callbackNode = null, e.callbackPriority = 0, Xu(Ce, function() {
				return Hu(), null;
			})) : (e.callbackNode = null, e.callbackPriority = 0), r = (t.flags & 13878) != 0, t.subtreeFlags & 13878 || r) {
				r = P.T, P.T = null, a = F.p, F.p = 2, s = Nl, Nl |= 4;
				try {
					Qc(e, t, n);
				} finally {
					Nl = s, F.p = a, P.T = r;
				}
			}
			ru = 1, Lu(), Ru(), zu();
		}
	}
	function Lu() {
		if (ru === 1) {
			ru = 0;
			var e = iu, t = au, n = (t.flags & 13878) != 0;
			if (t.subtreeFlags & 13878 || n) {
				n = P.T, P.T = null;
				var r = F.p;
				F.p = 2;
				var i = Nl;
				Nl |= 4;
				try {
					dl(t, e);
					var a = Bd, o = vr(e.containerInfo), s = a.focusedElem, c = a.selectionRange;
					if (o !== s && s && s.ownerDocument && _r(s.ownerDocument.documentElement, s)) {
						if (c !== null && yr(s)) {
							var l = c.start, u = c.end;
							if (u === void 0 && (u = l), "selectionStart" in s) s.selectionStart = l, s.selectionEnd = Math.min(u, s.value.length);
							else {
								var d = s.ownerDocument || document, f = d && d.defaultView || window;
								if (f.getSelection) {
									var p = f.getSelection(), m = s.textContent.length, h = Math.min(c.start, m), g = c.end === void 0 ? h : Math.min(c.end, m);
									!p.extend && h > g && (o = g, g = h, h = o);
									var _ = gr(s, h), v = gr(s, g);
									if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
										var y = d.createRange();
										y.setStart(_.node, _.offset), p.removeAllRanges(), h > g ? (p.addRange(y), p.extend(v.node, v.offset)) : (y.setEnd(v.node, v.offset), p.addRange(y));
									}
								}
							}
						}
						for (d = [], p = s; p = p.parentNode;) p.nodeType === 1 && d.push({
							element: p,
							left: p.scrollLeft,
							top: p.scrollTop
						});
						for (typeof s.focus == "function" && s.focus(), s = 0; s < d.length; s++) {
							var b = d[s];
							b.element.scrollLeft = b.left, b.element.scrollTop = b.top;
						}
					}
					sp = !!zd, Bd = zd = null;
				} finally {
					Nl = i, F.p = r, P.T = n;
				}
			}
			e.current = t, ru = 2;
		}
	}
	function Ru() {
		if (ru === 2) {
			ru = 0;
			var e = iu, t = au, n = (t.flags & 8772) != 0;
			if (t.subtreeFlags & 8772 || n) {
				n = P.T, P.T = null;
				var r = F.p;
				F.p = 2;
				var i = Nl;
				Nl |= 4;
				try {
					$c(e, t.alternate, t);
				} finally {
					Nl = i, F.p = r, P.T = n;
				}
			}
			ru = 3;
		}
	}
	function zu() {
		if (ru === 4 || ru === 3) {
			ru = 0, ve();
			var e = iu, t = au, n = ou, r = lu;
			t.subtreeFlags & 10256 || t.flags & 10256 ? ru = 5 : (ru = 0, au = iu = null, Bu(e, e.pendingLanes));
			var i = e.pendingLanes;
			if (i === 0 && (nu = null), Ye(n), t = t.stateNode, Oe && typeof Oe.onCommitFiberRoot == "function") try {
				Oe.onCommitFiberRoot(U, t, void 0, (t.current.flags & 128) == 128);
			} catch {}
			if (r !== null) {
				t = P.T, i = F.p, F.p = 2, P.T = null;
				try {
					for (var a = e.onRecoverableError, o = 0; o < r.length; o++) {
						var s = r[o];
						a(s.value, { componentStack: s.stack });
					}
				} finally {
					P.T = t, F.p = i;
				}
			}
			ou & 3 && Vu(), rd(e), i = e.pendingLanes, n & 261930 && i & 42 ? e === du ? uu++ : (uu = 0, du = e) : uu = 0, id(0, !1);
		}
	}
	function Bu(e, t) {
		(e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, $i(t)));
	}
	function Vu() {
		return Lu(), Ru(), zu(), Hu();
	}
	function Hu() {
		if (ru !== 5) return !1;
		var e = iu, t = su;
		su = 0;
		var n = Ye(ou), r = P.T, a = F.p;
		try {
			F.p = 32 > n ? 32 : n, P.T = null, n = cu, cu = null;
			var o = iu, s = ou;
			if (ru = 0, au = iu = null, ou = 0, Nl & 6) throw Error(i(331));
			var c = Nl;
			if (Nl |= 4, Ol(o.current), bl(o, o.current, s, n), Nl = c, id(0, !1), Oe && typeof Oe.onPostCommitFiberRoot == "function") try {
				Oe.onPostCommitFiberRoot(U, o);
			} catch {}
			return !0;
		} finally {
			F.p = a, P.T = r, Bu(e, t);
		}
	}
	function Uu(e, t, n) {
		t = si(n, t), t = Ws(e.stateNode, t, 2), e = Ma(e, t, 2), e !== null && (Ue(e, 2), rd(e));
	}
	function Wu(e, t, n) {
		if (e.tag === 3) Uu(e, e, n);
		else for (; t !== null;) {
			if (t.tag === 3) {
				Uu(t, e, n);
				break;
			} else if (t.tag === 1) {
				var r = t.stateNode;
				if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (nu === null || !nu.has(r))) {
					e = si(n, e), n = Gs(2), r = Ma(t, n, 2), r !== null && (Ks(n, r, t, e), Ue(r, 2), rd(r));
					break;
				}
			}
			t = t.return;
		}
	}
	function Gu(e, t, n) {
		var r = e.pingCache;
		if (r === null) {
			r = e.pingCache = new Ml();
			var i = /* @__PURE__ */ new Set();
			r.set(t, i);
		} else i = r.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
		i.has(n) || (Vl = !0, i.add(n), e = Ku.bind(null, e, t, n), t.then(e, e));
	}
	function Ku(e, t, n) {
		var r = e.pingCache;
		r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, Pl === e && (Il & n) === n && (Ul === 4 || Ul === 3 && (Il & 62914560) === Il && 300 > ye() - Ql ? !(Nl & 2) && xu(e, 0) : Kl |= n, Jl === Il && (Jl = 0)), rd(e);
	}
	function qu(e, t) {
		t === 0 && (t = Ve()), e = qr(e, t), e !== null && (Ue(e, t), rd(e));
	}
	function Ju(e) {
		var t = e.memoizedState, n = 0;
		t !== null && (n = t.retryLane), qu(e, n);
	}
	function Yu(e, t) {
		var n = 0;
		switch (e.tag) {
			case 31:
			case 13:
				var r = e.stateNode, a = e.memoizedState;
				a !== null && (n = a.retryLane);
				break;
			case 19:
				r = e.stateNode;
				break;
			case 22:
				r = e.stateNode._retryCache;
				break;
			default: throw Error(i(314));
		}
		r !== null && r.delete(t), qu(e, n);
	}
	function Xu(e, t) {
		return he(e, t);
	}
	var Zu = null, Qu = null, $u = !1, ed = !1, td = !1, nd = 0;
	function rd(e) {
		e !== Qu && e.next === null && (Qu === null ? Zu = Qu = e : Qu = Qu.next = e), ed = !0, $u || ($u = !0, ld());
	}
	function id(e, t) {
		if (!td && ed) {
			td = !0;
			do
				for (var n = !1, r = Zu; r !== null;) {
					if (!t) if (e !== 0) {
						var i = r.pendingLanes;
						if (i === 0) var a = 0;
						else {
							var o = r.suspendedLanes, s = r.pingedLanes;
							a = (1 << 31 - Ae(42 | e) + 1) - 1, a &= i & ~(o & ~s), a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0;
						}
						a !== 0 && (n = !0, Z(r, a));
					} else a = Il, a = Re(r, r === Pl ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== -1), !(a & 3) || ze(r, a) || (n = !0, Z(r, a));
					r = r.next;
				}
			while (n);
			td = !1;
		}
	}
	function ad() {
		od();
	}
	function od() {
		ed = $u = !1;
		var e = 0;
		nd !== 0 && Kd() && (e = nd);
		for (var t = ye(), n = null, r = Zu; r !== null;) {
			var i = r.next, a = sd(r, t);
			a === 0 ? (r.next = null, n === null ? Zu = i : n.next = i, i === null && (Qu = n)) : (n = r, (e !== 0 || a & 3) && (ed = !0)), r = i;
		}
		ru !== 0 && ru !== 5 || id(e, !1), nd !== 0 && (nd = 0);
	}
	function sd(e, t) {
		for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes & -62914561; 0 < a;) {
			var o = 31 - Ae(a), s = 1 << o, c = i[o];
			c === -1 ? ((s & n) === 0 || (s & r) !== 0) && (i[o] = Be(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s;
		}
		if (t = Pl, n = Il, n = Re(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r = e.callbackNode, n === 0 || e === t && (Ll === 2 || Ll === 9) || e.cancelPendingCommit !== null) return r !== null && r !== null && ge(r), e.callbackNode = null, e.callbackPriority = 0;
		if (!(n & 3) || ze(e, n)) {
			if (t = n & -n, t === e.callbackPriority) return t;
			switch (r !== null && ge(r), Ye(n)) {
				case 2:
				case 8:
					n = Se;
					break;
				case 32:
					n = Ce;
					break;
				case 268435456:
					n = Te;
					break;
				default: n = Ce;
			}
			return r = cd.bind(null, e), n = he(n, r), e.callbackPriority = t, e.callbackNode = n, t;
		}
		return r !== null && r !== null && ge(r), e.callbackPriority = 2, e.callbackNode = null, 2;
	}
	function cd(e, t) {
		if (ru !== 0 && ru !== 5) return e.callbackNode = null, e.callbackPriority = 0, null;
		var n = e.callbackNode;
		if (Vu() && e.callbackNode !== n) return null;
		var r = Il;
		return r = Re(e, e === Pl ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r === 0 ? null : (hu(e, r, t), sd(e, ye()), e.callbackNode != null && e.callbackNode === n ? cd.bind(null, e) : null);
	}
	function Z(e, t) {
		if (Vu()) return null;
		hu(e, t, !0);
	}
	function ld() {
		Xd(function() {
			Nl & 6 ? he(xe, ad) : od();
		});
	}
	function ud() {
		if (nd === 0) {
			var e = X;
			e === 0 && (e = Pe, Pe <<= 1, !(Pe & 261888) && (Pe = 256)), nd = e;
		}
		return nd;
	}
	function dd(e) {
		return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : G("" + e);
	}
	function fd(e, t) {
		var n = t.ownerDocument.createElement("input");
		return n.name = t.name, n.value = t.value, e.id && n.setAttribute("form", e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e;
	}
	function pd(e, t, n, r, i) {
		if (t === "submit" && n && n.stateNode === i) {
			var a = dd((i[et] || null).action), o = r.submitter;
			o && (t = (t = o[et] || null) ? dd(t.formAction) : o.getAttribute("formAction"), t !== null && (a = t, o = null));
			var s = new fn("action", "action", null, r, i);
			e.push({
				event: s,
				listeners: [{
					instance: null,
					listener: function() {
						if (r.defaultPrevented) {
							if (nd !== 0) {
								var e = o ? fd(i, o) : new FormData(i);
								gs(n, {
									pending: !0,
									data: e,
									method: i.method,
									action: a
								}, null, e);
							}
						} else typeof a == "function" && (s.preventDefault(), e = o ? fd(i, o) : new FormData(i), gs(n, {
							pending: !0,
							data: e,
							method: i.method,
							action: a
						}, a, e));
					},
					currentTarget: i
				}]
			});
		}
	}
	for (var md = 0; md < Rr.length; md++) {
		var hd = Rr[md];
		zr(hd.toLowerCase(), "on" + (hd[0].toUpperCase() + hd.slice(1)));
	}
	zr(jr, "onAnimationEnd"), zr(Mr, "onAnimationIteration"), zr(Nr, "onAnimationStart"), zr("dblclick", "onDoubleClick"), zr("focusin", "onFocus"), zr("focusout", "onBlur"), zr(Pr, "onTransitionRun"), zr(Fr, "onTransitionStart"), zr(q, "onTransitionCancel"), zr(Ir, "onTransitionEnd"), W("onMouseEnter", ["mouseout", "mouseover"]), W("onMouseLeave", ["mouseout", "mouseover"]), W("onPointerEnter", ["pointerout", "pointerover"]), W("onPointerLeave", ["pointerout", "pointerover"]), ht("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), ht("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), ht("onBeforeInput", [
		"compositionend",
		"keypress",
		"textInput",
		"paste"
	]), ht("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), ht("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), ht("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
	var gd = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), _d = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(gd));
	function vd(e, t) {
		t = (t & 4) != 0;
		for (var n = 0; n < e.length; n++) {
			var r = e[n], i = r.event;
			r = r.listeners;
			a: {
				var a = void 0;
				if (t) for (var o = r.length - 1; 0 <= o; o--) {
					var s = r[o], c = s.instance, l = s.currentTarget;
					if (s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						Br(e);
					}
					i.currentTarget = null, a = c;
				}
				else for (o = 0; o < r.length; o++) {
					if (s = r[o], c = s.instance, l = s.currentTarget, s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						Br(e);
					}
					i.currentTarget = null, a = c;
				}
			}
		}
	}
	function yd(e, t) {
		var n = t[nt];
		n === void 0 && (n = t[nt] = /* @__PURE__ */ new Set());
		var r = e + "__bubble";
		n.has(r) || (Cd(t, e, 2, !1), n.add(r));
	}
	function bd(e, t, n) {
		var r = 0;
		t && (r |= 4), Cd(n, e, r, t);
	}
	var xd = "_reactListening" + Math.random().toString(36).slice(2);
	function Sd(e) {
		if (!e[xd]) {
			e[xd] = !0, pt.forEach(function(t) {
				t !== "selectionchange" && (_d.has(t) || bd(t, !1, e), bd(t, !0, e));
			});
			var t = e.nodeType === 9 ? e : e.ownerDocument;
			t === null || t[xd] || (t[xd] = !0, bd("selectionchange", !1, t));
		}
	}
	function Cd(e, t, n, r) {
		switch (mp(t)) {
			case 2:
				var i = cp;
				break;
			case 8:
				i = lp;
				break;
			default: i = up;
		}
		n = i.bind(null, t, n, e), i = void 0, !en || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), r ? i === void 0 ? e.addEventListener(t, n, !0) : e.addEventListener(t, n, {
			capture: !0,
			passive: i
		}) : i === void 0 ? e.addEventListener(t, n, !1) : e.addEventListener(t, n, { passive: i });
	}
	function wd(e, t, n, r, i) {
		var a = r;
		if (!(t & 1) && !(t & 2) && r !== null) a: for (;;) {
			if (r === null) return;
			var s = r.tag;
			if (s === 3 || s === 4) {
				var c = r.stateNode.containerInfo;
				if (c === i) break;
				if (s === 4) for (s = r.return; s !== null;) {
					var l = s.tag;
					if ((l === 3 || l === 4) && s.stateNode.containerInfo === i) return;
					s = s.return;
				}
				for (; c !== null;) {
					if (s = ct(c), s === null) return;
					if (l = s.tag, l === 5 || l === 6 || l === 26 || l === 27) {
						r = a = s;
						continue a;
					}
					c = c.parentNode;
				}
			}
			r = r.return;
		}
		Zt(function() {
			var r = a, i = Kt(n), s = [];
			a: {
				var c = Lr.get(e);
				if (c !== void 0) {
					var l = fn, u = e;
					switch (e) {
						case "keypress": if (sn(n) === 0) break a;
						case "keydown":
						case "keyup":
							l = kn;
							break;
						case "focusin":
							u = "focus", l = bn;
							break;
						case "focusout":
							u = "blur", l = bn;
							break;
						case "beforeblur":
						case "afterblur":
							l = bn;
							break;
						case "click": if (n.button === 2) break a;
						case "auxclick":
						case "dblclick":
						case "mousedown":
						case "mousemove":
						case "mouseup":
						case "mouseout":
						case "mouseover":
						case "contextmenu":
							l = vn;
							break;
						case "drag":
						case "dragend":
						case "dragenter":
						case "dragexit":
						case "dragleave":
						case "dragover":
						case "dragstart":
						case "drop":
							l = yn;
							break;
						case "touchcancel":
						case "touchend":
						case "touchmove":
						case "touchstart":
							l = jn;
							break;
						case jr:
						case Mr:
						case Nr:
							l = xn;
							break;
						case Ir:
							l = Mn;
							break;
						case "scroll":
						case "scrollend":
							l = mn;
							break;
						case "wheel":
							l = Nn;
							break;
						case "copy":
						case "cut":
						case "paste":
							l = Sn;
							break;
						case "gotpointercapture":
						case "lostpointercapture":
						case "pointercancel":
						case "pointerdown":
						case "pointermove":
						case "pointerout":
						case "pointerover":
						case "pointerup":
							l = An;
							break;
						case "toggle":
						case "beforetoggle": l = Pn;
					}
					var d = (t & 4) != 0, f = !d && (e === "scroll" || e === "scrollend"), p = d ? c === null ? null : c + "Capture" : c;
					d = [];
					for (var m = r, h; m !== null;) {
						var g = m;
						if (h = g.stateNode, g = g.tag, g !== 5 && g !== 26 && g !== 27 || h === null || p === null || (g = Qt(m, p), g != null && d.push(Td(m, g, h))), f) break;
						m = m.return;
					}
					0 < d.length && (c = new l(c, u, null, n, i), s.push({
						event: c,
						listeners: d
					}));
				}
			}
			if (!(t & 7)) {
				a: {
					if (c = e === "mouseover" || e === "pointerover", l = e === "mouseout" || e === "pointerout", c && n !== Gt && (u = n.relatedTarget || n.fromElement) && (ct(u) || u[tt])) break a;
					if ((l || c) && (c = i.window === i ? i : (c = i.ownerDocument) ? c.defaultView || c.parentWindow : window, l ? (u = n.relatedTarget || n.toElement, l = r, u = u ? ct(u) : null, u !== null && (f = o(u), d = u.tag, u !== f || d !== 5 && d !== 27 && d !== 6) && (u = null)) : (l = null, u = r), l !== u)) {
						if (d = vn, g = "onMouseLeave", p = "onMouseEnter", m = "mouse", (e === "pointerout" || e === "pointerover") && (d = An, g = "onPointerLeave", p = "onPointerEnter", m = "pointer"), f = l == null ? c : ut(l), h = u == null ? c : ut(u), c = new d(g, m + "leave", l, n, i), c.target = f, c.relatedTarget = h, g = null, ct(i) === r && (d = new d(p, m + "enter", u, n, i), d.target = h, d.relatedTarget = f, g = d), f = g, l && u) b: {
							for (d = Dd, p = l, m = u, h = 0, g = p; g; g = d(g)) h++;
							g = 0;
							for (var _ = m; _; _ = d(_)) g++;
							for (; 0 < h - g;) p = d(p), h--;
							for (; 0 < g - h;) m = d(m), g--;
							for (; h--;) {
								if (p === m || m !== null && p === m.alternate) {
									d = p;
									break b;
								}
								p = d(p), m = d(m);
							}
							d = null;
						}
						else d = null;
						l !== null && Od(s, c, l, d, !1), u !== null && f !== null && Od(s, f, u, d, !0);
					}
				}
				a: {
					if (c = r ? ut(r) : window, l = c.nodeName && c.nodeName.toLowerCase(), l === "select" || l === "input" && c.type === "file") var v = tr;
					else if (Jn(c)) if (nr) v = dr;
					else {
						v = lr;
						var y = cr;
					}
					else l = c.nodeName, !l || l.toLowerCase() !== "input" || c.type !== "checkbox" && c.type !== "radio" ? r && Vt(r.elementType) && (v = tr) : v = ur;
					if (v &&= v(e, r)) {
						Yn(s, v, n, i);
						break a;
					}
					y && y(e, c, r), e === "focusout" && r && c.type === "number" && r.memoizedProps.value != null && Nt(c, "number", c.value);
				}
				switch (y = r ? ut(r) : window, e) {
					case "focusin":
						(Jn(y) || y.contentEditable === "true") && (xr = y, Sr = r, Cr = null);
						break;
					case "focusout":
						Cr = Sr = xr = null;
						break;
					case "mousedown":
						wr = !0;
						break;
					case "contextmenu":
					case "mouseup":
					case "dragend":
						wr = !1, Tr(s, n, i);
						break;
					case "selectionchange": if (br) break;
					case "keydown":
					case "keyup": Tr(s, n, i);
				}
				var b;
				if (In) b: {
					switch (e) {
						case "compositionstart":
							var x = "onCompositionStart";
							break b;
						case "compositionend":
							x = "onCompositionEnd";
							break b;
						case "compositionupdate":
							x = "onCompositionUpdate";
							break b;
					}
					x = void 0;
				}
				else Wn ? Hn(e, n) && (x = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (x = "onCompositionStart");
				x && (zn && n.locale !== "ko" && (Wn || x !== "onCompositionStart" ? x === "onCompositionEnd" && Wn && (b = on()) : (nn = i, rn = "value" in nn ? nn.value : nn.textContent, Wn = !0)), y = Ed(r, x), 0 < y.length && (x = new Cn(x, e, null, n, i), s.push({
					event: x,
					listeners: y
				}), b ? x.data = b : (b = Un(n), b !== null && (x.data = b)))), (b = Rn ? Gn(e, n) : Kn(e, n)) && (x = Ed(r, "onBeforeInput"), 0 < x.length && (y = new Cn("onBeforeInput", "beforeinput", null, n, i), s.push({
					event: y,
					listeners: x
				}), y.data = b)), pd(s, e, r, n, i);
			}
			vd(s, t);
		});
	}
	function Td(e, t, n) {
		return {
			instance: e,
			listener: t,
			currentTarget: n
		};
	}
	function Ed(e, t) {
		for (var n = t + "Capture", r = []; e !== null;) {
			var i = e, a = i.stateNode;
			if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || a === null || (i = Qt(e, n), i != null && r.unshift(Td(e, i, a)), i = Qt(e, t), i != null && r.push(Td(e, i, a))), e.tag === 3) return r;
			e = e.return;
		}
		return [];
	}
	function Dd(e) {
		if (e === null) return null;
		do
			e = e.return;
		while (e && e.tag !== 5 && e.tag !== 27);
		return e || null;
	}
	function Od(e, t, n, r, i) {
		for (var a = t._reactName, o = []; n !== null && n !== r;) {
			var s = n, c = s.alternate, l = s.stateNode;
			if (s = s.tag, c !== null && c === r) break;
			s !== 5 && s !== 26 && s !== 27 || l === null || (c = l, i ? (l = Qt(n, a), l != null && o.unshift(Td(n, l, c))) : i || (l = Qt(n, a), l != null && o.push(Td(n, l, c)))), n = n.return;
		}
		o.length !== 0 && e.push({
			event: t,
			listeners: o
		});
	}
	var kd = /\r\n?/g, Ad = /\u0000|\uFFFD/g;
	function jd(e) {
		return (typeof e == "string" ? e : "" + e).replace(kd, "\n").replace(Ad, "");
	}
	function Md(e, t) {
		return t = jd(t), jd(e) === t;
	}
	function Nd(e, t, n, r, a, o) {
		switch (n) {
			case "children":
				typeof r == "string" ? t === "body" || t === "textarea" && r === "" || Lt(e, r) : (typeof r == "number" || typeof r == "bigint") && t !== "body" && Lt(e, "" + r);
				break;
			case "className":
				xt(e, "class", r);
				break;
			case "tabIndex":
				xt(e, "tabindex", r);
				break;
			case "dir":
			case "role":
			case "viewBox":
			case "width":
			case "height":
				xt(e, n, r);
				break;
			case "style":
				Bt(e, r, o);
				break;
			case "data": if (t !== "object") {
				xt(e, "data", r);
				break;
			}
			case "src":
			case "href":
				if (r === "" && (t !== "a" || n !== "href")) {
					e.removeAttribute(n);
					break;
				}
				if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = G("" + r), e.setAttribute(n, r);
				break;
			case "action":
			case "formAction":
				if (typeof r == "function") {
					e.setAttribute(n, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
					break;
				} else typeof o == "function" && (n === "formAction" ? (t !== "input" && Nd(e, t, "name", a.name, a, null), Nd(e, t, "formEncType", a.formEncType, a, null), Nd(e, t, "formMethod", a.formMethod, a, null), Nd(e, t, "formTarget", a.formTarget, a, null)) : (Nd(e, t, "encType", a.encType, a, null), Nd(e, t, "method", a.method, a, null), Nd(e, t, "target", a.target, a, null)));
				if (r == null || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = G("" + r), e.setAttribute(n, r);
				break;
			case "onClick":
				r != null && (e.onclick = Wt);
				break;
			case "onScroll":
				r != null && yd("scroll", e);
				break;
			case "onScrollEnd":
				r != null && yd("scrollend", e);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						e.innerHTML = n;
					}
				}
				break;
			case "multiple":
				e.multiple = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "muted":
				e.muted = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "defaultValue":
			case "defaultChecked":
			case "innerHTML":
			case "ref": break;
			case "autoFocus": break;
			case "xlinkHref":
				if (r == null || typeof r == "function" || typeof r == "boolean" || typeof r == "symbol") {
					e.removeAttribute("xlink:href");
					break;
				}
				n = G("" + r), e.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", n);
				break;
			case "contentEditable":
			case "spellCheck":
			case "draggable":
			case "value":
			case "autoReverse":
			case "externalResourcesRequired":
			case "focusable":
			case "preserveAlpha":
				r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "" + r) : e.removeAttribute(n);
				break;
			case "inert":
			case "allowFullScreen":
			case "async":
			case "autoPlay":
			case "controls":
			case "default":
			case "defer":
			case "disabled":
			case "disablePictureInPicture":
			case "disableRemotePlayback":
			case "formNoValidate":
			case "hidden":
			case "loop":
			case "noModule":
			case "noValidate":
			case "open":
			case "playsInline":
			case "readOnly":
			case "required":
			case "reversed":
			case "scoped":
			case "seamless":
			case "itemScope":
				r && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "") : e.removeAttribute(n);
				break;
			case "capture":
			case "download":
				!0 === r ? e.setAttribute(n, "") : !1 !== r && r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "cols":
			case "rows":
			case "size":
			case "span":
				r != null && typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "rowSpan":
			case "start":
				r == null || typeof r == "function" || typeof r == "symbol" || isNaN(r) ? e.removeAttribute(n) : e.setAttribute(n, r);
				break;
			case "popover":
				yd("beforetoggle", e), yd("toggle", e), bt(e, "popover", r);
				break;
			case "xlinkActuate":
				St(e, "http://www.w3.org/1999/xlink", "xlink:actuate", r);
				break;
			case "xlinkArcrole":
				St(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", r);
				break;
			case "xlinkRole":
				St(e, "http://www.w3.org/1999/xlink", "xlink:role", r);
				break;
			case "xlinkShow":
				St(e, "http://www.w3.org/1999/xlink", "xlink:show", r);
				break;
			case "xlinkTitle":
				St(e, "http://www.w3.org/1999/xlink", "xlink:title", r);
				break;
			case "xlinkType":
				St(e, "http://www.w3.org/1999/xlink", "xlink:type", r);
				break;
			case "xmlBase":
				St(e, "http://www.w3.org/XML/1998/namespace", "xml:base", r);
				break;
			case "xmlLang":
				St(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", r);
				break;
			case "xmlSpace":
				St(e, "http://www.w3.org/XML/1998/namespace", "xml:space", r);
				break;
			case "is":
				bt(e, "is", r);
				break;
			case "innerText":
			case "textContent": break;
			default: (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = Ht.get(n) || n, bt(e, n, r));
		}
	}
	function Pd(e, t, n, r, a, o) {
		switch (n) {
			case "style":
				Bt(e, r, o);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						e.innerHTML = n;
					}
				}
				break;
			case "children":
				typeof r == "string" ? Lt(e, r) : (typeof r == "number" || typeof r == "bigint") && Lt(e, "" + r);
				break;
			case "onScroll":
				r != null && yd("scroll", e);
				break;
			case "onScrollEnd":
				r != null && yd("scrollend", e);
				break;
			case "onClick":
				r != null && (e.onclick = Wt);
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "innerHTML":
			case "ref": break;
			case "innerText":
			case "textContent": break;
			default: if (!mt.hasOwnProperty(n)) a: {
				if (n[0] === "o" && n[1] === "n" && (a = n.endsWith("Capture"), t = n.slice(2, a ? n.length - 7 : void 0), o = e[et] || null, o = o == null ? null : o[n], typeof o == "function" && e.removeEventListener(t, o, a), typeof r == "function")) {
					typeof o != "function" && o !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, r, a);
					break a;
				}
				n in e ? e[n] = r : !0 === r ? e.setAttribute(n, "") : bt(e, n, r);
			}
		}
	}
	function Fd(e, t, n) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "img":
				yd("error", e), yd("load", e);
				var r = !1, a = !1, o;
				for (o in n) if (n.hasOwnProperty(o)) {
					var s = n[o];
					if (s != null) switch (o) {
						case "src":
							r = !0;
							break;
						case "srcSet":
							a = !0;
							break;
						case "children":
						case "dangerouslySetInnerHTML": throw Error(i(137, t));
						default: Nd(e, t, o, s, n, null);
					}
				}
				a && Nd(e, t, "srcSet", n.srcSet, n, null), r && Nd(e, t, "src", n.src, n, null);
				return;
			case "input":
				yd("invalid", e);
				var c = o = s = a = null, l = null, u = null;
				for (r in n) if (n.hasOwnProperty(r)) {
					var d = n[r];
					if (d != null) switch (r) {
						case "name":
							a = d;
							break;
						case "type":
							s = d;
							break;
						case "checked":
							l = d;
							break;
						case "defaultChecked":
							u = d;
							break;
						case "value":
							o = d;
							break;
						case "defaultValue":
							c = d;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (d != null) throw Error(i(137, t));
							break;
						default: Nd(e, t, r, d, n, null);
					}
				}
				Mt(e, o, c, l, u, s, a, !1);
				return;
			case "select":
				for (a in yd("invalid", e), r = s = o = null, n) if (n.hasOwnProperty(a) && (c = n[a], c != null)) switch (a) {
					case "value":
						o = c;
						break;
					case "defaultValue":
						s = c;
						break;
					case "multiple": r = c;
					default: Nd(e, t, a, c, n, null);
				}
				t = o, n = s, e.multiple = !!r, t == null ? n != null && Pt(e, !!r, n, !0) : Pt(e, !!r, t, !1);
				return;
			case "textarea":
				for (s in yd("invalid", e), o = a = r = null, n) if (n.hasOwnProperty(s) && (c = n[s], c != null)) switch (s) {
					case "value":
						r = c;
						break;
					case "defaultValue":
						a = c;
						break;
					case "children":
						o = c;
						break;
					case "dangerouslySetInnerHTML":
						if (c != null) throw Error(i(91));
						break;
					default: Nd(e, t, s, c, n, null);
				}
				It(e, r, a, o);
				return;
			case "option":
				for (l in n) if (n.hasOwnProperty(l) && (r = n[l], r != null)) switch (l) {
					case "selected":
						e.selected = r && typeof r != "function" && typeof r != "symbol";
						break;
					default: Nd(e, t, l, r, n, null);
				}
				return;
			case "dialog":
				yd("beforetoggle", e), yd("toggle", e), yd("cancel", e), yd("close", e);
				break;
			case "iframe":
			case "object":
				yd("load", e);
				break;
			case "video":
			case "audio":
				for (r = 0; r < gd.length; r++) yd(gd[r], e);
				break;
			case "image":
				yd("error", e), yd("load", e);
				break;
			case "details":
				yd("toggle", e);
				break;
			case "embed":
			case "source":
			case "link": yd("error", e), yd("load", e);
			case "area":
			case "base":
			case "br":
			case "col":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "track":
			case "wbr":
			case "menuitem":
				for (u in n) if (n.hasOwnProperty(u) && (r = n[u], r != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML": throw Error(i(137, t));
					default: Nd(e, t, u, r, n, null);
				}
				return;
			default: if (Vt(t)) {
				for (d in n) n.hasOwnProperty(d) && (r = n[d], r !== void 0 && Pd(e, t, d, r, n, void 0));
				return;
			}
		}
		for (c in n) n.hasOwnProperty(c) && (r = n[c], r != null && Nd(e, t, c, r, n, null));
	}
	function Id(e, t, n, r) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "input":
				var a = null, o = null, s = null, c = null, l = null, u = null, d = null;
				for (m in n) {
					var f = n[m];
					if (n.hasOwnProperty(m) && f != null) switch (m) {
						case "checked": break;
						case "value": break;
						case "defaultValue": l = f;
						default: r.hasOwnProperty(m) || Nd(e, t, m, null, r, f);
					}
				}
				for (var p in r) {
					var m = r[p];
					if (f = n[p], r.hasOwnProperty(p) && (m != null || f != null)) switch (p) {
						case "type":
							o = m;
							break;
						case "name":
							a = m;
							break;
						case "checked":
							u = m;
							break;
						case "defaultChecked":
							d = m;
							break;
						case "value":
							s = m;
							break;
						case "defaultValue":
							c = m;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (m != null) throw Error(i(137, t));
							break;
						default: m !== f && Nd(e, t, p, m, r, f);
					}
				}
				jt(e, s, c, l, u, d, o, a);
				return;
			case "select":
				for (o in m = s = c = p = null, n) if (l = n[o], n.hasOwnProperty(o) && l != null) switch (o) {
					case "value": break;
					case "multiple": m = l;
					default: r.hasOwnProperty(o) || Nd(e, t, o, null, r, l);
				}
				for (a in r) if (o = r[a], l = n[a], r.hasOwnProperty(a) && (o != null || l != null)) switch (a) {
					case "value":
						p = o;
						break;
					case "defaultValue":
						c = o;
						break;
					case "multiple": s = o;
					default: o !== l && Nd(e, t, a, o, r, l);
				}
				t = c, n = s, r = m, p == null ? !!r != !!n && (t == null ? Pt(e, !!n, n ? [] : "", !1) : Pt(e, !!n, t, !0)) : Pt(e, !!n, p, !1);
				return;
			case "textarea":
				for (c in m = p = null, n) if (a = n[c], n.hasOwnProperty(c) && a != null && !r.hasOwnProperty(c)) switch (c) {
					case "value": break;
					case "children": break;
					default: Nd(e, t, c, null, r, a);
				}
				for (s in r) if (a = r[s], o = n[s], r.hasOwnProperty(s) && (a != null || o != null)) switch (s) {
					case "value":
						p = a;
						break;
					case "defaultValue":
						m = a;
						break;
					case "children": break;
					case "dangerouslySetInnerHTML":
						if (a != null) throw Error(i(91));
						break;
					default: a !== o && Nd(e, t, s, a, r, o);
				}
				Ft(e, p, m);
				return;
			case "option":
				for (var h in n) if (p = n[h], n.hasOwnProperty(h) && p != null && !r.hasOwnProperty(h)) switch (h) {
					case "selected":
						e.selected = !1;
						break;
					default: Nd(e, t, h, null, r, p);
				}
				for (l in r) if (p = r[l], m = n[l], r.hasOwnProperty(l) && p !== m && (p != null || m != null)) switch (l) {
					case "selected":
						e.selected = p && typeof p != "function" && typeof p != "symbol";
						break;
					default: Nd(e, t, l, p, r, m);
				}
				return;
			case "img":
			case "link":
			case "area":
			case "base":
			case "br":
			case "col":
			case "embed":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "source":
			case "track":
			case "wbr":
			case "menuitem":
				for (var g in n) p = n[g], n.hasOwnProperty(g) && p != null && !r.hasOwnProperty(g) && Nd(e, t, g, null, r, p);
				for (u in r) if (p = r[u], m = n[u], r.hasOwnProperty(u) && p !== m && (p != null || m != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML":
						if (p != null) throw Error(i(137, t));
						break;
					default: Nd(e, t, u, p, r, m);
				}
				return;
			default: if (Vt(t)) {
				for (var _ in n) p = n[_], n.hasOwnProperty(_) && p !== void 0 && !r.hasOwnProperty(_) && Pd(e, t, _, void 0, r, p);
				for (d in r) p = r[d], m = n[d], !r.hasOwnProperty(d) || p === m || p === void 0 && m === void 0 || Pd(e, t, d, p, r, m);
				return;
			}
		}
		for (var v in n) p = n[v], n.hasOwnProperty(v) && p != null && !r.hasOwnProperty(v) && Nd(e, t, v, null, r, p);
		for (f in r) p = r[f], m = n[f], !r.hasOwnProperty(f) || p === m || p == null && m == null || Nd(e, t, f, p, r, m);
	}
	function Ld(e) {
		switch (e) {
			case "css":
			case "script":
			case "font":
			case "img":
			case "image":
			case "input":
			case "link": return !0;
			default: return !1;
		}
	}
	function Rd() {
		if (typeof performance.getEntriesByType == "function") {
			for (var e = 0, t = 0, n = performance.getEntriesByType("resource"), r = 0; r < n.length; r++) {
				var i = n[r], a = i.transferSize, o = i.initiatorType, s = i.duration;
				if (a && s && Ld(o)) {
					for (o = 0, s = i.responseEnd, r += 1; r < n.length; r++) {
						var c = n[r], l = c.startTime;
						if (l > s) break;
						var u = c.transferSize, d = c.initiatorType;
						u && Ld(d) && (c = c.responseEnd, o += u * (c < s ? 1 : (s - l) / (c - l)));
					}
					if (--r, t += 8 * (a + o) / (i.duration / 1e3), e++, 10 < e) break;
				}
			}
			if (0 < e) return t / e / 1e6;
		}
		return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
	}
	var zd = null, Bd = null;
	function Vd(e) {
		return e.nodeType === 9 ? e : e.ownerDocument;
	}
	function Hd(e) {
		switch (e) {
			case "http://www.w3.org/2000/svg": return 1;
			case "http://www.w3.org/1998/Math/MathML": return 2;
			default: return 0;
		}
	}
	function Ud(e, t) {
		if (e === 0) switch (t) {
			case "svg": return 1;
			case "math": return 2;
			default: return 0;
		}
		return e === 1 && t === "foreignObject" ? 0 : e;
	}
	function Wd(e, t) {
		return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
	}
	var Gd = null;
	function Kd() {
		var e = window.event;
		return e && e.type === "popstate" ? e === Gd ? !1 : (Gd = e, !0) : (Gd = null, !1);
	}
	var qd = typeof setTimeout == "function" ? setTimeout : void 0, Jd = typeof clearTimeout == "function" ? clearTimeout : void 0, Yd = typeof Promise == "function" ? Promise : void 0, Xd = typeof queueMicrotask == "function" ? queueMicrotask : Yd === void 0 ? qd : function(e) {
		return Yd.resolve(null).then(e).catch(Zd);
	};
	function Zd(e) {
		setTimeout(function() {
			throw e;
		});
	}
	function Qd(e) {
		return e === "head";
	}
	function $d(e, t) {
		var n = t, r = 0;
		do {
			var i = n.nextSibling;
			if (e.removeChild(n), i && i.nodeType === 8) if (n = i.data, n === "/$" || n === "/&") {
				if (r === 0) {
					e.removeChild(i), Np(t);
					return;
				}
				r--;
			} else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&") r++;
			else if (n === "html") mf(e.ownerDocument.documentElement);
			else if (n === "head") {
				n = e.ownerDocument.head, mf(n);
				for (var a = n.firstChild; a;) {
					var o = a.nextSibling, s = a.nodeName;
					a[ot] || s === "SCRIPT" || s === "STYLE" || s === "LINK" && a.rel.toLowerCase() === "stylesheet" || n.removeChild(a), a = o;
				}
			} else n === "body" && mf(e.ownerDocument.body);
			n = i;
		} while (n);
		Np(t);
	}
	function ef(e, t) {
		var n = e;
		e = 0;
		do {
			var r = n.nextSibling;
			if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), r && r.nodeType === 8) if (n = r.data, n === "/$") {
				if (e === 0) break;
				e--;
			} else n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || e++;
			n = r;
		} while (n);
	}
	function tf(e) {
		var t = e.firstChild;
		for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
			var n = t;
			switch (t = t.nextSibling, n.nodeName) {
				case "HTML":
				case "HEAD":
				case "BODY":
					tf(n), st(n);
					continue;
				case "SCRIPT":
				case "STYLE": continue;
				case "LINK": if (n.rel.toLowerCase() === "stylesheet") continue;
			}
			e.removeChild(n);
		}
	}
	function nf(e, t, n, r) {
		for (; e.nodeType === 1;) {
			var i = n;
			if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
				if (!r && (e.nodeName !== "INPUT" || e.type !== "hidden")) break;
			} else if (!r) if (t === "input" && e.type === "hidden") {
				var a = i.name == null ? null : "" + i.name;
				if (i.type === "hidden" && e.getAttribute("name") === a) return e;
			} else return e;
			else if (!e[ot]) switch (t) {
				case "meta":
					if (!e.hasAttribute("itemprop")) break;
					return e;
				case "link":
					if (a = e.getAttribute("rel"), a === "stylesheet" && e.hasAttribute("data-precedence") || a !== i.rel || e.getAttribute("href") !== (i.href == null || i.href === "" ? null : i.href) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute("title") !== (i.title == null ? null : i.title)) break;
					return e;
				case "style":
					if (e.hasAttribute("data-precedence")) break;
					return e;
				case "script":
					if (a = e.getAttribute("src"), (a !== (i.src == null ? null : i.src) || e.getAttribute("type") !== (i.type == null ? null : i.type) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute("async") && !e.hasAttribute("itemprop")) break;
					return e;
				default: return e;
			}
			if (e = lf(e.nextSibling), e === null) break;
		}
		return null;
	}
	function rf(e, t, n) {
		if (t === "") return null;
		for (; e.nodeType !== 3;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !n || (e = lf(e.nextSibling), e === null)) return null;
		return e;
	}
	function af(e, t) {
		for (; e.nodeType !== 8;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = lf(e.nextSibling), e === null)) return null;
		return e;
	}
	function of(e) {
		return e.data === "$?" || e.data === "$~";
	}
	function sf(e) {
		return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
	}
	function cf(e, t) {
		var n = e.ownerDocument;
		if (e.data === "$~") e._reactRetry = t;
		else if (e.data !== "$?" || n.readyState !== "loading") t();
		else {
			var r = function() {
				t(), n.removeEventListener("DOMContentLoaded", r);
			};
			n.addEventListener("DOMContentLoaded", r), e._reactRetry = r;
		}
	}
	function lf(e) {
		for (; e != null; e = e.nextSibling) {
			var t = e.nodeType;
			if (t === 1 || t === 3) break;
			if (t === 8) {
				if (t = e.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F") break;
				if (t === "/$" || t === "/&") return null;
			}
		}
		return e;
	}
	var uf = null;
	function df(e) {
		e = e.nextSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "/$" || n === "/&") {
					if (t === 0) return lf(e.nextSibling);
					t--;
				} else n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || t++;
			}
			e = e.nextSibling;
		}
		return null;
	}
	function ff(e) {
		e = e.previousSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
					if (t === 0) return e;
					t--;
				} else n !== "/$" && n !== "/&" || t++;
			}
			e = e.previousSibling;
		}
		return null;
	}
	function pf(e, t, n) {
		switch (t = Vd(n), e) {
			case "html":
				if (e = t.documentElement, !e) throw Error(i(452));
				return e;
			case "head":
				if (e = t.head, !e) throw Error(i(453));
				return e;
			case "body":
				if (e = t.body, !e) throw Error(i(454));
				return e;
			default: throw Error(i(451));
		}
	}
	function mf(e) {
		for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
		st(e);
	}
	var hf = /* @__PURE__ */ new Map(), gf = /* @__PURE__ */ new Set();
	function _f(e) {
		return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
	}
	var vf = F.d;
	F.d = {
		f: yf,
		r: bf,
		D: Cf,
		C: wf,
		L: Tf,
		m: Ef,
		X: Of,
		S: Df,
		M: kf
	};
	function yf() {
		var e = vf.f(), t = yu();
		return e || t;
	}
	function bf(e) {
		var t = lt(e);
		t !== null && t.tag === 5 && t.type === "form" ? vs(t) : vf.r(e);
	}
	var xf = typeof document > "u" ? null : document;
	function Sf(e, t, n) {
		var r = xf;
		if (r && typeof t == "string" && t) {
			var i = At(t);
			i = "link[rel=\"" + e + "\"][href=\"" + i + "\"]", typeof n == "string" && (i += "[crossorigin=\"" + n + "\"]"), gf.has(i) || (gf.add(i), e = {
				rel: e,
				crossOrigin: n,
				href: t
			}, r.querySelector(i) === null && (t = r.createElement("link"), Fd(t, "link", e), ft(t), r.head.appendChild(t)));
		}
	}
	function Cf(e) {
		vf.D(e), Sf("dns-prefetch", e, null);
	}
	function wf(e, t) {
		vf.C(e, t), Sf("preconnect", e, t);
	}
	function Tf(e, t, n) {
		vf.L(e, t, n);
		var r = xf;
		if (r && e && t) {
			var i = "link[rel=\"preload\"][as=\"" + At(t) + "\"]";
			t === "image" && n && n.imageSrcSet ? (i += "[imagesrcset=\"" + At(n.imageSrcSet) + "\"]", typeof n.imageSizes == "string" && (i += "[imagesizes=\"" + At(n.imageSizes) + "\"]")) : i += "[href=\"" + At(e) + "\"]";
			var a = i;
			switch (t) {
				case "style":
					a = jf(e);
					break;
				case "script": a = Ff(e);
			}
			hf.has(a) || (e = f({
				rel: "preload",
				href: t === "image" && n && n.imageSrcSet ? void 0 : e,
				as: t
			}, n), hf.set(a, e), r.querySelector(i) !== null || t === "style" && r.querySelector(Mf(a)) || t === "script" && r.querySelector(Q(a)) || (t = r.createElement("link"), Fd(t, "link", e), ft(t), r.head.appendChild(t)));
		}
	}
	function Ef(e, t) {
		vf.m(e, t);
		var n = xf;
		if (n && e) {
			var r = t && typeof t.as == "string" ? t.as : "script", i = "link[rel=\"modulepreload\"][as=\"" + At(r) + "\"][href=\"" + At(e) + "\"]", a = i;
			switch (r) {
				case "audioworklet":
				case "paintworklet":
				case "serviceworker":
				case "sharedworker":
				case "worker":
				case "script": a = Ff(e);
			}
			if (!hf.has(a) && (e = f({
				rel: "modulepreload",
				href: e
			}, t), hf.set(a, e), n.querySelector(i) === null)) {
				switch (r) {
					case "audioworklet":
					case "paintworklet":
					case "serviceworker":
					case "sharedworker":
					case "worker":
					case "script": if (n.querySelector(Q(a))) return;
				}
				r = n.createElement("link"), Fd(r, "link", e), ft(r), n.head.appendChild(r);
			}
		}
	}
	function Df(e, t, n) {
		vf.S(e, t, n);
		var r = xf;
		if (r && e) {
			var i = dt(r).hoistableStyles, a = jf(e);
			t ||= "default";
			var o = i.get(a);
			if (!o) {
				var s = {
					loading: 0,
					preload: null
				};
				if (o = r.querySelector(Mf(a))) s.loading = 5;
				else {
					e = f({
						rel: "stylesheet",
						href: e,
						"data-precedence": t
					}, n), (n = hf.get(a)) && Rf(e, n);
					var c = o = r.createElement("link");
					ft(c), Fd(c, "link", e), c._p = new Promise(function(e, t) {
						c.onload = e, c.onerror = t;
					}), c.addEventListener("load", function() {
						s.loading |= 1;
					}), c.addEventListener("error", function() {
						s.loading |= 2;
					}), s.loading |= 4, Lf(o, t, r);
				}
				o = {
					type: "stylesheet",
					instance: o,
					count: 1,
					state: s
				}, i.set(a, o);
			}
		}
	}
	function Of(e, t) {
		vf.X(e, t);
		var n = xf;
		if (n && e) {
			var r = dt(n).hoistableScripts, i = Ff(e), a = r.get(i);
			a || (a = n.querySelector(Q(i)), a || (e = f({
				src: e,
				async: !0
			}, t), (t = hf.get(i)) && zf(e, t), a = n.createElement("script"), ft(a), Fd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function kf(e, t) {
		vf.M(e, t);
		var n = xf;
		if (n && e) {
			var r = dt(n).hoistableScripts, i = Ff(e), a = r.get(i);
			a || (a = n.querySelector(Q(i)), a || (e = f({
				src: e,
				async: !0,
				type: "module"
			}, t), (t = hf.get(i)) && zf(e, t), a = n.createElement("script"), ft(a), Fd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function Af(e, t, n, r) {
		var a = (a = ne.current) ? _f(a) : null;
		if (!a) throw Error(i(446));
		switch (e) {
			case "meta":
			case "title": return null;
			case "style": return typeof n.precedence == "string" && typeof n.href == "string" ? (t = jf(n.href), n = dt(a).hoistableStyles, r = n.get(t), r || (r = {
				type: "style",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			case "link":
				if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
					e = jf(n.href);
					var o = dt(a).hoistableStyles, s = o.get(e);
					if (s || (a = a.ownerDocument || a, s = {
						type: "stylesheet",
						instance: null,
						count: 0,
						state: {
							loading: 0,
							preload: null
						}
					}, o.set(e, s), (o = a.querySelector(Mf(e))) && !o._p && (s.instance = o, s.state.loading = 5), hf.has(e) || (n = {
						rel: "preload",
						as: "style",
						href: n.href,
						crossOrigin: n.crossOrigin,
						integrity: n.integrity,
						media: n.media,
						hrefLang: n.hrefLang,
						referrerPolicy: n.referrerPolicy
					}, hf.set(e, n), o || Pf(a, e, n, s.state))), t && r === null) throw Error(i(528, ""));
					return s;
				}
				if (t && r !== null) throw Error(i(529, ""));
				return null;
			case "script": return t = n.async, n = n.src, typeof n == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = Ff(n), n = dt(a).hoistableScripts, r = n.get(t), r || (r = {
				type: "script",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			default: throw Error(i(444, e));
		}
	}
	function jf(e) {
		return "href=\"" + At(e) + "\"";
	}
	function Mf(e) {
		return "link[rel=\"stylesheet\"][" + e + "]";
	}
	function Nf(e) {
		return f({}, e, {
			"data-precedence": e.precedence,
			precedence: null
		});
	}
	function Pf(e, t, n, r) {
		e.querySelector("link[rel=\"preload\"][as=\"style\"][" + t + "]") ? r.loading = 1 : (t = e.createElement("link"), r.preload = t, t.addEventListener("load", function() {
			return r.loading |= 1;
		}), t.addEventListener("error", function() {
			return r.loading |= 2;
		}), Fd(t, "link", n), ft(t), e.head.appendChild(t));
	}
	function Ff(e) {
		return "[src=\"" + At(e) + "\"]";
	}
	function Q(e) {
		return "script[async]" + e;
	}
	function If(e, t, n) {
		if (t.count++, t.instance === null) switch (t.type) {
			case "style":
				var r = e.querySelector("style[data-href~=\"" + At(n.href) + "\"]");
				if (r) return t.instance = r, ft(r), r;
				var a = f({}, n, {
					"data-href": n.href,
					"data-precedence": n.precedence,
					href: null,
					precedence: null
				});
				return r = (e.ownerDocument || e).createElement("style"), ft(r), Fd(r, "style", a), Lf(r, n.precedence, e), t.instance = r;
			case "stylesheet":
				a = jf(n.href);
				var o = e.querySelector(Mf(a));
				if (o) return t.state.loading |= 4, t.instance = o, ft(o), o;
				r = Nf(n), (a = hf.get(a)) && Rf(r, a), o = (e.ownerDocument || e).createElement("link"), ft(o);
				var s = o;
				return s._p = new Promise(function(e, t) {
					s.onload = e, s.onerror = t;
				}), Fd(o, "link", r), t.state.loading |= 4, Lf(o, n.precedence, e), t.instance = o;
			case "script": return o = Ff(n.src), (a = e.querySelector(Q(o))) ? (t.instance = a, ft(a), a) : (r = n, (a = hf.get(o)) && (r = f({}, n), zf(r, a)), e = e.ownerDocument || e, a = e.createElement("script"), ft(a), Fd(a, "link", r), e.head.appendChild(a), t.instance = a);
			case "void": return null;
			default: throw Error(i(443, t.type));
		}
		else t.type === "stylesheet" && !(t.state.loading & 4) && (r = t.instance, t.state.loading |= 4, Lf(r, n.precedence, e));
		return t.instance;
	}
	function Lf(e, t, n) {
		for (var r = n.querySelectorAll("link[rel=\"stylesheet\"][data-precedence],style[data-precedence]"), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
			var s = r[o];
			if (s.dataset.precedence === t) a = s;
			else if (a !== i) break;
		}
		a ? a.parentNode.insertBefore(e, a.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
	}
	function Rf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.title ??= t.title;
	}
	function zf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.integrity ??= t.integrity;
	}
	var Bf = null;
	function Vf(e, t, n) {
		if (Bf === null) {
			var r = /* @__PURE__ */ new Map(), i = Bf = /* @__PURE__ */ new Map();
			i.set(n, r);
		} else i = Bf, r = i.get(n), r || (r = /* @__PURE__ */ new Map(), i.set(n, r));
		if (r.has(e)) return r;
		for (r.set(e, null), n = n.getElementsByTagName(e), i = 0; i < n.length; i++) {
			var a = n[i];
			if (!(a[ot] || a[$e] || e === "link" && a.getAttribute("rel") === "stylesheet") && a.namespaceURI !== "http://www.w3.org/2000/svg") {
				var o = a.getAttribute(t) || "";
				o = e + o;
				var s = r.get(o);
				s ? s.push(a) : r.set(o, [a]);
			}
		}
		return r;
	}
	function Hf(e, t, n) {
		e = e.ownerDocument || e, e.head.insertBefore(n, t === "title" ? e.querySelector("head > title") : null);
	}
	function Uf(e, t, n) {
		if (n === 1 || t.itemProp != null) return !1;
		switch (e) {
			case "meta":
			case "title": return !0;
			case "style":
				if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "") break;
				return !0;
			case "link":
				if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError) break;
				switch (t.rel) {
					case "stylesheet": return e = t.disabled, typeof t.precedence == "string" && e == null;
					default: return !0;
				}
			case "script": if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string") return !0;
		}
		return !1;
	}
	function Wf(e) {
		return !(e.type === "stylesheet" && !(e.state.loading & 3));
	}
	function Gf(e, t, n, r) {
		if (n.type === "stylesheet" && (typeof r.media != "string" || !1 !== matchMedia(r.media).matches) && !(n.state.loading & 4)) {
			if (n.instance === null) {
				var i = jf(r.href), a = t.querySelector(Mf(i));
				if (a) {
					t = a._p, typeof t == "object" && t && typeof t.then == "function" && (e.count++, e = Jf.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = a, ft(a);
					return;
				}
				a = t.ownerDocument || t, r = Nf(r), (i = hf.get(i)) && Rf(r, i), a = a.createElement("link"), ft(a);
				var o = a;
				o._p = new Promise(function(e, t) {
					o.onload = e, o.onerror = t;
				}), Fd(a, "link", r), n.instance = a;
			}
			e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && !(n.state.loading & 3) && (e.count++, n = Jf.bind(e), t.addEventListener("load", n), t.addEventListener("error", n));
		}
	}
	var Kf = 0;
	function qf(e, t) {
		return e.stylesheets && e.count === 0 && Xf(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(n) {
			var r = setTimeout(function() {
				if (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, 6e4 + t);
			0 < e.imgBytes && Kf === 0 && (Kf = 62500 * Rd());
			var i = setTimeout(function() {
				if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend)) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, (e.imgBytes > Kf ? 50 : 800) + t);
			return e.unsuspend = n, function() {
				e.unsuspend = null, clearTimeout(r), clearTimeout(i);
			};
		} : null;
	}
	function Jf() {
		if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
			if (this.stylesheets) Xf(this, this.stylesheets);
			else if (this.unsuspend) {
				var e = this.unsuspend;
				this.unsuspend = null, e();
			}
		}
	}
	var Yf = null;
	function Xf(e, t) {
		e.stylesheets = null, e.unsuspend !== null && (e.count++, Yf = /* @__PURE__ */ new Map(), t.forEach(Zf, e), Yf = null, Jf.call(e));
	}
	function Zf(e, t) {
		if (!(t.state.loading & 4)) {
			var n = Yf.get(e);
			if (n) var r = n.get(null);
			else {
				n = /* @__PURE__ */ new Map(), Yf.set(e, n);
				for (var i = e.querySelectorAll("link[data-precedence],style[data-precedence]"), a = 0; a < i.length; a++) {
					var o = i[a];
					(o.nodeName === "LINK" || o.getAttribute("media") !== "not all") && (n.set(o.dataset.precedence, o), r = o);
				}
				r && n.set(null, r);
			}
			i = t.instance, o = i.getAttribute("data-precedence"), a = n.get(o) || r, a === r && n.set(null, i), n.set(o, i), this.count++, r = Jf.bind(this), i.addEventListener("load", r), i.addEventListener("error", r), a ? a.parentNode.insertBefore(i, a.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(i, e.firstChild)), t.state.loading |= 4;
		}
	}
	var Qf = {
		$$typeof: x,
		Provider: null,
		Consumer: null,
		_currentValue: I,
		_currentValue2: I,
		_threadCount: 0
	};
	function $f(e, t, n, r, i, a, o, s, c) {
		this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = He(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = He(0), this.hiddenUpdates = He(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c, this.incompleteTransitions = /* @__PURE__ */ new Map();
	}
	function ep(e, t, n, r, i, a, o, s, c, l, u, d) {
		return e = new $f(e, t, n, o, c, l, u, d, s), t = 1, !0 === a && (t |= 24), a = Qr(3, null, null, t), e.current = a, a.stateNode = e, t = Qi(), t.refCount++, e.pooledCache = t, t.refCount++, a.memoizedState = {
			element: r,
			isDehydrated: n,
			cache: t
		}, ka(a), e;
	}
	function tp(e) {
		return e ? (e = Xr, e) : Xr;
	}
	function np(e, t, n, r, i, a) {
		i = tp(i), r.context === null ? r.context = i : r.pendingContext = i, r = ja(t), r.payload = { element: n }, a = a === void 0 ? null : a, a !== null && (r.callback = a), n = Ma(e, r, t), n !== null && (mu(n, e, t), Na(n, e, t));
	}
	function rp(e, t) {
		if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
			var n = e.retryLane;
			e.retryLane = n !== 0 && n < t ? n : t;
		}
	}
	function ip(e, t) {
		rp(e, t), (e = e.alternate) && rp(e, t);
	}
	function ap(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = qr(e, 67108864);
			t !== null && mu(t, e, 67108864), ip(e, 67108864);
		}
	}
	function op(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = fu();
			t = Je(t);
			var n = qr(e, t);
			n !== null && mu(n, e, t), ip(e, t);
		}
	}
	var sp = !0;
	function cp(e, t, n, r) {
		var i = P.T;
		P.T = null;
		var a = F.p;
		try {
			F.p = 2, up(e, t, n, r);
		} finally {
			F.p = a, P.T = i;
		}
	}
	function lp(e, t, n, r) {
		var i = P.T;
		P.T = null;
		var a = F.p;
		try {
			F.p = 8, up(e, t, n, r);
		} finally {
			F.p = a, P.T = i;
		}
	}
	function up(e, t, n, r) {
		if (sp) {
			var i = dp(r);
			if (i === null) wd(e, t, r, fp, n), Cp(e, r);
			else if (Tp(i, e, t, n, r)) r.stopPropagation();
			else if (Cp(e, r), t & 4 && -1 < Sp.indexOf(e)) {
				for (; i !== null;) {
					var a = lt(i);
					if (a !== null) switch (a.tag) {
						case 3:
							if (a = a.stateNode, a.current.memoizedState.isDehydrated) {
								var o = Le(a.pendingLanes);
								if (o !== 0) {
									var s = a;
									for (s.pendingLanes |= 2, s.entangledLanes |= 2; o;) {
										var c = 1 << 31 - Ae(o);
										s.entanglements[1] |= c, o &= ~c;
									}
									rd(a), !(Nl & 6) && (eu = ye() + 500, id(0, !1));
								}
							}
							break;
						case 31:
						case 13: s = qr(a, 2), s !== null && mu(s, a, 2), yu(), ip(a, 2);
					}
					if (a = dp(r), a === null && wd(e, t, r, fp, n), a === i) break;
					i = a;
				}
				i !== null && r.stopPropagation();
			} else wd(e, t, r, null, n);
		}
	}
	function dp(e) {
		return e = Kt(e), pp(e);
	}
	var fp = null;
	function pp(e) {
		if (fp = null, e = ct(e), e !== null) {
			var t = o(e);
			if (t === null) e = null;
			else {
				var n = t.tag;
				if (n === 13) {
					if (e = s(t), e !== null) return e;
					e = null;
				} else if (n === 31) {
					if (e = c(t), e !== null) return e;
					e = null;
				} else if (n === 3) {
					if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
					e = null;
				} else t !== e && (e = null);
			}
		}
		return fp = e, null;
	}
	function mp(e) {
		switch (e) {
			case "beforetoggle":
			case "cancel":
			case "click":
			case "close":
			case "contextmenu":
			case "copy":
			case "cut":
			case "auxclick":
			case "dblclick":
			case "dragend":
			case "dragstart":
			case "drop":
			case "focusin":
			case "focusout":
			case "input":
			case "invalid":
			case "keydown":
			case "keypress":
			case "keyup":
			case "mousedown":
			case "mouseup":
			case "paste":
			case "pause":
			case "play":
			case "pointercancel":
			case "pointerdown":
			case "pointerup":
			case "ratechange":
			case "reset":
			case "resize":
			case "seeked":
			case "submit":
			case "toggle":
			case "touchcancel":
			case "touchend":
			case "touchstart":
			case "volumechange":
			case "change":
			case "selectionchange":
			case "textInput":
			case "compositionstart":
			case "compositionend":
			case "compositionupdate":
			case "beforeblur":
			case "afterblur":
			case "beforeinput":
			case "blur":
			case "fullscreenchange":
			case "focus":
			case "hashchange":
			case "popstate":
			case "select":
			case "selectstart": return 2;
			case "drag":
			case "dragenter":
			case "dragexit":
			case "dragleave":
			case "dragover":
			case "mousemove":
			case "mouseout":
			case "mouseover":
			case "pointermove":
			case "pointerout":
			case "pointerover":
			case "scroll":
			case "touchmove":
			case "wheel":
			case "mouseenter":
			case "mouseleave":
			case "pointerenter":
			case "pointerleave": return 8;
			case "message": switch (be()) {
				case xe: return 2;
				case Se: return 8;
				case Ce:
				case we: return 32;
				case Te: return 268435456;
				default: return 32;
			}
			default: return 32;
		}
	}
	var hp = !1, gp = null, _p = null, vp = null, yp = /* @__PURE__ */ new Map(), bp = /* @__PURE__ */ new Map(), xp = [], Sp = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
	function Cp(e, t) {
		switch (e) {
			case "focusin":
			case "focusout":
				gp = null;
				break;
			case "dragenter":
			case "dragleave":
				_p = null;
				break;
			case "mouseover":
			case "mouseout":
				vp = null;
				break;
			case "pointerover":
			case "pointerout":
				yp.delete(t.pointerId);
				break;
			case "gotpointercapture":
			case "lostpointercapture": bp.delete(t.pointerId);
		}
	}
	function wp(e, t, n, r, i, a) {
		return e === null || e.nativeEvent !== a ? (e = {
			blockedOn: t,
			domEventName: n,
			eventSystemFlags: r,
			nativeEvent: a,
			targetContainers: [i]
		}, t !== null && (t = lt(t), t !== null && ap(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
	}
	function Tp(e, t, n, r, i) {
		switch (t) {
			case "focusin": return gp = wp(gp, e, t, n, r, i), !0;
			case "dragenter": return _p = wp(_p, e, t, n, r, i), !0;
			case "mouseover": return vp = wp(vp, e, t, n, r, i), !0;
			case "pointerover":
				var a = i.pointerId;
				return yp.set(a, wp(yp.get(a) || null, e, t, n, r, i)), !0;
			case "gotpointercapture": return a = i.pointerId, bp.set(a, wp(bp.get(a) || null, e, t, n, r, i)), !0;
		}
		return !1;
	}
	function Ep(e) {
		var t = ct(e.target);
		if (t !== null) {
			var n = o(t);
			if (n !== null) {
				if (t = n.tag, t === 13) {
					if (t = s(n), t !== null) {
						e.blockedOn = t, Ze(e.priority, function() {
							op(n);
						});
						return;
					}
				} else if (t === 31) {
					if (t = c(n), t !== null) {
						e.blockedOn = t, Ze(e.priority, function() {
							op(n);
						});
						return;
					}
				} else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
					e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
					return;
				}
			}
		}
		e.blockedOn = null;
	}
	function Dp(e) {
		if (e.blockedOn !== null) return !1;
		for (var t = e.targetContainers; 0 < t.length;) {
			var n = dp(e.nativeEvent);
			if (n === null) {
				n = e.nativeEvent;
				var r = new n.constructor(n.type, n);
				Gt = r, n.target.dispatchEvent(r), Gt = null;
			} else return t = lt(n), t !== null && ap(t), e.blockedOn = n, !1;
			t.shift();
		}
		return !0;
	}
	function Op(e, t, n) {
		Dp(e) && n.delete(t);
	}
	function kp() {
		hp = !1, gp !== null && Dp(gp) && (gp = null), _p !== null && Dp(_p) && (_p = null), vp !== null && Dp(vp) && (vp = null), yp.forEach(Op), bp.forEach(Op);
	}
	function Ap(e, n) {
		e.blockedOn === n && (e.blockedOn = null, hp || (hp = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, kp)));
	}
	var jp = null;
	function Mp(e) {
		jp !== e && (jp = e, t.unstable_scheduleCallback(t.unstable_NormalPriority, function() {
			jp === e && (jp = null);
			for (var t = 0; t < e.length; t += 3) {
				var n = e[t], r = e[t + 1], i = e[t + 2];
				if (typeof r != "function") {
					if (pp(r || n) === null) continue;
					break;
				}
				var a = lt(n);
				a !== null && (e.splice(t, 3), t -= 3, gs(a, {
					pending: !0,
					data: i,
					method: n.method,
					action: r
				}, r, i));
			}
		}));
	}
	function Np(e) {
		function t(t) {
			return Ap(t, e);
		}
		gp !== null && Ap(gp, e), _p !== null && Ap(_p, e), vp !== null && Ap(vp, e), yp.forEach(t), bp.forEach(t);
		for (var n = 0; n < xp.length; n++) {
			var r = xp[n];
			r.blockedOn === e && (r.blockedOn = null);
		}
		for (; 0 < xp.length && (n = xp[0], n.blockedOn === null);) Ep(n), n.blockedOn === null && xp.shift();
		if (n = (e.ownerDocument || e).$$reactFormReplay, n != null) for (r = 0; r < n.length; r += 3) {
			var i = n[r], a = n[r + 1], o = i[et] || null;
			if (typeof a == "function") o || Mp(n);
			else if (o) {
				var s = null;
				if (a && a.hasAttribute("formAction")) {
					if (i = a, o = a[et] || null) s = o.formAction;
					else if (pp(i) !== null) continue;
				} else s = o.action;
				typeof s == "function" ? n[r + 1] = s : (n.splice(r, 3), r -= 3), Mp(n);
			}
		}
	}
	function Pp() {
		function e(e) {
			e.canIntercept && e.info === "react-transition" && e.intercept({
				handler: function() {
					return new Promise(function(e) {
						return i = e;
					});
				},
				focusReset: "manual",
				scroll: "manual"
			});
		}
		function t() {
			i !== null && (i(), i = null), r || setTimeout(n, 20);
		}
		function n() {
			if (!r && !navigation.transition) {
				var e = navigation.currentEntry;
				e && e.url != null && navigation.navigate(e.url, {
					state: e.getState(),
					info: "react-transition",
					history: "replace"
				});
			}
		}
		if (typeof navigation == "object") {
			var r = !1, i = null;
			return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(n, 100), function() {
				r = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), i !== null && (i(), i = null);
			};
		}
	}
	function Fp(e) {
		this._internalRoot = e;
	}
	Ip.prototype.render = Fp.prototype.render = function(e) {
		var t = this._internalRoot;
		if (t === null) throw Error(i(409));
		var n = t.current;
		np(n, fu(), e, t, null, null);
	}, Ip.prototype.unmount = Fp.prototype.unmount = function() {
		var e = this._internalRoot;
		if (e !== null) {
			this._internalRoot = null;
			var t = e.containerInfo;
			np(e.current, 2, null, e, null, null), yu(), t[tt] = null;
		}
	};
	function Ip(e) {
		this._internalRoot = e;
	}
	Ip.prototype.unstable_scheduleHydration = function(e) {
		if (e) {
			var t = Xe();
			e = {
				blockedOn: null,
				target: e,
				priority: t
			};
			for (var n = 0; n < xp.length && t !== 0 && t < xp[n].priority; n++);
			xp.splice(n, 0, e), n === 0 && Ep(e);
		}
	};
	var Lp = n.version;
	if (Lp !== "19.2.4") throw Error(i(527, Lp, "19.2.4"));
	F.findDOMNode = function(e) {
		var t = e._reactInternals;
		if (t === void 0) throw typeof e.render == "function" ? Error(i(188)) : (e = Object.keys(e).join(","), Error(i(268, e)));
		return e = u(t), e = e === null ? null : d(e), e = e === null ? null : e.stateNode, e;
	};
	var Rp = {
		bundleType: 0,
		version: "19.2.4",
		rendererPackageName: "react-dom",
		currentDispatcherRef: P,
		reconcilerVersion: "19.2.4"
	};
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
		var zp = __REACT_DEVTOOLS_GLOBAL_HOOK__;
		if (!zp.isDisabled && zp.supportsFiber) try {
			U = zp.inject(Rp), Oe = zp;
		} catch {}
	}
	e.createRoot = function(e, t) {
		if (!a(e)) throw Error(i(299));
		var n = !1, r = "", o = zs, s = Bs, c = Vs;
		return t != null && (!0 === t.unstable_strictMode && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (o = t.onUncaughtError), t.onCaughtError !== void 0 && (s = t.onCaughtError), t.onRecoverableError !== void 0 && (c = t.onRecoverableError)), t = ep(e, 1, !1, null, null, n, r, null, o, s, c, Pp), e[tt] = t.current, Sd(e), new Fp(t);
	}, e.hydrateRoot = function(e, t, n) {
		if (!a(e)) throw Error(i(299));
		var r = !1, o = "", s = zs, c = Bs, l = Vs, u = null;
		return n != null && (!0 === n.unstable_strictMode && (r = !0), n.identifierPrefix !== void 0 && (o = n.identifierPrefix), n.onUncaughtError !== void 0 && (s = n.onUncaughtError), n.onCaughtError !== void 0 && (c = n.onCaughtError), n.onRecoverableError !== void 0 && (l = n.onRecoverableError), n.formState !== void 0 && (u = n.formState)), t = ep(e, 1, !0, t, n ?? null, r, o, u, s, c, l, Pp), t.context = tp(null), n = t.current, r = fu(), r = Je(r), o = ja(r), o.callback = null, Ma(n, o, r), n = r, t.current.lanes = n, Ue(t, n), rd(t), e[tt] = t.current, Sd(e), new Ip(t);
	}, e.version = "19.2.4";
})), YT = /* @__PURE__ */ o(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e, t) {
			for (e = e.memoizedState; e !== null && 0 < t;) e = e.next, t--;
			return e;
		}
		function n(e, t, r, i) {
			if (r >= t.length) return i;
			var a = t[r], o = Ff(e) ? e.slice() : _f({}, e);
			return o[a] = n(e[a], t, r + 1, i), o;
		}
		function r(e, t, n) {
			if (t.length !== n.length) console.warn("copyWithRename() expects paths of the same length");
			else {
				for (var r = 0; r < n.length - 1; r++) if (t[r] !== n[r]) {
					console.warn("copyWithRename() expects paths to be the same except for the deepest key");
					return;
				}
				return i(e, t, n, 0);
			}
		}
		function i(e, t, n, r) {
			var a = t[r], o = Ff(e) ? e.slice() : _f({}, e);
			return r + 1 === t.length ? (o[n[r]] = o[a], Ff(o) ? o.splice(a, 1) : delete o[a]) : o[a] = i(e[a], t, n, r + 1), o;
		}
		function a(e, t, n) {
			var r = t[n], i = Ff(e) ? e.slice() : _f({}, e);
			return n + 1 === t.length ? (Ff(i) ? i.splice(r, 1) : delete i[r], i) : (i[r] = a(e[r], t, n + 1), i);
		}
		function o() {
			return !1;
		}
		function s() {
			return null;
		}
		function c() {
			console.error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks");
		}
		function l() {
			console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
		}
		function u() {}
		function d() {}
		function f(e) {
			var t = [];
			return e.forEach(function(e) {
				t.push(e);
			}), t.sort().join(", ");
		}
		function p(e, t, n, r) {
			return new ir(e, t, n, r);
		}
		function h(e, t) {
			e.context === wg && (Vd(e.current, 2, t, e, null, null), Kc());
		}
		function g(e, t) {
			if (Tg !== null) {
				var n = t.staleFamilies;
				t = t.updatedFamilies, vl(), rr(e.current, t, n), Kc();
			}
		}
		function _(e) {
			Tg = e;
		}
		function v(e) {
			return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
		}
		function y(e) {
			var t = e, n = e;
			if (e.alternate) for (; t.return;) t = t.return;
			else {
				e = t;
				do
					t = e, t.flags & 4098 && (n = t.return), e = t.return;
				while (e);
			}
			return t.tag === 3 ? n : null;
		}
		function b(e) {
			if (e.tag === 13) {
				var t = e.memoizedState;
				if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
			}
			return null;
		}
		function x(e) {
			if (e.tag === 31) {
				var t = e.memoizedState;
				if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
			}
			return null;
		}
		function S(e) {
			if (y(e) !== e) throw Error("Unable to find node on an unmounted component.");
		}
		function C(e) {
			var t = e.alternate;
			if (!t) {
				if (t = y(e), t === null) throw Error("Unable to find node on an unmounted component.");
				return t === e ? e : null;
			}
			for (var n = e, r = t;;) {
				var i = n.return;
				if (i === null) break;
				var a = i.alternate;
				if (a === null) {
					if (r = i.return, r !== null) {
						n = r;
						continue;
					}
					break;
				}
				if (i.child === a.child) {
					for (a = i.child; a;) {
						if (a === n) return S(i), e;
						if (a === r) return S(i), t;
						a = a.sibling;
					}
					throw Error("Unable to find node on an unmounted component.");
				}
				if (n.return !== r.return) n = i, r = a;
				else {
					for (var o = !1, s = i.child; s;) {
						if (s === n) {
							o = !0, n = i, r = a;
							break;
						}
						if (s === r) {
							o = !0, r = i, n = a;
							break;
						}
						s = s.sibling;
					}
					if (!o) {
						for (s = a.child; s;) {
							if (s === n) {
								o = !0, n = a, r = i;
								break;
							}
							if (s === r) {
								o = !0, r = a, n = i;
								break;
							}
							s = s.sibling;
						}
						if (!o) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
					}
				}
				if (n.alternate !== r) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
			}
			if (n.tag !== 3) throw Error("Unable to find node on an unmounted component.");
			return n.stateNode.current === n ? e : t;
		}
		function w(e) {
			var t = e.tag;
			if (t === 5 || t === 26 || t === 27 || t === 6) return e;
			for (e = e.child; e !== null;) {
				if (t = w(e), t !== null) return t;
				e = e.sibling;
			}
			return null;
		}
		function T(e) {
			return typeof e != "object" || !e ? null : (e = Nf && e[Nf] || e["@@iterator"], typeof e == "function" ? e : null);
		}
		function E(e) {
			if (e == null) return null;
			if (typeof e == "function") return e.$$typeof === Pf ? null : e.displayName || e.name || null;
			if (typeof e == "string") return e;
			switch (e) {
				case xf: return "Fragment";
				case Cf: return "Profiler";
				case Sf: return "StrictMode";
				case Df: return "Suspense";
				case Of: return "SuspenseList";
				case jf: return "Activity";
			}
			if (typeof e == "object") switch (typeof e.tag == "number" && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), e.$$typeof) {
				case bf: return "Portal";
				case Tf: return e.displayName || "Context";
				case wf: return (e._context.displayName || "Context") + ".Consumer";
				case Ef:
					var t = e.render;
					return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
				case kf: return t = e.displayName || null, t === null ? E(e.type) || "Memo" : t;
				case Af:
					t = e._payload, e = e._init;
					try {
						return E(e(t));
					} catch {}
			}
			return null;
		}
		function D(e) {
			return typeof e.tag == "number" ? O(e) : typeof e.name == "string" ? e.name : null;
		}
		function O(e) {
			var t = e.type;
			switch (e.tag) {
				case 31: return "Activity";
				case 24: return "Cache";
				case 9: return (t._context.displayName || "Context") + ".Consumer";
				case 10: return t.displayName || "Context";
				case 18: return "DehydratedFragment";
				case 11: return e = t.render, e = e.displayName || e.name || "", t.displayName || (e === "" ? "ForwardRef" : "ForwardRef(" + e + ")");
				case 7: return "Fragment";
				case 26:
				case 27:
				case 5: return t;
				case 4: return "Portal";
				case 3: return "Root";
				case 6: return "Text";
				case 16: return E(t);
				case 8: return t === Sf ? "StrictMode" : "Mode";
				case 22: return "Offscreen";
				case 12: return "Profiler";
				case 21: return "Scope";
				case 13: return "Suspense";
				case 19: return "SuspenseList";
				case 25: return "TracingMarker";
				case 1:
				case 0:
				case 14:
				case 15:
					if (typeof t == "function") return t.displayName || t.name || null;
					if (typeof t == "string") return t;
					break;
				case 29:
					if (t = e._debugInfo, t != null) {
						for (var n = t.length - 1; 0 <= n; n--) if (typeof t[n].name == "string") return t[n].name;
					}
					if (e.return !== null) return O(e.return);
			}
			return null;
		}
		function k(e) {
			return { current: e };
		}
		function A(e, t) {
			0 > Bf ? console.error("Unexpected pop.") : (t !== zf[Bf] && console.error("Unexpected Fiber popped."), e.current = Rf[Bf], Rf[Bf] = null, zf[Bf] = null, Bf--);
		}
		function j(e, t, n) {
			Bf++, Rf[Bf] = e.current, zf[Bf] = n, e.current = t;
		}
		function M(e) {
			return e === null && console.error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."), e;
		}
		function N(e, t) {
			j(Uf, t, e), j(Hf, e, e), j(Vf, null, e);
			var n = t.nodeType;
			switch (n) {
				case 9:
				case 11:
					n = n === 9 ? "#document" : "#fragment", t = (t = t.documentElement) && (t = t.namespaceURI) ? Ou(t) : US;
					break;
				default: if (n = t.tagName, t = t.namespaceURI) t = Ou(t), t = ku(t, n);
				else switch (n) {
					case "svg":
						t = WS;
						break;
					case "math":
						t = GS;
						break;
					default: t = US;
				}
			}
			n = n.toLowerCase(), n = Dt(null, n), n = {
				context: t,
				ancestorInfo: n
			}, A(Vf, e), j(Vf, n, e);
		}
		function P(e) {
			A(Vf, e), A(Hf, e), A(Uf, e);
		}
		function F() {
			return M(Vf.current);
		}
		function I(e) {
			e.memoizedState !== null && j(Wf, e, e);
			var t = M(Vf.current), n = e.type, r = ku(t.context, n);
			n = Dt(t.ancestorInfo, n), r = {
				context: r,
				ancestorInfo: n
			}, t !== r && (j(Hf, e, e), j(Vf, r, e));
		}
		function L(e) {
			Hf.current === e && (A(Vf, e), A(Hf, e)), Wf.current === e && (A(Wf, e), bC._currentValue = yC);
		}
		function ee() {}
		function R() {
			if (Gf === 0) {
				Kf = console.log, qf = console.info, Jf = console.warn, Yf = console.error, Xf = console.group, Zf = console.groupCollapsed, Qf = console.groupEnd;
				var e = {
					configurable: !0,
					enumerable: !0,
					value: ee,
					writable: !0
				};
				Object.defineProperties(console, {
					info: e,
					log: e,
					warn: e,
					error: e,
					group: e,
					groupCollapsed: e,
					groupEnd: e
				});
			}
			Gf++;
		}
		function z() {
			if (Gf--, Gf === 0) {
				var e = {
					configurable: !0,
					enumerable: !0,
					writable: !0
				};
				Object.defineProperties(console, {
					log: _f({}, e, { value: Kf }),
					info: _f({}, e, { value: qf }),
					warn: _f({}, e, { value: Jf }),
					error: _f({}, e, { value: Yf }),
					group: _f({}, e, { value: Xf }),
					groupCollapsed: _f({}, e, { value: Zf }),
					groupEnd: _f({}, e, { value: Qf })
				});
			}
			0 > Gf && console.error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
		}
		function te(e) {
			var t = Error.prepareStackTrace;
			if (Error.prepareStackTrace = void 0, e = e.stack, Error.prepareStackTrace = t, e.startsWith("Error: react-stack-top-frame\n") && (e = e.slice(29)), t = e.indexOf("\n"), t !== -1 && (e = e.slice(t + 1)), t = e.indexOf("react_stack_bottom_frame"), t !== -1 && (t = e.lastIndexOf("\n", t)), t !== -1) e = e.slice(0, t);
			else return "";
			return e;
		}
		function B(e) {
			if ($f === void 0) try {
				throw Error();
			} catch (e) {
				var t = e.stack.trim().match(/\n( *(at )?)/);
				$f = t && t[1] || "", ep = -1 < e.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
			}
			return "\n" + $f + e + ep;
		}
		function V(e, t) {
			if (!e || tp) return "";
			var n = np.get(e);
			if (n !== void 0) return n;
			tp = !0, n = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
			var r = null;
			r = Q.H, Q.H = null, R();
			try {
				var i = { DetermineComponentFrameRoot: function() {
					try {
						if (t) {
							var n = function() {
								throw Error();
							};
							if (Object.defineProperty(n.prototype, "props", { set: function() {
								throw Error();
							} }), typeof Reflect == "object" && Reflect.construct) {
								try {
									Reflect.construct(n, []);
								} catch (e) {
									var r = e;
								}
								Reflect.construct(e, [], n);
							} else {
								try {
									n.call();
								} catch (e) {
									r = e;
								}
								e.call(n.prototype);
							}
						} else {
							try {
								throw Error();
							} catch (e) {
								r = e;
							}
							(n = e()) && typeof n.catch == "function" && n.catch(function() {});
						}
					} catch (e) {
						if (e && r && typeof e.stack == "string") return [e.stack, r.stack];
					}
					return [null, null];
				} };
				i.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
				var a = Object.getOwnPropertyDescriptor(i.DetermineComponentFrameRoot, "name");
				a && a.configurable && Object.defineProperty(i.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
				var o = i.DetermineComponentFrameRoot(), s = o[0], c = o[1];
				if (s && c) {
					var l = s.split("\n"), u = c.split("\n");
					for (o = a = 0; a < l.length && !l[a].includes("DetermineComponentFrameRoot");) a++;
					for (; o < u.length && !u[o].includes("DetermineComponentFrameRoot");) o++;
					if (a === l.length || o === u.length) for (a = l.length - 1, o = u.length - 1; 1 <= a && 0 <= o && l[a] !== u[o];) o--;
					for (; 1 <= a && 0 <= o; a--, o--) if (l[a] !== u[o]) {
						if (a !== 1 || o !== 1) do
							if (a--, o--, 0 > o || l[a] !== u[o]) {
								var d = "\n" + l[a].replace(" at new ", " at ");
								return e.displayName && d.includes("<anonymous>") && (d = d.replace("<anonymous>", e.displayName)), typeof e == "function" && np.set(e, d), d;
							}
						while (1 <= a && 0 <= o);
						break;
					}
				}
			} finally {
				tp = !1, Q.H = r, z(), Error.prepareStackTrace = n;
			}
			return l = (l = e ? e.displayName || e.name : "") ? B(l) : "", typeof e == "function" && np.set(e, l), l;
		}
		function ne(e, t) {
			switch (e.tag) {
				case 26:
				case 27:
				case 5: return B(e.type);
				case 16: return B("Lazy");
				case 13: return e.child !== t && t !== null ? B("Suspense Fallback") : B("Suspense");
				case 19: return B("SuspenseList");
				case 0:
				case 15: return V(e.type, !1);
				case 11: return V(e.type.render, !1);
				case 1: return V(e.type, !0);
				case 31: return B("Activity");
				default: return "";
			}
		}
		function re(e) {
			try {
				var t = "", n = null;
				do {
					t += ne(e, n);
					var r = e._debugInfo;
					if (r) for (var i = r.length - 1; 0 <= i; i--) {
						var a = r[i];
						if (typeof a.name == "string") {
							var o = t;
							a: {
								var s = a.name, c = a.env, l = a.debugLocation;
								if (l != null) {
									var u = te(l), d = u.lastIndexOf("\n"), f = d === -1 ? u : u.slice(d + 1);
									if (f.indexOf(s) !== -1) {
										var p = "\n" + f;
										break a;
									}
								}
								p = B(s + (c ? " [" + c + "]" : ""));
							}
							t = o + p;
						}
					}
					n = e, e = e.return;
				} while (e);
				return t;
			} catch (e) {
				return "\nError generating stack: " + e.message + "\n" + e.stack;
			}
		}
		function ie(e) {
			return (e = e ? e.displayName || e.name : "") ? B(e) : "";
		}
		function ae() {
			if (rp === null) return null;
			var e = rp._debugOwner;
			return e == null ? null : D(e);
		}
		function oe() {
			if (rp === null) return "";
			var e = rp;
			try {
				var t = "";
				switch (e.tag === 6 && (e = e.return), e.tag) {
					case 26:
					case 27:
					case 5:
						t += B(e.type);
						break;
					case 13:
						t += B("Suspense");
						break;
					case 19:
						t += B("SuspenseList");
						break;
					case 31:
						t += B("Activity");
						break;
					case 30:
					case 0:
					case 15:
					case 1:
						e._debugOwner || t !== "" || (t += ie(e.type));
						break;
					case 11: e._debugOwner || t !== "" || (t += ie(e.type.render));
				}
				for (; e;) if (typeof e.tag == "number") {
					var n = e;
					e = n._debugOwner;
					var r = n._debugStack;
					if (e && r) {
						var i = te(r);
						i !== "" && (t += "\n" + i);
					}
				} else if (e.debugStack != null) {
					var a = e.debugStack;
					(e = e.owner) && a && (t += "\n" + te(a));
				} else break;
				var o = t;
			} catch (e) {
				o = "\nError generating stack: " + e.message + "\n" + e.stack;
			}
			return o;
		}
		function H(e, t, n, r, i, a, o) {
			var s = rp;
			se(e);
			try {
				return e !== null && e._debugTask ? e._debugTask.run(t.bind(null, n, r, i, a, o)) : t(n, r, i, a, o);
			} finally {
				se(s);
			}
			throw Error("runWithFiberInDEV should never be called in production. This is a bug in React.");
		}
		function se(e) {
			Q.getCurrentStack = e === null ? null : oe, ip = !1, rp = e;
		}
		function ce(e) {
			return typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
		}
		function le(e) {
			try {
				return ue(e), !1;
			} catch {
				return !0;
			}
		}
		function ue(e) {
			return "" + e;
		}
		function de(e, t) {
			if (le(e)) return console.error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.", t, ce(e)), ue(e);
		}
		function fe(e, t) {
			if (le(e)) return console.error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.", t, ce(e)), ue(e);
		}
		function pe(e) {
			if (le(e)) return console.error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.", ce(e)), ue(e);
		}
		function me(e) {
			if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
			var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
			if (t.isDisabled) return !0;
			if (!t.supportsFiber) return console.error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"), !0;
			try {
				yp = t.inject(e), bp = t;
			} catch (e) {
				console.error("React instrumentation encountered an error: %o.", e);
			}
			return !!t.checkDCE;
		}
		function he(e) {
			if (typeof _p == "function" && vp(e), bp && typeof bp.setStrictMode == "function") try {
				bp.setStrictMode(yp, e);
			} catch (e) {
				xp || (xp = !0, console.error("React instrumentation encountered an error: %o", e));
			}
		}
		function ge(e) {
			return e >>>= 0, e === 0 ? 32 : 31 - (wp(e) / Tp | 0) | 0;
		}
		function _e(e) {
			var t = e & 42;
			if (t !== 0) return t;
			switch (e & -e) {
				case 1: return 1;
				case 2: return 2;
				case 4: return 4;
				case 8: return 8;
				case 16: return 16;
				case 32: return 32;
				case 64: return 64;
				case 128: return 128;
				case 256:
				case 512:
				case 1024:
				case 2048:
				case 4096:
				case 8192:
				case 16384:
				case 32768:
				case 65536:
				case 131072: return e & 261888;
				case 262144:
				case 524288:
				case 1048576:
				case 2097152: return e & 3932160;
				case 4194304:
				case 8388608:
				case 16777216:
				case 33554432: return e & 62914560;
				case 67108864: return 67108864;
				case 134217728: return 134217728;
				case 268435456: return 268435456;
				case 536870912: return 536870912;
				case 1073741824: return 0;
				default: return console.error("Should have found matching lanes. This is a bug in React."), e;
			}
		}
		function ve(e, t, n) {
			var r = e.pendingLanes;
			if (r === 0) return 0;
			var i = 0, a = e.suspendedLanes, o = e.pingedLanes;
			e = e.warmLanes;
			var s = r & 134217727;
			return s === 0 ? (s = r & ~a, s === 0 ? o === 0 ? n || (n = r & ~e, n !== 0 && (i = _e(n))) : i = _e(o) : i = _e(s)) : (r = s & ~a, r === 0 ? (o &= s, o === 0 ? n || (n = s & ~e, n !== 0 && (i = _e(n))) : i = _e(o)) : i = _e(r)), i === 0 ? 0 : t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048) ? t : i;
		}
		function ye(e, t) {
			return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
		}
		function be(e, t) {
			switch (e) {
				case 1:
				case 2:
				case 4:
				case 8:
				case 64: return t + 250;
				case 16:
				case 32:
				case 128:
				case 256:
				case 512:
				case 1024:
				case 2048:
				case 4096:
				case 8192:
				case 16384:
				case 32768:
				case 65536:
				case 131072:
				case 262144:
				case 524288:
				case 1048576:
				case 2097152: return t + 5e3;
				case 4194304:
				case 8388608:
				case 16777216:
				case 33554432: return -1;
				case 67108864:
				case 134217728:
				case 268435456:
				case 536870912:
				case 1073741824: return -1;
				default: return console.error("Should have found matching lanes. This is a bug in React."), -1;
			}
		}
		function xe() {
			var e = Op;
			return Op <<= 1, !(Op & 62914560) && (Op = 4194304), e;
		}
		function Se(e) {
			for (var t = [], n = 0; 31 > n; n++) t.push(e);
			return t;
		}
		function Ce(e, t) {
			e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
		}
		function we(e, t, n, r, i, a) {
			var o = e.pendingLanes;
			e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
			var s = e.entanglements, c = e.expirationTimes, l = e.hiddenUpdates;
			for (n = o & ~n; 0 < n;) {
				var u = 31 - Cp(n), d = 1 << u;
				s[u] = 0, c[u] = -1;
				var f = l[u];
				if (f !== null) for (l[u] = null, u = 0; u < f.length; u++) {
					var p = f[u];
					p !== null && (p.lane &= -536870913);
				}
				n &= ~d;
			}
			r !== 0 && Te(e, r, 0), a !== 0 && i === 0 && e.tag !== 0 && (e.suspendedLanes |= a & ~(o & ~t));
		}
		function Te(e, t, n) {
			e.pendingLanes |= t, e.suspendedLanes &= ~t;
			var r = 31 - Cp(t);
			e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930;
		}
		function Ee(e, t) {
			var n = e.entangledLanes |= t;
			for (e = e.entanglements; n;) {
				var r = 31 - Cp(n), i = 1 << r;
				i & t | e[r] & t && (e[r] |= t), n &= ~i;
			}
		}
		function De(e, t) {
			var n = t & -t;
			return n = n & 42 ? 1 : U(n), (n & (e.suspendedLanes | t)) === 0 ? n : 0;
		}
		function U(e) {
			switch (e) {
				case 2:
					e = 1;
					break;
				case 8:
					e = 4;
					break;
				case 32:
					e = 16;
					break;
				case 256:
				case 512:
				case 1024:
				case 2048:
				case 4096:
				case 8192:
				case 16384:
				case 32768:
				case 65536:
				case 131072:
				case 262144:
				case 524288:
				case 1048576:
				case 2097152:
				case 4194304:
				case 8388608:
				case 16777216:
				case 33554432:
					e = 128;
					break;
				case 268435456:
					e = 134217728;
					break;
				default: e = 0;
			}
			return e;
		}
		function Oe(e, t, n) {
			if (Sp) for (e = e.pendingUpdatersLaneMap; 0 < n;) {
				var r = 31 - Cp(n), i = 1 << r;
				e[r].add(t), n &= ~i;
			}
		}
		function ke(e, t) {
			if (Sp) for (var n = e.pendingUpdatersLaneMap, r = e.memoizedUpdaters; 0 < t;) {
				var i = 31 - Cp(t);
				e = 1 << i, i = n[i], 0 < i.size && (i.forEach(function(e) {
					var t = e.alternate;
					t !== null && r.has(t) || r.add(e);
				}), i.clear()), t &= ~e;
			}
		}
		function Ae(e) {
			return e &= -e, kp !== 0 && kp < e ? Ap !== 0 && Ap < e ? e & 134217727 ? jp : Mp : Ap : kp;
		}
		function je() {
			var e = If.p;
			return e === 0 ? (e = window.event, e === void 0 ? jp : Qd(e.type)) : e;
		}
		function Me(e, t) {
			var n = If.p;
			try {
				return If.p = e, t();
			} finally {
				If.p = n;
			}
		}
		function Ne(e) {
			delete e[Pp], delete e[Fp], delete e[Lp], delete e[Rp], delete e[zp];
		}
		function Pe(e) {
			var t = e[Pp];
			if (t) return t;
			for (var n = e.parentNode; n;) {
				if (t = n[Ip] || n[Pp]) {
					if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = Z(e); e !== null;) {
						if (n = e[Pp]) return n;
						e = Z(e);
					}
					return t;
				}
				e = n, n = e.parentNode;
			}
			return null;
		}
		function Fe(e) {
			if (e = e[Pp] || e[Ip]) {
				var t = e.tag;
				if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) return e;
			}
			return null;
		}
		function Ie(e) {
			var t = e.tag;
			if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
			throw Error("getNodeFromInstance: Invalid argument.");
		}
		function Le(e) {
			var t = e[Bp];
			return t ||= e[Bp] = {
				hoistableStyles: /* @__PURE__ */ new Map(),
				hoistableScripts: /* @__PURE__ */ new Map()
			}, t;
		}
		function Re(e) {
			e[Vp] = !0;
		}
		function ze(e, t) {
			Be(e, t), Be(e + "Capture", t);
		}
		function Be(e, t) {
			Up[e] && console.error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), Up[e] = t;
			var n = e.toLowerCase();
			for (Wp[n] = e, e === "onDoubleClick" && (Wp.ondblclick = e), e = 0; e < t.length; e++) Hp.add(t[e]);
		}
		function Ve(e, t) {
			Gp[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || console.error(e === "select" ? "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`." : "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), t.onChange || t.readOnly || t.disabled || t.checked == null || console.error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
		}
		function He(e) {
			return ap.call(Jp, e) ? !0 : ap.call(qp, e) ? !1 : Kp.test(e) ? Jp[e] = !0 : (qp[e] = !0, console.error("Invalid attribute name: `%s`", e), !1);
		}
		function Ue(e, t, n) {
			if (He(t)) {
				if (!e.hasAttribute(t)) {
					switch (typeof n) {
						case "symbol":
						case "object": return n;
						case "function": return n;
						case "boolean": if (!1 === n) return n;
					}
					return n === void 0 ? void 0 : null;
				}
				return e = e.getAttribute(t), e === "" && !0 === n ? !0 : (de(n, t), e === "" + n ? n : e);
			}
		}
		function We(e, t, n) {
			if (He(t)) if (n === null) e.removeAttribute(t);
			else {
				switch (typeof n) {
					case "undefined":
					case "function":
					case "symbol":
						e.removeAttribute(t);
						return;
					case "boolean":
						var r = t.toLowerCase().slice(0, 5);
						if (r !== "data-" && r !== "aria-") {
							e.removeAttribute(t);
							return;
						}
				}
				de(n, t), e.setAttribute(t, "" + n);
			}
		}
		function Ge(e, t, n) {
			if (n === null) e.removeAttribute(t);
			else {
				switch (typeof n) {
					case "undefined":
					case "function":
					case "symbol":
					case "boolean":
						e.removeAttribute(t);
						return;
				}
				de(n, t), e.setAttribute(t, "" + n);
			}
		}
		function Ke(e, t, n, r) {
			if (r === null) e.removeAttribute(n);
			else {
				switch (typeof r) {
					case "undefined":
					case "function":
					case "symbol":
					case "boolean":
						e.removeAttribute(n);
						return;
				}
				de(r, n), e.setAttributeNS(t, n, "" + r);
			}
		}
		function qe(e) {
			switch (typeof e) {
				case "bigint":
				case "boolean":
				case "number":
				case "string":
				case "undefined": return e;
				case "object": return pe(e), e;
				default: return "";
			}
		}
		function Je(e) {
			var t = e.type;
			return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
		}
		function Ye(e, t, n) {
			var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
			if (!e.hasOwnProperty(t) && r !== void 0 && typeof r.get == "function" && typeof r.set == "function") {
				var i = r.get, a = r.set;
				return Object.defineProperty(e, t, {
					configurable: !0,
					get: function() {
						return i.call(this);
					},
					set: function(e) {
						pe(e), n = "" + e, a.call(this, e);
					}
				}), Object.defineProperty(e, t, { enumerable: r.enumerable }), {
					getValue: function() {
						return n;
					},
					setValue: function(e) {
						pe(e), n = "" + e;
					},
					stopTracking: function() {
						e._valueTracker = null, delete e[t];
					}
				};
			}
		}
		function Xe(e) {
			if (!e._valueTracker) {
				var t = Je(e) ? "checked" : "value";
				e._valueTracker = Ye(e, t, "" + e[t]);
			}
		}
		function Ze(e) {
			if (!e) return !1;
			var t = e._valueTracker;
			if (!t) return !0;
			var n = t.getValue(), r = "";
			return e && (r = Je(e) ? e.checked ? "true" : "false" : e.value), e = r, e === n ? !1 : (t.setValue(e), !0);
		}
		function Qe(e) {
			if (e ||= typeof document < "u" ? document : void 0, e === void 0) return null;
			try {
				return e.activeElement || e.body;
			} catch {
				return e.body;
			}
		}
		function $e(e) {
			return e.replace(Yp, function(e) {
				return "\\" + e.charCodeAt(0).toString(16) + " ";
			});
		}
		function et(e, t) {
			t.checked === void 0 || t.defaultChecked === void 0 || Zp || (console.error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", ae() || "A component", t.type), Zp = !0), t.value === void 0 || t.defaultValue === void 0 || Xp || (console.error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", ae() || "A component", t.type), Xp = !0);
		}
		function tt(e, t, n, r, i, a, o, s) {
			e.name = "", o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" ? (de(o, "type"), e.type = o) : e.removeAttribute("type"), t == null ? o !== "submit" && o !== "reset" || e.removeAttribute("value") : o === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + qe(t)) : e.value !== "" + qe(t) && (e.value = "" + qe(t)), t == null ? n == null ? r != null && e.removeAttribute("value") : rt(e, o, qe(n)) : rt(e, o, qe(t)), i == null && a != null && (e.defaultChecked = !!a), i != null && (e.checked = i && typeof i != "function" && typeof i != "symbol"), s != null && typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" ? (de(s, "name"), e.name = "" + qe(s)) : e.removeAttribute("name");
		}
		function nt(e, t, n, r, i, a, o, s) {
			if (a != null && typeof a != "function" && typeof a != "symbol" && typeof a != "boolean" && (de(a, "type"), e.type = a), t != null || n != null) {
				if (!(a !== "submit" && a !== "reset" || t != null)) {
					Xe(e);
					return;
				}
				n = n == null ? "" : "" + qe(n), t = t == null ? n : "" + qe(t), s || t === e.value || (e.value = t), e.defaultValue = t;
			}
			r ??= i, r = typeof r != "function" && typeof r != "symbol" && !!r, e.checked = s ? e.checked : !!r, e.defaultChecked = !!r, o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" && (de(o, "name"), e.name = o), Xe(e);
		}
		function rt(e, t, n) {
			t === "number" && Qe(e.ownerDocument) === e || e.defaultValue === "" + n || (e.defaultValue = "" + n);
		}
		function it(e, t) {
			t.value ?? (typeof t.children == "object" && t.children !== null ? hf.Children.forEach(t.children, function(e) {
				e == null || typeof e == "string" || typeof e == "number" || typeof e == "bigint" || $p || ($p = !0, console.error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."));
			}) : t.dangerouslySetInnerHTML == null || em || (em = !0, console.error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), t.selected == null || Qp || (console.error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Qp = !0);
		}
		function at() {
			var e = ae();
			return e ? "\n\nCheck the render method of `" + e + "`." : "";
		}
		function ot(e, t, n, r) {
			if (e = e.options, t) {
				t = {};
				for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
				for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
			} else {
				for (n = "" + qe(n), t = null, i = 0; i < e.length; i++) {
					if (e[i].value === n) {
						e[i].selected = !0, r && (e[i].defaultSelected = !0);
						return;
					}
					t !== null || e[i].disabled || (t = e[i]);
				}
				t !== null && (t.selected = !0);
			}
		}
		function st(e, t) {
			for (e = 0; e < nm.length; e++) {
				var n = nm[e];
				if (t[n] != null) {
					var r = Ff(t[n]);
					t.multiple && !r ? console.error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", n, at()) : !t.multiple && r && console.error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", n, at());
				}
			}
			t.value === void 0 || t.defaultValue === void 0 || tm || (console.error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"), tm = !0);
		}
		function ct(e, t) {
			t.value === void 0 || t.defaultValue === void 0 || rm || (console.error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components", ae() || "A component"), rm = !0), t.children != null && t.value == null && console.error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
		}
		function lt(e, t, n) {
			if (t != null && (t = "" + qe(t), t !== e.value && (e.value = t), n == null)) {
				e.defaultValue !== t && (e.defaultValue = t);
				return;
			}
			e.defaultValue = n == null ? "" : "" + qe(n);
		}
		function ut(e, t, n, r) {
			if (t == null) {
				if (r != null) {
					if (n != null) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
					if (Ff(r)) {
						if (1 < r.length) throw Error("<textarea> can only have at most one child.");
						r = r[0];
					}
					n = r;
				}
				n ??= "", t = n;
			}
			n = qe(t), e.defaultValue = n, r = e.textContent, r === n && r !== "" && r !== null && (e.value = r), Xe(e);
		}
		function dt(e, t) {
			return e.serverProps === void 0 && e.serverTail.length === 0 && e.children.length === 1 && 3 < e.distanceFromLeaf && e.distanceFromLeaf > 15 - t ? dt(e.children[0], t) : e;
		}
		function ft(e) {
			return "  " + "  ".repeat(e);
		}
		function pt(e) {
			return "+ " + "  ".repeat(e);
		}
		function mt(e) {
			return "- " + "  ".repeat(e);
		}
		function ht(e) {
			switch (e.tag) {
				case 26:
				case 27:
				case 5: return e.type;
				case 16: return "Lazy";
				case 31: return "Activity";
				case 13: return "Suspense";
				case 19: return "SuspenseList";
				case 0:
				case 15: return e = e.type, e.displayName || e.name || null;
				case 11: return e = e.type.render, e.displayName || e.name || null;
				case 1: return e = e.type, e.displayName || e.name || null;
				default: return null;
			}
		}
		function W(e, t) {
			return im.test(e) ? (e = JSON.stringify(e), e.length > t - 2 ? 8 > t ? "{\"...\"}" : "{" + e.slice(0, t - 7) + "...\"}" : "{" + e + "}") : e.length > t ? 5 > t ? "{\"...\"}" : e.slice(0, t - 3) + "..." : e;
		}
		function gt(e, t, n) {
			var r = 120 - 2 * n;
			if (t === null) return pt(n) + W(e, r) + "\n";
			if (typeof t == "string") {
				for (var i = 0; i < t.length && i < e.length && t.charCodeAt(i) === e.charCodeAt(i); i++);
				return i > r - 8 && 10 < i && (e = "..." + e.slice(i - 8), t = "..." + t.slice(i - 8)), pt(n) + W(e, r) + "\n" + mt(n) + W(t, r) + "\n";
			}
			return ft(n) + W(e, r) + "\n";
		}
		function _t(e) {
			return Object.prototype.toString.call(e).replace(/^\[object (.*)\]$/, function(e, t) {
				return t;
			});
		}
		function vt(e, t) {
			switch (typeof e) {
				case "string": return e = JSON.stringify(e), e.length > t ? 5 > t ? "\"...\"" : e.slice(0, t - 4) + "...\"" : e;
				case "object":
					if (e === null) return "null";
					if (Ff(e)) return "[...]";
					if (e.$$typeof === yf) return (t = E(e.type)) ? "<" + t + ">" : "<...>";
					var n = _t(e);
					if (n === "Object") {
						for (var r in n = "", t -= 2, e) if (e.hasOwnProperty(r)) {
							var i = JSON.stringify(r);
							if (i !== "\"" + r + "\"" && (r = i), t -= r.length - 2, i = vt(e[r], 15 > t ? t : 15), t -= i.length, 0 > t) {
								n += n === "" ? "..." : ", ...";
								break;
							}
							n += (n === "" ? "" : ",") + r + ":" + i;
						}
						return "{" + n + "}";
					}
					return n;
				case "function": return (t = e.displayName || e.name) ? "function " + t : "function";
				default: return String(e);
			}
		}
		function yt(e, t) {
			return typeof e != "string" || im.test(e) ? "{" + vt(e, t - 2) + "}" : e.length > t - 2 ? 5 > t ? "\"...\"" : "\"" + e.slice(0, t - 5) + "...\"" : "\"" + e + "\"";
		}
		function bt(e, t, n) {
			var r = 120 - n.length - e.length, i = [], a;
			for (a in t) if (t.hasOwnProperty(a) && a !== "children") {
				var o = yt(t[a], 120 - n.length - a.length - 1);
				r -= a.length + o.length + 2, i.push(a + "=" + o);
			}
			return i.length === 0 ? n + "<" + e + ">\n" : 0 < r ? n + "<" + e + " " + i.join(" ") + ">\n" : n + "<" + e + "\n" + n + "  " + i.join("\n" + n + "  ") + "\n" + n + ">\n";
		}
		function xt(e, t, n) {
			var r = "", i = _f({}, t), a;
			for (a in e) if (e.hasOwnProperty(a)) {
				delete i[a];
				var o = 120 - 2 * n - a.length - 2, s = vt(e[a], o);
				t.hasOwnProperty(a) ? (o = vt(t[a], o), r += pt(n) + a + ": " + s + "\n", r += mt(n) + a + ": " + o + "\n") : r += pt(n) + a + ": " + s + "\n";
			}
			for (var c in i) i.hasOwnProperty(c) && (e = vt(i[c], 120 - 2 * n - c.length - 2), r += mt(n) + c + ": " + e + "\n");
			return r;
		}
		function St(e, t, n, r) {
			var i = "", a = /* @__PURE__ */ new Map();
			for (l in n) n.hasOwnProperty(l) && a.set(l.toLowerCase(), l);
			if (a.size === 1 && a.has("children")) i += bt(e, t, ft(r));
			else {
				for (var o in t) if (t.hasOwnProperty(o) && o !== "children") {
					var s = 120 - 2 * (r + 1) - o.length - 1, c = a.get(o.toLowerCase());
					if (c !== void 0) {
						a.delete(o.toLowerCase());
						var l = t[o];
						c = n[c];
						var u = yt(l, s);
						s = yt(c, s), typeof l == "object" && l && typeof c == "object" && c && _t(l) === "Object" && _t(c) === "Object" && (2 < Object.keys(l).length || 2 < Object.keys(c).length || -1 < u.indexOf("...") || -1 < s.indexOf("...")) ? i += ft(r + 1) + o + "={{\n" + xt(l, c, r + 2) + ft(r + 1) + "}}\n" : (i += pt(r + 1) + o + "=" + u + "\n", i += mt(r + 1) + o + "=" + s + "\n");
					} else i += ft(r + 1) + o + "=" + yt(t[o], s) + "\n";
				}
				a.forEach(function(e) {
					if (e !== "children") {
						var t = 120 - 2 * (r + 1) - e.length - 1;
						i += mt(r + 1) + e + "=" + yt(n[e], t) + "\n";
					}
				}), i = i === "" ? ft(r) + "<" + e + ">\n" : ft(r) + "<" + e + "\n" + i + ft(r) + ">\n";
			}
			return e = n.children, t = t.children, typeof e == "string" || typeof e == "number" || typeof e == "bigint" ? (a = "", (typeof t == "string" || typeof t == "number" || typeof t == "bigint") && (a = "" + t), i += gt(a, "" + e, r + 1)) : (typeof t == "string" || typeof t == "number" || typeof t == "bigint") && (i = e == null ? i + gt("" + t, null, r + 1) : i + gt("" + t, void 0, r + 1)), i;
		}
		function Ct(e, t) {
			var n = ht(e);
			if (n === null) {
				for (n = "", e = e.child; e;) n += Ct(e, t), e = e.sibling;
				return n;
			}
			return ft(t) + "<" + n + ">\n";
		}
		function wt(e, t) {
			var n = dt(e, t);
			if (n !== e && (e.children.length !== 1 || e.children[0] !== n)) return ft(t) + "...\n" + wt(n, t + 1);
			n = "";
			var r = e.fiber._debugInfo;
			if (r) for (var i = 0; i < r.length; i++) {
				var a = r[i].name;
				typeof a == "string" && (n += ft(t) + "<" + a + ">\n", t++);
			}
			if (r = "", i = e.fiber.pendingProps, e.fiber.tag === 6) r = gt(i, e.serverProps, t), t++;
			else if (a = ht(e.fiber), a !== null) if (e.serverProps === void 0) {
				r = t;
				var o = 120 - 2 * r - a.length - 2, s = "";
				for (l in i) if (i.hasOwnProperty(l) && l !== "children") {
					var c = yt(i[l], 15);
					if (o -= l.length + c.length + 2, 0 > o) {
						s += " ...";
						break;
					}
					s += " " + l + "=" + c;
				}
				r = ft(r) + "<" + a + s + ">\n", t++;
			} else e.serverProps === null ? (r = bt(a, i, pt(t)), t++) : typeof e.serverProps == "string" ? console.error("Should not have matched a non HostText fiber to a Text node. This is a bug in React.") : (r = St(a, i, e.serverProps, t), t++);
			var l = "";
			for (i = e.fiber.child, a = 0; i && a < e.children.length;) o = e.children[a], o.fiber === i ? (l += wt(o, t), a++) : l += Ct(i, t), i = i.sibling;
			for (i && 0 < e.children.length && (l += ft(t) + "...\n"), i = e.serverTail, e.serverProps === null && t--, e = 0; e < i.length; e++) a = i[e], l = typeof a == "string" ? l + (mt(t) + W(a, 120 - 2 * t) + "\n") : l + bt(a.type, a.props, mt(t));
			return n + r + l;
		}
		function Tt(e) {
			try {
				return "\n\n" + wt(e, 0);
			} catch {
				return "";
			}
		}
		function Et(e, t, n) {
			for (var r = t, i = null, a = 0; r;) r === e && (a = 0), i = {
				fiber: r,
				children: i === null ? [] : [i],
				serverProps: r === t ? n : r === e ? null : void 0,
				serverTail: [],
				distanceFromLeaf: a
			}, a++, r = r.return;
			return i === null ? "" : Tt(i).replaceAll(/^[+-]/gm, ">");
		}
		function Dt(e, t) {
			var n = _f({}, e || lm), r = { tag: t };
			return om.indexOf(t) !== -1 && (n.aTagInScope = null, n.buttonTagInScope = null, n.nobrTagInScope = null), sm.indexOf(t) !== -1 && (n.pTagInButtonScope = null), am.indexOf(t) !== -1 && t !== "address" && t !== "div" && t !== "p" && (n.listItemTagAutoclosing = null, n.dlItemTagAutoclosing = null), n.current = r, t === "form" && (n.formTag = r), t === "a" && (n.aTagInScope = r), t === "button" && (n.buttonTagInScope = r), t === "nobr" && (n.nobrTagInScope = r), t === "p" && (n.pTagInButtonScope = r), t === "li" && (n.listItemTagAutoclosing = r), (t === "dd" || t === "dt") && (n.dlItemTagAutoclosing = r), t === "#document" || t === "html" ? n.containerTagInScope = null : n.containerTagInScope ||= r, e !== null || t !== "#document" && t !== "html" && t !== "body" ? !0 === n.implicitRootScope && (n.implicitRootScope = !1) : n.implicitRootScope = !0, n;
		}
		function Ot(e, t, n) {
			switch (t) {
				case "select": return e === "hr" || e === "option" || e === "optgroup" || e === "script" || e === "template" || e === "#text";
				case "optgroup": return e === "option" || e === "#text";
				case "option": return e === "#text";
				case "tr": return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
				case "tbody":
				case "thead":
				case "tfoot": return e === "tr" || e === "style" || e === "script" || e === "template";
				case "colgroup": return e === "col" || e === "template";
				case "table": return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
				case "head": return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
				case "html":
					if (n) break;
					return e === "head" || e === "body" || e === "frameset";
				case "frameset": return e === "frame";
				case "#document": if (!n) return e === "html";
			}
			switch (e) {
				case "h1":
				case "h2":
				case "h3":
				case "h4":
				case "h5":
				case "h6": return t !== "h1" && t !== "h2" && t !== "h3" && t !== "h4" && t !== "h5" && t !== "h6";
				case "rp":
				case "rt": return cm.indexOf(t) === -1;
				case "caption":
				case "col":
				case "colgroup":
				case "frameset":
				case "frame":
				case "tbody":
				case "td":
				case "tfoot":
				case "th":
				case "thead":
				case "tr": return t == null;
				case "head": return n || t === null;
				case "html": return n && t === "#document" || t === null;
				case "body": return n && (t === "#document" || t === "html") || t === null;
			}
			return !0;
		}
		function kt(e, t) {
			switch (e) {
				case "address":
				case "article":
				case "aside":
				case "blockquote":
				case "center":
				case "details":
				case "dialog":
				case "dir":
				case "div":
				case "dl":
				case "fieldset":
				case "figcaption":
				case "figure":
				case "footer":
				case "header":
				case "hgroup":
				case "main":
				case "menu":
				case "nav":
				case "ol":
				case "p":
				case "section":
				case "summary":
				case "ul":
				case "pre":
				case "listing":
				case "table":
				case "hr":
				case "xmp":
				case "h1":
				case "h2":
				case "h3":
				case "h4":
				case "h5":
				case "h6": return t.pTagInButtonScope;
				case "form": return t.formTag || t.pTagInButtonScope;
				case "li": return t.listItemTagAutoclosing;
				case "dd":
				case "dt": return t.dlItemTagAutoclosing;
				case "button": return t.buttonTagInScope;
				case "a": return t.aTagInScope;
				case "nobr": return t.nobrTagInScope;
			}
			return null;
		}
		function At(e, t) {
			for (; e;) {
				switch (e.tag) {
					case 5:
					case 26:
					case 27: if (e.type === t) return e;
				}
				e = e.return;
			}
			return null;
		}
		function jt(e, t) {
			t ||= lm;
			var n = t.current;
			if (t = (n = Ot(e, n && n.tag, t.implicitRootScope) ? null : n) ? null : kt(e, t), t = n || t, !t) return !0;
			var r = t.tag;
			if (t = String(!!n) + "|" + e + "|" + r, um[t]) return !1;
			um[t] = !0;
			var i = (t = rp) ? At(t.return, r) : null, a = t !== null && i !== null ? Et(i, t, null) : "", o = "<" + e + ">";
			return n ? (n = "", r === "table" && e === "tr" && (n += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error("In HTML, %s cannot be a child of <%s>.%s\nThis will cause a hydration error.%s", o, r, n, a)) : console.error("In HTML, %s cannot be a descendant of <%s>.\nThis will cause a hydration error.%s", o, r, a), t && (e = t.return, i === null || e === null || i === e && e._debugOwner === t._debugOwner || H(i, function() {
				console.error("<%s> cannot contain a nested %s.\nSee this log for the ancestor stack trace.", r, o);
			})), !1;
		}
		function Mt(e, t, n) {
			if (n || Ot("#text", t, !1)) return !0;
			if (n = "#text|" + t, um[n]) return !1;
			um[n] = !0;
			var r = (n = rp) ? At(n, t) : null;
			return n = n !== null && r !== null ? Et(r, n, n.tag === 6 ? null : { children: null }) : "", /\S/.test(e) ? console.error("In HTML, text nodes cannot be a child of <%s>.\nThis will cause a hydration error.%s", t, n) : console.error("In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.\nThis will cause a hydration error.%s", t, n), !1;
		}
		function Nt(e, t) {
			if (t) {
				var n = e.firstChild;
				if (n && n === e.lastChild && n.nodeType === 3) {
					n.nodeValue = t;
					return;
				}
			}
			e.textContent = t;
		}
		function Pt(e) {
			return e.replace(gm, function(e, t) {
				return t.toUpperCase();
			});
		}
		function Ft(e, t, n) {
			var r = t.indexOf("--") === 0;
			r || (-1 < t.indexOf("-") ? vm.hasOwnProperty(t) && vm[t] || (vm[t] = !0, console.error("Unsupported style property %s. Did you mean %s?", t, Pt(t.replace(hm, "ms-")))) : mm.test(t) ? vm.hasOwnProperty(t) && vm[t] || (vm[t] = !0, console.error("Unsupported vendor-prefixed style property %s. Did you mean %s?", t, t.charAt(0).toUpperCase() + t.slice(1))) : !_m.test(n) || ym.hasOwnProperty(n) && ym[n] || (ym[n] = !0, console.error("Style property values shouldn't contain a semicolon. Try \"%s: %s\" instead.", t, n.replace(_m, ""))), typeof n == "number" && (isNaN(n) ? bm || (bm = !0, console.error("`NaN` is an invalid value for the `%s` css style property.", t)) : isFinite(n) || xm || (xm = !0, console.error("`Infinity` is an invalid value for the `%s` css style property.", t)))), n == null || typeof n == "boolean" || n === "" ? r ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : r ? e.setProperty(t, n) : typeof n != "number" || n === 0 || Sm.has(t) ? t === "float" ? e.cssFloat = n : (fe(n, t), e[t] = ("" + n).trim()) : e[t] = n + "px";
		}
		function It(e, t, n) {
			if (t != null && typeof t != "object") throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
			if (t && Object.freeze(t), e = e.style, n != null) {
				if (t) {
					var r = {};
					if (n) {
						for (var i in n) if (n.hasOwnProperty(i) && !t.hasOwnProperty(i)) for (var a = dm[i] || [i], o = 0; o < a.length; o++) r[a[o]] = i;
					}
					for (var s in t) if (t.hasOwnProperty(s) && (!n || n[s] !== t[s])) for (i = dm[s] || [s], a = 0; a < i.length; a++) r[i[a]] = s;
					for (var c in s = {}, t) for (i = dm[c] || [c], a = 0; a < i.length; a++) s[i[a]] = c;
					for (var l in c = {}, r) if (i = r[l], (a = s[l]) && i !== a && (o = i + "," + a, !c[o])) {
						c[o] = !0, o = console;
						var u = t[i];
						o.error.call(o, "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", u == null || typeof u == "boolean" || u === "" ? "Removing" : "Updating", i, a);
					}
				}
				for (var d in n) !n.hasOwnProperty(d) || t != null && t.hasOwnProperty(d) || (d.indexOf("--") === 0 ? e.setProperty(d, "") : d === "float" ? e.cssFloat = "" : e[d] = "");
				for (var f in t) l = t[f], t.hasOwnProperty(f) && n[f] !== l && Ft(e, f, l);
			} else for (r in t) t.hasOwnProperty(r) && Ft(e, r, t[r]);
		}
		function Lt(e) {
			if (e.indexOf("-") === -1) return !1;
			switch (e) {
				case "annotation-xml":
				case "color-profile":
				case "font-face":
				case "font-face-src":
				case "font-face-uri":
				case "font-face-format":
				case "font-face-name":
				case "missing-glyph": return !1;
				default: return !0;
			}
		}
		function Rt(e) {
			return Tm.get(e) || e;
		}
		function zt(e, t) {
			if (ap.call(Om, t) && Om[t]) return !0;
			if (Am.test(t)) {
				if (e = "aria-" + t.slice(4).toLowerCase(), e = Dm.hasOwnProperty(e) ? e : null, e == null) return console.error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", t), Om[t] = !0;
				if (t !== e) return console.error("Invalid ARIA attribute `%s`. Did you mean `%s`?", t, e), Om[t] = !0;
			}
			if (km.test(t)) {
				if (e = t.toLowerCase(), e = Dm.hasOwnProperty(e) ? e : null, e == null) return Om[t] = !0, !1;
				t !== e && (console.error("Unknown ARIA attribute `%s`. Did you mean `%s`?", t, e), Om[t] = !0);
			}
			return !0;
		}
		function Bt(e, t) {
			var n = [], r;
			for (r in t) zt(e, r) || n.push(r);
			t = n.map(function(e) {
				return "`" + e + "`";
			}).join(", "), n.length === 1 ? console.error("Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", t, e) : 1 < n.length && console.error("Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", t, e);
		}
		function Vt(e, t, n, r) {
			if (ap.call(Mm, t) && Mm[t]) return !0;
			var i = t.toLowerCase();
			if (i === "onfocusin" || i === "onfocusout") return console.error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Mm[t] = !0;
			if (typeof n == "function" && (e === "form" && t === "action" || e === "input" && t === "formAction" || e === "button" && t === "formAction")) return !0;
			if (r != null) {
				if (e = r.possibleRegistrationNames, r.registrationNameDependencies.hasOwnProperty(t)) return !0;
				if (r = e.hasOwnProperty(i) ? e[i] : null, r != null) return console.error("Invalid event handler property `%s`. Did you mean `%s`?", t, r), Mm[t] = !0;
				if (Nm.test(t)) return console.error("Unknown event handler property `%s`. It will be ignored.", t), Mm[t] = !0;
			} else if (Nm.test(t)) return Pm.test(t) && console.error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", t), Mm[t] = !0;
			if (Fm.test(t) || Im.test(t)) return !0;
			if (i === "innerhtml") return console.error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Mm[t] = !0;
			if (i === "aria") return console.error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Mm[t] = !0;
			if (i === "is" && n != null && typeof n != "string") return console.error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof n), Mm[t] = !0;
			if (typeof n == "number" && isNaN(n)) return console.error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", t), Mm[t] = !0;
			if (Em.hasOwnProperty(i)) {
				if (i = Em[i], i !== t) return console.error("Invalid DOM property `%s`. Did you mean `%s`?", t, i), Mm[t] = !0;
			} else if (t !== i) return console.error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", t, i), Mm[t] = !0;
			switch (t) {
				case "dangerouslySetInnerHTML":
				case "children":
				case "style":
				case "suppressContentEditableWarning":
				case "suppressHydrationWarning":
				case "defaultValue":
				case "defaultChecked":
				case "innerHTML":
				case "ref": return !0;
				case "innerText":
				case "textContent": return !0;
			}
			switch (typeof n) {
				case "boolean": switch (t) {
					case "autoFocus":
					case "checked":
					case "multiple":
					case "muted":
					case "selected":
					case "contentEditable":
					case "spellCheck":
					case "draggable":
					case "value":
					case "autoReverse":
					case "externalResourcesRequired":
					case "focusable":
					case "preserveAlpha":
					case "allowFullScreen":
					case "async":
					case "autoPlay":
					case "controls":
					case "default":
					case "defer":
					case "disabled":
					case "disablePictureInPicture":
					case "disableRemotePlayback":
					case "formNoValidate":
					case "hidden":
					case "loop":
					case "noModule":
					case "noValidate":
					case "open":
					case "playsInline":
					case "readOnly":
					case "required":
					case "reversed":
					case "scoped":
					case "seamless":
					case "itemScope":
					case "capture":
					case "download":
					case "inert": return !0;
					default: return i = t.toLowerCase().slice(0, 5), i === "data-" || i === "aria-" ? !0 : (n ? console.error("Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s=\"%s\" or %s={value.toString()}.", n, t, t, n, t) : console.error("Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s=\"%s\" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", n, t, t, n, t, t, t), Mm[t] = !0);
				}
				case "function":
				case "symbol": return Mm[t] = !0, !1;
				case "string": if (n === "false" || n === "true") {
					switch (t) {
						case "checked":
						case "selected":
						case "multiple":
						case "muted":
						case "allowFullScreen":
						case "async":
						case "autoPlay":
						case "controls":
						case "default":
						case "defer":
						case "disabled":
						case "disablePictureInPicture":
						case "disableRemotePlayback":
						case "formNoValidate":
						case "hidden":
						case "loop":
						case "noModule":
						case "noValidate":
						case "open":
						case "playsInline":
						case "readOnly":
						case "required":
						case "reversed":
						case "scoped":
						case "seamless":
						case "itemScope":
						case "inert": break;
						default: return !0;
					}
					console.error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", n, t, n === "false" ? "The browser will interpret it as a truthy value." : "Although this works, it will not work as expected if you pass the string \"false\".", t, n), Mm[t] = !0;
				}
			}
			return !0;
		}
		function Ht(e, t, n) {
			var r = [], i;
			for (i in t) Vt(e, i, t[i], n) || r.push(i);
			t = r.map(function(e) {
				return "`" + e + "`";
			}).join(", "), r.length === 1 ? console.error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ", t, e) : 1 < r.length && console.error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ", t, e);
		}
		function Ut(e) {
			return Lm.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
		}
		function G() {}
		function Wt(e) {
			return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
		}
		function Gt(e) {
			var t = Fe(e);
			if (t && (e = t.stateNode)) {
				var n = e[Fp] || null;
				a: switch (e = t.stateNode, t.type) {
					case "input":
						if (tt(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, n.type === "radio" && t != null) {
							for (n = e; n.parentNode;) n = n.parentNode;
							for (de(t, "name"), n = n.querySelectorAll("input[name=\"" + $e("" + t) + "\"][type=\"radio\"]"), t = 0; t < n.length; t++) {
								var r = n[t];
								if (r !== e && r.form === e.form) {
									var i = r[Fp] || null;
									if (!i) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
									tt(r, i.value, i.defaultValue, i.defaultValue, i.checked, i.defaultChecked, i.type, i.name);
								}
							}
							for (t = 0; t < n.length; t++) r = n[t], r.form === e.form && Ze(r);
						}
						break a;
					case "textarea":
						lt(e, n.value, n.defaultValue);
						break a;
					case "select": t = n.value, t != null && ot(e, !!n.multiple, t, !1);
				}
			}
		}
		function Kt(e, t, n) {
			if (Vm) return e(t, n);
			Vm = !0;
			try {
				return e(t);
			} finally {
				if (Vm = !1, (zm !== null || Bm !== null) && (Kc(), zm && (t = zm, e = Bm, Bm = zm = null, Gt(t), e))) for (t = 0; t < e.length; t++) Gt(e[t]);
			}
		}
		function qt(e, t) {
			var n = e.stateNode;
			if (n === null) return null;
			var r = n[Fp] || null;
			if (r === null) return null;
			n = r[t];
			a: switch (t) {
				case "onClick":
				case "onClickCapture":
				case "onDoubleClick":
				case "onDoubleClickCapture":
				case "onMouseDown":
				case "onMouseDownCapture":
				case "onMouseMove":
				case "onMouseMoveCapture":
				case "onMouseUp":
				case "onMouseUpCapture":
				case "onMouseEnter":
					(r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
					break a;
				default: e = !1;
			}
			if (e) return null;
			if (n && typeof n != "function") throw Error("Expected `" + t + "` listener to be a function, instead got a value of `" + typeof n + "` type.");
			return n;
		}
		function Jt() {
			if (qm) return qm;
			var e, t = Km, n = t.length, r, i = "value" in Gm ? Gm.value : Gm.textContent, a = i.length;
			for (e = 0; e < n && t[e] === i[e]; e++);
			var o = n - e;
			for (r = 1; r <= o && t[n - r] === i[a - r]; r++);
			return qm = i.slice(e, 1 < r ? 1 - r : void 0);
		}
		function Yt(e) {
			var t = e.keyCode;
			return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
		}
		function Xt() {
			return !0;
		}
		function Zt() {
			return !1;
		}
		function Qt(e) {
			function t(t, n, r, i, a) {
				for (var o in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = a, this.currentTarget = null, e) e.hasOwnProperty(o) && (t = e[o], this[o] = t ? t(i) : i[o]);
				return this.isDefaultPrevented = (i.defaultPrevented == null ? !1 === i.returnValue : i.defaultPrevented) ? Xt : Zt, this.isPropagationStopped = Zt, this;
			}
			return _f(t.prototype, {
				preventDefault: function() {
					this.defaultPrevented = !0;
					var e = this.nativeEvent;
					e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = Xt);
				},
				stopPropagation: function() {
					var e = this.nativeEvent;
					e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = Xt);
				},
				persist: function() {},
				isPersistent: Xt
			}), t;
		}
		function $t(e) {
			var t = this.nativeEvent;
			return t.getModifierState ? t.getModifierState(e) : (e = dh[e]) ? !!t[e] : !1;
		}
		function en() {
			return $t;
		}
		function tn(e, t) {
			switch (e) {
				case "keyup": return vh.indexOf(t.keyCode) !== -1;
				case "keydown": return t.keyCode !== yh;
				case "keypress":
				case "mousedown":
				case "focusout": return !0;
				default: return !1;
			}
		}
		function nn(e) {
			return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
		}
		function rn(e, t) {
			switch (e) {
				case "compositionend": return nn(t);
				case "keypress": return t.which === wh ? (Eh = !0, Th) : null;
				case "textInput": return e = t.data, e === Th && Eh ? null : e;
				default: return null;
			}
		}
		function an(e, t) {
			if (Dh) return e === "compositionend" || !bh && tn(e, t) ? (e = Jt(), qm = Km = Gm = null, Dh = !1, e) : null;
			switch (e) {
				case "paste": return null;
				case "keypress":
					if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
						if (t.char && 1 < t.char.length) return t.char;
						if (t.which) return String.fromCharCode(t.which);
					}
					return null;
				case "compositionend": return Ch && t.locale !== "ko" ? null : t.data;
				default: return null;
			}
		}
		function on(e) {
			var t = e && e.nodeName && e.nodeName.toLowerCase();
			return t === "input" ? !!Oh[e.type] : t === "textarea";
		}
		function sn(e) {
			if (!Hm) return !1;
			e = "on" + e;
			var t = e in document;
			return t ||= (t = document.createElement("div"), t.setAttribute(e, "return;"), typeof t[e] == "function"), t;
		}
		function cn(e, t, n, r) {
			zm ? Bm ? Bm.push(r) : Bm = [r] : zm = r, t = tu(t, "onChange"), 0 < t.length && (n = new Ym("onChange", "change", null, n, r), e.push({
				event: n,
				listeners: t
			}));
		}
		function ln(e) {
			Jl(e, 0);
		}
		function un(e) {
			if (Ze(Ie(e))) return e;
		}
		function dn(e, t) {
			if (e === "change") return t;
		}
		function fn() {
			kh && (kh.detachEvent("onpropertychange", pn), Ah = kh = null);
		}
		function pn(e) {
			if (e.propertyName === "value" && un(Ah)) {
				var t = [];
				cn(t, Ah, e, Wt(e)), Kt(ln, t);
			}
		}
		function mn(e, t, n) {
			e === "focusin" ? (fn(), kh = t, Ah = n, kh.attachEvent("onpropertychange", pn)) : e === "focusout" && fn();
		}
		function hn(e) {
			if (e === "selectionchange" || e === "keyup" || e === "keydown") return un(Ah);
		}
		function gn(e, t) {
			if (e === "click") return un(t);
		}
		function _n(e, t) {
			if (e === "input" || e === "change") return un(t);
		}
		function K(e, t) {
			return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
		}
		function vn(e, t) {
			if (Mh(e, t)) return !0;
			if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
			var n = Object.keys(e), r = Object.keys(t);
			if (n.length !== r.length) return !1;
			for (r = 0; r < n.length; r++) {
				var i = n[r];
				if (!ap.call(t, i) || !Mh(e[i], t[i])) return !1;
			}
			return !0;
		}
		function yn(e) {
			for (; e && e.firstChild;) e = e.firstChild;
			return e;
		}
		function bn(e, t) {
			var n = yn(e);
			e = 0;
			for (var r; n;) {
				if (n.nodeType === 3) {
					if (r = e + n.textContent.length, e <= t && r >= t) return {
						node: n,
						offset: t - e
					};
					e = r;
				}
				a: {
					for (; n;) {
						if (n.nextSibling) {
							n = n.nextSibling;
							break a;
						}
						n = n.parentNode;
					}
					n = void 0;
				}
				n = yn(n);
			}
		}
		function xn(e, t) {
			return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? xn(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
		}
		function Sn(e) {
			e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
			for (var t = Qe(e.document); t instanceof e.HTMLIFrameElement;) {
				try {
					var n = typeof t.contentWindow.location.href == "string";
				} catch {
					n = !1;
				}
				if (n) e = t.contentWindow;
				else break;
				t = Qe(e.document);
			}
			return t;
		}
		function Cn(e) {
			var t = e && e.nodeName && e.nodeName.toLowerCase();
			return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
		}
		function wn(e, t, n) {
			var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
			Lh || Ph == null || Ph !== Qe(r) || (r = Ph, "selectionStart" in r && Cn(r) ? r = {
				start: r.selectionStart,
				end: r.selectionEnd
			} : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
				anchorNode: r.anchorNode,
				anchorOffset: r.anchorOffset,
				focusNode: r.focusNode,
				focusOffset: r.focusOffset
			}), Ih && vn(Ih, r) || (Ih = r, r = tu(Fh, "onSelect"), 0 < r.length && (t = new Ym("onSelect", "select", null, t, n), e.push({
				event: t,
				listeners: r
			}), t.target = Ph)));
		}
		function Tn(e, t) {
			var n = {};
			return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
		}
		function En(e) {
			if (zh[e]) return zh[e];
			if (!Rh[e]) return e;
			var t = Rh[e], n;
			for (n in t) if (t.hasOwnProperty(n) && n in Bh) return zh[e] = t[n];
			return e;
		}
		function Dn(e, t) {
			Jh.set(e, t), ze(t, [e]);
		}
		function On(e) {
			for (var t = ng, n = 0; n < e.length; n++) {
				var r = e[n];
				if (typeof r == "object" && r) if (Ff(r) && r.length === 2 && typeof r[0] == "string") {
					if (t !== ng && t !== ag) return rg;
					t = ag;
				} else return rg;
				else {
					if (typeof r == "function" || typeof r == "string" && 50 < r.length || t !== ng && t !== ig) return rg;
					t = ig;
				}
			}
			return t;
		}
		function kn(e, t, n, r) {
			for (var i in e) ap.call(e, i) && i[0] !== "_" && An(i, e[i], t, n, r);
		}
		function An(e, t, n, r, i) {
			switch (typeof t) {
				case "object": if (t === null) {
					t = "null";
					break;
				} else {
					if (t.$$typeof === yf) {
						var a = E(t.type) || "…", o = t.key;
						t = t.props;
						var s = Object.keys(t), c = s.length;
						if (o == null && c === 0) {
							t = "<" + a + " />";
							break;
						}
						if (3 > r || c === 1 && s[0] === "children" && o == null) {
							t = "<" + a + " … />";
							break;
						}
						for (var l in n.push([i + "\xA0\xA0".repeat(r) + e, "<" + a]), o !== null && An("key", o, n, r + 1, i), e = !1, t) l === "children" ? t.children != null && (!Ff(t.children) || 0 < t.children.length) && (e = !0) : ap.call(t, l) && l[0] !== "_" && An(l, t[l], n, r + 1, i);
						n.push(["", e ? ">…</" + a + ">" : "/>"]);
						return;
					}
					if (a = Object.prototype.toString.call(t), a = a.slice(8, a.length - 1), a === "Array") {
						if (l = On(t), l === ig || l === ng) {
							t = JSON.stringify(t);
							break;
						} else if (l === ag) {
							for (n.push([i + "\xA0\xA0".repeat(r) + e, ""]), e = 0; e < t.length; e++) a = t[e], An(a[0], a[1], n, r + 1, i);
							return;
						}
					}
					if (a === "Promise") {
						if (t.status === "fulfilled") {
							if (a = n.length, An(e, t.value, n, r, i), n.length > a) {
								n = n[a], n[1] = "Promise<" + (n[1] || "Object") + ">";
								return;
							}
						} else if (t.status === "rejected" && (a = n.length, An(e, t.reason, n, r, i), n.length > a)) {
							n = n[a], n[1] = "Rejected Promise<" + n[1] + ">";
							return;
						}
						n.push(["\xA0\xA0".repeat(r) + e, "Promise"]);
						return;
					}
					a === "Object" && (l = Object.getPrototypeOf(t)) && typeof l.constructor == "function" && (a = l.constructor.name), n.push([i + "\xA0\xA0".repeat(r) + e, a === "Object" ? 3 > r ? "" : "…" : a]), 3 > r && kn(t, n, r + 1, i);
					return;
				}
				case "function":
					t = t.name === "" ? "() => {}" : t.name + "() {}";
					break;
				case "string":
					t = t === tg ? "…" : JSON.stringify(t);
					break;
				case "undefined":
					t = "undefined";
					break;
				case "boolean":
					t = t ? "true" : "false";
					break;
				default: t = String(t);
			}
			n.push([i + "\xA0\xA0".repeat(r) + e, t]);
		}
		function jn(e, t, n, r) {
			var i = !0;
			for (o in e) o in t || (n.push([og + "\xA0\xA0".repeat(r) + o, "…"]), i = !1);
			for (var a in t) if (a in e) {
				var o = e[a], s = t[a];
				if (o !== s) {
					if (r === 0 && a === "children") i = "\xA0\xA0".repeat(r) + a, n.push([og + i, "…"], [sg + i, "…"]);
					else {
						if (!(3 <= r)) {
							if (typeof o == "object" && typeof s == "object" && o !== null && s !== null && o.$$typeof === s.$$typeof) if (s.$$typeof === yf) {
								if (o.type === s.type && o.key === s.key) {
									o = E(s.type) || "…", i = "\xA0\xA0".repeat(r) + a, o = "<" + o + " … />", n.push([og + i, o], [sg + i, o]), i = !1;
									continue;
								}
							} else {
								var c = Object.prototype.toString.call(o), l = Object.prototype.toString.call(s);
								if (c === l && (l === "[object Object]" || l === "[object Array]")) {
									c = [cg + "\xA0\xA0".repeat(r) + a, l === "[object Array]" ? "Array" : ""], n.push(c), l = n.length, jn(o, s, n, r + 1) ? l === n.length && (c[1] = "Referentially unequal but deeply equal objects. Consider memoization.") : i = !1;
									continue;
								}
							}
							else if (typeof o == "function" && typeof s == "function" && o.name === s.name && o.length === s.length && (c = Function.prototype.toString.call(o), l = Function.prototype.toString.call(s), c === l)) {
								o = s.name === "" ? "() => {}" : s.name + "() {}", n.push([cg + "\xA0\xA0".repeat(r) + a, o + " Referentially unequal function closure. Consider memoization."]);
								continue;
							}
						}
						An(a, o, n, r, og), An(a, s, n, r, sg);
					}
					i = !1;
				}
			} else n.push([sg + "\xA0\xA0".repeat(r) + a, "…"]), i = !1;
			return i;
		}
		function Mn(e) {
			fg = e & 63 ? "Blocking" : e & 64 ? "Gesture" : e & 4194176 ? "Transition" : e & 62914560 ? "Suspense" : e & 2080374784 ? "Idle" : "Other";
		}
		function Nn(e, t, n, r) {
			lg && (hg.start = t, hg.end = n, mg.color = "warning", mg.tooltipText = r, mg.properties = null, (e = e._debugTask) ? e.run(performance.measure.bind(performance, r, hg)) : performance.measure(r, hg));
		}
		function Pn(e, t, n) {
			Nn(e, t, n, "Reconnect");
		}
		function Fn(e, t, n, r, i) {
			var a = O(e);
			if (a !== null && lg) {
				var o = e.alternate, s = e.actualDuration;
				if (o === null || o.child !== e.child) for (var c = e.child; c !== null; c = c.sibling) s -= c.actualDuration;
				r = .5 > s ? r ? "tertiary-light" : "primary-light" : 10 > s ? r ? "tertiary" : "primary" : 100 > s ? r ? "tertiary-dark" : "primary-dark" : "error";
				var l = e.memoizedProps;
				s = e._debugTask, l !== null && o !== null && o.memoizedProps !== l ? (c = [gg], l = jn(o.memoizedProps, l, c, 0), 1 < c.length && (l && !pg && (o.lanes & i) === 0 && 100 < e.actualDuration ? (pg = !0, c[0] = vg, mg.color = "warning", mg.tooltipText = _g) : (mg.color = r, mg.tooltipText = a), mg.properties = c, hg.start = t, hg.end = n, s == null ? performance.measure("​" + a, hg) : s.run(performance.measure.bind(performance, "​" + a, hg)))) : s == null ? console.timeStamp(a, t, n, ug, void 0, r) : s.run(console.timeStamp.bind(console, a, t, n, ug, void 0, r));
			}
		}
		function In(e, t, n, r) {
			if (lg) {
				var i = O(e);
				if (i !== null) {
					for (var a = null, o = [], s = 0; s < r.length; s++) {
						var c = r[s];
						a == null && c.source !== null && (a = c.source._debugTask), c = c.value, o.push(["Error", typeof c == "object" && c && typeof c.message == "string" ? String(c.message) : String(c)]);
					}
					e.key !== null && An("key", e.key, o, 0, ""), e.memoizedProps !== null && kn(e.memoizedProps, o, 0, ""), a ??= e._debugTask, e = {
						start: t,
						end: n,
						detail: { devtools: {
							color: "error",
							track: ug,
							tooltipText: e.tag === 13 ? "Hydration failed" : "Error boundary caught an error",
							properties: o
						} }
					}, a ? a.run(performance.measure.bind(performance, "​" + i, e)) : performance.measure("​" + i, e);
				}
			}
		}
		function Ln(e, t, n, r, i) {
			if (i !== null) {
				if (lg) {
					var a = O(e);
					if (a !== null) {
						r = [];
						for (var o = 0; o < i.length; o++) {
							var s = i[o].value;
							r.push(["Error", typeof s == "object" && s && typeof s.message == "string" ? String(s.message) : String(s)]);
						}
						e.key !== null && An("key", e.key, r, 0, ""), e.memoizedProps !== null && kn(e.memoizedProps, r, 0, ""), t = {
							start: t,
							end: n,
							detail: { devtools: {
								color: "error",
								track: ug,
								tooltipText: "A lifecycle or effect errored",
								properties: r
							} }
						}, (e = e._debugTask) ? e.run(performance.measure.bind(performance, "​" + a, t)) : performance.measure("​" + a, t);
					}
				}
			} else a = O(e), a !== null && lg && (i = 1 > r ? "secondary-light" : 100 > r ? "secondary" : 500 > r ? "secondary-dark" : "error", (e = e._debugTask) ? e.run(console.timeStamp.bind(console, a, t, n, ug, void 0, i)) : console.timeStamp(a, t, n, ug, void 0, i));
		}
		function Rn(e, t, n, r) {
			if (lg && !(t <= e)) {
				var i = (n & 738197653) === n ? "tertiary-dark" : "primary-dark";
				n = (n & 536870912) === n ? "Prepared" : (n & 201326741) === n ? "Hydrated" : "Render", r ? r.run(console.timeStamp.bind(console, n, e, t, fg, dg, i)) : console.timeStamp(n, e, t, fg, dg, i);
			}
		}
		function zn(e, t, n, r) {
			!lg || t <= e || (n = (n & 738197653) === n ? "tertiary-dark" : "primary-dark", r ? r.run(console.timeStamp.bind(console, "Prewarm", e, t, fg, dg, n)) : console.timeStamp("Prewarm", e, t, fg, dg, n));
		}
		function Bn(e, t, n, r) {
			!lg || t <= e || (n = (n & 738197653) === n ? "tertiary-dark" : "primary-dark", r ? r.run(console.timeStamp.bind(console, "Suspended", e, t, fg, dg, n)) : console.timeStamp("Suspended", e, t, fg, dg, n));
		}
		function Vn(e, t, n, r, i, a) {
			if (lg && !(t <= e)) {
				n = [];
				for (var o = 0; o < r.length; o++) {
					var s = r[o].value;
					n.push(["Recoverable Error", typeof s == "object" && s && typeof s.message == "string" ? String(s.message) : String(s)]);
				}
				e = {
					start: e,
					end: t,
					detail: { devtools: {
						color: "primary-dark",
						track: fg,
						trackGroup: dg,
						tooltipText: i ? "Hydration Failed" : "Recovered after Error",
						properties: n
					} }
				}, a ? a.run(performance.measure.bind(performance, "Recovered", e)) : performance.measure("Recovered", e);
			}
		}
		function Hn(e, t, n, r) {
			!lg || t <= e || (r ? r.run(console.timeStamp.bind(console, "Errored", e, t, fg, dg, "error")) : console.timeStamp("Errored", e, t, fg, dg, "error"));
		}
		function Un(e, t, n, r) {
			!lg || t <= e || (r ? r.run(console.timeStamp.bind(console, n, e, t, fg, dg, "secondary-light")) : console.timeStamp(n, e, t, fg, dg, "secondary-light"));
		}
		function Wn(e, t, n, r, i) {
			if (lg && !(t <= e)) {
				for (var a = [], o = 0; o < n.length; o++) {
					var s = n[o].value;
					a.push(["Error", typeof s == "object" && s && typeof s.message == "string" ? String(s.message) : String(s)]);
				}
				e = {
					start: e,
					end: t,
					detail: { devtools: {
						color: "error",
						track: fg,
						trackGroup: dg,
						tooltipText: r ? "Remaining Effects Errored" : "Commit Errored",
						properties: a
					} }
				}, i ? i.run(performance.measure.bind(performance, "Errored", e)) : performance.measure("Errored", e);
			}
		}
		function Gn(e, t, n) {
			!lg || t <= e || (n ? n.run(console.timeStamp.bind(console, "Animating", e, t, fg, dg, "secondary-dark")) : console.timeStamp("Animating", e, t, fg, dg, "secondary-dark"));
		}
		function Kn() {
			for (var e = Sg, t = Cg = Sg = 0; t < e;) {
				var n = xg[t];
				xg[t++] = null;
				var r = xg[t];
				xg[t++] = null;
				var i = xg[t];
				xg[t++] = null;
				var a = xg[t];
				if (xg[t++] = null, r !== null && i !== null) {
					var o = r.pending;
					o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i;
				}
				a !== 0 && Xn(n, i, a);
			}
		}
		function qn(e, t, n, r) {
			xg[Sg++] = e, xg[Sg++] = t, xg[Sg++] = n, xg[Sg++] = r, Cg |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r);
		}
		function Jn(e, t, n, r) {
			return qn(e, t, n, r), Zn(e);
		}
		function Yn(e, t) {
			return qn(e, null, null, t), Zn(e);
		}
		function Xn(e, t, n) {
			e.lanes |= n;
			var r = e.alternate;
			r !== null && (r.lanes |= n);
			for (var i = !1, a = e.return; a !== null;) a.childLanes |= n, r = a.alternate, r !== null && (r.childLanes |= n), a.tag === 22 && (e = a.stateNode, e === null || e._visibility & yg || (i = !0)), e = a, a = a.return;
			return e.tag === 3 ? (a = e.stateNode, i && t !== null && (i = 31 - Cp(n), e = a.hiddenUpdates, r = e[i], r === null ? e[i] = [t] : r.push(t), t.lane = n | 536870912), a) : null;
		}
		function Zn(e) {
			if (Kx > Gx) throw Zx = Kx = 0, Qx = qx = null, Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
			Zx > Xx && (Zx = 0, Qx = null, console.error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.")), e.alternate === null && e.flags & 4098 && Al(e);
			for (var t = e, n = t.return; n !== null;) t.alternate === null && t.flags & 4098 && Al(e), t = n, n = t.return;
			return t.tag === 3 ? t.stateNode : null;
		}
		function Qn(e) {
			if (Tg === null) return e;
			var t = Tg(e);
			return t === void 0 ? e : t.current;
		}
		function $n(e) {
			if (Tg === null) return e;
			var t = Tg(e);
			return t === void 0 ? e != null && typeof e.render == "function" && (t = Qn(e.render), e.render !== t) ? (t = {
				$$typeof: Ef,
				render: t
			}, e.displayName !== void 0 && (t.displayName = e.displayName), t) : e : t.current;
		}
		function tr(e, t) {
			if (Tg === null) return !1;
			var n = e.elementType;
			t = t.type;
			var r = !1, i = typeof t == "object" && t ? t.$$typeof : null;
			switch (e.tag) {
				case 1:
					typeof t == "function" && (r = !0);
					break;
				case 0:
					(typeof t == "function" || i === Af) && (r = !0);
					break;
				case 11:
					(i === Ef || i === Af) && (r = !0);
					break;
				case 14:
				case 15:
					(i === kf || i === Af) && (r = !0);
					break;
				default: return !1;
			}
			return !!(r && (e = Tg(n), e !== void 0 && e === Tg(t)));
		}
		function nr(e) {
			Tg !== null && typeof WeakSet == "function" && (Eg === null && (Eg = /* @__PURE__ */ new WeakSet()), Eg.add(e));
		}
		function rr(e, t, n) {
			do {
				var r = e, i = r.alternate, a = r.child, o = r.sibling, s = r.tag;
				r = r.type;
				var c = null;
				switch (s) {
					case 0:
					case 15:
					case 1:
						c = r;
						break;
					case 11: c = r.render;
				}
				if (Tg === null) throw Error("Expected resolveFamily to be set during hot reload.");
				var l = !1;
				if (r = !1, c !== null && (c = Tg(c), c !== void 0 && (n.has(c) ? r = !0 : t.has(c) && (s === 1 ? r = !0 : l = !0))), Eg !== null && (Eg.has(e) || i !== null && Eg.has(i)) && (r = !0), r && (e._debugNeedsRemount = !0), (r || l) && (i = Yn(e, 2), i !== null && Vc(i, e, 2)), a === null || r || rr(a, t, n), o === null) break;
				e = o;
			} while (1);
		}
		function ir(e, t, n, r) {
			this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null, this.actualDuration = -0, this.actualStartTime = -1.1, this.treeBaseDuration = this.selfBaseDuration = -0, this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, Ng || typeof Object.preventExtensions != "function" || Object.preventExtensions(this);
		}
		function ar(e) {
			return e = e.prototype, !(!e || !e.isReactComponent);
		}
		function or(e, t) {
			var n = e.alternate;
			switch (n === null ? (n = p(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n._debugOwner = e._debugOwner, n._debugStack = e._debugStack, n._debugTask = e._debugTask, n._debugHookTypes = e._debugHookTypes, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null, n.actualDuration = -0, n.actualStartTime = -1.1), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
				lanes: t.lanes,
				firstContext: t.firstContext,
				_debugThenableState: t._debugThenableState
			}, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n.selfBaseDuration = e.selfBaseDuration, n.treeBaseDuration = e.treeBaseDuration, n._debugInfo = e._debugInfo, n._debugNeedsRemount = e._debugNeedsRemount, n.tag) {
				case 0:
				case 15:
					n.type = Qn(e.type);
					break;
				case 1:
					n.type = Qn(e.type);
					break;
				case 11: n.type = $n(e.type);
			}
			return n;
		}
		function sr(e, t) {
			e.flags &= 65011714;
			var n = e.alternate;
			return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
				lanes: t.lanes,
				firstContext: t.firstContext,
				_debugThenableState: t._debugThenableState
			}, e.selfBaseDuration = n.selfBaseDuration, e.treeBaseDuration = n.treeBaseDuration), e;
		}
		function cr(e, t, n, r, i, a) {
			var o = 0, s = e;
			if (typeof e == "function") ar(e) && (o = 1), s = Qn(s);
			else if (typeof e == "string") o = F(), o = jd(e, n, o) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
			else a: switch (e) {
				case jf: return t = p(31, n, t, i), t.elementType = jf, t.lanes = a, t;
				case xf: return ur(n.children, i, a, t);
				case Sf:
					o = 8, i |= Ag, i |= jg;
					break;
				case Cf: return e = n, r = i, typeof e.id != "string" && console.error("Profiler must specify an \"id\" of type `string` as a prop. Received the type `%s` instead.", typeof e.id), t = p(12, e, t, r | kg), t.elementType = Cf, t.lanes = a, t.stateNode = {
					effectDuration: 0,
					passiveEffectDuration: 0
				}, t;
				case Df: return t = p(13, n, t, i), t.elementType = Df, t.lanes = a, t;
				case Of: return t = p(19, n, t, i), t.elementType = Of, t.lanes = a, t;
				default:
					if (typeof e == "object" && e) switch (e.$$typeof) {
						case Tf:
							o = 10;
							break a;
						case wf:
							o = 9;
							break a;
						case Ef:
							o = 11, s = $n(s);
							break a;
						case kf:
							o = 14;
							break a;
						case Af:
							o = 16, s = null;
							break a;
					}
					s = "", (e === void 0 || typeof e == "object" && e && Object.keys(e).length === 0) && (s += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), e === null ? n = "null" : Ff(e) ? n = "array" : e !== void 0 && e.$$typeof === yf ? (n = "<" + (E(e.type) || "Unknown") + " />", s = " Did you accidentally export a JSX literal instead of a component?") : n = typeof e, (o = r ? D(r) : null) && (s += "\n\nCheck the render method of `" + o + "`."), o = 29, n = Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (n + "." + s)), s = null;
			}
			return t = p(o, n, t, i), t.elementType = e, t.type = s, t.lanes = a, t._debugOwner = r, t;
		}
		function lr(e, t, n) {
			return t = cr(e.type, e.key, e.props, e._owner, t, n), t._debugOwner = e._owner, t._debugStack = e._debugStack, t._debugTask = e._debugTask, t;
		}
		function ur(e, t, n, r) {
			return e = p(7, e, r, t), e.lanes = n, e;
		}
		function dr(e, t, n) {
			return e = p(6, e, null, t), e.lanes = n, e;
		}
		function fr(e) {
			var t = p(18, null, null, Dg);
			return t.stateNode = e, t;
		}
		function pr(e, t, n) {
			return t = p(4, e.children === null ? [] : e.children, e.key, t), t.lanes = n, t.stateNode = {
				containerInfo: e.containerInfo,
				pendingChildren: null,
				implementation: e.implementation
			}, t;
		}
		function mr(e, t) {
			if (typeof e == "object" && e) {
				var n = Fg.get(e);
				return n === void 0 ? (t = {
					value: e,
					source: t,
					stack: re(t)
				}, Fg.set(e, t), t) : n;
			}
			return {
				value: e,
				source: t,
				stack: re(t)
			};
		}
		function hr(e, t) {
			xr(), Ig[Lg++] = zg, Ig[Lg++] = Rg, Rg = e, zg = t;
		}
		function gr(e, t, n) {
			xr(), Bg[Vg++] = Ug, Bg[Vg++] = Wg, Bg[Vg++] = Hg, Hg = e;
			var r = Ug;
			e = Wg;
			var i = 32 - Cp(r) - 1;
			r &= ~(1 << i), n += 1;
			var a = 32 - Cp(t) + i;
			if (30 < a) {
				var o = i - i % 5;
				a = (r & (1 << o) - 1).toString(32), r >>= o, i -= o, Ug = 1 << 32 - Cp(t) + i | n << i | r, Wg = a + e;
			} else Ug = 1 << a | n << i | r, Wg = e;
		}
		function _r(e) {
			xr(), e.return !== null && (hr(e, 1), gr(e, 1, 0));
		}
		function vr(e) {
			for (; e === Rg;) Rg = Ig[--Lg], Ig[Lg] = null, zg = Ig[--Lg], Ig[Lg] = null;
			for (; e === Hg;) Hg = Bg[--Vg], Bg[Vg] = null, Wg = Bg[--Vg], Bg[Vg] = null, Ug = Bg[--Vg], Bg[Vg] = null;
		}
		function yr() {
			return xr(), Hg === null ? null : {
				id: Ug,
				overflow: Wg
			};
		}
		function br(e, t) {
			xr(), Bg[Vg++] = Ug, Bg[Vg++] = Wg, Bg[Vg++] = Hg, Ug = t.id, Wg = t.overflow, Hg = e;
		}
		function xr() {
			qg || console.error("Expected to be hydrating. This is a bug in React. Please file an issue.");
		}
		function Sr(e, t) {
			if (e.return === null) {
				if (Yg === null) Yg = {
					fiber: e,
					children: [],
					serverProps: void 0,
					serverTail: [],
					distanceFromLeaf: t
				};
				else {
					if (Yg.fiber !== e) throw Error("Saw multiple hydration diff roots in a pass. This is a bug in React.");
					Yg.distanceFromLeaf > t && (Yg.distanceFromLeaf = t);
				}
				return Yg;
			}
			var n = Sr(e.return, t + 1).children;
			return 0 < n.length && n[n.length - 1].fiber === e ? (n = n[n.length - 1], n.distanceFromLeaf > t && (n.distanceFromLeaf = t), n) : (t = {
				fiber: e,
				children: [],
				serverProps: void 0,
				serverTail: [],
				distanceFromLeaf: t
			}, n.push(t), t);
		}
		function Cr() {
			qg && console.error("We should not be hydrating here. This is a bug in React. Please file a bug.");
		}
		function wr(e, t) {
			Jg || (e = Sr(e, 0), e.serverProps = null, t !== null && (t = od(t), e.serverTail.push(t)));
		}
		function Tr(e) {
			var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : !1, n = "", r = Yg;
			throw r !== null && (Yg = null, n = Tt(r)), jr(mr(Error("Hydration failed because the server rendered " + (t ? "text" : "HTML") + " didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\nhttps://react.dev/link/hydration-mismatch" + n), e)), Qg;
		}
		function Er(e) {
			var t = e.stateNode, n = e.type, r = e.memoizedProps;
			switch (t[Pp] = e, t[Fp] = r, iu(n, r), n) {
				case "dialog":
					Yl("cancel", t), Yl("close", t);
					break;
				case "iframe":
				case "object":
				case "embed":
					Yl("load", t);
					break;
				case "video":
				case "audio":
					for (n = 0; n < fS.length; n++) Yl(fS[n], t);
					break;
				case "source":
					Yl("error", t);
					break;
				case "img":
				case "image":
				case "link":
					Yl("error", t), Yl("load", t);
					break;
				case "details":
					Yl("toggle", t);
					break;
				case "input":
					Ve("input", r), Yl("invalid", t), et(t, r), nt(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0);
					break;
				case "option":
					it(t, r);
					break;
				case "select":
					Ve("select", r), Yl("invalid", t), st(t, r);
					break;
				case "textarea": Ve("textarea", r), Yl("invalid", t), ct(t, r), ut(t, r.value, r.defaultValue, r.children);
			}
			n = r.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || t.textContent === "" + n || !0 === r.suppressHydrationWarning || uu(t.textContent, n) ? (r.popover != null && (Yl("beforetoggle", t), Yl("toggle", t)), r.onScroll != null && Yl("scroll", t), r.onScrollEnd != null && Yl("scrollend", t), r.onClick != null && (t.onclick = G), t = !0) : t = !1, t || Tr(e, !0);
		}
		function Dr(e) {
			for (Gg = e.return; Gg;) switch (Gg.tag) {
				case 5:
				case 31:
				case 13:
					Zg = !1;
					return;
				case 27:
				case 3:
					Zg = !0;
					return;
				default: Gg = Gg.return;
			}
		}
		function Or(e) {
			if (e !== Gg) return !1;
			if (!qg) return Dr(e), qg = !0, !1;
			var t = e.tag, n;
			if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = !(n !== "form" && n !== "button") || Au(e.type, e.memoizedProps)), n = !n), n && Kg) {
				for (n = Kg; n;) {
					var r = Sr(e, 0), i = od(n);
					r.serverTail.push(i), n = i.type === "Suspense" ? cd(n) : ad(n.nextSibling);
				}
				Tr(e);
			}
			if (Dr(e), t === 13) {
				if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
				Kg = cd(e);
			} else if (t === 31) {
				if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
				Kg = cd(e);
			} else t === 27 ? (t = Kg, Vu(e.type) ? (e = nC, nC = null, Kg = e) : Kg = t) : Kg = Gg ? ad(e.stateNode.nextSibling) : null;
			return !0;
		}
		function kr() {
			Kg = Gg = null, Jg = qg = !1;
		}
		function Ar() {
			var e = Xg;
			return e !== null && (mx === null ? mx = e : mx.push.apply(mx, e), Xg = null), e;
		}
		function jr(e) {
			Xg === null ? Xg = [e] : Xg.push(e);
		}
		function Mr() {
			var e = Yg;
			if (e !== null) {
				Yg = null;
				for (var t = Tt(e); 0 < e.children.length;) e = e.children[0];
				H(e.fiber, function() {
					console.error("A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\n%s%s", "https://react.dev/link/hydration-mismatch", t);
				});
			}
		}
		function Nr() {
			r_ = n_ = null, i_ = !1;
		}
		function Pr(e, t, n) {
			j($g, t._currentValue, e), t._currentValue = n, j(e_, t._currentRenderer, e), t._currentRenderer !== void 0 && t._currentRenderer !== null && t._currentRenderer !== t_ && console.error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), t._currentRenderer = t_;
		}
		function Fr(e, t) {
			e._currentValue = $g.current;
			var n = e_.current;
			A(e_, t), e._currentRenderer = n, A($g, t);
		}
		function q(e, t, n) {
			for (; e !== null;) {
				var r = e.alternate;
				if ((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n) break;
				e = e.return;
			}
			e !== n && console.error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
		}
		function Ir(e, t, n, r) {
			var i = e.child;
			for (i !== null && (i.return = e); i !== null;) {
				var a = i.dependencies;
				if (a !== null) {
					var o = i.child;
					a = a.firstContext;
					a: for (; a !== null;) {
						var s = a;
						a = i;
						for (var c = 0; c < t.length; c++) if (s.context === t[c]) {
							a.lanes |= n, s = a.alternate, s !== null && (s.lanes |= n), q(a.return, n, e), r || (o = null);
							break a;
						}
						a = s.next;
					}
				} else if (i.tag === 18) {
					if (o = i.return, o === null) throw Error("We just came from a parent so we must have had a parent. This is a bug in React.");
					o.lanes |= n, a = o.alternate, a !== null && (a.lanes |= n), q(o, n, e), o = null;
				} else o = i.child;
				if (o !== null) o.return = i;
				else for (o = i; o !== null;) {
					if (o === e) {
						o = null;
						break;
					}
					if (i = o.sibling, i !== null) {
						i.return = o.return, o = i;
						break;
					}
					o = o.return;
				}
				i = o;
			}
		}
		function Lr(e, t, n, r) {
			e = null;
			for (var i = t, a = !1; i !== null;) {
				if (!a) {
					if (i.flags & 524288) a = !0;
					else if (i.flags & 262144) break;
				}
				if (i.tag === 10) {
					var o = i.alternate;
					if (o === null) throw Error("Should have a current fiber. This is a bug in React.");
					if (o = o.memoizedProps, o !== null) {
						var s = i.type;
						Mh(i.pendingProps.value, o.value) || (e === null ? e = [s] : e.push(s));
					}
				} else if (i === Wf.current) {
					if (o = i.alternate, o === null) throw Error("Should have a current fiber. This is a bug in React.");
					o.memoizedState.memoizedState !== i.memoizedState.memoizedState && (e === null ? e = [bC] : e.push(bC));
				}
				i = i.return;
			}
			e !== null && Ir(t, e, n, r), t.flags |= 262144;
		}
		function Rr(e) {
			for (e = e.firstContext; e !== null;) {
				if (!Mh(e.context._currentValue, e.memoizedValue)) return !0;
				e = e.next;
			}
			return !1;
		}
		function zr(e) {
			n_ = e, r_ = null, e = e.dependencies, e !== null && (e.firstContext = null);
		}
		function Br(e) {
			return i_ && console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), Hr(n_, e);
		}
		function Vr(e, t) {
			return n_ === null && zr(e), Hr(e, t);
		}
		function Hr(e, t) {
			var n = t._currentValue;
			if (t = {
				context: t,
				memoizedValue: n,
				next: null
			}, r_ === null) {
				if (e === null) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
				r_ = t, e.dependencies = {
					lanes: 0,
					firstContext: t,
					_debugThenableState: null
				}, e.flags |= 524288;
			} else r_ = r_.next = t;
			return n;
		}
		function Ur() {
			return {
				controller: new a_(),
				data: /* @__PURE__ */ new Map(),
				refCount: 0
			};
		}
		function Wr(e) {
			e.controller.signal.aborted && console.warn("A cache instance was retained after it was already freed. This likely indicates a bug in React."), e.refCount++;
		}
		function Gr(e) {
			e.refCount--, 0 > e.refCount && console.warn("A cache instance was released after it was already freed. This likely indicates a bug in React."), e.refCount === 0 && o_(s_, function() {
				e.controller.abort();
			});
		}
		function Kr(e, t, n) {
			e & 127 ? 0 > T_ && (T_ = l_(), E_ = u_(t), O_ = t, n != null && (k_ = O(n)), (Vb & (Mb | Nb)) !== jb && (C_ = !0, D_ = d_), e = Nu(), t = Mu(), e !== M_ || t !== j_ ? M_ = -1.1 : t !== null && (D_ = d_), A_ = e, j_ = t) : e & 4194048 && 0 > I_ && (I_ = l_(), R_ = u_(t), z_ = t, n != null && (B_ = O(n)), 0 > F_) && (e = Nu(), t = Mu(), (e !== U_ || t !== H_) && (U_ = -1.1), V_ = e, H_ = t);
		}
		function qr(e) {
			if (0 > T_) {
				T_ = l_(), E_ = e._debugTask == null ? null : e._debugTask, (Vb & (Mb | Nb)) !== jb && (D_ = d_);
				var t = Nu(), n = Mu();
				t !== M_ || n !== j_ ? M_ = -1.1 : n !== null && (D_ = d_), A_ = t, j_ = n;
			}
			0 > I_ && (I_ = l_(), R_ = e._debugTask == null ? null : e._debugTask, 0 > F_) && (e = Nu(), t = Mu(), (e !== U_ || t !== H_) && (U_ = -1.1), V_ = e, H_ = t);
		}
		function Jr() {
			var e = v_;
			return v_ = 0, e;
		}
		function Yr(e) {
			var t = v_;
			return v_ = e, t;
		}
		function Xr(e) {
			var t = v_;
			return v_ += e, t;
		}
		function Zr() {
			x_ = b_ = -1.1;
		}
		function Qr() {
			var e = b_;
			return b_ = -1.1, e;
		}
		function $r(e) {
			0 <= e && (b_ = e);
		}
		function ei() {
			var e = y_;
			return y_ = -0, e;
		}
		function ti(e) {
			0 <= e && (y_ = e);
		}
		function J() {
			var e = S_;
			return S_ = null, e;
		}
		function ni() {
			var e = C_;
			return C_ = !1, e;
		}
		function ri(e) {
			__ = l_(), 0 > e.actualStartTime && (e.actualStartTime = __);
		}
		function ii(e) {
			if (0 <= __) {
				var t = l_() - __;
				e.actualDuration += t, e.selfBaseDuration = t, __ = -1;
			}
		}
		function ai(e) {
			if (0 <= __) {
				var t = l_() - __;
				e.actualDuration += t, __ = -1;
			}
		}
		function oi() {
			if (0 <= __) {
				var e = l_(), t = e - __;
				__ = -1, v_ += t, y_ += t, x_ = e;
			}
		}
		function si(e) {
			S_ === null && (S_ = []), S_.push(e), g_ === null && (g_ = []), g_.push(e);
		}
		function ci() {
			__ = l_(), 0 > b_ && (b_ = __);
		}
		function li(e) {
			for (var t = e.child; t;) e.actualDuration += t.actualDuration, t = t.sibling;
		}
		function ui(e, t) {
			if ($_ === null) {
				var n = $_ = [];
				ev = 0, tv = Ul(), nv = {
					status: "pending",
					value: void 0,
					then: function(e) {
						n.push(e);
					}
				};
			}
			return ev++, t.then(di, di), t;
		}
		function di() {
			if (--ev === 0 && (-1 < I_ || (F_ = -1.1), $_ !== null)) {
				nv !== null && (nv.status = "fulfilled");
				var e = $_;
				$_ = null, tv = 0, nv = null;
				for (var t = 0; t < e.length; t++) (0, e[t])();
			}
		}
		function fi(e, t) {
			var n = [], r = {
				status: "pending",
				value: null,
				reason: null,
				then: function(e) {
					n.push(e);
				}
			};
			return e.then(function() {
				r.status = "fulfilled", r.value = t;
				for (var e = 0; e < n.length; e++) (0, n[e])(t);
			}, function(e) {
				for (r.status = "rejected", r.reason = e, e = 0; e < n.length; e++) (0, n[e])(void 0);
			}), r;
		}
		function pi() {
			var e = iv.current;
			return e === null ? Hb.pooledCache : e;
		}
		function mi(e, t) {
			t === null ? j(iv, iv.current, e) : j(iv, t.pool, e);
		}
		function hi() {
			var e = pi();
			return e === null ? null : {
				parent: c_._currentValue,
				pool: e
			};
		}
		function gi() {
			return {
				didWarnAboutUncachedPromise: !1,
				thenables: []
			};
		}
		function _i(e) {
			return e = e.status, e === "fulfilled" || e === "rejected";
		}
		function vi(e, t, n) {
			Q.actQueue !== null && (Q.didUsePromise = !0);
			var r = e.thenables;
			if (n = r[n], n === void 0 ? r.push(t) : n !== t && (e.didWarnAboutUncachedPromise || (e.didWarnAboutUncachedPromise = !0, console.error("A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework.")), t.then(G, G), t = n), t._debugInfo === void 0) {
				e = performance.now(), r = t.displayName;
				var i = {
					name: typeof r == "string" ? r : "Promise",
					start: e,
					end: e,
					value: t
				};
				t._debugInfo = [{ awaited: i }], t.status !== "fulfilled" && t.status !== "rejected" && (e = function() {
					i.end = performance.now();
				}, t.then(e, e));
			}
			switch (t.status) {
				case "fulfilled": return t.value;
				case "rejected": throw e = t.reason, xi(e), e;
				default:
					if (typeof t.status == "string") t.then(G, G);
					else {
						if (e = Hb, e !== null && 100 < e.shellSuspendCounter) throw Error("An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
						e = t, e.status = "pending", e.then(function(e) {
							if (t.status === "pending") {
								var n = t;
								n.status = "fulfilled", n.value = e;
							}
						}, function(e) {
							if (t.status === "pending") {
								var n = t;
								n.status = "rejected", n.reason = e;
							}
						});
					}
					switch (t.status) {
						case "fulfilled": return t.value;
						case "rejected": throw e = t.reason, xi(e), e;
					}
					throw Lv = t, Rv = !0, Nv;
			}
		}
		function yi(e) {
			try {
				return Mv(e);
			} catch (e) {
				throw typeof e == "object" && e && typeof e.then == "function" ? (Lv = e, Rv = !0, Nv) : e;
			}
		}
		function bi() {
			if (Lv === null) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
			var e = Lv;
			return Lv = null, Rv = !1, e;
		}
		function xi(e) {
			if (e === Nv || e === Fv) throw Error("Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
		}
		function Si(e) {
			var t = Vv;
			return e != null && (Vv = t === null ? e : t.concat(e)), t;
		}
		function Ci() {
			var e = Vv;
			if (e != null) {
				for (var t = e.length - 1; 0 <= t; t--) if (e[t].name != null) {
					var n = e[t].debugTask;
					if (n != null) return n;
				}
			}
			return null;
		}
		function wi(e, t, n) {
			for (var r = Object.keys(e.props), i = 0; i < r.length; i++) {
				var a = r[i];
				if (a !== "children" && a !== "key") {
					t === null && (t = lr(e, n.mode, 0), t._debugInfo = Vv, t.return = n), H(t, function(e) {
						console.error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", e);
					}, a);
					break;
				}
			}
		}
		function Ti(e) {
			var t = Bv;
			return Bv += 1, zv === null && (zv = gi()), vi(zv, e, t);
		}
		function Ei(e, t) {
			t = t.props.ref, e.ref = t === void 0 ? null : t;
		}
		function Di(e, t) {
			throw t.$$typeof === vf ? Error("A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the \"react\" package is used.\n- A library pre-bundled an old copy of \"react\" or \"react/jsx-runtime\".\n- A compiler tries to \"inline\" JSX instead of using the runtime.") : (e = Object.prototype.toString.call(t), Error("Objects are not valid as a React child (found: " + (e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e) + "). If you meant to render a collection of children, use an array instead."));
		}
		function Oi(e, t) {
			var n = Ci();
			n === null ? Di(e, t) : n.run(Di.bind(null, e, t));
		}
		function ki(e, t) {
			var n = O(e) || "Component";
			Gv[n] || (Gv[n] = !0, t = t.displayName || t.name || "Component", e.tag === 3 ? console.error("Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  root.render(%s)", t, t, t) : console.error("Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  <%s>{%s}</%s>", t, t, n, t, n));
		}
		function Ai(e, t) {
			var n = Ci();
			n === null ? ki(e, t) : n.run(ki.bind(null, e, t));
		}
		function ji(e, t) {
			var n = O(e) || "Component";
			Kv[n] || (Kv[n] = !0, t = String(t), e.tag === 3 ? console.error("Symbols are not valid as a React child.\n  root.render(%s)", t) : console.error("Symbols are not valid as a React child.\n  <%s>%s</%s>", n, t, n));
		}
		function Mi(e, t) {
			var n = Ci();
			n === null ? ji(e, t) : n.run(ji.bind(null, e, t));
		}
		function Ni(e) {
			function t(t, n) {
				if (e) {
					var r = t.deletions;
					r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n);
				}
			}
			function n(n, r) {
				if (!e) return null;
				for (; r !== null;) t(n, r), r = r.sibling;
				return null;
			}
			function r(e) {
				for (var t = /* @__PURE__ */ new Map(); e !== null;) e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling;
				return t;
			}
			function i(e, t) {
				return e = or(e, t), e.index = 0, e.sibling = null, e;
			}
			function a(t, n, r) {
				return t.index = r, e ? (r = t.alternate, r === null ? (t.flags |= 67108866, n) : (r = r.index, r < n ? (t.flags |= 67108866, n) : r)) : (t.flags |= 1048576, n);
			}
			function o(t) {
				return e && t.alternate === null && (t.flags |= 67108866), t;
			}
			function s(e, t, n, r) {
				return t === null || t.tag !== 6 ? (t = dr(n, e.mode, r), t.return = e, t._debugOwner = e, t._debugTask = e._debugTask, t._debugInfo = Vv, t) : (t = i(t, n), t.return = e, t._debugInfo = Vv, t);
			}
			function c(e, t, n, r) {
				var a = n.type;
				return a === xf ? (t = u(e, t, n.props.children, r, n.key), wi(n, t, e), t) : t !== null && (t.elementType === a || tr(t, n) || typeof a == "object" && a && a.$$typeof === Af && yi(a) === t.type) ? (t = i(t, n.props), Ei(t, n), t.return = e, t._debugOwner = n._owner, t._debugInfo = Vv, t) : (t = lr(n, e.mode, r), Ei(t, n), t.return = e, t._debugInfo = Vv, t);
			}
			function l(e, t, n, r) {
				return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? (t = pr(n, e.mode, r), t.return = e, t._debugInfo = Vv, t) : (t = i(t, n.children || []), t.return = e, t._debugInfo = Vv, t);
			}
			function u(e, t, n, r, a) {
				return t === null || t.tag !== 7 ? (t = ur(n, e.mode, r, a), t.return = e, t._debugOwner = e, t._debugTask = e._debugTask, t._debugInfo = Vv, t) : (t = i(t, n), t.return = e, t._debugInfo = Vv, t);
			}
			function f(e, t, n) {
				if (typeof t == "string" && t !== "" || typeof t == "number" || typeof t == "bigint") return t = dr("" + t, e.mode, n), t.return = e, t._debugOwner = e, t._debugTask = e._debugTask, t._debugInfo = Vv, t;
				if (typeof t == "object" && t) {
					switch (t.$$typeof) {
						case yf: return n = lr(t, e.mode, n), Ei(n, t), n.return = e, e = Si(t._debugInfo), n._debugInfo = Vv, Vv = e, n;
						case bf: return t = pr(t, e.mode, n), t.return = e, t._debugInfo = Vv, t;
						case Af:
							var r = Si(t._debugInfo);
							return t = yi(t), e = f(e, t, n), Vv = r, e;
					}
					if (Ff(t) || T(t)) return n = ur(t, e.mode, n, null), n.return = e, n._debugOwner = e, n._debugTask = e._debugTask, e = Si(t._debugInfo), n._debugInfo = Vv, Vv = e, n;
					if (typeof t.then == "function") return r = Si(t._debugInfo), e = f(e, Ti(t), n), Vv = r, e;
					if (t.$$typeof === Tf) return f(e, Vr(e, t), n);
					Oi(e, t);
				}
				return typeof t == "function" && Ai(e, t), typeof t == "symbol" && Mi(e, t), null;
			}
			function m(e, t, n, r) {
				var i = t === null ? null : t.key;
				if (typeof n == "string" && n !== "" || typeof n == "number" || typeof n == "bigint") return i === null ? s(e, t, "" + n, r) : null;
				if (typeof n == "object" && n) {
					switch (n.$$typeof) {
						case yf: return n.key === i ? (i = Si(n._debugInfo), e = c(e, t, n, r), Vv = i, e) : null;
						case bf: return n.key === i ? l(e, t, n, r) : null;
						case Af: return i = Si(n._debugInfo), n = yi(n), e = m(e, t, n, r), Vv = i, e;
					}
					if (Ff(n) || T(n)) return i === null ? (i = Si(n._debugInfo), e = u(e, t, n, r, null), Vv = i, e) : null;
					if (typeof n.then == "function") return i = Si(n._debugInfo), e = m(e, t, Ti(n), r), Vv = i, e;
					if (n.$$typeof === Tf) return m(e, t, Vr(e, n), r);
					Oi(e, n);
				}
				return typeof n == "function" && Ai(e, n), typeof n == "symbol" && Mi(e, n), null;
			}
			function h(e, t, n, r, i) {
				if (typeof r == "string" && r !== "" || typeof r == "number" || typeof r == "bigint") return e = e.get(n) || null, s(t, e, "" + r, i);
				if (typeof r == "object" && r) {
					switch (r.$$typeof) {
						case yf: return n = e.get(r.key === null ? n : r.key) || null, e = Si(r._debugInfo), t = c(t, n, r, i), Vv = e, t;
						case bf: return e = e.get(r.key === null ? n : r.key) || null, l(t, e, r, i);
						case Af:
							var a = Si(r._debugInfo);
							return r = yi(r), t = h(e, t, n, r, i), Vv = a, t;
					}
					if (Ff(r) || T(r)) return n = e.get(n) || null, e = Si(r._debugInfo), t = u(t, n, r, i, null), Vv = e, t;
					if (typeof r.then == "function") return a = Si(r._debugInfo), t = h(e, t, n, Ti(r), i), Vv = a, t;
					if (r.$$typeof === Tf) return h(e, t, n, Vr(t, r), i);
					Oi(t, r);
				}
				return typeof r == "function" && Ai(t, r), typeof r == "symbol" && Mi(t, r), null;
			}
			function g(e, t, n, r) {
				if (typeof n != "object" || !n) return r;
				switch (n.$$typeof) {
					case yf:
					case bf:
						d(e, t, n);
						var i = n.key;
						if (typeof i != "string") break;
						if (r === null) {
							r = /* @__PURE__ */ new Set(), r.add(i);
							break;
						}
						if (!r.has(i)) {
							r.add(i);
							break;
						}
						H(t, function() {
							console.error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", i);
						});
						break;
					case Af: n = yi(n), g(e, t, n, r);
				}
				return r;
			}
			function _(i, o, s, c) {
				for (var l = null, u = null, d = null, p = o, _ = o = 0, v = null; p !== null && _ < s.length; _++) {
					p.index > _ ? (v = p, p = null) : v = p.sibling;
					var y = m(i, p, s[_], c);
					if (y === null) {
						p === null && (p = v);
						break;
					}
					l = g(i, y, s[_], l), e && p && y.alternate === null && t(i, p), o = a(y, o, _), d === null ? u = y : d.sibling = y, d = y, p = v;
				}
				if (_ === s.length) return n(i, p), qg && hr(i, _), u;
				if (p === null) {
					for (; _ < s.length; _++) p = f(i, s[_], c), p !== null && (l = g(i, p, s[_], l), o = a(p, o, _), d === null ? u = p : d.sibling = p, d = p);
					return qg && hr(i, _), u;
				}
				for (p = r(p); _ < s.length; _++) v = h(p, i, _, s[_], c), v !== null && (l = g(i, v, s[_], l), e && v.alternate !== null && p.delete(v.key === null ? _ : v.key), o = a(v, o, _), d === null ? u = v : d.sibling = v, d = v);
				return e && p.forEach(function(e) {
					return t(i, e);
				}), qg && hr(i, _), u;
			}
			function v(i, o, s, c) {
				if (s == null) throw Error("An iterable object provided no iterator.");
				for (var l = null, u = null, d = o, p = o = 0, _ = null, v = null, y = s.next(); d !== null && !y.done; p++, y = s.next()) {
					d.index > p ? (_ = d, d = null) : _ = d.sibling;
					var b = m(i, d, y.value, c);
					if (b === null) {
						d === null && (d = _);
						break;
					}
					v = g(i, b, y.value, v), e && d && b.alternate === null && t(i, d), o = a(b, o, p), u === null ? l = b : u.sibling = b, u = b, d = _;
				}
				if (y.done) return n(i, d), qg && hr(i, p), l;
				if (d === null) {
					for (; !y.done; p++, y = s.next()) d = f(i, y.value, c), d !== null && (v = g(i, d, y.value, v), o = a(d, o, p), u === null ? l = d : u.sibling = d, u = d);
					return qg && hr(i, p), l;
				}
				for (d = r(d); !y.done; p++, y = s.next()) _ = h(d, i, p, y.value, c), _ !== null && (v = g(i, _, y.value, v), e && _.alternate !== null && d.delete(_.key === null ? p : _.key), o = a(_, o, p), u === null ? l = _ : u.sibling = _, u = _);
				return e && d.forEach(function(e) {
					return t(i, e);
				}), qg && hr(i, p), l;
			}
			function y(e, r, a, s) {
				if (typeof a == "object" && a && a.type === xf && a.key === null && (wi(a, null, e), a = a.props.children), typeof a == "object" && a) {
					switch (a.$$typeof) {
						case yf:
							var c = Si(a._debugInfo);
							a: {
								for (var l = a.key; r !== null;) {
									if (r.key === l) {
										if (l = a.type, l === xf) {
											if (r.tag === 7) {
												n(e, r.sibling), s = i(r, a.props.children), s.return = e, s._debugOwner = a._owner, s._debugInfo = Vv, wi(a, s, e), e = s;
												break a;
											}
										} else if (r.elementType === l || tr(r, a) || typeof l == "object" && l && l.$$typeof === Af && yi(l) === r.type) {
											n(e, r.sibling), s = i(r, a.props), Ei(s, a), s.return = e, s._debugOwner = a._owner, s._debugInfo = Vv, e = s;
											break a;
										}
										n(e, r);
										break;
									} else t(e, r);
									r = r.sibling;
								}
								a.type === xf ? (s = ur(a.props.children, e.mode, s, a.key), s.return = e, s._debugOwner = e, s._debugTask = e._debugTask, s._debugInfo = Vv, wi(a, s, e), e = s) : (s = lr(a, e.mode, s), Ei(s, a), s.return = e, s._debugInfo = Vv, e = s);
							}
							return e = o(e), Vv = c, e;
						case bf:
							a: {
								for (c = a, a = c.key; r !== null;) {
									if (r.key === a) if (r.tag === 4 && r.stateNode.containerInfo === c.containerInfo && r.stateNode.implementation === c.implementation) {
										n(e, r.sibling), s = i(r, c.children || []), s.return = e, e = s;
										break a;
									} else {
										n(e, r);
										break;
									}
									else t(e, r);
									r = r.sibling;
								}
								s = pr(c, e.mode, s), s.return = e, e = s;
							}
							return o(e);
						case Af: return c = Si(a._debugInfo), a = yi(a), e = y(e, r, a, s), Vv = c, e;
					}
					if (Ff(a)) return c = Si(a._debugInfo), e = _(e, r, a, s), Vv = c, e;
					if (T(a)) {
						if (c = Si(a._debugInfo), l = T(a), typeof l != "function") throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
						var u = l.call(a);
						return u === a ? (e.tag !== 0 || Object.prototype.toString.call(e.type) !== "[object GeneratorFunction]" || Object.prototype.toString.call(u) !== "[object Generator]") && (Uv || console.error("Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."), Uv = !0) : a.entries !== l || Hv || (console.error("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Hv = !0), e = v(e, r, u, s), Vv = c, e;
					}
					if (typeof a.then == "function") return c = Si(a._debugInfo), e = y(e, r, Ti(a), s), Vv = c, e;
					if (a.$$typeof === Tf) return y(e, r, Vr(e, a), s);
					Oi(e, a);
				}
				return typeof a == "string" && a !== "" || typeof a == "number" || typeof a == "bigint" ? (c = "" + a, r !== null && r.tag === 6 ? (n(e, r.sibling), s = i(r, c), s.return = e, e = s) : (n(e, r), s = dr(c, e.mode, s), s.return = e, s._debugOwner = e, s._debugTask = e._debugTask, s._debugInfo = Vv, e = s), o(e)) : (typeof a == "function" && Ai(e, a), typeof a == "symbol" && Mi(e, a), n(e, r));
			}
			return function(e, t, n, r) {
				var i = Vv;
				Vv = null;
				try {
					Bv = 0;
					var a = y(e, t, n, r);
					return zv = null, a;
				} catch (t) {
					if (t === Nv || t === Fv) throw t;
					var o = p(29, t, null, e.mode);
					o.lanes = r, o.return = e;
					var s = o._debugInfo = Vv;
					if (o._debugOwner = e._debugOwner, o._debugTask = e._debugTask, s != null) {
						for (var c = s.length - 1; 0 <= c; c--) if (typeof s[c].stack == "string") {
							o._debugOwner = s[c], o._debugTask = s[c].debugTask;
							break;
						}
					}
					return o;
				} finally {
					Vv = i;
				}
			};
		}
		function Pi(e, t) {
			var n = Ff(e);
			return e = !n && typeof T(e) == "function", n || e ? (n = n ? "array" : "iterable", console.error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", n, t, n), !1) : !0;
		}
		function Fi(e) {
			e.updateQueue = {
				baseState: e.memoizedState,
				firstBaseUpdate: null,
				lastBaseUpdate: null,
				shared: {
					pending: null,
					lanes: 0,
					hiddenCallbacks: null
				},
				callbacks: null
			};
		}
		function Ii(e, t) {
			e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
				baseState: e.baseState,
				firstBaseUpdate: e.firstBaseUpdate,
				lastBaseUpdate: e.lastBaseUpdate,
				shared: e.shared,
				callbacks: null
			});
		}
		function Li(e) {
			return {
				lane: e,
				tag: Yv,
				payload: null,
				callback: null,
				next: null
			};
		}
		function Ri(e, t, n) {
			var r = e.updateQueue;
			if (r === null) return null;
			if (r = r.shared, ty === r && !ey) {
				var i = O(e);
				console.error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.\n\nPlease update the following component: %s", i), ey = !0;
			}
			return (Vb & Mb) === jb ? (qn(e, r, t, n), Zn(e)) : (i = r.pending, i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = Zn(e), Xn(e, null, n), t);
		}
		function zi(e, t, n) {
			if (t = t.updateQueue, t !== null && (t = t.shared, n & 4194048)) {
				var r = t.lanes;
				r &= e.pendingLanes, n |= r, t.lanes = n, Ee(e, n);
			}
		}
		function Bi(e, t) {
			var n = e.updateQueue, r = e.alternate;
			if (r !== null && (r = r.updateQueue, n === r)) {
				var i = null, a = null;
				if (n = n.firstBaseUpdate, n !== null) {
					do {
						var o = {
							lane: n.lane,
							tag: n.tag,
							payload: n.payload,
							callback: null,
							next: null
						};
						a === null ? i = a = o : a = a.next = o, n = n.next;
					} while (n !== null);
					a === null ? i = a = t : a = a.next = t;
				} else i = a = t;
				n = {
					baseState: r.baseState,
					firstBaseUpdate: i,
					lastBaseUpdate: a,
					shared: r.shared,
					callbacks: r.callbacks
				}, e.updateQueue = n;
				return;
			}
			e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
		}
		function Vi() {
			if (ny) {
				var e = nv;
				if (e !== null) throw e;
			}
		}
		function Hi(e, t, n, r) {
			ny = !1;
			var i = e.updateQueue;
			$v = !1, ty = i.shared;
			var a = i.firstBaseUpdate, o = i.lastBaseUpdate, s = i.shared.pending;
			if (s !== null) {
				i.shared.pending = null;
				var c = s, l = c.next;
				c.next = null, o === null ? a = l : o.next = l, o = c;
				var u = e.alternate;
				u !== null && (u = u.updateQueue, s = u.lastBaseUpdate, s !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c));
			}
			if (a !== null) {
				var d = i.baseState;
				o = 0, u = l = c = null, s = a;
				do {
					var f = s.lane & -536870913, p = f !== s.lane;
					if (p ? (Wb & f) === f : (r & f) === f) {
						f !== 0 && f === tv && (ny = !0), u !== null && (u = u.next = {
							lane: 0,
							tag: s.tag,
							payload: s.payload,
							callback: null,
							next: null
						});
						a: {
							f = e;
							var m = s, h = t, g = n;
							switch (m.tag) {
								case Xv:
									if (m = m.payload, typeof m == "function") {
										i_ = !0;
										var _ = m.call(g, d, h);
										if (f.mode & Ag) {
											he(!0);
											try {
												m.call(g, d, h);
											} finally {
												he(!1);
											}
										}
										i_ = !1, d = _;
										break a;
									}
									d = m;
									break a;
								case Qv: f.flags = f.flags & -65537 | 128;
								case Yv:
									if (_ = m.payload, typeof _ == "function") {
										if (i_ = !0, m = _.call(g, d, h), f.mode & Ag) {
											he(!0);
											try {
												_.call(g, d, h);
											} finally {
												he(!1);
											}
										}
										i_ = !1;
									} else m = _;
									if (m == null) break a;
									d = _f({}, d, m);
									break a;
								case Zv: $v = !0;
							}
						}
						f = s.callback, f !== null && (e.flags |= 64, p && (e.flags |= 8192), p = i.callbacks, p === null ? i.callbacks = [f] : p.push(f));
					} else p = {
						lane: f,
						tag: s.tag,
						payload: s.payload,
						callback: s.callback,
						next: null
					}, u === null ? (l = u = p, c = d) : u = u.next = p, o |= f;
					if (s = s.next, s === null) {
						if (s = i.shared.pending, s === null) break;
						p = s, s = p.next, p.next = null, i.lastBaseUpdate = p, i.shared.pending = null;
					}
				} while (1);
				u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), cx |= o, e.lanes = o, e.memoizedState = d;
			}
			ty = null;
		}
		function Ui(e, t) {
			if (typeof e != "function") throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + e);
			e.call(t);
		}
		function Wi(e, t) {
			var n = e.shared.hiddenCallbacks;
			if (n !== null) for (e.shared.hiddenCallbacks = null, e = 0; e < n.length; e++) Ui(n[e], t);
		}
		function Gi(e, t) {
			var n = e.callbacks;
			if (n !== null) for (e.callbacks = null, e = 0; e < n.length; e++) Ui(n[e], t);
		}
		function Ki(e, t) {
			var n = ox;
			j(iy, n, e), j(ry, t, e), ox = n | t.baseLanes;
		}
		function qi(e) {
			j(iy, ox, e), j(ry, ry.current, e);
		}
		function Ji(e) {
			ox = iy.current, A(ry, e), A(iy, e);
		}
		function Yi(e) {
			var t = e.alternate;
			j(ly, ly.current & sy, e), j(ay, e, e), oy === null && (t === null || ry.current !== null || t.memoizedState !== null) && (oy = e);
		}
		function Xi(e) {
			j(ly, ly.current, e), j(ay, e, e), oy === null && (oy = e);
		}
		function Zi(e) {
			e.tag === 22 ? (j(ly, ly.current, e), j(ay, e, e), oy === null && (oy = e)) : Qi(e);
		}
		function Qi(e) {
			j(ly, ly.current, e), j(ay, ay.current, e);
		}
		function $i(e) {
			A(ay, e), oy === e && (oy = null), A(ly, e);
		}
		function ea(e) {
			for (var t = e; t !== null;) {
				if (t.tag === 13) {
					var n = t.memoizedState;
					if (n !== null && (n = n.dehydrated, n === null || nd(n) || rd(n))) return t;
				} else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
					if (t.flags & 128) return t;
				} else if (t.child !== null) {
					t.child.return = t, t = t.child;
					continue;
				}
				if (t === e) break;
				for (; t.sibling === null;) {
					if (t.return === null || t.return === e) return null;
					t = t.return;
				}
				t.sibling.return = t.return, t = t.sibling;
			}
			return null;
		}
		function Y() {
			var e = $;
			My === null ? My = [e] : My.push(e);
		}
		function X() {
			var e = $;
			if (My !== null && (Ny++, My[Ny] !== e)) {
				var t = O(xy);
				if (!gy.has(t) && (gy.add(t), My !== null)) {
					for (var n = "", r = 0; r <= Ny; r++) {
						var i = My[r], a = r === Ny ? e : i;
						for (i = r + 1 + ". " + i; 30 > i.length;) i += " ";
						i += a + "\n", n += i;
					}
					console.error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", t, n);
				}
			}
		}
		function ta(e) {
			e == null || Ff(e) || console.error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", $, typeof e);
		}
		function na() {
			var e = O(xy);
			yy.has(e) || (yy.add(e), console.error("ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.", e));
		}
		function ra() {
			throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
		}
		function ia(e, t) {
			if (Py) return !1;
			if (t === null) return console.error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", $), !1;
			e.length !== t.length && console.error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", $, "[" + t.join(", ") + "]", "[" + e.join(", ") + "]");
			for (var n = 0; n < t.length && n < e.length; n++) if (!Mh(e[n], t[n])) return !1;
			return !0;
		}
		function aa(e, t, n, r, i, a) {
			by = a, xy = t, My = e === null ? null : e._debugHookTypes, Ny = -1, Py = e !== null && e.type !== t.type, (Object.prototype.toString.call(n) === "[object AsyncFunction]" || Object.prototype.toString.call(n) === "[object AsyncGeneratorFunction]") && (a = O(xy), vy.has(a) || (vy.add(a), console.error("%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.", a === null ? "An unknown Component" : "<" + a + ">"))), t.memoizedState = null, t.updateQueue = null, t.lanes = 0, Q.H = e !== null && e.memoizedState !== null ? Ry : My === null ? Iy : Ly, Ey = a = (t.mode & Ag) !== Dg;
			var o = gv(n, r, i);
			if (Ey = !1, Ty && (o = sa(t, n, r, i)), a) {
				he(!0);
				try {
					o = sa(t, n, r, i);
				} finally {
					he(!1);
				}
			}
			return oa(e, t), o;
		}
		function oa(e, t) {
			t._debugHookTypes = My, t.dependencies === null ? ky !== null && (t.dependencies = {
				lanes: 0,
				firstContext: null,
				_debugThenableState: ky
			}) : t.dependencies._debugThenableState = ky, Q.H = Fy;
			var n = Sy !== null && Sy.next !== null;
			if (by = 0, My = $ = Cy = Sy = xy = null, Ny = -1, e !== null && (e.flags & 65011712) != (t.flags & 65011712) && console.error("Internal React error: Expected static flag was missing. Please notify the React team."), wy = !1, Oy = 0, ky = null, n) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
			e === null || ib || (e = e.dependencies, e !== null && Rr(e) && (ib = !0)), Rv ? (Rv = !1, e = !0) : e = !1, e && (t = O(t) || "Unknown", _y.has(t) || vy.has(t) || (_y.add(t), console.error("`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary.")));
		}
		function sa(e, t, n, r) {
			xy = e;
			var i = 0;
			do {
				if (Ty && (ky = null), Oy = 0, Ty = !1, i >= jy) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
				if (i += 1, Py = !1, Cy = Sy = null, e.updateQueue != null) {
					var a = e.updateQueue;
					a.lastEffect = null, a.events = null, a.stores = null, a.memoCache != null && (a.memoCache.index = 0);
				}
				Ny = -1, Q.H = zy, a = gv(t, n, r);
			} while (Ty);
			return a;
		}
		function ca() {
			var e = Q.H, t = e.useState()[0];
			return t = typeof t.then == "function" ? ha(t) : t, e = e.useState()[0], (Sy === null ? null : Sy.memoizedState) !== e && (xy.flags |= 1024), t;
		}
		function la() {
			var e = Dy !== 0;
			return Dy = 0, e;
		}
		function ua(e, t, n) {
			t.updateQueue = e.updateQueue, t.flags = (t.mode & jg) === Dg ? t.flags & -2053 : t.flags & -402655237, e.lanes &= ~n;
		}
		function da(e) {
			if (wy) {
				for (e = e.memoizedState; e !== null;) {
					var t = e.queue;
					t !== null && (t.pending = null), e = e.next;
				}
				wy = !1;
			}
			by = 0, My = Cy = Sy = xy = null, Ny = -1, $ = null, Ty = !1, Oy = Dy = 0, ky = null;
		}
		function fa() {
			var e = {
				memoizedState: null,
				baseState: null,
				baseQueue: null,
				queue: null,
				next: null
			};
			return Cy === null ? xy.memoizedState = Cy = e : Cy = Cy.next = e, Cy;
		}
		function pa() {
			if (Sy === null) {
				var e = xy.alternate;
				e = e === null ? null : e.memoizedState;
			} else e = Sy.next;
			var t = Cy === null ? xy.memoizedState : Cy.next;
			if (t !== null) Cy = t, Sy = e;
			else {
				if (e === null) throw xy.alternate === null ? Error("Update hook called on initial render. This is likely a bug in React. Please file an issue.") : Error("Rendered more hooks than during the previous render.");
				Sy = e, e = {
					memoizedState: Sy.memoizedState,
					baseState: Sy.baseState,
					baseQueue: Sy.baseQueue,
					queue: Sy.queue,
					next: null
				}, Cy === null ? xy.memoizedState = Cy = e : Cy = Cy.next = e;
			}
			return Cy;
		}
		function ma() {
			return {
				lastEffect: null,
				events: null,
				stores: null,
				memoCache: null
			};
		}
		function ha(e) {
			var t = Oy;
			return Oy += 1, ky === null && (ky = gi()), e = vi(ky, e, t), t = xy, (Cy === null ? t.memoizedState : Cy.next) === null && (t = t.alternate, Q.H = t !== null && t.memoizedState !== null ? Ry : Iy), e;
		}
		function ga(e) {
			if (typeof e == "object" && e) {
				if (typeof e.then == "function") return ha(e);
				if (e.$$typeof === Tf) return Br(e);
			}
			throw Error("An unsupported type was passed to use(): " + String(e));
		}
		function _a(e) {
			var t = null, n = xy.updateQueue;
			if (n !== null && (t = n.memoCache), t == null) {
				var r = xy.alternate;
				r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
					data: r.data.map(function(e) {
						return e.slice();
					}),
					index: 0
				})));
			}
			if (t ??= {
				data: [],
				index: 0
			}, n === null && (n = ma(), xy.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0 || Py) for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = Mf;
			else n.length !== e && console.error("Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.", n.length, e);
			return t.index++, n;
		}
		function va(e, t) {
			return typeof t == "function" ? t(e) : t;
		}
		function ya(e, t, n) {
			var r = fa();
			if (n !== void 0) {
				var i = n(t);
				if (Ey) {
					he(!0);
					try {
						n(t);
					} finally {
						he(!1);
					}
				}
			} else i = t;
			return r.memoizedState = r.baseState = i, e = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: e,
				lastRenderedState: i
			}, r.queue = e, e = e.dispatch = Oo.bind(null, xy, e), [r.memoizedState, e];
		}
		function ba(e) {
			return xa(pa(), Sy, e);
		}
		function xa(e, t, n) {
			var r = e.queue;
			if (r === null) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
			r.lastRenderedReducer = n;
			var i = e.baseQueue, a = r.pending;
			if (a !== null) {
				if (i !== null) {
					var o = i.next;
					i.next = a.next, a.next = o;
				}
				t.baseQueue !== i && console.error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), t.baseQueue = i = a, r.pending = null;
			}
			if (a = e.baseState, i === null) e.memoizedState = a;
			else {
				t = i.next;
				var s = o = null, c = null, l = t, u = !1;
				do {
					var d = l.lane & -536870913;
					if (d === l.lane ? (by & d) === d : (Wb & d) === d) {
						var f = l.revertLane;
						if (f === 0) c !== null && (c = c.next = {
							lane: 0,
							revertLane: 0,
							gesture: null,
							action: l.action,
							hasEagerState: l.hasEagerState,
							eagerState: l.eagerState,
							next: null
						}), d === tv && (u = !0);
						else if ((by & f) === f) {
							l = l.next, f === tv && (u = !0);
							continue;
						} else d = {
							lane: 0,
							revertLane: l.revertLane,
							gesture: null,
							action: l.action,
							hasEagerState: l.hasEagerState,
							eagerState: l.eagerState,
							next: null
						}, c === null ? (s = c = d, o = a) : c = c.next = d, xy.lanes |= f, cx |= f;
						d = l.action, Ey && n(a, d), a = l.hasEagerState ? l.eagerState : n(a, d);
					} else f = {
						lane: d,
						revertLane: l.revertLane,
						gesture: l.gesture,
						action: l.action,
						hasEagerState: l.hasEagerState,
						eagerState: l.eagerState,
						next: null
					}, c === null ? (s = c = f, o = a) : c = c.next = f, xy.lanes |= d, cx |= d;
					l = l.next;
				} while (l !== null && l !== t);
				if (c === null ? o = a : c.next = s, !Mh(a, e.memoizedState) && (ib = !0, u && (n = nv, n !== null))) throw n;
				e.memoizedState = a, e.baseState = o, e.baseQueue = c, r.lastRenderedState = a;
			}
			return i === null && (r.lanes = 0), [e.memoizedState, r.dispatch];
		}
		function Sa(e) {
			var t = pa(), n = t.queue;
			if (n === null) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
			n.lastRenderedReducer = e;
			var r = n.dispatch, i = n.pending, a = t.memoizedState;
			if (i !== null) {
				n.pending = null;
				var o = i = i.next;
				do
					a = e(a, o.action), o = o.next;
				while (o !== i);
				Mh(a, t.memoizedState) || (ib = !0), t.memoizedState = a, t.baseQueue === null && (t.baseState = a), n.lastRenderedState = a;
			}
			return [a, r];
		}
		function Ca(e, t, n) {
			var r = xy, i = fa();
			if (qg) {
				if (n === void 0) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
				var a = n();
				hy || a === n() || (console.error("The result of getServerSnapshot should be cached to avoid an infinite loop"), hy = !0);
			} else {
				if (a = t(), hy || (n = t(), Mh(a, n) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), hy = !0)), Hb === null) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
				Wb & 127 || Ta(r, t, a);
			}
			return i.memoizedState = a, n = {
				value: a,
				getSnapshot: t
			}, i.queue = n, Qa(Da.bind(null, r, n, e), [e]), r.flags |= 2048, Ja(dy | my, { destroy: void 0 }, Ea.bind(null, r, n, a, t), null), a;
		}
		function wa(e, t, n) {
			var r = xy, i = pa(), a = qg;
			if (a) {
				if (n === void 0) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
				n = n();
			} else if (n = t(), !hy) {
				var o = t();
				Mh(n, o) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), hy = !0);
			}
			if ((o = !Mh((Sy || i).memoizedState, n)) && (i.memoizedState = n, ib = !0), i = i.queue, Za(2048, my, Da.bind(null, r, i, e), [e]), i.getSnapshot !== t || o || Cy !== null && Cy.memoizedState.tag & dy) {
				if (r.flags |= 2048, Ja(dy | my, { destroy: void 0 }, Ea.bind(null, r, i, n, t), null), Hb === null) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
				a || by & 127 || Ta(r, t, n);
			}
			return n;
		}
		function Ta(e, t, n) {
			e.flags |= 16384, e = {
				getSnapshot: t,
				value: n
			}, t = xy.updateQueue, t === null ? (t = ma(), xy.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
		}
		function Ea(e, t, n, r) {
			t.value = n, t.getSnapshot = r, Oa(t) && ka(e);
		}
		function Da(e, t, n) {
			return n(function() {
				Oa(t) && (Kr(2, "updateSyncExternalStore()", e), ka(e));
			});
		}
		function Oa(e) {
			var t = e.getSnapshot;
			e = e.value;
			try {
				var n = t();
				return !Mh(e, n);
			} catch {
				return !0;
			}
		}
		function ka(e) {
			var t = Yn(e, 2);
			t !== null && Vc(t, e, 2);
		}
		function Aa(e) {
			var t = fa();
			if (typeof e == "function") {
				var n = e;
				if (e = n(), Ey) {
					he(!0);
					try {
						n();
					} finally {
						he(!1);
					}
				}
			}
			return t.memoizedState = t.baseState = e, t.queue = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: va,
				lastRenderedState: e
			}, t;
		}
		function ja(e) {
			e = Aa(e);
			var t = e.queue, n = ko.bind(null, xy, t);
			return t.dispatch = n, [e.memoizedState, n];
		}
		function Ma(e) {
			var t = fa();
			t.memoizedState = t.baseState = e;
			var n = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: null,
				lastRenderedState: null
			};
			return t.queue = n, t = jo.bind(null, xy, !0, n), n.dispatch = t, [e, t];
		}
		function Na(e, t) {
			return Pa(pa(), Sy, e, t);
		}
		function Pa(e, t, n, r) {
			return e.baseState = n, xa(e, Sy, typeof r == "function" ? r : va);
		}
		function Fa(e, t) {
			var n = pa();
			return Sy === null ? (n.baseState = e, [e, n.queue.dispatch]) : Pa(n, Sy, e, t);
		}
		function Ia(e, t, n, r, i) {
			if (Mo(e)) throw Error("Cannot update form state while rendering.");
			if (e = t.action, e !== null) {
				var a = {
					payload: i,
					action: e,
					next: null,
					isTransition: !0,
					status: "pending",
					value: null,
					reason: null,
					listeners: [],
					then: function(e) {
						a.listeners.push(e);
					}
				};
				Q.T === null ? a.isTransition = !1 : n(!0), r(a), n = t.pending, n === null ? (a.next = t.pending = a, La(t, a)) : (a.next = n.next, t.pending = n.next = a);
			}
		}
		function La(e, t) {
			var n = t.action, r = t.payload, i = e.state;
			if (t.isTransition) {
				var a = Q.T, o = {};
				o._updatedFibers = /* @__PURE__ */ new Set(), Q.T = o;
				try {
					var s = n(i, r), c = Q.S;
					c !== null && c(o, s), Ra(e, t, s);
				} catch (n) {
					Ba(e, t, n);
				} finally {
					a !== null && o.types !== null && (a.types !== null && a.types !== o.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), a.types = o.types), Q.T = a, a === null && o._updatedFibers && (e = o._updatedFibers.size, o._updatedFibers.clear(), 10 < e && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
				}
			} else try {
				o = n(i, r), Ra(e, t, o);
			} catch (n) {
				Ba(e, t, n);
			}
		}
		function Ra(e, t, n) {
			typeof n == "object" && n && typeof n.then == "function" ? (Q.asyncTransitions++, n.then(go, go), n.then(function(n) {
				za(e, t, n);
			}, function(n) {
				return Ba(e, t, n);
			}), t.isTransition || console.error("An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop.")) : za(e, t, n);
		}
		function za(e, t, n) {
			t.status = "fulfilled", t.value = n, Va(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, La(e, n)));
		}
		function Ba(e, t, n) {
			var r = e.pending;
			if (e.pending = null, r !== null) {
				r = r.next;
				do
					t.status = "rejected", t.reason = n, Va(t), t = t.next;
				while (t !== r);
			}
			e.action = null;
		}
		function Va(e) {
			e = e.listeners;
			for (var t = 0; t < e.length; t++) (0, e[t])();
		}
		function Ha(e, t) {
			return t;
		}
		function Ua(e, t) {
			if (qg) {
				var n = Hb.formState;
				if (n !== null) {
					a: {
						var r = xy;
						if (qg) {
							if (Kg) {
								b: {
									for (var i = Kg, a = Zg; i.nodeType !== 8;) {
										if (!a) {
											i = null;
											break b;
										}
										if (i = ad(i.nextSibling), i === null) {
											i = null;
											break b;
										}
									}
									a = i.data, i = a === zS || a === BS ? i : null;
								}
								if (i) {
									Kg = ad(i.nextSibling), r = i.data === zS;
									break a;
								}
							}
							Tr(r);
						}
						r = !1;
					}
					r && (t = n[0]);
				}
			}
			return n = fa(), n.memoizedState = n.baseState = t, r = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: Ha,
				lastRenderedState: t
			}, n.queue = r, n = ko.bind(null, xy, r), r.dispatch = n, r = Aa(!1), a = jo.bind(null, xy, !1, r.queue), r = fa(), i = {
				state: t,
				dispatch: null,
				action: e,
				pending: null
			}, r.queue = i, n = Ia.bind(null, xy, i, a, n), i.dispatch = n, r.memoizedState = e, [
				t,
				n,
				!1
			];
		}
		function Wa(e) {
			return Ga(pa(), Sy, e);
		}
		function Ga(e, t, n) {
			if (t = xa(e, t, Ha)[0], e = ba(va)[0], typeof t == "object" && t && typeof t.then == "function") try {
				var r = ha(t);
			} catch (e) {
				throw e === Nv ? Fv : e;
			}
			else r = t;
			t = pa();
			var i = t.queue, a = i.dispatch;
			return n !== t.memoizedState && (xy.flags |= 2048, Ja(dy | my, { destroy: void 0 }, Ka.bind(null, i, n), null)), [
				r,
				a,
				e
			];
		}
		function Ka(e, t) {
			e.action = t;
		}
		function qa(e) {
			var t = pa(), n = Sy;
			if (n !== null) return Ga(t, n, e);
			pa(), t = t.memoizedState, n = pa();
			var r = n.queue.dispatch;
			return n.memoizedState = e, [
				t,
				r,
				!1
			];
		}
		function Ja(e, t, n, r) {
			return e = {
				tag: e,
				create: n,
				deps: r,
				inst: t,
				next: null
			}, t = xy.updateQueue, t === null && (t = ma(), xy.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
		}
		function Ya(e) {
			var t = fa();
			return e = { current: e }, t.memoizedState = e;
		}
		function Xa(e, t, n, r) {
			var i = fa();
			xy.flags |= e, i.memoizedState = Ja(dy | t, { destroy: void 0 }, n, r === void 0 ? null : r);
		}
		function Za(e, t, n, r) {
			var i = pa();
			r = r === void 0 ? null : r;
			var a = i.memoizedState.inst;
			Sy !== null && r !== null && ia(r, Sy.memoizedState.deps) ? i.memoizedState = Ja(t, a, n, r) : (xy.flags |= e, i.memoizedState = Ja(dy | t, a, n, r));
		}
		function Qa(e, t) {
			(xy.mode & jg) === Dg ? Xa(8390656, my, e, t) : Xa(276826112, my, e, t);
		}
		function $a(e) {
			xy.flags |= 4;
			var t = xy.updateQueue;
			if (t === null) t = ma(), xy.updateQueue = t, t.events = [e];
			else {
				var n = t.events;
				n === null ? t.events = [e] : n.push(e);
			}
		}
		function eo(e) {
			var t = fa(), n = { impl: e };
			return t.memoizedState = n, function() {
				if ((Vb & Mb) !== jb) throw Error("A function wrapped in useEffectEvent can't be called during rendering.");
				return n.impl.apply(void 0, arguments);
			};
		}
		function to(e) {
			var t = pa().memoizedState;
			return $a({
				ref: t,
				nextImpl: e
			}), function() {
				if ((Vb & Mb) !== jb) throw Error("A function wrapped in useEffectEvent can't be called during rendering.");
				return t.impl.apply(void 0, arguments);
			};
		}
		function no(e, t) {
			var n = 4194308;
			return (xy.mode & jg) !== Dg && (n |= 134217728), Xa(n, py, e, t);
		}
		function ro(e, t) {
			if (typeof t == "function") {
				e = e();
				var n = t(e);
				return function() {
					typeof n == "function" ? n() : t(null);
				};
			}
			if (t != null) return t.hasOwnProperty("current") || console.error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(t).join(", ") + "}"), e = e(), t.current = e, function() {
				t.current = null;
			};
		}
		function io(e, t, n) {
			typeof t != "function" && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t === null ? "null" : typeof t), n = n == null ? null : n.concat([e]);
			var r = 4194308;
			(xy.mode & jg) !== Dg && (r |= 134217728), Xa(r, py, ro.bind(null, t, e), n);
		}
		function ao(e, t, n) {
			typeof t != "function" && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t === null ? "null" : typeof t), n = n == null ? null : n.concat([e]), Za(4, py, ro.bind(null, t, e), n);
		}
		function oo(e, t) {
			return fa().memoizedState = [e, t === void 0 ? null : t], e;
		}
		function so(e, t) {
			var n = pa();
			t = t === void 0 ? null : t;
			var r = n.memoizedState;
			return t !== null && ia(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
		}
		function co(e, t) {
			var n = fa();
			t = t === void 0 ? null : t;
			var r = e();
			if (Ey) {
				he(!0);
				try {
					e();
				} finally {
					he(!1);
				}
			}
			return n.memoizedState = [r, t], r;
		}
		function lo(e, t) {
			var n = pa();
			t = t === void 0 ? null : t;
			var r = n.memoizedState;
			if (t !== null && ia(t, r[1])) return r[0];
			if (r = e(), Ey) {
				he(!0);
				try {
					e();
				} finally {
					he(!1);
				}
			}
			return n.memoizedState = [r, t], r;
		}
		function uo(e, t) {
			return mo(fa(), e, t);
		}
		function fo(e, t) {
			return ho(pa(), Sy.memoizedState, e, t);
		}
		function po(e, t) {
			var n = pa();
			return Sy === null ? mo(n, e, t) : ho(n, Sy.memoizedState, e, t);
		}
		function mo(e, t, n) {
			return n === void 0 || by & 1073741824 && !(Wb & 261930) ? e.memoizedState = t : (e.memoizedState = n, e = Bc(), xy.lanes |= e, cx |= e, n);
		}
		function ho(e, t, n, r) {
			return Mh(n, t) ? n : ry.current === null ? !(by & 42) || by & 1073741824 && !(Wb & 261930) ? (ib = !0, e.memoizedState = n) : (e = Bc(), xy.lanes |= e, cx |= e, t) : (e = mo(e, n, r), Mh(e, t) || (ib = !0), e);
		}
		function go() {
			Q.asyncTransitions--;
		}
		function _o(e, t, n, r, i) {
			var a = If.p;
			If.p = a !== 0 && a < Ap ? a : Ap;
			var o = Q.T, s = {};
			s._updatedFibers = /* @__PURE__ */ new Set(), Q.T = s, jo(e, !1, t, n);
			try {
				var c = i(), l = Q.S;
				if (l !== null && l(s, c), typeof c == "object" && c && typeof c.then == "function") {
					Q.asyncTransitions++, c.then(go, go);
					var u = fi(c, r);
					Ao(e, t, u, zc(e));
				} else Ao(e, t, r, zc(e));
			} catch (n) {
				Ao(e, t, {
					then: function() {},
					status: "rejected",
					reason: n
				}, zc(e));
			} finally {
				If.p = a, o !== null && s.types !== null && (o.types !== null && o.types !== s.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), o.types = s.types), Q.T = o, o === null && s._updatedFibers && (e = s._updatedFibers.size, s._updatedFibers.clear(), 10 < e && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
			}
		}
		function vo(e, t, n, r) {
			if (e.tag !== 5) throw Error("Expected the form instance to be a HostComponent. This is a bug in React.");
			var i = yo(e).queue;
			qr(e), _o(e, i, t, yC, n === null ? u : function() {
				return bo(e), n(r);
			});
		}
		function yo(e) {
			var t = e.memoizedState;
			if (t !== null) return t;
			t = {
				memoizedState: yC,
				baseState: yC,
				baseQueue: null,
				queue: {
					pending: null,
					lanes: 0,
					dispatch: null,
					lastRenderedReducer: va,
					lastRenderedState: yC
				},
				next: null
			};
			var n = {};
			return t.next = {
				memoizedState: n,
				baseState: n,
				baseQueue: null,
				queue: {
					pending: null,
					lanes: 0,
					dispatch: null,
					lastRenderedReducer: va,
					lastRenderedState: n
				},
				next: null
			}, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
		}
		function bo(e) {
			Q.T === null && console.error("requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition.");
			var t = yo(e);
			t.next === null && (t = e.alternate.memoizedState), Ao(e, t.next.queue, {}, zc(e));
		}
		function xo() {
			var e = Aa(!1);
			return e = _o.bind(null, xy, e.queue, !0, !1), fa().memoizedState = e, [!1, e];
		}
		function So() {
			var e = ba(va)[0], t = pa().memoizedState;
			return [typeof e == "boolean" ? e : ha(e), t];
		}
		function Co() {
			var e = Sa(va)[0], t = pa().memoizedState;
			return [typeof e == "boolean" ? e : ha(e), t];
		}
		function wo() {
			return Br(bC);
		}
		function To() {
			var e = fa(), t = Hb.identifierPrefix;
			if (qg) {
				var n = Wg, r = Ug;
				n = (r & ~(1 << 32 - Cp(r) - 1)).toString(32) + n, t = "_" + t + "R_" + n, n = Dy++, 0 < n && (t += "H" + n.toString(32)), t += "_";
			} else n = Ay++, t = "_" + t + "r_" + n.toString(32) + "_";
			return e.memoizedState = t;
		}
		function Eo() {
			return fa().memoizedState = Do.bind(null, xy);
		}
		function Do(e, t) {
			for (var n = e.return; n !== null;) {
				switch (n.tag) {
					case 24:
					case 3:
						var r = zc(n), i = Li(r), a = Ri(n, i, r);
						a !== null && (Kr(r, "refresh()", e), Vc(a, n, r), zi(a, n, r)), e = Ur(), t != null && a !== null && console.error("The seed argument is not enabled outside experimental channels."), i.payload = { cache: e };
						return;
				}
				n = n.return;
			}
		}
		function Oo(e, t, n) {
			var r = arguments;
			typeof r[3] == "function" && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."), r = zc(e);
			var i = {
				lane: r,
				revertLane: 0,
				gesture: null,
				action: n,
				hasEagerState: !1,
				eagerState: null,
				next: null
			};
			Mo(e) ? No(t, i) : (i = Jn(e, t, i, r), i !== null && (Kr(r, "dispatch()", e), Vc(i, e, r), Po(i, t, r)));
		}
		function ko(e, t, n) {
			var r = arguments;
			typeof r[3] == "function" && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."), r = zc(e), Ao(e, t, n, r) && Kr(r, "setState()", e);
		}
		function Ao(e, t, n, r) {
			var i = {
				lane: r,
				revertLane: 0,
				gesture: null,
				action: n,
				hasEagerState: !1,
				eagerState: null,
				next: null
			};
			if (Mo(e)) No(t, i);
			else {
				var a = e.alternate;
				if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) {
					var o = Q.H;
					Q.H = Vy;
					try {
						var s = t.lastRenderedState, c = a(s, n);
						if (i.hasEagerState = !0, i.eagerState = c, Mh(c, s)) return qn(e, t, i, 0), Hb === null && Kn(), !1;
					} catch {} finally {
						Q.H = o;
					}
				}
				if (n = Jn(e, t, i, r), n !== null) return Vc(n, e, r), Po(n, t, r), !0;
			}
			return !1;
		}
		function jo(e, t, n, r) {
			if (Q.T === null && tv === 0 && console.error("An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."), r = {
				lane: 2,
				revertLane: Ul(),
				gesture: null,
				action: r,
				hasEagerState: !1,
				eagerState: null,
				next: null
			}, Mo(e)) {
				if (t) throw Error("Cannot update optimistic state while rendering.");
				console.error("Cannot call startTransition while rendering.");
			} else t = Jn(e, n, r, 2), t !== null && (Kr(2, "setOptimistic()", e), Vc(t, e, 2));
		}
		function Mo(e) {
			var t = e.alternate;
			return e === xy || t !== null && t === xy;
		}
		function No(e, t) {
			Ty = wy = !0;
			var n = e.pending;
			n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
		}
		function Po(e, t, n) {
			if (n & 4194048) {
				var r = t.lanes;
				r &= e.pendingLanes, n |= r, t.lanes = n, Ee(e, n);
			}
		}
		function Fo(e) {
			if (e !== null && typeof e != "function") {
				var t = String(e);
				$y.has(t) || ($y.add(t), console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", e));
			}
		}
		function Io(e, t, n, r) {
			var i = e.memoizedState, a = n(r, i);
			if (e.mode & Ag) {
				he(!0);
				try {
					a = n(r, i);
				} finally {
					he(!1);
				}
			}
			a === void 0 && (t = E(t) || "Component", Yy.has(t) || (Yy.add(t), console.error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", t))), i = a == null ? i : _f({}, i, a), e.memoizedState = i, e.lanes === 0 && (e.updateQueue.baseState = i);
		}
		function Lo(e, t, n, r, i, a, o) {
			var s = e.stateNode;
			if (typeof s.shouldComponentUpdate == "function") {
				if (n = s.shouldComponentUpdate(r, a, o), e.mode & Ag) {
					he(!0);
					try {
						n = s.shouldComponentUpdate(r, a, o);
					} finally {
						he(!1);
					}
				}
				return n === void 0 && console.error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", E(t) || "Component"), n;
			}
			return t.prototype && t.prototype.isPureReactComponent ? !vn(n, r) || !vn(i, a) : !0;
		}
		function Ro(e, t, n, r) {
			var i = t.state;
			typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== i && (e = O(e) || "Component", Wy.has(e) || (Wy.add(e), console.error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", e)), eb.enqueueReplaceState(t, t.state, null));
		}
		function zo(e, t) {
			var n = t;
			if ("ref" in t) for (var r in n = {}, t) r !== "ref" && (n[r] = t[r]);
			if (e = e.defaultProps) for (var i in n === t && (n = _f({}, n)), e) n[i] === void 0 && (n[i] = e[i]);
			return n;
		}
		function Bo(e) {
			eg(e), console.warn("%s\n\n%s\n", tb ? "An error occurred in the <" + tb + "> component." : "An error occurred in one of your React components.", "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://react.dev/link/error-boundaries to learn more about error boundaries.");
		}
		function Vo(e) {
			var t = tb ? "The above error occurred in the <" + tb + "> component." : "The above error occurred in one of your React components.", n = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((nb || "Anonymous") + ".");
			if (typeof e == "object" && e && typeof e.environmentName == "string") {
				var r = e.environmentName;
				e = [
					"%o\n\n%s\n\n%s\n",
					e,
					t,
					n
				].slice(0), typeof e[0] == "string" ? e.splice(0, 1, xC + " " + e[0], SC, wC + r + wC, CC) : e.splice(0, 0, xC, SC, wC + r + wC, CC), e.unshift(console), r = TC.apply(console.error, e), r();
			} else console.error("%o\n\n%s\n\n%s\n", e, t, n);
		}
		function Ho(e) {
			eg(e);
		}
		function Uo(e, t) {
			try {
				tb = t.source ? O(t.source) : null, nb = null;
				var n = t.value;
				if (Q.actQueue !== null) Q.thrownErrors.push(n);
				else {
					var r = e.onUncaughtError;
					r(n, { componentStack: t.stack });
				}
			} catch (e) {
				setTimeout(function() {
					throw e;
				});
			}
		}
		function Wo(e, t, n) {
			try {
				tb = n.source ? O(n.source) : null, nb = O(t);
				var r = e.onCaughtError;
				r(n.value, {
					componentStack: n.stack,
					errorBoundary: t.tag === 1 ? t.stateNode : null
				});
			} catch (e) {
				setTimeout(function() {
					throw e;
				});
			}
		}
		function Go(e, t, n) {
			return n = Li(n), n.tag = Qv, n.payload = { element: null }, n.callback = function() {
				H(t.source, Uo, e, t);
			}, n;
		}
		function Ko(e) {
			return e = Li(e), e.tag = Qv, e;
		}
		function qo(e, t, n, r) {
			var i = n.type.getDerivedStateFromError;
			if (typeof i == "function") {
				var a = r.value;
				e.payload = function() {
					return i(a);
				}, e.callback = function() {
					nr(n), H(r.source, Wo, t, n, r);
				};
			}
			var o = n.stateNode;
			o !== null && typeof o.componentDidCatch == "function" && (e.callback = function() {
				nr(n), H(r.source, Wo, t, n, r), typeof i != "function" && (Cx === null ? Cx = new Set([this]) : Cx.add(this)), wv(this, r), typeof i == "function" || !(n.lanes & 2) && console.error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", O(n) || "Unknown");
			});
		}
		function Jo(e, t, n, r, i) {
			if (n.flags |= 32768, Sp && jl(e, i), typeof r == "object" && r && typeof r.then == "function") {
				if (t = n.alternate, t !== null && Lr(t, n, i, !0), qg && (Jg = !0), n = ay.current, n !== null) {
					switch (n.tag) {
						case 31:
						case 13: return oy === null ? tl() : n.alternate === null && sx === Pb && (sx = Lb), n.flags &= -257, n.flags |= 65536, n.lanes = i, r === Iv ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = new Set([r]) : t.add(r), Sl(e, r, i)), !1;
						case 22: return n.flags |= 65536, r === Iv ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
							transitions: null,
							markerInstances: null,
							retryQueue: new Set([r])
						}, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = new Set([r]) : n.add(r)), Sl(e, r, i)), !1;
					}
					throw Error("Unexpected Suspense handler tag (" + n.tag + "). This is a bug in React.");
				}
				return Sl(e, r, i), tl(), !1;
			}
			if (qg) return Jg = !0, t = ay.current, t === null ? (r !== Qg && jr(mr(Error("There was an error while hydrating but React was able to recover by instead client rendering the entire root.", { cause: r }), n)), e = e.current.alternate, e.flags |= 65536, i &= -i, e.lanes |= i, r = mr(r, n), i = Go(e.stateNode, r, i), Bi(e, i), sx !== Rb && (sx = Ib)) : (!(t.flags & 65536) && (t.flags |= 256), t.flags |= 65536, t.lanes = i, r !== Qg && jr(mr(Error("There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.", { cause: r }), n))), !1;
			var a = mr(Error("There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.", { cause: r }), n);
			if (px === null ? px = [a] : px.push(a), sx !== Rb && (sx = Ib), t === null) return !0;
			r = mr(r, n), n = t;
			do {
				switch (n.tag) {
					case 3: return n.flags |= 65536, e = i & -i, n.lanes |= e, e = Go(n.stateNode, r, e), Bi(n, e), !1;
					case 1: if (t = n.type, a = n.stateNode, !(n.flags & 128) && (typeof t.getDerivedStateFromError == "function" || a !== null && typeof a.componentDidCatch == "function" && (Cx === null || !Cx.has(a)))) return n.flags |= 65536, i &= -i, n.lanes |= i, i = Ko(i), qo(i, e, n, r), Bi(n, i), !1;
				}
				n = n.return;
			} while (n !== null);
			return !1;
		}
		function Yo(e, t, n, r) {
			t.child = e === null ? Jv(t, null, n, r) : qv(t, e.child, n, r);
		}
		function Xo(e, t, n, r, i) {
			n = n.render;
			var a = t.ref;
			if ("ref" in r) {
				var o = {};
				for (var s in r) s !== "ref" && (o[s] = r[s]);
			} else o = r;
			return zr(t), r = aa(e, t, n, o, a, i), s = la(), e !== null && !ib ? (ua(e, t, i), bs(e, t, i)) : (qg && s && _r(t), t.flags |= 1, Yo(e, t, r, i), t.child);
		}
		function Zo(e, t, n, r, i) {
			if (e === null) {
				var a = n.type;
				return typeof a == "function" && !ar(a) && a.defaultProps === void 0 && n.compare === null ? (n = Qn(a), t.tag = 15, t.type = n, us(t, a), Qo(e, t, n, r, i)) : (e = cr(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
			}
			if (a = e.child, !xs(e, i)) {
				var o = a.memoizedProps;
				if (n = n.compare, n = n === null ? vn : n, n(o, r) && e.ref === t.ref) return bs(e, t, i);
			}
			return t.flags |= 1, e = or(a, r), e.ref = t.ref, e.return = t, t.child = e;
		}
		function Qo(e, t, n, r, i) {
			if (e !== null) {
				var a = e.memoizedProps;
				if (vn(a, r) && e.ref === t.ref && t.type === e.type) if (ib = !1, t.pendingProps = r = a, xs(e, i)) e.flags & 131072 && (ib = !0);
				else return t.lanes = e.lanes, bs(e, t, i);
			}
			return os(e, t, n, r, i);
		}
		function $o(e, t, n, r) {
			var i = r.children, a = e === null ? null : e.memoizedState;
			if (e === null && t.stateNode === null && (t.stateNode = {
				_visibility: yg,
				_pendingMarkers: null,
				_retryCache: null,
				_transitions: null
			}), r.mode === "hidden") {
				if (t.flags & 128) {
					if (a = a === null ? n : a.baseLanes | n, e !== null) {
						for (r = t.child = e.child, i = 0; r !== null;) i = i | r.lanes | r.childLanes, r = r.sibling;
						r = i & ~a;
					} else r = 0, t.child = null;
					return ts(e, t, a, n, r);
				}
				if (n & 536870912) t.memoizedState = {
					baseLanes: 0,
					cachePool: null
				}, e !== null && mi(t, a === null ? null : a.cachePool), a === null ? qi(t) : Ki(t, a), Zi(t);
				else return r = t.lanes = 536870912, ts(e, t, a === null ? n : a.baseLanes | n, n, r);
			} else a === null ? (e !== null && mi(t, null), qi(t), Qi(t)) : (mi(t, a.cachePool), Ki(t, a), Qi(t), t.memoizedState = null);
			return Yo(e, t, i, n), t.child;
		}
		function es(e, t) {
			return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
				_visibility: yg,
				_pendingMarkers: null,
				_retryCache: null,
				_transitions: null
			}), t.sibling;
		}
		function ts(e, t, n, r, i) {
			var a = pi();
			return a = a === null ? null : {
				parent: c_._currentValue,
				pool: a
			}, t.memoizedState = {
				baseLanes: n,
				cachePool: a
			}, e !== null && mi(t, null), qi(t), Zi(t), e !== null && Lr(e, t, r, !0), t.childLanes = i, null;
		}
		function ns(e, t) {
			var n = t.hidden;
			return n !== void 0 && console.error("<Activity> doesn't accept a hidden prop. Use mode=\"hidden\" instead.\n- <Activity %s>\n+ <Activity %s>", !0 === n ? "hidden" : !1 === n ? "hidden={false}" : "hidden={...}", n ? "mode=\"hidden\"" : "mode=\"visible\""), t = hs({
				mode: t.mode,
				children: t.children
			}, e.mode), t.ref = e.ref, e.child = t, t.return = e, t;
		}
		function rs(e, t, n) {
			return qv(t, e.child, null, n), e = ns(t, t.pendingProps), e.flags |= 2, $i(t), t.memoizedState = null, e;
		}
		function is(e, t, n) {
			var r = t.pendingProps, i = (t.flags & 128) != 0;
			if (t.flags &= -129, e === null) {
				if (qg) {
					if (r.mode === "hidden") return e = ns(t, r), t.lanes = 536870912, es(null, e);
					if (Xi(t), (e = Kg) ? (n = td(e, Zg), n = n !== null && n.data === kS ? n : null, n !== null && (r = {
						dehydrated: n,
						treeContext: yr(),
						retryLane: 536870912,
						hydrationErrors: null
					}, t.memoizedState = r, r = fr(n), r.return = t, t.child = r, Gg = t, Kg = null)) : n = null, n === null) throw wr(t, e), Tr(t);
					return t.lanes = 536870912, null;
				}
				return ns(t, r);
			}
			var a = e.memoizedState;
			if (a !== null) {
				var o = a.dehydrated;
				if (Xi(t), i) if (t.flags & 256) t.flags &= -257, t = rs(e, t, n);
				else if (t.memoizedState !== null) t.child = e.child, t.flags |= 128, t = null;
				else throw Error("Client rendering an Activity suspended it again. This is a bug in React.");
				else if (Cr(), n & 536870912 && el(t), ib || Lr(e, t, n, !1), i = (n & e.childLanes) !== 0, ib || i) {
					if (r = Hb, r !== null && (o = De(r, n), o !== 0 && o !== a.retryLane)) throw a.retryLane = o, Yn(e, o), Vc(r, e, o), rb;
					tl(), t = rs(e, t, n);
				} else e = a.treeContext, Kg = ad(o.nextSibling), Gg = t, qg = !0, Xg = null, Jg = !1, Yg = null, Zg = !1, e !== null && br(t, e), t = ns(t, r), t.flags |= 4096;
				return t;
			}
			return a = e.child, r = {
				mode: r.mode,
				children: r.children
			}, n & 536870912 && (n & e.lanes) !== 0 && el(t), e = or(a, r), e.ref = t.ref, t.child = e, e.return = t, e;
		}
		function as(e, t) {
			var n = t.ref;
			if (n === null) e !== null && e.ref !== null && (t.flags |= 4194816);
			else {
				if (typeof n != "function" && typeof n != "object") throw Error("Expected ref to be a function, an object returned by React.createRef(), or undefined/null.");
				(e === null || e.ref !== n) && (t.flags |= 4194816);
			}
		}
		function os(e, t, n, r, i) {
			if (n.prototype && typeof n.prototype.render == "function") {
				var a = E(n) || "Unknown";
				ab[a] || (console.error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", a, a), ab[a] = !0);
			}
			return t.mode & Ag && av.recordLegacyContextWarning(t, null), e === null && (us(t, t.type), n.contextTypes && (a = E(n) || "Unknown", sb[a] || (sb[a] = !0, console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)", a)))), zr(t), n = aa(e, t, n, r, void 0, i), r = la(), e !== null && !ib ? (ua(e, t, i), bs(e, t, i)) : (qg && r && _r(t), t.flags |= 1, Yo(e, t, n, i), t.child);
		}
		function ss(e, t, n, r, i, a) {
			return zr(t), Ny = -1, Py = e !== null && e.type !== t.type, t.updateQueue = null, n = sa(t, r, n, i), oa(e, t), r = la(), e !== null && !ib ? (ua(e, t, a), bs(e, t, a)) : (qg && r && _r(t), t.flags |= 1, Yo(e, t, n, a), t.child);
		}
		function cs(e, t, n, r, i) {
			switch (s(t)) {
				case !1:
					var a = t.stateNode, o = new t.type(t.memoizedProps, a.context).state;
					a.updater.enqueueSetState(a, o, null);
					break;
				case !0:
					t.flags |= 128, t.flags |= 65536, a = Error("Simulated error coming from DevTools");
					var c = i & -i;
					if (t.lanes |= c, o = Hb, o === null) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
					c = Ko(c), qo(c, o, t, mr(a, t)), Bi(t, c);
			}
			if (zr(t), t.stateNode === null) {
				if (o = wg, a = n.contextType, "contextType" in n && a !== null && (a === void 0 || a.$$typeof !== Tf) && !Qy.has(n) && (Qy.add(n), c = a === void 0 ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof a == "object" ? a.$$typeof === wf ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(a).join(", ") + "}." : " However, it is set to a " + typeof a + ".", console.error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", E(n) || "Component", c)), typeof a == "object" && a && (o = Br(a)), a = new n(r, o), t.mode & Ag) {
					he(!0);
					try {
						a = new n(r, o);
					} finally {
						he(!1);
					}
				}
				if (o = t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = eb, t.stateNode = a, a._reactInternals = t, a._reactInternalInstance = Uy, typeof n.getDerivedStateFromProps == "function" && o === null && (o = E(n) || "Component", Gy.has(o) || (Gy.add(o), console.error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", o, a.state === null ? "null" : "undefined", o))), typeof n.getDerivedStateFromProps == "function" || typeof a.getSnapshotBeforeUpdate == "function") {
					var l = c = o = null;
					if (typeof a.componentWillMount == "function" && !0 !== a.componentWillMount.__suppressDeprecationWarning ? o = "componentWillMount" : typeof a.UNSAFE_componentWillMount == "function" && (o = "UNSAFE_componentWillMount"), typeof a.componentWillReceiveProps == "function" && !0 !== a.componentWillReceiveProps.__suppressDeprecationWarning ? c = "componentWillReceiveProps" : typeof a.UNSAFE_componentWillReceiveProps == "function" && (c = "UNSAFE_componentWillReceiveProps"), typeof a.componentWillUpdate == "function" && !0 !== a.componentWillUpdate.__suppressDeprecationWarning ? l = "componentWillUpdate" : typeof a.UNSAFE_componentWillUpdate == "function" && (l = "UNSAFE_componentWillUpdate"), o !== null || c !== null || l !== null) {
						a = E(n) || "Component";
						var u = typeof n.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
						qy.has(a) || (qy.add(a), console.error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://react.dev/link/unsafe-component-lifecycles", a, u, o === null ? "" : "\n  " + o, c === null ? "" : "\n  " + c, l === null ? "" : "\n  " + l));
					}
				}
				a = t.stateNode, o = E(n) || "Component", a.render || (n.prototype && typeof n.prototype.render == "function" ? console.error("No `render` method found on the %s instance: did you accidentally return an object from the constructor?", o) : console.error("No `render` method found on the %s instance: you may have forgotten to define `render`.", o)), !a.getInitialState || a.getInitialState.isReactClassApproved || a.state || console.error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", o), a.getDefaultProps && !a.getDefaultProps.isReactClassApproved && console.error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", o), a.contextType && console.error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", o), n.childContextTypes && !Zy.has(n) && (Zy.add(n), console.error("%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)", o)), n.contextTypes && !Xy.has(n) && (Xy.add(n), console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)", o)), typeof a.componentShouldUpdate == "function" && console.error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", o), n.prototype && n.prototype.isPureReactComponent && a.shouldComponentUpdate !== void 0 && console.error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", E(n) || "A pure component"), typeof a.componentDidUnmount == "function" && console.error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", o), typeof a.componentDidReceiveProps == "function" && console.error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", o), typeof a.componentWillRecieveProps == "function" && console.error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", o), typeof a.UNSAFE_componentWillRecieveProps == "function" && console.error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", o), c = a.props !== r, a.props !== void 0 && c && console.error("When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", o), a.defaultProps && console.error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", o, o), typeof a.getSnapshotBeforeUpdate != "function" || typeof a.componentDidUpdate == "function" || Ky.has(n) || (Ky.add(n), console.error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", E(n))), typeof a.getDerivedStateFromProps == "function" && console.error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", o), typeof a.getDerivedStateFromError == "function" && console.error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", o), typeof n.getSnapshotBeforeUpdate == "function" && console.error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", o), (c = a.state) && (typeof c != "object" || Ff(c)) && console.error("%s.state: must be set to an object or null", o), typeof a.getChildContext == "function" && typeof n.childContextTypes != "object" && console.error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", o), a = t.stateNode, a.props = r, a.state = t.memoizedState, a.refs = {}, Fi(t), o = n.contextType, a.context = typeof o == "object" && o ? Br(o) : wg, a.state === r && (o = E(n) || "Component", Jy.has(o) || (Jy.add(o), console.error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", o))), t.mode & Ag && av.recordLegacyContextWarning(t, a), av.recordUnsafeLifecycleWarnings(t, a), a.state = t.memoizedState, o = n.getDerivedStateFromProps, typeof o == "function" && (Io(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof a.getSnapshotBeforeUpdate == "function" || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (o = a.state, typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), o !== a.state && (console.error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", O(t) || "Component"), eb.enqueueReplaceState(a, a.state, null)), Hi(t, r, a, i), Vi(), a.state = t.memoizedState), typeof a.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & jg) !== Dg && (t.flags |= 134217728), a = !0;
			} else if (e === null) {
				a = t.stateNode;
				var d = t.memoizedProps;
				c = zo(n, d), a.props = c;
				var f = a.context;
				l = n.contextType, o = wg, typeof l == "object" && l && (o = Br(l)), u = n.getDerivedStateFromProps, l = typeof u == "function" || typeof a.getSnapshotBeforeUpdate == "function", d = t.pendingProps !== d, l || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (d || f !== o) && Ro(t, a, r, o), $v = !1;
				var p = t.memoizedState;
				a.state = p, Hi(t, r, a, i), Vi(), f = t.memoizedState, d || p !== f || $v ? (typeof u == "function" && (Io(t, n, u, r), f = t.memoizedState), (c = $v || Lo(t, n, c, r, p, f, o)) ? (l || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & jg) !== Dg && (t.flags |= 134217728)) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & jg) !== Dg && (t.flags |= 134217728), t.memoizedProps = r, t.memoizedState = f), a.props = r, a.state = f, a.context = o, a = c) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & jg) !== Dg && (t.flags |= 134217728), a = !1);
			} else {
				a = t.stateNode, Ii(e, t), o = t.memoizedProps, l = zo(n, o), a.props = l, u = t.pendingProps, p = a.context, f = n.contextType, c = wg, typeof f == "object" && f && (c = Br(f)), d = n.getDerivedStateFromProps, (f = typeof d == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (o !== u || p !== c) && Ro(t, a, r, c), $v = !1, p = t.memoizedState, a.state = p, Hi(t, r, a, i), Vi();
				var m = t.memoizedState;
				o !== u || p !== m || $v || e !== null && e.dependencies !== null && Rr(e.dependencies) ? (typeof d == "function" && (Io(t, n, d, r), m = t.memoizedState), (l = $v || Lo(t, n, l, r, p, m, c) || e !== null && e.dependencies !== null && Rr(e.dependencies)) ? (f || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, m, c), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, m, c)), typeof a.componentDidUpdate == "function" && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && p === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && p === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = m), a.props = r, a.state = m, a.context = c, a = l) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && p === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && p === e.memoizedState || (t.flags |= 1024), a = !1);
			}
			if (c = a, as(e, t), o = (t.flags & 128) != 0, c || o) {
				if (c = t.stateNode, se(t), o && typeof n.getDerivedStateFromError != "function") n = null, __ = -1;
				else if (n = vv(c), t.mode & Ag) {
					he(!0);
					try {
						vv(c);
					} finally {
						he(!1);
					}
				}
				t.flags |= 1, e !== null && o ? (t.child = qv(t, e.child, null, i), t.child = qv(t, null, n, i)) : Yo(e, t, n, i), t.memoizedState = c.state, e = t.child;
			} else e = bs(e, t, i);
			return i = t.stateNode, a && i.props !== r && (lb || console.error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", O(t) || "a component"), lb = !0), e;
		}
		function ls(e, t, n, r) {
			return kr(), t.flags |= 256, Yo(e, t, n, r), t.child;
		}
		function us(e, t) {
			t && t.childContextTypes && console.error("childContextTypes cannot be defined on a function component.\n  %s.childContextTypes = ...", t.displayName || t.name || "Component"), typeof t.getDerivedStateFromProps == "function" && (e = E(t) || "Unknown", cb[e] || (console.error("%s: Function components do not support getDerivedStateFromProps.", e), cb[e] = !0)), typeof t.contextType == "object" && t.contextType !== null && (t = E(t) || "Unknown", ob[t] || (console.error("%s: Function components do not support contextType.", t), ob[t] = !0));
		}
		function ds(e) {
			return {
				baseLanes: e,
				cachePool: hi()
			};
		}
		function fs(e, t, n) {
			return e = e === null ? 0 : e.childLanes & ~n, t && (e |= dx), e;
		}
		function ps(e, t, n) {
			var r, i = t.pendingProps;
			o(t) && (t.flags |= 128);
			var a = !1, s = (t.flags & 128) != 0;
			if ((r = s) || (r = e !== null && e.memoizedState === null ? !1 : (ly.current & cy) !== 0), r && (a = !0, t.flags &= -129), r = (t.flags & 32) != 0, t.flags &= -33, e === null) {
				if (qg) {
					if (a ? Yi(t) : Qi(t), (e = Kg) ? (n = td(e, Zg), n = n !== null && n.data !== kS ? n : null, n !== null && (r = {
						dehydrated: n,
						treeContext: yr(),
						retryLane: 536870912,
						hydrationErrors: null
					}, t.memoizedState = r, r = fr(n), r.return = t, t.child = r, Gg = t, Kg = null)) : n = null, n === null) throw wr(t, e), Tr(t);
					return rd(n) ? t.lanes = 32 : t.lanes = 536870912, null;
				}
				var c = i.children;
				if (i = i.fallback, a) {
					Qi(t);
					var l = t.mode;
					return c = hs({
						mode: "hidden",
						children: c
					}, l), i = ur(i, l, n, null), c.return = t, i.return = t, c.sibling = i, t.child = c, i = t.child, i.memoizedState = ds(n), i.childLanes = fs(e, r, n), t.memoizedState = fb, es(null, i);
				}
				return Yi(t), ms(t, c);
			}
			var u = e.memoizedState;
			if (u !== null) {
				var d = u.dehydrated;
				if (d !== null) {
					if (s) t.flags & 256 ? (Yi(t), t.flags &= -257, t = gs(e, t, n)) : t.memoizedState === null ? (Qi(t), c = i.fallback, l = t.mode, i = hs({
						mode: "visible",
						children: i.children
					}, l), c = ur(c, l, n, null), c.flags |= 2, i.return = t, c.return = t, i.sibling = c, t.child = i, qv(t, e.child, null, n), i = t.child, i.memoizedState = ds(n), i.childLanes = fs(e, r, n), t.memoizedState = fb, t = es(null, i)) : (Qi(t), t.child = e.child, t.flags |= 128, t = null);
					else if (Yi(t), Cr(), n & 536870912 && el(t), rd(d)) {
						if (r = d.nextSibling && d.nextSibling.dataset, r) {
							c = r.dgst;
							var f = r.msg;
							l = r.stck;
							var p = r.cstck;
						}
						a = f, r = c, i = l, d = p, c = a, l = d, c = Error(c || "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."), c.stack = i || "", c.digest = r, r = l === void 0 ? null : l, i = {
							value: c,
							source: null,
							stack: r
						}, typeof r == "string" && Fg.set(c, i), jr(i), t = gs(e, t, n);
					} else if (ib || Lr(e, t, n, !1), r = (n & e.childLanes) !== 0, ib || r) {
						if (r = Hb, r !== null && (i = De(r, n), i !== 0 && i !== u.retryLane)) throw u.retryLane = i, Yn(e, i), Vc(r, e, i), rb;
						nd(d) || tl(), t = gs(e, t, n);
					} else nd(d) ? (t.flags |= 192, t.child = e.child, t = null) : (e = u.treeContext, Kg = ad(d.nextSibling), Gg = t, qg = !0, Xg = null, Jg = !1, Yg = null, Zg = !1, e !== null && br(t, e), t = ms(t, i.children), t.flags |= 4096);
					return t;
				}
			}
			return a ? (Qi(t), c = i.fallback, l = t.mode, p = e.child, d = p.sibling, i = or(p, {
				mode: "hidden",
				children: i.children
			}), i.subtreeFlags = p.subtreeFlags & 65011712, d === null ? (c = ur(c, l, n, null), c.flags |= 2) : c = or(d, c), c.return = t, i.return = t, i.sibling = c, t.child = i, es(null, i), i = t.child, c = e.child.memoizedState, c === null ? c = ds(n) : (l = c.cachePool, l === null ? l = hi() : (p = c_._currentValue, l = l.parent === p ? l : {
				parent: p,
				pool: p
			}), c = {
				baseLanes: c.baseLanes | n,
				cachePool: l
			}), i.memoizedState = c, i.childLanes = fs(e, r, n), t.memoizedState = fb, es(e.child, i)) : (u !== null && (n & 62914560) === n && (n & e.lanes) !== 0 && el(t), Yi(t), n = e.child, e = n.sibling, n = or(n, {
				mode: "visible",
				children: i.children
			}), n.return = t, n.sibling = null, e !== null && (r = t.deletions, r === null ? (t.deletions = [e], t.flags |= 16) : r.push(e)), t.child = n, t.memoizedState = null, n);
		}
		function ms(e, t) {
			return t = hs({
				mode: "visible",
				children: t
			}, e.mode), t.return = e, e.child = t;
		}
		function hs(e, t) {
			return e = p(22, e, null, t), e.lanes = 0, e;
		}
		function gs(e, t, n) {
			return qv(t, e.child, null, n), e = ms(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
		}
		function _s(e, t, n) {
			e.lanes |= t;
			var r = e.alternate;
			r !== null && (r.lanes |= t), q(e.return, t, n);
		}
		function vs(e, t, n, r, i, a) {
			var o = e.memoizedState;
			o === null ? e.memoizedState = {
				isBackwards: t,
				rendering: null,
				renderingStartTime: 0,
				last: r,
				tail: n,
				tailMode: i,
				treeForkCount: a
			} : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i, o.treeForkCount = a);
		}
		function ys(e, t, n) {
			var r = t.pendingProps, i = r.revealOrder, a = r.tail, o = r.children, s = ly.current;
			if ((r = (s & cy) !== 0) ? (s = s & sy | cy, t.flags |= 128) : s &= sy, j(ly, s, t), s = i ?? "null", i !== "forwards" && i !== "unstable_legacy-backwards" && i !== "together" && i !== "independent" && !ub[s]) if (ub[s] = !0, i == null) console.error("The default for the <SuspenseList revealOrder=\"...\"> prop is changing. To be future compatible you must explictly specify either \"independent\" (the current default), \"together\", \"forwards\" or \"legacy_unstable-backwards\".");
			else if (i === "backwards") console.error("The rendering order of <SuspenseList revealOrder=\"backwards\"> is changing. To be future compatible you must specify revealOrder=\"legacy_unstable-backwards\" instead.");
			else if (typeof i == "string") switch (i.toLowerCase()) {
				case "together":
				case "forwards":
				case "backwards":
				case "independent":
					console.error("\"%s\" is not a valid value for revealOrder on <SuspenseList />. Use lowercase \"%s\" instead.", i, i.toLowerCase());
					break;
				case "forward":
				case "backward":
					console.error("\"%s\" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use \"%ss\" instead.", i, i.toLowerCase());
					break;
				default: console.error("\"%s\" is not a supported revealOrder on <SuspenseList />. Did you mean \"independent\", \"together\", \"forwards\" or \"backwards\"?", i);
			}
			else console.error("%s is not a supported value for revealOrder on <SuspenseList />. Did you mean \"independent\", \"together\", \"forwards\" or \"backwards\"?", i);
			s = a ?? "null", db[s] || (a == null ? (i === "forwards" || i === "backwards" || i === "unstable_legacy-backwards") && (db[s] = !0, console.error("The default for the <SuspenseList tail=\"...\"> prop is changing. To be future compatible you must explictly specify either \"visible\" (the current default), \"collapsed\" or \"hidden\".")) : a !== "visible" && a !== "collapsed" && a !== "hidden" ? (db[s] = !0, console.error("\"%s\" is not a supported value for tail on <SuspenseList />. Did you mean \"visible\", \"collapsed\" or \"hidden\"?", a)) : i !== "forwards" && i !== "backwards" && i !== "unstable_legacy-backwards" && (db[s] = !0, console.error("<SuspenseList tail=\"%s\" /> is only valid if revealOrder is \"forwards\" or \"backwards\". Did you mean to specify revealOrder=\"forwards\"?", a)));
			a: if ((i === "forwards" || i === "backwards" || i === "unstable_legacy-backwards") && o != null && !1 !== o) if (Ff(o)) {
				for (s = 0; s < o.length; s++) if (!Pi(o[s], s)) break a;
			} else if (s = T(o), typeof s == "function") {
				if (s = s.call(o)) for (var c = s.next(), l = 0; !c.done; c = s.next()) {
					if (!Pi(c.value, l)) break a;
					l++;
				}
			} else console.error("A single row was passed to a <SuspenseList revealOrder=\"%s\" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?", i);
			if (Yo(e, t, o, n), qg ? (xr(), o = zg) : o = 0, !r && e !== null && e.flags & 128) a: for (e = t.child; e !== null;) {
				if (e.tag === 13) e.memoizedState !== null && _s(e, n, t);
				else if (e.tag === 19) _s(e, n, t);
				else if (e.child !== null) {
					e.child.return = e, e = e.child;
					continue;
				}
				if (e === t) break a;
				for (; e.sibling === null;) {
					if (e.return === null || e.return === t) break a;
					e = e.return;
				}
				e.sibling.return = e.return, e = e.sibling;
			}
			switch (i) {
				case "forwards":
					for (n = t.child, i = null; n !== null;) e = n.alternate, e !== null && ea(e) === null && (i = n), n = n.sibling;
					n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), vs(t, !1, i, n, a, o);
					break;
				case "backwards":
				case "unstable_legacy-backwards":
					for (n = null, i = t.child, t.child = null; i !== null;) {
						if (e = i.alternate, e !== null && ea(e) === null) {
							t.child = i;
							break;
						}
						e = i.sibling, i.sibling = n, n = i, i = e;
					}
					vs(t, !0, n, null, a, o);
					break;
				case "together":
					vs(t, !1, null, null, void 0, o);
					break;
				default: t.memoizedState = null;
			}
			return t.child;
		}
		function bs(e, t, n) {
			if (e !== null && (t.dependencies = e.dependencies), __ = -1, cx |= t.lanes, (n & t.childLanes) === 0) if (e !== null) {
				if (Lr(e, t, n, !1), (n & t.childLanes) === 0) return null;
			} else return null;
			if (e !== null && t.child !== e.child) throw Error("Resuming work not yet implemented.");
			if (t.child !== null) {
				for (e = t.child, n = or(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, n = n.sibling = or(e, e.pendingProps), n.return = t;
				n.sibling = null;
			}
			return t.child;
		}
		function xs(e, t) {
			return (e.lanes & t) === 0 ? (e = e.dependencies, !!(e !== null && Rr(e))) : !0;
		}
		function Ss(e, t, n) {
			switch (t.tag) {
				case 3:
					N(t, t.stateNode.containerInfo), Pr(t, c_, e.memoizedState.cache), kr();
					break;
				case 27:
				case 5:
					I(t);
					break;
				case 4:
					N(t, t.stateNode.containerInfo);
					break;
				case 10:
					Pr(t, t.type, t.memoizedProps.value);
					break;
				case 12:
					(n & t.childLanes) !== 0 && (t.flags |= 4), t.flags |= 2048;
					var r = t.stateNode;
					r.effectDuration = -0, r.passiveEffectDuration = -0;
					break;
				case 31:
					if (t.memoizedState !== null) return t.flags |= 128, Xi(t), null;
					break;
				case 13:
					if (r = t.memoizedState, r !== null) return r.dehydrated === null ? (n & t.child.childLanes) === 0 ? (Yi(t), e = bs(e, t, n), e === null ? null : e.sibling) : ps(e, t, n) : (Yi(t), t.flags |= 128, null);
					Yi(t);
					break;
				case 19:
					var i = (e.flags & 128) != 0;
					if (r = (n & t.childLanes) !== 0, r ||= (Lr(e, t, n, !1), (n & t.childLanes) !== 0), i) {
						if (r) return ys(e, t, n);
						t.flags |= 128;
					}
					if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), j(ly, ly.current, t), r) break;
					return null;
				case 22: return t.lanes = 0, $o(e, t, n, t.pendingProps);
				case 24: Pr(t, c_, e.memoizedState.cache);
			}
			return bs(e, t, n);
		}
		function Cs(e, t, n) {
			if (t._debugNeedsRemount && e !== null) {
				n = cr(t.type, t.key, t.pendingProps, t._debugOwner || null, t.mode, t.lanes), n._debugStack = t._debugStack, n._debugTask = t._debugTask;
				var r = t.return;
				if (r === null) throw Error("Cannot swap the root fiber.");
				if (e.alternate = null, t.alternate = null, n.index = t.index, n.sibling = t.sibling, n.return = t.return, n.ref = t.ref, n._debugInfo = t._debugInfo, t === r.child) r.child = n;
				else {
					var i = r.child;
					if (i === null) throw Error("Expected parent to have a child.");
					for (; i.sibling !== t;) if (i = i.sibling, i === null) throw Error("Expected to find the previous sibling.");
					i.sibling = n;
				}
				return t = r.deletions, t === null ? (r.deletions = [e], r.flags |= 16) : t.push(e), n.flags |= 2, n;
			}
			if (e !== null) if (e.memoizedProps !== t.pendingProps || t.type !== e.type) ib = !0;
			else {
				if (!xs(e, n) && !(t.flags & 128)) return ib = !1, Ss(e, t, n);
				ib = !!(e.flags & 131072);
			}
			else ib = !1, (r = qg) && (xr(), r = (t.flags & 1048576) != 0), r && (r = t.index, xr(), gr(t, zg, r));
			switch (t.lanes = 0, t.tag) {
				case 16:
					a: if (r = t.pendingProps, e = yi(t.elementType), t.type = e, typeof e == "function") ar(e) ? (r = zo(e, r), t.tag = 1, t.type = e = Qn(e), t = cs(null, t, e, r, n)) : (t.tag = 0, us(t, e), t.type = e = Qn(e), t = os(null, t, e, r, n));
					else {
						if (e != null) {
							if (i = e.$$typeof, i === Ef) {
								t.tag = 11, t.type = e = $n(e), t = Xo(null, t, e, r, n);
								break a;
							} else if (i === kf) {
								t.tag = 14, t = Zo(null, t, e, r, n);
								break a;
							}
						}
						throw t = "", typeof e == "object" && e && e.$$typeof === Af && (t = " Did you wrap a component in React.lazy() more than once?"), n = E(e) || e, Error("Element type is invalid. Received a promise that resolves to: " + n + ". Lazy element type must resolve to a class or function." + t);
					}
					return t;
				case 0: return os(e, t, t.type, t.pendingProps, n);
				case 1: return r = t.type, i = zo(r, t.pendingProps), cs(e, t, r, i, n);
				case 3:
					a: {
						if (N(t, t.stateNode.containerInfo), e === null) throw Error("Should have a current fiber. This is a bug in React.");
						r = t.pendingProps;
						var a = t.memoizedState;
						i = a.element, Ii(e, t), Hi(t, r, null, n);
						var o = t.memoizedState;
						if (r = o.cache, Pr(t, c_, r), r !== a.cache && Ir(t, [c_], n, !0), Vi(), r = o.element, a.isDehydrated) if (a = {
							element: r,
							isDehydrated: !1,
							cache: o.cache
						}, t.updateQueue.baseState = a, t.memoizedState = a, t.flags & 256) {
							t = ls(e, t, r, n);
							break a;
						} else if (r !== i) {
							i = mr(Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), t), jr(i), t = ls(e, t, r, n);
							break a;
						} else {
							switch (e = t.stateNode.containerInfo, e.nodeType) {
								case 9:
									e = e.body;
									break;
								default: e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
							}
							for (Kg = ad(e.firstChild), Gg = t, qg = !0, Xg = null, Jg = !1, Yg = null, Zg = !0, n = Jv(t, null, r, n), t.child = n; n;) n.flags = n.flags & -3 | 4096, n = n.sibling;
						}
						else {
							if (kr(), r === i) {
								t = bs(e, t, n);
								break a;
							}
							Yo(e, t, r, n);
						}
						t = t.child;
					}
					return t;
				case 26: return as(e, t), e === null ? (n = _d(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : qg || (n = t.type, e = t.pendingProps, r = M(Uf.current), r = Du(r).createElement(n), r[Pp] = t, r[Fp] = e, pu(r, n, e), Re(r), t.stateNode = r) : t.memoizedState = _d(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null;
				case 27: return I(t), e === null && qg && (r = M(Uf.current), i = F(), r = t.stateNode = fd(t.type, t.pendingProps, r, i, !1), Jg || (i = Cu(r, t.type, t.pendingProps, i), i !== null && (Sr(t, 0).serverProps = i)), Gg = t, Zg = !0, i = Kg, Vu(t.type) ? (nC = i, Kg = ad(r.firstChild)) : Kg = i), Yo(e, t, t.pendingProps.children, n), as(e, t), e === null && (t.flags |= 4194304), t.child;
				case 5: return e === null && qg && (a = F(), r = jt(t.type, a.ancestorInfo), i = Kg, (o = !i) || (o = $u(i, t.type, t.pendingProps, Zg), o === null ? a = !1 : (t.stateNode = o, Jg || (a = Cu(o, t.type, t.pendingProps, a), a !== null && (Sr(t, 0).serverProps = a)), Gg = t, Kg = ad(o.firstChild), Zg = !1, a = !0), o = !a), o && (r && wr(t, i), Tr(t))), I(t), i = t.type, a = t.pendingProps, o = e === null ? null : e.memoizedProps, r = a.children, Au(i, a) ? r = null : o !== null && Au(i, o) && (t.flags |= 32), t.memoizedState !== null && (i = aa(e, t, ca, null, null, n), bC._currentValue = i), as(e, t), Yo(e, t, r, n), t.child;
				case 6: return e === null && qg && (n = t.pendingProps, e = F(), r = e.ancestorInfo.current, n = r == null ? !0 : Mt(n, r.tag, e.ancestorInfo.implicitRootScope), e = Kg, (r = !e) || (r = ed(e, t.pendingProps, Zg), r === null ? r = !1 : (t.stateNode = r, Gg = t, Kg = null, r = !0), r = !r), r && (n && wr(t, e), Tr(t))), null;
				case 13: return ps(e, t, n);
				case 4: return N(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = qv(t, null, r, n) : Yo(e, t, r, n), t.child;
				case 11: return Xo(e, t, t.type, t.pendingProps, n);
				case 7: return Yo(e, t, t.pendingProps, n), t.child;
				case 8: return Yo(e, t, t.pendingProps.children, n), t.child;
				case 12: return t.flags |= 4, t.flags |= 2048, r = t.stateNode, r.effectDuration = -0, r.passiveEffectDuration = -0, Yo(e, t, t.pendingProps.children, n), t.child;
				case 10: return r = t.type, i = t.pendingProps, a = i.value, "value" in i || pb || (pb = !0, console.error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?")), Pr(t, r, a), Yo(e, t, i.children, n), t.child;
				case 9: return i = t.type._context, r = t.pendingProps.children, typeof r != "function" && console.error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), zr(t), i = Br(i), r = gv(r, i, void 0), t.flags |= 1, Yo(e, t, r, n), t.child;
				case 14: return Zo(e, t, t.type, t.pendingProps, n);
				case 15: return Qo(e, t, t.type, t.pendingProps, n);
				case 19: return ys(e, t, n);
				case 31: return is(e, t, n);
				case 22: return $o(e, t, n, t.pendingProps);
				case 24: return zr(t), r = Br(c_), e === null ? (i = pi(), i === null && (i = Hb, a = Ur(), i.pooledCache = a, Wr(a), a !== null && (i.pooledCacheLanes |= n), i = a), t.memoizedState = {
					parent: r,
					cache: i
				}, Fi(t), Pr(t, c_, i)) : ((e.lanes & n) !== 0 && (Ii(e, t), Hi(t, null, null, n), Vi()), i = e.memoizedState, a = t.memoizedState, i.parent === r ? (r = a.cache, Pr(t, c_, r), r !== i.cache && Ir(t, [c_], n, !0)) : (i = {
					parent: r,
					cache: r
				}, t.memoizedState = i, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = i), Pr(t, c_, r))), Yo(e, t, t.pendingProps.children, n), t.child;
				case 29: throw t.pendingProps;
			}
			throw Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
		}
		function ws(e) {
			e.flags |= 4;
		}
		function Ts(e, t, n, r, i) {
			if ((t = (e.mode & Mg) !== Dg) && (t = !1), t) {
				if (e.flags |= 16777216, (i & 335544128) === i) if (e.stateNode.complete) e.flags |= 8192;
				else if (Zc()) e.flags |= 8192;
				else throw Lv = Iv, Pv;
			} else e.flags &= -16777217;
		}
		function Es(e, t) {
			if (t.type !== "stylesheet" || (t.state.loading & sC) !== rC) e.flags &= -16777217;
			else if (e.flags |= 16777216, !Md(t)) if (Zc()) e.flags |= 8192;
			else throw Lv = Iv, Pv;
		}
		function Ds(e, t) {
			t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag === 22 ? 536870912 : xe(), e.lanes |= t, fx |= t);
		}
		function Os(e, t) {
			if (!qg) switch (e.tailMode) {
				case "hidden":
					t = e.tail;
					for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
					n === null ? e.tail = null : n.sibling = null;
					break;
				case "collapsed":
					n = e.tail;
					for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
					r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
			}
		}
		function ks(e) {
			var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
			if (t) if ((e.mode & kg) !== Dg) {
				for (var i = e.selfBaseDuration, a = e.child; a !== null;) n |= a.lanes | a.childLanes, r |= a.subtreeFlags & 65011712, r |= a.flags & 65011712, i += a.treeBaseDuration, a = a.sibling;
				e.treeBaseDuration = i;
			} else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 65011712, r |= i.flags & 65011712, i.return = e, i = i.sibling;
			else if ((e.mode & kg) !== Dg) {
				i = e.actualDuration, a = e.selfBaseDuration;
				for (var o = e.child; o !== null;) n |= o.lanes | o.childLanes, r |= o.subtreeFlags, r |= o.flags, i += o.actualDuration, a += o.treeBaseDuration, o = o.sibling;
				e.actualDuration = i, e.treeBaseDuration = a;
			} else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
			return e.subtreeFlags |= r, e.childLanes = n, t;
		}
		function As(e, t, n) {
			var r = t.pendingProps;
			switch (vr(t), t.tag) {
				case 16:
				case 15:
				case 0:
				case 11:
				case 7:
				case 8:
				case 12:
				case 9:
				case 14: return ks(t), null;
				case 1: return ks(t), null;
				case 3: return n = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), Fr(c_, t), P(t), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (Or(t) ? (Mr(), ws(t)) : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Ar())), ks(t), null;
				case 26:
					var i = t.type, a = t.memoizedState;
					return e === null ? (ws(t), a === null ? (ks(t), Ts(t, i, null, r, n)) : (ks(t), Es(t, a))) : a ? a === e.memoizedState ? (ks(t), t.flags &= -16777217) : (ws(t), ks(t), Es(t, a)) : (e = e.memoizedProps, e !== r && ws(t), ks(t), Ts(t, i, e, r, n)), null;
				case 27:
					if (L(t), n = M(Uf.current), i = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && ws(t);
					else {
						if (!r) {
							if (t.stateNode === null) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
							return ks(t), null;
						}
						e = F(), Or(t) ? Er(t, e) : (e = fd(i, r, n, e, !0), t.stateNode = e, ws(t));
					}
					return ks(t), null;
				case 5:
					if (L(t), i = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && ws(t);
					else {
						if (!r) {
							if (t.stateNode === null) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
							return ks(t), null;
						}
						var o = F();
						if (Or(t)) Er(t, o);
						else {
							switch (a = M(Uf.current), jt(i, o.ancestorInfo), o = o.context, a = Du(a), o) {
								case WS:
									a = a.createElementNS(wm, i);
									break;
								case GS:
									a = a.createElementNS(Cm, i);
									break;
								default: switch (i) {
									case "svg":
										a = a.createElementNS(wm, i);
										break;
									case "math":
										a = a.createElementNS(Cm, i);
										break;
									case "script":
										a = a.createElement("div"), a.innerHTML = "<script><\/script>", a = a.removeChild(a.firstChild);
										break;
									case "select":
										a = typeof r.is == "string" ? a.createElement("select", { is: r.is }) : a.createElement("select"), r.multiple ? a.multiple = !0 : r.size && (a.size = r.size);
										break;
									default: a = typeof r.is == "string" ? a.createElement(i, { is: r.is }) : a.createElement(i), i.indexOf("-") === -1 && (i !== i.toLowerCase() && console.error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", i), Object.prototype.toString.call(a) !== "[object HTMLUnknownElement]" || ap.call(JS, i) || (JS[i] = !0, console.error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", i)));
								}
							}
							a[Pp] = t, a[Fp] = r;
							a: for (o = t.child; o !== null;) {
								if (o.tag === 5 || o.tag === 6) a.appendChild(o.stateNode);
								else if (o.tag !== 4 && o.tag !== 27 && o.child !== null) {
									o.child.return = o, o = o.child;
									continue;
								}
								if (o === t) break a;
								for (; o.sibling === null;) {
									if (o.return === null || o.return === t) break a;
									o = o.return;
								}
								o.sibling.return = o.return, o = o.sibling;
							}
							t.stateNode = a;
							a: switch (pu(a, i, r), i) {
								case "button":
								case "input":
								case "select":
								case "textarea":
									r = !!r.autoFocus;
									break a;
								case "img":
									r = !0;
									break a;
								default: r = !1;
							}
							r && ws(t);
						}
					}
					return ks(t), Ts(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n), null;
				case 6:
					if (e && t.stateNode != null) e.memoizedProps !== r && ws(t);
					else {
						if (typeof r != "string" && t.stateNode === null) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
						if (e = M(Uf.current), n = F(), Or(t)) {
							if (e = t.stateNode, n = t.memoizedProps, i = !Jg, r = null, a = Gg, a !== null) switch (a.tag) {
								case 3:
									i && (i = sd(e, n, r), i !== null && (Sr(t, 0).serverProps = i));
									break;
								case 27:
								case 5: r = a.memoizedProps, i && (i = sd(e, n, r), i !== null && (Sr(t, 0).serverProps = i));
							}
							e[Pp] = t, e = !!(e.nodeValue === n || r !== null && !0 === r.suppressHydrationWarning || uu(e.nodeValue, n)), e || Tr(t, !0);
						} else i = n.ancestorInfo.current, i != null && Mt(r, i.tag, n.ancestorInfo.implicitRootScope), e = Du(e).createTextNode(r), e[Pp] = t, t.stateNode = e;
					}
					return ks(t), null;
				case 31:
					if (n = t.memoizedState, e === null || e.memoizedState !== null) {
						if (r = Or(t), n !== null) {
							if (e === null) {
								if (!r) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
								if (e = t.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error("Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue.");
								e[Pp] = t, ks(t), (t.mode & kg) !== Dg && n !== null && (e = t.child, e !== null && (t.treeBaseDuration -= e.treeBaseDuration));
							} else Mr(), kr(), !(t.flags & 128) && (n = t.memoizedState = null), t.flags |= 4, ks(t), (t.mode & kg) !== Dg && n !== null && (e = t.child, e !== null && (t.treeBaseDuration -= e.treeBaseDuration));
							e = !1;
						} else n = Ar(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
						if (!e) return t.flags & 256 ? ($i(t), t) : ($i(t), null);
						if (t.flags & 128) throw Error("Client rendering an Activity suspended it again. This is a bug in React.");
					}
					return ks(t), null;
				case 13:
					if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
						if (i = r, a = Or(t), i !== null && i.dehydrated !== null) {
							if (e === null) {
								if (!a) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
								if (a = t.memoizedState, a = a === null ? null : a.dehydrated, !a) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
								a[Pp] = t, ks(t), (t.mode & kg) !== Dg && i !== null && (i = t.child, i !== null && (t.treeBaseDuration -= i.treeBaseDuration));
							} else Mr(), kr(), !(t.flags & 128) && (i = t.memoizedState = null), t.flags |= 4, ks(t), (t.mode & kg) !== Dg && i !== null && (i = t.child, i !== null && (t.treeBaseDuration -= i.treeBaseDuration));
							i = !1;
						} else i = Ar(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = i), i = !0;
						if (!i) return t.flags & 256 ? ($i(t), t) : ($i(t), null);
					}
					return $i(t), t.flags & 128 ? (t.lanes = n, (t.mode & kg) !== Dg && li(t), t) : (n = r !== null, e = e !== null && e.memoizedState !== null, n && (r = t.child, i = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (i = r.alternate.memoizedState.cachePool.pool), a = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (a = r.memoizedState.cachePool.pool), a !== i && (r.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), Ds(t, t.updateQueue), ks(t), (t.mode & kg) !== Dg && n && (e = t.child, e !== null && (t.treeBaseDuration -= e.treeBaseDuration)), null);
				case 4: return P(t), e === null && Zl(t.stateNode.containerInfo), ks(t), null;
				case 10: return Fr(t.type, t), ks(t), null;
				case 19:
					if (A(ly, t), r = t.memoizedState, r === null) return ks(t), null;
					if (i = (t.flags & 128) != 0, a = r.rendering, a === null) if (i) Os(r, !1);
					else {
						if (sx !== Pb || e !== null && e.flags & 128) for (e = t.child; e !== null;) {
							if (a = ea(e), a !== null) {
								for (t.flags |= 128, Os(r, !1), e = a.updateQueue, t.updateQueue = e, Ds(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null;) sr(n, e), n = n.sibling;
								return j(ly, ly.current & sy | cy, t), qg && hr(t, r.treeForkCount), t.child;
							}
							e = e.sibling;
						}
						r.tail !== null && up() > yx && (t.flags |= 128, i = !0, Os(r, !1), t.lanes = 4194304);
					}
					else {
						if (!i) if (e = ea(a), e !== null) {
							if (t.flags |= 128, i = !0, e = e.updateQueue, t.updateQueue = e, Ds(t, e), Os(r, !0), r.tail === null && r.tailMode === "hidden" && !a.alternate && !qg) return ks(t), null;
						} else 2 * up() - r.renderingStartTime > yx && n !== 536870912 && (t.flags |= 128, i = !0, Os(r, !1), t.lanes = 4194304);
						r.isBackwards ? (a.sibling = t.child, t.child = a) : (e = r.last, e === null ? t.child = a : e.sibling = a, r.last = a);
					}
					return r.tail === null ? (ks(t), null) : (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = up(), e.sibling = null, n = ly.current, n = i ? n & sy | cy : n & sy, j(ly, n, t), qg && hr(t, r.treeForkCount), e);
				case 22:
				case 23: return $i(t), Ji(t), r = t.memoizedState !== null, e === null ? r && (t.flags |= 8192) : e.memoizedState !== null !== r && (t.flags |= 8192), r ? n & 536870912 && !(t.flags & 128) && (ks(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : ks(t), n = t.updateQueue, n !== null && Ds(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== n && (t.flags |= 2048), e !== null && A(iv, t), null;
				case 24: return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), Fr(c_, t), ks(t), null;
				case 25: return null;
				case 30: return null;
			}
			throw Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
		}
		function js(e, t) {
			switch (vr(t), t.tag) {
				case 1: return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & kg) !== Dg && li(t), t) : null;
				case 3: return Fr(c_, t), P(t), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
				case 26:
				case 27:
				case 5: return L(t), null;
				case 31:
					if (t.memoizedState !== null) {
						if ($i(t), t.alternate === null) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
						kr();
					}
					return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & kg) !== Dg && li(t), t) : null;
				case 13:
					if ($i(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
						if (t.alternate === null) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
						kr();
					}
					return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & kg) !== Dg && li(t), t) : null;
				case 19: return A(ly, t), null;
				case 4: return P(t), null;
				case 10: return Fr(t.type, t), null;
				case 22:
				case 23: return $i(t), Ji(t), e !== null && A(iv, t), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & kg) !== Dg && li(t), t) : null;
				case 24: return Fr(c_, t), null;
				case 25: return null;
				default: return null;
			}
		}
		function Ms(e, t) {
			switch (vr(t), t.tag) {
				case 3:
					Fr(c_, t), P(t);
					break;
				case 26:
				case 27:
				case 5:
					L(t);
					break;
				case 4:
					P(t);
					break;
				case 31:
					t.memoizedState !== null && $i(t);
					break;
				case 13:
					$i(t);
					break;
				case 19:
					A(ly, t);
					break;
				case 10:
					Fr(t.type, t);
					break;
				case 22:
				case 23:
					$i(t), Ji(t), e !== null && A(iv, t);
					break;
				case 24: Fr(c_, t);
			}
		}
		function Ns(e) {
			return (e.mode & kg) !== Dg;
		}
		function Ps(e, t) {
			Ns(e) ? (ci(), Is(t, e), oi()) : Is(t, e);
		}
		function Fs(e, t, n) {
			Ns(e) ? (ci(), Ls(n, e, t), oi()) : Ls(n, e, t);
		}
		function Is(e, t) {
			try {
				var n = t.updateQueue, r = n === null ? null : n.lastEffect;
				if (r !== null) {
					var i = r.next;
					n = i;
					do {
						if ((n.tag & e) === e && (r = void 0, (e & fy) !== uy && ($x = !0), r = H(t, Ov, n), (e & fy) !== uy && ($x = !1), r !== void 0 && typeof r != "function")) {
							var a = void 0;
							a = (n.tag & py) === 0 ? (n.tag & fy) === 0 ? "useEffect" : "useInsertionEffect" : "useLayoutEffect";
							var o = void 0;
							o = r === null ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof r.then == "function" ? "\n\nIt looks like you wrote " + a + "(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n" + a + "(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching" : " You returned: " + r, H(t, function(e, t) {
								console.error("%s must not return anything besides a function, which is used for clean-up.%s", e, t);
							}, a, o);
						}
						n = n.next;
					} while (n !== i);
				}
			} catch (e) {
				xl(t, t.return, e);
			}
		}
		function Ls(e, t, n) {
			try {
				var r = t.updateQueue, i = r === null ? null : r.lastEffect;
				if (i !== null) {
					var a = i.next;
					r = a;
					do {
						if ((r.tag & e) === e) {
							var o = r.inst, s = o.destroy;
							s !== void 0 && (o.destroy = void 0, (e & fy) !== uy && ($x = !0), i = t, H(i, Av, i, n, s), (e & fy) !== uy && ($x = !1));
						}
						r = r.next;
					} while (r !== a);
				}
			} catch (e) {
				xl(t, t.return, e);
			}
		}
		function Rs(e, t) {
			Ns(e) ? (ci(), Is(t, e), oi()) : Is(t, e);
		}
		function zs(e, t, n) {
			Ns(e) ? (ci(), Ls(n, e, t), oi()) : Ls(n, e, t);
		}
		function Bs(e) {
			var t = e.updateQueue;
			if (t !== null) {
				var n = e.stateNode;
				e.type.defaultProps || "ref" in e.memoizedProps || lb || (n.props !== e.memoizedProps && console.error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", O(e) || "instance"), n.state !== e.memoizedState && console.error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", O(e) || "instance"));
				try {
					H(e, Gi, t, n);
				} catch (t) {
					xl(e, e.return, t);
				}
			}
		}
		function Vs(e, t, n) {
			return e.getSnapshotBeforeUpdate(t, n);
		}
		function Hs(e, t) {
			var n = t.memoizedProps, r = t.memoizedState;
			t = e.stateNode, e.type.defaultProps || "ref" in e.memoizedProps || lb || (t.props !== e.memoizedProps && console.error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", O(e) || "instance"), t.state !== e.memoizedState && console.error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", O(e) || "instance"));
			try {
				var i = zo(e.type, n), a = H(e, Vs, t, i, r);
				n = mb, a !== void 0 || n.has(e.type) || (n.add(e.type), H(e, function() {
					console.error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", O(e));
				})), t.__reactInternalSnapshotBeforeUpdate = a;
			} catch (t) {
				xl(e, e.return, t);
			}
		}
		function Us(e, t, n) {
			n.props = zo(e.type, e.memoizedProps), n.state = e.memoizedState, Ns(e) ? (ci(), H(e, Ev, e, t, n), oi()) : H(e, Ev, e, t, n);
		}
		function Ws(e) {
			var t = e.ref;
			if (t !== null) {
				switch (e.tag) {
					case 26:
					case 27:
					case 5:
						var n = e.stateNode;
						break;
					case 30:
						n = e.stateNode;
						break;
					default: n = e.stateNode;
				}
				if (typeof t == "function") if (Ns(e)) try {
					ci(), e.refCleanup = t(n);
				} finally {
					oi();
				}
				else e.refCleanup = t(n);
				else typeof t == "string" ? console.error("String refs are no longer supported.") : t.hasOwnProperty("current") || console.error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", O(e)), t.current = n;
			}
		}
		function Gs(e, t) {
			try {
				H(e, Ws, e);
			} catch (n) {
				xl(e, t, n);
			}
		}
		function Ks(e, t) {
			var n = e.ref, r = e.refCleanup;
			if (n !== null) if (typeof r == "function") try {
				if (Ns(e)) try {
					ci(), H(e, r);
				} finally {
					oi(e);
				}
				else H(e, r);
			} catch (n) {
				xl(e, t, n);
			} finally {
				e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
			}
			else if (typeof n == "function") try {
				if (Ns(e)) try {
					ci(), H(e, n, null);
				} finally {
					oi(e);
				}
				else H(e, n, null);
			} catch (n) {
				xl(e, t, n);
			}
			else n.current = null;
		}
		function qs(e, t, n, r) {
			var i = e.memoizedProps, a = i.id, o = i.onCommit;
			i = i.onRender, t = t === null ? "mount" : "update", Z_ && (t = "nested-update"), typeof i == "function" && i(a, t, e.actualDuration, e.treeBaseDuration, e.actualStartTime, n), typeof o == "function" && o(a, t, r, n);
		}
		function Js(e, t, n, r) {
			var i = e.memoizedProps;
			e = i.id, i = i.onPostCommit, t = t === null ? "mount" : "update", Z_ && (t = "nested-update"), typeof i == "function" && i(e, t, r, n);
		}
		function Ys(e) {
			var t = e.type, n = e.memoizedProps, r = e.stateNode;
			try {
				H(e, Fu, r, t, n, e);
			} catch (t) {
				xl(e, e.return, t);
			}
		}
		function Xs(e, t, n) {
			try {
				H(e, Lu, e.stateNode, e.type, n, t, e);
			} catch (t) {
				xl(e, e.return, t);
			}
		}
		function Zs(e) {
			return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Vu(e.type) || e.tag === 4;
		}
		function Qs(e) {
			a: for (;;) {
				for (; e.sibling === null;) {
					if (e.return === null || Zs(e.return)) return null;
					e = e.return;
				}
				for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
					if (e.tag === 27 && Vu(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue a;
					e.child.return = e, e = e.child;
				}
				if (!(e.flags & 2)) return e.stateNode;
			}
		}
		function $s(e, t, n) {
			var r = e.tag;
			if (r === 5 || r === 6) e = e.stateNode, t ? (Bu(n), (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(e, t)) : (Bu(n), t = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = G));
			else if (r !== 4 && (r === 27 && Vu(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null)) for ($s(e, t, n), e = e.sibling; e !== null;) $s(e, t, n), e = e.sibling;
		}
		function ec(e, t, n) {
			var r = e.tag;
			if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
			else if (r !== 4 && (r === 27 && Vu(e.type) && (n = e.stateNode), e = e.child, e !== null)) for (ec(e, t, n), e = e.sibling; e !== null;) ec(e, t, n), e = e.sibling;
		}
		function tc(e) {
			for (var t, n = e.return; n !== null;) {
				if (Zs(n)) {
					t = n;
					break;
				}
				n = n.return;
			}
			if (t == null) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
			switch (t.tag) {
				case 27:
					t = t.stateNode, n = Qs(e), ec(e, n, t);
					break;
				case 5:
					n = t.stateNode, t.flags & 32 && (Ru(n), t.flags &= -33), t = Qs(e), ec(e, t, n);
					break;
				case 3:
				case 4:
					t = t.stateNode.containerInfo, n = Qs(e), $s(e, n, t);
					break;
				default: throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
			}
		}
		function nc(e) {
			var t = e.stateNode, n = e.memoizedProps;
			try {
				H(e, pd, e.type, n, t, e);
			} catch (t) {
				xl(e, e.return, t);
			}
		}
		function rc(e, t) {
			return t.tag === 31 ? (t = t.memoizedState, e.memoizedState !== null && t === null) : t.tag === 13 ? (e = e.memoizedState, t = t.memoizedState, e !== null && e.dehydrated !== null && (t === null || t.dehydrated === null)) : t.tag === 3 ? e.memoizedState.isDehydrated && (t.flags & 256) == 0 : !1;
		}
		function ic(e, t) {
			if (e = e.containerInfo, KS = LC, e = Sn(e), Cn(e)) {
				if ("selectionStart" in e) var n = {
					start: e.selectionStart,
					end: e.selectionEnd
				};
				else a: {
					n = (n = e.ownerDocument) && n.defaultView || window;
					var r = n.getSelection && n.getSelection();
					if (r && r.rangeCount !== 0) {
						n = r.anchorNode;
						var i = r.anchorOffset, a = r.focusNode;
						r = r.focusOffset;
						try {
							n.nodeType, a.nodeType;
						} catch {
							n = null;
							break a;
						}
						var o = 0, s = -1, c = -1, l = 0, u = 0, d = e, f = null;
						b: for (;;) {
							for (var p; d !== n || i !== 0 && d.nodeType !== 3 || (s = o + i), d !== a || r !== 0 && d.nodeType !== 3 || (c = o + r), d.nodeType === 3 && (o += d.nodeValue.length), (p = d.firstChild) !== null;) f = d, d = p;
							for (;;) {
								if (d === e) break b;
								if (f === n && ++l === i && (s = o), f === a && ++u === r && (c = o), (p = d.nextSibling) !== null) break;
								d = f, f = d.parentNode;
							}
							d = p;
						}
						n = s === -1 || c === -1 ? null : {
							start: s,
							end: c
						};
					} else n = null;
				}
				n ||= {
					start: 0,
					end: 0
				};
			} else n = null;
			for (qS = {
				focusedElem: e,
				selectionRange: n
			}, LC = !1, yb = t; yb !== null;) if (t = yb, e = t.child, t.subtreeFlags & 1028 && e !== null) e.return = t, yb = e;
			else for (; yb !== null;) {
				switch (e = t = yb, n = e.alternate, i = e.flags, e.tag) {
					case 0:
						if (i & 4 && (e = e.updateQueue, e = e === null ? null : e.events, e !== null)) for (n = 0; n < e.length; n++) i = e[n], i.ref.impl = i.nextImpl;
						break;
					case 11:
					case 15: break;
					case 1:
						i & 1024 && n !== null && Hs(e, n);
						break;
					case 3:
						if (i & 1024) {
							if (e = e.stateNode.containerInfo, n = e.nodeType, n === 9) Qu(e);
							else if (n === 1) switch (e.nodeName) {
								case "HEAD":
								case "HTML":
								case "BODY":
									Qu(e);
									break;
								default: e.textContent = "";
							}
						}
						break;
					case 5:
					case 26:
					case 27:
					case 6:
					case 4:
					case 17: break;
					default: if (i & 1024) throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
				}
				if (e = t.sibling, e !== null) {
					e.return = t.return, yb = e;
					break;
				}
				yb = t.return;
			}
		}
		function ac(e, t, n) {
			var r = Qr(), i = ei(), a = J(), o = ni(), s = n.flags;
			switch (n.tag) {
				case 0:
				case 11:
				case 15:
					_c(e, n), s & 4 && Ps(n, py | dy);
					break;
				case 1:
					if (_c(e, n), s & 4) if (e = n.stateNode, t === null) n.type.defaultProps || "ref" in n.memoizedProps || lb || (e.props !== n.memoizedProps && console.error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", O(n) || "instance"), e.state !== n.memoizedState && console.error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", O(n) || "instance")), Ns(n) ? (ci(), H(n, bv, n, e), oi()) : H(n, bv, n, e);
					else {
						var c = zo(n.type, t.memoizedProps);
						t = t.memoizedState, n.type.defaultProps || "ref" in n.memoizedProps || lb || (e.props !== n.memoizedProps && console.error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", O(n) || "instance"), e.state !== n.memoizedState && console.error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", O(n) || "instance")), Ns(n) ? (ci(), H(n, Sv, n, e, c, t, e.__reactInternalSnapshotBeforeUpdate), oi()) : H(n, Sv, n, e, c, t, e.__reactInternalSnapshotBeforeUpdate);
					}
					s & 64 && Bs(n), s & 512 && Gs(n, n.return);
					break;
				case 3:
					if (t = Jr(), _c(e, n), s & 64 && (s = n.updateQueue, s !== null)) {
						if (c = null, n.child !== null) switch (n.child.tag) {
							case 27:
							case 5:
								c = n.child.stateNode;
								break;
							case 1: c = n.child.stateNode;
						}
						try {
							H(n, Gi, s, c);
						} catch (e) {
							xl(n, n.return, e);
						}
					}
					e.effectDuration += Yr(t);
					break;
				case 27: t === null && s & 4 && nc(n);
				case 26:
				case 5:
					if (_c(e, n), t === null) {
						if (s & 4) Ys(n);
						else if (s & 64) {
							e = n.type, t = n.memoizedProps, c = n.stateNode;
							try {
								H(n, Iu, c, e, t, n);
							} catch (e) {
								xl(n, n.return, e);
							}
						}
					}
					s & 512 && Gs(n, n.return);
					break;
				case 12:
					if (s & 4) {
						s = Jr(), _c(e, n), e = n.stateNode, e.effectDuration += Xr(s);
						try {
							H(n, qs, n, t, m_, e.effectDuration);
						} catch (e) {
							xl(n, n.return, e);
						}
					} else _c(e, n);
					break;
				case 31:
					_c(e, n), s & 4 && lc(e, n);
					break;
				case 13:
					_c(e, n), s & 4 && uc(e, n), s & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (s = Tl.bind(null, n), id(e, s))));
					break;
				case 22:
					if (s = n.memoizedState !== null || hb, !s) {
						t = t !== null && t.memoizedState !== null || gb, c = hb;
						var l = gb;
						hb = s, (gb = t) && !l ? (xc(e, n, (n.subtreeFlags & 8772) != 0), (n.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && .05 < x_ - b_ && Pn(n, b_, x_)) : _c(e, n), hb = c, gb = l;
					}
					break;
				case 30: break;
				default: _c(e, n);
			}
			(n.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && ((C_ || .05 < y_) && Ln(n, b_, x_, y_, S_), n.alternate === null && n.return !== null && n.return.alternate !== null && .05 < x_ - b_ && (rc(n.return.alternate, n.return) || Nn(n, b_, x_, "Mount"))), $r(r), ti(i), S_ = a, C_ = o;
		}
		function oc(e) {
			var t = e.alternate;
			t !== null && (e.alternate = null, oc(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && Ne(t)), e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
		}
		function sc(e, t, n) {
			for (n = n.child; n !== null;) cc(e, t, n), n = n.sibling;
		}
		function cc(e, t, n) {
			if (bp && typeof bp.onCommitFiberUnmount == "function") try {
				bp.onCommitFiberUnmount(yp, n);
			} catch (e) {
				xp || (xp = !0, console.error("React instrumentation encountered an error: %o", e));
			}
			var r = Qr(), i = ei(), a = J(), o = ni();
			switch (n.tag) {
				case 26:
					gb || Ks(n, t), sc(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (e = n.stateNode, e.parentNode.removeChild(e));
					break;
				case 27:
					gb || Ks(n, t);
					var s = Sb, c = Cb;
					Vu(n.type) && (Sb = n.stateNode, Cb = !1), sc(e, t, n), H(n, md, n.stateNode), Sb = s, Cb = c;
					break;
				case 5: gb || Ks(n, t);
				case 6:
					if (s = Sb, c = Cb, Sb = null, sc(e, t, n), Sb = s, Cb = c, Sb !== null) if (Cb) try {
						H(n, Uu, Sb, n.stateNode);
					} catch (e) {
						xl(n, t, e);
					}
					else try {
						H(n, Hu, Sb, n.stateNode);
					} catch (e) {
						xl(n, t, e);
					}
					break;
				case 18:
					Sb !== null && (Cb ? (e = Sb, Wu(e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, n.stateNode), lf(e)) : Wu(Sb, n.stateNode));
					break;
				case 4:
					s = Sb, c = Cb, Sb = n.stateNode.containerInfo, Cb = !0, sc(e, t, n), Sb = s, Cb = c;
					break;
				case 0:
				case 11:
				case 14:
				case 15:
					Ls(fy, n, t), gb || Fs(n, t, py), sc(e, t, n);
					break;
				case 1:
					gb || (Ks(n, t), s = n.stateNode, typeof s.componentWillUnmount == "function" && Us(n, t, s)), sc(e, t, n);
					break;
				case 21:
					sc(e, t, n);
					break;
				case 22:
					gb = (s = gb) || n.memoizedState !== null, sc(e, t, n), gb = s;
					break;
				default: sc(e, t, n);
			}
			(n.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && (C_ || .05 < y_) && Ln(n, b_, x_, y_, S_), $r(r), ti(i), S_ = a, C_ = o;
		}
		function lc(e, t) {
			if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
				e = e.dehydrated;
				try {
					H(t, ud, e);
				} catch (e) {
					xl(t, t.return, e);
				}
			}
		}
		function uc(e, t) {
			if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) try {
				H(t, dd, e);
			} catch (e) {
				xl(t, t.return, e);
			}
		}
		function dc(e) {
			switch (e.tag) {
				case 31:
				case 13:
				case 19:
					var t = e.stateNode;
					return t === null && (t = e.stateNode = new vb()), t;
				case 22: return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new vb()), t;
				default: throw Error("Unexpected Suspense handler tag (" + e.tag + "). This is a bug in React.");
			}
		}
		function fc(e, t) {
			var n = dc(e);
			t.forEach(function(t) {
				if (!n.has(t)) {
					if (n.add(t), Sp) if (bb !== null && xb !== null) jl(xb, bb);
					else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
					var r = El.bind(null, e, t);
					t.then(r, r);
				}
			});
		}
		function pc(e, t) {
			var n = t.deletions;
			if (n !== null) for (var r = 0; r < n.length; r++) {
				var i = e, a = t, o = n[r], s = Qr(), c = a;
				a: for (; c !== null;) {
					switch (c.tag) {
						case 27:
							if (Vu(c.type)) {
								Sb = c.stateNode, Cb = !1;
								break a;
							}
							break;
						case 5:
							Sb = c.stateNode, Cb = !1;
							break a;
						case 3:
						case 4:
							Sb = c.stateNode.containerInfo, Cb = !0;
							break a;
					}
					c = c.return;
				}
				if (Sb === null) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
				cc(i, a, o), Sb = null, Cb = !1, (o.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && .05 < x_ - b_ && Nn(o, b_, x_, "Unmount"), $r(s), i = o, a = i.alternate, a !== null && (a.return = null), i.return = null;
			}
			if (t.subtreeFlags & 13886) for (t = t.child; t !== null;) mc(t, e), t = t.sibling;
		}
		function mc(e, t) {
			var n = Qr(), r = ei(), i = J(), a = ni(), o = e.alternate, s = e.flags;
			switch (e.tag) {
				case 0:
				case 11:
				case 14:
				case 15:
					pc(t, e), hc(e), s & 4 && (Ls(fy | dy, e, e.return), Is(fy | dy, e), Fs(e, e.return, py | dy));
					break;
				case 1:
					if (pc(t, e), hc(e), s & 512 && (gb || o === null || Ks(o, o.return)), s & 64 && hb && (s = e.updateQueue, s !== null && (o = s.callbacks, o !== null))) {
						var c = s.shared.hiddenCallbacks;
						s.shared.hiddenCallbacks = c === null ? o : c.concat(o);
					}
					break;
				case 26:
					if (c = wb, pc(t, e), hc(e), s & 512 && (gb || o === null || Ks(o, o.return)), s & 4) {
						var l = o === null ? null : o.memoizedState;
						if (s = e.memoizedState, o === null) if (s === null) if (e.stateNode === null) {
							a: {
								s = e.type, o = e.memoizedProps, c = c.ownerDocument || c;
								b: switch (s) {
									case "title":
										l = c.getElementsByTagName("title")[0], (!l || l[Vp] || l[Pp] || l.namespaceURI === wm || l.hasAttribute("itemprop")) && (l = c.createElement(s), c.head.insertBefore(l, c.querySelector("head > title"))), pu(l, s, o), l[Pp] = e, Re(l), s = l;
										break a;
									case "link":
										var u = kd("link", "href", c).get(s + (o.href || ""));
										if (u) {
											for (var d = 0; d < u.length; d++) if (l = u[d], l.getAttribute("href") === (o.href == null || o.href === "" ? null : o.href) && l.getAttribute("rel") === (o.rel == null ? null : o.rel) && l.getAttribute("title") === (o.title == null ? null : o.title) && l.getAttribute("crossorigin") === (o.crossOrigin == null ? null : o.crossOrigin)) {
												u.splice(d, 1);
												break b;
											}
										}
										l = c.createElement(s), pu(l, s, o), c.head.appendChild(l);
										break;
									case "meta":
										if (u = kd("meta", "content", c).get(s + (o.content || ""))) {
											for (d = 0; d < u.length; d++) if (l = u[d], de(o.content, "content"), l.getAttribute("content") === (o.content == null ? null : "" + o.content) && l.getAttribute("name") === (o.name == null ? null : o.name) && l.getAttribute("property") === (o.property == null ? null : o.property) && l.getAttribute("http-equiv") === (o.httpEquiv == null ? null : o.httpEquiv) && l.getAttribute("charset") === (o.charSet == null ? null : o.charSet)) {
												u.splice(d, 1);
												break b;
											}
										}
										l = c.createElement(s), pu(l, s, o), c.head.appendChild(l);
										break;
									default: throw Error("getNodesForType encountered a type it did not expect: \"" + s + "\". This is a bug in React.");
								}
								l[Pp] = e, Re(l), s = l;
							}
							e.stateNode = s;
						} else Ad(c, e.type, e.stateNode);
						else e.stateNode = Td(c, s, e.memoizedProps);
						else l === s ? s === null && e.stateNode !== null && Xs(e, e.memoizedProps, o.memoizedProps) : (l === null ? o.stateNode !== null && (o = o.stateNode, o.parentNode.removeChild(o)) : l.count--, s === null ? Ad(c, e.type, e.stateNode) : Td(c, s, e.memoizedProps));
					}
					break;
				case 27:
					pc(t, e), hc(e), s & 512 && (gb || o === null || Ks(o, o.return)), o !== null && s & 4 && Xs(e, e.memoizedProps, o.memoizedProps);
					break;
				case 5:
					if (pc(t, e), hc(e), s & 512 && (gb || o === null || Ks(o, o.return)), e.flags & 32) {
						c = e.stateNode;
						try {
							H(e, Ru, c);
						} catch (t) {
							xl(e, e.return, t);
						}
					}
					s & 4 && e.stateNode != null && (c = e.memoizedProps, Xs(e, c, o === null ? c : o.memoizedProps)), s & 1024 && (_b = !0, e.type !== "form" && console.error("Unexpected host component type. Expected a form. This is a bug in React."));
					break;
				case 6:
					if (pc(t, e), hc(e), s & 4) {
						if (e.stateNode === null) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
						s = e.memoizedProps, o = o === null ? s : o.memoizedProps, c = e.stateNode;
						try {
							H(e, zu, c, o, s);
						} catch (t) {
							xl(e, e.return, t);
						}
					}
					break;
				case 3:
					if (c = Jr(), fC = null, l = wb, wb = hd(t.containerInfo), pc(t, e), wb = l, hc(e), s & 4 && o !== null && o.memoizedState.isDehydrated) try {
						H(e, ld, t.containerInfo);
					} catch (t) {
						xl(e, e.return, t);
					}
					_b && (_b = !1, gc(e)), t.effectDuration += Yr(c);
					break;
				case 4:
					s = wb, wb = hd(e.stateNode.containerInfo), pc(t, e), hc(e), wb = s;
					break;
				case 12:
					s = Jr(), pc(t, e), hc(e), e.stateNode.effectDuration += Xr(s);
					break;
				case 31:
					pc(t, e), hc(e), s & 4 && (s = e.updateQueue, s !== null && (e.updateQueue = null, fc(e, s)));
					break;
				case 13:
					pc(t, e), hc(e), e.child.flags & 8192 && e.memoizedState !== null != (o !== null && o.memoizedState !== null) && (gx = up()), s & 4 && (s = e.updateQueue, s !== null && (e.updateQueue = null, fc(e, s)));
					break;
				case 22:
					c = e.memoizedState !== null;
					var f = o !== null && o.memoizedState !== null, p = hb, m = gb;
					if (hb = p || c, gb = m || f, pc(t, e), gb = m, hb = p, f && !c && !p && !m && (e.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && .05 < x_ - b_ && Pn(e, b_, x_), hc(e), s & 8192) a: for (t = e.stateNode, t._visibility = c ? t._visibility & ~yg : t._visibility | yg, !c || o === null || f || hb || gb || (yc(e), (e.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && .05 < x_ - b_ && Nn(e, b_, x_, "Disconnect")), o = null, t = e;;) {
						if (t.tag === 5 || t.tag === 26) {
							if (o === null) {
								f = o = t;
								try {
									l = f.stateNode, c ? H(f, qu, l) : H(f, Xu, f.stateNode, f.memoizedProps);
								} catch (e) {
									xl(f, f.return, e);
								}
							}
						} else if (t.tag === 6) {
							if (o === null) {
								f = t;
								try {
									u = f.stateNode, c ? H(f, Ju, u) : H(f, Zu, u, f.memoizedProps);
								} catch (e) {
									xl(f, f.return, e);
								}
							}
						} else if (t.tag === 18) {
							if (o === null) {
								f = t;
								try {
									d = f.stateNode, c ? H(f, Ku, d) : H(f, Yu, f.stateNode);
								} catch (e) {
									xl(f, f.return, e);
								}
							}
						} else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
							t.child.return = t, t = t.child;
							continue;
						}
						if (t === e) break a;
						for (; t.sibling === null;) {
							if (t.return === null || t.return === e) break a;
							o === t && (o = null), t = t.return;
						}
						o === t && (o = null), t.sibling.return = t.return, t = t.sibling;
					}
					s & 4 && (s = e.updateQueue, s !== null && (o = s.retryQueue, o !== null && (s.retryQueue = null, fc(e, o))));
					break;
				case 19:
					pc(t, e), hc(e), s & 4 && (s = e.updateQueue, s !== null && (e.updateQueue = null, fc(e, s)));
					break;
				case 30: break;
				case 21: break;
				default: pc(t, e), hc(e);
			}
			(e.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && ((C_ || .05 < y_) && Ln(e, b_, x_, y_, S_), e.alternate === null && e.return !== null && e.return.alternate !== null && .05 < x_ - b_ && (rc(e.return.alternate, e.return) || Nn(e, b_, x_, "Mount"))), $r(n), ti(r), S_ = i, C_ = a;
		}
		function hc(e) {
			var t = e.flags;
			if (t & 2) {
				try {
					H(e, tc, e);
				} catch (t) {
					xl(e, e.return, t);
				}
				e.flags &= -3;
			}
			t & 4096 && (e.flags &= -4097);
		}
		function gc(e) {
			if (e.subtreeFlags & 1024) for (e = e.child; e !== null;) {
				var t = e;
				gc(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
			}
		}
		function _c(e, t) {
			if (t.subtreeFlags & 8772) for (t = t.child; t !== null;) ac(e, t.alternate, t), t = t.sibling;
		}
		function vc(e) {
			var t = Qr(), n = ei(), r = J(), i = ni();
			switch (e.tag) {
				case 0:
				case 11:
				case 14:
				case 15:
					Fs(e, e.return, py), yc(e);
					break;
				case 1:
					Ks(e, e.return);
					var a = e.stateNode;
					typeof a.componentWillUnmount == "function" && Us(e, e.return, a), yc(e);
					break;
				case 27: H(e, md, e.stateNode);
				case 26:
				case 5:
					Ks(e, e.return), yc(e);
					break;
				case 22:
					e.memoizedState === null && yc(e);
					break;
				case 30:
					yc(e);
					break;
				default: yc(e);
			}
			(e.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && (C_ || .05 < y_) && Ln(e, b_, x_, y_, S_), $r(t), ti(n), S_ = r, C_ = i;
		}
		function yc(e) {
			for (e = e.child; e !== null;) vc(e), e = e.sibling;
		}
		function bc(e, t, n, r) {
			var i = Qr(), a = ei(), o = J(), s = ni(), c = n.flags;
			switch (n.tag) {
				case 0:
				case 11:
				case 15:
					xc(e, n, r), Ps(n, py);
					break;
				case 1:
					if (xc(e, n, r), t = n.stateNode, typeof t.componentDidMount == "function" && H(n, bv, n, t), t = n.updateQueue, t !== null) {
						e = n.stateNode;
						try {
							H(n, Wi, t, e);
						} catch (e) {
							xl(n, n.return, e);
						}
					}
					r && c & 64 && Bs(n), Gs(n, n.return);
					break;
				case 27: nc(n);
				case 26:
				case 5:
					xc(e, n, r), r && t === null && c & 4 && Ys(n), Gs(n, n.return);
					break;
				case 12:
					if (r && c & 4) {
						c = Jr(), xc(e, n, r), r = n.stateNode, r.effectDuration += Xr(c);
						try {
							H(n, qs, n, t, m_, r.effectDuration);
						} catch (e) {
							xl(n, n.return, e);
						}
					} else xc(e, n, r);
					break;
				case 31:
					xc(e, n, r), r && c & 4 && lc(e, n);
					break;
				case 13:
					xc(e, n, r), r && c & 4 && uc(e, n);
					break;
				case 22:
					n.memoizedState === null && xc(e, n, r), Gs(n, n.return);
					break;
				case 30: break;
				default: xc(e, n, r);
			}
			(n.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && (C_ || .05 < y_) && Ln(n, b_, x_, y_, S_), $r(i), ti(a), S_ = o, C_ = s;
		}
		function xc(e, t, n) {
			for (n &&= (t.subtreeFlags & 8772) != 0, t = t.child; t !== null;) bc(e, t.alternate, t, n), t = t.sibling;
		}
		function Sc(e, t) {
			var n = null;
			e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && Wr(e), n != null && Gr(n));
		}
		function Cc(e, t) {
			e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (Wr(t), e != null && Gr(e));
		}
		function wc(e, t, n, r, i) {
			if (t.subtreeFlags & 10256 || t.actualDuration !== 0 && (t.alternate === null || t.alternate.child !== t.child)) for (t = t.child; t !== null;) {
				var a = t.sibling;
				Tc(e, t, n, r, a === null ? i : a.actualStartTime), t = a;
			}
		}
		function Tc(e, t, n, r, i) {
			var a = Qr(), o = ei(), s = J(), c = ni(), l = pg, u = t.flags;
			switch (t.tag) {
				case 0:
				case 11:
				case 15:
					(t.mode & kg) !== Dg && 0 < t.actualStartTime && t.flags & 1 && Fn(t, t.actualStartTime, i, Tb, n), wc(e, t, n, r, i), u & 2048 && Rs(t, my | dy);
					break;
				case 1:
					(t.mode & kg) !== Dg && 0 < t.actualStartTime && (t.flags & 128 ? In(t, t.actualStartTime, i, []) : t.flags & 1 && Fn(t, t.actualStartTime, i, Tb, n)), wc(e, t, n, r, i);
					break;
				case 3:
					var d = Jr(), f = Tb;
					Tb = t.alternate !== null && t.alternate.memoizedState.isDehydrated && (t.flags & 256) == 0, wc(e, t, n, r, i), Tb = f, u & 2048 && (n = null, t.alternate !== null && (n = t.alternate.memoizedState.cache), r = t.memoizedState.cache, r !== n && (Wr(r), n != null && Gr(n))), e.passiveEffectDuration += Yr(d);
					break;
				case 12:
					if (u & 2048) {
						u = Jr(), wc(e, t, n, r, i), e = t.stateNode, e.passiveEffectDuration += Xr(u);
						try {
							H(t, Js, t, t.alternate, m_, e.passiveEffectDuration);
						} catch (e) {
							xl(t, t.return, e);
						}
					} else wc(e, t, n, r, i);
					break;
				case 31:
					u = Tb, d = t.alternate === null ? null : t.alternate.memoizedState, f = t.memoizedState, d !== null && f === null ? (f = t.deletions, f !== null && 0 < f.length && f[0].tag === 18 ? (Tb = !1, d = d.hydrationErrors, d !== null && In(t, t.actualStartTime, i, d)) : Tb = !0) : Tb = !1, wc(e, t, n, r, i), Tb = u;
					break;
				case 13:
					u = Tb, d = t.alternate === null ? null : t.alternate.memoizedState, f = t.memoizedState, d === null || d.dehydrated === null || f !== null && f.dehydrated !== null ? Tb = !1 : (f = t.deletions, f !== null && 0 < f.length && f[0].tag === 18 ? (Tb = !1, d = d.hydrationErrors, d !== null && In(t, t.actualStartTime, i, d)) : Tb = !0), wc(e, t, n, r, i), Tb = u;
					break;
				case 23: break;
				case 22:
					f = t.stateNode, d = t.alternate, t.memoizedState === null ? f._visibility & bg ? wc(e, t, n, r, i) : (f._visibility |= bg, Ec(e, t, n, r, (t.subtreeFlags & 10256) != 0 || t.actualDuration !== 0 && (t.alternate === null || t.alternate.child !== t.child), i), (t.mode & kg) === Dg || Tb || (e = t.actualStartTime, 0 <= e && .05 < i - e && Pn(t, e, i), 0 <= b_ && 0 <= x_ && .05 < x_ - b_ && Pn(t, b_, x_))) : f._visibility & bg ? wc(e, t, n, r, i) : Oc(e, t, n, r, i), u & 2048 && Sc(d, t);
					break;
				case 24:
					wc(e, t, n, r, i), u & 2048 && Cc(t.alternate, t);
					break;
				default: wc(e, t, n, r, i);
			}
			(t.mode & kg) !== Dg && ((e = !Tb && t.alternate === null && t.return !== null && t.return.alternate !== null) && (n = t.actualStartTime, 0 <= n && .05 < i - n && Nn(t, n, i, "Mount")), 0 <= b_ && 0 <= x_ && ((C_ || .05 < y_) && Ln(t, b_, x_, y_, S_), e && .05 < x_ - b_ && Nn(t, b_, x_, "Mount"))), $r(a), ti(o), S_ = s, C_ = c, pg = l;
		}
		function Ec(e, t, n, r, i, a) {
			for (i &&= (t.subtreeFlags & 10256) != 0 || t.actualDuration !== 0 && (t.alternate === null || t.alternate.child !== t.child), t = t.child; t !== null;) {
				var o = t.sibling;
				Dc(e, t, n, r, i, o === null ? a : o.actualStartTime), t = o;
			}
		}
		function Dc(e, t, n, r, i, a) {
			var o = Qr(), s = ei(), c = J(), l = ni(), u = pg;
			i && (t.mode & kg) !== Dg && 0 < t.actualStartTime && t.flags & 1 && Fn(t, t.actualStartTime, a, Tb, n);
			var d = t.flags;
			switch (t.tag) {
				case 0:
				case 11:
				case 15:
					Ec(e, t, n, r, i, a), Rs(t, my);
					break;
				case 23: break;
				case 22:
					var f = t.stateNode;
					t.memoizedState === null ? (f._visibility |= bg, Ec(e, t, n, r, i, a)) : f._visibility & bg ? Ec(e, t, n, r, i, a) : Oc(e, t, n, r, a), i && d & 2048 && Sc(t.alternate, t);
					break;
				case 24:
					Ec(e, t, n, r, i, a), i && d & 2048 && Cc(t.alternate, t);
					break;
				default: Ec(e, t, n, r, i, a);
			}
			(t.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && (C_ || .05 < y_) && Ln(t, b_, x_, y_, S_), $r(o), ti(s), S_ = c, C_ = l, pg = u;
		}
		function Oc(e, t, n, r, i) {
			if (t.subtreeFlags & 10256 || t.actualDuration !== 0 && (t.alternate === null || t.alternate.child !== t.child)) for (var a = t.child; a !== null;) {
				t = a.sibling;
				var o = e, s = n, c = r, l = t === null ? i : t.actualStartTime, u = pg;
				(a.mode & kg) !== Dg && 0 < a.actualStartTime && a.flags & 1 && Fn(a, a.actualStartTime, l, Tb, s);
				var d = a.flags;
				switch (a.tag) {
					case 22:
						Oc(o, a, s, c, l), d & 2048 && Sc(a.alternate, a);
						break;
					case 24:
						Oc(o, a, s, c, l), d & 2048 && Cc(a.alternate, a);
						break;
					default: Oc(o, a, s, c, l);
				}
				pg = u, a = t;
			}
		}
		function kc(e, t, n) {
			if (e.subtreeFlags & Eb) for (e = e.child; e !== null;) Ac(e, t, n), e = e.sibling;
		}
		function Ac(e, t, n) {
			switch (e.tag) {
				case 26:
					kc(e, t, n), e.flags & Eb && e.memoizedState !== null && Nd(n, wb, e.memoizedState, e.memoizedProps);
					break;
				case 5:
					kc(e, t, n);
					break;
				case 3:
				case 4:
					var r = wb;
					wb = hd(e.stateNode.containerInfo), kc(e, t, n), wb = r;
					break;
				case 22:
					e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = Eb, Eb = 16777216, kc(e, t, n), Eb = r) : kc(e, t, n));
					break;
				default: kc(e, t, n);
			}
		}
		function jc(e) {
			var t = e.alternate;
			if (t !== null && (e = t.child, e !== null)) {
				t.child = null;
				do
					t = e.sibling, e.sibling = null, e = t;
				while (e !== null);
			}
		}
		function Mc(e) {
			var t = e.deletions;
			if (e.flags & 16) {
				if (t !== null) for (var n = 0; n < t.length; n++) {
					var r = t[n], i = Qr();
					yb = r, Ic(r, e), (r.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && .05 < x_ - b_ && Nn(r, b_, x_, "Unmount"), $r(i);
				}
				jc(e);
			}
			if (e.subtreeFlags & 10256) for (e = e.child; e !== null;) Nc(e), e = e.sibling;
		}
		function Nc(e) {
			var t = Qr(), n = ei(), r = J(), i = ni();
			switch (e.tag) {
				case 0:
				case 11:
				case 15:
					Mc(e), e.flags & 2048 && zs(e, e.return, my | dy);
					break;
				case 3:
					var a = Jr();
					Mc(e), e.stateNode.passiveEffectDuration += Yr(a);
					break;
				case 12:
					a = Jr(), Mc(e), e.stateNode.passiveEffectDuration += Xr(a);
					break;
				case 22:
					a = e.stateNode, e.memoizedState !== null && a._visibility & bg && (e.return === null || e.return.tag !== 13) ? (a._visibility &= ~bg, Pc(e), (e.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && .05 < x_ - b_ && Nn(e, b_, x_, "Disconnect")) : Mc(e);
					break;
				default: Mc(e);
			}
			(e.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && (C_ || .05 < y_) && Ln(e, b_, x_, y_, S_), $r(t), ti(n), C_ = i, S_ = r;
		}
		function Pc(e) {
			var t = e.deletions;
			if (e.flags & 16) {
				if (t !== null) for (var n = 0; n < t.length; n++) {
					var r = t[n], i = Qr();
					yb = r, Ic(r, e), (r.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && .05 < x_ - b_ && Nn(r, b_, x_, "Unmount"), $r(i);
				}
				jc(e);
			}
			for (e = e.child; e !== null;) Fc(e), e = e.sibling;
		}
		function Fc(e) {
			var t = Qr(), n = ei(), r = J(), i = ni();
			switch (e.tag) {
				case 0:
				case 11:
				case 15:
					zs(e, e.return, my), Pc(e);
					break;
				case 22:
					var a = e.stateNode;
					a._visibility & bg && (a._visibility &= ~bg, Pc(e));
					break;
				default: Pc(e);
			}
			(e.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && (C_ || .05 < y_) && Ln(e, b_, x_, y_, S_), $r(t), ti(n), C_ = i, S_ = r;
		}
		function Ic(e, t) {
			for (; yb !== null;) {
				var n = yb, r = n, i = t, a = Qr(), o = ei(), s = J(), c = ni();
				switch (r.tag) {
					case 0:
					case 11:
					case 15:
						zs(r, i, my);
						break;
					case 23:
					case 22:
						r.memoizedState !== null && r.memoizedState.cachePool !== null && (i = r.memoizedState.cachePool.pool, i != null && Wr(i));
						break;
					case 24: Gr(r.memoizedState.cache);
				}
				if ((r.mode & kg) !== Dg && 0 <= b_ && 0 <= x_ && (C_ || .05 < y_) && Ln(r, b_, x_, y_, S_), $r(a), ti(o), C_ = c, S_ = s, r = n.child, r !== null) r.return = n, yb = r;
				else a: for (n = e; yb !== null;) {
					if (r = yb, a = r.sibling, o = r.return, oc(r), r === n) {
						yb = null;
						break a;
					}
					if (a !== null) {
						a.return = o, yb = a;
						break a;
					}
					yb = o;
				}
			}
		}
		function Lc() {
			kb.forEach(function(e) {
				return e();
			});
		}
		function Rc() {
			var e = typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
			return e || Q.actQueue === null || console.error("The current testing environment is not configured to support act(...)"), e;
		}
		function zc(e) {
			if ((Vb & Mb) !== jb && Wb !== 0) return Wb & -Wb;
			var t = Q.T;
			return t === null ? je() : (t._updatedFibers ||= /* @__PURE__ */ new Set(), t._updatedFibers.add(e), Ul());
		}
		function Bc() {
			if (dx === 0) if (!(Wb & 536870912) || qg) {
				var e = Dp;
				Dp <<= 1, !(Dp & 3932160) && (Dp = 262144), dx = e;
			} else dx = 536870912;
			return e = ay.current, e !== null && (e.flags |= 32), dx;
		}
		function Vc(e, t, n) {
			if ($x && console.error("useInsertionEffect must not schedule updates."), Jx && (Yx = !0), (e === Hb && (tx === qb || tx === ex) || e.cancelPendingCommit !== null) && (Yc(e, 0), Gc(e, Wb, dx, !1)), Ce(e, n), (Vb & Mb) !== jb && e === Hb) {
				if (ip) switch (t.tag) {
					case 0:
					case 11:
					case 15:
						e = Ub && O(Ub) || "Unknown", nS.has(e) || (nS.add(e), t = O(t) || "Unknown", console.error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render", t, e, e));
						break;
					case 1: tS ||= (console.error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), !0);
				}
			} else Sp && Oe(e, t, n), Nl(t), e === Hb && ((Vb & Mb) === jb && (lx |= n), sx === Rb && Gc(e, Wb, dx, !1)), Pl(e);
		}
		function Hc(e, t, n) {
			if ((Vb & (Mb | Nb)) !== jb) throw Error("Should not already be working.");
			if (Wb !== 0 && Ub !== null) {
				var r = Ub, i = up();
				switch (Y_) {
					case Jb:
					case qb:
						var a = X_;
						lg && ((r = r._debugTask) ? r.run(console.timeStamp.bind(console, "Suspended", a, i, ug, void 0, "primary-light")) : console.timeStamp("Suspended", a, i, ug, void 0, "primary-light"));
						break;
					case ex:
						a = X_, lg && ((r = r._debugTask) ? r.run(console.timeStamp.bind(console, "Action", a, i, ug, void 0, "primary-light")) : console.timeStamp("Action", a, i, ug, void 0, "primary-light"));
						break;
					default: lg && (r = i - X_, 3 > r || console.timeStamp("Blocked", X_, i, ug, void 0, 5 > r ? "primary-light" : 10 > r ? "primary" : 100 > r ? "primary-dark" : "error"));
				}
			}
			a = (n = !n && (t & 127) == 0 && (t & e.expiredLanes) === 0 || ye(e, t)) ? il(e, t) : nl(e, t, !0);
			var o = n;
			do {
				if (a === Pb) {
					ix && !n && Gc(e, t, 0, !1), t = tx, X_ = l_(), Y_ = t;
					break;
				} else {
					if (r = up(), i = e.current.alternate, o && !Wc(i)) {
						Mn(t), i = p_, a = r, !lg || a <= i || (Sx ? Sx.run(console.timeStamp.bind(console, "Teared Render", i, a, fg, dg, "error")) : console.timeStamp("Teared Render", i, a, fg, dg, "error")), Jc(t, r), a = nl(e, t, !1), o = !1;
						continue;
					}
					if (a === Ib) {
						if (o = t, e.errorRecoveryDisabledLanes & o) var s = 0;
						else s = e.pendingLanes & -536870913, s = s === 0 ? s & 536870912 ? 536870912 : 0 : s;
						if (s !== 0) {
							Mn(t), Hn(p_, r, t, Sx), Jc(t, r), t = s;
							a: {
								r = e, a = o, o = px;
								var c = r.current.memoizedState.isDehydrated;
								if (c && (Yc(r, s).flags |= 256), s = nl(r, s, !1), s !== Ib) {
									if (ax && !c) {
										r.errorRecoveryDisabledLanes |= a, lx |= a, a = Rb;
										break a;
									}
									r = mx, mx = o, r !== null && (mx === null ? mx = r : mx.push.apply(mx, r));
								}
								a = s;
							}
							if (o = !1, a !== Ib) continue;
							r = up();
						}
					}
					if (a === Fb) {
						Mn(t), Hn(p_, r, t, Sx), Jc(t, r), Yc(e, 0), Gc(e, t, 0, !0);
						break;
					}
					a: {
						switch (n = e, a) {
							case Pb:
							case Fb: throw Error("Root did not complete. This is a bug in React.");
							case Rb: if ((t & 4194048) !== t) break;
							case zb:
								Mn(t), zn(p_, r, t, Sx), Jc(t, r), i = t, i & 127 ? N_ = r : i & 4194048 && (W_ = r), Gc(n, t, dx, !rx);
								break a;
							case Ib:
								mx = null;
								break;
							case Lb:
							case Bb: break;
							default: throw Error("Unknown root exit status.");
						}
						if (Q.actQueue !== null) fl(n, i, t, mx, xx, hx, dx, lx, fx, a, null, null, p_, r);
						else {
							if ((t & 62914560) === t && (o = gx + vx - up(), 10 < o)) {
								if (Gc(n, t, dx, !rx), ve(n, 0, !0) !== 0) break a;
								Lx = t, n.timeoutHandle = ZS(Uc.bind(null, n, i, mx, xx, hx, t, dx, lx, fx, rx, a, "Throttled", p_, r), o);
								break a;
							}
							Uc(n, i, mx, xx, hx, t, dx, lx, fx, rx, a, null, p_, r);
						}
					}
				}
				break;
			} while (1);
			Pl(e);
		}
		function Uc(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
			e.timeoutHandle = $S;
			var m = t.subtreeFlags, h = null;
			if ((m & 8192 || (m & 16785408) == 16785408) && (h = {
				stylesheets: null,
				count: 0,
				imgCount: 0,
				imgBytes: 0,
				suspenseyImages: [],
				waitingForImages: !0,
				waitingForViewTransition: !1,
				unsuspend: G
			}, Ac(t, a, h), m = (a & 62914560) === a ? gx - up() : (a & 4194048) === a ? _x - up() : 0, m = Pd(h, m), m !== null)) {
				Lx = a, e.cancelPendingCommit = m(fl.bind(null, e, t, a, n, r, i, o, s, c, u, h, h.waitingForViewTransition ? "Waiting for the previous Animation" : 0 < h.count ? 0 < h.imgCount ? "Suspended on CSS and Images" : "Suspended on CSS" : h.imgCount === 1 ? "Suspended on an Image" : 0 < h.imgCount ? "Suspended on Images" : null, f, p)), Gc(e, a, o, !l);
				return;
			}
			fl(e, t, a, n, r, i, o, s, c, u, h, d, f, p);
		}
		function Wc(e) {
			for (var t = e;;) {
				var n = t.tag;
				if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) for (var r = 0; r < n.length; r++) {
					var i = n[r], a = i.getSnapshot;
					i = i.value;
					try {
						if (!Mh(a(), i)) return !1;
					} catch {
						return !1;
					}
				}
				if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
				else {
					if (t === e) break;
					for (; t.sibling === null;) {
						if (t.return === null || t.return === e) return !0;
						t = t.return;
					}
					t.sibling.return = t.return, t = t.sibling;
				}
			}
			return !0;
		}
		function Gc(e, t, n, r) {
			t &= ~ux, t &= ~lx, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
			for (var i = t; 0 < i;) {
				var a = 31 - Cp(i), o = 1 << a;
				r[a] = -1, i &= ~o;
			}
			n !== 0 && Te(e, n, t);
		}
		function Kc() {
			return (Vb & (Mb | Nb)) === jb ? (Fl(0, !1), !1) : !0;
		}
		function qc() {
			if (Ub !== null) {
				if (tx === Gb) var e = Ub.return;
				else e = Ub, Nr(), da(e), zv = null, Bv = 0, e = Ub;
				for (; e !== null;) Ms(e.alternate, e), e = e.return;
				Ub = null;
			}
		}
		function Jc(e, t) {
			e & 127 && (w_ = t), e & 4194048 && (P_ = t), e & 62914560 && (G_ = t), e & 2080374784 && (K_ = t);
		}
		function Yc(e, t) {
			lg && (console.timeStamp("Blocking Track", .003, .003, "Blocking", dg, "primary-light"), console.timeStamp("Transition Track", .003, .003, "Transition", dg, "primary-light"), console.timeStamp("Suspense Track", .003, .003, "Suspense", dg, "primary-light"), console.timeStamp("Idle Track", .003, .003, "Idle", dg, "primary-light"));
			var n = p_;
			if (p_ = l_(), Wb !== 0 && 0 < n) {
				if (Mn(Wb), sx === Lb || sx === Rb) zn(n, p_, t, Sx);
				else {
					var r = p_, i = Sx;
					if (lg && !(r <= n)) {
						var a = (t & 738197653) === t ? "tertiary-dark" : "primary-dark", o = (t & 536870912) === t ? "Prewarm" : (t & 201326741) === t ? "Interrupted Hydration" : "Interrupted Render";
						i ? i.run(console.timeStamp.bind(console, o, n, r, fg, dg, a)) : console.timeStamp(o, n, r, fg, dg, a);
					}
				}
				Jc(Wb, p_);
			}
			if (n = Sx, Sx = null, t & 127) {
				Sx = E_, i = 0 <= T_ && T_ < w_ ? w_ : T_, r = 0 <= A_ && A_ < w_ ? w_ : A_, a = 0 <= r ? r : 0 <= i ? i : p_, 0 <= N_ ? (Mn(2), Bn(N_, a, t, n)) : q_ & 127 && (Mn(2), Gn(w_, a, J_)), n = i;
				var s = r, c = j_, l = 0 < M_, u = D_ === d_, d = D_ === f_;
				if (i = p_, r = E_, a = O_, o = k_, lg) {
					if (fg = "Blocking", 0 < n ? n > i && (n = i) : n = i, 0 < s ? s > n && (s = n) : s = n, c !== null && n > s) {
						var f = l ? "secondary-light" : "warning";
						r ? r.run(console.timeStamp.bind(console, l ? "Consecutive" : "Event: " + c, s, n, fg, dg, f)) : console.timeStamp(l ? "Consecutive" : "Event: " + c, s, n, fg, dg, f);
					}
					i > n && (s = u ? "error" : (t & 738197653) === t ? "tertiary-light" : "primary-light", u = d ? "Promise Resolved" : u ? "Cascading Update" : 5 < i - n ? "Update Blocked" : "Update", d = [], o != null && d.push(["Component name", o]), a != null && d.push(["Method name", a]), n = {
						start: n,
						end: i,
						detail: { devtools: {
							properties: d,
							track: fg,
							trackGroup: dg,
							color: s
						} }
					}, r ? r.run(performance.measure.bind(performance, u, n)) : performance.measure(u, n));
				}
				T_ = -1.1, D_ = 0, k_ = O_ = null, N_ = -1.1, M_ = A_, A_ = -1.1, w_ = l_();
			}
			if (t & 4194048 && (Sx = R_, i = 0 <= F_ && F_ < P_ ? P_ : F_, n = 0 <= I_ && I_ < P_ ? P_ : I_, r = 0 <= V_ && V_ < P_ ? P_ : V_, a = 0 <= r ? r : 0 <= n ? n : p_, 0 <= W_ ? (Mn(256), Bn(W_, a, t, Sx)) : q_ & 4194048 && (Mn(256), Gn(P_, a, J_)), d = r, s = H_, c = 0 < U_, l = L_ === f_, a = p_, r = R_, o = z_, u = B_, lg && (fg = "Transition", 0 < n ? n > a && (n = a) : n = a, 0 < i ? i > n && (i = n) : i = n, 0 < d ? d > i && (d = i) : d = i, i > d && s !== null && (f = c ? "secondary-light" : "warning", r ? r.run(console.timeStamp.bind(console, c ? "Consecutive" : "Event: " + s, d, i, fg, dg, f)) : console.timeStamp(c ? "Consecutive" : "Event: " + s, d, i, fg, dg, f)), n > i && (r ? r.run(console.timeStamp.bind(console, "Action", i, n, fg, dg, "primary-dark")) : console.timeStamp("Action", i, n, fg, dg, "primary-dark")), a > n && (i = l ? "Promise Resolved" : 5 < a - n ? "Update Blocked" : "Update", d = [], u != null && d.push(["Component name", u]), o != null && d.push(["Method name", o]), n = {
				start: n,
				end: a,
				detail: { devtools: {
					properties: d,
					track: fg,
					trackGroup: dg,
					color: "primary-light"
				} }
			}, r ? r.run(performance.measure.bind(performance, i, n)) : performance.measure(i, n))), I_ = F_ = -1.1, L_ = 0, W_ = -1.1, U_ = V_, V_ = -1.1, P_ = l_()), t & 62914560 && q_ & 62914560 && (Mn(4194304), Gn(G_, p_, J_)), t & 2080374784 && q_ & 2080374784 && (Mn(268435456), Gn(K_, p_, J_)), n = e.timeoutHandle, n !== $S && (e.timeoutHandle = $S, QS(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), Lx = 0, qc(), Hb = e, Ub = n = or(e.current, null), Wb = t, tx = Gb, nx = null, rx = !1, ix = ye(e, t), ax = !1, sx = Pb, fx = dx = ux = lx = cx = 0, mx = px = null, hx = !1, t & 8 && (t |= t & 32), r = e.entangledLanes, r !== 0) for (e = e.entanglements, r &= t; 0 < r;) i = 31 - Cp(r), a = 1 << i, t |= e[i], r &= ~a;
			return ox = t, Kn(), e = Qh(), 1e3 < e - Xh && (Q.recentlyCreatedOwnerStacks = 0, Xh = e), av.discardPendingWarnings(), n;
		}
		function Xc(e, t) {
			xy = null, Q.H = Fy, Q.getCurrentStack = null, ip = !1, rp = null, t === Nv || t === Fv ? (t = bi(), tx = Jb) : t === Pv ? (t = bi(), tx = Yb) : tx = t === rb ? $b : typeof t == "object" && t && typeof t.then == "function" ? Zb : Kb, nx = t;
			var n = Ub;
			n === null ? (sx = Fb, Uo(e, mr(t, e.current))) : n.mode & kg && ii(n);
		}
		function Zc() {
			var e = ay.current;
			return e === null ? !0 : (Wb & 4194048) === Wb ? oy === null : (Wb & 62914560) === Wb || Wb & 536870912 ? e === oy : !1;
		}
		function Qc() {
			var e = Q.H;
			return Q.H = Fy, e === null ? Fy : e;
		}
		function $c() {
			var e = Q.A;
			return Q.A = Db, e;
		}
		function el(e) {
			Sx === null && (Sx = e._debugTask == null ? null : e._debugTask);
		}
		function tl() {
			sx = Rb, rx || (Wb & 4194048) !== Wb && ay.current !== null || (ix = !0), !(cx & 134217727) && !(lx & 134217727) || Hb === null || Gc(Hb, Wb, dx, !1);
		}
		function nl(e, t, n) {
			var r = Vb;
			Vb |= Mb;
			var i = Qc(), a = $c();
			if (Hb !== e || Wb !== t) {
				if (Sp) {
					var o = e.memoizedUpdaters;
					0 < o.size && (jl(e, Wb), o.clear()), ke(e, t);
				}
				xx = null, Yc(e, t);
			}
			t = !1, o = sx;
			a: do
				try {
					if (tx !== Gb && Ub !== null) {
						var s = Ub, c = nx;
						switch (tx) {
							case $b:
								qc(), o = zb;
								break a;
							case Jb:
							case qb:
							case ex:
							case Zb:
								ay.current === null && (t = !0);
								var l = tx;
								if (tx = Gb, nx = null, ll(e, s, c, l), n && ix) {
									o = Pb;
									break a;
								}
								break;
							default: l = tx, tx = Gb, nx = null, ll(e, s, c, l);
						}
					}
					rl(), o = sx;
					break;
				} catch (t) {
					Xc(e, t);
				}
			while (1);
			return t && e.shellSuspendCounter++, Nr(), Vb = r, Q.H = i, Q.A = a, Ub === null && (Hb = null, Wb = 0, Kn()), o;
		}
		function rl() {
			for (; Ub !== null;) ol(Ub);
		}
		function il(e, t) {
			var n = Vb;
			Vb |= Mb;
			var r = Qc(), i = $c();
			if (Hb !== e || Wb !== t) {
				if (Sp) {
					var a = e.memoizedUpdaters;
					0 < a.size && (jl(e, Wb), a.clear()), ke(e, t);
				}
				xx = null, yx = up() + bx, Yc(e, t);
			} else ix = ye(e, t);
			a: do
				try {
					if (tx !== Gb && Ub !== null) b: switch (t = Ub, a = nx, tx) {
						case Kb:
							tx = Gb, nx = null, ll(e, t, a, Kb);
							break;
						case qb:
						case ex:
							if (_i(a)) {
								tx = Gb, nx = null, sl(t);
								break;
							}
							t = function() {
								tx !== qb && tx !== ex || Hb !== e || (tx = Qb), Pl(e);
							}, a.then(t, t);
							break a;
						case Jb:
							tx = Qb;
							break a;
						case Yb:
							tx = Xb;
							break a;
						case Qb:
							_i(a) ? (tx = Gb, nx = null, sl(t)) : (tx = Gb, nx = null, ll(e, t, a, Qb));
							break;
						case Xb:
							var o = null;
							switch (Ub.tag) {
								case 26: o = Ub.memoizedState;
								case 5:
								case 27:
									var s = Ub;
									if (o ? Md(o) : s.stateNode.complete) {
										tx = Gb, nx = null;
										var c = s.sibling;
										if (c !== null) Ub = c;
										else {
											var l = s.return;
											l === null ? Ub = null : (Ub = l, ul(l));
										}
										break b;
									}
									break;
								default: console.error("Unexpected type of fiber triggered a suspensey commit. This is a bug in React.");
							}
							tx = Gb, nx = null, ll(e, t, a, Xb);
							break;
						case Zb:
							tx = Gb, nx = null, ll(e, t, a, Zb);
							break;
						case $b:
							qc(), sx = zb;
							break a;
						default: throw Error("Unexpected SuspendedReason. This is a bug in React.");
					}
					Q.actQueue === null ? al() : rl();
					break;
				} catch (t) {
					Xc(e, t);
				}
			while (1);
			return Nr(), Q.H = r, Q.A = i, Vb = n, Ub === null ? (Hb = null, Wb = 0, Kn(), sx) : Pb;
		}
		function al() {
			for (; Ub !== null && !cp();) ol(Ub);
		}
		function ol(e) {
			var t = e.alternate;
			(e.mode & kg) === Dg ? t = H(e, Cs, t, e, ox) : (ri(e), t = H(e, Cs, t, e, ox), ii(e)), e.memoizedProps = e.pendingProps, t === null ? ul(e) : Ub = t;
		}
		function sl(e) {
			var t = H(e, cl, e);
			e.memoizedProps = e.pendingProps, t === null ? ul(e) : Ub = t;
		}
		function cl(e) {
			var t = e.alternate, n = (e.mode & kg) !== Dg;
			switch (n && ri(e), e.tag) {
				case 15:
				case 0:
					t = ss(t, e, e.pendingProps, e.type, void 0, Wb);
					break;
				case 11:
					t = ss(t, e, e.pendingProps, e.type.render, e.ref, Wb);
					break;
				case 5: da(e);
				default: Ms(t, e), e = Ub = sr(e, ox), t = Cs(t, e, ox);
			}
			return n && ii(e), t;
		}
		function ll(e, t, n, r) {
			Nr(), da(t), zv = null, Bv = 0;
			var i = t.return;
			try {
				if (Jo(e, i, t, n, Wb)) {
					sx = Fb, Uo(e, mr(n, e.current)), Ub = null;
					return;
				}
			} catch (t) {
				if (i !== null) throw Ub = i, t;
				sx = Fb, Uo(e, mr(n, e.current)), Ub = null;
				return;
			}
			t.flags & 32768 ? (qg || r === Kb ? e = !0 : ix || Wb & 536870912 ? e = !1 : (rx = e = !0, (r === qb || r === ex || r === Jb || r === Zb) && (r = ay.current, r !== null && r.tag === 13 && (r.flags |= 16384))), dl(t, e)) : ul(t);
		}
		function ul(e) {
			var t = e;
			do {
				if (t.flags & 32768) {
					dl(t, rx);
					return;
				}
				var n = t.alternate;
				if (e = t.return, ri(t), n = H(t, As, n, t, ox), (t.mode & kg) !== Dg && ai(t), n !== null) {
					Ub = n;
					return;
				}
				if (t = t.sibling, t !== null) {
					Ub = t;
					return;
				}
				Ub = t = e;
			} while (t !== null);
			sx === Pb && (sx = Bb);
		}
		function dl(e, t) {
			do {
				var n = js(e.alternate, e);
				if (n !== null) {
					n.flags &= 32767, Ub = n;
					return;
				}
				if ((e.mode & kg) !== Dg) {
					ai(e), n = e.actualDuration;
					for (var r = e.child; r !== null;) n += r.actualDuration, r = r.sibling;
					e.actualDuration = n;
				}
				if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
					Ub = e;
					return;
				}
				Ub = e = n;
			} while (e !== null);
			sx = zb, Ub = null;
		}
		function fl(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
			e.cancelPendingCommit = null;
			do
				vl();
			while (Px !== Ox);
			if (av.flushLegacyContextWarning(), av.flushPendingUnsafeLifecycleWarnings(), (Vb & (Mb | Nb)) !== jb) throw Error("Should not already be working.");
			if (Mn(n), l === Ib ? Hn(f, p, n, Sx) : r === null ? Rn(f, p, n, Sx) : Vn(f, p, n, r, t !== null && t.alternate !== null && t.alternate.memoizedState.isDehydrated && (t.flags & 256) != 0, Sx), t !== null) {
				if (n === 0 && console.error("finishedLanes should not be empty during a commit. This is a bug in React."), t === e.current) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
				if (a = t.lanes | t.childLanes, a |= Cg, we(e, n, a, o, s, c), e === Hb && (Ub = Hb = null, Wb = 0), Ix = t, Fx = e, Lx = n, Rx = a, Bx = i, Vx = r, zx = p, Hx = d, Ux = wx, Wx = null, t.actualDuration !== 0 || t.subtreeFlags & 10256 || t.flags & 10256 ? (e.callbackNode = null, e.callbackPriority = 0, Ml(mp, function() {
					return XS = window.event, Ux === wx && (Ux = Ex), yl(), null;
				})) : (e.callbackNode = null, e.callbackPriority = 0), g_ = null, m_ = l_(), d !== null && Un(p, m_, d, Sx), r = (t.flags & 13878) != 0, t.subtreeFlags & 13878 || r) {
					r = Q.T, Q.T = null, i = If.p, If.p = kp, o = Vb, Vb |= Nb;
					try {
						ic(e, t, n);
					} finally {
						Vb = o, If.p = i, Q.T = r;
					}
				}
				Px = kx, pl(), ml(), hl();
			}
		}
		function pl() {
			if (Px === kx) {
				Px = Ox;
				var e = Fx, t = Ix, n = Lx, r = (t.flags & 13878) != 0;
				if (t.subtreeFlags & 13878 || r) {
					r = Q.T, Q.T = null;
					var i = If.p;
					If.p = kp;
					var a = Vb;
					Vb |= Nb;
					try {
						bb = n, xb = e, Zr(), mc(t, e), xb = bb = null, n = qS;
						var o = Sn(e.containerInfo), s = n.focusedElem, c = n.selectionRange;
						if (o !== s && s && s.ownerDocument && xn(s.ownerDocument.documentElement, s)) {
							if (c !== null && Cn(s)) {
								var l = c.start, u = c.end;
								if (u === void 0 && (u = l), "selectionStart" in s) s.selectionStart = l, s.selectionEnd = Math.min(u, s.value.length);
								else {
									var d = s.ownerDocument || document, f = d && d.defaultView || window;
									if (f.getSelection) {
										var p = f.getSelection(), m = s.textContent.length, h = Math.min(c.start, m), g = c.end === void 0 ? h : Math.min(c.end, m);
										!p.extend && h > g && (o = g, g = h, h = o);
										var _ = bn(s, h), v = bn(s, g);
										if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
											var y = d.createRange();
											y.setStart(_.node, _.offset), p.removeAllRanges(), h > g ? (p.addRange(y), p.extend(v.node, v.offset)) : (y.setEnd(v.node, v.offset), p.addRange(y));
										}
									}
								}
							}
							for (d = [], p = s; p = p.parentNode;) p.nodeType === 1 && d.push({
								element: p,
								left: p.scrollLeft,
								top: p.scrollTop
							});
							for (typeof s.focus == "function" && s.focus(), s = 0; s < d.length; s++) {
								var b = d[s];
								b.element.scrollLeft = b.left, b.element.scrollTop = b.top;
							}
						}
						LC = !!KS, qS = KS = null;
					} finally {
						Vb = a, If.p = i, Q.T = r;
					}
				}
				e.current = t, Px = Ax;
			}
		}
		function ml() {
			if (Px === Ax) {
				Px = Ox;
				var e = Wx;
				if (e !== null) {
					m_ = l_();
					var t = h_, n = m_;
					!lg || n <= t || (J_ ? J_.run(console.timeStamp.bind(console, e, t, n, fg, dg, "secondary-light")) : console.timeStamp(e, t, n, fg, dg, "secondary-light"));
				}
				e = Fx, t = Ix, n = Lx;
				var r = (t.flags & 8772) != 0;
				if (t.subtreeFlags & 8772 || r) {
					r = Q.T, Q.T = null;
					var i = If.p;
					If.p = kp;
					var a = Vb;
					Vb |= Nb;
					try {
						bb = n, xb = e, Zr(), ac(e, t.alternate, t), xb = bb = null;
					} finally {
						Vb = a, If.p = i, Q.T = r;
					}
				}
				e = zx, t = Hx, h_ = l_(), e = t === null ? e : m_, t = h_, n = Ux === Tx, r = Sx, g_ === null ? !lg || t <= e || (r ? r.run(console.timeStamp.bind(console, n ? "Commit Interrupted View Transition" : "Commit", e, t, fg, dg, n ? "error" : "secondary-dark")) : console.timeStamp(n ? "Commit Interrupted View Transition" : "Commit", e, t, fg, dg, n ? "error" : "secondary-dark")) : Wn(e, t, g_, !1, r), Px = jx;
			}
		}
		function hl() {
			if (Px === Mx || Px === jx) {
				if (Px === Mx) {
					var e = h_;
					h_ = l_();
					var t = h_, n = Ux === Tx;
					!lg || t <= e || (J_ ? J_.run(console.timeStamp.bind(console, n ? "Interrupted View Transition" : "Starting Animation", e, t, fg, dg, n ? "error" : "secondary-light")) : console.timeStamp(n ? "Interrupted View Transition" : "Starting Animation", e, t, fg, dg, n ? " error" : "secondary-light")), Ux !== Tx && (Ux = Dx);
				}
				Px = Ox, lp(), e = Fx;
				var r = Ix;
				t = Lx, n = Vx;
				var i = r.actualDuration !== 0 || (r.subtreeFlags & 10256) != 0 || (r.flags & 10256) != 0;
				i ? Px = Nx : (Px = Ox, Ix = Fx = null, _l(e, e.pendingLanes), Zx = 0, Qx = null);
				var a = e.pendingLanes;
				if (a === 0 && (Cx = null), i || kl(e), a = Ae(t), r = r.stateNode, bp && typeof bp.onCommitFiberRoot == "function") try {
					var o = (r.current.flags & 128) == 128;
					switch (a) {
						case kp:
							var s = fp;
							break;
						case Ap:
							s = pp;
							break;
						case jp:
							s = mp;
							break;
						case Mp:
							s = gp;
							break;
						default: s = mp;
					}
					bp.onCommitFiberRoot(yp, r, s, o);
				} catch (e) {
					xp || (xp = !0, console.error("React instrumentation encountered an error: %o", e));
				}
				if (Sp && e.memoizedUpdaters.clear(), Lc(), n !== null) {
					o = Q.T, s = If.p, If.p = kp, Q.T = null;
					try {
						var c = e.onRecoverableError;
						for (r = 0; r < n.length; r++) {
							var l = n[r], u = gl(l.stack);
							H(l.source, c, l.value, u);
						}
					} finally {
						Q.T = o, If.p = s;
					}
				}
				Lx & 3 && vl(), Pl(e), a = e.pendingLanes, t & 261930 && a & 42 ? (Q_ = !0, e === qx ? Kx++ : (Kx = 0, qx = e)) : Kx = 0, i || Jc(t, h_), Fl(0, !1);
			}
		}
		function gl(e) {
			return e = { componentStack: e }, Object.defineProperty(e, "digest", { get: function() {
				console.error("You are accessing \"digest\" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.");
			} }), e;
		}
		function _l(e, t) {
			(e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, Gr(t)));
		}
		function vl() {
			return pl(), ml(), hl(), yl();
		}
		function yl() {
			if (Px !== Nx) return !1;
			var e = Fx, t = Rx;
			Rx = 0;
			var n = Ae(Lx), r = jp === 0 || jp > n ? jp : n;
			n = Q.T;
			var i = If.p;
			try {
				If.p = r, Q.T = null;
				var a = Bx;
				Bx = null, r = Fx;
				var o = Lx;
				if (Px = Ox, Ix = Fx = null, Lx = 0, (Vb & (Mb | Nb)) !== jb) throw Error("Cannot flush passive effects while already rendering.");
				Mn(o), Jx = !0, Yx = !1;
				var s = 0;
				if (g_ = null, s = up(), Ux === Dx) Gn(h_, s, J_);
				else {
					var c = h_, l = s, u = Ux === Ex;
					!lg || l <= c || (Sx ? Sx.run(console.timeStamp.bind(console, u ? "Waiting for Paint" : "Waiting", c, l, fg, dg, "secondary-light")) : console.timeStamp(u ? "Waiting for Paint" : "Waiting", c, l, fg, dg, "secondary-light"));
				}
				c = Vb, Vb |= Nb;
				var d = r.current;
				Zr(), Nc(d);
				var f = r.current;
				d = zx, Zr(), Tc(r, f, o, a, d), kl(r), Vb = c;
				var p = up();
				if (f = s, d = Sx, g_ === null ? !lg || p <= f || (d ? d.run(console.timeStamp.bind(console, "Remaining Effects", f, p, fg, dg, "secondary-dark")) : console.timeStamp("Remaining Effects", f, p, fg, dg, "secondary-dark")) : Wn(f, p, g_, !0, d), Jc(o, p), Fl(0, !1), Yx ? r === Qx ? Zx++ : (Zx = 0, Qx = r) : Zx = 0, Yx = Jx = !1, bp && typeof bp.onPostCommitFiberRoot == "function") try {
					bp.onPostCommitFiberRoot(yp, r);
				} catch (e) {
					xp || (xp = !0, console.error("React instrumentation encountered an error: %o", e));
				}
				var m = r.current.stateNode;
				return m.effectDuration = 0, m.passiveEffectDuration = 0, !0;
			} finally {
				If.p = i, Q.T = n, _l(e, t);
			}
		}
		function bl(e, t, n) {
			t = mr(n, t), si(t), t = Go(e.stateNode, t, 2), e = Ri(e, t, 2), e !== null && (Ce(e, 2), Pl(e));
		}
		function xl(e, t, n) {
			if ($x = !1, e.tag === 3) bl(e, e, n);
			else {
				for (; t !== null;) {
					if (t.tag === 3) {
						bl(t, e, n);
						return;
					}
					if (t.tag === 1) {
						var r = t.stateNode;
						if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (Cx === null || !Cx.has(r))) {
							e = mr(n, e), si(e), n = Ko(2), r = Ri(t, n, 2), r !== null && (qo(n, r, t, e), Ce(r, 2), Pl(r));
							return;
						}
					}
					t = t.return;
				}
				console.error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", n);
			}
		}
		function Sl(e, t, n) {
			var r = e.pingCache;
			if (r === null) {
				r = e.pingCache = new Ab();
				var i = /* @__PURE__ */ new Set();
				r.set(t, i);
			} else i = r.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
			i.has(n) || (ax = !0, i.add(n), r = Cl.bind(null, e, t, n), Sp && jl(e, n), t.then(r, r));
		}
		function Cl(e, t, n) {
			var r = e.pingCache;
			r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, n & 127 ? 0 > T_ && (w_ = T_ = l_(), E_ = u_("Promise Resolved"), D_ = f_) : n & 4194048 && 0 > I_ && (P_ = I_ = l_(), R_ = u_("Promise Resolved"), L_ = f_), Rc() && Q.actQueue === null && console.error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act"), Hb === e && (Wb & n) === n && (sx === Rb || sx === Lb && (Wb & 62914560) === Wb && up() - gx < vx ? (Vb & Mb) === jb && Yc(e, 0) : ux |= n, fx === Wb && (fx = 0)), Pl(e);
		}
		function wl(e, t) {
			t === 0 && (t = xe()), e = Yn(e, t), e !== null && (Ce(e, t), Pl(e));
		}
		function Tl(e) {
			var t = e.memoizedState, n = 0;
			t !== null && (n = t.retryLane), wl(e, n);
		}
		function El(e, t) {
			var n = 0;
			switch (e.tag) {
				case 31:
				case 13:
					var r = e.stateNode, i = e.memoizedState;
					i !== null && (n = i.retryLane);
					break;
				case 19:
					r = e.stateNode;
					break;
				case 22:
					r = e.stateNode._retryCache;
					break;
				default: throw Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
			}
			r !== null && r.delete(t), wl(e, n);
		}
		function Dl(e, t, n) {
			if (t.subtreeFlags & 67117056) for (t = t.child; t !== null;) {
				var r = e, i = t, a = i.type === Sf;
				a = n || a, i.tag === 22 ? i.memoizedState === null && (a && i.flags & 8192 ? H(i, Ol, r, i) : i.subtreeFlags & 67108864 && H(i, Dl, r, i, a)) : i.flags & 67108864 ? a && H(i, Ol, r, i) : Dl(r, i, a), t = t.sibling;
			}
		}
		function Ol(e, t) {
			he(!0);
			try {
				vc(t), Fc(t), bc(e, t.alternate, t, !1), Dc(e, t, 0, null, !1, 0);
			} finally {
				he(!1);
			}
		}
		function kl(e) {
			var t = !0;
			e.current.mode & (Ag | jg) || (t = !1), Dl(e, e.current, t);
		}
		function Al(e) {
			if ((Vb & Mb) === jb) {
				var t = e.tag;
				if (t === 3 || t === 1 || t === 0 || t === 11 || t === 14 || t === 15) {
					if (t = O(e) || "ReactComponent", eS !== null) {
						if (eS.has(t)) return;
						eS.add(t);
					} else eS = new Set([t]);
					H(e, function() {
						console.error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead.");
					});
				}
			}
		}
		function jl(e, t) {
			Sp && e.memoizedUpdaters.forEach(function(n) {
				Oe(e, n, t);
			});
		}
		function Ml(e, t) {
			var n = Q.actQueue;
			return n === null ? op(e, t) : (n.push(t), rS);
		}
		function Nl(e) {
			Rc() && Q.actQueue === null && H(e, function() {
				console.error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act", O(e));
			});
		}
		function Pl(e) {
			e !== aS && e.next === null && (aS === null ? iS = aS = e : aS = aS.next = e), cS = !0, Q.actQueue === null ? oS || (oS = !0, Hl()) : sS || (sS = !0, Hl());
		}
		function Fl(e, t) {
			if (!lS && cS) {
				lS = !0;
				do
					for (var n = !1, r = iS; r !== null;) {
						if (!t) if (e !== 0) {
							var i = r.pendingLanes;
							if (i === 0) var a = 0;
							else {
								var o = r.suspendedLanes, s = r.pingedLanes;
								a = (1 << 31 - Cp(42 | e) + 1) - 1, a &= i & ~(o & ~s), a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0;
							}
							a !== 0 && (n = !0, Bl(r, a));
						} else a = Wb, a = ve(r, r === Hb ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== $S), !(a & 3) || ye(r, a) || (n = !0, Bl(r, a));
						r = r.next;
					}
				while (n);
				lS = !1;
			}
		}
		function Il() {
			XS = window.event, Ll();
		}
		function Ll() {
			cS = sS = oS = !1;
			var e = 0;
			uS !== 0 && ju() && (e = uS);
			for (var t = up(), n = null, r = iS; r !== null;) {
				var i = r.next, a = Rl(r, t);
				a === 0 ? (r.next = null, n === null ? iS = i : n.next = i, i === null && (aS = n)) : (n = r, (e !== 0 || a & 3) && (cS = !0)), r = i;
			}
			Px !== Ox && Px !== Nx || Fl(e, !1), uS !== 0 && (uS = 0);
		}
		function Rl(e, t) {
			for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes & -62914561; 0 < a;) {
				var o = 31 - Cp(a), s = 1 << o, c = i[o];
				c === -1 ? ((s & n) === 0 || (s & r) !== 0) && (i[o] = be(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s;
			}
			if (t = Hb, n = Wb, n = ve(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== $S), r = e.callbackNode, n === 0 || e === t && (tx === qb || tx === ex) || e.cancelPendingCommit !== null) return r !== null && Vl(r), e.callbackNode = null, e.callbackPriority = 0;
			if (!(n & 3) || ye(e, n)) {
				if (t = n & -n, t !== e.callbackPriority || Q.actQueue !== null && r !== dS) Vl(r);
				else return t;
				switch (Ae(n)) {
					case kp:
					case Ap:
						n = pp;
						break;
					case jp:
						n = mp;
						break;
					case Mp:
						n = gp;
						break;
					default: n = mp;
				}
				return r = zl.bind(null, e), Q.actQueue === null ? n = op(n, r) : (Q.actQueue.push(r), n = dS), e.callbackPriority = t, e.callbackNode = n, t;
			}
			return r !== null && Vl(r), e.callbackPriority = 2, e.callbackNode = null, 2;
		}
		function zl(e, t) {
			if (Q_ = Z_ = !1, XS = window.event, Px !== Ox && Px !== Nx) return e.callbackNode = null, e.callbackPriority = 0, null;
			var n = e.callbackNode;
			if (Ux === wx && (Ux = Ex), vl() && e.callbackNode !== n) return null;
			var r = Wb;
			return r = ve(e, e === Hb ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== $S), r === 0 ? null : (Hc(e, r, t), Rl(e, up()), e.callbackNode != null && e.callbackNode === n ? zl.bind(null, e) : null);
		}
		function Bl(e, t) {
			if (vl()) return null;
			Z_ = Q_, Q_ = !1, Hc(e, t, !0);
		}
		function Vl(e) {
			e !== dS && e !== null && sp(e);
		}
		function Hl() {
			Q.actQueue !== null && Q.actQueue.push(function() {
				return Ll(), null;
			}), tC(function() {
				(Vb & (Mb | Nb)) === jb ? Ll() : op(fp, Il);
			});
		}
		function Ul() {
			if (uS === 0) {
				var e = tv;
				e === 0 && (e = Ep, Ep <<= 1, !(Ep & 261888) && (Ep = 256)), uS = e;
			}
			return uS;
		}
		function Wl(e) {
			return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : (de(e, "action"), Ut("" + e));
		}
		function Gl(e, t) {
			var n = t.ownerDocument.createElement("input");
			return n.name = t.name, n.value = t.value, e.id && n.setAttribute("form", e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e;
		}
		function Kl(e, t, n, r, i) {
			if (t === "submit" && n && n.stateNode === i) {
				var a = Wl((i[Fp] || null).action), o = r.submitter;
				o && (t = (t = o[Fp] || null) ? Wl(t.formAction) : o.getAttribute("formAction"), t !== null && (a = t, o = null));
				var s = new Ym("action", "action", null, r, i);
				e.push({
					event: s,
					listeners: [{
						instance: null,
						listener: function() {
							if (r.defaultPrevented) {
								if (uS !== 0) {
									var e = o ? Gl(i, o) : new FormData(i), t = {
										pending: !0,
										data: e,
										method: i.method,
										action: a
									};
									Object.freeze(t), vo(n, t, null, e);
								}
							} else typeof a == "function" && (s.preventDefault(), e = o ? Gl(i, o) : new FormData(i), t = {
								pending: !0,
								data: e,
								method: i.method,
								action: a
							}, Object.freeze(t), vo(n, t, a, e));
						},
						currentTarget: i
					}]
				});
			}
		}
		function ql(e, t, n) {
			e.currentTarget = n;
			try {
				t(e);
			} catch (e) {
				eg(e);
			}
			e.currentTarget = null;
		}
		function Jl(e, t) {
			t = (t & 4) != 0;
			for (var n = 0; n < e.length; n++) {
				var r = e[n];
				a: {
					var i = void 0, a = r.event;
					if (r = r.listeners, t) for (var o = r.length - 1; 0 <= o; o--) {
						var s = r[o], c = s.instance, l = s.currentTarget;
						if (s = s.listener, c !== i && a.isPropagationStopped()) break a;
						c === null ? ql(a, s, l) : H(c, ql, a, s, l), i = c;
					}
					else for (o = 0; o < r.length; o++) {
						if (s = r[o], c = s.instance, l = s.currentTarget, s = s.listener, c !== i && a.isPropagationStopped()) break a;
						c === null ? ql(a, s, l) : H(c, ql, a, s, l), i = c;
					}
				}
			}
		}
		function Yl(e, t) {
			pS.has(e) || console.error("Did not expect a listenToNonDelegatedEvent() call for \"%s\". This is a bug in React. Please file an issue.", e);
			var n = t[Lp];
			n === void 0 && (n = t[Lp] = /* @__PURE__ */ new Set());
			var r = e + "__bubble";
			n.has(r) || (Ql(t, e, 2, !1), n.add(r));
		}
		function Xl(e, t, n) {
			pS.has(e) && !t && console.error("Did not expect a listenToNativeEvent() call for \"%s\" in the bubble phase. This is a bug in React. Please file an issue.", e);
			var r = 0;
			t && (r |= 4), Ql(n, e, r, t);
		}
		function Zl(e) {
			if (!e[mS]) {
				e[mS] = !0, Hp.forEach(function(t) {
					t !== "selectionchange" && (pS.has(t) || Xl(t, !1, e), Xl(t, !0, e));
				});
				var t = e.nodeType === 9 ? e : e.ownerDocument;
				t === null || t[mS] || (t[mS] = !0, Xl("selectionchange", !1, t));
			}
		}
		function Ql(e, t, n, r) {
			switch (Qd(t)) {
				case kp:
					var i = qd;
					break;
				case Ap:
					i = Jd;
					break;
				default: i = Yd;
			}
			n = i.bind(null, t, n, e), i = void 0, !Um || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), r ? i === void 0 ? e.addEventListener(t, n, !0) : e.addEventListener(t, n, {
				capture: !0,
				passive: i
			}) : i === void 0 ? e.addEventListener(t, n, !1) : e.addEventListener(t, n, { passive: i });
		}
		function $l(e, t, n, r, i) {
			var a = r;
			if (!(t & 1) && !(t & 2) && r !== null) a: for (;;) {
				if (r === null) return;
				var o = r.tag;
				if (o === 3 || o === 4) {
					var s = r.stateNode.containerInfo;
					if (s === i) break;
					if (o === 4) for (o = r.return; o !== null;) {
						var c = o.tag;
						if ((c === 3 || c === 4) && o.stateNode.containerInfo === i) return;
						o = o.return;
					}
					for (; s !== null;) {
						if (o = Pe(s), o === null) return;
						if (c = o.tag, c === 5 || c === 6 || c === 26 || c === 27) {
							r = a = o;
							continue a;
						}
						s = s.parentNode;
					}
				}
				r = r.return;
			}
			Kt(function() {
				var r = a, i = Wt(n), o = [];
				a: {
					var s = Jh.get(e);
					if (s !== void 0) {
						var c = Ym, l = e;
						switch (e) {
							case "keypress": if (Yt(n) === 0) break a;
							case "keydown":
							case "keyup":
								c = fh;
								break;
							case "focusin":
								l = "focus", c = ih;
								break;
							case "focusout":
								l = "blur", c = ih;
								break;
							case "beforeblur":
							case "afterblur":
								c = ih;
								break;
							case "click": if (n.button === 2) break a;
							case "auxclick":
							case "dblclick":
							case "mousedown":
							case "mousemove":
							case "mouseup":
							case "mouseout":
							case "mouseover":
							case "contextmenu":
								c = nh;
								break;
							case "drag":
							case "dragend":
							case "dragenter":
							case "dragexit":
							case "dragleave":
							case "dragover":
							case "dragstart":
							case "drop":
								c = rh;
								break;
							case "touchcancel":
							case "touchend":
							case "touchmove":
							case "touchstart":
								c = mh;
								break;
							case Vh:
							case Hh:
							case Uh:
								c = ah;
								break;
							case qh:
								c = hh;
								break;
							case "scroll":
							case "scrollend":
								c = Zm;
								break;
							case "wheel":
								c = gh;
								break;
							case "copy":
							case "cut":
							case "paste":
								c = oh;
								break;
							case "gotpointercapture":
							case "lostpointercapture":
							case "pointercancel":
							case "pointerdown":
							case "pointermove":
							case "pointerout":
							case "pointerover":
							case "pointerup":
								c = ph;
								break;
							case "toggle":
							case "beforetoggle": c = _h;
						}
						var u = (t & 4) != 0, d = !u && (e === "scroll" || e === "scrollend"), f = u ? s === null ? null : s + "Capture" : s;
						u = [];
						for (var p = r, m; p !== null;) {
							var h = p;
							if (m = h.stateNode, h = h.tag, h !== 5 && h !== 26 && h !== 27 || m === null || f === null || (h = qt(p, f), h != null && u.push(eu(p, h, m))), d) break;
							p = p.return;
						}
						0 < u.length && (s = new c(s, l, null, n, i), o.push({
							event: s,
							listeners: u
						}));
					}
				}
				if (!(t & 7)) {
					a: {
						if (s = e === "mouseover" || e === "pointerover", c = e === "mouseout" || e === "pointerout", s && n !== Rm && (l = n.relatedTarget || n.fromElement) && (Pe(l) || l[Ip])) break a;
						if ((c || s) && (s = i.window === i ? i : (s = i.ownerDocument) ? s.defaultView || s.parentWindow : window, c ? (l = n.relatedTarget || n.toElement, c = r, l = l ? Pe(l) : null, l !== null && (d = y(l), u = l.tag, l !== d || u !== 5 && u !== 27 && u !== 6) && (l = null)) : (c = null, l = r), c !== l)) {
							if (u = nh, h = "onMouseLeave", f = "onMouseEnter", p = "mouse", (e === "pointerout" || e === "pointerover") && (u = ph, h = "onPointerLeave", f = "onPointerEnter", p = "pointer"), d = c == null ? s : Ie(c), m = l == null ? s : Ie(l), s = new u(h, p + "leave", c, n, i), s.target = d, s.relatedTarget = m, h = null, Pe(i) === r && (u = new u(f, p + "enter", l, n, i), u.target = m, u.relatedTarget = d, h = u), d = h, c && l) b: {
								for (u = nu, f = c, p = l, m = 0, h = f; h; h = u(h)) m++;
								h = 0;
								for (var g = p; g; g = u(g)) h++;
								for (; 0 < m - h;) f = u(f), m--;
								for (; 0 < h - m;) p = u(p), h--;
								for (; m--;) {
									if (f === p || p !== null && f === p.alternate) {
										u = f;
										break b;
									}
									f = u(f), p = u(p);
								}
								u = null;
							}
							else u = null;
							c !== null && ru(o, s, c, u, !1), l !== null && d !== null && ru(o, d, l, u, !0);
						}
					}
					a: {
						if (s = r ? Ie(r) : window, c = s.nodeName && s.nodeName.toLowerCase(), c === "select" || c === "input" && s.type === "file") var _ = dn;
						else if (on(s)) if (jh) _ = _n;
						else {
							_ = hn;
							var v = mn;
						}
						else c = s.nodeName, !c || c.toLowerCase() !== "input" || s.type !== "checkbox" && s.type !== "radio" ? r && Lt(r.elementType) && (_ = dn) : _ = gn;
						if (_ &&= _(e, r)) {
							cn(o, _, n, i);
							break a;
						}
						v && v(e, s, r), e === "focusout" && r && s.type === "number" && r.memoizedProps.value != null && rt(s, "number", s.value);
					}
					switch (v = r ? Ie(r) : window, e) {
						case "focusin":
							(on(v) || v.contentEditable === "true") && (Ph = v, Fh = r, Ih = null);
							break;
						case "focusout":
							Ih = Fh = Ph = null;
							break;
						case "mousedown":
							Lh = !0;
							break;
						case "contextmenu":
						case "mouseup":
						case "dragend":
							Lh = !1, wn(o, n, i);
							break;
						case "selectionchange": if (Nh) break;
						case "keydown":
						case "keyup": wn(o, n, i);
					}
					var b;
					if (bh) b: {
						switch (e) {
							case "compositionstart":
								var x = "onCompositionStart";
								break b;
							case "compositionend":
								x = "onCompositionEnd";
								break b;
							case "compositionupdate":
								x = "onCompositionUpdate";
								break b;
						}
						x = void 0;
					}
					else Dh ? tn(e, n) && (x = "onCompositionEnd") : e === "keydown" && n.keyCode === yh && (x = "onCompositionStart");
					x && (Ch && n.locale !== "ko" && (Dh || x !== "onCompositionStart" ? x === "onCompositionEnd" && Dh && (b = Jt()) : (Gm = i, Km = "value" in Gm ? Gm.value : Gm.textContent, Dh = !0)), v = tu(r, x), 0 < v.length && (x = new sh(x, e, null, n, i), o.push({
						event: x,
						listeners: v
					}), b ? x.data = b : (b = nn(n), b !== null && (x.data = b)))), (b = Sh ? rn(e, n) : an(e, n)) && (x = tu(r, "onBeforeInput"), 0 < x.length && (v = new ch("onBeforeInput", "beforeinput", null, n, i), o.push({
						event: v,
						listeners: x
					}), v.data = b)), Kl(o, e, r, n, i);
				}
				Jl(o, t);
			});
		}
		function eu(e, t, n) {
			return {
				instance: e,
				listener: t,
				currentTarget: n
			};
		}
		function tu(e, t) {
			for (var n = t + "Capture", r = []; e !== null;) {
				var i = e, a = i.stateNode;
				if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || a === null || (i = qt(e, n), i != null && r.unshift(eu(e, i, a)), i = qt(e, t), i != null && r.push(eu(e, i, a))), e.tag === 3) return r;
				e = e.return;
			}
			return [];
		}
		function nu(e) {
			if (e === null) return null;
			do
				e = e.return;
			while (e && e.tag !== 5 && e.tag !== 27);
			return e || null;
		}
		function ru(e, t, n, r, i) {
			for (var a = t._reactName, o = []; n !== null && n !== r;) {
				var s = n, c = s.alternate, l = s.stateNode;
				if (s = s.tag, c !== null && c === r) break;
				s !== 5 && s !== 26 && s !== 27 || l === null || (c = l, i ? (l = qt(n, a), l != null && o.unshift(eu(n, l, c))) : i || (l = qt(n, a), l != null && o.push(eu(n, l, c)))), n = n.return;
			}
			o.length !== 0 && e.push({
				event: t,
				listeners: o
			});
		}
		function iu(e, t) {
			Bt(e, t), e !== "input" && e !== "textarea" && e !== "select" || t == null || t.value !== null || jm || (jm = !0, e === "select" && t.multiple ? console.error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : console.error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
			var n = {
				registrationNameDependencies: Up,
				possibleRegistrationNames: Wp
			};
			Lt(e) || typeof t.is == "string" || Ht(e, t, n), t.contentEditable && !t.suppressContentEditableWarning && t.children != null && console.error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
		}
		function au(e, t, n, r) {
			t !== n && (n = lu(n), lu(t) !== n && (r[e] = t));
		}
		function ou(e, t, n) {
			t.forEach(function(t) {
				n[hu(t)] = t === "style" ? gu(e) : e.getAttribute(t);
			});
		}
		function su(e, t) {
			!1 === t ? console.error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : console.error("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof t);
		}
		function cu(e, t) {
			return e = e.namespaceURI === Cm || e.namespaceURI === wm ? e.ownerDocument.createElementNS(e.namespaceURI, e.tagName) : e.ownerDocument.createElement(e.tagName), e.innerHTML = t, e.innerHTML;
		}
		function lu(e) {
			return le(e) && (console.error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.", ce(e)), ue(e)), (typeof e == "string" ? e : "" + e).replace(CS, "\n").replace(wS, "");
		}
		function uu(e, t) {
			return t = lu(t), lu(e) === t;
		}
		function du(e, t, n, r, i, a) {
			switch (n) {
				case "children":
					typeof r == "string" ? (Mt(r, t, !1), t === "body" || t === "textarea" && r === "" || Nt(e, r)) : (typeof r == "number" || typeof r == "bigint") && (Mt("" + r, t, !1), t !== "body" && Nt(e, "" + r));
					break;
				case "className":
					Ge(e, "class", r);
					break;
				case "tabIndex":
					Ge(e, "tabindex", r);
					break;
				case "dir":
				case "role":
				case "viewBox":
				case "width":
				case "height":
					Ge(e, n, r);
					break;
				case "style":
					It(e, r, a);
					break;
				case "data": if (t !== "object") {
					Ge(e, "data", r);
					break;
				}
				case "src":
				case "href":
					if (r === "" && (t !== "a" || n !== "href")) {
						console.error(n === "src" ? "An empty string (\"\") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string." : "An empty string (\"\") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.", n, n), e.removeAttribute(n);
						break;
					}
					if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") {
						e.removeAttribute(n);
						break;
					}
					de(r, n), r = Ut("" + r), e.setAttribute(n, r);
					break;
				case "action":
				case "formAction":
					if (r != null && (t === "form" ? n === "formAction" ? console.error("You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>.") : typeof r == "function" && (i.encType == null && i.method == null || bS || (bS = !0, console.error("Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden.")), i.target == null || yS || (yS = !0, console.error("Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."))) : t === "input" || t === "button" ? n === "action" ? console.error("You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>.") : t !== "input" || i.type === "submit" || i.type === "image" || _S ? t !== "button" || i.type == null || i.type === "submit" || _S ? typeof r == "function" && (i.name == null || vS || (vS = !0, console.error("Cannot specify a \"name\" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.")), i.formEncType == null && i.formMethod == null || bS || (bS = !0, console.error("Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden.")), i.formTarget == null || yS || (yS = !0, console.error("Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."))) : (_S = !0, console.error("A button can only specify a formAction along with type=\"submit\" or no type.")) : (_S = !0, console.error("An input can only specify a formAction along with type=\"submit\" or type=\"image\".")) : console.error(n === "action" ? "You can only pass the action prop to <form>." : "You can only pass the formAction prop to <input> or <button>.")), typeof r == "function") {
						e.setAttribute(n, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
						break;
					} else typeof a == "function" && (n === "formAction" ? (t !== "input" && du(e, t, "name", i.name, i, null), du(e, t, "formEncType", i.formEncType, i, null), du(e, t, "formMethod", i.formMethod, i, null), du(e, t, "formTarget", i.formTarget, i, null)) : (du(e, t, "encType", i.encType, i, null), du(e, t, "method", i.method, i, null), du(e, t, "target", i.target, i, null)));
					if (r == null || typeof r == "symbol" || typeof r == "boolean") {
						e.removeAttribute(n);
						break;
					}
					de(r, n), r = Ut("" + r), e.setAttribute(n, r);
					break;
				case "onClick":
					r != null && (typeof r != "function" && su(n, r), e.onclick = G);
					break;
				case "onScroll":
					r != null && (typeof r != "function" && su(n, r), Yl("scroll", e));
					break;
				case "onScrollEnd":
					r != null && (typeof r != "function" && su(n, r), Yl("scrollend", e));
					break;
				case "dangerouslySetInnerHTML":
					if (r != null) {
						if (typeof r != "object" || !("__html" in r)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
						if (n = r.__html, n != null) {
							if (i.children != null) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
							e.innerHTML = n;
						}
					}
					break;
				case "multiple":
					e.multiple = r && typeof r != "function" && typeof r != "symbol";
					break;
				case "muted":
					e.muted = r && typeof r != "function" && typeof r != "symbol";
					break;
				case "suppressContentEditableWarning":
				case "suppressHydrationWarning":
				case "defaultValue":
				case "defaultChecked":
				case "innerHTML":
				case "ref": break;
				case "autoFocus": break;
				case "xlinkHref":
					if (r == null || typeof r == "function" || typeof r == "boolean" || typeof r == "symbol") {
						e.removeAttribute("xlink:href");
						break;
					}
					de(r, n), n = Ut("" + r), e.setAttributeNS(TS, "xlink:href", n);
					break;
				case "contentEditable":
				case "spellCheck":
				case "draggable":
				case "value":
				case "autoReverse":
				case "externalResourcesRequired":
				case "focusable":
				case "preserveAlpha":
					r != null && typeof r != "function" && typeof r != "symbol" ? (de(r, n), e.setAttribute(n, "" + r)) : e.removeAttribute(n);
					break;
				case "inert": r !== "" || SS[n] || (SS[n] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", n));
				case "allowFullScreen":
				case "async":
				case "autoPlay":
				case "controls":
				case "default":
				case "defer":
				case "disabled":
				case "disablePictureInPicture":
				case "disableRemotePlayback":
				case "formNoValidate":
				case "hidden":
				case "loop":
				case "noModule":
				case "noValidate":
				case "open":
				case "playsInline":
				case "readOnly":
				case "required":
				case "reversed":
				case "scoped":
				case "seamless":
				case "itemScope":
					r && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "") : e.removeAttribute(n);
					break;
				case "capture":
				case "download":
					!0 === r ? e.setAttribute(n, "") : !1 !== r && r != null && typeof r != "function" && typeof r != "symbol" ? (de(r, n), e.setAttribute(n, r)) : e.removeAttribute(n);
					break;
				case "cols":
				case "rows":
				case "size":
				case "span":
					r != null && typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r ? (de(r, n), e.setAttribute(n, r)) : e.removeAttribute(n);
					break;
				case "rowSpan":
				case "start":
					r == null || typeof r == "function" || typeof r == "symbol" || isNaN(r) ? e.removeAttribute(n) : (de(r, n), e.setAttribute(n, r));
					break;
				case "popover":
					Yl("beforetoggle", e), Yl("toggle", e), We(e, "popover", r);
					break;
				case "xlinkActuate":
					Ke(e, TS, "xlink:actuate", r);
					break;
				case "xlinkArcrole":
					Ke(e, TS, "xlink:arcrole", r);
					break;
				case "xlinkRole":
					Ke(e, TS, "xlink:role", r);
					break;
				case "xlinkShow":
					Ke(e, TS, "xlink:show", r);
					break;
				case "xlinkTitle":
					Ke(e, TS, "xlink:title", r);
					break;
				case "xlinkType":
					Ke(e, TS, "xlink:type", r);
					break;
				case "xmlBase":
					Ke(e, ES, "xml:base", r);
					break;
				case "xmlLang":
					Ke(e, ES, "xml:lang", r);
					break;
				case "xmlSpace":
					Ke(e, ES, "xml:space", r);
					break;
				case "is":
					a != null && console.error("Cannot update the \"is\" prop after it has been initialized."), We(e, "is", r);
					break;
				case "innerText":
				case "textContent": break;
				case "popoverTarget": xS || typeof r != "object" || !r || (xS = !0, console.error("The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.", r));
				default: !(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N" ? (n = Rt(n), We(e, n, r)) : Up.hasOwnProperty(n) && r != null && typeof r != "function" && su(n, r);
			}
		}
		function fu(e, t, n, r, i, a) {
			switch (n) {
				case "style":
					It(e, r, a);
					break;
				case "dangerouslySetInnerHTML":
					if (r != null) {
						if (typeof r != "object" || !("__html" in r)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
						if (n = r.__html, n != null) {
							if (i.children != null) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
							e.innerHTML = n;
						}
					}
					break;
				case "children":
					typeof r == "string" ? Nt(e, r) : (typeof r == "number" || typeof r == "bigint") && Nt(e, "" + r);
					break;
				case "onScroll":
					r != null && (typeof r != "function" && su(n, r), Yl("scroll", e));
					break;
				case "onScrollEnd":
					r != null && (typeof r != "function" && su(n, r), Yl("scrollend", e));
					break;
				case "onClick":
					r != null && (typeof r != "function" && su(n, r), e.onclick = G);
					break;
				case "suppressContentEditableWarning":
				case "suppressHydrationWarning":
				case "innerHTML":
				case "ref": break;
				case "innerText":
				case "textContent": break;
				default: if (Up.hasOwnProperty(n)) r != null && typeof r != "function" && su(n, r);
				else a: {
					if (n[0] === "o" && n[1] === "n" && (i = n.endsWith("Capture"), t = n.slice(2, i ? n.length - 7 : void 0), a = e[Fp] || null, a = a == null ? null : a[n], typeof a == "function" && e.removeEventListener(t, a, i), typeof r == "function")) {
						typeof a != "function" && a !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, r, i);
						break a;
					}
					n in e ? e[n] = r : !0 === r ? e.setAttribute(n, "") : We(e, n, r);
				}
			}
		}
		function pu(e, t, n) {
			switch (iu(t, n), t) {
				case "div":
				case "span":
				case "svg":
				case "path":
				case "a":
				case "g":
				case "p":
				case "li": break;
				case "img":
					Yl("error", e), Yl("load", e);
					var r = !1, i = !1, a;
					for (a in n) if (n.hasOwnProperty(a)) {
						var o = n[a];
						if (o != null) switch (a) {
							case "src":
								r = !0;
								break;
							case "srcSet":
								i = !0;
								break;
							case "children":
							case "dangerouslySetInnerHTML": throw Error(t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
							default: du(e, t, a, o, n, null);
						}
					}
					i && du(e, t, "srcSet", n.srcSet, n, null), r && du(e, t, "src", n.src, n, null);
					return;
				case "input":
					Ve("input", n), Yl("invalid", e);
					var s = a = o = i = null, c = null, l = null;
					for (r in n) if (n.hasOwnProperty(r)) {
						var u = n[r];
						if (u != null) switch (r) {
							case "name":
								i = u;
								break;
							case "type":
								o = u;
								break;
							case "checked":
								c = u;
								break;
							case "defaultChecked":
								l = u;
								break;
							case "value":
								a = u;
								break;
							case "defaultValue":
								s = u;
								break;
							case "children":
							case "dangerouslySetInnerHTML":
								if (u != null) throw Error(t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
								break;
							default: du(e, t, r, u, n, null);
						}
					}
					et(e, n), nt(e, a, s, c, l, o, i, !1);
					return;
				case "select":
					for (i in Ve("select", n), Yl("invalid", e), r = o = a = null, n) if (n.hasOwnProperty(i) && (s = n[i], s != null)) switch (i) {
						case "value":
							a = s;
							break;
						case "defaultValue":
							o = s;
							break;
						case "multiple": r = s;
						default: du(e, t, i, s, n, null);
					}
					st(e, n), t = a, n = o, e.multiple = !!r, t == null ? n != null && ot(e, !!r, n, !0) : ot(e, !!r, t, !1);
					return;
				case "textarea":
					for (o in Ve("textarea", n), Yl("invalid", e), a = i = r = null, n) if (n.hasOwnProperty(o) && (s = n[o], s != null)) switch (o) {
						case "value":
							r = s;
							break;
						case "defaultValue":
							i = s;
							break;
						case "children":
							a = s;
							break;
						case "dangerouslySetInnerHTML":
							if (s != null) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
							break;
						default: du(e, t, o, s, n, null);
					}
					ct(e, n), ut(e, r, i, a);
					return;
				case "option":
					for (c in it(e, n), n) if (n.hasOwnProperty(c) && (r = n[c], r != null)) switch (c) {
						case "selected":
							e.selected = r && typeof r != "function" && typeof r != "symbol";
							break;
						default: du(e, t, c, r, n, null);
					}
					return;
				case "dialog":
					Yl("beforetoggle", e), Yl("toggle", e), Yl("cancel", e), Yl("close", e);
					break;
				case "iframe":
				case "object":
					Yl("load", e);
					break;
				case "video":
				case "audio":
					for (r = 0; r < fS.length; r++) Yl(fS[r], e);
					break;
				case "image":
					Yl("error", e), Yl("load", e);
					break;
				case "details":
					Yl("toggle", e);
					break;
				case "embed":
				case "source":
				case "link": Yl("error", e), Yl("load", e);
				case "area":
				case "base":
				case "br":
				case "col":
				case "hr":
				case "keygen":
				case "meta":
				case "param":
				case "track":
				case "wbr":
				case "menuitem":
					for (l in n) if (n.hasOwnProperty(l) && (r = n[l], r != null)) switch (l) {
						case "children":
						case "dangerouslySetInnerHTML": throw Error(t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
						default: du(e, t, l, r, n, null);
					}
					return;
				default: if (Lt(t)) {
					for (u in n) n.hasOwnProperty(u) && (r = n[u], r !== void 0 && fu(e, t, u, r, n, void 0));
					return;
				}
			}
			for (s in n) n.hasOwnProperty(s) && (r = n[s], r != null && du(e, t, s, r, n, null));
		}
		function mu(e, t, n, r) {
			switch (iu(t, r), t) {
				case "div":
				case "span":
				case "svg":
				case "path":
				case "a":
				case "g":
				case "p":
				case "li": break;
				case "input":
					var i = null, a = null, o = null, s = null, c = null, l = null, u = null;
					for (p in n) {
						var d = n[p];
						if (n.hasOwnProperty(p) && d != null) switch (p) {
							case "checked": break;
							case "value": break;
							case "defaultValue": c = d;
							default: r.hasOwnProperty(p) || du(e, t, p, null, r, d);
						}
					}
					for (var f in r) {
						var p = r[f];
						if (d = n[f], r.hasOwnProperty(f) && (p != null || d != null)) switch (f) {
							case "type":
								a = p;
								break;
							case "name":
								i = p;
								break;
							case "checked":
								l = p;
								break;
							case "defaultChecked":
								u = p;
								break;
							case "value":
								o = p;
								break;
							case "defaultValue":
								s = p;
								break;
							case "children":
							case "dangerouslySetInnerHTML":
								if (p != null) throw Error(t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
								break;
							default: p !== d && du(e, t, f, p, r, d);
						}
					}
					t = n.type === "checkbox" || n.type === "radio" ? n.checked != null : n.value != null, r = r.type === "checkbox" || r.type === "radio" ? r.checked != null : r.value != null, t || !r || gS || (console.error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), gS = !0), !t || r || hS || (console.error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), hS = !0), tt(e, o, s, c, l, u, a, i);
					return;
				case "select":
					for (a in p = o = s = f = null, n) if (c = n[a], n.hasOwnProperty(a) && c != null) switch (a) {
						case "value": break;
						case "multiple": p = c;
						default: r.hasOwnProperty(a) || du(e, t, a, null, r, c);
					}
					for (i in r) if (a = r[i], c = n[i], r.hasOwnProperty(i) && (a != null || c != null)) switch (i) {
						case "value":
							f = a;
							break;
						case "defaultValue":
							s = a;
							break;
						case "multiple": o = a;
						default: a !== c && du(e, t, i, a, r, c);
					}
					r = s, t = o, n = p, f == null ? !!n != !!t && (r == null ? ot(e, !!t, t ? [] : "", !1) : ot(e, !!t, r, !0)) : ot(e, !!t, f, !1);
					return;
				case "textarea":
					for (s in p = f = null, n) if (i = n[s], n.hasOwnProperty(s) && i != null && !r.hasOwnProperty(s)) switch (s) {
						case "value": break;
						case "children": break;
						default: du(e, t, s, null, r, i);
					}
					for (o in r) if (i = r[o], a = n[o], r.hasOwnProperty(o) && (i != null || a != null)) switch (o) {
						case "value":
							f = i;
							break;
						case "defaultValue":
							p = i;
							break;
						case "children": break;
						case "dangerouslySetInnerHTML":
							if (i != null) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
							break;
						default: i !== a && du(e, t, o, i, r, a);
					}
					lt(e, f, p);
					return;
				case "option":
					for (var m in n) if (f = n[m], n.hasOwnProperty(m) && f != null && !r.hasOwnProperty(m)) switch (m) {
						case "selected":
							e.selected = !1;
							break;
						default: du(e, t, m, null, r, f);
					}
					for (c in r) if (f = r[c], p = n[c], r.hasOwnProperty(c) && f !== p && (f != null || p != null)) switch (c) {
						case "selected":
							e.selected = f && typeof f != "function" && typeof f != "symbol";
							break;
						default: du(e, t, c, f, r, p);
					}
					return;
				case "img":
				case "link":
				case "area":
				case "base":
				case "br":
				case "col":
				case "embed":
				case "hr":
				case "keygen":
				case "meta":
				case "param":
				case "source":
				case "track":
				case "wbr":
				case "menuitem":
					for (var h in n) f = n[h], n.hasOwnProperty(h) && f != null && !r.hasOwnProperty(h) && du(e, t, h, null, r, f);
					for (l in r) if (f = r[l], p = n[l], r.hasOwnProperty(l) && f !== p && (f != null || p != null)) switch (l) {
						case "children":
						case "dangerouslySetInnerHTML":
							if (f != null) throw Error(t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
							break;
						default: du(e, t, l, f, r, p);
					}
					return;
				default: if (Lt(t)) {
					for (var g in n) f = n[g], n.hasOwnProperty(g) && f !== void 0 && !r.hasOwnProperty(g) && fu(e, t, g, void 0, r, f);
					for (u in r) f = r[u], p = n[u], !r.hasOwnProperty(u) || f === p || f === void 0 && p === void 0 || fu(e, t, u, f, r, p);
					return;
				}
			}
			for (var _ in n) f = n[_], n.hasOwnProperty(_) && f != null && !r.hasOwnProperty(_) && du(e, t, _, null, r, f);
			for (d in r) f = r[d], p = n[d], !r.hasOwnProperty(d) || f === p || f == null && p == null || du(e, t, d, f, r, p);
		}
		function hu(e) {
			switch (e) {
				case "class": return "className";
				case "for": return "htmlFor";
				default: return e;
			}
		}
		function gu(e) {
			var t = {};
			e = e.style;
			for (var n = 0; n < e.length; n++) {
				var r = e[n];
				t[r] = e.getPropertyValue(r);
			}
			return t;
		}
		function _u(e, t, n) {
			if (t != null && typeof t != "object") console.error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
			else {
				var r, i = r = "", a;
				for (a in t) if (t.hasOwnProperty(a)) {
					var o = t[a];
					o != null && typeof o != "boolean" && o !== "" && (a.indexOf("--") === 0 ? (fe(o, a), r += i + a + ":" + ("" + o).trim()) : typeof o != "number" || o === 0 || Sm.has(a) ? (fe(o, a), r += i + a.replace(fm, "-$1").toLowerCase().replace(pm, "-ms-") + ":" + ("" + o).trim()) : r += i + a.replace(fm, "-$1").toLowerCase().replace(pm, "-ms-") + ":" + o + "px", i = ";");
				}
				r ||= null, t = e.getAttribute("style"), t !== r && (r = lu(r), lu(t) !== r && (n.style = gu(e)));
			}
		}
		function vu(e, t, n, r, i, a) {
			if (i.delete(n), e = e.getAttribute(n), e === null) switch (typeof r) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean": return;
			}
			else if (r != null) switch (typeof r) {
				case "function":
				case "symbol":
				case "boolean": break;
				default: if (de(r, t), e === "" + r) return;
			}
			au(t, e, r, a);
		}
		function yu(e, t, n, r, i, a) {
			if (i.delete(n), e = e.getAttribute(n), e === null) {
				switch (typeof r) {
					case "function":
					case "symbol": return;
				}
				if (!r) return;
			} else switch (typeof r) {
				case "function":
				case "symbol": break;
				default: if (r) return;
			}
			au(t, e, r, a);
		}
		function bu(e, t, n, r, i, a) {
			if (i.delete(n), e = e.getAttribute(n), e === null) switch (typeof r) {
				case "undefined":
				case "function":
				case "symbol": return;
			}
			else if (r != null) switch (typeof r) {
				case "function":
				case "symbol": break;
				default: if (de(r, n), e === "" + r) return;
			}
			au(t, e, r, a);
		}
		function xu(e, t, n, r, i, a) {
			if (i.delete(n), e = e.getAttribute(n), e === null) switch (typeof r) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean": return;
				default: if (isNaN(r)) return;
			}
			else if (r != null) switch (typeof r) {
				case "function":
				case "symbol":
				case "boolean": break;
				default: if (!isNaN(r) && (de(r, t), e === "" + r)) return;
			}
			au(t, e, r, a);
		}
		function Su(e, t, n, r, i, a) {
			if (i.delete(n), e = e.getAttribute(n), e === null) switch (typeof r) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean": return;
			}
			else if (r != null) switch (typeof r) {
				case "function":
				case "symbol":
				case "boolean": break;
				default: if (de(r, t), n = Ut("" + r), e === n) return;
			}
			au(t, e, r, a);
		}
		function Cu(e, t, n, r) {
			for (var i = {}, a = /* @__PURE__ */ new Set(), o = e.attributes, s = 0; s < o.length; s++) switch (o[s].name.toLowerCase()) {
				case "value": break;
				case "checked": break;
				case "selected": break;
				default: a.add(o[s].name);
			}
			if (Lt(t)) {
				for (var c in n) if (n.hasOwnProperty(c)) {
					var l = n[c];
					if (l != null) {
						if (Up.hasOwnProperty(c)) typeof l != "function" && su(c, l);
						else if (!0 !== n.suppressHydrationWarning) switch (c) {
							case "children":
								typeof l != "string" && typeof l != "number" || au("children", e.textContent, l, i);
								continue;
							case "suppressContentEditableWarning":
							case "suppressHydrationWarning":
							case "defaultValue":
							case "defaultChecked":
							case "innerHTML":
							case "ref": continue;
							case "dangerouslySetInnerHTML":
								o = e.innerHTML, l = l ? l.__html : void 0, l != null && (l = cu(e, l), au(c, o, l, i));
								continue;
							case "style":
								a.delete(c), _u(e, l, i);
								continue;
							case "offsetParent":
							case "offsetTop":
							case "offsetLeft":
							case "offsetWidth":
							case "offsetHeight":
							case "isContentEditable":
							case "outerText":
							case "outerHTML":
								a.delete(c.toLowerCase()), console.error("Assignment to read-only property will result in a no-op: `%s`", c);
								continue;
							case "className":
								a.delete("class"), o = Ue(e, "class", l), au("className", o, l, i);
								continue;
							default: r.context === US && t !== "svg" && t !== "math" ? a.delete(c.toLowerCase()) : a.delete(c), o = Ue(e, c, l), au(c, o, l, i);
						}
					}
				}
			} else for (l in n) if (n.hasOwnProperty(l) && (c = n[l], c != null)) {
				if (Up.hasOwnProperty(l)) typeof c != "function" && su(l, c);
				else if (!0 !== n.suppressHydrationWarning) switch (l) {
					case "children":
						typeof c != "string" && typeof c != "number" || au("children", e.textContent, c, i);
						continue;
					case "suppressContentEditableWarning":
					case "suppressHydrationWarning":
					case "value":
					case "checked":
					case "selected":
					case "defaultValue":
					case "defaultChecked":
					case "innerHTML":
					case "ref": continue;
					case "dangerouslySetInnerHTML":
						o = e.innerHTML, c = c ? c.__html : void 0, c != null && (c = cu(e, c), o !== c && (i[l] = { __html: o }));
						continue;
					case "className":
						vu(e, l, "class", c, a, i);
						continue;
					case "tabIndex":
						vu(e, l, "tabindex", c, a, i);
						continue;
					case "style":
						a.delete(l), _u(e, c, i);
						continue;
					case "multiple":
						a.delete(l), au(l, e.multiple, c, i);
						continue;
					case "muted":
						a.delete(l), au(l, e.muted, c, i);
						continue;
					case "autoFocus":
						a.delete("autofocus"), au(l, e.autofocus, c, i);
						continue;
					case "data": if (t !== "object") {
						a.delete(l), o = e.getAttribute("data"), au(l, o, c, i);
						continue;
					}
					case "src":
					case "href":
						if (!(c !== "" || t === "a" && l === "href" || t === "object" && l === "data")) {
							console.error(l === "src" ? "An empty string (\"\") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string." : "An empty string (\"\") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.", l, l);
							continue;
						}
						Su(e, l, l, c, a, i);
						continue;
					case "action":
					case "formAction":
						if (o = e.getAttribute(l), typeof c == "function") {
							a.delete(l.toLowerCase()), l === "formAction" ? (a.delete("name"), a.delete("formenctype"), a.delete("formmethod"), a.delete("formtarget")) : (a.delete("enctype"), a.delete("method"), a.delete("target"));
							continue;
						} else if (o === DS) {
							a.delete(l.toLowerCase()), au(l, "function", c, i);
							continue;
						}
						Su(e, l, l.toLowerCase(), c, a, i);
						continue;
					case "xlinkHref":
						Su(e, l, "xlink:href", c, a, i);
						continue;
					case "contentEditable":
						bu(e, l, "contenteditable", c, a, i);
						continue;
					case "spellCheck":
						bu(e, l, "spellcheck", c, a, i);
						continue;
					case "draggable":
					case "autoReverse":
					case "externalResourcesRequired":
					case "focusable":
					case "preserveAlpha":
						bu(e, l, l, c, a, i);
						continue;
					case "allowFullScreen":
					case "async":
					case "autoPlay":
					case "controls":
					case "default":
					case "defer":
					case "disabled":
					case "disablePictureInPicture":
					case "disableRemotePlayback":
					case "formNoValidate":
					case "hidden":
					case "loop":
					case "noModule":
					case "noValidate":
					case "open":
					case "playsInline":
					case "readOnly":
					case "required":
					case "reversed":
					case "scoped":
					case "seamless":
					case "itemScope":
						yu(e, l, l.toLowerCase(), c, a, i);
						continue;
					case "capture":
					case "download":
						a: {
							s = e;
							var u = o = l, d = i;
							if (a.delete(u), s = s.getAttribute(u), s === null) switch (typeof c) {
								case "undefined":
								case "function":
								case "symbol": break a;
								default: if (!1 === c) break a;
							}
							else if (c != null) switch (typeof c) {
								case "function":
								case "symbol": break;
								case "boolean":
									if (!0 === c && s === "") break a;
									break;
								default: if (de(c, o), s === "" + c) break a;
							}
							au(o, s, c, d);
						}
						continue;
					case "cols":
					case "rows":
					case "size":
					case "span":
						a: {
							if (s = e, u = o = l, d = i, a.delete(u), s = s.getAttribute(u), s === null) switch (typeof c) {
								case "undefined":
								case "function":
								case "symbol":
								case "boolean": break a;
								default: if (isNaN(c) || 1 > c) break a;
							}
							else if (c != null) switch (typeof c) {
								case "function":
								case "symbol":
								case "boolean": break;
								default: if (!(isNaN(c) || 1 > c) && (de(c, o), s === "" + c)) break a;
							}
							au(o, s, c, d);
						}
						continue;
					case "rowSpan":
						xu(e, l, "rowspan", c, a, i);
						continue;
					case "start":
						xu(e, l, l, c, a, i);
						continue;
					case "xHeight":
						vu(e, l, "x-height", c, a, i);
						continue;
					case "xlinkActuate":
						vu(e, l, "xlink:actuate", c, a, i);
						continue;
					case "xlinkArcrole":
						vu(e, l, "xlink:arcrole", c, a, i);
						continue;
					case "xlinkRole":
						vu(e, l, "xlink:role", c, a, i);
						continue;
					case "xlinkShow":
						vu(e, l, "xlink:show", c, a, i);
						continue;
					case "xlinkTitle":
						vu(e, l, "xlink:title", c, a, i);
						continue;
					case "xlinkType":
						vu(e, l, "xlink:type", c, a, i);
						continue;
					case "xmlBase":
						vu(e, l, "xml:base", c, a, i);
						continue;
					case "xmlLang":
						vu(e, l, "xml:lang", c, a, i);
						continue;
					case "xmlSpace":
						vu(e, l, "xml:space", c, a, i);
						continue;
					case "inert":
						c !== "" || SS[l] || (SS[l] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", l)), yu(e, l, l, c, a, i);
						continue;
					default: if (!(2 < l.length) || l[0] !== "o" && l[0] !== "O" || l[1] !== "n" && l[1] !== "N") {
						s = Rt(l), o = !1, r.context === US && t !== "svg" && t !== "math" ? a.delete(s.toLowerCase()) : (u = l.toLowerCase(), u = Em.hasOwnProperty(u) && Em[u] || null, u !== null && u !== l && (o = !0, a.delete(u)), a.delete(s));
						a: if (u = e, d = s, s = c, He(d)) if (u.hasAttribute(d)) u = u.getAttribute(d), de(s, d), s = u === "" + s ? s : u;
						else {
							switch (typeof s) {
								case "function":
								case "symbol": break a;
								case "boolean": if (u = d.toLowerCase().slice(0, 5), u !== "data-" && u !== "aria-") break a;
							}
							s = s === void 0 ? void 0 : null;
						}
						else s = void 0;
						o || au(l, s, c, i);
					}
				}
			}
			return 0 < a.size && !0 !== n.suppressHydrationWarning && ou(e, a, i), Object.keys(i).length === 0 ? null : i;
		}
		function wu(e, t) {
			switch (e.length) {
				case 0: return "";
				case 1: return e[0];
				case 2: return e[0] + " " + t + " " + e[1];
				default: return e.slice(0, -1).join(", ") + ", " + t + " " + e[e.length - 1];
			}
		}
		function Tu(e) {
			switch (e) {
				case "css":
				case "script":
				case "font":
				case "img":
				case "image":
				case "input":
				case "link": return !0;
				default: return !1;
			}
		}
		function Eu() {
			if (typeof performance.getEntriesByType == "function") {
				for (var e = 0, t = 0, n = performance.getEntriesByType("resource"), r = 0; r < n.length; r++) {
					var i = n[r], a = i.transferSize, o = i.initiatorType, s = i.duration;
					if (a && s && Tu(o)) {
						for (o = 0, s = i.responseEnd, r += 1; r < n.length; r++) {
							var c = n[r], l = c.startTime;
							if (l > s) break;
							var u = c.transferSize, d = c.initiatorType;
							u && Tu(d) && (c = c.responseEnd, o += u * (c < s ? 1 : (s - l) / (c - l)));
						}
						if (--r, t += 8 * (a + o) / (i.duration / 1e3), e++, 10 < e) break;
					}
				}
				if (0 < e) return t / e / 1e6;
			}
			return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
		}
		function Du(e) {
			return e.nodeType === 9 ? e : e.ownerDocument;
		}
		function Ou(e) {
			switch (e) {
				case wm: return WS;
				case Cm: return GS;
				default: return US;
			}
		}
		function ku(e, t) {
			if (e === US) switch (t) {
				case "svg": return WS;
				case "math": return GS;
				default: return US;
			}
			return e === WS && t === "foreignObject" ? US : e;
		}
		function Au(e, t) {
			return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
		}
		function ju() {
			var e = window.event;
			return e && e.type === "popstate" ? e === YS ? !1 : (YS = e, !0) : (YS = null, !1);
		}
		function Mu() {
			var e = window.event;
			return e && e !== XS ? e.type : null;
		}
		function Nu() {
			var e = window.event;
			return e && e !== XS ? e.timeStamp : -1.1;
		}
		function Pu(e) {
			setTimeout(function() {
				throw e;
			});
		}
		function Fu(e, t, n) {
			switch (t) {
				case "button":
				case "input":
				case "select":
				case "textarea":
					n.autoFocus && e.focus();
					break;
				case "img": n.src ? e.src = n.src : n.srcSet && (e.srcset = n.srcSet);
			}
		}
		function Iu() {}
		function Lu(e, t, n, r) {
			mu(e, t, n, r), e[Fp] = r;
		}
		function Ru(e) {
			Nt(e, "");
		}
		function zu(e, t, n) {
			e.nodeValue = n;
		}
		function Bu(e) {
			if (!e.__reactWarnedAboutChildrenConflict) {
				var t = e[Fp] || null;
				if (t !== null) {
					var n = Fe(e);
					n !== null && (typeof t.children == "string" || typeof t.children == "number" ? (e.__reactWarnedAboutChildrenConflict = !0, H(n, function() {
						console.error("Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets \"children\" text content using React. It should be a leaf with no children. Otherwise it's ambiguous which children should be used.");
					})) : t.dangerouslySetInnerHTML != null && (e.__reactWarnedAboutChildrenConflict = !0, H(n, function() {
						console.error("Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets \"dangerouslySetInnerHTML\" using React. It should be a leaf with no children. Otherwise it's ambiguous which children should be used.");
					})));
				}
			}
		}
		function Vu(e) {
			return e === "head";
		}
		function Hu(e, t) {
			e.removeChild(t);
		}
		function Uu(e, t) {
			(e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e).removeChild(t);
		}
		function Wu(e, t) {
			var n = t, r = 0;
			do {
				var i = n.nextSibling;
				if (e.removeChild(n), i && i.nodeType === 8) if (n = i.data, n === MS || n === AS) {
					if (r === 0) {
						e.removeChild(i), lf(t);
						return;
					}
					r--;
				} else if (n === jS || n === NS || n === PS || n === FS || n === kS) r++;
				else if (n === IS) md(e.ownerDocument.documentElement);
				else if (n === RS) {
					n = e.ownerDocument.head, md(n);
					for (var a = n.firstChild; a;) {
						var o = a.nextSibling, s = a.nodeName;
						a[Vp] || s === "SCRIPT" || s === "STYLE" || s === "LINK" && a.rel.toLowerCase() === "stylesheet" || n.removeChild(a), a = o;
					}
				} else n === LS && md(e.ownerDocument.body);
				n = i;
			} while (n);
			lf(t);
		}
		function Gu(e, t) {
			var n = e;
			e = 0;
			do {
				var r = n.nextSibling;
				if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), r && r.nodeType === 8) if (n = r.data, n === MS) {
					if (e === 0) break;
					e--;
				} else n !== jS && n !== NS && n !== PS && n !== FS || e++;
				n = r;
			} while (n);
		}
		function Ku(e) {
			Gu(e, !0);
		}
		function qu(e) {
			e = e.style, typeof e.setProperty == "function" ? e.setProperty("display", "none", "important") : e.display = "none";
		}
		function Ju(e) {
			e.nodeValue = "";
		}
		function Yu(e) {
			Gu(e, !1);
		}
		function Xu(e, t) {
			t = t[HS], t = t != null && t.hasOwnProperty("display") ? t.display : null, e.style.display = t == null || typeof t == "boolean" ? "" : ("" + t).trim();
		}
		function Zu(e, t) {
			e.nodeValue = t;
		}
		function Qu(e) {
			var t = e.firstChild;
			for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
				var n = t;
				switch (t = t.nextSibling, n.nodeName) {
					case "HTML":
					case "HEAD":
					case "BODY":
						Qu(n), Ne(n);
						continue;
					case "SCRIPT":
					case "STYLE": continue;
					case "LINK": if (n.rel.toLowerCase() === "stylesheet") continue;
				}
				e.removeChild(n);
			}
		}
		function $u(e, t, n, r) {
			for (; e.nodeType === 1;) {
				var i = n;
				if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
					if (!r && (e.nodeName !== "INPUT" || e.type !== "hidden")) break;
				} else if (!r) if (t === "input" && e.type === "hidden") {
					de(i.name, "name");
					var a = i.name == null ? null : "" + i.name;
					if (i.type === "hidden" && e.getAttribute("name") === a) return e;
				} else return e;
				else if (!e[Vp]) switch (t) {
					case "meta":
						if (!e.hasAttribute("itemprop")) break;
						return e;
					case "link":
						if (a = e.getAttribute("rel"), a === "stylesheet" && e.hasAttribute("data-precedence") || a !== i.rel || e.getAttribute("href") !== (i.href == null || i.href === "" ? null : i.href) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute("title") !== (i.title == null ? null : i.title)) break;
						return e;
					case "style":
						if (e.hasAttribute("data-precedence")) break;
						return e;
					case "script":
						if (a = e.getAttribute("src"), (a !== (i.src == null ? null : i.src) || e.getAttribute("type") !== (i.type == null ? null : i.type) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute("async") && !e.hasAttribute("itemprop")) break;
						return e;
					default: return e;
				}
				if (e = ad(e.nextSibling), e === null) break;
			}
			return null;
		}
		function ed(e, t, n) {
			if (t === "") return null;
			for (; e.nodeType !== 3;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !n || (e = ad(e.nextSibling), e === null)) return null;
			return e;
		}
		function td(e, t) {
			for (; e.nodeType !== 8;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = ad(e.nextSibling), e === null)) return null;
			return e;
		}
		function nd(e) {
			return e.data === NS || e.data === PS;
		}
		function rd(e) {
			return e.data === FS || e.data === NS && e.ownerDocument.readyState !== VS;
		}
		function id(e, t) {
			var n = e.ownerDocument;
			if (e.data === PS) e._reactRetry = t;
			else if (e.data !== NS || n.readyState !== VS) t();
			else {
				var r = function() {
					t(), n.removeEventListener("DOMContentLoaded", r);
				};
				n.addEventListener("DOMContentLoaded", r), e._reactRetry = r;
			}
		}
		function ad(e) {
			for (; e != null; e = e.nextSibling) {
				var t = e.nodeType;
				if (t === 1 || t === 3) break;
				if (t === 8) {
					if (t = e.data, t === jS || t === FS || t === NS || t === PS || t === kS || t === zS || t === BS) break;
					if (t === MS || t === AS) return null;
				}
			}
			return e;
		}
		function od(e) {
			if (e.nodeType === 1) {
				for (var t = e.nodeName.toLowerCase(), n = {}, r = e.attributes, i = 0; i < r.length; i++) {
					var a = r[i];
					n[hu(a.name)] = a.name.toLowerCase() === "style" ? gu(e) : a.value;
				}
				return {
					type: t,
					props: n
				};
			}
			return e.nodeType === 8 ? e.data === kS ? {
				type: "Activity",
				props: {}
			} : {
				type: "Suspense",
				props: {}
			} : e.nodeValue;
		}
		function sd(e, t, n) {
			return n === null || !0 !== n[OS] ? (e.nodeValue === t ? e = null : (t = lu(t), e = lu(e.nodeValue) === t ? null : e.nodeValue), e) : null;
		}
		function cd(e) {
			e = e.nextSibling;
			for (var t = 0; e;) {
				if (e.nodeType === 8) {
					var n = e.data;
					if (n === MS || n === AS) {
						if (t === 0) return ad(e.nextSibling);
						t--;
					} else n !== jS && n !== FS && n !== NS && n !== PS && n !== kS || t++;
				}
				e = e.nextSibling;
			}
			return null;
		}
		function Z(e) {
			e = e.previousSibling;
			for (var t = 0; e;) {
				if (e.nodeType === 8) {
					var n = e.data;
					if (n === jS || n === FS || n === NS || n === PS || n === kS) {
						if (t === 0) return e;
						t--;
					} else n !== MS && n !== AS || t++;
				}
				e = e.previousSibling;
			}
			return null;
		}
		function ld(e) {
			lf(e);
		}
		function ud(e) {
			lf(e);
		}
		function dd(e) {
			lf(e);
		}
		function fd(e, t, n, r, i) {
			switch (i && jt(e, r.ancestorInfo), t = Du(n), e) {
				case "html":
					if (e = t.documentElement, !e) throw Error("React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page.");
					return e;
				case "head":
					if (e = t.head, !e) throw Error("React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page.");
					return e;
				case "body":
					if (e = t.body, !e) throw Error("React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page.");
					return e;
				default: throw Error("resolveSingletonInstance was called with an element type that is not supported. This is a bug in React.");
			}
		}
		function pd(e, t, n, r) {
			if (!n[Ip] && Fe(n)) {
				var i = n.tagName.toLowerCase();
				console.error("You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.", i, i, i);
			}
			switch (e) {
				case "html":
				case "head":
				case "body": break;
				default: console.error("acquireSingletonInstance was called with an element type that is not supported. This is a bug in React.");
			}
			for (i = n.attributes; i.length;) n.removeAttributeNode(i[0]);
			pu(n, e, t), n[Pp] = r, n[Fp] = t;
		}
		function md(e) {
			for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
			Ne(e);
		}
		function hd(e) {
			return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
		}
		function gd(e, t, n) {
			var r = dC;
			if (r && typeof t == "string" && t) {
				var i = $e(t);
				i = "link[rel=\"" + e + "\"][href=\"" + i + "\"]", typeof n == "string" && (i += "[crossorigin=\"" + n + "\"]"), lC.has(i) || (lC.add(i), e = {
					rel: e,
					crossOrigin: n,
					href: t
				}, r.querySelector(i) === null && (t = r.createElement("link"), pu(t, "link", e), Re(t), r.head.appendChild(t)));
			}
		}
		function _d(e, t, n, r) {
			var i = (i = Uf.current) ? hd(i) : null;
			if (!i) throw Error("\"resourceRoot\" was expected to exist. This is a bug in React.");
			switch (e) {
				case "meta":
				case "title": return null;
				case "style": return typeof n.precedence == "string" && typeof n.href == "string" ? (n = yd(n.href), t = Le(i).hoistableStyles, r = t.get(n), r || (r = {
					type: "style",
					instance: null,
					count: 0,
					state: null
				}, t.set(n, r)), r) : {
					type: "void",
					instance: null,
					count: 0,
					state: null
				};
				case "link":
					if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
						e = yd(n.href);
						var a = Le(i).hoistableStyles, o = a.get(e);
						if (!o && (i = i.ownerDocument || i, o = {
							type: "stylesheet",
							instance: null,
							count: 0,
							state: {
								loading: rC,
								preload: null
							}
						}, a.set(e, o), (a = i.querySelector(bd(e))) && !a._p && (o.instance = a, o.state.loading = iC | sC), !cC.has(e))) {
							var s = {
								rel: "preload",
								as: "style",
								href: n.href,
								crossOrigin: n.crossOrigin,
								integrity: n.integrity,
								media: n.media,
								hrefLang: n.hrefLang,
								referrerPolicy: n.referrerPolicy
							};
							cC.set(e, s), a || Sd(i, e, s, o.state);
						}
						if (t && r === null) throw n = "\n\n  - " + vd(t) + "\n  + " + vd(n), Error("Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + n);
						return o;
					}
					if (t && r !== null) throw n = "\n\n  - " + vd(t) + "\n  + " + vd(n), Error("Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + n);
					return null;
				case "script": return t = n.async, n = n.src, typeof n == "string" && t && typeof t != "function" && typeof t != "symbol" ? (n = Cd(n), t = Le(i).hoistableScripts, r = t.get(n), r || (r = {
					type: "script",
					instance: null,
					count: 0,
					state: null
				}, t.set(n, r)), r) : {
					type: "void",
					instance: null,
					count: 0,
					state: null
				};
				default: throw Error("getResource encountered a type it did not expect: \"" + e + "\". this is a bug in React.");
			}
		}
		function vd(e) {
			var t = 0, n = "<link";
			return typeof e.rel == "string" ? (t++, n += " rel=\"" + e.rel + "\"") : ap.call(e, "rel") && (t++, n += " rel=\"" + (e.rel === null ? "null" : "invalid type " + typeof e.rel) + "\""), typeof e.href == "string" ? (t++, n += " href=\"" + e.href + "\"") : ap.call(e, "href") && (t++, n += " href=\"" + (e.href === null ? "null" : "invalid type " + typeof e.href) + "\""), typeof e.precedence == "string" ? (t++, n += " precedence=\"" + e.precedence + "\"") : ap.call(e, "precedence") && (t++, n += " precedence={" + (e.precedence === null ? "null" : "invalid type " + typeof e.precedence) + "}"), Object.getOwnPropertyNames(e).length > t && (n += " ..."), n + " />";
		}
		function yd(e) {
			return "href=\"" + $e(e) + "\"";
		}
		function bd(e) {
			return "link[rel=\"stylesheet\"][" + e + "]";
		}
		function xd(e) {
			return _f({}, e, {
				"data-precedence": e.precedence,
				precedence: null
			});
		}
		function Sd(e, t, n, r) {
			e.querySelector("link[rel=\"preload\"][as=\"style\"][" + t + "]") ? r.loading = iC : (t = e.createElement("link"), r.preload = t, t.addEventListener("load", function() {
				return r.loading |= iC;
			}), t.addEventListener("error", function() {
				return r.loading |= aC;
			}), pu(t, "link", n), Re(t), e.head.appendChild(t));
		}
		function Cd(e) {
			return "[src=\"" + $e(e) + "\"]";
		}
		function wd(e) {
			return "script[async]" + e;
		}
		function Td(e, t, n) {
			if (t.count++, t.instance === null) switch (t.type) {
				case "style":
					var r = e.querySelector("style[data-href~=\"" + $e(n.href) + "\"]");
					if (r) return t.instance = r, Re(r), r;
					var i = _f({}, n, {
						"data-href": n.href,
						"data-precedence": n.precedence,
						href: null,
						precedence: null
					});
					return r = (e.ownerDocument || e).createElement("style"), Re(r), pu(r, "style", i), Ed(r, n.precedence, e), t.instance = r;
				case "stylesheet":
					i = yd(n.href);
					var a = e.querySelector(bd(i));
					if (a) return t.state.loading |= sC, t.instance = a, Re(a), a;
					r = xd(n), (i = cC.get(i)) && Dd(r, i), a = (e.ownerDocument || e).createElement("link"), Re(a);
					var o = a;
					return o._p = new Promise(function(e, t) {
						o.onload = e, o.onerror = t;
					}), pu(a, "link", r), t.state.loading |= sC, Ed(a, n.precedence, e), t.instance = a;
				case "script": return a = Cd(n.src), (i = e.querySelector(wd(a))) ? (t.instance = i, Re(i), i) : (r = n, (i = cC.get(a)) && (r = _f({}, n), Od(r, i)), e = e.ownerDocument || e, i = e.createElement("script"), Re(i), pu(i, "link", r), e.head.appendChild(i), t.instance = i);
				case "void": return null;
				default: throw Error("acquireResource encountered a resource type it did not expect: \"" + t.type + "\". this is a bug in React.");
			}
			else t.type === "stylesheet" && (t.state.loading & sC) === rC && (r = t.instance, t.state.loading |= sC, Ed(r, n.precedence, e));
			return t.instance;
		}
		function Ed(e, t, n) {
			for (var r = n.querySelectorAll("link[rel=\"stylesheet\"][data-precedence],style[data-precedence]"), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
				var s = r[o];
				if (s.dataset.precedence === t) a = s;
				else if (a !== i) break;
			}
			a ? a.parentNode.insertBefore(e, a.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
		}
		function Dd(e, t) {
			e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.title ??= t.title;
		}
		function Od(e, t) {
			e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.integrity ??= t.integrity;
		}
		function kd(e, t, n) {
			if (fC === null) {
				var r = /* @__PURE__ */ new Map(), i = fC = /* @__PURE__ */ new Map();
				i.set(n, r);
			} else i = fC, r = i.get(n), r || (r = /* @__PURE__ */ new Map(), i.set(n, r));
			if (r.has(e)) return r;
			for (r.set(e, null), n = n.getElementsByTagName(e), i = 0; i < n.length; i++) {
				var a = n[i];
				if (!(a[Vp] || a[Pp] || e === "link" && a.getAttribute("rel") === "stylesheet") && a.namespaceURI !== wm) {
					var o = a.getAttribute(t) || "";
					o = e + o;
					var s = r.get(o);
					s ? s.push(a) : r.set(o, [a]);
				}
			}
			return r;
		}
		function Ad(e, t, n) {
			e = e.ownerDocument || e, e.head.insertBefore(n, t === "title" ? e.querySelector("head > title") : null);
		}
		function jd(e, t, n) {
			var r = !n.ancestorInfo.containerTagInScope;
			if (n.context === WS || t.itemProp != null) return !r || t.itemProp == null || e !== "meta" && e !== "title" && e !== "style" && e !== "link" && e !== "script" || console.error("Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.", e, e), !1;
			switch (e) {
				case "meta":
				case "title": return !0;
				case "style":
					if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "") {
						r && console.error("Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel=\"stylesheet\" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence=\"default\"` and `href=\"some unique resource identifier\"`.");
						break;
					}
					return !0;
				case "link":
					if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError) {
						if (t.rel === "stylesheet" && typeof t.precedence == "string") {
							e = t.href;
							var i = t.onError, a = t.disabled;
							n = [], t.onLoad && n.push("`onLoad`"), i && n.push("`onError`"), a != null && n.push("`disabled`"), i = wu(n, "and"), i += n.length === 1 ? " prop" : " props", a = n.length === 1 ? "an " + i : "the " + i, n.length && console.error("React encountered a <link rel=\"stylesheet\" href=\"%s\" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.", e, a, i);
						}
						r && (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" ? console.error("Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag") : (t.onError || t.onLoad) && console.error("Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."));
						break;
					}
					switch (t.rel) {
						case "stylesheet": return e = t.precedence, t = t.disabled, typeof e != "string" && r && console.error("Cannot render a <link rel=\"stylesheet\" /> outside the main document without knowing its precedence. Consider adding precedence=\"default\" or moving it into the root <head> tag."), typeof e == "string" && t == null;
						default: return !0;
					}
				case "script":
					if (e = t.async && typeof t.async != "function" && typeof t.async != "symbol", !e || t.onLoad || t.onError || !t.src || typeof t.src != "string") {
						r && (e ? t.onLoad || t.onError ? console.error("Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>.") : console.error("Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>.") : console.error("Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async=\"\" or moving it into the root <head> tag."));
						break;
					}
					return !0;
				case "noscript":
				case "template": r && console.error("Cannot render <%s> outside the main document. Try moving it into the root <head> tag.", e);
			}
			return !1;
		}
		function Md(e) {
			return !(e.type === "stylesheet" && (e.state.loading & oC) === rC);
		}
		function Nd(e, t, n, r) {
			if (n.type === "stylesheet" && (typeof r.media != "string" || !1 !== matchMedia(r.media).matches) && (n.state.loading & sC) === rC) {
				if (n.instance === null) {
					var i = yd(r.href), a = t.querySelector(bd(i));
					if (a) {
						t = a._p, typeof t == "object" && t && typeof t.then == "function" && (e.count++, e = Fd.bind(e), t.then(e, e)), n.state.loading |= sC, n.instance = a, Re(a);
						return;
					}
					a = t.ownerDocument || t, r = xd(r), (i = cC.get(i)) && Dd(r, i), a = a.createElement("link"), Re(a);
					var o = a;
					o._p = new Promise(function(e, t) {
						o.onload = e, o.onerror = t;
					}), pu(a, "link", r), n.instance = a;
				}
				e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && (n.state.loading & oC) === rC && (e.count++, n = Fd.bind(e), t.addEventListener("load", n), t.addEventListener("error", n));
			}
		}
		function Pd(e, t) {
			return e.stylesheets && e.count === 0 && Id(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(n) {
				var r = setTimeout(function() {
					if (e.stylesheets && Id(e, e.stylesheets), e.unsuspend) {
						var t = e.unsuspend;
						e.unsuspend = null, t();
					}
				}, pC + t);
				0 < e.imgBytes && gC === 0 && (gC = 125 * Eu() * hC);
				var i = setTimeout(function() {
					if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && Id(e, e.stylesheets), e.unsuspend)) {
						var t = e.unsuspend;
						e.unsuspend = null, t();
					}
				}, (e.imgBytes > gC ? 50 : mC) + t);
				return e.unsuspend = n, function() {
					e.unsuspend = null, clearTimeout(r), clearTimeout(i);
				};
			} : null;
		}
		function Fd() {
			if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
				if (this.stylesheets) Id(this, this.stylesheets);
				else if (this.unsuspend) {
					var e = this.unsuspend;
					this.unsuspend = null, e();
				}
			}
		}
		function Id(e, t) {
			e.stylesheets = null, e.unsuspend !== null && (e.count++, vC = /* @__PURE__ */ new Map(), t.forEach(Ld, e), vC = null, Fd.call(e));
		}
		function Ld(e, t) {
			if (!(t.state.loading & sC)) {
				var n = vC.get(e);
				if (n) var r = n.get(_C);
				else {
					n = /* @__PURE__ */ new Map(), vC.set(e, n);
					for (var i = e.querySelectorAll("link[data-precedence],style[data-precedence]"), a = 0; a < i.length; a++) {
						var o = i[a];
						(o.nodeName === "LINK" || o.getAttribute("media") !== "not all") && (n.set(o.dataset.precedence, o), r = o);
					}
					r && n.set(_C, r);
				}
				i = t.instance, o = i.getAttribute("data-precedence"), a = n.get(o) || r, a === r && n.set(_C, i), n.set(o, i), this.count++, r = Fd.bind(this), i.addEventListener("load", r), i.addEventListener("error", r), a ? a.parentNode.insertBefore(i, a.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(i, e.firstChild)), t.state.loading |= sC;
			}
		}
		function Rd(e, t, n, r, i, a, o, s, c) {
			for (this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = $S, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Se(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Se(0), this.hiddenUpdates = Se(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c, this.incompleteTransitions = /* @__PURE__ */ new Map(), this.passiveEffectDuration = this.effectDuration = -0, this.memoizedUpdaters = /* @__PURE__ */ new Set(), e = this.pendingUpdatersLaneMap = [], t = 0; 31 > t; t++) e.push(/* @__PURE__ */ new Set());
			this._debugRootType = n ? "hydrateRoot()" : "createRoot()";
		}
		function zd(e, t, n, r, i, a, o, s, c, l, u, d) {
			return e = new Rd(e, t, n, o, c, l, u, d, s), t = Og, !0 === a && (t |= Ag | jg), t |= kg, a = p(3, null, null, t), e.current = a, a.stateNode = e, t = Ur(), Wr(t), e.pooledCache = t, Wr(t), a.memoizedState = {
				element: r,
				isDehydrated: n,
				cache: t
			}, Fi(a), e;
		}
		function Bd(e) {
			return e ? (e = wg, e) : wg;
		}
		function Vd(e, t, n, r, i, a) {
			if (bp && typeof bp.onScheduleFiberRoot == "function") try {
				bp.onScheduleFiberRoot(yp, r, n);
			} catch (e) {
				xp || (xp = !0, console.error("React instrumentation encountered an error: %o", e));
			}
			i = Bd(i), r.context === null ? r.context = i : r.pendingContext = i, ip && rp !== null && !EC && (EC = !0, console.error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", O(rp) || "Unknown")), r = Li(t), r.payload = { element: n }, a = a === void 0 ? null : a, a !== null && (typeof a != "function" && console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", a), r.callback = a), n = Ri(e, r, t), n !== null && (Kr(t, "root.render()", null), Vc(n, e, t), zi(n, e, t));
		}
		function Hd(e, t) {
			if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
				var n = e.retryLane;
				e.retryLane = n !== 0 && n < t ? n : t;
			}
		}
		function Ud(e, t) {
			Hd(e, t), (e = e.alternate) && Hd(e, t);
		}
		function Wd(e) {
			if (e.tag === 13 || e.tag === 31) {
				var t = Yn(e, 67108864);
				t !== null && Vc(t, e, 67108864), Ud(e, 67108864);
			}
		}
		function Gd(e) {
			if (e.tag === 13 || e.tag === 31) {
				var t = zc(e);
				t = U(t);
				var n = Yn(e, t);
				n !== null && Vc(n, e, t), Ud(e, t);
			}
		}
		function Kd() {
			return rp;
		}
		function qd(e, t, n, r) {
			var i = Q.T;
			Q.T = null;
			var a = If.p;
			try {
				If.p = kp, Yd(e, t, n, r);
			} finally {
				If.p = a, Q.T = i;
			}
		}
		function Jd(e, t, n, r) {
			var i = Q.T;
			Q.T = null;
			var a = If.p;
			try {
				If.p = Ap, Yd(e, t, n, r);
			} finally {
				If.p = a, Q.T = i;
			}
		}
		function Yd(e, t, n, r) {
			if (LC) {
				var i = Xd(r);
				if (i === null) $l(e, t, r, RC, n), $d(e, r);
				else if (tf(i, e, t, n, r)) r.stopPropagation();
				else if ($d(e, r), t & 4 && -1 < KC.indexOf(e)) {
					for (; i !== null;) {
						var a = Fe(i);
						if (a !== null) switch (a.tag) {
							case 3:
								if (a = a.stateNode, a.current.memoizedState.isDehydrated) {
									var o = _e(a.pendingLanes);
									if (o !== 0) {
										var s = a;
										for (s.pendingLanes |= 2, s.entangledLanes |= 2; o;) {
											var c = 1 << 31 - Cp(o);
											s.entanglements[1] |= c, o &= ~c;
										}
										Pl(a), (Vb & (Mb | Nb)) === jb && (yx = up() + bx, Fl(0, !1));
									}
								}
								break;
							case 31:
							case 13: s = Yn(a, 2), s !== null && Vc(s, a, 2), Kc(), Ud(a, 2);
						}
						if (a = Xd(r), a === null && $l(e, t, r, RC, n), a === i) break;
						i = a;
					}
					i !== null && r.stopPropagation();
				} else $l(e, t, r, null, n);
			}
		}
		function Xd(e) {
			return e = Wt(e), Zd(e);
		}
		function Zd(e) {
			if (RC = null, e = Pe(e), e !== null) {
				var t = y(e);
				if (t === null) e = null;
				else {
					var n = t.tag;
					if (n === 13) {
						if (e = b(t), e !== null) return e;
						e = null;
					} else if (n === 31) {
						if (e = x(t), e !== null) return e;
						e = null;
					} else if (n === 3) {
						if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
						e = null;
					} else t !== e && (e = null);
				}
			}
			return RC = e, null;
		}
		function Qd(e) {
			switch (e) {
				case "beforetoggle":
				case "cancel":
				case "click":
				case "close":
				case "contextmenu":
				case "copy":
				case "cut":
				case "auxclick":
				case "dblclick":
				case "dragend":
				case "dragstart":
				case "drop":
				case "focusin":
				case "focusout":
				case "input":
				case "invalid":
				case "keydown":
				case "keypress":
				case "keyup":
				case "mousedown":
				case "mouseup":
				case "paste":
				case "pause":
				case "play":
				case "pointercancel":
				case "pointerdown":
				case "pointerup":
				case "ratechange":
				case "reset":
				case "resize":
				case "seeked":
				case "submit":
				case "toggle":
				case "touchcancel":
				case "touchend":
				case "touchstart":
				case "volumechange":
				case "change":
				case "selectionchange":
				case "textInput":
				case "compositionstart":
				case "compositionend":
				case "compositionupdate":
				case "beforeblur":
				case "afterblur":
				case "beforeinput":
				case "blur":
				case "fullscreenchange":
				case "focus":
				case "hashchange":
				case "popstate":
				case "select":
				case "selectstart": return kp;
				case "drag":
				case "dragenter":
				case "dragexit":
				case "dragleave":
				case "dragover":
				case "mousemove":
				case "mouseout":
				case "mouseover":
				case "pointermove":
				case "pointerout":
				case "pointerover":
				case "scroll":
				case "touchmove":
				case "wheel":
				case "mouseenter":
				case "mouseleave":
				case "pointerenter":
				case "pointerleave": return Ap;
				case "message": switch (dp()) {
					case fp: return kp;
					case pp: return Ap;
					case mp:
					case hp: return jp;
					case gp: return Mp;
					default: return jp;
				}
				default: return jp;
			}
		}
		function $d(e, t) {
			switch (e) {
				case "focusin":
				case "focusout":
					BC = null;
					break;
				case "dragenter":
				case "dragleave":
					VC = null;
					break;
				case "mouseover":
				case "mouseout":
					HC = null;
					break;
				case "pointerover":
				case "pointerout":
					UC.delete(t.pointerId);
					break;
				case "gotpointercapture":
				case "lostpointercapture": WC.delete(t.pointerId);
			}
		}
		function ef(e, t, n, r, i, a) {
			return e === null || e.nativeEvent !== a ? (e = {
				blockedOn: t,
				domEventName: n,
				eventSystemFlags: r,
				nativeEvent: a,
				targetContainers: [i]
			}, t !== null && (t = Fe(t), t !== null && Wd(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
		}
		function tf(e, t, n, r, i) {
			switch (t) {
				case "focusin": return BC = ef(BC, e, t, n, r, i), !0;
				case "dragenter": return VC = ef(VC, e, t, n, r, i), !0;
				case "mouseover": return HC = ef(HC, e, t, n, r, i), !0;
				case "pointerover":
					var a = i.pointerId;
					return UC.set(a, ef(UC.get(a) || null, e, t, n, r, i)), !0;
				case "gotpointercapture": return a = i.pointerId, WC.set(a, ef(WC.get(a) || null, e, t, n, r, i)), !0;
			}
			return !1;
		}
		function nf(e) {
			var t = Pe(e.target);
			if (t !== null) {
				var n = y(t);
				if (n !== null) {
					if (t = n.tag, t === 13) {
						if (t = b(n), t !== null) {
							e.blockedOn = t, Me(e.priority, function() {
								Gd(n);
							});
							return;
						}
					} else if (t === 31) {
						if (t = x(n), t !== null) {
							e.blockedOn = t, Me(e.priority, function() {
								Gd(n);
							});
							return;
						}
					} else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
						e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
						return;
					}
				}
			}
			e.blockedOn = null;
		}
		function rf(e) {
			if (e.blockedOn !== null) return !1;
			for (var t = e.targetContainers; 0 < t.length;) {
				var n = Xd(e.nativeEvent);
				if (n === null) {
					n = e.nativeEvent;
					var r = new n.constructor(n.type, n), i = r;
					Rm !== null && console.error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Rm = i, n.target.dispatchEvent(r), Rm === null && console.error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Rm = null;
				} else return t = Fe(n), t !== null && Wd(t), e.blockedOn = n, !1;
				t.shift();
			}
			return !0;
		}
		function af(e, t, n) {
			rf(e) && n.delete(t);
		}
		function of() {
			zC = !1, BC !== null && rf(BC) && (BC = null), VC !== null && rf(VC) && (VC = null), HC !== null && rf(HC) && (HC = null), UC.forEach(af), WC.forEach(af);
		}
		function sf(e, t) {
			e.blockedOn === t && (e.blockedOn = null, zC || (zC = !0, mf.unstable_scheduleCallback(mf.unstable_NormalPriority, of)));
		}
		function cf(e) {
			qC !== e && (qC = e, mf.unstable_scheduleCallback(mf.unstable_NormalPriority, function() {
				qC === e && (qC = null);
				for (var t = 0; t < e.length; t += 3) {
					var n = e[t], r = e[t + 1], i = e[t + 2];
					if (typeof r != "function") {
						if (Zd(r || n) === null) continue;
						break;
					}
					var a = Fe(n);
					a !== null && (e.splice(t, 3), t -= 3, n = {
						pending: !0,
						data: i,
						method: n.method,
						action: r
					}, Object.freeze(n), vo(a, n, r, i));
				}
			}));
		}
		function lf(e) {
			function t(t) {
				return sf(t, e);
			}
			BC !== null && sf(BC, e), VC !== null && sf(VC, e), HC !== null && sf(HC, e), UC.forEach(t), WC.forEach(t);
			for (var n = 0; n < GC.length; n++) {
				var r = GC[n];
				r.blockedOn === e && (r.blockedOn = null);
			}
			for (; 0 < GC.length && (n = GC[0], n.blockedOn === null);) nf(n), n.blockedOn === null && GC.shift();
			if (n = (e.ownerDocument || e).$$reactFormReplay, n != null) for (r = 0; r < n.length; r += 3) {
				var i = n[r], a = n[r + 1], o = i[Fp] || null;
				if (typeof a == "function") o || cf(n);
				else if (o) {
					var s = null;
					if (a && a.hasAttribute("formAction")) {
						if (i = a, o = a[Fp] || null) s = o.formAction;
						else if (Zd(i) !== null) continue;
					} else s = o.action;
					typeof s == "function" ? n[r + 1] = s : (n.splice(r, 3), r -= 3), cf(n);
				}
			}
		}
		function uf() {
			function e(e) {
				e.canIntercept && e.info === "react-transition" && e.intercept({
					handler: function() {
						return new Promise(function(e) {
							return i = e;
						});
					},
					focusReset: "manual",
					scroll: "manual"
				});
			}
			function t() {
				i !== null && (i(), i = null), r || setTimeout(n, 20);
			}
			function n() {
				if (!r && !navigation.transition) {
					var e = navigation.currentEntry;
					e && e.url != null && navigation.navigate(e.url, {
						state: e.getState(),
						info: "react-transition",
						history: "replace"
					});
				}
			}
			if (typeof navigation == "object") {
				var r = !1, i = null;
				return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(n, 100), function() {
					r = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), i !== null && (i(), i = null);
				};
			}
		}
		function df(e) {
			this._internalRoot = e;
		}
		function ff(e) {
			this._internalRoot = e;
		}
		function pf(e) {
			e[Ip] && (e._reactRootContainer ? console.error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : console.error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var mf = qT(), hf = m(), gf = er(), _f = Object.assign, vf = Symbol.for("react.element"), yf = Symbol.for("react.transitional.element"), bf = Symbol.for("react.portal"), xf = Symbol.for("react.fragment"), Sf = Symbol.for("react.strict_mode"), Cf = Symbol.for("react.profiler"), wf = Symbol.for("react.consumer"), Tf = Symbol.for("react.context"), Ef = Symbol.for("react.forward_ref"), Df = Symbol.for("react.suspense"), Of = Symbol.for("react.suspense_list"), kf = Symbol.for("react.memo"), Af = Symbol.for("react.lazy"), jf = Symbol.for("react.activity"), Mf = Symbol.for("react.memo_cache_sentinel"), Nf = Symbol.iterator, Pf = Symbol.for("react.client.reference"), Ff = Array.isArray, Q = hf.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, If = gf.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Lf = Object.freeze({
			pending: !1,
			data: null,
			method: null,
			action: null
		}), Rf = [], zf = [], Bf = -1, Vf = k(null), Hf = k(null), Uf = k(null), Wf = k(null), Gf = 0, Kf, qf, Jf, Yf, Xf, Zf, Qf;
		ee.__reactDisabledLog = !0;
		var $f, ep, tp = !1, np = new (typeof WeakMap == "function" ? WeakMap : Map)(), rp = null, ip = !1, ap = Object.prototype.hasOwnProperty, op = mf.unstable_scheduleCallback, sp = mf.unstable_cancelCallback, cp = mf.unstable_shouldYield, lp = mf.unstable_requestPaint, up = mf.unstable_now, dp = mf.unstable_getCurrentPriorityLevel, fp = mf.unstable_ImmediatePriority, pp = mf.unstable_UserBlockingPriority, mp = mf.unstable_NormalPriority, hp = mf.unstable_LowPriority, gp = mf.unstable_IdlePriority, _p = mf.log, vp = mf.unstable_setDisableYieldValue, yp = null, bp = null, xp = !1, Sp = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u", Cp = Math.clz32 ? Math.clz32 : ge, wp = Math.log, Tp = Math.LN2, Ep = 256, Dp = 262144, Op = 4194304, kp = 2, Ap = 8, jp = 32, Mp = 268435456, Np = Math.random().toString(36).slice(2), Pp = "__reactFiber$" + Np, Fp = "__reactProps$" + Np, Ip = "__reactContainer$" + Np, Lp = "__reactEvents$" + Np, Rp = "__reactListeners$" + Np, zp = "__reactHandles$" + Np, Bp = "__reactResources$" + Np, Vp = "__reactMarker$" + Np, Hp = /* @__PURE__ */ new Set(), Up = {}, Wp = {}, Gp = {
			button: !0,
			checkbox: !0,
			image: !0,
			hidden: !0,
			radio: !0,
			reset: !0,
			submit: !0
		}, Kp = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), qp = {}, Jp = {}, Yp = /[\n"\\]/g, Xp = !1, Zp = !1, Qp = !1, $p = !1, em = !1, tm = !1, nm = ["value", "defaultValue"], rm = !1, im = /["'&<>\n\t]|^\s|\s$/, am = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(" "), om = "applet caption html table td th marquee object template foreignObject desc title".split(" "), sm = om.concat(["button"]), cm = "dd dt li option optgroup p rp rt".split(" "), lm = {
			current: null,
			formTag: null,
			aTagInScope: null,
			buttonTagInScope: null,
			nobrTagInScope: null,
			pTagInButtonScope: null,
			listItemTagAutoclosing: null,
			dlItemTagAutoclosing: null,
			containerTagInScope: null,
			implicitRootScope: !1
		}, um = {}, dm = {
			animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(" "),
			background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(" "),
			backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
			border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(" "),
			borderBlockEnd: [
				"borderBlockEndColor",
				"borderBlockEndStyle",
				"borderBlockEndWidth"
			],
			borderBlockStart: [
				"borderBlockStartColor",
				"borderBlockStartStyle",
				"borderBlockStartWidth"
			],
			borderBottom: [
				"borderBottomColor",
				"borderBottomStyle",
				"borderBottomWidth"
			],
			borderColor: [
				"borderBottomColor",
				"borderLeftColor",
				"borderRightColor",
				"borderTopColor"
			],
			borderImage: [
				"borderImageOutset",
				"borderImageRepeat",
				"borderImageSlice",
				"borderImageSource",
				"borderImageWidth"
			],
			borderInlineEnd: [
				"borderInlineEndColor",
				"borderInlineEndStyle",
				"borderInlineEndWidth"
			],
			borderInlineStart: [
				"borderInlineStartColor",
				"borderInlineStartStyle",
				"borderInlineStartWidth"
			],
			borderLeft: [
				"borderLeftColor",
				"borderLeftStyle",
				"borderLeftWidth"
			],
			borderRadius: [
				"borderBottomLeftRadius",
				"borderBottomRightRadius",
				"borderTopLeftRadius",
				"borderTopRightRadius"
			],
			borderRight: [
				"borderRightColor",
				"borderRightStyle",
				"borderRightWidth"
			],
			borderStyle: [
				"borderBottomStyle",
				"borderLeftStyle",
				"borderRightStyle",
				"borderTopStyle"
			],
			borderTop: [
				"borderTopColor",
				"borderTopStyle",
				"borderTopWidth"
			],
			borderWidth: [
				"borderBottomWidth",
				"borderLeftWidth",
				"borderRightWidth",
				"borderTopWidth"
			],
			columnRule: [
				"columnRuleColor",
				"columnRuleStyle",
				"columnRuleWidth"
			],
			columns: ["columnCount", "columnWidth"],
			flex: [
				"flexBasis",
				"flexGrow",
				"flexShrink"
			],
			flexFlow: ["flexDirection", "flexWrap"],
			font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(" "),
			fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(" "),
			gap: ["columnGap", "rowGap"],
			grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(" "),
			gridArea: [
				"gridColumnEnd",
				"gridColumnStart",
				"gridRowEnd",
				"gridRowStart"
			],
			gridColumn: ["gridColumnEnd", "gridColumnStart"],
			gridColumnGap: ["columnGap"],
			gridGap: ["columnGap", "rowGap"],
			gridRow: ["gridRowEnd", "gridRowStart"],
			gridRowGap: ["rowGap"],
			gridTemplate: [
				"gridTemplateAreas",
				"gridTemplateColumns",
				"gridTemplateRows"
			],
			listStyle: [
				"listStyleImage",
				"listStylePosition",
				"listStyleType"
			],
			margin: [
				"marginBottom",
				"marginLeft",
				"marginRight",
				"marginTop"
			],
			marker: [
				"markerEnd",
				"markerMid",
				"markerStart"
			],
			mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(" "),
			maskPosition: ["maskPositionX", "maskPositionY"],
			outline: [
				"outlineColor",
				"outlineStyle",
				"outlineWidth"
			],
			overflow: ["overflowX", "overflowY"],
			padding: [
				"paddingBottom",
				"paddingLeft",
				"paddingRight",
				"paddingTop"
			],
			placeContent: ["alignContent", "justifyContent"],
			placeItems: ["alignItems", "justifyItems"],
			placeSelf: ["alignSelf", "justifySelf"],
			textDecoration: [
				"textDecorationColor",
				"textDecorationLine",
				"textDecorationStyle"
			],
			textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
			transition: [
				"transitionDelay",
				"transitionDuration",
				"transitionProperty",
				"transitionTimingFunction"
			],
			wordWrap: ["overflowWrap"]
		}, fm = /([A-Z])/g, pm = /^ms-/, mm = /^(?:webkit|moz|o)[A-Z]/, hm = /^-ms-/, gm = /-(.)/g, _m = /;\s*$/, vm = {}, ym = {}, bm = !1, xm = !1, Sm = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), Cm = "http://www.w3.org/1998/Math/MathML", wm = "http://www.w3.org/2000/svg", Tm = new Map([
			["acceptCharset", "accept-charset"],
			["htmlFor", "for"],
			["httpEquiv", "http-equiv"],
			["crossOrigin", "crossorigin"],
			["accentHeight", "accent-height"],
			["alignmentBaseline", "alignment-baseline"],
			["arabicForm", "arabic-form"],
			["baselineShift", "baseline-shift"],
			["capHeight", "cap-height"],
			["clipPath", "clip-path"],
			["clipRule", "clip-rule"],
			["colorInterpolation", "color-interpolation"],
			["colorInterpolationFilters", "color-interpolation-filters"],
			["colorProfile", "color-profile"],
			["colorRendering", "color-rendering"],
			["dominantBaseline", "dominant-baseline"],
			["enableBackground", "enable-background"],
			["fillOpacity", "fill-opacity"],
			["fillRule", "fill-rule"],
			["floodColor", "flood-color"],
			["floodOpacity", "flood-opacity"],
			["fontFamily", "font-family"],
			["fontSize", "font-size"],
			["fontSizeAdjust", "font-size-adjust"],
			["fontStretch", "font-stretch"],
			["fontStyle", "font-style"],
			["fontVariant", "font-variant"],
			["fontWeight", "font-weight"],
			["glyphName", "glyph-name"],
			["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
			["glyphOrientationVertical", "glyph-orientation-vertical"],
			["horizAdvX", "horiz-adv-x"],
			["horizOriginX", "horiz-origin-x"],
			["imageRendering", "image-rendering"],
			["letterSpacing", "letter-spacing"],
			["lightingColor", "lighting-color"],
			["markerEnd", "marker-end"],
			["markerMid", "marker-mid"],
			["markerStart", "marker-start"],
			["overlinePosition", "overline-position"],
			["overlineThickness", "overline-thickness"],
			["paintOrder", "paint-order"],
			["panose-1", "panose-1"],
			["pointerEvents", "pointer-events"],
			["renderingIntent", "rendering-intent"],
			["shapeRendering", "shape-rendering"],
			["stopColor", "stop-color"],
			["stopOpacity", "stop-opacity"],
			["strikethroughPosition", "strikethrough-position"],
			["strikethroughThickness", "strikethrough-thickness"],
			["strokeDasharray", "stroke-dasharray"],
			["strokeDashoffset", "stroke-dashoffset"],
			["strokeLinecap", "stroke-linecap"],
			["strokeLinejoin", "stroke-linejoin"],
			["strokeMiterlimit", "stroke-miterlimit"],
			["strokeOpacity", "stroke-opacity"],
			["strokeWidth", "stroke-width"],
			["textAnchor", "text-anchor"],
			["textDecoration", "text-decoration"],
			["textRendering", "text-rendering"],
			["transformOrigin", "transform-origin"],
			["underlinePosition", "underline-position"],
			["underlineThickness", "underline-thickness"],
			["unicodeBidi", "unicode-bidi"],
			["unicodeRange", "unicode-range"],
			["unitsPerEm", "units-per-em"],
			["vAlphabetic", "v-alphabetic"],
			["vHanging", "v-hanging"],
			["vIdeographic", "v-ideographic"],
			["vMathematical", "v-mathematical"],
			["vectorEffect", "vector-effect"],
			["vertAdvY", "vert-adv-y"],
			["vertOriginX", "vert-origin-x"],
			["vertOriginY", "vert-origin-y"],
			["wordSpacing", "word-spacing"],
			["writingMode", "writing-mode"],
			["xmlnsXlink", "xmlns:xlink"],
			["xHeight", "x-height"]
		]), Em = {
			accept: "accept",
			acceptcharset: "acceptCharset",
			"accept-charset": "acceptCharset",
			accesskey: "accessKey",
			action: "action",
			allowfullscreen: "allowFullScreen",
			alt: "alt",
			as: "as",
			async: "async",
			autocapitalize: "autoCapitalize",
			autocomplete: "autoComplete",
			autocorrect: "autoCorrect",
			autofocus: "autoFocus",
			autoplay: "autoPlay",
			autosave: "autoSave",
			capture: "capture",
			cellpadding: "cellPadding",
			cellspacing: "cellSpacing",
			challenge: "challenge",
			charset: "charSet",
			checked: "checked",
			children: "children",
			cite: "cite",
			class: "className",
			classid: "classID",
			classname: "className",
			cols: "cols",
			colspan: "colSpan",
			content: "content",
			contenteditable: "contentEditable",
			contextmenu: "contextMenu",
			controls: "controls",
			controlslist: "controlsList",
			coords: "coords",
			crossorigin: "crossOrigin",
			dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
			data: "data",
			datetime: "dateTime",
			default: "default",
			defaultchecked: "defaultChecked",
			defaultvalue: "defaultValue",
			defer: "defer",
			dir: "dir",
			disabled: "disabled",
			disablepictureinpicture: "disablePictureInPicture",
			disableremoteplayback: "disableRemotePlayback",
			download: "download",
			draggable: "draggable",
			enctype: "encType",
			enterkeyhint: "enterKeyHint",
			fetchpriority: "fetchPriority",
			for: "htmlFor",
			form: "form",
			formmethod: "formMethod",
			formaction: "formAction",
			formenctype: "formEncType",
			formnovalidate: "formNoValidate",
			formtarget: "formTarget",
			frameborder: "frameBorder",
			headers: "headers",
			height: "height",
			hidden: "hidden",
			high: "high",
			href: "href",
			hreflang: "hrefLang",
			htmlfor: "htmlFor",
			httpequiv: "httpEquiv",
			"http-equiv": "httpEquiv",
			icon: "icon",
			id: "id",
			imagesizes: "imageSizes",
			imagesrcset: "imageSrcSet",
			inert: "inert",
			innerhtml: "innerHTML",
			inputmode: "inputMode",
			integrity: "integrity",
			is: "is",
			itemid: "itemID",
			itemprop: "itemProp",
			itemref: "itemRef",
			itemscope: "itemScope",
			itemtype: "itemType",
			keyparams: "keyParams",
			keytype: "keyType",
			kind: "kind",
			label: "label",
			lang: "lang",
			list: "list",
			loop: "loop",
			low: "low",
			manifest: "manifest",
			marginwidth: "marginWidth",
			marginheight: "marginHeight",
			max: "max",
			maxlength: "maxLength",
			media: "media",
			mediagroup: "mediaGroup",
			method: "method",
			min: "min",
			minlength: "minLength",
			multiple: "multiple",
			muted: "muted",
			name: "name",
			nomodule: "noModule",
			nonce: "nonce",
			novalidate: "noValidate",
			open: "open",
			optimum: "optimum",
			pattern: "pattern",
			placeholder: "placeholder",
			playsinline: "playsInline",
			poster: "poster",
			preload: "preload",
			profile: "profile",
			radiogroup: "radioGroup",
			readonly: "readOnly",
			referrerpolicy: "referrerPolicy",
			rel: "rel",
			required: "required",
			reversed: "reversed",
			role: "role",
			rows: "rows",
			rowspan: "rowSpan",
			sandbox: "sandbox",
			scope: "scope",
			scoped: "scoped",
			scrolling: "scrolling",
			seamless: "seamless",
			selected: "selected",
			shape: "shape",
			size: "size",
			sizes: "sizes",
			span: "span",
			spellcheck: "spellCheck",
			src: "src",
			srcdoc: "srcDoc",
			srclang: "srcLang",
			srcset: "srcSet",
			start: "start",
			step: "step",
			style: "style",
			summary: "summary",
			tabindex: "tabIndex",
			target: "target",
			title: "title",
			type: "type",
			usemap: "useMap",
			value: "value",
			width: "width",
			wmode: "wmode",
			wrap: "wrap",
			about: "about",
			accentheight: "accentHeight",
			"accent-height": "accentHeight",
			accumulate: "accumulate",
			additive: "additive",
			alignmentbaseline: "alignmentBaseline",
			"alignment-baseline": "alignmentBaseline",
			allowreorder: "allowReorder",
			alphabetic: "alphabetic",
			amplitude: "amplitude",
			arabicform: "arabicForm",
			"arabic-form": "arabicForm",
			ascent: "ascent",
			attributename: "attributeName",
			attributetype: "attributeType",
			autoreverse: "autoReverse",
			azimuth: "azimuth",
			basefrequency: "baseFrequency",
			baselineshift: "baselineShift",
			"baseline-shift": "baselineShift",
			baseprofile: "baseProfile",
			bbox: "bbox",
			begin: "begin",
			bias: "bias",
			by: "by",
			calcmode: "calcMode",
			capheight: "capHeight",
			"cap-height": "capHeight",
			clip: "clip",
			clippath: "clipPath",
			"clip-path": "clipPath",
			clippathunits: "clipPathUnits",
			cliprule: "clipRule",
			"clip-rule": "clipRule",
			color: "color",
			colorinterpolation: "colorInterpolation",
			"color-interpolation": "colorInterpolation",
			colorinterpolationfilters: "colorInterpolationFilters",
			"color-interpolation-filters": "colorInterpolationFilters",
			colorprofile: "colorProfile",
			"color-profile": "colorProfile",
			colorrendering: "colorRendering",
			"color-rendering": "colorRendering",
			contentscripttype: "contentScriptType",
			contentstyletype: "contentStyleType",
			cursor: "cursor",
			cx: "cx",
			cy: "cy",
			d: "d",
			datatype: "datatype",
			decelerate: "decelerate",
			descent: "descent",
			diffuseconstant: "diffuseConstant",
			direction: "direction",
			display: "display",
			divisor: "divisor",
			dominantbaseline: "dominantBaseline",
			"dominant-baseline": "dominantBaseline",
			dur: "dur",
			dx: "dx",
			dy: "dy",
			edgemode: "edgeMode",
			elevation: "elevation",
			enablebackground: "enableBackground",
			"enable-background": "enableBackground",
			end: "end",
			exponent: "exponent",
			externalresourcesrequired: "externalResourcesRequired",
			fill: "fill",
			fillopacity: "fillOpacity",
			"fill-opacity": "fillOpacity",
			fillrule: "fillRule",
			"fill-rule": "fillRule",
			filter: "filter",
			filterres: "filterRes",
			filterunits: "filterUnits",
			floodopacity: "floodOpacity",
			"flood-opacity": "floodOpacity",
			floodcolor: "floodColor",
			"flood-color": "floodColor",
			focusable: "focusable",
			fontfamily: "fontFamily",
			"font-family": "fontFamily",
			fontsize: "fontSize",
			"font-size": "fontSize",
			fontsizeadjust: "fontSizeAdjust",
			"font-size-adjust": "fontSizeAdjust",
			fontstretch: "fontStretch",
			"font-stretch": "fontStretch",
			fontstyle: "fontStyle",
			"font-style": "fontStyle",
			fontvariant: "fontVariant",
			"font-variant": "fontVariant",
			fontweight: "fontWeight",
			"font-weight": "fontWeight",
			format: "format",
			from: "from",
			fx: "fx",
			fy: "fy",
			g1: "g1",
			g2: "g2",
			glyphname: "glyphName",
			"glyph-name": "glyphName",
			glyphorientationhorizontal: "glyphOrientationHorizontal",
			"glyph-orientation-horizontal": "glyphOrientationHorizontal",
			glyphorientationvertical: "glyphOrientationVertical",
			"glyph-orientation-vertical": "glyphOrientationVertical",
			glyphref: "glyphRef",
			gradienttransform: "gradientTransform",
			gradientunits: "gradientUnits",
			hanging: "hanging",
			horizadvx: "horizAdvX",
			"horiz-adv-x": "horizAdvX",
			horizoriginx: "horizOriginX",
			"horiz-origin-x": "horizOriginX",
			ideographic: "ideographic",
			imagerendering: "imageRendering",
			"image-rendering": "imageRendering",
			in2: "in2",
			in: "in",
			inlist: "inlist",
			intercept: "intercept",
			k1: "k1",
			k2: "k2",
			k3: "k3",
			k4: "k4",
			k: "k",
			kernelmatrix: "kernelMatrix",
			kernelunitlength: "kernelUnitLength",
			kerning: "kerning",
			keypoints: "keyPoints",
			keysplines: "keySplines",
			keytimes: "keyTimes",
			lengthadjust: "lengthAdjust",
			letterspacing: "letterSpacing",
			"letter-spacing": "letterSpacing",
			lightingcolor: "lightingColor",
			"lighting-color": "lightingColor",
			limitingconeangle: "limitingConeAngle",
			local: "local",
			markerend: "markerEnd",
			"marker-end": "markerEnd",
			markerheight: "markerHeight",
			markermid: "markerMid",
			"marker-mid": "markerMid",
			markerstart: "markerStart",
			"marker-start": "markerStart",
			markerunits: "markerUnits",
			markerwidth: "markerWidth",
			mask: "mask",
			maskcontentunits: "maskContentUnits",
			maskunits: "maskUnits",
			mathematical: "mathematical",
			mode: "mode",
			numoctaves: "numOctaves",
			offset: "offset",
			opacity: "opacity",
			operator: "operator",
			order: "order",
			orient: "orient",
			orientation: "orientation",
			origin: "origin",
			overflow: "overflow",
			overlineposition: "overlinePosition",
			"overline-position": "overlinePosition",
			overlinethickness: "overlineThickness",
			"overline-thickness": "overlineThickness",
			paintorder: "paintOrder",
			"paint-order": "paintOrder",
			panose1: "panose1",
			"panose-1": "panose1",
			pathlength: "pathLength",
			patterncontentunits: "patternContentUnits",
			patterntransform: "patternTransform",
			patternunits: "patternUnits",
			pointerevents: "pointerEvents",
			"pointer-events": "pointerEvents",
			points: "points",
			pointsatx: "pointsAtX",
			pointsaty: "pointsAtY",
			pointsatz: "pointsAtZ",
			popover: "popover",
			popovertarget: "popoverTarget",
			popovertargetaction: "popoverTargetAction",
			prefix: "prefix",
			preservealpha: "preserveAlpha",
			preserveaspectratio: "preserveAspectRatio",
			primitiveunits: "primitiveUnits",
			property: "property",
			r: "r",
			radius: "radius",
			refx: "refX",
			refy: "refY",
			renderingintent: "renderingIntent",
			"rendering-intent": "renderingIntent",
			repeatcount: "repeatCount",
			repeatdur: "repeatDur",
			requiredextensions: "requiredExtensions",
			requiredfeatures: "requiredFeatures",
			resource: "resource",
			restart: "restart",
			result: "result",
			results: "results",
			rotate: "rotate",
			rx: "rx",
			ry: "ry",
			scale: "scale",
			security: "security",
			seed: "seed",
			shaperendering: "shapeRendering",
			"shape-rendering": "shapeRendering",
			slope: "slope",
			spacing: "spacing",
			specularconstant: "specularConstant",
			specularexponent: "specularExponent",
			speed: "speed",
			spreadmethod: "spreadMethod",
			startoffset: "startOffset",
			stddeviation: "stdDeviation",
			stemh: "stemh",
			stemv: "stemv",
			stitchtiles: "stitchTiles",
			stopcolor: "stopColor",
			"stop-color": "stopColor",
			stopopacity: "stopOpacity",
			"stop-opacity": "stopOpacity",
			strikethroughposition: "strikethroughPosition",
			"strikethrough-position": "strikethroughPosition",
			strikethroughthickness: "strikethroughThickness",
			"strikethrough-thickness": "strikethroughThickness",
			string: "string",
			stroke: "stroke",
			strokedasharray: "strokeDasharray",
			"stroke-dasharray": "strokeDasharray",
			strokedashoffset: "strokeDashoffset",
			"stroke-dashoffset": "strokeDashoffset",
			strokelinecap: "strokeLinecap",
			"stroke-linecap": "strokeLinecap",
			strokelinejoin: "strokeLinejoin",
			"stroke-linejoin": "strokeLinejoin",
			strokemiterlimit: "strokeMiterlimit",
			"stroke-miterlimit": "strokeMiterlimit",
			strokewidth: "strokeWidth",
			"stroke-width": "strokeWidth",
			strokeopacity: "strokeOpacity",
			"stroke-opacity": "strokeOpacity",
			suppresscontenteditablewarning: "suppressContentEditableWarning",
			suppresshydrationwarning: "suppressHydrationWarning",
			surfacescale: "surfaceScale",
			systemlanguage: "systemLanguage",
			tablevalues: "tableValues",
			targetx: "targetX",
			targety: "targetY",
			textanchor: "textAnchor",
			"text-anchor": "textAnchor",
			textdecoration: "textDecoration",
			"text-decoration": "textDecoration",
			textlength: "textLength",
			textrendering: "textRendering",
			"text-rendering": "textRendering",
			to: "to",
			transform: "transform",
			transformorigin: "transformOrigin",
			"transform-origin": "transformOrigin",
			typeof: "typeof",
			u1: "u1",
			u2: "u2",
			underlineposition: "underlinePosition",
			"underline-position": "underlinePosition",
			underlinethickness: "underlineThickness",
			"underline-thickness": "underlineThickness",
			unicode: "unicode",
			unicodebidi: "unicodeBidi",
			"unicode-bidi": "unicodeBidi",
			unicoderange: "unicodeRange",
			"unicode-range": "unicodeRange",
			unitsperem: "unitsPerEm",
			"units-per-em": "unitsPerEm",
			unselectable: "unselectable",
			valphabetic: "vAlphabetic",
			"v-alphabetic": "vAlphabetic",
			values: "values",
			vectoreffect: "vectorEffect",
			"vector-effect": "vectorEffect",
			version: "version",
			vertadvy: "vertAdvY",
			"vert-adv-y": "vertAdvY",
			vertoriginx: "vertOriginX",
			"vert-origin-x": "vertOriginX",
			vertoriginy: "vertOriginY",
			"vert-origin-y": "vertOriginY",
			vhanging: "vHanging",
			"v-hanging": "vHanging",
			videographic: "vIdeographic",
			"v-ideographic": "vIdeographic",
			viewbox: "viewBox",
			viewtarget: "viewTarget",
			visibility: "visibility",
			vmathematical: "vMathematical",
			"v-mathematical": "vMathematical",
			vocab: "vocab",
			widths: "widths",
			wordspacing: "wordSpacing",
			"word-spacing": "wordSpacing",
			writingmode: "writingMode",
			"writing-mode": "writingMode",
			x1: "x1",
			x2: "x2",
			x: "x",
			xchannelselector: "xChannelSelector",
			xheight: "xHeight",
			"x-height": "xHeight",
			xlinkactuate: "xlinkActuate",
			"xlink:actuate": "xlinkActuate",
			xlinkarcrole: "xlinkArcrole",
			"xlink:arcrole": "xlinkArcrole",
			xlinkhref: "xlinkHref",
			"xlink:href": "xlinkHref",
			xlinkrole: "xlinkRole",
			"xlink:role": "xlinkRole",
			xlinkshow: "xlinkShow",
			"xlink:show": "xlinkShow",
			xlinktitle: "xlinkTitle",
			"xlink:title": "xlinkTitle",
			xlinktype: "xlinkType",
			"xlink:type": "xlinkType",
			xmlbase: "xmlBase",
			"xml:base": "xmlBase",
			xmllang: "xmlLang",
			"xml:lang": "xmlLang",
			xmlns: "xmlns",
			"xml:space": "xmlSpace",
			xmlnsxlink: "xmlnsXlink",
			"xmlns:xlink": "xmlnsXlink",
			xmlspace: "xmlSpace",
			y1: "y1",
			y2: "y2",
			y: "y",
			ychannelselector: "yChannelSelector",
			z: "z",
			zoomandpan: "zoomAndPan"
		}, Dm = {
			"aria-current": 0,
			"aria-description": 0,
			"aria-details": 0,
			"aria-disabled": 0,
			"aria-hidden": 0,
			"aria-invalid": 0,
			"aria-keyshortcuts": 0,
			"aria-label": 0,
			"aria-roledescription": 0,
			"aria-autocomplete": 0,
			"aria-checked": 0,
			"aria-expanded": 0,
			"aria-haspopup": 0,
			"aria-level": 0,
			"aria-modal": 0,
			"aria-multiline": 0,
			"aria-multiselectable": 0,
			"aria-orientation": 0,
			"aria-placeholder": 0,
			"aria-pressed": 0,
			"aria-readonly": 0,
			"aria-required": 0,
			"aria-selected": 0,
			"aria-sort": 0,
			"aria-valuemax": 0,
			"aria-valuemin": 0,
			"aria-valuenow": 0,
			"aria-valuetext": 0,
			"aria-atomic": 0,
			"aria-busy": 0,
			"aria-live": 0,
			"aria-relevant": 0,
			"aria-dropeffect": 0,
			"aria-grabbed": 0,
			"aria-activedescendant": 0,
			"aria-colcount": 0,
			"aria-colindex": 0,
			"aria-colspan": 0,
			"aria-controls": 0,
			"aria-describedby": 0,
			"aria-errormessage": 0,
			"aria-flowto": 0,
			"aria-labelledby": 0,
			"aria-owns": 0,
			"aria-posinset": 0,
			"aria-rowcount": 0,
			"aria-rowindex": 0,
			"aria-rowspan": 0,
			"aria-setsize": 0,
			"aria-braillelabel": 0,
			"aria-brailleroledescription": 0,
			"aria-colindextext": 0,
			"aria-rowindextext": 0
		}, Om = {}, km = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), Am = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), jm = !1, Mm = {}, Nm = /^on./, Pm = /^on[^A-Z]/, Fm = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), Im = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), Lm = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, Rm = null, zm = null, Bm = null, Vm = !1, Hm = !(typeof window > "u" || window.document === void 0 || window.document.createElement === void 0), Um = !1;
		if (Hm) try {
			var Wm = {};
			Object.defineProperty(Wm, "passive", { get: function() {
				Um = !0;
			} }), window.addEventListener("test", Wm, Wm), window.removeEventListener("test", Wm, Wm);
		} catch {
			Um = !1;
		}
		var Gm = null, Km = null, qm = null, Jm = {
			eventPhase: 0,
			bubbles: 0,
			cancelable: 0,
			timeStamp: function(e) {
				return e.timeStamp || Date.now();
			},
			defaultPrevented: 0,
			isTrusted: 0
		}, Ym = Qt(Jm), Xm = _f({}, Jm, {
			view: 0,
			detail: 0
		}), Zm = Qt(Xm), Qm, $m, eh, th = _f({}, Xm, {
			screenX: 0,
			screenY: 0,
			clientX: 0,
			clientY: 0,
			pageX: 0,
			pageY: 0,
			ctrlKey: 0,
			shiftKey: 0,
			altKey: 0,
			metaKey: 0,
			getModifierState: en,
			button: 0,
			buttons: 0,
			relatedTarget: function(e) {
				return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
			},
			movementX: function(e) {
				return "movementX" in e ? e.movementX : (e !== eh && (eh && e.type === "mousemove" ? (Qm = e.screenX - eh.screenX, $m = e.screenY - eh.screenY) : $m = Qm = 0, eh = e), Qm);
			},
			movementY: function(e) {
				return "movementY" in e ? e.movementY : $m;
			}
		}), nh = Qt(th), rh = Qt(_f({}, th, { dataTransfer: 0 })), ih = Qt(_f({}, Xm, { relatedTarget: 0 })), ah = Qt(_f({}, Jm, {
			animationName: 0,
			elapsedTime: 0,
			pseudoElement: 0
		})), oh = Qt(_f({}, Jm, { clipboardData: function(e) {
			return "clipboardData" in e ? e.clipboardData : window.clipboardData;
		} })), sh = Qt(_f({}, Jm, { data: 0 })), ch = sh, lh = {
			Esc: "Escape",
			Spacebar: " ",
			Left: "ArrowLeft",
			Up: "ArrowUp",
			Right: "ArrowRight",
			Down: "ArrowDown",
			Del: "Delete",
			Win: "OS",
			Menu: "ContextMenu",
			Apps: "ContextMenu",
			Scroll: "ScrollLock",
			MozPrintableKey: "Unidentified"
		}, uh = {
			8: "Backspace",
			9: "Tab",
			12: "Clear",
			13: "Enter",
			16: "Shift",
			17: "Control",
			18: "Alt",
			19: "Pause",
			20: "CapsLock",
			27: "Escape",
			32: " ",
			33: "PageUp",
			34: "PageDown",
			35: "End",
			36: "Home",
			37: "ArrowLeft",
			38: "ArrowUp",
			39: "ArrowRight",
			40: "ArrowDown",
			45: "Insert",
			46: "Delete",
			112: "F1",
			113: "F2",
			114: "F3",
			115: "F4",
			116: "F5",
			117: "F6",
			118: "F7",
			119: "F8",
			120: "F9",
			121: "F10",
			122: "F11",
			123: "F12",
			144: "NumLock",
			145: "ScrollLock",
			224: "Meta"
		}, dh = {
			Alt: "altKey",
			Control: "ctrlKey",
			Meta: "metaKey",
			Shift: "shiftKey"
		}, fh = Qt(_f({}, Xm, {
			key: function(e) {
				if (e.key) {
					var t = lh[e.key] || e.key;
					if (t !== "Unidentified") return t;
				}
				return e.type === "keypress" ? (e = Yt(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? uh[e.keyCode] || "Unidentified" : "";
			},
			code: 0,
			location: 0,
			ctrlKey: 0,
			shiftKey: 0,
			altKey: 0,
			metaKey: 0,
			repeat: 0,
			locale: 0,
			getModifierState: en,
			charCode: function(e) {
				return e.type === "keypress" ? Yt(e) : 0;
			},
			keyCode: function(e) {
				return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
			},
			which: function(e) {
				return e.type === "keypress" ? Yt(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
			}
		})), ph = Qt(_f({}, th, {
			pointerId: 0,
			width: 0,
			height: 0,
			pressure: 0,
			tangentialPressure: 0,
			tiltX: 0,
			tiltY: 0,
			twist: 0,
			pointerType: 0,
			isPrimary: 0
		})), mh = Qt(_f({}, Xm, {
			touches: 0,
			targetTouches: 0,
			changedTouches: 0,
			altKey: 0,
			metaKey: 0,
			ctrlKey: 0,
			shiftKey: 0,
			getModifierState: en
		})), hh = Qt(_f({}, Jm, {
			propertyName: 0,
			elapsedTime: 0,
			pseudoElement: 0
		})), gh = Qt(_f({}, th, {
			deltaX: function(e) {
				return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
			},
			deltaY: function(e) {
				return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
			},
			deltaZ: 0,
			deltaMode: 0
		})), _h = Qt(_f({}, Jm, {
			newState: 0,
			oldState: 0
		})), vh = [
			9,
			13,
			27,
			32
		], yh = 229, bh = Hm && "CompositionEvent" in window, xh = null;
		Hm && "documentMode" in document && (xh = document.documentMode);
		var Sh = Hm && "TextEvent" in window && !xh, Ch = Hm && (!bh || xh && 8 < xh && 11 >= xh), wh = 32, Th = String.fromCharCode(wh), Eh = !1, Dh = !1, Oh = {
			color: !0,
			date: !0,
			datetime: !0,
			"datetime-local": !0,
			email: !0,
			month: !0,
			number: !0,
			password: !0,
			range: !0,
			search: !0,
			tel: !0,
			text: !0,
			time: !0,
			url: !0,
			week: !0
		}, kh = null, Ah = null, jh = !1;
		Hm && (jh = sn("input") && (!document.documentMode || 9 < document.documentMode));
		var Mh = typeof Object.is == "function" ? Object.is : K, Nh = Hm && "documentMode" in document && 11 >= document.documentMode, Ph = null, Fh = null, Ih = null, Lh = !1, Rh = {
			animationend: Tn("Animation", "AnimationEnd"),
			animationiteration: Tn("Animation", "AnimationIteration"),
			animationstart: Tn("Animation", "AnimationStart"),
			transitionrun: Tn("Transition", "TransitionRun"),
			transitionstart: Tn("Transition", "TransitionStart"),
			transitioncancel: Tn("Transition", "TransitionCancel"),
			transitionend: Tn("Transition", "TransitionEnd")
		}, zh = {}, Bh = {};
		Hm && (Bh = document.createElement("div").style, "AnimationEvent" in window || (delete Rh.animationend.animation, delete Rh.animationiteration.animation, delete Rh.animationstart.animation), "TransitionEvent" in window || delete Rh.transitionend.transition);
		var Vh = En("animationend"), Hh = En("animationiteration"), Uh = En("animationstart"), Wh = En("transitionrun"), Gh = En("transitionstart"), Kh = En("transitioncancel"), qh = En("transitionend"), Jh = /* @__PURE__ */ new Map(), Yh = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
		Yh.push("scrollEnd");
		var Xh = 0;
		if (typeof performance == "object" && typeof performance.now == "function") var Zh = performance, Qh = function() {
			return Zh.now();
		};
		else {
			var $h = Date;
			Qh = function() {
				return $h.now();
			};
		}
		var eg = typeof reportError == "function" ? reportError : function(e) {
			if (typeof window == "object" && typeof window.ErrorEvent == "function") {
				var t = new window.ErrorEvent("error", {
					bubbles: !0,
					cancelable: !0,
					message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
					error: e
				});
				if (!window.dispatchEvent(t)) return;
			} else if (typeof process == "object" && typeof process.emit == "function") {
				process.emit("uncaughtException", e);
				return;
			}
			console.error(e);
		}, tg = "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects.", ng = 0, rg = 1, ig = 2, ag = 3, og = "–\xA0", sg = "+\xA0", cg = " \xA0", lg = typeof console < "u" && typeof console.timeStamp == "function" && typeof performance < "u" && typeof performance.measure == "function", ug = "Components ⚛", dg = "Scheduler ⚛", fg = "Blocking", pg = !1, mg = {
			color: "primary",
			properties: null,
			tooltipText: "",
			track: ug
		}, hg = {
			start: -0,
			end: -0,
			detail: { devtools: mg }
		}, gg = ["Changed Props", ""], _g = "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner.", vg = ["Changed Props", _g], yg = 1, bg = 2, xg = [], Sg = 0, Cg = 0, wg = {};
		Object.freeze(wg);
		var Tg = null, Eg = null, Dg = 0, Og = 1, kg = 2, Ag = 8, jg = 16, Mg = 32, Ng = !1;
		try {
			var Pg = Object.preventExtensions({});
			new Map([[Pg, null]]), new Set([Pg]);
		} catch {
			Ng = !0;
		}
		var Fg = /* @__PURE__ */ new WeakMap(), Ig = [], Lg = 0, Rg = null, zg = 0, Bg = [], Vg = 0, Hg = null, Ug = 1, Wg = "", Gg = null, Kg = null, qg = !1, Jg = !1, Yg = null, Xg = null, Zg = !1, Qg = Error("Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), $g = k(null), e_ = k(null), t_ = {}, n_ = null, r_ = null, i_ = !1, a_ = typeof AbortController < "u" ? AbortController : function() {
			var e = [], t = this.signal = {
				aborted: !1,
				addEventListener: function(t, n) {
					e.push(n);
				}
			};
			this.abort = function() {
				t.aborted = !0, e.forEach(function(e) {
					return e();
				});
			};
		}, o_ = mf.unstable_scheduleCallback, s_ = mf.unstable_NormalPriority, c_ = {
			$$typeof: Tf,
			Consumer: null,
			Provider: null,
			_currentValue: null,
			_currentValue2: null,
			_threadCount: 0,
			_currentRenderer: null,
			_currentRenderer2: null
		}, l_ = mf.unstable_now, u_ = console.createTask ? console.createTask : function() {
			return null;
		}, d_ = 1, f_ = 2, p_ = -0, m_ = -0, h_ = -0, g_ = null, __ = -1.1, v_ = -0, y_ = -0, b_ = -1.1, x_ = -1.1, S_ = null, C_ = !1, w_ = -0, T_ = -1.1, E_ = null, D_ = 0, O_ = null, k_ = null, A_ = -1.1, j_ = null, M_ = -1.1, N_ = -1.1, P_ = -0, F_ = -1.1, I_ = -1.1, L_ = 0, R_ = null, z_ = null, B_ = null, V_ = -1.1, H_ = null, U_ = -1.1, W_ = -1.1, G_ = -0, K_ = -0, q_ = 0, J_ = null, Y_ = 0, X_ = -1.1, Z_ = !1, Q_ = !1, $_ = null, ev = 0, tv = 0, nv = null, rv = Q.S;
		Q.S = function(e, t) {
			if (_x = up(), typeof t == "object" && t && typeof t.then == "function") {
				if (0 > F_ && 0 > I_) {
					F_ = l_();
					var n = Nu(), r = Mu();
					(n !== U_ || r !== H_) && (U_ = -1.1), V_ = n, H_ = r;
				}
				ui(e, t);
			}
			rv !== null && rv(e, t);
		};
		var iv = k(null), av = {
			recordUnsafeLifecycleWarnings: function() {},
			flushPendingUnsafeLifecycleWarnings: function() {},
			recordLegacyContextWarning: function() {},
			flushLegacyContextWarning: function() {},
			discardPendingWarnings: function() {}
		}, ov = [], sv = [], cv = [], lv = [], uv = [], dv = [], fv = /* @__PURE__ */ new Set();
		av.recordUnsafeLifecycleWarnings = function(e, t) {
			fv.has(e.type) || (typeof t.componentWillMount == "function" && !0 !== t.componentWillMount.__suppressDeprecationWarning && ov.push(e), e.mode & Ag && typeof t.UNSAFE_componentWillMount == "function" && sv.push(e), typeof t.componentWillReceiveProps == "function" && !0 !== t.componentWillReceiveProps.__suppressDeprecationWarning && cv.push(e), e.mode & Ag && typeof t.UNSAFE_componentWillReceiveProps == "function" && lv.push(e), typeof t.componentWillUpdate == "function" && !0 !== t.componentWillUpdate.__suppressDeprecationWarning && uv.push(e), e.mode & Ag && typeof t.UNSAFE_componentWillUpdate == "function" && dv.push(e));
		}, av.flushPendingUnsafeLifecycleWarnings = function() {
			var e = /* @__PURE__ */ new Set();
			0 < ov.length && (ov.forEach(function(t) {
				e.add(O(t) || "Component"), fv.add(t.type);
			}), ov = []);
			var t = /* @__PURE__ */ new Set();
			0 < sv.length && (sv.forEach(function(e) {
				t.add(O(e) || "Component"), fv.add(e.type);
			}), sv = []);
			var n = /* @__PURE__ */ new Set();
			0 < cv.length && (cv.forEach(function(e) {
				n.add(O(e) || "Component"), fv.add(e.type);
			}), cv = []);
			var r = /* @__PURE__ */ new Set();
			0 < lv.length && (lv.forEach(function(e) {
				r.add(O(e) || "Component"), fv.add(e.type);
			}), lv = []);
			var i = /* @__PURE__ */ new Set();
			0 < uv.length && (uv.forEach(function(e) {
				i.add(O(e) || "Component"), fv.add(e.type);
			}), uv = []);
			var a = /* @__PURE__ */ new Set();
			if (0 < dv.length && (dv.forEach(function(e) {
				a.add(O(e) || "Component"), fv.add(e.type);
			}), dv = []), 0 < t.size) {
				var o = f(t);
				console.error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", o);
			}
			0 < r.size && (o = f(r), console.error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n\nPlease update the following components: %s", o)), 0 < a.size && (o = f(a), console.error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", o)), 0 < e.size && (o = f(e), console.warn("componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", o)), 0 < n.size && (o = f(n), console.warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", o)), 0 < i.size && (o = f(i), console.warn("componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", o));
		};
		var pv = /* @__PURE__ */ new Map(), mv = /* @__PURE__ */ new Set();
		av.recordLegacyContextWarning = function(e, t) {
			for (var n = null, r = e; r !== null;) r.mode & Ag && (n = r), r = r.return;
			n === null ? console.error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.") : !mv.has(e.type) && (r = pv.get(n), e.type.contextTypes != null || e.type.childContextTypes != null || t !== null && typeof t.getChildContext == "function") && (r === void 0 && (r = [], pv.set(n, r)), r.push(e));
		}, av.flushLegacyContextWarning = function() {
			pv.forEach(function(e) {
				if (e.length !== 0) {
					var t = e[0], n = /* @__PURE__ */ new Set();
					e.forEach(function(e) {
						n.add(O(e) || "Component"), mv.add(e.type);
					});
					var r = f(n);
					H(t, function() {
						console.error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://react.dev/link/legacy-context", r);
					});
				}
			});
		}, av.discardPendingWarnings = function() {
			ov = [], sv = [], cv = [], lv = [], uv = [], dv = [], pv = /* @__PURE__ */ new Map();
		};
		var hv = { react_stack_bottom_frame: function(e, t, n) {
			var r = ip;
			ip = !0;
			try {
				return e(t, n);
			} finally {
				ip = r;
			}
		} }, gv = hv.react_stack_bottom_frame.bind(hv), _v = { react_stack_bottom_frame: function(e) {
			var t = ip;
			ip = !0;
			try {
				return e.render();
			} finally {
				ip = t;
			}
		} }, vv = _v.react_stack_bottom_frame.bind(_v), yv = { react_stack_bottom_frame: function(e, t) {
			try {
				t.componentDidMount();
			} catch (t) {
				xl(e, e.return, t);
			}
		} }, bv = yv.react_stack_bottom_frame.bind(yv), xv = { react_stack_bottom_frame: function(e, t, n, r, i) {
			try {
				t.componentDidUpdate(n, r, i);
			} catch (t) {
				xl(e, e.return, t);
			}
		} }, Sv = xv.react_stack_bottom_frame.bind(xv), Cv = { react_stack_bottom_frame: function(e, t) {
			var n = t.stack;
			e.componentDidCatch(t.value, { componentStack: n === null ? "" : n });
		} }, wv = Cv.react_stack_bottom_frame.bind(Cv), Tv = { react_stack_bottom_frame: function(e, t, n) {
			try {
				n.componentWillUnmount();
			} catch (n) {
				xl(e, t, n);
			}
		} }, Ev = Tv.react_stack_bottom_frame.bind(Tv), Dv = { react_stack_bottom_frame: function(e) {
			var t = e.create;
			return e = e.inst, t = t(), e.destroy = t;
		} }, Ov = Dv.react_stack_bottom_frame.bind(Dv), kv = { react_stack_bottom_frame: function(e, t, n) {
			try {
				n();
			} catch (n) {
				xl(e, t, n);
			}
		} }, Av = kv.react_stack_bottom_frame.bind(kv), jv = { react_stack_bottom_frame: function(e) {
			var t = e._init;
			return t(e._payload);
		} }, Mv = jv.react_stack_bottom_frame.bind(jv), Nv = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."), Pv = Error("Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), Fv = Error("Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."), Iv = { then: function() {
			console.error("Internal React error: A listener was unexpectedly attached to a \"noop\" thenable. This is a bug in React. Please file an issue.");
		} }, Lv = null, Rv = !1, zv = null, Bv = 0, Vv = null, Hv, Uv = Hv = !1, Wv = {}, Gv = {}, Kv = {};
		d = function(e, t, n) {
			if (typeof n == "object" && n && n._store && (!n._store.validated && n.key == null || n._store.validated === 2)) {
				if (typeof n._store != "object") throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
				n._store.validated = 1;
				var r = O(e), i = r || "null";
				if (!Wv[i]) {
					Wv[i] = !0, n = n._owner, e = e._debugOwner;
					var a = "";
					e && typeof e.tag == "number" && (i = O(e)) && (a = "\n\nCheck the render method of `" + i + "`."), a || r && (a = "\n\nCheck the top-level render call using <" + r + ">.");
					var o = "";
					n != null && e !== n && (r = null, typeof n.tag == "number" ? r = O(n) : typeof n.name == "string" && (r = n.name), r && (o = " It was passed a child from " + r + ".")), H(t, function() {
						console.error("Each child in a list should have a unique \"key\" prop.%s%s See https://react.dev/link/warning-keys for more information.", a, o);
					});
				}
			}
		};
		var qv = Ni(!0), Jv = Ni(!1), Yv = 0, Xv = 1, Zv = 2, Qv = 3, $v = !1, ey = !1, ty = null, ny = !1, ry = k(null), iy = k(0), ay = k(null), oy = null, sy = 1, cy = 2, ly = k(0), uy = 0, dy = 1, fy = 2, py = 4, my = 8, hy, gy = /* @__PURE__ */ new Set(), _y = /* @__PURE__ */ new Set(), vy = /* @__PURE__ */ new Set(), yy = /* @__PURE__ */ new Set(), by = 0, xy = null, Sy = null, Cy = null, wy = !1, Ty = !1, Ey = !1, Dy = 0, Oy = 0, ky = null, Ay = 0, jy = 25, $ = null, My = null, Ny = -1, Py = !1, Fy = {
			readContext: Br,
			use: ga,
			useCallback: ra,
			useContext: ra,
			useEffect: ra,
			useImperativeHandle: ra,
			useLayoutEffect: ra,
			useInsertionEffect: ra,
			useMemo: ra,
			useReducer: ra,
			useRef: ra,
			useState: ra,
			useDebugValue: ra,
			useDeferredValue: ra,
			useTransition: ra,
			useSyncExternalStore: ra,
			useId: ra,
			useHostTransitionStatus: ra,
			useFormState: ra,
			useActionState: ra,
			useOptimistic: ra,
			useMemoCache: ra,
			useCacheRefresh: ra
		};
		Fy.useEffectEvent = ra;
		var Iy = null, Ly = null, Ry = null, zy = null, By = null, Vy = null, Hy = null;
		Iy = {
			readContext: function(e) {
				return Br(e);
			},
			use: ga,
			useCallback: function(e, t) {
				return $ = "useCallback", Y(), ta(t), oo(e, t);
			},
			useContext: function(e) {
				return $ = "useContext", Y(), Br(e);
			},
			useEffect: function(e, t) {
				return $ = "useEffect", Y(), ta(t), Qa(e, t);
			},
			useImperativeHandle: function(e, t, n) {
				return $ = "useImperativeHandle", Y(), ta(n), io(e, t, n);
			},
			useInsertionEffect: function(e, t) {
				$ = "useInsertionEffect", Y(), ta(t), Xa(4, fy, e, t);
			},
			useLayoutEffect: function(e, t) {
				return $ = "useLayoutEffect", Y(), ta(t), no(e, t);
			},
			useMemo: function(e, t) {
				$ = "useMemo", Y(), ta(t);
				var n = Q.H;
				Q.H = By;
				try {
					return co(e, t);
				} finally {
					Q.H = n;
				}
			},
			useReducer: function(e, t, n) {
				$ = "useReducer", Y();
				var r = Q.H;
				Q.H = By;
				try {
					return ya(e, t, n);
				} finally {
					Q.H = r;
				}
			},
			useRef: function(e) {
				return $ = "useRef", Y(), Ya(e);
			},
			useState: function(e) {
				$ = "useState", Y();
				var t = Q.H;
				Q.H = By;
				try {
					return ja(e);
				} finally {
					Q.H = t;
				}
			},
			useDebugValue: function() {
				$ = "useDebugValue", Y();
			},
			useDeferredValue: function(e, t) {
				return $ = "useDeferredValue", Y(), uo(e, t);
			},
			useTransition: function() {
				return $ = "useTransition", Y(), xo();
			},
			useSyncExternalStore: function(e, t, n) {
				return $ = "useSyncExternalStore", Y(), Ca(e, t, n);
			},
			useId: function() {
				return $ = "useId", Y(), To();
			},
			useFormState: function(e, t) {
				return $ = "useFormState", Y(), na(), Ua(e, t);
			},
			useActionState: function(e, t) {
				return $ = "useActionState", Y(), Ua(e, t);
			},
			useOptimistic: function(e) {
				return $ = "useOptimistic", Y(), Ma(e);
			},
			useHostTransitionStatus: wo,
			useMemoCache: _a,
			useCacheRefresh: function() {
				return $ = "useCacheRefresh", Y(), Eo();
			},
			useEffectEvent: function(e) {
				return $ = "useEffectEvent", Y(), eo(e);
			}
		}, Ly = {
			readContext: function(e) {
				return Br(e);
			},
			use: ga,
			useCallback: function(e, t) {
				return $ = "useCallback", X(), oo(e, t);
			},
			useContext: function(e) {
				return $ = "useContext", X(), Br(e);
			},
			useEffect: function(e, t) {
				return $ = "useEffect", X(), Qa(e, t);
			},
			useImperativeHandle: function(e, t, n) {
				return $ = "useImperativeHandle", X(), io(e, t, n);
			},
			useInsertionEffect: function(e, t) {
				$ = "useInsertionEffect", X(), Xa(4, fy, e, t);
			},
			useLayoutEffect: function(e, t) {
				return $ = "useLayoutEffect", X(), no(e, t);
			},
			useMemo: function(e, t) {
				$ = "useMemo", X();
				var n = Q.H;
				Q.H = By;
				try {
					return co(e, t);
				} finally {
					Q.H = n;
				}
			},
			useReducer: function(e, t, n) {
				$ = "useReducer", X();
				var r = Q.H;
				Q.H = By;
				try {
					return ya(e, t, n);
				} finally {
					Q.H = r;
				}
			},
			useRef: function(e) {
				return $ = "useRef", X(), Ya(e);
			},
			useState: function(e) {
				$ = "useState", X();
				var t = Q.H;
				Q.H = By;
				try {
					return ja(e);
				} finally {
					Q.H = t;
				}
			},
			useDebugValue: function() {
				$ = "useDebugValue", X();
			},
			useDeferredValue: function(e, t) {
				return $ = "useDeferredValue", X(), uo(e, t);
			},
			useTransition: function() {
				return $ = "useTransition", X(), xo();
			},
			useSyncExternalStore: function(e, t, n) {
				return $ = "useSyncExternalStore", X(), Ca(e, t, n);
			},
			useId: function() {
				return $ = "useId", X(), To();
			},
			useActionState: function(e, t) {
				return $ = "useActionState", X(), Ua(e, t);
			},
			useFormState: function(e, t) {
				return $ = "useFormState", X(), na(), Ua(e, t);
			},
			useOptimistic: function(e) {
				return $ = "useOptimistic", X(), Ma(e);
			},
			useHostTransitionStatus: wo,
			useMemoCache: _a,
			useCacheRefresh: function() {
				return $ = "useCacheRefresh", X(), Eo();
			},
			useEffectEvent: function(e) {
				return $ = "useEffectEvent", X(), eo(e);
			}
		}, Ry = {
			readContext: function(e) {
				return Br(e);
			},
			use: ga,
			useCallback: function(e, t) {
				return $ = "useCallback", X(), so(e, t);
			},
			useContext: function(e) {
				return $ = "useContext", X(), Br(e);
			},
			useEffect: function(e, t) {
				$ = "useEffect", X(), Za(2048, my, e, t);
			},
			useImperativeHandle: function(e, t, n) {
				return $ = "useImperativeHandle", X(), ao(e, t, n);
			},
			useInsertionEffect: function(e, t) {
				return $ = "useInsertionEffect", X(), Za(4, fy, e, t);
			},
			useLayoutEffect: function(e, t) {
				return $ = "useLayoutEffect", X(), Za(4, py, e, t);
			},
			useMemo: function(e, t) {
				$ = "useMemo", X();
				var n = Q.H;
				Q.H = Vy;
				try {
					return lo(e, t);
				} finally {
					Q.H = n;
				}
			},
			useReducer: function(e, t, n) {
				$ = "useReducer", X();
				var r = Q.H;
				Q.H = Vy;
				try {
					return ba(e, t, n);
				} finally {
					Q.H = r;
				}
			},
			useRef: function() {
				return $ = "useRef", X(), pa().memoizedState;
			},
			useState: function() {
				$ = "useState", X();
				var e = Q.H;
				Q.H = Vy;
				try {
					return ba(va);
				} finally {
					Q.H = e;
				}
			},
			useDebugValue: function() {
				$ = "useDebugValue", X();
			},
			useDeferredValue: function(e, t) {
				return $ = "useDeferredValue", X(), fo(e, t);
			},
			useTransition: function() {
				return $ = "useTransition", X(), So();
			},
			useSyncExternalStore: function(e, t, n) {
				return $ = "useSyncExternalStore", X(), wa(e, t, n);
			},
			useId: function() {
				return $ = "useId", X(), pa().memoizedState;
			},
			useFormState: function(e) {
				return $ = "useFormState", X(), na(), Wa(e);
			},
			useActionState: function(e) {
				return $ = "useActionState", X(), Wa(e);
			},
			useOptimistic: function(e, t) {
				return $ = "useOptimistic", X(), Na(e, t);
			},
			useHostTransitionStatus: wo,
			useMemoCache: _a,
			useCacheRefresh: function() {
				return $ = "useCacheRefresh", X(), pa().memoizedState;
			},
			useEffectEvent: function(e) {
				return $ = "useEffectEvent", X(), to(e);
			}
		}, zy = {
			readContext: function(e) {
				return Br(e);
			},
			use: ga,
			useCallback: function(e, t) {
				return $ = "useCallback", X(), so(e, t);
			},
			useContext: function(e) {
				return $ = "useContext", X(), Br(e);
			},
			useEffect: function(e, t) {
				$ = "useEffect", X(), Za(2048, my, e, t);
			},
			useImperativeHandle: function(e, t, n) {
				return $ = "useImperativeHandle", X(), ao(e, t, n);
			},
			useInsertionEffect: function(e, t) {
				return $ = "useInsertionEffect", X(), Za(4, fy, e, t);
			},
			useLayoutEffect: function(e, t) {
				return $ = "useLayoutEffect", X(), Za(4, py, e, t);
			},
			useMemo: function(e, t) {
				$ = "useMemo", X();
				var n = Q.H;
				Q.H = Hy;
				try {
					return lo(e, t);
				} finally {
					Q.H = n;
				}
			},
			useReducer: function(e, t, n) {
				$ = "useReducer", X();
				var r = Q.H;
				Q.H = Hy;
				try {
					return Sa(e, t, n);
				} finally {
					Q.H = r;
				}
			},
			useRef: function() {
				return $ = "useRef", X(), pa().memoizedState;
			},
			useState: function() {
				$ = "useState", X();
				var e = Q.H;
				Q.H = Hy;
				try {
					return Sa(va);
				} finally {
					Q.H = e;
				}
			},
			useDebugValue: function() {
				$ = "useDebugValue", X();
			},
			useDeferredValue: function(e, t) {
				return $ = "useDeferredValue", X(), po(e, t);
			},
			useTransition: function() {
				return $ = "useTransition", X(), Co();
			},
			useSyncExternalStore: function(e, t, n) {
				return $ = "useSyncExternalStore", X(), wa(e, t, n);
			},
			useId: function() {
				return $ = "useId", X(), pa().memoizedState;
			},
			useFormState: function(e) {
				return $ = "useFormState", X(), na(), qa(e);
			},
			useActionState: function(e) {
				return $ = "useActionState", X(), qa(e);
			},
			useOptimistic: function(e, t) {
				return $ = "useOptimistic", X(), Fa(e, t);
			},
			useHostTransitionStatus: wo,
			useMemoCache: _a,
			useCacheRefresh: function() {
				return $ = "useCacheRefresh", X(), pa().memoizedState;
			},
			useEffectEvent: function(e) {
				return $ = "useEffectEvent", X(), to(e);
			}
		}, By = {
			readContext: function(e) {
				return l(), Br(e);
			},
			use: function(e) {
				return c(), ga(e);
			},
			useCallback: function(e, t) {
				return $ = "useCallback", c(), Y(), oo(e, t);
			},
			useContext: function(e) {
				return $ = "useContext", c(), Y(), Br(e);
			},
			useEffect: function(e, t) {
				return $ = "useEffect", c(), Y(), Qa(e, t);
			},
			useImperativeHandle: function(e, t, n) {
				return $ = "useImperativeHandle", c(), Y(), io(e, t, n);
			},
			useInsertionEffect: function(e, t) {
				$ = "useInsertionEffect", c(), Y(), Xa(4, fy, e, t);
			},
			useLayoutEffect: function(e, t) {
				return $ = "useLayoutEffect", c(), Y(), no(e, t);
			},
			useMemo: function(e, t) {
				$ = "useMemo", c(), Y();
				var n = Q.H;
				Q.H = By;
				try {
					return co(e, t);
				} finally {
					Q.H = n;
				}
			},
			useReducer: function(e, t, n) {
				$ = "useReducer", c(), Y();
				var r = Q.H;
				Q.H = By;
				try {
					return ya(e, t, n);
				} finally {
					Q.H = r;
				}
			},
			useRef: function(e) {
				return $ = "useRef", c(), Y(), Ya(e);
			},
			useState: function(e) {
				$ = "useState", c(), Y();
				var t = Q.H;
				Q.H = By;
				try {
					return ja(e);
				} finally {
					Q.H = t;
				}
			},
			useDebugValue: function() {
				$ = "useDebugValue", c(), Y();
			},
			useDeferredValue: function(e, t) {
				return $ = "useDeferredValue", c(), Y(), uo(e, t);
			},
			useTransition: function() {
				return $ = "useTransition", c(), Y(), xo();
			},
			useSyncExternalStore: function(e, t, n) {
				return $ = "useSyncExternalStore", c(), Y(), Ca(e, t, n);
			},
			useId: function() {
				return $ = "useId", c(), Y(), To();
			},
			useFormState: function(e, t) {
				return $ = "useFormState", c(), Y(), Ua(e, t);
			},
			useActionState: function(e, t) {
				return $ = "useActionState", c(), Y(), Ua(e, t);
			},
			useOptimistic: function(e) {
				return $ = "useOptimistic", c(), Y(), Ma(e);
			},
			useMemoCache: function(e) {
				return c(), _a(e);
			},
			useHostTransitionStatus: wo,
			useCacheRefresh: function() {
				return $ = "useCacheRefresh", Y(), Eo();
			},
			useEffectEvent: function(e) {
				return $ = "useEffectEvent", c(), Y(), eo(e);
			}
		}, Vy = {
			readContext: function(e) {
				return l(), Br(e);
			},
			use: function(e) {
				return c(), ga(e);
			},
			useCallback: function(e, t) {
				return $ = "useCallback", c(), X(), so(e, t);
			},
			useContext: function(e) {
				return $ = "useContext", c(), X(), Br(e);
			},
			useEffect: function(e, t) {
				$ = "useEffect", c(), X(), Za(2048, my, e, t);
			},
			useImperativeHandle: function(e, t, n) {
				return $ = "useImperativeHandle", c(), X(), ao(e, t, n);
			},
			useInsertionEffect: function(e, t) {
				return $ = "useInsertionEffect", c(), X(), Za(4, fy, e, t);
			},
			useLayoutEffect: function(e, t) {
				return $ = "useLayoutEffect", c(), X(), Za(4, py, e, t);
			},
			useMemo: function(e, t) {
				$ = "useMemo", c(), X();
				var n = Q.H;
				Q.H = Vy;
				try {
					return lo(e, t);
				} finally {
					Q.H = n;
				}
			},
			useReducer: function(e, t, n) {
				$ = "useReducer", c(), X();
				var r = Q.H;
				Q.H = Vy;
				try {
					return ba(e, t, n);
				} finally {
					Q.H = r;
				}
			},
			useRef: function() {
				return $ = "useRef", c(), X(), pa().memoizedState;
			},
			useState: function() {
				$ = "useState", c(), X();
				var e = Q.H;
				Q.H = Vy;
				try {
					return ba(va);
				} finally {
					Q.H = e;
				}
			},
			useDebugValue: function() {
				$ = "useDebugValue", c(), X();
			},
			useDeferredValue: function(e, t) {
				return $ = "useDeferredValue", c(), X(), fo(e, t);
			},
			useTransition: function() {
				return $ = "useTransition", c(), X(), So();
			},
			useSyncExternalStore: function(e, t, n) {
				return $ = "useSyncExternalStore", c(), X(), wa(e, t, n);
			},
			useId: function() {
				return $ = "useId", c(), X(), pa().memoizedState;
			},
			useFormState: function(e) {
				return $ = "useFormState", c(), X(), Wa(e);
			},
			useActionState: function(e) {
				return $ = "useActionState", c(), X(), Wa(e);
			},
			useOptimistic: function(e, t) {
				return $ = "useOptimistic", c(), X(), Na(e, t);
			},
			useMemoCache: function(e) {
				return c(), _a(e);
			},
			useHostTransitionStatus: wo,
			useCacheRefresh: function() {
				return $ = "useCacheRefresh", X(), pa().memoizedState;
			},
			useEffectEvent: function(e) {
				return $ = "useEffectEvent", c(), X(), to(e);
			}
		}, Hy = {
			readContext: function(e) {
				return l(), Br(e);
			},
			use: function(e) {
				return c(), ga(e);
			},
			useCallback: function(e, t) {
				return $ = "useCallback", c(), X(), so(e, t);
			},
			useContext: function(e) {
				return $ = "useContext", c(), X(), Br(e);
			},
			useEffect: function(e, t) {
				$ = "useEffect", c(), X(), Za(2048, my, e, t);
			},
			useImperativeHandle: function(e, t, n) {
				return $ = "useImperativeHandle", c(), X(), ao(e, t, n);
			},
			useInsertionEffect: function(e, t) {
				return $ = "useInsertionEffect", c(), X(), Za(4, fy, e, t);
			},
			useLayoutEffect: function(e, t) {
				return $ = "useLayoutEffect", c(), X(), Za(4, py, e, t);
			},
			useMemo: function(e, t) {
				$ = "useMemo", c(), X();
				var n = Q.H;
				Q.H = Vy;
				try {
					return lo(e, t);
				} finally {
					Q.H = n;
				}
			},
			useReducer: function(e, t, n) {
				$ = "useReducer", c(), X();
				var r = Q.H;
				Q.H = Vy;
				try {
					return Sa(e, t, n);
				} finally {
					Q.H = r;
				}
			},
			useRef: function() {
				return $ = "useRef", c(), X(), pa().memoizedState;
			},
			useState: function() {
				$ = "useState", c(), X();
				var e = Q.H;
				Q.H = Vy;
				try {
					return Sa(va);
				} finally {
					Q.H = e;
				}
			},
			useDebugValue: function() {
				$ = "useDebugValue", c(), X();
			},
			useDeferredValue: function(e, t) {
				return $ = "useDeferredValue", c(), X(), po(e, t);
			},
			useTransition: function() {
				return $ = "useTransition", c(), X(), Co();
			},
			useSyncExternalStore: function(e, t, n) {
				return $ = "useSyncExternalStore", c(), X(), wa(e, t, n);
			},
			useId: function() {
				return $ = "useId", c(), X(), pa().memoizedState;
			},
			useFormState: function(e) {
				return $ = "useFormState", c(), X(), qa(e);
			},
			useActionState: function(e) {
				return $ = "useActionState", c(), X(), qa(e);
			},
			useOptimistic: function(e, t) {
				return $ = "useOptimistic", c(), X(), Fa(e, t);
			},
			useMemoCache: function(e) {
				return c(), _a(e);
			},
			useHostTransitionStatus: wo,
			useCacheRefresh: function() {
				return $ = "useCacheRefresh", X(), pa().memoizedState;
			},
			useEffectEvent: function(e) {
				return $ = "useEffectEvent", c(), X(), to(e);
			}
		};
		var Uy = {}, Wy = /* @__PURE__ */ new Set(), Gy = /* @__PURE__ */ new Set(), Ky = /* @__PURE__ */ new Set(), qy = /* @__PURE__ */ new Set(), Jy = /* @__PURE__ */ new Set(), Yy = /* @__PURE__ */ new Set(), Xy = /* @__PURE__ */ new Set(), Zy = /* @__PURE__ */ new Set(), Qy = /* @__PURE__ */ new Set(), $y = /* @__PURE__ */ new Set();
		Object.freeze(Uy);
		var eb = {
			enqueueSetState: function(e, t, n) {
				e = e._reactInternals;
				var r = zc(e), i = Li(r);
				i.payload = t, n != null && (Fo(n), i.callback = n), t = Ri(e, i, r), t !== null && (Kr(r, "this.setState()", e), Vc(t, e, r), zi(t, e, r));
			},
			enqueueReplaceState: function(e, t, n) {
				e = e._reactInternals;
				var r = zc(e), i = Li(r);
				i.tag = Xv, i.payload = t, n != null && (Fo(n), i.callback = n), t = Ri(e, i, r), t !== null && (Kr(r, "this.replaceState()", e), Vc(t, e, r), zi(t, e, r));
			},
			enqueueForceUpdate: function(e, t) {
				e = e._reactInternals;
				var n = zc(e), r = Li(n);
				r.tag = Zv, t != null && (Fo(t), r.callback = t), t = Ri(e, r, n), t !== null && (Kr(n, "this.forceUpdate()", e), Vc(t, e, n), zi(t, e, n));
			}
		}, tb = null, nb = null, rb = Error("This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."), ib = !1, ab = {}, ob = {}, sb = {}, cb = {}, lb = !1, ub = {}, db = {}, fb = {
			dehydrated: null,
			treeContext: null,
			retryLane: 0,
			hydrationErrors: null
		}, pb = !1, mb = null;
		mb = /* @__PURE__ */ new Set();
		var hb = !1, gb = !1, _b = !1, vb = typeof WeakSet == "function" ? WeakSet : Set, yb = null, bb = null, xb = null, Sb = null, Cb = !1, wb = null, Tb = !1, Eb = 8192, Db = {
			getCacheForType: function(e) {
				var t = Br(c_), n = t.data.get(e);
				return n === void 0 && (n = e(), t.data.set(e, n)), n;
			},
			cacheSignal: function() {
				return Br(c_).controller.signal;
			},
			getOwner: function() {
				return rp;
			}
		};
		if (typeof Symbol == "function" && Symbol.for) {
			var Ob = Symbol.for;
			Ob("selector.component"), Ob("selector.has_pseudo_class"), Ob("selector.role"), Ob("selector.test_id"), Ob("selector.text");
		}
		var kb = [], Ab = typeof WeakMap == "function" ? WeakMap : Map, jb = 0, Mb = 2, Nb = 4, Pb = 0, Fb = 1, Ib = 2, Lb = 3, Rb = 4, zb = 6, Bb = 5, Vb = jb, Hb = null, Ub = null, Wb = 0, Gb = 0, Kb = 1, qb = 2, Jb = 3, Yb = 4, Xb = 5, Zb = 6, Qb = 7, $b = 8, ex = 9, tx = Gb, nx = null, rx = !1, ix = !1, ax = !1, ox = 0, sx = Pb, cx = 0, lx = 0, ux = 0, dx = 0, fx = 0, px = null, mx = null, hx = !1, gx = 0, _x = 0, vx = 300, yx = Infinity, bx = 500, xx = null, Sx = null, Cx = null, wx = 0, Tx = 1, Ex = 2, Dx = 3, Ox = 0, kx = 1, Ax = 2, jx = 3, Mx = 4, Nx = 5, Px = 0, Fx = null, Ix = null, Lx = 0, Rx = 0, zx = -0, Bx = null, Vx = null, Hx = null, Ux = wx, Wx = null, Gx = 50, Kx = 0, qx = null, Jx = !1, Yx = !1, Xx = 50, Zx = 0, Qx = null, $x = !1, eS = null, tS = !1, nS = /* @__PURE__ */ new Set(), rS = {}, iS = null, aS = null, oS = !1, sS = !1, cS = !1, lS = !1, uS = 0, dS = {};
		(function() {
			for (var e = 0; e < Yh.length; e++) {
				var t = Yh[e], n = t.toLowerCase();
				t = t[0].toUpperCase() + t.slice(1), Dn(n, "on" + t);
			}
			Dn(Vh, "onAnimationEnd"), Dn(Hh, "onAnimationIteration"), Dn(Uh, "onAnimationStart"), Dn("dblclick", "onDoubleClick"), Dn("focusin", "onFocus"), Dn("focusout", "onBlur"), Dn(Wh, "onTransitionRun"), Dn(Gh, "onTransitionStart"), Dn(Kh, "onTransitionCancel"), Dn(qh, "onTransitionEnd");
		})(), Be("onMouseEnter", ["mouseout", "mouseover"]), Be("onMouseLeave", ["mouseout", "mouseover"]), Be("onPointerEnter", ["pointerout", "pointerover"]), Be("onPointerLeave", ["pointerout", "pointerover"]), ze("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), ze("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), ze("onBeforeInput", [
			"compositionend",
			"keypress",
			"textInput",
			"paste"
		]), ze("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), ze("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), ze("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
		var fS = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), pS = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(fS)), mS = "_reactListening" + Math.random().toString(36).slice(2), hS = !1, gS = !1, _S = !1, vS = !1, yS = !1, bS = !1, xS = !1, SS = {}, CS = /\r\n?/g, wS = /\u0000|\uFFFD/g, TS = "http://www.w3.org/1999/xlink", ES = "http://www.w3.org/XML/1998/namespace", DS = "javascript:throw new Error('React form unexpectedly submitted.')", OS = "suppressHydrationWarning", kS = "&", AS = "/&", jS = "$", MS = "/$", NS = "$?", PS = "$~", FS = "$!", IS = "html", LS = "body", RS = "head", zS = "F!", BS = "F", VS = "loading", HS = "style", US = 0, WS = 1, GS = 2, KS = null, qS = null, JS = {
			dialog: !0,
			webview: !0
		}, YS = null, XS = void 0, ZS = typeof setTimeout == "function" ? setTimeout : void 0, QS = typeof clearTimeout == "function" ? clearTimeout : void 0, $S = -1, eC = typeof Promise == "function" ? Promise : void 0, tC = typeof queueMicrotask == "function" ? queueMicrotask : eC === void 0 ? ZS : function(e) {
			return eC.resolve(null).then(e).catch(Pu);
		}, nC = null, rC = 0, iC = 1, aC = 2, oC = 3, sC = 4, cC = /* @__PURE__ */ new Map(), lC = /* @__PURE__ */ new Set(), uC = If.d;
		If.d = {
			f: function() {
				var e = uC.f(), t = Kc();
				return e || t;
			},
			r: function(e) {
				var t = Fe(e);
				t !== null && t.tag === 5 && t.type === "form" ? bo(t) : uC.r(e);
			},
			D: function(e) {
				uC.D(e), gd("dns-prefetch", e, null);
			},
			C: function(e, t) {
				uC.C(e, t), gd("preconnect", e, t);
			},
			L: function(e, t, n) {
				uC.L(e, t, n);
				var r = dC;
				if (r && e && t) {
					var i = "link[rel=\"preload\"][as=\"" + $e(t) + "\"]";
					t === "image" && n && n.imageSrcSet ? (i += "[imagesrcset=\"" + $e(n.imageSrcSet) + "\"]", typeof n.imageSizes == "string" && (i += "[imagesizes=\"" + $e(n.imageSizes) + "\"]")) : i += "[href=\"" + $e(e) + "\"]";
					var a = i;
					switch (t) {
						case "style":
							a = yd(e);
							break;
						case "script": a = Cd(e);
					}
					cC.has(a) || (e = _f({
						rel: "preload",
						href: t === "image" && n && n.imageSrcSet ? void 0 : e,
						as: t
					}, n), cC.set(a, e), r.querySelector(i) !== null || t === "style" && r.querySelector(bd(a)) || t === "script" && r.querySelector(wd(a)) || (t = r.createElement("link"), pu(t, "link", e), Re(t), r.head.appendChild(t)));
				}
			},
			m: function(e, t) {
				uC.m(e, t);
				var n = dC;
				if (n && e) {
					var r = t && typeof t.as == "string" ? t.as : "script", i = "link[rel=\"modulepreload\"][as=\"" + $e(r) + "\"][href=\"" + $e(e) + "\"]", a = i;
					switch (r) {
						case "audioworklet":
						case "paintworklet":
						case "serviceworker":
						case "sharedworker":
						case "worker":
						case "script": a = Cd(e);
					}
					if (!cC.has(a) && (e = _f({
						rel: "modulepreload",
						href: e
					}, t), cC.set(a, e), n.querySelector(i) === null)) {
						switch (r) {
							case "audioworklet":
							case "paintworklet":
							case "serviceworker":
							case "sharedworker":
							case "worker":
							case "script": if (n.querySelector(wd(a))) return;
						}
						r = n.createElement("link"), pu(r, "link", e), Re(r), n.head.appendChild(r);
					}
				}
			},
			X: function(e, t) {
				uC.X(e, t);
				var n = dC;
				if (n && e) {
					var r = Le(n).hoistableScripts, i = Cd(e), a = r.get(i);
					a || (a = n.querySelector(wd(i)), a || (e = _f({
						src: e,
						async: !0
					}, t), (t = cC.get(i)) && Od(e, t), a = n.createElement("script"), Re(a), pu(a, "link", e), n.head.appendChild(a)), a = {
						type: "script",
						instance: a,
						count: 1,
						state: null
					}, r.set(i, a));
				}
			},
			S: function(e, t, n) {
				uC.S(e, t, n);
				var r = dC;
				if (r && e) {
					var i = Le(r).hoistableStyles, a = yd(e);
					t ||= "default";
					var o = i.get(a);
					if (!o) {
						var s = {
							loading: rC,
							preload: null
						};
						if (o = r.querySelector(bd(a))) s.loading = iC | sC;
						else {
							e = _f({
								rel: "stylesheet",
								href: e,
								"data-precedence": t
							}, n), (n = cC.get(a)) && Dd(e, n);
							var c = o = r.createElement("link");
							Re(c), pu(c, "link", e), c._p = new Promise(function(e, t) {
								c.onload = e, c.onerror = t;
							}), c.addEventListener("load", function() {
								s.loading |= iC;
							}), c.addEventListener("error", function() {
								s.loading |= aC;
							}), s.loading |= sC, Ed(o, t, r);
						}
						o = {
							type: "stylesheet",
							instance: o,
							count: 1,
							state: s
						}, i.set(a, o);
					}
				}
			},
			M: function(e, t) {
				uC.M(e, t);
				var n = dC;
				if (n && e) {
					var r = Le(n).hoistableScripts, i = Cd(e), a = r.get(i);
					a || (a = n.querySelector(wd(i)), a || (e = _f({
						src: e,
						async: !0,
						type: "module"
					}, t), (t = cC.get(i)) && Od(e, t), a = n.createElement("script"), Re(a), pu(a, "link", e), n.head.appendChild(a)), a = {
						type: "script",
						instance: a,
						count: 1,
						state: null
					}, r.set(i, a));
				}
			}
		};
		var dC = typeof document > "u" ? null : document, fC = null, pC = 6e4, mC = 800, hC = 500, gC = 0, _C = null, vC = null, yC = Lf, bC = {
			$$typeof: Tf,
			Provider: null,
			Consumer: null,
			_currentValue: yC,
			_currentValue2: yC,
			_threadCount: 0
		}, xC = "%c%s%c", SC = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", CC = "", wC = " ", TC = Function.prototype.bind, EC = !1, DC = null, OC = null, kC = null, AC = null, jC = null, MC = null, NC = null, PC = null, FC = null, IC = null;
		DC = function(e, r, i, a) {
			r = t(e, r), r !== null && (i = n(r.memoizedState, i, 0, a), r.memoizedState = i, r.baseState = i, e.memoizedProps = _f({}, e.memoizedProps), i = Yn(e, 2), i !== null && Vc(i, e, 2));
		}, OC = function(e, n, r) {
			n = t(e, n), n !== null && (r = a(n.memoizedState, r, 0), n.memoizedState = r, n.baseState = r, e.memoizedProps = _f({}, e.memoizedProps), r = Yn(e, 2), r !== null && Vc(r, e, 2));
		}, kC = function(e, n, i, a) {
			n = t(e, n), n !== null && (i = r(n.memoizedState, i, a), n.memoizedState = i, n.baseState = i, e.memoizedProps = _f({}, e.memoizedProps), i = Yn(e, 2), i !== null && Vc(i, e, 2));
		}, AC = function(e, t, r) {
			e.pendingProps = n(e.memoizedProps, t, 0, r), e.alternate && (e.alternate.pendingProps = e.pendingProps), t = Yn(e, 2), t !== null && Vc(t, e, 2);
		}, jC = function(e, t) {
			e.pendingProps = a(e.memoizedProps, t, 0), e.alternate && (e.alternate.pendingProps = e.pendingProps), t = Yn(e, 2), t !== null && Vc(t, e, 2);
		}, MC = function(e, t, n) {
			e.pendingProps = r(e.memoizedProps, t, n), e.alternate && (e.alternate.pendingProps = e.pendingProps), t = Yn(e, 2), t !== null && Vc(t, e, 2);
		}, NC = function(e) {
			var t = Yn(e, 2);
			t !== null && Vc(t, e, 2);
		}, PC = function(e) {
			var t = xe(), n = Yn(e, t);
			n !== null && Vc(n, e, t);
		}, FC = function(e) {
			s = e;
		}, IC = function(e) {
			o = e;
		};
		var LC = !0, RC = null, zC = !1, BC = null, VC = null, HC = null, UC = /* @__PURE__ */ new Map(), WC = /* @__PURE__ */ new Map(), GC = [], KC = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" "), qC = null;
		if (ff.prototype.render = df.prototype.render = function(e) {
			var t = this._internalRoot;
			if (t === null) throw Error("Cannot update an unmounted root.");
			var n = arguments;
			typeof n[1] == "function" ? console.error("does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : v(n[1]) ? console.error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : n[1] !== void 0 && console.error("You passed a second argument to root.render(...) but it only accepts one argument."), n = e;
			var r = t.current;
			Vd(r, zc(r), n, t, null, null);
		}, ff.prototype.unmount = df.prototype.unmount = function() {
			var e = arguments;
			if (typeof e[0] == "function" && console.error("does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."), e = this._internalRoot, e !== null) {
				this._internalRoot = null;
				var t = e.containerInfo;
				(Vb & (Mb | Nb)) !== jb && console.error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Vd(e.current, 2, null, e, null, null), Kc(), t[Ip] = null;
			}
		}, ff.prototype.unstable_scheduleHydration = function(e) {
			if (e) {
				var t = je();
				e = {
					blockedOn: null,
					target: e,
					priority: t
				};
				for (var n = 0; n < GC.length && t !== 0 && t < GC[n].priority; n++);
				GC.splice(n, 0, e), n === 0 && nf(e);
			}
		}, (function() {
			var e = hf.version;
			if (e !== "19.2.4") throw Error("Incompatible React versions: The \"react\" and \"react-dom\" packages must have the exact same version. Instead got:\n  - react:      " + (e + "\n  - react-dom:  19.2.4\nLearn more: https://react.dev/warnings/version-mismatch"));
		})(), typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"), If.findDOMNode = function(e) {
			var t = e._reactInternals;
			if (t === void 0) throw typeof e.render == "function" ? Error("Unable to find node on an unmounted component.") : (e = Object.keys(e).join(","), Error("Argument appears to not be a ReactComponent. Keys: " + e));
			return e = C(t), e = e === null ? null : w(e), e = e === null ? null : e.stateNode, e;
		}, !(function() {
			var e = {
				bundleType: 1,
				version: "19.2.4",
				rendererPackageName: "react-dom",
				currentDispatcherRef: Q,
				reconcilerVersion: "19.2.4"
			};
			return e.overrideHookState = DC, e.overrideHookStateDeletePath = OC, e.overrideHookStateRenamePath = kC, e.overrideProps = AC, e.overridePropsDeletePath = jC, e.overridePropsRenamePath = MC, e.scheduleUpdate = NC, e.scheduleRetry = PC, e.setErrorHandler = FC, e.setSuspenseHandler = IC, e.scheduleRefresh = g, e.scheduleRoot = h, e.setRefreshHandler = _, e.getCurrentFiber = Kd, me(e);
		})() && Hm && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && navigator.userAgent.indexOf("Edge") === -1 || -1 < navigator.userAgent.indexOf("Firefox"))) {
			var JC = window.location.protocol;
			/^(https?|file):$/.test(JC) && console.info("%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + (JC === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq" : ""), "font-weight:bold");
		}
		e.createRoot = function(e, t) {
			if (!v(e)) throw Error("Target container is not a DOM element.");
			pf(e);
			var n = !1, r = "", i = Bo, a = Vo, o = Ho;
			return t != null && (t.hydrate ? console.warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof t == "object" && t && t.$$typeof === yf && console.error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);"), !0 === t.unstable_strictMode && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (i = t.onUncaughtError), t.onCaughtError !== void 0 && (a = t.onCaughtError), t.onRecoverableError !== void 0 && (o = t.onRecoverableError)), t = zd(e, 1, !1, null, null, n, r, null, i, a, o, uf), e[Ip] = t.current, Zl(e), new df(t);
		}, e.hydrateRoot = function(e, t, n) {
			if (!v(e)) throw Error("Target container is not a DOM element.");
			pf(e), t === void 0 && console.error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
			var r = !1, i = "", a = Bo, o = Vo, s = Ho, c = null;
			return n != null && (!0 === n.unstable_strictMode && (r = !0), n.identifierPrefix !== void 0 && (i = n.identifierPrefix), n.onUncaughtError !== void 0 && (a = n.onUncaughtError), n.onCaughtError !== void 0 && (o = n.onCaughtError), n.onRecoverableError !== void 0 && (s = n.onRecoverableError), n.formState !== void 0 && (c = n.formState)), t = zd(e, 1, !0, t, n ?? null, r, i, c, a, o, s, uf), t.context = Bd(null), n = t.current, r = zc(n), r = U(r), i = Li(r), i.callback = null, Ri(n, i, r), Kr(r, "hydrateRoot()", null), n = r, t.current.lanes = n, Ce(t, n), Pl(t), e[Ip] = t.current, Zl(e), new ff(t);
		}, e.version = "19.2.4", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
})), XT = (/* @__PURE__ */ o(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
			if (process.env.NODE_ENV !== "production") throw Error("^_^");
			try {
				__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
			} catch (e) {
				console.error(e);
			}
		}
	}
	process.env.NODE_ENV === "production" ? (n(), t.exports = JT()) : t.exports = YT();
})))();
function ZT(e) {
	let t = (0, x.c)(10), { children: n, intl: r } = e, i;
	t[0] === r.locale ? i = t[1] : (i = gC({ locale: r.locale }, bS()), t[0] = r.locale, t[1] = i);
	let a;
	t[2] === r ? a = t[3] : (a = (e, t) => r.formatMessage(e, t), t[2] = r, t[3] = a);
	let o = a, s;
	t[4] !== i || t[5] !== o ? (s = {
		...i,
		formatMessage: o
	}, t[4] = i, t[5] = o, t[6] = s) : s = t[6];
	let c = s, l;
	return t[7] !== n || t[8] !== c ? (l = /* @__PURE__ */ (0, C.jsx)(sC, {
		value: c,
		children: n
	}), t[7] = n, t[8] = c, t[9] = l) : l = t[9], l;
}
//#endregion
//#region src/lumen/mount.tsx
function QT(e) {
	return e;
}
function $T(e, t, n) {
	let r = t, i = (0, XT.createRoot)(e), a = (e, t) => {
		(0, tr.flushSync)(() => {
			i.render(/* @__PURE__ */ (0, C.jsx)(ZT, {
				intl: e.intl,
				children: /* @__PURE__ */ (0, C.jsx)(TC, {
					...e.router,
					children: /* @__PURE__ */ (0, C.jsx)(BT, {
						featureToggles: e.featureToggles,
						children: /* @__PURE__ */ (0, C.jsx)(E, {
							access: e.access,
							children: /* @__PURE__ */ (0, C.jsx)(r, { ...t })
						})
					})
				})
			}));
		});
	}, { props: o, ...s } = n;
	return a(s, o), {
		render: a,
		unmount: () => i.unmount()
	};
}
//#endregion
//#region src/lumen/components.ts
var eE = QT(ET), tE = QT(VT), nE = QT(UT), rE = QT(LT), iE = QT(HT), aE = QT(WT), oE = "Hello from React";
function sE(e) {
	function t() {
		let e = (0, x.c)(2), t;
		e[0] === Symbol.for("react.memo_cache_sentinel") ? (t = [], e[0] = t) : t = e[0], (0, S.useLayoutEffect)(n, t);
		let r;
		return e[1] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ (0, C.jsx)("span", {
			"data-test-react": !0,
			children: oE
		}), e[1] = r) : r = e[1], r;
	}
	function n() {
		return r;
	}
	function r() {
		return e?.();
	}
	return QT(t);
}
function cE() {
	function e() {
		let e = (0, x.c)(1), t;
		return e[0] === Symbol.for("react.memo_cache_sentinel") ? (t = /* @__PURE__ */ (0, C.jsx)("span", {
			"data-test-react": !0,
			children: /* @__PURE__ */ (0, C.jsx)(bC, { value: .5 })
		}), e[0] = t) : t = e[0], t;
	}
	return QT(e);
}
function lE(e) {
	function t() {
		let t = (0, x.c)(4), { isActive: n } = SC(), r;
		t[0] === n ? r = t[1] : (r = n({ to: e }), t[0] = n, t[1] = r);
		let i = String(r), a;
		return t[2] === i ? a = t[3] : (a = /* @__PURE__ */ (0, C.jsx)("span", {
			"data-test-react": !0,
			children: i
		}), t[2] = i, t[3] = a), a;
	}
	return QT(t);
}
//#endregion
export { eE as DaasHeader, rE as DaasSettingsSidePanel, u as FEATURE_TOGGLES, tE as HotelHeader, iE as HotelSettingsSidePanel, nE as MarketHeader, aE as MarketSettingsSidePanel, l as createAccess, lE as createActiveTestComponent, d as createFeatureToggles, cE as createLocaleTestComponent, sE as createTestComponent, $T as mount };
